/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	__webpack_require__(10);
	__webpack_require__(12);
	__webpack_require__(16);
	__webpack_require__(20);
	__webpack_require__(22);
	__webpack_require__(25);
	__webpack_require__(26);
	__webpack_require__(27);
	__webpack_require__(29);
	__webpack_require__(166);
	__webpack_require__(168);
	__webpack_require__(169);
	
	__webpack_require__(177);
	__webpack_require__(178);
	
	var Marionette = __webpack_require__(180);
	var Router = __webpack_require__(184);
	var RootView = __webpack_require__(185);
	
	const App = Marionette.Application.extend({
	    region: '#app',
	    onStart: function(options) {
	        var rootView = new RootView(options);
	        this.showView(rootView);
	        var router = new Router({controller: rootView});
	        Backbone.history.start();
	    }
	});
	
	const myApp = new App();
	myApp.start({});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
	 * Bootstrap v3.4.1 (https://getbootstrap.com/)
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery')
	}
	
	+function ($) {
	  'use strict';
	  var version = $.fn.jquery.split(' ')[0].split('.')
	  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
	  }
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // https://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.4.1'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    selector    = selector === '#' ? [] : selector
	    var $parent = $(document).find(selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.4.1'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.4.1'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      if (typeof $next === 'object' && $next.length) {
	        $next[0].offsetWidth // force reflow
	      }
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    if (href) {
	      href = href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	    }
	
	    var target  = $this.attr('data-target') || href
	    var $target = $(document).find(target)
	
	    if (!$target.hasClass('carousel')) return
	
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.4.1'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(document).find(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(document).find(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.4.1'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector !== '#' ? $(document).find(selector) : null
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options = options
	    this.$body = $(document.body)
	    this.$element = $(element)
	    this.$dialog = this.$element.find('.modal-dialog')
	    this.$backdrop = null
	    this.isShown = null
	    this.originalBodyPad = null
	    this.scrollbarWidth = 0
	    this.ignoreBackdropClick = false
	    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION = '3.4.1'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	          this.$element[0] !== e.target &&
	          !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    var scrollbarWidth = this.scrollbarWidth
	    if (this.bodyIsOverflowing) {
	      this.$body.css('padding-right', bodyPad + scrollbarWidth)
	      $(this.fixedContent).each(function (index, element) {
	        var actualPadding = element.style.paddingRight
	        var calculatedPadding = $(element).css('padding-right')
	        $(element)
	          .data('padding-right', actualPadding)
	          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
	      })
	    }
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	    $(this.fixedContent).each(function (index, element) {
	      var padding = $(element).data('padding-right')
	      $(element).removeData('padding-right')
	      element.style.paddingRight = padding ? padding : ''
	    })
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this = $(this)
	      var data = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this = $(this)
	    var href = $this.attr('href')
	    var target = $this.attr('data-target') ||
	      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	
	    var $target = $(document).find(target)
	    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn']
	
	  var uriAttrs = [
	    'background',
	    'cite',
	    'href',
	    'itemtype',
	    'longdesc',
	    'poster',
	    'src',
	    'xlink:href'
	  ]
	
	  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i
	
	  var DefaultWhitelist = {
	    // Global attributes allowed on any supplied element below.
	    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
	    a: ['target', 'href', 'title', 'rel'],
	    area: [],
	    b: [],
	    br: [],
	    col: [],
	    code: [],
	    div: [],
	    em: [],
	    hr: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    i: [],
	    img: ['src', 'alt', 'title', 'width', 'height'],
	    li: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    small: [],
	    span: [],
	    sub: [],
	    sup: [],
	    strong: [],
	    u: [],
	    ul: []
	  }
	
	  /**
	   * A pattern that recognizes a commonly useful subset of URLs that are safe.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi
	
	  /**
	   * A pattern that matches safe data URLs. Only matches image, video and audio types.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i
	
	  function allowedAttribute(attr, allowedAttributeList) {
	    var attrName = attr.nodeName.toLowerCase()
	
	    if ($.inArray(attrName, allowedAttributeList) !== -1) {
	      if ($.inArray(attrName, uriAttrs) !== -1) {
	        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
	      }
	
	      return true
	    }
	
	    var regExp = $(allowedAttributeList).filter(function (index, value) {
	      return value instanceof RegExp
	    })
	
	    // Check if a regular expression validates the attribute.
	    for (var i = 0, l = regExp.length; i < l; i++) {
	      if (attrName.match(regExp[i])) {
	        return true
	      }
	    }
	
	    return false
	  }
	
	  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
	    if (unsafeHtml.length === 0) {
	      return unsafeHtml
	    }
	
	    if (sanitizeFn && typeof sanitizeFn === 'function') {
	      return sanitizeFn(unsafeHtml)
	    }
	
	    // IE 8 and below don't support createHTMLDocument
	    if (!document.implementation || !document.implementation.createHTMLDocument) {
	      return unsafeHtml
	    }
	
	    var createdDocument = document.implementation.createHTMLDocument('sanitization')
	    createdDocument.body.innerHTML = unsafeHtml
	
	    var whitelistKeys = $.map(whiteList, function (el, i) { return i })
	    var elements = $(createdDocument.body).find('*')
	
	    for (var i = 0, len = elements.length; i < len; i++) {
	      var el = elements[i]
	      var elName = el.nodeName.toLowerCase()
	
	      if ($.inArray(elName, whitelistKeys) === -1) {
	        el.parentNode.removeChild(el)
	
	        continue
	      }
	
	      var attributeList = $.map(el.attributes, function (el) { return el })
	      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || [])
	
	      for (var j = 0, len2 = attributeList.length; j < len2; j++) {
	        if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
	          el.removeAttribute(attributeList[j].nodeName)
	        }
	      }
	    }
	
	    return createdDocument.body.innerHTML
	  }
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.4.1'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    },
	    sanitize : true,
	    sanitizeFn : null,
	    whiteList : DefaultWhitelist
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    var dataAttributes = this.$element.data()
	
	    for (var dataAttr in dataAttributes) {
	      if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
	        delete dataAttributes[dataAttr]
	      }
	    }
	
	    options = $.extend({}, this.getDefaults(), dataAttributes, options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    if (options.sanitize) {
	      options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn)
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    if (this.options.html) {
	      if (this.options.sanitize) {
	        title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn)
	      }
	
	      $tip.find('.tooltip-inner').html(title)
	    } else {
	      $tip.find('.tooltip-inner').text(title)
	    }
	
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	  Tooltip.prototype.sanitizeHtml = function (unsafeHtml) {
	    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn)
	  }
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.4.1'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    if (this.options.html) {
	      var typeContent = typeof content
	
	      if (this.options.sanitize) {
	        title = this.sanitizeHtml(title)
	
	        if (typeContent === 'string') {
	          content = this.sanitizeHtml(content)
	        }
	      }
	
	      $tip.find('.popover-title').html(title)
	      $tip.find('.popover-content').children().detach().end()[
	        typeContent === 'string' ? 'html' : 'append'
	      ](content)
	    } else {
	      $tip.find('.popover-title').text(title)
	      $tip.find('.popover-content').children().detach().end().text(content)
	    }
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	        o.content.call($e[0]) :
	        o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.4.1'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.4.1'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(document).find(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	        .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	          .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    var target = this.options.target === Affix.DEFAULTS.target ? $(this.options.target) : $(document).find(this.options.target)
	
	    this.$target = target
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.4.1'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.5.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2020-05-04T22:49Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.5.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.5
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2020-03-14
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,
	
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
	
				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
	
					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem.namespaceURI,
			docElem = ( elem.ownerDocument || elem ).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
	
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {
	
				var input;
	
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}
	
				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}
	
				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );
	
			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}
	
		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {
	
			assert( function( el ) {
	
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
	
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}
	
			return i ?
	
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :
	
				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
	
			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {
	
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
	
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					/* eslint-disable max-len */
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */
	
				};
			},
	
			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
	
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			"not": markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),
	
			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},
	
			"selected": function( elem ) {
	
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
	
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
	
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}
	
	return Sizzle;
	
	} )( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
						dataPriv.get( this, "events" ) || Object.create( null )
					)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
							return result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px";
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = parseInt( trStyle.height ) > 3;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
						jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = (
						dataPriv.get( cur, "events" ) || Object.create( null )
					)[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
	
					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script
				if ( !isSuccess && jQuery.inArray( "script", s.dataTypes ) > -1 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				if ( typeof props.top === "number" ) {
					props.top += "px";
				}
				if ( typeof props.left === "number" ) {
					props.left += "px";
				}
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		} );
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! selectize.js - v0.12.6 | https://github.com/selectize/selectize.js | Apache License (v2) */
	
	!function(a,b){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11),__webpack_require__(23),__webpack_require__(24)], __WEBPACK_AMD_DEFINE_FACTORY__ = (b), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=b(require("jquery"),require("sifter"),require("microplugin")):a.Selectize=b(a.jQuery,a.Sifter,a.MicroPlugin)}(this,function(a,b,c){"use strict";var d=function(a,b){if("string"!=typeof b||b.length){var c="string"==typeof b?new RegExp(b,"i"):b,d=function(a){var b=0;if(3===a.nodeType){var e=a.data.search(c);if(e>=0&&a.data.length>0){var f=a.data.match(c),g=document.createElement("span");g.className="highlight";var h=a.splitText(e),i=(h.splitText(f[0].length),h.cloneNode(!0));g.appendChild(i),h.parentNode.replaceChild(g,h),b=1}}else if(1===a.nodeType&&a.childNodes&&!/(script|style)/i.test(a.tagName)&&("highlight"!==a.className||"SPAN"!==a.tagName))for(var j=0;j<a.childNodes.length;++j)j+=d(a.childNodes[j]);return b};return a.each(function(){d(this)})}};a.fn.removeHighlight=function(){return this.find("span.highlight").each(function(){this.parentNode.firstChild.nodeName;var a=this.parentNode;a.replaceChild(this.firstChild,this),a.normalize()}).end()};var e=function(){};e.prototype={on:function(a,b){this._events=this._events||{},this._events[a]=this._events[a]||[],this._events[a].push(b)},off:function(a,b){var c=arguments.length;return 0===c?delete this._events:1===c?delete this._events[a]:(this._events=this._events||{},void(a in this._events!=!1&&this._events[a].splice(this._events[a].indexOf(b),1)))},trigger:function(a){if(this._events=this._events||{},a in this._events!=!1)for(var b=0;b<this._events[a].length;b++)this._events[a][b].apply(this,Array.prototype.slice.call(arguments,1))}},e.mixin=function(a){for(var b=["on","off","trigger"],c=0;c<b.length;c++)a.prototype[b[c]]=e.prototype[b[c]]};var f=/Mac/.test(navigator.userAgent),g=f?91:17,h=f?18:17,i=!/android/i.test(window.navigator.userAgent)&&!!document.createElement("input").validity,j=function(a){return void 0!==a},k=function(a){return void 0===a||null===a?null:"boolean"==typeof a?a?"1":"0":a+""},l=function(a){return(a+"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")},m={};m.before=function(a,b,c){var d=a[b];a[b]=function(){return c.apply(a,arguments),d.apply(a,arguments)}},m.after=function(a,b,c){var d=a[b];a[b]=function(){var b=d.apply(a,arguments);return c.apply(a,arguments),b}};var n=function(a){var b=!1;return function(){b||(b=!0,a.apply(this,arguments))}},o=function(a,b){var c;return function(){var d=this,e=arguments;window.clearTimeout(c),c=window.setTimeout(function(){a.apply(d,e)},b)}},p=function(a,b,c){var d,e=a.trigger,f={};a.trigger=function(){var c=arguments[0];if(-1===b.indexOf(c))return e.apply(a,arguments);f[c]=arguments},c.apply(a,[]),a.trigger=e;for(d in f)f.hasOwnProperty(d)&&e.apply(a,f[d])},q=function(a,b,c,d){a.on(b,c,function(b){for(var c=b.target;c&&c.parentNode!==a[0];)c=c.parentNode;return b.currentTarget=c,d.apply(this,[b])})},r=function(a){var b={};if("selectionStart"in a)b.start=a.selectionStart,b.length=a.selectionEnd-b.start;else if(document.selection){a.focus();var c=document.selection.createRange(),d=document.selection.createRange().text.length;c.moveStart("character",-a.value.length),b.start=c.text.length-d,b.length=d}return b},s=function(a,b,c){var d,e,f={};if(c)for(d=0,e=c.length;d<e;d++)f[c[d]]=a.css(c[d]);else f=a.css();b.css(f)},t=function(b,c){return b?(w.$testInput||(w.$testInput=a("<span />").css({position:"absolute",top:-99999,left:-99999,width:"auto",padding:0,whiteSpace:"pre"}).appendTo("body")),w.$testInput.text(b),s(c,w.$testInput,["letterSpacing","fontSize","fontFamily","fontWeight","textTransform"]),w.$testInput.width()):0},u=function(a){var b=null,c=function(c,d){var e,f,g,h,i,j,k,l;c=c||window.event||{},d=d||{},c.metaKey||c.altKey||(d.force||!1!==a.data("grow"))&&(e=a.val(),c.type&&"keydown"===c.type.toLowerCase()&&(f=c.keyCode,g=f>=48&&f<=57||f>=65&&f<=90||f>=96&&f<=111||f>=186&&f<=222||32===f,46===f||8===f?(l=r(a[0]),l.length?e=e.substring(0,l.start)+e.substring(l.start+l.length):8===f&&l.start?e=e.substring(0,l.start-1)+e.substring(l.start+1):46===f&&void 0!==l.start&&(e=e.substring(0,l.start)+e.substring(l.start+1))):g&&(j=c.shiftKey,k=String.fromCharCode(c.keyCode),k=j?k.toUpperCase():k.toLowerCase(),e+=k)),h=a.attr("placeholder"),!e&&h&&(e=h),(i=t(e,a)+4)!==b&&(b=i,a.width(i),a.triggerHandler("resize")))};a.on("keydown keyup update blur",c),c()},v=function(a){var b=document.createElement("div");return b.appendChild(a.cloneNode(!0)),b.innerHTML},w=function(c,d){var e,f,g,h,i=this;h=c[0],h.selectize=i;var j=window.getComputedStyle&&window.getComputedStyle(h,null);if(g=j?j.getPropertyValue("direction"):h.currentStyle&&h.currentStyle.direction,g=g||c.parents("[dir]:first").attr("dir")||"",a.extend(i,{order:0,settings:d,$input:c,tabIndex:c.attr("tabindex")||"",tagType:"select"===h.tagName.toLowerCase()?1:2,rtl:/rtl/i.test(g),eventNS:".selectize"+ ++w.count,highlightedValue:null,isBlurring:!1,isOpen:!1,isDisabled:!1,isRequired:c.is("[required]"),isInvalid:!1,isLocked:!1,isFocused:!1,isInputHidden:!1,isSetup:!1,isShiftDown:!1,isCmdDown:!1,isCtrlDown:!1,ignoreFocus:!1,ignoreBlur:!1,ignoreHover:!1,hasOptions:!1,currentResults:null,lastValue:"",caretPos:0,loading:0,loadedSearches:{},$activeOption:null,$activeItems:[],optgroups:{},options:{},userOptions:{},items:[],renderCache:{},onSearchChange:null===d.loadThrottle?i.onSearchChange:o(i.onSearchChange,d.loadThrottle)}),i.sifter=new b(this.options,{diacritics:d.diacritics}),i.settings.options){for(e=0,f=i.settings.options.length;e<f;e++)i.registerOption(i.settings.options[e]);delete i.settings.options}if(i.settings.optgroups){for(e=0,f=i.settings.optgroups.length;e<f;e++)i.registerOptionGroup(i.settings.optgroups[e]);delete i.settings.optgroups}i.settings.mode=i.settings.mode||(1===i.settings.maxItems?"single":"multi"),"boolean"!=typeof i.settings.hideSelected&&(i.settings.hideSelected="multi"===i.settings.mode),i.initializePlugins(i.settings.plugins),i.setupCallbacks(),i.setupTemplates(),i.setup()};return e.mixin(w),void 0!==c?c.mixin(w):function(a,b){b||(b={});console.error("Selectize: "+a),b.explanation&&(console.group&&console.group(),console.error(b.explanation),console.group&&console.groupEnd())}("Dependency MicroPlugin is missing",{explanation:'Make sure you either: (1) are using the "standalone" version of Selectize, or (2) require MicroPlugin before you load Selectize.'}),a.extend(w.prototype,{setup:function(){var b,c,d,e,j,k,l,m,n,o,p=this,r=p.settings,s=p.eventNS,t=a(window),v=a(document),w=p.$input;if(l=p.settings.mode,m=w.attr("class")||"",b=a("<div>").addClass(r.wrapperClass).addClass(m).addClass(l),c=a("<div>").addClass(r.inputClass).addClass("items").appendTo(b),d=a('<input type="text" autocomplete="off" />').appendTo(c).attr("tabindex",w.is(":disabled")?"-1":p.tabIndex),k=a(r.dropdownParent||b),e=a("<div>").addClass(r.dropdownClass).addClass(l).hide().appendTo(k),j=a("<div>").addClass(r.dropdownContentClass).appendTo(e),(o=w.attr("id"))&&(d.attr("id",o+"-selectized"),a("label[for='"+o+"']").attr("for",o+"-selectized")),p.settings.copyClassesToDropdown&&e.addClass(m),b.css({width:w[0].style.width}),p.plugins.names.length&&(n="plugin-"+p.plugins.names.join(" plugin-"),b.addClass(n),e.addClass(n)),(null===r.maxItems||r.maxItems>1)&&1===p.tagType&&w.attr("multiple","multiple"),p.settings.placeholder&&d.attr("placeholder",r.placeholder),!p.settings.splitOn&&p.settings.delimiter){var x=p.settings.delimiter.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&");p.settings.splitOn=new RegExp("\\s*"+x+"+\\s*")}w.attr("autocorrect")&&d.attr("autocorrect",w.attr("autocorrect")),w.attr("autocapitalize")&&d.attr("autocapitalize",w.attr("autocapitalize")),d[0].type=w[0].type,p.$wrapper=b,p.$control=c,p.$control_input=d,p.$dropdown=e,p.$dropdown_content=j,e.on("mouseenter mousedown click","[data-disabled]>[data-selectable]",function(a){a.stopImmediatePropagation()}),e.on("mouseenter","[data-selectable]",function(){return p.onOptionHover.apply(p,arguments)}),e.on("mousedown click","[data-selectable]",function(){return p.onOptionSelect.apply(p,arguments)}),q(c,"mousedown","*:not(input)",function(){return p.onItemSelect.apply(p,arguments)}),u(d),c.on({mousedown:function(){return p.onMouseDown.apply(p,arguments)},click:function(){return p.onClick.apply(p,arguments)}}),d.on({mousedown:function(a){a.stopPropagation()},keydown:function(){return p.onKeyDown.apply(p,arguments)},keyup:function(){return p.onKeyUp.apply(p,arguments)},keypress:function(){return p.onKeyPress.apply(p,arguments)},resize:function(){p.positionDropdown.apply(p,[])},blur:function(){return p.onBlur.apply(p,arguments)},focus:function(){return p.ignoreBlur=!1,p.onFocus.apply(p,arguments)},paste:function(){return p.onPaste.apply(p,arguments)}}),v.on("keydown"+s,function(a){p.isCmdDown=a[f?"metaKey":"ctrlKey"],p.isCtrlDown=a[f?"altKey":"ctrlKey"],p.isShiftDown=a.shiftKey}),v.on("keyup"+s,function(a){a.keyCode===h&&(p.isCtrlDown=!1),16===a.keyCode&&(p.isShiftDown=!1),a.keyCode===g&&(p.isCmdDown=!1)}),v.on("mousedown"+s,function(a){if(p.isFocused){if(a.target===p.$dropdown[0]||a.target.parentNode===p.$dropdown[0])return!1;p.$control.has(a.target).length||a.target===p.$control[0]||p.blur(a.target)}}),t.on(["scroll"+s,"resize"+s].join(" "),function(){p.isOpen&&p.positionDropdown.apply(p,arguments)}),t.on("mousemove"+s,function(){p.ignoreHover=!1}),this.revertSettings={$children:w.children().detach(),tabindex:w.attr("tabindex")},w.attr("tabindex",-1).hide().after(p.$wrapper),a.isArray(r.items)&&(p.setValue(r.items),delete r.items),i&&w.on("invalid"+s,function(a){a.preventDefault(),p.isInvalid=!0,p.refreshState()}),p.updateOriginalInput(),p.refreshItems(),p.refreshState(),p.updatePlaceholder(),p.isSetup=!0,w.is(":disabled")&&p.disable(),p.on("change",this.onChange),w.data("selectize",p),w.addClass("selectized"),p.trigger("initialize"),!0===r.preload&&p.onSearchChange("")},setupTemplates:function(){var b=this,c=b.settings.labelField,d=b.settings.optgroupLabelField,e={optgroup:function(a){return'<div class="optgroup">'+a.html+"</div>"},optgroup_header:function(a,b){return'<div class="optgroup-header">'+b(a[d])+"</div>"},option:function(a,b){return'<div class="option">'+b(a[c])+"</div>"},item:function(a,b){return'<div class="item">'+b(a[c])+"</div>"},option_create:function(a,b){return'<div class="create">Add <strong>'+b(a.input)+"</strong>&hellip;</div>"}};b.settings.render=a.extend({},e,b.settings.render)},setupCallbacks:function(){var a,b,c={initialize:"onInitialize",change:"onChange",item_add:"onItemAdd",item_remove:"onItemRemove",clear:"onClear",option_add:"onOptionAdd",option_remove:"onOptionRemove",option_clear:"onOptionClear",optgroup_add:"onOptionGroupAdd",optgroup_remove:"onOptionGroupRemove",optgroup_clear:"onOptionGroupClear",dropdown_open:"onDropdownOpen",dropdown_close:"onDropdownClose",type:"onType",load:"onLoad",focus:"onFocus",blur:"onBlur"};for(a in c)c.hasOwnProperty(a)&&(b=this.settings[c[a]])&&this.on(a,b)},onClick:function(a){var b=this;b.isFocused&&b.isOpen||(b.focus(),a.preventDefault())},onMouseDown:function(b){var c=this,d=b.isDefaultPrevented();a(b.target);if(c.isFocused){if(b.target!==c.$control_input[0])return"single"===c.settings.mode?c.isOpen?c.close():c.open():d||c.setActiveItem(null),!1}else d||window.setTimeout(function(){c.focus()},0)},onChange:function(){this.$input.trigger("change")},onPaste:function(b){var c=this;if(c.isFull()||c.isInputHidden||c.isLocked)return void b.preventDefault();c.settings.splitOn&&setTimeout(function(){var b=c.$control_input.val();if(b.match(c.settings.splitOn))for(var d=a.trim(b).split(c.settings.splitOn),e=0,f=d.length;e<f;e++)c.createItem(d[e])},0)},onKeyPress:function(a){if(this.isLocked)return a&&a.preventDefault();var b=String.fromCharCode(a.keyCode||a.which);return this.settings.create&&"multi"===this.settings.mode&&b===this.settings.delimiter?(this.createItem(),a.preventDefault(),!1):void 0},onKeyDown:function(a){var b=(a.target,this.$control_input[0],this);if(b.isLocked)return void(9!==a.keyCode&&a.preventDefault());switch(a.keyCode){case 65:if(b.isCmdDown)return void b.selectAll();break;case 27:return void(b.isOpen&&(a.preventDefault(),a.stopPropagation(),b.close()));case 78:if(!a.ctrlKey||a.altKey)break;case 40:if(!b.isOpen&&b.hasOptions)b.open();else if(b.$activeOption){b.ignoreHover=!0;var c=b.getAdjacentOption(b.$activeOption,1);c.length&&b.setActiveOption(c,!0,!0)}return void a.preventDefault();case 80:if(!a.ctrlKey||a.altKey)break;case 38:if(b.$activeOption){b.ignoreHover=!0;var d=b.getAdjacentOption(b.$activeOption,-1);d.length&&b.setActiveOption(d,!0,!0)}return void a.preventDefault();case 13:return void(b.isOpen&&b.$activeOption&&(b.onOptionSelect({currentTarget:b.$activeOption}),a.preventDefault()));case 37:return void b.advanceSelection(-1,a);case 39:return void b.advanceSelection(1,a);case 9:return b.settings.selectOnTab&&b.isOpen&&b.$activeOption&&(b.onOptionSelect({currentTarget:b.$activeOption}),b.isFull()||a.preventDefault()),void(b.settings.create&&b.createItem()&&a.preventDefault());case 8:case 46:return void b.deleteSelection(a)}return!b.isFull()&&!b.isInputHidden||(f?a.metaKey:a.ctrlKey)?void 0:void a.preventDefault()},onKeyUp:function(a){var b=this;if(b.isLocked)return a&&a.preventDefault();var c=b.$control_input.val()||"";b.lastValue!==c&&(b.lastValue=c,b.onSearchChange(c),b.refreshOptions(),b.trigger("type",c))},onSearchChange:function(a){var b=this,c=b.settings.load;c&&(b.loadedSearches.hasOwnProperty(a)||(b.loadedSearches[a]=!0,b.load(function(d){c.apply(b,[a,d])})))},onFocus:function(a){var b=this,c=b.isFocused;if(b.isDisabled)return b.blur(),a&&a.preventDefault(),!1;b.ignoreFocus||(b.isFocused=!0,"focus"===b.settings.preload&&b.onSearchChange(""),c||b.trigger("focus"),b.$activeItems.length||(b.showInput(),b.setActiveItem(null),b.refreshOptions(!!b.settings.openOnFocus)),b.refreshState())},onBlur:function(a,b){var c=this;if(c.isFocused&&(c.isFocused=!1,!c.ignoreFocus)){if(!c.ignoreBlur&&document.activeElement===c.$dropdown_content[0])return c.ignoreBlur=!0,void c.onFocus(a);var d=function(){c.close(),c.setTextboxValue(""),c.setActiveItem(null),c.setActiveOption(null),c.setCaret(c.items.length),c.refreshState(),b&&b.focus&&b.focus(),c.isBlurring=!1,c.ignoreFocus=!1,c.trigger("blur")};c.isBlurring=!0,c.ignoreFocus=!0,c.settings.create&&c.settings.createOnBlur?c.createItem(null,!1,d):d()}},onOptionHover:function(a){this.ignoreHover||this.setActiveOption(a.currentTarget,!1)},onOptionSelect:function(b){var c,d,e=this;b.preventDefault&&(b.preventDefault(),b.stopPropagation()),d=a(b.currentTarget),d.hasClass("create")?e.createItem(null,function(){e.settings.closeAfterSelect&&e.close()}):void 0!==(c=d.attr("data-value"))&&(e.lastQuery=null,e.setTextboxValue(""),e.addItem(c),e.settings.closeAfterSelect?e.close():!e.settings.hideSelected&&b.type&&/mouse/.test(b.type)&&e.setActiveOption(e.getOption(c)))},onItemSelect:function(a){var b=this;b.isLocked||"multi"===b.settings.mode&&(a.preventDefault(),b.setActiveItem(a.currentTarget,a))},load:function(a){var b=this,c=b.$wrapper.addClass(b.settings.loadingClass);b.loading++,a.apply(b,[function(a){b.loading=Math.max(b.loading-1,0),a&&a.length&&(b.addOption(a),b.refreshOptions(b.isFocused&&!b.isInputHidden)),b.loading||c.removeClass(b.settings.loadingClass),b.trigger("load",a)}])},setTextboxValue:function(a){var b=this.$control_input;b.val()!==a&&(b.val(a).triggerHandler("update"),this.lastValue=a)},getValue:function(){return 1===this.tagType&&this.$input.attr("multiple")?this.items:this.items.join(this.settings.delimiter)},setValue:function(a,b){p(this,b?[]:["change"],function(){this.clear(b),this.addItems(a,b)})},setActiveItem:function(b,c){var d,e,f,g,h,i,j,k,l=this;if("single"!==l.settings.mode){if(b=a(b),!b.length)return a(l.$activeItems).removeClass("active"),l.$activeItems=[],void(l.isFocused&&l.showInput());if("mousedown"===(d=c&&c.type.toLowerCase())&&l.isShiftDown&&l.$activeItems.length){for(k=l.$control.children(".active:last"),g=Array.prototype.indexOf.apply(l.$control[0].childNodes,[k[0]]),h=Array.prototype.indexOf.apply(l.$control[0].childNodes,[b[0]]),g>h&&(j=g,g=h,h=j),e=g;e<=h;e++)i=l.$control[0].childNodes[e],-1===l.$activeItems.indexOf(i)&&(a(i).addClass("active"),l.$activeItems.push(i));c.preventDefault()}else"mousedown"===d&&l.isCtrlDown||"keydown"===d&&this.isShiftDown?b.hasClass("active")?(f=l.$activeItems.indexOf(b[0]),l.$activeItems.splice(f,1),b.removeClass("active")):l.$activeItems.push(b.addClass("active")[0]):(a(l.$activeItems).removeClass("active"),l.$activeItems=[b.addClass("active")[0]]);l.hideInput(),this.isFocused||l.focus()}},setActiveOption:function(b,c,d){var e,f,g,h,i,k=this;k.$activeOption&&k.$activeOption.removeClass("active"),k.$activeOption=null,b=a(b),b.length&&(k.$activeOption=b.addClass("active"),!c&&j(c)||(e=k.$dropdown_content.height(),f=k.$activeOption.outerHeight(!0),c=k.$dropdown_content.scrollTop()||0,g=k.$activeOption.offset().top-k.$dropdown_content.offset().top+c,h=g,i=g-e+f,g+f>e+c?k.$dropdown_content.stop().animate({scrollTop:i},d?k.settings.scrollDuration:0):g<c&&k.$dropdown_content.stop().animate({scrollTop:h},d?k.settings.scrollDuration:0)))},selectAll:function(){var a=this;"single"!==a.settings.mode&&(a.$activeItems=Array.prototype.slice.apply(a.$control.children(":not(input)").addClass("active")),a.$activeItems.length&&(a.hideInput(),a.close()),a.focus())},hideInput:function(){var a=this;a.setTextboxValue(""),a.$control_input.css({opacity:0,position:"absolute",left:a.rtl?1e4:-1e4}),a.isInputHidden=!0},showInput:function(){this.$control_input.css({opacity:1,position:"relative",left:0}),this.isInputHidden=!1},focus:function(){var a=this;a.isDisabled||(a.ignoreFocus=!0,a.$control_input[0].focus(),window.setTimeout(function(){a.ignoreFocus=!1,a.onFocus()},0))},blur:function(a){this.$control_input[0].blur(),this.onBlur(null,a)},getScoreFunction:function(a){return this.sifter.getScoreFunction(a,this.getSearchOptions())},getSearchOptions:function(){var a=this.settings,b=a.sortField;return"string"==typeof b&&(b=[{field:b}]),{fields:a.searchField,conjunction:a.searchConjunction,sort:b,nesting:a.nesting}},search:function(b){var c,d,e,f=this,g=f.settings,h=this.getSearchOptions();if(g.score&&"function"!=typeof(e=f.settings.score.apply(this,[b])))throw new Error('Selectize "score" setting must be a function that returns a function');if(b!==f.lastQuery?(f.lastQuery=b,d=f.sifter.search(b,a.extend(h,{score:e})),f.currentResults=d):d=a.extend(!0,{},f.currentResults),g.hideSelected)for(c=d.items.length-1;c>=0;c--)-1!==f.items.indexOf(k(d.items[c].id))&&d.items.splice(c,1);return d},refreshOptions:function(b){var c,e,f,g,h,i,j,l,m,n,o,p,q,r,s,t;void 0===b&&(b=!0);var u=this,w=a.trim(u.$control_input.val()),x=u.search(w),y=u.$dropdown_content,z=u.$activeOption&&k(u.$activeOption.attr("data-value"));for(g=x.items.length,"number"==typeof u.settings.maxOptions&&(g=Math.min(g,u.settings.maxOptions)),h={},i=[],c=0;c<g;c++)for(j=u.options[x.items[c].id],l=u.render("option",j),m=j[u.settings.optgroupField]||"",n=a.isArray(m)?m:[m],e=0,f=n&&n.length;e<f;e++)m=n[e],u.optgroups.hasOwnProperty(m)||(m=""),h.hasOwnProperty(m)||(h[m]=document.createDocumentFragment(),i.push(m)),h[m].appendChild(l);for(this.settings.lockOptgroupOrder&&i.sort(function(a,b){return(u.optgroups[a].$order||0)-(u.optgroups[b].$order||0)}),o=document.createDocumentFragment(),c=0,g=i.length;c<g;c++)m=i[c],u.optgroups.hasOwnProperty(m)&&h[m].childNodes.length?(p=document.createDocumentFragment(),p.appendChild(u.render("optgroup_header",u.optgroups[m])),p.appendChild(h[m]),o.appendChild(u.render("optgroup",a.extend({},u.optgroups[m],{html:v(p),dom:p})))):o.appendChild(h[m]);if(y.html(o),u.settings.highlight&&(y.removeHighlight(),x.query.length&&x.tokens.length))for(c=0,g=x.tokens.length;c<g;c++)d(y,x.tokens[c].regex);if(!u.settings.hideSelected)for(c=0,g=u.items.length;c<g;c++)u.getOption(u.items[c]).addClass("selected");q=u.canCreate(w),q&&(y.prepend(u.render("option_create",{input:w})),t=a(y[0].childNodes[0])),u.hasOptions=x.items.length>0||q,u.hasOptions?(x.items.length>0?(s=z&&u.getOption(z),s&&s.length?r=s:"single"===u.settings.mode&&u.items.length&&(r=u.getOption(u.items[0])),r&&r.length||(r=t&&!u.settings.addPrecedence?u.getAdjacentOption(t,1):y.find("[data-selectable]:first"))):r=t,u.setActiveOption(r),b&&!u.isOpen&&u.open()):(u.setActiveOption(null),b&&u.isOpen&&u.close())},addOption:function(b){var c,d,e,f=this;if(a.isArray(b))for(c=0,d=b.length;c<d;c++)f.addOption(b[c]);else(e=f.registerOption(b))&&(f.userOptions[e]=!0,f.lastQuery=null,f.trigger("option_add",e,b))},registerOption:function(a){var b=k(a[this.settings.valueField]);return void 0!==b&&null!==b&&!this.options.hasOwnProperty(b)&&(a.$order=a.$order||++this.order,this.options[b]=a,b)},registerOptionGroup:function(a){var b=k(a[this.settings.optgroupValueField]);return!!b&&(a.$order=a.$order||++this.order,this.optgroups[b]=a,b)},addOptionGroup:function(a,b){b[this.settings.optgroupValueField]=a,(a=this.registerOptionGroup(b))&&this.trigger("optgroup_add",a,b)},removeOptionGroup:function(a){this.optgroups.hasOwnProperty(a)&&(delete this.optgroups[a],this.renderCache={},this.trigger("optgroup_remove",a))},clearOptionGroups:function(){this.optgroups={},this.renderCache={},this.trigger("optgroup_clear")},updateOption:function(b,c){var d,e,f,g,h,i,j,l=this;if(b=k(b),f=k(c[l.settings.valueField]),null!==b&&l.options.hasOwnProperty(b)){if("string"!=typeof f)throw new Error("Value must be set in option data");j=l.options[b].$order,f!==b&&(delete l.options[b],-1!==(g=l.items.indexOf(b))&&l.items.splice(g,1,f)),c.$order=c.$order||j,l.options[f]=c,h=l.renderCache.item,i=l.renderCache.option,h&&(delete h[b],delete h[f]),i&&(delete i[b],delete i[f]),-1!==l.items.indexOf(f)&&(d=l.getItem(b),e=a(l.render("item",c)),d.hasClass("active")&&e.addClass("active"),d.replaceWith(e)),l.lastQuery=null,l.isOpen&&l.refreshOptions(!1)}},removeOption:function(a,b){var c=this;a=k(a);var d=c.renderCache.item,e=c.renderCache.option;d&&delete d[a],e&&delete e[a],delete c.userOptions[a],delete c.options[a],c.lastQuery=null,c.trigger("option_remove",a),c.removeItem(a,b)},clearOptions:function(){var b=this;b.loadedSearches={},b.userOptions={},b.renderCache={};var c=b.options;a.each(b.options,function(a,d){-1==b.items.indexOf(a)&&delete c[a]}),b.options=b.sifter.items=c,b.lastQuery=null,b.trigger("option_clear")},getOption:function(a){return this.getElementWithValue(a,this.$dropdown_content.find("[data-selectable]"))},getAdjacentOption:function(b,c){var d=this.$dropdown.find("[data-selectable]"),e=d.index(b)+c;return e>=0&&e<d.length?d.eq(e):a()},getElementWithValue:function(b,c){if(void 0!==(b=k(b))&&null!==b)for(var d=0,e=c.length;d<e;d++)if(c[d].getAttribute("data-value")===b)return a(c[d]);return a()},getItem:function(a){return this.getElementWithValue(a,this.$control.children())},addItems:function(b,c){this.buffer=document.createDocumentFragment();for(var d=this.$control[0].childNodes,e=0;e<d.length;e++)this.buffer.appendChild(d[e]);for(var f=a.isArray(b)?b:[b],e=0,g=f.length;e<g;e++)this.isPending=e<g-1,this.addItem(f[e],c);var h=this.$control[0];h.insertBefore(this.buffer,h.firstChild),this.buffer=null},addItem:function(b,c){p(this,c?[]:["change"],function(){var d,e,f,g,h,i=this,j=i.settings.mode;if(b=k(b),-1!==i.items.indexOf(b))return void("single"===j&&i.close());i.options.hasOwnProperty(b)&&("single"===j&&i.clear(c),"multi"===j&&i.isFull()||(d=a(i.render("item",i.options[b])),h=i.isFull(),i.items.splice(i.caretPos,0,b),i.insertAtCaret(d),(!i.isPending||!h&&i.isFull())&&i.refreshState(),i.isSetup&&(f=i.$dropdown_content.find("[data-selectable]"),i.isPending||(e=i.getOption(b),g=i.getAdjacentOption(e,1).attr("data-value"),i.refreshOptions(i.isFocused&&"single"!==j),g&&i.setActiveOption(i.getOption(g))),!f.length||i.isFull()?i.close():i.isPending||i.positionDropdown(),i.updatePlaceholder(),i.trigger("item_add",b,d),i.isPending||i.updateOriginalInput({silent:c}))))})},removeItem:function(b,c){var d,e,f,g=this;d=b instanceof a?b:g.getItem(b),b=k(d.attr("data-value")),-1!==(e=g.items.indexOf(b))&&(d.remove(),d.hasClass("active")&&(f=g.$activeItems.indexOf(d[0]),g.$activeItems.splice(f,1)),g.items.splice(e,1),g.lastQuery=null,!g.settings.persist&&g.userOptions.hasOwnProperty(b)&&g.removeOption(b,c),e<g.caretPos&&g.setCaret(g.caretPos-1),g.refreshState(),g.updatePlaceholder(),g.updateOriginalInput({silent:c}),g.positionDropdown(),g.trigger("item_remove",b,d))},createItem:function(b,c){var d=this,e=d.caretPos;b=b||a.trim(d.$control_input.val()||"");var f=arguments[arguments.length-1];if("function"!=typeof f&&(f=function(){}),"boolean"!=typeof c&&(c=!0),!d.canCreate(b))return f(),!1;d.lock();var g="function"==typeof d.settings.create?this.settings.create:function(a){var b={};return b[d.settings.labelField]=a,b[d.settings.valueField]=a,b},h=n(function(a){if(d.unlock(),!a||"object"!=typeof a)return f();var b=k(a[d.settings.valueField]);if("string"!=typeof b)return f();d.setTextboxValue(""),d.addOption(a),d.setCaret(e),d.addItem(b),d.refreshOptions(c&&"single"!==d.settings.mode),f(a)}),i=g.apply(this,[b,h]);return void 0!==i&&h(i),!0},refreshItems:function(){this.lastQuery=null,this.isSetup&&this.addItem(this.items),this.refreshState(),this.updateOriginalInput()},refreshState:function(){this.refreshValidityState(),this.refreshClasses()},refreshValidityState:function(){if(!this.isRequired)return!1;var a=!this.items.length;this.isInvalid=a,this.$control_input.prop("required",a),this.$input.prop("required",!a)},refreshClasses:function(){var b=this,c=b.isFull(),d=b.isLocked;b.$wrapper.toggleClass("rtl",b.rtl),b.$control.toggleClass("focus",b.isFocused).toggleClass("disabled",b.isDisabled).toggleClass("required",b.isRequired).toggleClass("invalid",b.isInvalid).toggleClass("locked",d).toggleClass("full",c).toggleClass("not-full",!c).toggleClass("input-active",b.isFocused&&!b.isInputHidden).toggleClass("dropdown-active",b.isOpen).toggleClass("has-options",!a.isEmptyObject(b.options)).toggleClass("has-items",b.items.length>0),b.$control_input.data("grow",!c&&!d)},isFull:function(){return null!==this.settings.maxItems&&this.items.length>=this.settings.maxItems},updateOriginalInput:function(a){var b,c,d,e,f=this;if(a=a||{},1===f.tagType){for(d=[],b=0,c=f.items.length;b<c;b++)e=f.options[f.items[b]][f.settings.labelField]||"",d.push('<option value="'+l(f.items[b])+'" selected="selected">'+l(e)+"</option>");d.length||this.$input.attr("multiple")||d.push('<option value="" selected="selected"></option>'),f.$input.html(d.join(""))}else f.$input.val(f.getValue()),f.$input.attr("value",f.$input.val());f.isSetup&&(a.silent||f.trigger("change",f.$input.val()))},updatePlaceholder:function(){if(this.settings.placeholder){var a=this.$control_input;this.items.length?a.removeAttr("placeholder"):a.attr("placeholder",this.settings.placeholder),a.triggerHandler("update",{force:!0})}},open:function(){var a=this;a.isLocked||a.isOpen||"multi"===a.settings.mode&&a.isFull()||(a.focus(),a.isOpen=!0,a.refreshState(),a.$dropdown.css({visibility:"hidden",display:"block"}),a.positionDropdown(),a.$dropdown.css({visibility:"visible"}),a.trigger("dropdown_open",a.$dropdown))},close:function(){var a=this,b=a.isOpen;"single"===a.settings.mode&&a.items.length&&(a.hideInput(),a.isBlurring||a.$control_input.blur()),a.isOpen=!1,a.$dropdown.hide(),a.setActiveOption(null),a.refreshState(),b&&a.trigger("dropdown_close",a.$dropdown)},positionDropdown:function(){var a=this.$control,b="body"===this.settings.dropdownParent?a.offset():a.position();b.top+=a.outerHeight(!0),this.$dropdown.css({width:a[0].getBoundingClientRect().width,top:b.top,left:b.left})},clear:function(a){var b=this;b.items.length&&(b.$control.children(":not(input)").remove(),b.items=[],b.lastQuery=null,b.setCaret(0),b.setActiveItem(null),b.updatePlaceholder(),b.updateOriginalInput({silent:a}),b.refreshState(),b.showInput(),b.trigger("clear"))},insertAtCaret:function(a){var b=Math.min(this.caretPos,this.items.length),c=a[0],d=this.buffer||this.$control[0];0===b?d.insertBefore(c,d.firstChild):d.insertBefore(c,d.childNodes[b]),this.setCaret(b+1)},deleteSelection:function(b){var c,d,e,f,g,h,i,j,k,l=this;if(e=b&&8===b.keyCode?-1:1,f=r(l.$control_input[0]),l.$activeOption&&!l.settings.hideSelected&&(i=l.getAdjacentOption(l.$activeOption,-1).attr("data-value")),g=[],l.$activeItems.length){for(k=l.$control.children(".active:"+(e>0?"last":"first")),h=l.$control.children(":not(input)").index(k),e>0&&h++,c=0,d=l.$activeItems.length;c<d;c++)g.push(a(l.$activeItems[c]).attr("data-value"));b&&(b.preventDefault(),b.stopPropagation())}else(l.isFocused||"single"===l.settings.mode)&&l.items.length&&(e<0&&0===f.start&&0===f.length?g.push(l.items[l.caretPos-1]):e>0&&f.start===l.$control_input.val().length&&g.push(l.items[l.caretPos]));if(!g.length||"function"==typeof l.settings.onDelete&&!1===l.settings.onDelete.apply(l,[g]))return!1;for(void 0!==h&&l.setCaret(h);g.length;)l.removeItem(g.pop());return l.showInput(),l.positionDropdown(),l.refreshOptions(!0),i&&(j=l.getOption(i),j.length&&l.setActiveOption(j)),!0},advanceSelection:function(a,b){var c,d,e,f,g,h=this;0!==a&&(h.rtl&&(a*=-1),c=a>0?"last":"first",d=r(h.$control_input[0]),h.isFocused&&!h.isInputHidden?(f=h.$control_input.val().length,(a<0?0===d.start&&0===d.length:d.start===f)&&!f&&h.advanceCaret(a,b)):(g=h.$control.children(".active:"+c),g.length&&(e=h.$control.children(":not(input)").index(g),h.setActiveItem(null),h.setCaret(a>0?e+1:e))))},advanceCaret:function(a,b){var c,d,e=this;0!==a&&(c=a>0?"next":"prev",e.isShiftDown?(d=e.$control_input[c](),d.length&&(e.hideInput(),e.setActiveItem(d),b&&b.preventDefault())):e.setCaret(e.caretPos+a))},setCaret:function(b){var c=this;if(b="single"===c.settings.mode?c.items.length:Math.max(0,Math.min(c.items.length,b)),!c.isPending){var d,e,f,g;for(f=c.$control.children(":not(input)"),d=0,e=f.length;d<e;d++)g=a(f[d]).detach(),d<b?c.$control_input.before(g):c.$control.append(g)}c.caretPos=b},lock:function(){this.close(),this.isLocked=!0,this.refreshState()},unlock:function(){this.isLocked=!1,this.refreshState()},disable:function(){var a=this;a.$input.prop("disabled",!0),a.$control_input.prop("disabled",!0).prop("tabindex",-1),a.isDisabled=!0,a.lock()},enable:function(){var a=this;a.$input.prop("disabled",!1),a.$control_input.prop("disabled",!1).prop("tabindex",a.tabIndex),a.isDisabled=!1,a.unlock()},destroy:function(){var b=this,c=b.eventNS,d=b.revertSettings;b.trigger("destroy"),b.off(),b.$wrapper.remove(),b.$dropdown.remove(),b.$input.html("").append(d.$children).removeAttr("tabindex").removeClass("selectized").attr({tabindex:d.tabindex}).show(),b.$control_input.removeData("grow"),b.$input.removeData("selectize"),0==--w.count&&w.$testInput&&(w.$testInput.remove(),w.$testInput=void 0),a(window).off(c),a(document).off(c),a(document.body).off(c),delete b.$input[0].selectize},render:function(b,c){var d,e,f="",g=!1,h=this;return"option"!==b&&"item"!==b||(d=k(c[h.settings.valueField]),g=!!d),g&&(j(h.renderCache[b])||(h.renderCache[b]={}),h.renderCache[b].hasOwnProperty(d))?h.renderCache[b][d]:(f=a(h.settings.render[b].apply(this,[c,l])),"option"===b||"option_create"===b?c[h.settings.disabledField]||f.attr("data-selectable",""):"optgroup"===b&&(e=c[h.settings.optgroupValueField]||"",f.attr("data-group",e),c[h.settings.disabledField]&&f.attr("data-disabled","")),"option"!==b&&"item"!==b||f.attr("data-value",d||""),g&&(h.renderCache[b][d]=f[0]),f[0])},clearCache:function(a){var b=this;void 0===a?b.renderCache={}:delete b.renderCache[a]},canCreate:function(a){var b=this;if(!b.settings.create)return!1;var c=b.settings.createFilter;return a.length&&("function"!=typeof c||c.apply(b,[a]))&&("string"!=typeof c||new RegExp(c).test(a))&&(!(c instanceof RegExp)||c.test(a))}}),w.count=0,w.defaults={options:[],optgroups:[],plugins:[],delimiter:",",splitOn:null,persist:!0,diacritics:!0,
	create:!1,createOnBlur:!1,createFilter:null,highlight:!0,openOnFocus:!0,maxOptions:1e3,maxItems:null,hideSelected:null,addPrecedence:!1,selectOnTab:!1,preload:!1,allowEmptyOption:!1,closeAfterSelect:!1,scrollDuration:60,loadThrottle:300,loadingClass:"loading",dataAttr:"data-data",optgroupField:"optgroup",valueField:"value",labelField:"text",disabledField:"disabled",optgroupLabelField:"label",optgroupValueField:"value",lockOptgroupOrder:!1,sortField:"$order",searchField:["text"],searchConjunction:"and",mode:null,wrapperClass:"selectize-control",inputClass:"selectize-input",dropdownClass:"selectize-dropdown",dropdownContentClass:"selectize-dropdown-content",dropdownParent:null,copyClassesToDropdown:!0,render:{}},a.fn.selectize=function(b){var c=a.fn.selectize.defaults,d=a.extend({},c,b),e=d.dataAttr,f=d.labelField,g=d.valueField,h=d.disabledField,i=d.optgroupField,j=d.optgroupLabelField,l=d.optgroupValueField,m=function(b,c){var h,i,j,k,l=b.attr(e);if(l)for(c.options=JSON.parse(l),h=0,i=c.options.length;h<i;h++)c.items.push(c.options[h][g]);else{var m=a.trim(b.val()||"");if(!d.allowEmptyOption&&!m.length)return;for(j=m.split(d.delimiter),h=0,i=j.length;h<i;h++)k={},k[f]=j[h],k[g]=j[h],c.options.push(k);c.items=j}},n=function(b,c){var m,n,o,p,q=c.options,r={},s=function(a){var b=e&&a.attr(e);return"string"==typeof b&&b.length?JSON.parse(b):null},t=function(b,e){b=a(b);var j=k(b.val());if(j||d.allowEmptyOption)if(r.hasOwnProperty(j)){if(e){var l=r[j][i];l?a.isArray(l)?l.push(e):r[j][i]=[l,e]:r[j][i]=e}}else{var m=s(b)||{};m[f]=m[f]||b.text(),m[g]=m[g]||j,m[h]=m[h]||b.prop("disabled"),m[i]=m[i]||e,r[j]=m,q.push(m),b.is(":selected")&&c.items.push(j)}};for(c.maxItems=b.attr("multiple")?null:1,p=b.children(),m=0,n=p.length;m<n;m++)o=p[m].tagName.toLowerCase(),"optgroup"===o?function(b){var d,e,f,g,i;for(b=a(b),f=b.attr("label"),f&&(g=s(b)||{},g[j]=f,g[l]=f,g[h]=b.prop("disabled"),c.optgroups.push(g)),i=a("option",b),d=0,e=i.length;d<e;d++)t(i[d],f)}(p[m]):"option"===o&&t(p[m])};return this.each(function(){if(!this.selectize){var e=a(this),f=this.tagName.toLowerCase(),g=e.attr("placeholder")||e.attr("data-placeholder");g||d.allowEmptyOption||(g=e.children('option[value=""]').text());var h={placeholder:g,options:[],optgroups:[],items:[]};"select"===f?n(e,h):m(e,h),new w(e,a.extend(!0,{},c,h,b))}})},a.fn.selectize.defaults=w.defaults,a.fn.selectize.support={validity:i},w.define("drag_drop",function(b){if(!a.fn.sortable)throw new Error('The "drag_drop" plugin requires jQuery UI "sortable".');if("multi"===this.settings.mode){var c=this;c.lock=function(){var a=c.lock;return function(){var b=c.$control.data("sortable");return b&&b.disable(),a.apply(c,arguments)}}(),c.unlock=function(){var a=c.unlock;return function(){var b=c.$control.data("sortable");return b&&b.enable(),a.apply(c,arguments)}}(),c.setup=function(){var b=c.setup;return function(){b.apply(this,arguments);var d=c.$control.sortable({items:"[data-value]",forcePlaceholderSize:!0,disabled:c.isLocked,start:function(a,b){b.placeholder.css("width",b.helper.css("width")),d.css({overflow:"visible"})},stop:function(){d.css({overflow:"hidden"});var b=c.$activeItems?c.$activeItems.slice():null,e=[];d.children("[data-value]").each(function(){e.push(a(this).attr("data-value"))}),c.setValue(e),c.setActiveItem(b)}})}}()}}),w.define("dropdown_header",function(b){var c=this;b=a.extend({title:"Untitled",headerClass:"selectize-dropdown-header",titleRowClass:"selectize-dropdown-header-title",labelClass:"selectize-dropdown-header-label",closeClass:"selectize-dropdown-header-close",html:function(a){return'<div class="'+a.headerClass+'"><div class="'+a.titleRowClass+'"><span class="'+a.labelClass+'">'+a.title+'</span><a href="javascript:void(0)" class="'+a.closeClass+'">&times;</a></div></div>'}},b),c.setup=function(){var d=c.setup;return function(){d.apply(c,arguments),c.$dropdown_header=a(b.html(b)),c.$dropdown.prepend(c.$dropdown_header)}}()}),w.define("optgroup_columns",function(b){var c=this;b=a.extend({equalizeWidth:!0,equalizeHeight:!0},b),this.getAdjacentOption=function(b,c){var d=b.closest("[data-group]").find("[data-selectable]"),e=d.index(b)+c;return e>=0&&e<d.length?d.eq(e):a()},this.onKeyDown=function(){var a=c.onKeyDown;return function(b){var d,e,f,g;return!this.isOpen||37!==b.keyCode&&39!==b.keyCode?a.apply(this,arguments):(c.ignoreHover=!0,g=this.$activeOption.closest("[data-group]"),d=g.find("[data-selectable]").index(this.$activeOption),g=37===b.keyCode?g.prev("[data-group]"):g.next("[data-group]"),f=g.find("[data-selectable]"),e=f.eq(Math.min(f.length-1,d)),void(e.length&&this.setActiveOption(e)))}}();var d=function(){var a,b=d.width,c=document;return void 0===b&&(a=c.createElement("div"),a.innerHTML='<div style="width:50px;height:50px;position:absolute;left:-50px;top:-50px;overflow:auto;"><div style="width:1px;height:100px;"></div></div>',a=a.firstChild,c.body.appendChild(a),b=d.width=a.offsetWidth-a.clientWidth,c.body.removeChild(a)),b},e=function(){var e,f,g,h,i,j,k;if(k=a("[data-group]",c.$dropdown_content),(f=k.length)&&c.$dropdown_content.width()){if(b.equalizeHeight){for(g=0,e=0;e<f;e++)g=Math.max(g,k.eq(e).height());k.css({height:g})}b.equalizeWidth&&(j=c.$dropdown_content.innerWidth()-d(),h=Math.round(j/f),k.css({width:h}),f>1&&(i=j-h*(f-1),k.eq(f-1).css({width:i})))}};(b.equalizeHeight||b.equalizeWidth)&&(m.after(this,"positionDropdown",e),m.after(this,"refreshOptions",e))}),w.define("remove_button",function(b){b=a.extend({label:"&times;",title:"Remove",className:"remove",append:!0},b);if("single"===this.settings.mode)return void function(b,c){c.className="remove-single";var d=b,e='<a href="javascript:void(0)" class="'+c.className+'" tabindex="-1" title="'+l(c.title)+'">'+c.label+"</a>",f=function(b,c){return a("<span>").append(b).append(c)};b.setup=function(){var g=d.setup;return function(){if(c.append){var h=a(d.$input.context).attr("id"),i=(a("#"+h),d.settings.render.item);d.settings.render.item=function(a){return f(i.apply(b,arguments),e)}}g.apply(b,arguments),b.$control.on("click","."+c.className,function(a){a.preventDefault(),d.isLocked||d.clear()})}}()}(this,b);!function(b,c){var d=b,e='<a href="javascript:void(0)" class="'+c.className+'" tabindex="-1" title="'+l(c.title)+'">'+c.label+"</a>",f=function(a,b){var c=a.search(/(<\/[^>]+>\s*)$/);return a.substring(0,c)+b+a.substring(c)};b.setup=function(){var g=d.setup;return function(){if(c.append){var h=d.settings.render.item;d.settings.render.item=function(a){return f(h.apply(b,arguments),e)}}g.apply(b,arguments),b.$control.on("click","."+c.className,function(b){if(b.preventDefault(),!d.isLocked){var c=a(b.currentTarget).parent();d.setActiveItem(c),d.deleteSelection()&&d.setCaret(d.items.length)}})}}()}(this,b)}),w.define("restore_on_backspace",function(a){var b=this;a.text=a.text||function(a){return a[this.settings.labelField]},this.onKeyDown=function(){var c=b.onKeyDown;return function(b){var d,e;return 8===b.keyCode&&""===this.$control_input.val()&&!this.$activeItems.length&&(d=this.caretPos-1)>=0&&d<this.items.length?(e=this.options[this.items[d]],this.deleteSelection(b)&&(this.setTextboxValue(a.text.apply(this,[e])),this.refreshOptions(!0)),void b.preventDefault()):c.apply(this,arguments)}}()}),w});

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {/**
	 * sifter.js
	 * Copyright (c) 2013 Brian Reavis & contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 * @author Brian Reavis <brian@thirdroute.com>
	 */
	
	(function(root, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			root.Sifter = factory();
		}
	}(this, function() {
	
		/**
		 * Textually searches arrays and hashes of objects
		 * by property (or multiple properties). Designed
		 * specifically for autocomplete.
		 *
		 * @constructor
		 * @param {array|object} items
		 * @param {object} items
		 */
		var Sifter = function(items, settings) {
			this.items = items;
			this.settings = settings || {diacritics: true};
		};
	
		/**
		 * Splits a search string into an array of individual
		 * regexps to be used to match results.
		 *
		 * @param {string} query
		 * @returns {array}
		 */
		Sifter.prototype.tokenize = function(query) {
			query = trim(String(query || '').toLowerCase());
			if (!query || !query.length) return [];
	
			var i, n, regex, letter;
			var tokens = [];
			var words = query.split(/ +/);
	
			for (i = 0, n = words.length; i < n; i++) {
				regex = escape_regex(words[i]);
				if (this.settings.diacritics) {
					for (letter in DIACRITICS) {
						if (DIACRITICS.hasOwnProperty(letter)) {
							regex = regex.replace(new RegExp(letter, 'g'), DIACRITICS[letter]);
						}
					}
				}
				tokens.push({
					string : words[i],
					regex  : new RegExp(regex, 'i')
				});
			}
	
			return tokens;
		};
	
		/**
		 * Iterates over arrays and hashes.
		 *
		 * ```
		 * this.iterator(this.items, function(item, id) {
		 *    // invoked for each item
		 * });
		 * ```
		 *
		 * @param {array|object} object
		 */
		Sifter.prototype.iterator = function(object, callback) {
			var iterator;
			if (is_array(object)) {
				iterator = Array.prototype.forEach || function(callback) {
					for (var i = 0, n = this.length; i < n; i++) {
						callback(this[i], i, this);
					}
				};
			} else {
				iterator = function(callback) {
					for (var key in this) {
						if (this.hasOwnProperty(key)) {
							callback(this[key], key, this);
						}
					}
				};
			}
	
			iterator.apply(object, [callback]);
		};
	
		/**
		 * Returns a function to be used to score individual results.
		 *
		 * Good matches will have a higher score than poor matches.
		 * If an item is not a match, 0 will be returned by the function.
		 *
		 * @param {object|string} search
		 * @param {object} options (optional)
		 * @returns {function}
		 */
		Sifter.prototype.getScoreFunction = function(search, options) {
			var self, fields, tokens, token_count, nesting;
	
			self        = this;
			search      = self.prepareSearch(search, options);
			tokens      = search.tokens;
			fields      = search.options.fields;
			token_count = tokens.length;
			nesting     = search.options.nesting;
	
			/**
			 * Calculates how close of a match the
			 * given value is against a search token.
			 *
			 * @param {mixed} value
			 * @param {object} token
			 * @return {number}
			 */
			var scoreValue = function(value, token) {
				var score, pos;
	
				if (!value) return 0;
				value = String(value || '');
				pos = value.search(token.regex);
				if (pos === -1) return 0;
				score = token.string.length / value.length;
				if (pos === 0) score += 0.5;
				return score;
			};
	
			/**
			 * Calculates the score of an object
			 * against the search query.
			 *
			 * @param {object} token
			 * @param {object} data
			 * @return {number}
			 */
			var scoreObject = (function() {
				var field_count = fields.length;
				if (!field_count) {
					return function() { return 0; };
				}
				if (field_count === 1) {
					return function(token, data) {
						return scoreValue(getattr(data, fields[0], nesting), token);
					};
				}
				return function(token, data) {
					for (var i = 0, sum = 0; i < field_count; i++) {
						sum += scoreValue(getattr(data, fields[i], nesting), token);
					}
					return sum / field_count;
				};
			})();
	
			if (!token_count) {
				return function() { return 0; };
			}
			if (token_count === 1) {
				return function(data) {
					return scoreObject(tokens[0], data);
				};
			}
	
			if (search.options.conjunction === 'and') {
				return function(data) {
					var score;
					for (var i = 0, sum = 0; i < token_count; i++) {
						score = scoreObject(tokens[i], data);
						if (score <= 0) return 0;
						sum += score;
					}
					return sum / token_count;
				};
			} else {
				return function(data) {
					for (var i = 0, sum = 0; i < token_count; i++) {
						sum += scoreObject(tokens[i], data);
					}
					return sum / token_count;
				};
			}
		};
	
		/**
		 * Returns a function that can be used to compare two
		 * results, for sorting purposes. If no sorting should
		 * be performed, `null` will be returned.
		 *
		 * @param {string|object} search
		 * @param {object} options
		 * @return function(a,b)
		 */
		Sifter.prototype.getSortFunction = function(search, options) {
			var i, n, self, field, fields, fields_count, multiplier, multipliers, get_field, implicit_score, sort;
	
			self   = this;
			search = self.prepareSearch(search, options);
			sort   = (!search.query && options.sort_empty) || options.sort;
	
			/**
			 * Fetches the specified sort field value
			 * from a search result item.
			 *
			 * @param  {string} name
			 * @param  {object} result
			 * @return {mixed}
			 */
			get_field = function(name, result) {
				if (name === '$score') return result.score;
				return getattr(self.items[result.id], name, options.nesting);
			};
	
			// parse options
			fields = [];
			if (sort) {
				for (i = 0, n = sort.length; i < n; i++) {
					if (search.query || sort[i].field !== '$score') {
						fields.push(sort[i]);
					}
				}
			}
	
			// the "$score" field is implied to be the primary
			// sort field, unless it's manually specified
			if (search.query) {
				implicit_score = true;
				for (i = 0, n = fields.length; i < n; i++) {
					if (fields[i].field === '$score') {
						implicit_score = false;
						break;
					}
				}
				if (implicit_score) {
					fields.unshift({field: '$score', direction: 'desc'});
				}
			} else {
				for (i = 0, n = fields.length; i < n; i++) {
					if (fields[i].field === '$score') {
						fields.splice(i, 1);
						break;
					}
				}
			}
	
			multipliers = [];
			for (i = 0, n = fields.length; i < n; i++) {
				multipliers.push(fields[i].direction === 'desc' ? -1 : 1);
			}
	
			// build function
			fields_count = fields.length;
			if (!fields_count) {
				return null;
			} else if (fields_count === 1) {
				field = fields[0].field;
				multiplier = multipliers[0];
				return function(a, b) {
					return multiplier * cmp(
						get_field(field, a),
						get_field(field, b)
					);
				};
			} else {
				return function(a, b) {
					var i, result, a_value, b_value, field;
					for (i = 0; i < fields_count; i++) {
						field = fields[i].field;
						result = multipliers[i] * cmp(
							get_field(field, a),
							get_field(field, b)
						);
						if (result) return result;
					}
					return 0;
				};
			}
		};
	
		/**
		 * Parses a search query and returns an object
		 * with tokens and fields ready to be populated
		 * with results.
		 *
		 * @param {string} query
		 * @param {object} options
		 * @returns {object}
		 */
		Sifter.prototype.prepareSearch = function(query, options) {
			if (typeof query === 'object') return query;
	
			options = extend({}, options);
	
			var option_fields     = options.fields;
			var option_sort       = options.sort;
			var option_sort_empty = options.sort_empty;
	
			if (option_fields && !is_array(option_fields)) options.fields = [option_fields];
			if (option_sort && !is_array(option_sort)) options.sort = [option_sort];
			if (option_sort_empty && !is_array(option_sort_empty)) options.sort_empty = [option_sort_empty];
	
			return {
				options : options,
				query   : String(query || '').toLowerCase(),
				tokens  : this.tokenize(query),
				total   : 0,
				items   : []
			};
		};
	
		/**
		 * Searches through all items and returns a sorted array of matches.
		 *
		 * The `options` parameter can contain:
		 *
		 *   - fields {string|array}
		 *   - sort {array}
		 *   - score {function}
		 *   - filter {bool}
		 *   - limit {integer}
		 *
		 * Returns an object containing:
		 *
		 *   - options {object}
		 *   - query {string}
		 *   - tokens {array}
		 *   - total {int}
		 *   - items {array}
		 *
		 * @param {string} query
		 * @param {object} options
		 * @returns {object}
		 */
		Sifter.prototype.search = function(query, options) {
			var self = this, value, score, search, calculateScore;
			var fn_sort;
			var fn_score;
	
			search  = this.prepareSearch(query, options);
			options = search.options;
			query   = search.query;
	
			// generate result scoring function
			fn_score = options.score || self.getScoreFunction(search);
	
			// perform search and sort
			if (query.length) {
				self.iterator(self.items, function(item, id) {
					score = fn_score(item);
					if (options.filter === false || score > 0) {
						search.items.push({'score': score, 'id': id});
					}
				});
			} else {
				self.iterator(self.items, function(item, id) {
					search.items.push({'score': 1, 'id': id});
				});
			}
	
			fn_sort = self.getSortFunction(search, options);
			if (fn_sort) search.items.sort(fn_sort);
	
			// apply limits
			search.total = search.items.length;
			if (typeof options.limit === 'number') {
				search.items = search.items.slice(0, options.limit);
			}
	
			return search;
		};
	
		// utilities
		// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	
		var cmp = function(a, b) {
			if (typeof a === 'number' && typeof b === 'number') {
				return a > b ? 1 : (a < b ? -1 : 0);
			}
			a = asciifold(String(a || ''));
			b = asciifold(String(b || ''));
			if (a > b) return 1;
			if (b > a) return -1;
			return 0;
		};
	
		var extend = function(a, b) {
			var i, n, k, object;
			for (i = 1, n = arguments.length; i < n; i++) {
				object = arguments[i];
				if (!object) continue;
				for (k in object) {
					if (object.hasOwnProperty(k)) {
						a[k] = object[k];
					}
				}
			}
			return a;
		};
	
		/**
		 * A property getter resolving dot-notation
		 * @param  {Object}  obj     The root object to fetch property on
		 * @param  {String}  name    The optionally dotted property name to fetch
		 * @param  {Boolean} nesting Handle nesting or not
		 * @return {Object}          The resolved property value
		 */
		var getattr = function(obj, name, nesting) {
		    if (!obj || !name) return;
		    if (!nesting) return obj[name];
		    var names = name.split(".");
		    while(names.length && (obj = obj[names.shift()]));
		    return obj;
		};
	
		var trim = function(str) {
			return (str + '').replace(/^\s+|\s+$|/g, '');
		};
	
		var escape_regex = function(str) {
			return (str + '').replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
		};
	
		var is_array = Array.isArray || (typeof $ !== 'undefined' && $.isArray) || function(object) {
			return Object.prototype.toString.call(object) === '[object Array]';
		};
	
		var DIACRITICS = {
			'a': '[aḀḁĂăÂâǍǎȺⱥȦȧẠạÄäÀàÁáĀāÃãÅåąĄÃąĄ]',
			'b': '[b␢βΒB฿𐌁ᛒ]',
			'c': '[cĆćĈĉČčĊċC̄c̄ÇçḈḉȻȼƇƈɕᴄＣｃ]',
			'd': '[dĎďḊḋḐḑḌḍḒḓḎḏĐđD̦d̦ƉɖƊɗƋƌᵭᶁᶑȡᴅＤｄð]',
			'e': '[eÉéÈèÊêḘḙĚěĔĕẼẽḚḛẺẻĖėËëĒēȨȩĘęᶒɆɇȄȅẾếỀềỄễỂểḜḝḖḗḔḕȆȇẸẹỆệⱸᴇＥｅɘǝƏƐε]',
			'f': '[fƑƒḞḟ]',
			'g': '[gɢ₲ǤǥĜĝĞğĢģƓɠĠġ]',
			'h': '[hĤĥĦħḨḩẖẖḤḥḢḣɦʰǶƕ]',
			'i': '[iÍíÌìĬĭÎîǏǐÏïḮḯĨĩĮįĪīỈỉȈȉȊȋỊịḬḭƗɨɨ̆ᵻᶖİiIıɪＩｉ]',
			'j': '[jȷĴĵɈɉʝɟʲ]',
			'k': '[kƘƙꝀꝁḰḱǨǩḲḳḴḵκϰ₭]',
			'l': '[lŁłĽľĻļĹĺḶḷḸḹḼḽḺḻĿŀȽƚⱠⱡⱢɫɬᶅɭȴʟＬｌ]',
			'n': '[nŃńǸǹŇňÑñṄṅŅņṆṇṊṋṈṉN̈n̈ƝɲȠƞᵰᶇɳȵɴＮｎŊŋ]',
			'o': '[oØøÖöÓóÒòÔôǑǒŐőŎŏȮȯỌọƟɵƠơỎỏŌōÕõǪǫȌȍՕօ]',
			'p': '[pṔṕṖṗⱣᵽƤƥᵱ]',
			'q': '[qꝖꝗʠɊɋꝘꝙq̃]',
			'r': '[rŔŕɌɍŘřŖŗṘṙȐȑȒȓṚṛⱤɽ]',
			's': '[sŚśṠṡṢṣꞨꞩŜŝŠšŞşȘșS̈s̈]',
			't': '[tŤťṪṫŢţṬṭƮʈȚțṰṱṮṯƬƭ]',
			'u': '[uŬŭɄʉỤụÜüÚúÙùÛûǓǔŰűŬŭƯưỦủŪūŨũŲųȔȕ∪]',
			'v': '[vṼṽṾṿƲʋꝞꝟⱱʋ]',
			'w': '[wẂẃẀẁŴŵẄẅẆẇẈẉ]',
			'x': '[xẌẍẊẋχ]',
			'y': '[yÝýỲỳŶŷŸÿỸỹẎẏỴỵɎɏƳƴ]',
			'z': '[zŹźẐẑŽžŻżẒẓẔẕƵƶ]'
		};
	
		var asciifold = (function() {
			var i, n, k, chunk;
			var foreignletters = '';
			var lookup = {};
			for (k in DIACRITICS) {
				if (DIACRITICS.hasOwnProperty(k)) {
					chunk = DIACRITICS[k].substring(2, DIACRITICS[k].length - 1);
					foreignletters += chunk;
					for (i = 0, n = chunk.length; i < n; i++) {
						lookup[chunk.charAt(i)] = k;
					}
				}
			}
			var regexp = new RegExp('[' +  foreignletters + ']', 'g');
			return function(str) {
				return str.replace(regexp, function(foreignletter) {
					return lookup[foreignletter];
				}).toLowerCase();
			};
		})();
	
	
		// export
		// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	
		return Sifter;
	}));
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * microplugin.js
	 * Copyright (c) 2013 Brian Reavis & contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
	 * file except in compliance with the License. You may obtain a copy of the License at:
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software distributed under
	 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific language
	 * governing permissions and limitations under the License.
	 *
	 * @author Brian Reavis <brian@thirdroute.com>
	 */
	
	(function(root, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			root.MicroPlugin = factory();
		}
	}(this, function() {
		var MicroPlugin = {};
	
		MicroPlugin.mixin = function(Interface) {
			Interface.plugins = {};
	
			/**
			 * Initializes the listed plugins (with options).
			 * Acceptable formats:
			 *
			 * List (without options):
			 *   ['a', 'b', 'c']
			 *
			 * List (with options):
			 *   [{'name': 'a', options: {}}, {'name': 'b', options: {}}]
			 *
			 * Hash (with options):
			 *   {'a': { ... }, 'b': { ... }, 'c': { ... }}
			 *
			 * @param {mixed} plugins
			 */
			Interface.prototype.initializePlugins = function(plugins) {
				var i, n, key;
				var self  = this;
				var queue = [];
	
				self.plugins = {
					names     : [],
					settings  : {},
					requested : {},
					loaded    : {}
				};
	
				if (utils.isArray(plugins)) {
					for (i = 0, n = plugins.length; i < n; i++) {
						if (typeof plugins[i] === 'string') {
							queue.push(plugins[i]);
						} else {
							self.plugins.settings[plugins[i].name] = plugins[i].options;
							queue.push(plugins[i].name);
						}
					}
				} else if (plugins) {
					for (key in plugins) {
						if (plugins.hasOwnProperty(key)) {
							self.plugins.settings[key] = plugins[key];
							queue.push(key);
						}
					}
				}
	
				while (queue.length) {
					self.require(queue.shift());
				}
			};
	
			Interface.prototype.loadPlugin = function(name) {
				var self    = this;
				var plugins = self.plugins;
				var plugin  = Interface.plugins[name];
	
				if (!Interface.plugins.hasOwnProperty(name)) {
					throw new Error('Unable to find "' +  name + '" plugin');
				}
	
				plugins.requested[name] = true;
				plugins.loaded[name] = plugin.fn.apply(self, [self.plugins.settings[name] || {}]);
				plugins.names.push(name);
			};
	
			/**
			 * Initializes a plugin.
			 *
			 * @param {string} name
			 */
			Interface.prototype.require = function(name) {
				var self = this;
				var plugins = self.plugins;
	
				if (!self.plugins.loaded.hasOwnProperty(name)) {
					if (plugins.requested[name]) {
						throw new Error('Plugin has circular dependency ("' + name + '")');
					}
					self.loadPlugin(name);
				}
	
				return plugins.loaded[name];
			};
	
			/**
			 * Registers a plugin.
			 *
			 * @param {string} name
			 * @param {function} fn
			 */
			Interface.define = function(name, fn) {
				Interface.plugins[name] = {
					'name' : name,
					'fn'   : fn
				};
			};
		};
	
		var utils = {
			isArray: Array.isArray || function(vArg) {
				return Object.prototype.toString.call(vArg) === '[object Array]';
			}
		};
	
		return MicroPlugin;
	}));

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(a){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):a("object"==typeof exports?require("jquery"):jQuery)}(function(a){function b(b,d,e){var d={content:{message:"object"==typeof d?d.message:d,title:d.title?d.title:"",icon:d.icon?d.icon:"",url:d.url?d.url:"#",target:d.target?d.target:"-"}};e=a.extend(!0,{},d,e),this.settings=a.extend(!0,{},c,e),this._defaults=c,"-"==this.settings.content.target&&(this.settings.content.target=this.settings.url_target),this.animations={start:"webkitAnimationStart oanimationstart MSAnimationStart animationstart",end:"webkitAnimationEnd oanimationend MSAnimationEnd animationend"},"number"==typeof this.settings.offset&&(this.settings.offset={x:this.settings.offset,y:this.settings.offset}),this.init()}var c={element:"body",position:null,type:"info",allow_dismiss:!0,newest_on_top:!1,showProgressbar:!1,placement:{from:"top",align:"right"},offset:20,spacing:10,z_index:1031,delay:5e3,timer:1e3,url_target:"_blank",mouse_over:null,animate:{enter:"animated fadeInDown",exit:"animated fadeOutUp"},onShow:null,onShown:null,onClose:null,onClosed:null,icon_type:"class",template:'<div data-notify="container" class="col-xs-11 col-sm-4 alert alert-{0}" role="alert"><button type="button" aria-hidden="true" class="close" data-notify="dismiss">&times;</button><span data-notify="icon"></span> <span data-notify="title">{1}</span> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>'};String.format=function(){for(var a=arguments[0],b=1;b<arguments.length;b++)a=a.replace(RegExp("\\{"+(b-1)+"\\}","gm"),arguments[b]);return a},a.extend(b.prototype,{init:function(){var a=this;this.buildNotify(),this.settings.content.icon&&this.setIcon(),"#"!=this.settings.content.url&&this.styleURL(),this.styleDismiss(),this.placement(),this.bind(),this.notify={$ele:this.$ele,update:function(b,c){var d={};"string"==typeof b?d[b]=c:d=b;for(var b in d)switch(b){case"type":this.$ele.removeClass("alert-"+a.settings.type),this.$ele.find('[data-notify="progressbar"] > .progress-bar').removeClass("progress-bar-"+a.settings.type),a.settings.type=d[b],this.$ele.addClass("alert-"+d[b]).find('[data-notify="progressbar"] > .progress-bar').addClass("progress-bar-"+d[b]);break;case"icon":var e=this.$ele.find('[data-notify="icon"]');"class"==a.settings.icon_type.toLowerCase()?e.removeClass(a.settings.content.icon).addClass(d[b]):(e.is("img")||e.find("img"),e.attr("src",d[b]));break;case"progress":var f=a.settings.delay-a.settings.delay*(d[b]/100);this.$ele.data("notify-delay",f),this.$ele.find('[data-notify="progressbar"] > div').attr("aria-valuenow",d[b]).css("width",d[b]+"%");break;case"url":this.$ele.find('[data-notify="url"]').attr("href",d[b]);break;case"target":this.$ele.find('[data-notify="url"]').attr("target",d[b]);break;default:this.$ele.find('[data-notify="'+b+'"]').html(d[b])}var g=this.$ele.outerHeight()+parseInt(a.settings.spacing)+parseInt(a.settings.offset.y);a.reposition(g)},close:function(){a.close()}}},buildNotify:function(){var b=this.settings.content;this.$ele=a(String.format(this.settings.template,this.settings.type,b.title,b.message,b.url,b.target)),this.$ele.attr("data-notify-position",this.settings.placement.from+"-"+this.settings.placement.align),this.settings.allow_dismiss||this.$ele.find('[data-notify="dismiss"]').css("display","none"),(this.settings.delay<=0&&!this.settings.showProgressbar||!this.settings.showProgressbar)&&this.$ele.find('[data-notify="progressbar"]').remove()},setIcon:function(){"class"==this.settings.icon_type.toLowerCase()?this.$ele.find('[data-notify="icon"]').addClass(this.settings.content.icon):this.$ele.find('[data-notify="icon"]').is("img")?this.$ele.find('[data-notify="icon"]').attr("src",this.settings.content.icon):this.$ele.find('[data-notify="icon"]').append('<img src="'+this.settings.content.icon+'" alt="Notify Icon" />')},styleDismiss:function(){this.$ele.find('[data-notify="dismiss"]').css({position:"absolute",right:"10px",top:"5px",zIndex:this.settings.z_index+2})},styleURL:function(){this.$ele.find('[data-notify="url"]').css({backgroundImage:"url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)",height:"100%",left:"0px",position:"absolute",top:"0px",width:"100%",zIndex:this.settings.z_index+1})},placement:function(){var b=this,c=this.settings.offset.y,d={display:"inline-block",margin:"0px auto",position:this.settings.position?this.settings.position:"body"===this.settings.element?"fixed":"absolute",transition:"all .5s ease-in-out",zIndex:this.settings.z_index},e=!1,f=this.settings;switch(a('[data-notify-position="'+this.settings.placement.from+"-"+this.settings.placement.align+'"]:not([data-closing="true"])').each(function(){return c=Math.max(c,parseInt(a(this).css(f.placement.from))+parseInt(a(this).outerHeight())+parseInt(f.spacing))}),1==this.settings.newest_on_top&&(c=this.settings.offset.y),d[this.settings.placement.from]=c+"px",this.settings.placement.align){case"left":case"right":d[this.settings.placement.align]=this.settings.offset.x+"px";break;case"center":d.left=0,d.right=0}this.$ele.css(d).addClass(this.settings.animate.enter),a.each(Array("webkit","moz","o","ms",""),function(a,c){b.$ele[0].style[c+"AnimationIterationCount"]=1}),a(this.settings.element).append(this.$ele),1==this.settings.newest_on_top&&(c=parseInt(c)+parseInt(this.settings.spacing)+this.$ele.outerHeight(),this.reposition(c)),a.isFunction(b.settings.onShow)&&b.settings.onShow.call(this.$ele),this.$ele.one(this.animations.start,function(a){e=!0}).one(this.animations.end,function(c){a.isFunction(b.settings.onShown)&&b.settings.onShown.call(this)}),setTimeout(function(){e||a.isFunction(b.settings.onShown)&&b.settings.onShown.call(this)},600)},bind:function(){var b=this;if(this.$ele.find('[data-notify="dismiss"]').on("click",function(){b.close()}),this.$ele.mouseover(function(b){a(this).data("data-hover","true")}).mouseout(function(b){a(this).data("data-hover","false")}),this.$ele.data("data-hover","false"),this.settings.delay>0){b.$ele.data("notify-delay",b.settings.delay);var c=setInterval(function(){var a=parseInt(b.$ele.data("notify-delay"))-b.settings.timer;if("false"===b.$ele.data("data-hover")&&"pause"==b.settings.mouse_over||"pause"!=b.settings.mouse_over){var d=(b.settings.delay-a)/b.settings.delay*100;b.$ele.data("notify-delay",a),b.$ele.find('[data-notify="progressbar"] > div').attr("aria-valuenow",d).css("width",d+"%")}a<=-b.settings.timer&&(clearInterval(c),b.close())},b.settings.timer)}},close:function(){var b=this,c=parseInt(this.$ele.css(this.settings.placement.from)),d=!1;this.$ele.data("closing","true").addClass(this.settings.animate.exit),b.reposition(c),a.isFunction(b.settings.onClose)&&b.settings.onClose.call(this.$ele),this.$ele.one(this.animations.start,function(a){d=!0}).one(this.animations.end,function(c){a(this).remove(),a.isFunction(b.settings.onClosed)&&b.settings.onClosed.call(this)}),setTimeout(function(){d||(b.$ele.remove(),b.settings.onClosed&&b.settings.onClosed(b.$ele))},600)},reposition:function(b){var c=this,d='[data-notify-position="'+this.settings.placement.from+"-"+this.settings.placement.align+'"]:not([data-closing="true"])',e=this.$ele.nextAll(d);1==this.settings.newest_on_top&&(e=this.$ele.prevAll(d)),e.each(function(){a(this).css(c.settings.placement.from,b),b=parseInt(b)+parseInt(c.settings.spacing)+a(this).outerHeight()})}}),a.notify=function(a,c){var d=new b(this,a,c);return d.notify},a.notifyDefaults=function(b){return c=a.extend(!0,{},c,b)},a.notifyClose=function(b){"undefined"==typeof b||"all"==b?a("[data-notify]").find('[data-notify="dismiss"]').trigger("click"):a('[data-notify-position="'+b+'"]').find('[data-notify="dismiss"]').trigger("click")}});

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Datepicker for Bootstrap v1.9.0 (https://github.com/uxsolutions/bootstrap-datepicker)
	 *
	 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
	 */
	
	!function(a){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):a("object"==typeof exports?require("jquery"):jQuery)}(function(a,b){function c(){return new Date(Date.UTC.apply(Date,arguments))}function d(){var a=new Date;return c(a.getFullYear(),a.getMonth(),a.getDate())}function e(a,b){return a.getUTCFullYear()===b.getUTCFullYear()&&a.getUTCMonth()===b.getUTCMonth()&&a.getUTCDate()===b.getUTCDate()}function f(c,d){return function(){return d!==b&&a.fn.datepicker.deprecated(d),this[c].apply(this,arguments)}}function g(a){return a&&!isNaN(a.getTime())}function h(b,c){function d(a,b){return b.toLowerCase()}var e,f=a(b).data(),g={},h=new RegExp("^"+c.toLowerCase()+"([A-Z])");c=new RegExp("^"+c.toLowerCase());for(var i in f)c.test(i)&&(e=i.replace(h,d),g[e]=f[i]);return g}function i(b){var c={};if(q[b]||(b=b.split("-")[0],q[b])){var d=q[b];return a.each(p,function(a,b){b in d&&(c[b]=d[b])}),c}}var j=function(){var b={get:function(a){return this.slice(a)[0]},contains:function(a){for(var b=a&&a.valueOf(),c=0,d=this.length;c<d;c++)if(0<=this[c].valueOf()-b&&this[c].valueOf()-b<864e5)return c;return-1},remove:function(a){this.splice(a,1)},replace:function(b){b&&(a.isArray(b)||(b=[b]),this.clear(),this.push.apply(this,b))},clear:function(){this.length=0},copy:function(){var a=new j;return a.replace(this),a}};return function(){var c=[];return c.push.apply(c,arguments),a.extend(c,b),c}}(),k=function(b,c){a.data(b,"datepicker",this),this._events=[],this._secondaryEvents=[],this._process_options(c),this.dates=new j,this.viewDate=this.o.defaultViewDate,this.focusDate=null,this.element=a(b),this.isInput=this.element.is("input"),this.inputField=this.isInput?this.element:this.element.find("input"),this.component=!!this.element.hasClass("date")&&this.element.find(".add-on, .input-group-addon, .input-group-append, .input-group-prepend, .btn"),this.component&&0===this.component.length&&(this.component=!1),this.isInline=!this.component&&this.element.is("div"),this.picker=a(r.template),this._check_template(this.o.templates.leftArrow)&&this.picker.find(".prev").html(this.o.templates.leftArrow),this._check_template(this.o.templates.rightArrow)&&this.picker.find(".next").html(this.o.templates.rightArrow),this._buildEvents(),this._attachEvents(),this.isInline?this.picker.addClass("datepicker-inline").appendTo(this.element):this.picker.addClass("datepicker-dropdown dropdown-menu"),this.o.rtl&&this.picker.addClass("datepicker-rtl"),this.o.calendarWeeks&&this.picker.find(".datepicker-days .datepicker-switch, thead .datepicker-title, tfoot .today, tfoot .clear").attr("colspan",function(a,b){return Number(b)+1}),this._process_options({startDate:this._o.startDate,endDate:this._o.endDate,daysOfWeekDisabled:this.o.daysOfWeekDisabled,daysOfWeekHighlighted:this.o.daysOfWeekHighlighted,datesDisabled:this.o.datesDisabled}),this._allow_update=!1,this.setViewMode(this.o.startView),this._allow_update=!0,this.fillDow(),this.fillMonths(),this.update(),this.isInline&&this.show()};k.prototype={constructor:k,_resolveViewName:function(b){return a.each(r.viewModes,function(c,d){if(b===c||-1!==a.inArray(b,d.names))return b=c,!1}),b},_resolveDaysOfWeek:function(b){return a.isArray(b)||(b=b.split(/[,\s]*/)),a.map(b,Number)},_check_template:function(c){try{if(c===b||""===c)return!1;if((c.match(/[<>]/g)||[]).length<=0)return!0;return a(c).length>0}catch(a){return!1}},_process_options:function(b){this._o=a.extend({},this._o,b);var e=this.o=a.extend({},this._o),f=e.language;q[f]||(f=f.split("-")[0],q[f]||(f=o.language)),e.language=f,e.startView=this._resolveViewName(e.startView),e.minViewMode=this._resolveViewName(e.minViewMode),e.maxViewMode=this._resolveViewName(e.maxViewMode),e.startView=Math.max(this.o.minViewMode,Math.min(this.o.maxViewMode,e.startView)),!0!==e.multidate&&(e.multidate=Number(e.multidate)||!1,!1!==e.multidate&&(e.multidate=Math.max(0,e.multidate))),e.multidateSeparator=String(e.multidateSeparator),e.weekStart%=7,e.weekEnd=(e.weekStart+6)%7;var g=r.parseFormat(e.format);e.startDate!==-1/0&&(e.startDate?e.startDate instanceof Date?e.startDate=this._local_to_utc(this._zero_time(e.startDate)):e.startDate=r.parseDate(e.startDate,g,e.language,e.assumeNearbyYear):e.startDate=-1/0),e.endDate!==1/0&&(e.endDate?e.endDate instanceof Date?e.endDate=this._local_to_utc(this._zero_time(e.endDate)):e.endDate=r.parseDate(e.endDate,g,e.language,e.assumeNearbyYear):e.endDate=1/0),e.daysOfWeekDisabled=this._resolveDaysOfWeek(e.daysOfWeekDisabled||[]),e.daysOfWeekHighlighted=this._resolveDaysOfWeek(e.daysOfWeekHighlighted||[]),e.datesDisabled=e.datesDisabled||[],a.isArray(e.datesDisabled)||(e.datesDisabled=e.datesDisabled.split(",")),e.datesDisabled=a.map(e.datesDisabled,function(a){return r.parseDate(a,g,e.language,e.assumeNearbyYear)});var h=String(e.orientation).toLowerCase().split(/\s+/g),i=e.orientation.toLowerCase();if(h=a.grep(h,function(a){return/^auto|left|right|top|bottom$/.test(a)}),e.orientation={x:"auto",y:"auto"},i&&"auto"!==i)if(1===h.length)switch(h[0]){case"top":case"bottom":e.orientation.y=h[0];break;case"left":case"right":e.orientation.x=h[0]}else i=a.grep(h,function(a){return/^left|right$/.test(a)}),e.orientation.x=i[0]||"auto",i=a.grep(h,function(a){return/^top|bottom$/.test(a)}),e.orientation.y=i[0]||"auto";else;if(e.defaultViewDate instanceof Date||"string"==typeof e.defaultViewDate)e.defaultViewDate=r.parseDate(e.defaultViewDate,g,e.language,e.assumeNearbyYear);else if(e.defaultViewDate){var j=e.defaultViewDate.year||(new Date).getFullYear(),k=e.defaultViewDate.month||0,l=e.defaultViewDate.day||1;e.defaultViewDate=c(j,k,l)}else e.defaultViewDate=d()},_applyEvents:function(a){for(var c,d,e,f=0;f<a.length;f++)c=a[f][0],2===a[f].length?(d=b,e=a[f][1]):3===a[f].length&&(d=a[f][1],e=a[f][2]),c.on(e,d)},_unapplyEvents:function(a){for(var c,d,e,f=0;f<a.length;f++)c=a[f][0],2===a[f].length?(e=b,d=a[f][1]):3===a[f].length&&(e=a[f][1],d=a[f][2]),c.off(d,e)},_buildEvents:function(){var b={keyup:a.proxy(function(b){-1===a.inArray(b.keyCode,[27,37,39,38,40,32,13,9])&&this.update()},this),keydown:a.proxy(this.keydown,this),paste:a.proxy(this.paste,this)};!0===this.o.showOnFocus&&(b.focus=a.proxy(this.show,this)),this.isInput?this._events=[[this.element,b]]:this.component&&this.inputField.length?this._events=[[this.inputField,b],[this.component,{click:a.proxy(this.show,this)}]]:this._events=[[this.element,{click:a.proxy(this.show,this),keydown:a.proxy(this.keydown,this)}]],this._events.push([this.element,"*",{blur:a.proxy(function(a){this._focused_from=a.target},this)}],[this.element,{blur:a.proxy(function(a){this._focused_from=a.target},this)}]),this.o.immediateUpdates&&this._events.push([this.element,{"changeYear changeMonth":a.proxy(function(a){this.update(a.date)},this)}]),this._secondaryEvents=[[this.picker,{click:a.proxy(this.click,this)}],[this.picker,".prev, .next",{click:a.proxy(this.navArrowsClick,this)}],[this.picker,".day:not(.disabled)",{click:a.proxy(this.dayCellClick,this)}],[a(window),{resize:a.proxy(this.place,this)}],[a(document),{"mousedown touchstart":a.proxy(function(a){this.element.is(a.target)||this.element.find(a.target).length||this.picker.is(a.target)||this.picker.find(a.target).length||this.isInline||this.hide()},this)}]]},_attachEvents:function(){this._detachEvents(),this._applyEvents(this._events)},_detachEvents:function(){this._unapplyEvents(this._events)},_attachSecondaryEvents:function(){this._detachSecondaryEvents(),this._applyEvents(this._secondaryEvents)},_detachSecondaryEvents:function(){this._unapplyEvents(this._secondaryEvents)},_trigger:function(b,c){var d=c||this.dates.get(-1),e=this._utc_to_local(d);this.element.trigger({type:b,date:e,viewMode:this.viewMode,dates:a.map(this.dates,this._utc_to_local),format:a.proxy(function(a,b){0===arguments.length?(a=this.dates.length-1,b=this.o.format):"string"==typeof a&&(b=a,a=this.dates.length-1),b=b||this.o.format;var c=this.dates.get(a);return r.formatDate(c,b,this.o.language)},this)})},show:function(){if(!(this.inputField.is(":disabled")||this.inputField.prop("readonly")&&!1===this.o.enableOnReadonly))return this.isInline||this.picker.appendTo(this.o.container),this.place(),this.picker.show(),this._attachSecondaryEvents(),this._trigger("show"),(window.navigator.msMaxTouchPoints||"ontouchstart"in document)&&this.o.disableTouchKeyboard&&a(this.element).blur(),this},hide:function(){return this.isInline||!this.picker.is(":visible")?this:(this.focusDate=null,this.picker.hide().detach(),this._detachSecondaryEvents(),this.setViewMode(this.o.startView),this.o.forceParse&&this.inputField.val()&&this.setValue(),this._trigger("hide"),this)},destroy:function(){return this.hide(),this._detachEvents(),this._detachSecondaryEvents(),this.picker.remove(),delete this.element.data().datepicker,this.isInput||delete this.element.data().date,this},paste:function(b){var c;if(b.originalEvent.clipboardData&&b.originalEvent.clipboardData.types&&-1!==a.inArray("text/plain",b.originalEvent.clipboardData.types))c=b.originalEvent.clipboardData.getData("text/plain");else{if(!window.clipboardData)return;c=window.clipboardData.getData("Text")}this.setDate(c),this.update(),b.preventDefault()},_utc_to_local:function(a){if(!a)return a;var b=new Date(a.getTime()+6e4*a.getTimezoneOffset());return b.getTimezoneOffset()!==a.getTimezoneOffset()&&(b=new Date(a.getTime()+6e4*b.getTimezoneOffset())),b},_local_to_utc:function(a){return a&&new Date(a.getTime()-6e4*a.getTimezoneOffset())},_zero_time:function(a){return a&&new Date(a.getFullYear(),a.getMonth(),a.getDate())},_zero_utc_time:function(a){return a&&c(a.getUTCFullYear(),a.getUTCMonth(),a.getUTCDate())},getDates:function(){return a.map(this.dates,this._utc_to_local)},getUTCDates:function(){return a.map(this.dates,function(a){return new Date(a)})},getDate:function(){return this._utc_to_local(this.getUTCDate())},getUTCDate:function(){var a=this.dates.get(-1);return a!==b?new Date(a):null},clearDates:function(){this.inputField.val(""),this.update(),this._trigger("changeDate"),this.o.autoclose&&this.hide()},setDates:function(){var b=a.isArray(arguments[0])?arguments[0]:arguments;return this.update.apply(this,b),this._trigger("changeDate"),this.setValue(),this},setUTCDates:function(){var b=a.isArray(arguments[0])?arguments[0]:arguments;return this.setDates.apply(this,a.map(b,this._utc_to_local)),this},setDate:f("setDates"),setUTCDate:f("setUTCDates"),remove:f("destroy","Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead"),setValue:function(){var a=this.getFormattedDate();return this.inputField.val(a),this},getFormattedDate:function(c){c===b&&(c=this.o.format);var d=this.o.language;return a.map(this.dates,function(a){return r.formatDate(a,c,d)}).join(this.o.multidateSeparator)},getStartDate:function(){return this.o.startDate},setStartDate:function(a){return this._process_options({startDate:a}),this.update(),this.updateNavArrows(),this},getEndDate:function(){return this.o.endDate},setEndDate:function(a){return this._process_options({endDate:a}),this.update(),this.updateNavArrows(),this},setDaysOfWeekDisabled:function(a){return this._process_options({daysOfWeekDisabled:a}),this.update(),this},setDaysOfWeekHighlighted:function(a){return this._process_options({daysOfWeekHighlighted:a}),this.update(),this},setDatesDisabled:function(a){return this._process_options({datesDisabled:a}),this.update(),this},place:function(){if(this.isInline)return this;var b=this.picker.outerWidth(),c=this.picker.outerHeight(),d=a(this.o.container),e=d.width(),f="body"===this.o.container?a(document).scrollTop():d.scrollTop(),g=d.offset(),h=[0];this.element.parents().each(function(){var b=a(this).css("z-index");"auto"!==b&&0!==Number(b)&&h.push(Number(b))});var i=Math.max.apply(Math,h)+this.o.zIndexOffset,j=this.component?this.component.parent().offset():this.element.offset(),k=this.component?this.component.outerHeight(!0):this.element.outerHeight(!1),l=this.component?this.component.outerWidth(!0):this.element.outerWidth(!1),m=j.left-g.left,n=j.top-g.top;"body"!==this.o.container&&(n+=f),this.picker.removeClass("datepicker-orient-top datepicker-orient-bottom datepicker-orient-right datepicker-orient-left"),"auto"!==this.o.orientation.x?(this.picker.addClass("datepicker-orient-"+this.o.orientation.x),"right"===this.o.orientation.x&&(m-=b-l)):j.left<0?(this.picker.addClass("datepicker-orient-left"),m-=j.left-10):m+b>e?(this.picker.addClass("datepicker-orient-right"),m+=l-b):this.o.rtl?this.picker.addClass("datepicker-orient-right"):this.picker.addClass("datepicker-orient-left");var o,p=this.o.orientation.y;if("auto"===p&&(o=-f+n-c,p=o<0?"bottom":"top"),this.picker.addClass("datepicker-orient-"+p),"top"===p?n-=c+parseInt(this.picker.css("padding-top")):n+=k,this.o.rtl){var q=e-(m+l);this.picker.css({top:n,right:q,zIndex:i})}else this.picker.css({top:n,left:m,zIndex:i});return this},_allow_update:!0,update:function(){if(!this._allow_update)return this;var b=this.dates.copy(),c=[],d=!1;return arguments.length?(a.each(arguments,a.proxy(function(a,b){b instanceof Date&&(b=this._local_to_utc(b)),c.push(b)},this)),d=!0):(c=this.isInput?this.element.val():this.element.data("date")||this.inputField.val(),c=c&&this.o.multidate?c.split(this.o.multidateSeparator):[c],delete this.element.data().date),c=a.map(c,a.proxy(function(a){return r.parseDate(a,this.o.format,this.o.language,this.o.assumeNearbyYear)},this)),c=a.grep(c,a.proxy(function(a){return!this.dateWithinRange(a)||!a},this),!0),this.dates.replace(c),this.o.updateViewDate&&(this.dates.length?this.viewDate=new Date(this.dates.get(-1)):this.viewDate<this.o.startDate?this.viewDate=new Date(this.o.startDate):this.viewDate>this.o.endDate?this.viewDate=new Date(this.o.endDate):this.viewDate=this.o.defaultViewDate),d?(this.setValue(),this.element.change()):this.dates.length&&String(b)!==String(this.dates)&&d&&(this._trigger("changeDate"),this.element.change()),!this.dates.length&&b.length&&(this._trigger("clearDate"),this.element.change()),this.fill(),this},fillDow:function(){if(this.o.showWeekDays){var b=this.o.weekStart,c="<tr>";for(this.o.calendarWeeks&&(c+='<th class="cw">&#160;</th>');b<this.o.weekStart+7;)c+='<th class="dow',-1!==a.inArray(b,this.o.daysOfWeekDisabled)&&(c+=" disabled"),c+='">'+q[this.o.language].daysMin[b++%7]+"</th>";c+="</tr>",this.picker.find(".datepicker-days thead").append(c)}},fillMonths:function(){for(var a,b=this._utc_to_local(this.viewDate),c="",d=0;d<12;d++)a=b&&b.getMonth()===d?" focused":"",c+='<span class="month'+a+'">'+q[this.o.language].monthsShort[d]+"</span>";this.picker.find(".datepicker-months td").html(c)},setRange:function(b){b&&b.length?this.range=a.map(b,function(a){return a.valueOf()}):delete this.range,this.fill()},getClassNames:function(b){var c=[],f=this.viewDate.getUTCFullYear(),g=this.viewDate.getUTCMonth(),h=d();return b.getUTCFullYear()<f||b.getUTCFullYear()===f&&b.getUTCMonth()<g?c.push("old"):(b.getUTCFullYear()>f||b.getUTCFullYear()===f&&b.getUTCMonth()>g)&&c.push("new"),this.focusDate&&b.valueOf()===this.focusDate.valueOf()&&c.push("focused"),this.o.todayHighlight&&e(b,h)&&c.push("today"),-1!==this.dates.contains(b)&&c.push("active"),this.dateWithinRange(b)||c.push("disabled"),this.dateIsDisabled(b)&&c.push("disabled","disabled-date"),-1!==a.inArray(b.getUTCDay(),this.o.daysOfWeekHighlighted)&&c.push("highlighted"),this.range&&(b>this.range[0]&&b<this.range[this.range.length-1]&&c.push("range"),-1!==a.inArray(b.valueOf(),this.range)&&c.push("selected"),b.valueOf()===this.range[0]&&c.push("range-start"),b.valueOf()===this.range[this.range.length-1]&&c.push("range-end")),c},_fill_yearsView:function(c,d,e,f,g,h,i){for(var j,k,l,m="",n=e/10,o=this.picker.find(c),p=Math.floor(f/e)*e,q=p+9*n,r=Math.floor(this.viewDate.getFullYear()/n)*n,s=a.map(this.dates,function(a){return Math.floor(a.getUTCFullYear()/n)*n}),t=p-n;t<=q+n;t+=n)j=[d],k=null,t===p-n?j.push("old"):t===q+n&&j.push("new"),-1!==a.inArray(t,s)&&j.push("active"),(t<g||t>h)&&j.push("disabled"),t===r&&j.push("focused"),i!==a.noop&&(l=i(new Date(t,0,1)),l===b?l={}:"boolean"==typeof l?l={enabled:l}:"string"==typeof l&&(l={classes:l}),!1===l.enabled&&j.push("disabled"),l.classes&&(j=j.concat(l.classes.split(/\s+/))),l.tooltip&&(k=l.tooltip)),m+='<span class="'+j.join(" ")+'"'+(k?' title="'+k+'"':"")+">"+t+"</span>";o.find(".datepicker-switch").text(p+"-"+q),o.find("td").html(m)},fill:function(){var e,f,g=new Date(this.viewDate),h=g.getUTCFullYear(),i=g.getUTCMonth(),j=this.o.startDate!==-1/0?this.o.startDate.getUTCFullYear():-1/0,k=this.o.startDate!==-1/0?this.o.startDate.getUTCMonth():-1/0,l=this.o.endDate!==1/0?this.o.endDate.getUTCFullYear():1/0,m=this.o.endDate!==1/0?this.o.endDate.getUTCMonth():1/0,n=q[this.o.language].today||q.en.today||"",o=q[this.o.language].clear||q.en.clear||"",p=q[this.o.language].titleFormat||q.en.titleFormat,s=d(),t=(!0===this.o.todayBtn||"linked"===this.o.todayBtn)&&s>=this.o.startDate&&s<=this.o.endDate&&!this.weekOfDateIsDisabled(s);if(!isNaN(h)&&!isNaN(i)){this.picker.find(".datepicker-days .datepicker-switch").text(r.formatDate(g,p,this.o.language)),this.picker.find("tfoot .today").text(n).css("display",t?"table-cell":"none"),this.picker.find("tfoot .clear").text(o).css("display",!0===this.o.clearBtn?"table-cell":"none"),this.picker.find("thead .datepicker-title").text(this.o.title).css("display","string"==typeof this.o.title&&""!==this.o.title?"table-cell":"none"),this.updateNavArrows(),this.fillMonths();var u=c(h,i,0),v=u.getUTCDate();u.setUTCDate(v-(u.getUTCDay()-this.o.weekStart+7)%7);var w=new Date(u);u.getUTCFullYear()<100&&w.setUTCFullYear(u.getUTCFullYear()),w.setUTCDate(w.getUTCDate()+42),w=w.valueOf();for(var x,y,z=[];u.valueOf()<w;){if((x=u.getUTCDay())===this.o.weekStart&&(z.push("<tr>"),this.o.calendarWeeks)){var A=new Date(+u+(this.o.weekStart-x-7)%7*864e5),B=new Date(Number(A)+(11-A.getUTCDay())%7*864e5),C=new Date(Number(C=c(B.getUTCFullYear(),0,1))+(11-C.getUTCDay())%7*864e5),D=(B-C)/864e5/7+1;z.push('<td class="cw">'+D+"</td>")}y=this.getClassNames(u),y.push("day");var E=u.getUTCDate();this.o.beforeShowDay!==a.noop&&(f=this.o.beforeShowDay(this._utc_to_local(u)),f===b?f={}:"boolean"==typeof f?f={enabled:f}:"string"==typeof f&&(f={classes:f}),!1===f.enabled&&y.push("disabled"),f.classes&&(y=y.concat(f.classes.split(/\s+/))),f.tooltip&&(e=f.tooltip),f.content&&(E=f.content)),y=a.isFunction(a.uniqueSort)?a.uniqueSort(y):a.unique(y),z.push('<td class="'+y.join(" ")+'"'+(e?' title="'+e+'"':"")+' data-date="'+u.getTime().toString()+'">'+E+"</td>"),e=null,x===this.o.weekEnd&&z.push("</tr>"),u.setUTCDate(u.getUTCDate()+1)}this.picker.find(".datepicker-days tbody").html(z.join(""));var F=q[this.o.language].monthsTitle||q.en.monthsTitle||"Months",G=this.picker.find(".datepicker-months").find(".datepicker-switch").text(this.o.maxViewMode<2?F:h).end().find("tbody span").removeClass("active");if(a.each(this.dates,function(a,b){b.getUTCFullYear()===h&&G.eq(b.getUTCMonth()).addClass("active")}),(h<j||h>l)&&G.addClass("disabled"),h===j&&G.slice(0,k).addClass("disabled"),h===l&&G.slice(m+1).addClass("disabled"),this.o.beforeShowMonth!==a.noop){var H=this;a.each(G,function(c,d){var e=new Date(h,c,1),f=H.o.beforeShowMonth(e);f===b?f={}:"boolean"==typeof f?f={enabled:f}:"string"==typeof f&&(f={classes:f}),!1!==f.enabled||a(d).hasClass("disabled")||a(d).addClass("disabled"),f.classes&&a(d).addClass(f.classes),f.tooltip&&a(d).prop("title",f.tooltip)})}this._fill_yearsView(".datepicker-years","year",10,h,j,l,this.o.beforeShowYear),this._fill_yearsView(".datepicker-decades","decade",100,h,j,l,this.o.beforeShowDecade),this._fill_yearsView(".datepicker-centuries","century",1e3,h,j,l,this.o.beforeShowCentury)}},updateNavArrows:function(){if(this._allow_update){var a,b,c=new Date(this.viewDate),d=c.getUTCFullYear(),e=c.getUTCMonth(),f=this.o.startDate!==-1/0?this.o.startDate.getUTCFullYear():-1/0,g=this.o.startDate!==-1/0?this.o.startDate.getUTCMonth():-1/0,h=this.o.endDate!==1/0?this.o.endDate.getUTCFullYear():1/0,i=this.o.endDate!==1/0?this.o.endDate.getUTCMonth():1/0,j=1;switch(this.viewMode){case 4:j*=10;case 3:j*=10;case 2:j*=10;case 1:a=Math.floor(d/j)*j<=f,b=Math.floor(d/j)*j+j>h;break;case 0:a=d<=f&&e<=g,b=d>=h&&e>=i}this.picker.find(".prev").toggleClass("disabled",a),this.picker.find(".next").toggleClass("disabled",b)}},click:function(b){b.preventDefault(),b.stopPropagation();var e,f,g,h;e=a(b.target),e.hasClass("datepicker-switch")&&this.viewMode!==this.o.maxViewMode&&this.setViewMode(this.viewMode+1),e.hasClass("today")&&!e.hasClass("day")&&(this.setViewMode(0),this._setDate(d(),"linked"===this.o.todayBtn?null:"view")),e.hasClass("clear")&&this.clearDates(),e.hasClass("disabled")||(e.hasClass("month")||e.hasClass("year")||e.hasClass("decade")||e.hasClass("century"))&&(this.viewDate.setUTCDate(1),f=1,1===this.viewMode?(h=e.parent().find("span").index(e),g=this.viewDate.getUTCFullYear(),this.viewDate.setUTCMonth(h)):(h=0,g=Number(e.text()),this.viewDate.setUTCFullYear(g)),this._trigger(r.viewModes[this.viewMode-1].e,this.viewDate),this.viewMode===this.o.minViewMode?this._setDate(c(g,h,f)):(this.setViewMode(this.viewMode-1),this.fill())),this.picker.is(":visible")&&this._focused_from&&this._focused_from.focus(),delete this._focused_from},dayCellClick:function(b){var c=a(b.currentTarget),d=c.data("date"),e=new Date(d);this.o.updateViewDate&&(e.getUTCFullYear()!==this.viewDate.getUTCFullYear()&&this._trigger("changeYear",this.viewDate),e.getUTCMonth()!==this.viewDate.getUTCMonth()&&this._trigger("changeMonth",this.viewDate)),this._setDate(e)},navArrowsClick:function(b){var c=a(b.currentTarget),d=c.hasClass("prev")?-1:1;0!==this.viewMode&&(d*=12*r.viewModes[this.viewMode].navStep),this.viewDate=this.moveMonth(this.viewDate,d),this._trigger(r.viewModes[this.viewMode].e,this.viewDate),this.fill()},_toggle_multidate:function(a){var b=this.dates.contains(a);if(a||this.dates.clear(),-1!==b?(!0===this.o.multidate||this.o.multidate>1||this.o.toggleActive)&&this.dates.remove(b):!1===this.o.multidate?(this.dates.clear(),this.dates.push(a)):this.dates.push(a),"number"==typeof this.o.multidate)for(;this.dates.length>this.o.multidate;)this.dates.remove(0)},_setDate:function(a,b){b&&"date"!==b||this._toggle_multidate(a&&new Date(a)),(!b&&this.o.updateViewDate||"view"===b)&&(this.viewDate=a&&new Date(a)),this.fill(),this.setValue(),b&&"view"===b||this._trigger("changeDate"),this.inputField.trigger("change"),!this.o.autoclose||b&&"date"!==b||this.hide()},moveDay:function(a,b){var c=new Date(a);return c.setUTCDate(a.getUTCDate()+b),c},moveWeek:function(a,b){return this.moveDay(a,7*b)},moveMonth:function(a,b){if(!g(a))return this.o.defaultViewDate;if(!b)return a;var c,d,e=new Date(a.valueOf()),f=e.getUTCDate(),h=e.getUTCMonth(),i=Math.abs(b);if(b=b>0?1:-1,1===i)d=-1===b?function(){return e.getUTCMonth()===h}:function(){return e.getUTCMonth()!==c},c=h+b,e.setUTCMonth(c),c=(c+12)%12;else{for(var j=0;j<i;j++)e=this.moveMonth(e,b);c=e.getUTCMonth(),e.setUTCDate(f),d=function(){return c!==e.getUTCMonth()}}for(;d();)e.setUTCDate(--f),e.setUTCMonth(c);return e},moveYear:function(a,b){return this.moveMonth(a,12*b)},moveAvailableDate:function(a,b,c){do{if(a=this[c](a,b),!this.dateWithinRange(a))return!1;c="moveDay"}while(this.dateIsDisabled(a));return a},weekOfDateIsDisabled:function(b){return-1!==a.inArray(b.getUTCDay(),this.o.daysOfWeekDisabled)},dateIsDisabled:function(b){return this.weekOfDateIsDisabled(b)||a.grep(this.o.datesDisabled,function(a){return e(b,a)}).length>0},dateWithinRange:function(a){return a>=this.o.startDate&&a<=this.o.endDate},keydown:function(a){if(!this.picker.is(":visible"))return void(40!==a.keyCode&&27!==a.keyCode||(this.show(),a.stopPropagation()));var b,c,d=!1,e=this.focusDate||this.viewDate;switch(a.keyCode){case 27:this.focusDate?(this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.fill()):this.hide(),a.preventDefault(),a.stopPropagation();break;case 37:case 38:case 39:case 40:if(!this.o.keyboardNavigation||7===this.o.daysOfWeekDisabled.length)break;b=37===a.keyCode||38===a.keyCode?-1:1,0===this.viewMode?a.ctrlKey?(c=this.moveAvailableDate(e,b,"moveYear"))&&this._trigger("changeYear",this.viewDate):a.shiftKey?(c=this.moveAvailableDate(e,b,"moveMonth"))&&this._trigger("changeMonth",this.viewDate):37===a.keyCode||39===a.keyCode?c=this.moveAvailableDate(e,b,"moveDay"):this.weekOfDateIsDisabled(e)||(c=this.moveAvailableDate(e,b,"moveWeek")):1===this.viewMode?(38!==a.keyCode&&40!==a.keyCode||(b*=4),c=this.moveAvailableDate(e,b,"moveMonth")):2===this.viewMode&&(38!==a.keyCode&&40!==a.keyCode||(b*=4),c=this.moveAvailableDate(e,b,"moveYear")),c&&(this.focusDate=this.viewDate=c,this.setValue(),this.fill(),a.preventDefault());break;case 13:if(!this.o.forceParse)break;e=this.focusDate||this.dates.get(-1)||this.viewDate,this.o.keyboardNavigation&&(this._toggle_multidate(e),d=!0),this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.setValue(),this.fill(),this.picker.is(":visible")&&(a.preventDefault(),a.stopPropagation(),this.o.autoclose&&this.hide());break;case 9:this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.fill(),this.hide()}d&&(this.dates.length?this._trigger("changeDate"):this._trigger("clearDate"),this.inputField.trigger("change"))},setViewMode:function(a){this.viewMode=a,this.picker.children("div").hide().filter(".datepicker-"+r.viewModes[this.viewMode].clsName).show(),this.updateNavArrows(),this._trigger("changeViewMode",new Date(this.viewDate))}};var l=function(b,c){a.data(b,"datepicker",this),this.element=a(b),this.inputs=a.map(c.inputs,function(a){return a.jquery?a[0]:a}),delete c.inputs,this.keepEmptyValues=c.keepEmptyValues,delete c.keepEmptyValues,n.call(a(this.inputs),c).on("changeDate",a.proxy(this.dateUpdated,this)),this.pickers=a.map(this.inputs,function(b){return a.data(b,"datepicker")}),this.updateDates()};l.prototype={updateDates:function(){this.dates=a.map(this.pickers,function(a){return a.getUTCDate()}),this.updateRanges()},updateRanges:function(){var b=a.map(this.dates,function(a){return a.valueOf()});a.each(this.pickers,function(a,c){c.setRange(b)})},clearDates:function(){a.each(this.pickers,function(a,b){b.clearDates()})},dateUpdated:function(c){if(!this.updating){this.updating=!0;var d=a.data(c.target,"datepicker");if(d!==b){var e=d.getUTCDate(),f=this.keepEmptyValues,g=a.inArray(c.target,this.inputs),h=g-1,i=g+1,j=this.inputs.length;if(-1!==g){if(a.each(this.pickers,function(a,b){b.getUTCDate()||b!==d&&f||b.setUTCDate(e)}),e<this.dates[h])for(;h>=0&&e<this.dates[h];)this.pickers[h--].setUTCDate(e);else if(e>this.dates[i])for(;i<j&&e>this.dates[i];)this.pickers[i++].setUTCDate(e);this.updateDates(),delete this.updating}}}},destroy:function(){a.map(this.pickers,function(a){a.destroy()}),a(this.inputs).off("changeDate",this.dateUpdated),delete this.element.data().datepicker},remove:f("destroy","Method `remove` is deprecated and will be removed in version 2.0. Use `destroy` instead")};var m=a.fn.datepicker,n=function(c){var d=Array.apply(null,arguments);d.shift();var e;if(this.each(function(){var b=a(this),f=b.data("datepicker"),g="object"==typeof c&&c;if(!f){var j=h(this,"date"),m=a.extend({},o,j,g),n=i(m.language),p=a.extend({},o,n,j,g);b.hasClass("input-daterange")||p.inputs?(a.extend(p,{inputs:p.inputs||b.find("input").toArray()}),f=new l(this,p)):f=new k(this,p),b.data("datepicker",f)}"string"==typeof c&&"function"==typeof f[c]&&(e=f[c].apply(f,d))}),e===b||e instanceof k||e instanceof l)return this;if(this.length>1)throw new Error("Using only allowed for the collection of a single element ("+c+" function)");return e};a.fn.datepicker=n;var o=a.fn.datepicker.defaults={assumeNearbyYear:!1,autoclose:!1,beforeShowDay:a.noop,beforeShowMonth:a.noop,beforeShowYear:a.noop,beforeShowDecade:a.noop,beforeShowCentury:a.noop,calendarWeeks:!1,clearBtn:!1,toggleActive:!1,daysOfWeekDisabled:[],daysOfWeekHighlighted:[],datesDisabled:[],endDate:1/0,forceParse:!0,format:"mm/dd/yyyy",keepEmptyValues:!1,keyboardNavigation:!0,language:"en",minViewMode:0,maxViewMode:4,multidate:!1,multidateSeparator:",",orientation:"auto",rtl:!1,startDate:-1/0,startView:0,todayBtn:!1,todayHighlight:!1,updateViewDate:!0,weekStart:0,disableTouchKeyboard:!1,enableOnReadonly:!0,showOnFocus:!0,zIndexOffset:10,container:"body",immediateUpdates:!1,title:"",templates:{leftArrow:"&#x00AB;",rightArrow:"&#x00BB;"},showWeekDays:!0},p=a.fn.datepicker.locale_opts=["format","rtl","weekStart"];a.fn.datepicker.Constructor=k;var q=a.fn.datepicker.dates={en:{days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],daysMin:["Su","Mo","Tu","We","Th","Fr","Sa"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],today:"Today",clear:"Clear",titleFormat:"MM yyyy"}},r={viewModes:[{names:["days","month"],clsName:"days",e:"changeMonth"},{names:["months","year"],clsName:"months",e:"changeYear",navStep:1},{names:["years","decade"],clsName:"years",e:"changeDecade",navStep:10},{names:["decades","century"],clsName:"decades",e:"changeCentury",navStep:100},{names:["centuries","millennium"],clsName:"centuries",e:"changeMillennium",navStep:1e3}],validParts:/dd?|DD?|mm?|MM?|yy(?:yy)?/g,nonpunctuation:/[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,parseFormat:function(a){if("function"==typeof a.toValue&&"function"==typeof a.toDisplay)return a;var b=a.replace(this.validParts,"\0").split("\0"),c=a.match(this.validParts);if(!b||!b.length||!c||0===c.length)throw new Error("Invalid date format.");return{separators:b,parts:c}},parseDate:function(c,e,f,g){function h(a,b){return!0===b&&(b=10),a<100&&(a+=2e3)>(new Date).getFullYear()+b&&(a-=100),a}function i(){var a=this.slice(0,j[n].length),b=j[n].slice(0,a.length);return a.toLowerCase()===b.toLowerCase()}if(!c)return b;if(c instanceof Date)return c;if("string"==typeof e&&(e=r.parseFormat(e)),e.toValue)return e.toValue(c,e,f);var j,l,m,n,o,p={d:"moveDay",m:"moveMonth",w:"moveWeek",y:"moveYear"},s={yesterday:"-1d",today:"+0d",tomorrow:"+1d"};if(c in s&&(c=s[c]),/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/i.test(c)){for(j=c.match(/([\-+]\d+)([dmwy])/gi),c=new Date,n=0;n<j.length;n++)l=j[n].match(/([\-+]\d+)([dmwy])/i),m=Number(l[1]),o=p[l[2].toLowerCase()],c=k.prototype[o](c,m);return k.prototype._zero_utc_time(c)}j=c&&c.match(this.nonpunctuation)||[];var t,u,v={},w=["yyyy","yy","M","MM","m","mm","d","dd"],x={yyyy:function(a,b){return a.setUTCFullYear(g?h(b,g):b)},m:function(a,b){if(isNaN(a))return a;for(b-=1;b<0;)b+=12;for(b%=12,a.setUTCMonth(b);a.getUTCMonth()!==b;)a.setUTCDate(a.getUTCDate()-1);return a},d:function(a,b){return a.setUTCDate(b)}};x.yy=x.yyyy,x.M=x.MM=x.mm=x.m,x.dd=x.d,c=d();var y=e.parts.slice();if(j.length!==y.length&&(y=a(y).filter(function(b,c){return-1!==a.inArray(c,w)}).toArray()),j.length===y.length){var z;for(n=0,z=y.length;n<z;n++){if(t=parseInt(j[n],10),l=y[n],isNaN(t))switch(l){case"MM":u=a(q[f].months).filter(i),t=a.inArray(u[0],q[f].months)+1;break;case"M":u=a(q[f].monthsShort).filter(i),t=a.inArray(u[0],q[f].monthsShort)+1}v[l]=t}var A,B;for(n=0;n<w.length;n++)(B=w[n])in v&&!isNaN(v[B])&&(A=new Date(c),x[B](A,v[B]),isNaN(A)||(c=A))}return c},formatDate:function(b,c,d){if(!b)return"";if("string"==typeof c&&(c=r.parseFormat(c)),c.toDisplay)return c.toDisplay(b,c,d);var e={d:b.getUTCDate(),D:q[d].daysShort[b.getUTCDay()],DD:q[d].days[b.getUTCDay()],m:b.getUTCMonth()+1,M:q[d].monthsShort[b.getUTCMonth()],MM:q[d].months[b.getUTCMonth()],yy:b.getUTCFullYear().toString().substring(2),yyyy:b.getUTCFullYear()};e.dd=(e.d<10?"0":"")+e.d,e.mm=(e.m<10?"0":"")+e.m,b=[];for(var f=a.extend([],c.separators),g=0,h=c.parts.length;g<=h;g++)f.length&&b.push(f.shift()),b.push(e[c.parts[g]]);return b.join("")},
	headTemplate:'<thead><tr><th colspan="7" class="datepicker-title"></th></tr><tr><th class="prev">'+o.templates.leftArrow+'</th><th colspan="5" class="datepicker-switch"></th><th class="next">'+o.templates.rightArrow+"</th></tr></thead>",contTemplate:'<tbody><tr><td colspan="7"></td></tr></tbody>',footTemplate:'<tfoot><tr><th colspan="7" class="today"></th></tr><tr><th colspan="7" class="clear"></th></tr></tfoot>'};r.template='<div class="datepicker"><div class="datepicker-days"><table class="table-condensed">'+r.headTemplate+"<tbody></tbody>"+r.footTemplate+'</table></div><div class="datepicker-months"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-years"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-decades"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-centuries"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+"</table></div></div>",a.fn.datepicker.DPGlobal=r,a.fn.datepicker.noConflict=function(){return a.fn.datepicker=m,this},a.fn.datepicker.version="1.9.0",a.fn.datepicker.deprecated=function(a){var b=window.console;b&&b.warn&&b.warn("DEPRECATED: "+a)},a(document).on("focus.datepicker.data-api click.datepicker.data-api",'[data-provide="datepicker"]',function(b){var c=a(this);c.data("datepicker")||(b.preventDefault(),n.call(c,"show"))}),a(function(){n.call(a('[data-provide="datepicker-inline"]'))})});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(a){"use strict";if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11),__webpack_require__(30)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("object"==typeof exports)module.exports=a(require("jquery"),require("moment"));else{if("undefined"==typeof jQuery)throw"bootstrap-datetimepicker requires jQuery to be loaded first";if("undefined"==typeof moment)throw"bootstrap-datetimepicker requires Moment.js to be loaded first";a(jQuery,moment)}}(function(a,b){"use strict";if(!b)throw new Error("bootstrap-datetimepicker requires Moment.js to be loaded first");var c=function(c,d){var e,f,g,h,i,j,k,l={},m=!0,n=!1,o=!1,p=0,q=[{clsName:"days",navFnc:"M",navStep:1},{clsName:"months",navFnc:"y",navStep:1},{clsName:"years",navFnc:"y",navStep:10},{clsName:"decades",navFnc:"y",navStep:100}],r=["days","months","years","decades"],s=["top","bottom","auto"],t=["left","right","auto"],u=["default","top","bottom"],v={up:38,38:"up",down:40,40:"down",left:37,37:"left",right:39,39:"right",tab:9,9:"tab",escape:27,27:"escape",enter:13,13:"enter",pageUp:33,33:"pageUp",pageDown:34,34:"pageDown",shift:16,16:"shift",control:17,17:"control",space:32,32:"space",t:84,84:"t",delete:46,46:"delete"},w={},x=function(){return void 0!==b.tz&&void 0!==d.timeZone&&null!==d.timeZone&&""!==d.timeZone},y=function(a){var c;return c=void 0===a||null===a?b():b.isDate(a)||b.isMoment(a)?b(a):x()?b.tz(a,j,d.useStrict,d.timeZone):b(a,j,d.useStrict),x()&&c.tz(d.timeZone),c},z=function(a){if("string"!=typeof a||a.length>1)throw new TypeError("isEnabled expects a single character string parameter");switch(a){case"y":return i.indexOf("Y")!==-1;case"M":return i.indexOf("M")!==-1;case"d":return i.toLowerCase().indexOf("d")!==-1;case"h":case"H":return i.toLowerCase().indexOf("h")!==-1;case"m":return i.indexOf("m")!==-1;case"s":return i.indexOf("s")!==-1;default:return!1}},A=function(){return z("h")||z("m")||z("s")},B=function(){return z("y")||z("M")||z("d")},C=function(){var b=a("<thead>").append(a("<tr>").append(a("<th>").addClass("prev").attr("data-action","previous").append(a("<span>").addClass(d.icons.previous))).append(a("<th>").addClass("picker-switch").attr("data-action","pickerSwitch").attr("colspan",d.calendarWeeks?"6":"5")).append(a("<th>").addClass("next").attr("data-action","next").append(a("<span>").addClass(d.icons.next)))),c=a("<tbody>").append(a("<tr>").append(a("<td>").attr("colspan",d.calendarWeeks?"8":"7")));return[a("<div>").addClass("datepicker-days").append(a("<table>").addClass("table-condensed").append(b).append(a("<tbody>"))),a("<div>").addClass("datepicker-months").append(a("<table>").addClass("table-condensed").append(b.clone()).append(c.clone())),a("<div>").addClass("datepicker-years").append(a("<table>").addClass("table-condensed").append(b.clone()).append(c.clone())),a("<div>").addClass("datepicker-decades").append(a("<table>").addClass("table-condensed").append(b.clone()).append(c.clone()))]},D=function(){var b=a("<tr>"),c=a("<tr>"),e=a("<tr>");return z("h")&&(b.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.incrementHour}).addClass("btn").attr("data-action","incrementHours").append(a("<span>").addClass(d.icons.up)))),c.append(a("<td>").append(a("<span>").addClass("timepicker-hour").attr({"data-time-component":"hours",title:d.tooltips.pickHour}).attr("data-action","showHours"))),e.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.decrementHour}).addClass("btn").attr("data-action","decrementHours").append(a("<span>").addClass(d.icons.down))))),z("m")&&(z("h")&&(b.append(a("<td>").addClass("separator")),c.append(a("<td>").addClass("separator").html(":")),e.append(a("<td>").addClass("separator"))),b.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.incrementMinute}).addClass("btn").attr("data-action","incrementMinutes").append(a("<span>").addClass(d.icons.up)))),c.append(a("<td>").append(a("<span>").addClass("timepicker-minute").attr({"data-time-component":"minutes",title:d.tooltips.pickMinute}).attr("data-action","showMinutes"))),e.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.decrementMinute}).addClass("btn").attr("data-action","decrementMinutes").append(a("<span>").addClass(d.icons.down))))),z("s")&&(z("m")&&(b.append(a("<td>").addClass("separator")),c.append(a("<td>").addClass("separator").html(":")),e.append(a("<td>").addClass("separator"))),b.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.incrementSecond}).addClass("btn").attr("data-action","incrementSeconds").append(a("<span>").addClass(d.icons.up)))),c.append(a("<td>").append(a("<span>").addClass("timepicker-second").attr({"data-time-component":"seconds",title:d.tooltips.pickSecond}).attr("data-action","showSeconds"))),e.append(a("<td>").append(a("<a>").attr({href:"#",tabindex:"-1",title:d.tooltips.decrementSecond}).addClass("btn").attr("data-action","decrementSeconds").append(a("<span>").addClass(d.icons.down))))),h||(b.append(a("<td>").addClass("separator")),c.append(a("<td>").append(a("<button>").addClass("btn btn-primary").attr({"data-action":"togglePeriod",tabindex:"-1",title:d.tooltips.togglePeriod}))),e.append(a("<td>").addClass("separator"))),a("<div>").addClass("timepicker-picker").append(a("<table>").addClass("table-condensed").append([b,c,e]))},E=function(){var b=a("<div>").addClass("timepicker-hours").append(a("<table>").addClass("table-condensed")),c=a("<div>").addClass("timepicker-minutes").append(a("<table>").addClass("table-condensed")),d=a("<div>").addClass("timepicker-seconds").append(a("<table>").addClass("table-condensed")),e=[D()];return z("h")&&e.push(b),z("m")&&e.push(c),z("s")&&e.push(d),e},F=function(){var b=[];return d.showTodayButton&&b.push(a("<td>").append(a("<a>").attr({"data-action":"today",title:d.tooltips.today}).append(a("<span>").addClass(d.icons.today)))),!d.sideBySide&&B()&&A()&&b.push(a("<td>").append(a("<a>").attr({"data-action":"togglePicker",title:d.tooltips.selectTime}).append(a("<span>").addClass(d.icons.time)))),d.showClear&&b.push(a("<td>").append(a("<a>").attr({"data-action":"clear",title:d.tooltips.clear}).append(a("<span>").addClass(d.icons.clear)))),d.showClose&&b.push(a("<td>").append(a("<a>").attr({"data-action":"close",title:d.tooltips.close}).append(a("<span>").addClass(d.icons.close)))),a("<table>").addClass("table-condensed").append(a("<tbody>").append(a("<tr>").append(b)))},G=function(){var b=a("<div>").addClass("bootstrap-datetimepicker-widget dropdown-menu"),c=a("<div>").addClass("datepicker").append(C()),e=a("<div>").addClass("timepicker").append(E()),f=a("<ul>").addClass("list-unstyled"),g=a("<li>").addClass("picker-switch"+(d.collapse?" accordion-toggle":"")).append(F());return d.inline&&b.removeClass("dropdown-menu"),h&&b.addClass("usetwentyfour"),z("s")&&!h&&b.addClass("wider"),d.sideBySide&&B()&&A()?(b.addClass("timepicker-sbs"),"top"===d.toolbarPlacement&&b.append(g),b.append(a("<div>").addClass("row").append(c.addClass("col-md-6")).append(e.addClass("col-md-6"))),"bottom"===d.toolbarPlacement&&b.append(g),b):("top"===d.toolbarPlacement&&f.append(g),B()&&f.append(a("<li>").addClass(d.collapse&&A()?"collapse in":"").append(c)),"default"===d.toolbarPlacement&&f.append(g),A()&&f.append(a("<li>").addClass(d.collapse&&B()?"collapse":"").append(e)),"bottom"===d.toolbarPlacement&&f.append(g),b.append(f))},H=function(){var b,e={};return b=c.is("input")||d.inline?c.data():c.find("input").data(),b.dateOptions&&b.dateOptions instanceof Object&&(e=a.extend(!0,e,b.dateOptions)),a.each(d,function(a){var c="date"+a.charAt(0).toUpperCase()+a.slice(1);void 0!==b[c]&&(e[a]=b[c])}),e},I=function(){var b,e=(n||c).position(),f=(n||c).offset(),g=d.widgetPositioning.vertical,h=d.widgetPositioning.horizontal;if(d.widgetParent)b=d.widgetParent.append(o);else if(c.is("input"))b=c.after(o).parent();else{if(d.inline)return void(b=c.append(o));b=c,c.children().first().after(o)}if("auto"===g&&(g=f.top+1.5*o.height()>=a(window).height()+a(window).scrollTop()&&o.height()+c.outerHeight()<f.top?"top":"bottom"),"auto"===h&&(h=b.width()<f.left+o.outerWidth()/2&&f.left+o.outerWidth()>a(window).width()?"right":"left"),"top"===g?o.addClass("top").removeClass("bottom"):o.addClass("bottom").removeClass("top"),"right"===h?o.addClass("pull-right"):o.removeClass("pull-right"),"static"===b.css("position")&&(b=b.parents().filter(function(){return"static"!==a(this).css("position")}).first()),0===b.length)throw new Error("datetimepicker component should be placed within a non-static positioned container");o.css({top:"top"===g?"auto":e.top+c.outerHeight(),bottom:"top"===g?b.outerHeight()-(b===c?0:e.top):"auto",left:"left"===h?b===c?0:e.left:"auto",right:"left"===h?"auto":b.outerWidth()-c.outerWidth()-(b===c?0:e.left)})},J=function(a){"dp.change"===a.type&&(a.date&&a.date.isSame(a.oldDate)||!a.date&&!a.oldDate)||c.trigger(a)},K=function(a){"y"===a&&(a="YYYY"),J({type:"dp.update",change:a,viewDate:f.clone()})},L=function(a){o&&(a&&(k=Math.max(p,Math.min(3,k+a))),o.find(".datepicker > div").hide().filter(".datepicker-"+q[k].clsName).show())},M=function(){var b=a("<tr>"),c=f.clone().startOf("w").startOf("d");for(d.calendarWeeks===!0&&b.append(a("<th>").addClass("cw").text("#"));c.isBefore(f.clone().endOf("w"));)b.append(a("<th>").addClass("dow").text(c.format("dd"))),c.add(1,"d");o.find(".datepicker-days thead").append(b)},N=function(a){return d.disabledDates[a.format("YYYY-MM-DD")]===!0},O=function(a){return d.enabledDates[a.format("YYYY-MM-DD")]===!0},P=function(a){return d.disabledHours[a.format("H")]===!0},Q=function(a){return d.enabledHours[a.format("H")]===!0},R=function(b,c){if(!b.isValid())return!1;if(d.disabledDates&&"d"===c&&N(b))return!1;if(d.enabledDates&&"d"===c&&!O(b))return!1;if(d.minDate&&b.isBefore(d.minDate,c))return!1;if(d.maxDate&&b.isAfter(d.maxDate,c))return!1;if(d.daysOfWeekDisabled&&"d"===c&&d.daysOfWeekDisabled.indexOf(b.day())!==-1)return!1;if(d.disabledHours&&("h"===c||"m"===c||"s"===c)&&P(b))return!1;if(d.enabledHours&&("h"===c||"m"===c||"s"===c)&&!Q(b))return!1;if(d.disabledTimeIntervals&&("h"===c||"m"===c||"s"===c)){var e=!1;if(a.each(d.disabledTimeIntervals,function(){if(b.isBetween(this[0],this[1]))return e=!0,!1}),e)return!1}return!0},S=function(){for(var b=[],c=f.clone().startOf("y").startOf("d");c.isSame(f,"y");)b.push(a("<span>").attr("data-action","selectMonth").addClass("month").text(c.format("MMM"))),c.add(1,"M");o.find(".datepicker-months td").empty().append(b)},T=function(){var b=o.find(".datepicker-months"),c=b.find("th"),g=b.find("tbody").find("span");c.eq(0).find("span").attr("title",d.tooltips.prevYear),c.eq(1).attr("title",d.tooltips.selectYear),c.eq(2).find("span").attr("title",d.tooltips.nextYear),b.find(".disabled").removeClass("disabled"),R(f.clone().subtract(1,"y"),"y")||c.eq(0).addClass("disabled"),c.eq(1).text(f.year()),R(f.clone().add(1,"y"),"y")||c.eq(2).addClass("disabled"),g.removeClass("active"),e.isSame(f,"y")&&!m&&g.eq(e.month()).addClass("active"),g.each(function(b){R(f.clone().month(b),"M")||a(this).addClass("disabled")})},U=function(){var a=o.find(".datepicker-years"),b=a.find("th"),c=f.clone().subtract(5,"y"),g=f.clone().add(6,"y"),h="";for(b.eq(0).find("span").attr("title",d.tooltips.prevDecade),b.eq(1).attr("title",d.tooltips.selectDecade),b.eq(2).find("span").attr("title",d.tooltips.nextDecade),a.find(".disabled").removeClass("disabled"),d.minDate&&d.minDate.isAfter(c,"y")&&b.eq(0).addClass("disabled"),b.eq(1).text(c.year()+"-"+g.year()),d.maxDate&&d.maxDate.isBefore(g,"y")&&b.eq(2).addClass("disabled");!c.isAfter(g,"y");)h+='<span data-action="selectYear" class="year'+(c.isSame(e,"y")&&!m?" active":"")+(R(c,"y")?"":" disabled")+'">'+c.year()+"</span>",c.add(1,"y");a.find("td").html(h)},V=function(){var a,c=o.find(".datepicker-decades"),g=c.find("th"),h=b({y:f.year()-f.year()%100-1}),i=h.clone().add(100,"y"),j=h.clone(),k=!1,l=!1,m="";for(g.eq(0).find("span").attr("title",d.tooltips.prevCentury),g.eq(2).find("span").attr("title",d.tooltips.nextCentury),c.find(".disabled").removeClass("disabled"),(h.isSame(b({y:1900}))||d.minDate&&d.minDate.isAfter(h,"y"))&&g.eq(0).addClass("disabled"),g.eq(1).text(h.year()+"-"+i.year()),(h.isSame(b({y:2e3}))||d.maxDate&&d.maxDate.isBefore(i,"y"))&&g.eq(2).addClass("disabled");!h.isAfter(i,"y");)a=h.year()+12,k=d.minDate&&d.minDate.isAfter(h,"y")&&d.minDate.year()<=a,l=d.maxDate&&d.maxDate.isAfter(h,"y")&&d.maxDate.year()<=a,m+='<span data-action="selectDecade" class="decade'+(e.isAfter(h)&&e.year()<=a?" active":"")+(R(h,"y")||k||l?"":" disabled")+'" data-selection="'+(h.year()+6)+'">'+(h.year()+1)+" - "+(h.year()+12)+"</span>",h.add(12,"y");m+="<span></span><span></span><span></span>",c.find("td").html(m),g.eq(1).text(j.year()+1+"-"+h.year())},W=function(){var b,c,g,h=o.find(".datepicker-days"),i=h.find("th"),j=[],k=[];if(B()){for(i.eq(0).find("span").attr("title",d.tooltips.prevMonth),i.eq(1).attr("title",d.tooltips.selectMonth),i.eq(2).find("span").attr("title",d.tooltips.nextMonth),h.find(".disabled").removeClass("disabled"),i.eq(1).text(f.format(d.dayViewHeaderFormat)),R(f.clone().subtract(1,"M"),"M")||i.eq(0).addClass("disabled"),R(f.clone().add(1,"M"),"M")||i.eq(2).addClass("disabled"),b=f.clone().startOf("M").startOf("w").startOf("d"),g=0;g<42;g++)0===b.weekday()&&(c=a("<tr>"),d.calendarWeeks&&c.append('<td class="cw">'+b.week()+"</td>"),j.push(c)),k=["day"],b.isBefore(f,"M")&&k.push("old"),b.isAfter(f,"M")&&k.push("new"),b.isSame(e,"d")&&!m&&k.push("active"),R(b,"d")||k.push("disabled"),b.isSame(y(),"d")&&k.push("today"),0!==b.day()&&6!==b.day()||k.push("weekend"),J({type:"dp.classify",date:b,classNames:k}),c.append('<td data-action="selectDay" data-day="'+b.format("L")+'" class="'+k.join(" ")+'">'+b.date()+"</td>"),b.add(1,"d");h.find("tbody").empty().append(j),T(),U(),V()}},X=function(){var b=o.find(".timepicker-hours table"),c=f.clone().startOf("d"),d=[],e=a("<tr>");for(f.hour()>11&&!h&&c.hour(12);c.isSame(f,"d")&&(h||f.hour()<12&&c.hour()<12||f.hour()>11);)c.hour()%4===0&&(e=a("<tr>"),d.push(e)),e.append('<td data-action="selectHour" class="hour'+(R(c,"h")?"":" disabled")+'">'+c.format(h?"HH":"hh")+"</td>"),c.add(1,"h");b.empty().append(d)},Y=function(){for(var b=o.find(".timepicker-minutes table"),c=f.clone().startOf("h"),e=[],g=a("<tr>"),h=1===d.stepping?5:d.stepping;f.isSame(c,"h");)c.minute()%(4*h)===0&&(g=a("<tr>"),e.push(g)),g.append('<td data-action="selectMinute" class="minute'+(R(c,"m")?"":" disabled")+'">'+c.format("mm")+"</td>"),c.add(h,"m");b.empty().append(e)},Z=function(){for(var b=o.find(".timepicker-seconds table"),c=f.clone().startOf("m"),d=[],e=a("<tr>");f.isSame(c,"m");)c.second()%20===0&&(e=a("<tr>"),d.push(e)),e.append('<td data-action="selectSecond" class="second'+(R(c,"s")?"":" disabled")+'">'+c.format("ss")+"</td>"),c.add(5,"s");b.empty().append(d)},$=function(){var a,b,c=o.find(".timepicker span[data-time-component]");h||(a=o.find(".timepicker [data-action=togglePeriod]"),b=e.clone().add(e.hours()>=12?-12:12,"h"),a.text(e.format("A")),R(b,"h")?a.removeClass("disabled"):a.addClass("disabled")),c.filter("[data-time-component=hours]").text(e.format(h?"HH":"hh")),c.filter("[data-time-component=minutes]").text(e.format("mm")),c.filter("[data-time-component=seconds]").text(e.format("ss")),X(),Y(),Z()},_=function(){o&&(W(),$())},aa=function(a){var b=m?null:e;if(!a)return m=!0,g.val(""),c.data("date",""),J({type:"dp.change",date:!1,oldDate:b}),void _();if(a=a.clone().locale(d.locale),x()&&a.tz(d.timeZone),1!==d.stepping)for(a.minutes(Math.round(a.minutes()/d.stepping)*d.stepping).seconds(0);d.minDate&&a.isBefore(d.minDate);)a.add(d.stepping,"minutes");R(a)?(e=a,f=e.clone(),g.val(e.format(i)),c.data("date",e.format(i)),m=!1,_(),J({type:"dp.change",date:e.clone(),oldDate:b})):(d.keepInvalid?J({type:"dp.change",date:a,oldDate:b}):g.val(m?"":e.format(i)),J({type:"dp.error",date:a,oldDate:b}))},ba=function(){var b=!1;return o?(o.find(".collapse").each(function(){var c=a(this).data("collapse");return!c||!c.transitioning||(b=!0,!1)}),b?l:(n&&n.hasClass("btn")&&n.toggleClass("active"),o.hide(),a(window).off("resize",I),o.off("click","[data-action]"),o.off("mousedown",!1),o.remove(),o=!1,J({type:"dp.hide",date:e.clone()}),g.blur(),f=e.clone(),l)):l},ca=function(){aa(null)},da=function(a){return void 0===d.parseInputDate?(!b.isMoment(a)||a instanceof Date)&&(a=y(a)):a=d.parseInputDate(a),a},ea={next:function(){var a=q[k].navFnc;f.add(q[k].navStep,a),W(),K(a)},previous:function(){var a=q[k].navFnc;f.subtract(q[k].navStep,a),W(),K(a)},pickerSwitch:function(){L(1)},selectMonth:function(b){var c=a(b.target).closest("tbody").find("span").index(a(b.target));f.month(c),k===p?(aa(e.clone().year(f.year()).month(f.month())),d.inline||ba()):(L(-1),W()),K("M")},selectYear:function(b){var c=parseInt(a(b.target).text(),10)||0;f.year(c),k===p?(aa(e.clone().year(f.year())),d.inline||ba()):(L(-1),W()),K("YYYY")},selectDecade:function(b){var c=parseInt(a(b.target).data("selection"),10)||0;f.year(c),k===p?(aa(e.clone().year(f.year())),d.inline||ba()):(L(-1),W()),K("YYYY")},selectDay:function(b){var c=f.clone();a(b.target).is(".old")&&c.subtract(1,"M"),a(b.target).is(".new")&&c.add(1,"M"),aa(c.date(parseInt(a(b.target).text(),10))),A()||d.keepOpen||d.inline||ba()},incrementHours:function(){var a=e.clone().add(1,"h");R(a,"h")&&aa(a)},incrementMinutes:function(){var a=e.clone().add(d.stepping,"m");R(a,"m")&&aa(a)},incrementSeconds:function(){var a=e.clone().add(1,"s");R(a,"s")&&aa(a)},decrementHours:function(){var a=e.clone().subtract(1,"h");R(a,"h")&&aa(a)},decrementMinutes:function(){var a=e.clone().subtract(d.stepping,"m");R(a,"m")&&aa(a)},decrementSeconds:function(){var a=e.clone().subtract(1,"s");R(a,"s")&&aa(a)},togglePeriod:function(){aa(e.clone().add(e.hours()>=12?-12:12,"h"))},togglePicker:function(b){var c,e=a(b.target),f=e.closest("ul"),g=f.find(".in"),h=f.find(".collapse:not(.in)");if(g&&g.length){if(c=g.data("collapse"),c&&c.transitioning)return;g.collapse?(g.collapse("hide"),h.collapse("show")):(g.removeClass("in"),h.addClass("in")),e.is("span")?e.toggleClass(d.icons.time+" "+d.icons.date):e.find("span").toggleClass(d.icons.time+" "+d.icons.date)}},showPicker:function(){o.find(".timepicker > div:not(.timepicker-picker)").hide(),o.find(".timepicker .timepicker-picker").show()},showHours:function(){o.find(".timepicker .timepicker-picker").hide(),o.find(".timepicker .timepicker-hours").show()},showMinutes:function(){o.find(".timepicker .timepicker-picker").hide(),o.find(".timepicker .timepicker-minutes").show()},showSeconds:function(){o.find(".timepicker .timepicker-picker").hide(),o.find(".timepicker .timepicker-seconds").show()},selectHour:function(b){var c=parseInt(a(b.target).text(),10);h||(e.hours()>=12?12!==c&&(c+=12):12===c&&(c=0)),aa(e.clone().hours(c)),ea.showPicker.call(l)},selectMinute:function(b){aa(e.clone().minutes(parseInt(a(b.target).text(),10))),ea.showPicker.call(l)},selectSecond:function(b){aa(e.clone().seconds(parseInt(a(b.target).text(),10))),ea.showPicker.call(l)},clear:ca,today:function(){var a=y();R(a,"d")&&aa(a)},close:ba},fa=function(b){return!a(b.currentTarget).is(".disabled")&&(ea[a(b.currentTarget).data("action")].apply(l,arguments),!1)},ga=function(){var b,c={year:function(a){return a.month(0).date(1).hours(0).seconds(0).minutes(0)},month:function(a){return a.date(1).hours(0).seconds(0).minutes(0)},day:function(a){return a.hours(0).seconds(0).minutes(0)},hour:function(a){return a.seconds(0).minutes(0)},minute:function(a){return a.seconds(0)}};return g.prop("disabled")||!d.ignoreReadonly&&g.prop("readonly")||o?l:(void 0!==g.val()&&0!==g.val().trim().length?aa(da(g.val().trim())):m&&d.useCurrent&&(d.inline||g.is("input")&&0===g.val().trim().length)&&(b=y(),"string"==typeof d.useCurrent&&(b=c[d.useCurrent](b)),aa(b)),o=G(),M(),S(),o.find(".timepicker-hours").hide(),o.find(".timepicker-minutes").hide(),o.find(".timepicker-seconds").hide(),_(),L(),a(window).on("resize",I),o.on("click","[data-action]",fa),o.on("mousedown",!1),n&&n.hasClass("btn")&&n.toggleClass("active"),I(),o.show(),d.focusOnShow&&!g.is(":focus")&&g.focus(),J({type:"dp.show"}),l)},ha=function(){return o?ba():ga()},ia=function(a){var b,c,e,f,g=null,h=[],i={},j=a.which,k="p";w[j]=k;for(b in w)w.hasOwnProperty(b)&&w[b]===k&&(h.push(b),parseInt(b,10)!==j&&(i[b]=!0));for(b in d.keyBinds)if(d.keyBinds.hasOwnProperty(b)&&"function"==typeof d.keyBinds[b]&&(e=b.split(" "),e.length===h.length&&v[j]===e[e.length-1])){for(f=!0,c=e.length-2;c>=0;c--)if(!(v[e[c]]in i)){f=!1;break}if(f){g=d.keyBinds[b];break}}g&&(g.call(l,o),a.stopPropagation(),a.preventDefault())},ja=function(a){w[a.which]="r",a.stopPropagation(),a.preventDefault()},ka=function(b){var c=a(b.target).val().trim(),d=c?da(c):null;return aa(d),b.stopImmediatePropagation(),!1},la=function(){g.on({change:ka,blur:d.debug?"":ba,keydown:ia,keyup:ja,focus:d.allowInputToggle?ga:""}),c.is("input")?g.on({focus:ga}):n&&(n.on("click",ha),n.on("mousedown",!1))},ma=function(){g.off({change:ka,blur:blur,keydown:ia,keyup:ja,focus:d.allowInputToggle?ba:""}),c.is("input")?g.off({focus:ga}):n&&(n.off("click",ha),n.off("mousedown",!1))},na=function(b){var c={};return a.each(b,function(){var a=da(this);a.isValid()&&(c[a.format("YYYY-MM-DD")]=!0)}),!!Object.keys(c).length&&c},oa=function(b){var c={};return a.each(b,function(){c[this]=!0}),!!Object.keys(c).length&&c},pa=function(){var a=d.format||"L LT";i=a.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,function(a){var b=e.localeData().longDateFormat(a)||a;return b.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,function(a){return e.localeData().longDateFormat(a)||a})}),j=d.extraFormats?d.extraFormats.slice():[],j.indexOf(a)<0&&j.indexOf(i)<0&&j.push(i),h=i.toLowerCase().indexOf("a")<1&&i.replace(/\[.*?\]/g,"").indexOf("h")<1,z("y")&&(p=2),z("M")&&(p=1),z("d")&&(p=0),k=Math.max(p,k),m||aa(e)};if(l.destroy=function(){ba(),ma(),c.removeData("DateTimePicker"),c.removeData("date")},l.toggle=ha,l.show=ga,l.hide=ba,l.disable=function(){return ba(),n&&n.hasClass("btn")&&n.addClass("disabled"),g.prop("disabled",!0),l},l.enable=function(){return n&&n.hasClass("btn")&&n.removeClass("disabled"),g.prop("disabled",!1),l},l.ignoreReadonly=function(a){if(0===arguments.length)return d.ignoreReadonly;if("boolean"!=typeof a)throw new TypeError("ignoreReadonly () expects a boolean parameter");return d.ignoreReadonly=a,l},l.options=function(b){if(0===arguments.length)return a.extend(!0,{},d);if(!(b instanceof Object))throw new TypeError("options() options parameter should be an object");return a.extend(!0,d,b),a.each(d,function(a,b){if(void 0===l[a])throw new TypeError("option "+a+" is not recognized!");l[a](b)}),l},l.date=function(a){if(0===arguments.length)return m?null:e.clone();if(!(null===a||"string"==typeof a||b.isMoment(a)||a instanceof Date))throw new TypeError("date() parameter must be one of [null, string, moment or Date]");return aa(null===a?null:da(a)),l},l.format=function(a){if(0===arguments.length)return d.format;if("string"!=typeof a&&("boolean"!=typeof a||a!==!1))throw new TypeError("format() expects a string or boolean:false parameter "+a);return d.format=a,i&&pa(),l},l.timeZone=function(a){if(0===arguments.length)return d.timeZone;if("string"!=typeof a)throw new TypeError("newZone() expects a string parameter");return d.timeZone=a,l},l.dayViewHeaderFormat=function(a){if(0===arguments.length)return d.dayViewHeaderFormat;if("string"!=typeof a)throw new TypeError("dayViewHeaderFormat() expects a string parameter");return d.dayViewHeaderFormat=a,l},l.extraFormats=function(a){if(0===arguments.length)return d.extraFormats;if(a!==!1&&!(a instanceof Array))throw new TypeError("extraFormats() expects an array or false parameter");return d.extraFormats=a,j&&pa(),l},l.disabledDates=function(b){if(0===arguments.length)return d.disabledDates?a.extend({},d.disabledDates):d.disabledDates;if(!b)return d.disabledDates=!1,_(),l;if(!(b instanceof Array))throw new TypeError("disabledDates() expects an array parameter");return d.disabledDates=na(b),d.enabledDates=!1,_(),l},l.enabledDates=function(b){if(0===arguments.length)return d.enabledDates?a.extend({},d.enabledDates):d.enabledDates;if(!b)return d.enabledDates=!1,_(),l;if(!(b instanceof Array))throw new TypeError("enabledDates() expects an array parameter");return d.enabledDates=na(b),d.disabledDates=!1,_(),l},l.daysOfWeekDisabled=function(a){if(0===arguments.length)return d.daysOfWeekDisabled.splice(0);if("boolean"==typeof a&&!a)return d.daysOfWeekDisabled=!1,_(),l;if(!(a instanceof Array))throw new TypeError("daysOfWeekDisabled() expects an array parameter");if(d.daysOfWeekDisabled=a.reduce(function(a,b){return b=parseInt(b,10),b>6||b<0||isNaN(b)?a:(a.indexOf(b)===-1&&a.push(b),a)},[]).sort(),d.useCurrent&&!d.keepInvalid){for(var b=0;!R(e,"d");){if(e.add(1,"d"),31===b)throw"Tried 31 times to find a valid date";b++}aa(e)}return _(),l},l.maxDate=function(a){if(0===arguments.length)return d.maxDate?d.maxDate.clone():d.maxDate;if("boolean"==typeof a&&a===!1)return d.maxDate=!1,_(),l;"string"==typeof a&&("now"!==a&&"moment"!==a||(a=y()));var b=da(a);if(!b.isValid())throw new TypeError("maxDate() Could not parse date parameter: "+a);if(d.minDate&&b.isBefore(d.minDate))throw new TypeError("maxDate() date parameter is before options.minDate: "+b.format(i));return d.maxDate=b,d.useCurrent&&!d.keepInvalid&&e.isAfter(a)&&aa(d.maxDate),f.isAfter(b)&&(f=b.clone().subtract(d.stepping,"m")),_(),l},l.minDate=function(a){if(0===arguments.length)return d.minDate?d.minDate.clone():d.minDate;if("boolean"==typeof a&&a===!1)return d.minDate=!1,_(),l;"string"==typeof a&&("now"!==a&&"moment"!==a||(a=y()));var b=da(a);if(!b.isValid())throw new TypeError("minDate() Could not parse date parameter: "+a);if(d.maxDate&&b.isAfter(d.maxDate))throw new TypeError("minDate() date parameter is after options.maxDate: "+b.format(i));return d.minDate=b,d.useCurrent&&!d.keepInvalid&&e.isBefore(a)&&aa(d.minDate),f.isBefore(b)&&(f=b.clone().add(d.stepping,"m")),_(),l},l.defaultDate=function(a){if(0===arguments.length)return d.defaultDate?d.defaultDate.clone():d.defaultDate;if(!a)return d.defaultDate=!1,l;"string"==typeof a&&(a="now"===a||"moment"===a?y():y(a));var b=da(a);if(!b.isValid())throw new TypeError("defaultDate() Could not parse date parameter: "+a);if(!R(b))throw new TypeError("defaultDate() date passed is invalid according to component setup validations");return d.defaultDate=b,(d.defaultDate&&d.inline||""===g.val().trim())&&aa(d.defaultDate),l},l.locale=function(a){if(0===arguments.length)return d.locale;if(!b.localeData(a))throw new TypeError("locale() locale "+a+" is not loaded from moment locales!");return d.locale=a,e.locale(d.locale),f.locale(d.locale),i&&pa(),o&&(ba(),ga()),l},l.stepping=function(a){return 0===arguments.length?d.stepping:(a=parseInt(a,10),(isNaN(a)||a<1)&&(a=1),d.stepping=a,l)},l.useCurrent=function(a){var b=["year","month","day","hour","minute"];if(0===arguments.length)return d.useCurrent;if("boolean"!=typeof a&&"string"!=typeof a)throw new TypeError("useCurrent() expects a boolean or string parameter");if("string"==typeof a&&b.indexOf(a.toLowerCase())===-1)throw new TypeError("useCurrent() expects a string parameter of "+b.join(", "));return d.useCurrent=a,l},l.collapse=function(a){if(0===arguments.length)return d.collapse;if("boolean"!=typeof a)throw new TypeError("collapse() expects a boolean parameter");return d.collapse===a?l:(d.collapse=a,o&&(ba(),ga()),l)},l.icons=function(b){if(0===arguments.length)return a.extend({},d.icons);if(!(b instanceof Object))throw new TypeError("icons() expects parameter to be an Object");return a.extend(d.icons,b),o&&(ba(),ga()),l},l.tooltips=function(b){if(0===arguments.length)return a.extend({},d.tooltips);if(!(b instanceof Object))throw new TypeError("tooltips() expects parameter to be an Object");return a.extend(d.tooltips,b),o&&(ba(),ga()),l},l.useStrict=function(a){if(0===arguments.length)return d.useStrict;if("boolean"!=typeof a)throw new TypeError("useStrict() expects a boolean parameter");return d.useStrict=a,l},l.sideBySide=function(a){if(0===arguments.length)return d.sideBySide;if("boolean"!=typeof a)throw new TypeError("sideBySide() expects a boolean parameter");return d.sideBySide=a,o&&(ba(),ga()),l},l.viewMode=function(a){if(0===arguments.length)return d.viewMode;if("string"!=typeof a)throw new TypeError("viewMode() expects a string parameter");if(r.indexOf(a)===-1)throw new TypeError("viewMode() parameter must be one of ("+r.join(", ")+") value");return d.viewMode=a,k=Math.max(r.indexOf(a),p),L(),l},l.toolbarPlacement=function(a){if(0===arguments.length)return d.toolbarPlacement;if("string"!=typeof a)throw new TypeError("toolbarPlacement() expects a string parameter");if(u.indexOf(a)===-1)throw new TypeError("toolbarPlacement() parameter must be one of ("+u.join(", ")+") value");return d.toolbarPlacement=a,o&&(ba(),ga()),l},l.widgetPositioning=function(b){if(0===arguments.length)return a.extend({},d.widgetPositioning);if("[object Object]"!=={}.toString.call(b))throw new TypeError("widgetPositioning() expects an object variable");if(b.horizontal){if("string"!=typeof b.horizontal)throw new TypeError("widgetPositioning() horizontal variable must be a string");if(b.horizontal=b.horizontal.toLowerCase(),t.indexOf(b.horizontal)===-1)throw new TypeError("widgetPositioning() expects horizontal parameter to be one of ("+t.join(", ")+")");d.widgetPositioning.horizontal=b.horizontal}if(b.vertical){if("string"!=typeof b.vertical)throw new TypeError("widgetPositioning() vertical variable must be a string");if(b.vertical=b.vertical.toLowerCase(),s.indexOf(b.vertical)===-1)throw new TypeError("widgetPositioning() expects vertical parameter to be one of ("+s.join(", ")+")");d.widgetPositioning.vertical=b.vertical}return _(),l},l.calendarWeeks=function(a){if(0===arguments.length)return d.calendarWeeks;if("boolean"!=typeof a)throw new TypeError("calendarWeeks() expects parameter to be a boolean value");return d.calendarWeeks=a,_(),l},l.showTodayButton=function(a){if(0===arguments.length)return d.showTodayButton;if("boolean"!=typeof a)throw new TypeError("showTodayButton() expects a boolean parameter");return d.showTodayButton=a,o&&(ba(),ga()),l},l.showClear=function(a){if(0===arguments.length)return d.showClear;if("boolean"!=typeof a)throw new TypeError("showClear() expects a boolean parameter");return d.showClear=a,o&&(ba(),ga()),l},l.widgetParent=function(b){if(0===arguments.length)return d.widgetParent;if("string"==typeof b&&(b=a(b)),null!==b&&"string"!=typeof b&&!(b instanceof a))throw new TypeError("widgetParent() expects a string or a jQuery object parameter");return d.widgetParent=b,o&&(ba(),ga()),l},l.keepOpen=function(a){if(0===arguments.length)return d.keepOpen;if("boolean"!=typeof a)throw new TypeError("keepOpen() expects a boolean parameter");return d.keepOpen=a,l},l.focusOnShow=function(a){if(0===arguments.length)return d.focusOnShow;if("boolean"!=typeof a)throw new TypeError("focusOnShow() expects a boolean parameter");return d.focusOnShow=a,l},l.inline=function(a){if(0===arguments.length)return d.inline;if("boolean"!=typeof a)throw new TypeError("inline() expects a boolean parameter");return d.inline=a,l},l.clear=function(){return ca(),l},l.keyBinds=function(a){return 0===arguments.length?d.keyBinds:(d.keyBinds=a,l)},l.getMoment=function(a){return y(a)},l.debug=function(a){if("boolean"!=typeof a)throw new TypeError("debug() expects a boolean parameter");return d.debug=a,l},l.allowInputToggle=function(a){if(0===arguments.length)return d.allowInputToggle;if("boolean"!=typeof a)throw new TypeError("allowInputToggle() expects a boolean parameter");return d.allowInputToggle=a,l},l.showClose=function(a){if(0===arguments.length)return d.showClose;if("boolean"!=typeof a)throw new TypeError("showClose() expects a boolean parameter");return d.showClose=a,l},l.keepInvalid=function(a){if(0===arguments.length)return d.keepInvalid;if("boolean"!=typeof a)throw new TypeError("keepInvalid() expects a boolean parameter");
	return d.keepInvalid=a,l},l.datepickerInput=function(a){if(0===arguments.length)return d.datepickerInput;if("string"!=typeof a)throw new TypeError("datepickerInput() expects a string parameter");return d.datepickerInput=a,l},l.parseInputDate=function(a){if(0===arguments.length)return d.parseInputDate;if("function"!=typeof a)throw new TypeError("parseInputDate() sholud be as function");return d.parseInputDate=a,l},l.disabledTimeIntervals=function(b){if(0===arguments.length)return d.disabledTimeIntervals?a.extend({},d.disabledTimeIntervals):d.disabledTimeIntervals;if(!b)return d.disabledTimeIntervals=!1,_(),l;if(!(b instanceof Array))throw new TypeError("disabledTimeIntervals() expects an array parameter");return d.disabledTimeIntervals=b,_(),l},l.disabledHours=function(b){if(0===arguments.length)return d.disabledHours?a.extend({},d.disabledHours):d.disabledHours;if(!b)return d.disabledHours=!1,_(),l;if(!(b instanceof Array))throw new TypeError("disabledHours() expects an array parameter");if(d.disabledHours=oa(b),d.enabledHours=!1,d.useCurrent&&!d.keepInvalid){for(var c=0;!R(e,"h");){if(e.add(1,"h"),24===c)throw"Tried 24 times to find a valid date";c++}aa(e)}return _(),l},l.enabledHours=function(b){if(0===arguments.length)return d.enabledHours?a.extend({},d.enabledHours):d.enabledHours;if(!b)return d.enabledHours=!1,_(),l;if(!(b instanceof Array))throw new TypeError("enabledHours() expects an array parameter");if(d.enabledHours=oa(b),d.disabledHours=!1,d.useCurrent&&!d.keepInvalid){for(var c=0;!R(e,"h");){if(e.add(1,"h"),24===c)throw"Tried 24 times to find a valid date";c++}aa(e)}return _(),l},l.viewDate=function(a){if(0===arguments.length)return f.clone();if(!a)return f=e.clone(),l;if(!("string"==typeof a||b.isMoment(a)||a instanceof Date))throw new TypeError("viewDate() parameter must be one of [string, moment or Date]");return f=da(a),K(),l},c.is("input"))g=c;else if(g=c.find(d.datepickerInput),0===g.length)g=c.find("input");else if(!g.is("input"))throw new Error('CSS class "'+d.datepickerInput+'" cannot be applied to non input element');if(c.hasClass("input-group")&&(n=0===c.find(".datepickerbutton").length?c.find(".input-group-addon"):c.find(".datepickerbutton")),!d.inline&&!g.is("input"))throw new Error("Could not initialize DateTimePicker without an input element");return e=y(),f=e.clone(),a.extend(!0,d,H()),l.options(d),pa(),la(),g.prop("disabled")&&l.disable(),g.is("input")&&0!==g.val().trim().length?aa(da(g.val().trim())):d.defaultDate&&void 0===g.attr("placeholder")&&aa(d.defaultDate),d.inline&&ga(),l};return a.fn.datetimepicker=function(b){b=b||{};var d,e=Array.prototype.slice.call(arguments,1),f=!0,g=["destroy","hide","show","toggle"];if("object"==typeof b)return this.each(function(){var d,e=a(this);e.data("DateTimePicker")||(d=a.extend(!0,{},a.fn.datetimepicker.defaults,b),e.data("DateTimePicker",c(e,d)))});if("string"==typeof b)return this.each(function(){var c=a(this),g=c.data("DateTimePicker");if(!g)throw new Error('bootstrap-datetimepicker("'+b+'") method was called on an element that is not using DateTimePicker');d=g[b].apply(g,e),f=d===g}),f||a.inArray(b,g)>-1?this:d;throw new TypeError("Invalid arguments for DateTimePicker: "+b)},a.fn.datetimepicker.defaults={timeZone:"",format:!1,dayViewHeaderFormat:"MMMM YYYY",extraFormats:!1,stepping:1,minDate:!1,maxDate:!1,useCurrent:!0,collapse:!0,locale:b.locale(),defaultDate:!1,disabledDates:!1,enabledDates:!1,icons:{time:"glyphicon glyphicon-time",date:"glyphicon glyphicon-calendar",up:"glyphicon glyphicon-chevron-up",down:"glyphicon glyphicon-chevron-down",previous:"glyphicon glyphicon-chevron-left",next:"glyphicon glyphicon-chevron-right",today:"glyphicon glyphicon-screenshot",clear:"glyphicon glyphicon-trash",close:"glyphicon glyphicon-remove"},tooltips:{today:"Go to today",clear:"Clear selection",close:"Close the picker",selectMonth:"Select Month",prevMonth:"Previous Month",nextMonth:"Next Month",selectYear:"Select Year",prevYear:"Previous Year",nextYear:"Next Year",selectDecade:"Select Decade",prevDecade:"Previous Decade",nextDecade:"Next Decade",prevCentury:"Previous Century",nextCentury:"Next Century",pickHour:"Pick Hour",incrementHour:"Increment Hour",decrementHour:"Decrement Hour",pickMinute:"Pick Minute",incrementMinute:"Increment Minute",decrementMinute:"Decrement Minute",pickSecond:"Pick Second",incrementSecond:"Increment Second",decrementSecond:"Decrement Second",togglePeriod:"Toggle Period",selectTime:"Select Time"},useStrict:!1,sideBySide:!1,daysOfWeekDisabled:!1,calendarWeeks:!1,viewMode:"days",toolbarPlacement:"default",showTodayButton:!1,showClear:!1,showClose:!1,widgetPositioning:{horizontal:"auto",vertical:"auto"},widgetParent:null,ignoreReadonly:!1,keepOpen:!1,focusOnShow:!0,inline:!1,keepInvalid:!1,datepickerInput:".datepickerinput",keyBinds:{up:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")?this.date(b.clone().subtract(7,"d")):this.date(b.clone().add(this.stepping(),"m"))}},down:function(a){if(!a)return void this.show();var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")?this.date(b.clone().add(7,"d")):this.date(b.clone().subtract(this.stepping(),"m"))},"control up":function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")?this.date(b.clone().subtract(1,"y")):this.date(b.clone().add(1,"h"))}},"control down":function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")?this.date(b.clone().add(1,"y")):this.date(b.clone().subtract(1,"h"))}},left:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")&&this.date(b.clone().subtract(1,"d"))}},right:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")&&this.date(b.clone().add(1,"d"))}},pageUp:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")&&this.date(b.clone().subtract(1,"M"))}},pageDown:function(a){if(a){var b=this.date()||this.getMoment();a.find(".datepicker").is(":visible")&&this.date(b.clone().add(1,"M"))}},enter:function(){this.hide()},escape:function(){this.hide()},"control space":function(a){a&&a.find(".timepicker").is(":visible")&&a.find('.btn[data-action="togglePeriod"]').click()},t:function(){this.date(this.getMoment())},delete:function(){this.clear()}},debug:!1,allowInputToggle:!1,disabledTimeIntervals:!1,disabledHours:!1,enabledHours:!1,viewDate:!1},a.fn.datetimepicker});

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.27.0
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(32)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged and will be removed in an upcoming major release. Please refer to ' +
	            'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.27.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)(module)))

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 33,
		"./af.js": 33,
		"./ar": 34,
		"./ar-dz": 35,
		"./ar-dz.js": 35,
		"./ar-kw": 36,
		"./ar-kw.js": 36,
		"./ar-ly": 37,
		"./ar-ly.js": 37,
		"./ar-ma": 38,
		"./ar-ma.js": 38,
		"./ar-sa": 39,
		"./ar-sa.js": 39,
		"./ar-tn": 40,
		"./ar-tn.js": 40,
		"./ar.js": 34,
		"./az": 41,
		"./az.js": 41,
		"./be": 42,
		"./be.js": 42,
		"./bg": 43,
		"./bg.js": 43,
		"./bm": 44,
		"./bm.js": 44,
		"./bn": 45,
		"./bn.js": 45,
		"./bo": 46,
		"./bo.js": 46,
		"./br": 47,
		"./br.js": 47,
		"./bs": 48,
		"./bs.js": 48,
		"./ca": 49,
		"./ca.js": 49,
		"./cs": 50,
		"./cs.js": 50,
		"./cv": 51,
		"./cv.js": 51,
		"./cy": 52,
		"./cy.js": 52,
		"./da": 53,
		"./da.js": 53,
		"./de": 54,
		"./de-at": 55,
		"./de-at.js": 55,
		"./de-ch": 56,
		"./de-ch.js": 56,
		"./de.js": 54,
		"./dv": 57,
		"./dv.js": 57,
		"./el": 58,
		"./el.js": 58,
		"./en-au": 59,
		"./en-au.js": 59,
		"./en-ca": 60,
		"./en-ca.js": 60,
		"./en-gb": 61,
		"./en-gb.js": 61,
		"./en-ie": 62,
		"./en-ie.js": 62,
		"./en-il": 63,
		"./en-il.js": 63,
		"./en-in": 64,
		"./en-in.js": 64,
		"./en-nz": 65,
		"./en-nz.js": 65,
		"./en-sg": 66,
		"./en-sg.js": 66,
		"./eo": 67,
		"./eo.js": 67,
		"./es": 68,
		"./es-do": 69,
		"./es-do.js": 69,
		"./es-us": 70,
		"./es-us.js": 70,
		"./es.js": 68,
		"./et": 71,
		"./et.js": 71,
		"./eu": 72,
		"./eu.js": 72,
		"./fa": 73,
		"./fa.js": 73,
		"./fi": 74,
		"./fi.js": 74,
		"./fil": 75,
		"./fil.js": 75,
		"./fo": 76,
		"./fo.js": 76,
		"./fr": 77,
		"./fr-ca": 78,
		"./fr-ca.js": 78,
		"./fr-ch": 79,
		"./fr-ch.js": 79,
		"./fr.js": 77,
		"./fy": 80,
		"./fy.js": 80,
		"./ga": 81,
		"./ga.js": 81,
		"./gd": 82,
		"./gd.js": 82,
		"./gl": 83,
		"./gl.js": 83,
		"./gom-deva": 84,
		"./gom-deva.js": 84,
		"./gom-latn": 85,
		"./gom-latn.js": 85,
		"./gu": 86,
		"./gu.js": 86,
		"./he": 87,
		"./he.js": 87,
		"./hi": 88,
		"./hi.js": 88,
		"./hr": 89,
		"./hr.js": 89,
		"./hu": 90,
		"./hu.js": 90,
		"./hy-am": 91,
		"./hy-am.js": 91,
		"./id": 92,
		"./id.js": 92,
		"./is": 93,
		"./is.js": 93,
		"./it": 94,
		"./it-ch": 95,
		"./it-ch.js": 95,
		"./it.js": 94,
		"./ja": 96,
		"./ja.js": 96,
		"./jv": 97,
		"./jv.js": 97,
		"./ka": 98,
		"./ka.js": 98,
		"./kk": 99,
		"./kk.js": 99,
		"./km": 100,
		"./km.js": 100,
		"./kn": 101,
		"./kn.js": 101,
		"./ko": 102,
		"./ko.js": 102,
		"./ku": 103,
		"./ku.js": 103,
		"./ky": 104,
		"./ky.js": 104,
		"./lb": 105,
		"./lb.js": 105,
		"./lo": 106,
		"./lo.js": 106,
		"./lt": 107,
		"./lt.js": 107,
		"./lv": 108,
		"./lv.js": 108,
		"./me": 109,
		"./me.js": 109,
		"./mi": 110,
		"./mi.js": 110,
		"./mk": 111,
		"./mk.js": 111,
		"./ml": 112,
		"./ml.js": 112,
		"./mn": 113,
		"./mn.js": 113,
		"./mr": 114,
		"./mr.js": 114,
		"./ms": 115,
		"./ms-my": 116,
		"./ms-my.js": 116,
		"./ms.js": 115,
		"./mt": 117,
		"./mt.js": 117,
		"./my": 118,
		"./my.js": 118,
		"./nb": 119,
		"./nb.js": 119,
		"./ne": 120,
		"./ne.js": 120,
		"./nl": 121,
		"./nl-be": 122,
		"./nl-be.js": 122,
		"./nl.js": 121,
		"./nn": 123,
		"./nn.js": 123,
		"./oc-lnc": 124,
		"./oc-lnc.js": 124,
		"./pa-in": 125,
		"./pa-in.js": 125,
		"./pl": 126,
		"./pl.js": 126,
		"./pt": 127,
		"./pt-br": 128,
		"./pt-br.js": 128,
		"./pt.js": 127,
		"./ro": 129,
		"./ro.js": 129,
		"./ru": 130,
		"./ru.js": 130,
		"./sd": 131,
		"./sd.js": 131,
		"./se": 132,
		"./se.js": 132,
		"./si": 133,
		"./si.js": 133,
		"./sk": 134,
		"./sk.js": 134,
		"./sl": 135,
		"./sl.js": 135,
		"./sq": 136,
		"./sq.js": 136,
		"./sr": 137,
		"./sr-cyrl": 138,
		"./sr-cyrl.js": 138,
		"./sr.js": 137,
		"./ss": 139,
		"./ss.js": 139,
		"./sv": 140,
		"./sv.js": 140,
		"./sw": 141,
		"./sw.js": 141,
		"./ta": 142,
		"./ta.js": 142,
		"./te": 143,
		"./te.js": 143,
		"./tet": 144,
		"./tet.js": 144,
		"./tg": 145,
		"./tg.js": 145,
		"./th": 146,
		"./th.js": 146,
		"./tk": 147,
		"./tk.js": 147,
		"./tl-ph": 148,
		"./tl-ph.js": 148,
		"./tlh": 149,
		"./tlh.js": 149,
		"./tr": 150,
		"./tr.js": 150,
		"./tzl": 151,
		"./tzl.js": 151,
		"./tzm": 152,
		"./tzm-latn": 153,
		"./tzm-latn.js": 153,
		"./tzm.js": 152,
		"./ug-cn": 154,
		"./ug-cn.js": 154,
		"./uk": 155,
		"./uk.js": 155,
		"./ur": 156,
		"./ur.js": 156,
		"./uz": 157,
		"./uz-latn": 158,
		"./uz-latn.js": 158,
		"./uz.js": 157,
		"./vi": 159,
		"./vi.js": 159,
		"./x-pseudo": 160,
		"./x-pseudo.js": 160,
		"./yo": 161,
		"./yo.js": 161,
		"./zh-cn": 162,
		"./zh-cn.js": 162,
		"./zh-hk": 163,
		"./zh-hk.js": 163,
		"./zh-mo": 164,
		"./zh-mo.js": 164,
		"./zh-tw": 165,
		"./zh-tw.js": 165
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 32;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '١',
	            '2': '٢',
	            '3': '٣',
	            '4': '٤',
	            '5': '٥',
	            '6': '٦',
	            '7': '٧',
	            '8': '٨',
	            '9': '٩',
	            '0': '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '1',
	            '2': '2',
	            '3': '3',
	            '4': '4',
	            '5': '5',
	            '6': '6',
	            '7': '7',
	            '8': '8',
	            '9': '9',
	            '0': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '١',
	            '2': '٢',
	            '3': '٣',
	            '4': '٤',
	            '5': '٥',
	            '6': '٦',
	            '7': '٧',
	            '8': '٨',
	            '9': '٩',
	            '0': '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	            '_'
	        ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'birneçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
	            '_'
	        ),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '১',
	            '2': '২',
	            '3': '৩',
	            '4': '৪',
	            '5': '৫',
	            '6': '৬',
	            '7': '৭',
	            '8': '৮',
	            '9': '৯',
	            '0': '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '༡',
	            '2': '༢',
	            '3': '༣',
	            '4': '༤',
	            '5': '༥',
	            '6': '༦',
	            '7': '༧',
	            '8': '༨',
	            '9': '༩',
	            '0': '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	            '_'
	        ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                '_'
	            ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	            '_'
	        ),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	            '_'
	        ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	            '_'
	        ),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	            '_'
	        ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha invalida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
	            '_'
	        ),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	            '_'
	        ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	            '_'
	        ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '۱',
	            '2': '۲',
	            '3': '۳',
	            '4': '۴',
	            '5': '۵',
	            '6': '۶',
	            '7': '۷',
	            '8': '۸',
	            '9': '۹',
	            '0': '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	            ' '
	        ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	            '_'
	        ),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	            '_'
	        ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
	            '_'
	        );
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                '_'
	            ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                '_'
	            ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
	            '_'
	        ),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '१',
	            '2': '२',
	            '3': '३',
	            '4': '४',
	            '5': '५',
	            '6': '६',
	            '7': '७',
	            '8': '८',
	            '9': '९',
	            '0': '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var hi = moment.defineLocale('hi', {
	        months: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
	        ' '
	    );
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split(
	            '_'
	        ),
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	            '_'
	        ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                '_'
	            ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
	                    $0,
	                    $1,
	                    $2
	                ) {
	                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                });
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '១',
	            '2': '២',
	            '3': '៣',
	            '4': '៤',
	            '5': '៥',
	            '6': '៦',
	            '7': '៧',
	            '8': '៨',
	            '9': '៩',
	            '0': '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '೧',
	            '2': '೨',
	            '3': '೩',
	            '4': '೪',
	            '5': '೫',
	            '6': '೬',
	            '7': '೭',
	            '8': '೮',
	            '9': '೯',
	            '0': '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '١',
	            '2': '٢',
	            '3': '٣',
	            '4': '٤',
	            '5': '٥',
	            '6': '٦',
	            '7': '٧',
	            '8': '٨',
	            '9': '٩',
	            '0': '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                '_'
	            ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	            '_'
	        ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	            '_'
	        ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '१',
	            '2': '२',
	            '3': '३',
	            '4': '४',
	            '5': '५',
	            '6': '६',
	            '7': '७',
	            '8': '८',
	            '9': '९',
	            '0': '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '၁',
	            '2': '၂',
	            '3': '၃',
	            '4': '၄',
	            '5': '၅',
	            '6': '၆',
	            '7': '၇',
	            '8': '၈',
	            '9': '၉',
	            '0': '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '१',
	            '2': '२',
	            '3': '३',
	            '4': '४',
	            '5': '५',
	            '6': '६',
	            '7': '७',
	            '8': '८',
	            '9': '९',
	            '0': '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                '_'
	            ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '੧',
	            '2': '੨',
	            '3': '੩',
	            '4': '੪',
	            '5': '੫',
	            '6': '੬',
	            '7': '੭',
	            '8': '੮',
	            '9': '੯',
	            '0': '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	            '_'
	        ),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	            '_'
	        );
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return (
	                    '(' +
	                    monthsSubjective[momentToFormat.month()] +
	                    '|' +
	                    monthsNominative[momentToFormat.month()] +
	                    ')'
	                );
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                '_'
	            ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	        },
	        weekdays: {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                '_'
	            ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
	            '_'
	        ),
	        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	            '_'
	        ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	            '_'
	        ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	            '_'
	        ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            '1': '௧',
	            '2': '௨',
	            '3': '௩',
	            '4': '௪',
	            '5': '௫',
	            '6': '௬',
	            '7': '௭',
	            '8': '௮',
	            '9': '௯',
	            '0': '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	            '_'
	        ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	            '_'
	        ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Пагоҳ соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [trk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js language configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                    '_'
	                ),
	                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                    '_'
	                ),
	                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                    '_'
	                ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	            '_'
	        ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	            '_'
	        ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 166 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */,
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node/CommonJS
	        factory(require('jquery'));
	    } else {
	        // Browser globals
	        factory(jQuery);
	    }
	}(function ($) {
	
	var ua = navigator.userAgent,
		iPhone = /iphone/i.test(ua),
		chrome = /chrome/i.test(ua),
		android = /android/i.test(ua),
		caretTimeoutId;
	
	$.mask = {
		//Predefined character definitions
		definitions: {
			'9': "[0-9]",
			'a': "[A-Za-z]",
			'*': "[A-Za-z0-9]"
		},
		autoclear: true,
		dataName: "rawMaskFn",
		placeholder: '_'
	};
	
	$.fn.extend({
		//Helper Function for Caret positioning
		caret: function(begin, end) {
			var range;
	
			if (this.length === 0 || this.is(":hidden") || this.get(0) !== document.activeElement) {
				return;
			}
	
			if (typeof begin == 'number') {
				end = (typeof end === 'number') ? end : begin;
				return this.each(function() {
					if (this.setSelectionRange) {
						this.setSelectionRange(begin, end);
					} else if (this.createTextRange) {
						range = this.createTextRange();
						range.collapse(true);
						range.moveEnd('character', end);
						range.moveStart('character', begin);
						range.select();
					}
				});
			} else {
				if (this[0].setSelectionRange) {
					begin = this[0].selectionStart;
					end = this[0].selectionEnd;
				} else if (document.selection && document.selection.createRange) {
					range = document.selection.createRange();
					begin = 0 - range.duplicate().moveStart('character', -100000);
					end = begin + range.text.length;
				}
				return { begin: begin, end: end };
			}
		},
		unmask: function() {
			return this.trigger("unmask");
		},
		mask: function(mask, settings) {
			var input,
				defs,
				tests,
				partialPosition,
				firstNonMaskPos,
	            lastRequiredNonMaskPos,
	            len,
	            oldVal;
	
			if (!mask && this.length > 0) {
				input = $(this[0]);
	            var fn = input.data($.mask.dataName)
				return fn?fn():undefined;
			}
	
			settings = $.extend({
				autoclear: $.mask.autoclear,
				placeholder: $.mask.placeholder, // Load default placeholder
				completed: null
			}, settings);
	
	
			defs = $.mask.definitions;
			tests = [];
			partialPosition = len = mask.length;
			firstNonMaskPos = null;
	
			mask = String(mask);
	
			$.each(mask.split(""), function(i, c) {
				if (c == '?') {
					len--;
					partialPosition = i;
				} else if (defs[c]) {
					tests.push(new RegExp(defs[c]));
					if (firstNonMaskPos === null) {
						firstNonMaskPos = tests.length - 1;
					}
	                if(i < partialPosition){
	                    lastRequiredNonMaskPos = tests.length - 1;
	                }
				} else {
					tests.push(null);
				}
			});
	
			return this.trigger("unmask").each(function() {
				var input = $(this),
					buffer = $.map(
	    				mask.split(""),
	    				function(c, i) {
	    					if (c != '?') {
	    						return defs[c] ? getPlaceholder(i) : c;
	    					}
	    				}),
					defaultBuffer = buffer.join(''),
					focusText = input.val();
	
	            function tryFireCompleted(){
	                if (!settings.completed) {
	                    return;
	                }
	
	                for (var i = firstNonMaskPos; i <= lastRequiredNonMaskPos; i++) {
	                    if (tests[i] && buffer[i] === getPlaceholder(i)) {
	                        return;
	                    }
	                }
	                settings.completed.call(input);
	            }
	
	            function getPlaceholder(i){
	                if(i < settings.placeholder.length)
	                    return settings.placeholder.charAt(i);
	                return settings.placeholder.charAt(0);
	            }
	
				function seekNext(pos) {
					while (++pos < len && !tests[pos]);
					return pos;
				}
	
				function seekPrev(pos) {
					while (--pos >= 0 && !tests[pos]);
					return pos;
				}
	
				function shiftL(begin,end) {
					var i,
						j;
	
					if (begin<0) {
						return;
					}
	
					for (i = begin, j = seekNext(end); i < len; i++) {
						if (tests[i]) {
							if (j < len && tests[i].test(buffer[j])) {
								buffer[i] = buffer[j];
								buffer[j] = getPlaceholder(j);
							} else {
								break;
							}
	
							j = seekNext(j);
						}
					}
					writeBuffer();
					input.caret(Math.max(firstNonMaskPos, begin));
				}
	
				function shiftR(pos) {
					var i,
						c,
						j,
						t;
	
					for (i = pos, c = getPlaceholder(pos); i < len; i++) {
						if (tests[i]) {
							j = seekNext(i);
							t = buffer[i];
							buffer[i] = c;
							if (j < len && tests[j].test(t)) {
								c = t;
							} else {
								break;
							}
						}
					}
				}
	
				function androidInputEvent(e) {
					var curVal = input.val();
					var pos = input.caret();
					if (oldVal && oldVal.length && oldVal.length > curVal.length ) {
						// a deletion or backspace happened
						checkVal(true);
						while (pos.begin > 0 && !tests[pos.begin-1])
							pos.begin--;
						if (pos.begin === 0)
						{
							while (pos.begin < firstNonMaskPos && !tests[pos.begin])
								pos.begin++;
						}
						input.caret(pos.begin,pos.begin);
					} else {
						var pos2 = checkVal(true);
						var lastEnteredValue = curVal.charAt(pos.begin);
						if (pos.begin < len){
							if(!tests[pos.begin]){
								pos.begin++;
								if(tests[pos.begin].test(lastEnteredValue)){
									pos.begin++;
								}
							}else{
								if(tests[pos.begin].test(lastEnteredValue)){
									pos.begin++;
								}
							}
						}
						input.caret(pos.begin,pos.begin);
					}
					tryFireCompleted();
				}
	
	
				function blurEvent(e) {
	                checkVal();
	
	                if (input.val() != focusText)
	                    input.change();
	            }
	
				function keydownEvent(e) {
	                if (input.prop("readonly")){
	                    return;
	                }
	
					var k = e.which || e.keyCode,
						pos,
						begin,
						end;
	                    oldVal = input.val();
					//backspace, delete, and escape get special treatment
					if (k === 8 || k === 46 || (iPhone && k === 127)) {
						pos = input.caret();
						begin = pos.begin;
						end = pos.end;
	
						if (end - begin === 0) {
							begin=k!==46?seekPrev(begin):(end=seekNext(begin-1));
							end=k===46?seekNext(end):end;
						}
						clearBuffer(begin, end);
						shiftL(begin, end - 1);
	
						e.preventDefault();
					} else if( k === 13 ) { // enter
						blurEvent.call(this, e);
					} else if (k === 27) { // escape
						input.val(focusText);
						input.caret(0, checkVal());
						e.preventDefault();
					}
				}
	
				function keypressEvent(e) {
	                if (input.prop("readonly")){
	                    return;
	                }
	
					var k = e.which || e.keyCode,
						pos = input.caret(),
						p,
						c,
						next;
	
					if (e.ctrlKey || e.altKey || e.metaKey || k < 32) {//Ignore
						return;
					} else if ( k && k !== 13 ) {
						if (pos.end - pos.begin !== 0){
							clearBuffer(pos.begin, pos.end);
							shiftL(pos.begin, pos.end-1);
						}
	
						p = seekNext(pos.begin - 1);
						if (p < len) {
							c = String.fromCharCode(k);
							if (tests[p].test(c)) {
								shiftR(p);
	
								buffer[p] = c;
								writeBuffer();
								next = seekNext(p);
	
								if(android){
									//Path for CSP Violation on FireFox OS 1.1
									var proxy = function() {
										$.proxy($.fn.caret,input,next)();
									};
	
									setTimeout(proxy,0);
								}else{
									input.caret(next);
								}
	                            if(pos.begin <= lastRequiredNonMaskPos){
			                         tryFireCompleted();
	                             }
							}
						}
						e.preventDefault();
					}
				}
	
				function clearBuffer(start, end) {
					var i;
					for (i = start; i < end && i < len; i++) {
						if (tests[i]) {
							buffer[i] = getPlaceholder(i);
						}
					}
				}
	
				function writeBuffer() { input.val(buffer.join('')); }
	
				function checkVal(allow) {
					//try to place characters where they belong
					var test = input.val(),
						lastMatch = -1,
						i,
						c,
						pos;
	
					for (i = 0, pos = 0; i < len; i++) {
						if (tests[i]) {
							buffer[i] = getPlaceholder(i);
							while (pos++ < test.length) {
								c = test.charAt(pos - 1);
								if (tests[i].test(c)) {
									buffer[i] = c;
									lastMatch = i;
									break;
								}
							}
							if (pos > test.length) {
								clearBuffer(i + 1, len);
								break;
							}
						} else {
	                        if (buffer[i] === test.charAt(pos)) {
	                            pos++;
	                        }
	                        if( i < partialPosition){
	                            lastMatch = i;
	                        }
						}
					}
					if (allow) {
						writeBuffer();
					} else if (lastMatch + 1 < partialPosition) {
						if (settings.autoclear || buffer.join('') === defaultBuffer) {
							// Invalid value. Remove it and replace it with the
							// mask, which is the default behavior.
							if(input.val()) input.val("");
							clearBuffer(0, len);
						} else {
							// Invalid value, but we opt to show the value to the
							// user and allow them to correct their mistake.
							writeBuffer();
						}
					} else {
						writeBuffer();
						input.val(input.val().substring(0, lastMatch + 1));
					}
					return (partialPosition ? i : firstNonMaskPos);
				}
	
				input.data($.mask.dataName,function(){
					return $.map(buffer, function(c, i) {
						return tests[i]&&c!=getPlaceholder(i) ? c : null;
					}).join('');
				});
	
	
				input
					.one("unmask", function() {
						input
							.off(".mask")
							.removeData($.mask.dataName);
					})
					.on("focus.mask", function() {
	                    if (input.prop("readonly")){
	                        return;
	                    }
	
						clearTimeout(caretTimeoutId);
						var pos;
	
						focusText = input.val();
	
						pos = checkVal();
	
						caretTimeoutId = setTimeout(function(){
	                        if(input.get(0) !== document.activeElement){
	                            return;
	                        }
							writeBuffer();
							if (pos == mask.replace("?","").length) {
								input.caret(0, pos);
							} else {
								input.caret(pos);
							}
						}, 10);
					})
					.on("blur.mask", blurEvent)
					.on("keydown.mask", keydownEvent)
					.on("keypress.mask", keypressEvent)
					.on("input.mask paste.mask", function() {
	                    if (input.prop("readonly")){
	                        return;
	                    }
	
						setTimeout(function() {
							var pos=checkVal(true);
							input.caret(pos);
	                        tryFireCompleted();
						}, 0);
					});
	                if (chrome && android)
	                {
	                    input
	                        .off('input.mask')
	                        .on('input.mask', androidInputEvent);
	                }
					checkVal(); //Perform initial check for existing values
			});
		}
	});
	}));


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * @copyright Copyright &copy; Kartik Visweswaran, Krajee.com, 2014 - 2015
	 * @version 4.2.8
	 *
	 * File input styled for Bootstrap 3.0 that utilizes HTML5 File Input's advanced 
	 * features including the FileReader API. 
	 * 
	 * The plugin drastically enhances the HTML file input to preview multiple files on the client before
	 * upload. In addition it provides the ability to preview content of images, text, videos, audio, html, 
	 * flash and other objects. It also offers the ability to upload and delete files using AJAX, and add 
	 * files in batches (i.e. preview, append, or remove before upload).
	 * 
	 * Author: Kartik Visweswaran
	 * Copyright: 2015, Kartik Visweswaran, Krajee.com
	 * For more JQuery plugins visit http://plugins.krajee.com
	 * For more Yii related demos visit http://demos.krajee.com
	 */!function(e){"use strict"; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=e(require("jquery")):e(window.jQuery)}(function(e){"use strict";e.fn.fileinputLocales={};var i,t,a,r,n,l,o,s,d,c,p,u,f,v,g,m,h,w,b,C,x,y,T,F,I,E,k,S,$,P,D,U,A,j,L,z,O,R,M,B,N,Z,H,W,q,_,V,K,X,J,Q,Y;i=function(e){if("Microsoft Internet Explorer"!==navigator.appName)return!1;if(10===e)return new RegExp("msie\\s"+e,"i").test(navigator.userAgent);var i,t=document.createElement("div");return t.innerHTML="<!--[if IE "+e+"]> <i></i> <![endif]-->",i=t.getElementsByTagName("i").length,document.body.appendChild(t),t.parentNode.removeChild(t),i},t=function(){return new RegExp("Edge/[0-9]+","i").test(navigator.userAgent)},a=function(e,i,t,a){var r=a?i:i+".fileinput";e.off(r).on(r,t)},r={data:{},init:function(e){var i=e.initialPreview,t=e.id;i.length>0&&!q(i)&&(i=i.split(e.initialPreviewDelimiter)),r.data[t]={content:i,config:e.initialPreviewConfig,tags:e.initialPreviewThumbTags,delimiter:e.initialPreviewDelimiter,template:e.previewGenericTemplate,msg:function(i){return e.getMsgSelected(i)},initId:e.previewInitId,footer:e.getLayoutTemplate("footer").replace(/\{progress}/g,e.renderThumbProgress()),isDelete:e.initialPreviewShowDelete,caption:e.initialCaption,actions:function(i,t,a,r,n){return e.renderFileActions(i,t,a,r,n)}}},fetch:function(e){return r.data[e].content.filter(function(e){return null!==e})},count:function(e,i){return r.data[e]&&r.data[e].content?i?r.data[e].content.length:r.fetch(e).length:0},get:function(i,t,a){var n,l,o="init_"+t,s=r.data[i],d=s.config[t],c=s.initId+"-"+o,p=" file-preview-initial";return a=void 0===a?!0:a,null===s.content[t]?"":(W(d)||W(d.frameClass)||(p+=" "+d.frameClass),n=s.template.replace(/\{previewId}/g,c).replace(/\{frameClass}/g,p).replace(/\{fileindex}/g,o).replace(/\{content}/g,s.content[t]).replace(/\{footer}/g,r.footer(i,t,a)),s.tags.length&&s.tags[t]&&(n=J(n,s.tags[t])),W(d)||W(d.frameAttr)||(l=e(document.createElement("div")).html(n),l.find(".file-preview-initial").attr(d.frameAttr),n=l.html(),l.remove()),n)},add:function(i,t,a,n,l){var o,s=e.extend(!0,{},r.data[i]);return q(t)||(t=t.split(s.delimiter)),l?(o=s.content.push(t)-1,s.config[o]=a,s.tags[o]=n):(o=t.length,s.content=t,s.config=a,s.tags=n),r.data[i]=s,o},set:function(i,t,a,n,l){var o,s,d=e.extend(!0,{},r.data[i]);if(t&&t.length&&(q(t)||(t=t.split(d.delimiter)),s=t.filter(function(e){return null!==e}),s.length)){if(void 0===d.content&&(d.content=[]),void 0===d.config&&(d.config=[]),void 0===d.tags&&(d.tags=[]),l){for(o=0;o<t.length;o++)t[o]&&d.content.push(t[o]);for(o=0;o<a.length;o++)a[o]&&d.config.push(a[o]);for(o=0;o<n.length;o++)n[o]&&d.tags.push(n[o])}else d.content=t,d.config=a,d.tags=n;r.data[i]=d}},unset:function(e,i){var t=r.count(e);if(t){if(1===t)return r.data[e].content=[],void(r.data[e].config=[]);r.data[e].content[i]=null,r.data[e].config[i]=null}},out:function(e){var i,t="",a=r.data[e],n=r.count(e,!0);if(0===n)return{content:"",caption:""};for(var l=0;n>l;l++)t+=r.get(e,l);return i=a.msg(r.count(e)),{content:t,caption:i}},footer:function(e,i,t){var a=r.data[e];if(t=void 0===t?!0:t,0===a.config.length||W(a.config[i]))return"";var n=a.config[i],l=_("caption",n)?n.caption:"",o=_("width",n)?n.width:"auto",s=_("url",n)?n.url:!1,d=_("key",n)?n.key:null,c=s===!1&&t,p=a.isDelete?a.actions(!1,!0,c,s,d):"",u=a.footer.replace(/\{actions}/g,p);return u.replace(/\{caption}/g,l).replace(/\{width}/g,o).replace(/\{indicator}/g,"").replace(/\{indicatorTitle}/g,"")}},n=function(e,i){return i=i||0,"number"==typeof e?e:("string"==typeof e&&(e=parseFloat(e)),isNaN(e)?i:e)},l=function(){return window.File&&window.FileReader},o=function(){var e=document.createElement("div");return!i(9)&&!t()&&(void 0!==e.draggable||void 0!==e.ondragstart&&void 0!==e.ondrop)},s=function(){return l()&&window.FormData},d=function(e,i){e.removeClass(i).addClass(i)},c='style="width:{width};height:{height};"',p='      <param name="controller" value="true" />\n      <param name="allowFullScreen" value="true" />\n      <param name="allowScriptAccess" value="always" />\n      <param name="autoPlay" value="false" />\n      <param name="autoStart" value="false" />\n      <param name="quality" value="high" />\n',u='<div class="file-preview-other">\n   <span class="{previewFileIconClass}">{previewFileIcon}</span>\n</div>',f={removeIcon:'<i class="glyphicon glyphicon-trash text-danger"></i>',removeClass:"btn btn-xs btn-default",removeTitle:"Remove file",uploadIcon:'<i class="glyphicon glyphicon-upload text-info"></i>',uploadClass:"btn btn-xs btn-default",uploadTitle:"Upload file",indicatorNew:'<i class="glyphicon glyphicon-hand-down text-warning"></i>',indicatorSuccess:'<i class="glyphicon glyphicon-ok-sign text-success"></i>',indicatorError:'<i class="glyphicon glyphicon-exclamation-sign text-danger"></i>',indicatorLoading:'<i class="glyphicon glyphicon-hand-up text-muted"></i>',indicatorNewTitle:"Not uploaded yet",indicatorSuccessTitle:"Uploaded",indicatorErrorTitle:"Upload Error",indicatorLoadingTitle:"Uploading ..."},v='{preview}\n<div class="kv-upload-progress hide"></div>\n<div class="input-group {class}">\n   {caption}\n   <div class="input-group-btn">\n       {remove}\n       {cancel}\n       {upload}\n       {browse}\n   </div>\n</div>',g='{preview}\n<div class="kv-upload-progress hide"></div>\n{remove}\n{cancel}\n{upload}\n{browse}\n',m='<div class="file-preview {class}">\n    {close}    <div class="{dropClass}">\n    <div class="file-preview-thumbnails">\n    </div>\n    <div class="clearfix"></div>    <div class="file-preview-status text-center text-success"></div>\n    <div class="kv-fileinput-error"></div>\n    </div>\n</div>',w='<div class="close fileinput-remove">&times;</div>\n',h='<span class="glyphicon glyphicon-file kv-caption-icon"></span>',b='<div tabindex="500" class="form-control file-caption {class}">\n   <div class="file-caption-name"></div>\n</div>\n',C='<button type="{type}" tabindex="500" title="{title}" class="{css}" {status}>{icon}{label}</button>',x='<a href="{href}" tabindex="500" title="{title}" class="{css}" {status}>{icon}{label}</a>',y='<div tabindex="500" class="{css}" {status}>{icon}{label}</div>',T='<div id="{id}" class="file-preview-detail-modal modal fade" tabindex="-1">\n  <div class="modal-dialog modal-lg">\n    <div class="modal-content">\n      <div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>\n        <h3 class="modal-title">{heading} <small>{title}</small></h3>\n      </div>\n      <div class="modal-body">\n           <pre>{body}</pre>\n      </div>\n    </div>\n  </div>\n</div>',F='<div class="progress">\n    <div class="{class}" role="progressbar" aria-valuenow="{percent}" aria-valuemin="0" aria-valuemax="100" style="width:{percent}%;">\n        {percent}%\n     </div>\n</div>',I='<div class="file-thumbnail-footer">\n    <div class="file-footer-caption" title="{caption}">{caption}</div>\n    {progress} {actions}\n</div>',E='<div class="file-actions">\n    <div class="file-footer-buttons">\n        {upload}{delete}{other}    </div>\n    <div class="file-upload-indicator" title="{indicatorTitle}">{indicator}</div>\n    <div class="clearfix"></div>\n</div>',k='<button type="button" class="kv-file-remove {removeClass}" title="{removeTitle}"{dataUrl}{dataKey}>{removeIcon}</button>\n',S='<button type="button" class="kv-file-upload {uploadClass}" title="{uploadTitle}">   {uploadIcon}\n</button>\n',$='<button type="button" class="btn btn-default btn-xs btn-block" title="{zoomTitle}: {caption}" onclick="{dialog}">\n   {zoomInd}\n</button>\n',P='<div class="file-preview-frame{frameClass}" id="{previewId}" data-fileindex="{fileindex}">\n   {content}\n   {footer}\n</div>\n',D='<div class="file-preview-frame{frameClass}" id="{previewId}" data-fileindex="{fileindex}">\n    <object class="file-object" data="{data}" type="{type}" width="{width}" height="{height}">\n       '+u+"\n    </object>\n   {footer}\n</div>",U='<div class="file-preview-frame{frameClass}" id="{previewId}" data-fileindex="{fileindex}">\n   <img src="{data}" class="file-preview-image" title="{caption}" alt="{caption}" '+c+">\n   {footer}\n</div>\n",A='<div class="file-preview-frame{frameClass}" id="{previewId}" data-fileindex="{fileindex}">\n   <pre class="file-preview-text" title="{caption}" '+c+">{data}</pre>\n   {zoom}\n   {footer}\n</div>",j='<div class="file-preview-frame{frameClass}" id="{previewId}" data-fileindex="{fileindex}" title="{caption}" '+c+'>\n   <video width="{width}" height="{height}" controls>\n       <source src="{data}" type="{type}">\n       '+u+"\n   </video>\n   {footer}\n</div>\n",L='<div class="file-preview-frame{frameClass}" id="{previewId}" data-fileindex="{fileindex}" title="{caption}" '+c+'>\n   <audio controls>\n       <source src="{data}" type="{type}">\n       '+u+"\n   </audio>\n   {footer}\n</div>",z='<div class="file-preview-frame{frameClass}" id="{previewId}" data-fileindex="{fileindex}" title="{caption}" '+c+'>\n   <object class="file-object" type="application/x-shockwave-flash" width="{width}" height="{height}" data="{data}">\n'+p+"       "+u+"\n   </object>\n   {footer}\n</div>\n",O='<div class="file-preview-frame{frameClass}" id="{previewId}" data-fileindex="{fileindex}" title="{caption}" '+c+'>\n   <object class="file-object" data="{data}" type="{type}" width="{width}" height="{height}">\n       <param name="movie" value="{caption}" />\n'+p+"         "+u+"\n   </object>\n   {footer}\n</div>",R='<div class="file-preview-frame{frameClass}" id="{previewId}" data-fileindex="{fileindex}" title="{caption}" '+c+'>\n   <div class="file-preview-other-frame">\n   '+u+'\n   </div>\n   <div class="file-preview-other-footer">{footer}</div>\n</div>',M={main1:v,main2:g,preview:m,close:w,zoom:$,icon:h,caption:b,modal:T,progress:F,footer:I,actions:E,actionDelete:k,actionUpload:S,btnDefault:C,btnLink:x,btnBrowse:y},B={generic:P,html:D,image:U,text:A,video:j,audio:L,flash:z,object:O,other:R},N=["image","html","text","video","audio","flash","object"],Z={image:{width:"auto",height:"160px"},html:{width:"213px",height:"160px"},text:{width:"160px",height:"136px"},video:{width:"213px",height:"160px"},audio:{width:"213px",height:"80px"},flash:{width:"213px",height:"160px"},object:{width:"160px",height:"160px"},other:{width:"160px",height:"160px"}},H={image:function(e,i){return void 0!==e?e.match("image.*"):i.match(/\.(gif|png|jpe?g)$/i)},html:function(e,i){return void 0!==e?"text/html"===e:i.match(/\.(htm|html)$/i)},text:function(e,i){return void 0!==e&&e.match("text.*")||i.match(/\.(txt|md|csv|nfo|ini|json|php|js|css)$/i)},video:function(e,i){return void 0!==e&&e.match(/\.video\/(ogg|mp4|webm|3gp)$/i)||i.match(/\.(og?|mp4|webm|3gp)$/i)},audio:function(e,i){return void 0!==e&&e.match(/\.audio\/(ogg|mp3|wav)$/i)||i.match(/\.(ogg|mp3|wav)$/i)},flash:function(e,i){return void 0!==e&&"application/x-shockwave-flash"===e||i.match(/\.(swf)$/i)},object:function(){return!0},other:function(){return!0}},W=function(i,t){return void 0===i||null===i||0===i.length||t&&""===e.trim(i)},q=function(e){return Array.isArray(e)||"[object Array]"===Object.prototype.toString.call(e)},_=function(e,i){return"object"==typeof i&&e in i},V=function(i,t,a){return W(i)||W(i[t])?a:e(i[t])},K=function(){return Math.round((new Date).getTime()+100*Math.random())},X=function(e){return e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&apos;")},J=function(i,t){var a=i;return t?(e.each(t,function(e,i){"function"==typeof i&&(i=i()),a=a.split(e).join(i)}),a):a},Q=window.URL||window.webkitURL,Y=function(t,a){var r=this;r.$element=e(t),r.validate()&&(r.isPreviewable=l(),r.isIE9=i(9),r.isIE10=i(10),r.isPreviewable||r.isIE9?(r.init(a),r.listen()):r.$element.removeClass("file-loading"))},Y.prototype={constructor:Y,validate:function(){var e,i=this;return"file"===i.$element.attr("type")?!0:(e='<div class="help-block alert alert-warning"><h4>Invalid Input Type</h4>You must set an input <code>type = file</code> for <b>bootstrap-fileinput</b> plugin to initialize.</div>',i.$element.after(e),!1)},init:function(i){var t,a=this,l=a.$element;e.each(i,function(e,i){switch(e){case"minFileCount":case"maxFileCount":case"maxFileSize":a[e]=n(i);break;default:a[e]=i}}),a.fileInputCleared=!1,a.fileBatchCompleted=!0,a.isPreviewable||(a.showPreview=!1),a.uploadFileAttr=W(l.attr("name"))?"file_data":l.attr("name"),a.reader=null,a.formdata={},a.clearStack(),a.uploadCount=0,a.uploadStatus={},a.uploadLog=[],a.uploadAsyncCount=0,a.loadedImages=[],a.totalImagesCount=0,a.ajaxRequests=[],a.isError=!1,a.ajaxAborted=!1,a.cancelling=!1,t=a.getLayoutTemplate("progress"),a.progressTemplate=t.replace("{class}",a.progressClass),a.progressCompleteTemplate=t.replace("{class}",a.progressCompleteClass),a.dropZoneEnabled=o()&&a.dropZoneEnabled,a.isDisabled=a.$element.attr("disabled")||a.$element.attr("readonly"),a.isUploadable=s()&&!W(a.uploadUrl),a.slug="function"==typeof i.slugCallback?i.slugCallback:a.slugDefault,a.mainTemplate=a.getLayoutTemplate(a.showCaption?"main1":"main2"),a.captionTemplate=a.getLayoutTemplate("caption"),a.previewGenericTemplate=a.getPreviewTemplate("generic"),a.resizeImage&&(a.maxImageWidth||a.maxImageHeight)&&(a.imageCanvas=document.createElement("canvas"),a.imageCanvasContext=a.imageCanvas.getContext("2d")),W(a.$element.attr("id"))&&a.$element.attr("id",K()),void 0===a.$container?a.$container=a.createContainer():a.refreshContainer(),a.$progress=a.$container.find(".kv-upload-progress"),a.$btnUpload=a.$container.find(".fileinput-upload"),a.$captionContainer=V(i,"elCaptionContainer",a.$container.find(".file-caption")),a.$caption=V(i,"elCaptionText",a.$container.find(".file-caption-name")),a.$previewContainer=V(i,"elPreviewContainer",a.$container.find(".file-preview")),a.$preview=V(i,"elPreviewImage",a.$container.find(".file-preview-thumbnails")),a.$previewStatus=V(i,"elPreviewStatus",a.$container.find(".file-preview-status")),a.$errorContainer=V(i,"elErrorContainer",a.$previewContainer.find(".kv-fileinput-error")),W(a.msgErrorClass)||d(a.$errorContainer,a.msgErrorClass),a.$errorContainer.hide(),a.fileActionSettings=e.extend(f,i.fileActionSettings),a.previewInitId="preview-"+K(),a.id=a.$element.attr("id"),r.init(a),a.initPreview(!0),a.initPreviewDeletes(),a.options=i,a.setFileDropZoneTitle(),a.$element.removeClass("file-loading"),a.$element.attr("disabled")&&a.disable()},parseError:function(i,t,a){var r=this,n=e.trim(t+""),l="."===n.slice(-1)?"":".",o=void 0!==i.responseJSON&&void 0!==i.responseJSON.error?i.responseJSON.error:i.responseText;return r.cancelling&&r.msgUploadAborted&&(n=r.msgUploadAborted),r.showAjaxErrorDetails&&o?(o=e.trim(o.replace(/\n\s*\n/g,"\n")),o=o.length>0?"<pre>"+o+"</pre>":"",n+=l+o):n+=l,r.cancelling=!1,a?"<b>"+a+": </b>"+n:n},raise:function(i,t){var a=this,r=e.Event(i);if(void 0!==t?a.$element.trigger(r,t):a.$element.trigger(r),r.isDefaultPrevented())return!1;if(!r.result)return r.result;switch(i){case"filebatchuploadcomplete":case"filebatchuploadsuccess":case"fileuploaded":case"fileclear":case"filecleared":case"filereset":case"fileerror":case"filefoldererror":case"fileuploaderror":case"filebatchuploaderror":case"filedeleteerror":case"filecustomerror":case"filesuccessremove":break;default:a.ajaxAborted=r.result}return!0},getLayoutTemplate:function(e){var i=this,t=_(e,i.layoutTemplates)?i.layoutTemplates[e]:M[e];return W(i.customLayoutTags)?t:J(t,i.customLayoutTags)},getPreviewTemplate:function(e){var i=this,t=_(e,i.previewTemplates)?i.previewTemplates[e]:B[e];return W(i.customPreviewTags)?t:J(t,i.customPreviewTags)},parseFilePreviewIcon:function(i,t){var a,r=this,n=r.previewFileIcon;return t&&t.indexOf(".")>-1&&(a=t.split(".").pop(),r.previewFileIconSettings&&r.previewFileIconSettings[a]&&(n=r.previewFileIconSettings[a]),r.previewFileExtSettings&&e.each(r.previewFileExtSettings,function(e,i){r.previewFileIconSettings[e]&&i(a)&&(n=r.previewFileIconSettings[e])})),i.indexOf("{previewFileIcon}")>-1?i.replace(/\{previewFileIconClass}/g,r.previewFileIconClass).replace(/\{previewFileIcon}/g,n):i},getOutData:function(e,i,t){var a=this;return e=e||{},i=i||{},t=t||a.filestack.slice(0)||{},{form:a.formdata,files:t,filenames:a.filenames,extra:a.getExtraData(),response:i,reader:a.reader,jqXHR:e}},listen:function(){var i=this,t=i.$element,r=i.$captionContainer,n=i.$btnFile,l=t.closest("form"),o=i.$container;a(t,"change",e.proxy(i.change,i)),a(n,"click",function(){i.raise("filebrowse"),i.isError&&!i.isUploadable&&i.clear(),r.focus()}),a(l,"reset",e.proxy(i.reset,i)),a(o.find(".fileinput-remove:not([disabled])"),"click",e.proxy(i.clear,i)),a(o.find(".fileinput-cancel"),"click",e.proxy(i.cancel,i)),i.isUploadable&&i.dropZoneEnabled&&i.showPreview&&i.initDragDrop(),i.isUploadable||a(l,"submit",e.proxy(i.submitForm,i)),a(i.$container.find(".fileinput-upload"),"click",function(t){var a,r=e(this),n=!r.hasClass("disabled")&&W(r.attr("disabled"));return i.isUploadable?(t.preventDefault(),void(n&&i.upload())):void(n&&"submit"!==r.attr("type")&&(a=r.closest("form"),a.length&&a.trigger("submit"),t.preventDefault()))})},submitForm:function(){var e=this,i=e.$element,t=i.get(0).files;return t&&e.minFileCount>0&&e.getFileCount(t.length)<e.minFileCount?(e.noFilesError({}),!1):!e.abort({})},abort:function(i){var t,a=this;return a.ajaxAborted&&"object"==typeof a.ajaxAborted&&void 0!==a.ajaxAborted.message?(t=e.extend(a.getOutData(),i),t.abortData=a.ajaxAborted.data||{},t.abortMessage=a.ajaxAborted.message,a.cancel(),a.setProgress(100),a.showUploadError(a.ajaxAborted.message,t,"filecustomerror"),!0):!1},noFilesError:function(e){var i=this,t=i.minFileCount>1?i.filePlural:i.fileSingle,a=i.msgFilesTooLess.replace("{n}",i.minFileCount).replace("{files}",t),r=i.$errorContainer;i.addError(a),i.isError=!0,i.updateFileDetails(0),r.fadeIn(800),i.raise("fileerror",[e]),i.clearFileInput(),d(i.$container,"has-error")},setProgress:function(e,i){var t=this,a=Math.min(e,100),r=100>a?t.progressTemplate:t.progressCompleteTemplate;i=i||t.$progress,W(r)||i.html(r.replace(/\{percent}/g,a))},lock:function(){var e=this;e.resetErrors(),e.disable(),e.showRemove&&d(e.$container.find(".fileinput-remove"),"hide"),e.showCancel&&e.$container.find(".fileinput-cancel").removeClass("hide"),e.raise("filelock",[e.filestack,e.getExtraData()])},unlock:function(e){var i=this;void 0===e&&(e=!0),i.enable(),i.showCancel&&d(i.$container.find(".fileinput-cancel"),"hide"),i.showRemove&&i.$container.find(".fileinput-remove").removeClass("hide"),e&&i.resetFileStack(),i.raise("fileunlock",[i.filestack,i.getExtraData()])},resetFileStack:function(){var i=this,t=0,a=[],r=[];i.getThumbs().each(function(){var n=e(this),l=n.attr("data-fileindex"),o=i.filestack[l];-1!==l&&(void 0!==o?(a[t]=o,r[t]=i.getFileName(o),n.attr({id:i.previewInitId+"-"+t,"data-fileindex":t}),t++):n.attr({id:"uploaded-"+K(),"data-fileindex":"-1"}))}),i.filestack=a,i.filenames=r},destroy:function(){var e=this,i=e.$container;i.find(".file-drop-zone").off(),e.$element.insertBefore(i).off(".fileinput").removeData(),i.off().remove()},refresh:function(i){var t=this,a=t.$element;i=i?e.extend(t.options,i):t.options,t.destroy(),a.fileinput(i),a.val()&&a.trigger("change.fileinput")},initDragDrop:function(){var i=this,t=i.$container.find(".file-drop-zone"),r="dragenter.fileinput dragover.fileinput drop.fileinput";a(t,"dragenter.fileinput dragover.fileinput",function(t){var a=e.inArray("Files",t.originalEvent.dataTransfer.types)>-1;return t.stopPropagation(),t.preventDefault(),i.isDisabled||!a?(t.originalEvent.dataTransfer.effectAllowed="none",void(t.originalEvent.dataTransfer.dropEffect="none")):void d(e(this),"file-highlighted")},!0),a(t,"dragleave",function(t){t.stopPropagation(),t.preventDefault(),i.isDisabled||e(this).removeClass("file-highlighted")}),a(t,"drop",function(t){t.preventDefault(),i.isDisabled||W(t.originalEvent.dataTransfer.files)||(i.change(t,"dragdrop"),e(this).removeClass("file-highlighted"))}),a(e(document),r,function(e){e.stopPropagation(),e.preventDefault()},!0)},setFileDropZoneTitle:function(){var e=this,i=e.$container.find(".file-drop-zone");i.find("."+e.dropZoneTitleClass).remove(),e.isUploadable&&e.showPreview&&0!==i.length&&!(e.getFileStack().length>0)&&e.dropZoneEnabled&&(0===i.find(".file-preview-frame").length&&W(e.defaultPreviewContent)&&i.prepend('<div class="'+e.dropZoneTitleClass+'">'+e.dropZoneTitle+"</div>"),e.$container.removeClass("file-input-new"),d(e.$container,"file-input-ajax-new"))},errorsExist:function(){var i,t=this;return t.$errorContainer.find("li").length?!0:(i=e(document.createElement("div")).html(t.$errorContainer.html()),i.find("span.kv-error-close").remove(),i.find("ul").remove(),e.trim(i.text()).length?!0:!1)},getMsgSelected:function(e){var i=this,t=1===e?i.fileSingle:i.filePlural;return i.msgSelected.replace("{n}",e).replace("{files}",t)},renderThumbProgress:function(){return'<div class="file-thumb-progress hide">'+this.progressTemplate.replace(/\{percent}/g,"0")+"</div>"},renderFileFooter:function(e,i){var t,a,r=this,n=r.fileActionSettings,l=r.getLayoutTemplate("footer");return r.isUploadable?(t=l.replace(/\{actions}/g,r.renderFileActions(!0,!0,!1,!1,!1)),a=t.replace(/\{caption}/g,e).replace(/\{width}/g,i).replace(/\{progress}/g,r.renderThumbProgress()).replace(/\{indicator}/g,n.indicatorNew).replace(/\{indicatorTitle}/g,n.indicatorNewTitle)):a=l.replace(/\{actions}/g,"").replace(/\{caption}/g,e).replace(/\{progress}/g,"").replace(/\{width}/g,i).replace(/\{indicator}/g,"").replace(/\{indicatorTitle}/g,""),a=J(a,r.previewThumbTags)},renderFileActions:function(e,i,t,a,r){if(!e&&!i)return"";var n=this,l=a===!1?"":' data-url="'+a+'"',o=r===!1?"":' data-key="'+r+'"',s=n.getLayoutTemplate("actionDelete"),d="",c=n.getLayoutTemplate("actions"),p=n.otherActionButtons.replace(/\{dataKey}/g,o),u=n.fileActionSettings,f=t?u.removeClass+" disabled":u.removeClass;return s=s.replace(/\{removeClass}/g,f).replace(/\{removeIcon}/g,u.removeIcon).replace(/\{removeTitle}/g,u.removeTitle).replace(/\{dataUrl}/g,l).replace(/\{dataKey}/g,o),e&&(d=n.getLayoutTemplate("actionUpload").replace(/\{uploadClass}/g,u.uploadClass).replace(/\{uploadIcon}/g,u.uploadIcon).replace(/\{uploadTitle}/g,u.uploadTitle)),c.replace(/\{delete}/g,s).replace(/\{upload}/g,d).replace(/\{other}/g,p)},setThumbStatus:function(e,i){var t=this;if(t.showPreview){var a="indicator"+i,r=a+"Title",n="file-preview-"+i.toLowerCase(),l=e.find(".file-upload-indicator"),o=t.fileActionSettings;e.removeClass("file-preview-success file-preview-error file-preview-loading"),"Error"===i&&e.find(".kv-file-upload").attr("disabled",!0),l.html(o[a]),l.attr("title",o[r]),e.addClass(n)}},clearPreview:function(){var e=this,i=e.$preview.find(e.showUploadedThumbs?".file-preview-frame:not(.file-preview-success)":".file-preview-frame");i.remove(),e.$preview.find(".file-preview-frame").length&&e.showPreview||e.resetUpload(),e.validateDefaultPreview()},initPreview:function(e){var i,t=this,a=t.initialCaption||"";return r.count(t.id)?(i=r.out(t.id),a=e&&t.initialCaption?t.initialCaption:i.caption,t.$preview.html(i.content),t.setCaption(a),void(W(i.content)||t.$container.removeClass("file-input-new"))):(t.clearPreview(),void(e?t.setCaption(a):t.initCaption()))},initPreviewDeletes:function(){var i=this,t=i.deleteExtraData||{},n=function(){var e=i.isUploadable?r.count(i.id):i.$element.get(0).files.length;0!==i.$preview.find(".kv-file-remove").length||e||(i.reset(),i.initialCaption="")};i.$preview.find(".kv-file-remove").each(function(){var l=e(this),o=l.data("url")||i.deleteUrl,s=l.data("key");if(!W(o)&&void 0!==s){var c,p,u,f,v=l.closest(".file-preview-frame"),g=r.data[i.id],m=v.data("fileindex");m=parseInt(m.replace("init_","")),u=W(g.config)&&W(g.config[m])?null:g.config[m],f=W(u)||W(u.extra)?t:u.extra,"function"==typeof f&&(f=f()),p={id:l.attr("id"),key:s,extra:f},c=e.extend({url:o,type:"POST",dataType:"json",data:e.extend({key:s},f),beforeSend:function(e){i.ajaxAborted=!1,i.raise("filepredelete",[s,e,f]),i.ajaxAborted?e.abort():(d(v,"file-uploading"),d(l,"disabled"))},success:function(e,t,a){var o,d;return W(e)||W(e.error)?(r.unset(i.id,m),o=r.count(i.id),d=o>0?i.getMsgSelected(o):"",i.raise("filedeleted",[s,a,f]),i.setCaption(d),v.removeClass("file-uploading").addClass("file-deleted"),void v.fadeOut("slow",function(){i.clearObjects(v),v.remove(),n(),o||0!==i.getFileStack().length||(i.setCaption(""),i.reset())})):(p.jqXHR=a,p.response=e,i.showError(e.error,p,"filedeleteerror"),v.removeClass("file-uploading"),l.removeClass("disabled"),void n())},error:function(e,t,a){var r=i.parseError(e,a);p.jqXHR=e,p.response={},i.showError(r,p,"filedeleteerror"),v.removeClass("file-uploading"),n()}},i.ajaxDeleteSettings),a(l,"click",function(){return i.validateMinCount()?void e.ajax(c):!1})}})},clearObjects:function(i){i.find("video audio").each(function(){this.pause(),e(this).remove()}),i.find("img object div").each(function(){e(this).remove()})},clearFileInput:function(){var i,t,a,r=this,n=r.$element;W(n.val())||(r.isIE9||r.isIE10?(i=n.closest("form"),t=e(document.createElement("form")),a=e(document.createElement("div")),n.before(a),i.length?i.after(t):a.after(t),t.append(n).trigger("reset"),a.before(n).remove(),t.remove()):n.val(""),r.fileInputCleared=!0)},resetUpload:function(){var e=this;e.uploadCache={content:[],config:[],tags:[],append:!0},e.uploadCount=0,e.uploadStatus={},e.uploadLog=[],e.uploadAsyncCount=0,e.loadedImages=[],e.totalImagesCount=0,e.$btnUpload.removeAttr("disabled"),e.setProgress(0),d(e.$progress,"hide"),e.resetErrors(!1),e.ajaxAborted=!1,e.ajaxRequests=[],e.resetCanvas()},resetCanvas:function(){var e=this;e.canvas&&e.imageCanvasContext&&e.imageCanvasContext.clearRect(0,0,e.canvas.width,e.canvas.height)},cancel:function(){var i,t=this,a=t.ajaxRequests,r=a.length;if(r>0)for(i=0;r>i;i+=1)t.cancelling=!0,a[i].abort();t.getThumbs().each(function(){var i=e(this),a=i.attr("data-fileindex");i.removeClass("file-uploading"),void 0!==t.filestack[a]&&(i.find(".kv-file-upload").removeClass("disabled").removeAttr("disabled"),i.find(".kv-file-remove").removeClass("disabled").removeAttr("disabled")),t.unlock()})},cleanMemory:function(e){var i=e.is("img")?e.attr("src"):e.find("source").attr("src");Q.revokeObjectURL(i)},hasInitialPreview:function(){var e=this;return!e.overwriteInitial&&r.count(e.id)},clear:function(){var i,t=this;t.$btnUpload.removeAttr("disabled"),t.getThumbs().find("video,audio,img").each(function(){t.cleanMemory(e(this))}),t.resetUpload(),t.clearStack(),t.clearFileInput(),t.resetErrors(!0),t.raise("fileclear"),t.hasInitialPreview()?(t.showFileIcon(),t.resetPreview(),t.initPreviewDeletes(),t.$container.removeClass("file-input-new")):(t.getThumbs().each(function(){t.clearObjects(e(this))}),t.isUploadable&&(r.data[t.id]={}),t.$preview.html(""),i=!t.overwriteInitial&&t.initialCaption.length>0?t.initialCaption:"",t.setCaption(i),t.$caption.attr("title",""),d(t.$container,"file-input-new"),t.validateDefaultPreview()),0===t.$container.find(".file-preview-frame").length&&(t.initCaption()||t.$captionContainer.find(".kv-caption-icon").hide()),t.hideFileIcon(),t.raise("filecleared"),t.$captionContainer.focus(),t.setFileDropZoneTitle()},resetPreview:function(){var e,i,t=this;r.count(t.id)?(e=r.out(t.id),t.$preview.html(e.content),i=t.initialCaption?t.initialCaption:e.caption,t.setCaption(i)):(t.clearPreview(),t.initCaption())},clearDefaultPreview:function(){var e=this;e.$preview.find(".file-default-preview").remove()},validateDefaultPreview:function(){var e=this;e.showPreview&&!W(e.defaultPreviewContent)&&(e.$preview.html('<div class="file-default-preview">'+e.defaultPreviewContent+"</div>"),e.$container.removeClass("file-input-new"))},resetPreviewThumbs:function(e){var i,t=this;return e?(t.clearPreview(),void t.clearStack()):void(t.hasInitialPreview()?(i=r.out(t.id),t.$preview.html(i.content),t.setCaption(i.caption),t.initPreviewDeletes()):t.clearPreview())},reset:function(){var e=this;e.resetPreview(),e.$container.find(".fileinput-filename").text(""),e.raise("filereset"),d(e.$container,"file-input-new"),(e.$preview.find(".file-preview-frame").length||e.isUploadable&&e.dropZoneEnabled)&&e.$container.removeClass("file-input-new"),e.setFileDropZoneTitle(),e.clearStack(),e.formdata={}},disable:function(){var e=this;e.isDisabled=!0,e.raise("filedisabled"),e.$element.attr("disabled","disabled"),e.$container.find(".kv-fileinput-caption").addClass("file-caption-disabled"),e.$container.find(".btn-file, .fileinput-remove, .fileinput-upload, .file-preview-frame button").attr("disabled",!0),e.initDragDrop()},enable:function(){var e=this;e.isDisabled=!1,e.raise("fileenabled"),e.$element.removeAttr("disabled"),e.$container.find(".kv-fileinput-caption").removeClass("file-caption-disabled"),e.$container.find(".btn-file, .fileinput-remove, .fileinput-upload, .file-preview-frame button").removeAttr("disabled"),e.initDragDrop()},getThumbs:function(e){return e=e||"",this.$preview.find(".file-preview-frame:not(.file-preview-initial)"+e)},getExtraData:function(e,i){var t=this,a=t.uploadExtraData;return"function"==typeof t.uploadExtraData&&(a=t.uploadExtraData(e,i)),a},uploadExtra:function(i,t){var a=this,r=a.getExtraData(i,t);0!==r.length&&e.each(r,function(e,i){a.formdata.append(e,i)})},setAsyncUploadStatus:function(i,t,a){var r=this,n=0;r.setProgress(t,e("#"+i).find(".file-thumb-progress")),r.uploadStatus[i]=t,e.each(r.uploadStatus,function(e,i){n+=i}),r.setProgress(Math.ceil(n/a))},initXhr:function(e,i,t){var a=this;return e.upload&&e.upload.addEventListener("progress",function(e){var r=0,n=e.loaded||e.position,l=e.total;e.lengthComputable&&(r=Math.ceil(n/l*100)),i?a.setAsyncUploadStatus(i,r,t):a.setProgress(Math.ceil(r))},!1),e},ajaxSubmit:function(i,t,a,r,n,l){var o,s=this;s.raise("filepreajax",[n,l]),s.uploadExtra(n,l),o=e.extend({xhr:function(){var i=e.ajaxSettings.xhr();return s.initXhr(i,n,s.getFileStack().length)},url:s.uploadUrl,type:"POST",dataType:"json",data:s.formdata,cache:!1,processData:!1,contentType:!1,beforeSend:i,success:t,complete:a,error:r},s.ajaxSettings),s.ajaxRequests.push(e.ajax(o))},initUploadSuccess:function(i,t,a){var n,l,o,s,d,c,p,u,f=this;f.showPreview&&"object"==typeof i&&!e.isEmptyObject(i)&&void 0!==i.initialPreview&&i.initialPreview.length>0&&(f.hasInitData=!0,d=i.initialPreview||[],c=i.initialPreviewConfig||[],p=i.initialPreviewThumbTags||[],n=void 0===i.append||i.append?!0:!1,f.overwriteInitial=!1,void 0!==t?a?(u=t.attr("data-fileindex"),f.uploadCache.content[u]=d[0],f.uploadCache.config[u]=c[0],f.uploadCache.tags[u]=p[0],f.uploadCache.append=n):(o=r.add(f.id,d,c[0],p[0],n),l=r.get(f.id,o,!1),s=e(l).hide(),t.after(s).fadeOut("slow",function(){s.fadeIn("slow").css("display:inline-block"),f.initPreviewDeletes(),f.clearFileInput(),t.remove()})):(r.set(f.id,d,c,p,n),f.initPreview(),f.initPreviewDeletes()))},initSuccessThumbs:function(){var i=this;i.showPreview&&i.getThumbs(".file-preview-success").each(function(){var t=e(this),r=t.find(".kv-file-remove");r.removeAttr("disabled"),a(r,"click",function(){var e=i.raise("filesuccessremove",[t.attr("id"),t.data("fileindex")]);i.cleanMemory(t),e!==!1&&t.fadeOut("slow",function(){t.remove(),i.$preview.find(".file-preview-frame").length||i.reset()})})})},checkAsyncComplete:function(){var i,t,a=this;for(t=0;t<a.filestack.length;t++)if(a.filestack[t]&&(i=a.previewInitId+"-"+t,-1===e.inArray(i,a.uploadLog)))return!1;return a.uploadAsyncCount===a.uploadLog.length},uploadSingle:function(i,t,a){var n,l,o,s,c,p,u,f,v,g,m=this,h=m.getFileStack().length,w=new FormData,b=m.previewInitId+"-"+i,C=m.filestack.length>0||!e.isEmptyObject(m.uploadExtraData),x={id:b,index:i};m.formdata=w,m.showPreview&&(l=e("#"+b+":not(.file-preview-initial)"),s=l.find(".kv-file-upload"),c=l.find(".kv-file-remove"),e("#"+b).find(".file-thumb-progress").removeClass("hide")),0===h||!C||s&&s.hasClass("disabled")||m.abort(x)||(g=function(e,i){
	m.updateStack(e,void 0),m.uploadLog.push(i),m.checkAsyncComplete()&&(m.fileBatchCompleted=!0)},o=function(){m.fileBatchCompleted&&setTimeout(function(){m.showPreview&&(r.set(m.id,m.uploadCache.content,m.uploadCache.config,m.uploadCache.tags,m.uploadCache.append),m.hasInitData&&(m.initPreview(),m.initPreviewDeletes())),m.unlock(),m.clearFileInput(),m.raise("filebatchuploadcomplete",[m.filestack,m.getExtraData()]),m.uploadCount=0,m.uploadStatus={},m.uploadLog=[],m.setProgress(100)},100)},p=function(t){n=m.getOutData(t),m.fileBatchCompleted=!1,m.showPreview&&(l.hasClass("file-preview-success")||(m.setThumbStatus(l,"Loading"),d(l,"file-uploading")),s.attr("disabled",!0),c.attr("disabled",!0)),a||m.lock(),m.raise("filepreupload",[n,b,i]),x=e.extend(x,n),m.abort(x)&&(t.abort(),m.setProgress(100))},u=function(t,r,o){n=m.getOutData(o,t),x=e.extend(x,n),setTimeout(function(){W(t)||W(t.error)?(m.showPreview&&(m.setThumbStatus(l,"Success"),s.hide(),m.initUploadSuccess(t,l,a)),m.raise("fileuploaded",[n,b,i]),a?g(i,b):m.updateStack(i,void 0)):(m.setThumbStatus(l,"Error"),m.showUploadError(t.error,x),a&&g(i,b))},100)},f=function(){setTimeout(function(){m.showPreview&&(s.removeAttr("disabled"),c.removeAttr("disabled"),l.removeClass("file-uploading")),a?o():m.unlock(!1),m.initSuccessThumbs()},100)},v=function(r,n,o){var s=m.parseError(r,o,a?t[i].name:null);setTimeout(function(){a&&g(i,b),m.uploadStatus[b]=100,m.setThumbStatus(l,"Error"),x=e.extend(x,m.getOutData(r)),m.showUploadError(s,x)},100)},w.append(m.uploadFileAttr,t[i],m.filenames[i]),w.append("file_id",i),m.ajaxSubmit(p,u,f,v,b,i))},uploadBatch:function(){var i,t,a,r,n,l=this,o=l.filestack,s=o.length,c={},p=l.filestack.length>0||!e.isEmptyObject(l.uploadExtraData);l.formdata=new FormData,0!==s&&p&&!l.abort(c)&&(i=function(){e.each(o,function(e){l.updateStack(e,void 0)}),l.clearFileInput()},t=function(i){l.lock();var t=l.getOutData(i);l.showPreview&&l.getThumbs().each(function(){var i=e(this),t=i.find(".kv-file-upload"),a=i.find(".kv-file-remove");i.hasClass("file-preview-success")||(l.setThumbStatus(i,"Loading"),d(i,"file-uploading")),t.attr("disabled",!0),a.attr("disabled",!0)}),l.raise("filebatchpreupload",[t]),l.abort(t)&&(i.abort(),l.setProgress(100))},a=function(t,a,r){var n=l.getOutData(r,t),o=l.getThumbs(),s=0,d=W(t)||W(t.errorkeys)?[]:t.errorkeys;W(t)||W(t.error)?(l.raise("filebatchuploadsuccess",[n]),i(),l.showPreview?(o.each(function(){var i=e(this),t=i.find(".kv-file-upload");i.find(".kv-file-upload").hide(),l.setThumbStatus(i,"Success"),i.removeClass("file-uploading"),t.removeAttr("disabled")}),l.initUploadSuccess(t)):l.reset()):(l.showPreview&&(o.each(function(){var i=e(this),t=i.find(".kv-file-remove"),a=i.find(".kv-file-upload");return i.removeClass("file-uploading"),a.removeAttr("disabled"),t.removeAttr("disabled"),0===d.length?void l.setThumbStatus(i,"Error"):(-1!==e.inArray(s,d)?l.setThumbStatus(i,"Error"):(i.find(".kv-file-upload").hide(),l.setThumbStatus(i,"Success"),l.updateStack(s,void 0)),void s++)}),l.initUploadSuccess(t)),l.showUploadError(t.error,n,"filebatchuploaderror"))},r=function(){l.setProgress(100),l.unlock(),l.initSuccessThumbs(),l.clearFileInput(),l.raise("filebatchuploadcomplete",[l.filestack,l.getExtraData()])},n=function(i,t,a){var r=l.getOutData(i),n=l.parseError(i,a);l.showUploadError(n,r,"filebatchuploaderror"),l.uploadFileCount=s-1,l.showPreview&&(l.getThumbs().each(function(){var i=e(this),t=i.attr("data-fileindex");i.removeClass("file-uploading"),void 0!==l.filestack[t]&&l.setThumbStatus(i,"Error")}),l.getThumbs().removeClass("file-uploading"),l.getThumbs(" .kv-file-upload").removeAttr("disabled"),l.getThumbs(" .kv-file-delete").removeAttr("disabled"))},e.each(o,function(e,i){W(o[e])||l.formdata.append(l.uploadFileAttr,i,l.filenames[e])}),l.ajaxSubmit(t,a,r,n))},uploadExtraOnly:function(){var e,i,t,a,r=this,n={};r.formdata=new FormData,r.abort(n)||(e=function(e){r.lock();var i=r.getOutData(e);r.raise("filebatchpreupload",[i]),r.setProgress(50),n.data=i,n.xhr=e,r.abort(n)&&(e.abort(),r.setProgress(100))},i=function(e,i,t){var a=r.getOutData(t,e);W(e)||W(e.error)?(r.raise("filebatchuploadsuccess",[a]),r.clearFileInput(),r.initUploadSuccess(e)):r.showUploadError(e.error,a,"filebatchuploaderror")},t=function(){r.setProgress(100),r.unlock(),r.clearFileInput(),r.raise("filebatchuploadcomplete",[r.filestack,r.getExtraData()])},a=function(e,i,t){var a=r.getOutData(e),l=r.parseError(e,t);n.data=a,r.showUploadError(l,a,"filebatchuploaderror")},r.ajaxSubmit(e,i,t,a))},upload:function(){var i,t,a,r=this,n=r.getFileStack().length,l={},o=!e.isEmptyObject(r.getExtraData());if(r.minFileCount>0&&r.getFileCount(n)<r.minFileCount)return void r.noFilesError(l);if(r.isUploadable&&!r.isDisabled&&(0!==n||o)){if(r.resetUpload(),r.$progress.removeClass("hide"),r.uploadCount=0,r.uploadStatus={},r.uploadLog=[],r.lock(),r.setProgress(2),0===n&&o)return void r.uploadExtraOnly();if(a=r.filestack.length,r.hasInitData=!1,r.uploadAsync){for(t=r.getOutData(),r.raise("filebatchpreupload",[t]),r.fileBatchCompleted=!1,r.uploadCache={content:[],config:[],tags:[],append:!0},r.uploadAsyncCount=r.getFileStack().length,i=0;a>i;i++)r.uploadCache.content[i]=null,r.uploadCache.config[i]=null,r.uploadCache.tags[i]=null;for(i=0;a>i;i++)void 0!==r.filestack[i]&&r.uploadSingle(i,r.filestack,!0)}else r.uploadBatch()}},initFileActions:function(){var i=this;i.showPreview&&(i.$preview.find(".kv-file-remove").each(function(){var t,n,l,o,s=e(this),d=s.closest(".file-preview-frame"),c=d.attr("id"),p=d.attr("data-fileindex");a(s,"click",function(){return o=i.raise("filepreremove",[c,p]),o!==!1&&i.validateMinCount()?(t=d.hasClass("file-preview-error"),i.cleanMemory(d),void d.fadeOut("slow",function(){i.updateStack(p,void 0),i.clearObjects(d),d.remove(),c&&t&&i.$errorContainer.find('li[data-file-id="'+c+'"]').fadeOut("fast",function(){e(this).remove(),i.errorsExist()||i.resetErrors()});var a=i.getFileStack(!0),o=a.length,s=r.count(i.id),u=i.showPreview&&i.$preview.find(".file-preview-frame").length;i.clearFileInput(),0!==o||0!==s||u?(n=s+o,l=n>1?i.getMsgSelected(n):a[0]?i.getFileNames()[0]:"",i.setCaption(l)):i.reset(),i.raise("fileremoved",[c,p])})):!1})}),i.$preview.find(".kv-file-upload").each(function(){var t=e(this);a(t,"click",function(){var e=t.closest(".file-preview-frame"),a=e.attr("data-fileindex");e.hasClass("file-preview-error")||i.uploadSingle(a,i.filestack,!1)})}))},hideFileIcon:function(){this.overwriteInitial&&this.$captionContainer.find(".kv-caption-icon").hide()},showFileIcon:function(){this.$captionContainer.find(".kv-caption-icon").show()},addError:function(e){var i=this,t=i.$errorContainer;e&&t.length&&(t.html(i.errorCloseButton+e),t.find(".kv-error-close").off("click").on("click",function(){t.fadeOut("slow")}))},resetErrors:function(e){var i=this,t=i.$errorContainer;i.isError=!1,i.$container.removeClass("has-error"),t.html(""),e?t.fadeOut("slow"):t.hide()},showFolderError:function(e){var i=this,t=i.$errorContainer;e&&(i.addError(i.msgFoldersNotAllowed.replace(/\{n}/g,e)),t.fadeIn(800),d(i.$container,"has-error"),i.raise("filefoldererror",[e]))},showUploadError:function(e,i,t){var a=this,r=a.$errorContainer,n=t||"fileuploaderror",l=i&&i.id?'<li data-file-id="'+i.id+'">'+e+"</li>":"<li>"+e+"</li>";return 0===r.find("ul").length?a.addError("<ul>"+l+"</ul>"):r.find("ul").append(l),r.fadeIn(800),a.raise(n,[i]),a.$container.removeClass("file-input-new"),d(a.$container,"has-error"),!0},showError:function(e,i,t){var a=this,r=a.$errorContainer,n=t||"fileerror";return i=i||{},i.reader=a.reader,a.addError(e),r.fadeIn(800),a.raise(n,[i]),a.isUploadable||a.clearFileInput(),a.$container.removeClass("file-input-new"),d(a.$container,"has-error"),a.$btnUpload.attr("disabled",!0),!0},errorHandler:function(e,i){var t=this,a=e.target.error;t.showError(a.code===a.NOT_FOUND_ERR?t.msgFileNotFound.replace("{name}",i):a.code===a.SECURITY_ERR?t.msgFileSecured.replace("{name}",i):a.code===a.NOT_READABLE_ERR?t.msgFileNotReadable.replace("{name}",i):a.code===a.ABORT_ERR?t.msgFilePreviewAborted.replace("{name}",i):t.msgFilePreviewError.replace("{name}",i))},parseFileType:function(e){var i,t,a,r,n=this;for(r=0;r<N.length;r+=1)if(a=N[r],i=_(a,n.fileTypeSettings)?n.fileTypeSettings[a]:H[a],t=i(e.type,e.name)?a:"",!W(t))return t;return"other"},previewDefault:function(i,t,a){if(this.showPreview){var r=this,n="",l=i?i.name:"",o=Q.createObjectURL(i),s=t.slice(t.lastIndexOf("-")+1),d=r.previewSettings.other||Z.other,c=r.renderFileFooter(i.name,d.width),p=r.parseFilePreviewIcon(r.getPreviewTemplate("other"),l);a===!0&&(r.isUploadable||(c+='<div class="file-other-error" title="'+r.fileActionSettings.indicatorErrorTitle+'">'+r.fileActionSettings.indicatorError+"</div>")),r.clearDefaultPreview(),r.$preview.append("\n"+p.replace(/\{previewId}/g,t).replace(/\{frameClass}/g,n).replace(/\{fileindex}/g,s).replace(/\{caption}/g,r.slug(i.name)).replace(/\{width}/g,d.width).replace(/\{height}/g,d.height).replace(/\{type}/g,i.type).replace(/\{data}/g,o).replace(/\{footer}/g,c)),a===!0&&r.isUploadable&&r.setThumbStatus(e("#"+t),"Error")}},previewFile:function(e,i,t,a,r){if(this.showPreview){var n,l,o,s=this,d=s.parseFileType(i),c=i?i.name:"",p=s.slug(c),u=s.allowedPreviewTypes,f=s.allowedPreviewMimeTypes,v=s.getPreviewTemplate(d),g=u&&u.indexOf(d)>=0,m=_(d,s.previewSettings)?s.previewSettings[d]:Z[d],h=f&&-1!==f.indexOf(i.type),w=s.renderFileFooter(p,m.width),b="",C=a.slice(a.lastIndexOf("-")+1);g||h?(v=s.parseFilePreviewIcon(v,c.split(".").pop()),"text"===d?(l=X(t.target.result),o="text-"+K(),n=v.replace(/\{zoom}/g,s.getLayoutTemplate("zoom")),b=s.getLayoutTemplate("modal").replace("{id}",o).replace(/\{title}/g,p).replace(/\{body}/g,l).replace(/\{heading}/g,s.msgZoomModalHeading),n=n.replace(/\{previewId}/g,a).replace(/\{caption}/g,p).replace(/\{width}/g,m.width).replace(/\{height}/g,m.height).replace(/\{frameClass}/g,"").replace(/\{zoomInd}/g,s.zoomIndicator).replace(/\{footer}/g,w).replace(/\{fileindex}/g,C).replace(/\{type}/g,i.type).replace(/\{zoomTitle}/g,s.msgZoomTitle).replace(/\{dialog}/g,"$('#"+o+"').modal('show')").replace(/\{data}/g,l)+b):n=v.replace(/\{previewId}/g,a).replace(/\{caption}/g,p).replace(/\{frameClass}/g,"").replace(/\{type}/g,i.type).replace(/\{fileindex}/g,C).replace(/\{width}/g,m.width).replace(/\{height}/g,m.height).replace(/\{footer}/g,w).replace(/\{data}/g,r),s.clearDefaultPreview(),s.$preview.append("\n"+n),s.validateImage(e,a,p,i.type)):s.previewDefault(i,a)}},slugDefault:function(e){return W(e)?"":e.split(/(\\|\/)/g).pop().replace(/[^\w\u00C0-\u017F\-.\\\/ ]+/g,"")},readFiles:function(i){this.reader=new FileReader;var t,a=this,r=a.$element,n=a.$preview,l=a.reader,o=a.$previewContainer,s=a.$previewStatus,d=a.msgLoading,c=a.msgProgress,p=a.previewInitId,u=i.length,f=a.fileTypeSettings,v=a.filestack.length,g=function(r,n,l,o){var s=e.extend(a.getOutData({},{},i),{id:l,index:o}),d={id:l,index:o,file:n,files:i};return a.previewDefault(n,l,!0),a.isUploadable&&a.pushStack(void 0),setTimeout(t(o+1),100),a.initFileActions(),a.isUploadable?a.showUploadError(r,s):a.showError(r,d)};a.loadedImages=[],a.totalImagesCount=0,e.each(i,function(e,i){var t="image",r=_(t,a.fileTypeSettings)?a.fileTypeSettings[t]:H[t];r&&r(i.type)&&a.totalImagesCount++}),t=function(e){if(W(r.attr("multiple"))&&(u=1),e>=u)return a.isUploadable&&a.filestack.length>0?a.raise("filebatchselected",[a.getFileStack()]):a.raise("filebatchselected",[i]),o.removeClass("file-thumb-loading"),void s.html("");var m,h,w,b,C,x,y=v+e,T=p+"-"+y,F=i[e],I=a.slug(F.name),E=(F.size||0)/1e3,k="",S=Q.createObjectURL(F),$=0,P=a.allowedFileTypes,D=W(P)?"":P.join(", "),U=a.allowedFileExtensions,A=W(U)?"":U.join(", ");if(W(U)||(k=new RegExp("\\.("+U.join("|")+")$","i")),E=E.toFixed(2),a.maxFileSize>0&&E>a.maxFileSize)return b=a.msgSizeTooLarge.replace("{name}",I).replace("{size}",E).replace("{maxSize}",a.maxFileSize),void(a.isError=g(b,F,T,e));if(!W(P)&&q(P)){for(w=0;w<P.length;w+=1)C=P[w],h=f[C],x=void 0!==h&&h(F.type,I),$+=W(x)?0:x.length;if(0===$)return b=a.msgInvalidFileType.replace("{name}",I).replace("{types}",D),void(a.isError=g(b,F,T,e))}return 0!==$||W(U)||!q(U)||W(k)||(x=I.match(k),$+=W(x)?0:x.length,0!==$)?a.showPreview?(n.length>0&&void 0!==FileReader?(s.html(d.replace("{index}",e+1).replace("{files}",u)),o.addClass("file-thumb-loading"),l.onerror=function(e){a.errorHandler(e,I)},l.onload=function(i){a.previewFile(e,F,i,T,S),a.initFileActions()},l.onloadend=function(){b=c.replace("{index}",e+1).replace("{files}",u).replace("{percent}",50).replace("{name}",I),setTimeout(function(){s.html(b),a.updateFileDetails(u),t(e+1)},100),a.raise("fileloaded",[F,T,e,l])},l.onprogress=function(i){if(i.lengthComputable){var t=i.loaded/i.total*100,a=Math.ceil(t);b=c.replace("{index}",e+1).replace("{files}",u).replace("{percent}",a).replace("{name}",I),setTimeout(function(){s.html(b)},100)}},m=_("text",f)?f.text:H.text,m(F.type,I)?l.readAsText(F,a.textEncoding):l.readAsArrayBuffer(F)):(a.previewDefault(F,T),setTimeout(function(){t(e+1),a.updateFileDetails(u)},100),a.raise("fileloaded",[F,T,e,l])),void a.pushStack(F)):(a.pushStack(F),setTimeout(t(e+1),100),void a.raise("fileloaded",[F,T,e,l])):(b=a.msgInvalidFileExtension.replace("{name}",I).replace("{extensions}",A),void(a.isError=g(b,F,T,e)))},t(0),a.updateFileDetails(u,!1)},updateFileDetails:function(e){var i=this,t=i.$element,a=i.getFileStack(),n=t.val()||a.length&&a[0].name||"",l=i.slug(n),o=i.isUploadable?a.length:e,s=r.count(i.id)+o,d=o>1?i.getMsgSelected(s):l;i.isError?(i.$previewContainer.removeClass("file-thumb-loading"),i.$previewStatus.html(""),i.$captionContainer.find(".kv-caption-icon").hide()):i.showFileIcon(),i.setCaption(d,i.isError),i.$container.removeClass("file-input-new file-input-ajax-new"),1===arguments.length&&i.raise("fileselect",[e,l]),r.count(i.id)&&i.initPreviewDeletes()},validateMinCount:function(){var e=this,i=e.isUploadable?e.getFileStack().length:e.$element.get(0).files.length;return e.validateInitialCount&&e.minFileCount>0&&e.getFileCount(i-1)<e.minFileCount?(e.noFilesError({}),!1):!0},getFileCount:function(e){var i=this,t=0;return i.validateInitialCount&&!i.overwriteInitial&&(t=r.count(i.id),e+=t),e},change:function(i){var t=this,a=t.$element;if(!t.isUploadable&&W(a.val())&&t.fileInputCleared)return void(t.fileInputCleared=!1);t.fileInputCleared=!1;var n,l,o,s,d,c,p=arguments.length>1,u=p?i.originalEvent.dataTransfer.files:a.get(0).files,f=W(a.attr("multiple")),v=0,g=0,m=t.filestack.length,h=t.isUploadable,w=f&&m>0,b=function(i,a,r,n){var l=e.extend(t.getOutData({},{},u),{id:r,index:n}),o={id:r,index:n,file:a,files:u};return t.isUploadable?t.showUploadError(i,l):t.showError(i,o)};if(t.reader=null,t.resetUpload(),t.hideFileIcon(),t.isUploadable&&t.$container.find(".file-drop-zone ."+t.dropZoneTitleClass).remove(),p)for(n=[];u[v];)s=u[v],s.type||s.size%4096!==0?n.push(s):g++,v++;else n=void 0===i.target.files?i.target&&i.target.value?[{name:i.target.value.replace(/^.+\\/,"")}]:[]:i.target.files;if(W(n)||0===n.length)return h||t.clear(),t.showFolderError(g),void t.raise("fileselectnone");if(t.resetErrors(),c=n.length,o=t.isUploadable?t.getFileStack().length+c:c,o=t.getFileCount(o),t.maxFileCount>0&&o>t.maxFileCount){if(!t.autoReplace||c>t.maxFileCount)return d=t.autoReplace&&c>t.maxFileCount?c:o,l=t.msgFilesTooMany.replace("{m}",t.maxFileCount).replace("{n}",d),t.isError=b(l,null,null,null),t.$captionContainer.find(".kv-caption-icon").hide(),t.setCaption("",!0),void t.$container.removeClass("file-input-new file-input-ajax-new");o>t.maxFileCount&&t.resetPreviewThumbs(h)}else!h||w?(t.resetPreviewThumbs(!1),w&&t.clearStack()):!h||0!==m||r.count(t.id)&&!t.overwriteInitial||t.resetPreviewThumbs(!0);t.isPreviewable?t.readFiles(n):t.updateFileDetails(1),t.showFolderError(g)},getFileName:function(e){return e&&e.name?this.slug(e.name):void 0},getFileNames:function(e){var i=this;return i.filenames.filter(function(i){return e?void 0!==i:void 0!==i&&null!==i})},getFileStack:function(e){var i=this;return i.filestack.filter(function(i){return e?void 0!==i:void 0!==i&&null!==i})},clearStack:function(){var e=this;e.filestack=[],e.filenames=[]},updateStack:function(e,i){var t=this;t.filestack[e]=i,t.filenames[e]=t.getFileName(i)},pushStack:function(e){var i=this;i.filestack.push(e),i.filenames.push(i.getFileName(e))},checkDimensions:function(e,i,t,a,r,n,l){var o,s,d,c,p=this,u="Small"===i?"min":"max",f=p[u+"Image"+n];!W(f)&&t.length&&(d=t[0],s="Width"===n?d.naturalWidth||d.width:d.naturalHeight||d.height,c="Small"===i?s>=f:f>=s,c||(o=p["msgImage"+n+i].replace("{name}",r).replace("{size}",f),p.showUploadError(o,l),p.setThumbStatus(a,"Error"),p.updateStack(e,null)))},validateImage:function(e,i,t,r){var n,l,o,s=this,d=s.$preview,c=d.find("#"+i),p=c.find("img");t=t||"Untitled",p.length&&a(p,"load",function(){l=c.width(),o=d.width(),l>o&&(p.css("width","100%"),c.css("width","97%")),n={ind:e,id:i},s.checkDimensions(e,"Small",p,c,t,"Width",n),s.checkDimensions(e,"Small",p,c,t,"Height",n),s.resizeImage||(s.checkDimensions(e,"Large",p,c,t,"Width",n),s.checkDimensions(e,"Large",p,c,t,"Height",n)),s.raise("fileimageloaded",[i]),s.loadedImages.push({ind:e,img:p,thumb:c,pid:i,typ:r}),s.validateAllImages(),Q.revokeObjectURL(p.attr("src"))})},validateAllImages:function(){var e,i,t,a,r,n,l,o=this,s={};if(o.loadedImages.length===o.totalImagesCount&&(o.raise("fileimagesloaded"),o.resizeImage)){for(l=o.isUploadable?o.showUploadError:o.showError,e=0;e<o.loadedImages.length;e++)i=o.loadedImages[e],t=i.img,a=i.thumb,r=i.pid,n=i.ind,s={id:r,index:n},o.getResizedImage(t[0],i.typ,r,n)||(l(o.msgImageResizeError,s,"fileimageresizeerror"),o.setThumbStatus(a,"Error"),o.updateStack(n,void 0));o.raise("fileimagesresized")}},getResizedImage:function(e,i,t,a){var r,n,l=this,o=e.naturalWidth,s=e.naturalHeight,d=1,c=l.maxImageWidth||o,p=l.maxImageHeight||s,u=o&&s,f=l.imageCanvas,v=l.imageCanvasContext;if(!u)return!1;if(o===c&&s===p)return!0;i=i||l.resizeDefaultImageType,r=o>c,n=s>p,d="width"===l.resizePreference?r?c/o:n?p/s:1:n?p/s:r?c/o:1,l.resetCanvas(),o*=d,s*=d,f.width=o,f.height=s;try{return v.drawImage(e,0,0,o,s),f.toBlob(function(e){l.raise("fileimageresized",[t,a]),l.filestack[a]=e},i,l.resizeQuality),!0}catch(g){return!1}},initCaption:function(){var e=this,i=e.initialCaption||"";return e.overwriteInitial||W(i)?(e.$caption.html(""),!1):(e.setCaption(i),!0)},setCaption:function(i,t){var a,r,n=this;if(t)a=e("<div>"+n.msgValidationError+"</div>").text(),r='<span class="'+n.msgValidationErrorClass+'">'+n.msgValidationErrorIcon+a+"</span>";else{if(W(i)||0===n.$caption.length)return;a=e("<div>"+i+"</div>").text(),r=n.getLayoutTemplate("icon")+a}n.$caption.html(r),n.$caption.attr("title",a),n.$captionContainer.find(".file-caption-ellipsis").attr("title",a)},initBrowse:function(e){var i=this;i.$btnFile=e.find(".btn-file"),i.$btnFile.append(i.$element)},createContainer:function(){var i=this,t=e(document.createElement("div")).attr({"class":"file-input file-input-new"}).html(i.renderMain());return i.$element.before(t),i.initBrowse(t),t},refreshContainer:function(){var e=this,i=e.$container;i.before(e.$element),i.html(e.renderMain()),e.initBrowse(i)},renderMain:function(){var e=this,i=e.isUploadable&&e.dropZoneEnabled?" file-drop-zone":"file-drop-disabled",t=e.showClose?e.getLayoutTemplate("close"):"",a=e.showPreview?e.getLayoutTemplate("preview").replace(/\{class}/g,e.previewClass).replace(/\{dropClass}/g,i):"",r=e.isDisabled?e.captionClass+" file-caption-disabled":e.captionClass,n=e.captionTemplate.replace(/\{class}/g,r+" kv-fileinput-caption");return e.mainTemplate.replace(/\{class}/g,e.mainClass).replace(/\{preview}/g,a).replace(/\{close}/g,t).replace(/\{caption}/g,n).replace(/\{upload}/g,e.renderButton("upload")).replace(/\{remove}/g,e.renderButton("remove")).replace(/\{cancel}/g,e.renderButton("cancel")).replace(/\{browse}/g,e.renderButton("browse"))},renderButton:function(e){var i=this,t=i.getLayoutTemplate("btnDefault"),a=i[e+"Class"],r=i[e+"Title"],n=i[e+"Icon"],l=i[e+"Label"],o=i.isDisabled?" disabled":"",s="button";switch(e){case"remove":if(!i.showRemove)return"";break;case"cancel":if(!i.showCancel)return"";a+=" hide";break;case"upload":if(!i.showUpload)return"";i.isUploadable&&!i.isDisabled?t=i.getLayoutTemplate("btnLink").replace("{href}",i.uploadUrl):s="submit";break;case"browse":t=i.getLayoutTemplate("btnBrowse");break;default:return""}return a+="browse"===e?" btn-file":" fileinput-"+e+" fileinput-"+e+"-button",W(l)||(l=' <span class="'+i.buttonLabelClass+'">'+l+"</span>"),t.replace("{type}",s).replace("{css}",a).replace("{title}",r).replace("{status}",o).replace("{icon}",n).replace("{label}",l)}},e.fn.fileinput=function(t){if(l()||i(9)){var a=Array.apply(null,arguments),r=[];switch(a.shift(),this.each(function(){var i,n=e(this),l=n.data("fileinput"),o="object"==typeof t&&t,s=o.language||n.data("language")||"en";l||(i=e.extend({},e.fn.fileinput.defaults),"en"===s||W(e.fn.fileinputLocales[s])||(i=e.extend(i,e.fn.fileinputLocales[s])),l=new Y(this,e.extend(i,o,n.data())),n.data("fileinput",l)),"string"==typeof t&&r.push(l[t].apply(l,a))}),r.length){case 0:return this;case 1:return r[0];default:return r}}},e.fn.fileinput.defaults={language:"en",showCaption:!0,showPreview:!0,showRemove:!0,showUpload:!0,showCancel:!0,showClose:!0,showUploadedThumbs:!0,autoReplace:!1,mainClass:"",previewClass:"",captionClass:"",mainTemplate:null,initialCaption:"",initialPreview:[],initialPreviewDelimiter:"*$$*",initialPreviewConfig:[],initialPreviewThumbTags:[],previewThumbTags:{},initialPreviewShowDelete:!0,deleteUrl:"",deleteExtraData:{},overwriteInitial:!0,layoutTemplates:M,previewTemplates:B,allowedPreviewTypes:N,allowedPreviewMimeTypes:null,allowedFileTypes:null,allowedFileExtensions:null,defaultPreviewContent:null,customLayoutTags:{},customPreviewTags:{},previewSettings:Z,fileTypeSettings:H,previewFileIcon:'<i class="glyphicon glyphicon-file"></i>',previewFileIconClass:"file-icon-4x",previewFileIconSettings:{},previewFileExtSettings:{},buttonLabelClass:"hidden-xs",browseIcon:'<i class="glyphicon glyphicon-folder-open"></i>',browseClass:"btn btn-primary",removeIcon:'<i class="glyphicon glyphicon-trash"></i>',removeClass:"btn btn-default",cancelIcon:'<i class="glyphicon glyphicon-ban-circle"></i>',cancelClass:"btn btn-default",uploadIcon:'<i class="glyphicon glyphicon-upload"></i>',uploadClass:"btn btn-default",uploadUrl:null,uploadAsync:!0,uploadExtraData:{},minImageWidth:null,minImageHeight:null,maxImageWidth:null,maxImageHeight:null,resizeImage:!1,resizePreference:"width",resizeQuality:.92,resizeDefaultImageType:"image/jpeg",maxFileSize:0,minFileCount:0,maxFileCount:0,validateInitialCount:!1,msgValidationErrorClass:"text-danger",msgValidationErrorIcon:'<i class="glyphicon glyphicon-exclamation-sign"></i> ',msgErrorClass:"file-error-message",progressThumbClass:"progress-bar progress-bar-success progress-bar-striped active",progressClass:"progress-bar progress-bar-success progress-bar-striped active",progressCompleteClass:"progress-bar progress-bar-success",previewFileType:"image",zoomIndicator:'<i class="glyphicon glyphicon-zoom-in"></i>',elCaptionContainer:null,elCaptionText:null,elPreviewContainer:null,elPreviewImage:null,elPreviewStatus:null,elErrorContainer:null,errorCloseButton:'<span class="close kv-error-close">&times;</span>',slugCallback:null,dropZoneEnabled:!0,dropZoneTitleClass:"file-drop-zone-title",fileActionSettings:{},otherActionButtons:"",textEncoding:"UTF-8",ajaxSettings:{},ajaxDeleteSettings:{},showAjaxErrorDetails:!0},e.fn.fileinputLocales.en={fileSingle:"file",filePlural:"files",browseLabel:"Browse &hellip;",removeLabel:"Remove",removeTitle:"Clear selected files",cancelLabel:"Cancel",cancelTitle:"Abort ongoing upload",uploadLabel:"Upload",uploadTitle:"Upload selected files",msgZoomTitle:"View details",msgZoomModalHeading:"Detailed Preview",msgSizeTooLarge:'File "{name}" (<b>{size} KB</b>) exceeds maximum allowed upload size of <b>{maxSize} KB</b>.',msgFilesTooLess:"You must select at least <b>{n}</b> {files} to upload.",msgFilesTooMany:"Number of files selected for upload <b>({n})</b> exceeds maximum allowed limit of <b>{m}</b>.",msgFileNotFound:'File "{name}" not found!',msgFileSecured:'Security restrictions prevent reading the file "{name}".',msgFileNotReadable:'File "{name}" is not readable.',msgFilePreviewAborted:'File preview aborted for "{name}".',msgFilePreviewError:'An error occurred while reading the file "{name}".',msgInvalidFileType:'Invalid type for file "{name}". Only "{types}" files are supported.',msgInvalidFileExtension:'Invalid extension for file "{name}". Only "{extensions}" files are supported.',msgUploadAborted:"The file upload was aborted",msgValidationError:"File Upload Error",msgLoading:"Loading file {index} of {files} &hellip;",msgProgress:"Loading file {index} of {files} - {name} - {percent}% completed.",msgSelected:"{n} {files} selected",msgFoldersNotAllowed:"Drag & drop files only! {n} folder(s) dropped were skipped.",msgImageWidthSmall:'Width of image file "{name}" must be at least {size} px.',msgImageHeightSmall:'Height of image file "{name}" must be at least {size} px.',msgImageWidthLarge:'Width of image file "{name}" cannot exceed {size} px.',msgImageHeightLarge:'Height of image file "{name}" cannot exceed {size} px.',msgImageResizeError:"Could not get the image dimensions to resize.",msgImageResizeException:"Error while resizing the image.<pre>{errors}</pre>",dropZoneTitle:"Drag & drop files here &hellip;"},e.extend(e.fn.fileinput.defaults,e.fn.fileinputLocales.en),e.fn.fileinput.Constructor=Y,e(document).ready(function(){var i=e("input.file[type=file]");i.length&&i.fileinput()})});

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */,
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* @license
	* MarionetteJS (Backbone.Marionette)
	* ----------------------------------
	* v3.5.1
	*
	* Copyright (c)2017 Derick Bailey, Muted Solutions, LLC.
	* Distributed under MIT license
	*
	* http://marionettejs.com
	*/
	
	
	(function (global, factory) {
		 true ? module.exports = factory(__webpack_require__(181), __webpack_require__(182), __webpack_require__(183)) :
		typeof define === 'function' && define.amd ? define(['backbone', 'underscore', 'backbone.radio'], factory) :
		(global.Marionette = factory(global.Backbone,global._,global.Backbone.Radio));
	}(this, (function (Backbone,_,Radio) { 'use strict';
	
	Backbone = Backbone && Backbone.hasOwnProperty('default') ? Backbone['default'] : Backbone;
	_ = _ && _.hasOwnProperty('default') ? _['default'] : _;
	Radio = Radio && Radio.hasOwnProperty('default') ? Radio['default'] : Radio;
	
	var version = "3.5.1";
	
	//Internal utility for creating context style global utils
	var proxy = function proxy(method) {
	  return function (context) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return method.apply(context, args);
	  };
	};
	
	// Marionette.extend
	// -----------------
	
	// Borrow the Backbone `extend` method so we can use it as needed
	var extend = Backbone.Model.extend;
	
	/* global console */
	
	var deprecate = function deprecate(message, test) {
	  if (_.isObject(message)) {
	    message = message.prev + ' is going to be removed in the future. ' + 'Please use ' + message.next + ' instead.' + (message.url ? ' See: ' + message.url : '');
	  }
	
	  if (!Marionette.DEV_MODE) {
	    return;
	  }
	
	  if ((test === undefined || !test) && !deprecate._cache[message]) {
	    deprecate._warn('Deprecation warning: ' + message);
	    deprecate._cache[message] = true;
	  }
	};
	
	/* istanbul ignore next: can't clear console */
	deprecate._console = typeof console !== 'undefined' ? console : {};
	deprecate._warn = function () {
	  var warn = deprecate._console.warn || deprecate._console.log || _.noop;
	  return warn.apply(deprecate._console, arguments);
	};
	deprecate._cache = {};
	
	// Marionette.isNodeAttached
	// -------------------------
	
	// Determine if `el` is a child of the document
	var isNodeAttached = function isNodeAttached(el) {
	  return document.documentElement.contains(el && el.parentNode);
	};
	
	// Merge `keys` from `options` onto `this`
	var mergeOptions = function mergeOptions(options, keys) {
	  var _this = this;
	
	  if (!options) {
	    return;
	  }
	
	  _.each(keys, function (key) {
	    var option = options[key];
	    if (option !== undefined) {
	      _this[key] = option;
	    }
	  });
	};
	
	// Marionette.getOption
	// --------------------
	
	// Retrieve an object, function or other value from the
	// object or its `options`, with `options` taking precedence.
	var getOption = function getOption(optionName) {
	  if (!optionName) {
	    return;
	  }
	  if (this.options && this.options[optionName] !== undefined) {
	    return this.options[optionName];
	  } else {
	    return this[optionName];
	  }
	};
	
	// Marionette.normalizeMethods
	// ----------------------
	
	// Pass in a mapping of events => functions or function names
	// and return a mapping of events => functions
	var normalizeMethods = function normalizeMethods(hash) {
	  var _this = this;
	
	  return _.reduce(hash, function (normalizedHash, method, name) {
	    if (!_.isFunction(method)) {
	      method = _this[method];
	    }
	    if (method) {
	      normalizedHash[name] = method;
	    }
	    return normalizedHash;
	  }, {});
	};
	
	// Trigger Method
	// --------------
	
	// split the event name on the ":"
	var splitter = /(^|:)(\w)/gi;
	
	// take the event section ("section1:section2:section3")
	// and turn it in to uppercase name onSection1Section2Section3
	function getEventName(match, prefix, eventName) {
	  return eventName.toUpperCase();
	}
	
	var getOnMethodName = _.memoize(function (event) {
	  return 'on' + event.replace(splitter, getEventName);
	});
	
	// Trigger an event and/or a corresponding method name. Examples:
	//
	// `this.triggerMethod("foo")` will trigger the "foo" event and
	// call the "onFoo" method.
	//
	// `this.triggerMethod("foo:bar")` will trigger the "foo:bar" event and
	// call the "onFooBar" method.
	function triggerMethod(event) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  // get the method name from the event name
	  var methodName = getOnMethodName(event);
	  var method = getOption.call(this, methodName);
	  var result = void 0;
	
	  // call the onMethodName if it exists
	  if (_.isFunction(method)) {
	    // pass all args, except the event name
	    result = method.apply(this, args);
	  }
	
	  // trigger the event
	  this.trigger.apply(this, arguments);
	
	  return result;
	}
	
	// triggerMethodOn invokes triggerMethod on a specific context
	//
	// e.g. `Marionette.triggerMethodOn(view, 'show')`
	// will trigger a "show" event or invoke onShow the view.
	function triggerMethodOn(context) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  if (_.isFunction(context.triggerMethod)) {
	    return context.triggerMethod.apply(context, args);
	  }
	
	  return triggerMethod.apply(context, args);
	}
	
	// DOM Refresh
	// -----------
	
	// Trigger method on children unless a pure Backbone.View
	function triggerMethodChildren(view, event, shouldTrigger) {
	  if (!view._getImmediateChildren) {
	    return;
	  }
	  _.each(view._getImmediateChildren(), function (child) {
	    if (!shouldTrigger(child)) {
	      return;
	    }
	    triggerMethodOn(child, event, child);
	  });
	}
	
	function shouldTriggerAttach(view) {
	  return !view._isAttached;
	}
	
	function shouldAttach(view) {
	  if (!shouldTriggerAttach(view)) {
	    return false;
	  }
	  view._isAttached = true;
	  return true;
	}
	
	function shouldTriggerDetach(view) {
	  return view._isAttached;
	}
	
	function shouldDetach(view) {
	  if (!shouldTriggerDetach(view)) {
	    return false;
	  }
	  view._isAttached = false;
	  return true;
	}
	
	function triggerDOMRefresh(view) {
	  if (view._isAttached && view._isRendered) {
	    triggerMethodOn(view, 'dom:refresh', view);
	  }
	}
	
	function triggerDOMRemove(view) {
	  if (view._isAttached && view._isRendered) {
	    triggerMethodOn(view, 'dom:remove', view);
	  }
	}
	
	function handleBeforeAttach() {
	  triggerMethodChildren(this, 'before:attach', shouldTriggerAttach);
	}
	
	function handleAttach() {
	  triggerMethodChildren(this, 'attach', shouldAttach);
	  triggerDOMRefresh(this);
	}
	
	function handleBeforeDetach() {
	  triggerMethodChildren(this, 'before:detach', shouldTriggerDetach);
	  triggerDOMRemove(this);
	}
	
	function handleDetach() {
	  triggerMethodChildren(this, 'detach', shouldDetach);
	}
	
	function handleBeforeRender() {
	  triggerDOMRemove(this);
	}
	
	function handleRender() {
	  triggerDOMRefresh(this);
	}
	
	// Monitor a view's state, propagating attach/detach events to children and firing dom:refresh
	// whenever a rendered view is attached or an attached view is rendered.
	function monitorViewEvents(view) {
	  if (view._areViewEventsMonitored || view.monitorViewEvents === false) {
	    return;
	  }
	
	  view._areViewEventsMonitored = true;
	
	  view.on({
	    'before:attach': handleBeforeAttach,
	    'attach': handleAttach,
	    'before:detach': handleBeforeDetach,
	    'detach': handleDetach,
	    'before:render': handleBeforeRender,
	    'render': handleRender
	  });
	}
	
	// Error
	// -----
	
	var errorProps = ['description', 'fileName', 'lineNumber', 'name', 'message', 'number'];
	
	var MarionetteError = extend.call(Error, {
	  urlRoot: 'http://marionettejs.com/docs/v' + version + '/',
	
	  constructor: function constructor(message, options) {
	    if (_.isObject(message)) {
	      options = message;
	      message = options.message;
	    } else if (!options) {
	      options = {};
	    }
	
	    var error = Error.call(this, message);
	    _.extend(this, _.pick(error, errorProps), _.pick(options, errorProps));
	
	    this.captureStackTrace();
	
	    if (options.url) {
	      this.url = this.urlRoot + options.url;
	    }
	  },
	  captureStackTrace: function captureStackTrace() {
	    if (Error.captureStackTrace) {
	      Error.captureStackTrace(this, MarionetteError);
	    }
	  },
	  toString: function toString() {
	    return this.name + ': ' + this.message + (this.url ? ' See: ' + this.url : '');
	  }
	});
	
	MarionetteError.extend = extend;
	
	// Bind Entity Events & Unbind Entity Events
	// -----------------------------------------
	//
	// These methods are used to bind/unbind a backbone "entity" (e.g. collection/model)
	// to methods on a target object.
	//
	// The first parameter, `target`, must have the Backbone.Events module mixed in.
	//
	// The second parameter is the `entity` (Backbone.Model, Backbone.Collection or
	// any object that has Backbone.Events mixed in) to bind the events from.
	//
	// The third parameter is a hash of { "event:name": "eventHandler" }
	// configuration. Multiple handlers can be separated by a space. A
	// function can be supplied instead of a string handler name.
	
	// Bind/unbind the event to handlers specified as a string of
	// handler names on the target object
	function bindFromStrings(target, entity, evt, methods, actionName) {
	  var methodNames = methods.split(/\s+/);
	
	  if (methodNames.length > 1) {
	    deprecate('Multiple handlers for a single event are deprecated. If needed, use a single handler to call multiple methods.');
	  }
	
	  _.each(methodNames, function (methodName) {
	    var method = target[methodName];
	    if (!method) {
	      throw new MarionetteError('Method "' + methodName + '" was configured as an event handler, but does not exist.');
	    }
	
	    target[actionName](entity, evt, method);
	  });
	}
	
	// generic looping function
	function iterateEvents(target, entity, bindings, actionName) {
	  // type-check bindings
	  if (!_.isObject(bindings)) {
	    throw new MarionetteError({
	      message: 'Bindings must be an object.',
	      url: 'marionette.functions.html#marionettebindevents'
	    });
	  }
	
	  // iterate the bindings and bind/unbind them
	  _.each(bindings, function (method, evt) {
	
	    // allow for a list of method names as a string
	    if (_.isString(method)) {
	      bindFromStrings(target, entity, evt, method, actionName);
	      return;
	    }
	
	    target[actionName](entity, evt, method);
	  });
	}
	
	function bindEvents(entity, bindings) {
	  if (!entity || !bindings) {
	    return this;
	  }
	
	  iterateEvents(this, entity, bindings, 'listenTo');
	  return this;
	}
	
	function unbindEvents(entity, bindings) {
	  if (!entity) {
	    return this;
	  }
	
	  if (!bindings) {
	    this.stopListening(entity);
	    return this;
	  }
	
	  iterateEvents(this, entity, bindings, 'stopListening');
	  return this;
	}
	
	// Bind/Unbind Radio Requests
	// -----------------------------------------
	//
	// These methods are used to bind/unbind a backbone.radio request
	// to methods on a target object.
	//
	// The first parameter, `target`, will set the context of the reply method
	//
	// The second parameter is the `Radio.channel` to bind the reply to.
	//
	// The third parameter is a hash of { "request:name": "replyHandler" }
	// configuration. A function can be supplied instead of a string handler name.
	
	function iterateReplies(target, channel, bindings, actionName) {
	  // type-check bindings
	  if (!_.isObject(bindings)) {
	    throw new MarionetteError({
	      message: 'Bindings must be an object.',
	      url: 'marionette.functions.html#marionettebindrequests'
	    });
	  }
	
	  var normalizedRadioRequests = normalizeMethods.call(target, bindings);
	
	  channel[actionName](normalizedRadioRequests, target);
	}
	
	function bindRequests(channel, bindings) {
	  if (!channel || !bindings) {
	    return this;
	  }
	
	  iterateReplies(this, channel, bindings, 'reply');
	  return this;
	}
	
	function unbindRequests(channel, bindings) {
	  if (!channel) {
	    return this;
	  }
	
	  if (!bindings) {
	    channel.stopReplying(null, null, this);
	    return this;
	  }
	
	  iterateReplies(this, channel, bindings, 'stopReplying');
	  return this;
	}
	
	// Internal utility for setting options consistently across Mn
	var setOptions = function setOptions(options) {
	  this.options = _.extend({}, _.result(this, 'options'), options);
	};
	
	var CommonMixin = {
	
	  // Imports the "normalizeMethods" to transform hashes of
	  // events=>function references/names to a hash of events=>function references
	  normalizeMethods: normalizeMethods,
	
	  _setOptions: setOptions,
	
	  // A handy way to merge passed-in options onto the instance
	  mergeOptions: mergeOptions,
	
	  // Enable getting options from this or this.options by name.
	  getOption: getOption,
	
	  // Enable binding view's events from another entity.
	  bindEvents: bindEvents,
	
	  // Enable unbinding view's events from another entity.
	  unbindEvents: unbindEvents
	};
	
	// MixinOptions
	// - channelName
	// - radioEvents
	// - radioRequests
	
	var RadioMixin = {
	  _initRadio: function _initRadio() {
	    var channelName = _.result(this, 'channelName');
	
	    if (!channelName) {
	      return;
	    }
	
	    /* istanbul ignore next */
	    if (!Radio) {
	      throw new MarionetteError({
	        name: 'BackboneRadioMissing',
	        message: 'The dependency "backbone.radio" is missing.'
	      });
	    }
	
	    var channel = this._channel = Radio.channel(channelName);
	
	    var radioEvents = _.result(this, 'radioEvents');
	    this.bindEvents(channel, radioEvents);
	
	    var radioRequests = _.result(this, 'radioRequests');
	    this.bindRequests(channel, radioRequests);
	
	    this.on('destroy', this._destroyRadio);
	  },
	  _destroyRadio: function _destroyRadio() {
	    this._channel.stopReplying(null, null, this);
	  },
	  getChannel: function getChannel() {
	    return this._channel;
	  },
	
	
	  // Proxy `bindEvents`
	  bindEvents: bindEvents,
	
	  // Proxy `unbindEvents`
	  unbindEvents: unbindEvents,
	
	  // Proxy `bindRequests`
	  bindRequests: bindRequests,
	
	  // Proxy `unbindRequests`
	  unbindRequests: unbindRequests
	
	};
	
	// Object
	// ------
	
	var ClassOptions = ['channelName', 'radioEvents', 'radioRequests'];
	
	// A Base Class that other Classes should descend from.
	// Object borrows many conventions and utilities from Backbone.
	var MarionetteObject = function MarionetteObject(options) {
	  if (!this.hasOwnProperty('options')) {
	    this._setOptions(options);
	  }
	  this.mergeOptions(options, ClassOptions);
	  this._setCid();
	  this._initRadio();
	  this.initialize.apply(this, arguments);
	};
	
	MarionetteObject.extend = extend;
	
	// Object Methods
	// --------------
	
	// Ensure it can trigger events with Backbone.Events
	_.extend(MarionetteObject.prototype, Backbone.Events, CommonMixin, RadioMixin, {
	  cidPrefix: 'mno',
	
	  // for parity with Marionette.AbstractView lifecyle
	  _isDestroyed: false,
	
	  isDestroyed: function isDestroyed() {
	    return this._isDestroyed;
	  },
	
	
	  //this is a noop method intended to be overridden by classes that extend from this base
	  initialize: function initialize() {},
	  _setCid: function _setCid() {
	    if (this.cid) {
	      return;
	    }
	    this.cid = _.uniqueId(this.cidPrefix);
	  },
	  destroy: function destroy() {
	    if (this._isDestroyed) {
	      return this;
	    }
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    this.triggerMethod.apply(this, ['before:destroy', this].concat(args));
	
	    this._isDestroyed = true;
	    this.triggerMethod.apply(this, ['destroy', this].concat(args));
	    this.stopListening();
	
	    return this;
	  },
	
	
	  triggerMethod: triggerMethod
	});
	
	// Template Cache
	// --------------
	
	// Manage templates stored in `<script>` blocks,
	// caching them for faster access.
	var TemplateCache = function TemplateCache(templateId) {
	  this.templateId = templateId;
	};
	
	// TemplateCache object-level methods. Manage the template
	// caches from these method calls instead of creating
	// your own TemplateCache instances
	_.extend(TemplateCache, {
	
	  templateCaches: {},
	
	  // Get the specified template by id. Either
	  // retrieves the cached version, or loads it
	  // from the DOM.
	  get: function get(templateId, options) {
	    var cachedTemplate = this.templateCaches[templateId];
	
	    if (!cachedTemplate) {
	      cachedTemplate = new TemplateCache(templateId);
	      this.templateCaches[templateId] = cachedTemplate;
	    }
	
	    return cachedTemplate.load(options);
	  },
	
	
	  // Clear templates from the cache. If no arguments
	  // are specified, clears all templates:
	  // `clear()`
	  //
	  // If arguments are specified, clears each of the
	  // specified templates from the cache:
	  // `clear("#t1", "#t2", "...")`
	  clear: function clear() {
	    var i = void 0;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var length = args.length;
	
	    if (length > 0) {
	      for (i = 0; i < length; i++) {
	        delete this.templateCaches[args[i]];
	      }
	    } else {
	      this.templateCaches = {};
	    }
	  }
	});
	
	// TemplateCache instance methods, allowing each
	// template cache object to manage its own state
	// and know whether or not it has been loaded
	_.extend(TemplateCache.prototype, {
	
	  // Internal method to load the template
	  load: function load(options) {
	    // Guard clause to prevent loading this template more than once
	    if (this.compiledTemplate) {
	      return this.compiledTemplate;
	    }
	
	    // Load the template and compile it
	    var template = this.loadTemplate(this.templateId, options);
	    this.compiledTemplate = this.compileTemplate(template, options);
	
	    return this.compiledTemplate;
	  },
	
	
	  // Load a template from the DOM, by default. Override
	  // this method to provide your own template retrieval
	  // For asynchronous loading with AMD/RequireJS, consider
	  // using a template-loader plugin as described here:
	  // https://github.com/marionettejs/backbone.marionette/wiki/Using-marionette-with-requirejs
	  loadTemplate: function loadTemplate(templateId, options) {
	    var $template = Backbone.$(templateId);
	
	    if (!$template.length) {
	      throw new MarionetteError({
	        name: 'NoTemplateError',
	        message: 'Could not find template: "' + templateId + '"'
	      });
	    }
	    return $template.html();
	  },
	
	
	  // Pre-compile the template before caching it. Override
	  // this method if you do not need to pre-compile a template
	  // (JST / RequireJS for example) or if you want to change
	  // the template engine used (Handebars, etc).
	  compileTemplate: function compileTemplate(rawTemplate, options) {
	    return _.template(rawTemplate, options);
	  }
	});
	
	// Implementation of the invoke method (http://underscorejs.org/#invoke) with support for
	// lodash v3, v4, and underscore.js
	var _invoke = _.invokeMap || _.invoke;
	
	// MixinOptions
	// - behaviors
	
	// Takes care of getting the behavior class
	// given options and a key.
	// If a user passes in options.behaviorClass
	// default to using that.
	// If a user passes in a Behavior Class directly, use that
	// Otherwise delegate the lookup to the users `behaviorsLookup` implementation.
	function getBehaviorClass(options, key) {
	  if (options.behaviorClass) {
	    return options.behaviorClass;
	    //treat functions as a Behavior constructor
	  } else if (_.isFunction(options)) {
	    return options;
	  }
	
	  // behaviorsLookup can be either a flat object or a method
	  if (_.isFunction(Marionette.Behaviors.behaviorsLookup)) {
	    return Marionette.Behaviors.behaviorsLookup(options, key)[key];
	  }
	
	  return Marionette.Behaviors.behaviorsLookup[key];
	}
	
	// Iterate over the behaviors object, for each behavior
	// instantiate it and get its grouped behaviors.
	// This accepts a list of behaviors in either an object or array form
	function parseBehaviors(view, behaviors) {
	  return _.chain(behaviors).map(function (options, key) {
	    var BehaviorClass = getBehaviorClass(options, key);
	    //if we're passed a class directly instead of an object
	    var _options = options === BehaviorClass ? {} : options;
	    var behavior = new BehaviorClass(_options, view);
	    var nestedBehaviors = parseBehaviors(view, _.result(behavior, 'behaviors'));
	
	    return [behavior].concat(nestedBehaviors);
	  }).flatten().value();
	}
	
	var BehaviorsMixin = {
	  _initBehaviors: function _initBehaviors() {
	    this._behaviors = this._getBehaviors();
	  },
	  _getBehaviors: function _getBehaviors() {
	    var behaviors = _.result(this, 'behaviors');
	
	    // Behaviors defined on a view can be a flat object literal
	    // or it can be a function that returns an object.
	    return _.isObject(behaviors) ? parseBehaviors(this, behaviors) : {};
	  },
	  _getBehaviorTriggers: function _getBehaviorTriggers() {
	    var triggers = _invoke(this._behaviors, 'getTriggers');
	    return _.reduce(triggers, function (memo, _triggers) {
	      return _.extend(memo, _triggers);
	    }, {});
	  },
	  _getBehaviorEvents: function _getBehaviorEvents() {
	    var events = _invoke(this._behaviors, 'getEvents');
	    return _.reduce(events, function (memo, _events) {
	      return _.extend(memo, _events);
	    }, {});
	  },
	
	
	  // proxy behavior $el to the view's $el.
	  _proxyBehaviorViewProperties: function _proxyBehaviorViewProperties() {
	    _invoke(this._behaviors, 'proxyViewProperties');
	  },
	
	
	  // delegate modelEvents and collectionEvents
	  _delegateBehaviorEntityEvents: function _delegateBehaviorEntityEvents() {
	    _invoke(this._behaviors, 'delegateEntityEvents');
	  },
	
	
	  // undelegate modelEvents and collectionEvents
	  _undelegateBehaviorEntityEvents: function _undelegateBehaviorEntityEvents() {
	    _invoke(this._behaviors, 'undelegateEntityEvents');
	  },
	  _destroyBehaviors: function _destroyBehaviors() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    // Call destroy on each behavior after
	    // destroying the view.
	    // This unbinds event listeners
	    // that behaviors have registered for.
	    _invoke.apply(undefined, [this._behaviors, 'destroy'].concat(args));
	  },
	
	
	  // Remove a behavior
	  _removeBehavior: function _removeBehavior(behavior) {
	    // Don't worry about the clean up if the view is destroyed
	    if (this._isDestroyed) {
	      return;
	    }
	
	    // Remove behavior-only triggers and events
	    this.undelegate('.trig' + behavior.cid + ' .' + behavior.cid);
	
	    this._behaviors = _.without(this._behaviors, behavior);
	  },
	  _bindBehaviorUIElements: function _bindBehaviorUIElements() {
	    _invoke(this._behaviors, 'bindUIElements');
	  },
	  _unbindBehaviorUIElements: function _unbindBehaviorUIElements() {
	    _invoke(this._behaviors, 'unbindUIElements');
	  },
	  _triggerEventOnBehaviors: function _triggerEventOnBehaviors() {
	    var behaviors = this._behaviors;
	    // Use good ol' for as this is a very hot function
	    for (var i = 0, length = behaviors && behaviors.length; i < length; i++) {
	      triggerMethod.apply(behaviors[i], arguments);
	    }
	  }
	};
	
	// MixinOptions
	// - collectionEvents
	// - modelEvents
	
	var DelegateEntityEventsMixin = {
	  // Handle `modelEvents`, and `collectionEvents` configuration
	  _delegateEntityEvents: function _delegateEntityEvents(model, collection) {
	    var modelEvents = _.result(this, 'modelEvents');
	
	    if (modelEvents) {
	      unbindEvents.call(this, model, modelEvents);
	      bindEvents.call(this, model, modelEvents);
	    }
	
	    var collectionEvents = _.result(this, 'collectionEvents');
	
	    if (collectionEvents) {
	      unbindEvents.call(this, collection, collectionEvents);
	      bindEvents.call(this, collection, collectionEvents);
	    }
	  },
	  _undelegateEntityEvents: function _undelegateEntityEvents(model, collection) {
	    var modelEvents = _.result(this, 'modelEvents');
	    unbindEvents.call(this, model, modelEvents);
	
	    var collectionEvents = _.result(this, 'collectionEvents');
	    unbindEvents.call(this, collection, collectionEvents);
	  }
	};
	
	// Borrow event splitter from Backbone
	var delegateEventSplitter = /^(\S+)\s*(.*)$/;
	
	// Set event name to be namespaced using a unique index
	// to generate a non colliding event namespace
	// http://api.jquery.com/event.namespace/
	var getNamespacedEventName = function getNamespacedEventName(eventName, namespace) {
	  var match = eventName.match(delegateEventSplitter);
	  return match[1] + "." + namespace + " " + match[2];
	};
	
	// Add Feature flags here
	// e.g. 'class' => false
	var FEATURES = {
	  childViewEventPrefix: true,
	  triggersStopPropagation: true,
	  triggersPreventDefault: true
	};
	
	function isEnabled(name) {
	  return !!FEATURES[name];
	}
	
	function setEnabled(name, state) {
	  return FEATURES[name] = state;
	}
	
	// Internal method to create an event handler for a given `triggerDef` like
	// 'click:foo'
	function buildViewTrigger(view, triggerDef) {
	  if (_.isString(triggerDef)) {
	    triggerDef = { event: triggerDef };
	  }
	
	  var eventName = triggerDef.event;
	
	  var shouldPreventDefault = !!triggerDef.preventDefault;
	
	  if (isEnabled('triggersPreventDefault')) {
	    shouldPreventDefault = triggerDef.preventDefault !== false;
	  }
	
	  var shouldStopPropagation = !!triggerDef.stopPropagation;
	
	  if (isEnabled('triggersStopPropagation')) {
	    shouldStopPropagation = triggerDef.stopPropagation !== false;
	  }
	
	  return function (event) {
	    if (shouldPreventDefault) {
	      event.preventDefault();
	    }
	
	    if (shouldStopPropagation) {
	      event.stopPropagation();
	    }
	
	    view.triggerMethod(eventName, view, event);
	  };
	}
	
	var TriggersMixin = {
	
	  // Configure `triggers` to forward DOM events to view
	  // events. `triggers: {"click .foo": "do:foo"}`
	  _getViewTriggers: function _getViewTriggers(view, triggers) {
	    var _this = this;
	
	    // Configure the triggers, prevent default
	    // action and stop propagation of DOM events
	    return _.reduce(triggers, function (events, value, key) {
	      key = getNamespacedEventName(key, 'trig' + _this.cid);
	      events[key] = buildViewTrigger(view, value);
	      return events;
	    }, {});
	  }
	};
	
	// allows for the use of the @ui. syntax within
	// a given key for triggers and events
	// swaps the @ui with the associated selector.
	// Returns a new, non-mutated, parsed events hash.
	var _normalizeUIKeys = function _normalizeUIKeys(hash, ui) {
	  return _.reduce(hash, function (memo, val, key) {
	    var normalizedKey = _normalizeUIString(key, ui);
	    memo[normalizedKey] = val;
	    return memo;
	  }, {});
	};
	
	// utility method for parsing @ui. syntax strings
	// into associated selector
	var _normalizeUIString = function _normalizeUIString(uiString, ui) {
	  return uiString.replace(/@ui\.[a-zA-Z-_$0-9]*/g, function (r) {
	    return ui[r.slice(4)];
	  });
	};
	
	// allows for the use of the @ui. syntax within
	// a given value for regions
	// swaps the @ui with the associated selector
	var _normalizeUIValues = function _normalizeUIValues(hash, ui, properties) {
	  _.each(hash, function (val, key) {
	    if (_.isString(val)) {
	      hash[key] = _normalizeUIString(val, ui);
	    } else if (_.isObject(val) && _.isArray(properties)) {
	      _.extend(val, _normalizeUIValues(_.pick(val, properties), ui));
	      /* Value is an object, and we got an array of embedded property names to normalize. */
	      _.each(properties, function (property) {
	        var propertyVal = val[property];
	        if (_.isString(propertyVal)) {
	          val[property] = _normalizeUIString(propertyVal, ui);
	        }
	      });
	    }
	  });
	  return hash;
	};
	
	var UIMixin = {
	
	  // normalize the keys of passed hash with the views `ui` selectors.
	  // `{"@ui.foo": "bar"}`
	  normalizeUIKeys: function normalizeUIKeys(hash) {
	    var uiBindings = this._getUIBindings();
	    return _normalizeUIKeys(hash, uiBindings);
	  },
	
	
	  // normalize the passed string with the views `ui` selectors.
	  // `"@ui.bar"`
	  normalizeUIString: function normalizeUIString(uiString) {
	    var uiBindings = this._getUIBindings();
	    return _normalizeUIString(uiString, uiBindings);
	  },
	
	
	  // normalize the values of passed hash with the views `ui` selectors.
	  // `{foo: "@ui.bar"}`
	  normalizeUIValues: function normalizeUIValues(hash, properties) {
	    var uiBindings = this._getUIBindings();
	    return _normalizeUIValues(hash, uiBindings, properties);
	  },
	  _getUIBindings: function _getUIBindings() {
	    var uiBindings = _.result(this, '_uiBindings');
	    var ui = _.result(this, 'ui');
	    return uiBindings || ui;
	  },
	
	
	  // This method binds the elements specified in the "ui" hash inside the view's code with
	  // the associated jQuery selectors.
	  _bindUIElements: function _bindUIElements() {
	    var _this = this;
	
	    if (!this.ui) {
	      return;
	    }
	
	    // store the ui hash in _uiBindings so they can be reset later
	    // and so re-rendering the view will be able to find the bindings
	    if (!this._uiBindings) {
	      this._uiBindings = this.ui;
	    }
	
	    // get the bindings result, as a function or otherwise
	    var bindings = _.result(this, '_uiBindings');
	
	    // empty the ui so we don't have anything to start with
	    this._ui = {};
	
	    // bind each of the selectors
	    _.each(bindings, function (selector, key) {
	      _this._ui[key] = _this.$(selector);
	    });
	
	    this.ui = this._ui;
	  },
	  _unbindUIElements: function _unbindUIElements() {
	    var _this2 = this;
	
	    if (!this.ui || !this._uiBindings) {
	      return;
	    }
	
	    // delete all of the existing ui bindings
	    _.each(this.ui, function ($el, name) {
	      delete _this2.ui[name];
	    });
	
	    // reset the ui element to the original bindings configuration
	    this.ui = this._uiBindings;
	    delete this._uiBindings;
	    delete this._ui;
	  },
	  _getUI: function _getUI(name) {
	    return this._ui[name];
	  }
	};
	
	// DomApi
	//  ---------
	// Performant method for returning the jQuery instance
	function _getEl(el) {
	  return el instanceof Backbone.$ ? el : Backbone.$(el);
	}
	
	// Static setter
	function setDomApi(mixin) {
	  this.prototype.Dom = _.extend({}, this.prototype.Dom, mixin);
	  return this;
	}
	
	var DomApi = {
	
	  // Returns a new HTML DOM node instance
	  createBuffer: function createBuffer() {
	    return document.createDocumentFragment();
	  },
	
	
	  // Lookup the `selector` string
	  // Selector may also be a DOM element
	  // Returns an array-like object of nodes
	  getEl: function getEl(selector) {
	    return _getEl(selector);
	  },
	
	
	  // Finds the `selector` string with the el
	  // Returns an array-like object of nodes
	  findEl: function findEl(el, selector) {
	    var _$el = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _getEl(el);
	
	    return _$el.find(selector);
	  },
	
	
	  // Returns true if the el contains the node childEl
	  hasEl: function hasEl(el, childEl) {
	    return el.contains(childEl && childEl.parentNode);
	  },
	
	
	  // Detach `el` from the DOM without removing listeners
	  detachEl: function detachEl(el) {
	    var _$el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _getEl(el);
	
	    _$el.detach();
	  },
	
	
	  // Remove `oldEl` from the DOM and put `newEl` in its place
	  replaceEl: function replaceEl(newEl, oldEl) {
	    if (newEl === oldEl) {
	      return;
	    }
	
	    var parent = oldEl.parentNode;
	
	    if (!parent) {
	      return;
	    }
	
	    parent.replaceChild(newEl, oldEl);
	  },
	
	
	  // Swaps the location of `el1` and `el2` in the DOM
	  swapEl: function swapEl(el1, el2) {
	    if (el1 === el2) {
	      return;
	    }
	
	    var parent1 = el1.parentNode;
	    var parent2 = el2.parentNode;
	
	    if (!parent1 || !parent2) {
	      return;
	    }
	
	    var next1 = el1.nextSibling;
	    var next2 = el2.nextSibling;
	
	    parent1.insertBefore(el2, next1);
	    parent2.insertBefore(el1, next2);
	  },
	
	
	  // Replace the contents of `el` with the HTML string of `html`
	  setContents: function setContents(el, html) {
	    var _$el = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _getEl(el);
	
	    _$el.html(html);
	  },
	
	
	  // Takes the DOM node `el` and appends the DOM node `contents`
	  // to the end of the element's contents.
	  appendContents: function appendContents(el, contents) {
	    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	        _ref$_$el = _ref._$el,
	        _$el = _ref$_$el === undefined ? _getEl(el) : _ref$_$el,
	        _ref$_$contents = _ref._$contents,
	        _$contents = _ref$_$contents === undefined ? _getEl(contents) : _ref$_$contents;
	
	    _$el.append(_$contents);
	  },
	
	
	  // Does the el have child nodes
	  hasContents: function hasContents(el) {
	    return !!el && el.hasChildNodes();
	  },
	
	
	  // Remove the inner contents of `el` from the DOM while leaving
	  // `el` itself in the DOM.
	  detachContents: function detachContents(el) {
	    var _$el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _getEl(el);
	
	    _$el.contents().detach();
	  }
	};
	
	// ViewMixin
	//  ---------
	
	// MixinOptions
	// - behaviors
	// - childViewEventPrefix
	// - childViewEvents
	// - childViewTriggers
	// - collectionEvents
	// - modelEvents
	// - triggers
	// - ui
	
	
	var ViewMixin = {
	  Dom: DomApi,
	
	  supportsRenderLifecycle: true,
	  supportsDestroyLifecycle: true,
	
	  _isDestroyed: false,
	
	  isDestroyed: function isDestroyed() {
	    return !!this._isDestroyed;
	  },
	
	
	  _isRendered: false,
	
	  isRendered: function isRendered() {
	    return !!this._isRendered;
	  },
	
	
	  _isAttached: false,
	
	  isAttached: function isAttached() {
	    return !!this._isAttached;
	  },
	
	
	  // Overriding Backbone.View's `delegateEvents` to handle
	  // `events` and `triggers`
	  delegateEvents: function delegateEvents(eventsArg) {
	
	    this._proxyBehaviorViewProperties();
	    this._buildEventProxies();
	
	    var viewEvents = this._getEvents(eventsArg);
	
	    if (typeof eventsArg === 'undefined') {
	      this.events = viewEvents;
	    }
	
	    var combinedEvents = _.extend({}, this._getBehaviorEvents(), viewEvents, this._getBehaviorTriggers(), this.getTriggers());
	
	    Backbone.View.prototype.delegateEvents.call(this, combinedEvents);
	
	    return this;
	  },
	  _getEvents: function _getEvents(eventsArg) {
	    var events = eventsArg || this.events;
	
	    if (_.isFunction(events)) {
	      return this.normalizeUIKeys(events.call(this));
	    }
	
	    return this.normalizeUIKeys(events);
	  },
	
	
	  // Configure `triggers` to forward DOM events to view
	  // events. `triggers: {"click .foo": "do:foo"}`
	  getTriggers: function getTriggers() {
	    if (!this.triggers) {
	      return;
	    }
	
	    // Allow `triggers` to be configured as a function
	    var triggers = this.normalizeUIKeys(_.result(this, 'triggers'));
	
	    // Configure the triggers, prevent default
	    // action and stop propagation of DOM events
	    return this._getViewTriggers(this, triggers);
	  },
	
	
	  // Handle `modelEvents`, and `collectionEvents` configuration
	  delegateEntityEvents: function delegateEntityEvents() {
	    this._delegateEntityEvents(this.model, this.collection);
	
	    // bind each behaviors model and collection events
	    this._delegateBehaviorEntityEvents();
	
	    return this;
	  },
	
	
	  // Handle unbinding `modelEvents`, and `collectionEvents` configuration
	  undelegateEntityEvents: function undelegateEntityEvents() {
	    this._undelegateEntityEvents(this.model, this.collection);
	
	    // unbind each behaviors model and collection events
	    this._undelegateBehaviorEntityEvents();
	
	    return this;
	  },
	
	
	  // Handle destroying the view and its children.
	  destroy: function destroy() {
	    if (this._isDestroyed) {
	      return this;
	    }
	    var shouldTriggerDetach = this._isAttached && !this._shouldDisableEvents;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    this.triggerMethod.apply(this, ['before:destroy', this].concat(args));
	    if (shouldTriggerDetach) {
	      this.triggerMethod('before:detach', this);
	    }
	
	    // unbind UI elements
	    this.unbindUIElements();
	
	    // remove the view from the DOM
	    this._removeElement();
	
	    if (shouldTriggerDetach) {
	      this._isAttached = false;
	      this.triggerMethod('detach', this);
	    }
	
	    // remove children after the remove to prevent extra paints
	    this._removeChildren();
	
	    this._isDestroyed = true;
	    this._isRendered = false;
	
	    // Destroy behaviors after _isDestroyed flag
	    this._destroyBehaviors.apply(this, args);
	
	    this.triggerMethod.apply(this, ['destroy', this].concat(args));
	
	    this.stopListening();
	
	    return this;
	  },
	
	
	  // Equates to this.$el.remove
	  _removeElement: function _removeElement() {
	    this.$el.off().removeData();
	    this.Dom.detachEl(this.el, this.$el);
	  },
	  bindUIElements: function bindUIElements() {
	    this._bindUIElements();
	    this._bindBehaviorUIElements();
	
	    return this;
	  },
	
	
	  // This method unbinds the elements specified in the "ui" hash
	  unbindUIElements: function unbindUIElements() {
	    this._unbindUIElements();
	    this._unbindBehaviorUIElements();
	
	    return this;
	  },
	  getUI: function getUI(name) {
	    return this._getUI(name);
	  },
	
	
	  // used as the prefix for child view events
	  // that are forwarded through the layoutview
	  childViewEventPrefix: function childViewEventPrefix() {
	    return isEnabled('childViewEventPrefix') ? 'childview' : false;
	  },
	
	
	  // import the `triggerMethod` to trigger events with corresponding
	  // methods if the method exists
	  triggerMethod: function triggerMethod$$1() {
	    var ret = triggerMethod.apply(this, arguments);
	
	    this._triggerEventOnBehaviors.apply(this, arguments);
	
	    return ret;
	  },
	
	
	  // Cache `childViewEvents` and `childViewTriggers`
	  _buildEventProxies: function _buildEventProxies() {
	    this._childViewEvents = _.result(this, 'childViewEvents');
	    this._childViewTriggers = _.result(this, 'childViewTriggers');
	  },
	  _proxyChildViewEvents: function _proxyChildViewEvents(view) {
	    this.listenTo(view, 'all', this._childViewEventHandler);
	  },
	  _childViewEventHandler: function _childViewEventHandler(eventName) {
	    var childViewEvents = this.normalizeMethods(this._childViewEvents);
	
	    // call collectionView childViewEvent if defined
	
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    if (typeof childViewEvents !== 'undefined' && _.isFunction(childViewEvents[eventName])) {
	      childViewEvents[eventName].apply(this, args);
	    }
	
	    // use the parent view's proxyEvent handlers
	    var childViewTriggers = this._childViewTriggers;
	
	    // Call the event with the proxy name on the parent layout
	    if (childViewTriggers && _.isString(childViewTriggers[eventName])) {
	      this.triggerMethod.apply(this, [childViewTriggers[eventName]].concat(args));
	    }
	
	    var prefix = _.result(this, 'childViewEventPrefix');
	
	    if (prefix !== false) {
	      var childEventName = prefix + ':' + eventName;
	
	      this.triggerMethod.apply(this, [childEventName].concat(args));
	    }
	  }
	};
	
	_.extend(ViewMixin, BehaviorsMixin, CommonMixin, DelegateEntityEventsMixin, TriggersMixin, UIMixin);
	
	function renderView(view) {
	  if (view._isRendered) {
	    return;
	  }
	
	  if (!view.supportsRenderLifecycle) {
	    triggerMethodOn(view, 'before:render', view);
	  }
	
	  view.render();
	
	  if (!view.supportsRenderLifecycle) {
	    view._isRendered = true;
	    triggerMethodOn(view, 'render', view);
	  }
	}
	
	function destroyView(view) {
	  if (view.destroy) {
	    view.destroy();
	    return;
	  }
	
	  if (!view.supportsDestroyLifecycle) {
	    triggerMethodOn(view, 'before:destroy', view);
	  }
	
	  var shouldTriggerDetach = view._isAttached && !view._shouldDisableEvents;
	
	  if (shouldTriggerDetach) {
	    triggerMethodOn(view, 'before:detach', view);
	  }
	
	  view.remove();
	
	  if (shouldTriggerDetach) {
	    view._isAttached = false;
	    triggerMethodOn(view, 'detach', view);
	  }
	
	  view._isDestroyed = true;
	
	  if (!view.supportsDestroyLifecycle) {
	    triggerMethodOn(view, 'destroy', view);
	  }
	}
	
	// Region
	// ------
	
	var ClassOptions$2 = ['allowMissingEl', 'parentEl', 'replaceElement'];
	
	var Region = MarionetteObject.extend({
	  Dom: DomApi,
	
	  cidPrefix: 'mnr',
	  replaceElement: false,
	  _isReplaced: false,
	  _isSwappingView: false,
	
	  constructor: function constructor(options) {
	    this._setOptions(options);
	
	    this.mergeOptions(options, ClassOptions$2);
	
	    // getOption necessary because options.el may be passed as undefined
	    this._initEl = this.el = this.getOption('el');
	
	    // Handle when this.el is passed in as a $ wrapped element.
	    this.el = this.el instanceof Backbone.$ ? this.el[0] : this.el;
	
	    if (!this.el) {
	      throw new MarionetteError({
	        name: 'NoElError',
	        message: 'An "el" must be specified for a region.'
	      });
	    }
	
	    this.$el = this.getEl(this.el);
	    MarionetteObject.call(this, options);
	  },
	
	
	  // Displays a backbone view instance inside of the region. Handles calling the `render`
	  // method for you. Reads content directly from the `el` attribute. The `preventDestroy`
	  // option can be used to prevent a view from the old view being destroyed on show.
	  show: function show(view, options) {
	    if (!this._ensureElement(options)) {
	      return;
	    }
	
	    view = this._getView(view, options);
	
	    if (view === this.currentView) {
	      return this;
	    }
	
	    this._isSwappingView = !!this.currentView;
	
	    this.triggerMethod('before:show', this, view, options);
	
	    // Assume an attached view is already in the region for pre-existing DOM
	    if (!view._isAttached) {
	      this.empty(options);
	    }
	
	    this._setupChildView(view);
	
	    this.currentView = view;
	
	    renderView(view);
	
	    this._attachView(view, options);
	
	    this.triggerMethod('show', this, view, options);
	
	    this._isSwappingView = false;
	
	    return this;
	  },
	  _setupChildView: function _setupChildView(view) {
	    monitorViewEvents(view);
	
	    this._proxyChildViewEvents(view);
	
	    // We need to listen for if a view is destroyed in a way other than through the region.
	    // If this happens we need to remove the reference to the currentView since once a view
	    // has been destroyed we can not reuse it.
	    view.on('destroy', this._empty, this);
	  },
	  _proxyChildViewEvents: function _proxyChildViewEvents(view) {
	    var parentView = this._parentView;
	
	    if (!parentView) {
	      return;
	    }
	
	    parentView._proxyChildViewEvents(view);
	  },
	
	
	  // If the regions parent view is not monitoring its attach/detach events
	  _shouldDisableMonitoring: function _shouldDisableMonitoring() {
	    return this._parentView && this._parentView.monitorViewEvents === false;
	  },
	  _attachView: function _attachView(view) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var shouldTriggerAttach = !view._isAttached && isNodeAttached(this.el) && !this._shouldDisableMonitoring();
	    var shouldReplaceEl = typeof options.replaceElement === 'undefined' ? !!_.result(this, 'replaceElement') : !!options.replaceElement;
	
	    if (shouldTriggerAttach) {
	      triggerMethodOn(view, 'before:attach', view);
	    }
	
	    if (shouldReplaceEl) {
	      this._replaceEl(view);
	    } else {
	      this.attachHtml(view);
	    }
	
	    if (shouldTriggerAttach) {
	      view._isAttached = true;
	      triggerMethodOn(view, 'attach', view);
	    }
	  },
	  _ensureElement: function _ensureElement() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    if (!_.isObject(this.el)) {
	      this.$el = this.getEl(this.el);
	      this.el = this.$el[0];
	      // Make sure the $el contains only the el
	      this.$el = this.Dom.getEl(this.el);
	    }
	
	    if (!this.$el || this.$el.length === 0) {
	      var allowMissingEl = typeof options.allowMissingEl === 'undefined' ? !!_.result(this, 'allowMissingEl') : !!options.allowMissingEl;
	
	      if (allowMissingEl) {
	        return false;
	      } else {
	        throw new MarionetteError('An "el" must exist in DOM for this region ' + this.cid);
	      }
	    }
	    return true;
	  },
	  _getView: function _getView(view) {
	    if (!view) {
	      throw new MarionetteError({
	        name: 'ViewNotValid',
	        message: 'The view passed is undefined and therefore invalid. You must pass a view instance to show.'
	      });
	    }
	
	    if (view._isDestroyed) {
	      throw new MarionetteError({
	        name: 'ViewDestroyedError',
	        message: 'View (cid: "' + view.cid + '") has already been destroyed and cannot be used.'
	      });
	    }
	
	    if (view instanceof Backbone.View) {
	      return view;
	    }
	
	    var viewOptions = this._getViewOptions(view);
	
	    return new View(viewOptions);
	  },
	
	
	  // This allows for a template or a static string to be
	  // used as a template
	  _getViewOptions: function _getViewOptions(viewOptions) {
	    if (_.isFunction(viewOptions)) {
	      return { template: viewOptions };
	    }
	
	    if (_.isObject(viewOptions)) {
	      return viewOptions;
	    }
	
	    var template = function template() {
	      return viewOptions;
	    };
	
	    return { template: template };
	  },
	
	
	  // Override this method to change how the region finds the DOM element that it manages. Return
	  // a jQuery selector object scoped to a provided parent el or the document if none exists.
	  getEl: function getEl(el) {
	    var context = _.result(this, 'parentEl');
	
	    if (context && _.isString(el)) {
	      return this.Dom.findEl(context, el);
	    }
	
	    return this.Dom.getEl(el);
	  },
	  _replaceEl: function _replaceEl(view) {
	    // always restore the el to ensure the regions el is present before replacing
	    this._restoreEl();
	
	    view.on('before:destroy', this._restoreEl, this);
	
	    this.Dom.replaceEl(view.el, this.el);
	
	    this._isReplaced = true;
	  },
	
	
	  // Restore the region's element in the DOM.
	  _restoreEl: function _restoreEl() {
	    // There is nothing to replace
	    if (!this._isReplaced) {
	      return;
	    }
	
	    var view = this.currentView;
	
	    if (!view) {
	      return;
	    }
	
	    this._detachView(view);
	
	    this._isReplaced = false;
	  },
	
	
	  // Check to see if the region's el was replaced.
	  isReplaced: function isReplaced() {
	    return !!this._isReplaced;
	  },
	
	
	  // Check to see if a view is being swapped by another
	  isSwappingView: function isSwappingView() {
	    return !!this._isSwappingView;
	  },
	
	
	  // Override this method to change how the new view is appended to the `$el` that the
	  // region is managing
	  attachHtml: function attachHtml(view) {
	    this.Dom.appendContents(this.el, view.el, { _$el: this.$el, _$contents: view.$el });
	  },
	
	
	  // Destroy the current view, if there is one. If there is no current view, it does
	  // nothing and returns immediately.
	  empty: function empty() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { allowMissingEl: true };
	
	    var view = this.currentView;
	
	    // If there is no view in the region we should only detach current html
	    if (!view) {
	      if (this._ensureElement(options)) {
	        this.detachHtml();
	      }
	      return this;
	    }
	
	    var shouldDestroy = !options.preventDestroy;
	
	    if (!shouldDestroy) {
	      deprecate('The preventDestroy option is deprecated. Use Region#detachView');
	    }
	
	    this._empty(view, shouldDestroy);
	    return this;
	  },
	  _empty: function _empty(view, shouldDestroy) {
	    view.off('destroy', this._empty, this);
	    this.triggerMethod('before:empty', this, view);
	
	    this._restoreEl();
	
	    delete this.currentView;
	
	    if (!view._isDestroyed) {
	      if (shouldDestroy) {
	        this.removeView(view);
	      } else {
	        this._detachView(view);
	      }
	      this._stopChildViewEvents(view);
	    }
	
	    this.triggerMethod('empty', this, view);
	  },
	  _stopChildViewEvents: function _stopChildViewEvents(view) {
	    var parentView = this._parentView;
	
	    if (!parentView) {
	      return;
	    }
	
	    this._parentView.stopListening(view);
	  },
	  destroyView: function destroyView$$1(view) {
	    if (view._isDestroyed) {
	      return view;
	    }
	
	    view._shouldDisableEvents = this._shouldDisableMonitoring();
	    destroyView(view);
	    return view;
	  },
	  removeView: function removeView(view) {
	    this.destroyView(view);
	  },
	
	
	  // Empties the Region without destroying the view
	  // Returns the detached view
	  detachView: function detachView() {
	    var view = this.currentView;
	
	    if (!view) {
	      return;
	    }
	
	    this._empty(view);
	
	    return view;
	  },
	  _detachView: function _detachView(view) {
	    var shouldTriggerDetach = view._isAttached && !this._shouldDisableMonitoring();
	    var shouldRestoreEl = this._isReplaced;
	    if (shouldTriggerDetach) {
	      triggerMethodOn(view, 'before:detach', view);
	    }
	
	    if (shouldRestoreEl) {
	      this.Dom.replaceEl(this.el, view.el);
	    } else {
	      this.detachHtml();
	    }
	
	    if (shouldTriggerDetach) {
	      view._isAttached = false;
	      triggerMethodOn(view, 'detach', view);
	    }
	  },
	
	
	  // Override this method to change how the region detaches current content
	  detachHtml: function detachHtml() {
	    this.Dom.detachContents(this.el, this.$el);
	  },
	
	
	  // Checks whether a view is currently present within the region. Returns `true` if there is
	  // and `false` if no view is present.
	  hasView: function hasView() {
	    return !!this.currentView;
	  },
	
	
	  // Reset the region by destroying any existing view and clearing out the cached `$el`.
	  // The next time a view is shown via this region, the region will re-query the DOM for
	  // the region's `el`.
	  reset: function reset(options) {
	    this.empty(options);
	
	    if (this.$el) {
	      this.el = this._initEl;
	    }
	
	    delete this.$el;
	    return this;
	  },
	  destroy: function destroy(options) {
	    if (this._isDestroyed) {
	      return this;
	    }
	
	    this.reset(options);
	
	    if (this._name) {
	      this._parentView._removeReferences(this._name);
	    }
	    delete this._parentView;
	    delete this._name;
	
	    return MarionetteObject.prototype.destroy.apply(this, arguments);
	  }
	}, {
	  setDomApi: setDomApi
	});
	
	// return the region instance from the definition
	var buildRegion = function (definition, defaults) {
	  if (definition instanceof Region) {
	    return definition;
	  }
	
	  return buildRegionFromDefinition(definition, defaults);
	};
	
	function buildRegionFromDefinition(definition, defaults) {
	  var opts = _.extend({}, defaults);
	
	  if (_.isString(definition)) {
	    _.extend(opts, { el: definition });
	
	    return buildRegionFromObject(opts);
	  }
	
	  if (_.isFunction(definition)) {
	    _.extend(opts, { regionClass: definition });
	
	    return buildRegionFromObject(opts);
	  }
	
	  if (_.isObject(definition)) {
	    if (definition.selector) {
	      deprecate('The selector option on a Region definition object is deprecated. Use el to pass a selector string');
	    }
	
	    _.extend(opts, { el: definition.selector }, definition);
	
	    return buildRegionFromObject(opts);
	  }
	
	  throw new MarionetteError({
	    message: 'Improper region configuration type.',
	    url: 'marionette.region.html#region-configuration-types'
	  });
	}
	
	function buildRegionFromObject(definition) {
	  var RegionClass = definition.regionClass;
	
	  var options = _.omit(definition, 'regionClass');
	
	  return new RegionClass(options);
	}
	
	// MixinOptions
	// - regions
	// - regionClass
	
	var RegionsMixin = {
	  regionClass: Region,
	
	  // Internal method to initialize the regions that have been defined in a
	  // `regions` attribute on this View.
	  _initRegions: function _initRegions() {
	
	    // init regions hash
	    this.regions = this.regions || {};
	    this._regions = {};
	
	    this.addRegions(_.result(this, 'regions'));
	  },
	
	
	  // Internal method to re-initialize all of the regions by updating
	  // the `el` that they point to
	  _reInitRegions: function _reInitRegions() {
	    _invoke(this._regions, 'reset');
	  },
	
	
	  // Add a single region, by name, to the View
	  addRegion: function addRegion(name, definition) {
	    var regions = {};
	    regions[name] = definition;
	    return this.addRegions(regions)[name];
	  },
	
	
	  // Add multiple regions as a {name: definition, name2: def2} object literal
	  addRegions: function addRegions(regions) {
	    // If there's nothing to add, stop here.
	    if (_.isEmpty(regions)) {
	      return;
	    }
	
	    // Normalize region selectors hash to allow
	    // a user to use the @ui. syntax.
	    regions = this.normalizeUIValues(regions, ['selector', 'el']);
	
	    // Add the regions definitions to the regions property
	    this.regions = _.extend({}, this.regions, regions);
	
	    return this._addRegions(regions);
	  },
	
	
	  // internal method to build and add regions
	  _addRegions: function _addRegions(regionDefinitions) {
	    var _this = this;
	
	    var defaults = {
	      regionClass: this.regionClass,
	      parentEl: _.partial(_.result, this, 'el')
	    };
	
	    return _.reduce(regionDefinitions, function (regions, definition, name) {
	      regions[name] = buildRegion(definition, defaults);
	      _this._addRegion(regions[name], name);
	      return regions;
	    }, {});
	  },
	  _addRegion: function _addRegion(region, name) {
	    this.triggerMethod('before:add:region', this, name, region);
	
	    region._parentView = this;
	    region._name = name;
	
	    this._regions[name] = region;
	
	    this.triggerMethod('add:region', this, name, region);
	  },
	
	
	  // Remove a single region from the View, by name
	  removeRegion: function removeRegion(name) {
	    var region = this._regions[name];
	
	    this._removeRegion(region, name);
	
	    return region;
	  },
	
	
	  // Remove all regions from the View
	  removeRegions: function removeRegions() {
	    var regions = this._getRegions();
	
	    _.each(this._regions, _.bind(this._removeRegion, this));
	
	    return regions;
	  },
	  _removeRegion: function _removeRegion(region, name) {
	    this.triggerMethod('before:remove:region', this, name, region);
	
	    region.destroy();
	
	    this.triggerMethod('remove:region', this, name, region);
	  },
	
	
	  // Called in a region's destroy
	  _removeReferences: function _removeReferences(name) {
	    delete this.regions[name];
	    delete this._regions[name];
	  },
	
	
	  // Empty all regions in the region manager, but
	  // leave them attached
	  emptyRegions: function emptyRegions() {
	    var regions = this.getRegions();
	    _invoke(regions, 'empty');
	    return regions;
	  },
	
	
	  // Checks to see if view contains region
	  // Accepts the region name
	  // hasRegion('main')
	  hasRegion: function hasRegion(name) {
	    return !!this.getRegion(name);
	  },
	
	
	  // Provides access to regions
	  // Accepts the region name
	  // getRegion('main')
	  getRegion: function getRegion(name) {
	    if (!this._isRendered) {
	      this.render();
	    }
	    return this._regions[name];
	  },
	
	
	  // Get all regions
	  _getRegions: function _getRegions() {
	    return _.clone(this._regions);
	  },
	  getRegions: function getRegions() {
	    if (!this._isRendered) {
	      this.render();
	    }
	    return this._getRegions();
	  },
	  showChildView: function showChildView(name, view) {
	    var region = this.getRegion(name);
	
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    return region.show.apply(region, [view].concat(args));
	  },
	  detachChildView: function detachChildView(name) {
	    return this.getRegion(name).detachView();
	  },
	  getChildView: function getChildView(name) {
	    return this.getRegion(name).currentView;
	  }
	};
	
	// Renderer
	// --------
	
	// Render a template with data by passing in the template
	// selector and the data to render.
	var Renderer = {
	
	  // Render a template with data. The `template` parameter is
	  // passed to the `TemplateCache` object to retrieve the
	  // template function. Override this method to provide your own
	  // custom rendering and template handling for all of Marionette.
	  render: function render(template, data) {
	    if (!template) {
	      throw new MarionetteError({
	        name: 'TemplateNotFoundError',
	        message: 'Cannot render the template since its false, null or undefined.'
	      });
	    }
	
	    var templateFunc = _.isFunction(template) ? template : TemplateCache.get(template);
	
	    return templateFunc(data);
	  }
	};
	
	// View
	// ---------
	
	var ClassOptions$1 = ['behaviors', 'childViewEventPrefix', 'childViewEvents', 'childViewTriggers', 'collectionEvents', 'events', 'modelEvents', 'regionClass', 'regions', 'template', 'templateContext', 'triggers', 'ui'];
	
	// The standard view. Includes view events, automatic rendering
	// of Underscore templates, nested views, and more.
	var View = Backbone.View.extend({
	  constructor: function constructor(options) {
	    this.render = _.bind(this.render, this);
	
	    this._setOptions(options);
	
	    this.mergeOptions(options, ClassOptions$1);
	
	    monitorViewEvents(this);
	
	    this._initBehaviors();
	    this._initRegions();
	
	    var args = Array.prototype.slice.call(arguments);
	    args[0] = this.options;
	    Backbone.View.prototype.constructor.apply(this, args);
	
	    this.delegateEntityEvents();
	
	    this._triggerEventOnBehaviors('initialize', this);
	  },
	
	
	  // Serialize the view's model *or* collection, if
	  // it exists, for the template
	  serializeData: function serializeData() {
	    if (!this.model && !this.collection) {
	      return {};
	    }
	
	    // If we have a model, we serialize that
	    if (this.model) {
	      return this.serializeModel();
	    }
	
	    // Otherwise, we serialize the collection,
	    // making it available under the `items` property
	    return {
	      items: this.serializeCollection()
	    };
	  },
	
	
	  // Prepares the special `model` property of a view
	  // for being displayed in the template. By default
	  // we simply clone the attributes. Override this if
	  // you need a custom transformation for your view's model
	  serializeModel: function serializeModel() {
	    if (!this.model) {
	      return {};
	    }
	    return _.clone(this.model.attributes);
	  },
	
	
	  // Serialize a collection by cloning each of
	  // its model's attributes
	  serializeCollection: function serializeCollection() {
	    if (!this.collection) {
	      return {};
	    }
	    return this.collection.map(function (model) {
	      return _.clone(model.attributes);
	    });
	  },
	
	
	  // Overriding Backbone.View's `setElement` to handle
	  // if an el was previously defined. If so, the view might be
	  // rendered or attached on setElement.
	  setElement: function setElement() {
	    Backbone.View.prototype.setElement.apply(this, arguments);
	
	    this._isRendered = this.Dom.hasContents(this.el);
	    this._isAttached = isNodeAttached(this.el);
	
	    if (this._isRendered) {
	      this.bindUIElements();
	    }
	
	    return this;
	  },
	
	
	  // Render the view, defaulting to underscore.js templates.
	  // You can override this in your view definition to provide
	  // a very specific rendering for your view. In general, though,
	  // you should override the `Marionette.Renderer` object to
	  // change how Marionette renders views.
	  // Subsequent renders after the first will re-render all nested
	  // views.
	  render: function render() {
	    if (this._isDestroyed) {
	      return this;
	    }
	
	    this.triggerMethod('before:render', this);
	
	    // If this is not the first render call, then we need to
	    // re-initialize the `el` for each region
	    if (this._isRendered) {
	      this._reInitRegions();
	    }
	
	    this._renderTemplate();
	    this.bindUIElements();
	
	    this._isRendered = true;
	    this.triggerMethod('render', this);
	
	    return this;
	  },
	
	
	  // Internal method to render the template with the serialized data
	  // and template context via the `Marionette.Renderer` object.
	  _renderTemplate: function _renderTemplate() {
	    var template = this.getTemplate();
	
	    // Allow template-less views
	    if (template === false) {
	      deprecate('template:false is deprecated.  Use _.noop.');
	      return;
	    }
	
	    // Add in entity data and template context
	    var data = this.mixinTemplateContext(this.serializeData());
	
	    // Render and add to el
	    var html = this._renderHtml(template, data);
	    this.attachElContent(html);
	  },
	
	
	  // Renders the data into the template
	  _renderHtml: function _renderHtml(template, data) {
	    return Renderer.render(template, data, this);
	  },
	
	
	  // Get the template for this view
	  // instance. You can set a `template` attribute in the view
	  // definition or pass a `template: "whatever"` parameter in
	  // to the constructor options.
	  getTemplate: function getTemplate() {
	    return this.template;
	  },
	
	
	  // Mix in template context methods. Looks for a
	  // `templateContext` attribute, which can either be an
	  // object literal, or a function that returns an object
	  // literal. All methods and attributes from this object
	  // are copies to the object passed in.
	  mixinTemplateContext: function mixinTemplateContext() {
	    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var templateContext = _.result(this, 'templateContext');
	    return _.extend(target, templateContext);
	  },
	
	
	  // Attaches the content of a given view.
	  // This method can be overridden to optimize rendering,
	  // or to render in a non standard way.
	  //
	  // For example, using `innerHTML` instead of `$el.html`
	  //
	  // ```js
	  // attachElContent(html) {
	  //   this.el.innerHTML = html;
	  //   return this;
	  // }
	  // ```
	  attachElContent: function attachElContent(html) {
	    this.Dom.setContents(this.el, html, this.$el);
	
	    return this;
	  },
	
	
	  // called by ViewMixin destroy
	  _removeChildren: function _removeChildren() {
	    this.removeRegions();
	  },
	  _getImmediateChildren: function _getImmediateChildren() {
	    return _.chain(this._getRegions()).map('currentView').compact().value();
	  }
	}, {
	  // Sets the renderer for the Marionette.View class
	  setRenderer: function setRenderer(renderer) {
	    this.prototype._renderHtml = renderer;
	    return this;
	  },
	
	
	  setDomApi: setDomApi
	});
	
	_.extend(View.prototype, ViewMixin, RegionsMixin);
	
	// Mix in methods from Underscore, for iteration, and other
	// collection related features.
	// Borrowing this code from Backbone.Collection:
	// https://github.com/jashkenas/backbone/blob/1.1.2/backbone.js#L962
	
	var methods = ['forEach', 'each', 'map', 'find', 'detect', 'filter', 'select', 'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke', 'toArray', 'first', 'initial', 'rest', 'last', 'without', 'isEmpty', 'pluck', 'reduce', 'partition'];
	
	var emulateCollection = function emulateCollection(object, listProperty) {
	  _.each(methods, function (method) {
	    object[method] = function () {
	      var list = _.result(this, listProperty);
	      var args = Array.prototype.slice.call(arguments);
	      return _[method].apply(_, [list].concat(args));
	    };
	  });
	};
	
	// Provide a container to store, retrieve and
	// shut down child views.
	var Container = function Container(views) {
	  this._views = {};
	  this._indexByModel = {};
	  this._indexByCustom = {};
	  this._updateLength();
	
	  _.each(views, _.bind(this.add, this));
	};
	
	emulateCollection(Container.prototype, '_getViews');
	
	// Container Methods
	// -----------------
	
	_.extend(Container.prototype, {
	  _getViews: function _getViews() {
	    return _.values(this._views);
	  },
	
	
	  // Add a view to this container. Stores the view
	  // by `cid` and makes it searchable by the model
	  // cid (and model itself). Optionally specify
	  // a custom key to store an retrieve the view.
	  add: function add(view, customIndex) {
	    return this._add(view, customIndex)._updateLength();
	  },
	
	
	  // To be used when avoiding call _updateLength
	  // When you are done adding all your new views
	  // call _updateLength
	  _add: function _add(view, customIndex) {
	    var viewCid = view.cid;
	
	    // store the view
	    this._views[viewCid] = view;
	
	    // index it by model
	    if (view.model) {
	      this._indexByModel[view.model.cid] = viewCid;
	    }
	
	    // index by custom
	    if (customIndex) {
	      this._indexByCustom[customIndex] = viewCid;
	    }
	
	    return this;
	  },
	
	
	  // Find a view by the model that was attached to
	  // it. Uses the model's `cid` to find it.
	  findByModel: function findByModel(model) {
	    return this.findByModelCid(model.cid);
	  },
	
	
	  // Find a view by the `cid` of the model that was attached to
	  // it. Uses the model's `cid` to find the view `cid` and
	  // retrieve the view using it.
	  findByModelCid: function findByModelCid(modelCid) {
	    var viewCid = this._indexByModel[modelCid];
	    return this.findByCid(viewCid);
	  },
	
	
	  // Find a view by a custom indexer.
	  findByCustom: function findByCustom(index) {
	    var viewCid = this._indexByCustom[index];
	    return this.findByCid(viewCid);
	  },
	
	
	  // Find by index. This is not guaranteed to be a
	  // stable index.
	  findByIndex: function findByIndex(index) {
	    return _.values(this._views)[index];
	  },
	
	
	  // retrieve a view by its `cid` directly
	  findByCid: function findByCid(cid) {
	    return this._views[cid];
	  },
	
	
	  // Remove a view
	  remove: function remove(view) {
	    return this._remove(view)._updateLength();
	  },
	
	
	  // To be used when avoiding call _updateLength
	  // When you are done adding all your new views
	  // call _updateLength
	  _remove: function _remove(view) {
	    var viewCid = view.cid;
	
	    // delete model index
	    if (view.model) {
	      delete this._indexByModel[view.model.cid];
	    }
	
	    // delete custom index
	    _.some(this._indexByCustom, _.bind(function (cid, key) {
	      if (cid === viewCid) {
	        delete this._indexByCustom[key];
	        return true;
	      }
	    }, this));
	
	    // remove the view from the container
	    delete this._views[viewCid];
	
	    return this;
	  },
	
	
	  // Update the `.length` attribute on this container
	  _updateLength: function _updateLength() {
	    this.length = _.size(this._views);
	
	    return this;
	  }
	});
	
	// Collection View
	// ---------------
	
	var ClassOptions$3 = ['behaviors', 'childView', 'childViewEventPrefix', 'childViewEvents', 'childViewOptions', 'childViewTriggers', 'collectionEvents', 'events', 'filter', 'emptyView', 'emptyViewOptions', 'modelEvents', 'reorderOnSort', 'sort', 'triggers', 'ui', 'viewComparator'];
	
	// A view that iterates over a Backbone.Collection
	// and renders an individual child view for each model.
	var CollectionView = Backbone.View.extend({
	
	  // flag for maintaining the sorted order of the collection
	  sort: true,
	
	  // constructor
	  // option to pass `{sort: false}` to prevent the `CollectionView` from
	  // maintaining the sorted order of the collection.
	  // This will fallback onto appending childView's to the end.
	  //
	  // option to pass `{viewComparator: compFunction()}` to allow the `CollectionView`
	  // to use a custom sort order for the collection.
	  constructor: function constructor(options) {
	    this.render = _.bind(this.render, this);
	
	    this._setOptions(options);
	
	    this.mergeOptions(options, ClassOptions$3);
	
	    monitorViewEvents(this);
	
	    this._initBehaviors();
	    this.once('render', this._initialEvents);
	    this._initChildViewStorage();
	    this._bufferedChildren = [];
	
	    var args = Array.prototype.slice.call(arguments);
	    args[0] = this.options;
	    Backbone.View.prototype.constructor.apply(this, args);
	
	    this.delegateEntityEvents();
	
	    this._triggerEventOnBehaviors('initialize', this);
	  },
	
	
	  // Instead of inserting elements one by one into the page, it's much more performant to insert
	  // elements into a document fragment and then insert that document fragment into the page
	  _startBuffering: function _startBuffering() {
	    this._isBuffering = true;
	  },
	  _endBuffering: function _endBuffering() {
	    var shouldTriggerAttach = this._isAttached && this.monitorViewEvents !== false;
	    var triggerOnChildren = shouldTriggerAttach ? this._getImmediateChildren() : [];
	
	    this._isBuffering = false;
	
	    _.each(triggerOnChildren, function (child) {
	      triggerMethodOn(child, 'before:attach', child);
	    });
	
	    this.attachBuffer(this, this._createBuffer());
	
	    _.each(triggerOnChildren, function (child) {
	      child._isAttached = true;
	      triggerMethodOn(child, 'attach', child);
	    });
	
	    this._bufferedChildren = [];
	  },
	  _getImmediateChildren: function _getImmediateChildren() {
	    return _.values(this.children._views);
	  },
	
	
	  // Configured the initial events that the collection view binds to.
	  _initialEvents: function _initialEvents() {
	    if (this.collection) {
	      this.listenTo(this.collection, 'add', this._onCollectionAdd);
	      this.listenTo(this.collection, 'update', this._onCollectionUpdate);
	      this.listenTo(this.collection, 'reset', this.render);
	
	      if (this.sort) {
	        this.listenTo(this.collection, 'sort', this._sortViews);
	      }
	    }
	  },
	
	
	  // Handle a child added to the collection
	  _onCollectionAdd: function _onCollectionAdd(child, collection, opts) {
	    // `index` is present when adding with `at` since BB 1.2; indexOf fallback for < 1.2
	    var index = opts.at !== undefined && (opts.index || collection.indexOf(child));
	
	    // When filtered or when there is no initial index, calculate index.
	    if (this.filter || index === false) {
	      index = _.indexOf(this._filteredSortedModels(index), child);
	    }
	
	    if (this._shouldAddChild(child, index)) {
	      this._destroyEmptyView();
	      this._addChild(child, index);
	    }
	  },
	
	
	  // Handle collection update model removals
	  _onCollectionUpdate: function _onCollectionUpdate(collection, options) {
	    var changes = options.changes;
	    this._removeChildModels(changes.removed);
	  },
	
	
	  // Remove the child views and destroy them.
	  // This function also updates the indices of later views
	  // in the collection in order to keep the children in sync with the collection.
	  // "models" is an array of models and the corresponding views
	  // will be removed and destroyed from the CollectionView
	  _removeChildModels: function _removeChildModels(models) {
	    // Used to determine where to update the remaining
	    // sibling view indices after these views are removed.
	    var removedViews = this._getRemovedViews(models);
	
	    if (!removedViews.length) {
	      return;
	    }
	
	    this.children._updateLength();
	
	    // decrement the index of views after this one
	    this._updateIndices(removedViews, false);
	
	    if (this.isEmpty()) {
	      this._showEmptyView();
	    }
	  },
	
	
	  // Returns the views that will be used for re-indexing
	  // through CollectionView#_updateIndices.
	  _getRemovedViews: function _getRemovedViews(models) {
	    var _this = this;
	
	    // Returning a view means something was removed.
	    return _.reduce(models, function (removingViews, model) {
	      var view = model && _this.children.findByModel(model);
	
	      if (!view || view._isDestroyed) {
	        return removingViews;
	      }
	
	      _this._removeChildView(view);
	
	      removingViews.push(view);
	
	      return removingViews;
	    }, []);
	  },
	  _removeChildView: function _removeChildView(view) {
	    this.triggerMethod('before:remove:child', this, view);
	
	    this.children._remove(view);
	    view._shouldDisableEvents = this.monitorViewEvents === false;
	    destroyView(view);
	
	    this.stopListening(view);
	    this.triggerMethod('remove:child', this, view);
	  },
	
	
	  // Overriding Backbone.View's `setElement` to handle
	  // if an el was previously defined. If so, the view might be
	  // attached on setElement.
	  setElement: function setElement() {
	    Backbone.View.prototype.setElement.apply(this, arguments);
	
	    this._isAttached = isNodeAttached(this.el);
	
	    return this;
	  },
	
	
	  // Render children views. Override this method to provide your own implementation of a
	  // render function for the collection view.
	  render: function render() {
	    if (this._isDestroyed) {
	      return this;
	    }
	    this.triggerMethod('before:render', this);
	    this._renderChildren();
	    this._isRendered = true;
	    this.triggerMethod('render', this);
	    return this;
	  },
	
	
	  // An efficient rendering used for filtering. Instead of modifying the whole DOM for the
	  // collection view, we are only adding or removing the related childrenViews.
	  setFilter: function setFilter(filter) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        preventRender = _ref.preventRender;
	
	    var canBeRendered = this._isRendered && !this._isDestroyed;
	    var filterChanged = this.filter !== filter;
	    var shouldRender = canBeRendered && filterChanged && !preventRender;
	
	    if (shouldRender) {
	      var previousModels = this._filteredSortedModels();
	      this.filter = filter;
	      var models = this._filteredSortedModels();
	      this._applyModelDeltas(models, previousModels);
	    } else {
	      this.filter = filter;
	    }
	
	    return this;
	  },
	
	
	  // `removeFilter` is actually an alias for removing filters.
	  removeFilter: function removeFilter(options) {
	    return this.setFilter(null, options);
	  },
	
	
	  // Calculate and apply difference by cid between `models` and `previousModels`.
	  _applyModelDeltas: function _applyModelDeltas(models, previousModels) {
	    var _this2 = this;
	
	    var currentIds = {};
	    _.each(models, function (model, index) {
	      var addedChildNotExists = !_this2.children.findByModel(model);
	      if (addedChildNotExists) {
	        _this2._onCollectionAdd(model, _this2.collection, { at: index });
	      }
	      currentIds[model.cid] = true;
	    });
	
	    var removeModels = _.filter(previousModels, function (prevModel) {
	      return !currentIds[prevModel.cid] && _this2.children.findByModel(prevModel);
	    });
	
	    this._removeChildModels(removeModels);
	  },
	
	
	  // Reorder DOM after sorting. When your element's rendering do not use their index,
	  // you can pass reorderOnSort: true to only reorder the DOM after a sort instead of
	  // rendering all the collectionView.
	  reorder: function reorder() {
	    var _this3 = this;
	
	    var children = this.children;
	    var models = this._filteredSortedModels();
	
	    if (!models.length && this._showingEmptyView) {
	      return this;
	    }
	
	    var anyModelsAdded = _.some(models, function (model) {
	      return !children.findByModel(model);
	    });
	
	    // If there are any new models added due to filtering we need to add child views,
	    // so render as normal.
	    if (anyModelsAdded) {
	      this.render();
	    } else {
	
	      var filteredOutModels = [];
	
	      // Get the DOM nodes in the same order as the models and
	      // find the model that were children before but aren't in this new order.
	      var elsToReorder = _.reduce(this.children._views, function (viewEls, view) {
	        var index = _.indexOf(models, view.model);
	
	        if (index === -1) {
	          filteredOutModels.push(view.model);
	          return viewEls;
	        }
	
	        view._index = index;
	
	        viewEls[index] = view.el;
	
	        return viewEls;
	      }, new Array(models.length));
	
	      this.triggerMethod('before:reorder', this);
	
	      var elBuffer = this.Dom.createBuffer();
	
	      _.each(elsToReorder, function (el) {
	        _this3.Dom.appendContents(elBuffer, el);
	      });
	
	      // Since append moves elements that are already in the DOM, appending the elements
	      // will effectively reorder them.
	      this._appendReorderedChildren(elBuffer);
	
	      // remove any views that have been filtered out
	      this._removeChildModels(filteredOutModels);
	
	      this.triggerMethod('reorder', this);
	    }
	    return this;
	  },
	
	
	  // Render view after sorting. Override this method to change how the view renders
	  // after a `sort` on the collection.
	  resortView: function resortView() {
	    if (this.reorderOnSort) {
	      this.reorder();
	    } else {
	      this._renderChildren();
	    }
	    return this;
	  },
	
	
	  // Internal method. This checks for any changes in the order of the collection.
	  // If the index of any view doesn't match, it will render.
	  _sortViews: function _sortViews() {
	    var _this4 = this;
	
	    var models = this._filteredSortedModels();
	
	    // check for any changes in sort order of views
	    var orderChanged = _.find(models, function (item, index) {
	      var view = _this4.children.findByModel(item);
	      return !view || view._index !== index;
	    });
	
	    if (orderChanged) {
	      this.resortView();
	    }
	  },
	
	
	  // Internal reference to what index a `emptyView` is.
	  _emptyViewIndex: -1,
	
	  // Internal method. Separated so that CompositeView can append to the childViewContainer
	  // if necessary
	  _appendReorderedChildren: function _appendReorderedChildren(children) {
	    this.Dom.appendContents(this.el, children, { _$el: this.$el });
	  },
	
	
	  // Internal method. Separated so that CompositeView can have more control over events
	  // being triggered, around the rendering process
	  _renderChildren: function _renderChildren() {
	    if (this._isRendered) {
	      this._destroyEmptyView();
	      this._destroyChildren();
	    }
	
	    var models = this._filteredSortedModels();
	    if (this.isEmpty({ processedModels: models })) {
	      this._showEmptyView();
	    } else {
	      this.triggerMethod('before:render:children', this);
	      this._startBuffering();
	      this._showCollection(models);
	      this._endBuffering();
	      this.triggerMethod('render:children', this);
	    }
	  },
	  _createView: function _createView(model, index) {
	    var ChildView = this._getChildView(model);
	    var childViewOptions = this._getChildViewOptions(model, index);
	    var view = this.buildChildView(model, ChildView, childViewOptions);
	    return view;
	  },
	  _setupChildView: function _setupChildView(view, index) {
	    monitorViewEvents(view);
	
	    // set up the child view event forwarding
	    this._proxyChildViewEvents(view);
	
	    if (this.sort) {
	      view._index = index;
	    }
	  },
	
	
	  // Internal method to loop through collection and show each child view.
	  _showCollection: function _showCollection(models) {
	    _.each(models, _.bind(this._addChild, this));
	    this.children._updateLength();
	  },
	
	
	  // Allow the collection to be sorted by a custom view comparator
	  _filteredSortedModels: function _filteredSortedModels(addedAt) {
	    if (!this.collection || !this.collection.length) {
	      return [];
	    }
	
	    var viewComparator = this.getViewComparator();
	    var models = this.collection.models;
	    addedAt = Math.min(Math.max(addedAt, 0), models.length - 1);
	
	    if (viewComparator) {
	      var addedModel = void 0;
	      // Preserve `at` location, even for a sorted view
	      if (addedAt) {
	        addedModel = models[addedAt];
	        models = models.slice(0, addedAt).concat(models.slice(addedAt + 1));
	      }
	      models = this._sortModelsBy(models, viewComparator);
	      if (addedModel) {
	        models.splice(addedAt, 0, addedModel);
	      }
	    }
	
	    // Filter after sorting in case the filter uses the index
	    models = this._filterModels(models);
	
	    return models;
	  },
	  getViewComparator: function getViewComparator() {
	    return this.viewComparator;
	  },
	
	
	  // Filter an array of models, if a filter exists
	  _filterModels: function _filterModels(models) {
	    var _this5 = this;
	
	    if (this.filter) {
	      models = _.filter(models, function (model, index) {
	        return _this5._shouldAddChild(model, index);
	      });
	    }
	    return models;
	  },
	  _sortModelsBy: function _sortModelsBy(models, comparator) {
	    if (typeof comparator === 'string') {
	      return _.sortBy(models, function (model) {
	        return model.get(comparator);
	      });
	    } else if (comparator.length === 1) {
	      return _.sortBy(models, _.bind(comparator, this));
	    } else {
	      return _.clone(models).sort(_.bind(comparator, this));
	    }
	  },
	
	
	  // Internal method to show an empty view in place of a collection of child views,
	  // when the collection is empty
	  _showEmptyView: function _showEmptyView() {
	    var EmptyView = this._getEmptyView();
	
	    if (EmptyView && !this._showingEmptyView) {
	      this._showingEmptyView = true;
	
	      var model = new Backbone.Model();
	      var emptyViewOptions = this.emptyViewOptions || this.childViewOptions;
	      if (_.isFunction(emptyViewOptions)) {
	        emptyViewOptions = emptyViewOptions.call(this, model, this._emptyViewIndex);
	      }
	
	      var view = this.buildChildView(model, EmptyView, emptyViewOptions);
	
	      this.triggerMethod('before:render:empty', this, view);
	      this.addChildView(view, 0);
	      this.triggerMethod('render:empty', this, view);
	    }
	  },
	
	
	  // Internal method to destroy an existing emptyView instance if one exists. Called when
	  // a collection view has been rendered empty, and then a child is added to the collection.
	  _destroyEmptyView: function _destroyEmptyView() {
	    if (this._showingEmptyView) {
	      this.triggerMethod('before:remove:empty', this);
	
	      this._destroyChildren();
	      delete this._showingEmptyView;
	
	      this.triggerMethod('remove:empty', this);
	    }
	  },
	
	
	  // Retrieve the empty view class
	  _getEmptyView: function _getEmptyView() {
	    var emptyView = this.emptyView;
	
	    if (!emptyView) {
	      return;
	    }
	
	    return this._getView(emptyView);
	  },
	
	
	  // Retrieve the `childView` class
	  // The `childView` property can be either a view class or a function that
	  // returns a view class. If it is a function, it will receive the model that
	  // will be passed to the view instance (created from the returned view class)
	  _getChildView: function _getChildView(child) {
	    var childView = this.childView;
	
	    if (!childView) {
	      throw new MarionetteError({
	        name: 'NoChildViewError',
	        message: 'A "childView" must be specified'
	      });
	    }
	
	    childView = this._getView(childView, child);
	
	    if (!childView) {
	      throw new MarionetteError({
	        name: 'InvalidChildViewError',
	        message: '"childView" must be a view class or a function that returns a view class'
	      });
	    }
	
	    return childView;
	  },
	
	
	  // First check if the `view` is a view class (the common case)
	  // Then check if it's a function (which we assume that returns a view class)
	  _getView: function _getView(view, child) {
	    if (view.prototype instanceof Backbone.View || view === Backbone.View) {
	      return view;
	    } else if (_.isFunction(view)) {
	      return view.call(this, child);
	    }
	  },
	
	
	  // Internal method for building and adding a child view
	  _addChild: function _addChild(child, index) {
	    var view = this._createView(child, index);
	    this.addChildView(view, index);
	
	    return view;
	  },
	  _getChildViewOptions: function _getChildViewOptions(child, index) {
	    if (_.isFunction(this.childViewOptions)) {
	      return this.childViewOptions(child, index);
	    }
	
	    return this.childViewOptions;
	  },
	
	
	  // Render the child's view and add it to the HTML for the collection view at a given index.
	  // This will also update the indices of later views in the collection in order to keep the
	  // children in sync with the collection.
	  addChildView: function addChildView(view, index) {
	    this.triggerMethod('before:add:child', this, view);
	    this._setupChildView(view, index);
	
	    // Store the child view itself so we can properly remove and/or destroy it later
	    if (this._isBuffering) {
	      // Add to children, but don't update children's length.
	      this.children._add(view);
	    } else {
	      // increment indices of views after this one
	      this._updateIndices(view, true);
	      this.children.add(view);
	    }
	
	    renderView(view);
	
	    this._attachView(view, index);
	
	    this.triggerMethod('add:child', this, view);
	
	    return view;
	  },
	
	
	  // Internal method. This decrements or increments the indices of views after the added/removed
	  // view to keep in sync with the collection.
	  _updateIndices: function _updateIndices(views, increment) {
	    if (!this.sort) {
	      return;
	    }
	
	    if (!increment) {
	      _.each(_.sortBy(this.children._views, '_index'), function (view, index) {
	        view._index = index;
	      });
	
	      return;
	    }
	
	    var view = _.isArray(views) ? _.max(views, '_index') : views;
	
	    if (_.isObject(view)) {
	      // update the indexes of views after this one
	      _.each(this.children._views, function (laterView) {
	        if (laterView._index >= view._index) {
	          laterView._index += 1;
	        }
	      });
	    }
	  },
	  _attachView: function _attachView(view, index) {
	    // Only trigger attach if already attached and not buffering,
	    // otherwise _endBuffering() or Region#show() handles this.
	    var shouldTriggerAttach = !view._isAttached && !this._isBuffering && this._isAttached && this.monitorViewEvents !== false;
	
	    if (shouldTriggerAttach) {
	      triggerMethodOn(view, 'before:attach', view);
	    }
	
	    this.attachHtml(this, view, index);
	
	    if (shouldTriggerAttach) {
	      view._isAttached = true;
	      triggerMethodOn(view, 'attach', view);
	    }
	  },
	
	
	  // Build a `childView` for a model in the collection.
	  buildChildView: function buildChildView(child, ChildViewClass, childViewOptions) {
	    var options = _.extend({ model: child }, childViewOptions);
	    return new ChildViewClass(options);
	  },
	
	
	  // Remove the child view and destroy it. This function also updates the indices of later views
	  // in the collection in order to keep the children in sync with the collection.
	  removeChildView: function removeChildView(view) {
	    if (!view || view._isDestroyed) {
	      return view;
	    }
	
	    this._removeChildView(view);
	    this.children._updateLength();
	    // decrement the index of views after this one
	    this._updateIndices(view, false);
	    return view;
	  },
	
	
	  // check if the collection is empty or optionally whether an array of pre-processed models is empty
	  isEmpty: function isEmpty(options) {
	    var models = void 0;
	    if (_.result(options, 'processedModels')) {
	      models = options.processedModels;
	    } else {
	      models = this.collection ? this.collection.models : [];
	      models = this._filterModels(models);
	    }
	    return models.length === 0;
	  },
	
	
	  // You might need to override this if you've overridden attachHtml
	  attachBuffer: function attachBuffer(collectionView, buffer) {
	    this.Dom.appendContents(collectionView.el, buffer, { _$el: collectionView.$el });
	  },
	
	
	  // Create a fragment buffer from the currently buffered children
	  _createBuffer: function _createBuffer() {
	    var _this6 = this;
	
	    var elBuffer = this.Dom.createBuffer();
	    _.each(this._bufferedChildren, function (b) {
	      _this6.Dom.appendContents(elBuffer, b.el, { _$contents: b.$el });
	    });
	    return elBuffer;
	  },
	
	
	  // Append the HTML to the collection's `el`. Override this method to do something other
	  // than `.append`.
	  attachHtml: function attachHtml(collectionView, childView, index) {
	    if (collectionView._isBuffering) {
	      // buffering happens on reset events and initial renders
	      // in order to reduce the number of inserts into the
	      // document, which are expensive.
	      collectionView._bufferedChildren.splice(index, 0, childView);
	    } else {
	      // If we've already rendered the main collection, append
	      // the new child into the correct order if we need to. Otherwise
	      // append to the end.
	      if (!collectionView._insertBefore(childView, index)) {
	        collectionView._insertAfter(childView);
	      }
	    }
	  },
	
	
	  // Internal method. Check whether we need to insert the view into the correct position.
	  _insertBefore: function _insertBefore(childView, index) {
	    var currentView = void 0;
	    var findPosition = this.sort && index < this.children.length - 1;
	    if (findPosition) {
	      // Find the view after this one
	      currentView = _.find(this.children._views, function (view) {
	        return view._index === index + 1;
	      });
	    }
	
	    if (currentView) {
	      this.beforeEl(currentView.el, childView.el);
	      return true;
	    }
	
	    return false;
	  },
	
	
	  // Override to handle DOM inserting differently
	  beforeEl: function beforeEl(el, siblings) {
	    this.$(el).before(siblings);
	  },
	
	
	  // Internal method. Append a view to the end of the $el
	  _insertAfter: function _insertAfter(childView) {
	    this.Dom.appendContents(this.el, childView.el, { _$el: this.$el, _$contents: childView.$el });
	  },
	
	
	  // Internal method to set up the `children` object for storing all of the child views
	  _initChildViewStorage: function _initChildViewStorage() {
	    this.children = new Container();
	  },
	
	
	  // called by ViewMixin destroy
	  _removeChildren: function _removeChildren() {
	    this._destroyChildren();
	  },
	
	
	  // Destroy the child views that this collection view is holding on to, if any
	  _destroyChildren: function _destroyChildren(options) {
	    if (!this.children.length) {
	      return;
	    }
	
	    this.triggerMethod('before:destroy:children', this);
	    _.each(this.children._views, _.bind(this._removeChildView, this));
	    this.children._updateLength();
	    this.triggerMethod('destroy:children', this);
	  },
	
	
	  // Return true if the given child should be shown. Return false otherwise.
	  // The filter will be passed (child, index, collection), where
	  //  'child' is the given model
	  //  'index' is the index of that model in the collection
	  //  'collection' is the collection referenced by this CollectionView
	  _shouldAddChild: function _shouldAddChild(child, index) {
	    var filter = this.filter;
	    return !_.isFunction(filter) || filter.call(this, child, index, this.collection);
	  }
	}, {
	  setDomApi: setDomApi
	});
	
	_.extend(CollectionView.prototype, ViewMixin);
	
	// Provide a container to store, retrieve and
	// shut down child views.
	var Container$1 = function Container() {
	  this._init();
	};
	
	emulateCollection(Container$1.prototype, '_views');
	
	function stringComparator(comparator, view) {
	  return view.model && view.model.get(comparator);
	}
	
	// Container Methods
	// -----------------
	
	_.extend(Container$1.prototype, {
	
	  // Initializes an empty container
	  _init: function _init() {
	    this._views = [];
	    this._viewsByCid = {};
	    this._indexByModel = {};
	    this._updateLength();
	  },
	
	
	  // Add a view to this container. Stores the view
	  // by `cid` and makes it searchable by the model
	  // cid (and model itself). Additionally it stores
	  // the view by index in the _views array
	  _add: function _add(view) {
	    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._views.length;
	
	    var viewCid = view.cid;
	
	    // store the view
	    this._viewsByCid[viewCid] = view;
	
	    // index it by model
	    if (view.model) {
	      this._indexByModel[view.model.cid] = viewCid;
	    }
	
	    // add to end by default
	    this._views.splice(index, 0, view);
	
	    this._updateLength();
	  },
	
	
	  // Sort (mutate) and return the array of the child views.
	  _sort: function _sort(comparator, context) {
	    if (typeof comparator === 'string') {
	      comparator = _.partial(stringComparator, comparator);
	      return this._sortBy(comparator);
	    }
	
	    if (comparator.length === 1) {
	      return this._sortBy(_.bind(comparator, context));
	    }
	
	    return this._views.sort(_.bind(comparator, context));
	  },
	
	
	  // Makes `_.sortBy` mutate the array to match `this._views.sort`
	  _sortBy: function _sortBy(comparator) {
	    var sortedViews = _.sortBy(this._views, comparator);
	
	    this._set(sortedViews);
	
	    return sortedViews;
	  },
	
	
	  // Replace array contents without overwriting the reference.
	  _set: function _set(views) {
	    this._views.length = 0;
	
	    this._views.push.apply(this._views, views.slice(0));
	
	    this._updateLength();
	  },
	
	
	  // Swap views by index
	  _swap: function _swap(view1, view2) {
	    var view1Index = this.findIndexByView(view1);
	    var view2Index = this.findIndexByView(view2);
	
	    if (view1Index === -1 || view2Index === -1) {
	      return;
	    }
	
	    var swapView = this._views[view1Index];
	    this._views[view1Index] = this._views[view2Index];
	    this._views[view2Index] = swapView;
	  },
	
	
	  // Find a view by the model that was attached to it.
	  // Uses the model's `cid` to find it.
	  findByModel: function findByModel(model) {
	    return this.findByModelCid(model.cid);
	  },
	
	
	  // Find a view by the `cid` of the model that was attached to it.
	  // Uses the model's `cid` to find the view `cid` and
	  // retrieve the view using it.
	  findByModelCid: function findByModelCid(modelCid) {
	    var viewCid = this._indexByModel[modelCid];
	    return this.findByCid(viewCid);
	  },
	
	
	  // Find a view by index.
	  findByIndex: function findByIndex(index) {
	    return this._views[index];
	  },
	
	
	  // Find the index of a view instance
	  findIndexByView: function findIndexByView(view) {
	    return this._views.indexOf(view);
	  },
	
	
	  // Retrieve a view by its `cid` directly
	  findByCid: function findByCid(cid) {
	    return this._viewsByCid[cid];
	  },
	  hasView: function hasView(view) {
	    return !!this.findByCid(view.cid);
	  },
	
	
	  // Remove a view and clean up index references.
	  _remove: function _remove(view) {
	    if (!this._viewsByCid[view.cid]) {
	      return;
	    }
	
	    // delete model index
	    if (view.model) {
	      delete this._indexByModel[view.model.cid];
	    }
	
	    // remove the view from the container
	    delete this._viewsByCid[view.cid];
	
	    var index = this.findIndexByView(view);
	    this._views.splice(index, 1);
	
	    this._updateLength();
	  },
	
	
	  // Update the `.length` attribute on this container
	  _updateLength: function _updateLength() {
	    this.length = this._views.length;
	  }
	});
	
	// Next Collection View
	// ---------------
	
	var ClassOptions$4 = ['behaviors', 'childView', 'childViewEventPrefix', 'childViewEvents', 'childViewOptions', 'childViewTriggers', 'collectionEvents', 'emptyView', 'emptyViewOptions', 'events', 'modelEvents', 'sortWithCollection', 'triggers', 'ui', 'viewComparator', 'viewFilter'];
	
	// A view that iterates over a Backbone.Collection
	// and renders an individual child view for each model.
	var CollectionView$2 = Backbone.View.extend({
	  // flag for maintaining the sorted order of the collection
	  sortWithCollection: true,
	
	  // constructor
	  constructor: function constructor(options) {
	    this._setOptions(options);
	
	    this.mergeOptions(options, ClassOptions$4);
	
	    monitorViewEvents(this);
	
	    this.once('render', this._initialEvents);
	
	    // This children container isn't really used by a render, but it provides
	    // the ability to check `this.children.length` prior to rendering
	    // It also allows for cases where only addChildView is used
	    this._initChildViewStorage();
	    this._initBehaviors();
	
	    var args = Array.prototype.slice.call(arguments);
	    args[0] = this.options;
	    Backbone.View.prototype.constructor.apply(this, args);
	
	    // Init empty region
	    this.getEmptyRegion();
	
	    this.delegateEntityEvents();
	
	    this._triggerEventOnBehaviors('initialize', this);
	  },
	
	
	  // Internal method to set up the `children` object for storing all of the child views
	  _initChildViewStorage: function _initChildViewStorage() {
	    this.children = new Container$1();
	  },
	
	
	  // Create an region to show the emptyView
	  getEmptyRegion: function getEmptyRegion() {
	    if (this._emptyRegion && !this._emptyRegion.isDestroyed()) {
	      return this._emptyRegion;
	    }
	
	    this._emptyRegion = new Region({ el: this.el, replaceElement: false });
	
	    this._emptyRegion._parentView = this;
	
	    return this._emptyRegion;
	  },
	
	
	  // Configured the initial events that the collection view binds to.
	  _initialEvents: function _initialEvents() {
	    this.listenTo(this.collection, {
	      'sort': this._onCollectionSort,
	      'reset': this._onCollectionReset,
	      'update': this._onCollectionUpdate
	    });
	  },
	
	
	  // Internal method. This checks for any changes in the order of the collection.
	  // If the index of any view doesn't match, it will re-sort.
	  _onCollectionSort: function _onCollectionSort(collection, _ref) {
	    var add = _ref.add,
	        merge = _ref.merge,
	        remove = _ref.remove;
	
	    if (!this.sortWithCollection || this.viewComparator === false) {
	      return;
	    }
	
	    // If the data is changing we will handle the sort later in `_onCollectionUpdate`
	    if (add || remove || merge) {
	      return;
	    }
	
	    // If the only thing happening here is sorting, sort.
	    this.sort();
	  },
	  _onCollectionReset: function _onCollectionReset() {
	    this.render();
	  },
	
	
	  // Handle collection update model additions and  removals
	  _onCollectionUpdate: function _onCollectionUpdate(collection, options) {
	    var changes = options.changes;
	
	    // Remove first since it'll be a shorter array lookup.
	    var removedViews = changes.removed.length && this._removeChildModels(changes.removed);
	
	    this._addedViews = changes.added.length && this._addChildModels(changes.added);
	
	    this._detachChildren(removedViews);
	
	    this._showChildren();
	
	    // Destroy removed child views after all of the render is complete
	    this._removeChildViews(removedViews);
	  },
	  _removeChildModels: function _removeChildModels(models) {
	    var _this = this;
	
	    return _.reduce(models, function (views, model) {
	      var removeView = _this._removeChildModel(model);
	
	      if (removeView) {
	        views.push(removeView);
	      }
	
	      return views;
	    }, []);
	  },
	  _removeChildModel: function _removeChildModel(model) {
	    var view = this.children.findByModel(model);
	
	    if (view) {
	      this._removeChild(view);
	    }
	
	    return view;
	  },
	  _removeChild: function _removeChild(view) {
	    this.triggerMethod('before:remove:child', this, view);
	
	    this.children._remove(view);
	
	    this.triggerMethod('remove:child', this, view);
	  },
	
	
	  // Added views are returned for consistency with _removeChildModels
	  _addChildModels: function _addChildModels(models) {
	    return _.map(models, _.bind(this._addChildModel, this));
	  },
	  _addChildModel: function _addChildModel(model) {
	    var view = this._createChildView(model);
	
	    this._addChild(view);
	
	    return view;
	  },
	  _createChildView: function _createChildView(model) {
	    var ChildView = this._getChildView(model);
	    var childViewOptions = this._getChildViewOptions(model);
	    var view = this.buildChildView(model, ChildView, childViewOptions);
	
	    return view;
	  },
	  _addChild: function _addChild(view, index) {
	    this.triggerMethod('before:add:child', this, view);
	
	    this._setupChildView(view);
	    this.children._add(view, index);
	
	    this.triggerMethod('add:child', this, view);
	  },
	
	
	  // Retrieve the `childView` class
	  // The `childView` property can be either a view class or a function that
	  // returns a view class. If it is a function, it will receive the model that
	  // will be passed to the view instance (created from the returned view class)
	  _getChildView: function _getChildView(child) {
	    var childView = this.childView;
	
	    if (!childView) {
	      throw new MarionetteError({
	        name: 'NoChildViewError',
	        message: 'A "childView" must be specified'
	      });
	    }
	
	    childView = this._getView(childView, child);
	
	    if (!childView) {
	      throw new MarionetteError({
	        name: 'InvalidChildViewError',
	        message: '"childView" must be a view class or a function that returns a view class'
	      });
	    }
	
	    return childView;
	  },
	
	
	  // First check if the `view` is a view class (the common case)
	  // Then check if it's a function (which we assume that returns a view class)
	  _getView: function _getView(view, child) {
	    if (view.prototype instanceof Backbone.View || view === Backbone.View) {
	      return view;
	    } else if (_.isFunction(view)) {
	      return view.call(this, child);
	    }
	  },
	  _getChildViewOptions: function _getChildViewOptions(child) {
	    if (_.isFunction(this.childViewOptions)) {
	      return this.childViewOptions(child);
	    }
	
	    return this.childViewOptions;
	  },
	
	
	  // Build a `childView` for a model in the collection.
	  // Override to customize the build
	  buildChildView: function buildChildView(child, ChildViewClass, childViewOptions) {
	    var options = _.extend({ model: child }, childViewOptions);
	    return new ChildViewClass(options);
	  },
	  _setupChildView: function _setupChildView(view) {
	    monitorViewEvents(view);
	
	    // We need to listen for if a view is destroyed in a way other
	    // than through the CollectionView.
	    // If this happens we need to remove the reference to the view
	    // since once a view has been destroyed we can not reuse it.
	    view.on('destroy', this.removeChildView, this);
	
	    // set up the child view event forwarding
	    this._proxyChildViewEvents(view);
	  },
	
	
	  // used by ViewMixin's `_childViewEventHandler`
	  _getImmediateChildren: function _getImmediateChildren() {
	    return this.children._views;
	  },
	
	
	  // Overriding Backbone.View's `setElement` to handle
	  // if an el was previously defined. If so, the view might be
	  // attached on setElement.
	  setElement: function setElement() {
	    Backbone.View.prototype.setElement.apply(this, arguments);
	
	    this._isAttached = isNodeAttached(this.el);
	
	    return this;
	  },
	
	
	  // Render children views.
	  render: function render() {
	    if (this._isDestroyed) {
	      return this;
	    }
	    this.triggerMethod('before:render', this);
	
	    this._destroyChildren();
	
	    // After all children have been destroyed re-init the container
	    this.children._init();
	
	    if (this.collection) {
	      this._addChildModels(this.collection.models);
	    }
	
	    this._showChildren();
	
	    this._isRendered = true;
	
	    this.triggerMethod('render', this);
	    return this;
	  },
	
	
	  // Sorts the children then filters and renders the results.
	  sort: function sort() {
	    if (this._isDestroyed) {
	      return this;
	    }
	
	    if (!this.children.length) {
	      return this;
	    }
	
	    this._showChildren();
	
	    return this;
	  },
	  _showChildren: function _showChildren() {
	    if (this.isEmpty()) {
	      this._showEmptyView();
	      return;
	    }
	
	    this._sortChildren();
	
	    this.filter();
	  },
	
	
	  // Returns true if the collectionView is considered empty.
	  // This is called twice during a render. Once to check the data,
	  // and again when views are filtered. Override this function to
	  // customize what empty means.
	  isEmpty: function isEmpty(allViewsFiltered) {
	    return allViewsFiltered || !this.children.length;
	  },
	  _showEmptyView: function _showEmptyView() {
	    var EmptyView = this._getEmptyView();
	
	    if (!EmptyView) {
	      return;
	    }
	
	    var options = this._getEmptyViewOptions();
	
	    var emptyRegion = this.getEmptyRegion();
	
	    emptyRegion.show(new EmptyView(options));
	  },
	
	
	  // Retrieve the empty view class
	  _getEmptyView: function _getEmptyView() {
	    var emptyView = this.emptyView;
	
	    if (!emptyView) {
	      return;
	    }
	
	    return this._getView(emptyView);
	  },
	
	
	  // Remove the emptyView
	  _destroyEmptyView: function _destroyEmptyView() {
	    var emptyRegion = this.getEmptyRegion();
	    // Only empty if a view is show so the region
	    // doesn't detach any other unrelated HTML
	    if (emptyRegion.hasView()) {
	      emptyRegion.empty();
	    }
	  },
	
	
	  //
	  _getEmptyViewOptions: function _getEmptyViewOptions() {
	    var emptyViewOptions = this.emptyViewOptions || this.childViewOptions;
	
	    if (_.isFunction(emptyViewOptions)) {
	      return emptyViewOptions.call(this);
	    }
	
	    return emptyViewOptions;
	  },
	
	
	  // Sorts views by viewComparator and sets the children to the new order
	  _sortChildren: function _sortChildren() {
	    var viewComparator = this.getComparator();
	
	    if (!viewComparator) {
	      return;
	    }
	
	    // If children are sorted prevent added to end perf
	    delete this._addedViews;
	
	    this.triggerMethod('before:sort', this);
	
	    this.children._sort(viewComparator, this);
	
	    this.triggerMethod('sort', this);
	  },
	
	
	  // Sets the view's `viewComparator` and applies the sort if the view is ready.
	  // To prevent the render pass `{ preventRender: true }` as the 2nd argument.
	  setComparator: function setComparator(comparator) {
	    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        preventRender = _ref2.preventRender;
	
	    var comparatorChanged = this.viewComparator !== comparator;
	    var shouldSort = comparatorChanged && !preventRender;
	
	    this.viewComparator = comparator;
	
	    if (shouldSort) {
	      this.sort();
	    }
	
	    return this;
	  },
	
	
	  // Clears the `viewComparator` and follows the same rules for rendering as `setComparator`.
	  removeComparator: function removeComparator(options) {
	    return this.setComparator(null, options);
	  },
	
	
	  // If viewComparator is overriden it will be returned here.
	  // Additionally override this function to provide custom
	  // viewComparator logic
	  getComparator: function getComparator() {
	    if (this.viewComparator) {
	      return this.viewComparator;
	    }
	
	    if (!this.sortWithCollection || this.viewComparator === false || !this.collection) {
	      return false;
	    }
	
	    return this._viewComparator;
	  },
	
	
	  // Default internal view comparator that order the views by
	  // the order of the collection
	  _viewComparator: function _viewComparator(view) {
	    return this.collection.indexOf(view.model);
	  },
	
	
	  // This method re-filters the children views and re-renders the results
	  filter: function filter() {
	    if (this._isDestroyed) {
	      return this;
	    }
	
	    if (!this.children.length) {
	      return this;
	    }
	
	    var filteredViews = this._filterChildren();
	
	    this._renderChildren(filteredViews);
	
	    return this;
	  },
	  _filterChildren: function _filterChildren() {
	    var _this2 = this;
	
	    var viewFilter = this._getFilter();
	    var addedViews = this._addedViews;
	
	    delete this._addedViews;
	
	    if (!viewFilter) {
	      if (addedViews) {
	        return addedViews;
	      }
	
	      return this.children._views;
	    }
	
	    this.triggerMethod('before:filter', this);
	
	    var attachViews = [];
	    var detachViews = [];
	
	    _.each(this.children._views, function (view, key, children) {
	      (viewFilter.call(_this2, view, key, children) ? attachViews : detachViews).push(view);
	    });
	
	    this._detachChildren(detachViews);
	
	    this.triggerMethod('filter', this, attachViews, detachViews);
	
	    return attachViews;
	  },
	
	
	  // This method returns a function for the viewFilter
	  _getFilter: function _getFilter() {
	    var viewFilter = this.getFilter();
	
	    if (!viewFilter) {
	      return false;
	    }
	
	    if (_.isFunction(viewFilter)) {
	      return viewFilter;
	    }
	
	    // Support filter predicates `{ fooFlag: true }`
	    if (_.isObject(viewFilter)) {
	      var matcher = _.matches(viewFilter);
	      return function (view) {
	        return matcher(view.model && view.model.attributes);
	      };
	    }
	
	    // Filter by model attribute
	    if (_.isString(viewFilter)) {
	      return function (view) {
	        return view.model && view.model.get(viewFilter);
	      };
	    }
	
	    throw new MarionetteError({
	      name: 'InvalidViewFilterError',
	      message: '"viewFilter" must be a function, predicate object literal, a string indicating a model attribute, or falsy'
	    });
	  },
	
	
	  // Override this function to provide custom
	  // viewFilter logic
	  getFilter: function getFilter() {
	    return this.viewFilter;
	  },
	
	
	  // Sets the view's `viewFilter` and applies the filter if the view is ready.
	  // To prevent the render pass `{ preventRender: true }` as the 2nd argument.
	  setFilter: function setFilter(filter) {
	    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        preventRender = _ref3.preventRender;
	
	    var filterChanged = this.viewFilter !== filter;
	    var shouldRender = filterChanged && !preventRender;
	
	    this.viewFilter = filter;
	
	    if (shouldRender) {
	      this.filter();
	    }
	
	    return this;
	  },
	
	
	  // Clears the `viewFilter` and follows the same rules for rendering as `setFilter`.
	  removeFilter: function removeFilter(options) {
	    return this.setFilter(null, options);
	  },
	  _detachChildren: function _detachChildren(detachingViews) {
	    _.each(detachingViews, _.bind(this._detachChildView, this));
	  },
	  _detachChildView: function _detachChildView(view) {
	    var shouldTriggerDetach = view._isAttached && this.monitorViewEvents !== false;
	    if (shouldTriggerDetach) {
	      triggerMethodOn(view, 'before:detach', view);
	    }
	
	    this.detachHtml(view);
	
	    if (shouldTriggerDetach) {
	      view._isAttached = false;
	      triggerMethodOn(view, 'detach', view);
	    }
	  },
	
	
	  // Override this method to change how the collectionView detaches a child view
	  detachHtml: function detachHtml(view) {
	    this.Dom.detachEl(view.el, view.$el);
	  },
	  _renderChildren: function _renderChildren(views) {
	    if (this.isEmpty(!views.length)) {
	      this._showEmptyView();
	      return;
	    }
	
	    this._destroyEmptyView();
	
	    this.triggerMethod('before:render:children', this, views);
	
	    var els = this._getBuffer(views);
	
	    this._attachChildren(els, views);
	
	    this.triggerMethod('render:children', this, views);
	  },
	  _attachChildren: function _attachChildren(els, views) {
	    var shouldTriggerAttach = this._isAttached && this.monitorViewEvents !== false;
	
	    views = shouldTriggerAttach ? views : [];
	
	    _.each(views, function (view) {
	      if (view._isAttached) {
	        return;
	      }
	      triggerMethodOn(view, 'before:attach', view);
	    });
	
	    this.attachHtml(els);
	
	    _.each(views, function (view) {
	      if (view._isAttached) {
	        return;
	      }
	      view._isAttached = true;
	      triggerMethodOn(view, 'attach', view);
	    });
	  },
	
	
	  // Renders each view in children and creates a fragment buffer from them
	  _getBuffer: function _getBuffer(views) {
	    var _this3 = this;
	
	    var elBuffer = this.Dom.createBuffer();
	
	    _.each(views, function (view) {
	      renderView(view);
	      _this3.Dom.appendContents(elBuffer, view.el, { _$contents: view.$el });
	    });
	
	    return elBuffer;
	  },
	
	
	  // Override this method to do something other than `.append`.
	  // You can attach any HTML at this point including the els.
	  attachHtml: function attachHtml(els) {
	    this.Dom.appendContents(this.el, els, { _$el: this.$el });
	  },
	  swapChildViews: function swapChildViews(view1, view2) {
	    if (!this.children.hasView(view1) || !this.children.hasView(view2)) {
	      throw new MarionetteError({
	        name: 'ChildSwapError',
	        message: 'Both views must be children of the collection view'
	      });
	    }
	
	    this.children._swap(view1, view2);
	    this.Dom.swapEl(view1.el, view2.el);
	
	    // If the views are not filtered the same, refilter
	    if (this.Dom.hasEl(this.el, view1.el) !== this.Dom.hasEl(this.el, view2.el)) {
	      this.filter();
	    }
	
	    return this;
	  },
	
	
	  // Render the child's view and add it to the HTML for the collection view at a given index, based on the current sort
	  addChildView: function addChildView(view, index) {
	    if (!view || view._isDestroyed) {
	      return view;
	    }
	
	    // Only cache views if added to the end
	    if (!index || index >= this.children.length) {
	      this._addedViews = [view];
	    }
	    this._addChild(view, index);
	    this._showChildren();
	
	    return view;
	  },
	
	
	  // Detach a view from the children.  Best used when adding a
	  // childView from `addChildView`
	  detachChildView: function detachChildView(view) {
	    this.removeChildView(view, { shouldDetach: true });
	
	    return view;
	  },
	
	
	  // Remove the child view and destroy it.  Best used when adding a
	  // childView from `addChildView`
	  // The options argument is for internal use only
	  removeChildView: function removeChildView(view, options) {
	    if (!view) {
	      return view;
	    }
	
	    this._removeChildView(view, options);
	
	    this._removeChild(view);
	
	    if (this.isEmpty()) {
	      this._showEmptyView();
	    }
	
	    return view;
	  },
	  _removeChildViews: function _removeChildViews(views) {
	    _.each(views, _.bind(this._removeChildView, this));
	  },
	  _removeChildView: function _removeChildView(view) {
	    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        shouldDetach = _ref4.shouldDetach;
	
	    view.off('destroy', this.removeChildView, this);
	
	    if (shouldDetach) {
	      this._detachChildView(view);
	    } else {
	      this._destroyChildView(view);
	    }
	
	    this.stopListening(view);
	  },
	  _destroyChildView: function _destroyChildView(view) {
	    if (view._isDestroyed) {
	      return;
	    }
	
	    view._shouldDisableEvents = this.monitorViewEvents === false;
	    destroyView(view);
	  },
	
	
	  // called by ViewMixin destroy
	  _removeChildren: function _removeChildren() {
	    this._destroyChildren();
	    var emptyRegion = this.getEmptyRegion();
	    emptyRegion.destroy();
	    delete this._addedViews;
	  },
	
	
	  // Destroy the child views that this collection view is holding on to, if any
	  _destroyChildren: function _destroyChildren() {
	    if (!this.children || !this.children.length) {
	      return;
	    }
	
	    this.triggerMethod('before:destroy:children', this);
	    if (this.monitorViewEvents === false) {
	      this.Dom.detachContents(this.el, this.$el);
	    }
	    _.each(this.children._views, _.bind(this._removeChildView, this));
	    this.triggerMethod('destroy:children', this);
	  }
	}, {
	  setDomApi: setDomApi
	});
	
	_.extend(CollectionView$2.prototype, ViewMixin);
	
	// Composite View
	// --------------
	
	var ClassOptions$5 = ['childViewContainer', 'template', 'templateContext'];
	
	// Used for rendering a branch-leaf, hierarchical structure.
	// Extends directly from CollectionView
	// @deprecated
	var CompositeView = CollectionView.extend({
	
	  // Setting up the inheritance chain which allows changes to
	  // Marionette.CollectionView.prototype.constructor which allows overriding
	  // option to pass '{sort: false}' to prevent the CompositeView from
	  // maintaining the sorted order of the collection.
	  // This will fallback onto appending childView's to the end.
	  constructor: function constructor(options) {
	    deprecate('CompositeView is deprecated. Convert to View at your earliest convenience');
	
	    this.mergeOptions(options, ClassOptions$5);
	
	    CollectionView.prototype.constructor.apply(this, arguments);
	  },
	
	
	  // Configured the initial events that the composite view
	  // binds to. Override this method to prevent the initial
	  // events, or to add your own initial events.
	  _initialEvents: function _initialEvents() {
	
	    // Bind only after composite view is rendered to avoid adding child views
	    // to nonexistent childViewContainer
	
	    if (this.collection) {
	      this.listenTo(this.collection, 'add', this._onCollectionAdd);
	      this.listenTo(this.collection, 'update', this._onCollectionUpdate);
	      this.listenTo(this.collection, 'reset', this.renderChildren);
	
	      if (this.sort) {
	        this.listenTo(this.collection, 'sort', this._sortViews);
	      }
	    }
	  },
	
	
	  // Retrieve the `childView` to be used when rendering each of
	  // the items in the collection. The default is to return
	  // `this.childView` or Marionette.CompositeView if no `childView`
	  // has been defined. As happens in CollectionView, `childView` can
	  // be a function (which should return a view class).
	  _getChildView: function _getChildView(child) {
	    var childView = this.childView;
	
	    // for CompositeView, if `childView` is not specified, we'll get the same
	    // composite view class rendered for each child in the collection
	    // then check if the `childView` is a view class (the common case)
	    // finally check if it's a function (which we assume that returns a view class)
	    if (!childView) {
	      return this.constructor;
	    }
	
	    childView = this._getView(childView, child);
	
	    if (!childView) {
	      throw new MarionetteError({
	        name: 'InvalidChildViewError',
	        message: '"childView" must be a view class or a function that returns a view class'
	      });
	    }
	
	    return childView;
	  },
	
	
	  // Return the serialized model
	  serializeData: function serializeData() {
	    return this.serializeModel();
	  },
	
	
	  // Renders the model and the collection.
	  render: function render() {
	    if (this._isDestroyed) {
	      return this;
	    }
	    this._isRendering = true;
	    this.resetChildViewContainer();
	
	    this.triggerMethod('before:render', this);
	
	    this._renderTemplate();
	    this.bindUIElements();
	    this.renderChildren();
	
	    this._isRendering = false;
	    this._isRendered = true;
	    this.triggerMethod('render', this);
	    return this;
	  },
	  renderChildren: function renderChildren() {
	    if (this._isRendered || this._isRendering) {
	      CollectionView.prototype._renderChildren.call(this);
	    }
	  },
	
	
	  // You might need to override this if you've overridden attachHtml
	  attachBuffer: function attachBuffer(compositeView, buffer) {
	    var $container = this.getChildViewContainer(compositeView);
	    this.Dom.appendContents($container[0], buffer, { _$el: $container });
	  },
	
	
	  // Internal method. Append a view to the end of the $el.
	  // Overidden from CollectionView to ensure view is appended to
	  // childViewContainer
	  _insertAfter: function _insertAfter(childView) {
	    var $container = this.getChildViewContainer(this, childView);
	    this.Dom.appendContents($container[0], childView.el, { _$el: $container, _$contents: childView.$el });
	  },
	
	
	  // Internal method. Append reordered childView'.
	  // Overidden from CollectionView to ensure reordered views
	  // are appended to childViewContainer
	  _appendReorderedChildren: function _appendReorderedChildren(children) {
	    var $container = this.getChildViewContainer(this);
	    this.Dom.appendContents($container[0], children, { _$el: $container });
	  },
	
	
	  // Internal method to ensure an `$childViewContainer` exists, for the
	  // `attachHtml` method to use.
	  getChildViewContainer: function getChildViewContainer(containerView, childView) {
	    if (!!containerView.$childViewContainer) {
	      return containerView.$childViewContainer;
	    }
	
	    var container = void 0;
	    var childViewContainer = containerView.childViewContainer;
	    if (childViewContainer) {
	
	      var selector = _.result(containerView, 'childViewContainer');
	
	      if (selector.charAt(0) === '@' && containerView.ui) {
	        container = containerView.ui[selector.substr(4)];
	      } else {
	        container = this.$(selector);
	      }
	
	      if (container.length <= 0) {
	        throw new MarionetteError({
	          name: 'ChildViewContainerMissingError',
	          message: 'The specified "childViewContainer" was not found: ' + containerView.childViewContainer
	        });
	      }
	    } else {
	      container = containerView.$el;
	    }
	
	    containerView.$childViewContainer = container;
	    return container;
	  },
	
	
	  // Internal method to reset the `$childViewContainer` on render
	  resetChildViewContainer: function resetChildViewContainer() {
	    if (this.$childViewContainer) {
	      this.$childViewContainer = undefined;
	    }
	  }
	});
	
	// To prevent duplication but allow the best View organization
	// Certain View methods are mixed directly into the deprecated CompositeView
	var MixinFromView = _.pick(View.prototype, 'serializeModel', 'getTemplate', '_renderTemplate', '_renderHtml', 'mixinTemplateContext', 'attachElContent');
	_.extend(CompositeView.prototype, MixinFromView);
	
	// Behavior
	// --------
	
	// A Behavior is an isolated set of DOM /
	// user interactions that can be mixed into any View.
	// Behaviors allow you to blackbox View specific interactions
	// into portable logical chunks, keeping your views simple and your code DRY.
	
	var ClassOptions$6 = ['collectionEvents', 'events', 'modelEvents', 'triggers', 'ui'];
	
	var Behavior = MarionetteObject.extend({
	  cidPrefix: 'mnb',
	
	  constructor: function constructor(options, view) {
	    // Setup reference to the view.
	    // this comes in handle when a behavior
	    // wants to directly talk up the chain
	    // to the view.
	    this.view = view;
	
	    if (this.defaults) {
	      deprecate('Behavior defaults are deprecated. For similar functionality set options on the Behavior class.');
	    }
	
	    this.defaults = _.clone(_.result(this, 'defaults', {}));
	
	    this._setOptions(_.extend({}, this.defaults, options));
	    this.mergeOptions(this.options, ClassOptions$6);
	
	    // Construct an internal UI hash using
	    // the behaviors UI hash and then the view UI hash.
	    // This allows the user to use UI hash elements
	    // defined in the parent view as well as those
	    // defined in the given behavior.
	    // This order will help the reuse and share of a behavior
	    // between multiple views, while letting a view override a
	    // selector under an UI key.
	    this.ui = _.extend({}, _.result(this, 'ui'), _.result(view, 'ui'));
	
	    MarionetteObject.apply(this, arguments);
	  },
	
	
	  // proxy behavior $ method to the view
	  // this is useful for doing jquery DOM lookups
	  // scoped to behaviors view.
	  $: function $() {
	    return this.view.$.apply(this.view, arguments);
	  },
	
	
	  // Stops the behavior from listening to events.
	  // Overrides Object#destroy to prevent additional events from being triggered.
	  destroy: function destroy() {
	    this.stopListening();
	
	    this.view._removeBehavior(this);
	
	    return this;
	  },
	  proxyViewProperties: function proxyViewProperties() {
	    this.$el = this.view.$el;
	    this.el = this.view.el;
	
	    return this;
	  },
	  bindUIElements: function bindUIElements() {
	    this._bindUIElements();
	
	    return this;
	  },
	  unbindUIElements: function unbindUIElements() {
	    this._unbindUIElements();
	
	    return this;
	  },
	  getUI: function getUI(name) {
	    return this._getUI(name);
	  },
	
	
	  // Handle `modelEvents`, and `collectionEvents` configuration
	  delegateEntityEvents: function delegateEntityEvents() {
	    this._delegateEntityEvents(this.view.model, this.view.collection);
	
	    return this;
	  },
	  undelegateEntityEvents: function undelegateEntityEvents() {
	    this._undelegateEntityEvents(this.view.model, this.view.collection);
	
	    return this;
	  },
	  getEvents: function getEvents() {
	    var _this = this;
	
	    // Normalize behavior events hash to allow
	    // a user to use the @ui. syntax.
	    var behaviorEvents = this.normalizeUIKeys(_.result(this, 'events'));
	
	    // binds the handler to the behavior and builds a unique eventName
	    return _.reduce(behaviorEvents, function (events, behaviorHandler, key) {
	      if (!_.isFunction(behaviorHandler)) {
	        behaviorHandler = _this[behaviorHandler];
	      }
	      if (!behaviorHandler) {
	        return events;
	      }
	      key = getNamespacedEventName(key, _this.cid);
	      events[key] = _.bind(behaviorHandler, _this);
	      return events;
	    }, {});
	  },
	
	
	  // Internal method to build all trigger handlers for a given behavior
	  getTriggers: function getTriggers() {
	    if (!this.triggers) {
	      return;
	    }
	
	    // Normalize behavior triggers hash to allow
	    // a user to use the @ui. syntax.
	    var behaviorTriggers = this.normalizeUIKeys(_.result(this, 'triggers'));
	
	    return this._getViewTriggers(this.view, behaviorTriggers);
	  }
	});
	
	_.extend(Behavior.prototype, DelegateEntityEventsMixin, TriggersMixin, UIMixin);
	
	// Application
	// -----------
	var ClassOptions$7 = ['region', 'regionClass'];
	
	// A container for a Marionette application.
	var Application = MarionetteObject.extend({
	  cidPrefix: 'mna',
	
	  constructor: function constructor(options) {
	    this._setOptions(options);
	
	    this.mergeOptions(options, ClassOptions$7);
	
	    this._initRegion();
	
	    MarionetteObject.prototype.constructor.apply(this, arguments);
	  },
	
	
	  regionClass: Region,
	
	  _initRegion: function _initRegion() {
	    var region = this.region;
	
	    if (!region) {
	      return;
	    }
	
	    var defaults = {
	      regionClass: this.regionClass
	    };
	
	    this._region = buildRegion(region, defaults);
	  },
	  getRegion: function getRegion() {
	    return this._region;
	  },
	  showView: function showView(view) {
	    var region = this.getRegion();
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return region.show.apply(region, [view].concat(args));
	  },
	  getView: function getView() {
	    return this.getRegion().currentView;
	  },
	
	
	  // kick off all of the application's processes.
	  start: function start(options) {
	    this.triggerMethod('before:start', this, options);
	    this.triggerMethod('start', this, options);
	    return this;
	  }
	});
	
	// App Router
	// ----------
	
	// Reduce the boilerplate code of handling route events
	// and then calling a single method on another object,
	// called a controller.
	// Have your routers configured to call the method on
	// your controller, directly.
	//
	// Configure an AppRouter with `appRoutes`.
	//
	// App routers can only take one `controller` object.
	// It is recommended that you divide your controller
	// objects in to smaller pieces of related functionality
	// and have multiple routers / controllers, instead of
	// just one giant router and controller.
	//
	// You can also add standard routes to an AppRouter.
	
	var ClassOptions$8 = ['appRoutes', 'controller'];
	
	var AppRouter = Backbone.Router.extend({
	  constructor: function constructor(options) {
	    this._setOptions(options);
	
	    this.mergeOptions(options, ClassOptions$8);
	
	    Backbone.Router.apply(this, arguments);
	
	    var appRoutes = this.appRoutes;
	    var controller = this._getController();
	    this.processAppRoutes(controller, appRoutes);
	    this.on('route', this._processOnRoute, this);
	  },
	
	
	  // Similar to route method on a Backbone Router but
	  // method is called on the controller
	  appRoute: function appRoute(route, methodName) {
	    var controller = this._getController();
	    this._addAppRoute(controller, route, methodName);
	    return this;
	  },
	
	
	  // process the route event and trigger the onRoute
	  // method call, if it exists
	  _processOnRoute: function _processOnRoute(routeName, routeArgs) {
	    // make sure an onRoute before trying to call it
	    if (_.isFunction(this.onRoute)) {
	      // find the path that matches the current route
	      var routePath = _.invert(this.appRoutes)[routeName];
	      this.onRoute(routeName, routePath, routeArgs);
	    }
	  },
	
	
	  // Internal method to process the `appRoutes` for the
	  // router, and turn them in to routes that trigger the
	  // specified method on the specified `controller`.
	  processAppRoutes: function processAppRoutes(controller, appRoutes) {
	    var _this = this;
	
	    if (!appRoutes) {
	      return this;
	    }
	
	    var routeNames = _.keys(appRoutes).reverse(); // Backbone requires reverted order of routes
	
	    _.each(routeNames, function (route) {
	      _this._addAppRoute(controller, route, appRoutes[route]);
	    });
	
	    return this;
	  },
	  _getController: function _getController() {
	    return this.controller;
	  },
	  _addAppRoute: function _addAppRoute(controller, route, methodName) {
	    var method = controller[methodName];
	
	    if (!method) {
	      throw new MarionetteError('Method "' + methodName + '" was not found on the controller');
	    }
	
	    this.route(route, methodName, _.bind(method, controller));
	  },
	
	
	  triggerMethod: triggerMethod
	});
	
	_.extend(AppRouter.prototype, CommonMixin);
	
	// Placeholder method to be extended by the user.
	// The method should define the object that stores the behaviors.
	// i.e.
	//
	// ```js
	// Marionette.Behaviors.behaviorsLookup: function() {
	//   return App.Behaviors
	// }
	// ```
	function behaviorsLookup() {
	  throw new MarionetteError({
	    message: 'You must define where your behaviors are stored.',
	    url: 'marionette.behaviors.md#behaviorslookup'
	  });
	}
	
	var previousMarionette = Backbone.Marionette;
	var Marionette = Backbone.Marionette = {};
	
	// This allows you to run multiple instances of Marionette on the same
	// webapp. After loading the new version, call `noConflict()` to
	// get a reference to it. At the same time the old version will be
	// returned to Backbone.Marionette.
	Marionette.noConflict = function () {
	  Backbone.Marionette = previousMarionette;
	  return this;
	};
	
	// Utilities
	Marionette.bindEvents = proxy(bindEvents);
	Marionette.unbindEvents = proxy(unbindEvents);
	Marionette.bindRequests = proxy(bindRequests);
	Marionette.unbindRequests = proxy(unbindRequests);
	Marionette.mergeOptions = proxy(mergeOptions);
	Marionette.getOption = proxy(getOption);
	Marionette.normalizeMethods = proxy(normalizeMethods);
	Marionette.extend = extend;
	Marionette.isNodeAttached = isNodeAttached;
	Marionette.deprecate = deprecate;
	Marionette.triggerMethod = proxy(triggerMethod);
	Marionette.triggerMethodOn = triggerMethodOn;
	Marionette.isEnabled = isEnabled;
	Marionette.setEnabled = setEnabled;
	Marionette.monitorViewEvents = monitorViewEvents;
	
	Marionette.Behaviors = {};
	Marionette.Behaviors.behaviorsLookup = behaviorsLookup;
	
	// Classes
	Marionette.Application = Application;
	Marionette.AppRouter = AppRouter;
	Marionette.Renderer = Renderer;
	Marionette.TemplateCache = TemplateCache;
	Marionette.View = View;
	Marionette.CollectionView = CollectionView;
	Marionette.NextCollectionView = CollectionView$2;
	Marionette.CompositeView = CompositeView;
	Marionette.Behavior = Behavior;
	Marionette.Region = Region;
	Marionette.Error = MarionetteError;
	Marionette.Object = MarionetteObject;
	
	// Configuration
	Marionette.DEV_MODE = false;
	Marionette.FEATURES = FEATURES;
	Marionette.VERSION = version;
	Marionette.DomApi = DomApi;
	Marionette.setDomApi = function (mixin) {
	  CollectionView.setDomApi(mixin);
	  CompositeView.setDomApi(mixin);
	  CollectionView$2.setDomApi(mixin);
	  Region.setDomApi(mixin);
	  View.setDomApi(mixin);
	};
	
	return Marionette;
	
	})));
	this && this.Marionette && (this.Mn = this.Marionette);
	//# sourceMappingURL=backbone.marionette.js.map


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {//     Backbone.js 1.3.3
	
	//     (c) 2010-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Backbone may be freely distributed under the MIT license.
	//     For all details and documentation:
	//     http://backbonejs.org
	
	(function(factory) {
	
	  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
	  // We use `self` instead of `window` for `WebWorker` support.
	  var root = (typeof self == 'object' && self.self === self && self) ||
	            (typeof global == 'object' && global.global === global && global);
	
	  // Set up Backbone appropriately for the environment. Start with AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(182), __webpack_require__(11), exports], __WEBPACK_AMD_DEFINE_RESULT__ = function(_, $, exports) {
	      // Export global even in AMD case in case this script is loaded with
	      // others that may still expect a global Backbone.
	      root.Backbone = factory(root, exports, _, $);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
	  } else if (typeof exports !== 'undefined') {
	    var _ = require('underscore'), $;
	    try { $ = require('jquery'); } catch (e) {}
	    factory(root, exports, _, $);
	
	  // Finally, as a browser global.
	  } else {
	    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
	  }
	
	})(function(root, Backbone, _, $) {
	
	  // Initial Setup
	  // -------------
	
	  // Save the previous value of the `Backbone` variable, so that it can be
	  // restored later on, if `noConflict` is used.
	  var previousBackbone = root.Backbone;
	
	  // Create a local reference to a common array method we'll want to use later.
	  var slice = Array.prototype.slice;
	
	  // Current version of the library. Keep in sync with `package.json`.
	  Backbone.VERSION = '1.3.3';
	
	  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
	  // the `$` variable.
	  Backbone.$ = $;
	
	  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
	  // to its previous owner. Returns a reference to this Backbone object.
	  Backbone.noConflict = function() {
	    root.Backbone = previousBackbone;
	    return this;
	  };
	
	  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
	  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
	  // set a `X-Http-Method-Override` header.
	  Backbone.emulateHTTP = false;
	
	  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
	  // `application/json` requests ... this will encode the body as
	  // `application/x-www-form-urlencoded` instead and will send the model in a
	  // form param named `model`.
	  Backbone.emulateJSON = false;
	
	  // Proxy Backbone class methods to Underscore functions, wrapping the model's
	  // `attributes` object or collection's `models` array behind the scenes.
	  //
	  // collection.filter(function(model) { return model.get('age') > 10 });
	  // collection.each(this.addView);
	  //
	  // `Function#apply` can be slow so we use the method's arg count, if we know it.
	  var addMethod = function(length, method, attribute) {
	    switch (length) {
	      case 1: return function() {
	        return _[method](this[attribute]);
	      };
	      case 2: return function(value) {
	        return _[method](this[attribute], value);
	      };
	      case 3: return function(iteratee, context) {
	        return _[method](this[attribute], cb(iteratee, this), context);
	      };
	      case 4: return function(iteratee, defaultVal, context) {
	        return _[method](this[attribute], cb(iteratee, this), defaultVal, context);
	      };
	      default: return function() {
	        var args = slice.call(arguments);
	        args.unshift(this[attribute]);
	        return _[method].apply(_, args);
	      };
	    }
	  };
	  var addUnderscoreMethods = function(Class, methods, attribute) {
	    _.each(methods, function(length, method) {
	      if (_[method]) Class.prototype[method] = addMethod(length, method, attribute);
	    });
	  };
	
	  // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
	  var cb = function(iteratee, instance) {
	    if (_.isFunction(iteratee)) return iteratee;
	    if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
	    if (_.isString(iteratee)) return function(model) { return model.get(iteratee); };
	    return iteratee;
	  };
	  var modelMatcher = function(attrs) {
	    var matcher = _.matches(attrs);
	    return function(model) {
	      return matcher(model.attributes);
	    };
	  };
	
	  // Backbone.Events
	  // ---------------
	
	  // A module that can be mixed in to *any object* in order to provide it with
	  // a custom event channel. You may bind a callback to an event with `on` or
	  // remove with `off`; `trigger`-ing an event fires all callbacks in
	  // succession.
	  //
	  //     var object = {};
	  //     _.extend(object, Backbone.Events);
	  //     object.on('expand', function(){ alert('expanded'); });
	  //     object.trigger('expand');
	  //
	  var Events = Backbone.Events = {};
	
	  // Regular expression used to split event strings.
	  var eventSplitter = /\s+/;
	
	  // Iterates over the standard `event, callback` (as well as the fancy multiple
	  // space-separated events `"change blur", callback` and jQuery-style event
	  // maps `{event: callback}`).
	  var eventsApi = function(iteratee, events, name, callback, opts) {
	    var i = 0, names;
	    if (name && typeof name === 'object') {
	      // Handle event maps.
	      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
	      for (names = _.keys(name); i < names.length ; i++) {
	        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
	      }
	    } else if (name && eventSplitter.test(name)) {
	      // Handle space-separated event names by delegating them individually.
	      for (names = name.split(eventSplitter); i < names.length; i++) {
	        events = iteratee(events, names[i], callback, opts);
	      }
	    } else {
	      // Finally, standard events.
	      events = iteratee(events, name, callback, opts);
	    }
	    return events;
	  };
	
	  // Bind an event to a `callback` function. Passing `"all"` will bind
	  // the callback to all events fired.
	  Events.on = function(name, callback, context) {
	    return internalOn(this, name, callback, context);
	  };
	
	  // Guard the `listening` argument from the public API.
	  var internalOn = function(obj, name, callback, context, listening) {
	    obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
	      context: context,
	      ctx: obj,
	      listening: listening
	    });
	
	    if (listening) {
	      var listeners = obj._listeners || (obj._listeners = {});
	      listeners[listening.id] = listening;
	    }
	
	    return obj;
	  };
	
	  // Inversion-of-control versions of `on`. Tell *this* object to listen to
	  // an event in another object... keeping track of what it's listening to
	  // for easier unbinding later.
	  Events.listenTo = function(obj, name, callback) {
	    if (!obj) return this;
	    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
	    var listeningTo = this._listeningTo || (this._listeningTo = {});
	    var listening = listeningTo[id];
	
	    // This object is not listening to any other events on `obj` yet.
	    // Setup the necessary references to track the listening callbacks.
	    if (!listening) {
	      var thisId = this._listenId || (this._listenId = _.uniqueId('l'));
	      listening = listeningTo[id] = {obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0};
	    }
	
	    // Bind callbacks on obj, and keep track of them on listening.
	    internalOn(obj, name, callback, this, listening);
	    return this;
	  };
	
	  // The reducing API that adds a callback to the `events` object.
	  var onApi = function(events, name, callback, options) {
	    if (callback) {
	      var handlers = events[name] || (events[name] = []);
	      var context = options.context, ctx = options.ctx, listening = options.listening;
	      if (listening) listening.count++;
	
	      handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
	    }
	    return events;
	  };
	
	  // Remove one or many callbacks. If `context` is null, removes all
	  // callbacks with that function. If `callback` is null, removes all
	  // callbacks for the event. If `name` is null, removes all bound
	  // callbacks for all events.
	  Events.off = function(name, callback, context) {
	    if (!this._events) return this;
	    this._events = eventsApi(offApi, this._events, name, callback, {
	      context: context,
	      listeners: this._listeners
	    });
	    return this;
	  };
	
	  // Tell this object to stop listening to either specific events ... or
	  // to every object it's currently listening to.
	  Events.stopListening = function(obj, name, callback) {
	    var listeningTo = this._listeningTo;
	    if (!listeningTo) return this;
	
	    var ids = obj ? [obj._listenId] : _.keys(listeningTo);
	
	    for (var i = 0; i < ids.length; i++) {
	      var listening = listeningTo[ids[i]];
	
	      // If listening doesn't exist, this object is not currently
	      // listening to obj. Break out early.
	      if (!listening) break;
	
	      listening.obj.off(name, callback, this);
	    }
	
	    return this;
	  };
	
	  // The reducing API that removes a callback from the `events` object.
	  var offApi = function(events, name, callback, options) {
	    if (!events) return;
	
	    var i = 0, listening;
	    var context = options.context, listeners = options.listeners;
	
	    // Delete all events listeners and "drop" events.
	    if (!name && !callback && !context) {
	      var ids = _.keys(listeners);
	      for (; i < ids.length; i++) {
	        listening = listeners[ids[i]];
	        delete listeners[listening.id];
	        delete listening.listeningTo[listening.objId];
	      }
	      return;
	    }
	
	    var names = name ? [name] : _.keys(events);
	    for (; i < names.length; i++) {
	      name = names[i];
	      var handlers = events[name];
	
	      // Bail out if there are no events stored.
	      if (!handlers) break;
	
	      // Replace events if there are any remaining.  Otherwise, clean up.
	      var remaining = [];
	      for (var j = 0; j < handlers.length; j++) {
	        var handler = handlers[j];
	        if (
	          callback && callback !== handler.callback &&
	            callback !== handler.callback._callback ||
	              context && context !== handler.context
	        ) {
	          remaining.push(handler);
	        } else {
	          listening = handler.listening;
	          if (listening && --listening.count === 0) {
	            delete listeners[listening.id];
	            delete listening.listeningTo[listening.objId];
	          }
	        }
	      }
	
	      // Update tail event if the list has any events.  Otherwise, clean up.
	      if (remaining.length) {
	        events[name] = remaining;
	      } else {
	        delete events[name];
	      }
	    }
	    return events;
	  };
	
	  // Bind an event to only be triggered a single time. After the first time
	  // the callback is invoked, its listener will be removed. If multiple events
	  // are passed in using the space-separated syntax, the handler will fire
	  // once for each event, not once for a combination of all events.
	  Events.once = function(name, callback, context) {
	    // Map the event into a `{event: once}` object.
	    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.off, this));
	    if (typeof name === 'string' && context == null) callback = void 0;
	    return this.on(events, callback, context);
	  };
	
	  // Inversion-of-control versions of `once`.
	  Events.listenToOnce = function(obj, name, callback) {
	    // Map the event into a `{event: once}` object.
	    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.stopListening, this, obj));
	    return this.listenTo(obj, events);
	  };
	
	  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
	  // `offer` unbinds the `onceWrapper` after it has been called.
	  var onceMap = function(map, name, callback, offer) {
	    if (callback) {
	      var once = map[name] = _.once(function() {
	        offer(name, once);
	        callback.apply(this, arguments);
	      });
	      once._callback = callback;
	    }
	    return map;
	  };
	
	  // Trigger one or many events, firing all bound callbacks. Callbacks are
	  // passed the same arguments as `trigger` is, apart from the event name
	  // (unless you're listening on `"all"`, which will cause your callback to
	  // receive the true name of the event as the first argument).
	  Events.trigger = function(name) {
	    if (!this._events) return this;
	
	    var length = Math.max(0, arguments.length - 1);
	    var args = Array(length);
	    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];
	
	    eventsApi(triggerApi, this._events, name, void 0, args);
	    return this;
	  };
	
	  // Handles triggering the appropriate event callbacks.
	  var triggerApi = function(objEvents, name, callback, args) {
	    if (objEvents) {
	      var events = objEvents[name];
	      var allEvents = objEvents.all;
	      if (events && allEvents) allEvents = allEvents.slice();
	      if (events) triggerEvents(events, args);
	      if (allEvents) triggerEvents(allEvents, [name].concat(args));
	    }
	    return objEvents;
	  };
	
	  // A difficult-to-believe, but optimized internal dispatch function for
	  // triggering events. Tries to keep the usual cases speedy (most internal
	  // Backbone events have 3 arguments).
	  var triggerEvents = function(events, args) {
	    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
	    switch (args.length) {
	      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
	      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
	      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
	      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
	      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
	    }
	  };
	
	  // Aliases for backwards compatibility.
	  Events.bind   = Events.on;
	  Events.unbind = Events.off;
	
	  // Allow the `Backbone` object to serve as a global event bus, for folks who
	  // want global "pubsub" in a convenient place.
	  _.extend(Backbone, Events);
	
	  // Backbone.Model
	  // --------------
	
	  // Backbone **Models** are the basic data object in the framework --
	  // frequently representing a row in a table in a database on your server.
	  // A discrete chunk of data and a bunch of useful, related methods for
	  // performing computations and transformations on that data.
	
	  // Create a new model with the specified attributes. A client id (`cid`)
	  // is automatically generated and assigned for you.
	  var Model = Backbone.Model = function(attributes, options) {
	    var attrs = attributes || {};
	    options || (options = {});
	    this.cid = _.uniqueId(this.cidPrefix);
	    this.attributes = {};
	    if (options.collection) this.collection = options.collection;
	    if (options.parse) attrs = this.parse(attrs, options) || {};
	    var defaults = _.result(this, 'defaults');
	    attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
	    this.set(attrs, options);
	    this.changed = {};
	    this.initialize.apply(this, arguments);
	  };
	
	  // Attach all inheritable methods to the Model prototype.
	  _.extend(Model.prototype, Events, {
	
	    // A hash of attributes whose current and previous value differ.
	    changed: null,
	
	    // The value returned during the last failed validation.
	    validationError: null,
	
	    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
	    // CouchDB users may want to set this to `"_id"`.
	    idAttribute: 'id',
	
	    // The prefix is used to create the client id which is used to identify models locally.
	    // You may want to override this if you're experiencing name clashes with model ids.
	    cidPrefix: 'c',
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Return a copy of the model's `attributes` object.
	    toJSON: function(options) {
	      return _.clone(this.attributes);
	    },
	
	    // Proxy `Backbone.sync` by default -- but override this if you need
	    // custom syncing semantics for *this* particular model.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Get the value of an attribute.
	    get: function(attr) {
	      return this.attributes[attr];
	    },
	
	    // Get the HTML-escaped value of an attribute.
	    escape: function(attr) {
	      return _.escape(this.get(attr));
	    },
	
	    // Returns `true` if the attribute contains a value that is not null
	    // or undefined.
	    has: function(attr) {
	      return this.get(attr) != null;
	    },
	
	    // Special-cased proxy to underscore's `_.matches` method.
	    matches: function(attrs) {
	      return !!_.iteratee(attrs, this)(this.attributes);
	    },
	
	    // Set a hash of model attributes on the object, firing `"change"`. This is
	    // the core primitive operation of a model, updating the data and notifying
	    // anyone who needs to know about the change in state. The heart of the beast.
	    set: function(key, val, options) {
	      if (key == null) return this;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      var attrs;
	      if (typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options || (options = {});
	
	      // Run validation.
	      if (!this._validate(attrs, options)) return false;
	
	      // Extract attributes and options.
	      var unset      = options.unset;
	      var silent     = options.silent;
	      var changes    = [];
	      var changing   = this._changing;
	      this._changing = true;
	
	      if (!changing) {
	        this._previousAttributes = _.clone(this.attributes);
	        this.changed = {};
	      }
	
	      var current = this.attributes;
	      var changed = this.changed;
	      var prev    = this._previousAttributes;
	
	      // For each `set` attribute, update or delete the current value.
	      for (var attr in attrs) {
	        val = attrs[attr];
	        if (!_.isEqual(current[attr], val)) changes.push(attr);
	        if (!_.isEqual(prev[attr], val)) {
	          changed[attr] = val;
	        } else {
	          delete changed[attr];
	        }
	        unset ? delete current[attr] : current[attr] = val;
	      }
	
	      // Update the `id`.
	      if (this.idAttribute in attrs) this.id = this.get(this.idAttribute);
	
	      // Trigger all relevant attribute changes.
	      if (!silent) {
	        if (changes.length) this._pending = options;
	        for (var i = 0; i < changes.length; i++) {
	          this.trigger('change:' + changes[i], this, current[changes[i]], options);
	        }
	      }
	
	      // You might be wondering why there's a `while` loop here. Changes can
	      // be recursively nested within `"change"` events.
	      if (changing) return this;
	      if (!silent) {
	        while (this._pending) {
	          options = this._pending;
	          this._pending = false;
	          this.trigger('change', this, options);
	        }
	      }
	      this._pending = false;
	      this._changing = false;
	      return this;
	    },
	
	    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
	    // if the attribute doesn't exist.
	    unset: function(attr, options) {
	      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
	    },
	
	    // Clear all attributes on the model, firing `"change"`.
	    clear: function(options) {
	      var attrs = {};
	      for (var key in this.attributes) attrs[key] = void 0;
	      return this.set(attrs, _.extend({}, options, {unset: true}));
	    },
	
	    // Determine if the model has changed since the last `"change"` event.
	    // If you specify an attribute name, determine if that attribute has changed.
	    hasChanged: function(attr) {
	      if (attr == null) return !_.isEmpty(this.changed);
	      return _.has(this.changed, attr);
	    },
	
	    // Return an object containing all the attributes that have changed, or
	    // false if there are no changed attributes. Useful for determining what
	    // parts of a view need to be updated and/or what attributes need to be
	    // persisted to the server. Unset attributes will be set to undefined.
	    // You can also pass an attributes object to diff against the model,
	    // determining if there *would be* a change.
	    changedAttributes: function(diff) {
	      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
	      var old = this._changing ? this._previousAttributes : this.attributes;
	      var changed = {};
	      for (var attr in diff) {
	        var val = diff[attr];
	        if (_.isEqual(old[attr], val)) continue;
	        changed[attr] = val;
	      }
	      return _.size(changed) ? changed : false;
	    },
	
	    // Get the previous value of an attribute, recorded at the time the last
	    // `"change"` event was fired.
	    previous: function(attr) {
	      if (attr == null || !this._previousAttributes) return null;
	      return this._previousAttributes[attr];
	    },
	
	    // Get all of the attributes of the model at the time of the previous
	    // `"change"` event.
	    previousAttributes: function() {
	      return _.clone(this._previousAttributes);
	    },
	
	    // Fetch the model from the server, merging the response with the model's
	    // local attributes. Any changed attributes will trigger a "change" event.
	    fetch: function(options) {
	      options = _.extend({parse: true}, options);
	      var model = this;
	      var success = options.success;
	      options.success = function(resp) {
	        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
	        if (!model.set(serverAttrs, options)) return false;
	        if (success) success.call(options.context, model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Set a hash of model attributes, and sync the model to the server.
	    // If the server returns an attributes hash that differs, the model's
	    // state will be `set` again.
	    save: function(key, val, options) {
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      var attrs;
	      if (key == null || typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options = _.extend({validate: true, parse: true}, options);
	      var wait = options.wait;
	
	      // If we're not waiting and attributes exist, save acts as
	      // `set(attr).save(null, opts)` with validation. Otherwise, check if
	      // the model will be valid when the attributes, if any, are set.
	      if (attrs && !wait) {
	        if (!this.set(attrs, options)) return false;
	      } else if (!this._validate(attrs, options)) {
	        return false;
	      }
	
	      // After a successful server-side save, the client is (optionally)
	      // updated with the server-side state.
	      var model = this;
	      var success = options.success;
	      var attributes = this.attributes;
	      options.success = function(resp) {
	        // Ensure attributes are restored during synchronous saves.
	        model.attributes = attributes;
	        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
	        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
	        if (serverAttrs && !model.set(serverAttrs, options)) return false;
	        if (success) success.call(options.context, model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	
	      // Set temporary attributes if `{wait: true}` to properly find new ids.
	      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);
	
	      var method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
	      if (method === 'patch' && !options.attrs) options.attrs = attrs;
	      var xhr = this.sync(method, this, options);
	
	      // Restore attributes.
	      this.attributes = attributes;
	
	      return xhr;
	    },
	
	    // Destroy this model on the server if it was already persisted.
	    // Optimistically removes the model from its collection, if it has one.
	    // If `wait: true` is passed, waits for the server to respond before removal.
	    destroy: function(options) {
	      options = options ? _.clone(options) : {};
	      var model = this;
	      var success = options.success;
	      var wait = options.wait;
	
	      var destroy = function() {
	        model.stopListening();
	        model.trigger('destroy', model, model.collection, options);
	      };
	
	      options.success = function(resp) {
	        if (wait) destroy();
	        if (success) success.call(options.context, model, resp, options);
	        if (!model.isNew()) model.trigger('sync', model, resp, options);
	      };
	
	      var xhr = false;
	      if (this.isNew()) {
	        _.defer(options.success);
	      } else {
	        wrapError(this, options);
	        xhr = this.sync('delete', this, options);
	      }
	      if (!wait) destroy();
	      return xhr;
	    },
	
	    // Default URL for the model's representation on the server -- if you're
	    // using Backbone's restful methods, override this to change the endpoint
	    // that will be called.
	    url: function() {
	      var base =
	        _.result(this, 'urlRoot') ||
	        _.result(this.collection, 'url') ||
	        urlError();
	      if (this.isNew()) return base;
	      var id = this.get(this.idAttribute);
	      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
	    },
	
	    // **parse** converts a response into the hash of attributes to be `set` on
	    // the model. The default implementation is just to pass the response along.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new model with identical attributes to this one.
	    clone: function() {
	      return new this.constructor(this.attributes);
	    },
	
	    // A model is new if it has never been saved to the server, and lacks an id.
	    isNew: function() {
	      return !this.has(this.idAttribute);
	    },
	
	    // Check if the model is currently in a valid state.
	    isValid: function(options) {
	      return this._validate({}, _.extend({}, options, {validate: true}));
	    },
	
	    // Run validation against the next complete set of model attributes,
	    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
	    _validate: function(attrs, options) {
	      if (!options.validate || !this.validate) return true;
	      attrs = _.extend({}, this.attributes, attrs);
	      var error = this.validationError = this.validate(attrs, options) || null;
	      if (!error) return true;
	      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
	      return false;
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Model, mapped to the
	  // number of arguments they take.
	  var modelMethods = {keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
	      omit: 0, chain: 1, isEmpty: 1};
	
	  // Mix in each Underscore method as a proxy to `Model#attributes`.
	  addUnderscoreMethods(Model, modelMethods, 'attributes');
	
	  // Backbone.Collection
	  // -------------------
	
	  // If models tend to represent a single row of data, a Backbone Collection is
	  // more analogous to a table full of data ... or a small slice or page of that
	  // table, or a collection of rows that belong together for a particular reason
	  // -- all of the messages in this particular folder, all of the documents
	  // belonging to this particular author, and so on. Collections maintain
	  // indexes of their models, both in order, and for lookup by `id`.
	
	  // Create a new **Collection**, perhaps to contain a specific type of `model`.
	  // If a `comparator` is specified, the Collection will maintain
	  // its models in sort order, as they're added and removed.
	  var Collection = Backbone.Collection = function(models, options) {
	    options || (options = {});
	    if (options.model) this.model = options.model;
	    if (options.comparator !== void 0) this.comparator = options.comparator;
	    this._reset();
	    this.initialize.apply(this, arguments);
	    if (models) this.reset(models, _.extend({silent: true}, options));
	  };
	
	  // Default options for `Collection#set`.
	  var setOptions = {add: true, remove: true, merge: true};
	  var addOptions = {add: true, remove: false};
	
	  // Splices `insert` into `array` at index `at`.
	  var splice = function(array, insert, at) {
	    at = Math.min(Math.max(at, 0), array.length);
	    var tail = Array(array.length - at);
	    var length = insert.length;
	    var i;
	    for (i = 0; i < tail.length; i++) tail[i] = array[i + at];
	    for (i = 0; i < length; i++) array[i + at] = insert[i];
	    for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
	  };
	
	  // Define the Collection's inheritable methods.
	  _.extend(Collection.prototype, Events, {
	
	    // The default model for a collection is just a **Backbone.Model**.
	    // This should be overridden in most cases.
	    model: Model,
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // The JSON representation of a Collection is an array of the
	    // models' attributes.
	    toJSON: function(options) {
	      return this.map(function(model) { return model.toJSON(options); });
	    },
	
	    // Proxy `Backbone.sync` by default.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Add a model, or list of models to the set. `models` may be Backbone
	    // Models or raw JavaScript objects to be converted to Models, or any
	    // combination of the two.
	    add: function(models, options) {
	      return this.set(models, _.extend({merge: false}, options, addOptions));
	    },
	
	    // Remove a model, or a list of models from the set.
	    remove: function(models, options) {
	      options = _.extend({}, options);
	      var singular = !_.isArray(models);
	      models = singular ? [models] : models.slice();
	      var removed = this._removeModels(models, options);
	      if (!options.silent && removed.length) {
	        options.changes = {added: [], merged: [], removed: removed};
	        this.trigger('update', this, options);
	      }
	      return singular ? removed[0] : removed;
	    },
	
	    // Update a collection by `set`-ing a new list of models, adding new ones,
	    // removing models that are no longer present, and merging models that
	    // already exist in the collection, as necessary. Similar to **Model#set**,
	    // the core operation for updating the data contained by the collection.
	    set: function(models, options) {
	      if (models == null) return;
	
	      options = _.extend({}, setOptions, options);
	      if (options.parse && !this._isModel(models)) {
	        models = this.parse(models, options) || [];
	      }
	
	      var singular = !_.isArray(models);
	      models = singular ? [models] : models.slice();
	
	      var at = options.at;
	      if (at != null) at = +at;
	      if (at > this.length) at = this.length;
	      if (at < 0) at += this.length + 1;
	
	      var set = [];
	      var toAdd = [];
	      var toMerge = [];
	      var toRemove = [];
	      var modelMap = {};
	
	      var add = options.add;
	      var merge = options.merge;
	      var remove = options.remove;
	
	      var sort = false;
	      var sortable = this.comparator && at == null && options.sort !== false;
	      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
	
	      // Turn bare objects into model references, and prevent invalid models
	      // from being added.
	      var model, i;
	      for (i = 0; i < models.length; i++) {
	        model = models[i];
	
	        // If a duplicate is found, prevent it from being added and
	        // optionally merge it into the existing model.
	        var existing = this.get(model);
	        if (existing) {
	          if (merge && model !== existing) {
	            var attrs = this._isModel(model) ? model.attributes : model;
	            if (options.parse) attrs = existing.parse(attrs, options);
	            existing.set(attrs, options);
	            toMerge.push(existing);
	            if (sortable && !sort) sort = existing.hasChanged(sortAttr);
	          }
	          if (!modelMap[existing.cid]) {
	            modelMap[existing.cid] = true;
	            set.push(existing);
	          }
	          models[i] = existing;
	
	        // If this is a new, valid model, push it to the `toAdd` list.
	        } else if (add) {
	          model = models[i] = this._prepareModel(model, options);
	          if (model) {
	            toAdd.push(model);
	            this._addReference(model, options);
	            modelMap[model.cid] = true;
	            set.push(model);
	          }
	        }
	      }
	
	      // Remove stale models.
	      if (remove) {
	        for (i = 0; i < this.length; i++) {
	          model = this.models[i];
	          if (!modelMap[model.cid]) toRemove.push(model);
	        }
	        if (toRemove.length) this._removeModels(toRemove, options);
	      }
	
	      // See if sorting is needed, update `length` and splice in new models.
	      var orderChanged = false;
	      var replace = !sortable && add && remove;
	      if (set.length && replace) {
	        orderChanged = this.length !== set.length || _.some(this.models, function(m, index) {
	          return m !== set[index];
	        });
	        this.models.length = 0;
	        splice(this.models, set, 0);
	        this.length = this.models.length;
	      } else if (toAdd.length) {
	        if (sortable) sort = true;
	        splice(this.models, toAdd, at == null ? this.length : at);
	        this.length = this.models.length;
	      }
	
	      // Silently sort the collection if appropriate.
	      if (sort) this.sort({silent: true});
	
	      // Unless silenced, it's time to fire all appropriate add/sort/update events.
	      if (!options.silent) {
	        for (i = 0; i < toAdd.length; i++) {
	          if (at != null) options.index = at + i;
	          model = toAdd[i];
	          model.trigger('add', model, this, options);
	        }
	        if (sort || orderChanged) this.trigger('sort', this, options);
	        if (toAdd.length || toRemove.length || toMerge.length) {
	          options.changes = {
	            added: toAdd,
	            removed: toRemove,
	            merged: toMerge
	          };
	          this.trigger('update', this, options);
	        }
	      }
	
	      // Return the added (or merged) model (or models).
	      return singular ? models[0] : models;
	    },
	
	    // When you have more items than you want to add or remove individually,
	    // you can reset the entire set with a new list of models, without firing
	    // any granular `add` or `remove` events. Fires `reset` when finished.
	    // Useful for bulk operations and optimizations.
	    reset: function(models, options) {
	      options = options ? _.clone(options) : {};
	      for (var i = 0; i < this.models.length; i++) {
	        this._removeReference(this.models[i], options);
	      }
	      options.previousModels = this.models;
	      this._reset();
	      models = this.add(models, _.extend({silent: true}, options));
	      if (!options.silent) this.trigger('reset', this, options);
	      return models;
	    },
	
	    // Add a model to the end of the collection.
	    push: function(model, options) {
	      return this.add(model, _.extend({at: this.length}, options));
	    },
	
	    // Remove a model from the end of the collection.
	    pop: function(options) {
	      var model = this.at(this.length - 1);
	      return this.remove(model, options);
	    },
	
	    // Add a model to the beginning of the collection.
	    unshift: function(model, options) {
	      return this.add(model, _.extend({at: 0}, options));
	    },
	
	    // Remove a model from the beginning of the collection.
	    shift: function(options) {
	      var model = this.at(0);
	      return this.remove(model, options);
	    },
	
	    // Slice out a sub-array of models from the collection.
	    slice: function() {
	      return slice.apply(this.models, arguments);
	    },
	
	    // Get a model from the set by id, cid, model object with id or cid
	    // properties, or an attributes object that is transformed through modelId.
	    get: function(obj) {
	      if (obj == null) return void 0;
	      return this._byId[obj] ||
	        this._byId[this.modelId(obj.attributes || obj)] ||
	        obj.cid && this._byId[obj.cid];
	    },
	
	    // Returns `true` if the model is in the collection.
	    has: function(obj) {
	      return this.get(obj) != null;
	    },
	
	    // Get the model at the given index.
	    at: function(index) {
	      if (index < 0) index += this.length;
	      return this.models[index];
	    },
	
	    // Return models with matching attributes. Useful for simple cases of
	    // `filter`.
	    where: function(attrs, first) {
	      return this[first ? 'find' : 'filter'](attrs);
	    },
	
	    // Return the first model with matching attributes. Useful for simple cases
	    // of `find`.
	    findWhere: function(attrs) {
	      return this.where(attrs, true);
	    },
	
	    // Force the collection to re-sort itself. You don't need to call this under
	    // normal circumstances, as the set will maintain sort order as each item
	    // is added.
	    sort: function(options) {
	      var comparator = this.comparator;
	      if (!comparator) throw new Error('Cannot sort a set without a comparator');
	      options || (options = {});
	
	      var length = comparator.length;
	      if (_.isFunction(comparator)) comparator = _.bind(comparator, this);
	
	      // Run sort based on type of `comparator`.
	      if (length === 1 || _.isString(comparator)) {
	        this.models = this.sortBy(comparator);
	      } else {
	        this.models.sort(comparator);
	      }
	      if (!options.silent) this.trigger('sort', this, options);
	      return this;
	    },
	
	    // Pluck an attribute from each model in the collection.
	    pluck: function(attr) {
	      return this.map(attr + '');
	    },
	
	    // Fetch the default set of models for this collection, resetting the
	    // collection when they arrive. If `reset: true` is passed, the response
	    // data will be passed through the `reset` method instead of `set`.
	    fetch: function(options) {
	      options = _.extend({parse: true}, options);
	      var success = options.success;
	      var collection = this;
	      options.success = function(resp) {
	        var method = options.reset ? 'reset' : 'set';
	        collection[method](resp, options);
	        if (success) success.call(options.context, collection, resp, options);
	        collection.trigger('sync', collection, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Create a new instance of a model in this collection. Add the model to the
	    // collection immediately, unless `wait: true` is passed, in which case we
	    // wait for the server to agree.
	    create: function(model, options) {
	      options = options ? _.clone(options) : {};
	      var wait = options.wait;
	      model = this._prepareModel(model, options);
	      if (!model) return false;
	      if (!wait) this.add(model, options);
	      var collection = this;
	      var success = options.success;
	      options.success = function(m, resp, callbackOpts) {
	        if (wait) collection.add(m, callbackOpts);
	        if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
	      };
	      model.save(null, options);
	      return model;
	    },
	
	    // **parse** converts a response into a list of models to be added to the
	    // collection. The default implementation is just to pass it through.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new collection with an identical list of models as this one.
	    clone: function() {
	      return new this.constructor(this.models, {
	        model: this.model,
	        comparator: this.comparator
	      });
	    },
	
	    // Define how to uniquely identify models in the collection.
	    modelId: function(attrs) {
	      return attrs[this.model.prototype.idAttribute || 'id'];
	    },
	
	    // Private method to reset all internal state. Called when the collection
	    // is first initialized or reset.
	    _reset: function() {
	      this.length = 0;
	      this.models = [];
	      this._byId  = {};
	    },
	
	    // Prepare a hash of attributes (or other model) to be added to this
	    // collection.
	    _prepareModel: function(attrs, options) {
	      if (this._isModel(attrs)) {
	        if (!attrs.collection) attrs.collection = this;
	        return attrs;
	      }
	      options = options ? _.clone(options) : {};
	      options.collection = this;
	      var model = new this.model(attrs, options);
	      if (!model.validationError) return model;
	      this.trigger('invalid', this, model.validationError, options);
	      return false;
	    },
	
	    // Internal method called by both remove and set.
	    _removeModels: function(models, options) {
	      var removed = [];
	      for (var i = 0; i < models.length; i++) {
	        var model = this.get(models[i]);
	        if (!model) continue;
	
	        var index = this.indexOf(model);
	        this.models.splice(index, 1);
	        this.length--;
	
	        // Remove references before triggering 'remove' event to prevent an
	        // infinite loop. #3693
	        delete this._byId[model.cid];
	        var id = this.modelId(model.attributes);
	        if (id != null) delete this._byId[id];
	
	        if (!options.silent) {
	          options.index = index;
	          model.trigger('remove', model, this, options);
	        }
	
	        removed.push(model);
	        this._removeReference(model, options);
	      }
	      return removed;
	    },
	
	    // Method for checking whether an object should be considered a model for
	    // the purposes of adding to the collection.
	    _isModel: function(model) {
	      return model instanceof Model;
	    },
	
	    // Internal method to create a model's ties to a collection.
	    _addReference: function(model, options) {
	      this._byId[model.cid] = model;
	      var id = this.modelId(model.attributes);
	      if (id != null) this._byId[id] = model;
	      model.on('all', this._onModelEvent, this);
	    },
	
	    // Internal method to sever a model's ties to a collection.
	    _removeReference: function(model, options) {
	      delete this._byId[model.cid];
	      var id = this.modelId(model.attributes);
	      if (id != null) delete this._byId[id];
	      if (this === model.collection) delete model.collection;
	      model.off('all', this._onModelEvent, this);
	    },
	
	    // Internal method called every time a model in the set fires an event.
	    // Sets need to update their indexes when models change ids. All other
	    // events simply proxy through. "add" and "remove" events that originate
	    // in other collections are ignored.
	    _onModelEvent: function(event, model, collection, options) {
	      if (model) {
	        if ((event === 'add' || event === 'remove') && collection !== this) return;
	        if (event === 'destroy') this.remove(model, options);
	        if (event === 'change') {
	          var prevId = this.modelId(model.previousAttributes());
	          var id = this.modelId(model.attributes);
	          if (prevId !== id) {
	            if (prevId != null) delete this._byId[prevId];
	            if (id != null) this._byId[id] = model;
	          }
	        }
	      }
	      this.trigger.apply(this, arguments);
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Collection.
	  // 90% of the core usefulness of Backbone Collections is actually implemented
	  // right here:
	  var collectionMethods = {forEach: 3, each: 3, map: 3, collect: 3, reduce: 0,
	      foldl: 0, inject: 0, reduceRight: 0, foldr: 0, find: 3, detect: 3, filter: 3,
	      select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 3, includes: 3,
	      contains: 3, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
	      head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
	      without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
	      isEmpty: 1, chain: 1, sample: 3, partition: 3, groupBy: 3, countBy: 3,
	      sortBy: 3, indexBy: 3, findIndex: 3, findLastIndex: 3};
	
	  // Mix in each Underscore method as a proxy to `Collection#models`.
	  addUnderscoreMethods(Collection, collectionMethods, 'models');
	
	  // Backbone.View
	  // -------------
	
	  // Backbone Views are almost more convention than they are actual code. A View
	  // is simply a JavaScript object that represents a logical chunk of UI in the
	  // DOM. This might be a single item, an entire list, a sidebar or panel, or
	  // even the surrounding frame which wraps your whole app. Defining a chunk of
	  // UI as a **View** allows you to define your DOM events declaratively, without
	  // having to worry about render order ... and makes it easy for the view to
	  // react to specific changes in the state of your models.
	
	  // Creating a Backbone.View creates its initial element outside of the DOM,
	  // if an existing element is not provided...
	  var View = Backbone.View = function(options) {
	    this.cid = _.uniqueId('view');
	    _.extend(this, _.pick(options, viewOptions));
	    this._ensureElement();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regex to split keys for `delegate`.
	  var delegateEventSplitter = /^(\S+)\s*(.*)$/;
	
	  // List of view options to be set as properties.
	  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];
	
	  // Set up all inheritable **Backbone.View** properties and methods.
	  _.extend(View.prototype, Events, {
	
	    // The default `tagName` of a View's element is `"div"`.
	    tagName: 'div',
	
	    // jQuery delegate for element lookup, scoped to DOM elements within the
	    // current view. This should be preferred to global lookups where possible.
	    $: function(selector) {
	      return this.$el.find(selector);
	    },
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // **render** is the core function that your view should override, in order
	    // to populate its element (`this.el`), with the appropriate HTML. The
	    // convention is for **render** to always return `this`.
	    render: function() {
	      return this;
	    },
	
	    // Remove this view by taking the element out of the DOM, and removing any
	    // applicable Backbone.Events listeners.
	    remove: function() {
	      this._removeElement();
	      this.stopListening();
	      return this;
	    },
	
	    // Remove this view's element from the document and all event listeners
	    // attached to it. Exposed for subclasses using an alternative DOM
	    // manipulation API.
	    _removeElement: function() {
	      this.$el.remove();
	    },
	
	    // Change the view's element (`this.el` property) and re-delegate the
	    // view's events on the new element.
	    setElement: function(element) {
	      this.undelegateEvents();
	      this._setElement(element);
	      this.delegateEvents();
	      return this;
	    },
	
	    // Creates the `this.el` and `this.$el` references for this view using the
	    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
	    // context or an element. Subclasses can override this to utilize an
	    // alternative DOM manipulation API and are only required to set the
	    // `this.el` property.
	    _setElement: function(el) {
	      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
	      this.el = this.$el[0];
	    },
	
	    // Set callbacks, where `this.events` is a hash of
	    //
	    // *{"event selector": "callback"}*
	    //
	    //     {
	    //       'mousedown .title':  'edit',
	    //       'click .button':     'save',
	    //       'click .open':       function(e) { ... }
	    //     }
	    //
	    // pairs. Callbacks will be bound to the view, with `this` set properly.
	    // Uses event delegation for efficiency.
	    // Omitting the selector binds the event to `this.el`.
	    delegateEvents: function(events) {
	      events || (events = _.result(this, 'events'));
	      if (!events) return this;
	      this.undelegateEvents();
	      for (var key in events) {
	        var method = events[key];
	        if (!_.isFunction(method)) method = this[method];
	        if (!method) continue;
	        var match = key.match(delegateEventSplitter);
	        this.delegate(match[1], match[2], _.bind(method, this));
	      }
	      return this;
	    },
	
	    // Add a single event listener to the view's element (or a child element
	    // using `selector`). This only works for delegate-able events: not `focus`,
	    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
	    delegate: function(eventName, selector, listener) {
	      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
	      return this;
	    },
	
	    // Clears all callbacks previously bound to the view by `delegateEvents`.
	    // You usually don't need to use this, but may wish to if you have multiple
	    // Backbone views attached to the same DOM element.
	    undelegateEvents: function() {
	      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
	      return this;
	    },
	
	    // A finer-grained `undelegateEvents` for removing a single delegated event.
	    // `selector` and `listener` are both optional.
	    undelegate: function(eventName, selector, listener) {
	      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
	      return this;
	    },
	
	    // Produces a DOM element to be assigned to your view. Exposed for
	    // subclasses using an alternative DOM manipulation API.
	    _createElement: function(tagName) {
	      return document.createElement(tagName);
	    },
	
	    // Ensure that the View has a DOM element to render into.
	    // If `this.el` is a string, pass it through `$()`, take the first
	    // matching element, and re-assign it to `el`. Otherwise, create
	    // an element from the `id`, `className` and `tagName` properties.
	    _ensureElement: function() {
	      if (!this.el) {
	        var attrs = _.extend({}, _.result(this, 'attributes'));
	        if (this.id) attrs.id = _.result(this, 'id');
	        if (this.className) attrs['class'] = _.result(this, 'className');
	        this.setElement(this._createElement(_.result(this, 'tagName')));
	        this._setAttributes(attrs);
	      } else {
	        this.setElement(_.result(this, 'el'));
	      }
	    },
	
	    // Set attributes from a hash on this view's element.  Exposed for
	    // subclasses using an alternative DOM manipulation API.
	    _setAttributes: function(attributes) {
	      this.$el.attr(attributes);
	    }
	
	  });
	
	  // Backbone.sync
	  // -------------
	
	  // Override this function to change the manner in which Backbone persists
	  // models to the server. You will be passed the type of request, and the
	  // model in question. By default, makes a RESTful Ajax request
	  // to the model's `url()`. Some possible customizations could be:
	  //
	  // * Use `setTimeout` to batch rapid-fire updates into a single request.
	  // * Send up the models as XML instead of JSON.
	  // * Persist models via WebSockets instead of Ajax.
	  //
	  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
	  // as `POST`, with a `_method` parameter containing the true HTTP method,
	  // as well as all requests with the body as `application/x-www-form-urlencoded`
	  // instead of `application/json` with the model in a param named `model`.
	  // Useful when interfacing with server-side languages like **PHP** that make
	  // it difficult to read the body of `PUT` requests.
	  Backbone.sync = function(method, model, options) {
	    var type = methodMap[method];
	
	    // Default options, unless specified.
	    _.defaults(options || (options = {}), {
	      emulateHTTP: Backbone.emulateHTTP,
	      emulateJSON: Backbone.emulateJSON
	    });
	
	    // Default JSON-request options.
	    var params = {type: type, dataType: 'json'};
	
	    // Ensure that we have a URL.
	    if (!options.url) {
	      params.url = _.result(model, 'url') || urlError();
	    }
	
	    // Ensure that we have the appropriate request data.
	    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
	      params.contentType = 'application/json';
	      params.data = JSON.stringify(options.attrs || model.toJSON(options));
	    }
	
	    // For older servers, emulate JSON by encoding the request into an HTML-form.
	    if (options.emulateJSON) {
	      params.contentType = 'application/x-www-form-urlencoded';
	      params.data = params.data ? {model: params.data} : {};
	    }
	
	    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
	    // And an `X-HTTP-Method-Override` header.
	    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
	      params.type = 'POST';
	      if (options.emulateJSON) params.data._method = type;
	      var beforeSend = options.beforeSend;
	      options.beforeSend = function(xhr) {
	        xhr.setRequestHeader('X-HTTP-Method-Override', type);
	        if (beforeSend) return beforeSend.apply(this, arguments);
	      };
	    }
	
	    // Don't process data on a non-GET request.
	    if (params.type !== 'GET' && !options.emulateJSON) {
	      params.processData = false;
	    }
	
	    // Pass along `textStatus` and `errorThrown` from jQuery.
	    var error = options.error;
	    options.error = function(xhr, textStatus, errorThrown) {
	      options.textStatus = textStatus;
	      options.errorThrown = errorThrown;
	      if (error) error.call(options.context, xhr, textStatus, errorThrown);
	    };
	
	    // Make the request, allowing the user to override any Ajax options.
	    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
	    model.trigger('request', model, xhr, options);
	    return xhr;
	  };
	
	  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
	  var methodMap = {
	    'create': 'POST',
	    'update': 'PUT',
	    'patch': 'PATCH',
	    'delete': 'DELETE',
	    'read': 'GET'
	  };
	
	  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
	  // Override this if you'd like to use a different library.
	  Backbone.ajax = function() {
	    return Backbone.$.ajax.apply(Backbone.$, arguments);
	  };
	
	  // Backbone.Router
	  // ---------------
	
	  // Routers map faux-URLs to actions, and fire events when routes are
	  // matched. Creating a new one sets its `routes` hash, if not set statically.
	  var Router = Backbone.Router = function(options) {
	    options || (options = {});
	    if (options.routes) this.routes = options.routes;
	    this._bindRoutes();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regular expressions for matching named param parts and splatted
	  // parts of route strings.
	  var optionalParam = /\((.*?)\)/g;
	  var namedParam    = /(\(\?)?:\w+/g;
	  var splatParam    = /\*\w+/g;
	  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;
	
	  // Set up all inheritable **Backbone.Router** properties and methods.
	  _.extend(Router.prototype, Events, {
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Manually bind a single named route to a callback. For example:
	    //
	    //     this.route('search/:query/p:num', 'search', function(query, num) {
	    //       ...
	    //     });
	    //
	    route: function(route, name, callback) {
	      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
	      if (_.isFunction(name)) {
	        callback = name;
	        name = '';
	      }
	      if (!callback) callback = this[name];
	      var router = this;
	      Backbone.history.route(route, function(fragment) {
	        var args = router._extractParameters(route, fragment);
	        if (router.execute(callback, args, name) !== false) {
	          router.trigger.apply(router, ['route:' + name].concat(args));
	          router.trigger('route', name, args);
	          Backbone.history.trigger('route', router, name, args);
	        }
	      });
	      return this;
	    },
	
	    // Execute a route handler with the provided parameters.  This is an
	    // excellent place to do pre-route setup or post-route cleanup.
	    execute: function(callback, args, name) {
	      if (callback) callback.apply(this, args);
	    },
	
	    // Simple proxy to `Backbone.history` to save a fragment into the history.
	    navigate: function(fragment, options) {
	      Backbone.history.navigate(fragment, options);
	      return this;
	    },
	
	    // Bind all defined routes to `Backbone.history`. We have to reverse the
	    // order of the routes here to support behavior where the most general
	    // routes can be defined at the bottom of the route map.
	    _bindRoutes: function() {
	      if (!this.routes) return;
	      this.routes = _.result(this, 'routes');
	      var route, routes = _.keys(this.routes);
	      while ((route = routes.pop()) != null) {
	        this.route(route, this.routes[route]);
	      }
	    },
	
	    // Convert a route string into a regular expression, suitable for matching
	    // against the current location hash.
	    _routeToRegExp: function(route) {
	      route = route.replace(escapeRegExp, '\\$&')
	                   .replace(optionalParam, '(?:$1)?')
	                   .replace(namedParam, function(match, optional) {
	                     return optional ? match : '([^/?]+)';
	                   })
	                   .replace(splatParam, '([^?]*?)');
	      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
	    },
	
	    // Given a route, and a URL fragment that it matches, return the array of
	    // extracted decoded parameters. Empty or unmatched parameters will be
	    // treated as `null` to normalize cross-browser behavior.
	    _extractParameters: function(route, fragment) {
	      var params = route.exec(fragment).slice(1);
	      return _.map(params, function(param, i) {
	        // Don't decode the search params.
	        if (i === params.length - 1) return param || null;
	        return param ? decodeURIComponent(param) : null;
	      });
	    }
	
	  });
	
	  // Backbone.History
	  // ----------------
	
	  // Handles cross-browser history management, based on either
	  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
	  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
	  // and URL fragments. If the browser supports neither (old IE, natch),
	  // falls back to polling.
	  var History = Backbone.History = function() {
	    this.handlers = [];
	    this.checkUrl = _.bind(this.checkUrl, this);
	
	    // Ensure that `History` can be used outside of the browser.
	    if (typeof window !== 'undefined') {
	      this.location = window.location;
	      this.history = window.history;
	    }
	  };
	
	  // Cached regex for stripping a leading hash/slash and trailing space.
	  var routeStripper = /^[#\/]|\s+$/g;
	
	  // Cached regex for stripping leading and trailing slashes.
	  var rootStripper = /^\/+|\/+$/g;
	
	  // Cached regex for stripping urls of hash.
	  var pathStripper = /#.*$/;
	
	  // Has the history handling already been started?
	  History.started = false;
	
	  // Set up all inheritable **Backbone.History** properties and methods.
	  _.extend(History.prototype, Events, {
	
	    // The default interval to poll for hash changes, if necessary, is
	    // twenty times a second.
	    interval: 50,
	
	    // Are we at the app root?
	    atRoot: function() {
	      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
	      return path === this.root && !this.getSearch();
	    },
	
	    // Does the pathname match the root?
	    matchRoot: function() {
	      var path = this.decodeFragment(this.location.pathname);
	      var rootPath = path.slice(0, this.root.length - 1) + '/';
	      return rootPath === this.root;
	    },
	
	    // Unicode characters in `location.pathname` are percent encoded so they're
	    // decoded for comparison. `%25` should not be decoded since it may be part
	    // of an encoded parameter.
	    decodeFragment: function(fragment) {
	      return decodeURI(fragment.replace(/%25/g, '%2525'));
	    },
	
	    // In IE6, the hash fragment and search params are incorrect if the
	    // fragment contains `?`.
	    getSearch: function() {
	      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
	      return match ? match[0] : '';
	    },
	
	    // Gets the true hash value. Cannot use location.hash directly due to bug
	    // in Firefox where location.hash will always be decoded.
	    getHash: function(window) {
	      var match = (window || this).location.href.match(/#(.*)$/);
	      return match ? match[1] : '';
	    },
	
	    // Get the pathname and search params, without the root.
	    getPath: function() {
	      var path = this.decodeFragment(
	        this.location.pathname + this.getSearch()
	      ).slice(this.root.length - 1);
	      return path.charAt(0) === '/' ? path.slice(1) : path;
	    },
	
	    // Get the cross-browser normalized URL fragment from the path or hash.
	    getFragment: function(fragment) {
	      if (fragment == null) {
	        if (this._usePushState || !this._wantsHashChange) {
	          fragment = this.getPath();
	        } else {
	          fragment = this.getHash();
	        }
	      }
	      return fragment.replace(routeStripper, '');
	    },
	
	    // Start the hash change handling, returning `true` if the current URL matches
	    // an existing route, and `false` otherwise.
	    start: function(options) {
	      if (History.started) throw new Error('Backbone.history has already been started');
	      History.started = true;
	
	      // Figure out the initial configuration. Do we need an iframe?
	      // Is pushState desired ... is it available?
	      this.options          = _.extend({root: '/'}, this.options, options);
	      this.root             = this.options.root;
	      this._wantsHashChange = this.options.hashChange !== false;
	      this._hasHashChange   = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
	      this._useHashChange   = this._wantsHashChange && this._hasHashChange;
	      this._wantsPushState  = !!this.options.pushState;
	      this._hasPushState    = !!(this.history && this.history.pushState);
	      this._usePushState    = this._wantsPushState && this._hasPushState;
	      this.fragment         = this.getFragment();
	
	      // Normalize root to always include a leading and trailing slash.
	      this.root = ('/' + this.root + '/').replace(rootStripper, '/');
	
	      // Transition from hashChange to pushState or vice versa if both are
	      // requested.
	      if (this._wantsHashChange && this._wantsPushState) {
	
	        // If we've started off with a route from a `pushState`-enabled
	        // browser, but we're currently in a browser that doesn't support it...
	        if (!this._hasPushState && !this.atRoot()) {
	          var rootPath = this.root.slice(0, -1) || '/';
	          this.location.replace(rootPath + '#' + this.getPath());
	          // Return immediately as browser will do redirect to new url
	          return true;
	
	        // Or if we've started out with a hash-based route, but we're currently
	        // in a browser where it could be `pushState`-based instead...
	        } else if (this._hasPushState && this.atRoot()) {
	          this.navigate(this.getHash(), {replace: true});
	        }
	
	      }
	
	      // Proxy an iframe to handle location events if the browser doesn't
	      // support the `hashchange` event, HTML5 history, or the user wants
	      // `hashChange` but not `pushState`.
	      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
	        this.iframe = document.createElement('iframe');
	        this.iframe.src = 'javascript:0';
	        this.iframe.style.display = 'none';
	        this.iframe.tabIndex = -1;
	        var body = document.body;
	        // Using `appendChild` will throw on IE < 9 if the document is not ready.
	        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
	        iWindow.document.open();
	        iWindow.document.close();
	        iWindow.location.hash = '#' + this.fragment;
	      }
	
	      // Add a cross-platform `addEventListener` shim for older browsers.
	      var addEventListener = window.addEventListener || function(eventName, listener) {
	        return attachEvent('on' + eventName, listener);
	      };
	
	      // Depending on whether we're using pushState or hashes, and whether
	      // 'onhashchange' is supported, determine how we check the URL state.
	      if (this._usePushState) {
	        addEventListener('popstate', this.checkUrl, false);
	      } else if (this._useHashChange && !this.iframe) {
	        addEventListener('hashchange', this.checkUrl, false);
	      } else if (this._wantsHashChange) {
	        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
	      }
	
	      if (!this.options.silent) return this.loadUrl();
	    },
	
	    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
	    // but possibly useful for unit testing Routers.
	    stop: function() {
	      // Add a cross-platform `removeEventListener` shim for older browsers.
	      var removeEventListener = window.removeEventListener || function(eventName, listener) {
	        return detachEvent('on' + eventName, listener);
	      };
	
	      // Remove window listeners.
	      if (this._usePushState) {
	        removeEventListener('popstate', this.checkUrl, false);
	      } else if (this._useHashChange && !this.iframe) {
	        removeEventListener('hashchange', this.checkUrl, false);
	      }
	
	      // Clean up the iframe if necessary.
	      if (this.iframe) {
	        document.body.removeChild(this.iframe);
	        this.iframe = null;
	      }
	
	      // Some environments will throw when clearing an undefined interval.
	      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
	      History.started = false;
	    },
	
	    // Add a route to be tested when the fragment changes. Routes added later
	    // may override previous routes.
	    route: function(route, callback) {
	      this.handlers.unshift({route: route, callback: callback});
	    },
	
	    // Checks the current URL to see if it has changed, and if it has,
	    // calls `loadUrl`, normalizing across the hidden iframe.
	    checkUrl: function(e) {
	      var current = this.getFragment();
	
	      // If the user pressed the back button, the iframe's hash will have
	      // changed and we should use that for comparison.
	      if (current === this.fragment && this.iframe) {
	        current = this.getHash(this.iframe.contentWindow);
	      }
	
	      if (current === this.fragment) return false;
	      if (this.iframe) this.navigate(current);
	      this.loadUrl();
	    },
	
	    // Attempt to load the current URL fragment. If a route succeeds with a
	    // match, returns `true`. If no defined routes matches the fragment,
	    // returns `false`.
	    loadUrl: function(fragment) {
	      // If the root doesn't match, no routes can match either.
	      if (!this.matchRoot()) return false;
	      fragment = this.fragment = this.getFragment(fragment);
	      return _.some(this.handlers, function(handler) {
	        if (handler.route.test(fragment)) {
	          handler.callback(fragment);
	          return true;
	        }
	      });
	    },
	
	    // Save a fragment into the hash history, or replace the URL state if the
	    // 'replace' option is passed. You are responsible for properly URL-encoding
	    // the fragment in advance.
	    //
	    // The options object can contain `trigger: true` if you wish to have the
	    // route callback be fired (not usually desirable), or `replace: true`, if
	    // you wish to modify the current URL without adding an entry to the history.
	    navigate: function(fragment, options) {
	      if (!History.started) return false;
	      if (!options || options === true) options = {trigger: !!options};
	
	      // Normalize the fragment.
	      fragment = this.getFragment(fragment || '');
	
	      // Don't include a trailing slash on the root.
	      var rootPath = this.root;
	      if (fragment === '' || fragment.charAt(0) === '?') {
	        rootPath = rootPath.slice(0, -1) || '/';
	      }
	      var url = rootPath + fragment;
	
	      // Strip the hash and decode for matching.
	      fragment = this.decodeFragment(fragment.replace(pathStripper, ''));
	
	      if (this.fragment === fragment) return;
	      this.fragment = fragment;
	
	      // If pushState is available, we use it to set the fragment as a real URL.
	      if (this._usePushState) {
	        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);
	
	      // If hash changes haven't been explicitly disabled, update the hash
	      // fragment to store history.
	      } else if (this._wantsHashChange) {
	        this._updateHash(this.location, fragment, options.replace);
	        if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
	          var iWindow = this.iframe.contentWindow;
	
	          // Opening and closing the iframe tricks IE7 and earlier to push a
	          // history entry on hash-tag change.  When replace is true, we don't
	          // want this.
	          if (!options.replace) {
	            iWindow.document.open();
	            iWindow.document.close();
	          }
	
	          this._updateHash(iWindow.location, fragment, options.replace);
	        }
	
	      // If you've told us that you explicitly don't want fallback hashchange-
	      // based history, then `navigate` becomes a page refresh.
	      } else {
	        return this.location.assign(url);
	      }
	      if (options.trigger) return this.loadUrl(fragment);
	    },
	
	    // Update the hash location, either replacing the current entry, or adding
	    // a new one to the browser history.
	    _updateHash: function(location, fragment, replace) {
	      if (replace) {
	        var href = location.href.replace(/(javascript:|#).*$/, '');
	        location.replace(href + '#' + fragment);
	      } else {
	        // Some browsers require that `hash` contains a leading #.
	        location.hash = '#' + fragment;
	      }
	    }
	
	  });
	
	  // Create the default Backbone.history.
	  Backbone.history = new History;
	
	  // Helpers
	  // -------
	
	  // Helper function to correctly set up the prototype chain for subclasses.
	  // Similar to `goog.inherits`, but uses a hash of prototype properties and
	  // class properties to be extended.
	  var extend = function(protoProps, staticProps) {
	    var parent = this;
	    var child;
	
	    // The constructor function for the new subclass is either defined by you
	    // (the "constructor" property in your `extend` definition), or defaulted
	    // by us to simply call the parent constructor.
	    if (protoProps && _.has(protoProps, 'constructor')) {
	      child = protoProps.constructor;
	    } else {
	      child = function(){ return parent.apply(this, arguments); };
	    }
	
	    // Add static properties to the constructor function, if supplied.
	    _.extend(child, parent, staticProps);
	
	    // Set the prototype chain to inherit from `parent`, without calling
	    // `parent`'s constructor function and add the prototype properties.
	    child.prototype = _.create(parent.prototype, protoProps);
	    child.prototype.constructor = child;
	
	    // Set a convenience property in case the parent's prototype is needed
	    // later.
	    child.__super__ = parent.prototype;
	
	    return child;
	  };
	
	  // Set up inheritance for the model, collection, router, view and history.
	  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;
	
	  // Throw an error when a URL is needed, and none is supplied.
	  var urlError = function() {
	    throw new Error('A "url" property or function must be specified');
	  };
	
	  // Wrap an optional error callback with a fallback error event.
	  var wrapError = function(model, options) {
	    var error = options.error;
	    options.error = function(resp) {
	      if (error) error.call(options.context, model, resp, options);
	      model.trigger('error', model, resp, options);
	    };
	  };
	
	  return Backbone;
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	// Backbone.Radio v2.0.0
	
	(function (global, factory) {
	   true ? module.exports = factory(__webpack_require__(182), __webpack_require__(181)) :
	  typeof define === 'function' && define.amd ? define(['underscore', 'backbone'], factory) :
	  (global.Backbone = global.Backbone || {}, global.Backbone.Radio = factory(global._,global.Backbone));
	}(this, function (_,Backbone) { 'use strict';
	
	  _ = 'default' in _ ? _['default'] : _;
	  Backbone = 'default' in Backbone ? Backbone['default'] : Backbone;
	
	  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	  };
	
	  var previousRadio = Backbone.Radio;
	
	  var Radio = Backbone.Radio = {};
	
	  Radio.VERSION = '2.0.0';
	
	  // This allows you to run multiple instances of Radio on the same
	  // webapp. After loading the new version, call `noConflict()` to
	  // get a reference to it. At the same time the old version will be
	  // returned to Backbone.Radio.
	  Radio.noConflict = function () {
	    Backbone.Radio = previousRadio;
	    return this;
	  };
	
	  // Whether or not we're in DEBUG mode or not. DEBUG mode helps you
	  // get around the issues of lack of warnings when events are mis-typed.
	  Radio.DEBUG = false;
	
	  // Format debug text.
	  Radio._debugText = function (warning, eventName, channelName) {
	    return warning + (channelName ? ' on the ' + channelName + ' channel' : '') + ': "' + eventName + '"';
	  };
	
	  // This is the method that's called when an unregistered event was called.
	  // By default, it logs warning to the console. By overriding this you could
	  // make it throw an Error, for instance. This would make firing a nonexistent event
	  // have the same consequence as firing a nonexistent method on an Object.
	  Radio.debugLog = function (warning, eventName, channelName) {
	    if (Radio.DEBUG && console && console.warn) {
	      console.warn(Radio._debugText(warning, eventName, channelName));
	    }
	  };
	
	  var eventSplitter = /\s+/;
	
	  // An internal method used to handle Radio's method overloading for Requests.
	  // It's borrowed from Backbone.Events. It differs from Backbone's overload
	  // API (which is used in Backbone.Events) in that it doesn't support space-separated
	  // event names.
	  Radio._eventsApi = function (obj, action, name, rest) {
	    if (!name) {
	      return false;
	    }
	
	    var results = {};
	
	    // Handle event maps.
	    if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	      for (var key in name) {
	        var result = obj[action].apply(obj, [key, name[key]].concat(rest));
	        eventSplitter.test(key) ? _.extend(results, result) : results[key] = result;
	      }
	      return results;
	    }
	
	    // Handle space separated event names.
	    if (eventSplitter.test(name)) {
	      var names = name.split(eventSplitter);
	      for (var i = 0, l = names.length; i < l; i++) {
	        results[names[i]] = obj[action].apply(obj, [names[i]].concat(rest));
	      }
	      return results;
	    }
	
	    return false;
	  };
	
	  // An optimized way to execute callbacks.
	  Radio._callHandler = function (callback, context, args) {
	    var a1 = args[0],
	        a2 = args[1],
	        a3 = args[2];
	    switch (args.length) {
	      case 0:
	        return callback.call(context);
	      case 1:
	        return callback.call(context, a1);
	      case 2:
	        return callback.call(context, a1, a2);
	      case 3:
	        return callback.call(context, a1, a2, a3);
	      default:
	        return callback.apply(context, args);
	    }
	  };
	
	  // A helper used by `off` methods to the handler from the store
	  function removeHandler(store, name, callback, context) {
	    var event = store[name];
	    if ((!callback || callback === event.callback || callback === event.callback._callback) && (!context || context === event.context)) {
	      delete store[name];
	      return true;
	    }
	  }
	
	  function removeHandlers(store, name, callback, context) {
	    store || (store = {});
	    var names = name ? [name] : _.keys(store);
	    var matched = false;
	
	    for (var i = 0, length = names.length; i < length; i++) {
	      name = names[i];
	
	      // If there's no event by this name, log it and continue
	      // with the loop
	      if (!store[name]) {
	        continue;
	      }
	
	      if (removeHandler(store, name, callback, context)) {
	        matched = true;
	      }
	    }
	
	    return matched;
	  }
	
	  /*
	   * tune-in
	   * -------
	   * Get console logs of a channel's activity
	   *
	   */
	
	  var _logs = {};
	
	  // This is to produce an identical function in both tuneIn and tuneOut,
	  // so that Backbone.Events unregisters it.
	  function _partial(channelName) {
	    return _logs[channelName] || (_logs[channelName] = _.bind(Radio.log, Radio, channelName));
	  }
	
	  _.extend(Radio, {
	
	    // Log information about the channel and event
	    log: function log(channelName, eventName) {
	      if (typeof console === 'undefined') {
	        return;
	      }
	      var args = _.toArray(arguments).slice(2);
	      console.log('[' + channelName + '] "' + eventName + '"', args);
	    },
	
	    // Logs all events on this channel to the console. It sets an
	    // internal value on the channel telling it we're listening,
	    // then sets a listener on the Backbone.Events
	    tuneIn: function tuneIn(channelName) {
	      var channel = Radio.channel(channelName);
	      channel._tunedIn = true;
	      channel.on('all', _partial(channelName));
	      return this;
	    },
	
	    // Stop logging all of the activities on this channel to the console
	    tuneOut: function tuneOut(channelName) {
	      var channel = Radio.channel(channelName);
	      channel._tunedIn = false;
	      channel.off('all', _partial(channelName));
	      delete _logs[channelName];
	      return this;
	    }
	  });
	
	  /*
	   * Backbone.Radio.Requests
	   * -----------------------
	   * A messaging system for requesting data.
	   *
	   */
	
	  function makeCallback(callback) {
	    return _.isFunction(callback) ? callback : function () {
	      return callback;
	    };
	  }
	
	  Radio.Requests = {
	
	    // Make a request
	    request: function request(name) {
	      var args = _.toArray(arguments).slice(1);
	      var results = Radio._eventsApi(this, 'request', name, args);
	      if (results) {
	        return results;
	      }
	      var channelName = this.channelName;
	      var requests = this._requests;
	
	      // Check if we should log the request, and if so, do it
	      if (channelName && this._tunedIn) {
	        Radio.log.apply(this, [channelName, name].concat(args));
	      }
	
	      // If the request isn't handled, log it in DEBUG mode and exit
	      if (requests && (requests[name] || requests['default'])) {
	        var handler = requests[name] || requests['default'];
	        args = requests[name] ? args : arguments;
	        return Radio._callHandler(handler.callback, handler.context, args);
	      } else {
	        Radio.debugLog('An unhandled request was fired', name, channelName);
	      }
	    },
	
	    // Set up a handler for a request
	    reply: function reply(name, callback, context) {
	      if (Radio._eventsApi(this, 'reply', name, [callback, context])) {
	        return this;
	      }
	
	      this._requests || (this._requests = {});
	
	      if (this._requests[name]) {
	        Radio.debugLog('A request was overwritten', name, this.channelName);
	      }
	
	      this._requests[name] = {
	        callback: makeCallback(callback),
	        context: context || this
	      };
	
	      return this;
	    },
	
	    // Set up a handler that can only be requested once
	    replyOnce: function replyOnce(name, callback, context) {
	      if (Radio._eventsApi(this, 'replyOnce', name, [callback, context])) {
	        return this;
	      }
	
	      var self = this;
	
	      var once = _.once(function () {
	        self.stopReplying(name);
	        return makeCallback(callback).apply(this, arguments);
	      });
	
	      return this.reply(name, once, context);
	    },
	
	    // Remove handler(s)
	    stopReplying: function stopReplying(name, callback, context) {
	      if (Radio._eventsApi(this, 'stopReplying', name)) {
	        return this;
	      }
	
	      // Remove everything if there are no arguments passed
	      if (!name && !callback && !context) {
	        delete this._requests;
	      } else if (!removeHandlers(this._requests, name, callback, context)) {
	        Radio.debugLog('Attempted to remove the unregistered request', name, this.channelName);
	      }
	
	      return this;
	    }
	  };
	
	  /*
	   * Backbone.Radio.channel
	   * ----------------------
	   * Get a reference to a channel by name.
	   *
	   */
	
	  Radio._channels = {};
	
	  Radio.channel = function (channelName) {
	    if (!channelName) {
	      throw new Error('You must provide a name for the channel.');
	    }
	
	    if (Radio._channels[channelName]) {
	      return Radio._channels[channelName];
	    } else {
	      return Radio._channels[channelName] = new Radio.Channel(channelName);
	    }
	  };
	
	  /*
	   * Backbone.Radio.Channel
	   * ----------------------
	   * A Channel is an object that extends from Backbone.Events,
	   * and Radio.Requests.
	   *
	   */
	
	  Radio.Channel = function (channelName) {
	    this.channelName = channelName;
	  };
	
	  _.extend(Radio.Channel.prototype, Backbone.Events, Radio.Requests, {
	
	    // Remove all handlers from the messaging systems of this channel
	    reset: function reset() {
	      this.off();
	      this.stopListening();
	      this.stopReplying();
	      return this;
	    }
	  });
	
	  /*
	   * Top-level API
	   * -------------
	   * Supplies the 'top-level API' for working with Channels directly
	   * from Backbone.Radio.
	   *
	   */
	
	  var channel;
	  var args;
	  var systems = [Backbone.Events, Radio.Requests];
	  _.each(systems, function (system) {
	    _.each(system, function (method, methodName) {
	      Radio[methodName] = function (channelName) {
	        args = _.toArray(arguments).slice(1);
	        channel = this.channel(channelName);
	        return channel[methodName].apply(channel, args);
	      };
	    });
	  });
	
	  Radio.reset = function (channelName) {
	    var channels = !channelName ? this._channels : [this._channels[channelName]];
	    _.each(channels, function (channel) {
	      channel.reset();
	    });
	  };
	
	  return Radio;
	
	}));
	//# sourceMappingURL=./backbone.radio.js.map

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(180);
	
	var Router = Marionette.AppRouter.extend({
	    appRoutes: {
	        '': 'showRoot',
	        'organizations': 'organizationsList',
	        'organization/:entry': 'organizationEntry',
	        'organization/:entry/patients': 'organizationEntryPatients',
	        'documents': 'documentsList',
	        'document/:entry': 'documentEntry',
	        'document-history/:entry': 'documentHistoryEntry',
	        'history/:entry': 'historyEntries',
	        'upload': 'documentUploadShow',
	        'upload-signed': 'uploadSignedDocumentShow',
	        'login': 'login',
	        'signup': 'signup',
	        'settings': 'settingsList',
	        'persons': 'personsList',
	        'person/:entry': 'personEntry',
	        'relations': 'relationsList',
	        'relationtypes': 'relationtypesList',
	        'relationtype/:entry': 'relationtypeEntry',
	        'roles': 'rolesList',
	        'changepassword/:entry': 'changePasswordEntry',
	        'doctypes': 'doctypesList',
	        'help': 'helpSectionsList',
	        'help-physician': 'helpPhysician',
	        'help-office-admin': 'helpOfficeAdmin',
	        'help-corporate-admin': 'helpCorporateAdmin',
	        'help-feedback': 'helpFeedback',
	        'patients': 'patientsList',
	        'statistics': 'statistics',
	        'login/by-instant-token/:token':'instantToken',
	        'import-persons': 'importPersons',
	        'merge-persons': 'mergePersons',
	        'merge-persons/:mergeTo/:mergeFrom': 'mergePersons',
	        'cmform': 'referralForm',
	        'village-podiatry-form': 'villagePodiatryForm',
	        'ff-form': 'faceToFaceForm',
	        'ff-form/:entry': 'faceToFaceForm',
	        'ff-forms': 'faceToFaceFormsList'
	    },
	
	    initialize: function(){
	        this.controller = this.getOption('controller');
	    }
	
	});
	
	module.exports = Router;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	var Header = __webpack_require__(186);
	var Body = __webpack_require__(205);
	var Footer = __webpack_require__(528);
	var SvnInfoModal = __webpack_require__(530);
	var ActiveSessionsModal = __webpack_require__(532);
	
	var SessionModel = __webpack_require__(187);
	
	var Radio = __webpack_require__(183);
	var servicesChannel = Radio.channel('services');
	var actionsChannel = Radio.channel('actions');
	
	var servicesAddresses = undefined;
	var defaultMedicationForms = undefined;
	
	var Controller = Marionette.View.extend({
	
	    template: _.template('<div id="app-header" class="app-header"></div><div id="app-body"></div><div id="system-modal"></div><div id="app-footer"></div>'),
	
	    adminMenuItems: [
	        {title: 'Settings', url: '#settings', activeClass: ''}
	    ],
	
	    currentSessionId: undefined,
	
	    regions: {
	        header: '#app-header',
	        body: '#app-body',
	        footer: '#app-footer',
	        systemModal: "#system-modal"
	    },
	
	    notAuthenticablePaths: ['login', 'signup', 'help', 'help-physician', 'help-office-admin', 'help-corporate-admin', 'help-feedback', 'login/by-instant-token/:token'],
	    adminOnlyPaths: ['settings', 'relations', 'persons', 'person/:entry', 'relationtypes', 'relationtype/:entry', 'roles',
	        'doctypes', 'import-persons', 'merge-persons'],
	    session: new SessionModel(),
	
	    childViewEvents: {
	        'invalidate:current:session:id': 'invalidateCurrentSessionId'
	    },
	
	    initOnceSingletonData: function () {
	        this.fetchAndSetServicesAddresses();
	        this.fetchAndSetDefaultMedicationForms();
	    },
	
	    getServicesAddresses: function () {
	        return servicesAddresses;
	    },
	
	    getDefaultMedicationForms: function () {
	        return defaultMedicationForms;
	    },
	
	    fetchAndSetServicesAddresses: function () {
	        if (servicesAddresses == undefined) {
	            $.ajax({
	                type: "GET",
	                url: '/api/reference/hosts',
	                contentType: 'application/json',
	                statusCode: {
	                    200: function (response) {
	                        servicesAddresses = response;
	                    }
	                },
	                error: function (e) {
	                    console.log(e);
	                }
	            });
	        }
	    },
	
	    fetchAndSetDefaultMedicationForms: function () {
	        if (defaultMedicationForms == undefined) {
	            $.when(
	                $.ajax({
	                    type: "GET",
	                    headers: {
	                        Accept: 'application/json'
	                    },
	                    url: 'https://rxnav.nlm.nih.gov/REST/allconcepts.json?tty=DFG',
	                })
	            ).done(function (resp) {
	                defaultMedicationForms = _.sortBy(resp.minConceptGroup.minConcept.map(function (concept) {
	                    return {
	                        id: concept.rxcui,
	                        name: concept.name
	                    }
	                }), 'name');
	            }).fail(function (jqXHR, textStatus) {
	                console.log(jqXHR);
	            });
	        }
	    },
	
	
	    initialize: function () {
	        var that = this;
	        that.options = {};
	        this.defaultMenuItems = that.createDefaultMenuItems();
	        servicesChannel.reply('get:services:address', that.getServicesAddresses);
	        servicesChannel.reply('get:default:medication:forms', that.getDefaultMedicationForms);
	        actionsChannel.reply('redirect:to:login', function () {
	            that.getChildView('header').clearAndToMainPage();
	        });
	
	        that.initOnceSingletonData();
	    },
	
	    onRender: function () {
	        var that = this;
	
	        var body = new Body();
	        var header = new Header({
	            menuItems: _.map(that.defaultMenuItems, _.clone),
	            defaultMenuItems: that.defaultMenuItems,
	            body: body
	        });
	
	        this.getRegion('header').show(header);
	        this.getRegion('body').show(body);
	
	        var footer = new Footer();
	        this.getRegion('footer').show(footer);
	
	        /** We want easy access to our root view later */
	        this.options.header = header;
	        this.options.body = body;
	        this.options.footer = footer;
	
	
	        // fix for opening modal over other modals
	        $(document).on('hidden.bs.modal', function (event) {
	            if ($('.modal:visible').length) {
	                $('body').addClass('modal-open');
	            }
	        });
	
	        // init system and meta things
	        this.initSystemAndMeta();
	    },
	
	    actionDispatch: function (bodyEvent, menuItem, entry, entry2) {
	        if (this.notAuthenticablePaths.indexOf(menuItem) > -1) {
	            this.actionDispatchRender(bodyEvent, menuItem, entry, entry2);
	            return;
	        }
	        var that = this;
	        this.session.fetch({
	            error: function () {
	                that.getChildView('header').clearAndToMainPage();
	            },
	            success: function (gotSession) {
	                if ((gotSession.get('systemRoles') || []).indexOf('ADMIN') <= -1 && that.adminOnlyPaths.indexOf(menuItem) > -1
	                    && !that.isUsersOwnProfile(bodyEvent, entry, gotSession) && bodyEvent != 'show:person:entry') {
	                    Backbone.history.navigate('/', {trigger: true});
	                } else if (gotSession.get('person').defaultPassword) {
	                    that.updateSession(gotSession);
	                    that.actionDispatchRender('change:password:entry', 'settings', gotSession.get('person').login);
	                    Backbone.history.navigate('/', {trigger: false});
	                } else {
	                    that.updateSession(gotSession);
	                    that.actionDispatchRender(bodyEvent, menuItem, entry, entry2);
	                }
	            }
	        });
	    },
	
	    actionDispatchRender: function (bodyEvent, menuItem, entry, entry2) {
	        var layout = this.options.body;
	        if (typeof entry === 'undefined')
	            layout.triggerMethod(bodyEvent);
	        else if (typeof entry2 === 'undefined')
	            layout.triggerMethod(bodyEvent, entry);
	        else
	            layout.triggerMethod(bodyEvent, entry, entry2);
	        this.options.header.triggerMethod('menu:changed', menuItem);
	    },
	
	    updateSession: function (session) {
	        if (this.currentSessionId && this.currentSessionId == session.get('id')) {
	            return;
	        }
	        this.session = session;
	        this.currentLogin = session.get('person').login;
	        this.defaultMenuItems = this.createDefaultMenuItems();
	        if ((session.get('systemRoles') || []).indexOf('ADMIN') > -1) {
	            this.options.header.options.menuItems =
	                _.union(this.defaultMenuItems, this.adminMenuItems);
	        } else {
	            this.options.header.options.menuItems = this.defaultMenuItems;
	        }
	        this.currentSessionId = session.get('id');
	        this.options.header.triggerMethod('session:changed', session);
	        this.options.body.triggerMethod('session:changed', session);
	    },
	
	    invalidateCurrentSessionId: function () {
	        this.currentSessionId = undefined;
	    },
	
	    createDefaultMenuItems: function () {
	        return [
	            {
	                title: 'Documents', url: '/#documents', activeClass: 'dropdown',
	                submenus: [
	                    {title: 'View All', url: '/#documents?object_type=pdf', activeClass: ''},
	                    {title: 'Review Requested', url: '/#documents?toReview=true', activeClass: ''},
	                    {
	                        title: 'Reviewed by Me',
	                        url: '/#documents?PERSON_REVIEW_FINISHED_REQUEST=' + (this.currentLogin || ''),
	                        activeClass: ''
	                    },
	                    {title: 'Upload', url: '/#upload', activeClass: ''},
	                    {title: 'Upload Signed Document', url: '/#upload-signed', activeClass: ''}
	                ]
	            },
	            {title: 'Organizations', url: '/#organizations', activeClass: 'active'},
	            {title: 'Patients', url: '/#patients', activeClass: ''},
	            {title: 'Reports', url: '/#statistics', activeClass: ''},
	            {
	                title: 'Forms', url: '/#forms', activeClass: 'dropdown',
	                submenus: [
	                    {title: 'Village Podiatry HH Orders Form', url: '/#village-podiatry-form', activeClass: ''},
	                    {title: 'Face-to-face Form', url: '/#ff-form', activeClass: ''},
	                    {title: 'Face-to-face Forms List', url: '/#ff-forms', activeClass: ''}
	                ]
	            }
	        ]
	    },
	
	    initSystemAndMeta: function () {
	        var that = this;
	        document.onkeyup = function (e) {
	
	            if (that.currentSessionId) {
	                if (e.ctrlKey && e.shiftKey && e.which == 49) { // for SVN info
	                    var svnInfoModal = new SvnInfoModal();
	                    that.getRegion('systemModal').show(svnInfoModal);
	                } else if (e.ctrlKey && e.shiftKey && e.which == 50 && (that.session.get('systemRoles') || []).indexOf('ADMIN') > -1) { // Active Sessions (Users) only By Admin
	                    var activeSessionsModal = new ActiveSessionsModal({mySessionId: that.currentSessionId});
	                    that.getRegion('systemModal').show(activeSessionsModal);
	                }
	            }
	        };
	    },
	
	    showRoot: function () {
	        Backbone.history.navigate('/documents?object_type=pdf', {trigger: true});
	    },
	    organizationsList: function () {
	        this.actionDispatch('show:organizations:list', 'organizations');
	    },
	    organizationEntry: function (entry) {
	        this.actionDispatch('show:organization:entry', 'organizations', entry);
	    },
	    organizationEntryPatients: function (entry) {
	        this.actionDispatch('show:organization:entry:patients', 'organizations', entry);
	    },
	    personEntry: function (entry) {
	        this.actionDispatch('show:person:entry', 'settings', entry);
	    },
	    documentsList: function () {
	        this.actionDispatch('show:documents:list', 'documents');
	    },
	    documentEntry: function (entry) {
	        this.actionDispatch('show:document:entity', 'documents', entry);
	    },
	    documentHistoryEntry: function (entry) {
	        this.actionDispatch('show:document:history:entity', 'documents', entry);
	    },
	    historyEntries: function (entry) {
	        this.actionDispatch('show:history:entries', 'documents', entry);
	    },
	    documentUploadShow: function () {
	        this.actionDispatch('show:document:upload', 'documents');
	    },
	    uploadSignedDocumentShow: function () {
	        this.actionDispatch('show:document:upload:signed', 'documents');
	    },
	    personsList: function () {
	        this.actionDispatch('show:persons:list', 'settings');
	    },
	    login: function () {
	        this.actionDispatch('show:login', 'login');
	    },
	    signup: function () {
	        this.actionDispatch('show:signup', 'login');
	    },
	    settingsList: function () {
	        this.actionDispatch('show:settings:list', 'settings');
	    },
	    relationsList: function () {
	        this.actionDispatch('show:relations:list', 'settings');
	    },
	    relationtypesList: function () {
	        this.actionDispatch('show:relationtypes:list', 'settings');
	    },
	    relationtypeEntry: function (entry) {
	        this.actionDispatch('show:relationtype:entry', 'settings', entry);
	    },
	    rolesList: function () {
	        this.actionDispatch('show:roles:list', 'settings');
	    },
	    changePasswordEntry: function (entry) {
	        this.actionDispatch('change:password:entry', 'settings', entry);
	
	    },
	    doctypesList: function () {
	        this.actionDispatch('show:doctypes:list', 'settings');
	    },
	
	    helpSectionsList: function () {
	        this.actionDispatch('show:help:list', 'help');
	    },
	
	    helpPhysician: function () {
	        this.actionDispatch('show:help:physician', 'help');
	    },
	
	    helpOfficeAdmin: function () {
	        this.actionDispatch('show:help:office:admin', 'help');
	    },
	
	    helpCorporateAdmin: function () {
	        this.actionDispatch('show:help:corporate:admin', 'help');
	    },
	
	    helpFeedback: function () {
	        this.actionDispatch('show:help:feedback', 'help');
	    },
	
	
	    isUsersOwnProfile: function (bodyEvent, entry, session) {
	        return (bodyEvent == 'show:person:entry' || bodyEvent == 'change:password:entry') && (session.attributes.name || '') == entry;
	    },
	
	    patientsList: function () {
	        this.actionDispatch('show:patients:list', 'patients');
	    },
	
	    statistics: function () {
	        this.actionDispatch('show:statistics', 'statistics');
	    },
	
	    instantToken: function (token) {
	        this.actionDispatch('auth:by:instant:token', 'login/by-instant-token/:token', token);
	    },
	
	    importPersons: function () {
	        this.actionDispatch('show:import:persons', 'settings');
	    },
	
	    mergePersons: function (mergeTo, mergeFrom) {
	        this.actionDispatch('show:merge:persons', 'settings', mergeTo, mergeFrom);
	    },
	
	    referralForm: function () {
	        this.actionDispatch('show:referral:form', 'login');
	    },
	
	    villagePodiatryForm: function (entry) {
	        this.actionDispatch('show:village:podiatry:form', 'forms', entry);
	    },
	
	    faceToFaceForm: function (entry) {
	        this.actionDispatch('show:ff:form', 'forms', entry);
	    },
	
	    faceToFaceFormsList: function () {
	        this.actionDispatch('show:forms:list', 'forms');
	    }
	});
	
	module.exports = Controller;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var Session = __webpack_require__(187);
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var permissionsChannel = Radio.channel('session');
	var actionsChannel = Radio.channel('actions');
	
	var SetInitialViewModalView = __webpack_require__(188);
	
	var Header = Marionette.View.extend({
	    template: __webpack_require__(202),
	
	    regions: {
	        setInitialViewModal: '#initial-view-modal'
	    },
	
	    model: new Session(),
	    activeMenu: 'organizations',
	    modelEvents: {
	        'change': 'render'
	    },
	
	    events: {
	        'click #logout': 'performLogout',
	        'click #set-initial-for-me': 'setCurrentViewAsInitialForMe',
	        'click #set-initial': 'setCurrentViewAsInitial'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            isActiveMenu: that.isActiveMenu,
	            menuItems: that.options.menuItems,
	            isAdmin: that.body.byAdmin()
	        }
	    },
	
	    initialize: function (options) {
	        this.menuItems = options.menuItems;
	        _.bindAll(this, 'onSessionChanged', 'onMenuChanged', 'performLogout', 'isActiveMenu', 'getPermissions', 'getUserId', 'clearAndToMainPage');
	        permissionsChannel.reply('get:permissions', this.getPermissions);
	        permissionsChannel.reply('get:userId', this.getUserId);
	        this.body = options.body;
	    },
	
	    getPermissions: function () {
	        var userId = this.model.get('person').login;
	        var userSystemRoles = this.model.get('systemRoles');
	        var userPermissions = this.model.get('permissions');
	        return {
	            userId: userId,
	            userSystemRoles: userSystemRoles,
	            userPermissions: userPermissions,
	            isMd: this.model.get('person').isMd,
	            isPatient: this.model.get('person').isPatient
	        };
	    },
	
	    getUserId: function () {
	        return this.model.get('person').login;
	    },
	
	
	    isActiveMenu: function (menuItem) {
	        return (this.activeMenu.toLowerCase() == menuItem.toLowerCase()) ? 'active' : '';
	    },
	
	    onSessionChanged: function (session) {
	        this.model.set(session.toJSON());
	    },
	
	    onMenuChanged: function (menuItem) {
	        this.activeMenu = menuItem;
	        this.options.menuItems.forEach(function (menuItem) {
	            if (this.activeMenu.toLowerCase() == menuItem.title.toLowerCase()) {
	                menuItem.activeClass = 'active';
	            } else {
	                menuItem.activeClass = '';
	            }
	        }, this);
	        this.render();
	    },
	
	
	    performLogout: function () {
	        var that = this;
	        $.ajax({
	            type: "DELETE",
	            url: '/api/login/session',
	            statusCode: {
	                200: function () {
	                    that.clearAndToMainPage();
	                }
	            }
	        });
	    },
	
	    setCurrentViewAsInitialForMe: function () {
	        var url = window.location.hash;
	        $.ajax({
	            type: "POST",
	            url: '/api/person/initial-url',
	            contentType: 'text/plain',
	            data: url,
	            statusCode: {
	                200: function () {
	                    $.notify({
	                        message: 'Initial View was set successfully'
	                    }, {
	                        type: 'success',
	                        z_index: 2000
	                    });
	                }
	            },
	            error: function (e) {
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            }
	        });
	    },
	
	    setCurrentViewAsInitial: function () {
	        console.log("setCurrentViewAsInitial");
	        var url = window.location.hash;
	        console.log(url);
	
	        this.setInitialViewModalView = new SetInitialViewModalView();
	        this.showChildView('setInitialViewModal', this.setInitialViewModalView);
	        this.setInitialViewModalView.show(url);
	    },
	
	    clearAndToMainPage: function () {
	        var that = this;
	        var redirectUrl = '/login';
	        if (Backbone.history.fragment != '' && Backbone.history.fragment != '/' && Backbone.history.fragment != 'login') {
	            redirectUrl = redirectUrl + '?retpath=' +
	                encodeURIComponent(Backbone.history.fragment);
	        }
	        that.options.menuItems.forEach(function (menuItem) {
	            menuItem.activeClass = '';
	        }, this);
	        that.options.menuItems = _.map(that.options.defaultMenuItems, _.clone);
	        that.model.clear();
	        that.triggerMethod('invalidate:current:session:id');
	        Backbone.history.navigate(redirectUrl, {trigger: true});
	    }
	
	});
	
	
	module.exports = Header;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(181);
	
	
	var SessionModel = Backbone.Model.extend({
	    url: '/api/login/session'
	});
	
	
	module.exports = SessionModel;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var CommonUtils = __webpack_require__(189);
	var RemoteSuggesterView = __webpack_require__(196);
	
	var SetInitialViewModalView = Marionette.View.extend({
	    template: __webpack_require__(201),
	
	    regions: {
	        personsSelect: '#persons-container',
	    },
	
	    ui: {
	        modal: '#set-initial-view-modal',
	        save: '#save'
	    },
	
	    events: {
	        'click @ui.save': 'onSave'
	    },
	
	    childViewEvents: {
	        'suggestor:selected:person': 'personChanged'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {}
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.utils = new CommonUtils();
	        this.selectedPerson = null;
	        this.initialViewUrl = null;
	    },
	
	    onRender: function () {
	        var that = this;
	        that.renderPersonSelectView(that.selectedPerson);
	    },
	
	    renderPersonSelectView: function (person) {
	        var that = this;
	
	        that.showChildView('personsSelect', new RemoteSuggesterView({
	            maxNumberOfElements: 20,
	            url: '/api/person/preview?page-size=' + 20 + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Select Person",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return (arr[index] || {}).id;
	            },
	            tag: 'person',
	            defaultSelected: person
	        }));
	    },
	    onSave: function () {
	        var that = this;
	        console.log(that.selectedPerson);
	        console.log(that.initialViewUrl);
	        $.ajax({
	            type: "POST",
	            url: '/api/person/initial-url?personId=' + that.selectedPerson,
	            contentType: 'text/plain',
	            data: this.initialViewUrl,
	            statusCode: {
	                200: function () {
	                    that.hide();
	                    $.notify({
	                        message: 'Initial View was set successfully'
	                    }, {
	                        type: 'success',
	                        z_index: 2000
	                    });
	                }
	            },
	            error: function (e) {
	                if (e.status == 401) {
	                    that.hide();
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            }
	        });
	    },
	
	    show: function (initialViewUrl) {
	        this.initialViewUrl = initialViewUrl;
	        this.validate();
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    },
	
	    enableSave: function () {
	        this.ui.save.removeAttr('disabled');
	    },
	
	    disableSave: function () {
	        this.ui.save.attr('disabled', true);
	    },
	
	    validate: function () {
	        if (this.selectedPerson && this.initialViewUrl)
	            this.enableSave();
	        else
	            this.disableSave();
	    },
	
	    personChanged: function (id) {
	        this.selectedPerson = id;
	        this.validate();
	    },
	});
	
	module.exports = SetInitialViewModalView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Marionette = __webpack_require__(180);
	var moment = __webpack_require__(30); // For Date Time manipulations
	const uuidV4 = __webpack_require__(190);
	
	var Dicts = __webpack_require__(193);
	var DocumentMetaDicts = __webpack_require__(194);
	var Constants = __webpack_require__(195);
	
	var CommonUtils = Marionette.Object.extend({
	
	        stringContains: function (str, fragment) {
	            str = (str || '').toLowerCase();
	            fragment = (fragment || '').toLowerCase();
	            return str.indexOf(fragment) !== -1
	        },
	
	        stringDateToLong: function (format, stringValue) {
	            return moment(stringValue, format).toDate().getTime();
	        },
	
	        longToDateTimeFormatted: function (uts, format) {
	            return moment(uts).format(format);
	        },
	
	        dateToLong: function (d) {
	            try {
	                return Number(new Date(d).getTime());
	            }
	            catch (exp) {
	                return 0;
	            }
	        },
	
	        longToDateTimeFormattedInUtc: function (l, format) {
	            console.log(l);
	            //return moment(l).utcOffset(new Date().getTimezoneOffset()).format(format);
	
	            var date = new Date(l);
	            var utcDate = new Date();
	            utcDate.setFullYear(date.getUTCFullYear());
	            utcDate.setMonth(date.getUTCMonth());
	            utcDate.setDate(date.getUTCDate());
	            /*utcDate.setHours(date.getUTCHours());
	            utcDate.setMinutes(date.getUTCMinutes());
	            utcDate.setSeconds(date.getUTCSeconds());
	            utcDate.setMilliseconds(date.getUTCMilliseconds());*/
	            return moment(utcDate).format(format);
	        },
	
	        dateToLongInUtc: function (d) {
	            try {
	                var date = new Date(d);
	                var utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()/*,
	                    date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()*/);
	                console.log(utc);
	                console.log(Number(new Date(d).getTime()));
	                return utc;
	            }
	            catch (exp) {
	                return 0;
	            }
	        },
	
	        getDateWithoutTime: function (dt) {
	            return moment(dt).clone().startOf('day');
	        },
	
	        showSpinner: function (el) {
	            if (typeof el === 'undefined')
	                el = '.loader';
	            $(el).show();
	        },
	
	        hideSpinner: function (el) {
	            if (typeof el === 'undefined')
	                el = '.loader';
	            $(el).hide();
	        },
	
	        formatPerson: function (person) {
	            var names = [];
	            if (!_.isEmpty(person.lastName))
	                names.push(person.lastName.toUpperCase());
	            if (!_.isEmpty(person.firstName))
	                names.push(person.firstName.toUpperCase());
	            return names.join(", ");
	        },
	
	        userCanDo: function (userPermissions, userPermissionFilter, objectPermissions, objectPermissionFilter) {
	            if (_.contains(userPermissions.userSystemRoles, 'ADMIN'))
	                return true;
	
	            var canDoFor = (userPermissions || []).userPermissions.filter(userPermissionFilter).map(function (permission) {
	                return permission.permittedObjectId;
	            });
	            canDoFor.push(userPermissions.userId);
	
	            var canDo = false;
	            (objectPermissions || []).filter(objectPermissionFilter).forEach(function (permission) {
	                if (permission.ownerId && permission.organizationId &&
	                    canDoFor.indexOf(permission.ownerId) > -1 &&
	                    canDoFor.indexOf(permission.organizationId) > -1) {
	                    canDo = true;
	                }
	
	                if (permission.ownerId && !permission.organizationId &&
	                    canDoFor.indexOf(permission.ownerId) > -1) {
	                    canDo = true;
	                }
	
	                if (!permission.ownerId && permission.organizationId &&
	                    canDoFor.indexOf(permission.organizationId) > -1) {
	                    canDo = true;
	                }
	            });
	            return canDo;
	        },
	
	        userCanDoWithDocument: function (userPermissions, userPermissionFilterFor, userPermissionFilterAll, objectPermissions, objectPermissionFilter) {
	            if (_.contains(userPermissions.userSystemRoles, 'ADMIN'))
	                return true;
	
	            var canDoFor = (userPermissions || []).userPermissions.filter(userPermissionFilterFor).map(function (permission) {
	                return permission.permittedObjectId;
	            });
	            canDoFor.push(userPermissions.userId);
	
	            var canDoForAll = (userPermissions || []).userPermissions.filter(userPermissionFilterAll).map(function (permission) {
	                return permission.permittedObjectId;
	            });
	
	            var canDo = false;
	            (objectPermissions || []).filter(objectPermissionFilter).forEach(function (permission) {
	                if (permission.ownerId && permission.organizationId &&
	                    canDoFor.indexOf(permission.ownerId) > -1 &&
	                    canDoFor.indexOf(permission.organizationId) > -1) {
	                    canDo = true;
	                }
	
	                if (permission.ownerId && !permission.organizationId &&
	                    canDoFor.indexOf(permission.ownerId) > -1) {
	                    canDo = true;
	                }
	
	                if (!permission.ownerId && permission.organizationId &&
	                    canDoFor.indexOf(permission.organizationId) > -1) {
	                    canDo = true;
	                }
	
	                if (permission.organizationId && canDoForAll.indexOf(permission.organizationId) > -1)
	                    canDo = true;
	            });
	            return canDo;
	        },
	
	        queryParamsToCollection: function (params) {
	            var result = [];
	            for (var param in params) {
	
	                if (Array.isArray(params[param])) {
	
	                    for (var ind in params[param]) {
	                        result.push({key: param, value: params[param][ind]});
	                    }
	
	                } else {
	                    result.push({key: param, value: params[param]})
	                }
	            }
	            return result;
	        },
	
	        canUserChangeStatus: function (permissions, reviewer) {
	            if (permissions.userSystemRoles && _.contains(permissions.userSystemRoles, 'ADMIN'))
	                return true;
	
	            var perms = permissions.userPermissions;
	            if (reviewer.personId && !reviewer.organizationId) {
	
	                if (permissions.userId == reviewer.personId)
	                    return true;
	                var found = _.find(perms, function (perm) {
	                    return perm.permittedObjectId == reviewer.personId && perm.canSign == true;
	                });
	                return typeof(found) != "undefined";
	            }
	            else if (!reviewer.personId && reviewer.organizationId) {
	
	                var foundForOrganizationSignAll = _.find(perms, function (perm) {
	                    return perm.permittedObjectId == reviewer.organizationId && perm.canSignAll == true;
	                });
	
	                if (typeof(foundForOrganizationSignAll) != "undefined")
	                    return true;
	
	                var found = _.find(perms, function (perm) {
	                    return perm.permittedObjectId == reviewer.organizationId && perm.canSign == true;
	                });
	                return typeof(found) != "undefined";
	            }
	            else if (reviewer.personId && reviewer.organizationId) {
	
	                var foundForOrganizationSignAll = _.find(perms, function (perm) {
	                    return perm.permittedObjectId == reviewer.organizationId && perm.canSignAll == true;
	                });
	
	                if (typeof(foundForOrganizationSignAll) != "undefined")
	                    return true;
	
	                var foundForPerson = _.find(perms, function (perm) {
	                    return perm.permittedObjectId == reviewer.personId && perm.canSign == true;
	                });
	                var foundForOrganization = _.find(perms, function (perm) {
	                    return perm.permittedObjectId == reviewer.organizationId && perm.canSign == true;
	                });
	
	                return (typeof(foundForPerson) != "undefined" || permissions.userId == reviewer.personId)
	                    && typeof(foundForOrganization) != "undefined";
	            }
	
	            return false;
	        },
	
	        getQueryParams: function () {
	            var paramsTokens = window.location.hash.split("?");
	            var params = {};
	            if (paramsTokens.length > 1) {
	                params = $.deparam(window.location.hash.replace(paramsTokens[0], '').replace('?', '')) || {};
	            }
	            return params;
	        },
	
	        isUrlWoExtraQueryParameters: function () {
	
	            var queryParams = this.getQueryParams();
	            return _.isEmpty(queryParams) ||
	                (_.keys(queryParams).length == 2
	                    && typeof queryParams["page-size"] != "undefined"
	                    && typeof queryParams["page"] != "undefined")
	        },
	
	        redirectToUrlWoExtraQueryParameters: function () {
	
	            var defaultParams = this.fillWithDefaultParams({});
	            window.location.hash = this.getCleanBaseHash() + "?" + this.objectToQueryParams(defaultParams);
	        },
	
	        getDefaultListParams: function () {
	            var params = this.getQueryParams();
	            return this.fillWithDefaultParams(params);
	        },
	
	        fillWithDefaultParams: function (params) {
	            params['page-size'] = params['page-size'] || Constants.pageCapacity;
	            params.page = parseInt(params.page || Constants.pageInitialOrd, 10);
	            return params;
	        },
	
	        getCleanBaseHash: function () {
	            var paramsTokens = window.location.hash.split("?");
	            return paramsTokens[0].replace('#', '');
	        },
	
	        objectToQueryParams: function (params) {
	            var tokens = [];
	            for (var i in params) {
	                if (Array.isArray(params[i])) {
	                    for (var j in params[i]) {
	                        tokens.push(i + '=' + params[i][j]);
	                    }
	                } else {
	                    tokens.push(i + '=' + params[i]);
	                }
	            }
	            return tokens.join('&');
	        },
	
	        isParamExists: function (params, searchObject) {
	            if (_.findWhere(params, searchObject))
	                return true;
	            else
	                return false;
	        },
	
	        mergeCollectionParams: function (defaultCollectionParams, mergedCollectionParams) {
	            var newParams = []
	            mergedCollectionParams.forEach(function (param) {
	                var existed = _.find(defaultCollectionParams, function (p) {
	                    return param.key == p.key;
	                })
	                if (_.isUndefined(existed)) {
	                    newParams.push(param)
	                } else {
	                    existed.value = param.value
	                }
	            });
	
	            return defaultCollectionParams.concat(newParams)
	        },
	
	        delay: (function () {
	            var timer = 0;
	            return function (callback, ms) {
	                clearTimeout(timer);
	                timer = setTimeout(callback, ms);
	            };
	        })(),
	
	        getDocumentStatus: function (key) {
	            return Dicts.documentStatuses[key];
	        },
	
	        getReviewerStatus: function (key) {
	            return Dicts.reviewerStatuses[key];
	        },
	
	        getIntention: function (key) {
	            return Dicts.documentIntention[key];
	        },
	
	        getMedicationEventType: function (key) {
	            return Dicts.medicationEventTypes[key];
	        },
	
	        getContactPriorities: function () {
	            return Dicts.contactPriorities;
	        },
	
	        getContactTypes: function () {
	            return Dicts.contactTypes;
	        },
	
	        personDataFromNpiData: function (npiData) {
	            return {
	                lastName: npiData.basic["last_name"],
	                firstName: npiData.basic["first_name"],
	                middleName: npiData.basic["middle_name"],
	                gender: npiData.basic["gender"],
	                address: this.buildLocationAddressFromNpiData(npiData)
	            }
	        },
	
	        organizationDataFromNpiData: function (npiData) {
	            return {
	                name: npiData.basic["organization_name"],
	                createdDT: (npiData["created_epoch"] ? new Number(npiData["created_epoch"]) * 1000 : undefined),
	                address: this.buildLocationAddressFromNpiData(npiData)
	            }
	        },
	
	        buildLocationAddressFromNpiData: function (npiData) {
	            var locationAddresses = npiData.addresses.filter(function (address) {
	                return address["address_purpose"] == 'LOCATION';
	            });
	            var locationAddress = locationAddresses[0];
	            return {
	                uuid: this.generatedUUID(),
	                country: locationAddress["country_code"],
	                state: locationAddress["state"],
	                county: null,
	                zip: locationAddress["postal_code"],
	                town: locationAddress["city"],
	                address: locationAddress["address_1"] + ' ' + locationAddress["address_2"],
	                usage: 'WP',
	                source: 'NPI'
	            };
	        },
	
	        addressesAndContactsFromNpiData: function (npiData) {
	            var that = this;
	            var alreadyAddedContacts = [];
	            var addresses = [];
	            var contacts = [];
	
	            npiData.addresses.forEach(function (address) {
	                var addressToAdd = {
	                    uuid: that.generatedUUID(),
	                    country: address["country_code"],
	                    state: address["state"],
	                    county: null,
	                    zip: address["postal_code"],
	                    town: address["city"],
	                    address: address["address_1"] + ' ' + address["address_2"],
	                    usage: 'WP',
	                    source: 'NPI'
	                };
	                addresses.push(addressToAdd);
	
	                if (!_.isEmpty(address["fax_number"]) && alreadyAddedContacts.indexOf(address["fax_number"]) < 0) {
	                    contacts.push({
	                        data: address["fax_number"].replace(new RegExp('-', 'g'), ''),
	                        type: 'FAX',
	                        preferred: false,
	                        addresses: [addressToAdd.uuid],
	                        source: 'NPI'
	                    });
	                    alreadyAddedContacts.push(address["fax_number"]);
	                } else if (alreadyAddedContacts.indexOf(address["fax_number"]) >= 0) {
	                    contacts.filter(function (contact) {
	                        return contact.data == address["fax_number"].replace(new RegExp('-', 'g'), '');
	                    })[0].addresses.push(addressToAdd.uuid);
	                }
	
	                if (!_.isEmpty(address["telephone_number"]) && alreadyAddedContacts.indexOf(address["telephone_number"]) < 0) {
	                    contacts.push({
	                        data: address["telephone_number"].replace(new RegExp('-', 'g'), ''),
	                        type: 'PHONE',
	                        preferred: false,
	                        addresses: [addressToAdd.uuid],
	                        source: 'NPI'
	                    });
	                    alreadyAddedContacts.push(address["telephone_number"]);
	                } else if (alreadyAddedContacts.indexOf(address["telephone_number"]) >= 0) {
	                    contacts.filter(function (contact) {
	                        return contact.data == address["telephone_number"].replace(new RegExp('-', 'g'), '');
	                    })[0].addresses.push(addressToAdd.uuid);
	                }
	            });
	            return {
	                addresses: addresses,
	                contacts: contacts
	            };
	        },
	
	        generatePassword: function password_generator(len) {
	            var length = (len) ? (len) : (10);
	            var string = "abcdefghijklmnopqrstuvwxyz";
	            var numeric = '0123456789';
	            var password = "";
	            var character = "";
	            while (password.length < length) {
	                entity1 = Math.ceil(string.length * Math.random() * Math.random());
	                entity2 = Math.ceil(numeric.length * Math.random() * Math.random());
	                hold = string.charAt(entity1);
	                hold = (entity1 % 2 == 0) ? (hold.toUpperCase()) : (hold);
	                character += hold;
	                character += numeric.charAt(entity2);
	                password = character;
	            }
	            return password;
	        },
	
	        randomString: function (len) {
	            var text = " ";
	            var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
	
	            for (var i = 0; i < len; i++)
	                text += charset.charAt(Math.floor(Math.random() * charset.length));
	
	            return text;
	        },
	
	        generatedUUID: function () {
	            return uuidV4();
	        },
	
	        splitToPair: function (text, separator) {
	            return [text.substr(0, text.indexOf(separator)), text.substr(text.indexOf(separator) + 1)];
	        },
	
	        isValidEmail: function (email) {
	            return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
	        },
	
	        isValidNPI: function (npi) {
	            return /\d{10}/.test(npi);
	        },
	
	        deepClone: function (obj) {
	            return JSON.parse(JSON.stringify(obj));
	        },
	
	        getHousingValues: function () {
	            return Dicts.housingValues;
	        },
	
	        martialStatuses: function () {
	            return Dicts.martialStatuses;
	        },
	
	        getDeterminationOfNeedRevised: function () {
	            return Dicts.determinationOfNeedRevised;
	        },
	
	        extractContactValuesByType: function (contacts, type) {
	            return contacts.filter(function (contact) {
	                return contact.type == type;
	            }).map(function (contact) {
	                return contact.data;
	            });
	        },
	
	        extractContactValuesByTypeAsString: function (contacts, type) {
	            return this.extractContactValuesByType(contacts, type).join(', ');
	        },
	
	        getHoursValues: function () {
	            return _.range(24);
	        },
	
	        getDaysValues: function () {
	            return _.range(31);
	        },
	
	        getUpperCaseCharsList: function () {
	            return _.map(_.range(26), function (i) {
	                return String.fromCharCode(65 + i);
	            });
	        },
	
	        normalizeContact: function (contact) {
	            return contact.replace(new RegExp(' ', 'g'), '').replace(new RegExp('_', 'g'), '').replace(new RegExp('-', 'g'), '').replace(new RegExp('\\(', 'g'), '').replace(new RegExp('\\)', 'g'), '').replace(new RegExp('\\+', 'g'), '');
	        },
	
	        downloadFileWithPost: function (url, params) {
	            var form = document.createElement('form');
	            form.setAttribute('target', '_blank');
	            form.setAttribute('action', url);
	            form.setAttribute('method', 'post');
	            document.body.appendChild(form);
	            for (var i = 0; i < params.length; i++) {
	                var par = params[i];
	                if (_.isEmpty(par)) continue;
	                var keyValue = par.split('=');
	                var input = document.createElement('input');
	                input.setAttribute('type', 'text');
	                input.setAttribute('name', keyValue[0]);
	                input.setAttribute('value', decodeURIComponent(keyValue[1]));
	                form.appendChild(input);
	            }
	            form.submit();
	            document.body.removeChild(form);
	        },
	
	        initialMeta: function () {
	            return _.keys(DocumentMetaDicts.documentMetaFields).map(function (field) {
	                return {
	                    field: field,
	                    related: '',
	                    nodeRepresentation: '',
	                    nameLocalizedString: '',
	                    slotName: '',
	                    codingScheme: '',
	                    value: [''],
	                    description: ''
	                }
	            });
	        },
	
	        getPredefinedMetaCodesOrCodeNames: function (key, index) {
	            if (key === 'classCode' || key === 'typeCode')
	                return DocumentMetaDicts.classCodesWithDisplayName.map(function (item) {
	                    return item.split(';')[index];
	                });
	            else if (key === 'confidentialityCode')
	                return DocumentMetaDicts.confidentialityCodesWithDisplayName.map(function (item) {
	                    return item.split(';')[index];
	                });
	            else if (key === 'formatCode')
	                return DocumentMetaDicts.formatCodesWithDisplayName.map(function (item) {
	                    return item.split(';')[index];
	                });
	            else if (key === 'healthcareFacilityTypeCode')
	                return DocumentMetaDicts.healthcareFacilityTypeCodesWithDisplayName.map(function (item) {
	                    return item.split(';')[index];
	                });
	            else if (key === 'practiceSettingCode')
	                return DocumentMetaDicts.practiceSettingCodesWithDisplayName.map(function (item) {
	                    return item.split(';')[index];
	                });
	            else
	                return [];
	        },
	
	        mergeObjectsLeft: function (leftObject, rightObject) {
	            _.keys(rightObject).forEach(function (key) {
	                leftObject[key] = rightObject[key];
	            });
	            return leftObject;
	        },
	
	        mergeObjectsRight: function (leftObject, rightObject) {
	            _.keys(leftObject).forEach(function (key) {
	                rightObject[key] = leftObject[key];
	            });
	            return rightObject;
	        }
	
	    })
	;
	
	module.exports = CommonUtils;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(191);
	var bytesToUuid = __webpack_require__(192);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ }),
/* 191 */
/***/ (function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ }),
/* 192 */
/***/ (function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]]
	  ]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ }),
/* 193 */
/***/ (function(module, exports) {

	var Dicts = {
	
	    documentStatuses: {
	        UNREVIEWED: 'Not Assigned',
	        IN_REVIEW: 'Review Pending',
	        SIGNED: 'Signed',
	        VIEWED: 'Viewed',
	        DELETED: 'Obsolete',
	        UNDER_REVIEW: 'Under Review'
	    },
	
	    reviewerStatuses: {
	        UNREVIEWED: 'Review Pending',
	        IN_REVIEW: 'Review Pending',
	        SIGNED: 'Signed',
	        VIEWED: 'Viewed',
	        DELETED: 'Obsolete',
	        UNDER_REVIEW: 'Under Review'
	    },
	
	    documentIntention: {
	        UNASSIGNED: 'Not Assigned',
	        TO_SIGN: 'Signature',
	        TO_VIEW: 'Review'
	    },
	
	    medicationEventTypes: {
	        PRESCRIPTION: 'PRESCRIPTION',
	        ANOTHER_APPOINTMENT: 'ANOTHER APPOINTMENT',
	        PURCHASE: 'PURCHASE',
	        TAKEN_INSIDE: 'TAKEN'
	    },
	
	    housingValues: ['Alone',
	        'With relative or friend',
	        'Hospital',
	        'Personal care home',
	        'Nursing home',
	        'Other'],
	
	    martialStatuses:
	        [
	            {name: "annulled", value: "Annulled"},
	            {name: "divorced", value: "Divorced"},
	            {name: "interlocutory", value: "Interlocutory"},
	            {name: "legally-separated", value: "Legally Separated"},
	            {name: "married", value: "Married"},
	            {name: "polygamous", value: "Polygamous"},
	            {name: "never-married", value: "Never Married"},
	            {name: "domestic-partner", value: "Domestic partner"},
	            {name: "unmarried", value: "Unmarried"},
	            {name: "widowed", value: "Widowed"},
	            {name: "unknown", value: "Unknown"}
	        ],
	
	    determinationOfNeedRevised: [
	        {function: "Eating", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {function: "Bathing", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {function: "Grooming", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {function: "Dressing", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {function: "Transferring", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {function: "Continence", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {function: "Managing Money", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {function: "Telephoning", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {function: "Preparing Meals", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {function: "Laundry", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {function: "Housework", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {function: "Outside Home", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {function: "Routine Health", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {function: "Special Health", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {function: "Being Alone", levelOfImpairment: 0, unmetNeedForCare: 0, comment: "", editable: true},
	        {
	            function: "Total 1-6 (ADL)",
	            levelOfImpairment: 0,
	            unmetNeedForCare: 0,
	            comment: "",
	            editable: false,
	            start: 0,
	            stop: 5
	        },
	        {
	            function: "Total 7-15 (IADL)",
	            levelOfImpairment: 0,
	            unmetNeedForCare: 0,
	            comment: "",
	            editable: false,
	            start: 6,
	            stop: 14
	        },
	        {
	            function: "Total 1-15 (ADL + IADL)",
	            levelOfImpairment: 0,
	            unmetNeedForCare: 0,
	            comment: "",
	            editable: false,
	            start: 0,
	            stop: 14
	        }
	    ],
	
	    contactPriorities: {
	        0: '1-st Priority',
	        1: '2-d Priority',
	        5: '3-d Priority',
	        8: '4-d Priority',
	        9: 'Last Priority'
	    },
	
	    contactTypes: {
	        "EMAIL": "Email",
	        "FAX": "Fax",
	        "HAND_DELIVERY": "Hand delivery",
	        "MEDICITY": "Medicity",
	        "PHONE": "Phone",
	        "REVIEW_AND_SIGN": "Review and sign"
	    },
	
	    addressUsages: {
	        "H": "Home",
	        "WP": "Work Place",
	        "TMP": "Temporary",
	        "AS": "Answering service",
	        "EC": "Emergency contact",
	        "MC": "Mobile contact"
	    },
	
	    hl7Dict: {
	        "2.16.840.1.113883.6.88": "RxNorm",
	        "2.16.840.1.113883.6.90": "ICD-10",
	        "2.16.840.1.113883.6.96": "SNOMED ST",
	        "2.16.840.1.113883.6.103": "ICD-9"
	    },
	
	    documentTypes: {
	        pdf: "PDF",
	        xml: "XML",
	        txt: "TXT",
	        jpg: "JPG"
	    }
	};
	
	module.exports = Dicts;

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	var DocumentMetaDict = {
	
	    documentMetaFields: {
	        creationTime: "Creation time",
	        languageCode: "Language code",
	        serviceStartTime: "Service start time",
	        serviceStopTime: "Service stop time",
	        sourcePatientId: "Source patient id",
	        sourcePatientInfo: "Source patient info",
	        size: "Size",
	        hash: "Hash",
	        uri: "URI",
	        authorPerson: "Author person",
	        authorInstitution: "Author institution",
	        authorRole: "Author role",
	        authorSpecialty: "Author speciality",
	        classCode: "Class code",
	        confidentialityCode: "Confidentiality code",
	        formatCode: "Format code",
	        healthcareFacilityTypeCode: "Healthcare facility type code",
	        practiceSettingCode: "Practice setting code",
	        typeCode: "Type code",
	        patientId: "Patient id",
	        uniqueId: "Unique id",
	        ExtrinsicObjectId: "Extrinsic object id",
	        objectType: "Object type",
	        mimeType: "Mime type",
	        availabilityStatus: "Availability status",
	        title: "Title",
	        comments: "Comments",
	        entryUUID: "Entry UUID",
	        eventCode: "Event code",
	        intendedRecipient: "Intended recipient",
	        legalAuthenticator: "Legal authenticator",
	        parentDocumentId: "Parent document id"
	    },
	
	    requiredDocumentMetaFields: [
	        {field: "creationTime", required: ["value"]},
	        {field: "classCode", required: ["nodeRepresentation", "nameLocalizedString"]},
	        {field: "mimeType", required: ["value"]}
	    ],
	
	    classCodesWithDisplayName: [
	        "History of Immunization;11369-6",
	        "Anesthesia Records;11485-0",
	        "Chemotherapy Records;11486-8",
	        "Consultation note;11488-4",
	        "Subsequent evaluation note;11506-3",
	        "Nursery Records;11543-6",
	        "Labor And Delivery Records;15508-5",
	        "Radiology Studies;18726-0",
	        "Transfer summarization note;18761-7",
	        "Discharge summarization note;18842-5",
	        "Laboratory Studies;26436-6",
	        "Cardiology Studies;26441-6",
	        "Obstetrical Studies;26442-4",
	        "Gastroenterology Endoscopy Studies;27895-2",
	        "Pulmonary Studies;27896-0",
	        "Neuromuscular Electrophysiology Studies;27897-8",
	        "Pathology Studies;27898-6",
	        "Procedure note;28570-0",
	        "Ophthalmology Studies;28619-5",
	        "Miscellaneous Studies;28634-4",
	        "Dialysis Records;29749-9",
	        "Neonatal Intensive Care Records;29750-7",
	        "Critical Care Records;29751-5",
	        "Perioperative Records;29752-3",
	        "Evaluation and management note;34109-9",
	        "History and physical note;34117-2",
	        "Interventional procedure note;34121-4",
	        "Pathology procedure note;34122-2",
	        "Summarization of episode note;34133-9",
	        "Transfer of care referral note;34140-4",
	        "Telephone encounter note;34748-4",
	        "Pre-operative evaluation and management note;34775-7",
	        "Admission history and physical note;47039-3",
	        "Counseling note;47042-7",
	        "Study report;47045-0",
	        "Summary of death;47046-8",
	        "Communication;47049-2",
	        "Privacy Policy;57017-6",
	        "Privacy Policy Acknowledgment;57016-8",
	        "Medication Summary;56445-0",
	        "Personal health monitoring report;53576-5"
	    ],
	
	    confidentialityCodesWithDisplayName: [
	        "Business;B",
	        "Clinician;D",
	        "Individual;I",
	        "Low;L",
	        "Normal;N",
	        "Restricted;R",
	        "Very Restricted;V",
	        "Substance Abuse Related;ETH",
	        "HIV related;HIV",
	        "Psychiatry related;PSY",
	        "Sexual and Domestic Violence related;SDV",
	        "Celebrity;C",
	        "Sensitive;S",
	        "Taboo;T"
	    ],
	
	    formatCodesWithDisplayName: [
	        "HL7 CCD Document;urn:ihe:pcc:xphr:2007",
	        "IHE Antepartum Summary;urn:ihe:pcc:aps:2007",
	        "PDF embedded in CDA per XDS-SD profile;urn:ihe:iti:xds-sd:pdf:2008",
	        "Text embedded in CDA per XDS-SD profile;urn:ihe:iti:xds-sd:text:2008",
	        "XDS Medical Summaries;urn:ihe:pcc:xds-ms:2007",
	        "Personal Health Records;urn:ihe:pcc:xphr:2007",
	        "Emergency Department Referral (EDR);urn:ihe:pcc:edr:2007",
	        "Emergency Department Encounter Summary (EDES);urn:ihe:pcc:edes:2007",
	        "Antepartum Record (APR) - History and Physical;urn:ihe:pcc:apr:handp:2008",
	        "Antepartum Record (APR) - Laboratory;urn:ihe:pcc:apr:lab:2008",
	        "Antepartum Record (APR) - Education;urn:ihe:pcc:apr:edu:2008",
	        "Immunization Registry Content (IRC);urn:ihe:pcc:irc:2008",
	        "Cancer Registry Content (CRC);urn:ihe:pcc:crc:2008",
	        "Care Management (CM);urn:ihe:pcc:cm:2008",
	        "Basic Patient Privacy Consents;urn:ihe:iti:bppc:2007",
	        "Basic Patient Privacy Consents with Scanned Document;urn:ihe:iti:bppc-sd:2007",
	        "CDA Laboratory Report;urn:ihe:lab:xd-lab:2008",
	        "Access Consent Policy document formatted as XACML;urn:nhin:names:acp:XACML"
	    ],
	
	    healthcareFacilityTypeCodesWithDisplayName: [
	        "Hospital-children's;82242000",
	        "Hospital-community;225732001",
	        "Hospital-government;79993009",
	        "Hospital-long term care;32074000",
	        "Hospital-military field;4322002",
	        "Hospital-prison;224687002",
	        "Hospital-psychiatric;62480006",
	        "Hospital-rehabilitation;80522000",
	        "Hospital-trauma center;36125001",
	        "Hospital-Veterans' Administration;48311003",
	        "Hospice facility;284546000",
	        "Nursing home;42665001",
	        "Skilled nursing facility;45618002",
	        "Dialysis unit--hospital;418518002",
	        "Emergency department--hospital;73770003",
	        "Hospital ambulatory surgery facility;69362002",
	        "Hospital birthing center;52668009",
	        "Hospital outpatient allergy clinic;360957003",
	        "Hospital outpatient dental clinic;10206005",
	        "Hospital outpatient dermatology clinic;37550003",
	        "Hospital outpatient endocrinology clinic;73644007",
	        "Hospital outpatient family medicine clinic;31628002",
	        "Hospital outpatient gastroenterology clinic;58482006",
	        "Hospital outpatient general surgery clinic;90484001",
	        "Hospital outpatient geriatric health center;1814000",
	        "Hospital outpatient gynecology clinic;22549003",
	        "Hospital outpatient hematology clinic;56293002",
	        "Hospital outpatient immunology clinic;360966004",
	        "Hospital outpatient infectious disease clinic;2849009",
	        "Hospital outpatient mental health center;14866005",
	        "Hospital outpatient neurology clinic;38238005",
	        "Hospital outpatient obstetrical clinic;56189001",
	        "Hospital outpatient oncology clinic;89972002",
	        "Hospital outpatient ophthalmology clinic;78088001",
	        "Hospital outpatient orthopedics clinic;78001009",
	        "Hospital outpatient otorhinolaryngology clinic;23392004",
	        "Hospital outpatient pain clinic;36293008",
	        "Hospital outpatient pediatric clinic;3729002",
	        "Hospital outpatient peripheral vascular clinic;5584006",
	        "Hospital outpatient rehabilitation clinic;37546005",
	        "Hospital outpatient respiratory disease clinic;57159002",
	        "Hospital outpatient rheumatology clinic;331006",
	        "Hospital outpatient urology clinic;50569004",
	        "Hospital radiology facility;79491001",
	        "Hospital-based outpatient clinic or department;33022008",
	        "Fee-for-service private physicians' group office;19602009",
	        "Private physicians' group office;39350007",
	        "Solo practice private office;83891005",
	        "Independent ambulatory care provider site;394759007",
	        "Ambulatory surgery center;405607001",
	        "Care of the elderly day hospital;309900005",
	        "Elderly assessment clinic;275576008",
	        "Free-standing ambulatory surgery facility;10531005",
	        "Free-standing birthing center;91154008",
	        "Free-standing geriatric health center;41844007",
	        "Free-standing laboratory facility;45899008",
	        "Free-standing mental health center;51563005",
	        "Free-standing radiology facility;1773006",
	        "Health maintenance organization;72311000",
	        "Local community health center;6827000",
	        "Psychogeriatric day hospital;309898008",
	        "Residential school infirmary;39913001",
	        "Rural health center;77931003",
	        "Sexually transmitted disease health center;25681007",
	        "Substance abuse treatment center;20078004",
	        "Vaccination clinic;46224007",
	        "Walk-in clinic;81234003",
	        "Ambulatory care site;35971002",
	        "Ambulance-based care;11424001",
	        "Contained casualty setting;409519008",
	        "Helicopter-based care;901005",
	        "Hospital ship;2081004",
	        "Traveler's aid clinic;59374000",
	        "Adult day care center;413456002",
	        "Child day care center;413817003",
	        "Private residential home;310205006",
	        "Residential institution;419955002",
	        "Sports facility;272501009",
	        "Health encounter site;394777002",
	    ],
	
	    practiceSettingCodesWithDisplayName: [
	        "Adult mental illness;408467006",
	        "Anesthetics;394577000",
	        "Audiological medicine;394578005",
	        "Blood banking and transfusion medicine;421661004",
	        "Burns care;408462000",
	        "Cardiology;394579002",
	        "Clinical cytogenetics and molecular genetics;394804000",
	        "Clinical genetics;394580004",
	        "Clinical hematology;394803006",
	        "Clinical immunology;408480009",
	        "Clinical microbiology;408454008",
	        "Clinical neuro-physiology;394809005",
	        "Clinical oncology;394592004",
	        "Clinical pharmacology;394600006",
	        "Clinical physiology;394601005",
	        "Community medicine;394581000",
	        "Critical care medicine;408478003",
	        "Dental medicine specialties;394812008",
	        "Dental-General dental practice;408444009",
	        "Dermatology;394582007",
	        "Diabetic medicine;408475000",
	        "Dive medicine;410005002",
	        "Endocrinology;394583002",
	        "Family practice;419772000",
	        "Gastroenterology;394584008",
	        "General medical practice;408443003",
	        "General medicine;394802001",
	        "General pathology;394915009",
	        "General practice;394814009",
	        "Genito-urinary medicine;394808002",
	        "Geriatric medicine;394811001",
	        "Gynecological oncology;408446006",
	        "Gynecology;394586005",
	        "Hematopathology;394916005",
	        "Hepatology;408472002",
	        "Histopathology;394597005",
	        "Immunopathology;394598000",
	        "Infectious diseases;394807007",
	        "Internal medicine;419192003",
	        "Learning disability;408468001",
	        "Medical oncology;394593009",
	        "Medical ophthalmology;394813003",
	        "Military medicine;410001006",
	        "Nephrology;394589003",
	        "Neurology;394591006",
	        "Neuropathology;394599008",
	        "Nuclear medicine;394649004",
	        "Obstetrics;408470005",
	        "Obstetrics and gynecology;394585009",
	        "Occupational medicine;394821009",
	        "Ophthalmic surgery;422191005",
	        "Ophthalmology;394594003",
	        "Osteopathic manipulative medicine;416304004",
	        "Otolaryngology;418960008",
	        "Pain management;394882004",
	        "Palliative medicine;394806003",
	        "Pediatric (Child and adolescent) psychiatry;394588006",
	        "Pediatric cardiology;408459003",
	        "Pediatric dentistry;394607009",
	        "Pediatric endocrinology;419610006",
	        "Pediatric gastroenterology;418058008",
	        "Pediatric genetics;420208008",
	        "Pediatric hematology;418652005",
	        "Pediatric immunology;418535003",
	        "Pediatric infectious diseases;418862001",
	        "Pediatric nephrology;419365004",
	        "Pediatric oncology;418002000",
	        "Pediatric ophthalmology;419983000",
	        "Pediatric pulmonology;419170002",
	        "Pediatric rheumatology;419472004",
	        "Pediatric surgery;394539006",
	        "Pediatric surgery-bone marrow transplantation;420112009",
	        "Preventive medicine;409968004",
	        "Psychiatry;394587001",
	        "Psychotherapy;394913002",
	        "Public health medicine;408440000",
	        "Pulmonary medicine;418112009",
	        "Radiation oncology;419815003",
	        "Radiology;394914008",
	        "Radiology-Interventional radiology;408455009",
	        "Rehabilitation;394602003",
	        "Respite care;408447002",
	        "Rheumatology;394810000",
	        "Sleep studies;408450004",
	        "Surgery-Bone and marrow transplantation;408476004",
	        "Surgery-Breast surgery;408469009",
	        "Surgery-Cardiac surgery;408466002",
	        "Surgery-Cardiothoracic transplantation;408471009",
	        "Surgery-Colorectal surgery;408464004",
	        "Surgery-Dental-Endodontics;408441001",
	        "Surgery-Dental-Oral and maxillofacial surgery;408465003",
	        "Surgery-Dental-Oral surgery;394605001",
	        "Surgery-Dental-Orthodontics;394608004",
	        "Surgery-Dental-Periodontal surgery;408461007",
	        "Surgery-Dental-Prosthetic dentistry (Prosthodontics);408460008",
	        "Surgery-Dental-surgical-Prosthodontics;408460008",
	        "Surgery-Dentistry-Restorative dentistry;394606000",
	        "Surgery-Dentistry--surgical;408449004",
	        "Surgery-Dentistry-surgical-Orthodontics;394608004",
	        "Surgery-Dermatologic surgery;418018006",
	        "Surgery-Ear, nose and throat surgery;394604002",
	        "Surgery-general;394609007",
	        "Surgery-Hepatobiliary and pancreatic surgery;408474001",
	        "Surgery-Neurosurgery;394610002",
	        "Surgery-Plastic surgery;394611003",
	        "Surgery-Transplantation surgery;408477008",
	        "Surgery-Trauma and orthopedics;394801008",
	        "Surgery-Vascular;408463005",
	        "Surgical oncology;419321007",
	        "Surgical-Accident & emergency;394576009",
	        "Thoracic medicine;394590007",
	        "Toxicology;409967009",
	        "Tropical medicine;408448007",
	        "Urological oncology;419043006",
	        "Urology;394612005",
	        "Medical specialty;394733009",
	        "Surgical specialty;394732004"
	    ],
	
	    documentMimeTypes: [
	        "application/pdf",
	        "image/gif",
	        "image/jpeg",
	        "image/png",
	        "text/plain",
	        "text/xml"
	    ]
	
	};
	
	
	module.exports = DocumentMetaDict;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var Constants = {
	    googleRecaptchaKey: ("6Ld9MTMUAAAAAKZkeQJZ3UPa6U6xxXxVhkTKfpT6"),
	    pageCapacity: 20,
	    maxDocumentsForEndingWOConfirmation: 100,
	    pageInitialOrd: 0,
	    npiCode: "2.16.840.1.113883.4.6",
	
	    immunizationAddresses: [
	        {name: "Grits", url: "/api/immunizations/grits", method: "POST"}
	    ],
	
	    barCodePrefix: "barcode_"
	
	};
	
	module.exports = Constants;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(197);
	__webpack_require__(198);
	var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	
	var RemoteSuggesterView = Marionette.View.extend({
	    template: __webpack_require__(200),
	    events: {},
	
	    templateContext: function () {
	        var that = this;
	        return {
	            classes: that.classes,
	            inputId: that.inputId
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'getSelectedId', 'getSelectedValue', 'listLocationWrapper');
	        var that = this;
	        that.utils = new CommonUtils();
	
	        that.multiSelect = options.multiSelect ? true : false;
	        that.requestDelay = options.requestDelay || 1000;
	        that.inputId = options.inputId || that.utils.generatedUUID();
	        that.url = options.url;
	        that.symbolForSearchInUrl = options.symbolForSearchInUrl;
	        that.listLocation = options.listLocation;
	        that.getValueFn = options.getValueFn;
	        that.getIdFn = options.getIdFn;
	        that.ajaxMethod = options.method || 'GET';
	        that.ajaxDataType = options.ajaxDataType || 'json';
	        that.classes = options.classes || [];
	        that.placeholder = options.placeholder;
	        that.maxNumberOfElements = options.maxNumberOfElements || 20;
	        that.tag = options.tag;
	
	        that.findSelectedIdBySelectedValue = options.findSelectedIdBySelectedValue;
	        that.findSelectedIdBySelectedIndex = options.findSelectedIdBySelectedIndex;
	        that.defaultSelected = options.defaultSelected;
	        that.selectedIndex = null;
	        that.selectedIds = [];
	        that.anySymbol = new RegExp("^[A-Za-z0-9? ,_-]+$");
	
	        //internallyUsed
	        that.previousOptions = [];
	    },
	
	    onRender: function () {
	        var that = this;
	
	        if (that.multiSelect) {
	
	            var defaultItems;
	            if (that.defaultSelected != undefined) {
	                defaultItems = (that.defaultSelected || []).map(function (item) {
	                    return {
	                        id: that.getIdFn(item),
	                        name: that.getValueFn(item)
	                    }
	                });
	                that.selectedIds = (defaultItems || []).map(function (item) {
	                    return item.id;
	                });
	            }
	
	            //fix to restore a lose input val
	            var inputRestore = function (selectize_, searchText_, time) {
	                window.setTimeout(function () {
	                    selectize_.$control_input.val(searchText_);
	                    var size = 10 * searchText_.length;
	                    selectize_.$control_input.css('width', size + 50);
	                }, time);
	            };
	
	            $(function () {
	                $('#' + that.inputId).removeClass('form-control');
	                var select = $('#' + that.inputId).selectize({
	                    plugins: ['remove_button'],
	                    inputClass: 'form-control selectize-input normal-width selectized',
	                    valueField: 'id',
	                    labelField: 'name',
	                    placeholder: that.placeholder,
	                    sortField: 'name',
	                    options: defaultItems || [],
	                    items: (defaultItems || []).map(function (item) {
	                        return item.id;
	                    }),
	                    highlight: true,
	                    openOnFocus: true
	                });
	
	                var selectize = select[0].selectize;
	                var lazyRequest;
	                var inputVal = '';
	
	                selectize.$control_input.on('keyup', function (event) {
	
	                    if (lazyRequest)
	                        clearTimeout(lazyRequest);
	
	                    var searchText = event.target.value;
	                    inputVal = searchText;
	
	                    if (searchText == '') {
	                        inputRestore(selectize, searchText, 0);
	                        if (!_.isEmpty(that.previousOptions)) {
	                            if (_.isEmpty(that.selectedIds))
	                                selectize.clearOptions();
	                            else {
	                                that.previousOptions.forEach(function (option) {
	                                    if (that.selectedIds.filter(function (id) {
	                                            return id == option.id;
	                                        }).length == 0) {
	                                        selectize.removeOption(option.id);
	                                    }
	                                });
	                            }
	                        }
	                        window.setTimeout(function () {
	                            selectize.$control_input.parent().removeClass('data-loader');
	                        }, 1000);
	                        selectize.close();
	                        return;
	                    }
	
	                    var str = String.fromCharCode(!event.charCode ? event.which : event.charCode);
	
	                    if (that.anySymbol.test(str) || event.target.value != '' && (event.keyCode == 8 || event.keyCode == 46)) {
	                        selectize.$control_input.parent().addClass('data-loader');
	                    } else {
	                        return;
	                    }
	
	                    lazyRequest = setTimeout(function () {
	
	                        $.when(
	                            $.ajax({
	                                type: "GET",
	                                url: that.url.replace(that.symbolForSearchInUrl, searchText),
	                            })
	                        ).done(function (resp) {
	                            if (!_.isEmpty(that.previousOptions)) {
	                                if (_.isEmpty(that.selectedIds))
	                                    selectize.clearOptions();
	                                else {
	                                    that.previousOptions.forEach(function (option) {
	                                        if (that.selectedIds.filter(function (id) {
	                                                return id == option.id;
	                                            }).length == 0) {
	                                            selectize.removeOption(option.id);
	                                        }
	                                    });
	                                }
	                            }
	
	                            var list = that.listLocationWrapper(resp);
	                            var formattedResult = list.map(function (elem) {
	                                return {
	                                    id: that.getIdFn(elem),
	                                    name: that.getValueFn(elem)
	                                }
	                            });
	                            that.previousOptions = formattedResult;
	
	                            for (var ind in formattedResult) {
	                                if (ind >= that.maxNumberOfElements)
	                                    break;
	                                selectize.addOption(formattedResult[ind]);
	                            }
	
	                            selectize.$control_input.on('blur', function () {
	                                selectize.onBlur.apply(selectize, arguments);
	                                inputRestore(selectize, inputVal, 0);
	                            });
	                            selectize.$control_input.on('focus', function () {
	                                selectize.onBlur();
	                                selectize.open();
	                                inputRestore(selectize, inputVal, 0);
	                            });
	
	                            selectize.onBlur();
	                            selectize.open();
	                            inputRestore(selectize, searchText, 0);
	
	                            selectize.$control_input.parent().removeClass('data-loader');
	
	                        }).fail(function (jqXHR, textStatus) {
	                            selectize.$control_input.parent().removeClass('data-loader');
	                            console.log(jqXHR);
	                        });
	                    }, that.requestDelay);
	
	                });
	
	                selectize.on('item_add', function (value, item) {
	                    inputRestore(selectize, inputVal, 0);
	                    that.selectedIds.push(value);
	                    that.triggerMethod("suggestor:multi:add:id:" + that.tag, value);
	                });
	
	                selectize.on('item_remove', function (value, item) {
	                    inputRestore(selectize, inputVal, 0);
	                    that.selectedIds = that.selectedIds.filter(function (item) {
	                        return item != value;
	                    });
	                    that.triggerMethod("suggestor:multi:remove:id:" + that.tag, value);
	                });
	            });
	
	        } else {
	            var options = {
	                placeholder: that.placeholder,
	                requestDelay: that.requestDelay,
	                url: function (phrase) {
	                    return that.url.replace(that.symbolForSearchInUrl, phrase);
	                },
	
	                listLocation: that.listLocationWrapper,
	                getValue: that.getValueFn,
	                ajaxSettings: {
	                    dataType: that.ajaxDataType,
	                    method: that.ajaxMethod,
	                    data: {
	                        dataType: that.ajaxDataType
	                    }
	                },
	                list: {
	                    maxNumberOfElements: that.maxNumberOfElements,
	                    onLoadEvent: function () {
	                        $('#' + that.inputId).removeClass('data-loader');
	                        that.selectedIndex = null;
	                        that.sendSelectedIdToParent();
	                    },
	                    onChooseEvent: function () {
	                        var selectedLi = $("div#eac-container-" + that.inputId + " > ul > li.selected");
	                        that.selectedIndex = $("div#eac-container-" + that.inputId + " > ul > li").index(selectedLi);
	                        $('#' + that.inputId).removeClass('data-loader');
	                        that.sendSelectedIdToParent();
	                    }
	                },
	                preparePostData: that.ajaxMethod == 'POST' ? function (data) {
	                    data.phrase = $('#' + that.inputId).val();
	                    return data;
	                } : null
	            };
	
	            $(function () {
	                $('#' + that.inputId).easyAutocomplete(options);
	                $('.easy-autocomplete').removeAttr('style');
	
	                if (that.defaultSelected != undefined) {
	                    that.resultArr = [that.defaultSelected];
	                    that.selectedIndex = 0;
	                    $('#' + that.inputId).val(that.getValueFn(that.defaultSelected));
	                }
	
	                $('#eac-container-' + that.inputId).css({'max-height': 200, 'overflow-y': 'auto'});
	
	                $('#' + that.inputId).keyup(function (e) {
	                    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
	
	                    if (that.anySymbol.test(str) || e.target.value != '' && (e.keyCode == 8 || e.keyCode == 46))
	                        $('#' + that.inputId).addClass('data-loader');
	
	                    // for fix a unknown bug in mozilla.
	                    $('#' + that.inputId).show();
	
	                    if (e.target.value == '') {
	                        that.selectedIndex = null;
	                        that.sendSelectedIdToParent();
	                    }
	
	                    window.setTimeout(function () {
	                        // remove loader when ajax error because easyAutocomplete can not
	                        $('#' + that.inputId).removeClass('data-loader');
	                    }, that.requestDelay + 5000)
	                });
	            });
	        }
	    },
	
	    sendSelectedIdToParent: function () {
	        if (this.tag) {
	            this.triggerMethod("suggestor:selected:" + this.tag, this.findSelectedIdBySelectedIndex(this.resultArr, this.selectedIndex));
	        }
	    },
	
	    getSelectedSingleObject: function (id) {
	        return _.findWhere(this.resultArr, {id: id});
	    },
	
	    getSelectedId: function () {
	        if (this.multiSelect)
	            return;
	
	        var that = this;
	        if (typeof that.findSelectedIdBySelectedValue != "undefined") {
	            return that.findSelectedIdBySelectedValue(that.resultArr, that.getSelectedValue());
	        } else if (typeof that.findSelectedIdBySelectedIndex != "undefined" && that.selectedIndex != null) {
	            return that.findSelectedIdBySelectedIndex(that.resultArr, that.selectedIndex);
	        }
	        else return null;
	    },
	
	    getSelectedIdsList: function () {
	        if (!this.multiSelect)
	            return [];
	        return this.selectedIds;
	    },
	
	    getSelectedValue: function () {
	        if (this.multiSelect)
	            return;
	
	        return $('#' + this.inputId).val();
	    },
	
	    listLocationWrapper: function (data) {
	        var list = this.listLocation(data);
	        this.resultArr = list;
	        return list;
	    },
	
	});
	
	module.exports = RemoteSuggesterView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, jQuery) {/*
	 * easy-autocomplete
	 * jQuery plugin for autocompletion
	 * 
	 * @author Łukasz Pawełczak (http://github.com/pawelczak)
	 * @version 1.3.5
	 * Copyright  License: 
	 */
	
	var EasyAutocomplete=function(a){return a.Configuration=function(a){function b(){if("xml"===a.dataType&&(a.getValue||(a.getValue=function(a){return $(a).text()}),a.list||(a.list={}),a.list.sort||(a.list.sort={}),a.list.sort.method=function(b,c){return b=a.getValue(b),c=a.getValue(c),c>b?-1:b>c?1:0},a.list.match||(a.list.match={}),a.list.match.method=function(a,b){return a.search(b)>-1}),void 0!==a.categories&&a.categories instanceof Array){for(var b=[],c=0,d=a.categories.length;d>c;c+=1){var e=a.categories[c];for(var f in h.categories[0])void 0===e[f]&&(e[f]=h.categories[0][f]);b.push(e)}a.categories=b}}function c(){function b(a,c){var d=a||{};for(var e in a)void 0!==c[e]&&null!==c[e]&&("object"!=typeof c[e]||c[e]instanceof Array?d[e]=c[e]:b(a[e],c[e]));return void 0!==c.data&&null!==c.data&&"object"==typeof c.data&&(d.data=c.data),d}h=b(h,a)}function d(){if("list-required"!==h.url&&"function"!=typeof h.url){var b=h.url;h.url=function(){return b}}if(void 0!==h.ajaxSettings.url&&"function"!=typeof h.ajaxSettings.url){var b=h.ajaxSettings.url;h.ajaxSettings.url=function(){return b}}if("string"==typeof h.listLocation){var c=h.listLocation;"XML"===h.dataType.toUpperCase()?h.listLocation=function(a){return $(a).find(c)}:h.listLocation=function(a){return a[c]}}if("string"==typeof h.getValue){var d=h.getValue;h.getValue=function(a){return a[d]}}void 0!==a.categories&&(h.categoriesAssigned=!0)}function e(){void 0!==a.ajaxSettings&&"object"==typeof a.ajaxSettings?h.ajaxSettings=a.ajaxSettings:h.ajaxSettings={}}function f(a){return void 0!==h[a]&&null!==h[a]}function g(a,b){function c(b,d){for(var e in d)void 0===b[e]&&a.log("Property '"+e+"' does not exist in EasyAutocomplete options API."),"object"==typeof b[e]&&-1===$.inArray(e,i)&&c(b[e],d[e])}c(h,b)}var h={data:"list-required",url:"list-required",dataType:"json",listLocation:function(a){return a},xmlElementName:"",getValue:function(a){return a},autocompleteOff:!0,placeholder:!1,ajaxCallback:function(){},matchResponseProperty:!1,list:{sort:{enabled:!1,method:function(a,b){return a=h.getValue(a),b=h.getValue(b),b>a?-1:a>b?1:0}},maxNumberOfElements:6,hideOnEmptyPhrase:!0,match:{enabled:!1,caseSensitive:!1,method:function(a,b){return a.search(b)>-1}},showAnimation:{type:"normal",time:400,callback:function(){}},hideAnimation:{type:"normal",time:400,callback:function(){}},onClickEvent:function(){},onSelectItemEvent:function(){},onLoadEvent:function(){},onChooseEvent:function(){},onKeyEnterEvent:function(){},onMouseOverEvent:function(){},onMouseOutEvent:function(){},onShowListEvent:function(){},onHideListEvent:function(){}},highlightPhrase:!0,theme:"",cssClasses:"",minCharNumber:0,requestDelay:0,adjustWidth:!0,ajaxSettings:{},preparePostData:function(a,b){return a},loggerEnabled:!0,template:"",categoriesAssigned:!1,categories:[{maxNumberOfElements:4}]},i=["ajaxSettings","template"];this.get=function(a){return h[a]},this.equals=function(a,b){return!(!f(a)||h[a]!==b)},this.checkDataUrlProperties=function(){return"list-required"!==h.url||"list-required"!==h.data},this.checkRequiredProperties=function(){for(var a in h)if("required"===h[a])return logger.error("Option "+a+" must be defined"),!1;return!0},this.printPropertiesThatDoesntExist=function(a,b){g(a,b)},b(),c(),h.loggerEnabled===!0&&g(console,a),e(),d()},a}(EasyAutocomplete||{}),EasyAutocomplete=function(a){return a.Logger=function(){this.error=function(a){console.log("ERROR: "+a)},this.warning=function(a){console.log("WARNING: "+a)}},a}(EasyAutocomplete||{}),EasyAutocomplete=function(a){return a.Constans=function(){var a={CONTAINER_CLASS:"easy-autocomplete-container",CONTAINER_ID:"eac-container-",WRAPPER_CSS_CLASS:"easy-autocomplete"};this.getValue=function(b){return a[b]}},a}(EasyAutocomplete||{}),EasyAutocomplete=function(a){return a.ListBuilderService=function(a,b){function c(b,c){function d(){var d,e={};return void 0!==b.xmlElementName&&(e.xmlElementName=b.xmlElementName),void 0!==b.listLocation?d=b.listLocation:void 0!==a.get("listLocation")&&(d=a.get("listLocation")),void 0!==d?"string"==typeof d?e.data=$(c).find(d):"function"==typeof d&&(e.data=d(c)):e.data=c,e}function e(){var a={};return void 0!==b.listLocation?"string"==typeof b.listLocation?a.data=c[b.listLocation]:"function"==typeof b.listLocation&&(a.data=b.listLocation(c)):a.data=c,a}var f={};if(f="XML"===a.get("dataType").toUpperCase()?d():e(),void 0!==b.header&&(f.header=b.header),void 0!==b.maxNumberOfElements&&(f.maxNumberOfElements=b.maxNumberOfElements),void 0!==a.get("list").maxNumberOfElements&&(f.maxListSize=a.get("list").maxNumberOfElements),void 0!==b.getValue)if("string"==typeof b.getValue){var g=b.getValue;f.getValue=function(a){return a[g]}}else"function"==typeof b.getValue&&(f.getValue=b.getValue);else f.getValue=a.get("getValue");return f}function d(b){var c=[];return void 0===b.xmlElementName&&(b.xmlElementName=a.get("xmlElementName")),$(b.data).find(b.xmlElementName).each(function(){c.push(this)}),c}this.init=function(b){var c=[],d={};return d.data=a.get("listLocation")(b),d.getValue=a.get("getValue"),d.maxListSize=a.get("list").maxNumberOfElements,c.push(d),c},this.updateCategories=function(b,d){if(a.get("categoriesAssigned")){b=[];for(var e=0;e<a.get("categories").length;e+=1){var f=c(a.get("categories")[e],d);b.push(f)}}return b},this.convertXml=function(b){if("XML"===a.get("dataType").toUpperCase())for(var c=0;c<b.length;c+=1)b[c].data=d(b[c]);return b},this.processData=function(c,d){for(var e=0,f=c.length;f>e;e+=1)c[e].data=b(a,c[e],d);return c},this.checkIfDataExists=function(a){for(var b=0,c=a.length;c>b;b+=1)if(void 0!==a[b].data&&a[b].data instanceof Array&&a[b].data.length>0)return!0;return!1}},a}(EasyAutocomplete||{}),EasyAutocomplete=function(a){return a.proccess=function(b,c,d){function e(a,c){var d=[],e="";if(b.get("list").match.enabled)for(var g=0,h=a.length;h>g;g+=1)e=b.get("getValue")(a[g]),f(e,c)&&d.push(a[g]);else d=a;return d}function f(a,c){return b.get("list").match.caseSensitive||("string"==typeof a&&(a=a.toLowerCase()),c=c.toLowerCase()),!!b.get("list").match.method(a,c)}function g(a){return void 0!==c.maxNumberOfElements&&a.length>c.maxNumberOfElements&&(a=a.slice(0,c.maxNumberOfElements)),a}function h(a){return b.get("list").sort.enabled&&a.sort(b.get("list").sort.method),a}a.proccess.match=f;var i=c.data,j=d;return i=e(i,j),i=g(i),i=h(i)},a}(EasyAutocomplete||{}),EasyAutocomplete=function(a){return a.Template=function(a){var b={basic:{type:"basic",method:function(a){return a},cssClass:""},description:{type:"description",fields:{description:"description"},method:function(a){return a+" - description"},cssClass:"eac-description"},iconLeft:{type:"iconLeft",fields:{icon:""},method:function(a){return a},cssClass:"eac-icon-left"},iconRight:{type:"iconRight",fields:{iconSrc:""},method:function(a){return a},cssClass:"eac-icon-right"},links:{type:"links",fields:{link:""},method:function(a){return a},cssClass:""},custom:{type:"custom",method:function(){},cssClass:""}},c=function(a){var c,d=a.fields;return"description"===a.type?(c=b.description.method,"string"==typeof d.description?c=function(a,b){return a+" - <span>"+b[d.description]+"</span>"}:"function"==typeof d.description&&(c=function(a,b){return a+" - <span>"+d.description(b)+"</span>"}),c):"iconRight"===a.type?("string"==typeof d.iconSrc?c=function(a,b){return a+"<img class='eac-icon' src='"+b[d.iconSrc]+"' />"}:"function"==typeof d.iconSrc&&(c=function(a,b){return a+"<img class='eac-icon' src='"+d.iconSrc(b)+"' />"}),c):"iconLeft"===a.type?("string"==typeof d.iconSrc?c=function(a,b){return"<img class='eac-icon' src='"+b[d.iconSrc]+"' />"+a}:"function"==typeof d.iconSrc&&(c=function(a,b){return"<img class='eac-icon' src='"+d.iconSrc(b)+"' />"+a}),c):"links"===a.type?("string"==typeof d.link?c=function(a,b){return"<a href='"+b[d.link]+"' >"+a+"</a>"}:"function"==typeof d.link&&(c=function(a,b){return"<a href='"+d.link(b)+"' >"+a+"</a>"}),c):"custom"===a.type?a.method:b.basic.method},d=function(a){return a&&a.type&&a.type&&b[a.type]?c(a):b.basic.method},e=function(a){var c=function(){return""};return a&&a.type&&a.type&&b[a.type]?function(){var c=b[a.type].cssClass;return function(){return c}}():c};this.getTemplateClass=e(a),this.build=d(a)},a}(EasyAutocomplete||{}),EasyAutocomplete=function(a){return a.main=function(b,c){function d(){return 0===t.length?void p.error("Input field doesn't exist."):o.checkDataUrlProperties()?o.checkRequiredProperties()?(e(),void g()):void p.error("Will not work without mentioned properties."):void p.error("One of options variables 'data' or 'url' must be defined.")}function e(){function a(){var a=$("<div>"),c=n.getValue("WRAPPER_CSS_CLASS");o.get("theme")&&""!==o.get("theme")&&(c+=" eac-"+o.get("theme")),o.get("cssClasses")&&""!==o.get("cssClasses")&&(c+=" "+o.get("cssClasses")),""!==q.getTemplateClass()&&(c+=" "+q.getTemplateClass()),a.addClass(c),t.wrap(a),o.get("adjustWidth")===!0&&b()}function b(){var a=t.outerWidth();t.parent().css("width",a)}function c(){t.unwrap()}function d(){var a=$("<div>").addClass(n.getValue("CONTAINER_CLASS"));a.attr("id",f()).prepend($("<ul>")),function(){a.on("show.eac",function(){switch(o.get("list").showAnimation.type){case"slide":var b=o.get("list").showAnimation.time,c=o.get("list").showAnimation.callback;a.find("ul").slideDown(b,c);break;case"fade":var b=o.get("list").showAnimation.time,c=o.get("list").showAnimation.callback;a.find("ul").fadeIn(b),c;break;default:a.find("ul").show()}o.get("list").onShowListEvent()}).on("hide.eac",function(){switch(o.get("list").hideAnimation.type){case"slide":var b=o.get("list").hideAnimation.time,c=o.get("list").hideAnimation.callback;a.find("ul").slideUp(b,c);break;case"fade":var b=o.get("list").hideAnimation.time,c=o.get("list").hideAnimation.callback;a.find("ul").fadeOut(b,c);break;default:a.find("ul").hide()}o.get("list").onHideListEvent()}).on("selectElement.eac",function(){a.find("ul li").removeClass("selected"),a.find("ul li").eq(w).addClass("selected"),o.get("list").onSelectItemEvent()}).on("loadElements.eac",function(b,c,d){var e="",f=a.find("ul");f.empty().detach(),v=[];for(var h=0,i=0,k=c.length;k>i;i+=1){var l=c[i].data;if(0!==l.length){void 0!==c[i].header&&c[i].header.length>0&&f.append("<div class='eac-category' >"+c[i].header+"</div>");for(var m=0,n=l.length;n>m&&h<c[i].maxListSize;m+=1)e=$("<li><div class='eac-item'></div></li>"),function(){var a=m,b=h,f=c[i].getValue(l[a]);e.find(" > div").on("click",function(){t.val(f).trigger("change"),w=b,j(b),o.get("list").onClickEvent(),o.get("list").onChooseEvent()}).mouseover(function(){w=b,j(b),o.get("list").onMouseOverEvent()}).mouseout(function(){o.get("list").onMouseOutEvent()}).html(q.build(g(f,d),l[a]))}(),f.append(e),v.push(l[m]),h+=1}}a.append(f),o.get("list").onLoadEvent()})}(),t.after(a)}function e(){t.next("."+n.getValue("CONTAINER_CLASS")).remove()}function g(a,b){return o.get("highlightPhrase")&&""!==b?i(a,b):a}function h(a){return a.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")}function i(a,b){var c=h(b);return(a+"").replace(new RegExp("("+c+")","gi"),"<b>$1</b>")}t.parent().hasClass(n.getValue("WRAPPER_CSS_CLASS"))&&(e(),c()),a(),d(),u=$("#"+f()),o.get("placeholder")&&t.attr("placeholder",o.get("placeholder"))}function f(){var a=t.attr("id");return a=n.getValue("CONTAINER_ID")+a}function g(){function a(){s("autocompleteOff",!0)&&n(),b(),c(),d(),e(),f(),g()}function b(){t.focusout(function(){var a,b=t.val();o.get("list").match.caseSensitive||(b=b.toLowerCase());for(var c=0,d=v.length;d>c;c+=1)if(a=o.get("getValue")(v[c]),o.get("list").match.caseSensitive||(a=a.toLowerCase()),a===b)return w=c,void j(w)})}function c(){t.off("keyup").keyup(function(a){function b(a){function b(){var a={},b=o.get("ajaxSettings")||{};for(var c in b)a[c]=b[c];return a}function c(a,b){return o.get("matchResponseProperty")!==!1?"string"==typeof o.get("matchResponseProperty")?b[o.get("matchResponseProperty")]===a:"function"==typeof o.get("matchResponseProperty")?o.get("matchResponseProperty")(b)===a:!0:!0}if(!(a.length<o.get("minCharNumber"))){if("list-required"!==o.get("data")){var d=o.get("data"),e=r.init(d);e=r.updateCategories(e,d),e=r.processData(e,a),k(e,a),t.parent().find("li").length>0?h():i()}var f=b();void 0!==f.url&&""!==f.url||(f.url=o.get("url")),void 0!==f.dataType&&""!==f.dataType||(f.dataType=o.get("dataType")),void 0!==f.url&&"list-required"!==f.url&&(f.url=f.url(a),f.data=o.get("preparePostData")(f.data,a),$.ajax(f).done(function(b){var d=r.init(b);d=r.updateCategories(d,b),d=r.convertXml(d),c(a,b)&&(d=r.processData(d,a),k(d,a)),r.checkIfDataExists(d)&&t.parent().find("li").length>0?h():i(),o.get("ajaxCallback")()}).fail(function(){p.warning("Fail to load response data")}).always(function(){}))}}switch(a.keyCode){case 27:i(),l();break;case 38:a.preventDefault(),v.length>0&&w>0&&(w-=1,t.val(o.get("getValue")(v[w])),j(w));break;case 40:a.preventDefault(),v.length>0&&w<v.length-1&&(w+=1,t.val(o.get("getValue")(v[w])),j(w));break;default:if(a.keyCode>40||8===a.keyCode){var c=t.val();o.get("list").hideOnEmptyPhrase!==!0||8!==a.keyCode||""!==c?o.get("requestDelay")>0?(void 0!==m&&clearTimeout(m),m=setTimeout(function(){b(c)},o.get("requestDelay"))):b(c):i()}}})}function d(){t.on("keydown",function(a){a=a||window.event;var b=a.keyCode;return 38===b?(suppressKeypress=!0,!1):void 0}).keydown(function(a){13===a.keyCode&&w>-1&&(t.val(o.get("getValue")(v[w])),o.get("list").onKeyEnterEvent(),o.get("list").onChooseEvent(),w=-1,i(),a.preventDefault())})}function e(){t.off("keypress")}function f(){t.focus(function(){""!==t.val()&&v.length>0&&(w=-1,h())})}function g(){t.blur(function(){setTimeout(function(){w=-1,i()},250)})}function n(){t.attr("autocomplete","off")}a()}function h(){u.trigger("show.eac")}function i(){u.trigger("hide.eac")}function j(a){u.trigger("selectElement.eac",a)}function k(a,b){u.trigger("loadElements.eac",[a,b])}function l(){t.trigger("blur")}var m,n=new a.Constans,o=new a.Configuration(c),p=new a.Logger,q=new a.Template(c.template),r=new a.ListBuilderService(o,a.proccess),s=o.equals,t=b,u="",v=[],w=-1;a.consts=n,this.getConstants=function(){return n},this.getConfiguration=function(){return o},this.getContainer=function(){return u},this.getSelectedItemIndex=function(){return w},this.getItems=function(){return v},this.getItemData=function(a){return v.length<a||void 0===v[a]?-1:v[a]},this.getSelectedItemData=function(){return this.getItemData(w)},this.build=function(){e()},this.init=function(){d()}},a.eacHandles=[],a.getHandle=function(b){return a.eacHandles[b]},a.inputHasId=function(a){return void 0!==$(a).attr("id")&&$(a).attr("id").length>0},a.assignRandomId=function(b){var c="";do c="eac-"+Math.floor(1e4*Math.random());while(0!==$("#"+c).length);elementId=a.consts.getValue("CONTAINER_ID")+c,$(b).attr("id",c)},a.setHandle=function(b,c){a.eacHandles[c]=b},a}(EasyAutocomplete||{});!function(a){a.fn.easyAutocomplete=function(b){return this.each(function(){var c=a(this),d=new EasyAutocomplete.main(c,b);EasyAutocomplete.inputHasId(c)||EasyAutocomplete.assignRandomId(c),d.init(),EasyAutocomplete.setHandle(d,c.attr("id"))})},a.fn.getSelectedItemIndex=function(){var b=a(this).attr("id");return void 0!==b?EasyAutocomplete.getHandle(b).getSelectedItemIndex():-1},a.fn.getItems=function(){var b=a(this).attr("id");return void 0!==b?EasyAutocomplete.getHandle(b).getItems():-1},a.fn.getItemData=function(b){var c=a(this).attr("id");return void 0!==c&&b>-1?EasyAutocomplete.getHandle(c).getItemData(b):-1},a.fn.getSelectedItemData=function(){var b=a(this).attr("id");return void 0!==b?EasyAutocomplete.getHandle(b).getSelectedItemData():-1}}(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(11)))

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */,
/* 200 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<input id="'+
	((__t=( inputId ))==null?'':__t)+
	'" class="'+
	((__t=( classes.join(' ') ))==null?'':__t)+
	'"/>';
	}
	return __p;
	};


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Modal -->\n<div class="modal fade" id="set-initial-view-modal" tabindex="-1" role="dialog" style="z-index: 1100;"\n     aria-labelledby="set-initial-view-modal">\n    <div class="modal-dialog modal-sm" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\n                        aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title" id="set-initial-view-modal-label">Set Initial View</h4>\n            </div>\n            <div class="modal-body">\n                <div id="persons-container" class="form-group"></div>\n                <div id="set-initial-view-loader" class="loader" style="height: 200px;"></div>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-primary" id="save" disabled>Save</button>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if (typeof(id) !== "undefined" && typeof(person) !== "undefined") { 
	__p+='\n<nav class="navbar navbar-default bar-light">\n    ';
	 } else {
	__p+='\n    <nav class="navbar">\n        ';
	 } 
	__p+='\n        <div class="">\n            <div class="navbar-header">\n                <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar"\n                        aria-expanded="false" aria-controls="navbar">\n                    <span class="sr-only">Toggle navigation</span>\n                    <span class="icon-bar"></span>\n                    <span class="icon-bar"></span>\n                    <span class="icon-bar"></span>\n                </button>\n                <a href="#">\n                    ';
	 if (typeof(id) !== "undefined" && typeof(person) !== "undefined") { 
	__p+='\n                    <img class="img-responsive img-top-logo" src="' + __webpack_require__(203) + '"/>\n                    ';
	 } else {
	__p+='\n                    <img class="img-responsive img-top-logo" src="' + __webpack_require__(204) + '"/>\n                    ';
	 } 
	__p+='\n                </a>\n                ';
	 if (typeof(id) === "undefined" || typeof(person) === "undefined") { 
	__p+='\n                <p class="text-muted form-group col-md-7">\n                    Main Phone Number: 833-2ASKRNS (833-227-5767) &emsp;&emsp;\n                    Main Fax Number: 833-2FAXRNS (833-232-9767)\n                </p>\n                ';
	 } 
	__p+='\n            </div>\n            <div id="navbar" class="collapse navbar-collapse">\n                <ul class="nav navbar-nav">\n\n                    ';
	 if (typeof(id) !== "undefined" && typeof(person) !== "undefined") { 
	__p+='\n                    ';
	 for (var item in menuItems) { 
	__p+='\n                    ';
	 if (menuItems[item].submenus && menuItems[item].submenus.length > 0) { 
	__p+='\n                    <li class="'+
	((__t=( menuItems[item].activeClass ))==null?'':__t)+
	'">\n                        <a href="#" class="dropdown-toggle" id="'+
	((__t=( menuItems[item].title ))==null?'':__t)+
	'" data-toggle="dropdown"\n                           role="button" aria-haspopup="true" aria-expanded="false">\n                            <span>'+
	((__t=( menuItems[item].title ))==null?'':__t)+
	'</span>\n                            <span class="caret"></span>\n                        </a>\n                        <ul class="dropdown-menu" aria-labelledby="'+
	((__t=( menuItems[item].title ))==null?'':__t)+
	'">\n                            ';
	 for (var sub in menuItems[item].submenus) { 
	__p+='\n                            <li><a href="'+
	((__t=( menuItems[item].submenus[sub].url ))==null?'':__t)+
	'">'+
	((__t=(
	                                menuItems[item].submenus[sub].title ))==null?'':__t)+
	'</a></li>\n                            ';
	 } 
	__p+='\n\n                        </ul>\n                    </li>\n                    ';
	 } else { 
	__p+='\n                    <li class="'+
	((__t=( menuItems[item].activeClass ))==null?'':__t)+
	'">\n                        <a href="'+
	((__t=( menuItems[item].url ))==null?'':__t)+
	'">'+
	((__t=( menuItems[item].title ))==null?'':__t)+
	'</a>\n                    </li>\n                    ';
	 } 
	__p+='\n                    ';
	 } 
	__p+='\n                    ';
	 } 
	__p+='\n\n                </ul>\n                <ul class="nav navbar-nav navbar-right">\n                    ';
	 if (typeof(id) !== "undefined" && typeof(person) !== "undefined") { 
	__p+='\n                    <li class="dropdown">\n                        <a href="#" class="dropdown-toggle" id="drop2" data-toggle="dropdown" role="button"\n                           aria-haspopup="true" aria-expanded="false">\n                            <span class="date">View</span>\n                            <span class="caret"></span>\n                        </a>\n                        <ul class="dropdown-menu" aria-labelledby="drop2">\n                            <li><a id="set-initial-for-me" class="clickable">Set current view as initial for me</a></li>\n                            ';
	 if (isAdmin) { 
	__p+='\n                            <li role="separator" class="divider"></li>\n                            <li><a id="set-initial" class="clickable">Set current view as initial for</a></li>\n                            ';
	 } 
	__p+='\n                        </ul>\n                    </li>\n                    <li id="user-menu" class="dropdown">\n                        <a href="#" class="dropdown-toggle" id="drop3" data-toggle="dropdown" role="button"\n                           aria-haspopup="true" aria-expanded="false">\n                            <span class="date">'+
	((__t=( person.firstName ))==null?'':_.escape(__t))+
	' '+
	((__t=( person.lastName ))==null?'':_.escape(__t))+
	'</span>\n                            <span class="caret"></span>\n                        </a>\n                        <ul class="dropdown-menu" aria-labelledby="drop3">\n                            <li><a href="/#person/'+
	((__t=( person.login ))==null?'':_.escape(__t))+
	'">Profile</a></li>\n                            <li role="separator" class="divider"></li>\n                            <li><a href="#login" id="logout">Log out</a></li>\n                        </ul>\n                    </li>\n                    ';
	 } else {
	__p+='\n                    <li class="login-header-link"><a href="/#login">Log in</a></li>\n                    ';
	 } 
	__p+='\n                </ul>\n            </div>\n\n        </div>\n    </nav>\n    <div id="initial-view-modal"></div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Marionette = __webpack_require__(180);
	var Radio = __webpack_require__(183);
	
	var notificationsChannel = Radio.channel('notifications');
	var tablesFilterPreferencesChannel = Radio.channel('tablesFilterPreferencesChannel');
	
	//Models and collections
	var Session = __webpack_require__(187);
	var Person = __webpack_require__(206);
	var Document = __webpack_require__(207);
	var Organization = __webpack_require__(208);
	var ReviewElementStatusesModel = __webpack_require__(209);
	var PersonsCollection = __webpack_require__(210);
	var FaceToFaceFormModel = __webpack_require__(212);
	var MedProfileModel = __webpack_require__(213);
	
	//Views
	var Organizations = __webpack_require__(214);
	var OrganizationView = __webpack_require__(220);
	var OrganizationPatientsView = __webpack_require__(285);
	var Documents = __webpack_require__(299);
	var PersonsList = __webpack_require__(335);
	var LoginView = __webpack_require__(340);
	var PersonView = __webpack_require__(344);
	var SignUpView = __webpack_require__(390);
	var DocumentView = __webpack_require__(392);
	var Settings = __webpack_require__(424);
	var Relations = __webpack_require__(426);
	var RelationTypesList = __webpack_require__(428);
	var RelationTypeView = __webpack_require__(436);
	var DocumentUploadView = __webpack_require__(438);
	var UploadSignedDocumentView = __webpack_require__(442);
	var RolesList = __webpack_require__(446);
	var PasswordChangeForm = __webpack_require__(451);
	var DocTypesView = __webpack_require__(453);
	var PatientsView = __webpack_require__(460);
	var StatisticsView = __webpack_require__(463);
	var ImportPersonsView = __webpack_require__(474);
	var MergePersonsView = __webpack_require__(476);
	var DocumentHistoryView = __webpack_require__(416);
	var HelpSectionsList = __webpack_require__(500);
	var HelpPhysicianView = __webpack_require__(502);
	var HelpOfficeAdminView = __webpack_require__(505);
	var HelpCorporateAdminView = __webpack_require__(508);
	var HelpFeedbackView = __webpack_require__(511);
	var AuthByInstantToken = __webpack_require__(513);
	var ReferralFormView = __webpack_require__(514);
	var VillagePodiatryFormView = __webpack_require__(518);
	var FaceToFaceFormView = __webpack_require__(521);
	var FaceToFaceFormsListView = __webpack_require__(523);
	
	var CommonUtils = __webpack_require__(189);
	
	var Body = Marionette.View.extend({
	    template: __webpack_require__(527),
	    session: new Session(),
	
	    regions: {
	        body: '.body-hook'
	    },
	
	    childViewEvents: {
	        'server:error': 'onServerError',
	        'refresh:document:view': 'onShowDocumentEntity',
	        'update:tables:filters:preferences': 'onUpdateTablesFiltersPreferences'
	    },
	
	    initialize: function () {
	        this.reviewElementStatuses = new ReviewElementStatusesModel();
	        this.personsCollection = new PersonsCollection();
	        this.utils = new CommonUtils();
	        var that = this;
	        notificationsChannel.reply('show:notification', function (msg) {
	            that.triggerMethod('server:error', msg);
	        });
	
	    },
	
	    onServerError: function (message) {
	        var msg = "";
	        var title = "Error";
	        var type = "danger";
	        if (typeof message == "object") {
	            if (message.code > 199 && message.code < 300) {
	                type = "success";
	                title = "Success";
	            }
	            msg = message.message;
	        } else {
	            msg = message;
	        }
	        $.notify({
	            animate: {
	                enter: 'animated bounceIn',
	                exit: 'animated bounceOut'
	            },
	            title: '<strong>' + title + ': </strong>',
	            message: msg
	        }, {
	            type: type,
	            delay: 20000,
	            z_index: 11000
	        });
	    },
	
	    byAdmin: function () {
	        return _.some(this.session.get('systemRoles'), function (item) {
	            return item == 'ADMIN';
	        });
	    },
	
	    onSessionChanged: function (session) {
	        this.session.set(session.toJSON());
	    },
	
	    onShowOrganizationsList: function () {
	        this.showChildView('body', new Organizations({byAdmin: this.byAdmin()}));
	    },
	
	    onShowDocumentsList: function () {
	        this.showChildView('body', new Documents({
	            user: this.session.get('person'),
	            byAdmin: this.byAdmin()
	        }));
	    },
	
	    onShowDocumentEntity: function (entry) {
	        var that = this;
	        var documentModel = new Document();
	        documentModel.set('id', entry);
	        documentModel.fetch({
	            success: function () {
	                var documentView = new DocumentView({
	                    model: documentModel,
	                    byAdmin: that.byAdmin()
	                });
	                that.showChildView('body', documentView);
	            }
	        });
	    },
	
	    onShowDocumentHistoryEntity: function (entry) {
	        var that = this;
	        var documentModel = new Document();
	        documentModel.set('id', entry);
	        documentModel.fetch({
	            success: function () {
	                var documentHistoryView = new DocumentHistoryView({
	                    id: documentModel.get('id'),
	                    name: documentModel.get('name'),
	                    baseParentIdPath: '/api/document/view/',
	                    canEdit: that.byAdmin(),
	                    byAdmin: that.byAdmin(),
	                    document: documentModel.get('object')
	                });
	                that.showChildView('body', documentHistoryView);
	            }
	        });
	    },
	
	    onShowHistoryEntries: function (entry) {
	        var that = this;
	        var historyView = new DocumentHistoryView({
	            id: entry,
	            name: entry,
	            canEdit: that.byAdmin()
	        });
	        that.showChildView('body', historyView);
	    },
	
	    onShowDocumentUpload: function () {
	        var documentUploadView = new DocumentUploadView();
	        this.showChildView('body', documentUploadView);
	    },
	
	    onShowDocumentUploadSigned: function () {
	        var uploadSignedDocumentView = new UploadSignedDocumentView();
	        this.showChildView('body', uploadSignedDocumentView);
	    },
	
	    onShowPersonsList: function () {
	        this.showChildView('body', new PersonsList());
	    },
	
	    onShowOrganizationEntry: function (entry) {
	        var that = this;
	        var model = new Organization();
	        model.set('id', entry);
	        model.fetch({
	            success: function () {
	                that.showChildView('body', new OrganizationView({
	                    model: model,
	                    user: that.session.get('person'),
	                    byAdmin: that.byAdmin()
	                }));
	            }
	        });
	    },
	
	    onShowOrganizationEntryPatients: function (entry) {
	        var tablesFilterPreferencesList = JSON.parse(localStorage.getItem(this.session.get('person').login + "_" + "tables_filters_sort_preferences")) || [];
	        this.showChildView(
	            'body',
	            new OrganizationPatientsView({
	                id: entry,
	                byAdmin: this.byAdmin(),
	                tablesFilterPreferencesList: tablesFilterPreferencesList
	            })
	        )
	    },
	
	    onUpdateTablesFiltersPreferences: function (tableFilterPreferences) {
	        var tablesFilterPreferencesList = JSON.parse(localStorage.getItem(this.session.get('person').login + "_" + "tables_filters_sort_preferences")) || [];
	        var foundIndex = _.findIndex(tablesFilterPreferencesList, function (tfp) {
	            return tfp.tableName == tableFilterPreferences.tableName;
	        });
	
	        if (foundIndex > -1) {
	            tablesFilterPreferencesList[foundIndex] = tableFilterPreferences;
	        } else {
	            tablesFilterPreferencesList.push(tableFilterPreferences);
	        }
	
	        localStorage.setItem(this.session.get('person').login + "_" + "tables_filters_sort_preferences", JSON.stringify(tablesFilterPreferencesList));
	    },
	
	    onShowPersonEntry: function (entry) {
	        var that = this;
	        var isSelf = that.session.get('person').login == entry;
	        var personModel = new Person();
	        personModel.set('id', entry);
	
	        personModel.fetch({
	            success: function () {
	                that.showChildView('body', new PersonView({
	                    model: personModel,
	                    byAdmin: that.byAdmin(),
	                    isSelf: isSelf
	                }));
	            }
	        });
	    },
	
	    onShowLogin: function () {
	        this.showChildView('body', new LoginView());
	    },
	
	    onShowSignup: function () {
	        this.showChildView('body', new SignUpView());
	    },
	
	    onShowSettingsList: function () {
	        this.showChildView('body', new Settings());
	    },
	
	    onShowRelationsList: function () {
	        this.showChildView('body', new Relations());
	    },
	
	    onShowRelationtypesList: function () {
	        this.showChildView('body', new RelationTypesList());
	    },
	
	    onShowRelationtypeEntry: function (entry) {
	        this.showChildView('body', new RelationTypeView({id: entry}));
	    },
	
	    onShowRolesList: function () {
	        this.showChildView('body', new RolesList());
	    },
	
	    onChangePasswordEntry: function (entry) {
	        var isSelf = this.session.get('person').login == entry;
	        this.showChildView('body', new PasswordChangeForm({
	            id: entry,
	            byAdmin: this.byAdmin(),
	            isSelf: isSelf,
	            defaultPassword: this.session.get('person').defaultPassword
	        }));
	    },
	
	    onShowDoctypesList: function () {
	        this.showChildView('body', new DocTypesView());
	    },
	
	    onShowHelpList: function () {
	        this.showChildView('body', new HelpSectionsList());
	    },
	
	    onShowHelpPhysician: function () {
	        this.showChildView('body', new HelpPhysicianView());
	    },
	
	    onShowHelpOfficeAdmin: function () {
	        this.showChildView('body', new HelpOfficeAdminView());
	    },
	
	    onShowHelpCorporateAdmin: function () {
	        this.showChildView('body', new HelpCorporateAdminView());
	    },
	
	    onShowHelpFeedback: function () {
	        this.showChildView('body', new HelpFeedbackView());
	    },
	
	    onShowPatientsList: function () {
	        this.showChildView('body', new PatientsView({byAdmin: this.byAdmin()}));
	    },
	
	    onShowStatistics: function () {
	        this.showChildView('body', new StatisticsView());
	    },
	
	    onAuthByInstantToken: function (token) {
	        this.showChildView('body', new AuthByInstantToken({'token': token}));
	    },
	
	    onShowImportPersons: function () {
	        this.showChildView('body', new ImportPersonsView());
	    },
	
	    onShowMergePersons: function (mergeTo, mergeFrom) {
	        this.showChildView('body', new MergePersonsView({
	            mergeTo: mergeTo,
	            mergeFrom: mergeFrom
	        }));
	    },
	
	    onShowReferralForm: function () {
	        this.showChildView('body', new ReferralFormView());
	    },
	
	    onShowVillagePodiatryForm: function (entry) {
	
	        var that = this;
	        that.showChildView('body', new VillagePodiatryFormView({
	            currentUser: that.session.get('person').login
	        }));
	    },
	
	    onShowFfForm: function (entry) {
	
	        var that = this;
	        if (!entry) {
	            that.showChildView('body', new FaceToFaceFormView({
	                currentUser: that.session.get('person').login
	            }));
	        } else {
	            var fffModel = new FaceToFaceFormModel({
	                id: entry
	            });
	
	            fffModel.fetch({
	                success: function (ff) {
	                    var data = ff.attributes;
	                    var medProfileModel = new MedProfileModel();
	                    medProfileModel.set('id', 'MP_' + data.patient.id);
	                    medProfileModel.fetch({
	                        success: function (resp) {
	                            that.showChildView('body', new FaceToFaceFormView({
	                                model: data,
	                                medProfile: _.omit(resp.attributes.object, "@class"),
	                                currentUser: that.session.get('person').login
	                            }));
	                        }
	                    });
	                }
	            });
	        }
	    },
	
	    onShowFormsList: function () {
	        this.showChildView('body', new FaceToFaceFormsListView({currentUser: this.session.get('person').login}));
	    }
	});
	
	module.exports = Body;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(181);
	
	
	var PersonModel = Backbone.Model.extend({
	    defaults: {
	        id: undefined,
	        name: '',
	        object: {
	            firstName: '',
	            lastName: '',
	            login:'',
	            password:'',
	            //contact: undefined,
	            address:'',
	            isPatient: false,
	            isMd: false,
	            ssn: undefined
	        }
	    },
	
	    urlRoot: '/api/person',
	
	
	    validate: function(attrs) {
	        var errors = [];
	        var hasError = false;
	        if (!attrs.object) {
	            errors.push('Person data is empty');
	            hasError = true;
	        }
	        if (!attrs.object.login || attrs.object.login == '') {
	            errors.push('Login must be set');
	            hasError = true;
	        }
	        if (!attrs.object.firstName || attrs.object.firstName == '') {
	            errors.push('First name must be set');
	            hasError = true;
	        }
	        if (!attrs.object.lastName || attrs.object.lastName == '') {
	            errors.push('Last name must be set');
	            hasError = true;
	        }
	        if (hasError) {
	            return errors;
	        }
	    },
	
	    sync: function (method, model, options) {
	        options.attrs = _.omit(model.attributes, 'relations');
	        return Backbone.sync.call(this, method, model, options);
	    }
	});
	
	
	module.exports = PersonModel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(181);
	
	
	var DocumentModel = Backbone.Model.extend({
	
	    urlRoot: '/api/document'
	
	});
	
	
	module.exports = DocumentModel;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(181);
	
	var Organization = Backbone.Model.extend({
	    defaults: {
	        id: undefined,
	        name: '',
	        object: {
	            address: '',
	            created: '',
	            //contact: undefined
	        }
	    },
	
	    urlRoot: '/api/organization',
	
	
	    validate: function(attrs) {
	        var errors = {};
	        var hasError = false;
	        if (!attrs.name) {
	            errors.assignee = 'Name must be set';
	            hasError = true;
	        }
	        if (hasError) {
	            return errors;
	        }
	    },
	
	    sync: function (method, model, options) {
	        options.attrs = _.omit(model.attributes, 'relations');
	        return Backbone.sync.call(this, method, model, options);
	    }
	});
	
	
	module.exports = Organization;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(181);
	
	
	var ReviewElementStatusesCollection = Backbone.Model.extend({
	    url:"/api/document/statuses"
	});
	
	
	module.exports = ReviewElementStatusesCollection;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	
	
	var PersonsCollection = BaseCollection.extend({
	    url:"/api/person/preview",
	
	    initialize: function(models, options){
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    }
	});
	
	
	module.exports = PersonsCollection;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(181);
	
	var BaseCollection = Backbone.Collection.extend({
	
	    initialize: function(models, options) {
	        if (options && options.params){
	            this.url += "?" + options.params.map(function(param){return param.key + "=" + param.value}).join("&");
	        }
	    }
	});
	
	module.exports = BaseCollection;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(181);
	
	
	var FaceToFaceFormModel = Backbone.Model.extend({
	    defaults: {
	        id: undefined
	    },
	
	    urlRoot: '/api/face-to-face-form'
	});
	
	
	module.exports = FaceToFaceFormModel;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(181);
	
	
	var MedProfileModel = Backbone.Model.extend({
	
	    urlRoot: '/api/medprofile',
	
	    defaults: {
	        id: undefined,
	        name: undefined,
	        object: {
	            personId: undefined,
	            medications: []
	        }
	    },
	
	    sync: function (method, model, options) {
	        model.attributes.object.medications = model.attributes.object.medications.map(function (medication) {
	            medication = _.omit(medication, 'id');
	            return medication;
	        });
	        options.attrs = model.attributes;
	
	        return Backbone.sync.call(this, method, model, options);
	    }
	
	});
	
	
	module.exports = MedProfileModel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(215);
	
	var Marionette = __webpack_require__(180);
	var OrganizationForm = __webpack_require__(216);
	var OrganizationsCollections = __webpack_require__(218);
	var Organization = __webpack_require__(208);
	
	var CommonUtils = __webpack_require__(189);
	
	var Organizations = Marionette.View.extend({
	    template: __webpack_require__(219),
	    //collection: new OrganizationsCollections(),
	    model: new Organization(),
	
	    events: {
	        'click #save-organization': 'saveOrganization',
	        'keyup input#filter': 'applyFilter'
	    },
	
	    regions: {
	        modal: '#addOrganizationModal',
	        form: '#form',
	        tree: '#tree'
	    },
	
	    ui: {
	        modal: '#addOrganizationModal',
	        saveBtn: '#save-organization'
	    },
	
	    collectionEvents: {
	        add: 'itemAdded',
	        request: 'showLoading',
	        sync: 'hideLoading',
	        error: 'logError'
	    },
	
	    childViewEvents: {
	        'organization:save:valid': 'saveOrganizationBtnEnableOrDisable'
	    },
	
	
	    templateContext: function () {
	        return {
	            byAdmin: this.options.byAdmin
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'renderTree', 'collectionToTree', 'itemSaved',
	            'saveOrganization', 'applyFilter', 'satisfiesFilter', 'stringContains',
	            'saveOrganizationBtnEnableOrDisable'); // fixes loss of context for 'this' within methods
	
	        this.utils = new CommonUtils();
	        this.params = $.deparam(window.location.hash.replace('#organizations', '').replace('?', ''));
	        this.collection = new OrganizationsCollections([],
	            {params: this.utils.queryParamsToCollection(this.params) || []});
	    },
	
	    onRender: function () {
	        window.document.title = "RNS Organizations";
	        this.organizationForm = new OrganizationForm({
	            model: this.model,
	            isEditMode: false
	        });
	        this.showChildView('form', this.organizationForm);
	        this.collection.fetch({success: this.renderTree});
	    },
	
	    renderTree: function (response, array, collection, filter) {
	        $('#tree').treeview({
	            data: this.collectionToTree(this.collection.toJSON(), filter),
	            enableLinks: true,
	            showTags: true
	        });
	    },
	
	    saveOrganization: function () {
	        this.ui.modal.modal('hide');
	        this.model = this.organizationForm.fillModel();
	        this.model.save(this.model.toJSON(), {success: this.itemSaved});
	    },
	
	    itemAdded: function () {
	        this.model = this.organizationForm.clearModel();
	    },
	
	    itemSaved: function () {
	        this.collection.add(this.model.clone());
	        this.renderTree();
	    },
	
	    collectionToTree: function (collection, filter) {
	        var that = this;
	        var tree = [];
	        if ((collection || []).length == 0) {
	            return undefined;
	        }
	        collection.filter(function (organization) {
	            return that.satisfiesFilter(organization, filter)
	        }).forEach(function (organization) {
	            var tags = [];
	            if (organization.relatedAs) {
	                tags.push(organization.relatedAs);
	            }
	            tree.push({
	                icon: 'glyphicon glyphicon-home',
	                text: organization.name,
	                href: '/#organization/' + organization.id,
	                tags: tags,
	                state: {
	                    expanded: false
	                },
	                nodes: that.collectionToTree((organization.relations || []).map(function (relation) {
	                    relation.child.relatedAs = (relation.type ? relation.type.name : undefined);
	                    return relation.child
	                }))
	            });
	        });
	        return _.sortBy(tree, function (o) {
	            return o.text;
	        });
	    },
	
	    applyFilter: function (event) {
	        this.renderTree({}, {}, {}, event.target.value);
	    },
	
	    satisfiesFilter: function (organization, filter) {
	        return !filter || filter == '' ||
	            this.stringContains(organization.name, filter) ||
	            this.stringContains(organization.npi, filter);
	    },
	
	    stringContains: function (str, substr) {
	        str = (str || '').toLowerCase();
	        substr = (substr || '').toLowerCase();
	        return str.indexOf(substr) !== -1
	    },
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    },
	
	    saveOrganizationBtnEnableOrDisable: function (data) {
	        if (data.result)
	            this.ui.saveBtn.removeAttr("disabled");
	        else
	            this.ui.saveBtn.attr("disabled", "true");
	    }
	
	});
	
	module.exports = Organizations;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {!function(a,b,c,d){"use strict";var e="treeview",f={};f.settings={injectStyle:!0,levels:2,expandIcon:"glyphicon glyphicon-plus",collapseIcon:"glyphicon glyphicon-minus",emptyIcon:"glyphicon",nodeIcon:"",selectedIcon:"",checkedIcon:"glyphicon glyphicon-check",uncheckedIcon:"glyphicon glyphicon-unchecked",color:d,backColor:d,borderColor:d,onhoverColor:"#F5F5F5",selectedColor:"#FFFFFF",selectedBackColor:"#428bca",searchResultColor:"#D9534F",searchResultBackColor:d,enableLinks:!1,highlightSelected:!0,highlightSearchResults:!0,showBorder:!0,showIcon:!0,showCheckbox:!1,showTags:!1,multiSelect:!1,onNodeChecked:d,onNodeCollapsed:d,onNodeDisabled:d,onNodeEnabled:d,onNodeExpanded:d,onNodeSelected:d,onNodeUnchecked:d,onNodeUnselected:d,onSearchComplete:d,onSearchCleared:d},f.options={silent:!1,ignoreChildren:!1},f.searchOptions={ignoreCase:!0,exactMatch:!1,revealResults:!0};var g=function(b,c){return this.$element=a(b),this.elementId=b.id,this.styleId=this.elementId+"-style",this.init(c),{options:this.options,init:a.proxy(this.init,this),remove:a.proxy(this.remove,this),getNode:a.proxy(this.getNode,this),getParent:a.proxy(this.getParent,this),getSiblings:a.proxy(this.getSiblings,this),getSelected:a.proxy(this.getSelected,this),getUnselected:a.proxy(this.getUnselected,this),getExpanded:a.proxy(this.getExpanded,this),getCollapsed:a.proxy(this.getCollapsed,this),getChecked:a.proxy(this.getChecked,this),getUnchecked:a.proxy(this.getUnchecked,this),getDisabled:a.proxy(this.getDisabled,this),getEnabled:a.proxy(this.getEnabled,this),selectNode:a.proxy(this.selectNode,this),unselectNode:a.proxy(this.unselectNode,this),toggleNodeSelected:a.proxy(this.toggleNodeSelected,this),collapseAll:a.proxy(this.collapseAll,this),collapseNode:a.proxy(this.collapseNode,this),expandAll:a.proxy(this.expandAll,this),expandNode:a.proxy(this.expandNode,this),toggleNodeExpanded:a.proxy(this.toggleNodeExpanded,this),revealNode:a.proxy(this.revealNode,this),checkAll:a.proxy(this.checkAll,this),checkNode:a.proxy(this.checkNode,this),uncheckAll:a.proxy(this.uncheckAll,this),uncheckNode:a.proxy(this.uncheckNode,this),toggleNodeChecked:a.proxy(this.toggleNodeChecked,this),disableAll:a.proxy(this.disableAll,this),disableNode:a.proxy(this.disableNode,this),enableAll:a.proxy(this.enableAll,this),enableNode:a.proxy(this.enableNode,this),toggleNodeDisabled:a.proxy(this.toggleNodeDisabled,this),search:a.proxy(this.search,this),clearSearch:a.proxy(this.clearSearch,this)}};g.prototype.init=function(b){this.tree=[],this.nodes=[],b.data&&("string"==typeof b.data&&(b.data=a.parseJSON(b.data)),this.tree=a.extend(!0,[],b.data),delete b.data),this.options=a.extend({},f.settings,b),this.destroy(),this.subscribeEvents(),this.setInitialStates({nodes:this.tree},0),this.render()},g.prototype.remove=function(){this.destroy(),a.removeData(this,e),a("#"+this.styleId).remove()},g.prototype.destroy=function(){this.initialized&&(this.$wrapper.remove(),this.$wrapper=null,this.unsubscribeEvents(),this.initialized=!1)},g.prototype.unsubscribeEvents=function(){this.$element.off("click"),this.$element.off("nodeChecked"),this.$element.off("nodeCollapsed"),this.$element.off("nodeDisabled"),this.$element.off("nodeEnabled"),this.$element.off("nodeExpanded"),this.$element.off("nodeSelected"),this.$element.off("nodeUnchecked"),this.$element.off("nodeUnselected"),this.$element.off("searchComplete"),this.$element.off("searchCleared")},g.prototype.subscribeEvents=function(){this.unsubscribeEvents(),this.$element.on("click",a.proxy(this.clickHandler,this)),"function"==typeof this.options.onNodeChecked&&this.$element.on("nodeChecked",this.options.onNodeChecked),"function"==typeof this.options.onNodeCollapsed&&this.$element.on("nodeCollapsed",this.options.onNodeCollapsed),"function"==typeof this.options.onNodeDisabled&&this.$element.on("nodeDisabled",this.options.onNodeDisabled),"function"==typeof this.options.onNodeEnabled&&this.$element.on("nodeEnabled",this.options.onNodeEnabled),"function"==typeof this.options.onNodeExpanded&&this.$element.on("nodeExpanded",this.options.onNodeExpanded),"function"==typeof this.options.onNodeSelected&&this.$element.on("nodeSelected",this.options.onNodeSelected),"function"==typeof this.options.onNodeUnchecked&&this.$element.on("nodeUnchecked",this.options.onNodeUnchecked),"function"==typeof this.options.onNodeUnselected&&this.$element.on("nodeUnselected",this.options.onNodeUnselected),"function"==typeof this.options.onSearchComplete&&this.$element.on("searchComplete",this.options.onSearchComplete),"function"==typeof this.options.onSearchCleared&&this.$element.on("searchCleared",this.options.onSearchCleared)},g.prototype.setInitialStates=function(b,c){if(b.nodes){c+=1;var d=b,e=this;a.each(b.nodes,function(a,b){b.nodeId=e.nodes.length,b.parentId=d.nodeId,b.hasOwnProperty("selectable")||(b.selectable=!0),b.state=b.state||{},b.state.hasOwnProperty("checked")||(b.state.checked=!1),b.state.hasOwnProperty("disabled")||(b.state.disabled=!1),b.state.hasOwnProperty("expanded")||(!b.state.disabled&&c<e.options.levels&&b.nodes&&b.nodes.length>0?b.state.expanded=!0:b.state.expanded=!1),b.state.hasOwnProperty("selected")||(b.state.selected=!1),e.nodes.push(b),b.nodes&&e.setInitialStates(b,c)})}},g.prototype.clickHandler=function(b){this.options.enableLinks||b.preventDefault();var c=a(b.target),d=this.findNode(c);if(d&&!d.state.disabled){var e=c.attr("class")?c.attr("class").split(" "):[];-1!==e.indexOf("expand-icon")?(this.toggleExpandedState(d,f.options),this.render()):-1!==e.indexOf("check-icon")?(this.toggleCheckedState(d,f.options),this.render()):(d.selectable?this.toggleSelectedState(d,f.options):this.toggleExpandedState(d,f.options),this.render())}},g.prototype.findNode=function(a){var b=a.closest("li.list-group-item").attr("data-nodeid"),c=this.nodes[b];return c||console.log("Error: node does not exist"),c},g.prototype.toggleExpandedState=function(a,b){a&&this.setExpandedState(a,!a.state.expanded,b)},g.prototype.setExpandedState=function(b,c,d){c!==b.state.expanded&&(c&&b.nodes?(b.state.expanded=!0,d.silent||this.$element.trigger("nodeExpanded",a.extend(!0,{},b))):c||(b.state.expanded=!1,d.silent||this.$element.trigger("nodeCollapsed",a.extend(!0,{},b)),b.nodes&&!d.ignoreChildren&&a.each(b.nodes,a.proxy(function(a,b){this.setExpandedState(b,!1,d)},this))))},g.prototype.toggleSelectedState=function(a,b){a&&this.setSelectedState(a,!a.state.selected,b)},g.prototype.setSelectedState=function(b,c,d){c!==b.state.selected&&(c?(this.options.multiSelect||a.each(this.findNodes("true","g","state.selected"),a.proxy(function(a,b){this.setSelectedState(b,!1,d)},this)),b.state.selected=!0,d.silent||this.$element.trigger("nodeSelected",a.extend(!0,{},b))):(b.state.selected=!1,d.silent||this.$element.trigger("nodeUnselected",a.extend(!0,{},b))))},g.prototype.toggleCheckedState=function(a,b){a&&this.setCheckedState(a,!a.state.checked,b)},g.prototype.setCheckedState=function(b,c,d){c!==b.state.checked&&(c?(b.state.checked=!0,d.silent||this.$element.trigger("nodeChecked",a.extend(!0,{},b))):(b.state.checked=!1,d.silent||this.$element.trigger("nodeUnchecked",a.extend(!0,{},b))))},g.prototype.setDisabledState=function(b,c,d){c!==b.state.disabled&&(c?(b.state.disabled=!0,this.setExpandedState(b,!1,d),this.setSelectedState(b,!1,d),this.setCheckedState(b,!1,d),d.silent||this.$element.trigger("nodeDisabled",a.extend(!0,{},b))):(b.state.disabled=!1,d.silent||this.$element.trigger("nodeEnabled",a.extend(!0,{},b))))},g.prototype.render=function(){this.initialized||(this.$element.addClass(e),this.$wrapper=a(this.template.list),this.injectStyle(),this.initialized=!0),this.$element.empty().append(this.$wrapper.empty()),this.buildTree(this.tree,0)},g.prototype.buildTree=function(b,c){if(b){c+=1;var d=this;a.each(b,function(b,e){for(var f=a(d.template.item).addClass("node-"+d.elementId).addClass(e.state.checked?"node-checked":"").addClass(e.state.disabled?"node-disabled":"").addClass(e.state.selected?"node-selected":"").addClass(e.searchResult?"search-result":"").attr("data-nodeid",e.nodeId).attr("style",d.buildStyleOverride(e)),g=0;c-1>g;g++)f.append(d.template.indent);var h=[];if(e.nodes?(h.push("expand-icon"),h.push(e.state.expanded?d.options.collapseIcon:d.options.expandIcon)):h.push(d.options.emptyIcon),f.append(a(d.template.icon).addClass(h.join(" "))),d.options.showIcon){var h=["node-icon"];h.push(e.icon||d.options.nodeIcon),e.state.selected&&(h.pop(),h.push(e.selectedIcon||d.options.selectedIcon||e.icon||d.options.nodeIcon)),f.append(a(d.template.icon).addClass(h.join(" ")))}if(d.options.showCheckbox){var h=["check-icon"];h.push(e.state.checked?d.options.checkedIcon:d.options.uncheckedIcon),f.append(a(d.template.icon).addClass(h.join(" ")))}return f.append(d.options.enableLinks?a(d.template.link).attr("href",e.href).append(e.text):e.text),d.options.showTags&&e.tags&&a.each(e.tags,function(b,c){f.append(a(d.template.badge).append(c))}),d.$wrapper.append(f),e.nodes&&e.state.expanded&&!e.state.disabled?d.buildTree(e.nodes,c):void 0})}},g.prototype.buildStyleOverride=function(a){if(a.state.disabled)return"";var b=a.color,c=a.backColor;return this.options.highlightSelected&&a.state.selected&&(this.options.selectedColor&&(b=this.options.selectedColor),this.options.selectedBackColor&&(c=this.options.selectedBackColor)),this.options.highlightSearchResults&&a.searchResult&&!a.state.disabled&&(this.options.searchResultColor&&(b=this.options.searchResultColor),this.options.searchResultBackColor&&(c=this.options.searchResultBackColor)),"color:"+b+";background-color:"+c+";"},g.prototype.injectStyle=function(){this.options.injectStyle&&!c.getElementById(this.styleId)&&a('<style type="text/css" id="'+this.styleId+'"> '+this.buildStyle()+" </style>").appendTo("head")},g.prototype.buildStyle=function(){var a=".node-"+this.elementId+"{";return this.options.color&&(a+="color:"+this.options.color+";"),this.options.backColor&&(a+="background-color:"+this.options.backColor+";"),this.options.showBorder?this.options.borderColor&&(a+="border:1px solid "+this.options.borderColor+";"):a+="border:none;",a+="}",this.options.onhoverColor&&(a+=".node-"+this.elementId+":not(.node-disabled):hover{background-color:"+this.options.onhoverColor+";}"),this.css+a},g.prototype.template={list:'<ul class="list-group"></ul>',item:'<li class="list-group-item"></li>',indent:'<span class="indent"></span>',icon:'<span class="icon"></span>',link:'<a href="#" style="color:inherit;"></a>',badge:'<span class="badge"></span>'},g.prototype.css=".treeview .list-group-item{cursor:pointer}.treeview span.indent{margin-left:10px;margin-right:10px}.treeview span.icon{width:12px;margin-right:5px}.treeview .node-disabled{color:silver;cursor:not-allowed}",g.prototype.getNode=function(a){return this.nodes[a]},g.prototype.getParent=function(a){var b=this.identifyNode(a);return this.nodes[b.parentId]},g.prototype.getSiblings=function(a){var b=this.identifyNode(a),c=this.getParent(b),d=c?c.nodes:this.tree;return d.filter(function(a){return a.nodeId!==b.nodeId})},g.prototype.getSelected=function(){return this.findNodes("true","g","state.selected")},g.prototype.getUnselected=function(){return this.findNodes("false","g","state.selected")},g.prototype.getExpanded=function(){return this.findNodes("true","g","state.expanded")},g.prototype.getCollapsed=function(){return this.findNodes("false","g","state.expanded")},g.prototype.getChecked=function(){return this.findNodes("true","g","state.checked")},g.prototype.getUnchecked=function(){return this.findNodes("false","g","state.checked")},g.prototype.getDisabled=function(){return this.findNodes("true","g","state.disabled")},g.prototype.getEnabled=function(){return this.findNodes("false","g","state.disabled")},g.prototype.selectNode=function(b,c){this.forEachIdentifier(b,c,a.proxy(function(a,b){this.setSelectedState(a,!0,b)},this)),this.render()},g.prototype.unselectNode=function(b,c){this.forEachIdentifier(b,c,a.proxy(function(a,b){this.setSelectedState(a,!1,b)},this)),this.render()},g.prototype.toggleNodeSelected=function(b,c){this.forEachIdentifier(b,c,a.proxy(function(a,b){this.toggleSelectedState(a,b)},this)),this.render()},g.prototype.collapseAll=function(b){var c=this.findNodes("true","g","state.expanded");this.forEachIdentifier(c,b,a.proxy(function(a,b){this.setExpandedState(a,!1,b)},this)),this.render()},g.prototype.collapseNode=function(b,c){this.forEachIdentifier(b,c,a.proxy(function(a,b){this.setExpandedState(a,!1,b)},this)),this.render()},g.prototype.expandAll=function(b){if(b=a.extend({},f.options,b),b&&b.levels)this.expandLevels(this.tree,b.levels,b);else{var c=this.findNodes("false","g","state.expanded");this.forEachIdentifier(c,b,a.proxy(function(a,b){this.setExpandedState(a,!0,b)},this))}this.render()},g.prototype.expandNode=function(b,c){this.forEachIdentifier(b,c,a.proxy(function(a,b){this.setExpandedState(a,!0,b),a.nodes&&b&&b.levels&&this.expandLevels(a.nodes,b.levels-1,b)},this)),this.render()},g.prototype.expandLevels=function(b,c,d){d=a.extend({},f.options,d),a.each(b,a.proxy(function(a,b){this.setExpandedState(b,c>0?!0:!1,d),b.nodes&&this.expandLevels(b.nodes,c-1,d)},this))},g.prototype.revealNode=function(b,c){this.forEachIdentifier(b,c,a.proxy(function(a,b){for(var c=this.getParent(a);c;)this.setExpandedState(c,!0,b),c=this.getParent(c)},this)),this.render()},g.prototype.toggleNodeExpanded=function(b,c){this.forEachIdentifier(b,c,a.proxy(function(a,b){this.toggleExpandedState(a,b)},this)),this.render()},g.prototype.checkAll=function(b){var c=this.findNodes("false","g","state.checked");this.forEachIdentifier(c,b,a.proxy(function(a,b){this.setCheckedState(a,!0,b)},this)),this.render()},g.prototype.checkNode=function(b,c){this.forEachIdentifier(b,c,a.proxy(function(a,b){this.setCheckedState(a,!0,b)},this)),this.render()},g.prototype.uncheckAll=function(b){var c=this.findNodes("true","g","state.checked");this.forEachIdentifier(c,b,a.proxy(function(a,b){this.setCheckedState(a,!1,b)},this)),this.render()},g.prototype.uncheckNode=function(b,c){this.forEachIdentifier(b,c,a.proxy(function(a,b){this.setCheckedState(a,!1,b)},this)),this.render()},g.prototype.toggleNodeChecked=function(b,c){this.forEachIdentifier(b,c,a.proxy(function(a,b){this.toggleCheckedState(a,b)},this)),this.render()},g.prototype.disableAll=function(b){var c=this.findNodes("false","g","state.disabled");this.forEachIdentifier(c,b,a.proxy(function(a,b){this.setDisabledState(a,!0,b)},this)),this.render()},g.prototype.disableNode=function(b,c){this.forEachIdentifier(b,c,a.proxy(function(a,b){this.setDisabledState(a,!0,b)},this)),this.render()},g.prototype.enableAll=function(b){var c=this.findNodes("true","g","state.disabled");this.forEachIdentifier(c,b,a.proxy(function(a,b){this.setDisabledState(a,!1,b)},this)),this.render()},g.prototype.enableNode=function(b,c){this.forEachIdentifier(b,c,a.proxy(function(a,b){this.setDisabledState(a,!1,b)},this)),this.render()},g.prototype.toggleNodeDisabled=function(b,c){this.forEachIdentifier(b,c,a.proxy(function(a,b){this.setDisabledState(a,!a.state.disabled,b)},this)),this.render()},g.prototype.forEachIdentifier=function(b,c,d){c=a.extend({},f.options,c),b instanceof Array||(b=[b]),a.each(b,a.proxy(function(a,b){d(this.identifyNode(b),c)},this))},g.prototype.identifyNode=function(a){return"number"==typeof a?this.nodes[a]:a},g.prototype.search=function(b,c){c=a.extend({},f.searchOptions,c),this.clearSearch({render:!1});var d=[];if(b&&b.length>0){c.exactMatch&&(b="^"+b+"$");var e="g";c.ignoreCase&&(e+="i"),d=this.findNodes(b,e),a.each(d,function(a,b){b.searchResult=!0})}return c.revealResults?this.revealNode(d):this.render(),this.$element.trigger("searchComplete",a.extend(!0,{},d)),d},g.prototype.clearSearch=function(b){b=a.extend({},{render:!0},b);var c=a.each(this.findNodes("true","g","searchResult"),function(a,b){b.searchResult=!1});b.render&&this.render(),this.$element.trigger("searchCleared",a.extend(!0,{},c))},g.prototype.findNodes=function(b,c,d){c=c||"g",d=d||"text";var e=this;return a.grep(this.nodes,function(a){var f=e.getNodeValue(a,d);return"string"==typeof f?f.match(new RegExp(b,c)):void 0})},g.prototype.getNodeValue=function(a,b){var c=b.indexOf(".");if(c>0){var e=a[b.substring(0,c)],f=b.substring(c+1,b.length);return this.getNodeValue(e,f)}return a.hasOwnProperty(b)?a[b].toString():d};var h=function(a){b.console&&b.console.error(a)};a.fn[e]=function(b,c){var d;return this.each(function(){var f=a.data(this,e);"string"==typeof b?f?a.isFunction(f[b])&&"_"!==b.charAt(0)?(c instanceof Array||(c=[c]),d=f[b].apply(f,c)):h("No such method : "+b):h("Not initialized, can not call method : "+b):"boolean"==typeof b?d=f:a.data(this,e,new g(this,a.extend(!0,{},b)))}),d||this}}(jQuery,window,document);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	var Organization = __webpack_require__(208);
	
	var RemoteSuggesterView = __webpack_require__(196);
	
	var CommonUtils = __webpack_require__(189);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var OrganizationForm = Marionette.View.extend({
	    tagName: 'form',
	    template: __webpack_require__(217),
	    model: new Organization(),
	
	    modelEvents: {
	        change: 'render'
	    },
	
	    regions: {
	        stateSelect: '#state-select'
	    },
	
	    ui: {
	        name: '#id-name',
	        addressField: '.address-field',
	        zip: '#zip',
	        address: '#address',
	        town: '#town',
	
	        created: '#creation-date',
	        npi: '#id-npi',
	        reviewPeriodDays: '#review-period-days',
	        reviewPeriodHours: '#review-period-hours',
	
	        progress: '#progress',
	        reRequest: '#re-request',
	        fillForm: '#fill-form'
	    },
	
	    events: {
	        'blur @ui.name': 'validate',
	        'keyup @ui.name': 'validate',
	
	        'keyup @ui.npi': 'onNpiChange',
	        'change @ui.npi': 'onNpiChange',
	        'keypress @ui.npi': 'onNpiKeyPress',
	
	        'keyup @ui.addressField': 'onAddressChange',
	        'change @ui.addressField': 'onAddressChange',
	
	        'click @ui.reRequest': 'onReRequest',
	        'click @ui.fillForm': 'onFormFill'
	    },
	
	    defaultValidatingResults: {
	        "id-name": false,
	        "npi": false
	    },
	
	    validatingResults: undefined,
	
	    tempNpi: '',
	    npiOrganizationData: undefined,
	
	    templateContext: function () {
	        var that = this;
	        var created = that.model.get('object').created;
	        return {
	            created: (created == '' || created == null || created == 0 ? ''
	                : that.utils.longToDateTimeFormatted(Number(created), 'MM/DD/YYYY')),
	            days: that.utils.getDaysValues(),
	            hours: that.utils.getHoursValues(),
	            isEditMode: that.isEditMode
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'fillModel', 'clearModel', 'validate');
	        this.model.on('change', this.render, this);
	
	        this.isEditMode = options.isEditMode;
	
	        this.utils = new CommonUtils();
	
	        this.validatingResults = _.clone(this.defaultValidatingResults);
	        if (this.model.get('name'))
	            this.validatingResults["id-name"] = true;
	        if (this.model.get('object').npi && this.utils.isValidNPI(this.model.get('object').npi) || _.isEmpty(this.model.get('object').npi))
	            this.validatingResults["npi"] = true;
	
	        this.addressesAndContactsFromNpi = {};
	        this.isAddressFieldFilledManually = true;
	
	        this.address = {
	            uuid: this.utils.generatedUUID(),
	            country: '',
	            state: '',
	            zip: '',
	            town: '',
	            address: '',
	            usage: 'WP',
	            source: 'MANUAL'
	        };
	    },
	
	    onRender: function () {
	        var that = this;
	
	        that.ui.created.datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	
	        that.ui.reviewPeriodDays.selectize({
	            allowEmptyOption: false,
	            placeholder: 'Days',
	            inputClass: 'form-control selectize-input'
	        });
	
	        that.ui.reviewPeriodHours.selectize({
	            allowEmptyOption: false,
	            placeholder: 'Hours',
	            inputClass: 'form-control selectize-input'
	        });
	
	        that.ui.progress.parent().hide();
	        that.ui.reRequest.parent().hide();
	        that.ui.fillForm.parent().hide();
	
	        if (that.utils.isValidNPI(that.ui.npi.val())) {
	            that.npiRequest(that.ui.npi.val());
	        } else {
	            that.ui.fillForm.prop('disabled', true);
	        }
	
	        if (!this.isEditMode)
	            this.showStateSelect();
	
	        that.checkSaveBtn();
	    },
	
	    showStateSelect: function () {
	        var that = this;
	
	        that.showChildView('stateSelect', new RemoteSuggesterView({
	            tag: 'state',
	            inputId: 'state',
	            maxNumberOfElements: 20,
	            url: '/api/reference/states/~~~',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getValueFn: function (element) {
	                return element;
	            },
	            classes: ["form-control", "address-field"],
	            placeholder: "Select state",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return arr[index] || null;
	            }
	        }));
	    },
	
	    fillModel: function () {
	
	        var that = this;
	        var object = this.model.get('object');
	        var contacts = object.contacts || [];
	        var addresses = object.addresses || [];
	        var representatives = object.representatives || [];
	        var ccrPermissions = object.ccrPermissions;
	        var ccdPermissions = object.ccdPermissions;
	
	        if (that.addressesAndContactsFromNpi.addresses && !_.isEmpty(that.addressesAndContactsFromNpi.addresses)) {
	            addresses = addresses.filter(function (address) {
	                return address.source != 'NPI';
	            });
	            that.addressesAndContactsFromNpi.addresses.forEach(function (address) {
	                addresses.push(address);
	            });
	        }
	        if (that.addressesAndContactsFromNpi.contacts && !_.isEmpty(that.addressesAndContactsFromNpi.contacts)) {
	            var preferredContacts = contacts.filter(function (contact) {
	                return contact.preferred === true;
	            });
	            contacts = contacts.filter(function (contact) {
	                return contact.source != 'NPI';
	            });
	            that.addressesAndContactsFromNpi.contacts.forEach(function (contact) {
	                if (contact.type === "FAX" && (preferredContacts.length == 0 || preferredContacts.filter(function (ctct) {
	                        return ctct.data === contact.data && contact.type === "FAX" && ctct.type === "FAX";
	                    }).length > 0)) {
	                    contact.preferred = true;
	                } else {
	                    contact.preferred = false;
	                }
	                contacts.push(contact);
	            });
	        }
	
	        if (!that.isEditMode && that.isAddressFieldFilledManually) {
	            that.address.source = "MANUAL";
	            addresses.push(that.address);
	        }
	
	        that.model.set({
	            name: that.ui.name.val(),
	            object: that.utils.mergeObjectsLeft(object, {
	                created: that.utils.dateToLong(that.ui.created.val()),
	                npi: that.ui.npi.val(),
	                contacts: contacts,
	                addresses: addresses,
	                representatives: representatives,
	                ccrPermissions: ccrPermissions,
	                ccdPermissions: ccdPermissions,
	                defaultReviewPeriod: {
	                    days: that.ui.reviewPeriodDays.val(),
	                    hours: that.ui.reviewPeriodHours.val()
	                }
	            })
	        }, {validate: true});
	
	        return this.model;
	    },
	
	    clearModel: function () {
	        this.model.set(this.model.defaults);
	        return this.model;
	    },
	
	    validatingFunctions: {
	        "id-name": function (value) {
	            if (value.length == 0)
	                return "Name should not be empty";
	            else return "";
	        }
	    },
	
	    validate: function (event) {
	        var jQelement = $(event.target);
	        this.validateBy(jQelement);
	    },
	
	    validateBy: function (jQelement) {
	        var value = jQelement.val();
	        var id = jQelement.attr('id');
	
	        var checkResult = this.validatingFunctions[id](value);
	
	        if (checkResult.length > 0) {
	            this.addErrorClass(jQelement);
	            this.addTooltip(jQelement, checkResult);
	            this.updateValidatingResults(id, false);
	        }
	        else {
	            this.removeErrorClass(jQelement);
	            this.removeTooltip(jQelement);
	            this.updateValidatingResults(id, true);
	        }
	    },
	
	    updateValidatingResults: function (name, value) {
	        this.validatingResults[name] = value;
	        this.checkSaveBtn();
	    },
	
	    addTooltip: function (jQelement, text) {
	        jQelement.tooltip({title: text});
	    },
	
	    removeTooltip: function (jQelement) {
	        jQelement.tooltip("destroy");
	    }
	    ,
	
	    addErrorClass: function (jQelement) {
	        jQelement.parent().parent().addClass('has-error has-feedback');
	    },
	
	    removeErrorClass: function (jQelement) {
	        jQelement.parent().parent().removeClass('has-error has-feedback');
	    },
	
	    checkSaveBtn: function () {
	        if (this.validatingResults["id-name"] && this.validatingResults["npi"]) {
	            this.triggerMethod('organization:save:valid', {result: true});
	        } else {
	            this.triggerMethod('organization:save:valid', {result: false});
	        }
	    },
	
	    onNpiChange: function (event) {
	        var that = this;
	        var value = event.target.value;
	        var tempIdOld = that.tempNpi;
	        that.tempNpi = value;
	
	        if (that.utils.isValidNPI(value) && tempIdOld != value) {
	            that.ui.fillForm.prop('disabled', false);
	            window.setTimeout(function () {
	                that.npiRequest(value);
	            }, 0);
	            return;
	        } else {
	            that.destroyFilledAddressesAndContacts();
	        }
	
	        if (_.isEmpty(value)) {
	            that.ui.npi.tooltip("destroy");
	            that.ui.npi.parent().removeClass('has-error has-feedback');
	            that.validatingResults["npi"] = true;
	            that.checkSaveBtn();
	            that.ui.fillForm.prop('disabled', true);
	            return;
	        }
	
	        if (!that.utils.isValidNPI(value)) {
	            that.ui.npi.tooltip({title: 'Invalid NPI'});
	            that.ui.npi.parent().addClass('has-error has-feedback');
	            that.validatingResults["npi"] = false;
	            that.checkSaveBtn();
	            that.ui.fillForm.prop('disabled', true);
	            return;
	        }
	    },
	
	    onNpiKeyPress: function (event) {
	        event = event || window.event;  // IE support
	        var ctrlDown = event.ctrlKey || event.metaKey;
	
	        return event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 37 || event.keyCode == 39 ||
	            ctrlDown || event.charCode >= 48 && event.charCode <= 57 && event.target.value.length < 10;
	    },
	
	    onReRequest: function () {
	        this.npiRequest(this.ui.npi.val());
	    },
	
	    npiRequest: function (value) {
	        var that = this;
	        that.onNpiRequestStart();
	        $.ajax({
	            type: "GET",
	            url: '/api/npi?type=NPI_2&number=' + value,
	            statusCode: {
	                200: function (response) {
	                    if (response.length == 0) {
	                        that.onNpiRequestFailure();
	                        that.npiOrganizationData = undefined;
	                    }
	                    else {
	                        that.onNpiRequestSuccess();
	                        that.npiOrganizationData = that.utils.organizationDataFromNpiData(response[0]);
	                        that.npiData = response[0];
	                    }
	                }
	            },
	            error: function (e) {
	                that.onNpiRequestEnd();
	                notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        });
	    },
	
	    onNpiRequestStart: function () {
	        this.ui.npi.parent().removeClass('col-xs-10 col-md-10');
	        this.ui.npi.parent().addClass('col-xs-7 col-md-7');
	        this.ui.progress.parent().show();
	        this.ui.reRequest.parent().hide();
	        this.ui.fillForm.parent().hide();
	        this.ui.fillForm.prop('disabled', true);
	        this.ui.npi.tooltip("destroy");
	        this.ui.npi.attr('disabled', true);
	    },
	
	    onNpiRequestSuccess: function () {
	        this.ui.progress.parent().hide();
	        this.ui.reRequest.parent().hide();
	        this.ui.fillForm.parent().show();
	        this.ui.fillForm.prop('disabled', false);
	        this.ui.npi.tooltip({title: 'Organization with NPI found'});
	        this.ui.npi.parent().removeClass('has-error has-feedback');
	        this.ui.npi.removeAttr('disabled');
	        this.validatingResults["npi"] = true;
	        this.checkSaveBtn();
	    },
	
	    onNpiRequestFailure: function () {
	        this.ui.progress.parent().hide();
	        this.ui.reRequest.parent().show();
	        this.ui.fillForm.parent().hide();
	        this.ui.fillForm.prop('disabled', true);
	        this.ui.npi.tooltip({title: 'Organization with NPI found'});
	        this.ui.npi.parent().addClass('has-error has-feedback');
	        this.ui.npi.removeAttr('disabled');
	        this.validatingResults["npi"] = false;
	        this.checkSaveBtn();
	    },
	
	    onNpiRequestEnd: function () {
	        this.ui.npi.parent().removeClass('col-xs-7 col-md-7');
	        this.ui.npi.parent().addClass('col-xs-10 col-md-10');
	        this.ui.progress.parent().hide();
	        this.ui.reRequest.parent().hide();
	        this.ui.fillForm.prop('disabled', true);
	        this.ui.npi.tooltip("destroy");
	        this.ui.npi.removeAttr('disabled');
	        this.validatingResults["npi"] = false;
	        this.checkSaveBtn();
	    },
	
	    onFormFill: function () {
	        this.ui.name.val(this.npiOrganizationData["name"]);
	        this.validateBy(this.ui.name);
	        if (this.npiOrganizationData["createdDT"]) {
	            this.ui.created.datepicker('update', this.utils.longToDateTimeFormatted(this.npiOrganizationData["createdDT"], 'MM/DD/YYYY'));
	        }
	        if (!this.isEditMode) {
	            var addressObject = this.npiOrganizationData['address'];
	            this.ui.zip.val(addressObject.zip);
	            this.ui.address.val(addressObject.address);
	            this.ui.town.val(addressObject.town);
	            $('#state').val(addressObject.state);
	            this.address.zip = addressObject.zip;
	            this.address.address = addressObject.address;
	            this.address.town = addressObject.town;
	            this.address.state = addressObject.state;
	
	            this.isAddressFieldFilledManually = false;
	        }
	
	        this.fillAddressesAndContactsFromNpi();
	        notificationsChannel.request('show:notification', {
	            message: 'Profile is filled with data from NPI registry',
	            code: 200
	        });
	    },
	
	    destroyFilledAddressesAndContacts: function () {
	        this.addressesAndContactsFromNpi = {};
	    },
	
	    fillAddressesAndContactsFromNpi: function () {
	        this.addressesAndContactsFromNpi = this.utils.addressesAndContactsFromNpiData(this.npiData);
	    },
	
	    onAddressChange: function (event) {
	        this.address[event.target.id] = event.target.value;
	        this.isAddressFieldFilledManually = true;
	    }
	
	});
	
	module.exports = OrganizationForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form-horizontal">\n    <div>\n        <div class="form-group">\n            <label class="col-xs-2 col-md-2 control-label" for="id-npi">NPI</label>\n            <div class="col-xs-10 col-md-10">\n                <input class="form-control" type="text" id="id-npi" placeholder="NPI" value="'+
	((__t=( object.npi ))==null?'':_.escape(__t))+
	'">\n            </div>\n            <div class="col-xs-2 col-md-2">\n                <label id="progress"><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>\n                    Request...</label>\n            </div>\n            <div class="col-xs-2 col-md-2">\n                <button type="button" class="btn btn-primary" id="re-request">Re-request</button>\n            </div>\n            <div class="col-xs-2 col-md-2">\n                <button type="button" class="btn btn-primary" id="fill-form">Fill form</button>\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-xs-2 col-md-2 control-label" for="id-name">Name</label>\n            <div class="col-xs-10 col-md-10">\n                <input class="form-control" type="text" id="id-name" placeholder="Organization name"\n                       value="'+
	((__t=( name ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n        ';
	 if (!isEditMode) { 
	__p+='\n        <div class="form-group">\n            <label class="col-xs-2 col-md-2 control-label">Address</label>\n            <div class="col-xs-3 col-md-3">\n                <input class="form-control address-field" type="text" id="town" placeholder="Town" required=""/>\n            </div>\n            <div class="col-xs-4 col-md-4">\n                <div id="state-select"></div>\n            </div>\n            <div class="col-xs-3 col-md-3">\n                <input class="form-control address-field" type="text" id="zip" placeholder="Zip code" required=""/>\n            </div>\n        </div>\n        <div class="form-group">\n            <div class="col-md-offset-2 col-xs-offset-2 col-xs-10 col-md-10">\n                <input class="form-control address-field" type="text" id="address" placeholder="Address line" required=""/>\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n\n        <div class="form-group">\n            <label class="col-xs-2 col-md-2 control-label" for="creation-date">Creation date</label>\n            <div class="col-xs-10 col-md-10">\n                <input class="form-control" type="text" id="creation-date" placeholder="Creation date"\n                       value="'+
	((__t=( created ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-2 col-md-2 control-label">Review period</label>\n            <label class="col-xs-1 col-md-1 control-label" for="review-period-days">Days</label>\n            <div class="col-xs-2 col-md-2">\n                <select id="review-period-days">\n                    ';
	 _.each(days, function(day){ 
	__p+='\n                    ';
	 if (object.defaultReviewPeriod && object.defaultReviewPeriod.days && object.defaultReviewPeriod.days === day) { 
	__p+='\n                    <option value="'+
	((__t=( day ))==null?'':__t)+
	'" name="'+
	((__t=( day ))==null?'':__t)+
	'" selected> '+
	((__t=( day ))==null?'':__t)+
	'</option>\n                    ';
	 } else if (day === 3 && !object.defaultReviewPeriod) { 
	__p+='\n                    <option value="'+
	((__t=( day ))==null?'':__t)+
	'" name="'+
	((__t=( day ))==null?'':__t)+
	'" selected> '+
	((__t=( day ))==null?'':__t)+
	'</option>\n                    ';
	 } else { 
	__p+='\n                    <option value="'+
	((__t=( day ))==null?'':__t)+
	'" name="'+
	((__t=( day ))==null?'':__t)+
	'"> '+
	((__t=( day ))==null?'':__t)+
	'</option>\n                    ';
	 } 
	__p+='\n                    ';
	 }) 
	__p+='\n                </select>\n            </div>\n            <label class="col-xs-1 col-md-1 control-label" for="review-period-hours">Hours</label>\n            <div class="col-xs-2 col-md-2">\n                <select id="review-period-hours">\n                    ';
	 _.each(hours, function(hour){ 
	__p+='\n                    ';
	 if (object.defaultReviewPeriod && object.defaultReviewPeriod.hours && object.defaultReviewPeriod.hours === hour) { 
	__p+='\n                    <option value="'+
	((__t=( hour ))==null?'':__t)+
	'" name="'+
	((__t=( hour ))==null?'':__t)+
	'" selected> '+
	((__t=( hour ))==null?'':__t)+
	'</option>\n                    ';
	 } else if (hour === 0) { 
	__p+='\n                    <option value="'+
	((__t=( hour ))==null?'':__t)+
	'" name="'+
	((__t=( hour ))==null?'':__t)+
	'" selected> '+
	((__t=( hour ))==null?'':__t)+
	'</option>\n                    ';
	 } else { 
	__p+='\n                    <option value="'+
	((__t=( hour ))==null?'':__t)+
	'" name="'+
	((__t=( hour ))==null?'':__t)+
	'"> '+
	((__t=( hour ))==null?'':__t)+
	'</option>\n                    ';
	 } 
	__p+='\n                    ';
	 }) 
	__p+='\n                </select>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	
	var OrganizationsCollection = BaseCollection.extend({
	    url:"/api/organization/preview",
	
	    initialize: function(options) {
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    }
	});
	
	
	module.exports = OrganizationsCollection;

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row">\n    <div class="col-xs-10 col-md-6">\n        <div class="row">\n            <div class="col-xs-3 col-md-6">\n                <h2>Organizations</h2>\n            </div>\n            <div class="col-xs-1 col-md-1 filter">\n                <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#addOrganizationModal">+</button>\n            </div>\n            <div class="col-xs-4 col-md-5 filter">\n                <form><input class="form-control" type="text" id="filter" placeholder="Filter"></form>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class="loading"></div>\n\n<div class="row">\n    <div id="tree" class="col-xs-10 col-md-6"></div>\n</div>\n\n<!-- Modal -->\n<div class="modal fade" id="addOrganizationModal" tabindex="-1" role="dialog" aria-labelledby="addOrganizationModalLabel">\n    <div class="modal-dialog" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title" id="addOrganizationModalLabel">Add organization</h4>\n            </div>\n            <div class="modal-body">\n                <div id="form"></div>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>\n                <button type="button" class="btn btn-primary" id="save-organization" data-dismiss="modal" disabled>Save changes</button>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(215);
	var Marionette = __webpack_require__(180);
	
	var RelationsFormView = __webpack_require__(221);
	var OrganizationDataView = __webpack_require__(232);
	var RelationsListView = __webpack_require__(234);
	var PermissionsTableView = __webpack_require__(236);
	
	var OrganizationForm = __webpack_require__(216);
	var Organization = __webpack_require__(208);
	var DeleteConfirmationModal = __webpack_require__(241);
	var PermissionFormView = __webpack_require__(243);
	
	var RelationsCollection = __webpack_require__(248);
	var PermissionsCollection = __webpack_require__(249);
	
	var CommonUtils = __webpack_require__(189);
	
	var ContactsTableView = __webpack_require__(250);
	var ContactsCollection = __webpack_require__(253);
	var ContactFormView = __webpack_require__(254);
	
	var AddressTableView = __webpack_require__(256);
	var AddressesFormView = __webpack_require__(259);
	
	var RepresentativesTableView = __webpack_require__(261);
	var RepresentativeFormView = __webpack_require__(264);
	
	var CommentFormView = __webpack_require__(266);
	var CommentsTableView = __webpack_require__(268);
	
	var MedProfileImportSettingsForm = __webpack_require__(272);
	
	var ExternalIdsView = __webpack_require__(274);
	var OrganizationPersonsView = __webpack_require__(276);
	
	var Radio = __webpack_require__(183);
	var sessionChannel = Radio.channel('session');
	var notificationsChannel = Radio.channel('notifications');
	
	var OrganizationView = Marionette.View.extend({
	    template: __webpack_require__(284),
	    model: new Organization(),
	    regions: {
	        organizationData: '#organization-data',
	        organizationForm: '#organization-form',
	        editSection: '#edit-section',
	        organizationRelations: '#organization-relations',
	        addOrganizationRelation: '#add-organization-relation',
	        personRelations: '#person-relations',
	        addPersonRelation: '#add-person-relation',
	        deleteOrganizationConfirmationModal: '.delete-confirmation-modal',
	        permissions: '#permissions',
	        addPermission: '#add-permission',
	        contacts: '#contacts',
	        contactForm: '#contact-form',
	        addresses: '#addresses',
	        addressForm: '#address-form',
	        representatives: '#representatives',
	        representativeForm: '#representative-form',
	        comments: '#comments',
	        addComment: '#add-comment',
	        organizationImportSettings: '#organization-import-settings-content',
	        externalsIdsRegion: '#external-ids',
	        personsRegion: '#persons'
	    },
	
	    ui: {
	        organizationEdit: '#organization-data',
	        saveBtn: '#save-organization',
	        contactForm: '#contact-form',
	        commentsCount: '#comments-count',
	        commentsContainer: '#comments-list'
	    },
	
	    events: {
	        'click #edit-data': 'toggleEdit',
	        'click #cancel-edit': 'toggleEdit',
	        'click #save-organization': 'saveChanges',
	        'click #remove-organization': 'removeOrganisation',
	        'comment:count:changed': 'onCommentCountChanged'
	    },
	
	    childViewEvents: {
	        'relation:saved': 'relationSaved',
	        'delete:confirmed': 'deleteConfirmed',
	        'permission:saved': 'permissionSaved',
	        'on:contact:action': 'onContactAction',
	        'on:contact:saved': 'onContactSaved',
	        'on:address:action': 'onAddressAction',
	        'on:address:saved': 'onAddressSaved',
	        'on:representative:action': 'onRepresentativeAction',
	        'on:representative:saved': 'onRepresentativeSaved',
	        'organization:save:valid': 'saveOrganizationBtnEnableOrDisable',
	        'contact:hover': 'onContactHover',
	        'address:hover': 'onAddressHover',
	        'representative:hover': 'onRepresentativeHover',
	        'comment:added': 'onCommentAdded',
	        'comment:count:changed': 'onCommentCountChanged',
	        'on:cancel:comment:send': 'onCancelCommentSend',
	        'on:edit:comment': 'onEditComment',
	        'comment:updated': 'onCommentUpdated',
	        'on:new:comment': 'onNewComment',
	
	        'save:import:settings': 'onSaveImportSettings',
	        'cancel:import:settings': 'onCancelImportSettings',
	
	        'on:save:externalids': 'onSaveExternalIds',
	        'on:cancel:externalids': 'onCancelExternalIds'
	    },
	
	    userCanEdit: undefined,
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'renderOrg', 'toggleEdit', 'saveChanges', 'removeOrganisation', 'relationSaved',
	            'deleteConfirmed', 'permissionSaved', 'renderContacts', 'renderContactForm', 'onContactAction', 'onContactSaved',
	            'renderPermissionsListView', 'saveOrganizationBtnEnableOrDisable', 'onContactHover', 'onAddressHover',
	            'onAddressAction', 'onAddressSaved', 'onCommentAdded', 'onCommentCountChanged', 'onSaveImportSettings', 'onCancelImportSettings', 'canEdit');
	        this.permissions = sessionChannel.request('get:permissions');
	        this.model = options.model;
	        this.byAdmin = options.byAdmin;
	        this.user = options.user;
	        this.commonUtil = new CommonUtils();
	    },
	
	    onRender: function () {
	        window.document.title = this.model.get("name");
	        this.renderOrg();
	        this.initEvents();
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            canEdit: that.canEdit,
	            byAdmin: this.byAdmin
	        }
	    },
	
	
	    renderOrg: function () {
	        this.organizationForm = new OrganizationForm({
	            model: this.model,
	            isEditMode: true
	        });
	        this.personRelationsCollection = new RelationsCollection(this.model.get('relations').filter(function (item) {
	            return item.type.childType === 'person';
	        }));
	        this.orgRelationsCollection = new RelationsCollection(this.model.get('relations').filter(function (item) {
	            return item.type.childType === 'organization';
	        }));
	
	        this.showChildView('organizationData', new OrganizationDataView({
	            model: this.model,
	            canEdit: this.canEdit(),
	            byAdmin: this.byAdmin,
	            user: this.user
	        }));
	        this.showChildView('organizationForm', this.organizationForm);
	
	        //Organization relations
	        this.orgRelationsList = new RelationsListView({collection: this.orgRelationsCollection});
	        this.showChildView('organizationRelations', this.orgRelationsList);
	
	        this.orgRelationsFormView = new RelationsFormView({parentId: this.model.id, childrenTypes: ['organization']});
	        this.showChildView('addOrganizationRelation', this.orgRelationsFormView);
	
	        //Person relations
	        this.personRelationsList = new RelationsListView({collection: this.personRelationsCollection});
	        this.showChildView('personRelations', this.personRelationsList);
	
	        this.personRelationsFormView = new RelationsFormView({
	            parentId: this.model.id,
	            childrenTypes: ['person'],
	            parentTypes: ['organization']
	        });
	        this.showChildView('addPersonRelation', this.personRelationsFormView);
	
	        this.deleteOrganizationConfirmationModal =
	            new DeleteConfirmationModal({
	                message: 'Enter: "confirm" if you agree to remove the organization.',
	                confirmationAnswer: 'confirm'
	            });
	        this.showChildView('deleteOrganizationConfirmationModal', this.deleteOrganizationConfirmationModal);
	
	        this.renderContacts();
	        this.renderAddresses();
	        this.renderRepresentatives();
	        this.renderPersons(this.model);
	
	        if (this.canEdit()) {
	            this.permissionsCollection = new PermissionsCollection([], {
	                params: [{
	                    key: 'permittedObjectId',
	                    value: this.model.id
	                }]
	            });
	            this.renderPermissionsListView(this.permissionsCollection);
	
	            this.permissionFormView = new PermissionFormView({
	                'permittedObjectId': this.model.id,
	                showOrganization: true,
	                permittedObjectType: 'organization'
	            });
	            this.showChildView('addPermission', this.permissionFormView);
	
	            this.commentModel = new Backbone.Model({
	                id: undefined,
	                text: undefined
	            });
	
	            this.showChildView('comments', new CommentsTableView({
	                dboId: this.model.get('id'),
	                canEdit: this.canEdit()
	            }));
	
	            this.renderCommentForm();
	        }
	
	        if (this.byAdmin) {
	            this.renderImportSettings();
	            this.renderExternalIdsView(this.model.get('object').externalIds || []);
	        }
	    },
	
	    renderImportSettings: function () {
	        this.showChildView('organizationImportSettings', new MedProfileImportSettingsForm({
	            ccrPermissions: this.model.get('object').ccrPermissions,
	            ccdPermissions: this.model.get('object').ccdPermissions
	        }));
	    },
	
	    renderCommentForm: function (model) {
	        this.showChildView('addComment', new CommentFormView({
	            dboId: this.model.get('id'),
	            model: model ? model : new Backbone.Model({
	                id: undefined,
	                text: undefined
	            })
	        }));
	    },
	
	    initEvents: function () {
	        this.triggerMethod('comment:count:changed');
	    },
	
	    renderPermissionsListView: function (collection) {
	        this.permissionsListView = new PermissionsTableView({
	            collection: collection,
	            showOrganization: true,
	            permittedObjectType: 'organization'
	        });
	        this.showChildView('permissions', this.permissionsListView);
	    },
	
	    renderExternalIdsView: function (externalIds) {
	        this.externalIdsView = new ExternalIdsView({
	            externalIds: _.clone(externalIds)
	        });
	        this.showChildView('externalsIdsRegion', this.externalIdsView);
	    },
	
	    toggleEdit: function () {
	        this.ui.organizationEdit.toggle();
	        $('#edit-section').toggle();
	    },
	
	    saveChanges: function () {
	        var that = this;
	        that.model = that.organizationForm.fillModel();
	        that.model.save(that.model.toJSON(), {
	            success: function (response) {
	                that.toggleEdit();
	                that.renderContacts();
	                that.renderAddresses();
	                that.renderRepresentatives();
	            },
	            error: function (model, xhr, options) {
	                notificationsChannel.request('show:notification', JSON.parse(xhr.responseText));
	            }
	        });
	    },
	
	    removeOrganisation: function () {
	        this.$('#delete-confirmation-modal').modal();
	    },
	
	    relationSaved: function (data) {
	        var entityType = data.get('type').childType;
	        if (entityType === 'person') {
	            this.personRelationsCollection.add(data);
	            this.showChildView('addPersonRelation', new RelationsFormView({
	                parentId: this.model.id,
	                childrenTypes: ['person'],
	                parentTypes: ['organization']
	            }));
	        }
	        else {
	            this.orgRelationsCollection.add(data);
	            this.showChildView('addOrganizationRelation', new RelationsFormView({
	                parentId: this.model.id,
	                childrenTypes: ['organization']
	            }));
	        }
	    },
	
	    permissionSaved: function (model) {
	        this.renderPermissionsListView(this.permissionsCollection);
	    },
	
	    deleteConfirmed: function (value) {
	        if (value == true) {
	            var that = this;
	            this.model.destroy({
	                dataType: "text",
	                success: function () {
	                    that.remove();
	                    that.unbind();
	                    Backbone.history.navigate('/', {
	                        trigger: true
	                    });
	                }
	            });
	        }
	    },
	
	    canEdit: function () {
	        if (!this.userCanEdit) {
	            this.userCanEdit = this.commonUtil.userCanDo(this.permissions,
	                function (permission) {
	                    return permission.canWriteFor;
	                },
	                this.model.get('permissions'),
	                function (permission) {
	                    return permission.canWrite;
	                }
	            );
	        }
	        return this.userCanEdit;
	    },
	
	    renderContacts: function () {
	        this.contactsView = new ContactsTableView({
	            collection: new ContactsCollection(this.model.get('object').contacts),
	            canEdit: this.canEdit()
	        });
	        this.showChildView("contacts", this.contactsView);
	    },
	
	    renderAddresses: function () {
	        this.addressesView = new AddressTableView({
	            collection: new ContactsCollection(this.model.get('object').addresses),
	            canEdit: this.canEdit()
	        });
	        this.showChildView("addresses", this.addressesView);
	    },
	
	    renderRepresentatives: function () {
	        this.representativesView = new RepresentativesTableView({
	            collection: new ContactsCollection(this.model.get('object').representatives),
	            canEdit: this.canEdit()
	        });
	        this.showChildView("representatives", this.representativesView);
	    },
	
	    renderPersons: function (model) {
	        this.personsView = new OrganizationPersonsView({
	            organizationModel: model,
	            canEdit: this.canEdit()
	        });
	        this.showChildView('personsRegion', this.personsView);
	    },
	
	    renderContactForm: function (mode, contact) {
	        this.ui.contactForm.show();
	        if (mode == 'add') {
	            this.contactFormView = new ContactFormView({
	                mode: mode,
	                addresses: this.model.get('object').addresses || [],
	                representatives: this.model.get('object').representatives || []
	            });
	            this.showChildView("contactForm", this.contactFormView);
	        }
	        else if (mode == 'edit') {
	            this.contactFormView = new ContactFormView({
	                mode: mode,
	                contact: contact,
	                addresses: this.model.get('object').addresses || [],
	                representatives: this.model.get('object').representatives || []
	            });
	            this.showChildView("contactForm", this.contactFormView);
	        }
	    },
	
	    renderAddressForm: function (mode, address) {
	        if (mode == 'add') {
	            this.addressFormView = new AddressesFormView({
	                mode: mode
	            });
	            this.showChildView("addressForm", this.addressFormView);
	        }
	        else if (mode == 'edit') {
	            this.addressFormView = new AddressesFormView({
	                mode: mode,
	                address: address
	            });
	            this.showChildView("addressForm", this.addressFormView);
	        }
	    },
	
	    renderRepresentativeForm: function (mode, representative) {
	        if (mode == 'add') {
	            this.representativeFormView = new RepresentativeFormView({
	                mode: mode
	            });
	            this.showChildView("representativeForm", this.representativeFormView);
	        }
	        else if (mode == 'edit') {
	            this.representativeFormView = new RepresentativeFormView({
	                mode: mode,
	                representative: representative
	            });
	            this.showChildView("representativeForm", this.representativeFormView);
	        }
	    },
	
	    removeContactForm: function () {
	        this.ui.contactForm.hide();
	        this.detachChildView('contactForm');
	    },
	
	    removeAddressForm: function () {
	        this.detachChildView('addressForm');
	    },
	
	    removeRepresentativeForm: function () {
	        this.detachChildView('representativeForm');
	    },
	
	    onContactAction: function (data) {
	        var that = this;
	        if (data.mode == 'add') {
	            that.renderContactForm(data.mode);
	        }
	        else if (data.mode == 'delete') {
	            var willBeRemoveContact = data.data.attributes;
	            that.model.get('object').contacts = (that.model.get('object').contacts || []).filter(function (contact) {
	                return contact.data !== willBeRemoveContact.data
	                    || contact.type !== willBeRemoveContact.type
	                    || contact.preferred !== willBeRemoveContact.preferred;
	            });
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderContacts();
	                }
	            });
	        }
	        else if (data.mode == 'edit') {
	            var willBeEditedContact = data.data.attributes;
	            var willEditContact = (that.model.get('object').contacts || []).filter(function (contact) {
	                return contact.data == willBeEditedContact.data
	                    && contact.type == willBeEditedContact.type
	                    && contact.preferred == willBeEditedContact.preferred;
	            });
	            this.renderContactForm(data.mode, willEditContact[0]);
	        }
	        else if (data.mode == 'cancel') {
	            that.removeContactForm();
	        } else if (data.mode == 'save') {
	            var changedContact = data.data.attributes;
	            (that.model.get('object').contacts || []).forEach(function (contact) {
	                if (contact.data == changedContact.data
	                    && contact.type == changedContact.type) {
	                    contact.preferred = changedContact.preferred;
	                }
	            });
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderContacts();
	                }
	            });
	        }
	    },
	
	    onContactSaved: function (data) {
	        var that = this;
	        if (data.mode == 'add') {
	            that.model.get('object').contacts = (that.model.get('object').contacts || []).filter(function (contact) {
	                return contact.data !== data.contact.data
	                    || contact.type !== data.contact.type
	                    || contact.preferred !== data.contact.preferred;
	            });
	            that.model.get('object').contacts.push(data.contact);
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderContacts();
	                    that.removeContactForm();
	                }
	            });
	        } else if (data.mode == 'edit') {
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderContacts();
	                    that.removeContactForm();
	                }
	            });
	        }
	    },
	
	    onAddressAction: function (data) {
	        var that = this;
	        if (data.mode == 'add') {
	            that.renderAddressForm(data.mode);
	        }
	        else if (data.mode == 'delete') {
	            var willBeRemovedAddress = data.data.attributes;
	            that.model.get('object').addresses = (that.model.get('object').addresses || []).filter(function (address) {
	                return address.uuid !== willBeRemovedAddress.uuid;
	            });
	            that.model.get('object').contacts.forEach(function (contact) {
	                contact.addresses = (contact.addresses || []).filter(function (addressUuid) {
	                    return addressUuid != willBeRemovedAddress.uuid;
	                })
	            });
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderAddresses();
	                    that.renderContacts();
	                }
	            });
	        }
	        else if (data.mode == 'edit') {
	            var willBeEditedAddress = data.data.attributes;
	            var willEditAddress = (that.model.get('object').addresses || []).filter(function (address) {
	                return address.uuid == willBeEditedAddress.uuid;
	            });
	            this.renderAddressForm(data.mode, willEditAddress[0]);
	        }
	        else if (data.mode == 'cancel') {
	            that.removeAddressForm();
	        }
	    },
	
	    onAddressSaved: function (data) {
	        var that = this;
	        if (data.mode == 'add') {
	            that.model.get('object').addresses = (that.model.get('object').addresses || []).filter(function (address) {
	                return address !== null && address.uuid !== data.address.uuid;
	            });
	            that.model.get('object').addresses.push(data.address);
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderAddresses();
	                    that.renderContacts();
	                    that.removeAddressForm();
	                }
	            });
	        } else if (data.mode == 'edit') {
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderAddresses();
	                    that.renderContacts();
	                    that.removeAddressForm();
	                }
	            });
	        }
	    },
	
	    onRepresentativeAction: function (data) {
	        var that = this;
	        if (data.mode == 'add') {
	            that.renderRepresentativeForm(data.mode);
	        }
	        else if (data.mode == 'delete') {
	            var willBeRemovedRepresentative = data.data.attributes;
	            that.model.get('object').representatives = (that.model.get('object').representatives || []).filter(function (representative) {
	                return representative.uuid !== willBeRemovedRepresentative.uuid;
	            });
	            that.model.get('object').contacts.forEach(function (contact) {
	                contact.representatives = (contact.representatives || []).filter(function (representativeUuid) {
	                    return representativeUuid != willBeRemovedRepresentative.uuid;
	                })
	            });
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderRepresentatives();
	                    that.renderContacts();
	                }
	            });
	        }
	        else if (data.mode == 'edit') {
	            var willBeEditedRepresentative = data.data.attributes;
	            var willEditRepresentative = (that.model.get('object').representatives || []).filter(function (representative) {
	                return representative.uuid == willBeEditedRepresentative.uuid;
	            });
	            this.renderRepresentativeForm(data.mode, willEditRepresentative[0]);
	        }
	        else if (data.mode == 'cancel') {
	            that.removeRepresentativeForm();
	        }
	    },
	
	    onRepresentativeSaved: function (data) {
	        var that = this;
	        if (data.mode == 'add') {
	            that.model.get('object').representatives = (that.model.get('object').representatives || []).filter(function (representative) {
	                return representative !== null && representative.uuid !== data.representative.uuid;
	            });
	            that.model.get('object').representatives.push(data.representative);
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderRepresentatives();
	                    that.renderContacts();
	                    that.removeRepresentativeForm();
	                }
	            });
	        } else if (data.mode == 'edit') {
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderRepresentatives();
	                    that.renderContacts();
	                    that.removeRepresentativeForm();
	                }
	            });
	        }
	    },
	
	    onContactHover: function (data) {
	
	        $('.address-row').each(function () {
	            $(this).children().each(function () {
	                $(this).removeClass('hovered-contact-marked');
	            });
	        });
	
	        $('.representative-row').each(function () {
	            $(this).children().each(function () {
	                $(this).removeClass('hovered-contact-marked');
	            });
	        });
	
	        (data.addresses || []).forEach(function (addressUuid) {
	            $('.' + addressUuid).each(function () {
	                if (data.hovered) {
	                    $(this).addClass('hovered-contact-marked');
	                } else {
	                    $(this).removeClass('hovered-contact-marked');
	                }
	            });
	        });
	
	        (data.representatives || []).forEach(function (representativeUuid) {
	            $('.' + representativeUuid).each(function () {
	                if (data.hovered) {
	                    $(this).addClass('hovered-contact-marked');
	                } else {
	                    $(this).removeClass('hovered-contact-marked');
	                }
	            });
	        });
	    },
	
	    onAddressHover: function (event) {
	
	        $('.contact-row').each(function () {
	            $(this).removeClass('hovered-contact-marked');
	        });
	
	        this.model.get('object').contacts.forEach(function (contact, index) {
	            if ((contact.addresses || []).indexOf(event.uuid) > -1) {
	                if (event.hovered) {
	                    $($('.contact-row')[index]).addClass('hovered-contact-marked');
	                } else {
	                    $($('.contact-row')[index]).removeClass('hovered-contact-marked');
	                }
	            }
	        })
	    },
	
	    onRepresentativeHover: function (event) {
	
	        $('.contact-row').each(function () {
	            $(this).removeClass('hovered-contact-marked');
	        });
	
	        this.model.get('object').contacts.forEach(function (contact, index) {
	            if ((contact.representatives || []).indexOf(event.uuid) > -1) {
	                if (event.hovered) {
	                    $($('.contact-row')[index]).addClass('hovered-contact-marked');
	                } else {
	                    $($('.contact-row')[index]).removeClass('hovered-contact-marked');
	                }
	            }
	        });
	    },
	
	    saveOrganizationBtnEnableOrDisable: function (data) {
	        if (data.result)
	            this.ui.saveBtn.removeAttr("disabled");
	        else
	            this.ui.saveBtn.attr("disabled", "true");
	    },
	
	    onCommentAdded: function (commentModel) {
	        this.getChildView('comments').add(commentModel);
	        this.renderCommentForm();
	    },
	
	    onCommentUpdated: function (commentModel) {
	        this.getChildView('comments').update(commentModel);
	        this.renderCommentForm();
	    },
	
	    onCommentCountChanged: function () {
	        var that = this;
	
	        $.ajax({
	            type: "GET",
	            url: '/api/comment/' + that.model.get('id') + '/count',
	            statusCode: {
	                200: function (response) {
	                    that.ui.commentsCount.text(response);
	                    if (typeof that.getChildView('comments') != 'undefined') {
	                        that.getChildView('comments').syncWithCount(response);
	                    }
	                }
	            },
	            error: function (e) {
	                console.log(e);
	            }
	        });
	    },
	
	    onCancelCommentSend: function () {
	        this.renderCommentForm();
	    },
	
	    onEditComment: function (model) {
	        var that = this;
	        that.renderCommentForm(model);
	        $('html, body').animate({scrollTop: $(document).height()}, 'slow');
	    },
	
	    onNewComment: function () {
	        this.renderCommentForm();
	        $('html, body').animate({scrollTop: $(document).height()}, 'slow');
	    },
	
	    onSaveImportSettings: function (data) {
	        var that = this;
	        var originalCcrPermissions = _.clone(that.model.get('object').ccrPermissions);
	        var originalCcdPermissions = _.clone(that.model.get('object').ccdPermissions);
	        that.model.get('object').ccrPermissions = data.ccrPermissions;
	        that.model.get('object').ccdPermissions = data.ccdPermissions;
	        that.model.save(that.model.toJSON(), {
	            success: function (response) {
	                $.notify("Import settings updated successfully", "success");
	                that.renderImportSettings();
	            },
	            error: function (model, xhr, options) {
	                that.model.get('object').ccrPermissions = originalCcrPermissions;
	                that.model.get('object').ccdPermissions = originalCcdPermissions;
	                notificationsChannel.request('show:notification', JSON.parse(xhr.responseText));
	            }
	        });
	    },
	
	    onCancelImportSettings: function () {
	        this.renderImportSettings();
	    },
	
	
	    onSaveExternalIds: function (data) {
	        var that = this;
	        var idsList = data.externalIds;
	        var doSave = data.doSave;
	
	        if (doSave) {
	            that.model.get('object').externalIds = _.reject(idsList, function (id) {
	                return _.isEmpty(id);
	            });
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderExternalIdsView(that.model.get('object').externalIds || []);
	                    $.notify("External ids saved successfully", "success");
	                },
	                error: function (collection, response, options) {
	                    if (response.status == 401) {
	                        actionsChannel.request("redirect:to:login");
	                    } else {
	                        notificationsChannel.request('show:notification', JSON.parse(xhr.responseText));
	                    }
	                }
	            });
	        } else {
	            that.renderExternalIdsView(idsList);
	        }
	    },
	
	    onCancelExternalIds: function () {
	        this.renderExternalIdsView(this.model.get('object').externalIds || []);
	    }
	});
	
	module.exports = OrganizationView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var RelationsTypesSelectView = __webpack_require__(222);
	var EntitiesSelectView = __webpack_require__(226);
	var RelationModel = __webpack_require__(230);
	
	var RelationsFormView = Marionette.View.extend({
	    template: __webpack_require__(231),
	    regions:{
	        types: "#types-container",
	        entities: "#entities-container"
	    },
	
	    childViewEvents:{
	        'type:selected': 'typeSelected',
	        'entity:selected': 'entitySelected'
	    },
	
	    events:{
	        'click #save-relation': 'saveRelation'
	    },
	
	    initialize: function(options){
	        this.model = new RelationModel();
	        _.bindAll(this, 'onRender', 'typeSelected', 'entitySelected', 'saveRelation',
	            'afterUpdate', 'afterFetchedUpdated');
	        if (options){
	            this.reversed = options.reversed;
	            this.parentId = options.parentId;
	            this.model.set('parentId', options.parentId);
	            if (options.type){
	                this.model.set('type', {
	                    id: options.type
	                });
	            }
	            if (options.entity){
	                this.entityId = options.entity;
	                this.model.set('child', {
	                    id: options.entity
	                });
	            }
	            this.relationTypes = options.relationTypes || [];
	            this.childrenTypes = options.childrenTypes || [];
	            this.parentTypes = options.parentTypes || [];
	        }
	
	        this.model.view = this;
	        this.model.bind("validated", this.validated);
	    },
	
	    validated: function(valid) {
	        var saveBtn = this.view.$('#save-relation');
	        if (valid){
	            saveBtn.removeAttr("disabled");
	        } else {
	            saveBtn.attr("disabled", "true");
	        }
	    },
	
	    onRender: function(){
	        this.relationTypeSelectView = new RelationsTypesSelectView({
	            type: this.type,
	            relationTypes: this.relationTypes,
	            childrenTypes: this.childrenTypes,
	            parentTypes: this.parentTypes,
	            reversed: this.reversed
	        });
	        this.showChildView('types', this.relationTypeSelectView);
	    },
	
	    typeSelected: function (data) {
	        this.model.set('type', {
	            id: data.relationType
	        });
	        this.entitiesSelectView = new EntitiesSelectView({entityType: data.entityType});
	        this.showChildView('entities', this.entitiesSelectView);
	    },
	
	    entitySelected: function (data) {
	        if (this.reversed){
	            this.parentId = data.id;
	            this.model.set('parentId', data.id);
	            this.selectedName = data.name;
	        } else{
	            this.model.set('child', {
	                id: data.id
	            });
	        }
	    },
	
	    saveRelation: function(){
	        this.model.save(this.model.toJSON(), {success: this.afterUpdate});
	    },
	
	    afterUpdate: function (){
	        this.model.fetch({success: this.afterFetchedUpdated});
	    },
	
	    afterFetchedUpdated: function (){
	        if (this.reversed){
	            var reversedModel = this.model.clone();
	            reversedModel.set('parentId', this.model.get('child').id);
	            reversedModel.set('child', {id: this.model.get('parentId'), name: this.selectedName});
	            this.triggerMethod('relation:saved', reversedModel);
	        } else{
	            this.triggerMethod('relation:saved', this.model.clone());
	        }
	        this.model.clear().set(this.model.defaults);
	        /*this.model.set('parentId', this.parentId);
	        this.model.set('child', {
	            id: this.entityId
	        });*/
	    }
	
	});
	
	module.exports = RelationsFormView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	var RelationTypesCollection = __webpack_require__(223);
	var RelationTypeModel = __webpack_require__(224);
	
	
	var RelationsTypesSelect = Marionette.View.extend({
	    template: __webpack_require__(225),
	    collection: new RelationTypesCollection(),
	    selectedType: new RelationTypeModel(),
	    events: {
	        'change #relation-type': 'typeSelected'
	    },
	
	    collectionEvents: {
	        request: 'showLoading',
	        sync: 'hideLoading',
	        error: 'logError'
	    },
	
	    initialize: function(options){
	        _.bindAll(this, 'onRender', 'typeSelected', 'getEntityType');
	        if (options){
	            this.reversed = options.reversed;
	            this.selectedType.set('id', options.type);
	            var collectionParams = [];
	            if(options.types && options.types.length > 0){
	                var typeParams = options.types.map(function(type){
	                    return {key: 'type', value: type}
	                });
	                collectionParams = collectionParams.concat(typeParams);
	            }
	            if(options.childrenTypes && options.childrenTypes.length > 0){
	                var childrenTypes = options.childrenTypes.map(function(type){
	                    return {key: 'childType', value: type}
	                });
	                collectionParams = collectionParams.concat(childrenTypes);
	            }
	            if(options.parentTypes && options.parentTypes.length > 0){
	                var parentTypes = options.parentTypes.map(function(type){
	                    return {key: 'parentType', value: type}
	                });
	                collectionParams = collectionParams.concat(parentTypes);
	            }
	            this.collection = new RelationTypesCollection([], {params: collectionParams});
	            this.collection.fetch({success: this.render});
	        }
	    },
	
	    onRender: function() {
	        this.$('#relation-type').selectize({
	            allowEmptyOption: false
	        });
	    },
	
	    typeSelected: function (event) {
	        this.selectedType.set('id', event.target.value);
	        this.triggerMethod('type:selected', {
	            relationType: event.target.value,
	            entityType: this.getEntityType(event.target.value)
	        });
	    },
	
	    getEntityType: function (relationType) {
	        var result = this.collection.find(function(model){return relationType === model.get('id')});
	        if (result){
	            return  this.reversed ? result.get('parentType') :result.get('childType')
	        }
	        return undefined;
	    },
	
	    showLoading: function() {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function() {
	        this.$('.loading').hide();
	    },
	
	    logError: function(obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    }
	});
	
	module.exports = RelationsTypesSelect;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	
	
	var RelationTypesCollection = BaseCollection.extend({
	    url:"/api/relationtype",
	
	    initialize: function(models, options){
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    }
	});
	
	
	module.exports = RelationTypesCollection;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(181);
	
	
	var RelationTypeModel = Backbone.Model.extend({
	    defaults: {
	        id: undefined,
	        name: '',
	        description:'',
	        parentType: '',
	        childType: ''
	    },
	
	    urlRoot: 'api/relationtype',
	});
	
	
	module.exports = RelationTypeModel;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="control-group">\n    <label for="relation-type">Relation type</label>\n    <select id="relation-type" class="relation-type-class" data-placeholder="Select a relation type">\n        <option value=""></option>\n        ';
	 _.each(items, function(item){ 
	__p+='\n        <option value="'+
	((__t=( item.id ))==null?'':__t)+
	'">'+
	((__t=( item.name ))==null?'':__t)+
	'</option>\n        ';
	 }) 
	__p+='\n    </select>\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	var EntitiesCollection = __webpack_require__(227);
	var EntityModel = __webpack_require__(228);
	
	
	var EntitiesSelectView = Marionette.View.extend({
	    template: __webpack_require__(229),
	
	
	    selectedEntity: new EntityModel(),
	    events: {
	        'change #entity': 'entitySelected'
	    },
	
	    ui: {
	      selectEl: '#entity'
	    },
	
	    collectionEvents: {
	        request: 'showLoading',
	        sync: 'hideLoading',
	        error: 'logError'
	    },
	
	    placeholder: 'Select an entity',
	
	    templateContext: function () {
	        var that = this;
	        return {
	            showLabel: that.showLabel,
	            label: that.label,
	            placeholder: that.placeholder,
	            selectedEntityId: that.selectedEntity.get('id')
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'entitySelected');
	        var that = this;
	        if (options) {
	            that.selectedEntity.set('id', options.entityId);
	            that.renderLabel = options.renderLabel == true;
	            that.label = options.label;
	            var params = [];
	            if (options.customPlaceholder) {
	                that.placeholder = options.customPlaceholder;
	            }
	            if (options.entityType)
	                that.entityType = options.entityType;
	
	            if (options.collectionValues) {
	                that.collection = options.collectionValues;
	            } else {
	                if (options.entityType) {
	                    that.entityType = options.entityType;
	                    params.push({
	                        key: 'type',
	                        value: options.entityType
	                    });
	                }
	                if(options.params){
	                    params = params.concat(options.params);
	                }
	                that.collection = new EntitiesCollection([], {params: params});
	                that.collection.fetch({success: function() {
	                    if (options.filterFn && typeof options.filterFn == "function") {
	                        that.collection = that.collection.filter(options.filterFn);
	                    }
	                    that.render();
	                }});
	            }
	
	        }
	    },
	
	    onRender: function () {
	        this.$('#entity').selectize({
	            allowEmptyOption: false,
	            inputClass: 'form-control selectize-input normal-width'
	        });
	    },
	
	    entitySelected: function (event) {
	        var select = $(event.target);
	        var that = this;
	        that.selectedEntity.set('id', event.target.value);
	        that.triggerMethod('entity:selected', {
	            id: event.target.value,
	            name: $('option:selected', select).text(),
	            type: that.entityType
	        });
	    },
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    },
	
	    reset: function() {
	        this.ui.selectEl.selectedIndex = 0;
	        this.render();
	    }
	
	});
	
	module.exports = EntitiesSelectView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	
	
	var EntitiesCollection = BaseCollection.extend({
	    url:"/api/dbo/preview",
	
	    initialize: function(models, options){
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    }
	});
	
	
	module.exports = EntitiesCollection;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(181);
	
	
	var EntityModel = Backbone.Model.extend({
	    defaults: {
	        id: 0,
	        name: ''
	    },
	
	    urlRoot: '/api/dbo'
	});
	
	
	module.exports = EntityModel;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="control-group">\n    ';
	 if(showLabel) {
	__p+='\n    <label for="entity">Relates to</label>\n    ';
	 } 
	__p+='\n    <select id="entity" data-placeholder="'+
	((__t=( placeholder ))==null?'':__t)+
	'">\n        <option value=""></option>\n        ';
	 _.each(items, function(item){ 
	__p+='\n        <option value="'+
	((__t=( item.id ))==null?'':__t)+
	'" name="'+
	((__t=( item.name ))==null?'':__t)+
	'" ';
	if (item.id == selectedEntityId) {
	__p+=' selected ';
	 } 
	__p+=' >'+
	((__t=( item.name ))==null?'':__t)+
	'</option>\n        ';
	 }) 
	__p+='\n    </select>\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(181);
	
	
	var RelationModel = Backbone.Model.extend({
	    urlRoot: '/api/relation',
	
	    initialize: function(){
	        this.bind("change", this.attributesChanged);
	    },
	
	    attributesChanged: function(){
	        var valid = false;
	        if (this.get('parentId') && this.get('child'))
	            valid = true;
	        this.trigger("validated", valid);
	    }
	});
	
	
	module.exports = RelationModel;

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form-horizontal">\n    <form>\n        <div id="types-container"></div>\n        <div id="entities-container"></div>\n        <div class="left-buttons">\n            <button type="button" class="btn btn-success" id="save-relation" disabled>Save</button>\n        </div>\n    </form>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var OrganizationDataView = Marionette.View.extend({
	    template: __webpack_require__(233),
	
	    ui: {
	    	show: '#run-report',
	    	reportType: '#reportType',        
	        dateFrom: '#date-from',
	        dateTo: '#date-to',
	        basicTitleDates: '#basic-dates',
	        referralTitleDates: '#referral-dates'       
	    },
	    
	    events: {
	        'click @ui.show': 'runReport',
	        'change @ui.reportType': 'changeReportType'
	    },
	    
	    modelEvents: {
	        'change': 'fieldsChanged'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var object = that.model.get('object');
	        object.externalIds = object.externalIds || [];
	        return {
	            formattedDateTime: function (long) {
	                return that.utils.longToDateTimeFormatted(long, 'MMM DD YYYY hh:mm A');
	            },            
	            dateFrom:null,
	            dateTo:null,
	            selectedReport:"",
	            canEdit: that.canEdit,
	            byAdmin: that.byAdmin,
	            username: that.options.user.login,
	            isMd: that.options.user.isMd,
	            isOfficeAdministrator: that.options.user.isOfficeAdministrator,
	            isMedicalDirector: that.options.user.isMedicalDirector,
	            isManager: that.options.user.isManager,
	            isAdmin: that.options.user.isAdmin,
	            tels: that.utils.extractContactValuesByTypeAsString(object.contacts || [], 'PHONE'),
	            faxes: that.utils.extractContactValuesByTypeAsString(object.contacts || [], 'FAX'),
	            emails: that.utils.extractContactValuesByTypeAsString(object.contacts || [], 'EMAIL'),
	            signedDocumentsLink: '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	            + '&ORGANIZATION_REVIEW_REQUEST=' + that.model.get('id') + '&ORGANIZATION_REVIEW_FINISHED_REQUEST=' + that.model.get('id')
	            + '&object_status=SIGNED&object_status=VIEWED',
	            pendingDocumentsLink: '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	            + '&ORGANIZATION_REVIEW_REQUEST=' + that.model.get('id') + '&NOT_ORGANIZATION_REVIEW_FINISHED_REQUEST=' + that.model.get('id')
	            + '&object_status=IN_REVIEW',
	            allDocumentsLink: '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	            + '&ORGANIZATION_REVIEW_REQUEST=' + that.model.get('id'),
	            getMedsideExternalIdsParams: function () {
	                if (object.externalIds.length == 0) {
	                    return '';
	                }
	                return "org=" + object.externalIds.filter(function (id) {
	                    return id.toLowerCase().startsWith('medside_');
	                }).map(function (id) {
	                    return id.toLowerCase().replace('medside_', '');
	                }).join('&org=');
	            }
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'fieldsChanged');
	        this.utils = new CommonUtils();
	        this.canEdit = options.canEdit;
	        this.byAdmin = options.byAdmin;
	    },
	
	    fieldsChanged: function () {
	        this.render();
	    },
	    
	    getMedsideExternalIdsParams: function () {
	    	var that = this;
	    	var object = that.model.get('object');
	        if (object.externalIds.length == 0) {
	            return '';
	        }
	        return "org=" + object.externalIds.filter(function (id) {
	            return id.toLowerCase().startsWith('medside_');
	        }).map(function (id) {
	            return id.toLowerCase().replace('medside_', '');
	        }).join('&org=');
	    },
	    
	    runReport: function () {
	    	var  url = null;
	    	var from = this.ui.dateFrom.val()?'from='+this.utils.dateToLong(this.ui.dateFrom.val())+'&':"";
	    	var to = this.ui.dateTo.val()?'to='+(this.utils.dateToLong(this.ui.dateTo.val())+86340000)+'&':"";
	    	switch(this.ui.reportType.val()){
	    		case 'basic': url = '/#organization/'+this.model.get('id')+'/patients?'+from+to+this.getMedsideExternalIdsParams()+'&sourceOrganization=b2c93b43-c6ff-4ca0-b61d-88b2326bdcc0'; break;
	    		case 'simple': url = '/#organization/'+this.model.get('id')+'/patients?'+from+to+'isSimple=true&'+this.getMedsideExternalIdsParams()+'&sourceOrganization=b2c93b43-c6ff-4ca0-b61d-88b2326bdcc0'; break;
	    		case 'referral': url = '/#organization/'+this.model.get('id')+'/patients?'+from+to+'variant=referral&'+this.getMedsideExternalIdsParams()+'&sourceOrganization=b2c93b43-c6ff-4ca0-b61d-88b2326bdcc0'; break;
	    		default: alert('Please, select report.');
	    	}        
	        if(url)window.open(url);
	    },
	    
	    
	    
	    onRender: function () {
	        this.ui.reportType.selectize({        	
	        });
	        this.ui.dateFrom.datepicker({
	            format: 'mm/dd/yyyy',
	            autoclose: true,
	            clearBtn: true
	        });
	        this.ui.dateTo.datepicker({
	            format: 'mm/dd/yyyy',
	            autoclose: true,
	            clearBtn: true
	        });
	    },
	    
	    changeReportType: function (){
	    	//alert(this.ui.reportType.val());
	    	switch(this.ui.reportType.val()){
			case 'basic': this.ui.basicTitleDates.attr("hidden", false); this.ui.referralTitleDates.attr("hidden", true); break;
			case 'simple': this.ui.basicTitleDates.attr("hidden", false); this.ui.referralTitleDates.attr("hidden", true); break;
			case 'referral': this.ui.basicTitleDates.attr("hidden", true); this.ui.referralTitleDates.attr("hidden", false); break;
			default: this.ui.basicTitleDates.attr("hidden", true); this.ui.referralTitleDates.attr("hidden", true); break;
		} 
	    }
	
	});
	
	module.exports = OrganizationDataView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row">\n    <div class="col-md-8 col-xs-8">\n        <h3>'+
	((__t=( name ))==null?'':_.escape(__t))+
	' ';
	 if (canEdit) { 
	__p+='<span class="glyphicon glyphicon-pencil text-muted clickable edit-header"\n                                                  aria-hidden="true" id="edit-data"></span>';
	 } 
	__p+='</h3>\n\n    </div>\n    <div class="orgdata col-md-8 col-xs-8">\n\n        <dl class="dl-horizontal-left dl-horizontal">\n            <dt>Documents</dt>\n            <dd>\n                <div class="row">\n                    <div class="col-md-1-5 col-xs-2">\n                        <span style="color: green;" class="glyphicon glyphicon-check"/> <a\n                            href="'+
	((__t=( signedDocumentsLink ))==null?'':__t)+
	'" target="_blank">Reviewed</a>\n                    </div>\n                    <div class="col-md-1-5 col-xs-2">\n                        <span style="color: orange;" class="glyphicon glyphicon-hourglass"/> <a\n                            href="'+
	((__t=( pendingDocumentsLink ))==null?'':__t)+
	'" target="_blank">Pending</a>\n                    </div>\n                    <div class="col-md-1-5 col-xs-2">\n                        <span class="glyphicon glyphicon-file"/> <a href="'+
	((__t=( allDocumentsLink ))==null?'':__t)+
	'"\n                                                                    target="_blank">All</a>\n                    </div>\n                </div>\n            </dd>\n        </dl>\n        <dl class="dl-horizontal-left dl-horizontal">\n            <dt>NPI</dt>\n            <dd>'+
	((__t=( object.npi ))==null?'':_.escape(__t))+
	'</dd>\n        </dl>\n\n        <address>\n            <strong>'+
	((__t=( name ))==null?'':_.escape(__t))+
	'</strong><br>\n            '+
	((__t=( object.address ))==null?'':_.escape(__t))+
	'<br>\n            <abbr title="Phone">P:</abbr> '+
	((__t=( object.contact ? object.contact.phone : "" ))==null?'':_.escape(__t))+
	'\n        </address>\n\n        <dl class="dl-horizontal-left dl-horizontal">\n            <dt>Created time</dt>\n            <dd>'+
	((__t=( formattedDateTime(createdTime) ))==null?'':__t)+
	'</dd>\n        </dl>\n\n        <dl class="dl-horizontal-left dl-horizontal">\n            <dt>Phone</dt>\n            <dd>'+
	((__t=( tels ))==null?'':_.escape(__t))+
	'</dd>\n        </dl>\n\n        <dl class="dl-horizontal-left dl-horizontal">\n            <dt>Fax</dt>\n            <dd>'+
	((__t=( faxes ))==null?'':_.escape(__t))+
	'</dd>\n        </dl>\n\n        <dl class="dl-horizontal-left dl-horizontal">\n            <dt>Email</dt>\n            <dd>'+
	((__t=( emails ))==null?'':_.escape(__t))+
	'</dd>\n        </dl>\n\n    </div>\n    ';
	 if (isOfficeAdministrator || isMedicalDirector || isManager || isMd || isAdmin || byAdmin) { 
	__p+='\n    <div class="col-md-3 col-xs-3 col-md-offset-1 col-xs-offset-1">\n        <select id="reportType" data-placeholder="Report">\n            <option value="" selected></option>\n            <option value="basic" name="Jencare">View Patients</option>\n            <option value="referral" name="Referral">View Referrals</option>\n        </select>\n        <h5 id="basic-dates" hidden="true">Has visits:</h5>\n        <h5 id="referral-dates" hidden="true">Documents:</h5>\n        <div>\n            <table>\n                <tr>\n                    <td>\n                        <input class="form-control" type="text" id="date-from" value="'+
	((__t=( dateFrom ))==null?'':__t)+
	'"\n                               onkeypress="return false;" placeholder="From">\n                    </td>\n                    <td>\n                        <input class="form-control" type="text" id="date-to" value="'+
	((__t=( dateTo ))==null?'':__t)+
	'"\n                               onkeypress="return false;" placeholder="To">\n                    </td>\n                </tr>\n            </table>\n\n        </div>\n        <button type="button" class="btn btn-success" id="run-report">Show</button>\n    </div>\n    ';
	 } 
	__p+='\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	
	var RelationItem = Marionette.View.extend({
	    tagName: 'li',
	    template: __webpack_require__(235),
	    events:{
	        'click .remove-relation': 'removeRelation'
	    },
	
	    initialize: function(){
	        _.bindAll(this, 'removeRelation');
	    },
	
	    removeRelation: function(event){
	        this.model.destroy();
	    }
	});
	
	var RelationsListView = Marionette.CollectionView.extend({
	    tagName: 'ul',
	    childView: RelationItem,
	
	    initialize: function() {
	    }
	});
	
	module.exports = RelationsListView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\n    '+
	((__t=( type.name ))==null?'':__t)+
	': '+
	((__t=( child.name ))==null?'':__t)+
	'\n    <span class="glyphicon glyphicon-remove clickable remove-relation" rel-id="'+
	((__t=( id ))==null?'':__t)+
	'"/>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var YesNoConfirmationModal = __webpack_require__(237);
	var CommonUtils = __webpack_require__(189);
	
	var utils = new CommonUtils();
	
	var Radio = __webpack_require__(183);
	var actionsChannel = Radio.channel('actions');
	var notificationsChannel = Radio.channel('notifications');
	
	var PermissionRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(239),
	    events: {
	        'click .pemission-delete': 'removePermission',
	        'click input[type=checkbox]': 'onChecked'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var owner = that.model.get('owner');
	        var org = that.model.get('organization');
	        return {
	            owner: owner == undefined ? '-' : utils.formatPerson(owner.object)
	                + (!owner.object || _.isEmpty(owner.object.npi) || _.isUndefined(owner.object.npi) ? '' : ' (' + owner.object.npi + ')'),
	            ownerId: owner == undefined ? '' : owner.object.login,
	            showOrganization: that.showOrganization,
	            organization: org == undefined ? '-' : org.name
	                + (!org.object || _.isEmpty(org.object.npi) || _.isUndefined(org.object.npi) ? '' : ' (' + org.object.npi + ')'),
	            organizationId: org == undefined ? '' : org.id,
	            permittedObjectType: that.permittedObjectType
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'removePermission', 'onChecked');
	        this.showOrganization = options.showOrganization
	        this.permittedObjectType = options.permittedObjectType;
	    },
	
	    removePermission: function (event) {
	        this.triggerMethod('delete:model', this.model);
	    },
	
	    onChecked: function (event) {
	        this.model.set(event.target.value, event.target.checked);
	        this.triggerMethod('update:model', this.model);
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(13), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var PermissionsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: PermissionRowView,
	    emptyView: EmptyView,
	
	    collectionEvents: {
	        request: 'showLoading',
	        sync: 'hideLoading',
	        error: 'logError'
	    },
	
	    childViewEvents: {
	        'update:model': 'updateModel',
	        'delete:model': 'deleteModel'
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'showLoading', 'hideLoading', 'logError', 'updateModel', 'deleteModel');
	        this.showOrganization = options.showOrganization;
	        this.permittedObjectType = options.permittedObjectType;
	        this.collection = options.collection;
	    },
	
	    childViewOptions: function () {
	        return {
	            showOrganization: this.showOrganization,
	            permittedObjectType: this.permittedObjectType
	        };
	    },
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    },
	
	    updateModel: function (model) {
	        var that = this;
	        var callback = function () {
	            var cloned = model.clone();
	            cloned.unset('owner');
	            cloned.unset('organization');
	            cloned.save();
	            that.render();
	        };
	        this.triggerMethod('on:action', callback);
	    },
	
	    deleteModel: function (model) {
	        var that = this;
	        var responseHandler = function (model, xhr, options) {
	            if (xhr.status == 200) {
	                that.collection.remove(model);
	                that.render();
	            }
	            else
	                notificationsChannel.request('show:notification', JSON.parse(xhr.responseText));
	        };
	        var callback = function () {
	            model.destroy({
	                wait: true,
	                success: responseHandler,
	                error: responseHandler
	            });
	        }
	        this.triggerMethod('on:action', callback);
	    }
	});
	
	var PermissionsTableView = Marionette.View.extend({
	    tagName: 'div',
	    className: 'permissions-table',
	    template: __webpack_require__(240),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        confirmationModal: '#yes-no-confirmation-modal'
	    },
	
	    childViewEvents: {
	        'action:confirmed': 'saveConfirmed',
	        'on:action': 'onAction'
	    },
	
	    showOrganization: false,
	    callback: undefined,
	
	    templateContext: function () {
	        return {
	            showOrganization: this.showOrganization,
	            permittedObjectType: this.permittedObjectType
	        }
	    },
	
	    onRender: function () {
	        var that = this;
	        that.collection.fetch({
	            success: function () {
	                that.showChildView('body', new PermissionsTableBody({
	                    collection: that.collection,
	                    showOrganization: that.showOrganization,
	                    permittedObjectType: that.permittedObjectType
	                }));
	            },
	            error: function (collection, response, options) {
	                if (response.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                }
	            }
	        });
	
	        that.showChildView('confirmationModal', new YesNoConfirmationModal({message: 'You will update permission. Are you sure?'}));
	    },
	
	    initialize: function (options) {
	        var that = this;
	        _.bindAll(that, 'saveConfirmed', 'onAction');
	        if (options.showOrganization != undefined)
	            that.showOrganization = options.showOrganization;
	        that.permittedObjectType = options.permittedObjectType;
	        that.collection = options.collection;
	    },
	
	    onAction: function (callback) {
	        this.callback = callback;
	        if (typeof callback !== "function")
	            return;
	        this.$('#confirmation-modal').modal();
	    },
	
	    saveConfirmed: function (data) {
	        if (data.result == true) {
	            this.callback();
	        }
	        else {
	            this.$('#confirmation-modal').modal('hide');
	        }
	    }
	});
	
	module.exports = PermissionsTableView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var YesNoConfirmationModal = Marionette.View.extend({
	    template: __webpack_require__(238),
	
	    ui: {
	        modal: '#confirmation-modal',
	        yesBtn: '#yes',
	        noBtn: '#no'
	    },
	
	    events: {
	        'click @ui.yesBtn': 'actionConfirmed',
	        'click @ui.noBtn': 'actionDeclined'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            title: that.title || 'Confirmation',
	            message: that.message || 'Are you sure?'
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'actionConfirmed', 'actionDeclined', 'clearUI', 'show', 'hide');
	        if (options) {
	            this.title = options.title;
	            this.message = options.message;
	            this.tag = options.tag;
	        }
	    },
	
	    onRender: function () {
	    },
	
	    clearUI: function() {
	        this.ui.modal.modal('hide');
	        $('body').removeClass('modal-open');
	        $('.modal-backdrop').remove();
	    },
	
	    actionConfirmed: function () {
	        this.clearUI();
	        this.triggerMethod('action:confirmed', {result: true, tag: this.tag});
	    },
	
	    actionDeclined: function() {
	        this.clearUI();
	        this.triggerMethod('action:confirmed', {result: false, tag: this.tag});
	    },
	
	    show: function() {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function() {
	        this.clearUI();
	    }
	});
	
	module.exports = YesNoConfirmationModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Delete confirmation modal -->\r\n<div class="modal fade" id="confirmation-modal" tabindex="-1" role="dialog">\r\n    <div class="modal-dialog">\r\n\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal">&times;</button>\r\n                <h4 class="modal-title">'+
	((__t=( title ))==null?'':__t)+
	'</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <p>'+
	((__t=( message ))==null?'':__t)+
	'</p>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-danger" id="yes">Yes</button>\r\n                <button type="button" class="btn btn-default" id="no" data-dismiss="modal">No</button>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 239 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td><a href = "/#person/'+
	((__t=( ownerId ))==null?'':__t)+
	'">'+
	((__t=( owner ))==null?'':__t)+
	'</a></td>\r\n';
	 if (showOrganization == true) { 
	__p+='\r\n';
	 if (organizationId) { 
	__p+='\r\n<td><a href = "/#organization/'+
	((__t=( organizationId ))==null?'':__t)+
	'">'+
	((__t=( organization ))==null?'':__t)+
	'</a></td>\r\n';
	 } else { 
	__p+='\r\n<td>-</td>\r\n';
	 } 
	__p+='\r\n';
	 } 
	__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canRead" ';
	 if (canRead) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canReadAll" ';
	 if (canReadAll) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n';
	 } 
	__p+='\r\n';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canReadFor" ';
	 if (canReadFor) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n';
	 } 
	__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canWrite" ';
	 if (canWrite) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canWriteFor" ';
	 if (canWriteFor) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n';
	 } 
	__p+='\r\n';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canWriteAll" ';
	 if (canWriteAll) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n';
	 } 
	__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canDelete" ';
	 if (canDelete) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canSign" ';
	 if (canSign) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n';
	 if (showOrganization == true && permittedObjectType != 'document') { 
	__p+='\r\n<td><input type="checkbox" value="canSignAll" ';
	 if (canSignAll) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n';
	 } 
	__p+='\r\n';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canUploadFor" ';
	 if (canUploadFor) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n';
	 } 
	__p+='\r\n<td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canChangeReviewer" ';
	 if (canChangeReviewer) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n<td><span class="glyphicon glyphicon-remove clickable pemission-delete" rel-id="'+
	((__t=( id ))==null?'':__t)+
	'"/></td>';
	}
	return __p;
	};


/***/ }),
/* 240 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<table class="table table-hover">\r\n    <thead>\r\n    <tr>\r\n        <th>Permissions owner</th>\r\n        ';
	 if (showOrganization == true) { 
	__p+='\r\n        <th>Organization</th>\r\n        ';
	 } 
	__p+='\r\n        <th>Can View</th>\r\n        ';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n        <th>Can Read All</th>\r\n        ';
	 } 
	__p+='\r\n        ';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n        <th>Can Read For</th>\r\n        ';
	 } 
	__p+='\r\n        <th>Can Edit</th>\r\n        ';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n        <th>Can Edit For</th>\r\n        ';
	 } 
	__p+='\r\n        ';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n        <th>Can Edit All</th>\r\n        ';
	 } 
	__p+='\r\n        <th>Can Delete</th>\r\n        <th>Can Sign</th>\r\n        ';
	 if (showOrganization == true && permittedObjectType != 'document') { 
	__p+='\r\n        <th>Can Sign For All</th>\r\n        ';
	 } 
	__p+='\r\n        ';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n        <th>Can Upload For</th>\r\n        ';
	 } 
	__p+='\r\n        <th>Can Change Reviewer</th>\r\n        <th>Delete</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody></tbody>\r\n</table>\r\n<div id="yes-no-confirmation-modal"></div>';
	}
	return __p;
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var DeleteConfirmationModal = Marionette.View.extend({
	    template: __webpack_require__(242),
	
	    ui: {
	        modal: '#delete-confirmation-modal',
	        btn: '#remove',
	        close: '#close',
	        confirmationText: '#confirmation'
	    },
	
	    events: {
	        'click @ui.btn': 'deleteConfirmed'
	    },
	
	    templateContext: function(){
	        var that = this;
	        return{
	            title: that.title || 'Confirmation of delete',
	            message: that.message || 'Enter: "confirm" if you agree to remove.',
	            confirmationAnswer: that.confirmationAnswer
	        }
	    },
	
	    initialize: function(options){
	        _.bindAll(this, 'onRender', 'deleteConfirmed', 'show');
	        if (options){
	            this.title = options.title;
	            this.message = options.message;
	            this.confirmationAnswer = options.confirmationAnswer.trim().toLowerCase();
	        }
	    },
	
	    onRender: function(){
	    },
	
	    deleteConfirmed: function() {
	        if (this.confirmationAnswer === this.ui.confirmationText.val().trim().toLowerCase()) {
	            this.ui.modal.modal('hide');
	            $('body').removeClass('modal-open');
	            $('.modal-backdrop').remove();
	            this.triggerMethod('delete:confirmed', true);
	        }
	    },
	    
	    show: function() {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    }
	
	});
	
	module.exports = DeleteConfirmationModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Delete confirmation modal -->\r\n<div class="modal fade" id="delete-confirmation-modal" tabindex="-1" role="dialog">\r\n    <div class="modal-dialog">\r\n\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal">&times;</button>\r\n                <h4 class="modal-title">'+
	((__t=( title ))==null?'':__t)+
	'</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <p>'+
	((__t=( message ))==null?'':__t)+
	'</p>\r\n                <input class="form-control" type="text" placeholder="'+
	((__t=( confirmationAnswer ))==null?'':__t)+
	'" id="confirmation"/>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-danger" id="remove">Delete</button>\r\n                <button type="button" class="btn btn-default" id="close" data-dismiss="modal">Close</button>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var EntitiesSelectView = __webpack_require__(226);
	var RemoteSuggesterView = __webpack_require__(196);
	var PermissionModel = __webpack_require__(244);
	var EntitiesCollection = __webpack_require__(227);
	var RolesCollection = __webpack_require__(245);
	
	var PermissionFormView = Marionette.View.extend({
	    template: __webpack_require__(247),
	
	    regions: {
	        owners: "#owners-container",
	        organization: '#orgs-container',
	        permissionsTemplates: '#permission-templates-list'
	    },
	
	    model: new PermissionModel(),
	
	    childViewEvents: {
	        'entity:selected': 'entitySelected',
	        'suggestor:selected:person': 'personChanged',
	        'suggestor:selected:organization': 'organizationChanged'
	    },
	
	    events: {
	        'click #save-permission': 'addPermission',
	        'change #can-read': 'onChecked',
	        'change #can-write': 'onChecked',
	        'change #can-write-for': 'onChecked',
	        'change #can-delete': 'onChecked',
	        'change #can-sign': 'onChecked',
	        'change #can-sign-all': 'onChecked',
	        'change #can-upload-for': 'onChecked',
	        'change #can-read-for': 'onChecked',
	        'change #can-read-all': 'onChecked',
	        'change #can-change-reviewer': 'onChecked',
	        'change #can-edit-all': 'onChecked'
	    },
	
	    ui: {
	        saveBtn: '#save-permission'
	    },
	
	    showOrganization: false,
	
	    constants: {
	        maxNumberOfItemsInControlWithSuggester: 20
	    },
	
	    templateContext: function () {
	        return {
	            showOrganization: this.showOrganization,
	            permittedObjectType: this.permittedObjectType
	        };
	    },
	
	    initialize: function (options) {
	        var that = this;
	        _.bindAll(this, 'onRender', 'entitySelected', 'addPermission',
	            'afterUpdate', 'onChecked', 'fillModelFromPermissionTemplate', 'renderPersonSelectView', 'renderOrganizationSelectView');
	        if (options) {
	            that.permittedObjectId = options.permittedObjectId;
	            if (options.showOrganization)
	                that.showOrganization = options.showOrganization;
	            that.permittedObjectType = options.permittedObjectType;
	        }
	        that.model.view = that;
	        that.model.bind("validated", that.validated);
	
	        that.permissionTypesCollection = new RolesCollection([], {
	            params: [
	                {key: 'sortby', value: 'templateName'},
	                {key: 'sortdir', value: 'ASC'},
	                {key: 'templateType', value: that.permittedObjectType}
	            ]
	        });
	    },
	
	    validated: function (valid) {
	        var saveBtn = this.view.ui.saveBtn;
	        if (valid) {
	            saveBtn.removeAttr("disabled");
	        } else {
	            saveBtn.attr("disabled", "true");
	        }
	    },
	
	    onRender: function () {
	        var that = this;
	        that.renderPersonSelectView();
	
	        if (that.showOrganization) {
	            that.renderOrganizationSelectView();
	        }
	
	        that.initiateStates();
	        that.model.set('permittedObjectId', that.permittedObjectId);
	
	        that.permissionTypesCollection.fetch({
	            success: function () {
	                that.permissionTemplatesSelectView = new EntitiesSelectView({
	                    entityType: 'permissionTemplate',
	                    customPlaceholder: 'Select a permission template',
	                    collectionValues: new EntitiesCollection(that.permissionTypesCollection.map(function (elem) {
	                        return {
	                            id: elem.get('id'),
	                            name: elem.get('templateName')
	                        }
	                    }))
	                });
	                that.showChildView('permissionsTemplates', that.permissionTemplatesSelectView);
	            }
	        });
	
	
	        // $('.tooltipable').each(function () {
	        //     $(this).tooltip();
	        // })
	    },
	
	    renderPersonSelectView: function () {
	
	        var that = this;
	
	        that.showChildView('owners', new RemoteSuggesterView({
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
	            + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data.filter(function (item) {
	                    return item.object && item.object.mergeable === false;
	                });
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Select a person",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return (arr[index] || {}).id;
	            },
	            tag: 'person'
	        }));
	    },
	
	    renderOrganizationSelectView: function () {
	        var that = this;
	
	        that.showChildView('organization', new RemoteSuggesterView({
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
	            + '&sortby=name&like_name=~~~&type=organization',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Select a organization",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return (arr[index] || {}).id;
	            },
	            tag: 'organization'
	        }));
	    },
	
	    initiateStates: function () {
	        this.model.set(this.model.defaults);
	        this.ui.saveBtn.attr("disabled", "true");
	    },
	
	    entitySelected: function (data) {
	        if (data.type == 'permissionTemplate') {
	            var permissionTemplate = this.permissionTypesCollection.findWhere({id: data.id});
	            if (typeof permissionTemplate != "undefined") {
	                this.fillModelFromPermissionTemplate(permissionTemplate);
	            }
	        }
	    },
	
	    addPermission: function () {
	        this.model.save(this.model.toJSON(), {success: this.afterUpdate});
	    },
	
	    afterUpdate: function () {
	        this.triggerMethod('permission:saved', this.model.clone());
	        this.model.set(this.model.defaults);
	        this.render();
	    },
	
	    onChecked: function (event) {
	        this.model.set(event.target.value, event.target.checked);
	    },
	
	    fillModelFromPermissionTemplate: function (permissionTemplate) {
	        var that = this;
	        var booleanFields = Object.keys(permissionTemplate.attributes).filter(function (attr) {
	            return attr.startsWith('can');
	        });
	        booleanFields.forEach(function (field) {
	            var checkboxInput = that.$("input[value='" + field + "']");
	            var value = permissionTemplate.get(field);
	            if (value == true) {
	                checkboxInput.prop('checked', true);
	                that.model.set(field, true);
	            } else {
	                checkboxInput.prop('checked', false);
	                that.model.set(field, false);
	            }
	        });
	    },
	
	    personChanged: function (id) {
	        this.model.set('ownerId', id);
	    },
	
	    organizationChanged: function (id) {
	        this.model.set('organizationId', id);
	    }
	});
	
	module.exports = PermissionFormView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(181);
	
	var PermissionModel = Backbone.Model.extend({
	
	    defaults: {
	        id: undefined,
	        ownerId: undefined,
	        organizationId: undefined,
	        canRead: false,
	        canWrite: false,
	        canDelete: false,
	        canSign: false,
	        canSignAll: false,
	        canUploadFor: false,
	        canReadAll: false,
	        canReadFor: false,
	        canWriteFor: false,
	        canChangeReviewer: false,
	        canWriteAll: false
	    },
	
	    urlRoot: '/api/permission',
	
	    initialize: function () {
	        this.bind("change", this.attributesChanged);
	    },
	
	    attributesChanged: function () {
	        var valid = false;
	        if (this.get('permittedObjectId') && (this.get('ownerId') || this.get('organizationId')))
	            valid = true;
	        this.trigger("validated", valid);
	    }
	});
	
	
	module.exports = PermissionModel;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	var RoleModel = __webpack_require__(246);
	
	var RolesCollection = BaseCollection.extend({
	    url:"/api/permission/template",
	    model: RoleModel,
	
	    initialize: function(models, options){
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    }
	});
	
	
	module.exports = RolesCollection;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(181);
	
	
	var RoleModel = Backbone.Model.extend({
	    defaults: {
	        id: undefined,
	        templateName: undefined,
	        templateType: undefined,
	        canRead: false,
	        canReadAll: false,
	        canReadFor: false,
	        canWrite: false,
	        canWriteFor: false,
	        canWriteAll: false,
	        canDelete: false,
	        canSign: false,
	        canSignAll: false,
	        canUploadFor: false,
	        canChangeReviewer: false
	    },
	
	    urlRoot: '/api/permission/template'
	
	});
	
	
	module.exports = RoleModel;

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form top-margined row">\r\n    <h4 class="center">Add new permission</h4>\r\n    <div class="col-md-5 col-xs-5">\r\n        <div id="owners-container" class="form-group"></div>\r\n        ';
	 if (showOrganization == true) { 
	__p+='\r\n        <div id="orgs-container" class="form-group"></div>\r\n        ';
	 } 
	__p+='\r\n    </div>\r\n    <div class="col-md-3 col-xs-3 col-md-offset-1 col-xs-offset-1">\r\n        <div data-toggle="can-view-tooltip" class="tooltipable">\r\n            <label class="checkbox"><input type="checkbox" id="can-read" value="canRead">Can view</label>\r\n        </div>\r\n        <!--<div class="tooltip top" role="can-view-tooltip">-->\r\n            <!--<div class="tooltip-arrow"></div>-->\r\n            <!--<div class="tooltip-inner">-->\r\n                <!--Can see-->\r\n            <!--</div>-->\r\n        <!--</div>-->\r\n\r\n\r\n        ';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-read-all" value="canReadAll">Can read all entities for</label>\r\n        ';
	 } 
	__p+='\r\n        ';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-read-for" value="canReadFor">Can read for</label>\r\n        ';
	 } 
	__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-write" value="canWrite">Can edit</label>\r\n        ';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-write-for" value="canWriteFor">Can edit for</label>\r\n        ';
	 } 
	__p+='\r\n        ';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-edit-all" value="canWriteAll">Can edit all</label>\r\n        ';
	 } 
	__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-delete" value="canDelete">Can delete</label>\r\n        <label class="checkbox"><input type="checkbox" id="can-sign" value="canSign">Can sign</label>\r\n        ';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-sign-all" value="canSignAll">Can sign for all</label>\r\n        ';
	 } 
	__p+='\r\n        ';
	 if (permittedObjectType != 'document') { 
	__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-upload-for" value="canUploadFor">Can upload for</label>\r\n        ';
	 } 
	__p+='\r\n        <label class="checkbox"><input type="checkbox" id="can-change-reviewer" value="canChangeReviewer">Can change\r\n            reviewer</label>\r\n\r\n        <div class="left-buttons">\r\n            <button type="button" class="btn btn-success" id="save-permission" disabled>Add</button>\r\n        </div>\r\n    </div>\r\n    <div class="col-md-3 col-xs-3">\r\n        <div data-toggle="collapse" data-target="#permission-templates">\r\n            <span class="dotted-link">Select from permissions templates</span>\r\n        </div>\r\n\r\n        <div class="collapse" style="margin: 20px 0px 20px 0px;" id="permission-templates">\r\n            <div id="permission-templates-list"></div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n';
	}
	return __p;
	};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	var Relation = __webpack_require__(230);
	
	var RelationsCollection = BaseCollection.extend({
	    url:"/api/relation",
	    model: Relation,
	
	    initialize: function(models, options){
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    }
	});
	
	
	module.exports = RelationsCollection;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	var PermissionModel = __webpack_require__(244);
	
	var PermissionsCollection = BaseCollection.extend({
	    url:"/api/permission/view",
	    model: PermissionModel,
	
	    initialize: function(models, options){
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    }
	});
	
	
	module.exports = PermissionsCollection;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	var YesNoConfirmationModal = __webpack_require__(237);
	
	var Dicts = __webpack_require__(193);
	var CommonUtils = __webpack_require__(189);
	
	var utils = new CommonUtils();
	
	var ContactsRowView = Marionette.View.extend({
	    tagName: 'tr',
	    className: 'contact-row clickable',
	    template: __webpack_require__(251),
	
	    ui: {
	        td: 'td'
	    },
	
	    events: {
	        'click #contact-delete': 'removeContact',
	        'click #contact-edit': 'editContact',
	        'click #preferred': 'onCheckPreferred',
	        'click @ui.td': 'onRowSelected'
	    },
	
	    contactHovered: false,
	
	    templateContext: function () {
	        var that = this;
	        var dateFrom = that.model.get('from');
	        var dateTo = that.model.get('to');
	        return {
	            contactHovered: that.contactHovered,
	            clearedReceiver: function () {
	                var data = that.model.get('data') || "";
	                data = data.replace(new RegExp(' ', 'g'), '');
	                data = data.replace(new RegExp('_', 'g'), '');
	                data = data.replace(new RegExp('-', 'g'), '');
	                data = data.replace(new RegExp('\\(', 'g'), '');
	                data = data.replace(new RegExp('\\)', 'g'), '');
	                data = data.replace(new RegExp('\\+', 'g'), '');
	                return data;
	            },
	            priority: utils.getContactPriorities()[that.model.get('priority')] || '',
	            usage: Dicts.addressUsages[that.model.get('usage')] || '',
	            dateFrom: dateFrom != undefined && dateFrom != '' && !isNaN(dateFrom) ? utils.longToDateTimeFormatted(dateFrom, 'MM/DD/YYYY') : '',
	            dateTo: dateTo != undefined && dateTo != '' && !isNaN(dateTo) ? utils.longToDateTimeFormatted(dateTo, 'MM/DD/YYYY') : '',
	            typeRepresentation: function (type) {
	                return utils.getContactTypes()[type];
	            },
	            canEdit: that.getOption('canEdit'),
	            simpleView: that.getOption('simpleView')
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'removeContact', 'editContact', 'onCheckPreferred', 'onRowSelected');
	    },
	
	    removeContact: function (event) {
	        this.triggerMethod('delete:model', this.model);
	    },
	
	    editContact: function (event) {
	        this.triggerMethod('update:model', this.model);
	    },
	
	    onCheckPreferred: function (event) {
	        this.model.set('preferred', event.target.checked);
	        this.triggerMethod('update:model:wo:confirm', this.model);
	    },
	
	    onRowSelected: function () {
	        var that = this;
	        this.contactHovered = !this.contactHovered;
	        this.triggerMethod('contact:hover', {
	            hovered: this.contactHovered,
	            addresses: that.model.get('addresses'),
	            representatives: that.model.get('representatives')
	        });
	
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(5), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var ContactsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: ContactsRowView,
	    emptyView: EmptyView,
	
	    childViewEvents: {
	        'update:model': 'updateModel',
	        'update:model:wo:confirm': 'updateModelWoConfirm',
	        'delete:model': 'deleteModel',
	        'contact:hover': 'contactHover'
	    },
	
	    childViewOptions: function () {
	        var that = this;
	        return {
	            canEdit: that.getOption('canEdit'),
	            simpleView: that.getOption('simpleView') || false
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'updateModel', 'deleteModel', 'updateModelWoConfirm', 'contactHover');
	        this.collection = options.collection;
	    },
	
	    updateModel: function (model) {
	        var callback = function () {
	            this.triggerMethod('on:contact:action', {mode: 'edit', data: model});
	        };
	        this.triggerMethod('on:action', {
	            callback: callback,
	            mode: 'edit'
	        });
	    },
	
	    updateModelWoConfirm: function (model) {
	        this.triggerMethod('update:model:wo:confirm', model);
	    },
	
	    deleteModel: function (model) {
	        var callback = function () {
	            this.triggerMethod('on:contact:action', {mode: 'delete', data: model});
	        };
	        this.triggerMethod('on:action', {
	            callback: callback,
	            mode: 'delete'
	        });
	    },
	
	    contactHover: function (hovered) {
	        this.triggerMethod('contact:hover', hovered);
	    }
	});
	
	var ContactsTableView = Marionette.View.extend({
	    tagName: 'div',
	    className: 'contacts-table',
	    template: __webpack_require__(252),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        confirmationModal: '#yes-no-confirmation-modal'
	    },
	
	    childViewEvents: {
	        'action:confirmed': 'saveConfirmed',
	        'update:model:wo:confirm': 'updateModelWoConfirm',
	        'on:action': 'onAction',
	        'contact:hover': 'contactHover'
	    },
	
	    ui: {
	        addBtn: '#add-contact',
	        addAddressBtn: '#add-address'
	    },
	
	    events: {
	        'click @ui.addBtn': 'addNewContact',
	        'click @ui.addAddressBtn': 'addNewAddress'
	    },
	
	    callback: undefined,
	
	    templateContext: function () {
	        return {
	            canEdit: this.canEdit,
	            simpleView: this.simpleView || false
	        }
	    },
	
	    onRender: function () {
	        this.showChildView('body', new ContactsTableBody({
	            collection: this.collection,
	            canEdit: this.canEdit,
	            simpleView: this.simpleView
	        }));
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'saveConfirmed', 'onAction', 'addNewContact', 'addNewAddress', 'updateModelWoConfirm', 'contactHover');
	        this.collection = options.collection;
	        this.canEdit = options.canEdit;
	        this.simpleView = options.simpleView || false;
	        this.actionsWoConfirmation = options.actionsWoConfirmation;
	    },
	
	    renderConfirmationModal: function (mode) {
	        this.confirmationalModal = new YesNoConfirmationModal({message: 'You are going to ' + mode + ' contact. Are you sure?'});
	        this.showChildView('confirmationModal', this.confirmationalModal);
	        this.confirmationalModal.show();
	    },
	
	    onAction: function (data) {
	        this.callback = data.callback;
	        if (typeof this.callback !== "function")
	            return;
	        if (this.actionsWoConfirmation) {
	            this.callback();
	        } else
	            this.renderConfirmationModal(data.mode);
	    },
	
	    saveConfirmed: function (data) {
	        if (data.result == true) {
	            this.callback();
	        }
	        else {
	            this.confirmationalModal.hide();
	        }
	    },
	
	    addNewContact: function () {
	        this.triggerMethod('on:contact:action', {mode: 'add', data: ''});
	    },
	
	    addNewAddress: function () {
	        this.triggerMethod('on:address:action', {mode: 'add', data: ''});
	    },
	
	    updateModelWoConfirm: function (model) {
	        this.triggerMethod('on:contact:action', {mode: 'save', data: model});
	    },
	
	    contactHover: function (hovered) {
	        this.triggerMethod('contact:hover', hovered);
	    },
	
	    add: function (model) {
	        this.collection.add(model);
	    }
	});
	
	module.exports = ContactsTableView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td>'+
	((__t=( typeRepresentation(type) ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( data ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( (extension || '') ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( usage ))==null?'':__t)+
	'</td>\r\n';
	 if (!simpleView) { 
	__p+='\r\n<td><input type="checkbox" id="preferred" value="preferred" ';
	 if (preferred) { 
	__p+=' checked ';
	 } 
	__p+='\r\n    ';
	 if (!canEdit) { 
	__p+=' disabled ';
	 } 
	__p+=' ></td>\r\n<td>'+
	((__t=( priority ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( dateFrom ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( dateTo ))==null?'':__t)+
	'</td>\r\n';
	 } 
	__p+='\r\n';
	 if (simpleView) { 
	__p+='\r\n<td>'+
	((__t=( comment ))==null?'':__t)+
	'</td>\r\n';
	 } 
	__p+='\r\n\r\n<td><a href="/#history/'+
	((__t=( clearedReceiver() ))==null?'':__t)+
	'" target="_blank"><span class="glyphicon glyphicon-time clickable"/></a></td>\r\n';
	 if (canEdit) { 
	__p+='\r\n<td><span class="glyphicon glyphicon-edit clickable" id="contact-edit" rel-id="'+
	((__t=( data ))==null?'':__t)+
	'"/></td>\r\n<td><span class="glyphicon glyphicon-remove clickable" id="contact-delete" rel-id="'+
	((__t=( data ))==null?'':__t)+
	'"/></td>\r\n';
	 } 
	__p+='\r\n<td>'+
	((__t=( source || 'MANUAL' ))==null?'':__t)+
	'</td>';
	}
	return __p;
	};


/***/ }),
/* 252 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<table class="table table-hover">\r\n    <thead>\r\n    <tr>\r\n        <th>Type</th>\r\n        <th>Destination</th>\r\n        <th>Extension</th>\r\n        <th>Usage</th>\r\n        ';
	 if (!simpleView) { 
	__p+='\r\n        <th>Send docs?</th>\r\n        <th>Preference</th>\r\n        <th>From</th>\r\n        <th>To</th>\r\n        ';
	 } 
	__p+='\r\n        ';
	 if (simpleView) { 
	__p+='\r\n        <th>Comment</th>\r\n        ';
	 } 
	__p+='\r\n        <th>History</th>\r\n        ';
	 if (canEdit) { 
	__p+='\r\n        <th>Edit</th>\r\n        <th>Delete</th>\r\n        ';
	 } 
	__p+='\r\n        <th>Creation Source</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody></tbody>\r\n</table>\r\n';
	 if (canEdit) { 
	__p+='\r\n<div class="left-buttons">\r\n    <button type="button" class="btn btn-success" id="add-contact">Add New Contact</button>\r\n</div>\r\n';
	 } 
	__p+='\r\n<div id="yes-no-confirmation-modal"></div>';
	}
	return __p;
	};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	
	
	var ContactsCollection = BaseCollection.extend({
	
	    initialize: function(models, options){
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    }
	});
	
	
	module.exports = ContactsCollection;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	var Dicts = __webpack_require__(193);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var ContactFormView = Marionette.View.extend({
	    template: __webpack_require__(255),
	
	    ui: {
	        save: '#save-contact',
	        type: '#contact-type',
	        data: '#data',
	        extension: '#extension',
	        comment: '#comment',
	        preferred: '#preferred',
	        priority: '#priority',
	        addresses: '#addresses',
	        representatives: '#representatives',
	        cancel: '#cancel-contact',
	        usage: '#usage',
	        dateFrom: '#date-from',
	        dateTo: '#date-to'
	    },
	
	    events: {
	        'click @ui.save': 'saveContact',
	        'click @ui.cancel': 'cancel',
	        'change @ui.type': 'typeChanged',
	        'keyup @ui.data': 'dataChanged',
	        'keyup @ui.extension': 'extensionChanged',
	        'keyup @ui.comment': 'commentChanged',
	        'click @ui.preferred': 'preferredChanged',
	        'change @ui.priority': 'priorityChange',
	        'change @ui.addresses': 'addressesChanged',
	        'change @ui.representatives': 'representativesChanged',
	        'change @ui.usage': 'usageChanged'
	    },
	
	    default: {
	        contact: {
	            type: "EMAIL",
	            data: undefined,
	            preferred: false,
	            priority: 5,
	            source: 'MANUAL',
	            extension: null,
	            addresses: [],
	            comment: null,
	            from: 0,
	            to: 0,
	            usage: null
	        }
	    },
	
	    templateContext: function () {
	        var dateFrom = this.contact.from == 0 ? '' : this.utils.longToDateTimeFormatted(Number(this.contact.from), 'MM/DD/YYYY');
	        var dateTo = this.contact.to == 0 ? '' : this.utils.longToDateTimeFormatted(Number(this.contact.to), 'MM/DD/YYYY');
	        return {
	            title: this.mode == 'add' ? 'New Contact' : "Edit Contact",
	            mode: this.mode == 'add' ? 'Add' : "Edit",
	            contact: this.contact,
	            addresses: this.addresses,
	            representatives: this.representatives,
	            contactTypes: this.utils.getContactTypes(),
	            priorities: this.utils.getContactPriorities(),
	            addressUsages: Dicts.addressUsages,
	            dateFrom: dateFrom,
	            dateTo: dateTo
	        };
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'saveContact', 'typeChanged', 'dataChanged', 'preferredChanged', 'priorityChange', 'addressesChanged', 'usageChanged', 'cancel');
	        if (options) {
	            this.contact = options.contact || _.clone(this.default.contact);
	            this.contact.source = _.isEmpty(this.contact.source) ? 'MANUAL' : this.contact.source;
	            this.mode = options.mode;
	            this.addresses = options.addresses;
	            this.representatives = options.representatives;
	        }
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	        this.ui.type.selectize({
	            allowEmptyOption: false
	        });
	        this.ui.priority.selectize({
	            allowEmptyOption: false
	        });
	        this.ui.addresses.selectize({
	            allowEmptyOption: true
	        });
	        this.ui.representatives.selectize({
	            allowEmptyOption: true
	        });
	        this.ui.usage.selectize({
	            allowEmptyOption: false
	        });
	
	        this.ui.dateFrom.datepicker({
	            format: 'mm/dd/yyyy',
	            autoclose: true,
	            clearBtn: true
	        });
	        this.ui.dateTo.datepicker({
	            format: 'mm/dd/yyyy',
	            autoclose: true,
	            clearBtn: true
	        });
	    },
	
	    saveContact: function () {
	        if (_.isEmpty(this.contact.type)) {
	            notificationsChannel.request('show:notification', 'The type of the contact must be set');
	            return;
	        }
	        if (_.isEmpty(this.contact.data) && this.contact.type !== "REVIEW_AND_SIGN") {
	            notificationsChannel.request('show:notification', 'The value of the contact must be set');
	            return;
	        }
	        if (this.contact.type == "EMAIL" && !this.utils.isValidEmail(this.contact.data)) {
	            notificationsChannel.request('show:notification', 'Invalid e-mail value');
	            return;
	        }
	
	        if (!this.contact.priority) {
	            this.contact.priority = this.default.contact.priority;
	        }
	
	        this.contact.from = this.utils.dateToLong(this.ui.dateFrom.val());
	        this.contact.to = this.utils.dateToLong(this.ui.dateTo.val());
	
	        this.triggerMethod('on:contact:saved', {mode: this.mode, contact: this.contact});
	    },
	
	    typeChanged: function (event) {
	        this.contact.type = event.target.value;
	    },
	
	    dataChanged: function (event) {
	        this.contact.data = event.target.value;
	    },
	
	    extensionChanged: function(event) {
	        this.contact.extension = event.target.value;
	    },
	
	    commentChanged: function(event){
	        this.contact.comment = event.target.value;
	    },
	
	    preferredChanged: function (event) {
	        this.contact.preferred = event.target.checked;
	    },
	
	    addressChanged: function(event) {
	        this.contact.address = event.target.value;
	    },
	    usageChanged: function (event) {
	        this.contact.usage = event.target.value;
	    },
	
	    addressesChanged: function(event) {
	        var that = this;
	        this.contact.addresses = [];
	        $("#addresses :selected").each(function(){
	            that.contact.addresses.push($(this).val());
	        });
	    },
	
	    representativesChanged: function() {
	        var that = this;
	        this.contact.representatives = [];
	        $("#representatives :selected").each(function(){
	            that.contact.representatives.push($(this).val());
	        });
	    },
	
	    priorityChange: function(event) {
	        this.contact.priority = event.target.value;
	    },
	
	    cancel: function () {
	        this.triggerMethod('on:contact:action', {mode: 'cancel'});
	    }
	
	});
	
	module.exports = ContactFormView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form-horizontal col-md-offset-6 col-xs-offset-6 col-md-6 col-xs-6">\r\n    <h4 class="center">'+
	((__t=( title ))==null?'':__t)+
	'</h4>\r\n    <div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="contact-type">Contact Type</label>\r\n            <div class="col-md-9">\r\n                <select id="contact-type" data-placeholder="Contact Type" value="'+
	((__t=( contact.type ))==null?'':__t)+
	'">\r\n                    ';
	 _.each(_.keys(contactTypes), function(key){ 
	__p+='\r\n                    ';
	 if (key == contact.type || key == "EMAIL") { 
	__p+='\r\n                    <option value="'+
	((__t=( key ))==null?'':__t)+
	'" name="'+
	((__t=( key ))==null?'':__t)+
	'" selected> '+
	((__t=( contactTypes[key] ))==null?'':__t)+
	'</option>\r\n                    ';
	 } else { 
	__p+='\r\n                    <option value="'+
	((__t=( key ))==null?'':__t)+
	'" name="'+
	((__t=( key ))==null?'':__t)+
	'"> '+
	((__t=( contactTypes[key] ))==null?'':__t)+
	'</option>\r\n                    ';
	 } 
	__p+='\r\n                    ';
	 }) 
	__p+='\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="data">Destination</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="data" placeholder="Data" required=""\r\n                       value="'+
	((__t=( contact.data ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="extension">Extension</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="extension" placeholder="Extension" value="'+
	((__t=( contact.extension ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="usage">Association</label>\r\n            <div class="col-md-9">\r\n                <select id="usage" data-placeholder="Usage">\r\n                    <option value=""></option>\r\n                    ';
	 _.each(_.keys(addressUsages), function(key){ 
	__p+='\r\n                    <option value="'+
	((__t=( key ))==null?'':__t)+
	'"  ';
	 if (contact.usage==key) { 
	__p+='  selected="true" ';
	 } 
	__p+=' >'+
	((__t=( addressUsages[key] ))==null?'':__t)+
	'</option>\r\n                    ';
	 }) 
	__p+='\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="preferred">Primary?</label>\r\n            <div class="checkbox col-md-9">\r\n                <input type="checkbox" id="preferred" value="preferred" style="margin-left: 10px;" ';
	 if (contact.preferred) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="priority">Preference</label>\r\n            <div class="col-md-9">\r\n                <select id="priority" data-placeholder="Contact priority" value="'+
	((__t=( contact.priority ))==null?'':__t)+
	'">\r\n                    ';
	 _.each(_.keys(priorities), function(priority){ 
	__p+='\r\n                    ';
	 if (priority == contact.priority) { 
	__p+='\r\n                    <option value="'+
	((__t=( priority ))==null?'':__t)+
	'" name="'+
	((__t=( priorities[priority] ))==null?'':__t)+
	'" selected> '+
	((__t=( priorities[priority] ))==null?'':__t)+
	'</option>\r\n                    ';
	 } else { 
	__p+='\r\n                    <option value="'+
	((__t=( priority ))==null?'':__t)+
	'" name="'+
	((__t=( priorities[priority] ))==null?'':__t)+
	'" > '+
	((__t=( priorities[priority] ))==null?'':__t)+
	'</option>\r\n                    ';
	 } 
	__p+='\r\n                    ';
	 }) 
	__p+='\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="date-from">From</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="date-from" value="'+
	((__t=( dateFrom ))==null?'':__t)+
	'" onkeypress="return false;" placeholder="Date">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="date-to">To</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="date-to" value="'+
	((__t=( dateTo ))==null?'':__t)+
	'" onkeypress="return false;" placeholder="Date">\r\n            </div>\r\n        </div>\r\n        ';
	 if (addresses && addresses.length > 0) { 
	__p+='\r\n        <div>\r\n            <div class="form-group">\r\n                <label class="col-md-3 control-label" for="addresses">Addresses</label>\r\n                <div class="col-md-9">\r\n                    <select id="addresses" data-placeholder="Related addresses" multiple="multiple">\r\n                        <option value=""></option>\r\n                        ';
	 _.each(addresses, function(address, index){ 
	__p+='\r\n                        <option value="'+
	((__t=( address.uuid ))==null?'':__t)+
	'" ';
	 if((contact.addresses ||[]).indexOf(address.uuid) > -1){ 
	__p+=' selected="true" ';
	 } 
	__p+=' >\r\n                        '+
	((__t=( index + 1 ))==null?'':__t)+
	' - '+
	((__t=( address.address ))==null?'':__t)+
	' '+
	((__t=( address.town ))==null?'':__t)+
	' '+
	((__t=( address.state ))==null?'':__t)+
	' '+
	((__t=( address.zip ))==null?'':__t)+
	'\r\n                        </option>\r\n                        ';
	 }) 
	__p+='\r\n                    </select>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        ';
	 } 
	__p+='\r\n        ';
	 if (representatives && representatives.length > 0) { 
	__p+='\r\n        <div>\r\n            <div class="form-group">\r\n                <label class="col-md-3 control-label" for="representatives">Representatives</label>\r\n                <div class="col-md-9">\r\n                    <select id="representatives" data-placeholder="Related representatives" multiple="multiple">\r\n                        <option value=""></option>\r\n                        ';
	 _.each(representatives, function(representative, index){ 
	__p+='\r\n                        <option value="'+
	((__t=( representative.uuid ))==null?'':__t)+
	'" ';
	 if((contact.representatives ||[]).indexOf(representative.uuid) > -1){ 
	__p+=' selected="true" ';
	 } 
	__p+=' >\r\n                        '+
	((__t=( index + 1 ))==null?'':__t)+
	' - '+
	((__t=( representative.type ))==null?'':__t)+
	' '+
	((__t=( representative.name ))==null?'':__t)+
	' '+
	((__t=( representative.npi ))==null?'':__t)+
	'\r\n                        </option>\r\n                        ';
	 }) 
	__p+='\r\n                    </select>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        ';
	 } 
	__p+='\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="comment">Comment</label>\r\n            <div class="col-md-9">\r\n                <textarea class="form-control" rows="2" id="comment">'+
	((__t=( contact.comment ))==null?'':__t)+
	'</textarea>\r\n            </div>\r\n        </div>\r\n        <div class="right-buttons">\r\n            <button type="button" class="btn btn-success" id="save-contact">'+
	((__t=( mode ))==null?'':__t)+
	'</button>\r\n            <button type="button" class="btn btn-danger" id="cancel-contact">Cancel</button>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	var YesNoConfirmationModal = __webpack_require__(237);
	
	var Dicts = __webpack_require__(193);
	var CommonUtils = __webpack_require__(189);
	
	var utils = new CommonUtils();
	
	var AddressRowView = Marionette.View.extend({
	    tagName: 'tr',
	    className: 'address-row clickable',
	    template: __webpack_require__(257),
	
	    ui: {
	        td: 'td'
	    },
	
	    events: {
	        'click #address-delete': 'removeAddress',
	        'click #address-edit': 'editAddress',
	        'click @ui.td': 'onRowSelected'
	    },
	
	    addressHovered: false,
	
	    templateContext: function () {
	        var that = this;
	        return {
	            usage: Dicts.addressUsages[that.model.get('usage')] || '',
	            canEdit: that.getOption('canEdit')
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'removeAddress', 'editAddress', 'onRowSelected');
	        this.className = this.model.get('uuid');
	    },
	
	    removeAddress: function (event) {
	        this.triggerMethod('delete:model', this.model);
	    },
	
	    editAddress: function (event) {
	        this.triggerMethod('update:model', this.model);
	    },
	
	    onRowSelected: function () {
	        var that = this;
	        this.addressHovered = !this.addressHovered;
	        this.triggerMethod('address:hover', {hovered: this.addressHovered, uuid: that.model.get('uuid')});
	
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(5), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var AddressTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: AddressRowView,
	    emptyView: EmptyView,
	
	    childViewEvents: {
	        'update:model': 'updateModel',
	        'update:model:wo:confirm': 'updateModelWoConfirm',
	        'delete:model': 'deleteModel',
	        'address:hover': 'addressHover'
	    },
	
	    childViewOptions: function () {
	        var that = this;
	        return {
	            canEdit: that.getOption('canEdit')
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'updateModel', 'deleteModel', 'updateModelWoConfirm', 'addressHover');
	        this.collection = options.collection;
	    },
	
	    updateModel: function (model) {
	        var callback = function () {
	            this.triggerMethod('on:address:action', {mode: 'edit', data: model});
	        };
	        this.triggerMethod('on:action', {
	            callback: callback,
	            mode: 'edit'
	        });
	    },
	
	    updateModelWoConfirm: function (model) {
	        this.triggerMethod('update:model:wo:confirm', model);
	    },
	
	    deleteModel: function (model) {
	        var callback = function () {
	            this.triggerMethod('on:address:action', {mode: 'delete', data: model});
	        };
	        this.triggerMethod('on:action', {
	            callback: callback,
	            mode: 'delete'
	        });
	    },
	    addressHover: function (hovered) {
	        this.triggerMethod('address:hover', hovered);
	    }
	});
	
	var AddressesTableView = Marionette.View.extend({
	    tagName: 'div',
	    className: 'contacts-table',
	    template: __webpack_require__(258),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        confirmationModal: '#yes-no-confirmation-modal'
	    },
	
	    childViewEvents: {
	        'action:confirmed': 'saveConfirmed',
	        'update:model:wo:confirm': 'updateModelWoConfirm',
	        'on:action': 'onAction',
	        'address:hover': 'addressHover'
	    },
	
	    ui: {
	        addAddressBtn: '#add-address'
	    },
	
	    events: {
	        'click @ui.addAddressBtn': 'addNewAddress'
	    },
	
	    callback: undefined,
	
	    templateContext: function () {
	        return {
	            canEdit: this.canEdit
	        }
	    },
	
	    onRender: function () {
	        this.showChildView('body', new AddressTableBody({
	            collection: this.collection,
	            canEdit: this.canEdit
	        }));
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'saveConfirmed', 'onAction', 'addNewAddress', 'updateModelWoConfirm', 'addressHover');
	        this.collection = options.collection;
	        this.canEdit = options.canEdit;
	    },
	
	    renderConfirmationModal: function(mode) {
	        this.confirmationalModal = new YesNoConfirmationModal({message: 'You are going to ' + mode + ' address. Are you sure?'});
	        this.showChildView('confirmationModal', this.confirmationalModal);
	        this.confirmationalModal.show();
	    },
	
	    onAction: function (data) {
	        this.callback = data.callback;
	        if (typeof this.callback !== "function")
	            return;
	        this.renderConfirmationModal(data.mode);
	    },
	
	    saveConfirmed: function (data) {
	        if (data.result == true) {
	            this.callback();
	        }
	        else {
	            this.confirmationalModal.hide();
	        }
	    },
	
	    addNewAddress: function () {
	        this.triggerMethod('on:address:action', {mode: 'add', data: ''});
	    },
	
	    updateModelWoConfirm: function (model) {
	        this.triggerMethod('on:address:action', {mode: 'save', data: model});
	    },
	    addressHover: function (hovered) {
	        this.triggerMethod('address:hover', hovered);
	    }
	});
	
	module.exports = AddressesTableView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'">'+
	((__t=( source || 'MANUAL' ))==null?'':__t)+
	'</td>\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'">'+
	((__t=( town ))==null?'':__t)+
	'</td>\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'">'+
	((__t=( state ))==null?'':__t)+
	'</td>\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'">'+
	((__t=( zip ))==null?'':__t)+
	'</td>\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'">'+
	((__t=( address ))==null?'':__t)+
	'</td>\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'">'+
	((__t=( usage ))==null?'':__t)+
	'</td>\r\n';
	 if (canEdit) { 
	__p+='\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'"><span class="glyphicon glyphicon-edit clickable" id="address-edit" rel-id="'+
	((__t=( uuid ))==null?'':__t)+
	'"/></td>\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'"><span class="glyphicon glyphicon-remove clickable" id="address-delete" rel-id="'+
	((__t=( uuid ))==null?'':__t)+
	'"/></td>\r\n';
	 } 
	__p+='';
	}
	return __p;
	};


/***/ }),
/* 258 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<table class="table table-hover">\r\n    <thead>\r\n    <tr>\r\n        <th>Creation source</th>\r\n        <th>Town</th>\r\n        <th>State</th>\r\n        <th>ZIP</th>\r\n        <th>Address</th>\r\n        <th>Usage</th>\r\n        ';
	 if (canEdit) { 
	__p+='\r\n        <th>Edit</th>\r\n        <th>Delete</th>\r\n        ';
	 } 
	__p+='\r\n    </tr>\r\n    </thead>\r\n    <tbody></tbody>\r\n</table>\r\n';
	 if (canEdit) { 
	__p+='\r\n<div class="left-buttons">\r\n    <button type="button" class="btn btn-success" id="add-address">Add new address</button>\r\n</div>\r\n';
	 } 
	__p+='\r\n<div id="yes-no-confirmation-modal"></div>';
	}
	return __p;
	};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	var Dicts = __webpack_require__(193);
	
	var RemoteSuggesterView = __webpack_require__(196);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var AddressFormView = Marionette.View.extend({
	    template: __webpack_require__(260),
	
	    ui: {
	        cancel: '#cancel-address',
	        save: '#save-address',
	        zip: '#zip',
	        address: '#address-input',
	        town: '#town',
	        state: '#state',
	        usage: '#usage'
	    },
	
	    regions: {
	        stateSelect: '#state-select'
	    },
	
	    events: {
	        'click @ui.save': 'saveAddress',
	        'click @ui.cancel': 'cancel',
	        'keyup @ui.zip': 'zipChanged',
	        'keyup @ui.address': 'addressChanged',
	        'keyup @ui.town': 'townChanged',
	        'change @ui.state': 'stateChanged',
	        'change @ui.usage': 'usageChanged'
	    },
	
	    templateContext: function () {
	        return {
	            title: this.mode == 'add' ? 'New address' : "Edit address",
	            mode: this.mode == 'add' ? 'Add' : "Edit",
	            address: this.address,
	            addressUsages: Dicts.addressUsages
	        };
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'saveAddress', 'zipChanged', 'addressChanged', 'townChanged', 'stateChanged', 'onRender', 'usageChanged', 'cancel');
	        this.utils = new CommonUtils();
	        if (options) {
	            this.address = options.address || {uuid: this.utils.generatedUUID(), source: 'MANUAL'};
	            this.address.source = _.isEmpty(this.address.source) ? 'MANUAL' : this.address.source;
	            this.mode = options.mode;
	        }
	    },
	
	    onRender: function () {
	        this.ui.usage.selectize({
	            allowEmptyOption: false
	        });
	
	        this.showStateSelect();
	    },
	
	    saveAddress: function () {
	        if (_.isEmpty(this.address.address)) {
	            notificationsChannel.request('show:notification', 'Address must be set');
	            return;
	        }
	
	        this.triggerMethod('on:address:saved', {mode: this.mode, address: this.address});
	    },
	
	    zipChanged: function (event) {
	        this.address.zip = event.target.value;
	    },
	
	    addressChanged: function (event) {
	        this.address.address = event.target.value;
	    },
	    stateChanged: function (event) {
	        this.address.state = event.target.value;
	    },
	    townChanged: function (event) {
	        this.address.town = event.target.value;
	    },
	    usageChanged: function (event) {
	        this.address.usage = event.target.value;
	    },
	
	
	    showStateSelect: function () {
	        var that = this;
	
	        that.showChildView('stateSelect', new RemoteSuggesterView({
	            tag: 'state',
	            inputId: 'state',
	            maxNumberOfElements: 20,
	            url: '/api/reference/states/~~~',
	            symbolForSearchInUrl: '~~~',
	            defaultSelected: that.address.state,
	            listLocation: function (data) {
	                return data;
	            },
	            getValueFn: function (element) {
	                return element;
	            },
	            classes: ["form-control normal-width"],
	            placeholder: "Select state",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return arr[index] || null;
	            }
	        }));
	    },
	
	    cancel: function () {
	        this.triggerMethod('on:address:action', {mode: 'cancel'});
	    }
	
	});
	
	module.exports = AddressFormView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form-horizontal col-md-offset-6 col-xs-offset-6 col-md-6 col-xs-6">\r\n    <div>\r\n\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="town">Town</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="town" placeholder="Town" required=""\r\n                       value="'+
	((__t=( address.town ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label">State</label>\r\n            <div class="col-md-9">\r\n                <div id="state-select"></div>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="zip">Zip code</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="zip" placeholder="Zip code" required=""\r\n                       value="'+
	((__t=( address.zip ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="address-input">Address</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="address-input" placeholder="Address line" required=""\r\n                       value="'+
	((__t=( address.address ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="usage">Usage</label>\r\n            <div class="col-md-9">\r\n                <select id="usage" data-placeholder="Usage">\r\n                    <option value=""></option>\r\n                    ';
	 _.each(_.keys(addressUsages), function(key){ 
	__p+='\r\n                    <option value="'+
	((__t=( key ))==null?'':__t)+
	'"  ';
	 if (address.usage==key) { 
	__p+='  selected="true" ';
	 } 
	__p+=' >'+
	((__t=( addressUsages[key] ))==null?'':__t)+
	'</option>\r\n                    ';
	 }) 
	__p+='\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div class="right-buttons">\r\n            <button type="button" class="btn btn-success" id="save-address">'+
	((__t=( mode ))==null?'':__t)+
	'</button>\r\n            <button type="button" class="btn btn-danger" id="cancel-address">Cancel</button>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	var YesNoConfirmationModal = __webpack_require__(237);
	
	var Dicts = __webpack_require__(193);
	var CommonUtils = __webpack_require__(189);
	
	var utils = new CommonUtils();
	
	var RepresentativeRowView = Marionette.View.extend({
	    tagName: 'tr',
	    className: 'representative-row clickable',
	    template: __webpack_require__(262),
	
	    ui: {
	        td: 'td'
	    },
	
	    events: {
	        'click #representative-delete': 'removeRepresentative',
	        'click #representative-edit': 'editRepresentative',
	        'click @ui.td': 'onRowSelected'
	    },
	
	    representativeHovered: false,
	
	    templateContext: function () {
	        var that = this;
	        var contactorObj = this.model.get('personToContact') || {};
	        var contactorDistplay = (contactorObj.prefix || "") + " " + (contactorObj.firstName || "") + " " + (contactorObj.lastName || "");
	        if (this.model.get('personToContactType')){
	            contactorDistplay = this.model.get('personToContactType') + ": " + contactorDistplay;
	        }
	        return {
	            canEdit: that.getOption('canEdit'),
	            contactor: contactorDistplay,
	            link: function () {
	                var link = "";
	                var entityId = that.model.get('entityId');
	                var name = that.model.get('name');
	                if (!_.isEmpty(entityId) && !_.isEmpty(name)) {
	                    var type = that.model.get('type');
	                    if (type === "PERSON")
	                        link = '<a href="/#person/' + entityId + '" target="_blank">' + name + '</a>';
	                    else if (type === "ORGANIZATION")
	                        link = '<a href="/#organization/' + entityId + '" target="_blank">' + name + '</a>';
	                }
	                return link;
	            }
	        }
	    },
	
	    initialize: function (options) {
	        //_.bindAll(this, 'removeAddress', 'editAddress', 'onRowSelected');
	        this.className = this.model.get('uuid');
	    },
	
	    removeRepresentative: function (event) {
	        this.triggerMethod('delete:model', this.model);
	    },
	
	    editRepresentative: function (event) {
	        this.triggerMethod('update:model', this.model);
	    },
	
	    onRowSelected: function () {
	        var that = this;
	        this.representativeHovered = !this.representativeHovered;
	        this.triggerMethod('representative:hover', {hovered: this.representativeHovered, uuid: that.model.get('uuid')});
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(5), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var RepresentativeTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: RepresentativeRowView,
	    emptyView: EmptyView,
	
	    childViewEvents: {
	        'update:model': 'updateModel',
	        'update:model:wo:confirm': 'updateModelWoConfirm',
	        'delete:model': 'deleteModel',
	        'representative:hover': 'representativeHover'
	    },
	
	    childViewOptions: function () {
	        var that = this;
	        return {
	            canEdit: that.getOption('canEdit')
	        }
	    },
	
	    initialize: function (options) {
	        //_.bindAll(this, 'updateModel', 'deleteModel', 'updateModelWoConfirm', 'addressHover');
	        this.collection = options.collection;
	    },
	
	    updateModel: function (model) {
	        var callback = function () {
	            this.triggerMethod('on:representative:action', {mode: 'edit', data: model});
	        };
	        this.triggerMethod('on:action', {
	            callback: callback,
	            mode: 'edit'
	        });
	    },
	
	    updateModelWoConfirm: function (model) {
	        this.triggerMethod('update:model:wo:confirm', model);
	    },
	
	    deleteModel: function (model) {
	        var callback = function () {
	            this.triggerMethod('on:representative:action', {mode: 'delete', data: model});
	        };
	        this.triggerMethod('on:action', {
	            callback: callback,
	            mode: 'delete'
	        });
	    },
	
	    representativeHover: function (hovered) {
	        this.triggerMethod('representative:hover', hovered);
	    }
	});
	
	var RepresentativesTableView = Marionette.View.extend({
	    tagName: 'div',
	    className: 'representatives-table',
	    template: __webpack_require__(263),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        confirmationModal: '#yes-no-confirmation-modal'
	    },
	
	    childViewEvents: {
	        'action:confirmed': 'saveConfirmed',
	        'update:model:wo:confirm': 'updateModelWoConfirm',
	        'on:action': 'onAction',
	        'representative:hover': 'representativeHover'
	    },
	
	    ui: {
	        addRepresentative: '#add-representative'
	    },
	
	    events: {
	        'click @ui.addRepresentative': 'addNewRepresentative'
	    },
	
	    callback: undefined,
	
	    templateContext: function () {
	        return {
	            canEdit: this.canEdit
	        }
	    },
	
	    onRender: function () {
	        this.showChildView('body', new RepresentativeTableBody({
	            collection: this.collection,
	            canEdit: this.canEdit
	        }));
	    },
	
	    initialize: function (options) {
	        //_.bindAll(this, 'saveConfirmed', 'onAction', 'addNewAddress', 'updateModelWoConfirm', 'addressHover');
	        this.collection = options.collection;
	        this.canEdit = options.canEdit;
	    },
	
	    renderConfirmationModal: function(mode) {
	        this.confirmationalModal = new YesNoConfirmationModal({message: 'You are going to ' + mode + ' representative. Are you sure?'});
	        this.showChildView('confirmationModal', this.confirmationalModal);
	        this.confirmationalModal.show();
	    },
	
	    onAction: function (data) {
	        this.callback = data.callback;
	        if (typeof this.callback !== "function")
	            return;
	        this.renderConfirmationModal(data.mode);
	    },
	
	    saveConfirmed: function (data) {
	        if (data.result == true) {
	            this.callback();
	        }
	        else {
	            this.confirmationalModal.hide();
	        }
	    },
	
	    addNewRepresentative: function () {
	        this.triggerMethod('on:representative:action', {mode: 'add', data: ''});
	    },
	
	    updateModelWoConfirm: function (model) {
	        this.triggerMethod('on:representative:action', {mode: 'save', data: model});
	    },
	
	    representativeHover: function (hovered) {
	        this.triggerMethod('representative:hover', hovered);
	    }
	});
	
	module.exports = RepresentativesTableView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'">'+
	((__t=( type ))==null?'':__t)+
	'</td>\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'" hidden>'+
	((__t=( npi ))==null?'':__t)+
	'</td>\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'">'+
	((__t=( link() ))==null?'':__t)+
	'</td>\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'">'+
	((__t=( relation ))==null?'':__t)+
	'</td>\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'">'+
	((__t=( contactor ))==null?'':__t)+
	'</td>\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'">'+
	((__t=( comment ))==null?'':__t)+
	'</td>\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'" hidden>'+
	((__t=( entityId ))==null?'':__t)+
	'</td>\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'" hidden>'+
	((__t=( groupUuid ))==null?'':__t)+
	'</td>\r\n';
	 if (canEdit) { 
	__p+='\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'"><span class="glyphicon glyphicon-edit clickable" id="representative-edit" rel-id="'+
	((__t=( uuid ))==null?'':__t)+
	'"/></td>\r\n<td class="'+
	((__t=( uuid ))==null?'':__t)+
	'"><span class="glyphicon glyphicon-remove clickable" id="representative-delete" rel-id="'+
	((__t=( uuid ))==null?'':__t)+
	'"/></td>\r\n';
	 } 
	__p+='';
	}
	return __p;
	};


/***/ }),
/* 263 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<table class="table table-hover">\r\n    <thead>\r\n    <tr>\r\n        <th>Representative type</th>\r\n        <th hidden>NPI</th>\r\n        <th>Name</th>\r\n        <th>Relation</th>\r\n        <th>To contact</th>\r\n        <th>Comment</th>\r\n        <th hidden>Entity id</th>\r\n        <th hidden>Group id</th>\r\n        ';
	 if (canEdit) { 
	__p+='\r\n        <th>Edit</th>\r\n        <th>Delete</th>\r\n        ';
	 } 
	__p+='\r\n    </tr>\r\n    </thead>\r\n    <tbody></tbody>\r\n</table>\r\n';
	 if (canEdit) { 
	__p+='\r\n<div class="left-buttons">\r\n    <button type="button" class="btn btn-success" id="add-representative">Add new representative</button>\r\n</div>\r\n';
	 } 
	__p+='\r\n<div id="yes-no-confirmation-modal"></div>';
	}
	return __p;
	};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var Person = __webpack_require__(206);
	var Organization = __webpack_require__(208);
	
	var CommonUtils = __webpack_require__(189);
	var Dicts = __webpack_require__(193);
	
	var RemoteSuggesterView = __webpack_require__(196);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var RepresentativeFormView = Marionette.View.extend({
	    template: __webpack_require__(265),
	
	    ui: {
	        cancel: '#cancel-representative',
	        save: '#save-representative',
	
	        type: '#type',
	        npi: '#npi',
	        name: '#name',
	        relation: '#relation',
	        comment: '#comment',
	
	        personToContactType: '#person-to-contact-type',
	        personToContactPrefix: '#contact-person-prefix',
	        personToContactFirstName: '#contact-person-first-name',
	        personToContactLastName: '#contact-person-last-name'
	    },
	
	    regions: {
	        entitySelect: '#entity-select'
	    },
	
	    events: {
	        'click @ui.save': 'saveRepresentation',
	        'click @ui.cancel': 'cancelRepresentation',
	
	        'change @ui.type': 'typeChanged',
	        'keyup @ui.npi': 'npiChanged',
	        'keyup @ui.name': 'nameChanged',
	        'keyup @ui.relation': 'relationChanged',
	        'keyup @ui.comment': 'commentChanged',
	
	        'keyup @ui.personToContactType': 'personToContactTypeChanged',
	        'keyup @ui.personToContactPrefix': 'personToContactPrefixChanged',
	        'keyup @ui.personToContactFirstName': 'personToContactFirstNameChanged',
	        'keyup @ui.personToContactLastName': 'personToContactLastNameChanged'
	    },
	
	    childViewEvents: {
	        'suggestor:selected:person-entity': 'onEntitySelected',
	        'suggestor:selected:organization-entity': 'onEntitySelected'
	    },
	
	    templateContext: function () {
	        return {
	            title: this.mode == 'add' ? 'New representative' : "Edit representative",
	            mode: this.mode == 'add' ? 'Add' : "Edit",
	            representative: this.representative,
	            contactPersonPrefix: (this.representative.personToContact || {}).prefix,
	            contactPersonFirstName: (this.representative.personToContact || {}).firstName,
	            contactPersonLastName: (this.representative.personToContact || {}).lastName,
	        };
	    },
	
	    initialize: function (options) {
	        //_.bindAll(this, 'saveAddress', 'zipChanged', 'addressChanged', 'townChanged', 'stateChanged', 'onRender', 'usageChanged', 'cancel');
	        this.utils = new CommonUtils();
	        if (options) {
	            this.representative = options.representative || {uuid: this.utils.generatedUUID(), groupUuid: this.utils.generatedUUID(), personToContact:{}};
	            if (!this.representative.personToContact){
	                this.representative.personToContact = {};
	            }
	            this.mode = options.mode;
	        }
	    },
	
	    onRender: function () {
	        this.ui.type.selectize({
	            allowEmptyOption: false
	        });
	
	        if (this.representative.type == "PERSON") {
	            this.renderPersonSelect();
	        } else if (this.representative.type == "ORGANIZATION") {
	            this.renderOrganizationSelect();
	        }
	    },
	
	    typeChanged: function (event) {
	        this.representative.type = event.target.value;
	        if (this.representative.type == "PERSON") {
	            this.renderPersonSelect();
	        } else if (this.representative.type == "ORGANIZATION") {
	            this.renderOrganizationSelect();
	        }
	    },
	
	    npiChanged: function (event) {
	        this.representative.npi = event.target.value;
	    },
	
	    nameChanged: function (event) {
	        this.representative.name = event.target.value;
	    },
	
	    relationChanged: function (event) {
	        this.representative.relation = event.target.value;
	    },
	
	    commentChanged: function(event) {
	        this.representative.comment = event.target.value;
	    },
	
	    personToContactTypeChanged: function(event){
	        this.representative.personToContactType = event.target.value;
	    },
	    personToContactPrefixChanged: function(event){
	        this.representative.personToContact.prefix = event.target.value;
	    },
	    personToContactFirstNameChanged: function(event){
	        this.representative.personToContact.firstName = event.target.value;
	    },
	    personToContactLastNameChanged: function(event){
	        this.representative.personToContact.lastName = event.target.value;
	    },
	
	    renderPersonSelect: function () {
	        var that = this;
	        if (_.isEmpty(that.representative.entityId)) {
	            that.renderPersonSuggestor();
	        } else {
	            $.when(
	                $.ajax({
	                    type: "GET",
	                    url: '/api/dbo/preview?id=' + that.representative.entityId + '&type=person'
	                })
	            ).done(function (resp) {
	                if (resp.length > 0) {
	                    that.renderPersonSuggestor(resp[0]);
	                } else {
	                    that.renderPersonSuggestor();
	                }
	            }).fail(function (jqXHR, textStatus) {
	                that.renderPersonSuggestor();
	            });
	        }
	    },
	
	    renderOrganizationSelect: function() {
	        var that = this;
	        if (_.isEmpty(that.representative.entityId)) {
	            that.renderOrganizationSuggestor();
	        } else {
	            $.when(
	                $.ajax({
	                    type: "GET",
	                    url: '/api/dbo/preview?id=' + that.representative.entityId + '&type=organization'
	                })
	            ).done(function (resp) {
	                if (resp.length > 0) {
	                    that.renderOrganizationSuggestor(resp[0]);
	                } else {
	                    that.renderOrganizationSuggestor();
	                }
	            }).fail(function (jqXHR, textStatus) {
	                that.renderOrganizationSuggestor();
	            });
	        }
	    },
	
	    renderPersonSuggestor: function(defaultSelected) {
	        var that = this;
	        this.detachChildView('entitySelect');
	
	        that.showChildView('entitySelect', new RemoteSuggesterView({
	            tag: 'person-entity',
	            inputId: 'entity-id',
	            maxNumberOfElements: 20,
	            url: '/api/dbo/preview?page-size=' + 20 + '&sortby=name&like_name=~~~&type=person',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Person",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return arr[index] || null;
	            },
	            defaultSelected: defaultSelected
	        }));
	    },
	
	    renderOrganizationSuggestor: function(defaultSelected) {
	        var that = this;
	        this.detachChildView('entitySelect');
	
	        that.showChildView('entitySelect', new RemoteSuggesterView({
	            tag: 'organization-entity',
	            inputId: 'entity-id',
	            maxNumberOfElements: 20,
	            url: '/api/dbo/preview?page-size=' + 20 + '&sortby=name&like_name=~~~&type=organization',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Organization",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return arr[index] || null;
	            },
	            defaultSelected: defaultSelected
	        }));
	    },
	
	    cancelRepresentation: function () {
	        this.triggerMethod('on:representative:action', {mode: 'cancel'});
	    },
	
	    saveRepresentation: function () {
	        this.triggerMethod('on:representative:saved', {mode: this.mode, representative: this.representative});
	    },
	
	    onEntitySelected: function(selected) {
	        if (selected == null) return;
	        this.representative.entityId = selected.id;
	        this.representative.npi = selected.object.npi;
	        this.ui.npi.val(selected.object.npi || '');
	        this.representative.name = selected.name;
	        this.ui.name.val(selected.name);
	    }
	
	});
	
	module.exports = RepresentativeFormView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form-horizontal col-md-offset-6 col-xs-offset-6 col-md-6 col-xs-6" xmlns="http://www.w3.org/1999/html"\r\n     xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html">\r\n    <div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="type">Type</label>\r\n            <div class="col-md-9">\r\n                <select id="type" data-placeholder="Usage">\r\n                    <option value=""></option>\r\n                    ';
	 _.each(["PERSON", "ORGANIZATION"], function(type){ 
	__p+='\r\n                    <option value="'+
	((__t=( type ))==null?'':__t)+
	'" ';
	 if (representative.type==type) { 
	__p+='  selected="true" ';
	 } 
	__p+=' >'+
	((__t=( type ))==null?'':__t)+
	'</option>\r\n                    ';
	 }) 
	__p+='\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="relation">Relation</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="relation" placeholder="Relation" value="'+
	((__t=( representative.relation ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label">Entity</label>\r\n            <div class="col-md-9">\r\n                <div id="entity-select"></div>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="npi">NPI</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="npi" placeholder="NPI" value="'+
	((__t=( representative.npi ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="name">Name</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="name" placeholder="Name" value="'+
	((__t=( representative.name ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="person-to-contact-type">Contact person role</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="person-to-contact-type" placeholder="Person to contact role" value="'+
	((__t=( representative.personToContactType ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="contact-person-prefix">Contact person prefix</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" placeholder="Contact person prefix" id="contact-person-prefix" value="'+
	((__t=( contactPersonPrefix ))==null?'':__t)+
	'"/>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="contact-person-first-name">Contact person first name</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" placeholder="Contact person first name" id="contact-person-first-name" value="'+
	((__t=( contactPersonFirstName ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="contact-person-last-name">Contact person last name</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" placeholder="Contact person last name" id="contact-person-last-name" value="'+
	((__t=( contactPersonLastName ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="comment">Comment</label>\r\n            <div class="col-md-9">\r\n                <textarea class="form-control" rows="5" id="comment">'+
	((__t=( representative.comment ))==null?'':__t)+
	'</textarea>\r\n            </div>\r\n        </div>\r\n\r\n        <div class="right-buttons">\r\n            <button type="button" class="btn btn-success" id="save-representative">'+
	((__t=( mode ))==null?'':__t)+
	'</button>\r\n            <button type="button" class="btn btn-danger" id="cancel-representative">Cancel</button>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	var YesNoConfirmationModal = __webpack_require__(237);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var CommentFormView = Marionette.View.extend({
	    template: __webpack_require__(267),
	
	    regions: {
	        confirmationModal: '#yes-no-confirmation-modal'
	    },
	
	    childViewEvents: {
	        'action:confirmed': 'saveConfirmed'
	    },
	
	
	    modelEvents: {
	        change: 'render'
	    },
	
	    ui: {
	        isInternal: "#is-internal",
	        comment: '#text',
	        cancel: '#cancel',
	        send: '#send',
	
	        confirmationModal: '#yes-no-confirmation-modal'
	    },
	
	    events: {
	        'click @ui.isInternal': "validate",
	        'keyup @ui.comment': "validate",
	
	        'click @ui.send': 'onSend',
	        'click @ui.cancel': 'onCancel'
	    },
	
	    templateContext: function () {
	        return {}
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'sendComment');
	        this.model = options.model;
	        if (_.isUndefined(this.model.get("internal")))
	            this.model.set("internal", false);
	        this.dboId = options.dboId;
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	        console.log(this.model.get("internal"));
	        this.confirmationModal = new YesNoConfirmationModal({
	            tag: 'comment-edit',
	            message: "Editing the comment will effect the same comment in other entities. Are you sure you want to edit the comment?"
	        });
	        this.showChildView('confirmationModal', this.confirmationModal);
	    },
	
	    validate: function () {
	        var id = this.model.get('id');
	        if (_.isEmpty(id) && _.isEmpty(this.ui.comment.val())
	            || this.ui.comment.val() === this.model.get('text') && this.ui.isInternal.prop("checked") === this.model.get('internal'))
	            this.ui.send.attr("disabled", true);
	        else
	            this.ui.send.removeAttr("disabled");
	    },
	
	    onSend: function () {
	        var id = this.model.get('id');
	
	        if (_.isEmpty(id)) {
	            this.sendComment();
	        } else {
	            this.confirmationModal.show();
	        }
	    },
	
	    sendComment: function () {
	        var that = this;
	        var comment = that.ui.comment.val();
	        if (_.isEmpty(comment))
	            return;
	
	        that.utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/comment/' + that.dboId + "/" + (that.ui.isInternal.prop("checked") ? "internal" : "external"),
	            data: comment,
	            contentType: 'text/plain',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    that.triggerMethod('comment:added', response);
	                    $.notify({
	                        message: 'The comment added successfully'
	                    }, {
	                        type: 'success',
	                        z_index: 2000,
	                    });
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner();
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            }
	        });
	    },
	
	    updateComment: function () {
	        var that = this;
	        var comment = that.ui.comment.val();
	
	        that.model.set('text', comment);
	        that.model.set('internal', that.ui.isInternal.prop("checked"));
	        that.model.unset('commentedBy', {silent: true});
	        that.model.unset('editedBy', {silent: true});
	
	        that.utils.showSpinner();
	        $.ajax({
	            type: "PUT",
	            url: '/api/comment/' + that.dboId,
	            data: JSON.stringify(that.model.attributes),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    that.triggerMethod('comment:updated', response);
	                    $.notify({
	                        message: 'The comment edited successfully'
	                    }, {
	                        type: 'success',
	                        z_index: 2000,
	                    });
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner();
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            }
	        });
	    },
	
	    onCancel: function () {
	        this.triggerMethod('on:cancel:comment:send');
	    },
	
	    saveConfirmed: function (data) {
	        if (data.tag === 'comment-edit' && data.result == true) {
	            this.updateComment();
	        }
	        else {
	            this.confirmationModal.hide();
	        }
	    }
	});
	
	module.exports = CommentFormView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form-horizontal top-margined">\r\n    ';
	 if (_.isEmpty(id)) { 
	__p+='\r\n    <h4>Add comment</h4>\r\n    ';
	 } else { 
	__p+='\r\n    <h4>Edit comment</h4>\r\n    ';
	 } 
	__p+='\r\n    <div>\r\n        <div class="form-group">\r\n            <label class="checkbox" style="margin-left: 25px;"><input type="checkbox" id="is-internal" ';
	 if (internal) { 
	__p+=' checked ';
	 } 
	__p+=' >Is Internal?</label>\r\n        </div>\r\n        <div class="form-group">\r\n            <textarea class="form-control" rows="5" id="text">'+
	((__t=( text ))==null?'':__t)+
	'</textarea>\r\n        </div>\r\n        <div class="left-buttons">\r\n            <button type="button" class="btn btn-success" id="send" disabled>\r\n                ';
	 if (_.isEmpty(id)) { 
	__p+='\r\n                Send\r\n                ';
	 } else { 
	__p+='\r\n                Update\r\n                ';
	 } 
	__p+='\r\n            </button>\r\n            <button type="button" class="btn btn-success" id="cancel">Cancel</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div id="yes-no-confirmation-modal"></div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var CommentsCollection = __webpack_require__(269);
	var CommonUtils = __webpack_require__(189);
	
	var YesNoConfirmationModal = __webpack_require__(237);
	
	var Radio = __webpack_require__(183);
	var actionsChannel = Radio.channel('actions');
	var notificationsChannel = Radio.channel('notifications');
	
	var utils = new CommonUtils();
	
	var CommentRowView = Marionette.View.extend({
	    tagName: 'div',
	
	    template: __webpack_require__(270),
	
	    ui: {
	        //edit: '.edit-comment',
	        //remove: '.remove-comment'
	        setAsIrrelevant: ".set-as-irrelevant"
	    },
	    events: {
	        //'click @ui.edit': 'onEdit',
	        //'click @ui.remove': 'onRemove'
	        'click @ui.setAsIrrelevant': 'onSetAsIrrelevant'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var commenter = that.model.get('commentedBy');
	        return {
	            creator: commenter ? commenter.name : '',
	            creatorId: commenter ? commenter.id : '',
	            time: utils.longToDateTimeFormatted(Number(that.model.get('time')), 'MMM DD YYYY hh:mm A'),
	            text: (that.model.get('text') || '').replace(/\r?\n/g, '<br />'),
	            canEdit: that.getOption('canEdit'),
	            id: that.model.get('id')
	        }
	    },
	
	    initialize: function (options) {
	    },
	
	    /*onEdit: function () {
	        this.triggerMethod('on:edit:comment', this.model);
	    },
	
	    onRemove: function () {
	        this.triggerMethod('on:remove:comment', this.model);
	    },*/
	
	    onSetAsIrrelevant: function () {
	        this.triggerMethod('on:irrelevant:comment', this.model);
	    }
	});
	
	var CommentsTableBody = Marionette.CollectionView.extend({
	    tagName: 'div',
	    childView: CommentRowView,
	
	    collectionEvents: {},
	
	    childViewEvents: {
	        //'on:edit:comment': 'onEditComment',
	        //'on:remove:comment': 'onRemoveComment'
	        'on:irrelevant:comment': 'onSetAsIrrelevant'
	    },
	
	    childViewOptions: function () {
	        var that = this;
	        return {
	            canEdit: that.getOption('canEdit')
	        };
	    },
	
	    initialize: function (options) {
	        this.collection = options.collection;
	    },
	
	    /*onEditComment: function (model) {
	        this.triggerMethod('on:edit:comment', model);
	    },
	
	    onRemoveComment: function (model) {
	        this.triggerMethod('on:remove:comment', model);
	    },*/
	
	    onSetAsIrrelevant: function (model) {
	        this.triggerMethod('on:irrelevant:comment', model);
	    }
	});
	
	var CommentsTableView = Marionette.View.extend({
	    tagName: 'div',
	    //className: 'comments-table',
	    template: __webpack_require__(271),
	
	    regions: {
	        body: {
	            el: '.list-of-comments',
	            replaceElement: true
	        },
	        confirmationModal: '#confirmation-modal'
	    },
	
	    ui: {
	        scrollToNew: '#scroll-to-add'
	    },
	
	    events: {
	      'click @ui.scrollToNew': 'addNewComment'
	    },
	
	    childViewEvents: {
	        //'on:edit:comment': 'onEditComment',
	        //'on:remove:comment': 'onRemoveComment',
	        'on:irrelevant:comment': 'onSetAsIrrelevant',
	        'action:confirmed': 'onSetAsIrrelevantConfirmed'
	    },
	
	    templateContext: function () {
	        return {}
	    },
	
	    onRender: function () {
	        var that = this;
	        that.collection.fetch({
	            success: function () {
	                that.showChildView('body', new CommentsTableBody({
	                    collection: that.collection,
	                    canEdit: that.getOption('canEdit')
	                }));
	            },
	            error: function (collection, response, options) {
	                if (response.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                }
	            }
	        });
	
	        this.confirmationModal = new YesNoConfirmationModal({
	            tag: 'comment-irrelevant',
	            message: "Set the comment as Irrelevant will effect the same comment in other entities. Are you sure?"
	        });
	        this.showChildView('confirmationModal', this.confirmationModal);
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.dboId = options.dboId;
	        that.collection = new CommentsCollection();
	        that.collection.url = this.collection.url + "/" + this.dboId;
	    },
	
	    add: function (commentModel) {
	        this.collection.add(commentModel, {at: 0});
	        this.triggerMethod('comment:count:changed');
	    },
	
	    update: function (commentModel) {
	        var oldModel = this.collection.findWhere({id: commentModel.id});
	        var oldModelIndex = this.collection.indexOf(oldModel);
	        this.collection.remove([oldModel]);
	        this.collection.add(commentModel, {at: oldModelIndex});
	    },
	
	    syncWithCount: function (cnt) {
	
	        var that = this;
	        if (cnt != that.collection.models.length) {
	            that.collection.fetch();
	        }
	
	    },
	
	    /*onEditComment: function (model) {
	        this.triggerMethod('on:edit:comment', model);
	    },
	
	    onRemoveComment: function (model) {
	        this.beingRemovedComment = model;
	        this.confirmationModal.show();
	    },*/
	
	    onSetAsIrrelevant: function (model) {
	        this.beingIrrelevantComment = model;
	        this.confirmationModal.show();
	    },
	    
	    onSetAsIrrelevantConfirmed: function (data) {
	        if (data.tag === 'comment-irrelevant' && data.result == true) {
	            this.setAsIrrelevant();
	        }
	        else {
	            this.confirmationModal.hide();
	        }
	    },
	
	    setAsIrrelevant: function () {
	        var that = this;
	        var commentId = that.beingIrrelevantComment.get('id');
	
	        if (_.isEmpty(commentId))
	            return;
	
	        var dboId = that.dboId;
	
	        utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/comment/' + dboId + '/' + commentId + '/irrelevant',
	            statusCode: {
	                200: function (modelUpdated) {
	                    utils.hideSpinner();
	                    $.notify({
	                        message: 'The comment became as Irrelevant successfully'
	                    }, {
	                        type: 'success',
	                        z_index: 2000,
	                    });
	                    that.update(modelUpdated);
	                }
	            },
	            error: function (e) {
	                utils.hideSpinner();
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            }
	        });
	    },
	
	    /*onDeleteConfirmed: function (data) {
	        if (data.tag === 'comment-remove' && data.result == true) {
	            this.removeComment();
	        }
	        else {
	            this.confirmationModal.hide();
	        }
	    },*/
	
	    /*removeComment: function () {
	        var that = this;
	        var commentId = that.beingRemovedComment.get('id');
	
	        if (_.isEmpty(commentId))
	            return;
	
	        var dboId = that.dboId;
	
	        utils.showSpinner();
	        $.ajax({
	            type: "DELETE",
	            url: '/api/comment/' + dboId + '/' + commentId,
	            statusCode: {
	                200: function (response) {
	                    utils.hideSpinner();
	                    that.collection.remove([that.beingRemovedComment]);
	                    that.triggerMethod('comment:count:changed');
	                    $.notify({
	                        message: 'The comment removed successfully'
	                    }, {
	                        type: 'success',
	                        z_index: 2000,
	                    });
	                }
	            },
	            error: function (e) {
	                utils.hideSpinner();
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            }
	        });
	    },*/
	
	    addNewComment: function() {
	        this.triggerMethod('on:new:comment');
	    }
	});
	
	module.exports = CommentsTableView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	
	var CommentsCollection = BaseCollection.extend({
	    url:"/api/comment",
	
	    initialize: function(models, options){
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    }
	});
	
	
	module.exports = CommentsCollection;

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="panel ';
	 if (actual == true) { 
	__p+=' panel-success ';
	 } else { 
	__p+=' panel-warning ';
	 } 
	__p+='"\r\n        title="';
	 if (actual == true) { 
	__p+=' Actual comment ';
	 } else { 
	__p+=' Not actual comment ';
	 } 
	__p+='">\r\n    <div class="panel-heading">\r\n        <div class="inline center text-muted">\r\n            '+
	((__t=( (source || '') ))==null?'':__t)+
	' &nbsp; '+
	((__t=( (internal ? '(Internal)' : '(External)') ))==null?'':__t)+
	'\r\n        </div>\r\n        <div class="pull-right inline" style="margin-left: 10px;">\r\n            '+
	((__t=( time ))==null?'':__t)+
	'\r\n        </div>\r\n        <div class="pull-right inline">\r\n            ';
	 if (creatorId) { 
	__p+='\r\n            <a href="/#person/'+
	((__t=( creatorId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( creator ))==null?'':__t)+
	'</a>\r\n            ';
	 } else { 
	__p+='\r\n            <a>ADMIN</a>\r\n            ';
	 } 
	__p+='\r\n        </div>\r\n    </div>\r\n    <div class="panel-body">\r\n        <div class="col-xs-10 col-md-10">\r\n            '+
	((__t=( text ))==null?'':__t)+
	'\r\n        </div>\r\n        ';
	 if (canEdit) { 
	__p+='\r\n        <div class="row pull-right col-xs-1 col-md-1 col-xs-offset-1 col-md-offset-1">\r\n            <a href="/#documents?commentId='+
	((__t=( id ))==null?'':__t)+
	'" target="_blank">\r\n                <span class="clickable glyphicon glyphicon-file" title="Related documents"/>\r\n            </a>\r\n            ';
	 if (actual) { 
	__p+='\r\n                <span class="clickable glyphicon glyphicon-erase set-as-irrelevant" style="margin-left: 5px;" title="Set as Irrelevant"></span>\r\n            ';
	 } 
	__p+='\r\n            ';
	 if (false) { 
	__p+='\r\n            <span class="clickable glyphicon glyphicon-edit edit-comment" title="Edit"></span>\r\n            <span class="clickable glyphicon glyphicon-remove remove-comment" style="margin-left: 5px;" title="Remove"></span>\r\n            ';
	 } 
	__p+='\r\n        </div>\r\n        ';
	 } 
	__p+='\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 271 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\r\n    <button type="button" class="btn btn-primary" id="scroll-to-add">Add new comment</button>\r\n</div>\r\n\r\n<div class="top-margined bottom-margined">\r\n    <div class="list-of-comments" style="max-height: 2000px;"></div>\r\n</div>\r\n\r\n<div id="confirmation-modal"></div>';
	}
	return __p;
	};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	
	var MedProfileImportSettingsForm = Marionette.View.extend({
	    template: __webpack_require__(273),
	
	    regions: {
	        stateSelect: '#select-state',
	        orgSelectState: '#org-select-state'
	    },
	
	    ui: {
	        save: '#save',
	        cancel: '#cancel',
	
	        ccrDemographics: '#ccr-demographics',
	        ccrMedications: '#ccr-medications',
	        ccrProblems: '#ccr-medical-problems',
	        ccrVisits: '#ccr-visits',
	
	        ccdDemographics: '#ccd-demographics',
	        ccdMedications: '#ccd-medications',
	        ccdProblems: '#ccd-medical-problems',
	        ccdVisits: '#ccd-visits'
	
	    },
	
	    events: {
	        'click @ui.save': 'onSave',
	        'click @ui.cancel': 'onCancel',
	
	        'click @ui.ccrDemographics': 'onCheckCcrDemographics',
	        'click @ui.ccrMedications': 'onCheckCcrMedications',
	        'click @ui.ccrProblems': 'onCheckCcrProblems',
	        'click @ui.ccrVisits': 'onCheckCcrVisits',
	
	        'click @ui.ccdDemographics': 'onCheckCcdDemographics',
	        'click @ui.ccdMedications': 'onCheckCcdMedications',
	        'click @ui.ccdProblems': 'onCheckCcdProblems',
	        'click @ui.ccdVisits': 'onCheckCcdVisits'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            ccrPermissions: this.ccrPermissions,
	            ccdPermissions: this.ccdPermissions
	        }
	    },
	
	
	    initialize: function (options) {
	        this.utils = new CommonUtils();
	        this.ccrPermissions = _.clone(options.ccrPermissions) || this.initMedicalImportPermissions();
	        this.ccrPermissionsOriginal = _.clone(options.ccrPermissions);
	        this.ccdPermissions = _.clone(options.ccdPermissions) || this.initMedicalImportPermissions();
	        this.ccdPermissionsOriginal = _.clone(options.ccdPermissions);
	    },
	
	    onRender: function () {
	        this.validate();
	    },
	
	    initMedicalImportPermissions: function () {
	        return {
	            demographics: false,
	            medications: false,
	            medicalProblems: false,
	            visits: false
	        }
	    },
	
	    onSave: function () {
	        this.triggerMethod('save:import:settings', {
	            ccrPermissions: this.ccrPermissions,
	            ccdPermissions: this.ccdPermissions
	        });
	    },
	
	    onCancel: function () {
	        this.triggerMethod('cancel:import:settings');
	    },
	
	    validate: function () {
	        if (_.isEqual(this.ccrPermissions, this.ccrPermissionsOriginal) && _.isEqual(this.ccdPermissions, this.ccdPermissionsOriginal))
	            this.disableButtons();
	        else
	            this.enableButtons();
	    },
	
	    enableButtons: function () {
	        this.ui.save.removeAttr('disabled');
	        this.ui.cancel.removeAttr('disabled');
	    },
	
	    disableButtons: function () {
	        this.ui.save.attr('disabled', true);
	        this.ui.cancel.attr('disabled', true);
	    },
	
	    onCheckCcrDemographics: function(event) {
	        this.ccrPermissions.demographics = event.target.checked;
	        this.validate();
	    },
	
	    onCheckCcrMedications: function(event) {
	        this.ccrPermissions.medications = event.target.checked;
	        this.validate();
	    },
	
	    onCheckCcrProblems: function(event) {
	        this.ccrPermissions.medicalProblems = event.target.checked;
	        this.validate();
	    },
	
	    onCheckCcrVisits: function(event) {
	        this.ccrPermissions.visits = event.target.checked;
	        this.validate();
	    },
	
	    onCheckCcdDemographics: function(event) {
	        this.ccdPermissions.demographics = event.target.checked;
	        this.validate();
	    },
	
	    onCheckCcdMedications: function(event) {
	        this.ccdPermissions.medications = event.target.checked;
	        this.validate();
	    },
	
	    onCheckCcdProblems: function(event) {
	        this.ccdPermissions.medicalProblems = event.target.checked;
	        this.validate();
	    },
	
	    onCheckCcdVisits: function(event) {
	        this.ccdPermissions.visits = event.target.checked;
	        this.validate();
	    }
	
	});
	
	module.exports = MedProfileImportSettingsForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\r\n    <div class="col-md-6 col-xs-6">\r\n        <div class="panel panel-info">\r\n            <div class="panel-heading center">CCR permissions</div>\r\n            <div class="panel-body">\r\n                <div class="form-group">\r\n                    <div class="form-horizontal">\r\n                        <div class="form-group">\r\n                            <label class="col-md-6 control-label" for="ccr-demographics">Demographics</label>\r\n                            <div class="checkbox col-md-6">\r\n                                <input type="checkbox" id="ccr-demographics" style="margin-left: 10px;" ';
	 if (ccrPermissions.demographics) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n                            </div>\r\n                        </div>\r\n                        <div class="form-group">\r\n                            <label class="col-md-6 control-label" for="ccr-medications">Medications</label>\r\n                            <div class="checkbox col-md-6">\r\n                                <input type="checkbox" id="ccr-medications" style="margin-left: 10px;" ';
	 if (ccrPermissions.medications) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n                            </div>\r\n                        </div>\r\n                        <div class="form-group">\r\n                            <label class="col-md-6 control-label" for="ccr-medical-problems">Medical problems</label>\r\n                            <div class="checkbox col-md-6">\r\n                                <input type="checkbox" id="ccr-medical-problems" style="margin-left: 10px;" ';
	 if (ccrPermissions.medicalProblems) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n                            </div>\r\n                        </div>\r\n                        <div class="form-group">\r\n                            <label class="col-md-6 control-label" for="ccr-visits">Visits</label>\r\n                            <div class="checkbox col-md-6">\r\n                                <input type="checkbox" id="ccr-visits" style="margin-left: 10px;" ';
	 if (ccrPermissions.visits) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class="col-md-6 col-xs-6">\r\n        <div class="panel panel-info">\r\n            <div class="panel-heading center">CCD permissions</div>\r\n            <div class="panel-body">\r\n                <div class="form-group">\r\n                    <div class="form-horizontal">\r\n                        <div class="form-group">\r\n                            <label class="col-md-6 control-label" for="ccd-demographics">Demographics</label>\r\n                            <div class="checkbox col-md-6">\r\n                                <input type="checkbox" id="ccd-demographics" style="margin-left: 10px;" ';
	 if (ccdPermissions.demographics) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n                            </div>\r\n                        </div>\r\n                        <div class="form-group">\r\n                            <label class="col-md-6 control-label" for="ccd-medications">Medications</label>\r\n                            <div class="checkbox col-md-6">\r\n                                <input type="checkbox" id="ccd-medications" style="margin-left: 10px;" ';
	 if (ccdPermissions.medications) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n                            </div>\r\n                        </div>\r\n                        <div class="form-group">\r\n                            <label class="col-md-6 control-label" for="ccd-medical-problems">Medical problems</label>\r\n                            <div class="checkbox col-md-6">\r\n                                <input type="checkbox" id="ccd-medical-problems" style="margin-left: 10px;" ';
	 if (ccdPermissions.medicalProblems) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n                            </div>\r\n                        </div>\r\n                        <div class="form-group">\r\n                            <label class="col-md-6 control-label" for="ccd-visits">Visits</label>\r\n                            <div class="checkbox col-md-6">\r\n                                <input type="checkbox" id="ccd-visits" style="margin-left: 10px;" ';
	 if (ccdPermissions.visits) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div style="margin-left: 20px;">\r\n        <button type="button" class="btn btn-primary" id="save">Save</button>\r\n        <button type="button" class="btn btn-primary" id="cancel">Cancel</button>\r\n    </div>\r\n</div>\r\n';
	}
	return __p;
	};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var CommonUtils = __webpack_require__(189);
	
	var ExternalIdsView = Marionette.View.extend({
	    template: __webpack_require__(275),
	
	    ui: {
	        table: '#external-ids-table',
	        addNewButton: '#add-new-external-id',
	        saveButton: '#save-external-ids',
	        cancelButton: '#cancel-external-ids-save',
	
	        editButton: '.external-id-edit',
	        removeButton: '.external-id-remove',
	        externalIdTextInput: '.external-id-text'
	    },
	
	    events: {
	        'click @ui.addNewButton': 'onAddNewClick',
	        'click @ui.editButton': 'onEditClick',
	        'click @ui.removeButton': 'onRemoveClick',
	        'keyup @ui.externalIdTextInput': 'onExternalIdTextInputKeyUp',
	        'click @ui.saveButton': 'onSaveClick',
	        'click @ui.cancelButton': 'onCancelClick'
	    },
	
	    initialize: function (options) {
	        this.externalIds = options.externalIds;
	        this.externalIdsOriginal = _.clone(this.externalIds);
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            externalIds: that.externalIds
	        }
	    },
	
	    onRender: function () {
	        this.checkAddNewButton();
	        this.checkSaveAndCancelButtons();
	        this.checkForNewExternalId();
	
	        //var val = event.target.getAttribute('rel-id');
	    },
	
	    onAddNewClick: function () {
	        this.externalIds.push('');
	        this.triggerMethod('on:save:externalids', {
	            externalIds: this.externalIds,
	            doSave: false
	        });
	    },
	
	    checkAddNewButton: function () {
	        if (this.externalIds.filter(function (id) {
	                return _.isEmpty(id);
	            }).length > 0) {
	            this.ui.addNewButton.attr('disabled', true);
	        } else {
	            this.ui.addNewButton.removeAttr('disabled');
	        }
	    },
	
	    checkSaveAndCancelButtons: function () {
	        if (_.isEqual(this.externalIdsOriginal,
	                this.externalIds)) {
	            this.ui.saveButton.attr('disabled', true);
	            this.ui.cancelButton.attr('disabled', true);
	        } else {
	            this.ui.saveButton.removeAttr('disabled');
	            this.ui.cancelButton.removeAttr('disabled');
	        }
	    },
	
	    checkForNewExternalId: function () {
	        var indexOfAddedNew = null;
	        _.each(this.externalIds, function (externalId, indx) {
	            if (_.isEmpty(externalId) && indexOfAddedNew == null)
	                indexOfAddedNew = indx;
	        });
	
	        if (indexOfAddedNew == null) return;
	
	        var rowOfAddedNew = this.ui.table.find("tr:last");
	        this.activeEditInput(rowOfAddedNew);
	    },
	
	    onEditClick: function (event) {
	        var self = $(event.target);
	        var tr = self.closest('tr');
	        this.activeEditInput(tr);
	    },
	
	    onRemoveClick: function (event) {
	        var self = $(event.target);
	        var tr = self.closest('tr');
	        var firstTd = tr.find('td:eq(0)');
	        var span = firstTd.children('span');
	        var removedValue = span.text();
	
	        this.externalIds = _.reject(this.externalIds, function(id) {
	            return id === removedValue;
	        });
	        tr.remove();
	
	        this.checkAddNewButton();
	        this.checkSaveAndCancelButtons();
	    },
	
	    activeEditInput: function (tr) {
	        this.inactiveAllInputs();
	        var firstTd = tr.find('td:eq(0)');
	        var span = firstTd.children('span');
	        var input = firstTd.children('input');
	        span.hide();
	        input.show();
	        this.currentEditingExternalId = input.val();
	    },
	
	    inactiveAllInputs: function () {
	        $('input[type=text]').hide();
	        $('span.text').show();
	        this.currentEditingExternalId = null;
	    },
	
	    onExternalIdTextInputKeyUp: function (event) {
	        var self = $(event.target);
	        var newValue = self.val();
	        if (event.keyCode == 13 && this.currentEditingExternalId != null && !_.isEmpty(newValue)) {
	            var currentIndex = _.indexOf(this.externalIds, this.currentEditingExternalId);
	            if (currentIndex >= 0) {
	                this.externalIds[currentIndex] = newValue;
	                self.hide();
	                var span = self.parent().children('span.text');
	                span.text(newValue);
	                span.show();
	                this.currentEditingExternalId = null;
	
	                this.checkAddNewButton();
	                this.checkSaveAndCancelButtons();
	            }
	        }
	    },
	
	    onSaveClick: function() {
	        this.triggerMethod('on:save:externalids', {
	            externalIds: this.externalIds,
	            doSave: true
	        });
	    },
	
	    onCancelClick: function() {
	        this.triggerMethod('on:cancel:externalids');
	    }
	});
	
	module.exports = ExternalIdsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form weld top-margined">\r\n    <div class="col-md-4 col-xs-4">\r\n        <table class="table table-condensed vertical-aligned-table" id="external-ids-table">\r\n            <thead>\r\n            <tr>\r\n                <th class="center">External Id</th>\r\n                <th class="center">Edit</th>\r\n                <th class="center">Remove</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody>\r\n            ';
	 _.each(externalIds, function(externalId, indx) { 
	__p+='\r\n            <tr>\r\n                <td class="center">\r\n                    <span class="text">'+
	((__t=( externalId ))==null?'':__t)+
	'</span>\r\n                    <input type="text" class="form-control external-id-text" value="'+
	((__t=( externalId ))==null?'':__t)+
	'" style="min-width: 100px; display: none;" placeholder="Type and Press Enter"/>\r\n                </td>\r\n                <td class="center"><span class="glyphicon glyphicon-edit clickable external-id-edit" rel-id="'+
	((__t=( externalId ))==null?'':__t)+
	'"/></td>\r\n                <td class="center"><span class="glyphicon glyphicon-remove clickable external-id-remove" rel-id="'+
	((__t=( externalId ))==null?'':__t)+
	'"/></td>\r\n            </tr>\r\n            ';
	 }) 
	__p+='\r\n            </tbody>\r\n        </table>\r\n        <div class="top-margined">\r\n            <button type="button" class="btn btn-success btn-sm" id="add-new-external-id">Add new</button>\r\n        </div>\r\n    </div>\r\n    <div class="col-md-2 col-xs-2">\r\n        <button type="button" class="btn btn-primary btn-sm" id="save-external-ids">Save</button>\r\n        <button type="button" class="btn btn-primary btn-sm" id="cancel-external-ids-save">Cancel</button>\r\n    </div>\r\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var ReverseRelationCollection = __webpack_require__(277);
	var Relation = __webpack_require__(230);
	var PersonOrganizationModalView = __webpack_require__(278);
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	var YesNoConfirmationModal = __webpack_require__(237);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	
	var OrganizationPersonsItem = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(282),
	
	    ui: {
	        edit: '.org-person-edit',
	        remove: '.org-person-remove'
	    },
	
	    events: {
	        'click @ui.edit': 'onEdit',
	        'click @ui.remove': 'onRemove'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            formatDate: that.getOption('formatDate'),
	            canEdit: that.getOption('canEdit')
	        }
	    },
	
	    initialize: function (options) {
	    },
	
	    onEdit: function () {
	        this.triggerMethod('edit:org:person', this.model);
	    },
	
	    onRemove: function () {
	        this.triggerMethod('remove:org:person', this.model);
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(4), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	
	var OrganizationPersonsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: OrganizationPersonsItem,
	    emptyView: EmptyView,
	
	    collectionEvents: {
	        request: 'showLoading',
	        sync: 'hideLoading',
	        error: 'logError'
	    },
	
	    childViewEvents: {
	        'edit:org:person': 'onEdit',
	        'remove:org:person': 'onRemove'
	    },
	
	    initialize: function (options) {
	        this.collection = options.collection;
	        this.formatDate = options.formatDate;
	        this.canEdit = options.canEdit;
	    },
	
	    childViewOptions: function () {
	        return {
	            formatDate: this.formatDate,
	            canEdit: this.canEdit
	        };
	    },
	
	    onEdit: function (model) {
	        this.triggerMethod('edit:org:person', model);
	    },
	
	    onRemove: function (model) {
	        this.triggerMethod('remove:org:person', model);
	    },
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    }
	});
	
	var OrganizationPersonsView = Marionette.View.extend({
	    template: __webpack_require__(283),
	
	    regions: {
	        modal: '#organization-person',
	        tableBody: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        removeConfirmationModal: '#org-person-delete-confirmation-modal'
	    },
	
	    ui: {
	        newRelBtn: '#new-person'
	    },
	
	    events: {
	        'click @ui.newRelBtn': 'newRelation'
	    },
	
	    collectionEvents: {
	        error: 'logError'
	    },
	
	    childViewEvents: {
	        'edit:org:person': 'onEdit',
	        'remove:org:person': 'onRemove',
	        'saved:person:organization': 'onSavedOrganizationPerson',
	        'action:confirmed': 'onRemoveConfirmed'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            canEdit: that.canEdit
	        }
	    },
	
	    initialize: function (options) {
	        this.organizationModel = options.organizationModel;
	        this.organizationId = this.organizationModel.id;
	        this.organizationName = this.organizationModel.name;
	        this.canEdit = options.canEdit;
	        this.utils = new CommonUtils();
	    },
	
	    onErrors: function (model, errors) {
	        model.view.triggerMethod('server:error', errors.join('. \n'));
	    },
	
	    onRender: function () {
	        var that = this;
	
	        this.removeConfirmationModal = new YesNoConfirmationModal({
	            tag: 'remove',
	            message: "Are you sure you want to remove this relation?"
	        });
	        this.showChildView('removeConfirmationModal', this.removeConfirmationModal);
	
	        that.collection = new ReverseRelationCollection([],
	            {
	                params: [
	                    {key: 'systemRelationType', value: 'PERSON_ORGANIZATION'},
	                    {key: 'parentId', value: that.organizationId}
	                ]
	            });
	
	        that.reloadCollection();
	    },
	
	    renderEditor: function (model, originalModel, orgContacts, personContacts) {
	        var excludedPersonsIds = this.collection.map(function (model) {
	            return model.get("child").id;
	        });
	
	        this.personOrganizationModalView = new PersonOrganizationModalView({
	            mode: 'organization',
	            model: model,
	            excludedPersonsIds: _.without(excludedPersonsIds,
	                originalModel ? (originalModel.get("child") || {}).id : []),
	            selectedPerson: originalModel ? originalModel.get("child") : null,
	            orgContacts: orgContacts,
	            personContacts: personContacts
	        });
	        this.showChildView('modal', this.personOrganizationModalView);
	        this.personOrganizationModalView.show();
	    },
	
	    reloadCollection: function () {
	        var that = this;
	        that.showLoading();
	        that.collection.fetch({
	            success: function () {
	                that.renderTable();
	                that.hideLoading();
	            },
	            error: function () {
	                that.hideLoading();
	            }
	        });
	    },
	
	    renderTable: function () {
	        var that = this;
	        that.showChildView('tableBody', new OrganizationPersonsTableBody({
	            collection: that.collection,
	            formatDate: function (dateAsLong) {
	                return dateAsLong ? that.utils.longToDateTimeFormatted(dateAsLong, 'MMM DD YYYY') : "";
	            },
	            canEdit: that.canEdit
	        }));
	    },
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    },
	
	    newRelation: function () {
	        this.renderEditor(new Relation({
	            systemRelationType: 'PERSON_ORGANIZATION',
	            child: {
	                id: this.organizationId,
	                '@class': "com.reviewandsign.reviewnsign.dal.entities.OrganizationDbo" // custom fix
	            },
	            contacts: [],
	            description: ""
	        }), null, (this.organizationModel.get('object') || {}).contacts, []);
	    },
	
	    onSavedOrganizationPerson: function () {
	        this.reloadCollection();
	    },
	
	    onEdit: function (model) {
	        var clonedModelAttributes = this.utils.deepClone(_.extend({}, model.attributes));
	        var temp = _.clone(clonedModelAttributes.parentId);
	        clonedModelAttributes.parentId = _.clone(clonedModelAttributes.child.id);
	        clonedModelAttributes.child = {
	            id: temp,
	            '@class': "com.reviewandsign.reviewnsign.dal.entities.OrganizationDbo" // custom fix
	        };
	        var clonedModel = new Relation();
	        clonedModel.set(clonedModelAttributes);
	        this.renderEditor(clonedModel, model, (this.organizationModel.get('object') || {}).contacts, (model.get('child') || {}).object.contacts);
	    },
	
	    onRemove: function (model) {
	        this.modelToRemove = model;
	        this.removeConfirmationModal.show();
	    },
	
	    onRemoveConfirmed: function (resp) {
	        var that = this;
	        if (resp.tag === 'remove' && resp.result == true) {
	            that.modelToRemove.destroy({
	                success: function (model, resp) {
	                    that.reloadCollection();
	                    that.removeConfirmationModal.hide();
	                }
	            });
	        }
	        else {
	            that.removeConfirmationModal.hide();
	        }
	    }
	});
	
	
	module.exports = OrganizationPersonsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	var Relation = __webpack_require__(230);
	
	var ReverseRelationsCollection = BaseCollection.extend({
	    url:"/api/relation/reverse",
	    model: Relation,
	
	    initialize: function(models, options){
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    }
	});
	
	
	module.exports = ReverseRelationsCollection;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	var RemoteSuggesterView = __webpack_require__(196);
	
	var ContactsTableView = __webpack_require__(250);
	var ContactFormView = __webpack_require__(254);
	var ContactsCollection = __webpack_require__(253);
	
	var ContactsSelectView = __webpack_require__(279);
	
	var PersonOrganizationModalView = Marionette.View.extend({
	    template: __webpack_require__(281),
	
	    regions: {
	        organizationsSelect: '#organizations-container',
	        personsSelect: '#persons-container',
	        contacts: '#person-org-contacts',
	        contactForm: '#person-org-contact-form',
	
	        orgsContactList: '#orgs-contact-list',
	        personsContactList: '#persons-contact-list'
	    },
	
	    ui: {
	        modal: '#person-organization-modal',
	        startDate: '#start-date',
	        endDate: '#end-date',
	        comment: '#comment',
	        save: '#save',
	
	        contactForm: '#person-org-contact-form'
	    },
	
	    events: {
	        'change @ui.comment': 'onCommentChange',
	        'click @ui.save': 'onSave'
	    },
	
	    childViewEvents: {
	        'suggestor:selected:organization': 'organizationChanged',
	        'suggestor:selected:person': 'personChanged',
	        'on:contact:action': 'onContactAction',
	        'on:contact:saved': 'onContactSaved',
	        'contact:selected:from:contacts:list': 'onContactSelectedFromContactsList'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var caption = that.mode == 'person' ? " Person's Organization" : " Organization's Person"
	        return {
	            mode: that.mode,
	            caption: (that.model && that.model.get("id") ? "Edit" : "Add") + caption
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.utils = new CommonUtils();
	        that.mode = options.mode;
	        that.model = options.model;
	        that.excludedOrgsIds = options.excludedOrgsIds || [];
	        that.excludedPersonsIds = options.excludedPersonsIds || [];
	        that.selectedPerson = options.selectedPerson;
	        that.orgContacts = options.orgContacts;
	        that.personContacts = options.personContacts;
	    },
	
	    onRender: function () {
	        var that = this;
	
	        if (this.mode == 'person')
	            that.renderOrganizationSelectView(that.model.get("child"));
	        if (this.mode == 'organization')
	            that.renderPersonSelectView(that.selectedPerson);
	
	        that.ui.startDate.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'MM/DD/YYYY hh:mm A',
	            defaultDate: that.model.get("startTime") ? that.utils.getDateWithoutTime(new Date(that.model.get("startTime"))) : 0
	        });
	        that.ui.startDate.on("dp.change", function (e) {
	
	            if (e.date) {
	                that.model.set("startTime", e.date.valueOf());
	            } else {
	                that.model.set("startTime", 0);
	            }
	            that.validate();
	        })/*.on('dp.show', function () {
	            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(that.model.get("startTime")) || new Date());
	        })*/;
	
	        that.ui.endDate.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'MM/DD/YYYY hh:mm A',
	            defaultDate: that.model.get("endTime") ? that.utils.getDateWithoutTime(new Date(that.model.get("endTime"))) : 0
	        });
	        that.ui.endDate.on("dp.change", function (e) {
	
	            if (e.date) {
	                that.model.set("endTime", e.date.valueOf());
	            } else {
	                that.model.set("endTime", 0);
	            }
	            that.validate();
	        })/*.on('dp.show', function () {
	            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(that.model.get("endTime")) || new Date());
	        })*/;
	
	
	        this.renderContacts();
	        this.renderOrgContactsSelect(that.orgContacts || []);
	        this.renderPersonContactsSelect(that.personContacts || []);
	    },
	
	    renderOrganizationSelectView: function (org) {
	        var that = this;
	
	        that.showChildView('organizationsSelect', new RemoteSuggesterView({
	            maxNumberOfElements: 20,
	            url: '/api/dbo/preview?page-size=' + 20 + '&sortby=name&like_name=~~~&type=organization',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data.filter(function (item) {
	                    return that.excludedOrgsIds.filter(function (id) {
	                        return id == item.id;
	                    }).length == 0;
	                });
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Select Organization",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return (arr[index] || {}).id;
	            },
	            tag: 'organization',
	            defaultSelected: org
	        }));
	    },
	
	    renderPersonSelectView: function (person) {
	        var that = this;
	
	        that.showChildView('personsSelect', new RemoteSuggesterView({
	            maxNumberOfElements: 20,
	            url: '/api/person/preview?page-size=' + 20 + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data.filter(function (item) {
	                    return that.excludedPersonsIds.filter(function (id) {
	                        return id == item.id;
	                    }).length == 0;
	                });
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Select Person",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return (arr[index] || {}).id;
	            },
	            tag: 'person',
	            defaultSelected: person
	        }));
	    },
	
	    renderContacts: function () {
	        this.contactsView = new ContactsTableView({
	            collection: new ContactsCollection(this.model.get('contacts')),
	            canEdit: true,
	            actionsWoConfirmation: true
	        });
	        this.showChildView("contacts", this.contactsView);
	    },
	
	    renderOrgContactsSelect: function (contacts) {
	        this.orgContactsListView = new ContactsSelectView({
	            title: "Add Contact from Organization",
	            contacts: contacts,
	            tag: "org"
	        });
	        this.showChildView("orgsContactList", this.orgContactsListView);
	    },
	
	    renderPersonContactsSelect: function (contacts) {
	        this.personContactsListView = new ContactsSelectView({
	            title: "Add Contact from Person",
	            contacts: contacts,
	            tag: "person"
	        });
	        this.showChildView("personsContactList", this.personContactsListView);
	    },
	
	    onCommentChange: function(event) {
	        this.model.set("description", event.target.value);
	    },
	
	    onSave: function () {
	        var that = this;
	        console.log(this.model);
	        this.model.set("child", _.omit(this.model.get("child"), "object"));
	        this.model.save(this.model.toJSON(),
	            {
	                success: function () {
	                    that.onSaved();
	                    that.hide();
	                },
	                error: function (e) {
	                    console.log(e);
	                }
	            });
	    },
	
	    onSaved: function () {
	        this.triggerMethod("saved:person:organization");
	    },
	
	    show: function () {
	        this.validate();
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    },
	
	    enableSave: function () {
	        this.ui.save.removeAttr('disabled');
	    },
	
	    disableSave: function () {
	        this.ui.save.attr('disabled', true);
	    },
	
	    validate: function () {
	        if (this.model.get("parentId") && this.model.get("child") && this.model.get("child").id)
	            this.enableSave();
	        else
	            this.disableSave();
	    },
	
	    organizationChanged: function (id) {
	        if (this.model.get("child")) {
	            this.model.get("child").id = id;
	        }
	        else
	            this.model.set("child", {
	                id: id,
	                '@class': "com.reviewandsign.reviewnsign.dal.entities.OrganizationDbo" // custom fix
	            });
	
	        this.validate();
	        if (id) {
	            var selectedOrg = this.getChildView("organizationsSelect").getSelectedSingleObject(id);
	            this.renderOrgContactsSelect(((selectedOrg || {}).object || {}).contacts || []);
	        }
	    },
	
	    personChanged: function (id) {
	        this.model.set('parentId', id);
	        this.validate();
	
	        if (id) {
	            var selectedPerson = this.getChildView("personsSelect").getSelectedSingleObject(id);
	            this.renderPersonContactsSelect(((selectedPerson || {}).object || {}).contacts || []);
	        }
	    },
	
	    renderContactForm: function (mode, contact) {
	        this.ui.contactForm.show();
	        if (mode == 'add') {
	            this.contactFormView = new ContactFormView({
	                mode: mode,
	                addresses: [],
	                representatives: []
	            });
	            this.showChildView("contactForm", this.contactFormView);
	        }
	        else if (mode == 'edit') {
	            this.contactFormView = new ContactFormView({
	                mode: mode,
	                contact: contact,
	                addresses: [],
	                representatives: []
	            });
	            this.showChildView("contactForm", this.contactFormView);
	        }
	    },
	
	    removeContactForm: function () {
	        this.ui.contactForm.hide();
	        this.detachChildView('contactForm');
	    },
	
	    onContactAction: function (data) {
	        var that = this;
	
	        if (data.mode == 'add') {
	            that.renderContactForm(data.mode);
	        }
	        else if (data.mode == 'delete') {
	            var willBeRemoveContact = data.data.attributes;
	            that.model.set('contacts', (that.model.get('contacts') || []).filter(function (contact) {
	                return contact.data !== willBeRemoveContact.data
	                    || contact.type !== willBeRemoveContact.type
	                    || contact.preferred !== willBeRemoveContact.preferred;
	            }));
	            that.renderContacts();
	
	            this.orgContactsListView.showContactItem(data.data.attributes);
	            this.personContactsListView.showContactItem(data.data.attributes);
	
	        }
	        else if (data.mode == 'edit') {
	            var willBeEditedContact = data.data.attributes;
	            var willEditContact = (that.model.get('contacts') || []).filter(function (contact) {
	                return contact.data == willBeEditedContact.data
	                    && contact.type == willBeEditedContact.type
	                    && contact.preferred == willBeEditedContact.preferred;
	            });
	            this.renderContactForm(data.mode, willEditContact[0]);
	        }
	        else if (data.mode == 'cancel') {
	            that.removeContactForm();
	        } else if (data.mode == 'save') {
	            var changedContact = data.data.attributes;
	            (that.model.get('contacts') || []).forEach(function (contact) {
	                if (contact.data == changedContact.data
	                    && contact.type == changedContact.type) {
	                    contact.preferred = changedContact.preferred;
	                }
	            });
	        }
	    },
	
	    onContactSaved: function (data) {
	        var that = this;
	        if (data.mode == 'add') {
	            that.model.set('contacts', (that.model.get('contacts') || []).filter(function (contact) {
	                return contact.data !== data.contact.data
	                    || contact.type !== data.contact.type
	                    || contact.preferred !== data.contact.preferred;
	            }));
	
	            that.model.get('contacts').push(data.contact);
	        }
	
	        that.renderContacts();
	        that.removeContactForm();
	    },
	
	    onContactSelectedFromContactsList: function (payload) {
	        this.contactsView.add(payload.contact);
	        this.model.get('contacts').push(payload.contact);
	        if (payload.tag === 'org') {
	            this.orgContactsListView.hideContactItem(payload.contact);
	        } else if (payload.tag === 'person') {
	            this.personContactsListView.hideContactItem(payload.contact);
	        }
	
	    }
	});
	
	module.exports = PersonOrganizationModalView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var ContactsSelectView = Marionette.View.extend({
	    template: __webpack_require__(280),
	
	    ui: {
	        contact: '.contact'
	    },
	
	    events: {
	        'click @ui.contact': 'onContactSelected'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            title: that.title,
	            contacts: _.sortBy(that.contacts, function (contact) {
	                return contact.type + contact.data;
	            }),
	            style: "margin-right: 10px;" + that.style,
	            generatedElNameFromContact: that.generatedElNameFromContact,
	            generatedTitleFromContact: function (contact) {
	                return contact.type + ", " + contact.data;
	            }
	        }
	    },
	
	    initialize: function (options) {
	        this.title = options.title || 'Add contact from';
	        this.contacts = options.contacts || [];
	        this.tag = options.tag;
	        this.style = options.style;
	    },
	
	    onRender: function () {
	    },
	
	    generatedElNameFromContact: function (contact) {
	        return contact.type + "_" + contact.data;
	    },
	
	    onContactSelected: function (e) {
	        var that = this;
	        var name = e.target.name;
	        var selectedContact = _.find(that.contacts, function (contact) {
	            return name === that.generatedElNameFromContact(contact);
	        });
	
	        if (selectedContact)
	            that.triggerMethod("contact:selected:from:contacts:list", {contact: selectedContact, tag: this.tag});
	    },
	
	    elFromContact: function (contact) {
	        var elSelector = "[name='" + this.generatedElNameFromContact(contact) + "']";
	        return $(elSelector);
	    },
	
	    showContactItem: function (contact) {
	        this.elFromContact(contact).show();
	    },
	
	    hideContactItem: function (contact) {
	        this.elFromContact(contact).hide();
	    }
	
	});
	
	module.exports = ContactsSelectView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="dropdown" style="'+
	((__t=( style ))==null?'':__t)+
	'">\n    <button id="contacts-select" class="btn btn-primary" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n        '+
	((__t=( title ))==null?'':__t)+
	'\n        <span class="caret"></span>\n    </button>\n    <ul class="dropdown-menu" aria-labelledby="contacts-select">\n        ';
	 _.each(contacts, function(contact){ 
	__p+='\n        <li><a name="'+
	((__t=( generatedElNameFromContact(contact) ))==null?'':__t)+
	'" class="clickable contact">'+
	((__t=( generatedTitleFromContact(contact) ))==null?'':__t)+
	'</a></li>\n        ';
	 }) 
	__p+='\n    </ul>\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Modal -->\n<div class="modal fade" id="person-organization-modal" tabindex="-1" role="dialog" style="z-index: 1100;"\n     aria-labelledby="person-organization-modal">\n    <div class="modal-dialog modal-lg" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\n                        aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title" id="person-organization-modal-label">'+
	((__t=( caption ))==null?'':__t)+
	'</h4>\n            </div>\n            <div class="modal-body">\n                ';
	 if (mode == 'person') { 
	__p+='\n                <div id="organizations-container" class="form-group col-xs-6 col-md-6"></div>\n                ';
	 } 
	__p+='\n                <div class="form-group col-xs-3 col-md-3">\n                    <input type="text" class="form-control" id="start-date" placeholder="Start Date">\n                </div>\n                <div class="form-group col-xs-3 col-md-3">\n                    <input type="text" class="form-control" id="end-date" placeholder="End Date">\n                </div>\n                ';
	 if (mode == 'organization') { 
	__p+='\n                <div id="persons-container" class="form-group col-xs-6 col-md-6"></div>\n                ';
	 } 
	__p+='\n\n                <div class="form-group col-xs-12 col-md-12"><textarea id="comment" class="form-control" placeholder="Description">'+
	((__t=( description ))==null?'':__t)+
	'</textarea></div>\n\n                <div id="person-organization-loader" class="loader" style="height: 200px;"></div>\n\n                <div id="contacts-container" class="top-margined">\n                    <h3 class="center">Contacts</h3>\n                    <div id="person-org-contacts"></div>\n                    <div id="person-org-contact-form" class="col-xs-12 col-md-12"></div>\n                </div>\n            </div>\n            <div class="modal-footer">\n                <div class="col-xs-8 col-md-8 form-group">\n                    <div id="orgs-contact-list" class="pull-left"></div>\n                    <div id="persons-contact-list" class="pull-left"></div>\n                </div>\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-primary" id="save" disabled>Save</button>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td><a href="/#person/'+
	((__t=( child.id ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( child.name ))==null?'':__t)+
	'</a></td>\n<td>'+
	((__t=( formatDate(startTime) ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( formatDate(endTime) ))==null?'':__t)+
	'</td>\n<td>\n    ';
	 _.each(contacts, function(contact){ 
	__p+='\n    <span class="label ';
	 if (contact.preferred) { 
	__p+=' label-success ';
	 } else { 
	__p+=' label-primary ';
	 } 
	__p+='" style="font-size: 14px;">\n        '+
	((__t=( contact.type ))==null?'':__t)+
	' - '+
	((__t=( contact.data ))==null?'':__t)+
	'\n    </span>&nbsp;\n    ';
	 }) 
	__p+='\n</td>\n';
	 if (canEdit) { 
	__p+='\n<td><span class="glyphicon glyphicon-edit clickable org-person-edit" title="Edit"/></td>\n<td><span class="glyphicon glyphicon-remove clickable org-person-remove" title="Remove"/></td>\n';
	 } 
	__p+='\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="loading"></div>\n';
	 if (canEdit) { 
	__p+='\n<button class="btn btn-primary btn-sm" id="new-person">New Relationship</button>\n';
	 } 
	__p+='\n<table class="table table-hover top-margined">\n    <head>\n        <thead>\n        <tr>\n            <th>Person</th>\n            <th>Date From</th>\n            <th>Date To</th>\n            <th>Contacts</th>\n            <th></th>\n            <th></th>\n        </tr>\n        </thead>\n    </head>\n    <tbody></tbody>\n</table>\n\n<div id="organization-person"></div>\n<div id="org-person-delete-confirmation-modal"></div>';
	}
	return __p;
	};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\n\n    <h3 class="center">'+
	((__t=( name ))==null?'':_.escape(__t))+
	'</h3>\n\n    <!-- Nav tabs -->\n    <ul class="nav nav-tabs" role="tablist">\n        <li role="presentation" class="active"><a href="#organization-main" aria-controls="organization-main" role="tab" data-toggle="tab">Main</a></li>\n        <li role="presentation"><a href="#organization-contacts" aria-controls="organization-contacts" role="tab" data-toggle="tab">Contacts</a></li>\n        ';
	 if (canEdit()) { 
	__p+='\n        <li role="presentation"><a href="#organization-permissions" aria-controls="organization-permissions" role="tab" data-toggle="tab">Permissions</a></li>\n        <li role="presentation"><a href="#organization-comments" aria-controls="organization-comments" role="tab" data-toggle="tab">\n            Comments <span class="badge" id="comments-count"></span></a></li>\n        ';
	 } 
	__p+='\n        ';
	 if (byAdmin) { 
	__p+='\n        <li role="presentation"><a href="#organization-import-settings" aria-controls="organization-import-settings" role="tab" data-toggle="tab">Import settings</a></li>\n        <li role="presentation"><a href="#org-external-ids" aria-controls="org-external-ids" role="tab" data-toggle="tab">External Ids</a></li>\n        ';
	 } 
	__p+='\n        <li role="presentation"><a href="#organization-persons" aria-controls="organization-persons" role="tab" data-toggle="tab">Persons</a></li>\n    </ul>\n\n    <!-- Tab panes -->\n    <div class="tab-content">\n        <div role="tabpanel" class="tab-pane active top-margined" id="organization-main">\n            <div id="organization-data"></div>\n\n            <div id="edit-section" style="display: none;">\n                <div id="organization-form" class="edit-form"></div>\n                <div id="edit-buttons" class="edit-buttons">\n                    <div class="left-buttons">\n                        <button type="button" class="btn btn-default" id="cancel-edit">Cancel</button>\n                        <button type="button" class="btn btn-primary" id="save-organization">Save changes</button>\n                    </div>\n                    <div class="right-buttons">\n                        <button type="button" class="btn btn-danger" id="remove-organization">Remove organisation</button>\n                    </div>\n                </div>\n            </div>\n\n            <div class="row hidden">\n                <div class="col-md-6">\n                    <h3>Related organization</h3>\n                    <div id="organization-relations"></div>\n                    <div id="add-organization-relation" class="col-xs-6 col-md-4"></div>\n                </div>\n\n                <div class="col-md-6 hidden">\n                    <h3>Related persons</h3>\n                    <div id="person-relations"></div>\n                    <div id="add-person-relation" class="col-xs-6 col-md-4"></div>\n                </div>\n            </div>\n        </div>\n        <div role="tabpanel" class="tab-pane top-margined" id="organization-contacts">\n            <div class="row" id="contacts-list">\n                <h3 class="center">Representatives</h3>\n                <div id="representatives"></div>\n                <div id="representative-form" class="col-xs-12 col-md-12"></div>\n                <h3 class="center">Contacts</h3>\n                <div id="contacts"></div>\n                <div id="contact-form" class="col-xs-12 col-md-12"></div>\n                <h3 class="center">Addresses</h3>\n                <div id="addresses"></div>\n                <div id="address-form" class="col-xs-12 col-md-12"></div>\n            </div>\n        </div>\n        ';
	 if (canEdit()) { 
	__p+='\n        <div role="tabpanel" class="tab-pane top-margined" id="organization-permissions">\n            <div id="permissions-block">\n                <div class="row" id="permissions-list">\n                    <h3 class="center">Permissions</h3>\n                    <div id="permissions"></div>\n                    <div id="add-permission" class="col-xs-12 col-md-12"></div>\n                </div>\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n        ';
	 if (canEdit()) { 
	__p+='\n        <div role="tabpanel" class="tab-pane top-margined" id="organization-comments">\n            <div class="row"  id="comments-list">\n                <h3 class="center">Comments</h3>\n                <div id="comments" style="max-height: 20000px;"></div>\n                ';
	 if (canEdit()) { 
	__p+='\n                <div id="add-comment" class="col-xs-12 col-md-12"></div>\n                ';
	 } 
	__p+='\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n        ';
	 if (byAdmin) { 
	__p+='\n        <div role="tabpanel" class="tab-pane top-margined" id="organization-import-settings">\n            <h3 class="center">Import settings</h3>\n            <div id="organization-import-settings-content">\n            </div>\n        </div>\n        <div role="tabpanel" class="tab-pane top-margined" id="org-external-ids">\n            <h3 class="center">External Ids</h3>\n            <div id="external-ids">\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n        <div role="tabpanel" class="tab-pane top-margined" id="organization-persons">\n            <h3 class="center">Persons</h3>\n            <div id="persons"></div>\n        </div>\n    </div>\n\n</div>\n\n<div class="delete-confirmation-modal"></div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _, jQuery) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	var tablesFilterPreferencesChannel = Radio.channel('tablesFilterPreferencesChannel');
	
	var MedsidePatientsCollections = __webpack_require__(286);
	var TableSettingsManager = __webpack_require__(287);
	var TableColumnFiltersView = __webpack_require__(289);
	var utils = new CommonUtils();
	
	var OrganizationPatientAuditsTableRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(291),
	    ui: {},
	
	    events: {},
	
	    templateContext: function () {
	        var that = this;
	        var changeDate = that.model.get('changedate');
	        return {
	            canEdit: that.canEdit,
	            changeuser: that.model.get('changeuser'),
	            comment: that.model.get('comment'),
	            changeDate: changeDate != undefined && changeDate != ''
	            && !isNaN(changeDate) && changeDate != 0
	                ? that.utils.longToDateTimeFormatted(changeDate, "MM/DD/YYYY") : '-'
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	        this.canEdit = options.canEdit;
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	
	    }
	});
	
	var OrganizationPatientAuditsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: OrganizationPatientAuditsTableRowView,
	    emptyView: EmptyView,
	    collectionEvents: {},
	    childViewEvents: {},
	    initialize: function (options) {
	        this.collection = new Backbone.Collection(options.collection);
	    }
	});
	
	var OrganizationPatientPopoverView = Marionette.View.extend({
	    template: __webpack_require__(292),
	
	    regions: {
	        body: {
	            el: '[name="audits-popover"]',
	            replaceElement: true
	        }
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            reason: that.reason,
	            comment: that.comment,
	            hasAudits: that.auditList && that.auditList.length > 0 ? true : false
	        }
	    },
	
	    initialize: function (options) {
	        this.reason = options.reason;
	        this.comment = options.comment;
	        this.auditList = options.audits;
	    },
	
	    onRender: function () {
	        var that = this;
	        that.showChildView('body', new OrganizationPatientAuditsTableBody({
	            collection: that.auditList,
	            canEdit: that.canEdit
	        }));
	    }
	});
	
	var OrganizationPatientPopoverViewJF = Marionette.View.extend({
	    template: __webpack_require__(293),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	    },
	
	    ui: {
	        sortable: '.sortableR'
	    },
	
	    events: {
	        'click @ui.sortable': 'headerSorting',
	    },
	
	    templateContext: function () {
	    },
	
	    initialize: function (options) {
	        this.jfList = new Backbone.Collection(options.list);
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	        var that = this;
	        that.showChildView('body', new OrganizationPatientPopoverViewJFTableBody({
	            collection: that.jfList,
	            canEdit: that.canEdit
	        }));
	    },
	
	    headerSorting: function (event) {
	        var that = this;
	        var sortField = event.target.id;
	        var byAsc = $(event.target).children('div').hasClass('glyphicon-triangle-bottom');
	
	        that.ui.sortable.each(function () {
	            $(this).children('div').removeClass('glyphicon glyphicon-triangle-bottom');
	            $(this).children('div').removeClass('glyphicon glyphicon-triangle-top');
	        });
	        if (byAsc)
	            $(event.target).children('div').addClass('glyphicon glyphicon-triangle-top');
	        else
	            $(event.target).children('div').addClass('glyphicon glyphicon-triangle-bottom');
	
	        that.jfList.comparator = function (model1, model2) {
	            if (byAsc)
	                return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? 1 : -1;
	            else
	                return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? -1 : 1;
	        };
	        that.jfList.sort();
	    }
	});
	
	var OrganizationPatientPopoverViewJfVisits = Marionette.View.extend({
	    template: __webpack_require__(294),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	    },
	
	    ui: {
	        sortable: '.sortableR'
	    },
	
	    events: {
	        'click @ui.sortable': 'headerSorting',
	    },
	
	    templateContext: function () {
	    },
	
	    initialize: function (options) {
	        this.jfList = new Backbone.Collection(options.list);
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	        var that = this;
	        that.showChildView('body', new OrganizationPatientPopoverViewJfVisitsTableBody({
	            collection: that.jfList,
	            canEdit: that.canEdit
	        }));
	        window.setTimeout(function () {
	            that.headerSorting2($('#start'), "start", false);
	        }, 500);
	    },
	
	    headerSorting: function (event) {
	        var that = this;
	        var sortField = event.target.id;
	        var byAsc = $(event.target).children('div').hasClass('glyphicon-triangle-bottom');
	
	        that.ui.sortable.each(function () {
	            $(this).children('div').removeClass('glyphicon glyphicon-triangle-bottom');
	            $(this).children('div').removeClass('glyphicon glyphicon-triangle-top');
	        });
	        if (byAsc)
	            $(event.target).children('div').addClass('glyphicon glyphicon-triangle-top');
	        else
	            $(event.target).children('div').addClass('glyphicon glyphicon-triangle-bottom');
	
	        that.jfList.comparator = function (model1, model2) {
	            if (byAsc)
	                return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? 1 : -1;
	            else
	                return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? -1 : 1;
	        };
	        that.jfList.sort();
	    },
	
	    headerSorting2: function (target, sortField, byAsc) {
	        var that = this;
	
	        that.ui.sortable.each(function () {
	            $(this).children('div').removeClass('glyphicon glyphicon-triangle-bottom');
	            $(this).children('div').removeClass('glyphicon glyphicon-triangle-top');
	        });
	        if (byAsc)
	            target.children('div').addClass('glyphicon glyphicon-triangle-top');
	        else
	            target.children('div').addClass('glyphicon glyphicon-triangle-bottom');
	
	        that.jfList.comparator = function (model1, model2) {
	            if (byAsc)
	                return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? 1 : -1;
	            else
	                return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? -1 : 1;
	        };
	        that.jfList.sort();
	    }
	});
	
	var OrganizationPatientPopoverViewJFRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(295),
	
	    ui: {
	        canceled: '.rns-canceled-doc',
	        created: '.rns-created-doc'
	    },
	
	    events: {
	        'click @ui.canceled': 'openCanceled',
	        'click @ui.created': 'openCreated',
	    },
	
	    templateContext: function () {
	    },
	
	    initialize: function (options) {
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	    },
	
	    openCanceled: function () {
	        var that = this;
	        that.doIfDocExists(function (docId) {
	            window.open(docId);
	        }, 'canceled_docs');
	    },
	
	    openCreated: function () {
	        var that = this;
	        that.doIfDocExists(function (docId) {
	            window.open(docId);
	        }, 'created_docs');
	    },
	
	    doIfDocExists: function (fn, docType) {
	        var that = this;
	        var params = [];
	
	        that.model.get(docType).split(',').forEach(function (aliasDoc) {
	            params.push("alias=" + aliasDoc);
	        });
	
	        $.ajax({
	            type: "GET",
	            url: '/api/document/preview?' + params.join('&'),
	            statusCode: {
	                200: function (response) {
	                    if (response && response[0] && response[0].id) {
	                        if (response.length == 1)
	                            fn("/api/document/view/" + response[0].id);
	                        else {
	                            fn("#documents?" + params.join('&'));
	                        }
	
	                    }
	                    else
	                        $.notify("This Document was not found in R&S", "error");
	
	                },
	                503: function (e) {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	
	                },
	                401: function (e) {
	                    actionsChannel.request("redirect:to:login");
	
	                },
	                400: function (e) {
	                    $.notify("This Document was not found in R&S", "error");
	                }
	            }
	        });
	    }
	
	});
	
	var OrganizationPatientPopoverViewJfVisitsRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(296),
	
	    templateContext: function () {
	        var that = this;
	        this.utils = new CommonUtils();
	        return {
	            formatDate: function (dt) {
	                return (dt == '' || dt == null || dt == 0 ? '' : that.utils.longToDateTimeFormatted(Number(dt), 'MM/DD/YYYY'));
	            }
	        }
	    },
	
	    initialize: function (options) {
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	    }
	
	
	});
	
	var OrganizationPatientPopoverViewJFTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: OrganizationPatientPopoverViewJFRowView,
	    emptyView: EmptyView,
	
	    collectionEvents: {},
	
	    childViewEvents: {},
	
	    initialize: function (options) {
	        this.collection = options.collection;
	        this.canEdit = options.canEdit;
	    },
	
	    childViewOptions: function () {
	        return {
	            canEdit: this.canEdit,
	        };
	    }
	});
	
	var OrganizationPatientPopoverViewJfVisitsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: OrganizationPatientPopoverViewJfVisitsRowView,
	    emptyView: EmptyView,
	
	    collectionEvents: {},
	
	    childViewEvents: {},
	
	    initialize: function (options) {
	        this.collection = options.collection;
	        this.canEdit = options.canEdit;
	    },
	
	    childViewOptions: function () {
	        return {
	            canEdit: this.canEdit,
	        };
	    }
	});
	
	var OrganizationPatientsView = Marionette.View.extend({
	    template: __webpack_require__(297),
	    tagName: 'div',
	    className: 'patients-table',
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	
	        settingModule: {
	            el: '#setting-module',
	            replaceElement: true
	        },
	
	        //filter regions in column caption
	        patientNameFilter: '#patient_name',
	        referralDateFilter: '#referral_date',
	        socFilter: '#soc',
	        transferFilter: '#transfer_date',
	        statusFilter: '#status',
	        admitFilter: '#admit',
	        mdFilter: '#md',
	        locationFilter: '#location',
	        jencareCoordinatorsFilter: '#jencare_coordinators',
	        insuranceFilter: '#insurance',
	        intakeFilter: '#intake',
	        cmCnFilter: '#cm_sn'
	    },
	
	    ui: {
	        exportToPdf: '#export-to-pdf',
	        exportToCsv: '#export-to-csv',
	        patientsCount: '#patients-count',
	        sortable: '.sortable'
	    },
	
	    events: {
	        'click @ui.exportToPdf': 'onExportToPdf',
	        'click @ui.exportToCsv': 'onExportToCsv',
	        'click @ui.sortable': 'reorder'
	    },
	
	    childViewEvents: {
	        'filter:changed': 'onFilterChanged',
	        'filters:loaded': 'onFiltersReloaded'
	    },
	
	
	    templateContext: function () {
	        var that = this;
	        return {
	            isSimple: that.isSimple,
	            patientsCount: that.patientsCount,
	            placeholder: that.placeholder,
	            settings: that.settings,
	            selectedTableFiltersId: that.selectedTableFiltersId,
	            variant: that.variant
	        }
	    },
	
	
	    initialize: function (options) {
	        var that = this;
	        this.utils = new CommonUtils();
	        this.utils.showSpinner();
	        this.orgs = [];
	        this.settings = [];
	        this.selectedTableFiltersId = "";
	        this.params = $.deparam(window.location.hash.replace('#organization/' + options.id + '/patients', '').replace('?', ''));
	        var orgParams = this.params['org'];
	        this.isSimple = this.params['isSimple'] || false;
	        this.variant = this.params['variant'] || "";
	        this.from = this.params['from'];
	        this.to = this.params['to'];
	
	        if (Array.isArray(orgParams)) {
	            for (var ind in orgParams) {
	                this.orgs.push(orgParams[ind]);
	            }
	        } else {
	            this.orgs.push(orgParams);
	        }
	
	        this.id = options.id;
	
	        this.collection = new MedsidePatientsCollections([], {
	            id: options.id,
	            orgs: that.orgs,
	            variant: that.variant,
	            from: that.from,
	            to: that.to
	        });
	
	        if (that.variant == "referral")
	            that.reportTableName = 'organization-patients-report-referral';
	        else
	            that.reportTableName = 'organization-patients-report';
	        that.tableFilterPreferences = {
	            tableColumnFilters: [],
	            sortField: "patient_name",
	            sortDirection: "ASC"
	        };
	        this.filterFunctions = {};
	    },
	
	    onRender: function () {
	        var that = this;
	
	        this.collection.fetch({
	            success: function () {
	                that.tableReDrawPack();
	                that.utils.hideSpinner();
	            },
	            error: function (obj, response) {
	                that.utils.hideSpinner();
	                that.triggerMethod('server:error', response.responseText);
	            }
	        });
	
	        that.showChildView('settingModule', new TableSettingsManager({
	            table: that
	        }));
	    },
	
	    tableReDrawPack: function () {
	        var that = this;
	        that.resort(that.collection);
	        that.renderPatientsTableBody(that.collection);
	        that.renderColumnFilters();
	        that.renderSortColumns();
	    },
	
	    renderPatientsTableBody: function (collection) {
	        var that = this;
	
	        that.ui.patientsCount.text(' (' + collection.length + ')');
	
	        that.patientsTableBody = new PatientsTableBody({
	            collection: collection,
	            isSimple: that.isSimple,
	            variant: that.variant
	        });
	        that.showChildView('body', that.patientsTableBody);
	    },
	
	    renderSortColumns: function () {
	        var that = this;
	        var sortField = that.tableFilterPreferences.sortField;
	        var sortDirection = that.tableFilterPreferences.sortDirection;
	        $('.sort-icon').removeClass("glyphicon glyphicon-triangle-top glyphicon-triangle-bottom");
	        var currentSortEl = $("#" + sortField).parent().children(':first-child');
	
	        if (sortDirection == "ASC") {
	            currentSortEl.addClass("glyphicon glyphicon-triangle-top");
	        } else {
	            currentSortEl.addClass("glyphicon glyphicon-triangle-bottom");
	        }
	    },
	
	    reorder: function (event) {
	        var that = this;
	        var sortFieldName = $(event.target).next().attr("id");
	        if (this.tableFilterPreferences.sortField == sortFieldName) {
	            this.tableFilterPreferences.sortDirection = this.tableFilterPreferences.sortDirection == "ASC" ? "DESC" : "ASC";
	        } else {
	            this.tableFilterPreferences.sortField = sortFieldName;
	            this.tableFilterPreferences.sortDirection = "ASC";
	        }
	
	        this.renderSortColumns();
	        this.resort(this.patientsTableBody.getCollection());
	        this.patientsTableBody.render();
	    },
	
	    resort: function (collection) {
	        collection.sortByFieldAndDirection(this.tableFilterPreferences.sortField, this.tableFilterPreferences.sortDirection);
	    },
	
	    renderColumnFilters: function () {
	
	        var that = this;
	
	        that.showChildView("patientNameFilter", new TableColumnFiltersView({
	            filter: that.findFiltersForColumn("patient_name") || {
	                column: "patient_name",
	                dataType: "string",
	                filterType: "select",
	                value: null
	            },
	            'list': that.getAggregateTypes(this.collection, 'patient_name', 'patient_name')
	        }));
	
	        that.showChildView("socFilter", new TableColumnFiltersView({
	            filter: that.findFiltersForColumn("soc") || {
	                column: "soc",
	                dataType: "date",
	                filterType: "interval",
	                from: null,
	                to: null
	            }
	        }));
	
	        if (that.variant != 'referral') {
	            that.showChildView("transferFilter", new TableColumnFiltersView({
	                filter: that.findFiltersForColumn("transfer_date") || {
	                    column: "transfer_date",
	                    dataType: "date",
	                    filterType: "interval",
	                    from: null,
	                    to: null
	                }
	            }));
	
	            that.showChildView("statusFilter", new TableColumnFiltersView({
	                filter: that.findFiltersForColumn("status") || {
	                    column: "status",
	                    dataType: "date",
	                    filterType: "interval",
	                    from: null,
	                    to: null
	                }
	            }));
	        }
	
	
	        if (!that.isSimple) {
	            that.showChildView("referralDateFilter", new TableColumnFiltersView({
	                filter: that.findFiltersForColumn("referral_date") || {
	                    column: "referral_date",
	                    dataType: "date",
	                    filterType: "interval",
	                    from: null,
	                    to: null
	                }
	            }));
	
	            that.showChildView("admitFilter", new TableColumnFiltersView({
	                filter: that.findFiltersForColumn("admit") || {
	                    column: "admit",
	                    dataType: "string",
	                    filterType: "select",
	                    value: null
	                },
	                'list': that.getAggregateTypes(this.collection, 'admit', 'admit')
	            }));
	
	            that.showChildView("mdFilter", new TableColumnFiltersView({
	                filter: that.findFiltersForColumn("md") || {
	                    column: "md",
	                    dataType: "string",
	                    filterType: "select",
	                    value: null
	                },
	                'list': that.getAggregateTypes(this.collection, 'md', 'md')
	            }));
	
	            that.showChildView("locationFilter", new TableColumnFiltersView({
	                filter: that.findFiltersForColumn("location") || {
	                    column: "location",
	                    dataType: "string",
	                    filterType: "select",
	                    value: null
	                },
	                'list': that.getAggregateTypes(this.collection, 'location', 'location')
	            }));
	
	            that.showChildView("jencareCoordinatorsFilter", new TableColumnFiltersView({
	                filter: that.findFiltersForColumn("jencare_coordinators") || {
	                    column: "jencare_coordinators",
	                    dataType: "string",
	                    filterType: "select",
	                    value: null
	                },
	                'list': that.getAggregateTypes(this.collection, 'jencare_coordinators', 'jencare_coordinators')
	            }));
	
	            that.showChildView("insuranceFilter", new TableColumnFiltersView({
	                filter: that.findFiltersForColumn("insurance") || {
	                    column: "insurance",
	                    dataType: "string",
	                    filterType: "select",
	                    value: null
	                },
	                'list': that.getAggregateTypes(this.collection, 'insurance', 'insurance')
	            }));
	
	            that.showChildView("intakeFilter", new TableColumnFiltersView({
	                filter: that.findFiltersForColumn("intake") || {
	                    column: "intake",
	                    dataType: "string",
	                    filterType: "select",
	                    value: null
	                },
	                'list': that.getAggregateTypes(this.collection, 'intake', 'intake')
	            }));
	
	            that.showChildView("cmCnFilter", new TableColumnFiltersView({
	                filter: that.findFiltersForColumn("cm_sn") || {
	                    column: "cm_sn",
	                    dataType: "string",
	                    filterType: "select",
	                    value: null
	                },
	                'list': that.getAggregateTypes(this.collection, 'cm_sn', 'cm_sn')
	            }));
	        }
	    },
	
	    getAggregateTypes: function (collection, fieldName, fieldValue) {
	        var result = [];
	        collection.each(function (model, index, list) {
	            if (
	                model.get(fieldName) &&
	                model.get(fieldValue) &&
	                result.filter(function (e) {
	                    return e.name == model.get(fieldName) && e.value == model.get(fieldValue);
	                }).length == 0
	            ) {
	                result.push({name: model.get(fieldName), value: model.get(fieldValue)});
	            }
	        })
	        return result;
	    },
	
	    findFiltersForColumn: function (column) {
	        return _.find(this.tableFilterPreferences.tableColumnFilters, function (columnWithFilter) {
	            return columnWithFilter.column == column
	        });
	    },
	
	    onFiltersReloaded: function (filters) {
	        var that = this;
	        that.utils.showSpinner();
	
	        that.tableFilterPreferences = filters;
	        that.renderColumnFilters();
	        that.resort(that.collection);
	        that.renderSortColumns();
	
	        window.setTimeout(function () {
	            that.utils.hideSpinner();
	            $.notify("Filters successfully reloaded", "success");
	        }, 2000);
	    },
	
	    onFilterChanged: function (payload) {
	        var that = this;
	
	        var foundIndex = _.findIndex(that.tableFilterPreferences.tableColumnFilters, function (tcf) {
	            return tcf.column == payload.columnFilter.column
	                && tcf.dataType == payload.columnFilter.dataType
	                && tcf.filterType == payload.columnFilter.filterType;
	        });
	
	        if (foundIndex > -1) {
	            that.tableFilterPreferences.tableColumnFilters[foundIndex] = payload.columnFilter;
	        } else {
	            that.tableFilterPreferences.tableColumnFilters.push(payload.columnFilter);
	        }
	
	        that.filterFunctions[payload.columnFilter.column] = payload.filterFunction;
	
	        if (payload.deferred) {
	            if (_.keys(that.filterFunctions).length == (that.isSimple ? 4 : (that.variant == 'referral') ? 10 : 12) /* this is filter views count*/)
	                that.filterCollectionWithFilterFunctions(that.filterFunctions);
	        } else {
	            that.filterCollectionWithFilterFunctions(that.filterFunctions);
	        }
	    },
	
	    filterCollectionWithFilterFunctions: function (filterFunctions) {
	        var that = this;
	        var notEmptyFilterFunctionsKeys = _.keys(filterFunctions).filter(function (key) {
	            return _.isFunction(filterFunctions[key]);
	        });
	
	        var filteredCollection = new MedsidePatientsCollections(that.collection.filter(function (model) {
	                return _.reduce(notEmptyFilterFunctionsKeys, function (memo, fnKey) {
	                    return memo && filterFunctions[fnKey](model.get(fnKey));
	                }, true);
	            }
	        ), {id: that.id});
	
	        that.resort(filteredCollection);
	        that.renderPatientsTableBody(filteredCollection);
	    },
	
	    collectionValuesAsTsv: function () {
	
	        var that = this;
	        var asTable = that.getChildView("body").getCollection().models.map(function (model) {
	            return model.attributes
	        })
	        var rowSplitter = "~~~";
	        var valueSplitter = ";;;";
	        var emptinessSymbol = "___";
	
	        var formatDate = function (val) {
	            return (val == '' || val == null || val == 0 ? emptinessSymbol : that.utils.longToDateTimeFormatted(Number(val), 'MM/DD/YYYY'));
	        }
	
	        var asTsv = asTable.map(function (model) {
	            if (that.isSimple) {
	                return (model.patient_name || emptinessSymbol) + valueSplitter
	                    + formatDate(model.soc) + valueSplitter
	                    + formatDate(model.status)
	            }
	
	            return (model.patient_name || emptinessSymbol) + valueSplitter
	                + formatDate(model.referral_date) + valueSplitter
	                + formatDate(model.soc) + valueSplitter
	                + (that.variant != "referral" ? formatDate(model.transfer_date) + valueSplitter
	                    + formatDate(model.status) + " " + (model.dc_type || emptinessSymbol) + valueSplitter : "").replace(/___ ___/g, "")
	                + (model.admit || emptinessSymbol) + valueSplitter
	                + (model.md || emptinessSymbol) + valueSplitter
	                + (model.location || emptinessSymbol) + valueSplitter
	                + (model.jencare_coordinators || emptinessSymbol).split(':')[0] + valueSplitter
	                + (model.insurance || emptinessSymbol) + valueSplitter
	                + (model.intake || emptinessSymbol) + valueSplitter
	                + (model.cm_sn || emptinessSymbol)
	        }).join(rowSplitter);
	
	        var tsvHeader = "Patient" + valueSplitter
	            + "Refferal" + valueSplitter
	            + "SOC" + valueSplitter
	            + (that.variant != "referral" ? "Transfer" + valueSplitter
	                + "DC" + valueSplitter : "")
	            + "Admit" + valueSplitter
	            + "MD" + valueSplitter
	            + "Location" + valueSplitter
	            + "Coordinator" + valueSplitter
	            + "Insurance" + valueSplitter
	            + "Intake" + valueSplitter
	            + "CM" + rowSplitter;
	        if (that.isSimple) {
	            tsvHeader = "Patient" + valueSplitter
	                + "SOC" + valueSplitter
	                + "DC" + rowSplitter;
	        }
	
	        return tsvHeader + asTsv;
	    },
	
	    onExportToPdf: function () {
	
	        this.utils.downloadFileWithPost("/api/pdf/table/from/csv",
	            ["caption=Patients", "content=" + this.collectionValuesAsTsv()]);
	    },
	
	    onExportToCsv: function () {
	        var csv = this.collectionValuesAsTsv();
	        csv = csv.replace(/,/g, ".").replace(/~~~/g, "\n").replace(/;;;/g, ",").replace(/___/g, "");
	        var hiddenElement = document.createElement('a');
	        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
	        hiddenElement.target = '_blank';
	        hiddenElement.download = 'Patients.csv';
	        hiddenElement.click();
	        window.setTimeout(function () {
	            hiddenElement.remove();
	        }, 0);
	    }
	});
	
	var PatientsRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(298),
	    ui: {
	        refpo: '[name="refpo"]',
	        socpo: '[name="socpo"]',
	        jfsv: '[name="jfspov"]',
	        jfsvis: '[name="jfsvis"]',
	        patient_profile: '[name="open_profile"]',
	        rnsDocs: '.rns-docs'
	    },
	    events: {
	        'click @ui.patient_profile': 'openIfPatientExists',
	        'click @ui.rnsDocs': 'openDocumentsIfPatientExists'
	    },
	
	    templateContext: function () {
	        var that = this;
	        this.utils = new CommonUtils();
	        return {
	            formatDate: function (dt) {
	                return (dt == '' || dt == null || dt == 0 ? '' : that.utils.longToDateTimeFormatted(Number(dt), 'MM/DD/YYYY'));
	            },
	            isSimple: that.isSimple,
	            variant: that.variant,
	            toUpper: function (value) {
	                return value ? value.toUpperCase() : value;
	            }
	        }
	    },
	
	    initialize: function (options) {
	        this.params = $.deparam(window.location.hash.replace('#organization/' + options.id + '/patients', '').replace('?', ''));
	        this.sourceOrganization = this.params['sourceOrganization'];
	        this.isSimple = options.isSimple;
	        this.variant = options.variant || "";
	    },
	
	    onRender: function () {
	        var that = this;
	        var organizationPatientsViewRef = new OrganizationPatientPopoverView({
	            reason: that.model.get('ref_reason'),
	            comment: that.model.get('ref_comment'),
	            audits: that.model.get('ref_audits')
	        });
	        var organizationPatientsViewSoc = new OrganizationPatientPopoverView({
	            reason: that.model.get('soc_reason'),
	            comment: that.model.get('soc_comment'),
	            audits: that.model.get('soc_audits')
	        });
	        organizationPatientsViewRef.render();
	        organizationPatientsViewSoc.render();
	
	        that.ui.refpo.popover({
	            content: organizationPatientsViewRef.el,
	            template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-title"></div><div class="popover-content"></div></div>',
	            placement: 'right'
	        })
	            .on("show.bs.popover", function () {
	                var self = $(this);
	                $('.popover').each(function () {
	                    if (self != $(this)) {
	                        $(this).popover('hide');
	                    }
	                });
	                $(this).data("bs.popover").tip().css(
	                    {
	                        //"max-width": "100%",
	                        //"text-align": "right",
	                        //"border-style": "solid",
	                        "border-width": "3px"
	                    }
	                );
	
	                $(this).data("bs.popover").arrow().css(
	                    {
	                        "display": "none"
	                    }
	                );
	            })
	            .on('shown.bs.popover', function (e) {
	                var popover = $(this);
	
	                /*if (popover.data("bs.popover").tip().css("top").charAt(0) == '-') {
	                    popover.data("bs.popover").tip().css(
	                        {
	                            "top": "0px"
	                        }
	                    );
	                }*/
	                jQuery(this).parent().find('div.popover .close').on('click', function (e) {
	                    popover.popover('hide');
	                });
	            })
	            .on("hidden.bs.popover", function () {
	                $(this).data("bs.popover").inState.click = false
	            });
	
	        that.ui.socpo.popover({
	            content: organizationPatientsViewSoc.el,
	            placement: 'right',
	            template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-title"></div><div class="popover-content"></div></div>'
	        })
	            .on("show.bs.popover", function () {
	                var self = $(this);
	                $('.popover').each(function () {
	                    if (self != $(this)) {
	                        $(this).popover('hide');
	                    }
	                });
	                $(this).data("bs.popover").tip().css({
	                    //"max-width": "100%",
	                    //"text-align": "right",
	                    //"border-style": "solid",
	                    "border-width": "3px"
	                });
	                $(this).data("bs.popover").arrow().css(
	                    {
	                        "display": "none"
	                    }
	                );
	            })
	            .on('shown.bs.popover', function (e) {
	                var popover = $(this);
	
	                /*if (popover.data("bs.popover").tip().css("top").charAt(0) == '-') {
	                    popover.data("bs.popover").tip().css(
	                        {
	                            "top": "0px"
	                        }
	                    );
	                }*/
	                jQuery(this).parent().find('div.popover .close').on('click', function (e) {
	                    popover.popover('hide');
	                });
	            })
	            .on("hidden.bs.popover", function () {
	                $(this).data("bs.popover").inState.click = false
	            });
	
	        that.ui.jfsv.popover(
	            {
	                placement: "left",
	                //template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header test"></h3><div class="popover-body"></div></div>',
	                template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-title"></div><div class="popover-content"></div></div>',
	                content: function () {
	                    var div_id = "tmp-id-" + $.now();
	                    return that.asyncShowJournalFrequencies(div_id, 'v_' + that.model.get('patient_id'), that.model.get('soc'));
	                },
	            }
	        )
	            .on("show.bs.popover", function () {
	                var self = $(this);
	                $('.popover').each(function () {
	                    if (self != $(this)) {
	                        $(this).popover('hide');
	                    }
	                });
	                $(this).data("bs.popover").tip().css(
	                    {
	                        "max-width": "100%",
	                        //"text-align": "right",
	                        //"border-style": "solid",
	                        "border-width": "3px"
	                    }
	                );
	
	                $(this).data("bs.popover").arrow().css(
	                    {
	                        "display": "none"
	                    }
	                );
	            })
	            .on('shown.bs.popover', function (e) {
	                var popover = $(this);
	
	                popover.data("bs.popover").tip().css(
	                    {
	                        //"left": (Number($('body').width() - 1200) / 2) + "px",
	                        //"right": (Number($('body').width() - 1200) / 2) + "px"
	                        "left": "140px",
	                        "right": "140px"
	                    }
	                );
	
	                /*if (popover.data("bs.popover").tip().css("top").charAt(0) == '-') {
	                    popover.data("bs.popover").tip().css(
	                        {
	                            "top": "0px"
	                        }
	                    );
	                }*/
	
	                jQuery(this).parent().find('div.popover .close').on('click', function (e) {
	                    popover.popover('hide');
	                });
	            })
	            .on("hidden.bs.popover", function () {
	                $(this).data("bs.popover").inState.click = false
	            });
	
	        that.ui.jfsvis.popover(
	            {
	                placement: "left",
	                template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-title"></div><div class="popover-content"></div></div>',
	                content: function () {
	                    var div_id = "tmp-id-" + $.now();
	                    return that.asyncShowJournalFrequenciesVisits(div_id, 'jfd_' + that.model.get('patient_id'), that.model.get('soc'));
	                },
	            }
	        )
	            .on("show.bs.popover", function () {
	                var self = $(this);
	                $('.popover').each(function () {
	                    if (self != $(this)) {
	                        $(this).popover('hide');
	                    }
	                });
	                $(this).data("bs.popover").tip().css(
	                    {
	                        "max-width": "100%",
	                        //"text-align": "right",
	                        //"border-style": "solid",
	                        "border-width": "3px"
	                    }
	                );
	
	                $(this).data("bs.popover").arrow().css(
	                    {
	                        "display": "none"
	                    }
	                );
	            })
	            .on('shown.bs.popover', function (e) {
	                var popover = $(this);
	
	                popover.data("bs.popover").tip().css(
	                    {
	                        //"left": (Number($('body').width() - popover.width()) / 4) + "px"
	                        "left": "200px",
	                        "right": "200px"
	                    }
	                );
	
	                /*if (popover.data("bs.popover").tip().css("top").charAt(0) == '-') {
	                    popover.data("bs.popover").tip().css(
	                        {
	                            "top": "0px"
	                        }
	                    );
	                }
	
	                if (popover.data("bs.popover").tip().css("left").charAt(0) == '-') {
	                    popover.data("bs.popover").tip().css(
	                        {
	                            "left": "10px"
	                        }
	                    );
	                }*/
	
	                jQuery(this).parent().find('div.popover .close').on('click', function (e) {
	                    popover.popover('hide');
	                });
	            })
	            .on("hidden.bs.popover", function () {
	                $(this).data("bs.popover").inState.click = false
	            });
	    },
	
	
	    asyncShowJournalFrequencies: function (div_id, patient, date) {
	        var that = this;
	        var url = "/api/organization/journal_frequencies?patient_id=" + patient + "&date=" + date;
	        var method = "POST";
	
	
	        $.ajax({
	            type: method,
	            url: url,
	            statusCode: {
	                200: function (response) {
	                    if (response.list) {
	                        var organizationPatientPopoverViewJF = new OrganizationPatientPopoverViewJF({
	                            list: response.list
	                        });
	                        organizationPatientPopoverViewJF.render();
	                        $('#' + div_id).html(organizationPatientPopoverViewJF.el);
	                    }
	                    else {
	                        $('#' + div_id).html(response.responseText);
	                    }
	
	                },
	                503: function (e) {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	
	                },
	                401: function (e) {
	                    actionsChannel.request("redirect:to:login");
	
	                },
	                404: function (e) {
	                    var error = JSON.parse(e.responseText);
	                    $('#' + div_id).html(error.message);
	                }
	            },
	            error: function (e) {
	                console.log(e);
	            }
	        });
	        return '<div id="' + div_id + '" style="text-align:left">Loading...</div>';
	    },
	
	    asyncShowJournalFrequenciesVisits: function (div_id, patient, date) {
	        var that = this;
	        var url = "/api/organization/journal_frequencies?patient_id=" + patient + "&date=" + date;
	        var method = "POST";
	
	
	        $.ajax({
	            type: method,
	            url: url,
	            statusCode: {
	                200: function (response) {
	                    if (response.list) {
	                        var organizationPatientPopoverViewJfVisits = new OrganizationPatientPopoverViewJfVisits({
	                            list: response.list
	                        });
	                        organizationPatientPopoverViewJfVisits.render();
	                        $('#' + div_id).html(organizationPatientPopoverViewJfVisits.el);
	                    }
	                    else {
	                        $('#' + div_id).html(response.responseText);
	                    }
	
	                },
	                503: function (e) {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	
	                },
	                401: function (e) {
	                    actionsChannel.request("redirect:to:login");
	
	                },
	                404: function (e) {
	                    var error = JSON.parse(e.responseText);
	                    $('#' + div_id).html(error.message);
	                }
	            },
	            error: function (e) {
	                console.log(e);
	            }
	        });
	        return '<div id="' + div_id + '" style="text-align:left;">Loading...</div>';
	    },
	
	    openIfPatientExists: function () {
	        var that = this;
	        that.doIfPatientExists(function (patientId) {
	            window.open("/#person/" + patientId);
	        });
	        return false;
	    },
	
	    openDocumentsIfPatientExists: function () {
	        var that = this;
	        that.doIfPatientExists(function (patientId) {
	            //window.open("/#documents?page-size=" + Constants.pageCapacity + "&object_type=xml&like_name=_CCDA&page=0&DOCUMENT_PATIENT=" + patientId);
	            window.open("/#documents?page-size=" + Constants.pageCapacity + "&object_type=pdf&page=0&DOCUMENT_PATIENT=" + patientId);
	        });
	    },
	
	    doIfPatientExists: function (fn) {
	        var that = this;
	        var params = [];
	        params.push("organizationId=" + that.sourceOrganization);//org_id);
	        params.push("externalId=" + that.model.get('p_id'));
	
	        $.ajax({
	            type: "GET",
	            url: '/api/person/external-id?' + params.join('&'),
	            statusCode: {
	                200: function (response) {
	                    if (response && response.responseText) {
	                        fn(response.responseText);
	                    }
	                    else
	                        $.notify("This Patient was not found in R&S", "error");
	
	                },
	                503: function (e) {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	
	                },
	                401: function (e) {
	                    actionsChannel.request("redirect:to:login");
	
	                },
	                400: function (e) {
	                    $.notify("This Patient was not found in R&S", "error");
	                }
	            }
	        });
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(0), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var PatientsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: PatientsRowView,
	    emptyView: EmptyView,
	
	    childViewEvents: {},
	
	    initialize: function (options) {
	        this.collection = options.collection;
	        this.isSimple = options.isSimple;
	        this.variant = options.variant;
	    },
	
	    getCollection: function () {
	        return this.collection;
	    },
	
	    childViewOptions: function () {
	        return {
	            isSimple: this.isSimple,
	            variant: this.variant
	        }
	    }
	
	});
	
	module.exports = OrganizationPatientsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	
	var MedsidePatientsCollections = BaseCollection.extend({
	    url:"/api/organization",
	    sortConf: {field: 'patient_name', asc: true},
	
	    initialize: function(models, options) {
	    	var url = "/medware/patients?";
	    	if(options.variant=="referral")
	    		url = "/medware/patientsByReferral?";
	    	
	        this.url += "/" + options.id + url +
	            (options.orgs||[]).map(function(val){return "org=" + val}).join("&");        
	        
	        if(options.from) this.url += "&from=" + options.from;
	        if(options.to) this.url += "&to=" + options.to;
	        
	    },
	
	    comparator: function(a, b) {
	        if (this.sortConf.field == "referral_date" || this.sortConf.field == "soc" || this.sortConf.field == "status"|| this.sortConf.field == "transfer_date") {
	            a = new Number(a.get(this.sortConf.field));
	            b = new Number(b.get(this.sortConf.field));
	        } else {
	            a = a.get(this.sortConf.field);
	            b = b.get(this.sortConf.field);
	        }
	        result = a > b ?  1
	            : a < b ? -1
	            :          0;
	
	        if (!this.sortConf.asc){
	            return result * -1;
	        }
	        return result;
	    },
	
	    sortByField: function(fieldName) {
	        if (this.sortConf.field != fieldName){
	            this.sortConf = {field: fieldName, asc: true};
	        } else {
	            this.sortConf.asc = !this.sortConf.asc;
	        }
	        this.sort();
	    },
	
	    sortByFieldAndDirection: function (fieldName, direction) {
	        this.sortConf = {field: fieldName, asc: direction == "ASC"};
	        this.sort();
	    }
	
	});
	
	
	module.exports = MedsidePatientsCollections;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var CommonUtils = __webpack_require__(189);
	var utils = new CommonUtils();
	
	var TableSettingsManager = Marionette.View.extend({
	    template: __webpack_require__(288),
	    table: {},
	
	
	    ui: {
	        saveReportSetting: '#save-report-setting',
	        loadReportSetting: '#load-report-setting',
	        savedFilters: '#saved-filters-module',
	        newSettingNameSave: '#save-new-setting-name',
	        newSettingName: '#new-setting-name',
	        deleteSetting: '#delete-report-setting'
	    },
	
	    events: {
	        'click @ui.saveReportSetting': 'onSaveReportSetting',
	        'click @ui.loadReportSetting': 'onLoadReportSetting',
	        'click @ui.newSettingNameSave': 'onSaveNewSettingName',
	        'click @ui.deleteSetting': 'onDeleteSetting',
	        'change @ui.savedFilters': 'onChangeSavedFilters'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {}
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.table = options.table;
	    },
	
	    onRender: function () {
	        var that = this;
	        this.ui.savedFilters.selectize({
	            allowEmptyOption: true,
	            inputClass: 'form-control selectize-input normal-width form-control',
	            highlight: true,
	            openOnFocus: true
	        });
	        that.asyncGetTableSettingsList();
	    },
	
	    asyncGetTableSettingsList: function () {
	        var that = this;
	
	        $.ajax({
	            type: "GET",
	            url: "/api/table-column-filter-preferences/names/" + that.table.reportTableName,
	            statusCode: {
	                200: function (response) {
	                    if (response) {
	                        var arrayLength = response.length;
	                        for (var i = 0; i < arrayLength; i++) {
	                            that.ui.savedFilters["0"].selectize.addOption({
	                                value: response[i].id,
	                                text: response[i].name
	                            });
	                        }
	                    }
	                },
	                503: function (e) {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	
	                },
	                401: function (e) {
	                    actionsChannel.request("redirect:to:login");
	
	                },
	                404: function (e) {
	                    notificationsChannel.request('show:notification', e.responseText);
	                }
	            },
	            error: function (e) {
	                console.log(e);
	            }
	        });
	        return [];
	    },
	
	    onSaveReportSetting: function (e) {
	        var that = this;
	        if (that.ui.savedFilters["0"].selectedOptions["0"].value) {
	            utils.showSpinner();
	            that.table.tableFilterPreferences.settingName = that.ui.savedFilters["0"].selectedOptions["0"].value;
	            $.ajax({
	                type: "PUT",
	                url: "/api/table-column-filter-preferences/name/" + that.table.reportTableName,
	                data: JSON.stringify(that.table.tableFilterPreferences),
	                contentType: 'application/json',
	                statusCode: {
	                    200: function (response) {
	                        utils.hideSpinner();
	                        $.notify("Filters successfully saved", "success");
	                    }
	                },
	                error: function (e) {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                    utils.hideSpinner();
	                }
	            });
	        }
	        else {
	            $.notify("Select filter setting name", "error");
	        }
	    },
	
	    onSaveNewSettingName: function () {
	        var that = this;
	        utils.showSpinner();
	        that.table.tableFilterPreferences.settingName = that.ui.newSettingName["0"].value;
	        $.ajax({
	            type: "POST",
	            url: "/api/table-column-filter-preferences/name/" + that.table.reportTableName,
	            data: JSON.stringify(that.table.tableFilterPreferences),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    utils.hideSpinner();
	                    that.ui.savedFilters["0"].selectize.addOption({
	                        value: that.ui.newSettingName["0"].value,
	                        text: that.ui.newSettingName["0"].value
	                    });
	                    that.ui.savedFilters["0"].selectize.addItem(that.ui.newSettingName["0"].value);
	                    that.ui.newSettingName["0"].value = null;
	                    $('#newSettingInListModal').modal('toggle');
	                    $.notify("Filters successfully created", "success");
	                }
	            },
	            error: function (e) {
	                notificationsChannel.request('show:notification', e.responseText);
	                utils.hideSpinner();
	            }
	        });
	
	    },
	
	    onLoadReportSetting: function (e) {
	        var that = this;
	        if (that.ui.savedFilters["0"].selectedOptions["0"].value) {
	            var that = this;
	            var url = "/api/table-column-filter-preferences/name/" + that.table.reportTableName + "?settingName=" + that.ui.savedFilters["0"].selectedOptions["0"].value;
	            var method = "GET";
	
	            utils.showSpinner();
	            $.ajax({
	                type: method,
	                url: url,
	                statusCode: {
	                    200: function (response) {
	                        if (response) {
	                            that.table.tableFilterPreferences = response;
	                        }
	                        utils.hideSpinner();
	                        that.triggerMethod('filters:loaded', response);
	
	                    },
	                    503: function (e) {
	                        notificationsChannel.request('show:notification', e.responseJSON);
	
	                    },
	                    401: function (e) {
	                        actionsChannel.request("redirect:to:login");
	
	                    },
	                    404: function (e) {
	                        notificationsChannel.request('show:notification', e.responseText);
	                    }
	                },
	                error: function (e) {
	                    utils.hideSpinner();
	                    console.log(e);
	                }
	            });
	        }
	        else {
	            $.notify("Select filter setting name", "error");
	        }
	    },
	
	    onChangeSavedFilters: function (e) {
	        this.selectedTableFiltersId = e.target.selectedOptions["0"].value;
	    },
	
	    onDeleteSetting: function () {
	        var that = this;
	        if (that.ui.savedFilters["0"].selectedOptions["0"].value) {
	            if (confirm("Are you sure?")) {
	                var url = "/api/table-column-filter-preferences/name/" + that.table.reportTableName + "?settingName=" + that.ui.savedFilters["0"].selectedOptions["0"].value;
	                var method = "DELETE";
	
	                $.ajax({
	                    type: method,
	                    url: url,
	                    statusCode: {
	                        200: function (response) {
	                            that.ui.savedFilters["0"].selectize.removeOption(that.ui.savedFilters["0"].selectedOptions["0"].value);
	                            $.notify("Filters successfully removed", "success");
	                        },
	                        503: function (e) {
	                            notificationsChannel.request('show:notification', e.responseJSON);
	
	                        },
	                        401: function (e) {
	                            actionsChannel.request("redirect:to:login");
	
	                        },
	                        404: function (e) {
	                            notificationsChannel.request('show:notification', e.responseText);
	                        }
	                    },
	                    error: function (e) {
	                        console.log(e);
	                    }
	                });
	            }
	        } else
	            $.notify("Select filter setting name", "error");
	    }
	});
	
	module.exports = TableSettingsManager;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\n    <select id="saved-filters-module" placeholder="Select setting..."></select>\n</div>\n<div>     \n    <button id="load-report-setting" class="btn btn-primary"  title="Load setting" >\n        Load\n    </button>    \n    <button id="save-report-setting" class="btn btn-primary"  title="Save setting" >\n        Save\n    </button>\n    <button type="button" id="new-report-setting" class="btn btn-primary" data-toggle="modal" data-target="#newSettingInListModal">\n  		New\n	</button>\n    <button id="delete-report-setting" class="btn btn-primary"  title="Delete setting" >\n        Delete\n    </button>        \n</div> \n\n<!-- Modal -->\n<div class="modal fade" id=newSettingInListModal tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">\n  <div class="modal-dialog" role="document">\n    <div class="modal-content">\n      <div class="modal-header">\n        <h5 class="modal-title" id="exampleModalLabel">Add setting</h5>\n        <button type="button" class="close" data-dismiss="modal" aria-label="Close">\n          <span aria-hidden="true">&times;</span>\n        </button>\n      </div>\n      <div class="modal-body">        \n        <input class="form-control" type="text" id="new-setting-name" placeholder="New Setting Name">\n      </div>\n      <div class="modal-footer">\n        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>\n        <button type="button" class="btn btn-primary" id="save-new-setting-name">Add</button>\n      </div>\n    </div>\n  </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	
	var TableColumnFiltersView = Marionette.View.extend({
	    template: __webpack_require__(290),
	
	    ui: {
	        popover: '[data-toggle="popover"]',
	        content: '#content',
	
	        apply: '#apply',
	        reset: '#reset',
	        cancel: '#cancel',
	
	        from: '#from',
	        to: '#to',
	        val: '#val',
	
	        emptyOnlyCheckbox: "#empty-only",
	
	        iconFilter: '.glyphicon-filter'
	    },
	
	    events: {
	        'click @ui.apply': 'onApply',
	        'click @ui.reset': 'onReset',
	        'click @ui.cancel': 'onCancel',
	        'change @ui.emptyOnlyCheckbox': "onEmptyOnlyChanged"
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {}
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.utils = new CommonUtils();
	        that.dateFormat = 'MM/DD/YYYY';
	        that.activeColor = "red";
	        that.inactiveColor = "blue";
	
	        that.model = new Backbone.Model({
	            filter: options.filter
	        });
	
	        that.list = options.list;
	    },
	
	    onRender: function () {
	        var that = this;
	        var filter = this.model.get('filter');
	
	        $(document).ready(function () {
	            that.ui.popover.popover({
	                trigger: 'click',
	                html: true,
	                content: that.ui.content
	            });
	
	            if (filter.filterType == 'select') {
	                that.selectizedVal = that.ui.val.selectize({
	                    plugins: ['remove_button'],
	                    inputClass: 'form-control selectize-input normal-width selectized val-selectize',
	                    placeholder: 'Select',
	                    valueField: 'value',
	                    labelField: 'name',
	                    options: that.list,
	                    items: (that.list || []).map(function (item) {
	                        if (filter.value && filter.value.includes(item.value)) return item.value;
	                    }),//filter.value.split(",")([]).map(function (item) {return item.value;}), //function (){if(filter.value) return filter.value.split(","); else return [];}
	                    highlight: true,
	                    openOnFocus: true
	                });
	            }
	
	            that.ui.popover.on('show.bs.popover', function () {
	                that.ui.content.show();
	            });
	
	            that.ui.popover.on('hide.bs.popover', function () {
	                that.ui.content.hide();
	            });
	
	            if (filter.dataType == 'date') {
	
	                that.ui.from.datetimepicker({
	                    showClear: true,
	                    showClose: true,
	                    format: that.dateFormat
	                });
	                that.ui.to.datetimepicker({
	                    showClear: true,
	                    showClose: true,
	                    format: that.dateFormat
	                });
	
	
	                if (filter.filterType == 'interval') {
	                    that.ui.from.data("DateTimePicker").date(that.utils.longToDateTimeFormatted(filter.from, that.dateFormat));
	                    that.ui.to.data("DateTimePicker").date(that.utils.longToDateTimeFormatted(filter.to, that.dateFormat));
	                } else {
	                    that.ui.val.data("DateTimePicker").date(that.utils.longToDateTimeFormatted(filter.value, that.dateFormat));
	                }
	            }
	            if (!_.isEmpty(filter.from)
	                || !_.isEmpty(filter.to)
	                || !_.isEmpty(filter.value)) {
	                that.ui.iconFilter.css({color: that.activeColor});
	            }
	
	            window.setTimeout(function() {
	                that.onApply("deferred");
	            }, 1000);
	        });
	    },
	
	    onApply: function (deferred) {
	
	        var that = this;
	        var filter = that.model.get('filter');
	        var filterFunction;
	
	        if (filter.onlyEmpty) {
	            filterFunction = function (v) {
	                return !v;
	            };
	        } else {
	            if (filter.filterType == 'interval') {
	                if (_.isEmpty(that.ui.from.val()) && _.isEmpty(that.ui.to.val())) {
	                    filter.from = null;
	                    filter.to = null;
	                    filterFunction = null;
	                } else if (!_.isEmpty(that.ui.from.val()) && _.isEmpty(that.ui.to.val())) {
	                    filter.from = that.getConvertedValue(filter.dataType, that.ui.from.val());
	                    filter.to = null;
	                    filterFunction = function (v) {
	                        return v >= filter.from;
	                    };
	                } else if (_.isEmpty(that.ui.from.val()) && !_.isEmpty(that.ui.to.val())) {
	                    filter.from = null;
	                    filter.to = that.getConvertedValue(filter.dataType, that.ui.to.val())+86340000;
	                    filterFunction = function (v) {
	                        return v <= filter.to;
	                    };
	                } else {
	                    filter.from = that.getConvertedValue(filter.dataType, that.ui.from.val());
	                    filter.to = that.getConvertedValue(filter.dataType, that.ui.to.val())+86340000;
	                    filterFunction = function (v) {
	                        return v >= filter.from && v <= filter.to;
	                    };
	                }
	            } else if (filter.filterType == 'select' && !_.isEmpty(that.ui.val.val())) {
	                filter.value = that.ui.val.val();
	                filterFunction = function (v) {
	                    try {
	                        return v && filter.value.toLowerCase().includes(v.toLowerCase());
	                    }
	                    catch (e) {
	                        console.log(e);
	                    }
	                };
	            } else {
	                if (_.isEmpty(that.ui.val.val())) {
	                    filter.value = null;
	                    filterFunction = null;
	                } else {
	                    filter.value = that.getConvertedValue(filter.dataType, that.ui.val.val());
	                    if (filter.filterType == 'like') {
	                        filterFunction = function (v) {
	                            return (v || '').toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
	                        };
	                    } else {
	                        filterFunction = function (v) {
	                            return v == filter.value;
	                        };
	                    }
	                }
	            }
	        }
	
	        that.triggerMethod('filter:changed', {
	            columnFilter: filter,
	            filterFunction: filterFunction,
	            deferred: deferred == "deferred" ? true : false
	        });
	
	        if (filterFunction == null)
	            that.ui.iconFilter.css({color: that.inactiveColor});
	        else
	            that.ui.iconFilter.css({color: that.activeColor});
	
	        if (deferred != "deferred")
	            that.ui.popover.click();
	    },
	
	    getConvertedValue: function (dataType, value) {
	        var that = this;
	        if (dataType == 'date') {
	            return that.utils.stringDateToLong(that.dateFormat, value);
	        }
	
	        return value;
	    },
	
	    onReset: function () {
	        var filter = this.model.get('filter');
	
	        if (filter.filterType == 'interval') {
	            this.ui.from.val(null);
	            this.ui.to.val(null);
	
	            filter.from = null;
	            filter.to = null;
	        } else if (filter.filterType == 'select') {
	            this.ui.val["0"].selectize.clear();
	            filter.value = null;
	        } else {
	            this.ui.val.val(null);
	            filter.value = null;
	        }
	
	        this.emptyOnly(false);
	
	        this.triggerMethod('filter:changed', {
	            columnFilter: filter,
	            filterFunction: null,
	            deferred: false
	        });
	
	        this.ui.iconFilter.css({color: this.inactiveColor});
	        this.ui.popover.click();
	    },
	
	    onCancel: function () {
	        this.clearNewValues();
	        this.ui.popover.click();
	    },
	
	    clearNewValues: function () {
	        var filter = this.model.get('filter');
	        if (filter.dataType == 'date') {
	            if (filter.filterType == 'interval') {
	                this.ui.from.data("DateTimePicker").date(this.utils.longToDateTimeFormatted(filter.from, this.dateFormat));
	                this.ui.to.data("DateTimePicker").date(this.utils.longToDateTimeFormatted(filter.to, this.dateFormat));
	            } else {
	                this.ui.value.data("DateTimePicker").date(this.utils.longToDateTimeFormatted(filter.value, this.dateFormat));
	            }
	        } else {
	            this.ui.from.val(filter.from);
	            this.ui.to.val(filter.to);
	            this.ui.val.val(filter.value);
	        }
	        this.ui.emptyOnlyCheckbox.prop('checked', filter.onlyEmpty);
	    },
	
	    onEmptyOnlyChanged: function (e) {
	        var checked = e.target.checked;
	        this.emptyOnly(checked);
	    },
	
	    emptyOnly: function (checked) {
	        var that = this;
	        var filter = this.model.get('filter');
	        if (checked) {
	            that.ui.from.attr('disabled', true);
	            that.ui.to.attr('disabled', true);
	            that.ui.val.attr('disabled', true);
	            if (that.selectizedVal)
	                that.selectizedVal[0].selectize.disable();
	            that.ui.emptyOnlyCheckbox.prop('checked', true);
	            filter.onlyEmpty = true;
	
	        } else {
	            that.ui.from.removeAttr('disabled');
	            that.ui.to.removeAttr('disabled');
	            that.ui.val.removeAttr('disabled');
	            if (that.selectizedVal)
	                that.selectizedVal[0].selectize.enable();
	            that.ui.emptyOnlyCheckbox.prop('checked', false);
	            filter.onlyEmpty = false;
	        }
	    }
	});
	
	module.exports = TableColumnFiltersView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 290 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<button role="button" data-toggle="popover" data-placement="right"\n        style="background-color: transparent; border-color: transparent">\n    <span class="glyphicon glyphicon-filter" title="Filter"></span>\n</button>\n\n<div id="content" class="form form-horizontal tableDateInput" style="display: none; padding: 3px 3px 3px 3px;">\n    ';
	 if (filter.filterType == "interval") { 
	__p+='\n    <input type="text" id="from" class="form-control " value="'+
	((__t=( filter.from ))==null?'':__t)+
	'" placeholder="From"/>\n    <input type="text" id="to" class="form-control " value="'+
	((__t=( filter.to ))==null?'':__t)+
	'" placeholder="To"/>\n    ';
	 } else if (filter.filterType == "select"){ 
	__p+='\n    <input id="val"/>\n    ';
	 } else { 
	__p+='\n    <input type="text" id="val" class="form-control" value="'+
	((__t=( filter.value ))==null?'':__t)+
	'" placeholder="Value"/>\n    ';
	 } 
	__p+='\n\n    <label class="checkbox">\n        <input type="checkbox" id="empty-only" class="" ';
	 if (filter.onlyEmpty) { 
	__p+=' checked ';
	 } 
	__p+=' /> Empty only\n    </label>\n\n    <span id="apply" class="label label-primary clickable">Apply</span>\n    <span id="reset" class="label label-danger clickable">Reset</span>\n    <span id="cancel" class="label label-warning clickable">Cancel</span>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 291 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td>'+
	((__t=( changeuser ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( changeDate ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( comment ))==null?'':__t)+
	'</td>\r\n';
	}
	return __p;
	};


/***/ }),
/* 292 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div style="text-align:left;width:500px">\r\n<b>Reason: </b>'+
	((__t=( reason ))==null?'':__t)+
	'<br>\r\n<b>Comment: </b>'+
	((__t=( comment ))==null?'':__t)+
	'<br>\r\n';
	 if (hasAudits) { 
	__p+='\r\n<b>Audits:</b><br>\r\n	<table class="table popoverTable"> \r\n	<thead>\r\n            <tr>\r\n                <th  id="auditUserDate">User</th>\r\n                <th  id="auditDate">Date</th>                \r\n                <th  id="auditComment">Comment</th>\r\n            </tr>            \r\n            </thead>           \r\n        <tbody name="audits-popover">           \r\n		</tbody>\r\n    </table>\r\n';
	 } else {
	__p+='\r\n<div name="audits-popover"></div>\r\n';
	 }
	__p+='\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 293 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<table class="table table-hover popoverTable">\r\n    <thead>\r\n    <tr>\r\n        <th class="clickable sortableR center" id="from_date">From\r\n            <div></div>\r\n        </th>\r\n        <th class="clickable sortableR center" id="to_date">To\r\n            <div></div>\r\n        </th>\r\n        <th class="clickable sortableR center" id="visits" style="min-width: 200px;">Visits per period\r\n            <div></div>\r\n        </th>\r\n        <th class="clickable sortableR center" id="number_of_periods" style="min-width: 200px;">Period\r\n            <div></div>\r\n        </th>\r\n        <th class="clickable sortableR center" id="PRN" style="min-width: 10px;">PRN\r\n            <div></div>\r\n        </th>\r\n        <th class="clickable sortableR center" id="OrderedBy" style="min-width: 120px;">Order Status\r\n            <div></div>\r\n        </th>\r\n        <th class="clickable sortableR center" id="visits_number" style="min-width: 220px;">Number of Visits Completed\r\n            <div></div>\r\n        </th>\r\n        <th class="clickable sortableR center" id="visit_time">Other\r\n            <div></div>\r\n        </th>\r\n        <th class="clickable sortableR center" id="frequency_comment" style="min-width: 200px;">Comments\r\n            <div></div>\r\n        </th>\r\n        <th fieldname="related_documents center" style="min-width: 200px;">Associated Documents</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    </tbody>\r\n</table>';
	}
	return __p;
	};


/***/ }),
/* 294 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<table class="table table-hover">\r\n    <thead>\r\n    <tr>\r\n        <th class="clickable sortableR sticky-header center" id="start" style="min-width: 87px;">Start<div></div></th>\r\n        <th class="clickable sortableR sticky-header center" id="finish" style="min-width: 87px;">Finish<div></div></th>\r\n        <th class="clickable sortableR sticky-header center" id="patient" style="min-width: 200px;">Patient<div></div></th>\r\n        <th class="clickable sortableR sticky-header center" id="ins" style="min-width: 140px;">Insurance<div></div></th>\r\n<!--\r\n        <th class="clickable sortableR sticky-header" id="lic" style="min-width: 20px;">License<div></div></th>\r\n-->\r\n        <th class="clickable sortableR sticky-header center" id="st" style="min-width: 25px;">Service Type<div></div></th>\r\n        <th class="clickable sortableR sticky-header center" id="vt" style="min-width: 25px;">Visit Type<div></div></th>\r\n        <th class="clickable sortableR sticky-header center" id="et" style="min-width: 25px;">Employee Type<div></div></th>\r\n        <th class="clickable sortableR sticky-header center" id="Done" style="min-width: 10px;">Complete?<div></div></th>\r\n        <th class="clickable sortableR sticky-header center" id="an" style="min-width: 150px;">Authorization Number<div></div></th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    </tbody>\r\n</table>';
	}
	return __p;
	};


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td class="center">'+
	((__t=( from_date ))==null?'':__t)+
	'</td>\r\n<td class="center">'+
	((__t=( to_date ))==null?'':__t)+
	'</td>\r\n<td class="center" style="min-width: 200px;">'+
	((__t=( visits ))==null?'':__t)+
	'</td>\r\n<td class="center" style="min-width: 200px;">'+
	((__t=( number_of_periods ))==null?'':__t)+
	'</td>\r\n<td class="center" style="min-width: 10px;">'+
	((__t=( prn ))==null?'':__t)+
	'</td>\r\n<td class="center" style="min-width: 120px;">'+
	((__t=( orderedby == 'O' ? 'Physician Ordered' : (orderedby == 'S' ? 'Suggested by HH' : 'Final') ))==null?'':__t)+
	'</td>\r\n<td style="min-width: 220px;" class="center">'+
	((__t=( visits_number ))==null?'':__t)+
	'</td>\r\n<td class="center">'+
	((__t=( visit_time ))==null?'':__t)+
	''+
	((__t=( frequency_name ))==null?'':__t)+
	'</td>\r\n<td class="center" style="min-width: 200px;">'+
	((__t=( frequency_comment ))==null?'':__t)+
	'</td>\r\n<td class="center" style="min-width: 200px;">\r\n    ';
	 if (created_docs) { 
	__p+='\r\n    <button class="btn btn-primary btn-sm rns-created-doc">Created</button>\r\n    ';
	 } 
	__p+='\r\n    ';
	 if (canceled_docs) { 
	__p+='\r\n    <button class="btn btn-primary btn-sm rns-canceled-doc">Canceled</button>\r\n    ';
	 } 
	__p+='\r\n</td>\r\n';
	}
	return __p;
	};


/***/ }),
/* 296 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td style="min-width: 87px;" class="center">'+
	((__t=( formatDate(start) ))==null?'':__t)+
	'</td>\r\n<td style="min-width: 87px;" class="center">'+
	((__t=( formatDate(finish) ))==null?'':__t)+
	'</td>\r\n<td style="min-width: 200px;" class="center">'+
	((__t=( m0040_pat_lname ))==null?'':__t)+
	''+
	((__t=( m0040_pat_fname ))==null?'':__t)+
	'</td>\r\n<td style="min-width: 140px;" class="center">'+
	((__t=( ins ))==null?'':__t)+
	'</td>\r\n<!--\r\n<td style="min-width: 20px;">'+
	((__t=( lic ))==null?'':__t)+
	'</td>\r\n-->\r\n<td style="min-width: 25px;" class="center">'+
	((__t=( service ))==null?'':__t)+
	'</td>\r\n<td style="min-width: 25px;" class="center">'+
	((__t=( vis_type ))==null?'':__t)+
	'</td>\r\n<td style="min-width: 25px;" class="center">'+
	((__t=( empl_type ))==null?'':__t)+
	'</td>\r\n<td style="min-width: 10px;" class="center">\r\n<input type="checkbox" disabled ';
	 if (marked) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n</td>\r\n<td style="min-width: 150px;" class="center">'+
	((__t=( authorizationnumber ))==null?'':__t)+
	'</td>\r\n\r\n										\r\n';
	}
	return __p;
	};


/***/ }),
/* 297 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h2>\n    <div class="pull-left">Patients</div>\n    <span id="patients-count" style="margin-left: 10px;"></span>\n    <div class="btn-group" style="float:right;">\n        <button type="button" class="btn btn-success dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n            Export\n        </button>\n        <ul class="dropdown-menu pull-right" style="min-width: 50px !important;width: 68px !important;">\n            <li class="clickable"><a id="export-to-pdf">PDF</a></li>\n            <li class="clickable"><a id="export-to-csv">CSV</a></li>\n        </ul>\n    </div>\n</h2>\n<div id="setting-module"></div>\n<div id="patients-container" class="top-margined">\n\n    <table class="table table-hover">\n        <thead>\n        <tr class="without-transfer">\n            <th style="width: 117px;" class="center">\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Patient</div>\n                <div id="patient_name" class="pull-left"></div>\n            </th>\n\n            ';
	 if (!isSimple) { 
	__p+='\n            <th style="width: 115px;" class="center">\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Referral</div>\n                <div id="referral_date" class="pull-left"></div>\n            </th>\n            ';
	 } 
	__p+='\n\n            <th style="width: 91px;" class="center">\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">SOC</div>\n                <div id="soc" class="pull-left"></div>\n            </th>\n\n            ';
	 if (!isSimple) { 
	__p+='\n            <th style="width: 102px;" class="center">\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Admit</div>\n                <div id="admit" class="pull-left"></div>\n            </th>\n            ';
	 } 
	__p+='\n\n            ';
	 if (variant!='referral') { 
	__p+='\n            <th style="width: 116px;" class="center">\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Transfer</div>\n                <div id="transfer_date" class="pull-left"></div>\n            </th>\n            <th style="width: 123px;" class="center">\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">DC</div>\n                <div id="status" class="pull-left"></div>\n            </th>\n            ';
	 } 
	__p+='\n\n            ';
	 if (!isSimple) { 
	__p+='\n            <th style="width: 120px;" class="center">\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">PCP</div>\n                <div id="md" class="pull-left"></div>\n            </th>\n            <th style="width: 230px;" class="center">\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Location</div>\n                <div id="location" class="pull-left"></div>\n            </th>\n            <th style="width: 180px;" class="center">\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Coordinator</div>\n                <div id="jencare_coordinators" class="pull-left"></div>\n            </th>\n            <th style="width: 140px;" class="center">\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Insurance</div>\n                <div id="insurance" class="pull-left"></div>\n            </th>\n            <th style="width: 130px;" class="center">\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Intake</div>\n                <div id="intake" class="pull-left"></div>\n            </th>\n            <th style="width: 130px;" class="center">\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">CM</div>\n                <div id="cm_sn" class="pull-left"></div>\n            </th>\n            <th fieldname="journal_frequencies" style="width: 60px;" class="center">Orders</th>\n            <th style="width: 60px;" class="center">Visits</th>\n            ';
	 } 
	__p+='\n            <th style="width: 80px;" class="center">Documents</th>\n        </tr>\n        </thead>\n        <tbody></tbody>\n    </table>\n\n</div>\n\n<!-- Modal -->\n<div class="modal fade" id=newSettingInListModal tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"\n     aria-hidden="true">\n    <div class="modal-dialog" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <h5 class="modal-title" id="exampleModalLabel">Add setting</h5>\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close">\n                    <span aria-hidden="true">&times;</span>\n                </button>\n            </div>\n            <div class="modal-body">\n                <input class="form-control" type="text" id="new-setting-name" placeholder="New Setting Name">\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>\n                <button type="button" class="btn btn-primary" id="save-new-setting-name">Add</button>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td style="width: 117px;"><a href="#" name="open_profile">'+
	((__t=( toUpper(patient_name) ))==null?'':__t)+
	'</a></td>\n\n';
	 if (!isSimple) { 
	__p+='\n<td style="width: 115px;"><a tabindex="0" name="refpo" role="button" data-toggle="popover"\n                             title="<span class=\'close clickable active-sort-header left-close-btn\'>&times;</span>&nbsp;&nbsp;&nbsp;<span class=\'popover-title-custom\'>Additional Info</span>&nbsp;<span class=\'close clickable active-sort-header right-close-btn\'>&times;</span>"\n                             data-html="true">'+
	((__t=( formatDate(referral_date) ))==null?'':__t)+
	'</a></td>\n';
	 } 
	__p+='\n\n<td style="width: 91px;"><a tabindex="0" name="socpo" role="button" data-toggle="popover"\n                            title="<span class=\'close clickable active-sort-header left-close-btn\'>&times;</span>&nbsp;&nbsp;&nbsp;<span class=\'popover-title-custom\'>Additional Info</span>&nbsp;<span class=\'close clickable active-sort-header right-close-btn\'>&times;</span>"\n                            data-html="true">'+
	((__t=( formatDate(soc) ))==null?'':__t)+
	'</a></td>\n\n';
	 if (!isSimple) { 
	__p+='\n<td style="width: 102px;">'+
	((__t=( toUpper(admit) ))==null?'':__t)+
	'</td>\n';
	 } 
	__p+='\n\n';
	 if (variant!='referral') { 
	__p+='\n<td style="width: 116px;">'+
	((__t=( formatDate(transfer_date) ))==null?'':__t)+
	'</td>\n<td style="width: 123px;">'+
	((__t=( formatDate(status) ))==null?'':__t)+
	'<br>'+
	((__t=( toUpper(dc_type) ))==null?'':__t)+
	'</td>\n';
	 } 
	__p+='\n\n\n';
	 if (!isSimple) { 
	__p+='\n<td style="width: 120px;">'+
	((__t=( toUpper(md) ))==null?'':__t)+
	'</td>\n<td style="width: 230px;">'+
	((__t=( toUpper(location) ))==null?'':__t)+
	'</td>\n<td style="width: 180px; text-transform:capitalize;">\n    ';
	 _.each([jencare_coordinators.split(':')[0]], function(jc){
	__p+='\n    '+
	((__t=( toUpper(jc) ))==null?'':__t)+
	'<br>';
	 }) 
	__p+='\n</td>\n<td style="width: 140px;">'+
	((__t=( toUpper(insurance) ))==null?'':__t)+
	'</td>\n<td style="width: 130px;">'+
	((__t=( toUpper(intake) ))==null?'':__t)+
	'</td>\n<td style="width: 130px;">'+
	((__t=( toUpper(cm_sn) ))==null?'':__t)+
	'</td>\n<td style="width: 60px;">\n    ';
	 if (soc!=null) { 
	__p+='\n    <a tabindex="0" name="jfspov" data-html="true" class="btn btn-primary btn-sm" role="button" data-toggle="popover"\n       title="<span class=\'popover-title-custom\'>Frequency of Visits</span>&nbsp;<span class=\'close clickable active-sort-header right-close-btn\'>&times;</span>">View</a>\n    ';
	 } 
	__p+='\n</td>\n<td style="width: 60px;">\n    ';
	 if (soc!=null) { 
	__p+='\n    <a tabindex="0" name="jfsvis" data-html="true" class="btn btn-primary btn-sm" role="button" data-toggle="popover"\n       title="<span class=\'popover-title-custom\'>Visits</span>&nbsp;<span class=\'close clickable active-sort-header right-close-btn\'>&times;</span>">View</a>\n    ';
	 } 
	__p+='\n</td>\n';
	 } 
	__p+='\n<td style="width: 80px;" class="center">\n    <button class="btn btn-primary btn-sm rns-docs">Open</button>\n</td>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(300);
	
	var Marionette = __webpack_require__(180);
	
	var DocumentsListView = __webpack_require__(301);
	var ReviewElementStatusesModel = __webpack_require__(209);
	var Pager = __webpack_require__(309);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	var PasswordConfirmation = __webpack_require__(312);
	var AssignAndUpdateReviewersForm = __webpack_require__(314);
	var AssignPatientForm = __webpack_require__(318);
	var SetDocumentDueForm = __webpack_require__(320);
	var AddCommentsForm = __webpack_require__(322);
	var SendDocumentForm = __webpack_require__(324);
	var AddAddendumForm = __webpack_require__(326);
	var MarkAsForm = __webpack_require__(328);
	var ExportDocumentForm = __webpack_require__(330);
	var OkDialogModal = __webpack_require__(332);
	
	
	var Documents = Marionette.View.extend({
	    template: __webpack_require__(334),
	
	    regions: {
	        documents: '#documents',
	        pager: '#pager',
	        passwordConfirmationDiv: '.password-confirmation-div',
	        assignReviewersFormRegion: '#assign-reviewers-form',
	        addPatientFormModal: '#add-patient-form-modal',
	        sendFormModal: '#send-form-modal',
	        addPatientWarning: '#add-patient-warning',
	        setDueFormModal: '#set-due-form-modal',
	        addCommentsFormModal: '#add-comment-form-modal',
	        addAddendumFormModal: '#add-addendum-form-modal',
	        markAsModal: '#mark-as-modal',
	        exportFormModal: '#export-modal'
	    },
	
	    ui: {
	        count: '#count'
	    },
	
	    events: {},
	
	    childViewEvents: {
	        'document:will-be-remove': 'removeDocument',
	        'document:list:refresh': 'documentListRefresh',
	        'document:reviewers:add:or:update': 'addOrUpdateReviewers',
	        'document:patient:add': 'addPatient',
	        'sign:documents': 'signDocuments',
	        'reviewers:added:to:document': 'onReviewersAdded',
	        'patient:added:to:document': 'onPatientAdded',
	        'comment:added:to:document': 'onCommentAdded',
	        'sent:document': 'onDocumentSent',
	        'document:due:set': 'setDueDate',
	        'document:comment': 'onDocumentComment',
	        'document:send': 'onDocumentSend',
	        'document:add:addendum': 'onAddAddendum',
	        'due:set:to:document': 'onDueSet',
	        'addendum:added:to:document': 'onAddendumAdded',
	        'pager:count:change': 'countChange',
	        'document:mark:as': 'onDocumentMarkAs',
	        'document:export': 'onDocumentExport'
	    },
	
	    utils: new CommonUtils(),
	
	    initialize: function (options) {
	        this.reviewElementStatuses = new ReviewElementStatusesModel();
	        this.params = $.deparam(window.location.hash.replace('#documents', '').replace('?', ''));
	        this.docsCount = 0;
	
	        this.signDocsCallbackForPager = {
	            signDocuments: null
	        }
	
	    },
	
	    onRender: function () {
	        window.document.title = "RNS Documents";
	        var that = this;
	        $.when(that.reviewElementStatuses.fetch()
	        ).then(function () {
	            that.documentListRefresh();
	        });
	    },
	
	    renderPager: function () {
	        var that = this;
	        that.showChildView('pager', new Pager({
	            baseCountUrl: '/api/document/count',
	            callbackFunctions: that.signDocsCallbackForPager
	        }));
	    },
	
	    showErrors: function (model, errors) {
	        model.view.triggerMethod('server:error', errors.join('. \n'));
	    },
	
	    documentListRefresh: function () {
	        var that = this;
	        that.showChildView('documents', new DocumentsListView({
	            collectionParams: that.utils.queryParamsToCollection(that.params),
	            reviewElementStatuses: that.reviewElementStatuses,
	            username: that.options.user.login,
	            isMd: that.options.user.isMd,
	            isOfficeAdministrator: that.options.user.isOfficeAdministrator,
	            isMedicalDirector: that.options.user.isMedicalDirector,
	            isManager: that.options.user.isManager,
	            isAdmin: that.options.user.isAdmin,
	            byAdmin: that.getOption('byAdmin'),
	
	            signDocsCallbackForPager: that.signDocsCallbackForPager
	        }));
	
	        that.renderPager();
	    },
	
	    addOrUpdateReviewers: function (data) {
	        var that = this;
	
	        that.showChildView('assignReviewersFormRegion', new AssignAndUpdateReviewersForm({
	            reviewersAndDocuments: data.reviewersAndDocuments,
	            documentsIds: data.documentsIds,
	            getReviewerName: data.getReviewerName,
	            woResponseEvent: data.woResponseEvent
	        }));
	    },
	
	    addPatient: function (data) {
	        var that = this;
	        that.showChildView('addPatientFormModal', new AssignPatientForm({
	            docIds: data.docIds,
	            woResponseEvent: data.woResponseEvent
	        }));
	    },
	
	    setDueDate: function (data) {
	        var that = this;
	        that.showChildView('setDueFormModal', new SetDocumentDueForm({
	            docIds: data.docIds,
	            woResponseEvent: data.woResponseEvent
	        }));
	    },
	
	    onDocumentComment: function (data) {
	        var that = this;
	        that.showChildView('addCommentsFormModal', new AddCommentsForm({
	            docIds: data.docIds,
	            allFiltered: data.allFiltered,
	            params: data.params,
	            docsCount: that.docsCount,
	            woResponseEvent: data.woResponseEvent
	        }));
	    },
	
	    onDocumentSend: function (data) {
	        var that = this;
	        that.showChildView('sendFormModal', new SendDocumentForm({
	            docIds: data.docIds,
	            allFiltered: data.allFiltered,
	            params: data.params,
	            docsCount: that.docsCount,
	            woResponseEvent: data.woResponseEvent
	        }));
	    },
	
	    onAddAddendum: function (data) {
	        var that = this;
	        that.showChildView('addAddendumFormModal', new AddAddendumForm({
	            docIds: data.docIds,
	            woResponseEvent: data.woResponseEvent
	        }));
	    },
	
	    onDocumentMarkAs: function (data) {
	        var that = this;
	        that.showChildView('markAsModal', new MarkAsForm({
	            docIds: data.docIds,
	            mode: data.mode,
	            woResponseEvent: data.woResponseEvent
	        }));
	    },
	
	    onDocumentExport: function (data) {
	        var that = this;
	        that.showChildView('exportFormModal', new ExportDocumentForm({
	            docIds: data.docIds,
	            allFiltered: data.allFiltered,
	            params: data.params,
	            docsCount: that.docsCount,
	            woResponseEvent: data.woResponseEvent
	        }));
	    },
	
	    onReviewersAdded: function () {
	        this.documentListRefresh();
	    },
	
	    onPatientAdded: function (data) {
	        this.documentListRefresh();
	        if (data.documentsIdWithErrors && data.documentsIdWithErrors.length > 0) {
	            var text = "The patient was not added to following documents - <br><ul>"
	                + data.documentsIdWithErrors.map(function (docId) {
	                    return '<li><a href="/#document/' + docId + '" target="_blank">' + docId + '</a></li>';
	                }).join('') + "</ul><br> because update this documents is not allowed for you";
	
	            this.showWarnings('Warning', text);
	        }
	    },
	
	    onCommentAdded: function () {
	        this.documentListRefresh();
	    },
	
	    onDocumentSent: function () {
	        this.documentListRefresh();
	    },
	
	    onDueSet: function (data) {
	        this.documentListRefresh();
	        if (data.documentsIdWithErrors && data.documentsIdWithErrors.length > 0) {
	            var text = "The due date was not setted to following documents - <br><ul>"
	                + data.documentsIdWithErrors.map(function (docId) {
	                    return '<li><a href="/#document/' + docId + '" target="_blank">' + docId + '</a></li>';
	                }).join('') + "</ul><br> because update this documents is not allowed for you";
	
	            this.showWarnings('Warning', text);
	        }
	    },
	
	    onAddendumAdded: function () {
	        this.documentListRefresh();
	    },
	
	    countChange: function (data) {
	        this.docsCount = data;
	        this.ui.count.html(data);
	    },
	
	    showWarnings: function (title, content) {
	
	        this.addPatientWarningResultView = new OkDialogModal({
	            title: title,
	            message: content
	        });
	
	        this.showChildView('addPatientWarning', this.addPatientWarningResultView);
	        this.addPatientWarningResultView.show();
	    },
	
	    signDocuments: function (data) {
	        var passwordConfirmation = new PasswordConfirmation();
	        this.showChildView('passwordConfirmationDiv', passwordConfirmation);
	        passwordConfirmation.setIds(data.ids);
	        passwordConfirmation.setAction(data.action);
	        passwordConfirmation.setFn(data.fn);
	        passwordConfirmation.showPasswordConfirmation();
	        passwordConfirmation.setCancelAction(data.cancelAction);
	    }
	});
	
	module.exports = Documents;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	(function(deparam){
	    if (true) {
	        try {
	            var jquery = __webpack_require__(11);
	        } catch (e) {
	        }
	        module.exports = deparam(jquery);
	    } else if (typeof define === 'function' && define.amd){
	        define(['jquery'], function(jquery){
	            return deparam(jquery);
	        });
	    } else {
	        var global;
	        try {
	          global = (false || eval)('this'); // best cross-browser way to determine global for < ES5
	        } catch (e) {
	          global = window; // fails only if browser (https://developer.mozilla.org/en-US/docs/Web/Security/CSP/CSP_policy_directives)
	        }
	        global.deparam = deparam(global.jQuery); // assume jQuery is in global namespace
	    }
	})(function ($) {
	    var deparam = function( params, coerce ) {
	        var obj = {},
	        coerce_types = { 'true': !0, 'false': !1, 'null': null };
	
	        // If params is an empty string or otherwise falsy, return obj.
	        if (!params) {
	            return obj;
	        }
	
	        // Iterate over all name=value pairs.
	        params.replace(/\+/g, ' ').split('&').forEach(function(v){
	            var param = v.split( '=' ),
	            key = decodeURIComponent( param[0] ),
	            val,
	            cur = obj,
	            i = 0,
	
	            // If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
	            // into its component parts.
	            keys = key.split( '][' ),
	            keys_last = keys.length - 1;
	
	            // If the first keys part contains [ and the last ends with ], then []
	            // are correctly balanced.
	            if ( /\[/.test( keys[0] ) && /\]$/.test( keys[ keys_last ] ) ) {
	                // Remove the trailing ] from the last keys part.
	                keys[ keys_last ] = keys[ keys_last ].replace( /\]$/, '' );
	
	                // Split first keys part into two parts on the [ and add them back onto
	                // the beginning of the keys array.
	                keys = keys.shift().split('[').concat( keys );
	
	                keys_last = keys.length - 1;
	            } else {
	                // Basic 'foo' style key.
	                keys_last = 0;
	            }
	
	            // Are we dealing with a name=value pair, or just a name?
	            if ( param.length === 2 ) {
	                val = decodeURIComponent( param[1] );
	
	                // Coerce values.
	                if ( coerce ) {
	                    val = val && !isNaN(val) && ((+val + '') === val) ? +val        // number
	                    : val === 'undefined'                       ? undefined         // undefined
	                    : coerce_types[val] !== undefined           ? coerce_types[val] // true, false, null
	                    : val;                                                          // string
	                }
	
	                if ( keys_last ) {
	                    // Complex key, build deep object structure based on a few rules:
	                    // * The 'cur' pointer starts at the object top-level.
	                    // * [] = array push (n is set to array length), [n] = array if n is
	                    //   numeric, otherwise object.
	                    // * If at the last keys part, set the value.
	                    // * For each keys part, if the current level is undefined create an
	                    //   object or array based on the type of the next keys part.
	                    // * Move the 'cur' pointer to the next level.
	                    // * Rinse & repeat.
	                    for ( ; i <= keys_last; i++ ) {
	                        key = keys[i] === '' ? cur.length : keys[i];
	                        cur = cur[key] = i < keys_last
	                        ? cur[key] || ( keys[i+1] && isNaN( keys[i+1] ) ? {} : [] )
	                        : val;
	                    }
	
	                } else {
	                    // Simple key, even simpler rules, since only scalars and shallow
	                    // arrays are allowed.
	
	                    if ( Object.prototype.toString.call( obj[key] ) === '[object Array]' ) {
	                        // val is already an array, so push on the next value.
	                        obj[key].push( val );
	
	                    } else if ( {}.hasOwnProperty.call(obj, key) ) {
	                        // val isn't an array, but since a second value has been specified,
	                        // convert val into an array.
	                        obj[key] = [ obj[key], val ];
	
	                    } else {
	                        // val is a scalar.
	                        obj[key] = val;
	                    }
	                }
	
	            } else if ( key ) {
	                // No value was defined, so set something meaningful.
	                obj[key] = coerce
	                ? undefined
	                : '';
	            }
	        });
	
	        return obj;
	    };
	    if ($) {
	      $.prototype.deparam = $.deparam = deparam;
	    }
	    return deparam;
	});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	
	var EntitiesCollection = __webpack_require__(227);
	var DocumentsCollection = __webpack_require__(302);
	var DocumentModel = __webpack_require__(207);
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	var Dicts = __webpack_require__(193);
	
	var RemoteSuggesterView = __webpack_require__(196);
	var DocumentsStatisticsView = __webpack_require__(303);
	var DocumentsStatisticsAggregateView = __webpack_require__(305);
	
	var SetInitialViewModalView = __webpack_require__(188);
	
	var utils = new CommonUtils();
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var moment = __webpack_require__(30);
	
	var DocumentItem = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(307),
	
	    ui: {
	        previewDoc: '.preview-doc',
	
	        sendingMethods: '.sending-methods',
	        customSendingMethods: '.custom-sending-methods',
	    },
	
	    events: {
	        "click .create-request": "createRequest",
	        "click input[type=checkbox]": 'documentSelected',
	        "click @ui.previewDoc": 'viewDocument',
	
	        "click @ui.sendingMethods": "showSendingMethods",
	        "click @ui.customSendingMethods": "showCustomSendingMethods",
	    },
	
	    templateContext: function () {
	        var that = this;
	        var createdTime = that.model.get('object').createdTime;
	        var dueTime = that.model.get('object').dueDate;
	        var signedTime = that.model.get('object').signedTime;
	        var object = that.model.get('object');
	        var relations = that.model.get('relations') || [];
	        var relation = _.find(relations, function (item) {
	            return item.parentId == that.model.get('id')
	                && item.systemRelationType == 'DOCUMENT_PATIENT'
	                && item.child.id == object.patientId;
	        });
	        var orgRelation = _.find(relations, function (item) {
	            return item.child.id == object.organizationId
	                && item.systemRelationType == 'DOCUMENT_ORGANIZATION'
	        });
	
	        var createdByObj;
	        if (orgRelation) {
	            createdByObj = {name: orgRelation.child.name, url: '/#organization/' + orgRelation.child.id}
	        } else if (that.model.get('createdBy')) {
	            createdByObj = {name: that.model.get('createdBy').name, url: '/#person/' + that.model.get('createdBy').id}
	        }
	
	        return {
	            fmCreatedTime: utils.longToDateTimeFormatted(createdTime, "MM/DD/YYYY"),
	            fmDueTime: dueTime === 0 ? '' : utils.longToDateTimeFormatted(dueTime, "MM/DD/YYYY"),
	            fmSignedTime: signedTime === 0 ? '' : utils.longToDateTimeFormatted(signedTime, "MM/DD/YYYY"),
	            patient: relation && relation.child && relation.child.object ? {
	                id: relation.child.id,
	                name: utils.formatPerson(relation.child.object)
	            } : undefined,
	            accessSignAction: this.getOption('accessSignAction'),
	            createdByObj: createdByObj,
	            status: utils.getDocumentStatus(object.status),
	            intention: utils.getIntention(object.intention),
	            preferredSendingMethods: function () {
	                var reviewers = [];
	                object.reviewers.forEach(function (rvw) {
	                    if (!_.isEmpty(rvw.personId))
	                        reviewers.push(rvw.personId);
	                    if (!_.isEmpty(rvw.organizationId))
	                        reviewers.push(rvw.organizationId);
	                });
	
	                var preferredContactsTypes = [];
	                relations.forEach(function (relation) {
	                    if (relation.child && _.contains(reviewers, relation.child.id)
	                        && relation.child.object && relation.child.object.contacts) {
	                        _.uniq(relation.child.object.contacts.filter(function (contact) {
	                            return contact.preferred === true;
	                        }).map(function (contact) {
	                            return contact.type;
	                        })).forEach(function (contactType) {
	                            preferredContactsTypes.push(contactType);
	                        });
	                    }
	                });
	
	                return _.uniq(preferredContactsTypes).sort();
	            },
	            color: that.downloadColor(),
	            byAdmin: that.getOption('byAdmin'),
	            deliveryConf: that.getDeliveryConf(),
	            relations: relations,
	            reviewersNames: function () {
	                if (that.revieweresNames == undefined) {
	                    that.revieweresNames = that.getRevieweresNames();
	                }
	                return that.revieweresNames;
	            },
	            showSendingMethods: that.getOption('showSendingMethods'),
	            toUpper: function (val, isPersonName) {
	                return val ? val.toUpperCase() : "";
	            },
	            barCode: object.externalIds
	                .filter(function (id) {
	                    return id.startsWith(Constants.barCodePrefix);
	                }).map(function (id) {
	                    return id.replace(Constants.barCodePrefix, "");
	                })
	                .join(", ") || '-',
	            rnsBarCode: object.barcode || '',
	            hasCustomContacts: that.hasCustomContacts()
	        }
	    },
	
	    initialize: function () {
	        this.contactsContent = null;
	        if (_.isUndefined(this.model.get("selected")))
	            this.model.set("selected", false);
	    },
	
	    onRender: function () {
	
	        /*if (this.hasCustomContacts()) {
	            this.ui.customSendingMethods.popover();
	            this.ui.customSendingMethods.on('show.bs.popover', function () {
	                var thisPopover = $(this);
	                console.log("shown.bs.popover");
	            });
	        } else {
	            this.ui.sendingMethods.popover();
	            this.ui.sendingMethods.on('show.bs.popover', function () {
	                var thisPopover = $(this);
	                thisPopover.data("content", "Loading...");
	                this.ui.sendingMethods.data("content", "Loading...");
	            });
	        }*/
	
	    },
	
	    hasCustomContacts: function () {
	        return this.getActualPreferredDocumentContacts().length > 0;
	    },
	
	    getActualPreferredDocumentContacts: function () {
	        var that = this;
	        var now = new Date().getTime();
	        return that.model.get('object').contacts.filter(function (contact) {
	            return that.actualContactPredicate(contact, now);
	        });
	    },
	
	    actualContactPredicate: function (contact, now) {
	        return contact.preferred && (contact.from == 0 || contact.from <= now) && (contact.to == 0 || contact.to >= now);
	    },
	
	    showSendingMethods: function (e) {
	        var self = $(e.target);
	        var that = this;
	
	        if (!that.contactsContent) {
	            console.log('init');
	            self.popover({
	                html: true,
	                content: "<b>Loading...</b>"
	            });
	            self.popover('show');
	
	            var popoverAsyncRender = function (contactsContent) {
	                that.contactsContent = contactsContent;
	                self.attr("data-content", that.contactsContent);
	                self.popover({
	                    html: true,
	                    //content: contactsContent
	                });
	                self.popover('show');
	            }
	
	            that.reviewersContactsFetch(popoverAsyncRender);
	
	        } else {
	            self.attr("data-content", that.contactsContent);
	            self.popover({
	                html: true,
	                //content: that.contactsContent
	            });
	            self.popover('show');
	        }
	
	        setTimeout(function () {
	            self.popover('hide');
	        }, 5000);
	    },
	
	    showCustomSendingMethods: function (e) {
	        var self = $(e.target);
	
	        if (!this.contactsContent) {
	            var contacts = this.getActualPreferredDocumentContacts();
	            this.contactsContent = this.contactsToPopoverContent(contacts);
	        }
	
	        self.attr("data-content", this.contactsContent);
	        self.popover({
	            html: true,
	            //content: this.contactsContent
	        });
	        self.popover('show');
	
	        setTimeout(function () {
	            self.popover('hide');
	        }, 5000);
	    },
	
	    contactsToPopoverContent: function (contacts) {
	        var grouped = _.chain(contacts)
	            .map(function (contact) {
	                return {
	                    type: contact.type,
	                    data: contact.data
	                }
	            })
	            .groupBy('type')
	            .value();
	
	        var popoverContactContent = _.keys(grouped).map(function (key) {
	            return '<b>' + key + '</b> - ' + grouped[key].map(function (contact) {
	                return contact.data;
	            }).join(", ");
	        }).join('<br>');
	
	        return popoverContactContent;
	    },
	
	    reviewersContactsFetch: function (popoverRender) {
	        var that = this;
	
	        var fountContacts = [];
	        var now = new Date().getTime();
	        var contactsNorExistsText = "Contacts not found";
	
	        var reviewersForRelationship = (that.model.get('object').reviewers || []).filter(function (reviewer) {
	            return !_.isEmpty(reviewer.personId) && !_.isEmpty(reviewer.organizationId);
	        });
	
	        if (reviewersForRelationship.length == 0) {
	            popoverRender(contactsNorExistsText);
	            return;
	        }
	
	        reviewersForRelationship.forEach(function (reviewer, index) {
	
	            var isLast = (reviewersForRelationship.length - 1) === index;
	
	            $.ajax({
	                type: "GET",
	                url: '/api/relation?systemRelationType=PERSON_ORGANIZATION&parentId=' + reviewer.personId,
	                statusCode: {
	                    200: function (response) {
	                        var relations = response.filter(function (item) {
	                            return item.child.id == reviewer.organizationId
	                                && (item.startTime == 0 || item.startTime <= now)
	                                && (item.endTime == 0 || item.endTime >= now);
	                        });
	                        relations.forEach(function (relation) {
	                            (relation.contacts || []).filter(function (contact) {
	                                return that.actualContactPredicate(contact, now);
	                            }).forEach(function (contact) {
	                                fountContacts.push(contact);
	                            })
	                        })
	
	                        if (isLast) {
	                            setTimeout(function () {
	                                popoverRender(fountContacts.length == 0 ? contactsNorExistsText : that.contactsToPopoverContent(fountContacts));
	                            }, 1000);
	                        }
	                    }
	                },
	                error: function (e) {
	                    console.log(e);
	                }
	            });
	        })
	    },
	
	    createRequest: function (event) {
	        var that = this;
	        that.triggerMethod('document:create:request', {
	            documentId: that.model.get('id'),
	            documentName: that.model.get('name')
	        });
	    },
	
	    documentSelected: function (event) {
	        this.model.set("selected", event.target.checked);
	        console.log(this.model);
	        this.triggerMethod('document:selected', {
	            documentId: this.model.get("id"),
	            addOrRemove: event.target.checked,
	            isDocumentPreviewed: this.isDocumentPreviewedByUser(this.getOption('username') || '')
	        });
	    },
	
	    downloadColor: function () {
	        var that = this;
	        var username = that.getOption('username') || '';
	        return this.isDocumentPreviewedByUser(username) ? that.downloadedAndPreviewedColor : that.notDownloadedAndPreviewedColor;
	    },
	
	    viewDocument: function () {
	        var that = this;
	        setTimeout(function () {
	            $(that.ui.previewDoc).css("color", that.downloadedAndPreviewedColor);
	            that.triggerMethod('refresh:model', {model: that.model});
	        }, 5000);
	    },
	
	    isDocumentPreviewedByUser: function (username) {
	        return (this.model.get('object').downloadedOrPreviewedSigners || []).filter(function (signer) {
	            return signer == username;
	        }).length > 0;
	    },
	
	    getDeliveryConf: function () {
	        var conf = {};
	        var document = this.model.get('object');
	        if (document.lastDeliveredTime > 0) {
	            conf = {
	                deliveryColor: 'green',
	                deliveryTitle: 'Delivered'
	            }
	        } else if (document.lastDeliveredTime == 0 && document.lastSentTime > 0) {
	            conf = {
	                deliveryColor: 'orange',
	                deliveryTitle: 'Sent'
	            }
	        } else if (document.lastSentTime == 0) {
	            conf = {
	                deliveryColor: '#000000',
	                deliveryTitle: 'Not sent'
	            }
	        }
	        return conf;
	    },
	
	    getRevieweresNames: function () {
	        var that = this;
	        var result = {};
	        var relations = that.model.get('relations') || [];
	        relations.filter(function (item) {
	            return item.parentId == that.model.get('id')
	                && (item.systemRelationType == 'PERSON_REVIEW_REQUEST' ||
	                    item.systemRelationType == 'ORGANIZATION_REVIEW_REQUEST' ||
	                    item.systemRelationType == 'ORGANIZATION_REVIEW_FINISHED_REQUEST' ||
	                    item.systemRelationType == 'PERSON_REVIEW_FINISHED_REQUEST' ||
	                    item.systemRelationType == 'PERSON_REVIEW_DELETED' ||
	                    item.systemRelationType == 'ORGANIZATION_REVIEW_DELETED');
	        }).map(function (relation) {
	            if (relation.child.object.lastName && relation.child.object.firstName)
	                result[relation.child.id] = utils.formatPerson(relation.child.object)
	            else
	                result[relation.child.id] = relation.child.name ? relation.child.name.toUpperCase() : "";
	        });
	
	        return result;
	    },
	
	    downloadedAndPreviewedColor: '#afc7dc',
	    notDownloadedAndPreviewedColor: '#337ab7'
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(8), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	
	var DocumentsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: DocumentItem,
	    emptyView: EmptyView,
	
	    collectionEvents: {
	        request: 'showLoading',
	        sync: 'hideLoading',
	        error: 'logError'
	    },
	
	    childViewEvents: {
	        'document:create:request': 'createRequest',
	        'document:selected': 'documentSelected',
	        'refresh:model': 'refreshModel'
	    },
	
	    childViewOptions: function () {
	        return {
	            accessSignAction: this.accessSignAction,
	            username: this.username,
	            byAdmin: this.getOption('byAdmin'),
	            showSendingMethods: this.getOption('showSendingMethods')
	        };
	    },
	
	    initialize: function (options) {
	        this.collection = options.collection;
	        this.accessSignAction = options.accessSignAction;
	        this.username = options.username;
	    },
	
	    createRequest: function (data) {
	        this.triggerMethod('document:create:request', data);
	    },
	
	    documentSelected: function (data) {
	        this.triggerMethod('document:selected', data);
	    },
	
	    refreshModel: function (data) {
	        this.triggerMethod('refresh:model', data);
	    },
	
	    showLoading: function () {
	        this.triggerMethod('loader:show');
	    },
	
	    hideLoading: function () {
	        this.triggerMethod('loader:hide');
	    },
	
	    logError: function () {
	        this.triggerMethod('error:log');
	    },
	
	    refreshChildren: function (ids) {
	        var that = this;
	        ids.forEach(function (id) {
	            var currentChild = that.children.findByModel(that.collection.get({id: id}));
	            var model = new DocumentModel({id: id});
	            model.fetch(
	                {
	                    success: function () {
	                        currentChild.model = model;
	                        currentChild.render();
	                    }
	                }
	            );
	        });
	    }
	});
	
	
	var DocumentsListView = Marionette.View.extend({
	    template: __webpack_require__(308),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        patientsSelect: '#patients-select',
	        assignedToPersonsSelect: '#assigned-to-persons-select',
	        signedByPersonsSelect: '#signed-by-persons-select',
	        createdBySelect: '#created-by-select',
	        assignedToOrganizationsSelect: '#assigned-to-organizations-select',
	        signedByOrganizationsSelect: '#signed-by-organizations-select',
	        uploaderPersonsSelect: '#uploader-persons-select',
	        documentsStatisticsRegion: '#documents-statistics-content',
	        documentsStatisticsAggregateRegion: '#documents-statistics-aggregate-content',
	        setInitialViewModal: '#initial-view-modal'
	    },
	
	    ui: {
	        filter: '#requests-filter',
	        clearFilter: '#clear-filter',
	        clearFilterContainer: '#clear-filter-container',
	        createdAfter: '#createdAfter',
	        createdBefore: '#createdBefore',
	        objectCreatedAfter: '#docCreatedAfter',
	        objectCreatedBefore: '#docCreatedBefore',
	        statuses: '#element-statuses',
	        intentions: '#element-intentions',
	        doctypes: '#doctypes',
	        deliveryStatuses: '#delivery-statuses',
	        reviewed: '#reviewed',
	        signDocuments: '#sign-all',
	        signAndGetDocuments: '#sign-and-get',
	        download: '#download',
	        print: '#print',
	        assignModalShow: '#assign',
	        addPatientModalShow: '#add-patient',
	        setDueModalShow: '#set-due',
	        audit: '#audit',
	        auditMore: '#audit-more',
	        auditBulk: '#audit-bulk',
	        allDocCheckbox: '#root_check',
	        errorMessage: '#error-message',
	        send: '#send',
	        sendMore: '#send-more',
	        sendBulk: '#send-bulk',
	        addendum: "#addendum",
	
	        markAs: '#mark-as',
	        markAsSent: '#mark-as-sent',
	        markAsDelivered: '#mark-as-delivered',
	
	        export: '#export',
	        exportBulk: '#export-bulk',
	
	        timeFrameMonthly: "#time-frame-monthly-filtered",
	        timeFrameWeekly: "#time-frame-weekly-filtered",
	        timeFrameDaily: "#time-frame-daily-filtered",
	        timeFrameSelected: "#time-frame-selected",
	
	        //sentAfter: '#sent-after',
	        //sentBefore: '#sent-before',
	        dueAfter: '#due-after',
	        dueBefore: '#due-before',
	        deliveredAfter: '#delivered-after',
	        deliveredBefore: '#delivered-before',
	        signedAfter: '#signed-after',
	        signedBefore: '#signed-before',
	        removeCommentFilter: '#remove-comment-filter',
	
	        showDocumentsStatistics: '#show-documents-statistics',
	        documentsStatisticsModal: '#documents-statistics-modal',
	
	        showDocumentsStatisticsAggregate: '#show-documents-statistics-aggregate',
	        documentsStatisticsAggregateModal: '#documents-statistics-aggregate-modal',
	        signBeforeLeaveConfirmationModal: '#sign-before-leave-confirmation-modal',
	
	        sortHeader: '.sort-header',
	
	        showMoreFilters: '#show-more-filters',
	        moreFilters: '#more-filtes',
	
	        signBeforeLeaveConfirmationSignButton: '#sign-before-leave-confirmation-sign',
	        signBeforeLeaveConfirmationCancelButton: '#sign-before-leave-confirmation-cancel',
	        signBeforeLeaveConfirmationCloseButton: '#sign-before-leave-confirmation-close',
	
	        setAsInitialViewSortingReportForMe: '#set-initial-for-me',
	        setAsInitialViewSortingReport: '#set-initial'
	    },
	
	    events: {
	        'click @ui.filter': 'doFilter',
	        'click @ui.clearFilter': 'clearFilter',
	        'click @ui.signDocuments': 'onSignSelectedDocuments',
	        'click @ui.signAndGetDocuments': 'signAndGet',
	        'click @ui.allDocCheckbox': 'checkOrUncheckAllDocuments',
	        'click @ui.download': 'download',
	        'click @ui.print': 'print',
	        'click @ui.assignModalShow': 'assignModalShow',
	        'click @ui.addPatientModalShow': 'addPatientModalShow',
	        'click @ui.setDueModalShow': 'setDueModalShow',
	        'click @ui.audit': 'auditModalShow',
	        'click @ui.auditBulk': 'auditBulkModalShow',
	        'click @ui.send': 'sendModalShow',
	        'click @ui.sendBulk': 'sendBulkModalShow',
	        'click @ui.addendum': 'addAddendumModalShow',
	        'click @ui.markAsSent': 'markAsSentModalShow',
	        'click @ui.markAsDelivered': 'markAsDeliveredModalShow',
	        'click @ui.export': 'exportModalShow',
	        'click @ui.exportBulk': 'exportBulkModalShow',
	
	        'click @ui.timeFrameMonthly': 'timeFrameMonthly',
	        'click @ui.timeFrameWeekly': 'timeFrameWeekly',
	        'click @ui.timeFrameDaily': 'timeFrameDaily',
	        'click @ui.timeFrameSelected': 'timeFrameSelected',
	
	        'click @ui.removeCommentFilter': 'onRemoveCommentFilter',
	
	        'click @ui.showDocumentsStatistics': 'onShowDocumentsStatistics',
	        'click @ui.showDocumentsStatisticsAggregate': 'onShowDocumentsStatisticsAggregate',
	
	        'click @ui.sortHeader': 'onSort',
	
	        "click @ui.showMoreFilters": 'showMoreFilters',
	
	        "click @ui.setAsInitialViewSortingReportForMe": 'onSetAsInitialViewSortingReportForMe',
	        "click @ui.setAsInitialViewSortingReport": 'onSetAsInitialViewSortingReport'
	    },
	
	    childViewEvents: {
	        'document:create:request': 'createRequest',
	        'document:selected': 'documentSelected',
	        'refresh:model': 'refreshModel',
	        'loader:show': 'showLoading',
	        'loader:hide': 'hideLoading',
	        'error:log': 'logError',
	
	        // events from Aggregated report View
	        'statistics:aggregate': 'onStaticticsAggregate',
	        'aggregate:documents:selected': 'onDocumentsSelectedInAggregateReport',
	        'aggregate:documents:unselected': 'onDocumentsUnselectedInAggregateReport',
	        'aggregate:download': 'downloadFromAggregateReport',
	        'aggregate:print': 'printFromAggregateReport',
	        'aggregate:sign': 'signModalShowFromAggregateReport',
	        'aggregate:assign': 'assignModalShowFromAggregateReport',
	        'aggregate:add:patient': 'addPatientModalShowFromAggregateReport',
	        'aggregate:add:addendum': 'addAddendumModalShowFromAggregateReport',
	        'aggregate:set:due': 'setDueModalShowFromAggregateReport',
	        'aggregate:audit': 'auditModalShowFromAggregateReport',
	        'aggregate:send': 'sendModalShowFromAggregateReport',
	        'aggregate:mark:as:sent': 'markAsSentModalShowFromAggregateReport',
	        'aggregate:mark:as:delivered': 'markAsDeliveredModalShowFromAggregateReport'
	    },
	
	    documentsIds: [],
	    notPreviewedDocumentsIds: [],
	
	    constants: {
	        maxNumberOfItemsInControlWithSuggester: 200,
	        documentPatient: 'DOCUMENT_PATIENT',
	        documentUploaderPerson: 'DOCUMENT_UPLOADER_PERSON',
	        personReviewRequest: 'PERSON_REVIEW_REQUEST',
	        personReviewFinishedRequest: 'PERSON_REVIEW_FINISHED_REQUEST',
	        createdBy: 'DOCUMENT_ORGANIZATION',
	        organizationReviewRequest: 'ORGANIZATION_REVIEW_REQUEST',
	        organizationReviewFinishedRequest: 'ORGANIZATION_REVIEW_FINISHED_REQUEST',
	        objectIntentionStatus: 'object_intention',
	        objectDoctype: 'object_type',
	        objectStatus: 'object_status'
	    },
	
	    initialize: function (options) {
	        var collectionParams = [
	            {key: 'page-size', value: Constants.pageCapacity}
	        ];
	
	        if (!utils.isParamExists(options.collectionParams || [], {key: 'sortby'})) {
	            collectionParams.push({key: 'sortby', value: 'documentCreationTime'});
	        }
	        if (!utils.isParamExists(options.collectionParams || [], {key: 'sortdir'})) {
	            collectionParams.push({key: 'sortdir', value: 'DESC'});
	        }
	
	        this.reviewElementStatuses = options.reviewElementStatuses;
	        this.collection = new DocumentsCollection([],
	            {params: utils.mergeCollectionParams(collectionParams, options.collectionParams || [])});
	
	        this.accessSignAction = window.location.href.indexOf("toReview") > -1;
	        this.isSimple = window.location.href.indexOf("simpleMode=true") > -1;
	        this.notForToReview = window.location.href.indexOf("toReview") == -1;
	        this.viewAllMode = this.notForToReview && !this.isSimple;
	        this.params = utils.getDefaultListParams();
	
	        this.signDocsCallbackForPager = options.signDocsCallbackForPager
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            elementStatuses: _.values(that.reviewElementStatuses.toJSON()).filter(function (item) {
	                return item != 'VIEWED';
	            }).map(function (item) {
	                return {
	                    id: item,
	                    name: utils.getDocumentStatus(item)
	                }
	            }),
	            accessSignAction: this.accessSignAction,
	            isSimple: this.isSimple,
	            notForToReview: this.notForToReview,
	            viewAllMode: this.viewAllMode,
	            byAdmin: this.getOption('byAdmin'),
	            getParam: function (key) {
	                if (key == "object_externalIds_in")
	                    return (that.params[key] || '').replace(Constants.barCodePrefix, "");
	                else
	                    return that.params[key] || '';
	            },
	            getDateParam: function (key) {
	                if (that.params[key]) {
	                    try {
	                        return utils.longToDateTimeFormatted(Number(that.params[key]), 'MM/DD/YYYY');
	                    } catch (e) {
	                        console.log(e);
	                        return undefined;
	                    }
	
	                }
	                return undefined;
	            },
	            getDateTimeParam: function (key) {
	                if (that.params[key]) {
	                    try {
	                        return utils.longToDateTimeFormatted(Number(that.params[key]), 'MM/DD/YYYY hh:mm A');
	                    } catch (e) {
	                        console.log(e);
	                        return undefined;
	                    }
	
	                }
	                return undefined;
	            },
	            isMd: that.getOption('isMd'),
	            isOfficeAdministrator: that.getOption('isOfficeAdministrator'),
	            isMedicalDirector: that.getOption('isMedicalDirector'),
	            isManager: that.getOption('isManager'),
	            isAdmin: that.getOption('isAdmin'),
	            showSendingMethods: that.showSendingMethods(that),
	            getClassesForSortingHeader: function (sortBy) {
	                var classes = ["sortable"];
	                if ((that.params["sortby"] || "documentCreationTime") === sortBy) {
	                    if (that.params["sortdir"] === "ASC") {
	                        classes.push("glyphicon glyphicon-triangle-top");
	                        return classes.join(" ");
	                    } else {
	                        classes.push("glyphicon glyphicon-triangle-bottom");
	                        return classes.join(" ");
	                    }
	                } else {
	                    return classes.join(" ");
	                }
	            }
	        }
	    },
	
	    showMoreFilters: function () {
	        this.$('#more-filtes').toggle();
	    },
	
	    showSendingMethods: function (self) {
	        /*return self.getOption('isOfficeAdministrator')
	            || self.getOption('isMedicalDirector')
	            || self.getOption('isManager')
	            || self.getOption('isAdmin')
	            || self.getOption('byAdmin');*/
	        return false;
	    },
	
	    onRender: function () {
	        var that = this;
	
	        that.extraInit();
	
	        that.collection.fetch({
	            success: function () {
	                that.showChildView('body', new DocumentsTableBody({
	                    collection: that.collection,
	                    accessSignAction: that.accessSignAction,
	                    username: that.getOption('username'),
	                    byAdmin: that.getOption('byAdmin'),
	                    showSendingMethods: that.showSendingMethods(that)
	                }));
	            }
	        });
	
	        if (!that.isSimple) {
	
	            if (typeof that.params[that.constants.createdBy] != "undefined") {
	
	                var collectionCreatedBy = new EntitiesCollection([],
	                    {
	                        params: (Array.isArray(that.params[that.constants.createdBy])
	                            ? that.params[that.constants.createdBy]
	                            : [that.params[that.constants.createdBy]])
	                            .map(function (id) {
	                                return {
	                                    key: 'id',
	                                    value: id
	                                }
	                            })
	                    });
	                collectionCreatedBy.fetch(
	                    {
	                        success: function () {
	                            var items = collectionCreatedBy.models.map(function (model) {
	                                return model.attributes;
	                            });
	                            that.showCreatedBySelect(items);
	                        },
	                        error: function () {
	                            that.showCreatedBySelect();
	                        }
	                    }
	                );
	            } else {
	                that.showCreatedBySelect();
	            }
	
	            if (typeof that.params[that.constants.personReviewRequest] != "undefined") {
	
	                var collectionPersonReviewRequest = new EntitiesCollection([],
	                    {
	                        params: (Array.isArray(that.params[that.constants.personReviewRequest])
	                            ? that.params[that.constants.personReviewRequest]
	                            : [that.params[that.constants.personReviewRequest]])
	                            .map(function (id) {
	                                return {
	                                    key: 'id',
	                                    value: id
	                                }
	                            })
	                    });
	                collectionPersonReviewRequest.fetch(
	                    {
	                        success: function () {
	                            var items = collectionPersonReviewRequest.models.map(function (model) {
	                                return model.attributes;
	                            });
	                            that.showAssignedToPersonsSelect(items);
	                        },
	                        error: function () {
	                            that.showAssignedToPersonsSelect();
	                        }
	                    }
	                );
	            } else {
	                that.showAssignedToPersonsSelect();
	            }
	
	            if (typeof that.params[that.constants.organizationReviewRequest] != "undefined") {
	
	                var collectionOrganizationReviewRequest = new EntitiesCollection([],
	                    {
	                        params: (Array.isArray(that.params[that.constants.organizationReviewRequest])
	                            ? that.params[that.constants.organizationReviewRequest]
	                            : [that.params[that.constants.organizationReviewRequest]])
	                            .map(function (id) {
	                                return {
	                                    key: 'id',
	                                    value: id
	                                }
	                            })
	                    });
	                collectionOrganizationReviewRequest.fetch(
	                    {
	                        success: function () {
	                            var items = collectionOrganizationReviewRequest.models.map(function (model) {
	                                return model.attributes;
	                            });
	                            that.showAssignedToOrganizationsSelect(items);
	                        },
	                        error: function () {
	                            that.showAssignedToOrganizationsSelect();
	                        }
	                    }
	                );
	            } else {
	                that.showAssignedToOrganizationsSelect();
	            }
	
	            if (typeof that.params[that.constants.documentPatient] != "undefined") {
	
	                var collectionDocumentPatient = new EntitiesCollection([],
	                    {
	                        params: (Array.isArray(that.params[that.constants.documentPatient])
	                            ? that.params[that.constants.documentPatient]
	                            : [that.params[that.constants.documentPatient]])
	                            .map(function (id) {
	                                return {
	                                    key: 'id',
	                                    value: id
	                                }
	                            })
	                    });
	                collectionDocumentPatient.fetch(
	                    {
	                        success: function () {
	                            var patients = collectionDocumentPatient.models.map(function (model) {
	                                return model.attributes;
	                            }).filter(that.isPatientFilter);
	                            that.showPatientsSelect(patients);
	                        },
	                        error: function () {
	                            that.showPatientsSelect();
	                        }
	                    }
	                );
	
	            } else {
	                that.showPatientsSelect();
	            }
	
	            // if (typeof that.params[that.constants.personReviewFinishedRequest] != "undefined"
	            //     && typeof that.params[that.constants.personReviewRequest] == "undefined") {
	            if (typeof that.params[that.constants.personReviewFinishedRequest] != "undefined") {
	
	                var collectionPersonReviewFinishedRequest = new EntitiesCollection([],
	                    {
	                        params: (Array.isArray(that.params[that.constants.personReviewFinishedRequest])
	                            ? that.params[that.constants.personReviewFinishedRequest]
	                            : [that.params[that.constants.personReviewFinishedRequest]])
	                            .map(function (id) {
	                                return {
	                                    key: 'id',
	                                    value: id
	                                }
	                            })
	                    });
	                collectionPersonReviewFinishedRequest.fetch(
	                    {
	                        success: function () {
	                            var items = collectionPersonReviewFinishedRequest.models.map(function (model) {
	                                return model.attributes;
	                            });
	                            that.showSignedByPersonsSelect(items);
	                        },
	                        error: function () {
	                            that.showSignedByPersonsSelect();
	                        }
	                    }
	                );
	            } else {
	                that.showSignedByPersonsSelect();
	            }
	
	            if (typeof that.params[that.constants.documentUploaderPerson] != "undefined") {
	
	                var collectionPersonUploader = new EntitiesCollection([],
	                    {
	                        params: (Array.isArray(that.params[that.constants.documentUploaderPerson])
	                            ? that.params[that.constants.documentUploaderPerson]
	                            : [that.params[that.constants.documentUploaderPerson]])
	                            .map(function (id) {
	                                return {
	                                    key: 'id',
	                                    value: id
	                                }
	                            })
	                    });
	                collectionPersonUploader.fetch(
	                    {
	                        success: function () {
	                            var items = collectionPersonUploader.models.map(function (model) {
	                                return model.attributes;
	                            });
	                            that.showUploaderPersonsSelect(items);
	                        },
	                        error: function () {
	                            that.showUploaderPersonsSelect();
	                        }
	                    }
	                );
	            } else {
	                that.showUploaderPersonsSelect();
	            }
	
	            // if (typeof that.params[that.constants.organizationReviewFinishedRequest] != "undefined"
	            //     && typeof that.params[that.constants.organizationReviewRequest] == "undefined") {
	            if (typeof that.params[that.constants.organizationReviewFinishedRequest] != "undefined") {
	
	                var collectionOrganizationReviewFinishedRequest = new EntitiesCollection([],
	                    {
	                        params: (Array.isArray(that.params[that.constants.organizationReviewFinishedRequest])
	                            ? that.params[that.constants.organizationReviewFinishedRequest]
	                            : [that.params[that.constants.organizationReviewFinishedRequest]])
	                            .map(function (id) {
	                                return {
	                                    key: 'id',
	                                    value: id
	                                }
	                            })
	                    });
	                collectionOrganizationReviewFinishedRequest.fetch(
	                    {
	                        success: function () {
	                            var items = collectionOrganizationReviewFinishedRequest.models.map(function (model) {
	                                return model.attributes;
	                            });
	                            that.showSignedByOrganizationsSelect(items);
	                        },
	                        error: function () {
	                            that.showSignedByOrganizationsSelect();
	                        }
	                    }
	                );
	            } else {
	                that.showSignedByOrganizationsSelect();
	            }
	        }
	
	        this.$('#createdAfter').datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	        this.$('#createdBefore').datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	        this.$('#docCreatedBefore').datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	        this.$('#docCreatedAfter').datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	
	        this.$('#delivered-after').datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	        this.$('#delivered-before').datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	
	        this.$('#signed-after').datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	        this.$('#signed-before').datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	        /*this.ui.sentAfter.datepicker({
	         format: 'mm/dd/yyyy',
	         clearBtn: true
	         }).on('changeDate', function (e) {
	         $(this).datepicker('hide');
	         });
	         this.ui.sentBefore.datepicker({
	         format: 'mm/dd/yyyy',
	         clearBtn: true
	         }).on('changeDate', function (e) {
	         $(this).datepicker('hide');
	         });*/
	
	        this.ui.dueAfter.datetimepicker({
	            showClear: true,
	            showClose: true,
	            format: 'MM/DD/YYYY hh:mm A'
	        });
	        if (typeof that.params["object_dueDate_from"] !== 'undefined') {
	            this.ui.dueAfter.data("DateTimePicker").date(utils.longToDateTimeFormatted(Number(that.params["object_dueDate_from"]), 'MM/DD/YYYY hh:mm A'));
	        }
	
	        this.ui.dueBefore.datetimepicker({
	            showClear: true,
	            showClose: true,
	            format: 'MM/DD/YYYY hh:mm A'
	        });
	        if (typeof that.params["object_dueDate_to"] !== 'undefined') {
	            this.ui.dueBefore.data("DateTimePicker").date(utils.longToDateTimeFormatted(Number(that.params["object_dueDate_to"]), 'MM/DD/YYYY hh:mm A'));
	        }
	
	        this.ui.statuses.selectize({
	            plugins: ['remove_button'],
	            inputClass: 'form-control selectize-input normal-width selectized',
	            placeholder: 'Status',
	            valueField: 'id',
	            labelField: 'name',
	            options: _.keys(Dicts.documentStatuses)/*.filter(function (key) {
	                return key !== 'UNREVIEWED';
	            })*/.map(function (key) {
	                return {
	                    id: key,
	                    name: Dicts.documentStatuses[key].toUpperCase()
	                }
	            }),
	            items: function () {
	                if (typeof that.params[that.constants.objectStatus] != "undefined") {
	                    return Array.isArray(that.params[that.constants.objectStatus])
	                        ? that.params[that.constants.objectStatus]
	                        : [that.params[that.constants.objectStatus]];
	                } else {
	                    return [];
	                }
	            }(),
	            highlight: true,
	            openOnFocus: true
	        });
	
	        this.ui.intentions.selectize({
	            plugins: ['remove_button'],
	            inputClass: 'form-control selectize-input normal-width selectized',
	            placeholder: 'Request',
	            valueField: 'id',
	            labelField: 'name',
	            options: _.keys(Dicts.documentIntention).map(function (key) {
	                return {
	                    id: key,
	                    name: Dicts.documentIntention[key].toUpperCase()
	                }
	            }),
	            items: function () {
	                if (typeof that.params[that.constants.objectIntentionStatus] != "undefined") {
	                    return Array.isArray(that.params[that.constants.objectIntentionStatus])
	                        ? that.params[that.constants.objectIntentionStatus]
	                        : [that.params[that.constants.objectIntentionStatus]];
	                } else {
	                    return [];
	                }
	            }(),
	            highlight: true,
	            openOnFocus: true
	        });
	
	        this.ui.doctypes.selectize({
	            plugins: ['remove_button'],
	            inputClass: 'form-control selectize-input normal-width selectized',
	            placeholder: 'Document type',
	            valueField: 'id',
	            labelField: 'name',
	            options: _.keys(Dicts.documentTypes).map(function (key) {
	                return {
	                    id: key,
	                    name: Dicts.documentTypes[key]
	                }
	            }),
	            items: function () {
	                if (typeof that.params[that.constants.objectDoctype] != "undefined") {
	                    return Array.isArray(that.params[that.constants.objectDoctype])
	                        ? that.params[that.constants.objectDoctype]
	                        : [that.params[that.constants.objectDoctype]];
	                } else {
	                    return [];
	                }
	            }(),
	            highlight: true,
	            openOnFocus: true
	        });
	
	        /*this.ui.sentStatuses.selectize({
	         allowEmptyOption: false,
	         placeholder: 'Sent status (All)',
	         inputClass: 'form-control selectize-input normal-width'
	         });*/
	
	        this.ui.deliveryStatuses.selectize({
	            allowEmptyOption: false,
	            placeholder: 'Delivery Status',
	            inputClass: 'form-control selectize-input'
	        });
	
	        that.ui.documentsStatisticsModal.on("hidden.bs.modal", function () {
	            that.detachChildView('documentsStatisticsRegion');
	        });
	        that.ui.documentsStatisticsAggregateModal.on("hidden.bs.modal", function () {
	            that.detachChildView('documentsStatisticsAggregateRegion');
	            that.checkOrUncheckAllDocumentsInner(false);
	        });
	
	        if (utils.isUrlWoExtraQueryParameters()) {
	            that.ui.clearFilterContainer.hide();
	        } else {
	            that.ui.clearFilterContainer.show();
	        }
	
	        that.documentsIds = [];
	        that.notPreviewedDocumentsIds = [];
	    },
	
	    extraInit: function () {
	        console.log('extraInit');
	        var that = this;
	        window.setTimeout(function () {
	            var params = $.deparam(window.location.hash.replace('#documents', '').replace('?', ''));
	            if (params["initial-view"]) {
	                console.log(params["initial-view"]);
	                if (params["initial-view"] == "sorting-report") {
	                    that.onShowDocumentsStatisticsAggregate();
	                    delete that.params["initial-view"];
	                }
	            }
	        }, 500);
	    },
	
	    createRequest: function (data) {
	        var that = this;
	        that.triggerMethod('request:create', data);
	    },
	
	    initFilterParams: function () {
	        var that = this;
	
	        $('.filter-field').each(function (i, element) {
	            if ($(element).attr('name')) {
	                var names = $(element).attr('name').split(',');
	                for (var name in names) {
	                    if ($(element).val() && $(element).val() != 'all') {
	                        if (names[name] == "object_externalIds_in")
	                            that.params[names[name]] = Constants.barCodePrefix + $(element).val();
	                        else
	                            that.params[names[name]] = $(element).val();
	                    } else {
	                        delete that.params[names[name]];
	                    }
	                }
	            }
	        });
	
	        var statuses = that.ui.statuses.val();
	        if (_.isEmpty(statuses)) {
	            delete that.params[that.constants.objectStatus];
	        } else {
	            that.params[that.constants.objectStatus] = statuses.split(',');
	        }
	
	        var intentionStatuses = that.ui.intentions.val();
	        if (_.isEmpty(intentionStatuses)) {
	            delete that.params[that.constants.objectIntentionStatus];
	        } else {
	            that.params[that.constants.objectIntentionStatus] = intentionStatuses.split(',');
	        }
	
	
	        var doctypes = that.ui.doctypes.val();
	        if (_.isEmpty(doctypes)) {
	            delete that.params[that.constants.objectDoctype];
	        } else {
	            that.params[that.constants.objectDoctype] = doctypes.split(',');
	        }
	
	        if (this.ui.deliveryStatuses.val() == "delivered") {
	            that.params["object_lastDeliveredTime_from"] = 1;
	            delete that.params["object_lastDeliveredTime"];
	            delete that.params["object_lastSentTime_from"];
	            delete that.params["object_lastSentTime"];
	        } else if (this.ui.deliveryStatuses.val() == "not_delivered") {
	            that.params["object_lastDeliveredTime"] = 0;
	            that.params["object_lastSentTime_from"] = 1;
	            this.ui.deliveredAfter.val('');
	            delete that.params["object_lastDeliveredTime_from"];
	            delete that.params["object_lastSentTime"];
	        } else if (this.ui.deliveryStatuses.val() == "not_sent") {
	            that.params["object_lastSentTime"] = 0;
	            this.ui.deliveredAfter.val('');
	            delete that.params["object_lastDeliveredTime_from"];
	            delete that.params["object_lastDeliveredTime"];
	            delete that.params["object_lastSentTime_from"];
	        } else {
	            delete that.params["object_lastDeliveredTime"];
	            delete that.params["object_lastDeliveredTime_from"];
	            delete that.params["object_lastSentTime_from"];
	            delete that.params["object_lastSentTime"];
	        }
	
	        var documentPatientsIds = that.getChildView('patientsSelect').getSelectedIdsList();
	        if (documentPatientsIds.length > 0) {
	            that.params[that.constants.documentPatient] = documentPatientsIds;
	        } else {
	            delete (that.params[that.constants.documentPatient]);
	        }
	
	        var createdByValues = that.getChildView('createdBySelect').getSelectedIdsList();
	        if (createdByValues.length > 0) {
	            that.params[that.constants.createdBy] = createdByValues;
	        } else {
	            delete (that.params[that.constants.createdBy]);
	        }
	
	        var assignedToPersonValues = that.getChildView('assignedToPersonsSelect').getSelectedIdsList();
	        var assignedToOrganizationValues = that.getChildView('assignedToOrganizationsSelect').getSelectedIdsList();
	        var signedByPersonValues = that.getChildView('signedByPersonsSelect').getSelectedIdsList();
	        var signedByOrganizationValues = that.getChildView('signedByOrganizationsSelect').getSelectedIdsList();
	        var uploaderPersonValues = that.getChildView('uploaderPersonsSelect').getSelectedIdsList();
	
	        if (assignedToPersonValues.length > 0) {
	            that.params[that.constants.personReviewRequest] = assignedToPersonValues;
	        } else {
	            delete (that.params[that.constants.personReviewRequest]);
	        }
	
	        if (assignedToOrganizationValues.length > 0) {
	            that.params[that.constants.organizationReviewRequest] = assignedToOrganizationValues;
	        } else {
	            delete (that.params[that.constants.organizationReviewRequest]);
	        }
	
	        if (signedByPersonValues.length > 0) {
	            that.params[that.constants.personReviewFinishedRequest] = signedByPersonValues;
	        } else {
	            delete (that.params[that.constants.personReviewFinishedRequest]);
	        }
	
	        if (uploaderPersonValues.length > 0) {
	            that.params[that.constants.documentUploaderPerson] = uploaderPersonValues;
	        } else {
	            delete (that.params[that.constants.documentUploaderPerson]);
	        }
	
	        if (signedByOrganizationValues.length > 0) {
	            that.params[that.constants.organizationReviewFinishedRequest] = signedByOrganizationValues;
	        } else {
	            delete (that.params[that.constants.organizationReviewFinishedRequest]);
	        }
	
	        if (this.ui.createdAfter.val() != undefined && this.ui.createdAfter.val() != '')
	            this.params['from_createdTime'] = utils.dateToLong(this.ui.createdAfter.val());
	        else
	            delete this.params['from_createdTime'];
	        if (this.ui.createdBefore.val() != undefined && this.ui.createdBefore.val() != '')
	            this.params['to_createdTime'] = utils.dateToLong(this.ui.createdBefore.val());
	        else
	            delete this.params['to_createdTime'];
	
	        if (this.ui.objectCreatedAfter.val() != undefined && this.ui.objectCreatedAfter.val() != '')
	            this.params['object_createdTime_from'] = utils.dateToLong(this.ui.objectCreatedAfter.val());
	        else
	            delete this.params['object_createdTime_from'];
	        if (this.ui.objectCreatedBefore.val() != undefined && this.ui.objectCreatedBefore.val() != '')
	            this.params['object_createdTime_to'] = utils.dateToLong(this.ui.objectCreatedBefore.val());
	        else
	            delete this.params['object_createdTime_to'];
	
	        /*if (this.ui.sentAfter.val() != undefined && this.ui.sentAfter.val() != '')
	         this.params['object_lastSentTime_from'] = utils.dateToLong(this.ui.sentAfter.val());
	         else
	         delete this.params['object_lastSentTime_from'];
	         if (this.ui.sentBefore.val() != undefined && this.ui.sentBefore.val() != '')
	         this.params['object_lastSentTime_to'] = utils.dateToLong(this.ui.sentBefore.val());
	         else
	         delete this.params['object_lastSentTime_to'];*/
	
	        if (this.ui.dueAfter.val() != undefined && this.ui.dueAfter.val() != '')
	            this.params['object_dueDate_from'] = utils.dateToLong(this.ui.dueAfter.val());
	        else
	            delete this.params['object_dueDate_from'];
	        if (this.ui.dueBefore.val() != undefined && this.ui.dueBefore.val() != '')
	            this.params['object_dueDate_to'] = utils.dateToLong(this.ui.dueBefore.val());
	        else
	            delete this.params['object_dueDate_to'];
	
	        if (this.ui.deliveredAfter.val() != undefined && this.ui.deliveredAfter.val() != '')
	            this.params['object_lastDeliveredTime_from'] = utils.dateToLong(this.ui.deliveredAfter.val());
	        else if (this.ui.deliveryStatuses.val() == undefined) {
	            delete this.params['object_lastDeliveredTime_from'];
	        }
	
	        if (this.ui.deliveredBefore.val() != undefined && this.ui.deliveredBefore.val() != '')
	            this.params['object_lastDeliveredTime_to'] = utils.dateToLong(this.ui.deliveredBefore.val());
	        else
	            delete this.params['object_lastDeliveredTime_to'];
	
	        if (this.ui.signedAfter.val() != undefined && this.ui.signedAfter.val() != '')
	            this.params['object_signedTime_from'] = utils.dateToLong(this.ui.signedAfter.val());
	        else
	            delete this.params['object_signedTime_from'];
	
	        if (this.ui.signedBefore.val() != undefined && this.ui.signedBefore.val() != '')
	            this.params['object_signedTime_to'] = utils.dateToLong(this.ui.signedBefore.val());
	        else
	            delete this.params['object_signedTime_to'];
	
	    },
	
	    doFilter: function () {
	
	        this.initFilterParams();
	        this.params.page = 0;
	
	        console.log('Hashing to ' + utils.getCleanBaseHash() + "?" + utils.objectToQueryParams(this.params));
	
	        window.location.hash = utils.getCleanBaseHash() + "?" + utils.objectToQueryParams(this.params);
	    },
	
	    onRemoveCommentFilter: function () {
	        delete this.params["commentId"];
	        window.location.hash = utils.getCleanBaseHash() + "?" + utils.objectToQueryParams(this.params);
	    },
	
	    clearFilter: function () {
	        utils.redirectToUrlWoExtraQueryParameters();
	    },
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    },
	
	    enableButtons: function () {
	        this.ui.download.removeAttr("disabled");
	        this.ui.print.removeAttr("disabled");
	        this.ui.assignModalShow.removeAttr("disabled");
	        this.ui.addPatientModalShow.removeAttr("disabled");
	        this.ui.setDueModalShow.removeAttr("disabled");
	        this.ui.audit.removeAttr("disabled");
	        this.ui.send.removeAttr("disabled");
	        this.ui.addendum.removeAttr("disabled");
	        this.ui.markAs.removeAttr("disabled");
	        this.ui.export.removeAttr("disabled");
	        this.ui.timeFrameSelected.removeAttr("disabled");
	    },
	
	    disableButtons: function () {
	        this.ui.download.attr("disabled", "true");
	        this.ui.print.attr("disabled", "true");
	        this.ui.assignModalShow.attr("disabled", "true");
	        this.ui.addPatientModalShow.attr("disabled", "true");
	        this.ui.setDueModalShow.attr("disabled", "true");
	        this.ui.audit.attr("disabled", "true");
	        this.ui.send.attr("disabled", "true");
	        this.ui.addendum.attr("disabled", "true");
	        this.ui.markAs.attr("disabled", "true");
	        this.ui.export.attr("disabled", "true");
	        this.ui.timeFrameSelected.attr("disabled", "true");
	    },
	
	
	    enableSignButtons: function () {
	        this.ui.signDocuments.removeAttr("disabled");
	        this.ui.signAndGetDocuments.removeAttr("disabled");
	    },
	
	    disableSignButtons: function () {
	        this.ui.signDocuments.attr("disabled", "true");
	        this.ui.signAndGetDocuments.attr("disabled", "true");
	    },
	
	    documentSelected: function (data) {
	        var that = this;
	        if (data.addOrRemove) {
	            if (data.isDocumentPreviewed) {
	                this.documentsIds.push(data.documentId);
	            } else {
	                this.documentsIds.push(data.documentId);
	                this.notPreviewedDocumentsIds.push(data.documentId);
	            }
	        } else {
	            this.documentsIds = (this.documentsIds || []).filter(function (item) {
	                return item !== data.documentId
	            });
	            this.notPreviewedDocumentsIds = (this.notPreviewedDocumentsIds || []).filter(function (item) {
	                return item !== data.documentId
	            });
	        }
	        this.documentsIds = _.uniq(this.documentsIds);
	        this.notPreviewedDocumentsIds = _.uniq(this.notPreviewedDocumentsIds);
	
	
	        if (this.documentsIds.length - this.notPreviewedDocumentsIds.length == 0 || this.notPreviewedDocumentsIds.length > 0) {
	            this.disableSignButtons();
	            //this.signDocsCallbackForPager.signDocuments = null;
	        } else {
	            this.enableSignButtons();
	            /*this.signDocsCallbackForPager.signDocuments = function (fn) {
	                return that.signDocumentsBeforePageChanged(fn, that);
	            };*/
	        }
	
	        if (this.documentsIds.length == 0 && this.notPreviewedDocumentsIds.length == 0) {
	            this.disableButtons();
	        } else {
	            this.enableButtons();
	        }
	
	        if (/*this.getOption('isMd')*/ true) {
	            if (this.notPreviewedDocumentsIds.length == 0) {
	                this.showDocumentNotPreviewedMessage('hide');
	            } else {
	                this.showDocumentNotPreviewedMessage('show');
	            }
	        }
	
	        if (this.documentsIds.length == 0) {
	            this.signDocsCallbackForPager.signDocuments = null;
	        } else {
	            this.signDocsCallbackForPager.signDocuments = function (fn) {
	                return that.signDocumentsBeforePageChanged(fn, that);
	            };
	        }
	    },
	
	    showDocumentNotPreviewedMessage: function (mode) {
	        if (/*this.accessSignAction*/ true) {
	            if (mode == 'hide') {
	                this.ui.errorMessage.empty();
	            } else if (mode == 'show') {
	                this.ui.errorMessage.html('All documents should be viewed or downloaded before signing');
	            }
	        }
	    },
	
	    checkOrUncheckAllDocuments: function (event) {
	        this.checkOrUncheckAllDocumentsInner(event.target.checked);
	    },
	
	    checkOrUncheckAllDocumentsInner: function (checked) {
	        var that = this;
	
	        that.collection.forEach(function (model) {
	            model.set("selected", checked);
	        });
	
	        if (checked) {
	            $('.child_checkbox').prop('checked', true);
	
	            that.documentsIds = that.collection.map(function (model) {
	                return model.get('id');
	            });
	
	            that.notPreviewedDocumentsIds = that.collection.filter(function (model) {
	                return (model.get('object').downloadedOrPreviewedSigners || []).filter(function (signer) {
	                    return signer == that.getOption('username');
	                }).length == 0;
	            }).map(function (model) {
	                return model.get('id');
	            });
	
	            if (that.notPreviewedDocumentsIds.length > 0) {
	                that.showDocumentNotPreviewedMessage('show');
	            }
	
	            if (that.documentsIds.length > 0 && that.notPreviewedDocumentsIds.length == 0) {
	                that.enableSignButtons();
	                /*that.signDocsCallbackForPager.signDocuments = function (fn) {
	                    return that.signDocumentsBeforePageChanged(fn, that);
	                };*/
	            }
	            if (that.documentsIds.length > 0) {
	                that.enableButtons();
	                that.signDocsCallbackForPager.signDocuments = function (fn) {
	                    return that.signDocumentsBeforePageChanged(fn, that);
	                };
	            }
	        } else {
	            that.documentsIds = [];
	            that.notPreviewedDocumentsIds = [];
	            that.disableButtons();
	            that.disableSignButtons();
	            $('.child_checkbox').prop('checked', false);
	            that.showDocumentNotPreviewedMessage('hide');
	            that.signDocsCallbackForPager.signDocuments = null;
	        }
	
	        console.log(that.documentsIds);
	    },
	
	    onSignSelectedDocuments: function () {
	        var that = this;
	        this.signDocuments(function (documentsIds) {
	            that.triggerMethod('document:list:refresh', null);
	        });
	    },
	
	    signDocuments: function (fn, fn2) {
	        var that = this;
	        this.triggerMethod('sign:documents', {
	            ids: that.documentsIds.join(),
	            action: this.sendToServer,
	            fn: fn,
	            cancelAction: fn2
	        });
	
	    },
	    sendToServer: function (fn, ids, password) {
	        var that = this;
	        utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/document/sign/documents',
	            data: {
	                documentsIds: ids,
	                status: 'SIGNED',
	                password: password
	            },
	            dataType: 'text',
	            statusCode: {
	                200: function (response) {
	                    utils.hideSpinner();
	
	                    window.setTimeout(function () {
	                        var sended = ids.split(",").filter(function (item) {
	                            return item != '';
	                        });
	                        var received = (response.split(",") || []).filter(function (item) {
	                            return item != '';
	                        });
	                        if (sended.length != received.length) {
	                            var n = sended.length - received.length;
	                            notificationsChannel.request('show:notification',
	                                n + " documents were not signed. Signed documents should be viewed at least once or user doesn't have permissions to sign.");
	                        } else {
	                            $.notify({
	                                message: 'Documents were signed successfully'
	                            }, {
	                                type: 'success',
	                                z_index: 2000,
	                            });
	                        }
	                    }, 0);
	
	                    if (typeof fn == "function" && response != '')
	                        fn(response);
	                }
	            },
	            error: function (e) {
	                utils.hideSpinner();
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	                }
	            }
	        });
	    },
	    signAndGet: function () {
	        var that = this;
	        that.signDocuments(this.attachmentsDownloadFn);
	    },
	
	    download: function () {
	        this.attachmentsDownloadFn(this.documentsIds.join(), true);
	    },
	
	    attachmentsDownloadFn: function (docsIds, partialRefreshModels) {
	        var that = this;
	        var idsList = docsIds.split(",");
	        if (idsList.length == 1) {
	            window.open("/api/document/download/" + docsIds);
	        } else if (idsList.length > 1) {
	            window.open("/api/document/download/multi/" + docsIds);
	        }
	
	        if (partialRefreshModels) {
	            setTimeout(function () {
	                idsList.forEach(function (docId) {
	                    var oldDocumentModel = that.collection.findWhere({id: docId});
	                    that.refreshModel({model: oldDocumentModel});
	                });
	            }, 4000);
	
	            setTimeout(function () {
	                idsList.forEach(function (docId) {
	                    var oldDocumentModel = that.collection.findWhere({id: docId});
	                    that.refreshModel({model: oldDocumentModel});
	                });
	            }, 12000);
	        }
	    },
	
	    print: function () {
	        window.open("/api/document/print/" + this.documentsIds.join(","));
	    },
	
	    assignModalShow: function (woResponseEvent, fetchDocsById) {
	        var that = this;
	        var byAdmin = that.getOption('byAdmin');
	        var documentsIds = that.documentsIds;
	        if (fetchDocsById) {
	            var documentsCollection = new DocumentsCollection([], {
	                params: documentsIds.map(function (id) {
	                    return {
	                        key: 'id',
	                        value: id
	                    }
	                })
	            });
	            documentsCollection.fetch({
	                success: function () {
	                    that.assignModalShowInner(woResponseEvent, documentsCollection, documentsIds, byAdmin);
	                },
	                error: function (e) {
	                    console.log(e);
	                }
	            });
	        } else {
	            that.assignModalShowInner(woResponseEvent, that.collection, documentsIds, byAdmin);
	        }
	    },
	
	    assignModalShowInner: function (woResponseEvent, collection, documentsIds, byAdmin) {
	        var reviewersAndDocuments = this.buildAndGetDocumentsWithReviewers(collection, documentsIds, byAdmin);
	        var getReviewerName = this.getReviewerNamesCombiner(documentsIds);
	        this.triggerMethod("document:reviewers:add:or:update", {
	            reviewersAndDocuments: reviewersAndDocuments,
	            documentsIds: documentsIds,
	            getReviewerName: getReviewerName,
	            woResponseEvent: woResponseEvent
	        });
	    },
	
	    buildAndGetDocumentsWithReviewers: function (collection, documentsIds, isByAdmin) {
	        var resultData = {};
	        var delimeter = '~~~';
	
	        collection.filter(function (model) {
	            return documentsIds.indexOf(model.get('id')) > -1;
	        }).forEach(function (model) {
	            var id = model.get('id');
	            (model.get('object').reviewers || [])
	                .filter(function (reviewer) {
	                    if (isByAdmin)
	                        return true;
	                    return reviewer.status === 'UNREVIEWED'
	                        || reviewer.status === 'IN_REVIEW'
	                        || reviewer.status === 'UNDER_REVIEW'
	                        || reviewer.status === 'DELETED';
	                })
	                .forEach(function (reviewer) {
	                    var reviewersUniqueValue = (reviewer.organizationId ? reviewer.organizationId : ' ') + delimeter
	                        + (reviewer.personId ? reviewer.personId : ' ') + delimeter
	                        + reviewer.mandatory + delimeter
	                        + reviewer.status;
	                    if (!resultData[reviewersUniqueValue]) {
	                        resultData[reviewersUniqueValue] = [id];
	                    } else {
	                        resultData[reviewersUniqueValue].push(id);
	                    }
	                });
	        });
	
	        return (_.keys(resultData) || []).map(function (key) {
	            var unparsed = key.split(delimeter);
	            var organizationId = unparsed[0].trim();
	            var personId = unparsed[1].trim();
	            var mandatory = unparsed[2].trim() == 'true' ? true : false;
	            var status = unparsed[3].trim();
	            return {
	                originalReviewer: {
	                    organizationId: organizationId,
	                    personId: personId,
	                    mandatory: mandatory,
	                    status: status
	                },
	                beingUpdatedReviewer: {
	                    organizationId: organizationId,
	                    personId: personId,
	                    mandatory: mandatory,
	                    status: status
	                },
	                documentsIds: resultData[key]
	            };
	        });
	    },
	
	    getReviewerNamesCombiner: function (documentsIds) {
	
	        var idAndNames = {};
	
	        this.collection.filter(function (model) {
	            return documentsIds.indexOf(model.get('id')) > -1;
	        }).forEach(function (model) {
	            var id = model.get('id');
	            (model.get('relations') || [])
	                .filter(function (relation) {
	                    return relation.child
	                        && relation.child.id
	                        && relation.child.name
	                        && (relation.systemRelationType === 'PERSON_REVIEW_FINISHED_REQUEST'
	                            || relation.systemRelationType === 'PERSON_REVIEW_REQUEST'
	                            || relation.systemRelationType === 'ORGANIZATION_REVIEW_REQUEST'
	                            || relation.systemRelationType === 'ORGANIZATION_REVIEW_FINISHED_REQUEST'
	                            || relation.systemRelationType === 'ORGANIZATION_REVIEW_DELETED'
	                            || relation.systemRelationType === 'PERSON_REVIEW_DELETED');
	                })
	                .map(function (relation) {
	                    return {
	                        id: relation.child.id,
	                        name: relation.child.name
	                    }
	                })
	                .forEach(function (row) {
	                    idAndNames[row.id] = row.name;
	                });
	        });
	
	        return function (id) {
	            return idAndNames[id];
	        };
	    },
	
	    addPatientModalShow: function (woResponseEvent) {
	        this.triggerMethod("document:patient:add", {docIds: this.documentsIds, woResponseEvent: woResponseEvent});
	    },
	
	    addAddendumModalShow: function (woResponseEvent) {
	        this.triggerMethod("document:add:addendum", {docIds: this.documentsIds, woResponseEvent: woResponseEvent});
	    },
	
	    setDueModalShow: function (woResponseEvent) {
	        this.triggerMethod("document:due:set", {docIds: this.documentsIds, woResponseEvent: woResponseEvent});
	    },
	
	    signModalShow: function (callback) {
	        var that = this;
	        var sended = that.documentsIds;
	
	        this.triggerMethod('sign:documents', {
	            ids: that.documentsIds.join(),
	            action: this.sendToServer,
	            fn: function (handledDocumentIds) {
	                console.log(handledDocumentIds);
	                window.setTimeout(function () {
	                    var received = (handledDocumentIds.split(",") || []).filter(function (item) {
	                        return item != '';
	                    });
	                    callback(received, _.difference(sended, received));
	                }, 0);
	            },
	            cancelAction: null
	        });
	    },
	
	    auditModalShow: function (woResponseEvent) {
	        this.triggerMethod("document:comment", {
	            docIds: this.documentsIds,
	            allFiltered: false,
	            woResponseEvent: woResponseEvent
	        });
	    },
	
	    auditBulkModalShow: function () {
	        var that = this;
	        this.triggerMethod("document:comment", {
	            docIds: this.documentsIds,
	            allFiltered: true,
	            params: utils.objectToQueryParams(that.params)
	        });
	    },
	
	    sendModalShow: function (woResponseEvent) {
	        this.triggerMethod("document:send", {
	            docIds: this.documentsIds,
	            allFiltered: false,
	            woResponseEvent: woResponseEvent
	        });
	    },
	
	    sendBulkModalShow: function () {
	        var that = this;
	        this.triggerMethod("document:send", {
	            docIds: this.documentsIds,
	            allFiltered: true,
	            params: utils.objectToQueryParams(that.params)
	        });
	    },
	
	    addAddendumModalShow: function (woResponseEvent) {
	        this.triggerMethod("document:add:addendum", {docIds: this.documentsIds, woResponseEvent: woResponseEvent});
	    },
	
	    markAsSentModalShow: function (woResponseEvent) {
	        this.triggerMethod("document:mark:as", {
	            docIds: this.documentsIds,
	            mode: "sent",
	            woResponseEvent: woResponseEvent
	        });
	    },
	
	    markAsDeliveredModalShow: function (woResponseEvent) {
	        this.triggerMethod("document:mark:as", {
	            docIds: this.documentsIds,
	            mode: "delivered",
	            woResponseEvent: woResponseEvent
	        });
	    },
	
	    exportModalShow: function (woResponseEvent) {
	        this.triggerMethod("document:export", {
	            docIds: this.documentsIds,
	            allFiltered: false,
	            woResponseEvent: woResponseEvent
	        });
	    },
	
	    exportBulkModalShow: function () {
	        var that = this;
	        this.triggerMethod("document:export", {
	            docIds: [],
	            allFiltered: true,
	            params: utils.objectToQueryParams(that.params)
	        });
	    },
	
	    timeFrameMonthly: function () {
	        var startOfMonth = new moment().startOf('month');
	        var endOfMonth = new moment().endOf("month");
	        this.timeFrame({
	            object_createdTime_from: startOfMonth.toDate().getTime(),
	            object_createdTime_to: endOfMonth.toDate().getTime()
	        }, []);
	    },
	
	    timeFrameWeekly: function () {
	        var startOfWeek = new moment().startOf('week');
	        var endOfWeek = new moment().endOf("week");
	        this.timeFrame({
	            object_createdTime_from: startOfWeek.toDate().getTime(),
	            object_createdTime_to: endOfWeek.toDate().getTime()
	        }, []);
	    },
	
	    timeFrameDaily: function () {
	        var startOfDay = new moment().startOf('day');
	        var endOfDay = new moment().endOf("day");
	        /*console.log(startOfDay);
	        console.log(endOfDay);
	        console.log(startOfDay.toDate());
	        console.log(endOfDay.toDate());
	        console.log(startOfDay.format("YYYY-DD-MM"));
	        console.log(endOfDay.format("YYYY-DD-MM"));*/
	        this.timeFrame({
	            object_createdTime_from: startOfDay.toDate().getTime(),
	            object_createdTime_to: endOfDay.toDate().getTime()
	        }, []);
	    },
	
	    timeFrameSelected: function () {
	        this.timeFrame({}, this.documentsIds);
	    },
	
	    timeFrame: function (extraParams, documentsIds) {
	        var that = this;
	        var params = utils.deepClone(that.params);
	        _.keys(extraParams).forEach(function (key) {
	            params[key] = extraParams[key];
	        });
	
	        var config = {
	            params: params,
	            url: '/api/document/export?' + utils.objectToQueryParams(params),
	            exportType: "csv",
	            documentIds: documentsIds,
	            userTimezoneOffsetInHours: new Date().getTimezoneOffset() / 60
	        };
	        console.log(config);
	
	        var form = document.createElement('form');
	        form.setAttribute('target', '_blank');
	        form.setAttribute('action', config.url);
	        form.setAttribute('method', 'post');
	        document.body.appendChild(form);
	
	        var input = document.createElement('input');
	        input.setAttribute('type', 'text');
	        input.setAttribute('name', "exportType");
	        input.setAttribute('value', decodeURIComponent(config.exportType));
	        form.appendChild(input);
	
	        var input2 = document.createElement('input');
	        input2.setAttribute('type', 'text');
	        input2.setAttribute('name', "documentIds");
	        input2.setAttribute('value', decodeURIComponent(config.documentIds.join(",")));
	        form.appendChild(input2);
	
	        var input3 = document.createElement('input');
	        input3.setAttribute('type', 'text');
	        input3.setAttribute('name', "userTimezoneOffsetInHours");
	        input3.setAttribute('value', decodeURIComponent(config.userTimezoneOffsetInHours));
	        form.appendChild(input3);
	
	        form.submit();
	
	        window.setTimeout(function () {
	            document.body.removeChild(form);
	        }, 0);
	    },
	
	    downloadFromAggregateReport: function () {
	        this.download();
	    },
	
	    printFromAggregateReport: function () {
	        this.print();
	    },
	
	    signModalShowFromAggregateReport: function (callback) {
	        this.signModalShow(callback);
	    },
	
	    assignModalShowFromAggregateReport: function () {
	        this.assignModalShow(true, true);
	    },
	
	    addPatientModalShowFromAggregateReport: function () {
	        this.addPatientModalShow(true);
	    },
	
	    addAddendumModalShowFromAggregateReport: function () {
	        this.addAddendumModalShow(true);
	    },
	
	    setDueModalShowFromAggregateReport: function () {
	        this.setDueModalShow(true);
	    },
	
	    auditModalShowFromAggregateReport: function () {
	        this.auditModalShow(true);
	    },
	
	    sendModalShowFromAggregateReport: function () {
	        this.sendModalShow(true);
	    },
	
	    markAsSentModalShowFromAggregateReport: function () {
	        this.markAsSentModalShow(true);
	    },
	
	    markAsDeliveredModalShowFromAggregateReport: function () {
	        this.markAsDeliveredModalShow(true);
	    },
	
	    refreshModel: function (data) {
	        var that = this;
	        var model = new DocumentModel({id: data.model.get('id')});
	        model.fetch({
	            success: function () {
	                var oldModel = that.collection.findWhere({id: model.get('id')});
	                var oldModelIndex = that.collection.indexOf(data.model);
	                var oldModelSelected = oldModel.get("selected");
	                model.set("selected", oldModelSelected);
	                that.collection.remove([oldModel]);
	                that.collection.add(model, {at: oldModelIndex});
	
	                if ((model.get('object').downloadedOrPreviewedSigners || []).filter(function (signer) {
	                        return signer == that.getOption('username');
	                    }).length > 0) {
	                    that.notPreviewedDocumentsIds = (that.notPreviewedDocumentsIds || []).filter(function (item) {
	                        return item !== model.get('id')
	                    });
	                    if (_.isEmpty(that.notPreviewedDocumentsIds)) {
	                        that.showDocumentNotPreviewedMessage('hide');
	                    }
	                }
	
	                if (that.documentsIds.length - that.notPreviewedDocumentsIds.length == 0 || that.notPreviewedDocumentsIds.length > 0) {
	                    that.disableSignButtons();
	                    //that.signDocsCallbackForPager.signDocuments = null;
	                } else {
	                    that.enableSignButtons();
	                    /*that.signDocsCallbackForPager.signDocuments = function (fn) {
	                        return that.signDocumentsBeforePageChanged(fn, that);
	                    };*/
	                }
	
	                if (that.documentsIds.length == 0) {
	                    that.signDocsCallbackForPager.signDocuments = null;
	                } else {
	                    that.signDocsCallbackForPager.signDocuments = function (fn) {
	                        return that.signDocumentsBeforePageChanged(fn, that);
	                    };
	                }
	
	                /*that.documentsIds = (that.documentsIds || []).filter(function (item) {
	                    return item !== model.get('id')
	                });*/
	            }
	        });
	    },
	
	    isPatientFilter: function (item) {
	        return item.object && item.object.isPatient;
	    },
	
	    isMdFilter: function (item) {
	        return item.object && item.object.isMd;
	    },
	
	    showPatientsSelect: function (defaultSelected) {
	        var that = this;
	
	        that.showChildView('patientsSelect', new RemoteSuggesterView({
	            multiSelect: true,
	            inputId: that.constants.documentPatient,
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
	            + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data.filter(that.isPatientFilter).filter(function (item) {
	                    return item.object && item.object.isPatient && item.object.mergeable === false;
	                });
	            },
	            getIdFn: function (element) {
	                return element.id;
	            },
	            getValueFn: function (element) {
	                return element.name ? element.name.toUpperCase() : element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Patient",
	            defaultSelected: defaultSelected
	        }));
	    },
	
	    showCreatedBySelect: function (defaultSelected) {
	        var that = this;
	
	        that.showChildView('createdBySelect', new RemoteSuggesterView({
	            multiSelect: true,
	            inputId: that.constants.createdBy,
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
	            + '&sortby=name&like_name=~~~&type=organization',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getIdFn: function (element) {
	                return element.id;
	            },
	            getValueFn: function (element) {
	                return element.name ? element.name.toUpperCase() : element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Requesting Organization",
	            defaultSelected: defaultSelected
	        }));
	    },
	
	    showAssignedToPersonsSelect: function (defaultSelected) {
	        var that = this;
	
	        that.showChildView('assignedToPersonsSelect', new RemoteSuggesterView({
	            multiSelect: true,
	            inputId: that.constants.personReviewRequest,
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
	            + '&sortby=name&like_name=~~~&type=person',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data.filter(that.isMdFilter);
	            },
	            getIdFn: function (element) {
	                return element.id;
	            },
	            getValueFn: function (element) {
	                return element.name ? element.name.toUpperCase() : element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Assigned Reviewer",
	            defaultSelected: defaultSelected
	        }));
	    },
	
	    showAssignedToOrganizationsSelect: function (defaultSelected) {
	        var that = this;
	
	        that.showChildView('assignedToOrganizationsSelect', new RemoteSuggesterView({
	            multiSelect: true,
	            inputId: that.constants.organizationReviewRequest,
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
	            + '&sortby=name&like_name=~~~&type=organization',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getIdFn: function (element) {
	                return element.id;
	            },
	            getValueFn: function (element) {
	                return element.name ? element.name.toUpperCase() : element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Assigned Organization",
	            defaultSelected: defaultSelected
	        }));
	    },
	
	    showSignedByPersonsSelect: function (defaultSelected) {
	        var that = this;
	
	        that.showChildView('signedByPersonsSelect', new RemoteSuggesterView({
	            multiSelect: true,
	            inputId: that.constants.personReviewFinishedRequest,
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
	            + '&sortby=name&like_name=~~~&type=person',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data.filter(that.isMdFilter);
	            },
	            getIdFn: function (element) {
	                return element.id;
	            },
	            getValueFn: function (element) {
	                return element.name ? element.name.toUpperCase() : element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Signed by Reviewer",
	            defaultSelected: defaultSelected
	        }));
	    },
	
	    showUploaderPersonsSelect: function (defaultSelected) {
	        var that = this;
	
	        that.showChildView('uploaderPersonsSelect', new RemoteSuggesterView({
	            multiSelect: true,
	            inputId: that.constants.documentUploaderPerson,
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
	            + '&sortby=name&like_name=~~~&type=person',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getIdFn: function (element) {
	                return element.id;
	            },
	            getValueFn: function (element) {
	                return element.name ? element.name.toUpperCase() : element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Uploader Person",
	            defaultSelected: defaultSelected
	        }));
	    },
	
	    showSignedByOrganizationsSelect: function (defaultSelected) {
	        var that = this;
	
	        that.showChildView('signedByOrganizationsSelect', new RemoteSuggesterView({
	            multiSelect: true,
	            inputId: that.constants.organizationReviewFinishedRequest,
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
	            + '&sortby=name&like_name=~~~&type=organization',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getIdFn: function (element) {
	                return element.id;
	            },
	            getValueFn: function (element) {
	                return element.name ? element.name.toUpperCase() : element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Signed by Organization",
	            defaultSelected: defaultSelected
	        }));
	    },
	
	    findSelectedIdBySelectedIndex: function (arr, index) {
	        return ((arr || [])[index] || {}).id;
	    },
	
	    findSelectedIdBySelectedValue: function (arr, value) {
	        var found = _.findWhere(arr, {name: value});
	        return found ? found.id : null;
	    },
	
	    onShowDocumentsStatistics: function () {
	        var that = this;
	        that.ui.documentsStatisticsModal.modal({backdrop: 'static', keyboard: false});
	        utils.showSpinner('#data-loader');
	
	        var callback = function () {
	            utils.hideSpinner('#data-loader');
	        };
	
	        that.initFilterParams();
	        delete (that.params["page"]);
	        delete (that.params["page-size"]);
	
	        $.when(
	            $.ajax({
	                type: "GET",
	                url: '/api/statistics/realtime/signers/documents/filtered?' + utils.objectToQueryParams(that.params)
	            })
	        ).then(
	            function (response) {
	                that.renderDocumentsStatisticsView(response, that.params);
	                callback();
	                $('.sending-method').tooltip();
	            },
	            function (error, text, status) {
	                callback();
	
	                if (error.status == 401) {
	                    that.ui.documentsStatisticsModal.modal('hide');
	                    $('body').removeClass('modal-open');
	                    $('.modal-backdrop').remove();
	                    actionsChannel.request("redirect:to:login");
	                } else if (error.status == 403) {
	                    notificationsChannel.request('show:notification',
	                        error.responseJSON.message);
	                } else {
	                    notificationsChannel.request('show:notification',
	                        'Error. Try later');
	                }
	            }
	        );
	    },
	
	    onStaticticsAggregate: function (aggregateParams) {
	        this.showDocumentsStatisticsAggregate(aggregateParams);
	    },
	
	    onShowDocumentsStatisticsAggregate: function () {
	        var params = $.deparam(window.location.hash.replace('#documents', '').replace('?', ''));
	        var aggregateParams = {};
	        _.each(params, function (val, key) {
	            if (key == 'aggregates' || key == 'contactTypes' || key == 'contactValue' || key == 'mdNameFrom' || key == 'mdNameTo' || key == 'orgNameFrom' || key == 'orgNameTo') {
	                aggregateParams[key] = val;
	            }
	        });
	        this.showDocumentsStatisticsAggregate(aggregateParams);
	    },
	
	    showDocumentsStatisticsAggregate: function (aggregateParams) {
	        var that = this;
	        that.ui.documentsStatisticsAggregateModal.modal({backdrop: 'static', keyboard: false});
	        utils.showSpinner('#data-loader-aggregate');
	
	        var callback = function () {
	            utils.hideSpinner('#data-loader-aggregate');
	        };
	
	        that.initFilterParams();
	        delete (this.params["page"]);
	        delete (this.params["page-size"]);
	
	        var extraParams = {};
	        _.each(this.params, function (val, key) {
	            if (key != 'aggregates' && key != 'contactTypes' && key != 'contactValue'
	                && key != 'mdNameFrom' && key != 'mdNameTo' && key != 'orgNameFrom' && key != 'orgNameTo') {
	                extraParams[key] = val;
	            }
	        });
	
	        $.when(
	            $.ajax({
	                type: "GET",
	                url: '/api/statistics/realtime/signers/documents/filtered/aggregated?' + utils.objectToQueryParams(_.extend(utils.deepClone(extraParams), aggregateParams))
	            })
	        ).then(
	            function (response) {
	                that.renderDocumentsStatisticsAggregateView(response, aggregateParams, extraParams || {});
	                callback();
	                $('.sending-method').tooltip();
	            },
	            function (error, text, status) {
	                callback();
	                if (error.status == 401) {
	                    that.ui.documentsStatisticsAggregateModal.modal('hide');
	                    $('body').removeClass('modal-open');
	                    $('.modal-backdrop').remove();
	                    actionsChannel.request("redirect:to:login");
	                } else if (error.status == 403) {
	                    notificationsChannel.request('show:notification',
	                        error.responseJSON.message);
	                } else {
	                    notificationsChannel.request('show:notification',
	                        'Error. Try later');
	                }
	            }
	        );
	    },
	
	    renderDocumentsStatisticsView: function (data, params) {
	
	
	        delete (params["ORGANIZATION_REVIEW_FINISHED_REQUEST"]);
	        delete (params["ORGANIZATION_REVIEW_REQUEST"]);
	        delete (params["ORGANIZATION_REVIEW_DELETED"]);
	        delete (params["PERSON_REVIEW_FINISHED_REQUEST"]);
	        delete (params["PERSON_REVIEW_REQUEST"]);
	        delete (params["PERSON_REVIEW_DELETED"]);
	        delete (params["object_status"]);
	
	        this.showChildView('documentsStatisticsRegion', new DocumentsStatisticsView({
	            data: data,
	            extraParamsAsString: utils.objectToQueryParams(params)
	        }));
	
	    },
	
	    renderDocumentsStatisticsAggregateView: function (data, aggregateParams, params) {
	
	        var that = this;
	
	        that.showChildView('documentsStatisticsAggregateRegion', new DocumentsStatisticsAggregateView({
	            data: data,
	            aggregateParams: aggregateParams,
	            extraParams: params,
	            getSelectedDocuments: function () {
	                return that.documentsIds;
	            }
	        }));
	
	        this.checkOrUncheckAllDocumentsInner(false);
	    },
	
	    onDocumentsSelectedInAggregateReport: function (docIds) {
	        var that = this;
	        docIds.forEach(function (docId) {
	            that.documentsIds.push(docId);
	        })
	        that.documentsIds = _.uniq(that.documentsIds);
	        console.log("onDocumentsSelectedInAggregateReport");
	        console.log(that.documentsIds);
	    },
	
	    onDocumentsUnselectedInAggregateReport: function (docIds) {
	        var that = this;
	        that.documentsIds = (that.documentsIds || []).filter(function (id) {
	            var found = _.find(docIds, function (docId) {
	                return docId == id;
	            });
	            return !found;
	        });
	        that.documentsIds = _.uniq(that.documentsIds);
	        console.log("onDocumentsUnselectedInAggregateReport");
	        console.log(that.documentsIds);
	    },
	
	    onSetAsInitialViewSortingReportForMe: function () {
	        this.getChildView('documentsStatisticsAggregateRegion').setAsInitialView();
	    },
	
	    onSetAsInitialViewSortingReport: function () {
	        console.log("onSetAsInitialViewSortingReport");
	        var url = this.getChildView('documentsStatisticsAggregateRegion').getUrlAsInitialView();
	        console.log(url);
	
	        this.setInitialViewModalView = new SetInitialViewModalView();
	        this.showChildView('setInitialViewModal', this.setInitialViewModalView);
	        this.setInitialViewModalView.show(url);
	    },
	
	    onSort: function (event) {
	        this.params["sortby"] = event.target.id;
	        if ($(event.target).children('div').hasClass('glyphicon-triangle-bottom')) {
	            this.params["sortdir"] = "ASC";
	        } else {
	            this.params["sortdir"] = "DESC";
	        }
	
	        this.params.page = 0;
	        window.location.hash = utils.getCleanBaseHash() + "?" + utils.objectToQueryParams(this.params);
	    },
	
	    signDocumentsBeforePageChanged: function (fn, that) {
	
	        that.ui.signBeforeLeaveConfirmationSignButton.on('click', function (event) {
	            that.ui.signBeforeLeaveConfirmationModal.modal('hide');
	            that.signDocuments(fn, fn);
	            that.signDocsCallbackForPager.signDocuments = null;
	        });
	
	        that.ui.signBeforeLeaveConfirmationCancelButton.on('click', function (event) {
	            that.ui.signBeforeLeaveConfirmationModal.modal('hide');
	            fn();
	        });
	
	        that.ui.signBeforeLeaveConfirmationCloseButton.on('click', function (event) {
	            that.ui.signBeforeLeaveConfirmationModal.modal('hide');
	        });
	        that.ui.signBeforeLeaveConfirmationSignButton.hide();
	
	        that.ui.signBeforeLeaveConfirmationModal.modal({backdrop: 'static', keyboard: false});
	    }
	});
	
	module.exports = DocumentsListView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	
	var DocumentsCollection = BaseCollection.extend({
	    url:"/api/document/preview",
	
	    initialize: function(models, options){
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    }
	});
	
	
	module.exports = DocumentsCollection;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var Constants = __webpack_require__(195);
	var CommonUtils = __webpack_require__(189);
	
	var DocumentsStatisticsView = Marionette.View.extend({
	    template: __webpack_require__(304),
	
	    modelEvents: {
	        change: 'render'
	    },
	
	    ui: {
	        header: '.sort-header',
	        sendingMethod: '#sending-method',
	        mdNameFrom: '#md-name-from',
	        mdNameTo: '#md-name-to',
	        orgNameFrom: '#org-name-from',
	        orgNameTo: '#org-name-to',
	        filterField: '.filter-field',
	
	        contactPopover: '.contact-popover',
	
	        contactValueInput: '.contact-value-input',
	
	        signedMdTotal: '#signed-md-total',
	        pendingMdTotal: '#pending-md-total'
	    },
	
	    events: {
	        'click @ui.header': 'headerSorting',
	        'change @ui.filterField': 'onFilterFieldChanged',
	        'click #sending-method a': 'onSelectSendingMethod',
	        'keyup @ui.contactValueInput': 'onContactValueInputKeyUp'
	    },
	
	    initialize: function (options) {
	        //_.bindAll(this, 'onRender', 'getSortedOrgPersons', 'headerSorting', 'onFilterFieldChanged', 'onSelectSendingMethod', 'filter');
	        this.utils = new CommonUtils();
	
	        this.selectedSendingMethods = [];
	        this.sendingMethods = this.utils.getContactTypes();
	        this.sendingMethodsState = _.keys(this.sendingMethods).map(function (method) {
	            return {
	                method: 'notActive'
	            }
	        });
	
	        this.data = options.data;
	        this.extraParamsAsString = options.extraParamsAsString;
	        var initSortField = 'pending';
	        var initSortDirection = 'desc';
	        this.model = new Backbone.Model({
	            orgperson: this.getSortedOrgPersons(initSortField, initSortDirection == 'desc' ? true : false, true),
	            activeSort: initSortField,
	            sortDirection: initSortDirection,
	            mdNameFrom: "A",
	            mdNameTo: "Z",
	            orgNameFrom: "A",
	            orgNameTo: "Z",
	            contactValue: ''
	        });
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            orgSignedDocumentsLink: function (id) {
	                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	                    + '&ORGANIZATION_REVIEW_FINISHED_REQUEST=' + id + '&object_status=SIGNED&object_status=VIEWED' + (_.isEmpty(that.extraParamsAsString) ? '' : '&' + that.extraParamsAsString);
	            },
	            orgPendingDocumentsLink: function (id) {
	                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	                    + '&ORGANIZATION_REVIEW_REQUEST=' + id + '&object_status=IN_REVIEW' + (_.isEmpty(that.extraParamsAsString) ? '' : '&' + that.extraParamsAsString);
	            },
	            personSignedDocumentsLink: function (orgId, id) {
	                var result = '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	                    + '&PERSON_REVIEW_FINISHED_REQUEST=' + id + '&object_status=SIGNED&object_status=VIEWED' + (_.isEmpty(that.extraParamsAsString) ? '' : '&' + that.extraParamsAsString);
	                if (orgId != 'null') {
	                    result += '&ORGANIZATION_REVIEW_FINISHED_REQUEST=' + orgId;
	                }
	                return result;
	            },
	            personPendingDocumentsLink: function (orgId, id) {
	                var result = '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	                    + '&PERSON_REVIEW_REQUEST=' + id + '&object_status=IN_REVIEW' + (_.isEmpty(that.extraParamsAsString) ? '' : '&' + that.extraParamsAsString);
	                if (orgId != 'null') {
	                    result += '&ORGANIZATION_REVIEW_REQUEST=' + orgId;
	                }
	                return result;
	            },
	            transformSendingMethods: function (sendingMethods) {
	                var groupedBySendingMethods = _.groupBy(sendingMethods, function (method) {
	                    return method;
	                });
	                return _.keys(groupedBySendingMethods).map(function (method) {
	                    return {
	                        methodName: method,
	                        count: (groupedBySendingMethods[method] || []).length > 1 ? groupedBySendingMethods[method].length : ''
	                    }
	                });
	            },
	            sendingMethods: that.sendingMethods,
	            sendingMethodsState: that.sendingMethodsState,
	            upperCaseChars: that.utils.getUpperCaseCharsList(),
	            getContacts: function (contacts, type) {
	                return (contacts || []).filter(function (contact) {
	                    return contact.type == type;
	                }).map(function (contact) {
	                    return contact.data;
	                })
	            }
	        }
	    },
	
	    onRender: function () {
	        this.ui.contactPopover.popover();
	        this.ui.contactPopover.on('shown.bs.popover', function () {
	            var thisPopover = $(this);
	            $('.popover-content').css({color: '#000', 'font-size': '12px;'});
	
	            setTimeout(function () {
	                thisPopover.popover('hide');
	            }, 4000);
	        });
	
	        this.renderTotals();
	    },
	
	    getSortedOrgPersons: function (sortBy, reverseSort, beforeRender) {
	        var that = this;
	
	        var orgs = (that.data.orgperson || []).filter(function (orgStat) {
	            return orgStat.pending + orgStat.signed > 0;
	        });
	
	        (orgs || []).forEach(function (orgStat) {
	            if (orgStat.title)
	                orgStat.title = orgStat.title.toUpperCase();
	            else
	                orgStat.title = "";
	        });
	
	        var orgNameFrom = beforeRender ? "A" : (that.model.get('orgNameFrom') || "A");
	        var orgNameTo = beforeRender ? "Z" : (that.model.get('orgNameTo') || "Z");
	        var orgContactValue = beforeRender ? "" : that.utils.normalizeContact((that.model.get('contactValue') || ""));
	
	        orgs = orgs.filter(function (org) {
	            return (that.selectedSendingMethods.length == 0
	                || _.chain(that.selectedSendingMethods)
	                    .map(function (method) {
	                        return _.contains(org.sendingMethods, method);
	                    })
	                    .reduce(function (acc, value) {
	                        return acc || value;
	                    }, false)
	                    .value())
	                && (typeof org.title === "undefined" || org.title == null || org.title[0] >= orgNameFrom && org.title[0] <= orgNameTo)
	                && (orgContactValue === "" || that.isHasContact(org.contacts || [], orgContactValue))
	                || !org.title;
	        });
	
	        var sortedOrgs = _.sortBy(orgs || [], function (item) {
	            return item[sortBy];
	        });
	
	        if (reverseSort)
	            sortedOrgs = sortedOrgs.reverse();
	
	        /*var nullOrgs = sortedOrgs.filter(function (org) {
	         return org.id === 'null';
	         });
	         sortedOrgs = sortedOrgs.filter(function (org) {
	         return org.id !== 'null';
	         });
	         if (nullOrgs.length > 0) {
	         sortedOrgs.unshift(nullOrgs[0]);
	         }*/
	
	        sortedOrgs.forEach(function (orgStat) {
	            orgStat.personsList = [];
	            for (personId in orgStat.itemsMap) {
	                if (orgStat.itemsMap[personId].pending + orgStat.itemsMap[personId].signed > 0
	                    && orgStat.itemsMap[personId].id != null && orgStat.itemsMap[personId].id != 'null') {
	                    orgStat.personsList.push(orgStat.itemsMap[personId]);
	                }
	            }
	
	            orgStat.personsList.forEach(function (personStat) {
	                if (personStat.title)
	                    personStat.title = personStat.title.toUpperCase();
	            });
	
	            var mdNameFrom = beforeRender ? "A" : (that.model.get('mdNameFrom') || "A");
	            var mdNameTo = beforeRender ? "Z" : (that.model.get('mdNameTo') || "Z");
	            var mdContactValue = beforeRender ? "" : that.utils.normalizeContact((that.model.get('contactValue') || ""));
	
	            orgStat.personsList = orgStat.personsList.filter(function (person) {
	                return (that.selectedSendingMethods.length == 0
	                    || _.chain(that.selectedSendingMethods)
	                        .map(function (method) {
	                            return _.contains(person.sendingMethods, method);
	                        })
	                        .reduce(function (acc, value) {
	                            return acc || value;
	                        }, false)
	                        .value())
	                    && (person.title || "")[0] >= mdNameFrom && (person.title || "")[0] <= mdNameTo
	                    && (mdContactValue === "" || that.isHasContact(person.contacts || [], mdContactValue));
	            });
	
	            orgStat.personsList = _.sortBy(orgStat.personsList, function (item) {
	                return item[sortBy];
	            });
	
	            if (reverseSort)
	                orgStat.personsList = orgStat.personsList.reverse();
	
	        });
	
	        sortedOrgs = sortedOrgs.filter(function (orgStat) {
	            var contactValue = beforeRender ? "" : that.utils.normalizeContact((that.model.get('contactValue') || ""));
	            var orgIsNotEmpty = orgStat.personsList.length > 0;
	            var orgIsInDeliveryMethodFilter =
	                that.selectedSendingMethods.length == 0 ||
	                _.chain(that.selectedSendingMethods)
	                    .map(function (method) {
	                        return _.contains(orgStat.sendingMethods, method);
	                    })
	                    .reduce(function (acc, value) {
	                        return acc || value;
	                    }, false)
	                    .value();
	            var orgIsInFaxFilter = contactValue === "" ||
	                (orgStat.personsList.length == 0 && that.isHasContact(orgStat.contacts || [], contactValue));
	
	            return orgIsNotEmpty || (orgIsInDeliveryMethodFilter && orgIsInFaxFilter);
	        });
	
	        return sortedOrgs;
	    },
	
	    headerSorting: function (event) {
	        var sortField = event.target.id;
	        if (this.model.get('activeSort') != sortField) {
	            this.model.set('sortDirection', 'asc');
	            this.model.set('activeSort', sortField);
	        }
	        else if (this.model.get('activeSort') == sortField) {
	            if (this.model.get('sortDirection') == 'desc')
	                this.model.set('sortDirection', 'asc');
	            else
	                this.model.set('sortDirection', 'desc');
	        }
	
	        this.model.set('orgperson', this.getSortedOrgPersons(sortField, this.model.get('sortDirection') == 'desc' ? true : false));
	    },
	
	    onFilterFieldChanged: function (event) {
	        var jqElement = $(event.target);
	        this.model.set(jqElement.attr("name"), jqElement.val());
	        this.filter();
	    },
	
	    onSelectSendingMethod: function (event) {
	        var target = $(event.target);
	        var value = target.data('title');
	        var isActive = target.hasClass('active');
	
	        if (!isActive) {
	            target.removeClass('notActive').addClass('active');
	            this.sendingMethodsState[value] = 'active';
	            this.selectedSendingMethods.push(value);
	        } else {
	            target.removeClass('active').addClass('notActive');
	            this.sendingMethodsState[value] = 'notActive';
	            this.selectedSendingMethods = _.reject(this.selectedSendingMethods, function (method) {
	                return method == value;
	            });
	        }
	
	        this.filter();
	    },
	
	    onContactValueInputKeyUp: function (event) {
	        if (event.keyCode == 13 && event.target.value.length > 2 || _.isEmpty(event.target.value)) {
	            var jqEl = $(event.target);
	            this.model.set(jqEl.attr('name'), event.target.value);
	            this.filter();
	        }
	    },
	
	    filter: function () {
	        this.model.set('orgperson',
	            this.getSortedOrgPersons(this.model.get('activeSort'),
	                this.model.get('sortDirection') == 'desc' ? true : false));
	        this.model.set('stateUuid', this.utils.generatedUUID());
	    },
	
	    isHasContact: function (contacts, searched) {
	        var that = this;
	        if (_.isEmpty(contacts))
	            return false;
	        return _.chain(contacts)
	            .map(function (contact) {
	                return that.utils.normalizeContact(contact.data || "").indexOf(that.utils.normalizeContact(searched)) > -1;
	            })
	            .reduce(function (acc, value) {
	                return acc || value;
	            }, false)
	            .value();
	    },
	
	    renderTotals: function () {
	        var orgPersons = this.model.get('orgperson');
	        var signedCount = 0;
	        var pendingCount = 0;
	        /*_.chain(orgPersons).map(function (orgPerson) {
	            return orgPerson.personsList;
	        }).flatten().each(function (person) {
	            signedCount = signedCount + person.signed;
	            pendingCount = pendingCount + person.pending;
	        });*/
	        _.chain(orgPersons).each(function (org) {
	            signedCount = signedCount + org.signed;
	            pendingCount = pendingCount + org.pending;
	        });
	        this.ui.signedMdTotal.text(signedCount);
	        this.ui.pendingMdTotal.text(pendingCount);
	    }
	});
	
	
	module.exports = DocumentsStatisticsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="well" style="font-size: 12px;">\r\n    <div class="form form-inline">\r\n        <div class="form-group">\r\n            <label class="control-label" for="org-name-from">Org name: </label>\r\n            <select id="org-name-from" name="orgNameFrom" class="form-control input-sm filter-field" style="width:auto;">\r\n                ';
	 _.each(upperCaseChars, function(ucc) { 
	__p+='\r\n                ';
	 if (ucc == orgNameFrom) { 
	__p+='\r\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'" selected> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\r\n                ';
	 } else { 
	__p+='\r\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'"> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\r\n                ';
	 } 
	__p+='\r\n                ';
	 }) 
	__p+='\r\n            </select>\r\n            <label class="control-label" for="org-name-to">-</label>\r\n            <select id="org-name-to" name="orgNameTo" class="form-control input-sm filter-field" style="width:auto;">\r\n                ';
	 _.each(upperCaseChars, function(ucc) { 
	__p+='\r\n                ';
	 if (ucc == orgNameTo) { 
	__p+='\r\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'" selected> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\r\n                ';
	 } else { 
	__p+='\r\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'"> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\r\n                ';
	 } 
	__p+='\r\n                ';
	 }) 
	__p+='\r\n            </select>\r\n            <label class="control-label" for="md-name-from" style="margin-left: 20px;">MD name: </label>\r\n            <select id="md-name-from" name="mdNameFrom" class="form-control input-sm filter-field" style="width:auto;">\r\n                ';
	 _.each(upperCaseChars, function(ucc) { 
	__p+='\r\n                ';
	 if (ucc == mdNameFrom) { 
	__p+='\r\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'" selected> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\r\n                ';
	 } else { 
	__p+='\r\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'"> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\r\n                ';
	 } 
	__p+='\r\n                ';
	 }) 
	__p+='\r\n            </select>\r\n            <label class="control-label" for="md-name-to">-</label>\r\n            <select id="md-name-to" name="mdNameTo" class="form-control input-sm filter-field" style="width:auto;">\r\n                ';
	 _.each(upperCaseChars, function(ucc) { 
	__p+='\r\n                ';
	 if (ucc == mdNameTo) { 
	__p+='\r\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'" selected> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\r\n                ';
	 } else { 
	__p+='\r\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'"> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\r\n                ';
	 } 
	__p+='\r\n                ';
	 }) 
	__p+='\r\n            </select>\r\n            <label class="control-label" for="contact-value" style="margin-left: 20px;">Contact Value: </label>\r\n            <input type="text" class="form-control contact-value-input" id="contact-value" name="contactValue" style="min-width: 260px !important;"\r\n                   placeholder="Type at least 3 characters and Press Enter" value="'+
	((__t=( contactValue ))==null?'':__t)+
	'"/>\r\n        </div>\r\n    </div>\r\n\r\n    <div class="btn-group" id="sending-method" style="display: list-item; margin-left: auto; margin-right: auto; width: 60%;">\r\n        ';
	 _.each(_.keys(sendingMethods), function(method){ 
	__p+='\r\n        <a class="btn btn-primary btn-sm '+
	((__t=( sendingMethodsState[method] ))==null?'':__t)+
	'" data-title="'+
	((__t=( method ))==null?'':__t)+
	'">'+
	((__t=( sendingMethods[method] ))==null?'':__t)+
	'</a>\r\n        ';
	 }) 
	__p+='\r\n    </div>\r\n\r\n</div>\r\n<hr>\r\n<div class="col-md-12 col-xs-12 row bold">\r\n    <div class="col-md-3 col-xs-3 col-md-offset-2 col-xs-offset-2">\r\n        Total (by reviewer):\r\n    </div>\r\n    <div class="col-md-2 col-xs-2" id="signed-md-total"></div>\r\n    <div class="col-md-2 col-xs-2" id="pending-md-total"></div>\r\n</div>\r\n\r\n<div class="form form-horizontal" style="margin-left: 18px;">\r\n    <div class="col-md-12 col-xs-12 row stat-row">\r\n        <div class="col-md-5 col-xs-5 clickable sort-header\r\n            ';
	 if (activeSort == 'title' && sortDirection == 'asc') { 
	__p+=' active-sort-header glyphicon glyphicon-triangle-top\r\n                ';
	 } else if (activeSort == 'title' && sortDirection == 'desc') { 
	__p+=' active-sort-header glyphicon glyphicon-triangle-bottom ';
	 } 
	__p+='"\r\n             id="title" title="Sort"> Organization</div>\r\n        <div class="col-md-2 col-xs-2 clickable sort-header\r\n            ';
	 if (activeSort == 'signed' && sortDirection == 'asc') { 
	__p+=' active-sort-header glyphicon glyphicon-triangle-top\r\n                ';
	 } else if (activeSort == 'signed' && sortDirection == 'desc') { 
	__p+=' active-sort-header glyphicon glyphicon-triangle-bottom ';
	 } 
	__p+='"\r\n             id="signed" title="Sort"> Signed</div>\r\n        <div class="col-md-2 col-xs-2 clickable sort-header\r\n            ';
	 if (activeSort == 'pending' && sortDirection == 'asc') { 
	__p+=' active-sort-header glyphicon glyphicon-triangle-top\r\n                ';
	 } else if (activeSort == 'pending' && sortDirection == 'desc') { 
	__p+=' active-sort-header glyphicon glyphicon-triangle-bottom ';
	 } 
	__p+='"\r\n             id="pending" title="Sort"> Pending</div>\r\n        <div class="col-md-3 col-xs-3">Preferred Contact Method</div>\r\n    </div>\r\n\r\n    ';
	 _.each(orgperson, function(node, index) { 
	__p+='\r\n    <div class="col-md-12 col-xs-12 row stat-row">\r\n        <div class="col-md-5 col-xs-5">\r\n            <b><a href="/#organization/'+
	((__t=( node.id ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( node.title ))==null?'':__t)+
	'</a></b>\r\n        </div>\r\n        <div class="col-md-2 col-xs-2">\r\n            ';
	 if (node.id ==='null'){ 
	__p+='\r\n            '+
	((__t=( node.signed ))==null?'':__t)+
	'\r\n            ';
	 } else { 
	__p+='\r\n            <a href="'+
	((__t=( orgSignedDocumentsLink(node.id) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( node.signed ))==null?'':__t)+
	'</a>\r\n            ';
	 } 
	__p+='\r\n        </div>\r\n        <div class="col-md-2 col-xs-2">\r\n            ';
	 if (node.id ==='null'){ 
	__p+='\r\n            '+
	((__t=( node.pending ))==null?'':__t)+
	'\r\n            ';
	 } else { 
	__p+='\r\n            <a href="'+
	((__t=( orgPendingDocumentsLink(node.id) ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( node.pending ))==null?'':__t)+
	'</a>\r\n            ';
	 } 
	__p+='\r\n        </div>\r\n        <div class="col-md-3 col-xs-3">\r\n            ';
	 (transformSendingMethods(node.sendingMethods) || []).forEach(function(method){ 
	__p+='\r\n            <span class="badge badge-info">\r\n                ';
	 if (method.methodName === 'EMAIL') { 
	__p+=' <span title="Email"><span class="glyphicon glyphicon-envelope tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
	((__t=( (getContacts(node.contacts, 'EMAIL') || []).join(',\n') ))==null?'':__t)+
	'"></span></span>\r\n                ';
	 } else  if (method.methodName === 'FAX') {  
	__p+=' <span title="Fax"><span class="glyphicon glyphicon-print tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
	((__t=( (getContacts(node.contacts, 'FAX') || []).join(',\n') ))==null?'':__t)+
	'"></span></span>\r\n                ';
	 } else  if (method.methodName === 'PHONE'){ 
	__p+=' <span title="Phone"><span class="glyphicon glyphicon-earphone tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
	((__t=( (getContacts(node.contacts, 'PHONE') || []).join(',\n') ))==null?'':__t)+
	'"></span></span>\r\n                ';
	 } else if (method.methodName === 'REVIEW_AND_SIGN') {  
	__p+=' <span title="Review and sign"><span class="glyphicon glyphicon-home tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
	((__t=( (getContacts(node.contacts, 'REVIEW_AND_SIGN') || []).join(',\n') ))==null?'':__t)+
	'"></span></span>\r\n                ';
	 } else if (method.methodName === 'HAND_DELIVERY') { 
	__p+=' <span title="Hand Delivery"><span class="glyphicon glyphicon-hd-video tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
	((__t=( (getContacts(node.contacts, 'HAND_DELIVERY') || []).join(',\n') ))==null?'':__t)+
	'"></span></span>\r\n                ';
	 } else if (method.methodName === 'MEDICITY') {  
	__p+=' <span title="Direct Messaging"><span class="tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
	((__t=( (getContacts(node.contacts, 'MEDICITY') || []).join(',\n') ))==null?'':__t)+
	'">XDR</span></span>\r\n                ';
	 } else { 
	__p+=' <span>'+
	((__t=( method.methodName ))==null?'':__t)+
	'</span> ';
	 } 
	__p+='\r\n                '+
	((__t=( method.count ))==null?'':__t)+
	'\r\n            </span>\r\n            ';
	 }) 
	__p+='\r\n        </div>\r\n    </div>\r\n\r\n    ';
	 _.each(node.personsList, function(personStat, index) { 
	__p+='\r\n    <div class="col-md-12 col-xs-12 row person-stat-row">\r\n        <div class="col-md-4 col-xs-4 col-md-offset-1 col-xs-offset-1">\r\n            ';
	 if (personStat.duplicated) { 
	__p+='\r\n            <span class="glyphicon glyphicon-duplicate duplicate-icon" title="Appears in another organization"></span>\r\n            ';
	 } 
	__p+='\r\n            <a href="/#person/'+
	((__t=( personStat.id ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( personStat.title ))==null?'':__t)+
	'</a>\r\n        </div>\r\n        <div class="col-md-2 col-xs-2">\r\n            <a href="'+
	((__t=( personSignedDocumentsLink(node.id, personStat.id) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( personStat.signed ))==null?'':__t)+
	'</a>\r\n        </div>\r\n        <div class="col-md-2 col-xs-2">\r\n            <a href="'+
	((__t=( personPendingDocumentsLink(node.id, personStat.id) ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( personStat.pending ))==null?'':__t)+
	'</a>\r\n        </div>\r\n        <div class="col-md-3 col-xs-3">\r\n            ';
	 (transformSendingMethods(personStat.sendingMethods) || []).forEach(function(method){ 
	__p+='\r\n            <span class="badge badge-info">\r\n                ';
	 if (method.methodName === 'EMAIL') { 
	__p+=' <span title="Email"><span class="glyphicon glyphicon-envelope tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
	((__t=( (getContacts(personStat.contacts, 'EMAIL') || []).join(',\n') ))==null?'':__t)+
	'"></span></span>\r\n                ';
	 } else  if (method.methodName === 'FAX') {  
	__p+=' <span title="Fax"><span class="glyphicon glyphicon-print tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
	((__t=( (getContacts(personStat.contacts, 'FAX') || []).join(',\n') ))==null?'':__t)+
	'"></span></span>\r\n                ';
	 } else  if (method.methodName === 'PHONE'){ 
	__p+=' <span title="Phone"><span class="glyphicon glyphicon-earphone tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
	((__t=( (getContacts(personStat.contacts, 'PHONE') || []).join(',\n') ))==null?'':__t)+
	'"></span></span>\r\n                ';
	 } else if (method.methodName === 'REVIEW_AND_SIGN') {  
	__p+=' <span title="Review and sign"><span class="glyphicon glyphicon-home tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
	((__t=( (getContacts(personStat.contacts, 'REVIEW_AND_SIGN') || []).join(',\n') ))==null?'':__t)+
	'"></span></span>\r\n                ';
	 } else if (method.methodName === 'HAND_DELIVERY') { 
	__p+=' <span title="Hand Delivery"><span class="glyphicon glyphicon-hd-video tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
	((__t=( (getContacts(personStat.contacts, 'HAND_DELIVERY') || []).join(',\n') ))==null?'':__t)+
	'"></span></span>\r\n                ';
	 } else if (method.methodName === 'MEDICITY') {  
	__p+=' <span title="Direct Messaging"><span class="tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
	((__t=( (getContacts(personStat.contacts, 'MEDICITY') || []).join(',\n') ))==null?'':__t)+
	'">XDR</span></span>\r\n                ';
	 } else { 
	__p+=' <span>'+
	((__t=( method.methodName ))==null?'':__t)+
	'</span> ';
	 } 
	__p+='\r\n                '+
	((__t=( method.count ))==null?'':__t)+
	'\r\n            </span>\r\n            ';
	 }) 
	__p+='\r\n        </div>\r\n    </div>\r\n    ';
	 }) 
	__p+='\r\n    ';
	 }) 
	__p+='\r\n\r\n\r\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var Constants = __webpack_require__(195);
	var CommonUtils = __webpack_require__(189);
	var Dicts = __webpack_require__(193);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var DocumentsStatisticsAggregateView = Marionette.View.extend({
	    template: __webpack_require__(306),
	
	    modelEvents: {
	        change: 'render'
	    },
	
	    ui: {
	        sendingMethod: '#sending-method',
	        contactValueInput: '#contact-value',
	        letterRangeFilterField: '.letter-range-filter-field',
	
	        aggregates: "#aggregates",
	        applyAggregates: '#apply-aggregates',
	
	        selectDoc: '.doc-select',
	        docGroupSelect: '.doc-group-select',
	        actionBtn: '.action-btn'
	    },
	
	    events: {
	        'click #sending-method a': 'selectSendingMethod',
	        'click .contact-type': 'onContactTypeChanged',
	        'change @ui.contactValueInput': 'onContactValueChanged',
	        'change @ui.letterRangeFilterField': 'onChangeLetterRangeFilterField',
	        'click @ui.applyAggregates': 'onApplyAggregates',
	        "click @ui.selectDoc": 'onDocumentSelected',
	        "click @ui.docGroupSelect": 'onChildDocumentsSelected',
	
	        'click #agg-stat-download': 'onDownload',
	        'click #agg-stat-print': 'onPrint',
	        'click #agg-sign-all': 'onSign',
	        'click #agg-addendum': 'onAddAddendum',
	        'click #agg-stat-assign': 'onAssign',
	        'click #agg-stat-add-patient': 'onAddPatient',
	        'click #agg-stat-set-due': 'onSetDue',
	        'click #agg-stat-audit': 'onAudit',
	        'click #agg-stat-send': 'onSend',
	        'click #agg-stat-mark-as-sent': 'onMarkAsSent',
	        'click #agg-stat-mark-as-delivered': 'onMarkAsDelivered',
	        'click #agg-stat-open-selected': 'onOpenSelectedDocuments',
	
	        'click .expand-collapse-all': 'onExpandOrCollapse'
	    },
	
	    initialize: function (options) {
	
	        var that = this;
	
	        _.bindAll(this, 'onRender', 'onApplyAggregates', 'getAggregateTypes', 'getSelectedAggregates', 'getSelectedAggregatesNames',
	            'getSelectedAggregatesCaptions', 'nodeNameOrAsLink', 'nodeId', 'nodeNameIsNoValue', 'documentsLink',
	            'signedLink', 'pendingLink', 'viewedLink', 'unreviewedLink', 'deletedLink', 'underReviewLink', 'totalLink',
	            'getChildrenValues', 'onDocumentSelected');
	
	        that.utils = new CommonUtils();
	
	        that.contactTypes = that.utils.getContactTypes();
	
	        that.data = options.data;
	        that.aggregateParams = options.aggregateParams;
	        console.log(that.aggregateParams);
	        that.extraParams = options.extraParams;
	        console.log(that.extraParams);
	
	        that.extraParamsAsString = that.extraParamsToString();
	        that.getSelectedDocuments = options.getSelectedDocuments;
	
	        that.selectedSendingMethods = that.aggregateParams["contactTypes"] || [];
	        that.sendingMethodsState = {}
	        _.keys(that.contactTypes).forEach(function (method) {
	            that.sendingMethodsState[method] = (_.contains(that.selectedSendingMethods, method) ? 'active' : 'notActive');
	        });
	
	        this.model = new Backbone.Model({
	            tree: {
	                children: that.data
	            }
	        });
	
	        this.noValue = 'NO VALUE';
	        this.filtersChanged = false;
	
	        this.initTitleCaptions();
	    },
	
	    templateContext: function () {
	        var that = this;
	
	        return {
	            transformSendingMethods: function (contactTypes) {
	                var groupedBySendingMethods = _.groupBy(contactTypes, function (method) {
	                    return method;
	                });
	                return _.keys(groupedBySendingMethods).map(function (method) {
	                    return {
	                        methodName: method,
	                        count: (groupedBySendingMethods[method] || []).length > 1 ? groupedBySendingMethods[method].length : ''
	                    }
	                });
	            },
	            contactTypes: that.contactTypes,
	            sendingMethodsState: that.sendingMethodsState,
	            upperCaseChars: that.utils.getUpperCaseCharsList(),
	            orgNameFrom: that.aggregateParams["orgNameFrom"],
	            orgNameTo: that.aggregateParams["orgNameTo"],
	            mdNameFrom: that.aggregateParams["mdNameFrom"],
	            mdNameTo: that.aggregateParams["mdNameTo"],
	            contactValue: that.aggregateParams["contactValue"],
	
	            aggregatesList: that.getSelectedAggregates(),
	            aggregatesNamesList: that.getSelectedAggregatesNames(),
	            aggregatesCaptionsList: that.getSelectedAggregatesCaptions(),
	
	            getChildrenValues: that.getChildrenValues,
	            nodeNameOrAsLink: that.nodeNameOrAsLink,
	            nodeId: that.nodeId,
	            nodeNameIsNoValue: that.nodeNameIsNoValue,
	
	            pendingLink: that.pendingLink,
	            signedLink: that.signedLink,
	            viewedLink: that.viewedLink,
	            unreviewedLink: that.unreviewedLink,
	            deletedLink: that.deletedLink,
	            underReviewLink: that.underReviewLink,
	            totalLink: that.totalLink,
	
	            generateCollapseId: function (node, order, indexes) {
	                var fieldName = that.getSelectedAggregates()[order];
	                var id = node[fieldName];
	                if (id == that.noValue)
	                    return fieldName + _.allKeys(node.children).slice(1, 5).map(function (key) {
	                        return key.replace(" ", "").replace(".", "").replace(/\//g, "");
	                    }).join("-").replace(/\s/g, "").replace(/\./g, "").replace(/,/g, "").replace(/@/g, "") + order + "-" + indexes.join('-');
	                else
	                    return id.replace(/\s/g, "").replace(/\./g, "").replace(/,/g, "").replace(/@/g, "") + order + "-" + indexes.join('-');
	            }
	        }
	    },
	
	    onRender: function () {
	        var that = this;
	
	        that.ui.aggregates.selectize({
	            plugins: ['remove_button'],
	            inputClass: 'form-control selectize-input normal-width selectized',
	            placeholder: 'Add Aggregates (max 3), implicitly always last aggregate is "Document Name"',
	            valueField: 'value',
	            labelField: 'name',
	            options: that.getAggregateTypes().filter(function (type) {
	                return type.value != "DOCUMENT";
	            }),
	            items: function () {
	                if (typeof that.aggregateParams["aggregates"] != "undefined") {
	                    return Array.isArray(that.aggregateParams["aggregates"])
	                        ? that.aggregateParams["aggregates"]
	                        : [that.aggregateParams["aggregates"]];
	                } else {
	                    return [];
	                }
	            }(),
	            highlight: true,
	            openOnFocus: true,
	            maxItems: 3
	        });
	
	        that.initCollapseEvents();
	    },
	
	    initCollapseEvents: function () {
	        console.log('initCollapseEvents');
	        var that = this;
	        $(function () {
	            $('.expandable').on('shown.bs.collapse', function (e) {
	                var self = $(this);
	                if (self.is(e.target)) {
	                    var collapseControl = $('#' + self.attr('id') + "_control");
	                    collapseControl.html('<span><i class="fa fa-minus-square-o" aria-hidden="true"></i></span>');
	                }
	            });
	            $('.expandable').on('hidden.bs.collapse', function (e) {
	                var self = $(this);
	                if (self.is(e.target)) {
	                    var collapseControl = $('#' + self.attr('id') + "_control");
	                    collapseControl.html('<span><i class="fa fa-plus-square-o" aria-hidden="true"></i></span>');
	                }
	            });
	            /*that.ui.selectDoc.change(function () {
	                console.log('change');
	                that.handleDocumentsSelect(this.checked, this.name);
	            });*/
	            /*$('.document-checkbox').click(function () {
	                console.log('click');
	                console.log($(this));
	                var self = $(this);
	                if (self.hasClass('doc-select'))
	                    that.handleDocumentsSelect(self.checked, [self.name]);
	            });*/
	
	            //that.expandAll($('.expand-collapse-all i'));
	
	        });
	    },
	
	    initTitleCaptions: function () {
	        var that = this;
	        that.titleCaptions = _.extend(Dicts.documentIntention, Dicts.documentStatuses);
	    },
	
	    onApplyAggregates: function () {
	        var that = this;
	        var aggregates = that.ui.aggregates.val();
	        var aggregatesAsArray = aggregates.split(',');
	        aggregatesAsArray.push("DOCUMENT"); // Always DOCUMENT is last aggregate in report
	
	        if (_.isEqual(aggregatesAsArray, that.aggregateParams["aggregates"]) && !that.filtersChanged
	            || (_.isEmpty(aggregates) && _.isUndefined(that.aggregateParams["aggregates"])))
	            return;
	
	        if (_.isEmpty(aggregates)) {
	            delete that.aggregateParams["aggregates"];
	        } else {
	            that.aggregateParams["aggregates"] = aggregatesAsArray;
	        }
	
	        var contactValueForFilter = that.ui.contactValueInput.val();
	        if (_.isEmpty(contactValueForFilter))
	            delete that.aggregateParams["contactValue"];
	        else
	            that.aggregateParams["contactValue"] = contactValueForFilter;
	
	        if (_.isEmpty(that.selectedSendingMethods)) {
	            delete that.aggregateParams["contactTypes"];
	        } else {
	            that.aggregateParams["contactTypes"] = that.selectedSendingMethods;
	        }
	
	        that.ui.letterRangeFilterField.each(function () {
	            that.aggregateParams[$(this).attr("name")] = $(this).val();
	        });
	
	        that.triggerMethod('statistics:aggregate', that.aggregateParams);
	        that.filtersChanged = false;
	    },
	
	    getAggregateTypes: function () {
	        return [
	            {name: 'Assigned Organization', value: 'ORGANIZATION_REVIEW_REQUEST'},
	            {name: 'Signed By Organization', value: 'ORGANIZATION_REVIEW_FINISHED_REQUEST'},
	            {name: 'Obsoleted By Organization', value: 'ORGANIZATION_REVIEW_DELETED'},
	            {name: 'Assigned Person', value: 'PERSON_REVIEW_REQUEST'},
	            {name: 'Signed By Person', value: 'PERSON_REVIEW_FINISHED_REQUEST'},
	            {name: 'Obsoleted By Person', value: 'PERSON_REVIEW_DELETED'},
	            {name: 'Patient', value: 'DOCUMENT_PATIENT'},
	            {name: 'Requesting Organization', value: 'DOCUMENT_ORGANIZATION'},
	            {name: 'Document Uploader Person', value: 'DOCUMENT_UPLOADER_PERSON'},
	            {name: 'Created Date', value: 'CREATED_TIME'},
	            {name: 'Due Date', value: 'DUE_DATE'},
	            {name: 'Sign Date', value: 'SIGNED_TIME'},
	            {name: 'Intention', value: 'INTENTION'},
	            {name: 'Sign Status', value: 'STATUS'},
	            {name: 'Delivery Status', value: 'DELIVERY_STATUS'},
	            {name: 'Document Name', value: 'DOCUMENT'}
	        ]
	    },
	
	    getSelectedAggregates: function () {
	        return _.first(this.aggregateParams["aggregates"] || [], 4);
	    },
	
	    getSelectedAggregatesNames: function () {
	        return this.getSelectedAggregates().map(function (agg) {
	            return agg + "_NAME";
	        })
	    },
	
	    getSelectedAggregatesCaptions: function () {
	        var that = this;
	        return that.getSelectedAggregates().map(function (agg) {
	            return _.findWhere(that.getAggregateTypes(), {value: agg}).name;
	        })
	    },
	
	    getChildrenValues: function (children, aggIndex) {
	        var that = this;
	        var nodeType = that.getSelectedAggregates()[aggIndex];
	
	        if (nodeType == "CREATED_TIME" || nodeType == "DUE_DATE" || nodeType == "SIGNED_TIME") {
	            return _.sortBy(_.values(children) || [], function (child) {
	                var sortFieldForDate = child[nodeType];
	                return new Number(sortFieldForDate);
	            });
	        } else {
	            return _.sortBy(_.values(children) || [], function (child) {
	                if (child[nodeType + "_NAME"] == that.noValue)
	                    return "";
	                return child[nodeType + "_NAME"];
	            });
	        }
	    },
	
	    nodeId: function (node, aggIndex) {
	        return node[this.getSelectedAggregates()[aggIndex]];
	    },
	
	    nodeNameOrAsLink: function (node, aggIndex) {
	        var id = node[this.getSelectedAggregates()[aggIndex]];
	        var title = node[this.getSelectedAggregatesNames()[aggIndex]];
	        var nodeType = this.getSelectedAggregates()[aggIndex];
	
	        title = this.formatted(title);
	
	        if (id == this.noValue)
	            return '<a>' + title + '</a>';
	
	        switch (nodeType) {
	            case 'ORGANIZATION_REVIEW_REQUEST':
	            case 'ORGANIZATION_REVIEW_FINISHED_REQUEST':
	            case 'ORGANIZATION_REVIEW_DELETED':
	            case 'DOCUMENT_ORGANIZATION':
	                return '<a href="/#organization/' + id + '"  target="_blank">' + title + '</a>';
	            case 'PERSON_REVIEW_REQUEST':
	            case 'PERSON_REVIEW_FINISHED_REQUEST':
	            case 'PERSON_REVIEW_DELETED':
	            case 'DOCUMENT_PATIENT':
	            case 'DOCUMENT_UPLOADER_PERSON':
	                return '<a href="/#person/' + id + '"  target="_blank">' + title + '</a>';
	            case 'DOCUMENT':
	                return '<a href="/#document/' + id + '"  target="_blank">' + title + '</a>';
	
	            default:
	                return '<a>' + title + '</a>';
	        }
	    },
	
	    formatted: function (title) {
	        return (this.titleCaptions[title] || title).toUpperCase();
	    },
	
	    nodeNameIsNoValue: function (node, aggIndex) {
	        var id = node[this.getSelectedAggregates()[aggIndex]];
	        //return id == this.noValue;
	        return false;
	    },
	
	    signedLink: function (nodes) {
	        var link = this.documentsLink(nodes);
	        if (link.indexOf("object_status") < 0) {
	            return link + '&object_status=SIGNED';
	        }
	        return link;
	    },
	
	    viewedLink: function (nodes) {
	        var link = this.documentsLink(nodes);
	        if (link.indexOf("object_status") < 0) {
	            return link + '&object_status=VIEWED';
	        }
	        return link;
	    },
	
	    pendingLink: function (nodes) {
	        var link = this.documentsLink(nodes);
	        if (link.indexOf("object_status") < 0) {
	            return link + '&object_status=IN_REVIEW';
	        }
	        return link;
	    },
	
	    unreviewedLink: function (nodes) {
	        var link = this.documentsLink(nodes);
	        if (link.indexOf("object_status") < 0) {
	            return link + '&object_status=UNREVIEWED';
	        }
	        return link;
	    },
	
	    deletedLink: function (nodes) {
	        var link = this.documentsLink(nodes);
	        if (link.indexOf("object_status") < 0) {
	            return link + '&object_status=DELETED';
	        }
	        return link;
	    },
	
	    underReviewLink: function (nodes) {
	        var link = this.documentsLink(nodes);
	        if (link.indexOf("object_status") < 0) {
	            return link + '&object_status=UNDER_REVIEW';
	        }
	        return link;
	    },
	
	    totalLink: function (nodes) {
	        var link = this.documentsLink(nodes);
	        return link;
	    },
	
	    documentsLink: function (nodes) {
	        var that = this;
	
	        var link = '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	            + (_.isEmpty(that.extraParamsAsString) ? '' : '&' + that.extraParamsAsString);
	
	        var params = (nodes || []).map(function (node, index) {
	            return that.nodeToParams(node, index, nodes.length == index + 1);
	        });
	
	        link = link + "&" + params.join("&");
	
	        return link;
	    },
	
	    wasReportFiltersApplied: function () {
	        return this.aggregateParams["contactValue"]
	            || this.aggregateParams["contactTypes"]
	            || this.aggregateParams["orgNameFrom"] && this.aggregateParams["orgNameFrom"] != "A"
	            || this.aggregateParams["orgNameTo"] && this.aggregateParams["orgNameTo"] != "Z"
	            || this.aggregateParams["mdNameFrom"] && this.aggregateParams["mdNameFrom"] != "A"
	            || this.aggregateParams["mdNameTo"] && this.aggregateParams["mdNameTo"] != "Z";
	    },
	
	    nodeToParams: function (node, index, isLast) {
	        var nodeType = this.getSelectedAggregates()[index];
	        var id = node[this.getSelectedAggregates()[index]];
	
	        if ((id == this.noValue || nodeType == 'STATUS')) {
	            if (isLast)
	                return node.documentIds.map(function (id) {
	                    return 'id=' + id;
	                }).join("&");
	            else
	                return ""; // in the future will be here relation not exists filter
	        }
	
	        if (this.wasReportFiltersApplied() && isLast) {
	            return node.documentIds.map(function (id) {
	                return 'id=' + id;
	            }).join("&");
	        } else
	            console.log("Filters was empty");
	
	        var twelveHour = 1000 * 60 * 60 * 12;
	
	        switch (nodeType) {
	            case 'ORGANIZATION_REVIEW_REQUEST':
	                return 'ORGANIZATION_REVIEW_REQUEST=' + id;
	            case 'ORGANIZATION_REVIEW_FINISHED_REQUEST':
	                return 'ORGANIZATION_REVIEW_FINISHED_REQUEST=' + id;
	            case 'ORGANIZATION_REVIEW_DELETED':
	                return 'ORGANIZATION_REVIEW_DELETED=' + id;
	            case 'PERSON_REVIEW_REQUEST':
	                return 'PERSON_REVIEW_REQUEST=' + id;
	            case 'PERSON_REVIEW_FINISHED_REQUEST':
	                return 'PERSON_REVIEW_FINISHED_REQUEST=' + id;
	            case 'PERSON_REVIEW_DELETED':
	                return 'PERSON_REVIEW_DELETED=' + id;
	            case 'DOCUMENT_PATIENT':
	                return 'DOCUMENT_PATIENT=' + id;
	            case 'DOCUMENT_ORGANIZATION':
	                return 'DOCUMENT_ORGANIZATION=' + id;
	            case 'DOCUMENT_UPLOADER_PERSON':
	                return 'DOCUMENT_UPLOADER_PERSON=' + id;
	            case 'DOCUMENT':
	                return 'id=' + id;
	            case 'CREATED_TIME':
	                //return 'object_createdTime_from=' + (new Number(id) - twelveHour) + '&' + 'object_createdTime_to=' + (new Number(id) + twelveHour);
	                return 'object_createdTime_date=' + (new Number(id));
	            case 'DUE_DATE':
	                //return 'object_dueDate_from=' + (new Number(id) - twelveHour) + '&' + 'object_dueDate_to=' + (new Number(id) + twelveHour);
	                return 'object_dueDate_date=' + (new Number(id));
	            case 'SIGNED_TIME':
	                //return 'object_signedTime_from=' + (new Number(id) - twelveHour) + '&' + 'object_signedTime_to=' + (new Number(id) + twelveHour);
	                return 'object_signedTime_date=' + (new Number(id));
	            case 'INTENTION':
	                return 'object_intention=' + id;
	            /*case 'STATUS':
	                return 'object_status=' + id;*/
	            case 'DELIVERY_STATUS':
	                if (id == 'NOT SENT') {
	                    return 'object_lastSentTime=0';
	                } else if (id == 'NOT DELIVERED') {
	                    return 'object_lastDeliveredTime=0&object_lastSentTime_from=1';
	                } else if (id == 'DELIVERED') {
	                    return 'object_lastDeliveredTime_from=1'
	                }
	            default:
	                return "";
	        }
	    },
	
	    onContactValueChanged: function (event) {
	        this.filtersChanged = true;
	    },
	
	    onChangeLetterRangeFilterField: function (event) {
	        this.filtersChanged = true;
	    },
	
	    selectSendingMethod: function (event) {
	        var target = $(event.target);
	        var value = target.data('title');
	        var isActive = target.hasClass('active');
	
	        if (!isActive) {
	            target.removeClass('notActive').addClass('active');
	            this.selectedSendingMethods.push(value);
	        } else {
	            target.removeClass('active').addClass('notActive');
	            this.selectedSendingMethods = _.reject(this.selectedSendingMethods, function (method) {
	                return method == value;
	            });
	        }
	
	        this.filtersChanged = true;
	    },
	
	    onContactTypeChanged: function (event) {
	        var contactType = event.target.value;
	        if (event.target.checked) {
	            this.selectedSendingMethods.push(contactType);
	        } else {
	            this.selectedSendingMethods = _.reject(this.selectedSendingMethods, function (method) {
	                return method == contactType;
	            });
	        }
	        this.filtersChanged = true;
	    },
	
	    onDocumentSelected: function (event) {
	        this.handleDocumentsSelect(event.target.checked, [event.target.name]);
	    },
	
	    handleDocumentsSelect: function (checked, ids) {
	        if (checked)
	            this.triggerMethod('aggregate:documents:selected', ids);
	        else
	            this.triggerMethod('aggregate:documents:unselected', ids);
	        this.onOffButtons();
	
	        //$(function () {
	        ids.forEach(function (id) {
	            $(":checkbox[name='" + id + "']").each(function () {
	                console.log('success-el');
	                $(this).removeClass("success-el");
	                $(this).removeClass("error-el");
	            });
	        })
	        //});
	    },
	
	    onChildDocumentsSelected: function (event) {
	        var that = this;
	        var el = $(event.target);
	        var state = event.target.checked;
	        window.setTimeout(function () {
	            el.closest('.level-group').find('.document-checkbox').each(function () {
	                if ($(this) != el) {
	                    $(this).prop('checked', state);
	                    if ($(this).hasClass("doc-select"))
	                        that.handleDocumentsSelect(state, [$(this).prop("name")]);
	                }
	            });
	        }, 0);
	    },
	
	    onOffButtons: function () {
	        var isSelectedDocExists = false;
	        $('input:checkbox.doc-select').each(function () {
	            isSelectedDocExists = isSelectedDocExists || this.checked;
	        });
	
	        if (isSelectedDocExists)
	            this.ui.actionBtn.removeAttr("disabled");
	        else
	            this.ui.actionBtn.attr("disabled", true);
	    },
	
	    onDownload: function () {
	        console.log("onDownload");
	        this.triggerMethod('aggregate:download');
	    },
	
	    onPrint: function () {
	        console.log("onPrint");
	        this.triggerMethod('aggregate:print');
	    },
	
	    onSign: function () {
	        console.log("onSign");
	        this.triggerMethod('aggregate:sign', function (successDocIds, errorDocIds) {
	            console.log(successDocIds);
	            successDocIds.forEach(function (id) {
	                $(":checkbox[name='" + id + "']").each(function () {
	                    $(this).addClass("success-el");
	                });
	            });
	            console.log(errorDocIds);
	            errorDocIds.forEach(function (id) {
	                $(":checkbox[name='" + id + "']").each(function () {
	                    $(this).addClass("error-el");
	                });
	            })
	        });
	    },
	
	    onAddAddendum: function () {
	        console.log("onAddAddendum");
	        this.triggerMethod('aggregate:add:addendum');
	    },
	
	    onAssign: function () {
	        console.log("onAssign");
	        this.triggerMethod('aggregate:assign');
	    },
	
	    onAddPatient: function () {
	        console.log("onAddPatient");
	        this.triggerMethod('aggregate:add:patient');
	    },
	
	    onSetDue: function () {
	        console.log("onSetDue");
	        this.triggerMethod('aggregate:set:due');
	    },
	
	    onAudit: function () {
	        console.log("onAudit");
	        this.triggerMethod('aggregate:audit');
	    },
	
	    onSend: function () {
	        console.log("onSend");
	        this.triggerMethod('aggregate:send');
	    },
	
	    onMarkAsSent: function () {
	        console.log("onMarkAsSent");
	        this.triggerMethod('aggregate:mark:as:sent');
	    },
	
	    onMarkAsDelivered: function () {
	        console.log("onMarkAsDelivered");
	        this.triggerMethod('aggregate:mark:as:delivered');
	    },
	
	    onOpenSelectedDocuments: function () {
	        window.open("/#documents?" + (this.getSelectedDocuments() || []).map(function (id) {
	            return "id=" + id;
	        }).join("&"));
	    },
	
	    onExpandOrCollapse: function (event) {
	        var expandOrCollapseElement = $(event.target);
	        var expandAllText = "Expand All";
	        var collapseAllText = "Collapse All";
	        var expandClass = "fa-plus-square";
	        var collapseClass = "fa-minus-square";
	
	        if (expandOrCollapseElement.attr("title") == expandAllText) {
	            expandOrCollapseElement.attr("title", collapseAllText);
	            expandOrCollapseElement.removeClass(expandClass);
	            expandOrCollapseElement.addClass(collapseClass);
	            $('.expandable').collapse('show');
	        } else {
	            expandOrCollapseElement.attr("title", expandAllText);
	            expandOrCollapseElement.removeClass(collapseClass);
	            expandOrCollapseElement.addClass(expandClass);
	            $('.expandable').collapse('hide');
	        }
	    },
	
	    expandAll: function (target) {
	        var collapseAllText = "Collapse All";
	        var collapseClass = "fa-minus-square";
	        var expandClass = "fa-plus-square";
	
	        target.attr("title", collapseAllText);
	        target.removeClass(expandClass);
	        target.addClass(collapseClass);
	        $('.expandable').collapse('show');
	    },
	
	    setAsInitialView: function () {
	        var that = this;
	
	        $.ajax({
	            type: "POST",
	            url: '/api/person/initial-url',
	            contentType: 'text/plain',
	            data: that.getUrlAsInitialView(),
	            statusCode: {
	                200: function () {
	                    $.notify({
	                        message: 'Initial View was set successfully'
	                    }, {
	                        type: 'success',
	                        z_index: 2000
	                    });
	                }
	            },
	            error: function (e) {
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            }
	        });
	    },
	
	    getUrlAsInitialView: function () {
	        var that = this;
	        var params = _.extend(that.utils.deepClone(that.extraParams), that.aggregateParams);
	        that.utils.mergeObjectsLeft(params, {"initial-view": "sorting-report"});
	        var url = window.location.hash.split('?')[0] + '?' + that.utils.objectToQueryParams(params);
	        return url;
	    },
	
	    extraParamsToString: function () {
	        var extraParamsForLinks = {};
	        _.each(this.extraParams, function (val, key) {
	            if (key != 'ORGANIZATION_REVIEW_FINISHED_REQUEST' && key != 'ORGANIZATION_REVIEW_REQUEST' && key != 'ORGANIZATION_REVIEW_DELETED'
	                && key != 'PERSON_REVIEW_FINISHED_REQUEST' && key != 'PERSON_REVIEW_REQUEST' && key != 'PERSON_REVIEW_DELETED' && key != 'object_status') {
	                extraParamsForLinks[key] = val;
	            }
	        });
	
	        return this.utils.objectToQueryParams(extraParamsForLinks);
	    }
	
	});
	
	
	module.exports = DocumentsStatisticsAggregateView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="well" style="font-size: 14px;">\n    <div class="form form-inline center">\n        <div class="form-group">\n            <label class="control-label" for="org-name-from">Organization: </label>\n            <select id="org-name-from" name="orgNameFrom" class="form-control input-sm letter-range-filter-field" style="width:auto;">\n                ';
	 _.each(upperCaseChars, function(ucc) { 
	__p+='\n                ';
	 if (ucc == orgNameFrom) { 
	__p+='\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'" selected> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\n                ';
	 } else { 
	__p+='\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'"> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\n                ';
	 } 
	__p+='\n                ';
	 }) 
	__p+='\n            </select>\n            <label class="control-label" for="org-name-to">-</label>\n            <select id="org-name-to" name="orgNameTo" class="form-control input-sm letter-range-filter-field" style="width:auto;">\n                ';
	 _.each(upperCaseChars, function(ucc) { 
	__p+='\n                ';
	 if (ucc == orgNameTo || !orgNameTo && ucc == "Z") { 
	__p+='\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'" selected> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\n                ';
	 } else { 
	__p+='\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'"> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\n                ';
	 } 
	__p+='\n                ';
	 }) 
	__p+='\n            </select>\n            <label class="control-label" for="md-name-from" style="margin-left: 20px;">Physician: </label>\n            <select id="md-name-from" name="mdNameFrom" class="form-control input-sm letter-range-filter-field" style="width:auto;">\n                ';
	 _.each(upperCaseChars, function(ucc) { 
	__p+='\n                ';
	 if (ucc == mdNameFrom) { 
	__p+='\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'" selected> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\n                ';
	 } else { 
	__p+='\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'"> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\n                ';
	 } 
	__p+='\n                ';
	 }) 
	__p+='\n            </select>\n            <label class="control-label" for="md-name-to">-</label>\n            <select id="md-name-to" name="mdNameTo" class="form-control input-sm letter-range-filter-field" style="width:auto;">\n                ';
	 _.each(upperCaseChars, function(ucc) { 
	__p+='\n                ';
	 if (ucc == mdNameTo || !mdNameTo && ucc == "Z") { 
	__p+='\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'" selected> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\n                ';
	 } else { 
	__p+='\n                <option value="'+
	((__t=( ucc ))==null?'':__t)+
	'" name="'+
	((__t=( ucc ))==null?'':__t)+
	'"> '+
	((__t=( ucc ))==null?'':__t)+
	'</option>\n                ';
	 } 
	__p+='\n                ';
	 }) 
	__p+='\n            </select>\n            <label class="control-label" for="contact-value" style="margin-left: 20px;">Destination: </label>\n            <input type="text" class="form-control" id="contact-value" name="contact-value" placeholder="Destination" value="'+
	((__t=( contactValue ))==null?'':__t)+
	'"/>\n        </div>\n        <div class="form-group" style="display: none">\n            <div class="btn-group" id="sending-method" style="display: list-item;margin-left: 20px;">\n                ';
	 _.each(_.keys(contactTypes), function(method){ 
	__p+='\n                <a class="btn btn-primary btn-sm '+
	((__t=( sendingMethodsState[method] ))==null?'':__t)+
	'" data-title="'+
	((__t=( method ))==null?'':__t)+
	'">'+
	((__t=( contactTypes[method] ))==null?'':__t)+
	'</a>\n                ';
	 }) 
	__p+='\n            </div>\n        </div>\n        ';
	 _.each(_.keys(contactTypes), function(method){ 
	__p+='\n        <label class="checkbox"><input type="checkbox" class="contact-type" value="'+
	((__t=( method ))==null?'':__t)+
	'" style="margin-left: 20px; vertical-align: center;"\n            ';
	 if (sendingMethodsState[method] == 'active') { 
	__p+=' checked ';
	 } 
	__p+=' />'+
	((__t=( contactTypes[method] ))==null?'':__t)+
	'</label>\n        ';
	 }) 
	__p+='\n    </div>\n\n</div>\n<div>\n    <div style="font-size: 14px;">\n        <input id="aggregates"/>\n    </div>\n    <button id="apply-aggregates" class="btn btn-primary">Apply</button>\n</div>\n\n<hr>\n\n<div class="form form-horizontal" style="margin-left: 18px;font-size: 16px;">\n    ';
	 if (!_.isEmpty(tree.children)) { 
	__p+='\n    <div class="col-md-12 col-xs-12 row" style="margin-bottom: 10px;">\n        <div class="col-md-8 col-xs-8">\n            <span class="pull-left clickable expand-collapse-all">\n                <i class="fa fa-plus-square" aria-hidden="true" title="Expand All"></i>\n            </span>\n            ';
	 _.each(aggregatesCaptionsList, function(caption, index) { 
	__p+='\n            <div class="col-md-2 col-xs-2"><b>'+
	((__t=( caption ))==null?'':__t)+
	'</b></div>\n            ';
	 }) 
	__p+='\n        </div>\n        <div class="col-md-4 col-xs-4 center">\n            <div class="col-md-2 col-xs-2 center" id="pending"><b>Pending</b></div>\n            <div class="col-md-2 col-xs-2 center" id="viewed" style="display: none;"><b>Viewed</b></div>\n            <div class="col-md-2 col-xs-2 center" id="signed"><b>Signed</b></div>\n            <div class="col-md-4 col-xs-4 center" id="under"><b>Under Review</b></div>\n            <div class="col-md-2 col-xs-2 center" id="deleted"><b>Obsolete</b></div>\n            <div class="col-md-2 col-xs-2 center" id="unreviewed" style="display: none;"><b>Not Assigned</b></div>\n            <div class="col-md-2 col-xs-2 center" id="total"><b>Total</b></div>\n        </div>\n    </div>\n    ';
	 } else { 
	__p+='\n    <div>\n        <div class="center"><b>There are no data. Please, select aggregate values and Apply.</b></div>\n    </div>\n    ';
	 } 
	__p+='\n\n    ';
	 _.each(getChildrenValues(tree.children, 0), function(firstLevelNode, firstLevelIndex) { 
	__p+='\n        <div class="level-group">\n            <div class="col-md-12 col-xs-12 row first-level-node">\n                <div class="col-md-8 col-xs-8">\n                    ';
	 if (!_.isEmpty(firstLevelNode.children)) { 
	__p+='\n                    <a data-toggle="collapse" href="#'+
	((__t=( generateCollapseId(firstLevelNode, 0, [firstLevelIndex]) ))==null?'':__t)+
	'"\n                       id="'+
	((__t=( generateCollapseId(firstLevelNode, 0, [firstLevelIndex]) + '_control' ))==null?'':__t)+
	'"\n                       role="button" aria-expanded="false" aria-controls="'+
	((__t=( generateCollapseId(firstLevelNode, 0, [firstLevelIndex]) ))==null?'':__t)+
	'">\n                        <span><i class="fa fa-plus-square-o" aria-hidden="true"></i></span>\n                    </a>\n                    <input type="checkbox" class="doc-group-select document-checkbox" title="Select all documents"\n                           data-id="'+
	((__t=( nodeId(firstLevelNode, 0) ))==null?'':__t)+
	'" data-index="0">\n                    ';
	 } 
	__p+='\n                    <b>'+
	((__t=( nodeNameOrAsLink(firstLevelNode, 0) ))==null?'':__t)+
	'</b>\n                </div>\n                <div class="col-md-4 col-xs-4 center">\n                    <div class="col-md-2 col-xs-2 center">\n                        ';
	 if (nodeNameIsNoValue(firstLevelNode, 0)){ 
	__p+='\n                        '+
	((__t=( firstLevelNode.pending ))==null?'':__t)+
	'\n                        ';
	 } else { 
	__p+='\n                        <a href="'+
	((__t=( pendingLink([firstLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( firstLevelNode.pending ))==null?'':__t)+
	'</a>\n                        ';
	 } 
	__p+='\n                    </div>\n                    <div class="col-md-2 col-xs-2 center" style="display: none;">\n                        ';
	 if (nodeNameIsNoValue(firstLevelNode, 0)){ 
	__p+='\n                        '+
	((__t=( firstLevelNode.viewed ))==null?'':__t)+
	'\n                        ';
	 } else { 
	__p+='\n                        <a href="'+
	((__t=( viewedLink([firstLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( firstLevelNode.viewed ))==null?'':__t)+
	'</a>\n                        ';
	 } 
	__p+='\n                    </div>\n                    <div class="col-md-2 col-xs-2 center">\n                        ';
	 if (nodeNameIsNoValue(firstLevelNode, 0)){ 
	__p+='\n                        '+
	((__t=( firstLevelNode.signed ))==null?'':__t)+
	'\n                        ';
	 } else { 
	__p+='\n                        <a href="'+
	((__t=( signedLink([firstLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( firstLevelNode.signed ))==null?'':__t)+
	'</a>\n                        ';
	 } 
	__p+='\n                    </div>\n                    <div class="col-md-4 col-xs-4 center">\n                        ';
	 if (nodeNameIsNoValue(firstLevelNode, 0)){ 
	__p+='\n                        '+
	((__t=( firstLevelNode.under ))==null?'':__t)+
	'\n                        ';
	 } else { 
	__p+='\n                        <a href="'+
	((__t=( underReviewLink([firstLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( firstLevelNode.under ))==null?'':__t)+
	'</a>\n                        ';
	 } 
	__p+='\n                    </div>\n                    <div class="col-md-2 col-xs-2 center">\n                        ';
	 if (nodeNameIsNoValue(firstLevelNode, 0)){ 
	__p+='\n                        '+
	((__t=( firstLevelNode.deleted ))==null?'':__t)+
	'\n                        ';
	 } else { 
	__p+='\n                        <a href="'+
	((__t=( deletedLink([firstLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( firstLevelNode.deleted ))==null?'':__t)+
	'</a>\n                        ';
	 } 
	__p+='\n                    </div>\n                    <div class="col-md-2 col-xs-2 center" style="display: none;">\n                        ';
	 if (nodeNameIsNoValue(firstLevelNode, 0)){ 
	__p+='\n                        '+
	((__t=( firstLevelNode.unreviewed ))==null?'':__t)+
	'\n                        ';
	 } else { 
	__p+='\n                        <a href="'+
	((__t=( unreviewedLink([firstLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( firstLevelNode.unreviewed ))==null?'':__t)+
	'</a>\n                        ';
	 } 
	__p+='\n                    </div>\n                    <div class="col-md-2 col-xs-2 center">\n                        ';
	 if (nodeNameIsNoValue(firstLevelNode, 0)){ 
	__p+='\n                        '+
	((__t=( firstLevelNode.total ))==null?'':__t)+
	'\n                        ';
	 } else { 
	__p+='\n                        <a href="'+
	((__t=( totalLink([firstLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( firstLevelNode.total ))==null?'':__t)+
	'</a>\n                        ';
	 } 
	__p+='\n                    </div>\n                </div>\n            </div>\n\n            <div class="collapse expandable" id="'+
	((__t=( generateCollapseId(firstLevelNode, 0, [firstLevelIndex]) ))==null?'':__t)+
	'">\n\n                ';
	 _.each(getChildrenValues(firstLevelNode.children, 1), function(secondLevelNode, secondLevelIndex) { 
	__p+='\n                <div class="level-group">\n\n                    <div class="col-md-12 col-xs-12 row second-level-node">\n                        <div class="col-md-7 col-xs-7 col-md-offset-1 col-xs-offset-1" style="padding-left: 70px;">\n                            ';
	 if (!_.isEmpty(secondLevelNode.children)) { 
	__p+='\n                            <a data-toggle="collapse" href="#'+
	((__t=( generateCollapseId(secondLevelNode, 1, [firstLevelIndex, secondLevelIndex]) ))==null?'':__t)+
	'"\n                               id="'+
	((__t=( generateCollapseId(secondLevelNode, 1, [firstLevelIndex, secondLevelIndex]) + '_control' ))==null?'':__t)+
	'"\n                               role="button" aria-expanded="false" aria-controls="'+
	((__t=( generateCollapseId(secondLevelNode, 1, [firstLevelIndex, secondLevelIndex]) ))==null?'':__t)+
	'">\n                                <span><i class="fa fa-plus-square-o" aria-hidden="true"></i></span>\n                            </a>\n                            <input type="checkbox" class="doc-group-select document-checkbox" title="Select all documents"\n                                   data-id="'+
	((__t=( nodeId(secondLevelNode, 1) ))==null?'':__t)+
	'" data-index="1">\n                            ';
	 } else { 
	__p+='\n                            <a href="/api/document/view/'+
	((__t=( nodeId(secondLevelNode, 1) ))==null?'':__t)+
	'" target="_blank" title="View">\n                                <span class="clickable glyphicon glyphicon-eye-open"/>\n                            </a>\n                            <input type="checkbox" class="doc-select document-checkbox" name="'+
	((__t=( secondLevelNode['DOCUMENT'] ))==null?'':__t)+
	'">\n                            ';
	 } 
	__p+='\n                            <b>'+
	((__t=( nodeNameOrAsLink(secondLevelNode, 1) ))==null?'':__t)+
	'</b>\n                        </div>\n                        <div class="col-md-4 col-xs-4 center">\n                            <div class="col-md-2 col-xs-2 center">\n                                ';
	 if (nodeNameIsNoValue(secondLevelNode, 1)){ 
	__p+='\n                                '+
	((__t=( secondLevelNode.pending ))==null?'':__t)+
	'\n                                ';
	 } else { 
	__p+='\n                                <a href="'+
	((__t=( pendingLink([firstLevelNode, secondLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( secondLevelNode.pending ))==null?'':__t)+
	'</a>\n                                ';
	 } 
	__p+='\n                            </div>\n                            <div class="col-md-2 col-xs-2 center" style="display: none;">\n                                ';
	 if (nodeNameIsNoValue(secondLevelNode, 1)){ 
	__p+='\n                                '+
	((__t=( secondLevelNode.viewed ))==null?'':__t)+
	'\n                                ';
	 } else { 
	__p+='\n                                <a href="'+
	((__t=( viewedLink([firstLevelNode, secondLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( secondLevelNode.viewed ))==null?'':__t)+
	'</a>\n                                ';
	 } 
	__p+='\n                            </div>\n                            <div class="col-md-2 col-xs-2 center">\n                                ';
	 if (nodeNameIsNoValue(secondLevelNode, 1)){ 
	__p+='\n                                '+
	((__t=( secondLevelNode.signed ))==null?'':__t)+
	'\n                                ';
	 } else { 
	__p+='\n                                <a href="'+
	((__t=( signedLink([firstLevelNode, secondLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( secondLevelNode.signed ))==null?'':__t)+
	'</a>\n                                ';
	 } 
	__p+='\n                            </div>\n                            <div class="col-md-4 col-xs-4 center">\n                                ';
	 if (nodeNameIsNoValue(secondLevelNode, 1)){ 
	__p+='\n                                '+
	((__t=( secondLevelNode.under ))==null?'':__t)+
	'\n                                ';
	 } else { 
	__p+='\n                                <a href="'+
	((__t=( underReviewLink([firstLevelNode, secondLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( secondLevelNode.under ))==null?'':__t)+
	'</a>\n                                ';
	 } 
	__p+='\n                            </div>\n                            <div class="col-md-2 col-xs-2 center">\n                                ';
	 if (nodeNameIsNoValue(secondLevelNode, 1)){ 
	__p+='\n                                '+
	((__t=( secondLevelNode.deleted ))==null?'':__t)+
	'\n                                ';
	 } else { 
	__p+='\n                                <a href="'+
	((__t=( deletedLink([firstLevelNode, secondLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( secondLevelNode.deleted ))==null?'':__t)+
	'</a>\n                                ';
	 } 
	__p+='\n                            </div>\n                            <div class="col-md-2 col-xs-2 center" style="display: none;">\n                                ';
	 if (nodeNameIsNoValue(secondLevelNode, 1)){ 
	__p+='\n                                '+
	((__t=( secondLevelNode.unreviewed ))==null?'':__t)+
	'\n                                ';
	 } else { 
	__p+='\n                                <a href="'+
	((__t=( unreviewedLink([firstLevelNode, secondLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( secondLevelNode.unreviewed ))==null?'':__t)+
	'</a>\n                                ';
	 } 
	__p+='\n                            </div>\n                            <div class="col-md-2 col-xs-2 center">\n                                ';
	 if (nodeNameIsNoValue(secondLevelNode, 1)){ 
	__p+='\n                                '+
	((__t=( secondLevelNode.total ))==null?'':__t)+
	'\n                                ';
	 } else { 
	__p+='\n                                <a href="'+
	((__t=( totalLink([firstLevelNode, secondLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( secondLevelNode.total ))==null?'':__t)+
	'</a>\n                                ';
	 } 
	__p+='\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class="collapse expandable" id="'+
	((__t=( generateCollapseId(secondLevelNode, 1, [firstLevelIndex, secondLevelIndex]) ))==null?'':__t)+
	'">\n                        ';
	 _.each(getChildrenValues(secondLevelNode.children, 2), function(thirdLevelNode, thirdLevelIndex) { 
	__p+='\n                        <div class="level-group">\n                            <div class="col-md-12 col-xs-12 row second-level-node">\n                                <div class="col-md-6 col-xs-6 col-md-offset-2 col-xs-offset-2" style="padding-left: 90px;">\n                                    ';
	 if (!_.isEmpty(thirdLevelNode.children)) { 
	__p+='\n                                    <a data-toggle="collapse" href="#'+
	((__t=( generateCollapseId(thirdLevelNode, 2, [firstLevelIndex, secondLevelIndex, thirdLevelIndex]) ))==null?'':__t)+
	'"\n                                       id="'+
	((__t=( generateCollapseId(thirdLevelNode, 2, [firstLevelIndex, secondLevelIndex, thirdLevelIndex]) + '_control' ))==null?'':__t)+
	'"\n                                       role="button" aria-expanded="false" aria-controls="'+
	((__t=( generateCollapseId(thirdLevelNode, 2, [firstLevelIndex, secondLevelIndex, thirdLevelIndex]) ))==null?'':__t)+
	'">\n                                        <span><i class="fa fa-plus-square-o" aria-hidden="true"></i></span>\n                                    </a>\n                                    <input type="checkbox" class="doc-group-select document-checkbox" title="Select all documents"\n                                           data-id="'+
	((__t=( nodeId(thirdLevelNode, 2) ))==null?'':__t)+
	'" data-index="2">\n                                    ';
	 } else { 
	__p+='\n                                    <a href="/api/document/view/'+
	((__t=( nodeId(thirdLevelNode, 2) ))==null?'':__t)+
	'" target="_blank" title="View">\n                                        <span class="clickable glyphicon glyphicon-eye-open"/>\n                                    </a>\n                                    <input type="checkbox" class="doc-select document-checkbox" name="'+
	((__t=( thirdLevelNode['DOCUMENT'] ))==null?'':__t)+
	'">\n                                    ';
	 } 
	__p+='\n                                    <b>'+
	((__t=( nodeNameOrAsLink(thirdLevelNode, 2) ))==null?'':__t)+
	'</b>\n                                </div>\n                                <div class="col-md-4 col-xs-4 center">\n                                    <div class="col-md-2 col-xs-2 center">\n                                        ';
	 if (nodeNameIsNoValue(thirdLevelNode, 2)){ 
	__p+='\n                                        '+
	((__t=( thirdLevelNode.pending ))==null?'':__t)+
	'\n                                        ';
	 } else { 
	__p+='\n                                        <a href="'+
	((__t=( pendingLink([firstLevelNode, secondLevelNode, thirdLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( thirdLevelNode.pending ))==null?'':__t)+
	'</a>\n                                        ';
	 } 
	__p+='\n                                    </div>\n                                    <div class="col-md-2 col-xs-2 center" style="display: none;">\n                                        ';
	 if (nodeNameIsNoValue(thirdLevelNode, 2)){ 
	__p+='\n                                        '+
	((__t=( thirdLevelNode.viewed ))==null?'':__t)+
	'\n                                        ';
	 } else { 
	__p+='\n                                        <a href="'+
	((__t=( viewedLink([firstLevelNode, secondLevelNode, thirdLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( thirdLevelNode.viewed ))==null?'':__t)+
	'</a>\n                                        ';
	 } 
	__p+='\n                                    </div>\n                                    <div class="col-md-2 col-xs-2 center">\n                                        ';
	 if (nodeNameIsNoValue(thirdLevelNode, 2)){ 
	__p+='\n                                        '+
	((__t=( thirdLevelNode.signed ))==null?'':__t)+
	'\n                                        ';
	 } else { 
	__p+='\n                                        <a href="'+
	((__t=( signedLink([firstLevelNode, secondLevelNode, thirdLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( thirdLevelNode.signed ))==null?'':__t)+
	'</a>\n                                        ';
	 } 
	__p+='\n                                    </div>\n                                    <div class="col-md-4 col-xs-4 center">\n                                        ';
	 if (nodeNameIsNoValue(thirdLevelNode, 2)){ 
	__p+='\n                                        '+
	((__t=( thirdLevelNode.under ))==null?'':__t)+
	'\n                                        ';
	 } else { 
	__p+='\n                                        <a href="'+
	((__t=( underReviewLink([firstLevelNode, secondLevelNode, thirdLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( thirdLevelNode.under ))==null?'':__t)+
	'</a>\n                                        ';
	 } 
	__p+='\n                                    </div>\n                                    <div class="col-md-2 col-xs-2 center">\n                                        ';
	 if (nodeNameIsNoValue(thirdLevelNode, 2)){ 
	__p+='\n                                        '+
	((__t=( thirdLevelNode.deleted ))==null?'':__t)+
	'\n                                        ';
	 } else { 
	__p+='\n                                        <a href="'+
	((__t=( deletedLink([firstLevelNode, secondLevelNode, thirdLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( thirdLevelNode.deleted ))==null?'':__t)+
	'</a>\n                                        ';
	 } 
	__p+='\n                                    </div>\n                                    <div class="col-md-2 col-xs-2 center" style="display: none;">\n                                        ';
	 if (nodeNameIsNoValue(thirdLevelNode, 2)){ 
	__p+='\n                                        '+
	((__t=( thirdLevelNode.unreviewed ))==null?'':__t)+
	'\n                                        ';
	 } else { 
	__p+='\n                                        <a href="'+
	((__t=( unreviewedLink([firstLevelNode, secondLevelNode, thirdLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( thirdLevelNode.unreviewed ))==null?'':__t)+
	'</a>\n                                        ';
	 } 
	__p+='\n                                    </div>\n                                    <div class="col-md-2 col-xs-2 center">\n                                        ';
	 if (nodeNameIsNoValue(thirdLevelNode, 2)){ 
	__p+='\n                                        '+
	((__t=( thirdLevelNode.total ))==null?'':__t)+
	'\n                                        ';
	 } else { 
	__p+='\n                                        <a href="'+
	((__t=( totalLink([firstLevelNode, secondLevelNode, thirdLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( thirdLevelNode.total ))==null?'':__t)+
	'</a>\n                                        ';
	 } 
	__p+='\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="collapse expandable" id="'+
	((__t=( generateCollapseId(thirdLevelNode, 2, [firstLevelIndex, secondLevelIndex, thirdLevelIndex]) ))==null?'':__t)+
	'">\n                                ';
	 _.each(getChildrenValues(thirdLevelNode.children, 3), function(fourthLevelNode, fourthLevelIndex) { 
	__p+='\n                                <div class="col-md-12 col-xs-12 row third-level-node">\n                                    <div class="col-md-5 col-xs-5 col-md-offset-3 col-xs-offset-3" style="padding-left: 120px;">\n                                        <a href="/api/document/view/'+
	((__t=( nodeId(fourthLevelNode, 3) ))==null?'':__t)+
	'" target="_blank" title="View">\n                                            <span class="clickable glyphicon glyphicon-eye-open"/>\n                                        </a>\n                                        <input type="checkbox" class="doc-select document-checkbox" name="'+
	((__t=( fourthLevelNode['DOCUMENT'] ))==null?'':__t)+
	'">\n                                        <b>'+
	((__t=( nodeNameOrAsLink(fourthLevelNode, 3) ))==null?'':__t)+
	'</b>\n                                    </div>\n                                    <div class="col-md-4 col-xs-4 center">\n                                        <div class="col-md-2 col-xs-2 center">\n                                            ';
	 if (nodeNameIsNoValue(fourthLevelNode, 3)){ 
	__p+='\n                                            '+
	((__t=( fourthLevelNode.pending ))==null?'':__t)+
	'\n                                            ';
	 } else { 
	__p+='\n                                            <a href="'+
	((__t=( pendingLink([firstLevelNode, secondLevelNode, thirdLevelNode, fourthLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( fourthLevelNode.pending ))==null?'':__t)+
	'</a>\n                                            ';
	 } 
	__p+='\n                                        </div>\n                                        <div class="col-md-2 col-xs-2 center" style="display: none;">\n                                            ';
	 if (nodeNameIsNoValue(fourthLevelNode, 3)){ 
	__p+='\n                                            '+
	((__t=( fourthLevelNode.viewed ))==null?'':__t)+
	'\n                                            ';
	 } else { 
	__p+='\n                                            <a href="'+
	((__t=( viewedLink([firstLevelNode, secondLevelNode, thirdLevelNode, fourthLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( fourthLevelNode.viewed ))==null?'':__t)+
	'</a>\n                                            ';
	 } 
	__p+='\n                                        </div>\n                                        <div class="col-md-2 col-xs-2 center">\n                                            ';
	 if (nodeNameIsNoValue(fourthLevelNode, 3)){ 
	__p+='\n                                            '+
	((__t=( fourthLevelNode.signed ))==null?'':__t)+
	'\n                                            ';
	 } else { 
	__p+='\n                                            <a href="'+
	((__t=( signedLink([firstLevelNode, secondLevelNode, thirdLevelNode, fourthLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( fourthLevelNode.signed ))==null?'':__t)+
	'</a>\n                                            ';
	 } 
	__p+='\n                                        </div>\n                                        <div class="col-md-4 col-xs-4 center">\n                                            ';
	 if (nodeNameIsNoValue(fourthLevelNode, 3)){ 
	__p+='\n                                            '+
	((__t=( fourthLevelNode.under ))==null?'':__t)+
	'\n                                            ';
	 } else { 
	__p+='\n                                            <a href="'+
	((__t=( underReviewLink([firstLevelNode, secondLevelNode, thirdLevelNode, fourthLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( fourthLevelNode.under ))==null?'':__t)+
	'</a>\n                                            ';
	 } 
	__p+='\n                                        </div>\n                                        <div class="col-md-2 col-xs-2 center">\n                                            ';
	 if (nodeNameIsNoValue(fourthLevelNode, 3)){ 
	__p+='\n                                            '+
	((__t=( fourthLevelNode.deleted ))==null?'':__t)+
	'\n                                            ';
	 } else { 
	__p+='\n                                            <a href="'+
	((__t=( deletedLink([firstLevelNode, secondLevelNode, thirdLevelNode, fourthLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( fourthLevelNode.deleted ))==null?'':__t)+
	'</a>\n                                            ';
	 } 
	__p+='\n                                        </div>\n                                        <div class="col-md-2 col-xs-2 center" style="display: none;">\n                                            ';
	 if (nodeNameIsNoValue(fourthLevelNode, 3)){ 
	__p+='\n                                            '+
	((__t=( fourthLevelNode.unreviewed ))==null?'':__t)+
	'\n                                            ';
	 } else { 
	__p+='\n                                            <a href="'+
	((__t=( unreviewedLink([firstLevelNode, secondLevelNode, thirdLevelNode, fourthLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( fourthLevelNode.unreviewed ))==null?'':__t)+
	'</a>\n                                            ';
	 } 
	__p+='\n                                        </div>\n                                        <div class="col-md-2 col-xs-2 center">\n                                            ';
	 if (nodeNameIsNoValue(fourthLevelNode, 3)){ 
	__p+='\n                                            '+
	((__t=( fourthLevelNode.total ))==null?'':__t)+
	'\n                                            ';
	 } else { 
	__p+='\n                                            <a href="'+
	((__t=( totalLink([firstLevelNode, secondLevelNode, thirdLevelNode, fourthLevelNode]) ))==null?'':__t)+
	'"  target="_blank">'+
	((__t=( fourthLevelNode.total ))==null?'':__t)+
	'</a>\n                                            ';
	 } 
	__p+='\n                                        </div>\n                                    </div>\n                                </div>\n                                ';
	 }) 
	__p+='\n                            </div>\n                        </div>\n                        ';
	 }) 
	__p+='\n                    </div>\n                </div>\n                ';
	 }) 
	__p+='\n            </div>\n        </div>\n    ';
	 }) 
	__p+='\n\n    <hr>\n    <div style="margin-bottom: 50px;">\n        <button type="button" class="btn btn-success btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-download" title="DOWNLOAD" disabled>\n            <i class="fa fa-download" aria-hidden="true"></i>\n        </button>\n        <button type="button" class="btn btn-success btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-print" title="PRINT ALL SELECTED" disabled>\n            <i class="fa fa-print" aria-hidden="true"></i>\n        </button>\n        <button type="button" class="btn btn-success btn-sm action-btn" style="margin-top: 10px;" id="agg-sign-all" title="SIGN" disabled>\n            <i class="fa fa-pencil" aria-hidden="true"></i>\n        </button>\n        <button type="button" class="btn btn-success btn-sm action-btn" style="margin-top: 10px;" id="agg-addendum" title="ADD ADDENDUM" disabled>\n            <i class="fa fa-file-o" aria-hidden="true"></i>\n        </button>\n        <button type="button" class="btn btn-primary btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-assign" disabled>RE-ASSIGN</button>\n        <button type="button" class="btn btn-primary btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-add-patient" disabled>ADD PATIENT</button>\n        <button type="button" class="btn btn-primary btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-set-due" title="SET DUE" disabled>\n            <i class="fa fa-clock-o" aria-hidden="true"></i>\n        </button>\n        <button type="button" class="btn btn-primary btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-audit" title="AUDIT" disabled>\n            <i class="fa fa-comment-o" aria-hidden="true"></i>\n        </button>\n        <button type="button" class="btn btn-primary btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-send" title="SEND" disabled>\n            <i class="fa fa-envelope-o" aria-hidden="true"></i>\n        </button>\n        <div class="btn-group dropright">\n            <button type="button" class="btn btn-primary dropdown-toggle btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-mark-as"\n                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled>\n                Mark As\n            </button>\n            <ul class="dropdown-menu">\n                <li class="clickable"><a id="agg-stat-mark-as-sent">Sent</a></li>\n                <li class="clickable"><a id="agg-stat-mark-as-delivered">Delivered</a></li>\n            </ul>\n        </div>\n        <button type="button" class="btn btn-primary btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-open-selected"\n                title="Open selected documents in a new window" disabled>\n            <i class="fa fa-list" aria-hidden="true"></i>\n        </button>\n    </div>\n\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td class="center">\n    <a href="/api/document/view/'+
	((__t=( id ))==null?'':__t)+
	'" target="_blank" class="preview-doc" style="color:'+
	((__t=( color ))==null?'':__t)+
	';"><span class="clickable glyphicon glyphicon-eye-open"/></a>\n</td>\n<td class="center">\n    <a href="/api/document/download/'+
	((__t=( id ))==null?'':__t)+
	'" class="preview-doc" style="color:'+
	((__t=( color ))==null?'':__t)+
	';"><span class="clickable glyphicon glyphicon-floppy-disk"/></a>\n</td>\n<td class="center"><input type="checkbox" class="child_checkbox" ';
	 if (selected) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\n<td><a href="/#document/'+
	((__t=( id ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( name ))==null?'':__t)+
	'</a></td>\n<td>'+
	((__t=( rnsBarCode ))==null?'':__t)+
	'</td>\n<td>';
	 if (patient) { 
	__p+='<a href="/#person/'+
	((__t=( patient.id ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( toUpper(patient.name) ))==null?'':__t)+
	'</a>';
	 } else { 
	__p+=' - ';
	 } 
	__p+='</td>\n<td class="center">'+
	((__t=( fmCreatedTime ))==null?'':__t)+
	'</td>\n<td class="center">'+
	((__t=( fmDueTime ))==null?'':__t)+
	'</td>\n<td class="center">'+
	((__t=( fmSignedTime ))==null?'':__t)+
	'</td>\n<td>';
	 if (createdByObj) { 
	__p+='<a href="'+
	((__t=( createdByObj.url ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( toUpper(createdByObj.name) ))==null?'':__t)+
	'</a>';
	 } 
	__p+='</td>\n\n<td>\n    ';
	 for (var i in object.reviewers) { 
	__p+='\n\n    ';
	 if (object.reviewers[i].organizationId != null) { 
	__p+='\n    <a href="/#organization/'+
	((__t=( object.reviewers[i].organizationId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( toUpper(reviewersNames()[object.reviewers[i].organizationId]) ))==null?'':__t)+
	'</a>\n    ';
	 } 
	__p+='\n\n    ';
	 if (object.reviewers[i].organizationId == null) { 
	__p+='\n    <span/>\n    ';
	 } 
	__p+='\n\n    <br/>\n    ';
	 } 
	__p+='\n</td>\n<td>\n    ';
	 for (var i in object.reviewers) { 
	__p+='\n\n    ';
	 if (object.reviewers[i].personId != null) { 
	__p+='\n    <a href="/#person/'+
	((__t=( object.reviewers[i].personId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( toUpper(reviewersNames()[object.reviewers[i].personId]) ))==null?'':__t)+
	'</a>\n    ';
	 } 
	__p+='\n\n    ';
	 if (object.reviewers[i].personId == null ) { 
	__p+='\n    <span/>\n    ';
	 } 
	__p+='\n\n    <br/>\n    ';
	 } 
	__p+='\n</td>\n<td style="min-width: 120px;">'+
	((__t=( (intention ? intention.toUpperCase() : intention) ))==null?'':__t)+
	'</td>\n<td style="min-width: 140px;">'+
	((__t=( (status ? status.toUpperCase() : status) ))==null?'':__t)+
	'</td>\n';
	 if (showSendingMethods) { 
	__p+='\n<td>\n    ';
	 (preferredSendingMethods() || []).forEach(function(method){ 
	__p+='\n    ';
	 if (method === 'EMAIL') { 
	__p+=' <span class="glyphicon glyphicon-envelope sending-method" title="Email" data-toggle="tooltip"/> ';
	 } else  if (method === 'FAX') {  
	__p+='\n    <span class="glyphicon glyphicon-print sending-method" title="Fax" data-toggle="tooltip"/> ';
	 } else  if (method === 'PHONE'){ 
	__p+='\n    <span class="glyphicon glyphicon-earphone sending-method" title="Phone" data-toggle="tooltip"/> ';
	 } else if (method === 'REVIEW_AND_SIGN') {  
	__p+='\n    <span class="glyphicon glyphicon-home sending-method" title="Review And Sign" data-toggle="tooltip"/> ';
	 } else if (method === 'HAND_DELIVERY') { 
	__p+='\n    <span class="glyphicon glyphicon-hd-video sending-method" title="Hand Delivery" data-toggle="tooltip"/>';
	 } else if (method === 'MEDICITY') {  
	__p+='\n    <span class="sending-method" title="Direct Messaging" data-toggle="tooltip">XDR</span> ';
	 } else { 
	__p+='\n    <span>'+
	((__t=( method ))==null?'':__t)+
	'</span> ';
	 } 
	__p+='\n    ';
	 }) 
	__p+='\n</td>\n';
	 } 
	__p+='\n';
	 if (hasCustomContacts) { 
	__p+='\n<td class="center"><span class="glyphicon glyphicon-subtitles clickable custom-sending-methods" title="Document contacts"\n                         role="button" data-toggle="popover" data-placement="top" data-content=""/></td>\n';
	 } else { 
	__p+='\n<td class="center"><span class="glyphicon glyphicon-copyright-mark clickable sending-methods" title="Reviewer\'s contacts"\n                         role="button" data-toggle="popover" data-placement="top" data-content=""/></td>\n';
	 } 
	__p+='\n<td class="center">\n    <a href="/#document-history/'+
	((__t=( id ))==null?'':__t)+
	'" target="_blank" style="color:'+
	((__t=( deliveryConf.deliveryColor ))==null?'':__t)+
	';" title="'+
	((__t=( deliveryConf.deliveryTitle ))==null?'':__t)+
	'">\n        <span class="clickable glyphicon glyphicon-envelope"/>\n    </a>\n</td>';
	}
	return __p;
	};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if (!isSimple) { 
	__p+='\n<div class="requests-content">\n\n    <div class="col-md-12 col-xs-12 row">\n        <div class="col-md-4 col-xs-4">\n            <div id="patients-select"></div>\n        </div>\n\n        <div class="col-md-4 col-xs-4 ">\n            <input type="text" class="form-control filter-field" id="document-name" name="like_name"\n                   placeholder="Document Name"\n            ';
	 if (!_.isEmpty(getParam('like_name'))) { 
	__p+='\n            value="'+
	((__t=( getParam('like_name') ))==null?'':__t)+
	'"\n            ';
	 } 
	__p+='\n            />\n        </div>\n\n        <div class="col-md-4 col-xs-4" id="assigned-to-organizations-select"></div>\n    </div>\n\n    <div class="col-md-12 col-xs-12 row">\n        <div class="col-md-4 col-xs-4">\n            <input id="element-intentions"/>\n        </div>\n        <div class="col-md-4 col-xs-4">\n            <input id="element-statuses"/>\n        </div>\n        <div class="col-md-4 col-xs-4" id="assigned-to-persons-select"></div>\n    </div>\n</div>\n\n<div class="requests-content clickable right"><span id="show-more-filters" class="dotted-link">Advanced</span></div>\n\n<div class="requests-content" style="display:none;" id="more-filtes">\n    <div class="col-md-12 col-xs-12 row">\n        <div class="col-md-4 col-xs-4" id="created-by-select"></div>\n        <div class="col-md-4 col-xs-4">\n            <input id="doctypes"/>\n        </div>\n        <div class="col-md-4 col-xs-4">\n            <div class="input-daterange input-group col-md-12 col-xs-12" id="due-date-range">\n                <input type="text" class="form-control" id="due-after" placeholder="Due after"\n                       name="object_dueDate_from"\n                ';
	 if (getDateTimeParam('object_dueDate_from')){ 
	__p+=' value='+
	((__t=( getDateTimeParam('object_dueDate_from') ))==null?'':__t)+
	'\n                ';
	 } 
	__p+='\n                />\n                <span class="input-group-addon" style="width:10px;">to</span>\n                <input type="text" class="form-control" id="due-before" placeholder="Due before"\n                       name="object_dueDate_to"\n                ';
	 if (getDateTimeParam('object_dueDate_to')){ 
	__p+=' value='+
	((__t=( getDateTimeParam('object_dueDate_to') ))==null?'':__t)+
	' ';
	
	                } 
	__p+='\n                />\n            </div>\n        </div>\n    </div>\n    <div class="col-md-12 col-xs-12 row">\n        <div class="col-md-4 col-xs-4">\n            <select id="delivery-statuses">\n                <option value=""></option>\n                <option value="all">ALL</option>\n                <option value="delivered"\n                ';
	 if (getParam('object_lastDeliveredTime_from') == '1') { 
	__p+=' selected ';
	 } 
	__p+=' >DELIVERED</option>\n                <option value="not_delivered"\n                ';
	 if (getParam('object_lastDeliveredTime') == '0' && getParam('object_lastSentTime_from') == '1') { 
	__p+='\n                selected ';
	 } 
	__p+=' >NOT DELIVERED</option>\n                <option value="not_sent"\n                ';
	 if (getParam('object_lastSentTime') == '0') { 
	__p+=' selected ';
	 } 
	__p+=' >NOT SENT</option>\n            </select>\n        </div>\n        <div class="col-md-4 col-xs-4 ">\n            <input type="text" class="form-control filter-field" id="alias" name="alias"\n                   placeholder="Alias"\n            ';
	 if (!_.isEmpty(getParam('alias'))) { 
	__p+='\n            value="'+
	((__t=( getParam('alias') ))==null?'':__t)+
	'"\n            ';
	 } 
	__p+='\n            />\n        </div>\n        <div class="col-md-4 col-xs-4">\n            <div class="input-daterange input-group col-md-12 col-xs-12" id="signed-range">\n                <input type="text" class="form-control" id="signed-after" placeholder="Signed after"\n                       name="object_signedTime_from"\n                ';
	 if (getDateTimeParam('object_signedTime_from')){ 
	__p+=' value='+
	((__t=(
	                getDateTimeParam('object_signedTime_from') ))==null?'':__t)+
	' ';
	 } 
	__p+='\n                />\n                <span class="input-group-addon" style="width: 10px;">to</span>\n                <input type="text" class="form-control" id="signed-before" placeholder="Signed before"\n                       name="object_signedTime_to"\n                ';
	 if (getDateTimeParam('object_signedTime_to')){ 
	__p+=' value='+
	((__t=( getDateTimeParam('object_signedTime_to')
	                ))==null?'':__t)+
	' ';
	 } 
	__p+='\n                />\n            </div>\n        </div>\n    </div>\n    <div class="col-md-12 col-xs-12 row">\n        <div class="col-md-4 col-xs-4" id="signed-by-organizations-select"></div>\n        <div class="col-md-4 col-xs-4" id="signed-by-persons-select"></div>\n        <div class="col-md-4 col-xs-4" id="uploader-persons-select"></div>\n    </div>\n    <div class="col-md-12 col-xs-12 row">\n        <div class="col-md-4 col-xs-4">\n            <div class="input-daterange input-group col-md-12 col-xs-12" id="doc-created-range">\n                <input type="text" class="form-control" id="docCreatedAfter" placeholder="Created after"\n                       name="object_createdTime_from"\n                ';
	 if (getDateParam('object_createdTime_from')){ 
	__p+=' value='+
	((__t=( getDateParam('object_createdTime_from') ))==null?'':__t)+
	'\n                ';
	 } 
	__p+='\n                />\n                <span class="input-group-addon" style="width: 10px;">to</span>\n                <input type="text" class="form-control" id="docCreatedBefore" placeholder="Created before"\n                       name="object_createdTime_to"\n                ';
	 if (getDateParam('object_createdTime_to')){ 
	__p+=' value='+
	((__t=( getDateParam('object_createdTime_to') ))==null?'':__t)+
	' ';
	
	                } 
	__p+='\n                />\n            </div>\n        </div>\n        <div class="col-md-4 col-xs-4">\n            <div class="input-daterange input-group col-md-12 col-xs-12" id="doc-uploaded-range">\n                <input type="text" class="form-control" id="createdAfter" placeholder="Uploaded after"\n                       name="from_createdTime"\n                ';
	 if (getDateParam('from_createdTime')){ 
	__p+=' value='+
	((__t=( getDateParam('from_createdTime') ))==null?'':__t)+
	' ';
	 } 
	__p+='\n                />\n                <span class="input-group-addon" style="width: 10px;">to</span>\n                <input type="text" class="form-control" id="createdBefore" placeholder="Uploaded before"\n                       name="to_createdTime"\n                ';
	 if (getDateParam('to_createdTime')){ 
	__p+=' value='+
	((__t=( getDateParam('to_createdTime') ))==null?'':__t)+
	' ';
	 } 
	__p+='\n                />\n            </div>\n        </div>\n        <div class="col-md-4 col-xs-4">\n            <div class="input-daterange input-group col-md-12 col-xs-12" id="delivered-range">\n                <input type="text" class="form-control" id="delivered-after" placeholder="Delivered after"\n                       name="object_deliveredTime_from"\n                ';
	 if (getDateTimeParam('object_lastDeliveredTime_from')){ 
	__p+=' value='+
	((__t=(
	                getDateTimeParam('object_lastDeliveredTime_from') ))==null?'':__t)+
	' ';
	 } 
	__p+='\n                />\n                <span class="input-group-addon" style="width:10px;">to</span>\n                <input type="text" class="form-control" id="delivered-before" placeholder="Delivered before"\n                       name="object_deliveredTime_to"\n                ';
	 if (getDateTimeParam('object_lastDeliveredTime_to')){ 
	__p+=' value='+
	((__t=(
	                getDateTimeParam('object_lastDeliveredTime_to') ))==null?'':__t)+
	' ';
	 } 
	__p+='\n                />\n            </div>\n        </div>\n    </div>\n\n    <div class="col-md-12 col-xs-12 row" style="margin-top: 5px;margin-bottom: 20px;">\n        <div class="col-md-4 col-xs-4 ">\n            <input type="text" class="form-control filter-field" id="rns-bar-code" name="object_barcode"\n                   placeholder="Barcode"\n            ';
	 if (!_.isEmpty(getParam('object_barcode'))) { 
	__p+='\n            value="'+
	((__t=( getParam('object_barcode') ))==null?'':__t)+
	'"\n            ';
	 } 
	__p+='\n            />\n        </div>\n        ';
	 if (getParam('commentId') != ''){ 
	__p+='\n        <div class="col-md-2 col-xs-2">\n            <div class="input-daterange input-group" style="width:250px;">\n                <input type="text" class="form-control" id="comment-id" placeholder="Comment id"\n                       name="commentId" style="width:216px;" disabled\n                       value=\'Comment selected\'/>\n                <span class="input-group-addon clickable" id=\'remove-comment-filter\'>X</span>\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n    </div>\n\n</div>\n\n<div class="requests-content top-margined">\n    <div class="form-inline form" style="margin-top: 10px;">\n        <div class="form-group">\n            <button type="button" class="btn btn-primary" id="requests-filter">Filter</button>\n        </div>\n        <div class="form-group" id="clear-filter-container" style="display: none">\n            <button type="button" class="btn btn-primary" title="Clear filter" id="clear-filter">Clear filter</button>\n        </div>\n        ';
	 if (viewAllMode) { 
	__p+='\n        <div class="form-group">\n            <button type="button" class="btn btn-warning" id="show-documents-statistics">Statistics</button>\n        </div>\n        <div class="form-group">\n            <button type="button" class="btn btn-warning" id="show-documents-statistics-aggregate">Sorter</button>\n        </div>\n        ';
	 } 
	__p+='\n    </div>\n</div>\n\n\n';
	 } 
	__p+='\n\n<div class="loading"></div>\n<div id="documents-list-container">\n    <table class="table-striped table-hover table-condensed" style="width: 100%">\n        <head>\n            <thead class="thead-default">\n            <tr>\n                <th></th>\n                <th><b>All</b></th>\n                <th class="center">\n                    <input type="checkbox" id="root_check">\n                </th>\n                <th class="clickable sort-header" id="name">Document\n                    <div class="'+
	((__t=( getClassesForSortingHeader('name')))==null?'':__t)+
	'"></div>\n                </th>\n                <th>Barcode</th>\n                <th class="clickable sort-header" id="patientName">Patient\n                    <div class="'+
	((__t=( getClassesForSortingHeader('patientName')))==null?'':__t)+
	'"></div>\n                </th>\n                <th class="clickable sort-header" id="documentCreationTime">Date\n                    <div class="'+
	((__t=( getClassesForSortingHeader('documentCreationTime')))==null?'':__t)+
	'"></div>\n                </th>\n                <th class="clickable sort-header" id="dueDate">Due\n                    <div class="'+
	((__t=( getClassesForSortingHeader('dueDate')))==null?'':__t)+
	'"></div>\n                </th>\n                <th class="clickable sort-header" id="signedDate">Signed\n                    <div class="'+
	((__t=( getClassesForSortingHeader('signedDate')))==null?'':__t)+
	'"></div>\n                </th>\n                <th class="clickable sort-header" id="createdByOrgName">Requesting Organization\n                    <div class="'+
	((__t=( getClassesForSortingHeader('createdByOrgName')))==null?'':__t)+
	'"></div>\n                </th>\n                <th class="clickable sort-header" id="orgReviewerName">Reviewing Organization\n                    <div class="'+
	((__t=( getClassesForSortingHeader('orgReviewerName')))==null?'':__t)+
	'"></div>\n                </th>\n                <th class="clickable sort-header" id="reviewerName">Reviewer\n                    <div class="'+
	((__t=( getClassesForSortingHeader('reviewerName')))==null?'':__t)+
	'"></div>\n                </th>\n                <th class="clickable sort-header" id="intention" style="min-width: 120px;">Request\n                    <div class="'+
	((__t=( getClassesForSortingHeader('intention')))==null?'':__t)+
	'"></div>\n                </th>\n                <th class="clickable sort-header" id="status" style="min-width: 140px;">Status\n                    <div class="'+
	((__t=( getClassesForSortingHeader('status')))==null?'':__t)+
	'"></div>\n                </th>\n                ';
	 if (showSendingMethods) { 
	__p+='\n                <th>Sending methods</th>\n                ';
	 } 
	__p+='\n                <th>Contacts</th>\n                <th></th>\n            </tr>\n            </thead>\n        </head>\n        <tbody id="documents-list"></tbody>\n    </table>\n    <div>\n        ';
	 if (isMd || isMedicalDirector || isAdmin || isManager) { 
	__p+='\n        <button type="button" class="btn btn-success btn-md" class="toggle" id="sign-all" title="SIGN" disabled>\n            <i class="fa fa-pencil" aria-hidden="true"></i>\n        </button>\n        ';
	 if (!isSimple) { 
	__p+='\n        <button type="button" class="btn btn-success btn-md" class="toggle" id="sign-and-get" title="SIGN AND GET"\n                disabled>\n            <i class="fa fa-pencil" aria-hidden="true"></i>\n            <i class="fa fa-download" aria-hidden="true"></i>\n        </button>\n        ';
	 } 
	__p+='\n        ';
	 } 
	__p+='\n        <button type="button" class="btn btn-success btn-md" class="toggle" id="download" title="DOWNLOAD" disabled>\n            <i class="fa fa-download" aria-hidden="true"></i>\n        </button>\n        <button type="button" class="btn btn-success btn-md" class="toggle" id="print" title="PRINT ALL SELECTED"\n                disabled>\n            <i class="fa fa-print" aria-hidden="true"></i>\n        </button>\n        ';
	 if (notForToReview && (isMedicalDirector || isOfficeAdministrator || isManager || isAdmin || byAdmin)) { 
	__p+='\n        <button type="button" class="btn btn-success btn-md" class="toggle" id="assign" disabled>RE-ASSIGN</button>\n        <button type="button" class="btn btn-success btn-md" class="toggle" id="add-patient" disabled>ADD PATIENT\n        </button>\n        <button type="button" class="btn btn-success btn-md" class="toggle" id="set-due" title="SET DUE" disabled>\n            <i class="fa fa-clock-o" aria-hidden="true"></i>\n        </button>\n        <div class="btn-group">\n            <button type="button" class="btn btn-success btn-md" class="toggle" id="audit" title="AUDIT" disabled>\n                <i class="fa fa-comment-o" aria-hidden="true"></i>\n            </button>\n            <button type="button" class="btn btn-success dropdown-toggle" id="audit-more"\n                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n                <span class="caret"></span>\n                <span class="sr-only">Toggle Dropdown</span>\n            </button>\n            <ul class="dropdown-menu">\n                <li class="clickable"><a id="audit-bulk">Audit all by filter</a></li>\n            </ul>\n        </div>\n        ';
	 } 
	__p+='\n        ';
	 if (viewAllMode && (isManager || isAdmin || byAdmin)) { 
	__p+='\n        <div class="btn-group">\n            <button type="button" class="btn btn-success btn-md" class="toggle" id="send" title="SEND" disabled>\n                <i class="fa fa-envelope-o" aria-hidden="true"></i>\n            </button>\n            <button type="button" class="btn btn-success dropdown-toggle" id="send-more"\n                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n                <span class="caret"></span>\n                <span class="sr-only">Toggle Dropdown</span>\n            </button>\n            <ul class="dropdown-menu">\n                <li class="clickable"><a id="send-bulk">Send all by filter</a></li>\n            </ul>\n        </div>\n        <button type="button" class="btn btn-success btn-md" class="toggle" id="addendum" title="ADD ADDENDUM" disabled>\n            <i class="fa fa-file-o" aria-hidden="true"></i>\n        </button>\n        <div class="btn-group">\n            <button type="button" class="btn btn-success dropdown-toggle" id="mark-as"\n                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled>\n                Mark As\n            </button>\n            <ul class="dropdown-menu">\n                <li class="clickable"><a id="mark-as-sent">Sent</a></li>\n                <li class="clickable"><a id="mark-as-delivered">Delivered</a></li>\n            </ul>\n        </div>\n        ';
	 } 
	__p+='\n        <div class="btn-group">\n            <button type="button" class="btn btn-success btn-md" class="toggle" id="export" title="EXPORT" disabled>\n                <i class="fa fa-file-excel-o" aria-hidden="true"></i>\n            </button>\n            <button type="button" class="btn btn-success dropdown-toggle" id="export-more"\n                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n                <span class="caret"></span>\n                <span class="sr-only">Toggle Dropdown</span>\n            </button>\n            <ul class="dropdown-menu">\n                <li class="clickable"><a id="export-bulk">Export all by filter</a></li>\n            </ul>\n        </div>\n        <div class="btn-group">\n            <button type="button" class="btn btn-success btn-md" class="toggle" id="time-frame-selected"\n                    title="TIMEFRAME SELECTED" disabled>\n                TIMEFRAME\n            </button>\n            <button type="button" class="btn btn-success dropdown-toggle" id="time-frame"\n                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n                <span class="caret"></span>\n                <span class="sr-only">Toggle Dropdown</span>\n            </button>\n            <ul class="dropdown-menu">\n                <li class="clickable"><a id="time-frame-monthly-filtered">Monthly</a></li>\n                <li class="clickable"><a id="time-frame-weekly-filtered">Weekly</a></li>\n                <li class="clickable"><a id="time-frame-daily-filtered">Daily</a></li>\n            </ul>\n        </div>\n        <div id="error-message" class="pull-right" style="color:red;"></div>\n    </div>\n</div>\n\n<div class="modal fade" id="documents-statistics-modal" tabindex="-1" role="dialog">\n    <div class="modal-dialog modal-lg">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal">&times;</button>\n                <span class="pull-right" style="margin-right:20px;"> <a href="http://notificator.reviewandsign.org"\n                                                                        target="_blank">Fax Status</a></span>\n                <h4 class="modal-title">\n                    Statistics Report\n                </h4>\n            </div>\n            <div class="modal-body" style="min-height: 200px;max-height: 100%;overflow: auto;">\n                <div id="data-loader" class="loader"></div>\n                <div id="documents-statistics-content"></div>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>\n            </div>\n        </div>\n\n    </div>\n</div>\n\n<div class="modal fade" id="documents-statistics-aggregate-modal" tabindex="-1" role="dialog">\n    <div class="modal-dialog modal-lg higher-wider">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal">&times;</button>\n                <span class="pull-right" style="margin-right:20px;">\n                    <a href="http://notificator.reviewandsign.org" target="_blank">Fax Status</a></span>\n                <span class="pull-right" style="margin-right:20px;">\n                    <span class="dropdown">\n                        <a href="#" class="dropdown-toggle" id="drop2" data-toggle="dropdown" role="button"\n                           aria-haspopup="true" aria-expanded="false">\n                            <span class="date">View</span>\n                            <span class="caret"></span>\n                        </a>\n                        <ul class="dropdown-menu" aria-labelledby="drop2">\n                            <li><a id="set-initial-for-me" class="clickable">Set current view as initial for me</a></li>\n                            ';
	 if (isAdmin) { 
	__p+='\n                            <li role="separator" class="divider"></li>\n                            <li><a id="set-initial" class="clickable">Set current view as initial for</a></li>\n                            ';
	 } 
	__p+='\n                        </ul>\n                    </span>\n                </span>\n                <h4 class="modal-title">\n                    Sorting Report\n                </h4>\n            </div>\n            <div class="modal-body" style="min-height: 400px;max-height: 100%;overflow: auto;">\n                <div id="data-loader-aggregate" class="loader"></div>\n                <div id="documents-statistics-aggregate-content"></div>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>\n            </div>\n        </div>\n\n    </div>\n</div>\n\n<div class="modal fade" id="sign-before-leave-confirmation-modal" tabindex="-1" role="dialog">\n    <div class="modal-dialog modal-sm">\n        <div class="modal-content">\n            <div class="modal-header">\n                <h4 class="modal-title">\n                    WARNING\n                </h4>\n            </div>\n            <div class="modal-body">\n                You are about to leave this page of documents. Would you like to sign those that have already been\n                selected? Please note, if you do not sign these documents now, they will not be signed as you move to\n                the next page.\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-primary" id="sign-before-leave-confirmation-sign">Sign</button>\n                <button type="button" class="btn btn-danger" id="sign-before-leave-confirmation-cancel">Leave this\n                    page\n                </button>\n                <button type="button" class="btn btn-primary" id="sign-before-leave-confirmation-close">Cancel</button>\n            </div>\n        </div>\n\n    </div>\n</div>\n\n<div id="initial-view-modal"></div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(310);
	__webpack_require__(300);
	
	var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var utils = new CommonUtils();
	
	var Pager = Marionette.View.extend({
	    template: __webpack_require__(311),
	
	    model: new Backbone.Model(),
	
	    ui: {
	        pagerContent: '#pager-content',
	        pageSize: '#page-size'
	    },
	
	    events: {
	        'change @ui.pageSize': 'onPageSizeChanged'
	    },
	
	    templateContext: function () {
	        return {
	            pageSize: Constants.pageCapacity
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'renderPager');
	        var that = this;
	        this.items = [];
	        this.params = [];
	        if (options) {
	            this.baseCountUrl = options.baseCountUrl;
	            this.pagesToDisplay = options.pagesToDisplay;
	            this.callbackFunctions = options.callbackFunctions;
	        }
	        this.pagesToDisplay = this.pagesToDisplay || 10;
	        this.baseCountUrl = this.baseCountUrl || '/api/dbo/count';
	
	        var paramsTokens = window.location.hash.split("?");
	        if (paramsTokens.length > 1) {
	            if (this.baseCountUrl.indexOf("?") > 0)
	                this.baseCountUrl += "&" + paramsTokens[1];
	            else
	                this.baseCountUrl += "?" + paramsTokens[1];
	        }
	
	        this.params = utils.getDefaultListParams();
	        this.baseHash = utils.getCleanBaseHash();
	
	        $.ajax({
	            type: "GET",
	            url: this.baseCountUrl,
	            statusCode: {
	                200: function (response) {
	                    that.calculateAttributes(response);
	                    that.renderPager();
	                    that.triggerMethod('pager:count:change', response);
	
	                    if (response == 0) {
	                        that.hidePageSize()
	                    }
	                }
	            },
	            error: function (e) {
	                console.log(e);
	            }
	        });
	    },
	
	    calculateAttributes: function (count) {
	        this.total = count / this.params['page-size'] | 0;
	        if (count % this.params['page-size'] > 0) {
	            this.total++;
	        }
	    },
	
	    renderPager: function () {
	        var that = this;
	        $(this.ui.pagerContent).bootpag({
	            total: this.total,
	            maxVisible: this.pagesToDisplay,
	            page: this.params.page + 1,
	            firstLastUse: true,
	            first: 'FIRST',
	            last: 'LAST'
	        }).on("page", function (event, num) {
	
	            if (that.callbackFunctions && _.isFunction(that.callbackFunctions.signDocuments)) {
	                that.callbackFunctions.signDocuments(function() {
	                    that.params.page = num - 1;
	                    window.location.hash = that.baseHash + "?" + utils.objectToQueryParams(that.params)
	                    that.renderPager();
	                });
	            } else {
	                that.params.page = num - 1;
	                window.location.hash = that.baseHash + "?" + utils.objectToQueryParams(that.params)
	            }
	        });
	    },
	
	    onPageSizeChanged: function(event) {
	        var val = event.target.value
	        Constants.pageCapacity = val
	        this.params["page-size"] = val
	        this.params["page"] = 0;
	        window.location.hash = this.baseHash + "?" + utils.objectToQueryParams(this.params)
	    },
	
	    hidePageSize: function() {
	        this.ui.pageSize.remove()
	    }
	
	});
	
	module.exports = Pager;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*
	
	 bootpag - jQuery plugin for dynamic pagination
	
	 Copyright (c) 2015 botmonster@7items.com
	
	 Licensed under the MIT license:
	   http://www.opensource.org/licenses/mit-license.php
	
	 Project home:
	   http://botmonster.com/jquery-bootpag/
	
	 Version:  1.0.7
	
	*/
	(function(h,q){h.fn.bootpag=function(p){function m(c,b){b=parseInt(b,10);var d,e=0==a.maxVisible?1:a.maxVisible,k=1==a.maxVisible?0:1,n=Math.floor((b-1)/e)*e,f=c.find("li");a.page=b=0>b?0:b>a.total?a.total:b;f.removeClass(a.activeClass);d=1>b-1?1:a.leaps&&b-1>=a.maxVisible?Math.floor((b-1)/e)*e:b-1;a.firstLastUse&&f.first().toggleClass(a.disabledClass,1===b);e=f.first();a.firstLastUse&&(e=e.next());e.toggleClass(a.disabledClass,1===b).attr("data-lp",d).find("a").attr("href",g(d));k=1==a.maxVisible?
	0:1;d=b+1>a.total?a.total:a.leaps&&b+1<a.total-a.maxVisible?n+a.maxVisible+k:b+1;e=f.last();a.firstLastUse&&(e=e.prev());e.toggleClass(a.disabledClass,b===a.total).attr("data-lp",d).find("a").attr("href",g(d));f.last().toggleClass(a.disabledClass,b===a.total);e=f.filter("[data-lp="+b+"]");k="."+[a.nextClass,a.prevClass,a.firstClass,a.lastClass].join(",.");if(!e.not(k).length){var m=b<=n?-a.maxVisible:0;f.not(k).each(function(b){d=b+1+n+m;h(this).attr("data-lp",d).toggle(d<=a.total).find("a").html(d).attr("href",
	g(d))});e=f.filter("[data-lp="+b+"]")}e.not(k).addClass(a.activeClass);l.data("settings",a)}function g(c){return a.href.replace(a.hrefVariable,c)}var l=this,a=h.extend({total:0,page:1,maxVisible:null,leaps:!0,href:"javascript:void(0);",hrefVariable:"{{number}}",next:"&raquo;",prev:"&laquo;",firstLastUse:!1,first:'<span aria-hidden="true">&larr;</span>',last:'<span aria-hidden="true">&rarr;</span>',wrapClass:"pagination",activeClass:"active",disabledClass:"disabled",nextClass:"next",prevClass:"prev",
	lastClass:"last",firstClass:"first"},l.data("settings")||{},p||{});if(0>=a.total)return this;h.isNumeric(a.maxVisible)||a.maxVisible||(a.maxVisible=parseInt(a.total,10));l.data("settings",a);return this.each(function(){var c,b,d=h(this);c=['<ul class="',a.wrapClass,' bootpag">'];a.firstLastUse&&(c=c.concat(['<li data-lp="1" class="',a.firstClass,'"><a href="',g(1),'">',a.first,"</a></li>"]));a.prev&&(c=c.concat(['<li data-lp="1" class="',a.prevClass,'"><a href="',g(1),'">',a.prev,"</a></li>"]));for(b=
	1;b<=Math.min(a.total,a.maxVisible);b++)c=c.concat(['<li data-lp="',b,'"><a href="',g(b),'">',b,"</a></li>"]);a.next&&(b=a.leaps&&a.total>a.maxVisible?Math.min(a.maxVisible+1,a.total):2,c=c.concat(['<li data-lp="',b,'" class="',a.nextClass,'"><a href="',g(b),'">',a.next,"</a></li>"]));a.firstLastUse&&(c=c.concat(['<li data-lp="',a.total,'" class="last"><a href="',g(a.total),'">',a.last,"</a></li>"]));c.push("</ul>");d.find("ul.bootpag").remove();d.append(c.join(""));c=d.find("ul.bootpag");d.find("li").click(function(){var b=
	h(this);if(!b.hasClass(a.disabledClass)&&!b.hasClass(a.activeClass)){var c=parseInt(b.attr("data-lp"),10);l.find("ul.bootpag").each(function(){m(h(this),c)});l.trigger("page",c)}});m(c,a.page)})}})(jQuery,window);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\n    <div id="pager-content" style="float:left"></div>\n    <div style="display: inline-block; padding-left: 20px;">\n        <select id="page-size" class="form-control page-sizer">\n            <option value="20"\n            ';
	 if (pageSize == 20) { 
	__p+=' selected ';
	 } 
	__p+=' >20</option>\n            <option value="50"\n            ';
	 if (pageSize == 50) { 
	__p+=' selected ';
	 } 
	__p+=' >50</option>\n            <option value="100"\n            ';
	 if (pageSize == 100) { 
	__p+=' selected ';
	 } 
	__p+=' >100</option>\n        </select>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var PasswordConfirmation = Marionette.View.extend({
	    template: __webpack_require__(313),
	
	    ui: {
	        modal: '#password-confirmation-modal',
	        btn: '#sign-button',
	        close: '#close',
	        passwordGroup: '#password-group',
	        plainPassword: '#plain-password',
	        messagePassword: '#message-password'
	    },
	    events: {
	        'click @ui.btn': 'signDocument',
	        'keypress': 'onKeyPress',
	        'click @ui.close': 'close'
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'signDocument');
	        if (options.action)
	            this.action = options.action;
	        if (options.id)
	            this.id = options.id;
	    },
	    signDocument: function () {
	        if (this.ui.plainPassword.val() != "") {
	            if (this.id)
	                this.action(this.id, 'SIGNED', this.ui.plainPassword.val());
	            else if (this.ids) {
	                this.action(this.fn, this.ids, this.ui.plainPassword.val());
	            } else {
	                console.log("id and ids ia empty");
	            }
	            this.ui.modal.modal('hide');
	            $('body').removeClass('modal-open');
	            $('.modal-backdrop').remove();
	        } else {
	            this.ui.passwordGroup.addClass('has-error');
	            this.ui.messagePassword.text("Password can't be empty.");
	        }
	    },
	    onKeyPress: function (e) {
	        if (e.keyCode == 13)
	            this.signDocument();
	    },
	    setDocumentId: function (id) {
	        this.id = id;
	    },
	    setAction: function (action) {
	        this.action = action;
	    },
	    showPasswordConfirmation: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	    setIds: function (ids) {
	        this.ids = ids;
	    },
	    setFn: function (fn) {
	        this.fn = fn;
	    },
	    setCancelAction: function (action) {
	        this.cancelAction = action;
	    },
	
	    close: function() {
	        if (_.isFunction(this.cancelAction)) {
	            this.cancelAction();
	        }
	        this.ui.modal.modal('hide');
	    }
	});
	
	module.exports = PasswordConfirmation;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="modal fade" id="password-confirmation-modal" tabindex="-1" role="dialog">\n    <div class="modal-dialog">\n\n        <div class="modal-content">\n            <div class="modal-header">\n                <h4 class="modal-title">Signature confirmation</h4>\n            </div>\n            <div class="modal-body form-group" id="password-group">\n                <label class="control-label" for="plain-password" id="message-password">Please enter your password and press Sign</label>\n                <input class="form-control" type="password" placeholder="Your password" id="plain-password"/>\n            </div>\n            <div class="modal-body">\n                <label>\n                    Disclaimer: By electronically signing this document the case manager is indicating their acceptance and agreement with the course of action taken as outlined in this MIF.\n                    By electronically signing this document, you acknowledge that you intend to be bound by your electronic signature and you signing and attesting to this document under penalty of perjury.\n                    You acknowledge that you have been given a unique login and password to manage your electronic signature. You are not to share this login and password with anyone and should take precautions to keep this information secure. You should log out after each use of your electronic signature.\n                </label>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-success" id="sign-button">Sign</button>\n                <button type="button" class="btn btn-default" id="close">Close</button>\n            </div>\n        </div>\n\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var ReviewerFormView = __webpack_require__(315);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	
	var AssignAndUpdateReviewersForm = Marionette.View.extend({
	    template: __webpack_require__(317),
	
	    regions: {},
	
	    ui: {
	        modal: '#addReviewersModal',
	        reviewers: '.reviewers-review',
	        saveReviewers: '#save',
	        addReviewer: '.add-reviewer'
	    },
	
	    events: {
	        'click @ui.addReviewer': 'addReviewer',
	        'click @ui.saveReviewers': 'saveReviewers'
	    },
	
	    childViewEvents: {
	        'reviewer:will-be-remove': 'reviewerRemove',
	        'reviewer:re-render': 'reviewerRerender',
	        'reviewer:changed': 'onReviewerChanged'
	    },
	
	    initReviewer: function () {
	        var that = this;
	        return {
	            originalReviewer: null,
	            beingUpdatedReviewer: {
	                organizationId: '',
	                personId: '',
	                mandatory: true
	            },
	            documentsIds: that.docIds
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.reviewersAndDocuments = options.reviewersAndDocuments;
	        that.utils = new CommonUtils();
	        that.docIds = options.documentsIds;
	        that.getReviewerName = options.getReviewerName;
	    },
	
	    onRender: function () {
	        var that = this;
	        this.renderExistedReviewers();
	        that.show();
	    },
	
	    renderExistedReviewers: function () {
	        var that = this;
	        (that.reviewersAndDocuments || [])
	            .forEach(function (reviewer) {
	                that.constructReviewersRow(reviewer);
	            });
	    },
	
	    addReviewer: function () {
	        var reviewer = this.initReviewer();
	        this.reviewersAndDocuments.push(reviewer);
	        this.constructReviewersRow(reviewer, true);
	    },
	
	    constructReviewersRow: function (reviewer, isNew) {
	        var newRegionId = _.uniqueId('reviewer');
	        this.ui.reviewers.append('<div id="' + newRegionId + '"></div>');
	        this.addRegion(newRegionId, "#" + newRegionId);
	        this.storeRegion(newRegionId);
	
	        this.showChildView(newRegionId, new ReviewerFormView({
	            reviewer: reviewer.beingUpdatedReviewer,
	            regionId: newRegionId,
	            getReviewerName: this.getReviewerName,
	            obsoleteInsteadOfRemove: !isNew ? true : false
	        }));
	
	        this.checkReviewers();
	    },
	
	    reviewerRemove: function (data) {
	        var that = this;
	        var regionId = data.regionId;
	        var reviewer = data.reviewer;
	        that.getRegion(regionId).empty();
	        that.removeRegion(regionId);
	        that.$('#' + regionId).remove();
	        this.tempRegionNames = this.tempRegionNames.filter(function (item) {
	            return item !== regionId;
	        });
	        that.reviewersAndDocuments.forEach(function (item) {
	            if (item.beingUpdatedReviewer == reviewer) {
	                item.beingUpdatedReviewer = null;
	            }
	        });
	        that.reviewersAndDocuments = that.reviewersAndDocuments.filter(function (row) {
	            return row.originalReviewer != null || row.beingUpdatedReviewer != null;
	        });
	        that.checkReviewers();
	    },
	
	    reviewerRerender: function (regionId) {
	        this.getChildView(regionId).render();
	    },
	
	    saveReviewers: function () {
	
	        if (this.reviewersAndDocuments.length == 0 || this.docIds == [] || _.isEmpty(this.docIds))
	            return;
	
	        var that = this;
	        that.utils.showSpinner('#add-reviewers-loader');
	        $.ajax({
	            type: "POST",
	            url: '/api/document/bulk/reviewers',
	            data: JSON.stringify(this.transformReviewersAndDocuments()),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner('#add-reviewers-loader');
	                    that.reviewersSaved();
	                    $.notify({
	                        message: 'Reviewers assigned successfully'
	                    }, {
	                        type: 'success',
	                        z_index: 2000,
	                    });
	                    if (that.getOption("woResponseEvent") !== true)
	                        that.triggerMethod('reviewers:added:to:document');
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner('#add-reviewers-loader');
	                notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        });
	    },
	
	    transformReviewersAndDocuments: function () {
	        var that = this;
	        var documentAndReviewers = {};
	        that.reviewersAndDocuments.forEach(function (reviewersAndDocument) {
	            reviewersAndDocument.documentsIds.forEach(function (documentId) {
	                if (!documentAndReviewers[documentId]) {
	                    documentAndReviewers[documentId] = [
	                        {
	                            originalReviewer: reviewersAndDocument.originalReviewer,
	                            beingUpdatedReviewer: reviewersAndDocument.beingUpdatedReviewer
	                        }
	                    ]
	                } else {
	                    documentAndReviewers[documentId].push(
	                        {
	                            originalReviewer: reviewersAndDocument.originalReviewer,
	                            beingUpdatedReviewer: reviewersAndDocument.beingUpdatedReviewer
	                        }
	                    );
	                }
	            });
	        });
	
	        return _.keys(documentAndReviewers).map(function (key) {
	            return {
	                documentId: key,
	                reviewerDiffs: documentAndReviewers[key]
	            }
	        });
	    },
	
	    reviewersSaved: function () {
	        var that = this;
	        if (that.tempRegionNames) {
	            that.tempRegionNames.forEach(function (item) {
	                that.getRegion(item).empty();
	                that.removeRegion(item);
	                that.$('#' + item).remove();
	            });
	        }
	        that.tempRegionNames = [];
	        that.reviewersAndDocuments = [];
	        that.hide();
	    },
	
	    deleteRegion: function (regionId) {
	        this.getRegion(regionId).empty();
	        this.removeRegion(regionId);
	        this.$('#' + regionId).remove();
	    },
	
	    storeRegion: function (regionName) {
	        this.tempRegionNames = this.tempRegionNames || [];
	        this.tempRegionNames.push(regionName);
	    },
	
	    show: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    },
	
	    onReviewerChanged: function () {
	        this.checkReviewers();
	    },
	
	    checkReviewers: function () {
	        var that = this;
	        if (that.reviewersAndDocuments.filter(function (reviewer) {
	                return reviewer.originalReviewer || reviewer.beingUpdatedReviewer.organizationId || reviewer.beingUpdatedReviewer.personId;
	            }).length == that.reviewersAndDocuments.length)
	            that.ui.saveReviewers.removeAttr('disabled');
	        else
	            that.ui.saveReviewers.attr('disabled', true);
	    }
	});
	
	module.exports = AssignAndUpdateReviewersForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var RemoteSuggesterView = __webpack_require__(196);
	
	var ReviewerFormView = Marionette.View.extend({
	    template: __webpack_require__(316),
	
	    regions: {
	        persons: '#persons',
	        organizations: '#organizations'
	    },
	
	    ui: {
	        persons: '#persons',
	        organizations: '#organizations',
	        mandatory: '#mandatory'
	    },
	
	    events: {
	        'click .remove-reviewer': 'removeReviewer',
	        'click #mandatory': 'mandatoryChanged'
	    },
	
	    childViewEvents: {
	        'suggestor:selected:person': 'personChanged',
	        'suggestor:selected:organization': 'organizationChanged'
	    },
	
	    constants: {
	        maxNumberOfItemsInControlWithSuggester: 20
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            showRemove: this.showRemove,
	            mandatory: this.reviewer.mandatory ? 'checked' : '',
	            removeButtonText: this.obsoleteInsteadOfRemove ? (this.reviewer.status == 'DELETED' ? "Undo obsolete" : "Obsolete reviewer") : "Remove reviewer",
	            status: this.reviewer.status
	        }
	    },
	
	
	    initialize: function (options) {
	        //_.bindAll(this, 'personChanged', 'organizationChanged', 'removeReviewer', 'mandatoryChanged', 'disableInputsByConf');
	
	        this.reviewer = options.reviewer;
	        this.regionId = options.regionId;
	        this.getReviewerName = options.getReviewerName;
	
	        if (typeof options.obsoleteInsteadOfRemove === "undefined") {
	            this.obsoleteInsteadOfRemove = false;
	        } else {
	            this.obsoleteInsteadOfRemove = options.obsoleteInsteadOfRemove;
	        }
	
	        this.initDisabled();
	
	        if (!_.isUndefined(options.showRemove)) {
	            this.showRemove = options.showRemove;
	        }
	    }
	    ,
	
	    onRender: function () {
	        var that = this;
	
	        that.showChildView('organizations', new RemoteSuggesterView({
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
	            + '&sortby=name&like_name=~~~&type=organization',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Organization",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return (arr[index] || {}).id;
	            },
	            tag: 'organization',
	            defaultSelected: that.getReviewerName && _.isFunction(that.getReviewerName) && that.reviewer.organizationId ? {
	                id: that.reviewer.organizationId,
	                name: that.getReviewerName(that.reviewer.organizationId)
	            } : null
	        }));
	
	        that.showChildView('persons', new RemoteSuggesterView({
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
	            + '&sortby=name&like_name=~~~&type=person',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data.filter(function (item) {
	                    return item.object && item.object.isMd;
	                });
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Person",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return (arr[index] || {}).id;
	            },
	            tag: 'person',
	            defaultSelected: that.getReviewerName && _.isFunction(that.getReviewerName) && that.reviewer.personId ? {
	                id: that.reviewer.personId,
	                name: that.getReviewerName(that.reviewer.personId)
	            } : null
	        }));
	
	        window.setTimeout(function () {
	            that.disableInputsByConf();
	        }, 0);
	    },
	
	    initDisabled: function () {
	
	        if (this.reviewer.status == 'SIGNED' || this.reviewer.status == 'VIEWED') {
	            this.showRemove = false;
	            this.disablePersonSelect = true;
	            this.disableMandatory = true;
	        } else if (this.reviewer.status == 'DELETED') {
	            this.showRemove = true;
	            this.disableOrganizationSelect = true;
	            this.disablePersonSelect = true;
	            this.disableMandatory = true;
	        } else {
	            this.showRemove = true;
	            this.disablePersonSelect = false;
	            this.disableOrganizationSelect = false;
	            this.disableMandatory = false;
	        }
	    },
	
	    disableInputsByConf: function () {
	        if (this.disablePersonSelect) {
	            this.ui.persons.find('input').each(function () {
	                $(this).attr('disabled', true);
	            });
	        }
	
	        if (this.disableOrganizationSelect) {
	            this.ui.organizations.find('input').each(function () {
	                $(this).attr('disabled', true);
	            });
	        }
	
	        if (this.disableMandatory) {
	            this.ui.mandatory.attr('disabled', true);
	        }
	    },
	
	    organizationChanged: function (id) {
	        this.reviewer.organizationId = id;
	        this.triggerMethod('reviewer:changed');
	    },
	
	    personChanged: function (id) {
	        this.reviewer.personId = id;
	        this.triggerMethod('reviewer:changed');
	    },
	
	    mandatoryChanged: function (event) {
	        this.reviewer.mandatory = event.target.checked;
	    },
	
	    removeReviewer: function () {
	        var that = this;
	        if (that.showRemove)
	            if (that.obsoleteInsteadOfRemove) {
	                if (that.reviewer.status == 'UNREVIEWED')
	                    that.reviewer.status = "DELETED";
	                else
	                    that.reviewer.status = "UNREVIEWED";
	
	                that.initDisabled();
	                that.triggerMethod('reviewer:re-render', that.regionId);
	            }
	            else
	                that.triggerMethod('reviewer:will-be-remove', {regionId: that.regionId, reviewer: that.reviewer});
	    }
	});
	
	module.exports = ReviewerFormView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="reviewer-form-row reviewer-row ';
	 if (status == 'DELETED') { 
	__p+=' deprecated-header ';
	 } 
	__p+='">\n    <div class="form">\n        <div class="form-group col-md-4 col-xs-4" id="organizations"></div>\n\n        <div class="form-group col-md-4 col-xs-4" id="persons"></div>\n\n        <div class="form-group col-md-1 col-xs-1">\n            <div class="checkbox">\n                <label>\n                    <input type="checkbox" id="mandatory" '+
	((__t=( mandatory ))==null?'':__t)+
	' > Mandatory\n                </label>\n            </div>\n        </div>\n        <div class="form-group col-md-3 col-xs-3">\n        ';
	 if (showRemove) { 
	__p+='\n            <div class="checkbox">\n                <span class="remove-reviewer dotted-link edit-buttons right-buttons" style="color: red;">- '+
	((__t=( removeButtonText ))==null?'':__t)+
	'</span>\n            </div>\n        ';
	 } 
	__p+='\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 317 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\r\n<!-- Reviews add Modal -->\r\n<div class="modal fade" id="addReviewersModal" tabindex="-1" role="dialog" aria-labelledby="addReviewersModal">\r\n    <div class="modal-dialog modal-lg" role="document">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\r\n                        aria-hidden="true">&times;</span></button>\r\n                <h4 class="modal-title" id="addReviewersModalLabel">Add reviewers</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <div class="reviewers-review row"></div>\r\n                <div>\r\n                    <div class="form-inline">\r\n                        <div class="form-group"><span class="add-reviewer dotted-link">+ Add reviewer</span></div>\r\n                    </div>\r\n                </div>\r\n                <div id="add-reviewers-loader" class="loader" style="height: 200px;"></div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\r\n                <button type="button" class="btn btn-primary" id="save" disabled>Save</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var RemoteSuggesterView = __webpack_require__(196);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	
	var AssignPatientForm = Marionette.View.extend({
	    template: __webpack_require__(319),
	
	    regions: {
	        patientSelect: '#patient-select'
	    },
	
	    ui: {
	        modal: '#assign-patient-modal',
	        save: '#save'
	    },
	
	    events: {
	        'click @ui.save': 'onSave'
	    },
	
	    childViewEvents: {
	        'suggestor:selected:patient': 'onPatientSelected'
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.patientId = null;
	        that.utils = new CommonUtils();
	        that.docIds = options.docIds;
	    },
	
	    onRender: function () {
	        var that = this;
	        that.show();
	
	        that.patientsSelectView = new RemoteSuggesterView({
	            maxNumberOfElements: 100,
	            url: '/api/dbo/preview?page-size=' + 100
	            + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data.filter(function (item) {
	                    return item.object && item.object.isPatient && item.object.mergeable === false;
	                });
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Select patient to add or replace",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return (arr[index] || {}).id;
	            },
	            tag: 'patient'
	        });
	
	        that.showChildView('patientSelect', that.patientsSelectView);
	    },
	
	    onSave: function () {
	        var that = this;
	        if (that.patientId == null || that.docIds == [] || _.isEmpty(that.docIds))
	            return;
	
	        that.utils.showSpinner("#add-patient-loader");
	        $.ajax({
	            type: "POST",
	            url: '/api/document/patient/' + that.patientId + '/multi',
	            data: JSON.stringify(that.docIds),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner("#add-patient-loader");
	                    that.hide();
	                    $.notify({
	                        message: 'Patient added to document successfully'
	                    }, {
	                        type: 'success',
	                        z_index: 2000,
	                    });
	                    if (that.getOption("woResponseEvent") !== true)
	                        that.triggerMethod('patient:added:to:document', {
	                            documentsIdWithErrors: response
	                        });
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner("#add-patient-loader");
	                notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        });
	    },
	
	    show: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    },
	
	    onPatientSelected: function (patientId) {
	        this.patientId = patientId;
	        if (_.isUndefined(patientId))
	            this.ui.save.attr('disabled', true);
	        else
	            this.ui.save.removeAttr('disabled');
	    }
	});
	
	module.exports = AssignPatientForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Modal -->\r\n<div class="modal fade" id="assign-patient-modal" tabindex="-1" role="dialog" aria-labelledby="assign-patient-modal">\r\n    <div class="modal-dialog modal-sm" role="document">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\r\n                        aria-hidden="true">&times;</span></button>\r\n                <h4 class="modal-title" id="add-patient-modal-label">Add Patient</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <div class="form-group" id="patient-select"></div>\r\n                <div id="add-patient-loader" class="loader" style="height: 200px;"></div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\r\n                <button type="button" class="btn btn-primary" id="save" disabled>Save</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	
	var SetDocumentDueForm = Marionette.View.extend({
	    template: __webpack_require__(321),
	
	    ui: {
	        modal: '#set-due-modal',
	        dueDate: '#due-date',
	        save: '#save'
	    },
	
	    events: {
	        'click @ui.save': 'onSave'
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.utils = new CommonUtils();
	        that.docIds = options.docIds;
	        that.selectedDate = null;
	    },
	
	    onRender: function () {
	        var that = this;
	        that.ui.dueDate.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'MM/DD/YYYY hh:mm A'
	        });
	        that.ui.dueDate.on("dp.change", function (e) {
	
	            if (e.date) {
	                that.ui.save.removeAttr('disabled');
	                that.selectedDate = e.date.valueOf();
	            } else {
	                that.ui.save.attr('disabled', true);
	                that.selectedDate = null;
	            }
	        }).on('dp.show', function () {
	            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(new Date()));
	        });
	
	        that.show();
	    },
	
	    onSave: function () {
	        var that = this;
	        if (that.docIds == [] || _.isEmpty(that.docIds) || !that.selectedDate)
	            return;
	
	        that.utils.showSpinner("#set-due-loader");
	        $.ajax({
	            type: "POST",
	            url: '/api/document/due/' + that.selectedDate,
	            data: JSON.stringify(that.docIds),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner("#set-due-loader");
	                    that.hide();
	                    $.notify({
	                        message: 'Due date set successfully'
	                    }, {
	                        type: 'success',
	                        z_index: 2000,
	                    });
	                    if (that.getOption("woResponseEvent") !== true)
	                        that.triggerMethod('due:set:to:document', {
	                            documentsIdWithErrors: response,
	                            selectedDate: that.selectedDate
	                        });
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner("#set-due-loader");
	                notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        });
	    },
	
	    show: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    }
	});
	
	module.exports = SetDocumentDueForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Modal -->\r\n<div class="modal fade" id="set-due-modal" tabindex="-1" role="dialog" aria-labelledby="set-due-modal">\r\n    <div class="modal-dialog modal-sm" role="document">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\r\n                        aria-hidden="true">&times;</span></button>\r\n                <h4 class="modal-title" id="set-due-modal-label">Set due date</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <div class="form-group">\r\n                    <input type="text" class="form-control" id="due-date" placeholder="Select due date">\r\n                </div>\r\n                <div id="set-due-loader" class="loader" style="height: 200px;"></div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\r\n                <button type="button" class="btn btn-primary" id="save" disabled>Save</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var AddCommentForm = Marionette.View.extend({
	    template: __webpack_require__(323),
	
	    ui: {
	        modal: '#add-comment-modal',
	        comment: '#comment',
	        commentSource: "#comment-source",
	        commentIsInternal: "#is-internal",
	        checkDocument: '#check-document',
	        checkPhysician: '#check-physician',
	        checkOrganization: '#check-organization',
	        checkPatient: '#check-patient',
	        dueDate: '#due-date',
	
	        commentDocument: '#comment-document',
	        commentDocumentConfirm: '#comment-document-confirm',
	        commentFormBody: '#comment-form-body',
	        commentConfirmationBody: '#comment-confirmation-body',
	        commentFooter: '#comment-footer',
	        confirmationFooter: '#confirmation-footer'
	    },
	
	    events: {
	        'click @ui.commentDocument': 'onComment',
	        'click @ui.commentDocumentConfirm': 'onCommentNoConfirm',
	        'keyup @ui.comment': 'onCommentChanged',
	        'change @ui.commentSource': 'onChangeCommentSource',
	        'change @ui.commentIsInternal': 'onChangeCommentIsInternal',
	        'change @ui.checkDocument': 'onCheckDocument',
	        'change @ui.checkPhysician': 'onCheckPhysician',
	        'change @ui.checkOrganization': 'onCheckOrganization',
	        'change @ui.checkPatient': 'onCheckPatient'
	    },
	
	    initialize: function (options) {
	
	        var that = this;
	        that.utils = new CommonUtils();
	        that.allFiltered = options.allFiltered || false;
	        that.params = options.params || "";
	        if (that.allFiltered) {
	            that.url = '/api/document/comment/filtered?' + that.params;
	        } else {
	            that.url = '/api/comment/bulk/';
	        }
	
	        that.documentsComment = {
	            comment: {
	                text: undefined,
	                source: 'AUDIT',
	                internal: false
	            },
	            documentIds: options.docIds,
	            commentDocument: true,
	            commentReviewerPerson: true,
	            commentReviewerOrganization: true,
	            commentPatient: true,
	            dueDate: 0
	        }
	        that.docsCount = options.docsCount || 0;
	        that.docsCount = that.allFiltered ? that.docsCount : (that.documentsComment.documentIds || []).length;
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            docsCount: that.docsCount
	        }
	    },
	
	    onRender: function () {
	        var that = this;
	        that.ui.dueDate.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'MM/DD/YYYY hh:mm A'
	        });
	        that.ui.dueDate.on("dp.change", function (e) {
	
	            if (e.date) {
	                that.documentsComment.dueDate = e.date.valueOf();
	            } else {
	                that.documentsComment.dueDate = 0;
	            }
	        }).on('dp.show', function () {
	            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(new Date()));
	        });
	        /*this.ui.commentSource.selectize({
	            allowEmptyOption: false
	        });*/
	        this.show();
	    },
	
	    onComment: function () {
	        var that = this;
	        if ((that.documentsComment.documentIds == [] || _.isEmpty(that.documentsComment.documentIds) || _.isEmpty(that.documentsComment.comment.text))
	            && !that.allFiltered)
	            return;
	
	        if (that.docsCount > Constants.pageCapacity) {
	            that.ui.commentFormBody.hide();
	            that.ui.commentFooter.hide();
	            that.ui.commentConfirmationBody.show();
	            that.ui.confirmationFooter.show();
	        } else {
	            that.onCommentNoConfirm();
	        }
	    },
	
	    onCommentNoConfirm: function () {
	        var that = this;
	        that.utils.showSpinner("#add-comment-loader");
	        $.ajax({
	            type: "POST",
	            url: that.url,
	            data: JSON.stringify(that.documentsComment),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner("#add-comment-loader");
	                    that.hide();
	                    $.notify({
	                        message: 'Selected documents commented successfully'
	                    }, {
	                        type: 'success',
	                        z_index: 2000,
	                    });
	                    if (that.getOption("woResponseEvent") !== true)
	                        that.triggerMethod('comment:added:to:document', {
	                            documentsIdWithErrors: response
	                        });
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner("#add-comment-loader");
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	                }
	            }
	        });
	    },
	
	    show: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    },
	
	    onCommentChanged: function (event) {
	        this.documentsComment.comment.text = event.target.value;
	        if (_.isEmpty(event.target.value)) {
	            this.ui.commentDocument.attr('disabled', true);
	            this.ui.commentDocumentConfirm.attr('disabled', true);
	        } else {
	            this.ui.commentDocument.removeAttr('disabled');
	            this.ui.commentDocumentConfirm.removeAttr('disabled');
	        }
	    },
	
	    onChangeCommentSource: function (e) {
	        this.documentsComment.comment.source = e.target.value;
	    },
	
	    onChangeCommentIsInternal: function (e) {
	        this.documentsComment.comment.internal = e.target.checked;
	    },
	
	    onCheckDocument: function (event) {
	        this.documentsComment.commentDocument = event.target.checked;
	    },
	
	    onCheckPhysician: function (event) {
	        this.documentsComment.commentReviewerPerson = event.target.checked;
	    },
	
	    onCheckOrganization: function (event) {
	        this.documentsComment.commentReviewerOrganization = event.target.checked;
	    },
	
	    onCheckPatient: function (event) {
	        this.documentsComment.commentPatient = event.target.checked;
	    }
	
	});
	
	module.exports = AddCommentForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Modal -->\n<div class="modal fade" id="add-comment-modal" tabindex="-1" role="dialog" aria-labelledby="add-comment-modal">\n    <div class="modal-dialog modal-lg" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\n                        aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title" id="add-comment-modal-label">Add a Comment</h4>\n            </div>\n            <div class="modal-body" id="comment-form-body">\n                <div class="form-group col-md-3 col-xs-3">\n                    <select class="form-control" id="comment-source">\n                        <option value="AUDIT" selected>AUDIT</option>\n                        <option value="FRONTPAGE">FRONTPAGE</option>\n                    </select>\n                </div>\n                <div class="form-group col-md-3 col-xs-3">\n                    <label class="checkbox"><input type="checkbox" id="is-internal">Is Internal?</label>\n                </div>\n                <div class="form-group">\n                    <textarea rows="8" class="form-control" id="comment" placeholder="Comment"></textarea>\n                </div>\n                <div class="form-group">\n                    <div>Add comment to:</div>\n                    <div class="checkbox">\n                        <label>\n                            <input type="checkbox" class="checkbox" id="check-document" placeholder="Document" checked> Document\n                        </label>\n                    </div>\n                    <div class="checkbox">\n                        <label>\n                            <input type="checkbox" class="checkbox" id="check-physician" placeholder="Physician" checked> Physician\n                        </label>\n                    </div>\n                    <div class="checkbox">\n                        <label>\n                            <input type="checkbox" class="checkbox" id="check-organization" placeholder="Organization" checked> Organization\n                        </label>\n                    </div>\n                    <div class="checkbox">\n                        <label>\n                            <input type="checkbox" class="checkbox" id="check-patient" placeholder="Patient" checked> Patient\n                        </label>\n                    </div>\n\n                    <input type="text" class="form-control" id="due-date" placeholder="Document due date">\n                </div>\n                <div id="add-comment-loader" class="loader" style="height: 200px;"></div>\n            </div>\n\n            <div class="modal-body" style="display:none;" id="comment-confirmation-body">\n                <div class="send-warning"> You are about to comment <span class="send-warning-number"> '+
	((__t=( docsCount ))==null?'':__t)+
	' </span> documents. <br/> Are you sure? </div>\n            </div>\n\n            <div class="modal-footer" id="comment-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-primary" id="comment-document" disabled>Comment '+
	((__t=( docsCount ))==null?'':__t)+
	' documents</button>\n            </div>\n\n            <div class="modal-footer" id="confirmation-footer" style="display: none">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-danger" id="comment-document-confirm" disabled>Comment '+
	((__t=( docsCount ))==null?'':__t)+
	' documents</button>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var SendDocumentForm = Marionette.View.extend({
	    template: __webpack_require__(325),
	
	    ui: {
	        modal: '#send-document-modal',
	        comment: '#comment',
	        commentSource: "#comment-source",
	        commentIsInternal: "#is-internal",
	        checkDocument: '#check-document',
	        checkPhysician: '#check-physician',
	        checkOrganization: '#check-organization',
	        checkPatient: '#check-patient',
	        send: '#send-document',
	        sendDocumentConfirm: '#send-document-confirm',
	        sendFormBody: '#send-form-body',
	        sendConfirmationBody: '#send-confirmation-body',
	        sendFooter: '#send-footer',
	        confirmationFooter: '#confirmation-footer',
	        additionalSendConfirmationBody: '#additional-send-confirmation-body',
	        additionalSendDocumentConfirm: '#additional-send-document-confirm',
	        additionalConfirmationFooter: '#additional-confirmation-footer'
	
	    },
	
	    events: {
	        'click @ui.send': 'onSend',
	        'click @ui.sendDocumentConfirm': 'onSendCheckMoreThatLimitConfirm',
	        'keyup @ui.comment': 'onCommentChanged',
	        'change @ui.commentSource': 'onChangeCommentSource',
	        'change @ui.commentIsInternal': 'onChangeCommentIsInternal',
	        'change @ui.checkDocument': 'onCheckDocument',
	        'change @ui.checkPhysician': 'onCheckPhysician',
	        'change @ui.checkOrganization': 'onCheckOrganization',
	        'change @ui.checkPatient': 'onCheckPatient',
	        'click @ui.additionalSendDocumentConfirm': 'onSendNoConfirm'
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.utils = new CommonUtils();
	        that.allFiltered = options.allFiltered || false;
	        that.params = options.params || "";
	        if (that.allFiltered) {
	            that.url = '/api/document/send/filtered?' + that.params;
	        } else {
	            that.url = '/api/document/send/documents';
	        }
	        that.documentsComment = {
	            comment: {
	                text: undefined,
	                source: 'FRONTPAGE',
	                internal: false
	            },
	            commentDocument: true,
	            commentReviewerPerson: true,
	            commentReviewerOrganization: true,
	            commentPatient: true,
	            documentIds: options.docIds
	        };
	        that.docsCount = options.docsCount || 0;
	        that.docsCount = that.allFiltered ? that.docsCount : (that.documentsComment.documentIds || []).length;
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            docsCount: that.docsCount
	        }
	    },
	
	    onRender: function () {
	        this.show();
	    },
	
	    onSend: function () {
	        var that = this;
	        if ((that.documentsComment.documentIds == [] || _.isEmpty(that.documentsComment.documentIds)) && !that.allFiltered)
	            return;
	
	        if (that.docsCount > Constants.pageCapacity) {
	            that.ui.sendFormBody.hide();
	            that.ui.sendFooter.hide();
	            that.ui.sendConfirmationBody.show();
	            that.ui.confirmationFooter.show();
	        } else {
	            that.onSendNoConfirm();
	        }
	    },
	
	    onSendNoConfirm: function () {
	        var that = this;
	        that.utils.showSpinner("#send-document-loader");
	        $.ajax({
	            type: "POST",
	            url: that.url,
	            data: JSON.stringify(that.documentsComment),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner("#send-document-loader");
	                    that.hide();
	                    $.notify({
	                        message: 'Selected documents sent successfully'
	                    }, {
	                        type: 'success',
	                        z_index: 2000,
	                    });
	                    if (that.getOption("woResponseEvent") !== true)
	                        that.triggerMethod('sent:document');
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner("#send-document-loader");
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	                }
	            }
	        });
	    },
	    onSendCheckMoreThatLimitConfirm: function () {
	        var that = this;
	        if ((that.documentsComment.documentIds == [] || _.isEmpty(that.documentsComment.documentIds)) && !that.allFiltered)
	            return;
	
	        if (that.docsCount > Constants.maxDocumentsForEndingWOConfirmation) {
	            that.ui.sendConfirmationBody.hide();
	            that.ui.confirmationFooter.hide();
	            that.ui.additionalConfirmationFooter.show();
	            that.ui.additionalSendConfirmationBody.show();
	        } else {
	            that.onSendNoConfirm();
	        }
	    },
	
	    show: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    },
	
	    onCommentChanged: function (event) {
	        this.documentsComment.comment.text = event.target.value;
	    },
	
	    onChangeCommentSource: function (e) {
	        this.documentsComment.comment.source = e.target.value;
	    },
	
	    onChangeCommentIsInternal: function (e) {
	        this.documentsComment.comment.internal = e.target.checked;
	    },
	
	    onCheckDocument: function (event) {
	        this.documentsComment.commentDocument = event.target.checked;
	    },
	
	    onCheckPhysician: function (event) {
	        this.documentsComment.commentReviewerPerson = event.target.checked;
	    },
	
	    onCheckOrganization: function (event) {
	        this.documentsComment.commentReviewerOrganization = event.target.checked;
	    },
	
	    onCheckPatient: function (event) {
	        this.documentsComment.commentPatient = event.target.checked;
	    }
	});
	
	module.exports = SendDocumentForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Modal -->\r\n<div class="modal fade" id="send-document-modal" tabindex="-1" role="dialog" aria-labelledby="send-document-modal">\r\n    <div class="modal-dialog modal-lg" role="document">\r\n        <div class="modal-content col-md-offset-1 col-xs-offset-1 col-md-10 col-xs-10">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\r\n                        aria-hidden="true">&times;</span></button>\r\n                <h4 class="modal-title" id="send-document-modal-label">Send document</h4>\r\n            </div>\r\n            <div class="modal-body" id="send-form-body">\r\n                <div class="form-group col-md-3 col-xs-3">\r\n                    <select class="form-control" id="comment-source">\r\n                        <option value="AUDIT">AUDIT</option>\r\n                        <option value="FRONTPAGE" selected>FRONTPAGE</option>\r\n                    </select>\r\n                </div>\r\n                <div class="form-group col-md-3 col-xs-3">\r\n                    <label class="checkbox"><input type="checkbox" id="is-internal">Is Internal?</label>\r\n                </div>\r\n                <div class="form-group">\r\n                    <textarea rows="8" class="form-control no-resizable" id="comment" placeholder="Comment"></textarea>\r\n                </div>\r\n                <div class="form-group">\r\n                    <div>Add comment to:</div>\r\n                    <div class="checkbox">\r\n                        <label>\r\n                            <input type="checkbox" class="checkbox" id="check-document" placeholder="Document" checked> Document\r\n                        </label>\r\n                    </div>\r\n                    <div class="checkbox">\r\n                        <label>\r\n                            <input type="checkbox" class="checkbox" id="check-physician" placeholder="Physician" checked> Physician\r\n                        </label>\r\n                    </div>\r\n                    <div class="checkbox">\r\n                        <label>\r\n                            <input type="checkbox" class="checkbox" id="check-organization" placeholder="Organization" checked> Organization\r\n                        </label>\r\n                    </div>\r\n                    <div class="checkbox">\r\n                        <label>\r\n                            <input type="checkbox" class="checkbox" id="check-patient" placeholder="Patient" checked> Patient\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n                <div id="send-document-loader" class="loader" style="height: 200px;"></div>\r\n            </div>\r\n\r\n            <div class="modal-body" style="display:none;" id="send-confirmation-body">\r\n                <div class="send-warning"> You are about to send <span class="send-warning-number"> '+
	((__t=( docsCount ))==null?'':__t)+
	' </span> documents. <br/> Are you sure? </div>\r\n            </div>\r\n\r\n            <div class="modal-body" style="display:none;" id="additional-send-confirmation-body">\r\n                <div class="send-warning"> You are about to send <span class="send-danger-number"> '+
	((__t=( docsCount ))==null?'':__t)+
	' </span> documents. <br/> Are you absolutely sure? </div>\r\n            </div>\r\n\r\n            <div class="modal-footer" id="send-footer">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\r\n                <button type="button" class="btn btn-primary" id="send-document">Send '+
	((__t=( docsCount ))==null?'':__t)+
	' documents</button>\r\n            </div>\r\n\r\n            <div class="modal-footer" id="confirmation-footer" style="display: none">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\r\n                <button type="button" class="btn btn-warning" id="send-document-confirm">Send '+
	((__t=( docsCount ))==null?'':__t)+
	' documents</button>\r\n            </div>\r\n\r\n            <div class="modal-footer" id="additional-confirmation-footer" style="display: none">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\r\n                <button type="button" class="btn btn-danger btn-lg" id="additional-send-document-confirm">Send '+
	((__t=( docsCount ))==null?'':__t)+
	' documents</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var AddAddendumForm = Marionette.View.extend({
	    template: __webpack_require__(327),
	
	    ui: {
	        modal: '#add-addendum-modal',
	        comment: '#comment',
	        addAddendum: '#addendum-document'
	    },
	
	    events: {
	        'click @ui.addAddendum': 'onAddAddendum',
	        'keyup @ui.comment': 'onCommentChanged'
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.utils = new CommonUtils();
	        that.addendum = {
	            documentsId: options.docIds,
	            addendumComment: ""
	        };
	    },
	
	    templateContext: function () {
	        var that = this;
	    },
	
	    onRender: function () {
	        this.show();
	    },
	
	    onAddAddendum: function () {
	        var that = this;
	        that.utils.showSpinner("#add-addendum-loader");
	        $.ajax({
	            type: "POST",
	            url: '/api/document/addendum/comment',
	            data: JSON.stringify(that.addendum),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner("#add-addendum-loader");
	                    that.hide();
	                    $.notify({
	                        message: 'Addendum added to selected documents successfully'
	                    }, {
	                        type: 'success',
	                        z_index: 2000,
	                    });
	                    if (that.getOption("woResponseEvent") !== true)
	                        that.triggerMethod('addendum:added:to:document');
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner("#add-addendum-loader");
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	                }
	            }
	        });
	    },
	
	    show: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    },
	
	    onCommentChanged: function (event) {
	        this.addendum.addendumComment = event.target.value;
	        if (_.isEmpty(event.target.value)) {
	            this.ui.addAddendum.attr('disabled', true);
	        } else {
	            this.ui.addAddendum.removeAttr('disabled');
	        }
	    }
	
	});
	
	module.exports = AddAddendumForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Modal -->\n<div class="modal fade" id="add-addendum-modal" tabindex="-1" role="dialog" aria-labelledby="add-addendum-modal">\n    <div class="modal-dialog modal-lg" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\n                        aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title" id="add-addendum-modal-label">Add a Addendum</h4>\n            </div>\n            <div class="modal-body" id="addendum-form-body">\n                <div class="form-group">\n                    <textarea rows="8" class="form-control" id="comment" placeholder="Addendum comment"></textarea>\n                </div>\n                <div id="add-addendum-loader" class="loader" style="height: 200px;"></div>\n            </div>\n\n            <div class="modal-footer" id="addendum-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-primary" id="addendum-document" disabled>Add</button>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	
	var MarkAsForm = Marionette.View.extend({
	    template: __webpack_require__(329),
	
	    ui: {
	        modal: '#mark-as-modal',
	        comment: '#comment',
	        time: '#mark-as-time',
	        go: '#go',
	
	        loader: '#mark-as-loader'
	    },
	
	    events: {
	        'click @ui.go': 'onGo',
	        'keyup @ui.comment': 'onCommentChanged'
	    },
	
	    templateContext: function () {
	        var commentPalceholder;
	
	        if (this.mode == "sent")
	            commentPalceholder = "Please, specify following data - when, who sent, who will deliver";
	        else if (this.mode == "delivered")
	            commentPalceholder = "Please, specify following data - when, who delivered, who will received";
	        else
	            commentPalceholder = "Comment";
	
	        return {
	            mode: this.mode,
	            commentPlaceholder: commentPalceholder
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.utils = new CommonUtils();
	        that.mode = options.mode
	        that.documentsIds = options.docIds
	        that.comment = ""
	        that.sentDeliveredTime = 0
	    },
	
	    onRender: function () {
	        var that = this;
	        that.ui.time.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'MM/DD/YYYY hh:mm A',
	            maxDate: new Date()
	        });
	        that.ui.time.on("dp.change", function (e) {
	
	            if (e.date) {
	                that.sentDeliveredTime = e.date.valueOf();
	            } else {
	                that.sentDeliveredTime = 0;
	            }
	
	            that.check()
	
	        }).on('dp.show', function () {
	            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(new Date()));
	        });
	        this.show();
	    },
	
	    onGo: function () {
	
	        var that = this;
	
	        var apiCalls = that.documentsIds.map(function (documentId) {
	
	            return $.ajax({
	                type: "POST",
	                url: '/api/document/' + documentId + '/mark/as/' + that.mode,
	                //data: jQuery.param(),
	                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
	                data: {time: that.sentDeliveredTime, comment: that.comment},
	                statusCode: {
	                    200: function (response) {
	                    }
	                },
	                error: function (e) {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                    that.utils.hideSpinner(that.ui.loader.id);
	                }
	            });
	
	        });
	
	        that.utils.showSpinner(that.ui.loader.id);
	
	        $.when.apply($, apiCalls).then(function () {
	            that.utils.hideSpinner(that.ui.loader.id);
	            that.hide();
	            $.notify({
	                message: "Selected documents marked as " + that.mode
	            }, {
	                type: 'success',
	                z_index: 2000,
	            });
	            if (that.getOption("woResponseEvent") !== true)
	                that.triggerMethod("document:list:refresh");
	        });
	    },
	
	    show: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    },
	
	    onCommentChanged: function (event) {
	        this.comment = event.target.value;
	        this.check();
	    },
	
	    check: function () {
	
	        if (_.isEmpty(this.documentsIds) || _.isEmpty(this.comment) || this.sentDeliveredTime == 0) {
	            this.ui.go.attr('disabled', true);
	        } else {
	            this.ui.go.removeAttr('disabled');
	        }
	    }
	});
	
	module.exports = MarkAsForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Modal -->\n<div class="modal fade" id="mark-as-modal" tabindex="-1" role="dialog" aria-labelledby="mark-as-modal">\n    <div class="modal-dialog modal-lg" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\n                        aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title" id="mark-as-modal-label">Mark as '+
	((__t=( mode ))==null?'':__t)+
	'</h4>\n            </div>\n            <div class="modal-body">\n                <div class="form-group">\n                    <textarea rows="8" class="form-control" id="comment" placeholder="'+
	((__t=( commentPlaceholder ))==null?'':__t)+
	'"></textarea>\n                </div>\n                <div class="form-group">\n                    <input type="text" class="form-control" id="mark-as-time" placeholder="Time of '+
	((__t=( mode ))==null?'':__t)+
	'">\n                </div>\n                <div id="mark-as-loader" class="loader" style="height: 200px;"></div>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-primary" id="go" disabled>Save</button>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var ExportDocumentForm = Marionette.View.extend({
	    template: __webpack_require__(331),
	
	    ui: {
	        modal: '#export-modal',
	        exportType: "#export-type",
	
	        exportDocument: '#export-document',
	        exportDocumentConfirm: '#export-document-confirm',
	        exportFormBody: '#export-form-body',
	        exportConfirmationBody: '#export-confirmation-body',
	        exportFooter: '#export-footer',
	        confirmationFooter: '#confirmation-footer'
	    },
	
	    events: {
	        'click @ui.exportDocument': 'onExport',
	        'click @ui.exportDocumentConfirm': 'onExportNoConfirm',
	        'change @ui.exportType': 'onChangeExportType'
	    },
	
	    initialize: function (options) {
	
	        var that = this;
	        that.utils = new CommonUtils();
	        that.allFiltered = options.allFiltered || false;
	        that.params = options.params || "";
	        that.url = '/api/document/export?' + that.params;
	        that.documentsExport = {
	            exportType: "csv",
	            documentIds: options.docIds,
	            userTimezoneOffsetInHours: new Date().getTimezoneOffset() / 60
	        }
	        that.docsCount = options.docsCount || 0;
	        that.docsCount = that.allFiltered ? that.docsCount : (that.documentsExport.documentIds || []).length;
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            docsCount: that.docsCount
	        }
	    },
	
	    onRender: function () {
	        var that = this;
	        this.show();
	    },
	
	    onExport: function () {
	        var that = this;
	        if ((that.documentsExport.documentIds == [] || _.isEmpty(that.documentsExport.documentIds) || _.isEmpty(that.documentsExport.exportType)) && !that.allFiltered)
	            return;
	
	        if (that.docsCount > Constants.pageCapacity) {
	            that.ui.exportFormBody.hide();
	            that.ui.exportFooter.hide();
	            that.ui.exportConfirmationBody.show();
	            that.ui.confirmationFooter.show();
	        } else {
	            that.onExportNoConfirm();
	        }
	    },
	
	    onExportNoConfirm: function () {
	        var that = this;
	
	        var form = document.createElement('form');
	        form.setAttribute('target', '_blank');
	        form.setAttribute('action', that.url);
	        form.setAttribute('method', 'post');
	        document.body.appendChild(form);
	
	        var input = document.createElement('input');
	        input.setAttribute('type', 'text');
	        input.setAttribute('name', "exportType");
	        input.setAttribute('value', decodeURIComponent(that.documentsExport.exportType));
	        form.appendChild(input);
	
	        var input2 = document.createElement('input');
	        input2.setAttribute('type', 'text');
	        input2.setAttribute('name', "documentIds");
	        input2.setAttribute('value', decodeURIComponent(that.documentsExport.documentIds.join(",")));
	        form.appendChild(input2);
	
	        var input3 = document.createElement('input');
	        input3.setAttribute('type', 'text');
	        input3.setAttribute('name', "userTimezoneOffsetInHours");
	        input3.setAttribute('value', decodeURIComponent(that.documentsExport.userTimezoneOffsetInHours));
	        form.appendChild(input3);
	
	        form.submit();
	
	        window.setTimeout(function () {
	            document.body.removeChild(form);
	            that.hide();
	        }, 0);
	
	    },
	
	    show: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    },
	
	    onChangeExportType: function (e) {
	        this.documentsExport.exportType = e.target.value;
	    },
	
	});
	
	module.exports = ExportDocumentForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Modal -->\n<div class="modal fade" id="export-modal" tabindex="-1" role="dialog" aria-labelledby="export-modal">\n    <div class="modal-dialog" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\n                        aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title" id="export-modal-label">Export Documents</h4>\n            </div>\n            <div class="modal-body" id="export-form-body">\n                <select class="form-control" id="export-type">\n                    <option value="csv" selected>CSV</option>\n                    <option value="pdf">PDF</option>\n                </select>\n                <div id="export-loader" class="loader" style="height: 200px;"></div>\n            </div>\n\n            <div class="modal-body" style="display:none;" id="export-confirmation-body">\n                <div class="send-warning"> You are going to export <span class="send-warning-number"> '+
	((__t=( docsCount ))==null?'':__t)+
	' </span> documents. <br/> Are you sure? </div>\n            </div>\n\n            <div class="modal-footer" id="export-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-primary" id="export-document">Export '+
	((__t=( docsCount ))==null?'':__t)+
	' documents</button>\n            </div>\n\n            <div class="modal-footer" id="confirmation-footer" style="display: none">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-danger" id="export-document-confirm">Export '+
	((__t=( docsCount ))==null?'':__t)+
	' documents</button>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var OkDialogModal = Marionette.View.extend({
	    template: __webpack_require__(333),
	
	    ui: {
	        modal: '#ok-modal',
	        okBtn: '#ok'
	    },
	
	    events: {
	        'click @ui.okBtn': 'onCallback'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            title: that.title || 'Success',
	            message: that.message || 'The action finished successfully!'
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'onCallback', 'show');
	        if (options) {
	            this.title = options.title;
	            this.message = options.message;
	            this.action = options.action;
	        }
	    },
	
	    onRender: function () {
	    },
	
	    clearUI: function() {
	        this.ui.modal.modal('hide');
	        $('body').removeClass('modal-open');
	        $('.modal-backdrop').remove();
	    },
	
	    onCallback: function () {
	        this.clearUI();
	        if (typeof this.action == "function") {
	            this.action();
	        }
	    },
	
	    show: function() {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    }
	
	});
	
	module.exports = OkDialogModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="modal fade" id="ok-modal" tabindex="-1" role="dialog">\r\n    <div class="modal-dialog">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <h4 class="modal-title">'+
	((__t=( title ))==null?'':__t)+
	'</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <p>'+
	((__t=( message ))==null?'':__t)+
	'</p>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-primary" id="ok">OK</button>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 334 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h2>Documents  <span id="count" class="text-muted"></span></h2>\n\n<div id="documents"></div>\n<div id="pager"></div>\n\n<div id="assign-reviewers-form"></div>\n<div id="add-patient-form-modal"></div>\n<div id="set-due-form-modal"></div>\n<div id="add-comment-form-modal"></div>\n<div id="send-form-modal"></div>\n<div id="add-addendum-form-modal"></div>\n<div id="mark-as-modal"></div>\n<div id="export-modal"></div>\n<div class="password-confirmation-div"></div>\n<div id="add-patient-warning"></div>';
	}
	return __p;
	};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Marionette = __webpack_require__(180);
	
	var PersonsCollection = __webpack_require__(210);
	var Person = __webpack_require__(206);
	var PersonForm = __webpack_require__(336);
	var Pager = __webpack_require__(309);
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	
	var PersonItem = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(338),
	
	    ui: {
	        checkOrUncheck: '.check-person'
	    },
	
	    events: {
	        'click .activate': 'activate',
	        'click .deactivate': 'deactivate',
	        'click @ui.checkOrUncheck': 'checkOrUncheck'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var object = that.model.get('object');
	        return {
	            formatDate: that.getOption('formatDate'),
	            birthDate: (object.birthData == '' || object.birthData == null || object.birthData == 0 ? ''
	                : that.utils.longToDateTimeFormattedInUtc(Number(object.birthData), 'MM/DD/YYYY'))
	        }
	    },
	
	    initialize: function (options) {
	        this.utils = new CommonUtils();
	    },
	
	    activate: function (event) {
	        this.sendActiveRequest(true, $(event.target).attr('uid'));
	    },
	
	    deactivate: function (event) {
	        this.sendActiveRequest(false, $(event.target).attr('uid'));
	    },
	
	    sendActiveRequest: function (status, uid) {
	        var that = this;
	        var action = status ? 'activate' : 'deactivate';
	        $.ajax({
	            type: "POST",
	            url: '/api/person/' + uid + '/' + action,
	            statusCode: {
	                200: function () {
	                    that.model.set('active', status);
	                    that.render();
	                }
	            }
	        });
	    },
	
	    checkOrUncheck: function (event) {
	        this.triggerMethod('row:selected', {
	            personId: this.model.get("id"),
	            addOrRemove: event.target.checked
	        });
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(8), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	
	var PersonsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: PersonItem,
	    emptyView: EmptyView,
	
	    collectionEvents: {
	        request: 'showLoading',
	        sync: 'hideLoading',
	        error: 'logError'
	    },
	
	    childViewEvents: {
	        'row:selected': 'onPersonRowSelected'
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'showLoading', 'hideLoading', 'logError');
	        this.collection = options.collection;
	        this.formatDate = options.formatDate;
	    },
	
	    childViewOptions: function () {
	        return {formatDate: this.formatDate};
	    },
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    },
	
	    onPersonRowSelected: function (data) {
	        this.triggerMethod('row:selected', data);
	    }
	});
	
	var PersonsList = Marionette.View.extend({
	    template: __webpack_require__(339),
	
	    regions: {
	        modal: '#addPersonModal',
	        form: '#form',
	        tableBody: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        pager: '#pager'
	    },
	
	    ui: {
	        saveBtn: '#save-person',
	        filterBtn: '#filter',
	        resetBtn: '#reset',
	        filterField: '.filter-field',
	        burnAfter: '#burn-after',
	        burnBefore: '#burn-before',
	        checkOrUncheckAll: '#check-all'
	    },
	
	    events: {
	        'click @ui.saveBtn': 'savePerson',
	        'click @ui.filterBtn': 'applyFilter',
	        'click @ui.resetBtn': 'resetFilter',
	        'click @ui.checkOrUncheckAll': 'checkOrUncheckAllPersons'
	    },
	
	    collectionEvents: {
	        error: 'logError'
	    },
	
	    childViewEvents: {
	        'person:save:valid': 'savePersonBtnEnableOrDisable',
	        'row:selected': 'onPersonRowSelected'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            getParam: function (key) {
	                return that.params[key];
	            },
	            getDateParam: function (key) {
	                if (that.params[key]) {
	                    try {
	                        return that.utils.longToDateTimeFormatted(Number(that.params[key]), 'MM/DD/YYYY');
	                    } catch (e) {
	                        console.log(e);
	                        return undefined;
	                    }
	                }
	                return undefined;
	            }
	        }
	    },
	
	    initialize: function (options) {
	        this.model = new Person();
	        this.utils = new CommonUtils();
	        this.params = $.deparam(window.location.hash.replace('#persons', '').replace('?', ''));
	        this.defaultListParams = this.utils.getDefaultListParams();
	        this.personsIds = [];
	        this.initDefaultCollectionParams()
	    },
	
	    initDefaultCollectionParams: function () {
	
	        this.defaultCollectionParams = [
	            {key: 'active', value: 'true'},
	            {key: 'active', value: 'false'},
	            {key: 'sortby', value: 'createdTime'},
	            {key: 'sortdir', value: 'DESC'},
	            {key: 'page-size', value: Constants.pageCapacity}
	        ]
	    },
	
	    onErrors: function (model, errors) {
	        model.view.triggerMethod('server:error', errors.join('. \n'));
	    },
	
	    onRender: function () {
	        window.document.title = "RNS Persons";
	        var that = this;
	        that.personForm = new PersonForm({model: that.model, isEditMode: false});
	        that.showChildView('form', that.personForm);
	
	        that.collection = new PersonsCollection([],
	            {params: that.utils.mergeCollectionParams(that.defaultCollectionParams, that.utils.queryParamsToCollection(that.params) || [])});
	
	        that.showLoading();
	        that.collection.fetch({
	            success: function () {
	                that.renderTable();
	
	                that.showChildView('pager', new Pager({
	                    baseCountUrl: '/api/person/count?active=true&active=false'
	                }));
	                that.hideLoading();
	            },
	            error: function () {
	                that.hideLoading();
	            }
	        });
	
	        that.ui.burnAfter.datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	        that.ui.burnBefore.datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	
	        if (that.utils.isUrlWoExtraQueryParameters()) {
	            that.ui.resetBtn.hide();
	        } else {
	            that.ui.resetBtn.show();
	        }
	    },
	
	    renderTable: function () {
	        var that = this;
	        that.showChildView('tableBody', new PersonsTableBody({
	            collection: new PersonsCollection(that.collection.filter(function (model) {
	                return model.get("object").login != "undefined" && model.get("object").login != "null";
	            })), formatDate: function (dateAsLong) {
	                return that.utils.longToDateTimeFormatted(dateAsLong, 'MMM DD YYYY');
	            }
	        }));
	    },
	
	    savePerson: function () {
	        var that = this;
	        this.model = this.personForm.fillModel();
	        this.model.save(this.model.toJSON(), {
	            success: function (response) {
	                $('#addPersonModal').modal('hide');
	                that.itemSaved();
	            },
	            error: function (model, xhr, options) {
	                notificationsChannel.request('show:notification', JSON.parse(xhr.responseText));
	                that.personForm.validateAllRequiredFields();
	            }
	        });
	    },
	
	    itemSaved: function () {
	        this.resetFilter();
	    },
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    },
	
	    savePersonBtnEnableOrDisable: function (data) {
	        if (data.result)
	            this.ui.saveBtn.removeAttr("disabled");
	        else
	            this.ui.saveBtn.attr("disabled", "true");
	    },
	
	    applyFilter: function () {
	        var that = this;
	
	        that.ui.filterField.each(function (i, element) {
	            if ($(element).attr('name')) {
	                var name = $(element).attr('name');
	                if ($(element).val()) {
	                    that.defaultListParams[name] = $(element).val();
	                } else {
	                    delete that.defaultListParams[name];
	                }
	            }
	        });
	
	        if (that.ui.burnAfter.val() != undefined && that.ui.burnAfter.val() != '')
	            that.defaultListParams['object_birthData_from'] = that.utils.dateToLong(that.ui.burnAfter.val());
	        else
	            delete (that.defaultListParams['object_birthData_from']);
	
	        if (that.ui.burnBefore.val() != undefined && that.ui.burnBefore.val() != '')
	            that.defaultListParams['object_birthData_to'] = that.utils.dateToLong(that.ui.burnBefore.val());
	        else
	            delete (that.defaultListParams['object_birthData_to']);
	
	        that.defaultListParams.page = 0;
	        window.location.hash = that.utils.getCleanBaseHash() + "?" + that.utils.objectToQueryParams(that.defaultListParams);
	    },
	
	    resetFilter: function () {
	        this.utils.redirectToUrlWoExtraQueryParameters();
	    },
	
	    checkOrUncheckAllPersons: function (event) {
	        var that = this;
	        if (event.target.checked) {
	            $('.check-person').prop('checked', true);
	
	            that.personsIds = that.collection.map(function (model) {
	                return model.get('id');
	            });
	        } else {
	            that.personsIds = [];
	            $('.check-person').prop('checked', false);
	        }
	
	        that.personsIds = _.uniq(that.personsIds);
	        console.log(that.personsIds);
	    },
	
	    onPersonRowSelected: function (data) {
	        var that = this;
	        if (data.addOrRemove) {
	            that.personsIds.push(data.personId);
	        } else {
	            that.personsIds = (that.personsIds || []).filter(function (id) {
	                return id !== data.personId
	            });
	        }
	
	        that.personsIds = _.uniq(that.personsIds);
	        console.log(that.personsIds);
	    }
	});
	
	
	module.exports = PersonsList;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var Person = __webpack_require__(206);
	
	var RemoteSuggesterView = __webpack_require__(196);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	var utils = new CommonUtils();
	
	
	var PersonForm = Marionette.View.extend({
	    tagName: 'form',
	    template: __webpack_require__(337),
	    model: new Person(),
	    modelEvents: {
	        change: 'render'
	    },
	
	    regions: {
	        stateSelect: '#state-select'
	    },
	
	    ui: {
	        email: '#email',
	        login: '#login',
	        password: '#password',
	        passwordHidden: '#password-hidden',
	        firstName: '#first-name',
	        lastName: '#last-name',
	        middleName: '#middle-name',
	
	        addressField: '.address-field',
	        zip: '#zip',
	        address: '#address',
	        town: '#town',
	
	        npi: '#id-npi',
	        isPatient: '#is-patient',
	        isMd: '#is-md',
	        isOfficeAdmin: '#is-office-admin',
	        isMedicalDirector: '#is-medical-director',
	        isManager: '#is-manager',
	        isAdmin: '#is-admin',
	        ssn: '#ssn',
	        insuranceId: '#insuranceId',
	        birthDate: '#birth-date',
	        gender: '#gender-values',
	        pendingDocsNotifChb: '#pending-docs-notif',
	        reviewPeriodDays: '#review-period-days',
	        reviewPeriodHours: '#review-period-hours',
	
	        progress: '#progress',
	        reRequest: '#re-request',
	        fillForm: '#fill-form',
	
	        generatePass: '#generate-pass'
	    },
	
	    events: {
	        'change @ui.email': 'validate',
	        'blur @ui.email': 'validate',
	
	        'blur @ui.login': 'validate',
	        'blur @ui.password': 'validate',
	        'blur @ui.firstName': 'validate',
	        'blur @ui.lastName': 'validate',
	        'blur @ui.ssn': 'validate',
	
	        'keyup @ui.login': 'validate',
	        'keyup @ui.password': 'validate',
	        'change @ui.password': 'validate',
	        'keyup @ui.firstName': 'validate',
	        'keyup @ui.lastName': 'validate',
	        'keyup @ui.ssn': 'validate',
	
	        'keyup @ui.addressField': 'onAddressChange',
	        'change @ui.addressField': 'onAddressChange',
	
	        'keyup @ui.npi': 'onNpiKeyup',
	        'change @ui.npi': 'onNpiChange',
	        'keypress @ui.npi': 'onKeyPress',
	
	        'click @ui.reRequest': 'onReRequest',
	        'click @ui.fillForm': 'onFormFill',
	
	        'change @ui.isPatient': 'onChangeIsPatient',
	        'change @ui.isMd': 'onChangeIsMd',
	        'change @ui.isOfficeAdmin': 'onChangeIsOfficeAdmin',
	        'change @ui.isMedicalDirector': 'onChangeIsMedicalDirector',
	        'change @ui.isManager': 'onChangeIsManager',
	        'change @ui.isAdmin': 'onChangeIsAdmin',
	        'change @ui.pendingDocsNotifChb': 'onChangePendingDocsNotif',
	
	        'click @ui.generatePass': 'generatePass'
	    },
	
	    tempNpi: '',
	    npiPersonData: undefined,
	
	    generatePassButtonText: 'Generate and copy to clipboard',
	
	    templateContext: function () {
	        var that = this;
	        var bd = that.model.get('object').birthData;
	        return {
	            isEditMode: that.isEditMode,
	            birthData: (bd == '' || bd == null || bd == 0 ? '' : utils.longToDateTimeFormattedInUtc(Number(bd), 'MM/DD/YYYY')),
	            generatePassButtonText: that.generatePassButtonText,
	            byAdmin: that.getOption('byAdmin'),
	            forSignup: that.getOption("forSignup"),
	            email: (that.model.get('object').contacts || []).filter(function (contact) {
	                return contact.type == 'EMAIL' && contact.preferred == true;
	            }).map(function (contact) {
	                return contact.data;
	            })[0] || '',
	            days: utils.getDaysValues(),
	            hours: utils.getHoursValues()
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'fillModel', 'clearModel', 'validate', 'validateBy', 'updateValidatingResults', 'onNpiChange',
	            'initValidatingResults', 'onKeyPress', 'npiRequest', 'onNpiRequestStart', 'onNpiRequestSuccess', 'onNpiRequestFailure',
	            'onNpiRequestEnd', 'onReRequest', 'onFormFill', 'onChangeIsPatient', 'onChangeIsMd', 'onChangePendingDocsNotif', 'generatePass',
	            'destroyFilledAddressesAndContacts', 'fillAddressesAndContactsFromNpi', 'onChangeIsAdmin', 'onChangeIsOfficeAdmin',
	            'onChangeIsMedicalDirector', 'onChangeIsManager');
	        this.model.on('change', this.render, this);
	        this.initValidatingResults();
	        var object = this.model.get('object');
	        if (object.login)
	            this.validatingResults.login = true;
	        if (object.password || options.isEditMode)
	            this.validatingResults.password = true;
	        if (object.firstName)
	            this.validatingResults["first-name"] = true;
	        if (object.lastName)
	            this.validatingResults["last-name"] = true;
	
	        this.validatingResults["ssn"] = true;
	        this.isEditMode = options.isEditMode;
	        this.forSignup = options.forSignup;
	
	        if (!this.forSignup) {
	            this.validatingResults["email"] = true;
	        }
	
	        if (this.model.get('object').npi && utils.isValidNPI(this.model.get('object').npi) || _.isEmpty(this.model.get('object').npi))
	            this.validatingResults["npi"] = true;
	
	        this.addressesAndContactsFromNpi = {};
	        this.isAddressFieldFilledManually = true;
	
	        this.address = {
	            uuid: utils.generatedUUID(),
	            country: '',
	            state: '',
	            zip: '',
	            town: '',
	            address: '',
	            usage: 'WP',
	            source: 'MANUAL'
	        };
	    },
	
	    initValidatingResults: function () {
	        this.validatingResults = _.clone(this.defaultValidatingResults);
	    },
	
	    onRender: function () {
	        this.ui.birthDate.datepicker({
	            format: 'mm/dd/yyyy'
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	
	        var genderSelectize = this.ui.gender.selectize({
	            allowEmptyOption: false,
	            inputClass: 'form-control selectize-input normal-width form-control',
	            highlight: true,
	            openOnFocus: true
	        });
	        this.genderSelectized = genderSelectize[0].selectize;
	
	        this.ui.reviewPeriodDays.selectize({
	            allowEmptyOption: false,
	            placeholder: 'Days',
	            inputClass: 'form-control selectize-input'
	        });
	
	        this.ui.reviewPeriodHours.selectize({
	            allowEmptyOption: false,
	            placeholder: 'Hours',
	            inputClass: 'form-control selectize-input'
	        });
	
	        this.ui.ssn.mask("999-99-9999", {
	            autoclear: false
	        });
	
	        this.ui.progress.parent().hide();
	        this.ui.reRequest.parent().hide();
	
	        if (utils.isValidNPI(this.ui.npi.val())) {
	            this.npiRequest(this.ui.npi.val());
	        } else {
	            this.ui.fillForm.prop('disabled', true);
	        }
	
	        if (!this.isEditMode)
	            this.showStateSelect();
	    },
	
	    showStateSelect: function () {
	        var that = this;
	
	        that.showChildView('stateSelect', new RemoteSuggesterView({
	            tag: 'state',
	            inputId: 'state',
	            maxNumberOfElements: 20,
	            url: '/api/reference/states/~~~',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getValueFn: function (element) {
	                return element;
	            },
	            classes: ["form-control", "address-field"],
	            placeholder: "Select state",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return arr[index] || null;
	            }
	        }));
	    },
	
	    onChangeIsPatient: function (event) {
	        this.model.get('object').isPatient = event.target.checked;
	    },
	
	    onChangeIsMd: function (event) {
	        this.model.get('object').isMd = event.target.checked;
	    },
	
	    onChangeIsOfficeAdmin: function (event) {
	        this.model.get('object').isOfficeAdministrator = event.target.checked;
	    },
	
	    onChangeIsMedicalDirector: function (event) {
	        this.model.get('object').isMedicalDirector = event.target.checked;
	    },
	
	    onChangeIsManager: function (event) {
	        this.model.get('object').isManager = event.target.checked;
	    },
	
	    onChangeIsAdmin: function (event) {
	        this.model.get('object').isAdmin = event.target.checked;
	    },
	
	    onChangePendingDocsNotif: function (event) {
	        this.model.get('object').pendingDocumentsNotification = event.target.checked;
	    },
	
	    onNpiKeyup: function (event) {
	        this.onNpi(event);
	    },
	
	    onNpiChange: function (event) {
	        this.onNpi(event, true);
	    },
	
	    onNpi: function (event, copyToLogin) {
	        var that = this;
	        var value = event.target.value;
	        var tempIdOld = that.tempNpi;
	        that.tempNpi = value;
	
	        if (!this.isEditMode) {
	            var loginVal = that.ui.login.val();
	            if (loginVal == '' || loginVal.toLowerCase() == value.toLowerCase().substr(0, value.length - 1)
	                || (event.keyCode == 8 && loginVal.toLowerCase().substr(0, loginVal.length - 1) == value.toLowerCase())) {
	                that.ui.login.val(value);
	                that.ui.login.blur();
	            }
	
	            if (copyToLogin && value.length == 10) {
	                that.ui.login.val(value);
	                that.ui.login.blur();
	            }
	        }
	
	        if (utils.isValidNPI(value) && tempIdOld != value) {
	            this.ui.fillForm.prop('disabled', false);
	            window.setTimeout(function () {
	                that.npiRequest(value);
	            }, 0);
	            return;
	        } else {
	            that.destroyFilledAddressesAndContacts();
	        }
	
	        if (_.isEmpty(value)) {
	            that.ui.npi.tooltip("destroy");
	            that.ui.npi.parent().removeClass('has-error has-feedback');
	            that.validatingResults["npi"] = true;
	            this.checkSaveBtn();
	            this.ui.fillForm.prop('disabled', true);
	            return;
	        }
	
	        if (!utils.isValidNPI(value)) {
	            that.ui.npi.tooltip({title: 'Invalid NPI'});
	            this.ui.npi.parent().addClass('has-error has-feedback');
	            that.validatingResults["npi"] = false;
	            this.checkSaveBtn();
	            this.ui.fillForm.prop('disabled', true);
	            return;
	        }
	    },
	
	    npiRequest: function (value) {
	        var that = this;
	        that.onNpiRequestStart();
	        $.ajax({
	            type: "GET",
	            url: '/api/npi?type=NPI_1&number=' + value,
	            statusCode: {
	                200: function (response) {
	                    if (response.length == 0) {
	                        that.onNpiRequestFailure();
	                        that.npiPersonData = undefined;
	                    }
	                    else {
	                        that.onNpiRequestSuccess();
	                        that.npiPersonData = utils.personDataFromNpiData(response[0]);
	                        that.npiData = response[0];
	                    }
	                }
	            },
	            error: function (e) {
	                that.onNpiRequestEnd();
	                notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        });
	    },
	
	    onReRequest: function () {
	        this.npiRequest(this.ui.npi.val());
	    },
	
	    onKeyPress: function (event) {
	        event = event || window.event;  // IE support
	        var ctrlDown = event.ctrlKey || event.metaKey;
	
	        return event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 37 || event.keyCode == 39 ||
	            ctrlDown || event.charCode >= 48 && event.charCode <= 57 && event.target.value.length < 10;
	    },
	
	    onNpiRequestStart: function () {
	        this.ui.progress.parent().show();
	        this.ui.reRequest.parent().hide();
	        this.ui.fillForm.parent().hide();
	        this.ui.fillForm.prop('disabled', true);
	        this.ui.npi.tooltip("destroy");
	        this.ui.npi.attr('disabled', true);
	    },
	
	    onNpiRequestSuccess: function () {
	        this.ui.progress.parent().hide();
	        this.ui.reRequest.parent().hide();
	        this.ui.fillForm.parent().show();
	        this.ui.fillForm.prop('disabled', false);
	        this.ui.npi.tooltip({title: 'Person with this NPI found'});
	        this.ui.npi.parent().removeClass('has-error has-feedback');
	        this.ui.npi.removeAttr('disabled');
	        this.validatingResults["npi"] = true;
	        this.checkSaveBtn();
	    },
	
	    onNpiRequestFailure: function () {
	        this.ui.progress.parent().hide();
	        this.ui.reRequest.parent().show();
	        this.ui.fillForm.parent().hide();
	        this.ui.fillForm.prop('disabled', true);
	        this.ui.npi.tooltip({title: 'Person with this NPI not found'});
	        this.ui.npi.parent().addClass('has-error has-feedback');
	        this.ui.npi.removeAttr('disabled');
	        this.validatingResults["npi"] = false;
	        this.checkSaveBtn();
	    },
	
	    onNpiRequestEnd: function () {
	        this.ui.progress.parent().hide();
	        this.ui.reRequest.parent().hide();
	        this.ui.fillForm.prop('disabled', true);
	        this.ui.npi.tooltip("destroy");
	        this.ui.npi.removeAttr('disabled');
	        this.validatingResults["npi"] = false;
	        this.checkSaveBtn();
	    },
	
	    onFormFill: function () {
	        this.ui.isMd.prop('checked', true);
	        this.model.get('object').isMd = true;
	
	        this.ui.lastName.val(this.npiPersonData["lastName"]);
	        this.validateBy(this.ui.lastName);
	
	        this.ui.firstName.val(this.npiPersonData['firstName']);
	        this.validateBy(this.ui.firstName);
	
	        this.ui.middleName.val(this.npiPersonData["middleName"]);
	
	        this.genderSelectized.setValue(this.npiPersonData["gender"], true);
	
	        if (!this.isEditMode) {
	            var addressObject = this.npiPersonData['address'];
	            this.ui.zip.val(addressObject.zip);
	            this.ui.address.val(addressObject.address);
	            this.ui.town.val(addressObject.town);
	            $('#state').val(addressObject.state);
	            this.address.zip = addressObject.zip;
	            this.address.address = addressObject.address;
	            this.address.town = addressObject.town;
	            this.address.state = addressObject.state;
	
	            this.isAddressFieldFilledManually = false;
	        }
	
	        this.ui.login.val(this.ui.npi.val());
	
	        this.fillAddressesAndContactsFromNpi();
	        notificationsChannel.request('show:notification', {
	            message: 'Profile is filled with data from NPI registry',
	            code: 200
	        });
	    },
	
	    destroyFilledAddressesAndContacts: function () {
	        this.addressesAndContactsFromNpi = {};
	    },
	
	    fillAddressesAndContactsFromNpi: function () {
	        this.addressesAndContactsFromNpi = utils.addressesAndContactsFromNpiData(this.npiData);
	    },
	
	    onAddressChange: function (event) {
	        this.address[event.target.id] = event.target.value;
	        this.isAddressFieldFilledManually = true;
	    },
	
	    fillModel: function () {
	        var that = this;
	        var object = this.model.get('object');
	        var contacts = object.contacts || [];
	        var addresses = object.addresses || [];
	        var representatives = object.representatives || [];
	
	        if (this.forSignup) {
	            contacts.push({
	                data: that.ui.email.val(),
	                type: 'EMAIL',
	                preferred: true,
	                source: 'MANUAL'
	            });
	        }
	
	        if (that.addressesAndContactsFromNpi.addresses && !_.isEmpty(that.addressesAndContactsFromNpi.addresses)) {
	            addresses = addresses.filter(function (address) {
	                return address.source != 'NPI';
	            });
	            that.addressesAndContactsFromNpi.addresses.forEach(function (address) {
	                addresses.push(address);
	            });
	        }
	
	        if (that.addressesAndContactsFromNpi.contacts && !_.isEmpty(that.addressesAndContactsFromNpi.contacts)) {
	            var preferredContacts = contacts.filter(function (contact) {
	                return contact.preferred === true;
	            });
	            contacts = contacts.filter(function (contact) {
	                return contact.source != 'NPI';
	            });
	            that.addressesAndContactsFromNpi.contacts.forEach(function (contact) {
	                if (contact.type === "FAX" && (preferredContacts.length == 0 || preferredContacts.filter(function (ctct) {
	                        return ctct.data === contact.data && contact.type === "FAX" && ctct.type === "FAX";
	                    }).length > 0)) {
	                    contact.preferred = true;
	                } else {
	                    contact.preferred = false;
	                }
	                contacts.push(contact);
	            });
	        }
	
	        if (!that.isEditMode && that.isAddressFieldFilledManually) {
	            that.address.source = "MANUAL";
	            addresses.push(that.address);
	        }
	
	        that.model.set({
	            object: utils.mergeObjectsLeft(object, {
	                firstName: that.ui.firstName.val(),
	                lastName: that.ui.lastName.val(),
	                middleName: that.ui.middleName.val(),
	                login: that.isEditMode ? that.model.get('object').login : that.ui.login.val(),
	                password: that.isEditMode ? "" : that.ui.password.val(),
	                address: that.ui.address.val(),
	                npi: that.ui.npi.val(),
	                ssn: that.ui.ssn.val().replace(new RegExp('-', 'g'), ''),
	                insuranceId: that.ui.insuranceId.val(),
	                isMd: object.isMd,
	                isAdmin: object.isAdmin,
	                isPatient: object.isPatient,
	                isOfficeAdministrator: object.isOfficeAdministrator,
	                isMedicalDirector: object.isMedicalDirector,
	                isManager: object.isManager,
	                pendingDocumentsNotification: object.pendingDocumentsNotification,
	                birthData: utils.dateToLongInUtc(that.ui.birthDate.val()),
	                gender: that.ui.gender.val(),
	                contacts: contacts,
	                addresses: addresses,
	                representatives: representatives,
	                defaultReviewPeriod: {
	                    days: that.ui.reviewPeriodDays.val(),
	                    hours: that.ui.reviewPeriodHours.val()
	                }
	            })
	        }/*, {validate: true}*/);
	
	        return this.model;
	    },
	
	    clearModel: function () {
	        this.model.set(this.model.defaults);
	        return this.model;
	    },
	
	    defaultValidatingResults: {
	        "email": false,
	        "login": false,
	        "password": false,
	        "first-name": false,
	        "last-name": false,
	        "npi": false
	    },
	
	    validatingResults: undefined,
	
	    validatingFunctions: {
	        "email": function (value) {
	            if (_.isEmpty(value))
	                return "Email should be filled";
	            if (!utils.isValidEmail(value))
	                return "Invalid email";
	            else return "";
	        },
	        "login": function (value) {
	            if (value.length < 4)
	                return "Login length should be at least 4 characters long";
	            else return "";
	        },
	        "password": function (value) {
	            if (value.length < 8 || !(/[\d]/.test(value)) || !(/[a-z]/.test(value)) || !(/[A-Z]/.test(value))) {
	                return "Password length should be at least 8 characters long and contains at least 1 letter, 1 digit and 1 capital letter.";
	            }
	            else
	                return "";
	        },
	        "first-name": function (value) {
	            if (value.length == 0)
	                return "First name should not be empty";
	            else return "";
	        },
	        "last-name": function (value) {
	            if (value.length == 0)
	                return "Last name should not be empty";
	            else return "";
	        },
	        "ssn": function (value) {
	            value = value.replace('___-__-____', '');
	
	            if (value.indexOf('_') > -1) {
	                return "Invalid SSN";
	            } else if (_.isEmpty(value))
	                return "";
	            else
	                return "";
	        }
	    },
	
	    validate: function (event) {
	        var jQelement = $(event.target);
	        this.validateBy(jQelement);
	    },
	
	    validateBy: function (jQelement) {
	        var value = jQelement.val();
	        var id = jQelement.attr('id');
	        var checkResult = this.validatingFunctions[id](value);
	
	        if (this.isEditMode && (id == "password" || id == 'login')) {
	            checkResult = "";
	        }
	
	        if (checkResult.length > 0) {
	            this.addTooltip(jQelement, checkResult);
	            this.addErrorClass(jQelement);
	            this.updateValidatingResults(id, false);
	        }
	        else {
	            this.removeTooltip(jQelement);
	            this.removeErrorClass(jQelement);
	            this.updateValidatingResults(id, true);
	        }
	    },
	
	    updateValidatingResults: function (name, value) {
	        this.validatingResults[name] = value;
	        this.checkSaveBtn();
	    },
	
	    addTooltip: function (jQelement, text) {
	        jQelement.tooltip({title: text});
	    },
	
	    removeTooltip: function (jQelement) {
	        jQelement.tooltip("destroy");
	    },
	
	    addErrorClass: function (jQelement) {
	        jQelement.parent().parent().addClass('has-error has-feedback');
	    },
	
	    removeErrorClass: function (jQelement) {
	        jQelement.parent().parent().removeClass('has-error has-feedback');
	    },
	
	    checkSaveBtn: function () {
	        if (this.validatingResults["email"] && this.validatingResults.login && this.validatingResults.password
	            && this.validatingResults["first-name"] && this.validatingResults["last-name"]
	            && this.validatingResults["ssn"] && this.validatingResults["npi"]) {
	            this.triggerMethod('person:save:valid', {result: true});
	        } else {
	            this.triggerMethod('person:save:valid', {result: false});
	        }
	    },
	
	    generatePass: function () {
	        var password = utils.generatePassword(8);
	        this.ui.password.val(password);
	        this.ui.passwordHidden.val(password);
	        this.ui.passwordHidden.show();
	        this.ui.passwordHidden.select();
	        document.execCommand('copy');
	        this.ui.passwordHidden.hide();
	        this.ui.passwordHidden.val('');
	
	        this.ui.generatePass.toggleClass('btn-primary');
	        this.ui.generatePass.toggleClass('btn-success');
	        this.ui.generatePass.html('Copied');
	        this.ui.generatePass.prop('disabled', function (i, v) {
	            return !v;
	        });
	
	        var that = this;
	        setTimeout(function () {
	            that.ui.generatePass.toggleClass('btn-primary');
	            that.ui.generatePass.toggleClass('btn-success');
	            that.ui.generatePass.html(that.generatePassButtonText);
	            that.ui.generatePass.prop('disabled', function (i, v) {
	                return !v;
	            });
	        }, 1000);
	        this.validateBy($(that.ui.password));
	    },
	
	    validateAllRequiredFields: function () {
	        this.validateBy(this.ui.login);
	        this.validateBy(this.ui.password);
	        this.validateBy(this.ui.firstName);
	        this.validateBy(this.ui.lastName);
	        this.validateBy(this.ui.ssn);
	    }
	
	});
	
	module.exports = PersonForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form-horizontal top-margined">\n    <div>\n        ';
	 if (forSignup) { 
	__p+='\n        <div class="form-group">\n            <label class="col-xs-9 col-md-3 control-label" for="email">Email:</label>\n            <div class="col-xs-9 col-md-9">\n                <input class="form-control" type="text" id="email" placeholder="Email" value="'+
	((__t=( email ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="id-npi">NPI</label>\n            <div class="col-sm-7 col-md-7">\n                <input class="form-control" type="text" id="id-npi" placeholder="Type or paste NPI" value="'+
	((__t=( object.npi ))==null?'':_.escape(__t))+
	'">\n            </div>\n            <div class="col-sm-2 col-md-2">\n                <label id="progress"><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>\n                    Request...</label>\n            </div>\n            <div class="col-sm-2 col-md-2">\n                <button type="button" class="btn btn-primary" id="re-request">Re-request</button>\n            </div>\n            <div class="col-sm-2 col-md-2">\n                <button type="button" class="btn btn-primary" id="fill-form">Fill form</button>\n            </div>\n        </div>\n        ';
	 if (!isEditMode) { 
	__p+='\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="login">Login</label>\n            <div class="col-sm-9 col-md-9">\n                <input class="form-control" type="text" id="login" placeholder="Login" required=""\n                       value="'+
	((__t=( object.login ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="password">Password</label>\n            <div class="col-sm-5 col-md-5">\n                <input class="form-control" type="password" id="password" placeholder="Password" required="">\n                <input class="form-control" type="text" id="password-hidden" style="display: none">\n            </div>\n            <div class="col-sm-4 col-md-4">\n                <button type="button" class="btn btn-primary" id="generate-pass">'+
	((__t=( generatePassButtonText ))==null?'':__t)+
	'</button>\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="first-name">First Name</label>\n            <div class="col-sm-9 col-md-9">\n                <input class="form-control" type="text" id="first-name" placeholder="First Name"\n                       value="'+
	((__t=( object.firstName ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="middle-name">Middle Name</label>\n            <div class="col-sm-9 col-md-9">\n                <input class="form-control" type="text" id="middle-name" placeholder="Middle Name"\n                       value="'+
	((__t=( object.middleName ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="last-name">Last Name</label>\n            <div class="col-sm-9 col-md-9">\n                <input class="form-control" type="text" id="last-name" placeholder="Last Name"\n                       value="'+
	((__t=( object.lastName ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="birth-date">Birth Date</label>\n            <div class="col-sm-9 col-md-9">\n                <input class="form-control" type="text" id="birth-date" placeholder="Birth Date"\n                       value="'+
	((__t=( birthData ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="gender-values">Gender</label>\n            <div class="col-sm-9 col-md-9">\n                <select id="gender-values">\n                    <option value="M" ';
	 if (object.gender == 'M') { 
	__p+=' selected ';
	 } 
	__p+=' >Male</option>\n                    <option value="F" ';
	 if (object.gender == 'F') { 
	__p+=' selected ';
	 } 
	__p+=' >Female</option>\n                    <option value="NA" ';
	 if (object.gender == 'NA') { 
	__p+=' selected ';
	 } 
	__p+=' >NA</option>\n                </select>\n            </div>\n        </div>\n        ';
	 if (!isEditMode) { 
	__p+='\n        <div class="form-group">\n            <label class="col-xs-3 col-md-3 control-label">Address</label>\n            <div class="col-xs-3 col-md-3">\n                <input class="form-control address-field" type="text" id="town" placeholder="Town"/>\n            </div>\n            <div class="col-xs-4 col-md-4">\n                <div id="state-select"></div>\n            </div>\n            <div class="col-xs-2 col-md-2">\n                <input class="form-control address-field" type="text" id="zip" placeholder="Zip code"/>\n            </div>\n        </div>\n        <div class="form-group">\n            <div class="col-md-offset-3 col-xs-offset-3 col-xs-9 col-md-9">\n                <input class="form-control address-field" type="text" id="address" placeholder="Address line"/>\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n\n        ';
	 if (byAdmin || !isEditMode) { 
	__p+='\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="is-md">Is Provider</label>\n            <div class="checkbox col-sm-9 col-md-9">\n                <input type="checkbox" value="" id="is-md" style="margin-left: 10px;" ';
	 if (object && object.isMd) { 
	__p+='\n                checked ';
	 } 
	__p+=' >\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="is-patient">Is patient</label>\n            <div class="checkbox col-sm-9 col-md-9">\n                <input type="checkbox" value="" id="is-patient" style="margin-left: 10px;" ';
	 if (object &&
	                object.isPatient) { 
	__p+=' checked ';
	 } 
	__p+=' >\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="is-office-admin">Is Office Administrator</label>\n            <div class="checkbox col-sm-9 col-md-9">\n                <input type="checkbox" value="" id="is-office-admin" style="margin-left: 10px;" ';
	 if (object &&
	                object.isOfficeAdministrator) { 
	__p+=' checked ';
	 } 
	__p+=' >\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="is-medical-director">Is Medical Director</label>\n            <div class="checkbox col-sm-9 col-md-9">\n                <input type="checkbox" value="" id="is-medical-director" style="margin-left: 10px;" ';
	 if (object &&
	                object.isMedicalDirector) { 
	__p+=' checked ';
	 } 
	__p+=' >\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="is-manager">Is Manager</label>\n            <div class="checkbox col-sm-9 col-md-9">\n                <input type="checkbox" value="" id="is-manager" style="margin-left: 10px;" ';
	 if (object &&
	                object.isManager) { 
	__p+=' checked ';
	 } 
	__p+=' >\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n        ';
	 if (byAdmin) { 
	__p+='\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="is-admin">Is Admin</label>\n            <div class="checkbox col-sm-9 col-md-9">\n                <input type="checkbox" value="" id="is-admin" style="margin-left: 10px;" ';
	 if (object && object.isAdmin) { 
	__p+='\n                checked ';
	 } 
	__p+=' >\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="ssn">SSN</label>\n            <div class="col-sm-9 col-md-9">\n                <input class="form-control" type="text" id="ssn" placeholder="SSN"\n                       value="'+
	((__t=( object.ssn ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="insuranceId">Insurance ID</label>\n            <div class="col-sm-9 col-md-9">\n                <input class="form-control" type="text" id="insuranceId" placeholder="Insurance number"\n                       value="'+
	((__t=( object.insuranceId ))==null?'':_.escape(__t))+
	'">\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="pending-docs-notif">Pending documents\n                notification</label>\n            <div class="checkbox col-sm-9 col-md-9">\n                <input type="checkbox" value="" id="pending-docs-notif" style="margin-left: 10px;" ';
	 if (object &&
	                object.pendingDocumentsNotification) { 
	__p+=' checked ';
	 } 
	__p+=' >\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-3 col-md-3 control-label">Review period</label>\n            <label class="col-xs-1 col-md-1 control-label" for="review-period-days">Days</label>\n            <div class="col-xs-2 col-md-2">\n                <select id="review-period-days">\n                    ';
	 _.each(days, function(day){ 
	__p+='\n                    ';
	 if (object.defaultReviewPeriod && object.defaultReviewPeriod.days && object.defaultReviewPeriod.days === day) { 
	__p+='\n                    <option value="'+
	((__t=( day ))==null?'':__t)+
	'" name="'+
	((__t=( day ))==null?'':__t)+
	'" selected> '+
	((__t=( day ))==null?'':__t)+
	'</option>\n                    ';
	 } else if (day === 3 && !object.defaultReviewPeriod) { 
	__p+='\n                    <option value="'+
	((__t=( day ))==null?'':__t)+
	'" name="'+
	((__t=( day ))==null?'':__t)+
	'" selected> '+
	((__t=( day ))==null?'':__t)+
	'</option>\n                    ';
	 } else { 
	__p+='\n                    <option value="'+
	((__t=( day ))==null?'':__t)+
	'" name="'+
	((__t=( day ))==null?'':__t)+
	'"> '+
	((__t=( day ))==null?'':__t)+
	'</option>\n                    ';
	 } 
	__p+='\n                    ';
	 }) 
	__p+='\n                </select>\n            </div>\n            <label class="col-xs-1 col-md-1 control-label" for="review-period-hours">Hours</label>\n            <div class="col-xs-2 col-md-2">\n                <select id="review-period-hours">\n                    ';
	 _.each(hours, function(hour){ 
	__p+='\n                    ';
	 if (object.defaultReviewPeriod && object.defaultReviewPeriod.hours && object.defaultReviewPeriod.hours === hour) { 
	__p+='\n                    <option value="'+
	((__t=( hour ))==null?'':__t)+
	'" name="'+
	((__t=( hour ))==null?'':__t)+
	'" selected> '+
	((__t=( hour ))==null?'':__t)+
	'</option>\n                    ';
	 } else if (hour === 0) { 
	__p+='\n                    <option value="'+
	((__t=( hour ))==null?'':__t)+
	'" name="'+
	((__t=( hour ))==null?'':__t)+
	'" selected> '+
	((__t=( hour ))==null?'':__t)+
	'</option>\n                    ';
	 } else { 
	__p+='\n                    <option value="'+
	((__t=( hour ))==null?'':__t)+
	'" name="'+
	((__t=( hour ))==null?'':__t)+
	'"> '+
	((__t=( hour ))==null?'':__t)+
	'</option>\n                    ';
	 } 
	__p+='\n                    ';
	 }) 
	__p+='\n                </select>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td class="center"><input type="checkbox" class="check-person"></td>\n<td><a href = "/#person/'+
	((__t=( id ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( id ))==null?'':__t)+
	'</a></td>\n<td>'+
	((__t=( object.lastName ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( object.firstName ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( object.middleName ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( birthDate ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( object.ssn ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( object.npi ))==null?'':__t)+
	'</td>\n';
	 if (active) { 
	__p+='\n<td>Active</td>\n<td><span class="glyphicon glyphicon-remove clickable deactivate" uid="'+
	((__t=( id ))==null?'':__t)+
	'"/></td>\n';
	 } else { 
	__p+='\n<td>Not active</td>\n<td><span class="glyphicon glyphicon-play clickable activate" uid="'+
	((__t=( id ))==null?'':__t)+
	'"/></td>\n';
	 } 
	__p+='\n';
	}
	return __p;
	};


/***/ }),
/* 339 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row">\r\n    <div class="col-xs-10 col-md-6">\r\n        <div class="row">\r\n            <div class="col-xs-3 col-md-6">\r\n                <h2>\r\n                    Persons\r\n                </h2>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<!--Filters-->\r\n<div class="filters">\r\n    <div class="form-inline form">\r\n        <div class="form-group">\r\n            <input type="text"  class="form-control filter-field" placeholder="Login" name="object_login_like"\r\n            ';
	 if (getParam('object_login_like')){ 
	__p+=' value="'+
	((__t=( getParam('object_login_like') ))==null?'':__t)+
	'"  ';
	 } 
	__p+='\r\n            />\r\n        </div>\r\n        <div class="form-group">\r\n            <input type="text"  class="form-control filter-field" placeholder="Last name" name="object_lastName_like"\r\n            ';
	 if (getParam('object_lastName_like')){ 
	__p+=' value="'+
	((__t=( getParam('object_lastName_like') ))==null?'':__t)+
	'"  ';
	 } 
	__p+='\r\n            />\r\n        </div>\r\n        <div class="form-group">\r\n            <input type="text"  class="form-control filter-field" placeholder="First name" name="object_firstName_like"\r\n            ';
	 if (getParam('object_firstName_like')){ 
	__p+=' value="'+
	((__t=( getParam('object_firstName_like') ))==null?'':__t)+
	'"  ';
	 } 
	__p+='\r\n            />\r\n        </div>\r\n        <div class="form-group">\r\n            <input type="text"  class="form-control filter-field" placeholder="Middle name" name="object_middleName_like"\r\n            ';
	 if (getParam('object_middleName_like')){ 
	__p+=' value="'+
	((__t=( getParam('object_middleName_like') ))==null?'':__t)+
	'"  ';
	 } 
	__p+='\r\n            />\r\n        </div>\r\n        <div class="form-group">\r\n            <input type="text"  class="form-control filter-field" placeholder="SSN" name="object_ssn_like"\r\n            ';
	 if (getParam('object_ssn_like')){ 
	__p+=' value="'+
	((__t=( getParam('object_ssn_like') ))==null?'':__t)+
	'"  ';
	 } 
	__p+='\r\n            />\r\n        </div>\r\n        <div class="form-group">\r\n            <input type="text"  class="form-control filter-field" id="npi" placeholder="NPI" name="object_npi_like"\r\n            ';
	 if (getParam('object_npi_like')){ 
	__p+=' value="'+
	((__t=( getParam('object_npi_like') ))==null?'':__t)+
	'"  ';
	 } 
	__p+='\r\n            />\r\n        </div>\r\n        <div class="input-daterange input-group form-group" id="burn-range" style="width:280px;">\r\n            <input type="text" class="form-control" id="burn-after" placeholder="Born after" style="width:130px;" name="object_birthData_from"\r\n            ';
	 if (getDateParam('object_birthData_from')){ 
	__p+=' value="'+
	((__t=( getDateParam('object_birthData_from') ))==null?'':__t)+
	'"  ';
	 } 
	__p+='\r\n            />\r\n            <span class="input-group-addon">to</span>\r\n            <input type="text" class="form-control" id="burn-before" placeholder="Born before" style="width:130px;" name="object_birthData_to"\r\n            ';
	 if (getDateParam('object_birthData_to')){ 
	__p+=' value="'+
	((__t=( getDateParam('object_birthData_to') ))==null?'':__t)+
	'"  ';
	 } 
	__p+='\r\n            />\r\n        </div>\r\n        <div class="form-group">\r\n            <button class="btn btn-primary" title="Apply filter" id="filter">Filter</button>\r\n        </div>\r\n        <div class="form-group">\r\n            <button class="btn btn-primary" title="Reset filter" id="reset">Clear filter</button>\r\n        </div>\r\n        <div class="form-group">\r\n            <button type="button" title="Add new person" class="btn btn-primary" data-toggle="modal" data-target="#addPersonModal">+</button>\r\n        </div>\r\n        <div class="form-group">\r\n            <a href="#import-persons" title="Import persons" class="btn btn-primary"><span class="glyphicon glyphicon-import"></span></a>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div class="loading"></div>\r\n\r\n<table class="table table-hover top-margined">\r\n    <head>\r\n        <thead>\r\n        <tr>\r\n            <th><label class="checkbox-inline"><input type="checkbox" id="check-all"><b>All</b></label></th>\r\n            <th>Login</th>\r\n            <th>Last name</th>\r\n            <th>First name</th>\r\n            <th>Middle name</th>\r\n            <th>Birth date</th>\r\n            <th>SSN</th>\r\n            <th>NPI</th>\r\n            <th>Status</th>\r\n            <th></th>\r\n        </tr>\r\n        </thead>\r\n    </head>\r\n    <tbody></tbody>\r\n</table>\r\n\r\n<div id="pager"></div>\r\n\r\n<div class="modal fade" id="addPersonModal" tabindex="-1" role="dialog" aria-labelledby="addPersonModalLabel">\r\n    <div class="modal-dialog modal-lg" role="document">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\r\n                <h4 class="modal-title" id="addPersonModalLabel">Add new person</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <div id="form"></div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>\r\n                <button type="button" class="btn btn-primary" id="save-person" disabled>Save changes</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var ResendConfirmationLinkView = __webpack_require__(341);
	
	var CommonUtils = __webpack_require__(189);
	var Radio = __webpack_require__(183);
	
	var notificationsChannel = Radio.channel('notifications');
	
	var SessionModel = __webpack_require__(187);
	
	var LoginView = Marionette.View.extend({
	    template: __webpack_require__(343),
	
	    regions: {
	        resendConfirmationLinkFormRegion: '#resend-confirmation-link-form-modal'
	    },
	
	    ui: {
	        login: '#login',
	        password: '#password',
	        forgotPasswordLink: '#forgot-password-link',
	        needHelpLink: '#need-help-link',
	        popup: '#popup',
	        resendConfirmationLink: '#resend-confirmation-link',
	
	        name: '#name',
	        email: '#email',
	        text: '#text',
	        send: '#send'
	    },
	
	    events: {
	        'click #perform-login': 'performLogin',
	        'keypress': 'onKeyPress',
	        'click @ui.forgotPasswordLink': 'openForgotPasswordModal',
	        'click @ui.needHelpLink': 'openNeedHelpModal',
	        'click @ui.resendConfirmationLink': 'onClickResendConfirmationLink',
	
	        'click @ui.send': 'send',
	        'keyup @ui.name': 'validate',
	        'change @ui.name': 'validate',
	        'keyup @ui.email': 'validate',
	        'change @ui.email': 'validate',
	        'keyup @ui.text': 'validate',
	        'change @ui.text': 'validate'
	    },
	
	
	    initialize: function () {
	        _.bindAll(this, 'performLogin', 'onKeyPress');
	        this.utils = new CommonUtils();
	        this.session = new SessionModel();
	        window.document.title = "Login";
	    },
	
	    performLogin: function () {
	        var that = this;
	        // var redirectUrl = this.utils.getQueryParams()['retpath'] || '/documents?toReview=true&simpleMode=true&object_type=pdf';
	        var redirectUrl = that.utils.getQueryParams()['retpath'] || '/documents?object_type=pdf';
	        if (that.utils.getQueryParams()['retpath']) {
	            redirectUrl = '/' + decodeURIComponent(redirectUrl);
	        }
	        Backbone.$.ajax({
	            type: "POST",
	            url: '/api/login/auth?login=' + that.ui.login.val() + '&password=' + that.ui.password.val(),
	            data: {},
	            dataType: 'application/json',
	            statusCode: {
	                200: function () {
	                    that.session.fetch({
	                        success: function (gotSession) {
	                            if (gotSession.get('person').initialUrl) {
	                                Backbone.history.navigate(gotSession.get('person').initialUrl, {trigger: true});
	                            } else {
	                                Backbone.history.navigate(redirectUrl, {trigger: true});
	                            }
	                        }
	                    });
	                },
	                401: function (e) {
	                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	                }
	            }
	        });
	    },
	
	    onKeyPress: function (e) {
	        if (e.keyCode == 13)
	            this.performLogin();
	    },
	
	    openForgotPasswordModal: function () {
	        this.popupShow("Forgot password");
	    },
	
	    openNeedHelpModal: function () {
	        this.popupShow("Need help");
	    },
	
	    popupShow: function (title) {
	        this.$('.modal-title').text(title);
	        this.ui.popup.modal('show');
	        this.validate();
	    },
	
	    validate: function (event) {
	        var isAllInputsValid = true;
	
	        if (this.utils.isValidEmail(this.ui.email.val())) {
	            this.ui.email.parent().removeClass('has-error has-feedback');
	            this.ui.email.tooltip("destroy");
	        } else {
	            this.ui.email.parent().addClass('has-error has-feedback');
	            this.ui.email.tooltip({title: 'Invalid e-mail'});
	            this.ui.send.attr("disabled", "true");
	            isAllInputsValid = false;
	        }
	
	        if (this.ui.name.val().length > 0) {
	            this.ui.name.parent().removeClass('has-error has-feedback');
	            this.ui.name.tooltip("destroy");
	        } else {
	            this.ui.name.parent().addClass('has-error has-feedback');
	            this.ui.name.tooltip({title: 'Empty name'});
	            this.ui.send.attr("disabled", "true");
	            isAllInputsValid = false;
	        }
	
	        if (this.ui.text.val().length > 0) {
	            this.ui.text.parent().removeClass('has-error has-feedback');
	            this.ui.text.tooltip("destroy");
	        } else {
	            this.ui.text.parent().addClass('has-error has-feedback');
	            this.ui.text.tooltip({title: 'Empty text'});
	            this.ui.send.attr("disabled", "true");
	            isAllInputsValid = false;
	        }
	
	        if (isAllInputsValid)
	            this.ui.send.removeAttr("disabled");
	    },
	
	    clearInputs: function () {
	        this.ui.name.val('');
	        this.ui.email.val('');
	        this.ui.text.val('');
	    },
	
	    send: function () {
	        var that = this;
	        that.utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/help/feedback',
	            data: {
	                name: that.ui.name.val(),
	                email: that.ui.email.val(),
	                text: that.ui.text.val()
	            },
	            dataType: 'text',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    $.notify("Message sent successfully. We will contact you soon.", "success");
	                    that.ui.popup.modal('hide');
	                    that.clearInputs();
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner();
	                notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	            }
	        });
	    },
	
	    onClickResendConfirmationLink: function () {
	        var that = this;
	        that.showChildView('resendConfirmationLinkFormRegion', new ResendConfirmationLinkView());
	    }
	});
	
	module.exports = LoginView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	var OkDialogModal = __webpack_require__(332);
	
	var ResendConfirmationLinkView = Marionette.View.extend({
	    template: __webpack_require__(342),
	
	    regions: {
	        inform: '#inform'
	    },
	
	    ui: {
	        modal: '#resend-confirmation-link-modal',
	        send: '#send-confirmation-link',
	        email: '#email',
	        login: '#login'
	    },
	
	    events: {
	        'click @ui.send': 'onSend',
	        'keyup @ui.login': 'validate',
	        'keyup @ui.email': 'validate'
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	        var that = this;
	        that.show();
	        that.validate();
	    },
	
	    onSend: function () {
	
	        var that = this;
	        that.utils.showSpinner("#resend-confirmation-link-loader");
	
	        $.ajax({
	            type: "POST",
	            url: '/api/utility/send/confirmation-link/' + that.ui.login.val(),
	            data: that.ui.email.val(),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner("#resend-confirmation-link-loader");
	
	                    that.informWindow = new OkDialogModal({
	                        title: 'Information',
	                        message: "Confirmation link was send on email provided. Please click on the link to activate your account",
	                        action: function() {
	                            that.hide();
	                        }
	                    });
	
	                    that.showChildView('inform', that.informWindow);
	                    that.informWindow.show();
	                }
	            },
	            error: function(e) {
	                that.utils.hideSpinner("#resend-confirmation-link-loader");
	                notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        });
	    },
	
	    show: function() {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function() {
	        this.ui.modal.modal('hide');
	    },
	
	    validate: function() {
	        var email = this.ui.email.val();
	        var login = this.ui.login.val();
	
	        if (!_.isEmpty(email) && this.utils.isValidEmail(email)) {
	            this.clearError(this.ui.email);
	        } else {
	            this.showError(this.ui.email, "Empty or invalid email");
	        }
	
	        if (!_.isEmpty(login)) {
	            this.clearError(this.ui.login);
	        } else {
	            this.showError(this.ui.login, "Empty login");
	        }
	
	        if (!_.isEmpty(email) && this.utils.isValidEmail(email) && !_.isEmpty(login))
	            this.enableSendButton();
	        else
	            this.disableSendButton();
	    },
	
	    enableSendButton: function () {
	        this.ui.send.removeAttr('disabled');
	    },
	
	    disableSendButton: function () {
	        this.ui.send.attr('disabled', true);
	    },
	
	    showError: function (jQelement, text) {
	        jQelement.tooltip({title: text});
	        jQelement.parent().parent().addClass('has-error has-feedback');
	    },
	
	    clearError: function (jQelement) {
	        jQelement.tooltip("destroy");
	        jQelement.parent().parent().removeClass('has-error has-feedback');
	    }
	});
	
	module.exports = ResendConfirmationLinkView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Modal -->\r\n<div class="modal fade" id="resend-confirmation-link-modal" tabindex="-1" role="dialog" aria-labelledby="resend-confirmation-link-modal">\r\n    <div class="modal-dialog modal-sm" role="document">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\r\n                        aria-hidden="true">&times;</span></button>\r\n                <h4 class="modal-title" id="add-patient-modal-label">Resend confirmation link</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <div class="form-horizontal">\r\n                    <div class="form-group">\r\n                        <label class="col-xs-9 col-md-3 control-label" for="login">Login:</label>\r\n                        <div class="col-xs-9 col-md-9">\r\n                            <input class="form-control" type="text" id="login" placeholder="Login">\r\n                        </div>\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <label class="col-xs-9 col-md-3 control-label" for="email">Email:</label>\r\n                        <div class="col-xs-9 col-md-9">\r\n                            <input class="form-control" type="text" id="email" placeholder="Email">\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div id="resend-confirmation-link-loader" class="loader" style="height: 200px;"></div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\r\n                <button type="button" class="btn btn-primary" id="send-confirmation-link" disabled>Send</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div id="inform"></div>';
	}
	return __p;
	};


/***/ }),
/* 343 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="container">\n    <div id="left" class="col-md-3 col-xs-12">\n        <span class="caption">Welcome to Review & Sign</span>\n        <br>\n        <span class="bordered">\n            <p>\n                By logging into ReviewAndSign.org, I agree that my\n                electronic signature is the legally binding\n                equivalent to my handwritten signature.\n            </p>\n            <p>\n                Whenever I execute an electronic signature, it has\n                the same validity and meaning as my handwritten\n                signature. I will not, at any time in the future,\n                repudiate the meaning of my electronic signature\n                or claim that my electronic signature is not\n                legally binding.\n            </p>\n            <p>\n                <ul>\n                    <li>Casual sharing of ID codes and passwords not acceptable</li>\n                    <li>E-record falsification is as serious as paper record falsification</li>\n                    <li>Only access systems that you have been trained to use</li>\n                    <li>Adhere to system procedures</li>\n                    <li>Understand what you are signing when you execute an electronic signature.</li>\n                </ul>\n            </p>\n        </span>\n    </div>\n    <div id="right" class="col-md-9 col-xs-12">\n        <div id="right-top">\n            <span class="bordered">\n                <h3><b>Current user</b></h3>\n                Enter your ID and Password to access your account.\n\n                <div class="form-horizontal" id="login-form">\n                    <div class="form-group">\n                        <label class="col-sm-2 col-md-2 control-label" for="login">User ID:</label>\n                        <div class="col-sm-6 col-md-6">\n                            <input class="form-control" type="text" id="login" required>\n                        </div>\n                    </div>\n                    <div class="form-group">\n                        <label class="col-sm-2 col-md-2 control-label" for="password">Password:</label>\n                        <div class="col-sm-6 col-md-6">\n                            <input class="form-control" type="password" id="password" required>\n                        </div>\n                    </div>\n                    <div class="form-group">\n                        <div class="col-sm-8 col-md-8">\n                            <a class="clickable" id="forgot-password-link">Forgot password?</a>\n                            <div id="buttons" class="pull-right">\n                                <button type="button" class="btn btn-default" id="perform-login">Sign in</button>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="form-group">\n                        <div class="col-sm-8 col-md-8">\n                            <a class="clickable" id="need-help-link">Need help?</a>\n                        </div>\n                    </div>\n                    <div class="form-group">\n                        <div class="col-sm-8 col-md-8">\n                            <a href="/#cmform">Referral Form</a>\n                        </div>\n                    </div>\n                </div>\n\n            </span>\n        </div>\n        <div id="right-bottom">\n            <span class="bordered">\n                <h3><b>New User</b></h3>\n                <p>\n                    ReviewAndSign.org is pleased to offer you a secure electronic\n                    signature service to enhance communications between medical\n                    practices. Through this service you can <b>upload + download +\n                        sign + receive</b> medical orders and forms eliminating the\n                    inefficiencies of fax, mail and hand delivered paperwork.\n                </p>\n                <p>\n                    ReviewAndSign.org offers a electronic signature system between\n                    medical providers who have enrolled with our system and need to\n                    make communications more effective, reliable and less time\n                    consuming.\n                </p>\n                <h4 class="clickable"><a href="/#signup">Register Now</a></h4>\n                <h4><a class="clickable" id="resend-confirmation-link">Resend Confirmation Link</a></h4>\n            </span>\n        </div>\n    </div>\n</div>\n\n<!-- Modal -->\n<div class="modal fade" id="popup" tabindex="-1" role="dialog">\n    <div class="modal-dialog">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal">&times;</button>\n                <h4 class="modal-title">Help</h4>\n            </div>\n            <div class="modal-body">\n                <div class="form-group">\n                    <input class="form-control" id="name" placeholder="Enter your name" />\n                </div>\n                <div class="form-group">\n                    <input class="form-control" id="email" placeholder="Enter your e-mail" />\n                </div>\n                <div class="form-group">\n                    <textarea class="form-control" rows="10" id="text"></textarea>\n                </div>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-success" id="send" disabled>Send</button>\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div id="resend-confirmation-link-form-modal"></div>';
	}
	return __p;
	};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(215);
	var Marionette = __webpack_require__(180);
	
	var PersonDataView = __webpack_require__(345);
	var PersonForm = __webpack_require__(336);
	var Person = __webpack_require__(206);
	
	var RelationsFormView = __webpack_require__(221);
	var RelationsListView = __webpack_require__(234);
	var PermissionsTableView = __webpack_require__(236);
	var PermissionFormView = __webpack_require__(243);
	
	var ReverseRelationsCollection = __webpack_require__(277);
	var PermissionsCollection = __webpack_require__(249);
	var CommonUtils = __webpack_require__(189);
	
	var ContactsTableView = __webpack_require__(250);
	var ContactFormView = __webpack_require__(254);
	var ContactsCollection = __webpack_require__(253);
	
	var AddressTableView = __webpack_require__(256);
	var AddressesFormView = __webpack_require__(259);
	
	var RepresentativesTableView = __webpack_require__(261);
	var RepresentativeFormView = __webpack_require__(264);
	
	var CommentFormView = __webpack_require__(266);
	var CommentsTableView = __webpack_require__(268);
	
	var ExternalIdsView = __webpack_require__(274);
	
	var MedicalRecords = __webpack_require__(347);
	var DiseasesView = __webpack_require__(356);
	var PatientDocuments = __webpack_require__(364);
	var DeterminationOfNeedRevisedView = __webpack_require__(370);
	var PatientSources = __webpack_require__(372);
	var PatientImmunizations = __webpack_require__(375);
	var PatientDicoms = __webpack_require__(378);
	var PatientVitals = __webpack_require__(381);
	
	var PersonOrganizationsView = __webpack_require__(386);
	
	var Radio = __webpack_require__(183);
	var sessionChannel = Radio.channel('session');
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	
	var PersonView = Marionette.View.extend({
	    template: __webpack_require__(389),
	    regions: {
	        personData: '#person-data',
	        personForm: '#person-form',
	        editSection: '#edit-section',
	        organizationRelations: '#organization-relations',
	        addOrganizationRelation: '#add-organization-relation',
	        permissions: '#permissions',
	        addPermission: '#add-permission',
	        contacts: '#contacts',
	        contactForm: '#contact-form',
	        addresses: '#addresses',
	        addressForm: '#address-form',
	        representatives: '#representatives',
	        representativeForm: '#representative-form',
	        medicalRecords: '#medical-records-container',
	        diseasesRegion: '#diseases-container',
	        documentsRegion: '#documents-container',
	        appendixKKRegion: '#appendix-kk-container',
	        sourcesRegion: '#sources-container',
	        immunizationsRegion: '#immunizations-container',
	        dicomsRegion: '#dicoms-container',
	        vitalsRegion: '#vitals-container',
	        comments: '#comments',
	        addComment: '#add-comment',
	        externalsIdsRegion: '#external-ids',
	        organizationsRegion: '#organizations'
	    },
	
	    ui: {
	        personData: '#person-data',
	        saveBtn: '#save-person',
	        leftTabs: '.left-tabs',
	        saveAppendixKKBtn: '#save-appendix-kk',
	        contactForm: '#contact-form',
	        commentsCount: '#comments-count',
	        representativeForm: "#representative-form"
	    },
	
	    events: {
	        'click #edit-data': 'toggleEdit',
	        'click #cancel-edit': 'toggleEdit',
	        'click #save-person': 'saveChanges',
	        'click @ui.saveAppendixKKBtn': 'onSaveAppendixKK',
	        'comment:count:changed': 'onCommentCountChanged'
	    },
	
	    childViewEvents: {
	        'permission:saved': 'permissionSaved',
	        'person:save:valid': 'savePersonBtnEnableOrDisable',
	        'on:contact:action': 'onContactAction',
	        'on:contact:saved': 'onContactSaved',
	        'on:address:action': 'onAddressAction',
	        'on:address:saved': 'onAddressSaved',
	        'on:representative:action': 'onRepresentativeAction',
	        'on:representative:saved': 'onRepresentativeSaved',
	        'med:record:created': 'reRenderMedProfile',
	        'show:subtabs': 'showLeftSubTabs',
	        'changed-don-r': 'onDonRChanged',
	        'contact:hover': 'onContactHover',
	        'address:hover': 'onAddressHover',
	        'representative:hover': 'onRepresentativeHover',
	        'comment:added': 'onCommentAdded',
	        'comment:count:changed': 'onCommentCountChanged',
	        'on:cancel:comment:send': 'onCancelCommentSend',
	        'on:edit:comment': 'onEditComment',
	        'comment:updated': 'onCommentUpdated',
	        'on:new:comment': 'onNewComment',
	        'on:save:externalids': 'onSavePersonExternalIds',
	        'on:cancel:externalids': 'onCancelPersonExternalIds'
	    },
	
	    userCanEdit: undefined,
	
	    templateContext: function () {
	        var that = this;
	        return {
	            canEdit: function () {
	                return that.canEdit() || that.isItOwn();
	            }
	        }
	    },
	
	
	    initialize: function (options) {
	        this.model = options.model;
	        this.model.view = this;
	        this.model.on('invalid', this.onErrors);
	        this.parentOrganizationsRelations = new ReverseRelationsCollection([], {
	            params: [
	                {key: 'parentId', value: this.id},
	                {key: 'type.parentType', value: 'organization'},
	                {key: 'type.childType', value: 'person'}
	            ]
	        });
	        this.permissions = sessionChannel.request('get:permissions');
	        this.byAdmin = options.byAdmin;
	        this.isSelf = options.isSelf;
	        this.utils = new CommonUtils();
	    },
	
	    onErrors: function (model, errors) {
	        model.view.triggerMethod('server:error', errors.join('. \n'));
	    },
	
	    onRender: function () {
	        window.document.title = this.model.get("name");
	        var that = this;
	        that.initEvents();
	        this.ui.leftTabs.hide();
	        that.renderPerson();
	
	        that.$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
	            var target = that.$(e.target).attr("href");
	            if ((target == '#medical-records' || target == '#medications-content')/* && that.medicalRecords == undefined*/) {
	                that.medicalRecords = new MedicalRecords({
	                    personId: that.model.get('id'),
	                    name: that.model.get('name'),
	                    canEdit: that.canEdit()
	                });
	                that.showChildView('medicalRecords', that.medicalRecords);
	            } else if (target == '#diseases-content') {
	                that.diseasesView = new DiseasesView({
	                    medProfileModel: that.medProfileModel,
	                    name: that.model.get('name'),
	                    canEdit: that.canEdit()
	                });
	                that.showChildView('diseasesRegion', that.diseasesView);
	            } else if (target == '#visits-content') {
	            } else if (target == '#documents-content') {
	                that.documentsView = new PatientDocuments({
	                    medProfileModel: that.medProfileModel,
	                    name: that.model.get('name'),
	                    canEdit: that.canEdit()
	                });
	                that.showChildView('documentsRegion', that.documentsView);
	            } else if (target == '#appendix-kk-content') {
	                that.determinationOfNeedRevisedOriginal = that.utils.deepClone(that.medProfileModel.get('object').determinationOfNeedRevised || []);
	                if ((that.medProfileModel.get('object').determinationOfNeedRevised || []).length < 15) {
	                    that.medProfileModel.get('object').determinationOfNeedRevised = that.utils.getDeterminationOfNeedRevised();
	                }
	                that.appendixKKView = new DeterminationOfNeedRevisedView({
	                    determinationOfNeedRevised: that.medProfileModel.get('object').determinationOfNeedRevised,
	                    isEditMode: that.canEdit()
	                });
	                that.showChildView('appendixKKRegion', that.appendixKKView);
	                that.checkAppendixKKSaveBtn();
	            } else if (target == '#sources-content') {
	                that.sourcesView = new PatientSources({
	                    medProfileModel: that.medProfileModel,
	                    name: that.model.get('name'),
	                    canEdit: that.canEdit()
	                });
	                that.showChildView('sourcesRegion', that.sourcesView);
	            } else if (target == '#immunizations-content' && _.isUndefined(that.immunizationsView)) {
	                that.immunizationsView = new PatientImmunizations({
	                    medProfileModel: that.medProfileModel,
	                    patient: that.model.get('object'),
	                    name: that.model.get('name'),
	                    canEdit: that.canEdit()
	                });
	                that.showChildView('immunizationsRegion', that.immunizationsView);
	            } else if (target == '#dicoms-content') {
	                console.log("dicoms");
	                that.dicomsView = new PatientDicoms({patient: that.model.get('object')});
	                that.showChildView('dicomsRegion', that.dicomsView);
	            } else if (target == '#vitals-content' /*&& _.isUndefined(that.vitalsView)*/) {
	                that.vitalsView = new PatientVitals({
	                    medProfileModel: that.medProfileModel,
	                    patient: that.model.get('object'),
	                    name: that.model.get('name'),
	                    canEdit: that.canEdit()
	                });
	                that.showChildView('vitalsRegion', that.vitalsView);
	            } else if (target == '#person-comments' && typeof that.getChildView('comments') == 'undefined') {
	                that.renderCommentsView();
	            }
	
	            //$('.nav-tabs a[href="' + target + '"]').tab('show');
	        });
	        //this.parentOrganizationsRelations.fetch({success: this.renderParentRelations});
	    },
	
	    initEvents: function () {
	        this.triggerMethod('comment:count:changed');
	    },
	
	    renderPerson: function () {
	        if (this.canEdit()) {
	            this.personForm = new PersonForm({model: this.model, isEditMode: true, byAdmin: this.byAdmin});
	            this.showChildView('personForm', this.personForm);
	        }
	
	        this.showChildView('personData', new PersonDataView({
	            model: this.model,
	            byAdmin: this.byAdmin,
	            isSelf: this.isSelf,
	            canEdit: this.canEdit()
	        }));
	
	        this.renderContacts();
	        this.renderAddresses();
	        this.renderRepresentatives();
	        this.renderOrganizationsView(this.model);
	
	        if (this.canEdit()) {
	            this.permissionsCollection = new PermissionsCollection([], {
	                params: [{
	                    key: 'permittedObjectId',
	                    value: this.model.id
	                }]
	            });
	
	            this.renderPermissionsListView(this.permissionsCollection);
	
	            this.permissionFormView = new PermissionFormView({
	                'permittedObjectId': this.model.id,
	                showOrganization: true,
	                permittedObjectType: 'person'
	            });
	            this.showChildView('addPermission', this.permissionFormView);
	
	            this.renderExternalIdsView(this.model.get('object').externalIds || []);
	        }
	    },
	
	    renderParentRelations: function () {
	        this.showChildView('organizationRelations', new RelationsListView({collection: this.parentOrganizationsRelations}));
	    },
	
	    renderPermissionsListView: function (collection) {
	        this.permissionsListView = new PermissionsTableView({
	            collection: collection,
	            showOrganization: true,
	            permittedObjectType: 'person'
	        });
	        this.showChildView('permissions', this.permissionsListView);
	    },
	
	    renderCommentsView: function () {
	
	        this.commentModel = new Backbone.Model({
	            id: undefined,
	            text: undefined
	        });
	
	        this.showChildView('comments', new CommentsTableView({
	            dboId: this.model.get('id'),
	            canEdit: this.canEdit()
	        }));
	
	        this.renderCommentForm();
	    },
	
	    renderCommentForm: function (model) {
	        this.showChildView('addComment', new CommentFormView({
	            dboId: this.model.get('id'),
	            model: model ? model : new Backbone.Model({
	                id: undefined,
	                text: undefined
	            })
	        }));
	    },
	
	    renderExternalIdsView: function(externalIds) {
	        this.externalIdsView = new ExternalIdsView({
	            externalIds: _.clone(externalIds)
	        });
	        this.showChildView('externalsIdsRegion', this.externalIdsView);
	    },
	
	    renderOrganizationsView: function(model) {
	        this.organizationsView = new PersonOrganizationsView({
	            personModel: model,
	            canEdit: this.canEdit()
	        });
	        this.showChildView('organizationsRegion', this.organizationsView);
	    },
	
	    toggleEdit: function () {
	        if (this.canEdit()) {
	            this.ui.personData.toggle();
	            this.$('#edit-section').toggle();
	        }
	    },
	
	    saveChanges: function () {
	        var that = this;
	        that.model = that.personForm.fillModel();
	        that.model.save(that.model.toJSON(), {
	            success: function (response) {
	                that.toggleEdit();
	                that.renderContacts();
	                that.renderAddresses();
	                that.renderRepresentatives();
	            },
	            error: function (model, xhr, options) {
	                notificationsChannel.request('show:notification', xhr.responseText);
	            }
	        });
	    },
	
	    orgRelationSaved: function (event) {
	        this.parentOrganizationsRelations.add(event);
	        this.showBlankOrgRelationsForm();
	    },
	
	    showBlankOrgRelationsForm: function () {
	        this.orgRelationsFormView = new RelationsFormView({
	            entity: this.model.id,
	            reversed: true,
	            childrenTypes: ['person'],
	            parentTypes: ['organization']
	        });
	        this.listenTo(this.orgRelationsFormView, 'relation:saved', this.orgRelationSaved);
	        this.showChildView('addOrganizationRelation', this.orgRelationsFormView);
	    },
	
	    permissionSaved: function (model) {
	        this.renderPermissionsListView(this.permissionsCollection);
	    },
	
	    canEdit: function () {
	        if (typeof this.userCanEdit == "undefined") {
	            this.userCanEdit = this.utils.userCanDo(this.permissions || [],
	                function (permission) {
	                    return permission.canWriteFor;
	                },
	                this.model.get('permissions') || [],
	                function (permission) {
	                    return permission.canWrite;
	                }
	            );
	        }
	        return this.userCanEdit;
	    },
	
	    savePersonBtnEnableOrDisable: function (data) {
	        if (data.result)
	            this.ui.saveBtn.removeAttr("disabled");
	        else
	            this.ui.saveBtn.attr("disabled", "true");
	    },
	
	    renderContacts: function () {
	        this.contactsView = new ContactsTableView({
	            collection: new ContactsCollection(this.model.get('object').contacts),
	            canEdit: this.canEdit()
	        });
	        this.showChildView("contacts", this.contactsView);
	    },
	
	    renderAddresses: function () {
	        this.addressesView = new AddressTableView({
	            collection: new ContactsCollection(this.model.get('object').addresses),
	            canEdit: this.canEdit()
	        });
	        this.showChildView("addresses", this.addressesView);
	    },
	
	    renderRepresentatives: function () {
	        this.representativesView = new RepresentativesTableView({
	            collection: new ContactsCollection(this.model.get('object').representatives),
	            canEdit: this.canEdit()
	        });
	        this.showChildView("representatives", this.representativesView);
	    },
	
	    renderContactForm: function (mode, contact) {
	        this.ui.contactForm.show();
	        if (mode == 'add') {
	            this.contactFormView = new ContactFormView({
	                mode: mode,
	                addresses: this.model.get('object').addresses || [],
	                representatives: this.model.get('object').representatives || []
	            });
	            this.showChildView("contactForm", this.contactFormView);
	        }
	        else if (mode == 'edit') {
	            this.contactFormView = new ContactFormView({
	                mode: mode,
	                contact: contact,
	                addresses: this.model.get('object').addresses || [],
	                representatives: this.model.get('object').representatives || []
	            });
	            this.showChildView("contactForm", this.contactFormView);
	        }
	    },
	
	    renderAddressForm: function (mode, address) {
	        if (mode == 'add') {
	            this.addressFormView = new AddressesFormView({
	                mode: mode
	            });
	            this.showChildView("addressForm", this.addressFormView);
	        }
	        else if (mode == 'edit') {
	            this.addressFormView = new AddressesFormView({
	                mode: mode,
	                address: address
	            });
	            this.showChildView("addressForm", this.addressFormView);
	        }
	    },
	
	    renderRepresentativeForm: function (mode, representative) {
	        if (mode == 'add') {
	            this.representativeFormView = new RepresentativeFormView({
	                mode: mode
	            });
	            this.showChildView("representativeForm", this.representativeFormView);
	        }
	        else if (mode == 'edit') {
	            this.representativeFormView = new RepresentativeFormView({
	                mode: mode,
	                representative: representative
	            });
	            this.showChildView("representativeForm", this.representativeFormView);
	        }
	    },
	
	    removeContactForm: function () {
	        this.ui.contactForm.hide();
	        this.detachChildView('contactForm');
	    },
	
	    removeAddressForm: function () {
	        this.detachChildView('addressForm');
	    },
	
	    removeRepresentativeForm: function () {
	        this.ui.representativeForm.hide();
	        this.detachChildView('representativeForm');
	    },
	
	    onContactAction: function (data) {
	        var that = this;
	        if (data.mode == 'add') {
	            that.renderContactForm(data.mode);
	        }
	        else if (data.mode == 'delete') {
	            var willBeRemoveContact = data.data.attributes;
	            that.model.get('object').contacts = (that.model.get('object').contacts || []).filter(function (contact) {
	                return contact.data !== willBeRemoveContact.data
	                    || contact.type !== willBeRemoveContact.type
	                    || contact.preferred !== willBeRemoveContact.preferred;
	            });
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderContacts();
	                }
	            });
	        }
	        else if (data.mode == 'edit') {
	            var willBeEditedContact = data.data.attributes;
	            var willEditContact = (that.model.get('object').contacts || []).filter(function (contact) {
	                return contact.data == willBeEditedContact.data
	                    && contact.type == willBeEditedContact.type
	                    && contact.preferred == willBeEditedContact.preferred;
	            });
	            this.renderContactForm(data.mode, willEditContact[0]);
	        }
	        else if (data.mode == 'cancel') {
	            that.removeContactForm();
	        } else if (data.mode == 'save') {
	            var changedContact = data.data.attributes;
	            (that.model.get('object').contacts || []).forEach(function (contact) {
	                if (contact.data == changedContact.data
	                    && contact.type == changedContact.type) {
	                    contact.preferred = changedContact.preferred;
	                }
	            });
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderContacts();
	                }
	            });
	        }
	    },
	
	    onContactSaved: function (data) {
	        var that = this;
	        if (data.mode == 'add') {
	            that.model.get('object').contacts = (that.model.get('object').contacts || []).filter(function (contact) {
	                return contact.data !== data.contact.data
	                    || contact.type !== data.contact.type
	                    || contact.preferred !== data.contact.preferred;
	            });
	            that.model.get('object').contacts.push(data.contact);
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderContacts();
	                    that.removeContactForm();
	                }
	            });
	        } else if (data.mode == 'edit') {
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderContacts();
	                    that.removeContactForm();
	                }
	            });
	        }
	    },
	
	    onAddressAction: function (data) {
	        var that = this;
	        if (data.mode == 'add') {
	            that.renderAddressForm(data.mode);
	        }
	        else if (data.mode == 'delete') {
	            var willBeRemovedAddress = data.data.attributes;
	            that.model.get('object').addresses = (that.model.get('object').addresses || []).filter(function (address) {
	                return address.uuid !== willBeRemovedAddress.uuid;
	            });
	            that.model.get('object').contacts.forEach(function (contact) {
	                contact.addresses = (contact.addresses || []).filter(function (addressUuid) {
	                    return addressUuid != willBeRemovedAddress.uuid;
	                })
	            });
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderAddresses();
	                    that.renderContacts();
	                }
	            });
	        }
	        else if (data.mode == 'edit') {
	            var willBeEditedAddress = data.data.attributes;
	            var willEditAddress = (that.model.get('object').addresses || []).filter(function (address) {
	                return address.uuid == willBeEditedAddress.uuid;
	            });
	            this.renderAddressForm(data.mode, willEditAddress[0]);
	        }
	        else if (data.mode == 'cancel') {
	            that.removeAddressForm();
	        }
	    },
	
	    onAddressSaved: function (data) {
	        var that = this;
	        if (data.mode == 'add') {
	            that.model.get('object').addresses = (that.model.get('object').addresses || []).filter(function (address) {
	                return address !== null && address.uuid !== data.address.uuid;
	            });
	            that.model.get('object').addresses.push(data.address);
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderAddresses();
	                    that.renderContacts();
	                    that.removeAddressForm();
	                }
	            });
	        } else if (data.mode == 'edit') {
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderAddresses();
	                    that.renderContacts();
	                    that.removeAddressForm();
	                }
	            });
	        }
	    },
	
	    onRepresentativeAction: function(data) {
	        var that = this;
	        if (data.mode == 'add') {
	            this.ui.representativeForm.show();
	            that.renderRepresentativeForm(data.mode);
	        }
	        else if (data.mode == 'delete') {
	            var willBeRemovedRepresentative = data.data.attributes;
	            that.model.get('object').representatives = (that.model.get('object').representatives || []).filter(function (representative) {
	                return representative.uuid !== willBeRemovedRepresentative.uuid;
	            });
	            that.model.get('object').contacts.forEach(function (contact) {
	                contact.representatives = (contact.representatives || []).filter(function (representativeUuid) {
	                    return representativeUuid != willBeRemovedRepresentative.uuid;
	                })
	            });
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderRepresentatives();
	                    that.renderContacts();
	                }
	            });
	        }
	        else if (data.mode == 'edit') {
	            var willBeEditedRepresentative = data.data.attributes;
	            var willEditRepresentative = (that.model.get('object').representatives || []).filter(function (representative) {
	                return representative.uuid == willBeEditedRepresentative.uuid;
	            });
	            this.ui.representativeForm.show();
	            this.renderRepresentativeForm(data.mode, willEditRepresentative[0]);
	        }
	        else if (data.mode == 'cancel') {
	            that.removeRepresentativeForm();
	        }
	    },
	
	    onRepresentativeSaved: function(data) {
	        var that = this;
	        if (data.mode == 'add') {
	            that.model.get('object').representatives = (that.model.get('object').representatives || []).filter(function (representative) {
	                return representative !== null && representative.uuid !== data.representative.uuid;
	            });
	            that.model.get('object').representatives.push(data.representative);
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderRepresentatives();
	                    that.renderContacts();
	                    that.removeRepresentativeForm();
	                }
	            });
	        } else if (data.mode == 'edit') {
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderRepresentatives();
	                    that.renderContacts();
	                    that.removeRepresentativeForm();
	                }
	            });
	        }
	    },
	
	    onContactHover: function (data) {
	
	        $('.address-row').each(function () {
	            $(this).children().each(function () {
	                $(this).removeClass('hovered-contact-marked');
	            });
	        });
	
	        $('.representative-row').each(function () {
	            $(this).children().each(function () {
	                $(this).removeClass('hovered-contact-marked');
	            });
	        });
	
	        (data.addresses || []).forEach(function (addressUuid) {
	            $('.' + addressUuid).each(function () {
	                if (data.hovered) {
	                    $(this).addClass('hovered-contact-marked');
	                } else {
	                    $(this).removeClass('hovered-contact-marked');
	                }
	            });
	        });
	
	        (data.representatives || []).forEach(function (representativeUuid) {
	            $('.' + representativeUuid).each(function () {
	                if (data.hovered) {
	                    $(this).addClass('hovered-contact-marked');
	                } else {
	                    $(this).removeClass('hovered-contact-marked');
	                }
	            });
	        });
	    },
	
	    onAddressHover: function (event) {
	
	        $('.contact-row').each(function () {
	            $(this).removeClass('hovered-contact-marked');
	        });
	
	        this.model.get('object').contacts.forEach(function (contact, index) {
	            if ((contact.addresses || []).indexOf(event.uuid) > -1) {
	                if (event.hovered) {
	                    $($('.contact-row')[index]).addClass('hovered-contact-marked');
	                } else {
	                    $($('.contact-row')[index]).removeClass('hovered-contact-marked');
	                }
	            }
	        });
	    },
	
	    onRepresentativeHover: function(event) {
	
	        $('.contact-row').each(function () {
	            $(this).removeClass('hovered-contact-marked');
	        });
	
	        this.model.get('object').contacts.forEach(function (contact, index) {
	            if ((contact.representatives || []).indexOf(event.uuid) > -1) {
	                if (event.hovered) {
	                    $($('.contact-row')[index]).addClass('hovered-contact-marked');
	                } else {
	                    $($('.contact-row')[index]).removeClass('hovered-contact-marked');
	                }
	            }
	        });
	    },
	
	    isItOwn: function () {
	        return this.model.get('id') == this.permissions.userId;
	    },
	
	    reRenderMedProfile: function () {
	        this.getChildView('medicalRecords').render();
	    },
	
	    showLeftSubTabs: function (model) {
	        this.medProfileModel = model;
	        this.ui.leftTabs.show();
	    },
	
	    checkAppendixKKSaveBtn: function () {
	        if (_.isEqual(this.determinationOfNeedRevisedOriginal, this.medProfileModel.get('object').determinationOfNeedRevised || []))
	            this.ui.saveAppendixKKBtn.attr('disabled', true);
	        else
	            this.ui.saveAppendixKKBtn.removeAttr('disabled');
	    },
	
	    onDonRChanged: function () {
	        this.checkAppendixKKSaveBtn();
	    },
	
	    onSaveAppendixKK: function () {
	        var that = this;
	        that.utils.showSpinner();
	        $.ajax({
	            type: "PUT",
	            url: '/api/medprofile/' + that.medProfileModel.get('id') + '/appendix_kk',
	            data: JSON.stringify(that.medProfileModel.get('object').determinationOfNeedRevised),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    that.medProfileModel.get('object').determinationOfNeedRevised = response.object.determinationOfNeedRevised || [];
	                    that.determinationOfNeedRevisedOriginal = that.utils.deepClone(that.medProfileModel.get('object').determinationOfNeedRevised || []);
	                    that.appendixKKView = new DeterminationOfNeedRevisedView({
	                        determinationOfNeedRevised: that.medProfileModel.get('object').determinationOfNeedRevised,
	                        isEditMode: true
	                    });
	                    that.showChildView('appendixKKRegion', that.appendixKKView);
	                    that.checkAppendixKKSaveBtn();
	                }
	            },
	            error: function (e) {
	                notificationsChannel.request('show:notification', e.responseJSON);
	                that.utils.hideSpinner();
	            }
	        });
	    },
	
	    onCommentAdded: function (commentModel) {
	        this.getChildView('comments').add(commentModel);
	        this.renderCommentForm();
	    },
	
	    onCommentUpdated: function (commentModel) {
	        this.getChildView('comments').update(commentModel);
	        this.renderCommentForm();
	    },
	
	    onCommentCountChanged: function () {
	        var that = this;
	
	        $.ajax({
	            type: "GET",
	            url: '/api/comment/' + that.model.get('id') + '/count',
	            statusCode: {
	                200: function (response) {
	                    that.ui.commentsCount.text(response);
	                    if (typeof that.getChildView('comments') != 'undefined') {
	                        that.getChildView('comments').syncWithCount(response);
	                    }
	                }
	            },
	            error: function (e) {
	                console.log(e);
	            }
	        });
	    },
	
	    onCancelCommentSend: function () {
	        this.renderCommentForm();
	    },
	
	    onEditComment: function (model) {
	        this.renderCommentForm(model);
	        $('html, body').animate({scrollTop: $(document).height()}, 'slow');
	    },
	
	    onNewComment: function () {
	        this.renderCommentForm();
	        $('html, body').animate({scrollTop: $(document).height()}, 'slow');
	    },
	
	    onSavePersonExternalIds: function(data) {
	        var that = this;
	        var idsList = data.externalIds;
	        var doSave = data.doSave;
	
	        if (doSave) {
	            that.model.get('object').externalIds = _.reject(idsList, function(id) {
	                return _.isEmpty(id);
	            });
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderExternalIdsView(that.model.get('object').externalIds || []);
	                    $.notify("External ids saved successfully", "success");
	                },
	                error: function (collection, response, options) {
	                    if (response.status == 401) {
	                        actionsChannel.request("redirect:to:login");
	                    } else {
	                        notificationsChannel.request('show:notification', JSON.parse(xhr.responseText));
	                    }
	                }
	            });
	        } else {
	            that.renderExternalIdsView(idsList);
	        }
	    },
	
	    onCancelPersonExternalIds: function() {
	        this.renderExternalIdsView(this.model.get('object').externalIds || []);
	    }
	});
	
	module.exports = PersonView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var YesNoConfirmationModal = __webpack_require__(237);
	var SuccessDialog = __webpack_require__(332);
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var PersonDataView = Marionette.View.extend({
	    template: __webpack_require__(346),
	
	    modelEvents: {
	        'change': 'fieldsChanged'
	    },
	
	    regions: {
	        confirmationModal: '#save-confirmation-modal',
	        dialog: '#message-dialog',
	        logoutAllConfirmationModel: '#logout-all-confirmation-modal'
	    },
	
	    ui: {
	        resetToken: '#reset-token',
	        logoutAll: '#logout-all',
	        generateInstantToken: '#generate-instant-token',
	        removePerson: '#remove-person'
	    },
	
	    events: {
	        'click @ui.resetToken': 'onResetToken',
	        'click @ui.logoutAll': 'onLogoutAll',
	        'click @ui.generateInstantToken': 'onGenerateInstantToken',
	        'click @ui.removePerson': 'removePerson'
	    },
	
	    childViewEvents: {
	        'action:confirmed': 'onConfirmed'
	    },
	
	    callback: undefined,
	
	    templateContext: function () {
	        var that = this;
	        var object = that.model.get('object');
	        var positions = [
	            (object.isAdmin ? "Admin" : ""),
	            (object.isManager ? "Manager" : ""),
	            (object.isMedicalDirector ? "Medical Director" : ""),
	            (object.isOfficeAdministrator ? "Office Administrator" : ""),
	            (object.isPatient ? "Patient" : ""),
	            (object.isMd ? 'Provider' : '')
	        ];
	        return {
	            byAdmin: that.byAdmin,
	            isSelf: that.isSelf,
	            position: positions.filter(function (item) {
	                return item != '';
	            }).join(", "),
	            canEdit: that.canEdit,
	            formattedDateTime: function (long) {
	                return that.utils.longToDateTimeFormatted(long, 'MMM DD YYYY hh:mm A');
	            },
	            tels: that.utils.extractContactValuesByTypeAsString(object.contacts || [], 'PHONE'),
	            faxes: that.utils.extractContactValuesByTypeAsString(object.contacts || [], 'FAX'),
	            emails: that.utils.extractContactValuesByTypeAsString(object.contacts || [], 'EMAIL'),
	            signedDocumentsLink: '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	            + '&PERSON_REVIEW_REQUEST=' + that.model.get('id') + '&PERSON_REVIEW_FINISHED_REQUEST=' + that.model.get('id')
	            + '&object_status=SIGNED&object_status=VIEWED',
	            pendingDocumentsLink: '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	            + '&PERSON_REVIEW_REQUEST=' + that.model.get('id') + '&NOT_PERSON_REVIEW_FINISHED_REQUEST=' + that.model.get('id')
	            + '&object_status=IN_REVIEW',
	            allDocumentsLink: '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	            + '&PERSON_REVIEW_REQUEST=' + that.model.get('id'),
	            birthDate: (object.birthData == '' || object.birthData == null || object.birthData == 0 ? ''
	                : that.utils.longToDateTimeFormattedInUtc(Number(object.birthData), 'MM/DD/YYYY'))
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'fieldsChanged', 'onResetToken', 'onRender', 'onConfirmed', 'onLogoutAll', 'resetToken', 'logoutAll', 'removePerson');
	        this.model = options.model;
	        this.byAdmin = options.byAdmin;
	        this.isSelf = options.isSelf;
	        this.utils = new CommonUtils();
	        this.canEdit = options.canEdit;
	    },
	
	    onRender: function () {
	        this.confirmationModal =
	            new YesNoConfirmationModal({message: 'You are going to reset token for this user. Are you sure?'});
	        this.showChildView('confirmationModal', this.confirmationModal);
	        this.logoutConfirmationModal =
	            new YesNoConfirmationModal({message: 'You are going to logout on all computers and this will reset token. Are you sure?'});
	        this.showChildView('logoutAllConfirmationModel', this.logoutConfirmationModal);
	        this.showChildView('dialog', new SuccessDialog({title: '', message: 'The token reset successfully'}));
	    },
	
	    fieldsChanged: function () {
	        this.render();
	    },
	
	    onResetToken: function () {
	        this.confirmationModal.show();
	        this.callback = this.resetToken;
	    },
	
	    onConfirmed: function (data) {
	        if (data.result == true) {
	            this.callback();
	        }
	        else {
	            this.confirmationModal.hide();
	            this.logoutConfirmationModal.hide();
	        }
	    },
	
	    resetToken: function () {
	        var that = this;
	        that.utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/person/reset/token/' + that.model.get('id'),
	            dataType: 'text',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    that.getChildView('dialog').show();
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner();
	                notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	            }
	        });
	    },
	
	    onLogoutAll: function () {
	        this.logoutConfirmationModal.show();
	        this.callback = this.logoutAll;
	    },
	
	    logoutAll: function () {
	        var that = this;
	        that.utils.showSpinner();
	        $.ajax({
	            type: "DELETE",
	            url: '/api/login/session?from_all=true',
	            statusCode: {
	                200: function () {
	                    that.utils.hideSpinner();
	                    Backbone.history.navigate('/', {trigger: true});
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner();
	            }
	        });
	    },
	    onGenerateInstantToken: function () {
	        var that = this;
	        that.utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/utility/instant/token/' + that.model.get('id'),
	            dataTyp: 'text',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    notificationsChannel.request('show:notification', {
	                        message: "Token generated and sent.",
	                        code: 200
	                    });
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner();
	                notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	            }
	        });
	    },
	
	    removePerson: function () {
	        var that = this;
	        this.model.destroy({
	            dataType: "text",
	            success: function () {
	                that.remove();
	                that.unbind();
	                Backbone.history.navigate('/patients', {
	                    trigger: true
	                });
	            }
	        });
	    },
	
	});
	
	module.exports = PersonDataView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row">\n    <div class="col-md-8 col-xs-8">\n        <h3>'+
	((__t=( name ))==null?'':_.escape(__t))+
	' ';
	 if (canEdit) { 
	__p+='<span class="glyphicon glyphicon-pencil text-muted clickable edit-header"\n                                                  aria-hidden="true" id="edit-data"></span>';
	 } 
	__p+='</h3>\n    </div>\n    ';
	 if (isSelf || byAdmin) { 
	__p+='\n    <div class="dropdown col-md-2 col-xs-2">\n        <button id="actions" class="btn button-right" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n            Actions\n            <span class="caret"></span>\n        </button>\n        <ul class="dropdown-menu" aria-labelledby="actions">\n            <li>\n                <a href="/#changepassword/'+
	((__t=( id ))==null?'':__t)+
	'" id="change-password">Change password</a>\n            </li>\n            ';
	 if (byAdmin) { 
	__p+='\n            <li>\n                <a id="reset-token" class="clickable">Reset token</a>\n            </li>\n            <li>\n                <a id="generate-instant-token" class="clickable">Generate instant token</a>\n            </li>\n            ';
	 } 
	__p+='\n            ';
	 if (isSelf) { 
	__p+='\n            <li>\n                <a id="logout-all" class="clickable">Log out on all computers</a>\n            </li>\n            ';
	 } 
	__p+='\n            <li>\n                <a href="/api/person/export/'+
	((__t=( id ))==null?'':__t)+
	'?exportType=ccr" target="_blank" id="export-ccr">Export CCR</a>\n            </li>\n            <li>\n                <a href="/api/person/export/'+
	((__t=( id ))==null?'':__t)+
	'?exportType=ccda" target="_blank" id="export-ccda" >Export CCDA</a>\n            </li>\n        </ul>\n    </div>\n    ';
	 } 
	__p+='\n    ';
	 if (byAdmin) { 
	__p+='\n    <div class="col-md-2 col-xs-2">\n        <button type="button" class="btn btn-danger button-right"  id="remove-person">Remove profile</button>\n    </div>\n    ';
	 } 
	__p+='\n</div>\n\n<div>\n    ';
	 if (object.isMd) { 
	__p+='\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Documents</dt>\n        <dd>\n            <div class="row">\n                <div class="col-md-1-5 col-xs-2">\n                    <span style="color: green;" class="glyphicon glyphicon-check"/> <a href="'+
	((__t=( signedDocumentsLink ))==null?'':__t)+
	'" target="_blank">Reviewed</a>\n                </div>\n                <div class="col-md-1-5 col-xs-2">\n                    <span style="color: orange;" class="glyphicon glyphicon-hourglass"/> <a href="'+
	((__t=( pendingDocumentsLink ))==null?'':__t)+
	'" target="_blank">Pending</a>\n                </div>\n                <div class="col-md-1-5 col-xs-2">\n                    <span class="glyphicon glyphicon-file"/> <a href="'+
	((__t=( allDocumentsLink ))==null?'':__t)+
	'" target="_blank">All</a>\n                </div>\n            </div>\n        </dd>\n    </dl>\n    ';
	 } 
	__p+='\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Name</dt>\n        <dd>'+
	((__t=( object.firstName ))==null?'':_.escape(__t))+
	' '+
	((__t=( object.lastName ))==null?'':_.escape(__t))+
	'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Birth date</dt>\n        <dd>'+
	((__t=( birthDate ))==null?'':_.escape(__t))+
	'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Created time</dt>\n        <dd>'+
	((__t=( formattedDateTime(createdTime) ))==null?'':__t)+
	'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>NPI</dt>\n        <dd>'+
	((__t=( object.npi ))==null?'':_.escape(__t))+
	'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Position</dt>\n        <dd>'+
	((__t=( position ))==null?'':_.escape(__t))+
	'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>SSN</dt>\n        <dd>'+
	((__t=( object.ssn ))==null?'':_.escape(__t))+
	'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Phone</dt>\n        <dd>'+
	((__t=( tels ))==null?'':_.escape(__t))+
	'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Fax</dt>\n        <dd>'+
	((__t=( faxes ))==null?'':_.escape(__t))+
	'</dd>\n    </dl>\n\n    <dl class="dl-horizontal-left dl-horizontal">\n        <dt>Email</dt>\n        <dd>'+
	((__t=( emails ))==null?'':_.escape(__t))+
	'</dd>\n    </dl>\n</div>\n\n<div id="save-confirmation-modal"></div>\n<div id="logout-all-confirmation-modal"></div>\n<div id="message-dialog"></div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var MedProfileModel = __webpack_require__(213);
	var MedicationForm = __webpack_require__(348);
	var CommonUtils = __webpack_require__(189);
	var DeleteConfirmationModal = __webpack_require__(241);
	
	var DocumentsCollection = __webpack_require__(302);
	
	var Radio = __webpack_require__(183);
	var services = Radio.channel('services');
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	var utils = new CommonUtils();
	
	var MedicationsRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(354),
	
	    ui: {
	        edit: '.edit',
	        remove: '.remove',
	        addEvent: '.add-event',
	        showDiseases: '.diseases-show',
	        showDocuments: '.documents-show'
	    },
	
	    events: {
	        'click @ui.edit': 'onEdit',
	        'click @ui.remove': 'onRemove',
	        'click @ui.addEvent': 'onAddNewEvent',
	        'click @ui.showDiseases': 'onDiseasesShow',
	        'click @ui.showDocuments': 'onDocumentsShow'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var startDate = that.model.get('startDate');
	        var stopDate = that.model.get('stopDate');
	        var getFormName = that.getOption('getFormName');
	        return {
	            startDate: startDate != undefined && startDate != '' && !isNaN(startDate) ? utils.longToDateTimeFormatted(startDate, 'MM/DD/YYYY') : '',
	            stopDate: stopDate != undefined && stopDate != '' && !isNaN(stopDate) ? utils.longToDateTimeFormatted(stopDate, 'MM/DD/YYYY') : '',
	            groupSize: that.rowPositionInGroup != 0 ? 0 : that.rowGroupSize,
	            isHidden: that.rowPositionInGroup != 0 ? true : false,
	            formName: (that.model.get('formObj') || {}).title || "",
	            dose: (that.model.get('doseObj') || {}).title || "",
	            isTerminal: that.rowGroupSize - that.rowPositionInGroup == 1,
	            eventTypeName: utils.getMedicationEventType(that.model.get('eventType')),
	            canEdit: this.getOption('canEdit')
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	        window.setTimeout(function () {
	            var id = that.model.get('medicationId');
	            var whereFrom = (that.model.get('systemType') || '').toLowerCase();
	            var servicesAddresses = options.servicesAddresses;
	
	            var refreshRowCallback = function (name) {
	                that.model.set('name', name);
	                that.render();
	            };
	
	            /*if (whereFrom == 'snomed' && typeof servicesAddresses["snomedMedicationServiceAddress"] != "undefined") {
	             that.refreshMedicationFromSnomed(id, servicesAddresses["snomedMedicationServiceAddress"], refreshRowCallback);
	             } else*/
	            if (whereFrom == 'custom' && typeof servicesAddresses["customMedicationServiceAddress"] != "undefined") {
	                that.refreshMedicationFromCustom(id, servicesAddresses["customMedicationServiceAddress"], refreshRowCallback);
	            } else if (whereFrom == 'rxnorm' && typeof servicesAddresses["rxnormMedicationServiceAddress"] != "undefined") {
	                that.refreshMedicationFromRxNorm(id, servicesAddresses["rxnormMedicationServiceAddress"], refreshRowCallback);
	            }
	        }, 500);
	
	        var modelGroupStats = this.getOption('modelGroupStats');
	
	        var groupUuid = '';
	        for (var indx in modelGroupStats) {
	            if (modelGroupStats[indx].medicationUuid == that.model.get('medicationUuid')) {
	                groupUuid = modelGroupStats[indx].groupUuid;
	                break;
	            }
	        }
	
	        that.rowPositionInGroup = 0;
	        var currentGroupRows = modelGroupStats.filter(function (elem) {
	            return elem.groupUuid == groupUuid;
	        });
	        for (var indx in currentGroupRows) {
	            if (currentGroupRows[indx].medicationUuid == that.model.get('medicationUuid')) {
	                that.rowPositionInGroup = indx;
	                break;
	            }
	        }
	
	        that.rowGroupSize = currentGroupRows.length;
	
	        if (that.rowGroupSize - that.rowPositionInGroup == 1){
	            this.$el.toggleClass('border-bottom', true);
	        }
	    },
	
	    onRender: function () {
	        var that = this;
	        window.setTimeout(function() {
	            that.ui.edit.parent().parent().hover(function() {
	                var el = $(this);
	                el.addClass("hover");
	                if (el.has('td[rowspan]').length == 0)
	                    el.prevAll('tr:has(td[rowspan]):first').find('td[rowspan]').addClass("hover");
	            }, function() {
	                var el = $(this);
	                el.removeClass("hover");
	                el.prevAll('tr:has(td[rowspan]):first').find('td[rowspan]').removeClass("hover");
	            });
	        }, 1000);
	    },
	
	    refreshMedicationFromSnomed: function (id, serviceAddress, callback) {
	        $.when(
	            $.ajax({
	                type: "GET",
	                url: serviceAddress + '/concepts/' + id
	            })
	        ).done(function (resp) {
	            callback(resp.defaultTerm);
	        }).fail(function (jqXHR, textStatus) {
	        });
	    },
	
	    refreshMedicationFromCustom: function (id, serviceAddress, callback) {
	        $.when(
	            $.ajax({
	                type: "GET",
	                url: serviceAddress + '/api/medications/' + id
	            })
	        ).done(function (resp) {
	            callback(resp.name);
	        }).fail(function (jqXHR, textStatus) {
	        });
	    },
	
	    refreshMedicationFromRxNorm: function (id, serviceAddress, callback) {
	        if (!id) return;
	        $.when(
	            $.ajax({
	                type: "GET",
	                headers: {
	                    Accept: 'application/json'
	                },
	                url: serviceAddress + '/REST/rxcui/' + id
	            })
	        ).done(function (resp) {
	            if (resp.idGroup.name) {
	                callback(resp.idGroup.name);
	            }
	        }).fail(function (jqXHR, textStatus) {
	        });
	    },
	
	    onEdit: function () {
	        this.triggerMethod('edit:medication', {model: this.model});
	    },
	
	    onRemove: function () {
	        this.triggerMethod('remove:medication', {model: this.model});
	    },
	
	    onAddNewEvent: function() {
	        this.triggerMethod('new:event', {model: this.model});
	    },
	
	    onDiseasesShow: function() {
	        this.triggerMethod('show:diseases', this.model.get('diseasesUuids'));
	    },
	
	    onDocumentsShow: function() {
	        this.triggerMethod('show:documents', this.model.get('documentsIds'));
	    }
	});
	
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(10), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var MedicationsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: MedicationsRowView,
	    emptyView: EmptyView,
	
	    collectionEvents: {},
	
	    childViewEvents: {
	        'remove:medication': 'removeMedication',
	        'edit:medication': 'editMedication',
	        'new:event': 'newEvent',
	        'show:diseases': 'onDiseasesShow',
	        'show:documents': 'onDocumentsShow'
	    },
	
	    initialize: function (options) {
	        this.collection = options.collection;
	        this.servicesAddresses = options.servicesAddresses;
	        this.getFormName = options.getFormName;
	    },
	
	    childViewOptions: function () {
	        return {
	            canEdit: this.getOption('canEdit'),
	            servicesAddresses: this.servicesAddresses,
	            getFormName: this.getFormName,
	            modelGroupStats: this.collection.map(function (model) {
	                return {
	                    medicationUuid: model.get('medicationUuid'),
	                    groupUuid: model.get('groupUuid')
	                }
	            })
	        };
	    },
	
	    removeMedication: function (data) {
	        this.triggerMethod('remove:medication', data);
	    },
	
	    editMedication: function (data) {
	        this.triggerMethod('edit:medication', data);
	    },
	
	    newEvent: function(data) {
	        this.triggerMethod('new:event', data);
	    },
	
	    onDiseasesShow: function(data) {
	        this.triggerMethod('show:diseases', data);
	    },
	
	    onDocumentsShow: function(data) {
	        this.triggerMethod('show:documents', data);
	    }
	});
	
	var MedicalRecords = Marionette.View.extend({
	    template: __webpack_require__(355),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        medicationForm: '#medication-form',
	        deleteConfirmationModal: '#delete-confirmation-modal'
	    },
	
	    ui: {
	        errorText: '#error',
	        content: '#content',
	        buttonsContainer: '#buttons',
	        createBtn: '#create-med-record',
	        addMedication: '#add',
	        medicationsTable: '#medications-table',
	        diseasesShowModal: '#diseases-show-modal',
	        diseasesTable: '#diseases-table',
	        documentsShowModal: '#documents-show-modal',
	        documentsTable: '#documents-table'
	    },
	
	    events: {
	        'click @ui.createBtn': 'createMedRecord',
	        'click @ui.addMedication': 'addNewMedication'
	    },
	
	    childViewEvents: {
	        'new:medication': 'saveNewMedication',
	        'update:medication': 'updateMedication',
	        'remove:medication': 'removeMedication',
	        'delete:confirmed': 'deleteConfirmed',
	        'edit:medication': 'editMedication',
	        'new:event': 'newEvent',
	        'show:diseases': 'onDiseasesShow',
	        'show:documents': 'onDocumentsShow'
	    },
	
	    callback: undefined,
	    deletedMedicationModel: undefined,
	
	    templateContext: function () {
	        var that = this;
	        return {
	            canEdit: that.canEdit,
	            name: that.name
	        }
	    },
	
	
	    initialize: function (options) {
	        var that = this;
	        _.bindAll(this, 'createMedRecord', 'disableElements', 'renderTable', 'addNewMedication', 'saveNewMedication',
	            'deleteConfirmed', 'removeMedication', 'deepCloneObjectMedications', 'editMedication', 'updateMedication',
	            'modelSave', 'newEvent', 'onDiseasesShow', 'getFormName', 'onDocumentsShow');
	        if (options) {
	            this.personId = options.personId;
	            this.name = options.name;
	            this.canEdit = options.canEdit;
	        }
	        this.servicesAddresses = services.request('get:services:address');
	        this.defaultMedicationForms = services.request('get:default:medication:forms');
	
	        this.documentsCollection = new DocumentsCollection([], {params: [
	            {key: 'sortby', value: 'createdTime'},
	            {key: 'sortdir', value: 'DESC'},
	            {key: 'DOCUMENT_PATIENT', value: this.personId}
	        ]});
	        this.documentsCollection.fetch({
	            success: function() {
	                that.documents = that.documentsCollection.toJSON().map(function(document) {
	                    return {
	                        id: document.id,
	                        name: document.name
	                    }
	                });
	            },
	            error: function(collection, response, options) {
	                if (response.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                }
	            }
	        });
	    },
	
	    onRender: function () {
	        var that = this;
	        that.disableElements();
	
	        $.ajax({
	            type: "GET",
	            url: '/api/medprofile/person/' + that.personId,
	            statusCode: {
	                200: function (response) {
	                    that.model = new MedProfileModel(response);
	                    that.triggerMethod('show:subtabs', that.model);
	                    that.renderTable(response);
	                    that.ui.content.show();
	                },
	                401: function() {
	                    actionsChannel.request("redirect:to:login");
	                },
	                403: function (response) {
	                    that.ui.errorText.show();
	                },
	                404: function (response) {
	                    that.ui.buttonsContainer.show();
	                }
	            }
	        });
	    },
	
	    disableElements: function () {
	        this.ui.errorText.hide();
	        this.ui.content.hide();
	        this.ui.buttonsContainer.hide();
	    },
	
	    createMedRecord: function () {
	        var that = this;
	        var medProfileModel = new MedProfileModel();
	        medProfileModel.get('object').personId = that.personId;
	        medProfileModel.save(medProfileModel.toJSON(), {
	            success: function () {
	                that.triggerMethod('med:record:created');
	            },
	            error: function (model, xhr, options) {
	                notificationsChannel.request('show:notification', xhr.responseText);
	            }
	        });
	    },
	
	    renderTable: function (response) {
	        var that = this;
	        response.object.medications.forEach(function (medication) {
	            medication.id = utils.randomString(18);
	        });
	        that.medicationsCollection = new Backbone.Collection(response.object.medications);
	        that.medicationsCollection.comparator = function (model) {
	            return model.get('groupUuid');
	        }
	        that.medicationsCollection.sort();
	        that.showChildView('body', new MedicationsTableBody({
	            collection: that.medicationsCollection,
	            servicesAddresses: that.servicesAddresses,
	            getFormName: that.getFormName,
	            canEdit: that.canEdit
	        }));
	    },
	
	    addNewMedication: function () {
	        var that = this;
	        that.showChildView('medicationForm', new MedicationForm({
	            mode: 'add',
	            medication: {},
	            diseases: that.model.get('object').diseases.map(that.formatDisease),
	            servicesAddresses: that.servicesAddresses,
	            isNewGroup: true,
	            defaultMedicationForms: that.defaultMedicationForms,
	            documents: that.documents
	        }));
	    },
	
	    editMedication: function (data) {
	        var that = this;
	        that.showChildView('medicationForm', new MedicationForm({
	            mode: 'edit',
	            medication: data.model.toJSON(),
	            diseases: that.model.get('object').diseases.map(that.formatDisease),
	            servicesAddresses: that.servicesAddresses,
	            defaultMedicationForms: that.defaultMedicationForms,
	            documents: that.documents
	        }));
	    },
	
	    saveNewMedication: function (medication) {
	        var that = this;
	        that.model.get('object').medications = that.model.get('object').medications.map(function (medication) {
	            medication = _.omit(medication, 'id');
	            return medication;
	        });
	        that.model.get('object').medications.push(medication);
	        that.modelSave();
	    },
	
	    updateMedication: function (updatedMedication) {
	        var that = this;
	        that.model.get('object').medications.forEach(function (medication) {
	            if (medication.id == updatedMedication.id) {
	                medication.name = updatedMedication.name;
	                medication.form = updatedMedication.form;
	                medication.eventType = updatedMedication.eventType;
	                medication.doseObj = updatedMedication.doseObj;
	                medication.quantity = updatedMedication.quantity;
	                medication.frequency = updatedMedication.frequency;
	                medication.regularFrequency = updatedMedication.regularFrequency;
	                medication.startDate = updatedMedication.startDate;
	                medication.stopDate = updatedMedication.stopDate;
	                medication.comment = updatedMedication.comment;
	                medication.diseasesUuids = (updatedMedication.diseasesUuids || []).filter(function(diseaseUuid) {
	                        return diseaseUuid != "";
	                    });
	                medication.documentsIds = (updatedMedication.documentsIds || []).filter(function(id) {
	                    return id != "";
	                });
	            }
	        });
	        that.model.get('object').medications = that.model.get('object').medications.map(function (medication) {
	            medication = _.omit(medication, 'id');
	            return medication;
	        });
	        that.modelSave();
	    },
	
	    deleteConfirmed: function (value) {
	        if (value == true) {
	            var that = this;
	            that.model.get('object').medications = that.model.get('object').medications.filter(function (medication) {
	                return medication.id != that.deletedMedicationModel.get('id');
	            }).map(function (medication) {
	                medication = _.omit(medication, 'id');
	                return medication;
	            });
	            that.modelSave();
	        }
	    },
	
	    modelSave: function () {
	        var that = this;
	        that.model.save(that.model.toJSON(), {
	            success: function (model) {
	                model.get('object').medications.forEach(function (medication) {
	                    medication.id = utils.randomString(18);
	                });
	                that.renderTable(model.toJSON());
	            },
	            error: function (model, xhr, options) {
	                notificationsChannel.request('show:notification', xhr.responseText);
	            }
	        });
	    },
	
	    removeMedication: function (data) {
	        this.deletedMedicationModel = data.model;
	        this.deleteConfirmationModal =
	            new DeleteConfirmationModal({
	                message: 'Enter: "confirm" if you agree to remove the medication.',
	                confirmationAnswer: 'confirm'
	            });
	        this.showChildView('deleteConfirmationModal', this.deleteConfirmationModal);
	        this.deleteConfirmationModal.show();
	    },
	
	    deepCloneObjectMedications: function (object) {
	        var clonedObject = _.clone(object);
	        clonedObject.object = _.clone(object.object);
	        clonedObject.object.medications = _.clone(object.object.medication);
	        return clonedObject;
	    },
	
	    newEvent: function(data) {
	        var that = this;
	        var staticData = data.model.toJSON();
	        that.showChildView('medicationForm', new MedicationForm({
	            mode: 'add',
	            medication: {
	                name: staticData.name,
	                medicationId: staticData.medicationId,
	                form: staticData.form,
	                groupUuid: staticData.groupUuid,
	                systemType: staticData.systemType,
	                diseasesUuids: staticData.diseasesUuids
	            },
	            diseases: that.model.get('object').diseases.map(that.formatDisease),
	            servicesAddresses: that.servicesAddresses,
	            defaultMedicationForms: that.defaultMedicationForms,
	            documents: that.documents
	        }));
	    },
	
	    formatDisease: function(disease) {
	        return {
	            uuid: disease.uuid,
	            name: disease.name
	                + (disease.startDate != undefined && disease.startDate != '' && !isNaN(disease.startDate) 
	                    ? ', ' + utils.longToDateTimeFormatted(disease.startDate, 'MM/DD/YYYY') : ', ')
	                + (disease.stopDate != undefined && disease.stopDate != '' && !isNaN(disease.stopDate)
	                    ? ', ' + utils.longToDateTimeFormatted(disease.stopDate, 'MM/DD/YYYY') : '')
	        }
	    },
	
	    onDiseasesShow: function(data) {
	        var that = this;
	        var diseases = that.model.get('object').diseases.filter(function(disease) {
	            return _.contains(data, disease.uuid);
	        }).map(function(disease) {
	            return {
	                uuid: disease.uuid,
	                name: disease.name,
	                startDate: (disease.startDate != undefined && disease.startDate != '' && !isNaN(disease.startDate)
	                    ? utils.longToDateTimeFormatted(disease.startDate, 'MM/DD/YYYY') : '-'),
	                stopDate: (disease.stopDate != undefined && disease.stopDate != '' && !isNaN(disease.stopDate)
	                    ? utils.longToDateTimeFormatted(disease.stopDate, 'MM/DD/YYYY') : '-')
	            }
	        });
	
	        $('#diseases-table tr:not(:first)').remove();
	        diseases.forEach(function (disease) {
	            var newRowContent = "<tr id='" + disease.uuid + "'><td>"
	                + disease.name + "</td><td>" + disease.startDate + "</td><td>" + disease.stopDate + "</td></tr>";
	            $('#diseases-table tbody').append(newRowContent);
	        });
	        this.ui.diseasesShowModal.modal('show');
	    },
	
	    getFormName: function(form) {
	        var formObject = _.findWhere(this.defaultMedicationForms, {id: form});
	        if (formObject == undefined)
	            return null;
	        else
	            return formObject.name;
	    },
	
	    onDocumentsShow: function(data) {
	        var that = this;
	        var documents = that.documents.filter(function(document) {
	            return _.contains(data, document.id);
	        });
	
	        $('#documents-table tr:not(:first)').remove();
	
	        documents.forEach(function (document) {
	            var viewContent = '<a href="/api/document/view/' + document.id + '" target="_blank"><span class="clickable glyphicon glyphicon-eye-open"/></a>';
	            var newRowContent = '<tr id="' + document.id
	                + '"><td><a href="/#document/' + document.id + '" target="_blank"><b>' + document.name + '</b></a></td><td>'
	                + viewContent + '</td></tr>';
	
	            $('#documents-table tbody').append(newRowContent);
	        });
	
	        this.ui.documentsShowModal.modal('show');
	    }
	
	});
	
	module.exports = MedicalRecords;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	var RemoteSuggesterView = __webpack_require__(196);
	var SnomedTreeView = __webpack_require__(349);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var utils = new CommonUtils();
	
	var MedicationForm = Marionette.View.extend({
	        template: __webpack_require__(353),
	
	        regions: {
	            searchTextContainer: '#search-text-container',
	            snomedTree: '#snomed-tree'
	        },
	
	        ui: {
	            formModal: '#medication-form-modal',
	            save: '#save',
	            name: '#name',
	            diseases: '#diseases',
	            eventType: '#event',
	            form: '#form',
	            formcode: '#formcode',
	            dose: '#dose',
	            dosecode: '#dosecode',
	            quantity: '#quantity',
	            frequency: '#frequency',
	            continuousFrequencyContainer: '#continuous-frequency-container',
	            startDate: '#start-date',
	            stopDate: '#stop-date',
	            documents: '#documents',
	            comment: '#comment',
	
	            searchButton: '#search-button',
	            searchResultsTable: '#search-results',
	
	            continuousFrequencyFelected: "#continuous-frequency-selected",
	            continuousFrequencyFelectedValue: "#continuous-frequency-selected-value",
	            snomedTree: '#snomed-tree',
	
	            leftSide: '.inputs'
	        },
	
	        events: {
	            'click @ui.save': 'saveMedication',
	            'keypress @ui.quantity': 'allowOnlyInts',
	            'change @ui.frequency': 'onFrequencyChanged',
	            'keyup input[required]': 'validate',
	            'change input[required]': 'validate',
	            'click @ui.searchButton': 'search',
	            'click #continuous-frequency-remove': 'removeContinuousFrequency'
	        },
	
	        templateContext: function () {
	            var that = this;
	            return {
	                title: that.mode == 'add' ? 'Add medication' : 'Edit medication',
	                forms: that.defaultMedicationForms,
	                eventType: that.medication.eventType,
	                mode: that.mode,
	                name: that.medication.name,
	                form: (that.medication.formObj || {}).title || "",
	                dose: (that.medication.doseObj  || {}).title  || "",
	                quantity: that.medication.quantity,
	                frequency: that.medication.frequency,
	                continuousFrequency: that.medication.regularFrequency,
	                startDate: (that.medication.startDate == '' || that.medication.startDate == null || that.medication.startDate == 0
	                    ? '' : utils.longToDateTimeFormatted(Number(that.medication.startDate), 'MM/DD/YYYY')),
	                stopDate: (that.medication.stopDate == '' || that.medication.stopDate == null || that.medication.stopDate == 0
	                    ? '' : utils.longToDateTimeFormatted(Number(that.medication.stopDate), 'MM/DD/YYYY')),
	                comment: that.medication.comment,
	                eventTypes: that.getMedicationEventTypes().map(function(et) {
	                    return {
	                        id: et,
	                        name: utils.getMedicationEventType(et)
	                    }
	                }),
	                isNewGroup: that.isNewGroup,
	                getBaseInitialMedicationEventType: that.getBaseInitialMedicationEventType
	            };
	        },
	
	        initialize: function (options) {
	            _.bindAll(this, 'onRender', 'showModal', 'hideModal', 'saveMedication', 'allowOnlyInts', 'allowOnlyFloats',
	                'fillMedication', 'validate', 'search', 'tranformSnomedResponse', 'tranformCustomResponse', 'renderResultInTable',
	                'fillFormFromSelectedResult', 'showLoading', 'hideLoading', 'getMedicationEventTypes',
	                'showDefaultOptionsOfMedicationFormsSelect', 'showRxNormOptionsOfMedicationFormsSelect',
	                'clearAndAddMedicationFormsOptions', 'removeMedicationFormsOptions', 'resetDoseSelect', 'fillDoseSelectFromRxNorm',
	                'onFrequencyChanged', 'onChildviewNodeSelected', 'removeContinuousFrequency');
	            if (options) {
	                this.mode = options.mode;
	                this.medication = options.medication;
	                this.servicesAddresses = options.servicesAddresses;
	                this.isNewGroup = options.isNewGroup;
	                this.diseases = options.diseases || [];
	                this.defaultMedicationForms = options.defaultMedicationForms;
	                this.documents = options.documents;
	            }
	            this.utils = new CommonUtils();
	            this.results = [];
	            this.searchTextInputId = 'search-text';
	        },
	
	        listDelimeter: '~',
	
	        onRender: function () {
	            var that = this;
	
	            that.showChildView('snomedTree', new SnomedTreeView({
	                parent: '307430002',
	                showHead: false
	            }));
	
	            that.documentsSelect = that.ui.documents.selectize({
	                plugins: ['remove_button'],
	                inputClass: 'selectize-input normal-width selectized',
	                valueField: 'id',
	                labelField: 'name',
	                sortField: 'name',
	                placeholder: "Select documents",
	                options: that.documents,
	                items: that.medication.documentsIds,
	                delimiter: that.listDelimeter,
	                highlight: true,
	                openOnFocus: true,
	                render: {
	                    item: function(data, escape) {
	                        return '<div class="item"><a href="/#document/' + escape(data.id) + '" target="_blank">'
	                            + escape(data.name) + '</a></div>';
	                    }
	                }
	            });
	
	            that.formsSelect = that.ui.form.selectize({
	                allowEmptyOption: false
	            });
	
	            that.doseSelect = that.ui.dose.selectize({
	                create: true
	            });
	
	            that.frequencySelect = that.ui.frequency.selectize({
	                allowEmptyOption: true
	            });
	
	            try {
	                that.ui.eventType.selectize({
	                    allowEmptyOption: false
	                })[0].selectize.on('change', function (id) {
	                    that.validate();
	                });
	            } catch (e) {
	            }
	
	
	            var diseasesSelect = that.ui.diseases.selectize({
	                plugins: ['remove_button'],
	                inputClass: 'selectize-input normal-width selectized',
	                valueField: 'uuid',
	                labelField: 'name',
	                placeholder: "Select diseases",
	                options: that.diseases,
	                items: that.medication.diseasesUuids,
	                delimiter: that.listDelimeter,
	                highlight: true,
	                openOnFocus: true
	            });
	
	            this.showModal();
	            this.ui.save.attr('disabled', true);
	            this.ui.searchResultsTable.hide();
	
	            this.ui.startDate.datepicker({
	                format: 'mm/dd/yyyy',
	                clearBtn: true
	            }).on('changeDate', function (e) {
	                $(this).datepicker('hide');
	            });
	            this.ui.stopDate.datepicker({
	                format: 'mm/dd/yyyy',
	                clearBtn: true
	            }).on('changeDate', function (e) {
	                $(this).datepicker('hide');
	            });
	
	            if (this.mode == 'edit') {
	                this.ui.leftSide.removeClass('col-md-6');
	                this.ui.leftSide.addClass('col-md-11');
	            }
	
	            if (this.medication.medicationId != undefined && this.medication.medicationId != '') {
	                if (this.medication.systemType == 'RxNorm') {
	                    this.showRxNormOptionsOfMedicationFormsSelect(this.medication.medicationId, this.removeMedicationFormsOptions);
	                    this.fillDoseSelectFromRxNorm(this.medication.medicationId);
	                } else {
	                    this.resetDoseSelect();
	                }
	            }
	
	            this.validate();
	
	            if (this.mode == 'add') {
	                this.showChildView('searchTextContainer', new RemoteSuggesterView({
	                    inputId: this.searchTextInputId,
	                    url: that.servicesAddresses["rxnormMedicationServiceAddress"] + '/REST/spellingsuggestions.json?name=~~~',
	                    symbolForSearchInUrl: '~~~',
	                    listLocation: function (data) {
	                        return (data.suggestionGroup.suggestionList || {suggestion: []}).suggestion;
	                    },
	                    getValueFn: function (element) {
	                        return element;
	                    },
	                    classes: ["form-control"],
	                    placeholder: "For search type at least 2 character"
	                }));
	            }
	        },
	
	        showModal: function () {
	            this.ui.formModal.modal("show");
	        },
	
	        hideModal: function () {
	            this.ui.formModal.modal("hide");
	        },
	
	        saveMedication: function () {
	            if (this.mode == 'add')
	                this.triggerMethod('new:medication', this.fillMedication());
	            else if (this.mode == 'edit')
	                this.triggerMethod('update:medication', this.fillMedication());
	
	            this.hideModal();
	        },
	
	        fillMedication: function () {
	            if (this.isNewGroup) {
	                this.medication.groupUuid = this.utils.generatedUUID();
	            }
	            this.medication.medicationUuid = this.utils.generatedUUID();
	            this.medication.medicationId = typeof this.medication.medicationId == "undefined" ?
	                Math.round(Math.random() * 100000) : this.medication.medicationId;
	            this.medication.name = this.ui.name.val();
	
	
	            this.medication.formObj = {
	                title: $("#form option:selected").text(),
	                code: this.ui.form.val(),
	                systemId: 'RxNorm'
	            };
	
	            this.medication.eventType =
	                this.isNewGroup || this.medication.eventType == this.getBaseInitialMedicationEventType()
	                    ? this.getBaseInitialMedicationEventType() : this.ui.eventType.val();
	
	
	            this.medication.doseObj= {
	                title: this.ui.dose.val(),
	                code: this.ui.dose.val(),
	                systemId: 'RxNorm'
	            };
	
	            this.medication.quantity = this.ui.quantity.val();
	
	            this.medication.frequency = {
	                systemId: 'snomed',
	                code: this.ui.frequency.val(),
	                title: this.ui.frequency.children(':selected')[0].text
	            };
	
	            this.medication.startDate = this.utils.dateToLong(this.ui.startDate.val());
	            this.medication.stopDate = this.utils.dateToLong(this.ui.stopDate.val());
	            this.medication.comment = this.ui.comment.val();
	            this.medication.diseasesUuids = (this.ui.diseases.val().split(this.listDelimeter) || [])
	                .filter(function(diseaseUuid) {
	                    return diseaseUuid != "";
	                });
	            this.medication.documentsIds = (this.ui.documents.val().split(this.listDelimeter) || [])
	                .filter(function(id) {
	                    return id != "";
	                });
	
	            if (this.continuousFrequency){
	                this.medication.regularFrequency = this.continuousFrequency;
	            }
	
	            if ((this.medication.frequency || {}).code !== '255238004'){
	                this.medication.regularFrequency = undefined;
	            }
	            return this.medication;
	        },
	
	        allowOnlyFloats: function (event) {
	            return event.charCode == 46 || this.allowOnlyInts(event);
	        },
	
	        allowOnlyInts: function (event) {
	            return event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 37 || event.keyCode == 39 ||
	                event.charCode >= 48 && event.charCode <= 57;
	        },
	
	        validate: function () {
	            if (this.ui.name.val() != '' && this.ui.quantity.val() != '') {
	                this.ui.save.removeAttr('disabled');
	            } else {
	                this.ui.save.attr('disabled', true);
	            }
	
	            try {
	                if (this.ui.eventType.val() == '') {
	                    this.ui.save.attr('disabled', true);
	                }
	            } catch (exp) {
	            }
	
	        },
	
	        search: function (event) {
	            var searchText = $('#' + this.searchTextInputId).val();
	            if (searchText.length < 2)
	                return;
	            $('#search-results tr:not(:first)').remove();
	            var that = this;
	            if (event.keyCode == 13 || event.target.id == that.ui.searchButton.attr('id')) {
	                this.results = [];
	                that.showLoading();
	                //var isSnomedRequestComplete = false;
	                var isCustomRequestComplete = false;
	                var isRxnormRequestComplete = false;
	
	                /*if (typeof that.servicesAddresses["snomedMedicationServiceAddress"] != "undefined") {
	                 $.when(
	                 $.ajax({
	                 type: "GET",
	                 url: that.servicesAddresses["snomedMedicationServiceAddress"] +
	                 '/descriptions?returnLimit=100&semanticFilter=product&query=' + searchText
	                 })
	                 ).done(function (resp) {
	                 that.renderResultInTable(that.tranformSnomedResponse(resp));
	                 isSnomedRequestComplete = true;
	                 if (isSnomedRequestComplete && isCustomRequestComplete)
	                 that.hideLoading();
	                 }).fail(function (jqXHR, textStatus) {
	                 notificationsChannel.request('show:notification', "Error. Snomed medication service is unavailable");
	                 isSnomedRequestComplete = true;
	                 if (isSnomedRequestComplete && isCustomRequestComplete)
	                 that.hideLoading();
	                 });
	                 } else isSnomedRequestComplete = true;*/
	
	                if (typeof that.servicesAddresses["rxnormMedicationServiceAddress"] != "undefined") {
	                    $.when(
	                        $.ajax({
	                            type: "GET",
	                            headers: {
	                                Accept: 'application/json'
	                            },
	                            url: that.servicesAddresses["rxnormMedicationServiceAddress"] +
	                            '/REST/drugs.json?name=' + searchText
	                        })
	                    ).done(function (resp) {
	                        var transformed = that.tranformRxNormResponse(resp);
	                        if (transformed.length == 0) {
	                            that.showDefaultOptionsOfMedicationFormsSelect();
	                            that.resetDoseSelect();
	                        }
	                        that.renderResultInTable(transformed);
	                        isRxnormRequestComplete = true;
	                        if (isRxnormRequestComplete && isCustomRequestComplete)
	                            that.hideLoading();
	                    }).fail(function (jqXHR, textStatus) {
	                        notificationsChannel.request('show:notification', "Error. RxNorm medication service is unavailable");
	                        isRxnormRequestComplete = true;
	                        if (isRxnormRequestComplete && isCustomRequestComplete)
	                            that.hideLoading();
	                    });
	                } else isRxnormRequestComplete = true;
	
	                if (typeof that.servicesAddresses["customMedicationServiceAddress"] != "undefined") {
	                    $.when(
	                        $.ajax({
	                            type: "GET",
	                            url: that.servicesAddresses["customMedicationServiceAddress"] +
	                            '/api/medications?name=' + searchText
	                        })
	                    ).done(function (resp) {
	                        that.renderResultInTable(that.tranformCustomResponse(resp));
	                        isCustomRequestComplete = true;
	                        if (isRxnormRequestComplete && isCustomRequestComplete)
	                            that.hideLoading();
	                    }).fail(function (jqXHR, textStatus) {
	                        notificationsChannel.request('show:notification', "Error. Custom medication service is unavailable");
	                        isCustomRequestComplete = true;
	                        if (isRxnormRequestComplete && isCustomRequestComplete)
	                            that.hideLoading();
	                    });
	                } else isCustomRequestComplete = true;
	            }
	        },
	
	        tranformSnomedResponse: function (response) {
	            return (response.matches || []).map(function (item) {
	                return {
	                    id: item.conceptId,
	                    name: item.term,
	                    systemType: 'Snomed'
	                }
	            });
	        },
	
	        tranformCustomResponse: function (response) {
	            return (response || []).map(function (item) {
	                return {
	                    id: item.id,
	                    name: item.name,
	                    systemType: 'Custom'
	                }
	            });
	        },
	
	        onFrequencyChanged: function(){
	            if (this.ui.frequency.val() == '255238004'){
	                this.ui.continuousFrequencyContainer.show();
	            } else {
	                this.ui.continuousFrequencyContainer.hide();
	            }
	            this.validate()
	        },
	
	        tranformRxNormResponse: function (response) {
	            var sbd = (response.drugGroup.conceptGroup || []).filter(function (group) {
	                return group.tty == 'SBD' || group.tty == 'SCD';
	            });
	
	            if (sbd.length == 0) return [];
	
	            return (sbd[0].conceptProperties || []).map(function (group) {
	                return {
	                    id: group.rxcui,
	                    name: group.name,
	                    systemType: 'RxNorm'
	                }
	            });
	        },
	
	        renderResultInTable: function (results) {
	            var that = this;
	            that.results = that.results.concat(results);
	            results = _.sortBy(results, 'name');
	
	            results.forEach(function (item) {
	                var newRowContent = "<tr class='clickable' id='" + item.id + "'><td>"
	                    + item.name + "</td><td>" + item.systemType + "</td>";
	                $('#search-results tbody').append(newRowContent);
	            });
	
	            $("#search-results tr:not(:first)").on('click', function (event) {
	                var id = event.currentTarget.id;
	                $(this).addClass('selected').siblings().removeClass('selected');
	                that.fillFormFromSelectedResult(id, that.results);
	            });
	            if (results.length > 0) {
	                this.ui.searchResultsTable.show();
	            }
	        },
	
	        fillFormFromSelectedResult: function (selectedId, results) {
	            var selected = _.findWhere(results, {id: selectedId});
	            if (selected.systemType == 'RxNorm') {
	                this.showRxNormOptionsOfMedicationFormsSelect(selected.id, this.clearAndAddMedicationFormsOptions, true);
	                this.fillDoseSelectFromRxNorm(selected.id);
	            } else {
	                this.showDefaultOptionsOfMedicationFormsSelect();
	                this.resetDoseSelect();
	            }
	            this.medication.systemType = selected.systemType;
	            this.medication.medicationId = selected.id;
	            this.medication.name = selected.name;
	            this.ui.name.val(selected.name);
	            this.validate();
	        },
	
	        clearAndAddMedicationFormsOptions: function (obj) {
	            var that = this;
	            (_.sortBy(obj.conceptProperties, "name") || []).forEach(function (concept, index) {
	                that.formsSelect[0].selectize.addOption({
	                    value: concept.rxcui,
	                    text: concept.name
	                });
	                if (index == 0) {
	                    that.formsSelect[0].selectize.addItem(concept.rxcui);
	                }
	            });
	        },
	
	        removeMedicationFormsOptions: function (obj) {
	            var that = this;
	            Object.keys(that.formsSelect[0].selectize.options).forEach(function (id) {
	                var found = _.findWhere(_.sortBy(obj.conceptProperties, "name"), {rxcui: id});
	                if (found == undefined) {
	                    that.formsSelect[0].selectize.removeOption(id);
	                }
	            });
	        },
	
	        showDefaultOptionsOfMedicationFormsSelect: function () {
	            var that = this;
	            that.formsSelect[0].selectize.clearOptions();
	            that.defaultMedicationForms.forEach(function (form) {
	                that.formsSelect[0].selectize.addOption({
	                    value: form.id,
	                    text: form.name
	                });
	            });
	        },
	
	        showRxNormOptionsOfMedicationFormsSelect: function (rxcui, handler, clearAllOptions) {
	            var that = this;
	            if (clearAllOptions) {
	                that.formsSelect[0].selectize.clearOptions();
	            }
	            $.when(
	                $.ajax({
	                    type: "GET",
	                    headers: {
	                        Accept: 'application/json'
	                    },
	                    url: that.servicesAddresses["rxnormMedicationServiceAddress"] + '/REST/rxcui/' + rxcui + '/related.json?tty=DFG'
	                })
	            ).done(function (response) {
	                var dfg = (response.relatedGroup.conceptGroup || []).filter(function (group) {
	                    return group.tty == 'DFG';
	                });
	
	                if (dfg.length > 0) {
	                    handler(dfg[0]);
	                }
	            }).fail(function (jqXHR, textStatus) {
	                notificationsChannel.request('show:notification', "Error. RxNorm medication service is unavailable");
	            });
	        },
	
	        resetDoseSelect: function () {
	            var that = this;
	            that.doseSelect[0].selectize.clearOptions();
	            if (that.medication.dose != undefined) {
	                that.doseSelect[0].selectize.addOption({
	                    value: that.medication.dose,
	                    text: that.medication.dose
	                });
	                that.doseSelect[0].selectize.addItem(that.medication.dose);
	            }
	        },
	
	        fillDoseSelectFromRxNorm: function (rxcui) {
	            var that = this;
	            that.resetDoseSelect();
	
	            $.when(
	                $.ajax({
	                    type: "GET",
	                    headers: {
	                        Accept: 'application/json'
	                    },
	                    url: that.servicesAddresses["rxnormMedicationServiceAddress"]
	                    + '/REST/rxcui/' + rxcui + '/property.json?propName=AVAILABLE_STRENGTH'
	                })
	            ).done(function (response) {
	                (response.propConceptGroup.propConcept || []).forEach(function (concept, index) {
	                    that.doseSelect[0].selectize.addOption({
	                        value: concept.propValue,
	                        text: concept.propValue
	                    });
	                    if (index == 0 && that.medication.dose == undefined || concept.propValue == that.medication.dose) {
	                        that.doseSelect[0].selectize.addItem(concept.propValue);
	                    }
	                });
	            }).fail(function (jqXHR, textStatus) {
	                notificationsChannel.request('show:notification', "Error. RxNorm medication service is unavailable");
	            });
	        },
	
	        getMedicationEventTypes: function () {
	            return ["ANOTHER_APPOINTMENT", "PURCHASE", "TAKEN_INSIDE"];
	        },
	
	        getBaseInitialMedicationEventType: function () {
	            return "PRESCRIPTION";
	        },
	
	        showLoading: function () {
	            this.utils.showSpinner('#medication-loader');
	        },
	
	        hideLoading: function () {
	            this.utils.hideSpinner('#medication-loader');
	        },
	
	        onChildviewNodeSelected: function (element) {
	            this.ui.continuousFrequencyFelectedValue.html(element.text);
	            this.ui.continuousFrequencyFelected.show();
	            this.ui.snomedTree.hide();
	            this.continuousFrequency = {
	                systemId: 'snomed',
	                code: element.conceptId,
	                title: element.text
	            }
	        },
	
	        removeContinuousFrequency: function () {
	            this.ui.continuousFrequencyFelectedValue.html('');
	            this.ui.continuousFrequencyFelected.hide();
	            this.ui.snomedTree.show();
	            this.continuousFrequency = undefined;
	        }
	
	    })
	    ;
	
	module.exports = MedicationForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(215);
	
	var Marionette = __webpack_require__(180);
	var SnomedCollection = __webpack_require__(350);
	
	var SnomedTreeView = Marionette.View.extend({
	        template: __webpack_require__(352),
	
	        apiUrl: 'https://snomed.reviewandsign.org/snomed/en-edition/v20140731/concepts/',
	        tree: [],
	
	        ui: {
	            selected: '#selected'
	        },
	
	        templateContext: function () {
	            var that = this;
	            return {
	
	            };
	        },
	
	        initialize: function (options) {
	            _.bindAll(this, 'findAppendable', 'renderTree', 'addTreeNode', 'collectionToTree', 'fetchNode');
	
	            if (options) {
	                this.showHead = options.showHead || false;
	                this.parent = options.parent;
	            }
	            this.collection = new SnomedCollection([], {
	                parent: this.parent,
	                children: true
	            });
	            this.collection.fetch({success: this.addTreeNode});
	        },
	
	        renderTree: function(){
	            var that = this;
	            $('#tree').treeview({
	                data: that.tree,
	                enableLinks: false,
	                showTags: false,
	                levels: 10
	            });
	
	            $('#tree').on('nodeSelected', function(event, data) {
	                if (!data.isLeafStated){
	                    var node = (that.findAppendable(undefined, data.conceptId) || {});
	                    if (data.state.expanded){
	                        node.expanded = false;
	                        node.state.expanded = false;
	                        $('#tree').treeview('collapseNode', [data]);
	                    } else {
	                        node.expanded = true;
	                        node.state.expanded = true;
	                        that.fetchNode(event, node);
	                        $('#tree').treeview('expandNode', [data, { levels: 1, silent: true } ]);
	                    }
	                } else {
	                    that.triggerMethod('nodeSelected', data);
	                }
	            });
	
	            $('#tree').on('nodeExpanded', function(event, data) {
	                var node = (that.findAppendable(undefined, data.conceptId) || {})
	                node.expanded = true;
	                node.state.expanded = true;
	                that.fetchNode(event, node);
	            });
	
	            $('#tree').on('nodeCollapsed', function(event, data) {
	                var node = (that.findAppendable(undefined, data.conceptId) || {});
	                node.expanded = false;
	                node.state.expanded = false;
	                node.nodes.forEach(function (child) {
	                    $('#tree').treeview('collapseNode', [ child, { silent: true, ignoreChildren: false } ]);
	                });
	            });
	        },
	
	        fetchNode: function (event, data) {
	            var that = this;
	            if (!data.isLeafStated && (data.nodes || []).length == 0){
	                this.collection = new SnomedCollection([], {
	                    parent: data.conceptId,
	                    children: true
	                });
	                this.collection.fetch({success: function () {
	                    that.addTreeNode(data.conceptId);
	                }});
	            }
	        },
	
	        addTreeNode: function (parentId) {
	            var subtree = this.collectionToTree(this.collection.toJSON());
	            if (this.tree.length == 0){
	                this.tree = subtree;
	            } else {
	                var node = this.findAppendable(undefined, parentId);
	                node.nodes = subtree;
	                node.state.expanded = node.expanded;
	            }
	            this.renderTree();
	        },
	
	        collectionToTree: function(collection){
	            var that = this;
	            var tree = [];
	            if ((collection || []).length == 0){
	                return undefined;
	            }
	            collection.forEach(function(concept){
	                tree.push({
	                    conceptId: concept.conceptId,
	                    text: concept.defaultTerm,
	                    nodes: concept.isLeafStated ? undefined : [],
	                    isLeafStated: concept.isLeafStated,
	                    state:{
	                        expanded: concept.expanded === undefined ? false : concept.expanded
	                    }
	                });
	            });
	            return _.sortBy(tree, function(o) { return o.text; });
	        },
	
	        findAppendable: function (head, nodeId) {
	            if (!head){
	                head = {nodes: this.tree}
	            }
	            if (head.conceptId == nodeId) {return head};
	
	            var foundNode;
	            for (var i in (head.nodes || [])){
	                foundNode = this.findAppendable(head.nodes[i], nodeId);
	                if (foundNode){
	                    break;
	                }
	            }
	            return foundNode;
	        }
	
	    });
	
	module.exports = SnomedTreeView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	var SnomedModel = __webpack_require__(351);
	
	var SnomedCollection = Backbone.Collection.extend({
	    url:"https://snomed.reviewandsign.org/snomed/en-edition/v20140731/concepts",
	    model: SnomedModel,
	
	    initialize: function(models, options) {
	        if (options){
	            if (options.parent){
	                this.url += "/" + options.parent;
	            }
	            if (options.children){
	                this.url += "/children";
	            }
	        }
	    }
	
	});
	
	
	module.exports = SnomedCollection;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(181);
	
	
	var SnomedModel = Backbone.Model.extend({
	    url: 'https://snomed.reviewandsign.org/snomed/en-edition/v20140731/concepts',
	
	    initialize: function(models, options) {
	            if (options && options.params){
	                if (options.params.id){
	                    this.url += "/" + id;
	                }
	            }
	        },
	
	    parse: function(data){
	        data.defaultTerm = data.defaultTerm.replace('(qualifier value)', '').trim();
	        return data;
	    }
	});
	
	
	module.exports = SnomedModel;

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div id="tree"></div>';
	}
	return __p;
	};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="modal fade" id="medication-form-modal" tabindex="-1" role="dialog" aria-labelledby="medication-form-modal">\r\n    <div class="modal-dialog ';
	 if (mode == 'add') { 
	__p+=' modal-lg ';
	 } 
	__p+=' " role="document">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\r\n                        aria-hidden="true">&times;</span></button>\r\n                <h4 class="modal-title">'+
	((__t=( title ))==null?'':__t)+
	'</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <div id="medication-loader" class="loader"></div>\r\n                <div class="row" style="min-height: 100%">\r\n                    <div class="col-md-6 inputs">\r\n                        <div class="form-horizontal">\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="name">Name</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="name" required readonly\r\n                                           value="'+
	((__t=( name ))==null?'':__t)+
	'">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="form">Form</label>\r\n                                <div class="col-md-9">\r\n                                    <select id="form" data-placeholder="Select form" value="">\r\n                                        <option value=""></option>\r\n                                        ';
	 _.each(forms, function(f){ 
	__p+='\r\n                                        <option value="'+
	((__t=( f.id ))==null?'':__t)+
	'" name="'+
	((__t=( f.name ))==null?'':__t)+
	'"\r\n                                        ';
	 if (f.id == form){
	__p+=' selected ';
	}
	__p+=' > '+
	((__t=( f.name ))==null?'':__t)+
	'</option>\r\n                                        ';
	 }) 
	__p+='\r\n                                    </select>\r\n                                    <input type="hidden" id="formcode"/>\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="diseases">Diseases</label>\r\n                                <div class="col-md-9">\r\n                                    <input type="text" class="selectized" id="diseases" style="display: block;">\r\n                                </div>\r\n                            </div>\r\n                            ';
	 if (!isNewGroup && eventType != getBaseInitialMedicationEventType()) { 
	__p+='\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="event">Event</label>\r\n                                <div class="col-md-9">\r\n                                    <select id="event" data-placeholder="Select event" value="">\r\n                                        <option value=""></option>\r\n                                        ';
	 _.each(eventTypes, function(et){ 
	__p+='\r\n                                        <option value="'+
	((__t=( et.id ))==null?'':__t)+
	'" name="'+
	((__t=( et.id ))==null?'':__t)+
	'"\r\n                                        ';
	 if (et.id == eventType){
	__p+=' selected ';
	}
	__p+=' > '+
	((__t=( et.name ))==null?'':__t)+
	'</option>\r\n                                        ';
	 }) 
	__p+='\r\n                                    </select>\r\n                                </div>\r\n                            </div>\r\n                            ';
	 } 
	__p+='\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="dose">Dose</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <select id="dose" data-placeholder="Select or type dose" value="">\r\n                                    </select>\r\n                                </div>\r\n                                <input type="hidden" id="dosecode"/>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="quantity">Quantity</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="quantity" required\r\n                                           value="'+
	((__t=( quantity ))==null?'':__t)+
	'">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="frequency">Frequency</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <select id="frequency" data-placeholder="Frequency" value="">\r\n                                        <option value=""></option>\r\n                                        <option value="255238004" ';
	 if ((frequency || {}).code == 255238004){
	__p+=' selected ';
	}
	__p+=' >Continuous</option>\r\n                                        <option value="225761000" ';
	 if ((frequency || {}).code == 225761000){
	__p+=' selected ';
	}
	__p+=' >As required</option>\r\n                                        <option value="307486002" ';
	 if ((frequency || {}).code == 307486002){
	__p+=' selected ';
	}
	__p+=' >Single event</option>\r\n                                    </select>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div class="form-group" id="continuous-frequency-container" ';
	 if ((frequency || {}).code != 255238004){
	__p+=' style="display: none;" ';
	}
	__p+='>\r\n                                <div id="continuous-frequency-selected" ';
	 if (!continuousFrequency){
	__p+=' style="display: none" ';
	}
	__p+=' class="col-sm-12 col-md-12">\r\n                                    <label class="col-sm-3 col-md-3 control-label" for="stop-date"></label>\r\n                                    <div id="continuous-frequency-selected-value" class="col-sm-8 col-md-8">\r\n                                        ';
	 if (continuousFrequency){
	__p+=' '+
	((__t=( continuousFrequency.title ))==null?'':__t)+
	'  ';
	}
	__p+='\r\n                                    </div>\r\n                                    <div class="col-sm-1 col-md-1"><span class="glyphicon glyphicon-remove" id="continuous-frequency-remove"/></div>\r\n                                </div>\r\n                                <div id="snomed-tree" class="col-sm-12 col-md-12" ';
	 if (continuousFrequency){
	__p+=' style="display: none" ';
	}
	__p+='></div>\r\n                            </div>\r\n\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="start-date">Start date</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="start-date" value="'+
	((__t=( startDate ))==null?'':__t)+
	'"\r\n                                           onkeypress="return false;">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="stop-date">Stop date</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="stop-date" value="'+
	((__t=( stopDate ))==null?'':__t)+
	'"\r\n                                           onkeypress="return false;">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="documents">Documents</label>\r\n                                <div class="col-md-9">\r\n                                    <input type="text" class="selectized" id="documents" style="display: block;">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="comment">Comment</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <textarea class="form-control" rows="5" cols="50"\r\n                                              id="comment">'+
	((__t=( comment ))==null?'':__t)+
	'</textarea>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    ';
	 if (mode == 'add') { 
	__p+='\r\n                    <div class="col-md-6">\r\n                        <div class="form-horizontal">\r\n                            <div class="form-group col-xs-10 col-xs-10">\r\n                                <div id="search-text-container"></div>\r\n                            </div>\r\n                            <div class="form-group col-xs-2 col-xs-2">\r\n                                <button class="form-control glyphicon glyphicon-search" id="search-button"></button>\r\n                            </div>\r\n                            <div class="form-group col-xs-11 col-xs-11" style="height: 500px;overflow-y: auto">\r\n                                <table id="search-results" class="table table-hover table-striped">\r\n                                    <thead>\r\n                                    <tr>\r\n                                        <th>Name</th>\r\n                                        <th>System type</th>\r\n                                    </tr>\r\n                                    </thead>\r\n                                    <tbody></tbody>\r\n                                </table>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    ';
	 } 
	__p+='\r\n                </div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\r\n                <button type="button" class="btn btn-primary" id="save">Save</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if (!isHidden && canEdit) { 
	__p+='\r\n<td rowspan="'+
	((__t=( groupSize ))==null?'':__t)+
	'" style="vertical-align:bottom;" class="table-splitted">\r\n    <button type="button" class="btn btn-primary btn-sm add-event">Add event</button>\r\n</td>\r\n';
	 } 
	__p+='\r\n<td hidden>'+
	((__t=( medicationId ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( name ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( eventTypeName ))==null?'':__t)+
	'</td>\r\n<td>\r\n    ';
	 if ((diseasesUuids || []).length != 0) { 
	__p+='\r\n    <div class="diseases-show center clickable" title="Diseases">\r\n        <span class="badge">'+
	((__t=( (diseasesUuids || []).length ))==null?'':__t)+
	'</span>\r\n    </div>\r\n    ';
	 } 
	__p+='\r\n</td>\r\n<td hidden>'+
	((__t=( systemType ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( formName ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( dose ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( quantity ))==null?'':__t)+
	'</td>\r\n<td>\r\n    '+
	((__t=( (frequency || {}).title ))==null?'':__t)+
	'\r\n    ';
	 if (regularFrequency){
	__p+=' - '+
	((__t=( regularFrequency.title ))==null?'':__t)+
	' ';
	}
	__p+='\r\n</td>\r\n<td>'+
	((__t=( startDate ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( stopDate ))==null?'':__t)+
	'</td>\r\n<td>\r\n    ';
	 if ((documentsIds || []).length != 0) { 
	__p+='\r\n    <div class="documents-show center clickable" title="Documents">\r\n        <span class="badge">'+
	((__t=( (documentsIds || []).length ))==null?'':__t)+
	'</span>\r\n    </div>\r\n    ';
	 } 
	__p+='\r\n</td>\r\n<td class="col-md-2 col-xs-2">'+
	((__t=( comment ))==null?'':__t)+
	'</td>\r\n<td><span class="clickable glyphicon glyphicon glyphicon-pencil edit" title="Edit"></span></td>\r\n<td><span class="clickable glyphicon glyphicon-remove remove" title="Remove"></span></td>';
	}
	return __p;
	};


/***/ }),
/* 355 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div id="error">\r\n    <h2>Access denied</h2>\r\n</div>\r\n\r\n<div id="content">\r\n    <h3 class="center">Medications</h3>\r\n    ';
	 if (canEdit) { 
	__p+='\r\n    <div class="left-buttons">\r\n        <button type="button" class="btn btn-success" id="add">Add prescription</button>\r\n    </div>\r\n    ';
	 } 
	__p+='\r\n    <div id="medications-table" class="top-margined" style="font-size: 12px;">\r\n        <table class="table">\r\n            <thead>\r\n            <tr>';
	 if (canEdit) { 
	__p+='\r\n                <th></th>\r\n                ';
	 } 
	__p+='\r\n                <th hidden>Id</th>\r\n                <th>Name</th>\r\n                <th>Event</th>\r\n                <th>Reason</th>\r\n                <th hidden>System type</th>\r\n                <th>Form</th>\r\n                <th>Dose</th>\r\n                <th>Quant</th>\r\n                <th>Freq</th>\r\n                <th>Start date</th>\r\n                <th>Stop date</th>\r\n                <th>Docs</th>\r\n                <th>Comment</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody></tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n\r\n<div id="buttons">\r\n    <h2>Medical record doesn\'t exist</h2>\r\n    ';
	 if (canEdit) { 
	__p+='\r\n    <button type="button" class="btn btn-primary" id="create-med-record">Create medical record</button>\r\n    ';
	 } 
	__p+='\r\n</div>\r\n\r\n<div id="medication-form"></div>\r\n<div id="delete-confirmation-modal"></div>\r\n\r\n<!-- Diseases show modal with table -->\r\n<div class="modal fade" id="diseases-show-modal" tabindex="-1" role="dialog">\r\n    <div class="modal-dialog">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal">&times;</button>\r\n                <h4 class="modal-title">Diseases</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <table class="table" id="diseases-table">\r\n                    <thead>\r\n                    <tr>\r\n                        <th>Name</th>\r\n                        <th>Start date</th>\r\n                        <th>Stop date</th>\r\n                    </tr>\r\n                    </thead>\r\n                    <tbody></tbody>\r\n                </table>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n\r\n<!-- Documents show modal as table -->\r\n<div class="modal fade" id="documents-show-modal" tabindex="-1" role="dialog">\r\n    <div class="modal-dialog">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal">&times;</button>\r\n                <h4 class="modal-title">Documents</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <table class="table" id="documents-table">\r\n                    <thead>\r\n                    <tr>\r\n                        <th>Name</th>\r\n                        <th>View</th>\r\n                    </tr>\r\n                    </thead>\r\n                    <tbody></tbody>\r\n                </table>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var DiseasesForm = __webpack_require__(357);
	var DeleteConfirmationModal = __webpack_require__(241);
	var MedProfileModel = __webpack_require__(213);
	var ExacerbationsView = __webpack_require__(358);
	
	var CommonUtils = __webpack_require__(189);
	var Dicts = __webpack_require__(193);
	
	var Radio = __webpack_require__(183);
	var services = Radio.channel('services');
	var notificationsChannel = Radio.channel('notifications');
	var utils = new CommonUtils();
	
	var DiseasesRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(362),
	
	    ui: {
	        edit: '.edit',
	        remove: '.remove',
	        showExacerbations: '.e-show'
	    },
	
	    events: {
	        'click @ui.edit': 'onEdit',
	        'click @ui.remove': 'onRemove',
	        'click @ui.showExacerbations': 'showExacerbations'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var startDate = that.model.get('startDate');
	        var stopDate = that.model.get('stopDate');
	        var typeOfId = that.model.get('typeOfId');
	        return {
	            startDate: startDate != undefined && startDate != '' && !isNaN(startDate) ? utils.longToDateTimeFormatted(startDate, 'MM/DD/YYYY') : '',
	            stopDate: stopDate != undefined && stopDate != '' && !isNaN(stopDate) ? utils.longToDateTimeFormatted(stopDate, 'MM/DD/YYYY') : '',
	            typeOfId: Dicts.hl7Dict[typeOfId] || typeOfId
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	    },
	
	    onRender: function () {
	
	    },
	
	    onEdit: function() {
	        this.triggerMethod('edit:disease', {model: this.model});
	    },
	
	    onRemove: function() {
	        this.triggerMethod('remove:disease', {model: this.model});
	    },
	
	    showExacerbations: function() {
	        this.triggerMethod('show:exacerbations', {exacerbations: this.model.get('exacerbations')});
	    }
	});
	
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(8), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var DiseasesTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: DiseasesRowView,
	    emptyView: EmptyView,
	
	    collectionEvents: {},
	
	    childViewEvents: {
	        'remove:disease': 'removeDisease',
	        'edit:disease': 'editDisease',
	        'show:exacerbations': 'showExacerbations'
	    },
	
	    initialize: function (options) {
	        this.collection = options.collection;
	    },
	
	    childViewOptions: function () {
	        return {
	        };
	    },
	
	    removeDisease: function(data) {
	        this.triggerMethod('remove:disease', data);
	    },
	
	    editDisease: function(data) {
	        this.triggerMethod('edit:disease', data);
	    },
	
	    showExacerbations: function(data) {
	        this.triggerMethod('show:exacerbations', data);
	    }
	});
	
	var DiseasesView = Marionette.View.extend({
	    template: __webpack_require__(363),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        diseasesForm: '#disease-form',
	        deleteConfirmationModal: '#delete-confirmation-modal',
	        exacerbationsShowRegion: '#exacerbation-show'
	    },
	
	    ui: {
	        addDisease: '#add',
	        exacerbationShowModal: '#exacerbation-show-modal'
	    },
	
	    events: {
	        'click @ui.addDisease': 'addNewDisease'
	    },
	
	    childViewEvents: {
	        'new:disease': 'saveNewDisease',
	        'update:disease': 'updateDisease',
	        'remove:disease': 'removeDisease',
	        'delete:confirmed': 'deleteConfirmed',
	        'edit:disease': 'editDisease',
	        'show:exacerbations': 'showExacerbations'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            canEdit: that.canEdit,
	            name: that.name
	        }
	    },
	
	
	    initialize: function (options) {
	        _.bindAll(this, 'addNewDisease');
	        if (options) {
	            this.medProfileModel = options.medProfileModel;
	            this.name = options.name;
	            this.canEdit = options.canEdit
	        }
	        this.servicesAddresses = services.request('get:services:address');
	    },
	
	    onRender: function () {
	        var that = this;
	
	        var diseases = that.medProfileModel.get('object').diseases;
	        this.diseasesCollection = new Backbone.Collection(diseases);
	        this.showChildView('body', new DiseasesTableBody({
	            collection: this.diseasesCollection
	        }));
	
	        this.exacerbationsView = new ExacerbationsView({
	            exacerbations: [],
	            isReadOnly: true
	        });
	        this.showChildView('exacerbationsShowRegion', this.exacerbationsView);
	    },
	
	    addNewDisease: function () {
	        this.showChildView('diseasesForm', new DiseasesForm({
	            mode: 'add',
	            disease: {},
	            servicesAddresses: this.servicesAddresses
	        }));
	    },
	
	    editDisease: function (data) {
	        this.showChildView('diseasesForm', new DiseasesForm({
	            mode: 'edit',
	            disease: data.model.toJSON(),
	            servicesAddresses: this.servicesAddresses
	        }));
	    },
	
	    saveNewDisease: function (disease) {
	        var that = this;
	        utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/medprofile/' + this.medProfileModel.get('id') + '/disease',
	            data: JSON.stringify(disease),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    utils.hideSpinner();
	                    that.medProfileModel = new MedProfileModel(response);
	                    that.diseasesCollection.reset(that.medProfileModel.get('object').diseases);
	                }
	            },
	            error: function(e) {
	                notificationsChannel.request('show:notification', e.responseJSON);
	                utils.hideSpinner();
	            }
	        });
	    },
	
	    updateDisease: function(disease) {
	        var that = this;
	        utils.showSpinner();
	        $.ajax({
	            type: "PUT",
	            url: '/api/medprofile/' + this.medProfileModel.get('id') + '/disease',
	            data: JSON.stringify(disease),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    utils.hideSpinner();
	                    that.medProfileModel = new MedProfileModel(response);
	                    that.diseasesCollection.reset(that.medProfileModel.get('object').diseases);
	                }
	            },
	            error: function(e) {
	                notificationsChannel.request('show:notification', e.responseJSON);
	                utils.hideSpinner();
	            }
	        });
	    },
	
	    deleteConfirmed: function(value) {
	        if (value == true) {
	            var that = this;
	            var uuid = that.delModel.get('uuid');
	            utils.showSpinner();
	            $.ajax({
	                type: "DELETE",
	                url: '/api/medprofile/' + this.medProfileModel.get('id') + '/' + uuid,
	                statusCode: {
	                    200: function (response) {
	                        utils.hideSpinner();
	                        that.medProfileModel = new MedProfileModel(response);
	                        that.diseasesCollection.reset(that.medProfileModel.get('object').diseases);
	                    }
	                },
	                error: function (e) {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                    utils.hideSpinner();
	                }
	            });
	        }
	    },
	
	    removeDisease: function (data) {
	        this.delModel = data.model;
	        this.deleteConfirmationModal =
	            new DeleteConfirmationModal({
	                message: 'Enter: "confirm" if you agree to remove the disease.',
	                confirmationAnswer: 'confirm'
	            });
	        this.showChildView('deleteConfirmationModal', this.deleteConfirmationModal);
	        this.deleteConfirmationModal.show();
	    },
	
	    showExacerbations: function(data) {
	        this.exacerbationsView.resetCollection(data.exacerbations || []);
	        this.ui.exacerbationShowModal.modal('show');
	    }
	
	});
	
	module.exports = DiseasesView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	var ExacerbationsView = __webpack_require__(358);
	var Dicts = __webpack_require__(193);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var DiseasesForm = Marionette.View.extend({
	    template: __webpack_require__(361),
	
	    regions: {
	        exacerbationsRegion: '#exacerbations'
	    },
	
	    ui: {
	        formModal: '#disease-form-modal',
	        save: '#save',
	
	        typeOfId: '#type',
	        icdCode: '#icd-code',
	        name: '#name',
	        startDate: '#start-date',
	        stopDate: '#stop-date',
	        comment: '#comment',
	
	        searchText: '#search-text',
	        searchButton: '#search-button',
	        searchResultsTable: '#search-results',
	
	        leftSide: '.inputs'
	    },
	
	    events: {
	        'click @ui.save': 'saveDisease',
	        'keyup input[required]': 'validate',
	        'change input[required]': 'validate',
	        'keyup @ui.searchText': 'search',
	        'click @ui.searchButton': 'search'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            title: that.mode == 'add' ? 'Add disease' : 'Edit disease',
	            mode: that.mode,
	            name: that.disease.name,
	            diseaseId: that.disease.diseaseId,
	            typeOfId: Dicts.hl7Dict[that.disease.typeOfId] || that.disease.typeOfId,
	            startDate: (that.disease.startDate == '' || that.disease.startDate == null || that.disease.startDate == 0
	                ? '' : that.utils.longToDateTimeFormatted(Number(that.disease.startDate), 'MM/DD/YYYY')),
	            stopDate: (that.disease.stopDate == '' || that.disease.stopDate == null || that.disease.stopDate == 0
	                ? '' : that.utils.longToDateTimeFormatted(Number(that.disease.stopDate), 'MM/DD/YYYY')),
	            comment: that.disease.comment
	        };
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'showModal', 'hideModal', 'saveDisease',
	            'fillDisease', 'validate', 'search', 'tranformICDResponse', 'renderResultInTable',
	            'fillFormFromSelectedResult', 'showLoading', 'hideLoading');
	        if (options) {
	            this.mode = options.mode;
	            this.disease = options.disease;
	            this.disease.exacerbations = this.disease.exacerbations || [];
	            this.servicesAddresses = options.servicesAddresses;
	        }
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	        this.exacerbationsView = new ExacerbationsView({
	            exacerbations: this.disease.exacerbations
	        });
	        this.showChildView('exacerbationsRegion', this.exacerbationsView);
	
	        this.showModal();
	        this.ui.searchResultsTable.hide();
	        this.ui.save.attr('disabled', true);
	
	        this.ui.startDate.datepicker({
	            format: 'mm/dd/yyyy',
	            autoclose: true,
	            clearBtn: true
	        });
	        this.ui.stopDate.datepicker({
	            format: 'mm/dd/yyyy',
	            autoclose: true,
	            clearBtn: true
	        });
	
	        if (this.mode == 'edit') {
	            this.ui.leftSide.removeClass('col-md-6');
	            this.ui.leftSide.addClass('col-md-11');
	        }
	        this.validate();
	
	    },
	
	    showModal: function () {
	        this.ui.formModal.modal("show");
	    },
	
	    hideModal: function () {
	        this.ui.formModal.modal("hide");
	    },
	
	    saveDisease: function () {
	        if (this.mode == 'add')
	            this.triggerMethod('new:disease', this.fillDisease());
	        else if (this.mode == 'edit')
	            this.triggerMethod('update:disease', this.fillDisease());
	
	        this.hideModal();
	    },
	
	    fillDisease: function () {
	        this.disease.typeOfId = this.ui.typeOfId.val();
	        this.disease.diseaseId = this.ui.icdCode.val();
	        this.disease.name = this.ui.name.val();
	        this.disease.startDate = this.utils.dateToLong(this.ui.startDate.val());
	        this.disease.stopDate = this.utils.dateToLong(this.ui.stopDate.val());
	        this.disease.comment = this.ui.comment.val();
	        this.disease.exacerbations = this.exacerbationsView.getAllExacerbations() || [];
	        return this.disease;
	    },
	
	    validate: function () {
	        if (this.ui.name.val() != '' && this.ui.icdCode.val() != '') {
	            this.ui.save.removeAttr('disabled');
	        } else {
	            this.ui.save.attr('disabled', true);
	        }
	    },
	
	    search: function (event) {
	        var searchText = this.ui.searchText.val();
	        if (searchText.length <= 1) return;
	
	        $('#search-results tr:not(:first)').remove();
	        var that = this;
	        if (event.keyCode == 13 || event.target.id == that.ui.searchButton.attr('id')) {
	            that.showLoading();
	
	            if (typeof that.servicesAddresses["icdServiceAddress"] != "undefined") {
	                $.when(
	                    $.ajax({
	                        type: "GET",
	                        url: that.servicesAddresses["icdServiceAddress"] +
	                        '/search?terms=' + searchText
	                    })
	                ).done(function (resp) {
	                    that.renderResultInTable(resp || []);
	                    that.hideLoading();
	                }).fail(function (jqXHR, textStatus) {
	                    notificationsChannel.request('show:notification', "Error. ICD service is unavailable");
	                    that.hideLoading();
	                });
	            }
	        }
	    },
	
	    tranformICDResponse: function (response) {
	        return (response || []).map(function (item) {
	            return {
	                code: item.code,
	                name: item.name
	            }
	        });
	    },
	
	    renderResultInTable: function (results) {
	        var that = this;
	
	        results.forEach(function (item) {
	            var newRowContent = "<tr class='clickable' id='" + item.code + "'><td>"
	                + item.code + "</td><td>" + item.name + "</td></tr>";
	            $('#search-results tbody').append(newRowContent);
	        });
	
	        $("#search-results tr:not(:first)").on('click', function (event) {
	            var id = event.currentTarget.id;
	            $(this).addClass('selected').siblings().removeClass('selected');
	            that.fillFormFromSelectedResult(id, results);
	        });
	        if (results.length > 0) {
	            this.ui.searchResultsTable.show();
	        }
	    },
	
	    fillFormFromSelectedResult: function (selectedId, results) {
	        var selected = _.findWhere(results, {code: selectedId});
	        this.disease.diseaseId = selected.code;
	        this.disease.name = selected.name;
	        this.ui.icdCode.val(selected.code);
	        this.ui.name.val(selected.name);
	        this.validate();
	    },
	
	    showLoading: function () {
	        this.utils.showSpinner('#disease-loader');
	    },
	
	    hideLoading: function () {
	        this.utils.hideSpinner('#disease-loader');
	    }
	
	});
	
	module.exports = DiseasesForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	
	var utils = new CommonUtils();
	
	var ExacerbationsRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(359),
	
	    ui: {
	        edit: '.edit',
	        remove: '.remove'
	    },
	
	    events: {
	        'click @ui.edit': 'onEdit',
	        'click @ui.remove': 'onRemove'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var startDate = that.model.get('startDate');
	        var stopDate = that.model.get('stopDate');
	        return {
	            startDate: startDate != undefined && startDate != '' && !isNaN(startDate) ? utils.longToDateTimeFormatted(startDate, 'MM/DD/YYYY') : '',
	            stopDate: stopDate != undefined && stopDate != '' && !isNaN(stopDate) ? utils.longToDateTimeFormatted(stopDate, 'MM/DD/YYYY') : '',
	            isReadOnly: that.isReadOnly
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	        this.isReadOnly = this.getOption('isReadOnly');
	    },
	
	    onRender: function () {
	
	    },
	
	    onEdit: function () {
	        this.triggerMethod('edit:exacerbation', {model: this.model});
	    },
	
	    onRemove: function () {
	        this.triggerMethod('remove:exacerbation', {model: this.model});
	    }
	});
	
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(3), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var ExacerbationsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: ExacerbationsRowView,
	    emptyView: EmptyView,
	
	    collectionEvents: {},
	
	    childViewEvents: {
	        'remove:exacerbation': 'removeExacerbation',
	        'edit:exacerbation': 'editExacerbation'
	    },
	
	    childViewOptions: function () {
	        return {
	            isReadOnly: this.isReadOnly
	        };
	    },
	
	    initialize: function (options) {
	        this.collection = options.collection;
	        this.isReadOnly = options.isReadOnly;
	    },
	
	    removeExacerbation: function (data) {
	        this.triggerMethod('remove:exacerbation', data);
	    },
	
	    editExacerbation: function (data) {
	        this.triggerMethod('edit:exacerbation', data);
	    }
	});
	
	var ExacerbationsView = Marionette.View.extend({
	    template: __webpack_require__(360),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        }
	    },
	
	    ui: {
	        editInputs: '#edits',
	        startDate: '#e-start-date',
	        stopDate: '#e-stop-date',
	        comment: '#e-comment',
	        newBtn: '#e-new',
	        saveBtn: '#e-save'
	    },
	
	    events: {
	        'click @ui.newBtn': 'newExac',
	        'click @ui.saveBtn': 'saveExac'
	    },
	
	    childViewEvents: {
	        'remove:exacerbation': 'removeExacerbation',
	        'edit:exacerbation': 'editExacerbation'
	    },
	
	    tempModel: undefined,
	
	    templateContext: function () {
	        var that = this;
	        return {
	            isReadOnly: that.isReadOnly
	        }
	    },
	
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'newExac', 'saveExac', 'clearEditables', 'removeExacerbation', 'editExacerbation',
	            'getAllExacerbations', 'resetCollection');
	        if (options) {
	            this.exacerbations = options.exacerbations;
	            this.isReadOnly = options.isReadOnly;
	        }
	    },
	
	    onRender: function () {
	        var that = this;
	
	        that.ui.startDate.datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	        that.ui.stopDate.datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	
	        that.ui.saveBtn.hide();
	        that.ui.editInputs.hide();
	
	        that.exacerbationsCollection = new Backbone.Collection(that.exacerbations);
	        that.showChildView('body', new ExacerbationsTableBody({
	            collection: that.exacerbationsCollection,
	            isReadOnly: that.isReadOnly
	        }));
	    },
	
	    newExac: function () {
	        this.ui.newBtn.hide();
	        this.ui.saveBtn.show();
	        this.ui.editInputs.show();
	        this.tempModel = new Backbone.Model({
	            id: utils.randomString(18)
	        });
	    },
	
	    saveExac: function () {
	        this.tempModel.set('startDate', utils.dateToLong(this.ui.startDate.val()));
	        this.tempModel.set('stopDate', utils.dateToLong(this.ui.stopDate.val()));
	        this.tempModel.set('comment', this.ui.comment.val());
	        var newModel = _.clone(this.tempModel);
	        this.exacerbationsCollection.remove(this.tempModel);
	        this.exacerbationsCollection.add(this.tempModel);
	
	        this.clearEditables();
	        this.ui.editInputs.hide();
	        this.ui.newBtn.show();
	        this.ui.saveBtn.hide();
	    },
	
	    clearEditables: function () {
	        this.ui.startDate.val('');
	        this.ui.stopDate.val('');
	        this.ui.comment.val('');
	    },
	
	    removeExacerbation: function (data) {
	        this.exacerbationsCollection.remove(data.model);
	    },
	
	    editExacerbation: function (data) {
	        this.ui.newBtn.hide();
	        this.ui.saveBtn.show();
	        this.ui.editInputs.show();
	        this.tempModel = data.model;
	
	        var startDate = data.model.get('startDate');
	        var stopDate = data.model.get('stopDate');
	        this.ui.startDate.val(startDate != undefined && startDate != '' && !isNaN(startDate) ? utils.longToDateTimeFormatted(startDate, 'MM/DD/YYYY') : '');
	        this.ui.stopDate.val(stopDate != undefined && stopDate != '' && !isNaN(stopDate) ? utils.longToDateTimeFormatted(stopDate, 'MM/DD/YYYY') : '');
	        this.ui.comment.val(data.model.get('comment'));
	    },
	
	    getAllExacerbations: function () {
	        var exacerbations = this.exacerbationsCollection.toJSON().map(function (exacerbation) {
	            return _.omit(exacerbation, 'id');
	        });
	        return exacerbations;
	    },
	
	    resetCollection: function (exacerbations) {
	        this.exacerbationsCollection.reset(exacerbations);
	    }
	
	});
	
	module.exports = ExacerbationsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td>'+
	((__t=( startDate ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( stopDate ))==null?'':__t)+
	'</td>\r\n<td class="col-md-3 col-xs-3">'+
	((__t=( comment ))==null?'':__t)+
	'</td>\r\n';
	 if (!isReadOnly) { 
	__p+='\r\n<td><span class="clickable glyphicon glyphicon glyphicon-pencil edit" title="Edit"></span></td>\r\n<td><span class="clickable glyphicon glyphicon-remove remove" title="Remove"></span></td>\r\n';
	 } 
	__p+='';
	}
	return __p;
	};


/***/ }),
/* 360 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<table class="table table-hover">\r\n    <thead>\r\n    <tr>\r\n        <th>Start date</th>\r\n        <th>Stop date</th>\r\n        <th>Comment</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody></tbody>\r\n</table>\r\n\r\n';
	 if (!isReadOnly) { 
	__p+='\r\n<button type="button" class="btn btn-primary btn-sm" id="e-new">New</button>\r\n<button type="button" class="btn btn-primary btn-sm" id="e-save">Add</button>\r\n\r\n<div id="edits" class="form-inline" style="margin-top: 10px;">\r\n    <div class="form-group">\r\n        <div class="col-sm-3 col-md-3">\r\n            <input class="form-control" type="text" id="e-start-date" placeholder="Start date"\r\n                   onkeypress="return false;">\r\n        </div>\r\n        <div class="col-sm-3 col-md-3">\r\n            <input class="form-control" type="text" id="e-stop-date" placeholder="Stop date"\r\n            onkeypress="return false;">\r\n        </div>\r\n        <div class="col-sm-6 col-md-6">\r\n            <textarea class="form-control" rows="3" cols="20" id="e-comment" placeholder="Comment"></textarea>\r\n        </div>\r\n    </div>\r\n</div>\r\n';
	 } 
	__p+='';
	}
	return __p;
	};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="modal fade" id="disease-form-modal" tabindex="-1" role="dialog" aria-labelledby="disease-form-modal">\r\n    <div class="modal-dialog ';
	 if (mode == 'add') { 
	__p+=' modal-lg ';
	 } 
	__p+=' " role="document">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\r\n                        aria-hidden="true">&times;</span></button>\r\n                <h4 class="modal-title">'+
	((__t=( title ))==null?'':__t)+
	'</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <div id="disease-loader" class="loader"></div>\r\n                <div class="row" style="min-height: 100%">\r\n                    <div class="col-md-6 inputs">\r\n                        <div class="form-horizontal">\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="type">Type of id</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="type" required readonly value="'+
	((__t=( _.isEmpty(typeOfId) ? 'ICD-10' : typeOfId ))==null?'':__t)+
	'">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="icd-code">ICD code</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="icd-code" required readonly\r\n                                           value="'+
	((__t=( diseaseId ))==null?'':__t)+
	'">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="name">ICD name</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="name" required readonly\r\n                                           value="'+
	((__t=( name ))==null?'':__t)+
	'">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="start-date">Start date</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="start-date" value="'+
	((__t=( startDate ))==null?'':__t)+
	'"\r\n                                           onkeypress="return false;">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="stop-date">Stop date</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="stop-date" value="'+
	((__t=( stopDate ))==null?'':__t)+
	'"\r\n                                           onkeypress="return false;">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="comment">Comment</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <textarea class="form-control" rows="5" cols="50"\r\n                                              id="comment">'+
	((__t=( comment ))==null?'':__t)+
	'</textarea>\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <div class="col-sm-11 col-md-11 col-xs-offset-1 col-sm-offset-1">\r\n                                    <a class="dotted-link" data-toggle="collapse" data-target="#exacerbations">\r\n                                        Exacerbations\r\n                                        <span class="caret"></span>\r\n                                    </a>\r\n                                    <div class="collapse" id="exacerbations">\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    ';
	 if (mode == 'add') { 
	__p+='\r\n                    <div class="col-md-6">\r\n                        <div class="form-horizontal">\r\n                            <div class="form-group col-xs-12 col-xs-12">\r\n                                <div class="input-group">\r\n                                    <input class="form-control" type="text" id="search-text"\r\n                                           placeholder="For search type at least 2 character and Enter"/>\r\n                                        <span class="input-group-btn">\r\n                                            <button class="form-control col-xs-1 col-xs-1 glyphicon glyphicon-search"\r\n                                                    id="search-button"></button>\r\n                                        </span>\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group col-xs-11 col-xs-11" style="height: 500px;overflow-y: auto;">\r\n                                <table id="search-results" class="table table-hover table-striped">\r\n                                    <thead>\r\n                                    <tr>\r\n                                        <th>Code</th>\r\n                                        <th>Name</th>\r\n                                    </tr>\r\n                                    </thead>\r\n                                    <tbody></tbody>\r\n                                </table>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    ';
	 } 
	__p+='\r\n                </div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\r\n                <button type="button" class="btn btn-primary" id="save">Save</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td hidden>'+
	((__t=( uuid ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( typeOfId ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( diseaseId ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( name ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( startDate ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( stopDate ))==null?'':__t)+
	'</td>\r\n<td class="col-md-3 col-xs-3">'+
	((__t=( comment ))==null?'':__t)+
	'</td>\r\n<td><div class="e-show center clickable" title="Show exacerbations"><b>...</b></div></td>\r\n<td><span class="clickable glyphicon glyphicon glyphicon-pencil edit" title="Edit"></span></td>\r\n<td><span class="clickable glyphicon glyphicon-remove remove" title="Remove"></span></td>';
	}
	return __p;
	};


/***/ }),
/* 363 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div id="content">\r\n    <h3 class="center">Diseases</h3>\r\n    ';
	 if (canEdit) { 
	__p+='\r\n    <div class="left-buttons">\r\n        <button type="button" class="btn btn-success" id="add">Add</button>\r\n    </div>\r\n    ';
	 } 
	__p+='\r\n    <div class="top-margined">\r\n        <table class="table table-hover">\r\n            <thead>\r\n            <tr>\r\n                <th hidden>UUID</th>\r\n                <th>Type of id</th>\r\n                <th>ICD code</th>\r\n                <th>ICD name</th>\r\n                <th>Start date</th>\r\n                <th>Stop date</th>\r\n                <th>Comment</th>\r\n                <th>Exacerbations</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody></tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n\r\n<div id="disease-form"></div>\r\n<div id="delete-confirmation-modal"></div>\r\n\r\n<!-- Exacerbation show modal -->\r\n<div class="modal fade" id="exacerbation-show-modal" tabindex="-1" role="dialog">\r\n    <div class="modal-dialog">\r\n\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal">&times;</button>\r\n                <h4 class="modal-title">Exacerbations</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <div id="exacerbation-show"></div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" id="close" data-dismiss="modal">Close</button>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	var DocumentsCollection = __webpack_require__(302);
	var OasisServices = __webpack_require__(365);
	
	var OasisServicesValidatesView = __webpack_require__(366);
	
	var Radio = __webpack_require__(183);
	var services = Radio.channel('services');
	var notificationsChannel = Radio.channel('notifications');
	var utils = new CommonUtils();
	
	var PatientDocumentsRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(368),
	
	    ui: {
	        checkBox: 'input[type=checkbox]'
	    },
	
	    events: {
	        'change @ui.checkBox': 'onCheck'
	    },
	
	    downloadedAndPreviewedColor: '#337ab7',
	
	    templateContext: function () {
	        var that = this;
	        var createdTime = that.model.get('createdTime');
	        return {
	            color: that.downloadedAndPreviewedColor,
	            fmCreatedTime: createdTime != undefined && createdTime != '' && !isNaN(createdTime) ? utils.longToDateTimeFormatted(createdTime, 'MM/DD/YYYY') : '-',
	            isOasisFile: that.isOasisFile(that.model)
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	    },
	
	    onRender: function () {
	
	    },
	
	    isOasisFile: function (model) {
	        var type = model.get('object').type || "";
	        return type.toLowerCase() == "xml" || type.toLowerCase() == "txt";
	    },
	
	    onCheck: function (event) {
	        if (event.target.checked) {
	            this.triggerMethod("document:selected", {
	                id: this.model.get("id"),
	                name: this.model.get("name")
	            });
	        } else {
	            this.triggerMethod("document:unselected", {
	                id: this.model.get("id"),
	                name: this.model.get("name")
	            });
	        }
	    }
	});
	
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(4), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var PatientDocumentsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: PatientDocumentsRowView,
	    emptyView: EmptyView,
	
	    collectionEvents: {},
	
	    childViewEvents: {
	        "document:selected": "onDocumentSelect",
	        "document:unselected": "onDocumentUnselect"
	    },
	
	    initialize: function (options) {
	        this.collection = options.collection;
	    },
	
	    childViewOptions: function () {
	        return {};
	    },
	
	    onDocumentSelect: function (data) {
	        this.triggerMethod("document:selected", data);
	    },
	
	    onDocumentUnselect: function (data) {
	        this.triggerMethod("document:unselected", data);
	    }
	});
	
	var PatientDocuments = Marionette.View.extend({
	    template: __webpack_require__(369),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        oasisValidatingModal: "#oasis-validating-modal"
	    },
	
	    ui: {
	        validateBtn: "#validate",
	        applyBtn: '#apply-validates',
	        oasisServiceInput: '.oasis-service'
	    },
	
	    events: {
	        "click @ui.applyBtn": "onValidatesApply",
	        'change @ui.oasisServiceInput': 'onOasisServiceSelected'
	    },
	
	    childViewEvents: {
	        "document:selected": "onDocumentSelect",
	        "document:unselected": "onDocumentUnselect"
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            canEdit: that.canEdit,
	            name: that.name,
	            oasisServicesList: OasisServices.getServicesList()
	        }
	    },
	
	
	    initialize: function (options) {
	        //_.bindAll(this, 'onRender', 'showLoading', 'hideLoading', 'logError');
	        this.medProfileModel = options.medProfileModel;
	        this.name = options.name;
	        var personId = this.medProfileModel.get('object').personId;
	        this.documentsCollection = new DocumentsCollection([], {
	            params: [
	                {key: 'sortby', value: 'createdTime'},
	                {key: 'sortdir', value: 'DESC'},
	                {key: 'object_patientId', value: personId}
	            ]
	        });
	
	        this.selectedDocumentsIdNames = [];
	        this.selectedOasisServices = [];
	    },
	
	    onRender: function () {
	        var that = this;
	        that.showLoading();
	        that.documentsCollection.fetch({
	            success: function () {
	                that.showChildView('body', new PatientDocumentsTableBody({
	                    collection: that.documentsCollection
	                }));
	                that.hideLoading();
	            },
	            error: function (e) {
	                that.logError(e);
	            }
	        });
	
	        that.ui.validateBtn.attr("disabled", true);
	        that.ui.applyBtn.addClass("disabled");
	    },
	
	    onDocumentSelect: function (data) {
	        this.selectedDocumentsIdNames.push(data);
	        this.changeValidateBtnAccess(this.selectedDocumentsIdNames);
	    },
	
	    onDocumentUnselect: function (data) {
	        this.selectedDocumentsIdNames = _.reject(this.selectedDocumentsIdNames, function (item) {
	            return item.id == data.id && item.name == data.name;
	        });
	        this.changeValidateBtnAccess(this.selectedDocumentsIdNames);
	    },
	
	    changeValidateBtnAccess: function (selectedDocumentsIdNames) {
	        if (selectedDocumentsIdNames.length == 0)
	            this.ui.validateBtn.attr("disabled", true);
	        else
	            this.ui.validateBtn.removeAttr("disabled");
	    },
	
	    onOasisServiceSelected: function (event) {
	        var checked = event.target.checked;
	        var oasisServiceId = event.target.id;
	
	        if (checked) {
	            this.selectedOasisServices.push(oasisServiceId);
	        } else {
	
	            this.selectedOasisServices = _.reject(this.selectedOasisServices, function (id) {
	                return id == oasisServiceId;
	            });
	        }
	
	        if (this.selectedOasisServices.length == 0) {
	            this.ui.applyBtn.addClass("disabled");
	        } else {
	            this.ui.applyBtn.removeClass("disabled");
	        }
	    },
	
	    onValidatesApply: function () {
	        this.showChildView("oasisValidatingModal", new OasisServicesValidatesView({
	            oasisServicesIds: this.selectedOasisServices,
	            documents: this.selectedDocumentsIdNames
	        }));
	    },
	
	    showLoading: function () {
	        utils.showSpinner();
	    },
	
	    hideLoading: function () {
	        utils.hideSpinner();
	    },
	
	    logError: function (error) {
	        utils.hideSpinner();
	        notificationsChannel.request('show:notification', JSON.parse(error));
	    }
	
	});
	
	module.exports = PatientDocuments;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var OasisServices = {
	
	    validatorScorerServices: [
	        {
	            id: 'pps-grouper',
	            name: 'PPS-GROUPER',
	            url: 'http://reviewandsign.info:8085/pps-grouper/score'
	        },
	        {
	            id: 'pps-plus',
	            name: 'PPS-PLUS',
	            url: 'http://reviewandsign.info:8085/pps-plus/analysis-pdf'
	        },
	        {
	            id: 'vut',
	            name: 'VUT',
	            url: 'http://reviewandsign.info:8085/vut/validate'
	        }
	    ],
	
	    getServicesList: function () {
	        return this.validatorScorerServices;
	    },
	
	    getServiceById: function (serviceId) {
	        var found = _.find(this.validatorScorerServices, function (service) {
	            return service.id == serviceId;
	        });
	
	        return found ? found : null;
	    }
	};
	
	module.exports = OasisServices;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	var OasisServices = __webpack_require__(365);
	
	var OasisServicesValidatesView = Marionette.View.extend({
	    template: __webpack_require__(367),
	
	    regions: {},
	
	    ui: {
	        modal: '#validates-modal'
	    },
	
	    events: {},
	
	    childViewEvents: {},
	
	    templateContext: function () {
	        var that = this;
	        return {
	            oasisServices: that.oasisServices,
	            documents: that.documents
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.utils = new CommonUtils();
	        that.oasisServicesIds = options.oasisServicesIds;
	        that.oasisServicesIds.sort();
	        that.documents = _.sortBy(options.documents || [], "name");
	        that.oasisServices = that.oasisServicesIds.map(function (id) {
	            return OasisServices.getServiceById(id)
	        });
	    },
	
	    onRender: function () {
	        var that = this;
	        that.show();
	        $(function () {
	            that.startValidatingCalls();
	        });
	    },
	
	    startValidatingCalls: function () {
	        var that = this;
	        that.documents.forEach(function (doc) {
	            that.oasisServices.forEach(function (service) {
	                that.showLoader(doc.id, service.id);
	            })
	        });
	
	        var documentContentGetCalls = that.documents.map(function (document) {
	            return $.ajax({
	                type: "GET",
	                url: '/api/document/view/' + document.id
	            })
	        });
	        $.when.apply(undefined, documentContentGetCalls).then(function () {
	            var responses = arguments;
	            if (documentContentGetCalls.length == 1) {
	                responses = {0: responses};
	            }
	
	            _.keys(responses).forEach(function (respKey, index) {
	                var documentId = that.documents[index].id;
	                var documentName = that.documents[index].name;
	                var oasisFileContent = responses[respKey][0];
	                that.callOasisServices(documentId, documentName, oasisFileContent, that.oasisServices);
	            });
	        });
	    },
	
	    callOasisServices: function (docId, documentName, oasisContent, oasisServices) {
	        var that = this;
	        oasisServices.forEach(function (service) {
	            var elementIdForResult = '#' + docId + "-" + service.id + "-results";
	            if (service.id == 'pps-grouper' || service.id == "vut") {
	
	                $.ajax({
	                    type: "POST",
	                    url: service.url,
	                    data: oasisContent,
	                    contentType: 'text/xml',
	                    statusCode: {
	                        200: function (response) {
	
	                            if (service.id == "vut") {
	                                that.renderVutResults($(elementIdForResult), response.results);
	                            } else if (service.id == 'pps-grouper') {
	                                that.renderPpsGrouperResults($(elementIdForResult), response);
	                            } else {
	                                $(elementIdForResult).text(JSON.stringify(response, null, '\t'));
	                                $(elementIdForResult).css("color", "black");
	                            }
	
	                            that.hideLoader(docId, service.id);
	                        }
	                    },
	                    error: function (e) {
	                        if (e.status == 400) {
	                            $(elementIdForResult).css("color", "red");
	                        } else {
	                            $(elementIdForResult).css("color", "yellow");
	                        }
	                        $(elementIdForResult).text(e.responseJSON.errorText);
	                        that.hideLoader(docId, service.id);
	                    }
	                });
	            } else if (service.id == 'pps-plus') {
	
	                $.ajax({
	                    type: "POST",
	                    url: service.url,
	                    data: oasisContent,
	                    contentType: "text/xml",
	                    xhrFields: {
	                        responseType: 'blob'
	                    },
	                    statusCode: {
	                        200: function (response) {
	
	                            var blob = new Blob([response], {type: "application/pdf"});
	                            var blobAsFile = window.URL.createObjectURL(blob);
	
	                            var linkToViewPdf = document.createElement('a');
	                            linkToViewPdf.href = blobAsFile;
	                            linkToViewPdf.target = '_blank';
	                            linkToViewPdf.setAttribute('view', documentName + '-pps-plus-validating-result.pdf');
	                            linkToViewPdf.appendChild(document.createTextNode("View PPS-PLUS validating result (PDF)"));
	                            $(elementIdForResult).append(linkToViewPdf);
	
	                            $(elementIdForResult).append(document.createElement('br'));
	
	                            var linkToDownloadPdf = document.createElement('a');
	                            linkToDownloadPdf.href = blobAsFile;
	                            linkToDownloadPdf.target = '_blank';
	                            linkToDownloadPdf.setAttribute('download', documentName + '-pps-plus-validating-result.pdf');
	                            linkToDownloadPdf.appendChild(document.createTextNode("Download PPS-PLUS validating result (PDF)"));
	                            $(elementIdForResult).append(linkToDownloadPdf);
	
	                            that.hideLoader(docId, service.id);
	                        }
	                    },
	                    error: function (e) {
	                        if (e.status == 400) {
	                            $(elementIdForResult).css("color", "red");
	                        } else {
	                            $(elementIdForResult).css("color", "yellow");
	                        }
	                        $(elementIdForResult).text(JSON.stringify(e.responseJSON, null, '\t'));
	                        that.hideLoader(docId, service.id);
	                    }
	                });
	
	            } else {
	                $(elementIdForResult).text(oasisContent);
	                that.hideLoader(docId, service.id);
	            }
	        });
	    },
	
	    renderVutResults: function (parent, results) {
	        var tableStart = '<table class="table table-hover">\n' +
	            '            <thead>\n' +
	            '            <tr>\n' +
	            '                <th>No.</th>\n' +
	            '                <th>Severity</th>\n' +
	            '                <th>Text</th>\n' +
	            '                <th>Item</th>\n' +
	            '            </tr>\n' +
	            '            </thead>\n' +
	            '            <tbody>';
	        var tableEnd = '</tbody>\n' +
	            '        </table>';
	
	        var trs = '';
	
	        results.forEach(function (item) {
	            var tr = '<tr><td>' + item.messageNumber + '</td><td>' + item.severity + '</td><td>' + item.text + '</td><td>' + item.item.replace('^', '') + '</td></tr>';
	            trs = trs + tr;
	        });
	        parent.html(tableStart + trs + tableEnd);
	    },
	
	    renderPpsGrouperResults: function (parent, results) {
	        var caption = '<div><b>Scoring result - </b>' + '<span class="label label-primary">' + results.validityFlagDescription + '</span>' + '</div>';
	        var table = '<table class="table table-hover"><tbody>' + results.validationEdits.map(function (ve) {
	            return '<tr><td>' + ve.oasisDataItem + '</td><td>' + ve.description + '</td></tr>';
	        }).join('') + '</tbody></table>';
	
	        parent.append(caption);
	        if (results.validationEdits.length > 0) {
	            parent.append("<br>");
	            parent.append(table);
	        }
	    },
	
	    show: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    },
	
	    showLoader: function (docId, serviceId) {
	        $('#' + docId + "-" + serviceId + "-results").hide();
	        $('#' + docId + "-" + serviceId + "-loader").show();
	    },
	
	    hideLoader: function (docId, serviceId) {
	        $('#' + docId + "-" + serviceId + "-results").show();
	        $('#' + docId + "-" + serviceId + "-loader").hide();
	    }
	});
	
	module.exports = OasisServicesValidatesView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- Document validate OASIS Modal -->\n<div class="modal fade" id="validates-modal" tabindex="-1" role="dialog" aria-labelledby="validates-modal">\n    <div class="modal-dialog modal-lg" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\n                        aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title">OASIS documents validating</h4>\n            </div>\n            <div class="modal-body">\n\n                <div id="oasis-validating-content" class="panel-group">\n                    ';
	 _.each(documents, function(document, index){ 
	__p+='\n                    <div class="panel panel-info">\n                        <div class="panel-heading">\n                            <h4 class="panel-title">\n                                <a data-toggle="collapse" data-parent="#oasis-validating-content" href="#'+
	((__t=( document.id ))==null?'':__t)+
	'">'+
	((__t=( document.name ))==null?'':__t)+
	'</a>\n                            </h4>\n                        </div>\n                        <div id="'+
	((__t=( document.id ))==null?'':__t)+
	'" class="panel-collapse collapse">\n                            <div class="panel-body">\n                                <div id="'+
	((__t=( ('oasis-validating-content-' + document.id) ))==null?'':__t)+
	'" class="panel-group">\n                                    ';
	 _.each(oasisServices, function(service, index){ 
	__p+='\n                                    <div class="panel panel-success">\n                                        <div class="panel-heading">\n                                            <h4 class="panel-title">\n                                                <a data-toggle="collapse" data-parent="'+
	((__t=( ('#oasis-validating-content-' + document.id) ))==null?'':__t)+
	'"\n                                                   href="#'+
	((__t=( document.id + '-' + service.id ))==null?'':__t)+
	'">'+
	((__t=( service.name ))==null?'':__t)+
	' validating results</a>\n                                            </h4>\n                                        </div>\n                                        <div id="'+
	((__t=( document.id + '-' + service.id ))==null?'':__t)+
	'" class="panel-collapse collapse">\n                                            <div class="panel-body">\n                                                <div id="'+
	((__t=( document.id + '-' + service.id + '-loader' ))==null?'':__t)+
	'" style="min-height: 100px;" class="loader-wo-blocking"></div>\n                                                <div id="'+
	((__t=( document.id + '-' + service.id + '-results' ))==null?'':__t)+
	'"></div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    ';
	 }) 
	__p+='\n                                </div></div>\n                        </div>\n                    </div>\n                    ';
	 }) 
	__p+='\n                </div>\n\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td>';
	 if (isOasisFile) { 
	__p+='<input type="checkbox" class="float-right"/>';
	 } 
	__p+='</td>\r\n<td><a href="/#document/'+
	((__t=( id ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( name ))==null?'':__t)+
	'</a></td>\r\n<td>'+
	((__t=( fmCreatedTime ))==null?'':__t)+
	'</td>\r\n<td>\r\n    <a href="/api/document/download/'+
	((__t=( id ))==null?'':__t)+
	'" class="preview-doc" style="color:'+
	((__t=( color ))==null?'':__t)+
	';"><span class="clickable glyphicon glyphicon-floppy-disk"/></a>\r\n</td>\r\n<td>\r\n    <a href="/api/document/view/'+
	((__t=( id ))==null?'':__t)+
	'" target="_blank" class="preview-doc" style="color:'+
	((__t=( color ))==null?'':__t)+
	';"><span class="clickable glyphicon glyphicon-eye-open"/></a>\r\n</td>';
	}
	return __p;
	};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\r\n    <h3 class="center">Documents</h3>\r\n    <div class="top-margined">\r\n        <table class="table table-hover">\r\n            <thead>\r\n            <tr>\r\n                <th></th>\r\n                <th>Name</th>\r\n                <th>Created date</th>\r\n                <th>Download</th>\r\n                <th>View</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody></tbody>\r\n        </table>\r\n        <div class="container">\r\n            <div class="row">\r\n                <div class="col-lg-12">\r\n                    <div class="button-group">\r\n                        <button type="button" class="btn btn-success dropdown-toggle" id="validate"\r\n                                data-toggle="dropdown">Validate (and/or Score) <span class="caret"></span></button>\r\n                        <ul class="dropdown-menu">\r\n                            ';
	 _.each(oasisServicesList, function(service){ 
	__p+='\r\n                                <li>\r\n                                    <a class="small" data-value="'+
	((__t=( service.id ))==null?'':__t)+
	'" tabIndex="-1">\r\n                                    <input type="checkbox" id="'+
	((__t=( service.id ))==null?'':__t)+
	'" class="oasis-service"/>&nbsp;'+
	((__t=( service.name ))==null?'':__t)+
	'\r\n                                    </a>\r\n                                </li>\r\n                            ';
	 }) 
	__p+='\r\n                            <span id="apply-validates" class="label label-primary clickable dropdown-menu-item" style="margin-left: 50px;">Apply</span>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div id="oasis-validating-modal"></div>\r\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	
	var DeterminationOfNeedRevisedView = Marionette.View.extend({
	    template: __webpack_require__(371),
	
	    ui: {
	        comment: '.donr-comment',
	        levelOfImpairmentInfo: '#level-of-impairment-info',
	        unmetNeedForCareInfo: '#unmet-need-for-care-info'
	    },
	
	    events: {
	        'change @ui.comment': 'onCommentChanged',
	        'click .loi a': 'onLoiRadioButtonsClick',
	        'click .unfc a': 'onUnfcRadioButtonsClick'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            rows: that.determinationOfNeedRevised,
	            calculateSum: that.calculateSum
	        }
	    },
	
	
	    initialize: function (options) {
	        this.determinationOfNeedRevised = options.determinationOfNeedRevised;
	        this.isEditMode = options.isEditMode;
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	        var that = this;
	        this.ui.levelOfImpairmentInfo.popover({html: true});
	        this.ui.unmetNeedForCareInfo.popover({html: true});
	    },
	    
	    onLoiRadioButtonsClick: function (event) {
	        this.changeScore(event, "levelOfImpairment");
	    },
	
	    onUnfcRadioButtonsClick: function (event) {
	        this.changeScore(event, "unmetNeedForCare");
	    },
	
	    changeScore: function(event, field) {
	        if (!this.isEditMode)
	            return;
	
	        var target = $(event.target);
	        var value = target.data('title');
	
	        target.parent().find('a').not('[data-title="' + value + '"]').removeClass('active').addClass('notActive');
	        target.removeClass('notActive').addClass('active');
	
	        var rowId = $(event.target).closest('tr').attr('id');
	        this.determinationOfNeedRevised[rowId][field] = value;
	        this.triggerMethod('changed-don-r');
	        this.recalculateTotals();
	    },
	
	    onCommentChanged: function (event) {
	        var rowId = $(event.target).closest('tr').attr('id');
	        this.determinationOfNeedRevised[rowId].comment = event.target.value;
	        this.triggerMethod('changed-don-r');
	    },
	
	    calculateSum: function (column, start, stop, rows) {
	        var sum = 0;
	        for (var rowId = start; rowId <= stop; rowId++){
	            sum += rows[rowId][column];
	        }
	        return sum;
	    },
	
	    recalculateTotals: function () {
	        var that = this;
	        this.determinationOfNeedRevised.filter(function (row) {
	            return !row.editable;
	        }).forEach(function (row) {
	            row.levelOfImpairment = that.calculateSum('levelOfImpairment', row.start, row.stop, that.determinationOfNeedRevised);
	            row.unmetNeedForCare = that.calculateSum('unmetNeedForCare', row.start, row.stop, that.determinationOfNeedRevised);
	            var index = that.determinationOfNeedRevised.indexOf(row);
	            $('#levelOfImpairment-' + index).html(row.levelOfImpairment);
	            $('#unmetNeedForCare-' + index).html(row.unmetNeedForCare);
	        } )
	    }
	});
	
	module.exports = DeterminationOfNeedRevisedView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\r\n<table class="table table-hover well">\r\n    <thead>\r\n    <tr>\r\n        <th>Function</th>\r\n        <th>\r\n            Level of Impairment\r\n            <a id="level-of-impairment-info" tabindex="0" role="button" data-toggle="popover"\r\n               data-trigger="focus" title="Level of Impairment Info" data-container="body"\r\n               data-content="\r\n                    <div align=\'left\'>\r\n                    <b>Score 0</b> - performs or can perform all essential components of the activity,\r\n                    with or without an assistive device, such that:\r\n                    <ul>\r\n                    <li> No significant impairment of functions remains</li>\r\n                    <li> Activity is not required by the client</li>\r\n                    <li> Client may benefit from but does not require verbal or physical assistance </li>\r\n                    </ul>\r\n\r\n                    <b>Score 1</b> - performs or can perform most essential components of the activity,\r\n                    with or without an assistive device, but some impairment of the function remains such\r\n                    that client requires some verbal or physical assistance in some or all components of the activity.\r\n                    This includes clients who:\r\n                    <ul>\r\n                    <li>Experience minor, intermittent fatigue in performing the activity or</li>\r\n                    <li>Take longer that would be required for an unimpaired person</li>\r\n                    <li>Require some verbal prompting to complete the task</li>\r\n                    </ul>\r\n\r\n                    <b>Score 2</b> - can not perform most of the essential components of the activity,\r\n                    even with assistive device, and /or requires a great deal of verbal or physical assistance\r\n                    to accomplish the activity. This includes clients who:\r\n                    <ul>\r\n                    <li>Experience frequent fatigue or minor exertion in performing the activity</li>\r\n                    <li>Take an excessive amount of time to perform the activity</li>\r\n                    <li>Must perform the activity much more frequently then an unimpaired person</li>\r\n                    <li>Requires frequent verbal prompting to complete the task</li>\r\n                    </ul>\r\n\r\n                    <b>Score 3</b> - can not perform the activity and requires someone else to perform the task,\r\n                    although applicant may be able to assist in small ways; or requires constant physical assistance\r\n                    </div>\r\n                ">\r\n                <span class="glyphicon glyphicon-question-sign"></span>\r\n            </a>\r\n        </th>\r\n        <th>\r\n            Unmet Need for Care\r\n            <a id="unmet-need-for-care-info" tabindex="0" role="button" data-toggle="popover"\r\n               data-trigger="focus" title="Unmet Need for Care Info" data-container="body"\r\n               data-content="\r\n                    <div align=\'left\'>\r\n                    <b>Score 0</b> - the applicant\'s need for assistance is met to the extent that the applicant is at no risk\r\n                    to health or safety if additional assistance is not acquired; or the applicant has no need for assistance;\r\n                    or additional assistance will not benefit the applicant;\r\n                    <br/>\r\n                    <br/>\r\n\r\n                    <b>Score 1</b> - This applicant\'s need for assistance is met most of the time, or there is minimal\r\n                    risk to the health and safety of the applicant if additional assistance is not acquired\r\n                    <br/>\r\n                    <br/>\r\n\r\n                    <b>Score 2</b> - This applicant\'s need for assistance is not met most of the time, or there is moderate\r\n                    risk to the health and safety of the applicant if additional assistance is not acquired\r\n                    <br/>\r\n                    <br/>\r\n\r\n                    <b>Score 3</b> - This applicant\'s need for assistance is seldom or never met, or there is severe\r\n                    risk to the health and safety of the applicant that would require acute medical intervention if\r\n                    assistance is not acquired\r\n                    </div>\r\n                ">\r\n                <span class="glyphicon glyphicon-question-sign"></span>\r\n            </a>\r\n        </th>\r\n        <th>Comments</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    ';
	 _.each(rows, function(row, index){ 
	__p+='\r\n    <tr id="'+
	((__t=( index ))==null?'':__t)+
	'">\r\n        <td>'+
	((__t=( "" + (index + 1) + ". " + row.function ))==null?'':__t)+
	'</td>\r\n        <td>\r\n            ';
	 if (row.editable) { 
	__p+='\r\n            <div class="btn-group loi">\r\n                <a class="btn btn-primary btn-sm ';
	 if (row.levelOfImpairment == 0) { 
	__p+=' active ';
	 } else { 
	__p+=' notActive ';
	 } 
	__p+='" data-title="0">Score 0</a>\r\n                <a class="btn btn-primary btn-sm ';
	 if (row.levelOfImpairment == 1) { 
	__p+=' active ';
	 } else { 
	__p+=' notActive ';
	 } 
	__p+='" data-title="1">1</a>\r\n                <a class="btn btn-primary btn-sm ';
	 if (row.levelOfImpairment == 2) { 
	__p+=' active ';
	 } else { 
	__p+=' notActive ';
	 } 
	__p+='" data-title="2">2</a>\r\n                <a class="btn btn-primary btn-sm ';
	 if (row.levelOfImpairment == 3) { 
	__p+=' active ';
	 } else { 
	__p+=' notActive ';
	 } 
	__p+='" data-title="3">3</a>\r\n            </div>\r\n            ';
	 } 
	__p+='\r\n            ';
	 if (!row.editable) { 
	__p+='\r\n                <div id="levelOfImpairment-'+
	((__t=( index ))==null?'':__t)+
	'">'+
	((__t=( calculateSum('levelOfImpairment', row.start, row.stop, rows) ))==null?'':__t)+
	'</div>\r\n            ';
	 } 
	__p+='\r\n        </td>\r\n        <td>\r\n            ';
	 if (row.editable) { 
	__p+='\r\n            <div class="btn-group unfc">\r\n                <a class="btn btn-primary btn-sm ';
	 if (row.unmetNeedForCare == 0) { 
	__p+=' active ';
	 } else { 
	__p+=' notActive ';
	 } 
	__p+='" data-title="0">Score 0</a>\r\n                <a class="btn btn-primary btn-sm ';
	 if (row.unmetNeedForCare == 1) { 
	__p+=' active ';
	 } else { 
	__p+=' notActive ';
	 } 
	__p+='" data-title="1">1</a>\r\n                <a class="btn btn-primary btn-sm ';
	 if (row.unmetNeedForCare == 2) { 
	__p+=' active ';
	 } else { 
	__p+=' notActive ';
	 } 
	__p+='" data-title="2">2</a>\r\n                <a class="btn btn-primary btn-sm ';
	 if (row.unmetNeedForCare == 3) { 
	__p+=' active ';
	 } else { 
	__p+=' notActive ';
	 } 
	__p+='" data-title="3">3</a>\r\n            </div>\r\n            ';
	 } 
	__p+='\r\n            ';
	 if (!row.editable) { 
	__p+='\r\n                <div id="unmetNeedForCare-'+
	((__t=( index ))==null?'':__t)+
	'">'+
	((__t=( calculateSum('unmetNeedForCare', row.start, row.stop, rows) ))==null?'':__t)+
	'</div>\r\n            ';
	 } 
	__p+='\r\n        </td>\r\n        <td>\r\n            <textarea class="form-control donr-comment" rows="1">'+
	((__t=( row.comment ))==null?'':_.escape(__t))+
	'</textarea>\r\n        </td>\r\n    </tr>\r\n    ';
	 }) 
	__p+='\r\n    <tr>\r\n        <td></td>\r\n        <td></td>\r\n        <td></td>\r\n    </tr>\r\n\r\n    </tbody>\r\n</table>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	var PersonsCollection = __webpack_require__(210);
	
	var Radio = __webpack_require__(183);
	var services = Radio.channel('services');
	var notificationsChannel = Radio.channel('notifications');
	var utils = new CommonUtils();
	
	var PatientSourcesRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(373),
	
	    ui: {
	        merge: '.merge'
	    },
	
	    events: {
	        'click @ui.merge': 'onMergeClick'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var createdTime = that.model.get('createdTime');
	        return {
	            canEdit: that.canEdit,
	            fmCreatedTime: createdTime != undefined && createdTime != '' && !isNaN(createdTime)
	                ? utils.longToDateTimeFormatted(createdTime, "MM/DD/YYYY hh:mm A") : '-'
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	        this.canEdit = options.canEdit;
	    },
	
	    onRender: function () {
	
	    },
	
	    onMergeClick: function (event) {
	        this.triggerMethod('on:merge', {
	            selectedId: event.target.id
	        });
	    }
	});
	
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(3), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var PatientSourcesTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: PatientSourcesRowView,
	    emptyView: EmptyView,
	
	    collectionEvents: {},
	
	    childViewEvents: {
	        'on:merge': 'onMerge'
	    },
	
	    initialize: function (options) {
	        this.collection = options.collection;
	        this.canEdit = options.canEdit;
	    },
	
	    childViewOptions: function () {
	        return {
	            canEdit: this.canEdit
	        };
	    },
	
	    onMerge: function (data) {
	        this.triggerMethod('on:merge', data);
	    }
	});
	
	var PatientSources = Marionette.View.extend({
	    template: __webpack_require__(374),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        }
	    },
	
	    ui: {},
	
	    events: {},
	
	    childViewEvents: {
	        'on:merge': 'onMerge'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            canEdit: that.canEdit,
	            name: that.name
	        }
	    },
	
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'showLoading', 'hideLoading', 'logError');
	        this.medProfileModel = options.medProfileModel;
	        this.name = options.name;
	        this.canEdit = options.canEdit;
	        var personId = this.medProfileModel.get('object').personId;
	        this.personsCollection = new PersonsCollection([], {
	            params: [
	                {key: 'sortby', value: 'createdTime'},
	                {key: 'sortdir', value: 'DESC'},
	                {key: 'active', value: 'true'},
	                {key: 'active', value: 'false'},
	                {key: 'object_mergeableTo', value: personId}
	            ]
	        });
	    },
	
	    onRender: function () {
	        var that = this;
	        that.showLoading();
	        that.personsCollection.fetch({
	            success: function () {
	                that.showChildView('body', new PatientSourcesTableBody({
	                    collection: that.personsCollection,
	                    canEdit: that.canEdit
	                }));
	                that.hideLoading();
	            },
	            error: function (e) {
	                that.logError(e);
	            }
	        });
	    },
	
	    onMerge: function (data) {
	        var mergeTo = this.medProfileModel.get('object').personId;
	        var mergeFrom = data.selectedId;
	
	        if (_.isEmpty(mergeTo) || _.isEmpty(mergeFrom))
	            return;
	
	        Backbone.history.navigate('merge-persons/' + mergeTo + '/' + mergeFrom, {trigger: true});
	    },
	
	    showLoading: function () {
	        utils.showSpinner();
	    },
	
	    hideLoading: function () {
	        utils.hideSpinner();
	    },
	
	    logError: function (error) {
	        utils.hideSpinner();
	        notificationsChannel.request('show:notification', JSON.parse(error));
	    }
	
	});
	
	module.exports = PatientSources;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td><a href="/#person/'+
	((__t=( id ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( name ))==null?'':__t)+
	'</a></td>\r\n<td>'+
	((__t=( fmCreatedTime ))==null?'':__t)+
	'</td>\r\n';
	 if (canEdit) { 
	__p+='\r\n<td>\r\n    <i class="fa fa-compress clickable merge" aria-hidden="true" id="'+
	((__t=( id ))==null?'':__t)+
	'"></i>\r\n</td>\r\n';
	 } 
	__p+='';
	}
	return __p;
	};


/***/ }),
/* 374 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\r\n    <h3 class="center">Sources</h3>\r\n    <div class="top-margined">\r\n        <table class="table table-hover">\r\n            <thead>\r\n            <tr>\r\n                <th>Name</th>\r\n                <th>Created time</th>\r\n                ';
	 if (canEdit) { 
	__p+='\r\n                <th>Merge</th>\r\n                ';
	 } 
	__p+='\r\n            </tr>\r\n            </thead>\r\n            <tbody></tbody>\r\n        </table>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var services = Radio.channel('services');
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var PatientImmunizationsRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(376),
	
	    ui: {},
	
	    events: {},
	
	    templateContext: function () {
	        var that = this;
	        var dateAdministeredOfVaccine = that.model.get('dateAdministeredOfVaccine');
	        var doseQuantityValue = that.model.get('doseQuantityValue');
	        return {
	            canEdit: that.canEdit,
	            vaccineAdministeredDate: dateAdministeredOfVaccine != undefined && dateAdministeredOfVaccine != ''
	            && !isNaN(dateAdministeredOfVaccine) && dateAdministeredOfVaccine != 0
	                ? that.utils.longToDateTimeFormatted(dateAdministeredOfVaccine, "MM/DD/YYYY") : '-',
	            doseQuantityValue: doseQuantityValue == 0 ? '-' : doseQuantityValue
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	        this.canEdit = options.canEdit;
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	
	    }
	});
	
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(4), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var PatientImmunizationsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: PatientImmunizationsRowView,
	    emptyView: EmptyView,
	
	    collectionEvents: {},
	
	    childViewEvents: {},
	
	    initialize: function (options) {
	        this.collection = options.collection;
	        this.canEdit = options.canEdit;
	    },
	
	    childViewOptions: function () {
	        return {
	            canEdit: this.canEdit
	        };
	    }
	});
	
	var PatientImmunizations = Marionette.View.extend({
	        template: __webpack_require__(377),
	
	        regions: {
	            body: {
	                el: 'tbody',
	                replaceElement: true
	            }
	        },
	
	        ui: {
	            sortable: '.sortable',
	            updateBtn: '#update-from-grits'
	        },
	
	        events: {
	            'click @ui.sortable': 'headerSorting',
	            'click @ui.updateBtn': 'onUpdateFromGrits'
	        },
	
	        childViewEvents: {},
	
	        templateContext: function () {
	            var that = this;
	            return {
	                canEdit: that.canEdit,
	                name: that.name
	            }
	        },
	
	        initialize: function (options) {
	            this.medProfileModel = options.medProfileModel;
	            this.patient = _.omit(options.patient, "@class");
	            this.name = options.name;
	            this.canEdit = options.canEdit;
	            this.collection = new Backbone.Collection(this.medProfileModel.get('object').immunizations);
	
	            this.utils = new CommonUtils();
	        },
	
	        onRender: function () {
	            var that = this;
	            that.showChildView('body', new PatientImmunizationsTableBody({
	                collection: that.collection,
	                canEdit: that.canEdit
	            }));
	
	            window.setTimeout(function () {
	                that.asyncImmunizationsRequests(that.collection, that.patient);
	            }, 0);
	        },
	
	        asyncImmunizationsRequests: function (collection, patient) {
	            var that = this;
	            Constants.immunizationAddresses.forEach(function (address) {
	                var url = address.url;
	                var method = address.method;
	
	                that.showLoading();
	                $.ajax({
	                    type: method,
	                    url: url,
	                    data: JSON.stringify(patient),
	                    contentType: 'application/json',
	                    statusCode: {
	                        200: function (immnunizations) {
	                            if (_.isArray(immnunizations)) {
	                                var isNewExists = false;
	                                immnunizations.forEach(function (immnunization) {
	                                    if (that.isMedProfileNotContains(immnunization)) {
	                                        collection.add(new Backbone.Model(immnunization));
	                                        that.addToMedProfile(immnunization);
	                                        isNewExists = true;
	                                    }
	                                });
	                                if (isNewExists) {
	                                    that.saveMedProfile();
	                                }
	                            }
	                            that.hideLoading();
	                        },
	                        503: function (e) {
	                            notificationsChannel.request('show:notification', e.responseJSON);
	                            that.hideLoading();
	                        },
	                        401: function (e) {
	                            actionsChannel.request("redirect:to:login");
	                            that.hideLoading();
	                        }
	                    },
	                    error: function (e) {
	                        that.hideLoading();
	                        console.log(e);
	                    }
	                });
	            });
	        },
	
	        isMedProfileNotContains: function (immnunization) {
	            var that = this;
	            return (that.medProfileModel.get('object').immunizations || []).filter(function (immun) {
	                    return _.isEqual(_.omit(immun, 'uuid'), _.omit(immnunization, 'uuid'));
	                }).length == 0;
	        },
	
	        addToMedProfile: function (immnunization) {
	            var that = this;
	            if (that.medProfileModel.get('object').immunizations == null)
	                that.medProfileModel.get('object').immunizations = [];
	            that.medProfileModel.get('object').immunizations.push(immnunization);
	        },
	
	        saveMedProfile: function () {
	            var that = this;
	
	            that.medProfileModel.save(that.medProfileModel.toJSON(), {
	                success: function () {
	                },
	                error: function (model, xhr, options) {
	                    notificationsChannel.request('show:notification', JSON.parse(xhr.responseText));
	                }
	            });
	        },
	
	        headerSorting: function (event) {
	            var sortField = event.target.id;
	            var byAsc = $(event.target).children('div').hasClass('glyphicon-triangle-bottom');
	
	            this.ui.sortable.each(function () {
	                $(this).children('div').removeClass('glyphicon glyphicon-triangle-bottom');
	                $(this).children('div').removeClass('glyphicon glyphicon-triangle-top');
	            });
	            if (byAsc)
	                $(event.target).children('div').addClass('glyphicon glyphicon-triangle-top');
	            else
	                $(event.target).children('div').addClass('glyphicon glyphicon-triangle-bottom');
	
	            this.collection.comparator = function (model1, model2) {
	                if (byAsc)
	                    return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? 1 : -1;
	                else
	                    return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? -1 : 1;
	            };
	            this.collection.sort();
	        },
	
	        showLoading: function () {
	            this.utils.showSpinner();
	        },
	
	        hideLoading: function () {
	            this.utils.hideSpinner();
	        },
	
	        onUpdateFromGrits: function () {
	            this.asyncImmunizationsRequests(this.collection, this.patient);
	        }
	
	    })
	;
	
	module.exports = PatientImmunizations;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td>'+
	((__t=( vaccineName ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( vaccineCode ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( vaccineCodeSystemName ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( vaccineAdministeredDate ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( doseQuantityValue ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( doseQuantityUnit ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( routeName ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( manufacturerName ))==null?'':__t)+
	'</td>';
	}
	return __p;
	};


/***/ }),
/* 377 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\r\n    <h3 class="center">Immunizations</h3>\r\n    <div class="top-margined">\r\n        <div class="left-buttons">\r\n            <button type="button" class="btn btn-success" id="update-from-grits">Update from GRITS</button>\r\n        </div>\r\n        <table class="table table-hover">\r\n            <thead>\r\n            <tr>\r\n                <th class="clickable sortable" id="vaccineName">Vaccine name <div></div></th>\r\n                <th class="clickable sortable" id="vaccineCode">Vaccine code <div></div></th>\r\n                <th class="clickable sortable" id="vaccineCodeSystemName">Code system name <div></div></th>\r\n                <th class="clickable sortable" id="dateAdministeredOfVaccine">Administered date <div></div></th>\r\n                <th class="clickable sortable" id="doseQuantityValue">Dose amount <div></div></th>\r\n                <th class="clickable sortable" id="doseQuantityUnit">Dose unit <div></div></th>\r\n                <th class="clickable sortable" id="routeName">Route name <div></div></th>\r\n                <th class="clickable sortable" id="manufacturerName">Manufacturer name <div></div></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody></tbody>\r\n        </table>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var services = Radio.channel('services');
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var CommonUtils = __webpack_require__(189);
	
	var PatientDicomRow = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(379),
	    templateContext: function () {
	        var that = this;
	        var studyDateTime = that.model.get('date');
	        console.log(that.model.get('physicianName'));
	        return {
	            studyId: that.model.get('id'),
	            physicianName: that.model.get('physicianName'),
	            studyDate: !_.isNaN(studyDateTime) && !_.isNull(studyDateTime) && studyDateTime != '' ? that.untils.longToDateTimeFormatted(studyDateTime, "MM/DD/YYYY mm:hh") : '-'
	        }
	    },
	    initialize: function () {
	        this.untils = new CommonUtils();
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(3), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var PatientDicomsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: PatientDicomRow,
	    emptyView: EmptyView,
	
	    collectionEvents: {},
	
	    childViewEvents: {},
	
	    initialize: function (options) {
	        this.collection = options.collection;
	    },
	
	});
	
	var PatientDicoms = Marionette.View.extend({
	    template: __webpack_require__(380),
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        }
	    },
	    initialize: function (options) {
	        this.patient = _.omit(options.patient, "@class");
	        this.name = options.name;
	        this.collection = new Backbone.Collection();
	    },
	
	    onRender: function () {
	        var that = this;
	        that.showChildView('body', new PatientDicomsTableBody({
	            collection: that.collection
	        }));
	
	        that.asyncDicomsRequests(that.collection, that.patient);
	    },
	
	    asyncDicomsRequests: function (collection, patient) {
	        $.ajax({
	            type: "get",
	            url: "/api/dicom/" + patient.login,
	            statusCode: {
	                200: function (studies) {
	                    console.log(studies);
	                    if (_.isArray(studies)) {
	                        studies.forEach(function (study) {
	                            collection.add(new Backbone.Model(study));
	                        });
	                    }
	                },
	                503: function (e) {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                },
	                401: function (e) {
	                    actionsChannel.request("redirect:to:login");
	                }
	            },
	            error: function (e) {
	                console.log(e);
	            }
	        });
	    }
	});
	
	module.exports = PatientDicoms;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td>'+
	((__t=( studyDate ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( physicianName))==null?'':__t)+
	'</td>\n<td class="center">\n    <a href="/api/dicom/'+
	((__t=( serverId ))==null?'':__t)+
	'/'+
	((__t=( studyId ))==null?'':__t)+
	'"><span class="clickable glyphicon glyphicon-floppy-disk"/></a>\n</td>';
	}
	return __p;
	};


/***/ }),
/* 380 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\n    <h3 class="center">Studies</h3>\n    <div class="top-margined">\n        <table class="table table-hover">\n            <thead>\n            <tr>\n                <th>Study date</th>\n                <th>Physician Name</th>\n                <th>Download dicom</th>\n            </tr>\n            </thead>\n            <tbody></tbody>\n        </table>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	var VitalsForm = __webpack_require__(382);
	
	var Radio = __webpack_require__(183);
	var services = Radio.channel('services');
	var notificationsChannel = Radio.channel('notifications');
	var utils = new CommonUtils();
	
	var PatientVitalsRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(384),
	
	    ui: {
	        edit: '.edit',
	        remove: '.remove'
	    },
	
	    events: {
	        'click @ui.edit': 'onEdit',
	        'click @ui.remove': 'onRemove'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var time = that.model.get('time');
	        return {
	            canEdit: that.canEdit,
	            status: that.model.get('status'),
	            time: time != undefined && time != '' && !isNaN(time)
	                ? utils.longToDateTimeFormatted(time, "MM/DD/YYYY hh:mm A") : '-'
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	    },
	
	    onRender: function () {
	    },
	
	    onEdit: function() {
	        this.triggerMethod('edit:vital', {model: this.model});
	    },
	
	    onRemove: function() {
	        this.triggerMethod('remove:vital', {model: this.model});
	    }
	});
	
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(1), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var PatientVitalsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: PatientVitalsRowView,
	    emptyView: EmptyView,
	
	    collectionEvents: {},
	
	    childViewEvents: {
	        'remove:vital': 'removeVital',
	        'edit:vital': 'editVital'
	    },
	
	    initialize: function (options) {
	        this.collection = options.collection;
	    },
	
	    childViewOptions: function () {
	        return {
	        };
	    },
	
	    removeDisease: function(data) {
	        this.triggerMethod('remove:vital', data);
	    },
	
	    editVital: function(data) {
	        this.triggerMethod('edit:vital', data);
	    }
	});
	
	var PatientVitals = Marionette.View.extend({
	    template: __webpack_require__(385),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        vitalsForm: '#vital-form'
	    },
	
	    ui: {
	        addVital: '#add',
	    },
	
	    events: {
	        'click @ui.addVital': 'addNewVital',
	
	    },
	
	    childViewEvents: {
	        'new:vital': 'saveNewVital',
	        'update:vital': 'updateVital',
	        'remove:vital': 'removeVital',
	        'delete:confirmed': 'deleteConfirmed',
	        'edit:vital': 'editVital'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            canEdit: that.canEdit,
	            name: that.name
	        }
	    },
	
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'showLoading', 'hideLoading', 'logError');
	        this.medProfileModel = options.medProfileModel;
	        this.name = options.name;
	        this.canEdit = options.canEdit;
	      //  var personId = this.medProfileModel.get('object').personId;
	        this.collection = new Backbone.Collection(this.medProfileModel.get('object').vitals);
	    },
	
	    onRender: function () {
	        var that = this;
	
	        var vitals = that.medProfileModel.get('object').vitals;
	        this.vitalsCollection = new Backbone.Collection(vitals);
	        this.showChildView('body', new PatientVitalsTableBody({
	            collection: this.vitalsCollection
	        }));
	    },
	
	    addNewVital: function () {
	        this.showChildView('vitalsForm', new VitalsForm({
	            mode: 'add',
	            vital: {}
	        }));
	    },
	
	    editVital: function (data) {
	        this.showChildView('vitalsForm', new VitalsForm({
	            mode: 'edit',
	            vital: data.model.toJSON(),
	            servicesAddresses: this.servicesAddresses
	        }));
	    },
	
	    saveNewVital: function (vital) {
	        var that = this;
	        utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/medprofile/' + this.medProfileModel.get('id') + '/vital',
	            data: JSON.stringify(vital),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    utils.hideSpinner();
	                    that.medProfileModel = new MedProfileModel(response);
	                    that.vitalsCollection.reset(that.medProfileModel.get('object').vitals);
	                }
	            },
	            error: function(e) {
	                notificationsChannel.request('show:notification', e.responseJSON);
	                utils.hideSpinner();
	            }
	        });
	    },
	
	    updateVital: function(vital) {
	        var that = this;
	        utils.showSpinner();
	        $.ajax({
	            type: "PUT",
	            url: '/api/medprofile/' + this.medProfileModel.get('id') + '/vital',
	            data: JSON.stringify(vital),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    utils.hideSpinner();
	                    that.medProfileModel = new MedProfileModel(response);
	                    that.vitalsCollection.reset(that.medProfileModel.get('object').vitals);
	                }
	            },
	            error: function(e) {
	                notificationsChannel.request('show:notification', e.responseJSON);
	                utils.hideSpinner();
	            }
	        });
	    },
	
	    deleteConfirmed: function(value) {
	        if (value == true) {
	            var that = this;
	            var uuid = that.delModel.get('uuid');
	            utils.showSpinner();
	            $.ajax({
	                type: "DELETE",
	                url: '/api/medprofile/' + this.medProfileModel.get('id') + '/vital/' + uuid,
	                statusCode: {
	                    200: function (response) {
	                        utils.hideSpinner();
	                        that.medProfileModel = new MedProfileModel(response);
	                        that.vitalsCollection.reset(that.medProfileModel.get('object').vitals);
	                    }
	                },
	                error: function (e) {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                    utils.hideSpinner();
	                }
	            });
	        }
	    },
	
	    removeVital: function (data) {
	        this.delModel = data.model;
	        this.deleteConfirmationModal =
	            new DeleteConfirmationModal({
	                message: 'Enter: "confirm" if you agree to remove the vital.',
	                confirmationAnswer: 'confirm'
	            });
	        this.showChildView('deleteConfirmationModal', this.deleteConfirmationModal);
	        this.deleteConfirmationModal.show();
	    },
	/*
	    onMerge: function (data) {
	        var mergeTo = this.medProfileModel.get('object').personId;
	        var mergeFrom = data.selectedId;
	
	        if (_.isEmpty(mergeTo) || _.isEmpty(mergeFrom))
	            return;
	
	        Backbone.history.navigate('merge-persons/' + mergeTo + '/' + mergeFrom, {trigger: true});
	    },*/
	
	    showLoading: function () {
	        utils.showSpinner();
	    },
	
	    hideLoading: function () {
	        utils.hideSpinner();
	    },
	
	    logError: function (error) {
	        utils.hideSpinner();
	        notificationsChannel.request('show:notification', JSON.parse(error));
	    }
	
	});
	
	module.exports = PatientVitals;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	var Dicts = __webpack_require__(193);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var VitalsForm = Marionette.View.extend({
	    template: __webpack_require__(383),
	    ui: {
	        formModal: '#vital-form-modal',
	        save: '#save',
	        time: '#time',
	        status: '#status',
	        pbStatus: "#pbStatus",
	        pbTime: "#pbTime",
	        pbValueType: "#pbValueType",
	        pbValue: "#pbValue",
	        pbValueUnit: "#pbValueUnit",
	
	        leftSide: '.inputs'
	    },
	
	    events: {
	        'click @ui.save': 'saveVital',
	        'keyup input[required]': 'validate',
	        'change input[required]': 'validate'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            title: that.mode == 'add' ? 'Add vital' : 'Edit vital',
	            mode: that.mode,
	            status: that.status,
	            time: (that.vital.time == '' || that.vital.time == null || that.vital.time == 0
	                ? '' : that.utils.longToDateTimeFormatted(Number(that.vital.time), 'MM/DD/YYYY hh:mm A'))/*,
	
	            pbStatus: that.pbStatus,
	            pbTime: (that.vital.pbTime == '' || that.vital.pbTime == null || that.vital.pbTime == 0
	                ? '' : that.utils.longToDateTimeFormatted(Number(that.vital.pbTime), 'MM/DD/YYYY hh:mm A')),
	            pbValueType: that.pbTime,
	            pbValue: that.pbValue,
	            pbValueUnit: that.pbValueUnit*/
	        };
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'showModal', 'hideModal', 'saveVital',
	            'fillVital', 'validate', 'search', 'renderResultInTable',
	            'fillFormFromSelectedResult', 'showLoading', 'hideLoading');
	        if (options) {
	            this.mode = options.mode;
	            this.vital = options.vital;
	        }
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	
	        this.showModal();
	        /*this.ui.searchResultsTable.hide();
	        this.ui.save.attr('disabled', true);*/
	
	        this.ui.time.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'MM/DD/YYYY hh:mm A'
	        });
	
	        /*this.ui.time.on("dp.change", function (e) {
	            if (e.date) {
	                this.parameters.time = e.date.valueOf();
	            } else {
	                this.parameters.time = 0;
	            }
	        }).on('dp.show', function () {
	            return $(this).data('DateTimePicker').defaultDate(this.utils.getDateWithoutTime(new Date()));
	        });*/
	
	        if (this.mode == 'edit') {
	            this.ui.leftSide.removeClass('col-md-6');
	            this.ui.leftSide.addClass('col-md-11');
	        }
	        this.validate();
	
	    },
	
	    showModal: function () {
	        this.ui.formModal.modal("show");
	    },
	
	    hideModal: function () {
	        this.ui.formModal.modal("hide");
	    },
	
	    saveVital: function () {
	        if (this.mode == 'add')
	            this.triggerMethod('new:vital', this.fillVital());
	        else if (this.mode == 'edit')
	            this.triggerMethod('update:vital', this.fillVital());
	        this.hideModal();
	    },
	
	    fillVital: function () {
	        this.vital.time = this.utils.dateToLong(this.ui.time.val());
	        this.vital.status = this.utils.status;
	        this.vital.time = this.utils.dateToLong(this.ui.time.val());
	        return this.vital;
	    },
	
	    validate: function () {
	    },
	
	    search: function (event) {},
	
	    renderResultInTable: function (results) {
	        var that = this;
	
	        results.forEach(function (item) {
	            var newRowContent = "<tr class='clickable' id='" + item.code + "'><td>"
	                + item.code + "</td><td>" + item.name + "</td></tr>";
	            $('#search-results tbody').append(newRowContent);
	        });
	
	        $("#search-results tr:not(:first)").on('click', function (event) {
	            var id = event.currentTarget.id;
	            $(this).addClass('selected').siblings().removeClass('selected');
	            that.fillFormFromSelectedResult(id, results);
	        });
	        if (results.length > 0) {
	            this.ui.searchResultsTable.show();
	        }
	    },
	
	    fillFormFromSelectedResult: function (selectedId, results) {
	        var selected = _.findWhere(results, {code: selectedId});
	        this.vital.vitalId = selected.code;
	        this.vital.time = selected.time;
	        this.ui.icdCode.val(selected.code);
	        this.ui.time.val(selected.time);
	        this.validate();
	    },
	
	    showLoading: function () {
	        this.utils.showSpinner('#vital-loader');
	    },
	
	    hideLoading: function () {
	        this.utils.hideSpinner('#vital-loader');
	    }
	
	});
	
	module.exports = VitalsForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="modal fade" id="vital-form-modal" tabindex="-1" role="dialog" aria-labelledby="vital-form-modal">\r\n    <div class="modal-dialog ';
	 if (mode == 'add') { 
	__p+=' modal-lg ';
	 } 
	__p+=' " role="document">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\r\n                        aria-hidden="true">&times;</span></button>\r\n                <h4 class="modal-title">'+
	((__t=( title ))==null?'':__t)+
	'</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <div id="vital-loader" class="loader"></div>\r\n                <div class="row" style="min-height: 100%">\r\n                    <div class="col-md-6 inputs">\r\n                        <div class="form-horizontal">\r\n                            <div class="form-group">\r\n                                <label class="col-sm-3 col-md-3 control-label" for="status">Status</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="status">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="time">Time</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="time" required value="'+
	((__t=( _.isEmpty(time) ? 'time' : time ))==null?'':__t)+
	'">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <div class="container-fluid">\r\n                                <h4 class="text-center" >Blood pressure</h4>\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="pbStatus">Status</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="pbStatus">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="pbTime">Time</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="pbTime">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="pbValueType">Value type</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="pbValueType">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="pbValue">Value</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="pbValue">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="pbValueUnit">Unit</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="pbValueUnit">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <div class="container-fluid">\r\n                                    <h4 class="text-center">Heart rate</h4>\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="hrStatus">Status</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="hrStatus">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="hrTime">Time</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="hrTime">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="hrValueType">Value type</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="hrValueType">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="hrValue">Value</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="hrValue">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="hrValueUnit">Unit</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="hrValueUnit">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <div class="container-fluid">\r\n                                    <h4 class="text-center">Body temperature</h4>\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="btStatus">Status</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="btStatus">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="btTime">Time</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="btTime">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="hrValueType">Value type</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="btValueType">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="btValue">Value</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="btValue">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="btValueUnit">Unit</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="btValueUnit">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <div class="container-fluid">\r\n                                    <h4 class="text-center">Respiratory rate</h4>\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="rrStatus">Status</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="rrStatus">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="rrTime">Time</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="rrTime">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="rrValueType">Value type</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="rrValueType">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="rrValue">Value</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="rrValue">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="rrValueUnit">Unit</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="rrValueUnit">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <div class="container-fluid">\r\n                                    <h4 class="text-center">Height</h4>\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="hgtStatus">Status</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="hgtStatus">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="hgtTime">Time</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="hgtTime">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="hgtValueType">Value type</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="hgtValueType">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="hgtValue">Value</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="hgtValue">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="hgtValueUnit">Unit</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="hgtValueUnit">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <div class="container-fluid">\r\n                                    <h4 class="text-center">Weight</h4>\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="wgtStatus">Status</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="wgtStatus">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="wgtTime">Time</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="wgtTime">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="wgtValueType">Value type</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="wgtValueType">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="wgtValue">Value</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="wgtValue">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="wgtValueUnit">Unit</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="wgtValueUnit">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <div class="container-fluid">\r\n                                    <h4 class="text-center">Oxygen Saturation</h4>\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="osStatus">Status</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="osStatus">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="osTime">Time</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="osTime">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="osValueType">Value type</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="osValueType">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="osValue">Value</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="osValue">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="osValueUnit">Unit</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="osValueUnit">\r\n                                </div>\r\n                            </div>\r\n                            <div class="form-group">\r\n                                <div class="container-fluid">\r\n                                    <h4 class="text-center">Length</h4>\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="lntStatus">Status</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="lntStatus">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="lntTime">Time</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="lntTime">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="lntValueType">Value type</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="lntValueType">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="lntValue">Value</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="lntValue">\r\n                                </div>\r\n                                <label class="col-sm-3 col-md-3 control-label" for="lntValueUnit">Unit</label>\r\n                                <div class="col-sm-9 col-md-9">\r\n                                    <input class="form-control" type="text" id="lntValueUnit">\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\r\n                <button type="button" class="btn btn-primary" id="save">Save</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 384 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td hidden>'+
	((__t=( uuid ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( time ))==null?'':__t)+
	'</td>\r\n<td><span class="clickable glyphicon glyphicon glyphicon-pencil edit" title="Edit"></span></td>\r\n<td><span class="clickable glyphicon glyphicon-remove remove" title="Remove"></span></td>\r\n';
	}
	return __p;
	};


/***/ }),
/* 385 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\r\n    <h3 class="center">Vitals</h3>\r\n    ';
	 if (canEdit) { 
	__p+='\r\n    <div class="left-buttons">\r\n        <button type="button" class="btn btn-success" id="add">Add vital</button>\r\n    </div>\r\n    ';
	 } 
	__p+='\r\n    <div class="top-margined">\r\n        <table class="table table-hover">\r\n            <thead>\r\n            <tr>\r\n                <th>Created time</th>\r\n            </tr>\r\n            </thead>\r\n            <tbody></tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n\r\n<div id="vital-form"></div>\r\n<div id="delete-confirmation-modal"></div>';
	}
	return __p;
	};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var RelationCollection = __webpack_require__(248);
	var Relation = __webpack_require__(230);
	var PersonOrganizationModalView = __webpack_require__(278);
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	var YesNoConfirmationModal = __webpack_require__(237);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	
	var PersonOrganizationsItem = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(387),
	
	    ui: {
	        edit: '.person-org-edit',
	        remove: '.person-org-remove'
	    },
	
	    events: {
	        'click @ui.edit': 'onEdit',
	        'click @ui.remove': 'onRemove'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            formatDate: that.getOption('formatDate'),
	            canEdit: that.getOption('canEdit')
	        }
	    },
	
	    initialize: function (options) {
	    },
	
	    onEdit: function () {
	        this.triggerMethod('edit:person:org', this.model);
	    },
	
	    onRemove: function () {
	        this.triggerMethod('remove:person:org', this.model);
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(4), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	
	var PersonOrganizationsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: PersonOrganizationsItem,
	    emptyView: EmptyView,
	
	    collectionEvents: {
	        request: 'showLoading',
	        sync: 'hideLoading',
	        error: 'logError'
	    },
	
	    childViewEvents: {
	        'edit:person:org': 'onEdit',
	        'remove:person:org': 'onRemove'
	    },
	
	    initialize: function (options) {
	        //_.bindAll(this, 'showLoading', 'hideLoading', 'logError');
	        this.collection = options.collection;
	        this.formatDate = options.formatDate;
	        this.canEdit = options.canEdit;
	    },
	
	    childViewOptions: function () {
	        return {
	            formatDate: this.formatDate,
	            canEdit: this.canEdit
	        };
	    },
	
	    onEdit: function (model) {
	        this.triggerMethod('edit:person:org', model);
	    },
	
	    onRemove: function (model) {
	        this.triggerMethod('remove:person:org', model);
	    },
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    }
	});
	
	var PersonOrganizationsView = Marionette.View.extend({
	    template: __webpack_require__(388),
	
	    regions: {
	        modal: '#person-organization',
	        tableBody: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        removeConfirmationModal: '#person-org-delete-confirmation-modal'
	    },
	
	    ui: {
	        newRelBtn: '#new-org'
	    },
	
	    events: {
	        'click @ui.newRelBtn': 'newRelation'
	    },
	
	    collectionEvents: {
	        error: 'logError'
	    },
	
	    childViewEvents: {
	        'edit:person:org': 'onEdit',
	        'remove:person:org': 'onRemove',
	        'saved:person:organization': 'onSavedPersonOrganization',
	        'action:confirmed': 'onRemoveConfirmed'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            canEdit: that.canEdit
	        }
	    },
	
	    initialize: function (options) {
	        this.personModel = options.personModel;
	        this.canEdit = options.canEdit;
	        this.utils = new CommonUtils();
	    },
	
	    onErrors: function (model, errors) {
	        model.view.triggerMethod('server:error', errors.join('. \n'));
	    },
	
	    onRender: function () {
	        var that = this;
	
	        this.removeConfirmationModal = new YesNoConfirmationModal({
	            tag: 'remove',
	            message: "Are you sure you want to remove this relation?"
	        });
	        this.showChildView('removeConfirmationModal', this.removeConfirmationModal);
	
	        that.collection = new RelationCollection([],
	            {
	                params: [
	                    {key: 'systemRelationType', value: 'PERSON_ORGANIZATION'},
	                    {key: 'parentId', value: that.personModel.id}
	                ]
	            });
	
	        that.reloadCollection();
	    },
	
	    renderEditor: function (model, orgContacts, personContacts) {
	        var excludedOrgsIds = this.collection.map(function (model) {
	            return model.get("child").id;
	        });
	
	        this.personOrganizationModalView = new PersonOrganizationModalView({
	            mode: "person",
	            model: model,
	            excludedOrgsIds: _.without(excludedOrgsIds, (model.get("child") || {}).id),
	            orgContacts: orgContacts,
	            personContacts: personContacts
	        });
	        this.showChildView('modal', this.personOrganizationModalView);
	        this.personOrganizationModalView.show();
	    },
	
	    reloadCollection: function () {
	        var that = this;
	        that.showLoading();
	        that.collection.fetch({
	            success: function () {
	                that.renderTable();
	                that.hideLoading();
	            },
	            error: function () {
	                that.hideLoading();
	            }
	        });
	    },
	
	    renderTable: function () {
	        var that = this;
	        that.showChildView('tableBody', new PersonOrganizationsTableBody({
	            collection: that.collection,
	            formatDate: function (dateAsLong) {
	                return dateAsLong ? that.utils.longToDateTimeFormatted(dateAsLong, 'MMM DD YYYY') : "";
	            },
	            canEdit: that.canEdit
	        }));
	    },
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    },
	
	    newRelation: function () {
	        this.renderEditor(new Relation({
	            systemRelationType: 'PERSON_ORGANIZATION',
	            parentId: this.personModel.id,
	            contacts: [],
	            description: ""
	        }), [], (this.personModel.get('object') || {}).contacts);
	    },
	
	    onSavedPersonOrganization: function () {
	        this.reloadCollection();
	    },
	
	    onEdit: function (model) {
	        var clonedModelAttributes = this.utils.deepClone(_.extend({}, model.attributes));
	        var clonedModel = new Relation();
	        clonedModel.set(clonedModelAttributes);
	        this.renderEditor(clonedModel, clonedModelAttributes.child.object.contacts, (this.personModel.get('object') || {}).contacts);
	    },
	
	    onRemove: function (model) {
	        this.modelToRemove = model;
	        this.removeConfirmationModal.show();
	    },
	
	    onRemoveConfirmed: function (resp) {
	        var that = this;
	        if (resp.tag === 'remove' && resp.result == true) {
	            that.modelToRemove.destroy({
	                success: function (model, resp) {
	                    that.reloadCollection();
	                    that.removeConfirmationModal.hide();
	                }
	            });
	        }
	        else {
	            that.removeConfirmationModal.hide();
	        }
	    }
	});
	
	
	module.exports = PersonOrganizationsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td><a href="/#organization/'+
	((__t=( child.id ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( child.name ))==null?'':__t)+
	'</a></td>\n<td>'+
	((__t=( formatDate(startTime) ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( formatDate(endTime) ))==null?'':__t)+
	'</td>\n<td>\n    ';
	 _.each(contacts, function(contact){ 
	__p+='\n    <span class="label ';
	 if (contact.preferred) { 
	__p+=' label-success ';
	 } else { 
	__p+=' label-primary ';
	 } 
	__p+='" style="font-size: 14px;">\n        '+
	((__t=( contact.type ))==null?'':__t)+
	' - '+
	((__t=( contact.data ))==null?'':__t)+
	'\n    </span>&nbsp;\n    ';
	 }) 
	__p+='\n</td>\n';
	 if (canEdit) { 
	__p+='\n<td><span class="glyphicon glyphicon-edit clickable person-org-edit" title="Edit"/></td>\n<td><span class="glyphicon glyphicon-remove clickable person-org-remove" title="Remove"/></td>\n';
	 } 
	__p+='\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="loading"></div>\n';
	 if (canEdit) { 
	__p+='\n<button class="btn btn-primary btn-sm" id="new-org">New Relationship</button>\n';
	 } 
	__p+='\n<table class="table table-hover top-margined">\n    <head>\n        <thead>\n        <tr>\n            <th>Organization</th>\n            <th>Date From</th>\n            <th>Date To</th>\n            <th>Contacts</th>\n            <th></th>\n            <th></th>\n        </tr>\n        </thead>\n    </head>\n    <tbody></tbody>\n</table>\n\n<div id="person-organization"></div>\n<div id="person-org-delete-confirmation-modal"></div>';
	}
	return __p;
	};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\n\n    <h3 class="center">'+
	((__t=( name ))==null?'':_.escape(__t))+
	'</h3>\n\n    <!-- Nav tabs -->\n    <ul class="nav nav-tabs" role="tablist">\n        <li role="presentation" class="active"><a href="#person-main" aria-controls="person-main" role="tab" data-toggle="tab">Main</a></li>\n        <li role="presentation"><a href="#person-contacts" aria-controls="person-contacts" role="tab" data-toggle="tab">Contacts</a></li>\n        ';
	 if (canEdit()) { 
	__p+='\n        <li role="presentation"><a href="#person-permissions" aria-controls="person-permissions" role="tab" data-toggle="tab">Permissions</a></li>\n        <li role="presentation"><a href="#person-comments" aria-controls="person-comments" role="tab" data-toggle="tab">Comments <span class="badge" id="comments-count"></span></a></li>\n        ';
	 } 
	__p+='\n        <li role="presentation"><a href="#medical-records" aria-controls="medical-records" role="tab" data-toggle="tab">Medical records</a></li>\n        ';
	 if (canEdit()) { 
	__p+='\n        <li role="presentation"><a href="#person-external-ids" aria-controls="person-external-ids" role="tab" data-toggle="tab">External Ids</a></li>\n        ';
	 } 
	__p+='\n        <li role="presentation"><a href="#person-organizations" aria-controls="person-organizations" role="tab" data-toggle="tab">Organizations</a></li>\n    </ul>\n\n    <!-- Tab panes -->\n    <div class="tab-content">\n        <div role="tabpanel" class="tab-pane active top-margined" id="person-main">\n\n            <div id="person-data"></div>\n\n            ';
	 if (canEdit()) { 
	__p+='\n            <div id="edit-section" style="display: none;">\n                <div id="person-form" class="edit-form"></div>\n                <div id="edit-buttons" class="edit-buttons" style="margin-bottom: 130px;">\n                    <div class="left-buttons">\n                        <button type="button" class="btn btn-default" id="cancel-edit">Cancel</button>\n                        <button type="button" class="btn btn-primary" id="save-person">Save changes</button>\n                    </div>\n                </div>\n            </div>\n            ';
	 } 
	__p+='\n\n            <div class="row hidden">\n                <h3>Organization</h3>\n                <div id="organization-relations"></div>\n                <div id="add-organization-relation" class="col-xs-6 col-md-4"></div>\n            </div>\n        </div>\n        <div role="tabpanel" class="tab-pane top-margined" id="person-contacts">\n            <div class="row" id="contacts-list">\n                <h3 class="center">Representatives</h3>\n                <div id="representatives"></div>\n                <div id="representative-form" class="col-xs-12 col-md-12"></div>\n                <h3 class="center">Contacts</h3>\n                <div id="contacts"></div>\n                <div id="contact-form" class="col-xs-12 col-md-12"></div>\n                <h3 class="center">Addresses</h3>\n                <div id="addresses"></div>\n                <div id="address-form" class="col-xs-12 col-md-12"></div>\n            </div>\n        </div>\n        ';
	 if (canEdit()) { 
	__p+='\n        <div role="tabpanel" class="tab-pane top-margined" id="person-permissions">\n            <div class="row" id="permissions-list">\n                <h3 class="center">Permissions</h3>\n                <div id="permissions"></div>\n                <div id="add-permission" class="col-xs-12 col-md-12"></div>\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n        ';
	 if (canEdit()) { 
	__p+='\n        <div role="tabpanel" class="tab-pane top-margined" id="person-comments">\n            <div class="row"  id="comments-list">\n                <h3 class="center">Comments</h3>\n                <div id="comments" style="max-height: 20000px;"></div>\n                ';
	 if (canEdit()) { 
	__p+='\n                <div id="add-comment" class="col-xs-12 col-md-12"></div>\n                ';
	 } 
	__p+='\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n        <div role="tabpanel" class="tab-pane" id="medical-records">\n            <div class="col-xs-2">\n                <ul class="nav nav-tabs left-tabs">\n                    <li class="active"><a href="#medications-content" data-toggle="tab">Medications</a></li>\n                    <li><a href="#diseases-content" data-toggle="tab">Diseases</a></li>\n                    <li><a href="#visits-content" data-toggle="tab">Visits</a></li>\n                    <li><a href="#documents-content" data-toggle="tab">Documents</a></li>\n                    <li><a href="#appendix-kk-content" data-toggle="tab">Determination of need-revised (Appendix KK)</a></li>\n                    <li><a href="#sources-content" data-toggle="tab">Sources</a></li>\n                    <li><a href="#immunizations-content" data-toggle="tab">Immunizations</a></li>\n                    <li><a href="#dicoms-content" data-toggle="tab">Dicom</a></li>\n                    <li><a href="#vitals-content" data-toggle="tab">Vitals</a></li>\n                </ul>\n            </div>\n            <div class="col-xs-10">\n                <!-- Tab panes -->\n                <div class="tab-content">\n                    <div class="tab-pane active top-margined" id="medications-content">\n                        <div class="row" id="medical-records-container"></div>\n                    </div>\n                    <div class="tab-pane top-margined" id="diseases-content">\n                        <div class="row" id="diseases-container"></div>\n                    </div>\n                    <div class="tab-pane top-margined" id="visits-content"></div>\n                    <div class="tab-pane top-margined" id="documents-content">\n                        <div class="row" id="documents-container"></div>\n                    </div>\n                    <div class="tab-pane top-margined" id="appendix-kk-content">\n                        <h3 class="center">Determination of need-revised (DON-R)</h3>\n                        <div class="top-margined" id="appendix-kk-container"></div>\n                        ';
	 if (canEdit()) { 
	__p+='\n                        <div class="left-buttons">\n                            <button type="button" class="btn btn-primary" id="save-appendix-kk">Save changes</button>\n                        </div>\n                        ';
	 } 
	__p+='\n                    </div>\n                    <div class="tab-pane top-margined" id="sources-content">\n                        <div class="row" id="sources-container"></div>\n                    </div>\n                    <div class="tab-pane top-margined" id="immunizations-content">\n                        <div class="row" id="immunizations-container"></div>\n                    </div>\n                    <div class="tab-pane top-margined" id="dicoms-content">\n                        <div class="row" id="dicoms-container"></div>\n                    </div>\n                    <div class="tab-pane top-margined" id="vitals-content">\n                        <div class="row" id="vitals-container"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        ';
	 if (canEdit()) { 
	__p+='\n        <div role="tabpanel" class="tab-pane top-margined" id="person-external-ids">\n            <h3 class="center">External Ids</h3>\n            <div id="external-ids">\n            </div>\n        </div>\n        ';
	 } 
	__p+='\n        <div role="tabpanel" class="tab-pane top-margined" id="person-organizations">\n            <h3 class="center">Organizations</h3>\n            <div id="organizations"></div>\n        </div>\n    </div>\n\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var PersonForm = __webpack_require__(336);
	var Person = __webpack_require__(206);
	var OkDialogModal = __webpack_require__(332);
	
	var CommonUtils = __webpack_require__(189);
	var Radio = __webpack_require__(183);
	
	var notificationsChannel = Radio.channel('notifications');
	
	var SignupView = Marionette.View.extend({
	    template: __webpack_require__(391),
	
	    regions: {
	        personForm: '#person-form',
	        inform: '#inform'
	    },
	
	    ui: {
	        signupBtn: '#perform-signup'
	    },
	
	    events: {
	        'click @ui.signupBtn': 'performSignup'
	    },
	
	    childViewEvents: {
	        'person:save:valid': 'savePersonBtnEnableOrDisable'
	    },
	
	    initialize: function () {
	        _.bindAll(this, 'performSignup');
	        this.model = new Person();
	        this.model.view = this;
	        this.model.on('invalid', this.onErrors);
	        this.utils = new CommonUtils();
	    },
	
	    onErrors: function (model, errors) {
	        model.view.triggerMethod('server:error', errors.join('. \n'));
	    },
	
	    onRender: function () {
	        window.document.title = "Signup";
	        this.personForm = new PersonForm({model: this.model, isEditMode: false, forSignup: true});
	        this.showChildView('personForm', this.personForm);
	    },
	
	    performSignup: function () {
	        var that = this;
	        that.model.set(that.personForm.fillModel().toJSON());
	        that.model.urlRoot = '/api/login/signin';
	        that.model.set('id', undefined);
	        that.utils.showSpinner();
	        that.model.save(that.model.toJSON(), {
	            success: function (response) {
	                that.utils.hideSpinner();
	                that.personForm.clearModel();
	                that.informUser();
	            },
	            error: function (model, xhr, options) {
	                that.utils.hideSpinner();
	                var errorResp = JSON.parse(xhr.responseText);
	                errorResp.message = errorResp.message.replace("Entity", "Person").replace("id", "login");
	                notificationsChannel.request('show:notification', errorResp);
	                that.personForm.validateAllRequiredFields();
	            }
	        });
	    },
	
	    savePersonBtnEnableOrDisable: function (data) {
	        if (data.result)
	            this.ui.signupBtn.removeAttr("disabled");
	        else
	            this.ui.signupBtn.attr("disabled", "true");
	    },
	
	    informUser: function() {
	        var that = this;
	        that.informWindow = new OkDialogModal({
	            title: 'Information',
	            message: "Confirmation link was send on email provided. Please click on the link to activate your account",
	            action: function() {
	                Backbone.history.navigate('/login', {trigger: true});
	            }
	        });
	
	        that.showChildView('inform', that.informWindow);
	        that.informWindow.show();
	    }
	})
	
	module.exports = SignupView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h2 class="center">\n    Registration form\n</h2>\n<div class="container signup-form">\n    <div id="person-form" class="edit-form"></div>\n    <div id="edit-buttons" class="edit-buttons">\n        <div class="left-buttons">\n            <button type="button" class="btn btn-primary" id="perform-signup" disabled>Sign up</button>\n        </div>\n    </div>\n</div>\n\n<div id="inform"></div>';
	}
	return __p;
	};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var Document = __webpack_require__(207);
	var DocumentData = __webpack_require__(393);
	var DocumentSignData = __webpack_require__(399);
	var ReviewRequestModel = __webpack_require__(403);
	var YesNoConfirmationModal = __webpack_require__(237);
	var PermissionsCollection = __webpack_require__(249);
	var PermissionFormView = __webpack_require__(243);
	var PermissionsTableView = __webpack_require__(236);
	var ReviewerFormView = __webpack_require__(315);
	var DocumentReviewersView = __webpack_require__(404);
	var AddendumsView = __webpack_require__(408);
	var ReviewElementStatusesModel = __webpack_require__(209);
	var CommonUtils = __webpack_require__(189);
	var DocumentPatientForm = __webpack_require__(414);
	var CommentFormView = __webpack_require__(266);
	var CommentsTableView = __webpack_require__(268);
	var DocumentHistoryView = __webpack_require__(416);
	var DocumentActionByDocumentView = __webpack_require__(421);
	
	var ContactsTableView = __webpack_require__(250);
	var ContactsCollection = __webpack_require__(253);
	var ContactFormView = __webpack_require__(254);
	
	var Radio = __webpack_require__(183);
	var sessionChannel = Radio.channel('session');
	var notificationsChannel = Radio.channel('notifications');
	
	var DocumentView = Marionette.View.extend({
	    template: __webpack_require__(423),
	    model: new Document(),
	    reviewRequestModel: new ReviewRequestModel(),
	    commonUtil: new CommonUtils(),
	
	    regions: {
	        documentData: '#document-data',
	        documentSignData: '#document-sign-data',
	        requests: '#document-requests',
	        newRequest: '#create-request',
	        additionalElements: '#additional-elements',
	        reviewRequesterOrgSelect: '#review-requester-org',
	        confirmationModal: '#save-confirmation-modal',
	        permissions: '#permissions',
	        addPermission: '#add-permission',
	        addReviewersForm: '#add-reviewers-form',
	        reviewers: '#reviewers',
	        documentPatient: '#document-patient',
	        comments: '#comments',
	        addComment: '#add-comment',
	        historyView: '#history',
	        documentActionByDocument: '#document-action-by-document-content',
	        contacts: '#contacts',
	        contactForm: '#contact-form'
	    },
	
	    childViewEvents: {
	        'document:will-be-remove': 'removeDocument',
	        'entity:selected': 'entitySelected',
	        'action:confirmed': 'saveConfirmed',
	        'permission:saved': 'permissionSaved',
	        'review:status:updated': 'onReviewStatusChanged',
	        'patient:added:to:doc': 'refreshDocumentPatientForm',
	        'comment:added': 'onCommentAdded',
	        'comment:count:changed': 'onCommentCountChanged',
	        'reviewer:changed': 'onReviewerChanged',
	        'on:cancel:comment:send': 'onCancelCommentSend',
	        'on:edit:comment': 'onEditComment',
	        'comment:updated': 'onCommentUpdated',
	        'on:new:comment': 'onNewComment',
	        'action:with:document:upload': 'onActionWithDocumentUpload',
	        'on:contact:action': 'onContactAction',
	        'on:contact:saved': 'onContactSaved'
	    },
	
	    ui: {
	        modal: '#addReviewRequestModal',
	        additionalElements: '#additional-elements',
	        documentSignData: '#document-sign-data',
	        documentSignDataTab: '#item-sign-settings',
	        alias: '#alias',
	        aliasUpdate: '#alias-update',
	        aliasCancel: '#alias-cancel',
	        commentsCount: '#comments-count',
	        addReviewerButton: '#add-reviewer-button',
	        contactForm: '#contact-form'
	    },
	
	    events: {
	        'click #new-request': 'requestShow',
	        'click #save-request': 'saveRequest',
	        'click @ui.addReviewerButton': 'addReviewer',
	        'keyup @ui.alias': 'onAliasChange',
	        'click @ui.aliasUpdate': 'aliasUpdate',
	        'click @ui.aliasCancel': 'aliasCancel',
	        'comment:count:changed': 'onCommentCountChanged'
	    },
	
	    userCanEdit: undefined,
	
	    initReviewer: function () {
	        return {
	            personId: "",
	            organizationId: "",
	            mandatory: true
	        }
	    },
	
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'removeDocument',
	            'permissionSaved', 'renderReviewers',
	            'addReviewer', 'onReviewStatusChanged', 'canEdit', 'save', 'refreshDocumentPatientForm', 'isShowSignData',
	            'onCommentAdded', 'canUploadForOrganizationInDocument', 'renderPermissionsListView',
	            'onAliasChange', 'aliasUpdate', 'aliasCancel', 'onCommentCountChanged', 'onReviewerChanged', 'onActionWithDocumentUpload');
	        this.model = options.model;
	        this.reviewRequestModel.view = this;
	        this.reviewRequestModel.on('invalid', this.showErrors);
	        this.reviewElementStatuses = new ReviewElementStatusesModel();
	        this.utils = new CommonUtils();
	        this.permissions = sessionChannel.request('get:permissions');
	        this.userId = sessionChannel.request('get:userId');
	        this.byAdmin = options.byAdmin;
	
	        $.when(this.reviewElementStatuses.fetch()).then(this.renderReviewers);
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            canEdit: function () {
	                return that.canEdit();
	            },
	            canUploadForOrganizationInDocument: function () {
	                return that.canUploadForOrganizationInDocument();
	            },
	            isShowSignData: that.isShowSignData,
	            contactsCount: (that.model.get('object').contacts || []).length
	        }
	    },
	
	    showErrors: function (model, errors) {
	        model.view.triggerMethod('server:error', errors.join('. \n'));
	    },
	
	    onRender: function () {
	        window.document.title = this.model.get("name");
	        var that = this;
	
	        that.initEvents();
	
	        that.$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
	            var target = that.$(e.target).attr("href");
	            if (target == '#document-history' /* && typeof that.getChildView('historyView') == 'undefined'*/) {
	                that.showChildView('historyView', new DocumentHistoryView({
	                    id: that.model.get('id'),
	                    name: that.model.get('name'),
	                    baseParentIdPath: '/api/document/view/',
	                    canEdit: that.canEdit(),
	                    byAdmin: that.byAdmin,
	                    document: that.model.get('object')
	                }));
	            } else if (target == '#document-permissions' && typeof that.getChildView('addPermission') == 'undefined') {
	                if (that.canEdit()) {
	                    that.permissionsCollection = new PermissionsCollection([], {
	                        params: [{
	                            key: 'permittedObjectId',
	                            value: that.model.id
	                        }]
	                    });
	                    that.renderPermissionsListView(that.permissionsCollection);
	
	                    that.permissionFormView = new PermissionFormView({
	                        'permittedObjectId': that.model.id,
	                        showOrganization: true,
	                        permittedObjectType: 'document'
	                    });
	                    that.showChildView('addPermission', that.permissionFormView);
	                }
	            } else if (target == '#document-patients' && typeof that.getChildView('documentPatient') == 'undefined') {
	                if (that.canEdit()) {
	                    that.documentPatient = new DocumentPatientForm({model: that.model, canEdit: that.canEdit});
	                    that.showChildView('documentPatient', that.documentPatient);
	                }
	            } else if (target == '#document-comments' && typeof that.getChildView('comments') == 'undefined') {
	                that.renderCommentsView();
	            } else if (target == '#document-action-by-document' && typeof that.getChildView('documentActionByDocument') == 'undefined') {
	                that.showChildView('documentActionByDocument', new DocumentActionByDocumentView({
	                    model: that.model,
	                    canEdit: that.canEdit
	                }));
	            }
	        });
	        this.renderContacts();
	    },
	
	    renderReviewers: function () {
	        this.documentDataView = new DocumentData({
	            model: this.model,
	            canEdit: this.canEdit,
	            canUploadForOrganizationInDocument: this.canUploadForOrganizationInDocument,
	            isMd: this.permissions.isMd,
	            userId: this.userId,
	            byAdmin: this.byAdmin
	        });
	        this.showChildView('documentData', this.documentDataView);
	
	        if (this.canEdit()) {
	            this.confirmationModal =
	                new YesNoConfirmationModal({message: 'Requester organization is not selected. Are you sure you want to send request without organization?'});
	            this.showChildView('confirmationModal', this.confirmationModal);
	
	            if (this.isShowSignData()) {
	                this.documentSignDataView = new DocumentSignData({model: this.model, canEdit: this.canEdit});
	                this.showChildView('documentSignData', this.documentSignDataView);
	            }
	            else {
	                this.ui.documentSignData.remove();
	                this.ui.documentSignDataTab.remove();
	            }
	        }
	
	        if (this.canEdit() || this.canUploadForOrganizationInDocument()) {
	            this.reviewer = this.initReviewer();
	            this.reviewerFormView = new ReviewerFormView({
	                reviewer: this.reviewer,
	                regionId: "addReviewer",
	                showRemove: false
	            });
	            this.showChildView('addReviewersForm', this.reviewerFormView);
	        }
	
	        this.reviewersView = new DocumentReviewersView({
	            documentId: this.model.get('id'),
	            reviewers: this.model.get('object').reviewers,
	            idNamesMap: this.getIdNamesMap(),
	            elementStatuses: this.reviewElementStatuses.toJSON(),
	            permissions: this.permissions,
	            relations: this.model.get('relations'),
	            canEdit: this.canEdit,
	            canUploadForOrganizationInDocument: this.canUploadForOrganizationInDocument,
	            byAdmin: this.byAdmin
	        });
	        this.showChildView('reviewers', this.reviewersView);
	    },
	
	    initEvents: function () {
	        this.triggerMethod('comment:count:changed');
	    },
	
	    renderCommentsView: function () {
	
	        this.showChildView('comments', new CommentsTableView({
	            dboId: this.model.get('id'),
	            canEdit: this.canEdit()
	        }));
	
	        this.renderCommentForm();
	    },
	
	    renderCommentForm: function (model) {
	        this.showChildView('addComment', new CommentFormView({
	            dboId: this.model.get('id'),
	            model: model ? model : new Backbone.Model({
	                id: undefined,
	                text: undefined
	            })
	        }));
	    },
	
	    refreshDocumentPatientForm: function (model) {
	        var that = this;
	        that.showChildView('documentPatient', new DocumentPatientForm({
	            model: new Backbone.Model(model),
	            canEdit: that.canEdit
	        }));
	    },
	
	    renderPermissionsListView: function (collection) {
	        this.permissionsListView = new PermissionsTableView({
	            collection: collection,
	            showOrganization: true,
	            permittedObjectType: 'document'
	        });
	        this.showChildView('permissions', this.permissionsListView);
	    },
	
	    requestShow: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    saveRequest: function () {
	        if (typeof this.reviewRequestModel.get('object').requesterOrganizationId === "undefined") {
	            $(this.ui.modal).modal('hide');
	            this.$('#confirmation-modal').modal();
	        }
	        else
	            this.save();
	    },
	
	    save: function () {
	        var that = this;
	        var name = (that.reviewRequestModel.get('object').reviewRequestElements || [])
	            .map(function (element) {
	                return element.documentName
	            })
	            .join(', ');
	        that.reviewRequestModel.set('name', name == '' ? 'Review request' : name);
	        that.reviewRequestModel.save(that.reviewRequestModel.toJSON(), {success: that.requestSaved});
	    },
	
	    removeDocument: function (data) {
	        var that = this;
	        var regionId = data.regionId;
	        var element = data.element;
	        that.deleteRegion(regionId);
	        this.tempRegionNames = this.tempRegionNames.filter(function (item) {
	            return item !== regionId;
	        });
	        this.reviewRequestModel.get('object').reviewRequestElements = this.reviewRequestModel.get('object').reviewRequestElements.filter(function (item) {
	            return item !== element;
	        });
	    },
	
	    storeRegion: function (regionName) {
	        this.tempRegionNames = this.tempRegionNames || [];
	        this.tempRegionNames.push(regionName);
	    },
	
	    deleteRegion: function (regionId) {
	        this.getRegion(regionId).empty();
	        this.removeRegion(regionId);
	        this.$('#' + regionId).remove();
	    },
	
	    entitySelected: function (data) {
	        this.reviewRequestModel.get('object').requesterOrganizationId = data.id;
	    },
	
	    saveConfirmed: function (data) {
	        if (data.result == true) {
	            this.save();
	        }
	        else {
	            $(this.ui.modal).modal('show');
	        }
	    },
	
	    permissionSaved: function (model) {
	        this.renderPermissionsListView(this.permissionsCollection);
	    },
	
	    addReviewer: function () {
	        var that = this;
	        that.utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/document/' + this.model.get('id') + '/reviewer',
	            data: JSON.stringify(this.reviewer),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    that.model.set(response);
	                    that.reviewer = that.initReviewer();
	                    that.renderReviewers();
	                    that.ui.addReviewerButton.attr('disabled', true);
	                }
	            },
	            error: function (e) {
	                console.log(e);
	                notificationsChannel.request('show:notification', e.responseJSON);
	                that.utils.hideSpinner();
	            }
	        });
	    },
	
	    getIdNamesMap: function () {
	        var idNamesMap = {};
	        (this.model.get('relations') || []).forEach(function (relation) {
	            idNamesMap[relation.child.id] = relation.child.name;
	        });
	        return idNamesMap;
	    },
	
	    onReviewStatusChanged: function (object) {
	        this.model.set(object);
	        this.renderReviewers();
	    },
	
	    canEdit: function () {
	        if (!this.userCanEdit) {
	            this.userCanEdit = this.commonUtil.userCanDoWithDocument(this.permissions,
	                function (permission) {
	                    return permission.canWriteFor || permission.canSign;
	                },
	                function (permission) {
	                    return permission.canWriteAll || permission.canSignAll;
	                },
	                this.model.get('permissions'),
	                function (permission) {
	                    return permission.canWrite || permission.canSign;
	                }
	            );
	        }
	        return this.userCanEdit;
	    },
	
	    isShowSignData: function () {
	        var that = this;
	        return that.model.get('object').reviewers.filter(function (reviewer) {
	            return reviewer.status == 'SIGNED';
	        }).length == 0;
	    },
	
	    onCommentAdded: function (commentModel) {
	        this.getChildView('comments').add(commentModel);
	        this.renderCommentForm();
	    },
	
	    onCommentUpdated: function (commentModel) {
	        this.getChildView('comments').update(commentModel);
	        this.renderCommentForm();
	    },
	
	    onCommentCountChanged: function () {
	        var that = this;
	
	        $.ajax({
	            type: "GET",
	            url: '/api/comment/' + that.model.get('id') + '/count',
	            statusCode: {
	                200: function (response) {
	                    that.ui.commentsCount.text(response);
	                    if (typeof that.getChildView('comments') != 'undefined') {
	                        that.getChildView('comments').syncWithCount(response);
	                    }
	                }
	            },
	            error: function (e) {
	                console.log(e);
	            }
	        });
	    },
	
	    canUploadForOrganizationInDocument: function () {
	        if (!this.userCanUpload) {
	            var organizationId = this.model.get('object').organizationId || '';
	            this.userCanUpload = (this.permissions.userPermissions || [])
	                .filter(function (permission) {
	                    return permission.canUploadFor && permission.permittedObjectId == organizationId;
	                }).length > 0;
	        }
	        return this.userCanUpload;
	    },
	
	    onAliasChange: function (event) {
	        if (event.target.value != this.model.get('alias')) {
	            this.ui.aliasCancel.removeAttr('disabled');
	            this.ui.aliasUpdate.removeAttr('disabled');
	        } else {
	            this.ui.aliasCancel.attr('disabled', true);
	            this.ui.aliasUpdate.attr('disabled', true);
	        }
	    },
	
	    aliasUpdate: function (event) {
	        var that = this;
	        var alias = that.ui.alias.val();
	        that.utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/document/' + that.model.get('id') + '/alias',
	            data: alias,
	            contentType: 'text/plain',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    that.model.set('alias', alias);
	                    that.ui.aliasCancel.attr('disabled', true);
	                    that.ui.aliasUpdate.attr('disabled', true);
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner();
	                notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        });
	    },
	
	    aliasCancel: function (event) {
	        this.ui.alias.val(this.model.get('alias'));
	        this.ui.aliasCancel.attr('disabled', true);
	        this.ui.aliasUpdate.attr('disabled', true);
	    },
	
	    onReviewerChanged: function () {
	        if (this.reviewer.organizationId || this.reviewer.personId)
	            this.ui.addReviewerButton.removeAttr('disabled');
	        else
	            this.ui.addReviewerButton.attr('disabled', true);
	    },
	
	    onCancelCommentSend: function () {
	        this.renderCommentForm();
	    },
	
	    onEditComment: function (model) {
	        this.renderCommentForm(model);
	        $('html, body').animate({scrollTop: $(document).height()}, 'slow');
	    },
	
	    onNewComment: function () {
	        this.renderCommentForm();
	        $('html, body').animate({scrollTop: $(document).height()}, 'slow');
	    },
	
	    onActionWithDocumentUpload: function (data) {
	        this.triggerMethod('refresh:document:view', data.id);
	    },
	
	    renderContacts: function () {
	        this.contactsView = new ContactsTableView({
	            collection: new ContactsCollection(this.model.get('object').contacts),
	            canEdit: this.canEdit()
	        });
	        this.showChildView("contacts", this.contactsView);
	    },
	
	    renderContactForm: function (mode, contact) {
	        this.ui.contactForm.show();
	        if (mode == 'add') {
	            this.contactFormView = new ContactFormView({
	                mode: mode,
	                addresses: this.model.get('object').addresses || [],
	                representatives: this.model.get('object').representatives || []
	            });
	            this.showChildView("contactForm", this.contactFormView);
	        }
	        else if (mode == 'edit') {
	            this.contactFormView = new ContactFormView({
	                mode: mode,
	                contact: contact,
	                addresses: this.model.get('object').addresses || [],
	                representatives: this.model.get('object').representatives || []
	            });
	            this.showChildView("contactForm", this.contactFormView);
	        }
	    },
	
	    removeContactForm: function () {
	        this.ui.contactForm.hide();
	        this.detachChildView('contactForm');
	    },
	
	    onContactAction: function (data) {
	        var that = this;
	        if (data.mode == 'add') {
	            that.renderContactForm(data.mode);
	        }
	        else if (data.mode == 'delete') {
	            var willBeRemoveContact = data.data.attributes;
	            that.model.get('object').contacts = (that.model.get('object').contacts || []).filter(function (contact) {
	                return contact.data !== willBeRemoveContact.data
	                    || contact.type !== willBeRemoveContact.type
	                    || contact.preferred !== willBeRemoveContact.preferred;
	            });
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderContacts();
	                }
	            });
	        }
	        else if (data.mode == 'edit') {
	            var willBeEditedContact = data.data.attributes;
	            var willEditContact = (that.model.get('object').contacts || []).filter(function (contact) {
	                return contact.data == willBeEditedContact.data
	                    && contact.type == willBeEditedContact.type
	                    && contact.preferred == willBeEditedContact.preferred;
	            });
	            this.renderContactForm(data.mode, willEditContact[0]);
	        }
	        else if (data.mode == 'cancel') {
	            that.removeContactForm();
	        } else if (data.mode == 'save') {
	            var changedContact = data.data.attributes;
	            (that.model.get('object').contacts || []).forEach(function (contact) {
	                if (contact.data == changedContact.data
	                    && contact.type == changedContact.type) {
	                    contact.preferred = changedContact.preferred;
	                }
	            });
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderContacts();
	                }
	            });
	        }
	    },
	
	    onContactSaved: function (data) {
	        var that = this;
	        if (data.mode == 'add') {
	            that.model.get('object').contacts = (that.model.get('object').contacts || []).filter(function (contact) {
	                return contact.data !== data.contact.data
	                    || contact.type !== data.contact.type
	                    || contact.preferred !== data.contact.preferred;
	            });
	            that.model.get('object').contacts.push(data.contact);
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderContacts();
	                    that.removeContactForm();
	                }
	            });
	        } else if (data.mode == 'edit') {
	            that.model.save(that.model.toJSON(), {
	                success: function () {
	                    that.renderContacts();
	                    that.removeContactForm();
	                }
	            });
	        }
	    }
	});
	
	module.exports = DocumentView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	var Radio = __webpack_require__(183);
	
	var Document = __webpack_require__(207);
	var DeleteConfirmationModal = __webpack_require__(241);
	var SetDocumentDueForm = __webpack_require__(320);
	var DocumentMetaModal = __webpack_require__(394);
	
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	
	
	var DocumentData = Marionette.View.extend({
	    template: __webpack_require__(398),
	
	    model: new Document(),
	
	    regions: {
	        removeConfirmationModal: '.delete-confirmation-modal',
	        setDueFormModal: '#set-due-form-modal',
	        addMetaFormRegion: '#add-meta-form'
	    },
	
	    ui: {
	        editDueTime: '#edit-due-time',
	        dueTimeLabel: '#due-time',
	        createdDate: "#created-date",
	        saveCreatedDate: "#save-created-date",
	        cancelCreatedDate: '#cancel-created-date',
	        createdDateForm: '#created-date-form',
	        editCreatedTime: '#edit-created-time',
	        createdDateDisplay: '#created-date-display',
	        createdDateDisplayContainer: '#created-date-display-container',
	
	        addEditMetadata: '#add-edit-metadata'
	    },
	
	    events: {
	        'click #remove-document': 'removeDocument',
	        'click @ui.editDueTime': 'onEditDueTime',
	        'click @ui.saveCreatedDate': 'saveCreatedDate',
	        'click @ui.cancelCreatedDate': 'cancelCreatedDate',
	        'click @ui.editCreatedTime': 'editCreatedTime',
	
	        'click @ui.addEditMetadata': 'addEditMetadata'
	    },
	
	    childViewEvents: {
	        'delete:confirmed': 'deleteConfirmed',
	        'due:set:to:document': 'onDueSet'
	    },
	
	    constants: {
	        addMetaTitle: 'Add metadata',
	        editMetaTitle: 'Edit metadata'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var uploaderPersonName = (that.model.get('relations') || []).filter(function(item) {
	            return item.parentId == that.model.get('id') && item.systemRelationType == 'DOCUMENT_UPLOADER_PERSON';
	        }).map(function(item) {
	            return item.child ? that.utils.formatPerson(item.child.object) : '';
	        });
	        return {
	            fmUploadedTime: that.utils.longToDateTimeFormatted(that.model.get('createdTime'), "MM/DD/YYYY hh:mm A"),
	            fmCreatedTime: that.utils.longToDateTimeFormatted(that.model.get('object').createdTime, "MM/DD/YYYY hh:mm A"),
	            fmDueTime: that.model.get('object').dueDate === 0 ? '' : that.utils.longToDateTimeFormatted(that.model.get('object').dueDate, "MM/DD/YYYY hh:mm A"),
	            fmSignedTime: that.utils.longToDateTimeFormatted(that.model.get('object').signedTime, "MM/DD/YYYY hh:mm A"),
	            canEdit: that.canEdit,
	            canUploadForOrganizationInDocument: that.canUploadForOrganizationInDocument,
	            status: that.utils.getDocumentStatus(that.model.get('object').status),
	            intention: that.utils.getIntention(that.model.get('object').intention || "UNASSIGNED"),
	            uploaderId: that.model.get('object').uploaderPersonId,
	            uploaderName: _.isEmpty(uploaderPersonName) ? "" : uploaderPersonName,
	            isMd: that.getOption('isMd'),
	            isDocumentCreator: (that.model.get('createdBy') || {}).id == that.getOption('userId'),
	            byAdmin: that.getOption('byAdmin')
	        }
	    },
	
	    initialize: function (options) {
	        this.utils = new CommonUtils();
	        this.model = options.model;
	        this.canEdit = options.canEdit;
	        this.canUploadForOrganizationInDocument = options.canUploadForOrganizationInDocument;
	        this.createdDate = this.model.get('object').createdTime;
	    },
	
	    onRender: function () {
	        var that = this;
	        this.showChildView('removeConfirmationModal',
	            new DeleteConfirmationModal({
	                message: 'Enter: "confirm" if you agree to remove the document.',
	                confirmationAnswer: 'confirm'
	            }));
	        this.ui.createdDate.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'MM/DD/YYYY hh:mm A',
	            defaultDate: that.utils.getDateWithoutTime(new Date(that.model.get('object').createdTime))
	        });
	        that.ui.createdDate.on("dp.change", function (e) {
	            if (e.date) {
	                that.createdDate = e.date.valueOf();
	            } else {
	                that.createdDate = 0;
	            }
	        });
	
	        that.checkAndGetMetadata();
	    },
	
	    removeDocument: function () {
	        this.$('#delete-confirmation-modal').modal();
	    },
	
	    deleteConfirmed: function (value) {
	        if (value == true) {
	            var that = this;
	            this.model.destroy({
	                dataType: "text",
	                success: function () {
	                    that.remove();
	                    that.unbind();
	                    Backbone.history.navigate('/documents', {
	                        trigger: true
	                    });
	                }
	            });
	        }
	    },
	
	    onEditDueTime: function () {
	        var that = this;
	        that.showChildView('setDueFormModal', new SetDocumentDueForm({
	            docIds: [this.model.get('id')]
	        }));
	    },
	
	    onDueSet: function (data) {
	        if (data.documentsIdWithErrors && data.documentsIdWithErrors.length > 0) {
	            $.notify("You do not have permissions for update this document", "error");
	        } else {
	            this.ui.dueTimeLabel.text(this.utils.longToDateTimeFormatted(data.selectedDate, "MM/DD/YYYY hh:mm A"));
	        }
	    },
	
	    editCreatedTime: function () {
	        this.ui.createdDateForm.show();
	        this.ui.createdDateDisplayContainer.hide();
	    },
	
	    saveCreatedDate: function () {
	        var that = this;
	        this.utils.showSpinner("#save-loader");
	        $.ajax({
	            type: "POST",
	            url: '/api/document/' + that.model.get('id') + '/created/' + that.createdDate,
	            contentType: 'application/json',
	            statusCode: {
	                200: function () {
	                    that.utils.hideSpinner("#save-loader");
	                    that.ui.createdDateForm.hide();
	                    that.ui.createdDateDisplayContainer.show();
	                    that.ui.createdDateDisplay.html(that.utils.longToDateTimeFormatted(that.createdDate, "MM/DD/YYYY hh:mm A"));
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner("#save-loader");
	                that.ui.createdDateForm.hide();
	                that.ui.createdDateDisplayContainer.show();
	                notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        });
	    },
	
	    cancelCreatedDate: function () {
	        this.ui.createdDateForm.hide();
	        this.ui.createdDateDisplayContainer.show();
	    },
	
	    addEditMetadata: function () {
	        var that = this;
	
	        that.showChildView('addMetaFormRegion', new DocumentMetaModal({
	            documentId: that.model.get('id'),
	            meta: that.metadata ? that.metadata.meta : that.utils.initialMeta(),
	            metadataId: that.metadata ? that.metadata.id : null,
	            successCallback: function () {
	                that.checkAndGetMetadata()
	            }
	        }));
	    },
	
	    checkAndGetMetadata: function () {
	
	        var that = this;
	
	        $.ajax({
	            type: "GET",
	            url: '/api/document/meta/' + that.model.get('id'),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    that.ui.addEditMetadata.text(that.constants.editMetaTitle);
	                    that.metadata = response;
	                },
	                404: function (response) {
	                    that.ui.addEditMetadata.text(that.constants.addMetaTitle);
	                    that.metadata = null;
	                }
	            },
	            error: function (e) {
	                console.log(e);
	            }
	        });
	    }
	
	});
	
	module.exports = DocumentData;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	
	var DocumentMetaForm = __webpack_require__(395);
	
	var DocumentMetaModal = Marionette.View.extend({
	    template: __webpack_require__(397),
	
	    regions: {
	        documentMetaForm: '#document-meta-form'
	    },
	
	    ui: {
	        modal: '#addMetaModal',
	        saveMeta: '#save',
	    },
	
	    events: {
	        'click @ui.saveMeta': 'saveMeta',
	    },
	
	    childViewEvents: {
	        'meta:saved': 'onMetaSaved',
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            metadataId: that.metadataId
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.utils = new CommonUtils();
	
	        that.meta = options.meta;
	        that.metadataId = options.metadataId;
	        that.documentId = options.documentId;
	        that.successCallback = options.successCallback;
	    },
	
	    onRender: function () {
	        var that = this;
	        that.show();
	
	        that.showChildView('documentMetaForm', new DocumentMetaForm({
	            documentId: that.documentId,
	            meta: that.meta,
	            metadataId: that.metadataId,
	            successCallback: that.successCallback
	        }));
	    },
	
	    saveMeta: function () {
	      this.getChildView('documentMetaForm').saveMeta();
	    },
	
	    show: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    },
	
	    onMetaSaved: function () {
	        this.hide();
	    }
	});
	
	module.exports = DocumentMetaModal;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	var DocumentMetaDicts = __webpack_require__(194);
	
	var DocumentMetaForm = Marionette.View.extend({
	    template: __webpack_require__(396),
	
	    regions: {},
	
	    ui: {
	        metaVal: '.meta-val',
	        metaValues: '.meta-values',
	        dateField: '.date-value',
	
	        addValueControl: '.add-value',
	        removeValueControl: '.remove-value',
	
	        expandAll: "#expand-all",
	        collapseAll: "#collapse-all",
	        expandRequired: "#expand-required",
	        expandFilled: "#expand-filled",
	
	        panelCollapse: ".panel-collapse"
	    },
	
	    events: {
	        'change @ui.metaVal': 'onChangeMetaVal',
	        'click @ui.addValueControl': 'addValue',
	        'click @ui.removeValueControl': 'removeValue',
	
	        'click @ui.expandAll': 'onExpandAll',
	        'click @ui.collapseAll': 'onCollapseAll',
	        'click @ui.expandRequired': 'onExpandRequired',
	        'click @ui.expandFilled': 'onExpandFilled',
	    },
	
	    childViewEvents: {},
	
	    templateContext: function () {
	        var that = this;
	        return {
	            getFieldTitle: function (field) {
	                return DocumentMetaDicts.documentMetaFields[field]
	            },
	            getPredefinedMetaCodesOrCodeNames: function (key, selectedValue, index) {
	                var result = that.utils.getPredefinedMetaCodesOrCodeNames(key, index);
	
	                if (!_.contains(result, selectedValue))
	                    result.push(selectedValue);
	
	                return result;
	            },
	            isMultipleValueAllowed: function (field) {
	                return _.contains(["sourcePatientInfo", "authorInstitution", "authorRole", "authorSpecialty", "eventCode", "intendedRecipient"], field);
	            },
	            addMoreValuesText: "Add more values",
	            getMimeTypes: function (selected) {
	                var mimeTypes = DocumentMetaDicts.documentMimeTypes;
	                if (!_.contains(mimeTypes, selected))
	                    mimeTypes.push(selected);
	                return mimeTypes;
	            },
	            requiredDocumentMetaFields: function (field) {
	                var found = _.findWhere(DocumentMetaDicts.requiredDocumentMetaFields, {field: field});
	                return found ? '<span style="color: red">*</span>' : "";
	            },
	            requiredDocumentMetaFieldsValues: function (field, subfield) {
	                var found = _.findWhere(DocumentMetaDicts.requiredDocumentMetaFields, {field: field});
	                return found && _.contains(found.required, subfield) ? '<span style="color: red">*</span>' : "";
	            }
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.utils = new CommonUtils();
	
	        that.model = new Backbone.Model({
	            meta: options.meta,
	            metadataId: options.metadataId,
	            documentId: options.documentId
	        });
	
	        that.successCallback = options.successCallback;
	    },
	
	    onRender: function () {
	        var that = this;
	
	        this.$(that.ui.metaValues).selectize({
	            createOnBlur: true,
	            create: true,
	            inputClass: 'form-control selectize-input normal-width'
	        });
	
	        that.ui.dateField.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'YYYYMMDDHHmmss'
	        });
	        that.ui.dateField.on("dp.change", function (e) {
	            that.onChangeMetaVal(e);
	        }).on('dp.show', function () {
	            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(new Date()));
	        });
	
	        that.hideCollapseButtons();
	    },
	
	    onChangeMetaVal: function (event) {
	        var that = this;
	        var val = event.target.value;
	        var nameAndIndex = event.target.id.split(' ');
	        var name = nameAndIndex[0];
	        var index = nameAndIndex[1];
	        var valueIndex = nameAndIndex[2];
	
	        var meta = that.model.get('meta');
	        if (name === 'value') {
	            meta[index][name][valueIndex] = val;
	        } else {
	            meta[index][name] = val;
	        }
	
	        that.model.set('meta', meta);
	    },
	
	    saveMeta: function () {
	
	        var that = this;
	
	        var meta = that.model.get('meta');
	        console.log(meta);
	        var documentId = that.model.get('documentId');
	        var metadataId = that.model.get('metadataId');
	
	        if (metadataId) {
	
	            $.ajax({
	                type: "PUT",
	                url: '/api/document/meta/' + documentId + '/' + metadataId,
	                data: JSON.stringify(meta),
	                contentType: 'application/json',
	                statusCode: {
	                    200: function (response) {
	                        that.triggerMethod('meta:saved');
	                        $.notify("Document meta was updated successfully", "success");
	
	                        if (_.isFunction(that.successCallback))
	                            that.successCallback();
	                    }
	                },
	                error: function (e) {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            });
	        } else {
	
	            $.ajax({
	                type: "POST",
	                url: '/api/document/meta/' + documentId,
	                data: JSON.stringify(meta),
	                contentType: 'application/json',
	                statusCode: {
	                    200: function (response) {
	                        that.triggerMethod('meta:saved');
	                        $.notify("Document meta was added successfully", "success");
	
	                        if (_.isFunction(that.successCallback))
	                            that.successCallback();
	                    }
	                },
	                error: function (e) {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            });
	        }
	    },
	
	    addValue: function (event) {
	        var that = this;
	        var ids = event.target.id.split(' ');
	        var index = ids[1];
	        var meta = that.model.get('meta');
	        meta[index]['value'].push("");
	        that.model.set('meta', meta);
	        that.reRender(meta[index].field, index, $(event.target).offset().top);
	    },
	
	    removeValue: function (event) {
	        var ids = event.target.id.split(' ');
	        var index = ids[1];
	        var valueIndex = ids[2];
	        var meta = this.model.get('meta');
	        meta[index]['value'].splice(valueIndex, 1);
	        this.model.set('meta', meta);
	        this.reRender(meta[index].field, index, $(event.target).offset().top);
	    },
	
	    reRender: function (fieldName, index, topPosition) {
	        this.render();
	        window.setTimeout(function () {
	            $('#' + fieldName + index).collapse('toggle');
	            $('html, body').animate({
	                scrollTop: topPosition
	            }, 1000);
	        }, 0);
	    },
	
	    onExpandAll: function () {
	        this.ui.panelCollapse.collapse("show");
	        this.hideExpandButtons();
	        this.showCollapseButtons();
	    },
	
	    onCollapseAll: function () {
	        this.ui.panelCollapse.collapse("hide");
	        this.hideCollapseButtons();
	        this.showExpandButtons();
	    },
	
	    onExpandRequired: function () {
	        this.ui.panelCollapse.each(function (i, element) {
	            var self = $(this);
	            var id = element.id;
	            var fieldName = id.replace(i, "");
	            if (_.findWhere(DocumentMetaDicts.requiredDocumentMetaFields, {field: fieldName})) {
	                self.collapse('show');
	            }
	        });
	        this.hideExpandButtons();
	        this.showCollapseButtons();
	    },
	
	    onExpandFilled: function () {
	        var that = this;
	        var meta = that.model.get('meta');
	
	        this.ui.panelCollapse.each(function (i, element) {
	            var self = $(this);
	            var id = element.id;
	            var fieldName = id.replace(i, "");
	            var metaForField = meta[i];
	            if (!_.isEmpty(metaForField.codingScheme) || !_.isEmpty(metaForField.description) || !_.isEmpty(metaForField.nameLocalizedString)
	                || !_.isEmpty(metaForField.nodeRepresentation) || !_.isEmpty(metaForField.related) || !_.isEmpty(metaForField.slotName)
	                || (!_.isEmpty(metaForField.value) && metaForField.value.filter(function (v) {
	                    return !_.isEmpty(v);
	                }).length > 0)) {
	                self.collapse('show');
	            }
	        });
	        this.hideExpandButtons();
	        this.showCollapseButtons();
	    },
	
	    hideExpandButtons: function () {
	        this.ui.expandAll.hide();
	        this.ui.expandRequired.hide();
	        this.ui.expandFilled.hide();
	    },
	
	    showExpandButtons: function () {
	        this.ui.expandAll.show();
	        this.ui.expandRequired.show();
	        this.ui.expandFilled.show();
	    },
	
	    hideCollapseButtons: function () {
	        this.ui.collapseAll.hide();
	    },
	
	    showCollapseButtons: function () {
	        this.ui.collapseAll.show();
	    },
	});
	
	module.exports = DocumentMetaForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form form-inline">\n    <button class="btn btn-primary btn-sm" id="expand-all">Expand All</button>\n    <button class="btn btn-primary btn-sm" id="collapse-all">Collapse All</button>\n    <button class="btn btn-primary btn-sm" id="expand-required">Expand Required</button>\n    <button class="btn btn-primary btn-sm" id="expand-filled">Expand Filled</button>\n</div>\n\n<div id="document-meta-content" class="panel-group top-margined">\n    ';
	 _.each(meta, function(item, index){ 
	__p+='\n    <div class="panel panel-info">\n        <div class="panel-heading">\n            <h4 class="panel-title">\n                <a data-toggle="collapse" data-parent="#document-meta-content" href="#'+
	((__t=( item.field + index ))==null?'':__t)+
	'">\n                    '+
	((__t=( getFieldTitle(item.field) ))==null?'':__t)+
	' '+
	((__t=( requiredDocumentMetaFields(item.field) ))==null?'':__t)+
	'\n                </a>\n            </h4>\n        </div>\n        <div id="'+
	((__t=( item.field + index ))==null?'':__t)+
	'" class="panel-collapse collapse">\n            <div class="panel-body">\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Related '+
	((__t=( requiredDocumentMetaFieldsValues(item.field, "related") ))==null?'':__t)+
	'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <input class="form-control meta-val" type="text" id="'+
	((__t=( 'related' + ' ' + index ))==null?'':__t)+
	'" value="'+
	((__t=( item.related ))==null?'':_.escape(__t))+
	'">\n                    </div>\n                </div>\n\n                ';
	 if (item.field == 'classCode' || item.field == 'confidentialityCode' || item.field == 'formatCode' || item.field == 'healthcareFacilityTypeCode'
	                || item.field == 'practiceSettingCode' || item.field == 'typeCode') { 
	__p+='\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Node representation '+
	((__t=( requiredDocumentMetaFieldsValues(item.field, "nodeRepresentation") ))==null?'':__t)+
	'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <select id="'+
	((__t=( 'nodeRepresentation' + ' ' + index ))==null?'':__t)+
	'" class="meta-val meta-values">\n                            ';
	 _.each(getPredefinedMetaCodesOrCodeNames(item.field, item.nodeRepresentation, 1), function(code){ 
	__p+='\n                            <option value="'+
	((__t=( code ))==null?'':__t)+
	'" ';
	if (code == item.nodeRepresentation) {
	__p+=' selected ';
	 } 
	__p+=' >'+
	((__t=( code ))==null?'':__t)+
	'</option>\n                            ';
	 }) 
	__p+='\n                        </select>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Name (localized string) '+
	((__t=( requiredDocumentMetaFieldsValues(item.field, "nameLocalizedString") ))==null?'':__t)+
	'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <select id="'+
	((__t=( 'nameLocalizedString' + ' ' + index ))==null?'':__t)+
	'" class="meta-val meta-values">\n                            ';
	 _.each(getPredefinedMetaCodesOrCodeNames(item.field, item.nameLocalizedString, 0), function(code){ 
	__p+='\n                            <option value="'+
	((__t=( code ))==null?'':__t)+
	'" ';
	if (code == item.nameLocalizedString) {
	__p+=' selected ';
	 } 
	__p+=' >'+
	((__t=( code ))==null?'':__t)+
	'</option>\n                            ';
	 }) 
	__p+='\n                        </select>\n                    </div>\n                </div>\n                ';
	 } else { 
	__p+='\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Node representation '+
	((__t=( requiredDocumentMetaFieldsValues(item.field, "nodeRepresentation") ))==null?'':__t)+
	'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <input class="form-control meta-val" type="text" id="'+
	((__t=( 'nodeRepresentation' + ' ' + index ))==null?'':__t)+
	'" value="'+
	((__t=( item.nodeRepresentation ))==null?'':_.escape(__t))+
	'">\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Name (localized string) '+
	((__t=( requiredDocumentMetaFieldsValues(item.field, "nameLocalizedString") ))==null?'':__t)+
	'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <input class="form-control meta-val" type="text" id="'+
	((__t=( 'nameLocalizedString' + ' ' + index ))==null?'':__t)+
	'" value="'+
	((__t=( item.nameLocalizedString ))==null?'':_.escape(__t))+
	'">\n                    </div>\n                </div>\n                ';
	 } 
	__p+='\n\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Slot name '+
	((__t=( requiredDocumentMetaFieldsValues(item.field, "slotName") ))==null?'':__t)+
	'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <input class="form-control meta-val" type="text" id="'+
	((__t=( 'slotName' + ' ' + index ))==null?'':__t)+
	'" value="'+
	((__t=( item.slotName ))==null?'':_.escape(__t))+
	'">\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Coding scheme '+
	((__t=( requiredDocumentMetaFieldsValues(item.field, "codingScheme") ))==null?'':__t)+
	'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <input class="form-control meta-val" type="text" id="'+
	((__t=( 'codingScheme' + ' ' + index ))==null?'':__t)+
	'" value="'+
	((__t=( item.codingScheme ))==null?'':_.escape(__t))+
	'">\n                    </div>\n                </div>\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Description '+
	((__t=( requiredDocumentMetaFieldsValues(item.field, "description") ))==null?'':__t)+
	'</label>\n                    <div class="col-xs-8 col-md-8">\n                        <input class="form-control meta-val" type="text" id="'+
	((__t=( 'description' + ' ' + index ))==null?'':__t)+
	'" value="'+
	((__t=( item.description ))==null?'':_.escape(__t))+
	'">\n                    </div>\n                </div>\n\n                ';
	 _.each(item.value, function(v, valueIndex){ 
	__p+='\n                <div class="form-group">\n                    <label class="col-xs-3 col-md-3 control-label">Value '+
	((__t=( requiredDocumentMetaFieldsValues(item.field, "value") ))==null?'':__t)+
	'</label>\n                    <div class="col-xs-8 col-md-8">\n                        ';
	 if (item.field == 'mimeType') { 
	__p+='\n                        <select id="'+
	((__t=( 'value' + ' ' + index + ' ' + valueIndex ))==null?'':__t)+
	'" class="meta-val meta-values">\n                            ';
	 _.each(getMimeTypes(item.value[valueIndex]), function(mimeType){ 
	__p+='\n                            <option value="'+
	((__t=( mimeType ))==null?'':__t)+
	'" ';
	if (mimeType == item.value[valueIndex]) {
	__p+=' selected ';
	 } 
	__p+=' >'+
	((__t=( mimeType ))==null?'':__t)+
	'</option>\n                            ';
	 }) 
	__p+='\n                        </select>\n                        ';
	 } else if (item.field == 'creationTime' || item.field == 'serviceStartTime' || item.field == 'serviceStopTime') { 
	__p+='\n                        <input class="form-control meta-val date-value" type="text" id="'+
	((__t=( 'value' + ' ' + index + ' ' + valueIndex ))==null?'':__t)+
	'" value="'+
	((__t=( item.value[valueIndex] ))==null?'':_.escape(__t))+
	'">\n                        ';
	 } else {
	__p+='\n                        <input class="form-control meta-val" type="text" id="'+
	((__t=( 'value' + ' ' + index + ' ' + valueIndex ))==null?'':__t)+
	'" value="'+
	((__t=( item.value[valueIndex] ))==null?'':_.escape(__t))+
	'">\n                        ';
	 } 
	__p+='\n                    </div>\n\n                    ';
	 if (isMultipleValueAllowed(item.field)) { 
	__p+='\n                        ';
	 if (valueIndex === item.value.length - 1) { 
	__p+='\n                        <div class="col-xs-1 col-md-1">\n                                                <span class="glyphicon glyphicon-plus-sign clickable control-label add-value"\n                                                      id="'+
	((__t=( 'add_value' + ' ' + index ))==null?'':__t)+
	'" title="'+
	((__t=( addMoreValuesText ))==null?'':__t)+
	'"/>\n                        </div>\n                        ';
	 } else { 
	__p+='\n                        <div class="col-xs-1 col-md-1">\n                                                    <span class="glyphicon glyphicon-minus-sign clickable control-label remove-value"\n                                                          id="'+
	((__t=( 'remove_value' + ' ' + index + ' ' + valueIndex ))==null?'':__t)+
	'"/>\n                        </div>\n                        ';
	 } 
	__p+='\n                    ';
	 } 
	__p+='\n\n                </div>\n\n                ';
	 }) 
	__p+='\n\n            </div>\n        </div>\n    </div>\n    ';
	 }) 
	__p+='\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 397 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<!-- Document meta form Modal -->\n<div class="modal fade" id="addMetaModal" tabindex="-1" role="dialog" aria-labelledby="addMetaModal">\n    <div class="modal-dialog modal-lg" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\n                        aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title" id="addMetaModalLabel">'+
	((__t=( (metadataId ? 'Edit metadata' : 'Add metadata') ))==null?'':__t)+
	'</h4>\n            </div>\n            <div class="modal-body">\n                <div id="document-meta-form"></div>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-primary" id="save">Save</button>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 398 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row">\r\n    <div class="col-xs-1 col-md-1">\r\n        <h3>\r\n            <a href="/api/document/download/'+
	((__t=( id ))==null?'':__t)+
	'">\r\n                <span class="clickable glyphicon glyphicon-floppy-disk"/>\r\n            </a>\r\n            <a href="/api/document/view/'+
	((__t=( id ))==null?'':__t)+
	'" target="_blank">\r\n                <span class="clickable glyphicon glyphicon-eye-open"/>\r\n            </a>\r\n        </h3>\r\n    </div>\r\n    <div class="col-xs-8 col-md-8">\r\n        <h3>\r\n            <a class="dotted-link" data-toggle="collapse" data-target="#document-lifetimes">'+
	((__t=( name ))==null?'':__t)+
	'</a>\r\n            (Status: '+
	((__t=( status ))==null?'':__t)+
	', Request: '+
	((__t=( intention ))==null?'':__t)+
	')\r\n        </h3>\r\n    </div>\r\n\r\n    <div class="col-xs-3 col-md-3">\r\n        ';
	 if ((canEdit() || canUploadForOrganizationInDocument()) && isMd || isDocumentCreator || byAdmin) { 
	__p+='\r\n        <button type="button" class="btn btn-danger" style="float: right;margin-top: 16px;" id="remove-document">Remove document</button>\r\n        <button type="button" class="btn btn-info" style="float: right;margin-top: 16px;margin-right: 4px;" id="add-edit-metadata">Add metadata</button>\r\n        ';
	 } 
	__p+='\r\n    </div>\r\n</div>\r\n<div class="row">\r\n    <div class="collapse col-md-5 col-xs-5 top-margined" id="document-lifetimes">\r\n        <div id="save-loader" class="loader" style="height: 200px;"></div>\r\n        ';
	 if (uploaderId) { 
	__p+='\r\n        <div class="form-group col-md-4 col-xs-4">\r\n            <label>Uploaded By</label>\r\n        </div>\r\n        <div class="form-group col-md-8 col-xs-8">\r\n            <label><a href="/#person/'+
	((__t=( uploaderId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( uploaderName ))==null?'':__t)+
	'</a></label>\r\n        </div>\r\n        ';
	 } 
	__p+='\r\n        <div class="form-group col-md-4 col-xs-4">\r\n            <label>Uploaded Time</label>\r\n        </div>\r\n        <div class="form-group col-md-8 col-xs-8">\r\n            <label>'+
	((__t=( fmUploadedTime ))==null?'':__t)+
	'</label>\r\n        </div>\r\n        <div class="form-group col-md-4 col-xs-4">\r\n            <label>Created Time</label>\r\n        </div>\r\n        <div class="form-group col-md-8 col-xs-8" id="created-date-display-container">\r\n            <label>\r\n                    <span id="created-date-display">\r\n                        '+
	((__t=( fmCreatedTime ))==null?'':__t)+
	'\r\n                    </span>\r\n                ';
	 if (canEdit()) { 
	__p+='\r\n                <span class="glyphicon glyphicon-edit clickable" style="margin-left: 10px;" title="Edit" id="edit-created-time"></span>\r\n                ';
	 } 
	__p+='\r\n            </label>\r\n        </div>\r\n\r\n        <div class="form-group col-md-8 col-xs-8" style="display: none" id="created-date-form">\r\n            <label>\r\n                ';
	 if (canEdit()) { 
	__p+='\r\n                <form class="form-inline">\r\n                    <div class="form-group">\r\n                        <input type="text" class="form-control" id="created-date" placeholder="Select created date">\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <button type="button" class="btn btn-success" id="save-created-date">Save</button>\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <button type="button" class="btn btn-default" id="cancel-created-date">Cancel</button>\r\n                    </div>\r\n                </form>\r\n                ';
	 } 
	__p+='\r\n            </label>\r\n        </div>\r\n        <div class="form-group col-md-4 col-xs-4">\r\n            <label>Due Time</label>\r\n        </div>\r\n        <div class="form-group col-md-8 col-xs-8">\r\n            <label id="due-time">'+
	((__t=( fmDueTime ))==null?'':__t)+
	'</label>\r\n            ';
	 if (canEdit()) { 
	__p+='\r\n            <span class="glyphicon glyphicon-edit clickable" style="margin-left: 10px;" title="Edit" id="edit-due-time"></span>\r\n            ';
	 } 
	__p+='\r\n        </div>\r\n        ';
	 if (object.signedTime > 0) { 
	__p+='\r\n        <div class="form-group col-md-4 col-xs-4">\r\n            <label>Signed time</label>\r\n        </div>\r\n        <div class="form-group col-md-8 col-xs-8">\r\n            <label>'+
	((__t=( fmSignedTime ))==null?'':__t)+
	'</label>\r\n        </div>\r\n        ';
	 } 
	__p+='\r\n    </div>\r\n</div>\r\n<div class="delete-confirmation-modal"></div>\r\n<div id="set-due-form-modal"></div>\r\n<div id="add-meta-form"></div>';
	}
	return __p;
	};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	var Document = __webpack_require__(207);
	var DocumentType = __webpack_require__(400);
	var CommonUtils = __webpack_require__(189);
	var EntitiesSelectView = __webpack_require__(226);
	var DocumentTypesCollection = __webpack_require__(401);
	var Radio = __webpack_require__(183);
	
	var notificationsChannel = Radio.channel('notifications');
	
	
	var DocumentSignData = Marionette.View.extend({
	    template: __webpack_require__(402),
	
	    model: new Document(),
	
	    regions:{
	        docTypes: '#doc-types-list'
	    },
	
	    childViewEvents:{
	        'entity:selected': 'entitySelected'
	    },
	
	    ui: {
	        settings: '#settings',
	        signsLimit: '#signs-limit',
	        signX: '#sign-x',
	        signY: '#sign-y',
	        signWidth: '#sign-width',
	        pagesToSign: '#pages-to-sign',
	        signAllPages: '#sign-all-pages',
	        cancelBtn: '#cancel',
	        saveBtn: '#save',
	        previewBtn: '#preview'
	    },
	
	    events: {
	        'click @ui.cancelBtn': 'cancel',
	        'click @ui.saveBtn': 'saveDocumentSignData',
	        'click @ui.previewBtn': 'previewDocument',
	        'click @ui.signAllPages': 'disablePagesToSignElement',
	        'change input': 'onInputChange',
	        'keyup input': 'onInputChange',
	        'keypress input[type=number]': 'onKeyPress'
	    },
	
	    signSettings: {},
	
	    templateContext: function () {
	        var that = this;
	        return {
	            canEdit: function() { return that.canEdit(); }
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'cancel', 'disablePagesToSignElement', 'saveDocumentSignData', 'onInputChange', 'previewDocument',
	            'buildSignSettingsObject', 'onKeyPress', 'findModel', 'fillForm');
	        this.model = options.model;
	        this.canEdit = options.canEdit;
	        this.utils = new CommonUtils();
	        this.docTypesCollection = new DocumentTypesCollection([], {params:
	            [{key: 'sortby', value: 'name'}, {key: 'sortdir', value: 'ASC'}]
	        });
	        this.documentTypeModelDefault = new DocumentType();
	    },
	
	    onRender: function () {
	        var that = this;
	        if (that.model.get('object').signSettings.signAllPages)
	            that.ui.pagesToSign.attr('disabled', 'disabled');
	
	        that.docTypesCollection.fetch({success: function() {
	            that.documentTypeSelectView = new EntitiesSelectView({
	                entityType: 'documentType',
	                customPlaceholder: 'Select a document type',
	                collectionValues: that.docTypesCollection
	            });
	            that.showChildView('docTypes', that.documentTypeSelectView);
	        }});
	    },
	
	    onInputChange: function() {
	        this.ui.saveBtn.removeAttr("disabled");
	    },
	
	    cancel: function () {
	    },
	
	    buildSignSettingsObject: function() {
	        this.signSettings.signsLimit = this.ui.signsLimit.val();
	        this.signSettings.signX = this.ui.signX.val();
	        this.signSettings.signY = this.ui.signY.val();
	        this.signSettings.signWidth = this.ui.signWidth.val();
	        if (this.signSettings.signAllPages)
	            this.signSettings.pagesToSign = '';
	        else
	            this.signSettings.pagesToSign = this.ui.pagesToSign.val();
	
	        return this.signSettings;
	    },
	
	    previewDocument: function() {
	        var signSettingsflat = JSON.stringify(this.buildSignSettingsObject());
	        window.open('/api/document/preview/' + this.model.get('id') + '?settings=' + signSettingsflat, '_blank');
	    },
	
	    saveDocumentSignData: function () {
	        var that =this;
	        var object = that.model.get('object');
	        object.signSettings = this.buildSignSettingsObject();
	
	        // remove unnessesary fields in inner objects - start
	        if (that.model.get('createdBy')) {
	            delete that.model.get('createdBy')["object"];
	            delete that.model.get('createdBy')["permissions"];
	            delete that.model.get('createdBy')["relations"];
	        }
	        (that.model.get('relations') || []).forEach(function(item) {
	            var child = item.child;
	            delete child["object"];
	            delete child["permissions"];
	            delete child["relations"];
	        });
	        // remove unnessesary fields in inner objects - end
	
	        that.model.save(that.model.toJSON(), {
	            success: function() {
	                that.ui.saveBtn.attr("disabled", "true");
	            },
	            error: function(model, xhr, options) {
	                notificationsChannel.request('show:notification', xhr.responseText);
	            }
	        });
	    },
	
	    disablePagesToSignElement: function (event) {
	        if (event.target.checked) {
	            this.ui.pagesToSign.attr('disabled', 'disabled');
	            this.signSettings.signAllPages  = true;
	            //this.model.get('object').signSettings.signAllPages = true;
	        }
	        else {
	            this.ui.pagesToSign.removeAttr('disabled');
	            this.signSettings.signAllPages  = false;
	            //this.model.get('object').signSettings.signAllPages = false;
	        }
	    },
	
	    onKeyPress: function (event) {
	        return event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 37 || event.keyCode == 39 ||
	            event.charCode >= 48 && event.charCode <= 57;
	    },
	
	    entitySelected: function(data) {
	        this.findModel(data.id);
	        this.onInputChange();
	    },
	
	    findModel: function(id) {
	        var selectedDocumentType = this.docTypesCollection.findWhere({id: id});
	        if (selectedDocumentType != null) {
	            this.fillForm(selectedDocumentType.get('object'));
	        } else {
	            this.fillForm(this.documentTypeModelDefault.get('object'));
	        }
	    },
	
	    fillForm: function(signSettings) {
	        this.ui.signsLimit.val(signSettings.signsLimit);
	        this.ui.signX.val(signSettings.signX);
	        this.ui.signY.val(signSettings.signY);
	        this.ui.signWidth.val(signSettings.signWidth);
	    }
	
	});
	
	module.exports = DocumentSignData;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(181);
	
	
	var DocumentTypeModel = Backbone.Model.extend({
	
	    urlRoot: '/api/document/type',
	
	    defaults: {
	        id: undefined,
	        organizationId: undefined,
	        name: undefined,
	        object: {
	            signsLimit: 1,
	            signX: 105,
	            signY: 40,
	            signWidth: 400
	        }
	    },
	
	});
	
	
	module.exports = DocumentTypeModel;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	
	var DocumentTypesCollection = BaseCollection.extend({
	    url:"/api/document/type",
	
	    initialize: function(models, options){
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    }
	});
	
	
	module.exports = DocumentTypesCollection;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\r\n';
	 if (object) { 
	__p+='\r\n<div class="row">\r\n    <div class="col-xs-6 col-md-6">\r\n        <div id="settings">\r\n            <div class="form-horizontal" style="margin-top: 10px;">\r\n                <div>\r\n                    <div class="form-group">\r\n                        <div id="doc-types-list" class="col-md-12" style="margin: 20px 20px 20px 20px;"></div>\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <label class="col-sm-6 col-md-6 control-label" for="signs-limit">Sign limit</label>\r\n                        <div class="col-sm-6 col-md-6">\r\n                            <input class="form-control" type="number" id="signs-limit"\r\n                                   value="'+
	((__t=( object.signSettings.signsLimit ))==null?'':_.escape(__t))+
	'">\r\n                        </div>\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <label class="col-sm-6 col-md-6 control-label" for="sign-x">Sign-X</label>\r\n                        <div class="col-sm-6 col-md-6">\r\n                            <input class="form-control" type="number" id="sign-x"\r\n                                   value="'+
	((__t=( object.signSettings.signX ))==null?'':_.escape(__t))+
	'">\r\n                        </div>\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <label class="col-sm-6 col-md-6 control-label" for="sign-y">Sign-Y</label>\r\n                        <div class="col-sm-6 col-md-6">\r\n                            <input class="form-control" type="number" id="sign-y"\r\n                                   value="'+
	((__t=( object.signSettings.signY ))==null?'':_.escape(__t))+
	'">\r\n                        </div>\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <label class="col-sm-6 col-md-6 control-label" for="sign-width">Sign width</label>\r\n                        <div class="col-sm-6 col-md-6">\r\n                            <input class="form-control" type="number" id="sign-width"\r\n                                   value="'+
	((__t=( object.signSettings.signWidth ))==null?'':_.escape(__t))+
	'">\r\n                        </div>\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <label class="col-sm-6 col-md-6 control-label" for="pages-to-sign">Pages for sign</label>\r\n                        <div class="col-sm-6 col-md-6">\r\n                            <input class="form-control" type="text" id="pages-to-sign"\r\n                                   title="List of pages comma separated. E.g. 1,2,7,9."\r\n                                   value="'+
	((__t=( object.signSettings.pagesToSign ))==null?'':_.escape(__t))+
	'">\r\n                        </div>\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <label class="col-sm-6 col-md-6 control-label" for="sign-all-pages">Sign all pages</label>\r\n                        <div class="col-sm-6 col-md-6">\r\n                            <div class="checkbox">\r\n                                <label><input type="checkbox" value="" id="sign-all-pages" ';
	 if (object.signSettings.signAllPages == true) { 
	__p+=' checked ';
	 } 
	__p+=' ></label>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class="form-group">\r\n                        <div class="right">\r\n                            <button type="button" class="btn btn-primary" id="preview">Preview</button>\r\n                            <button type="button" class="btn btn-primary" id="save" disabled>Save changes</button>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n';
	 } 
	__p+='';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(181);
	
	
	var ReviewRequestModel = Backbone.Model.extend({
	    defaults: {
	        id: undefined,
	        name: 'Review Request',
	        object: {
	            reviewRequestElements: [],
	            requesterOrganizationId: undefined
	        },
	        createdBy: undefined
	    },
	
	    urlRoot: '/api/review',
	
	    validate: function(attrs) {
	        var errors = [];
	        var hasError = false;
	        if (!attrs.object || !attrs.object.reviewRequestElements || attrs.object.reviewRequestElements.length == 0) {
	            errors.push('Review Request data is empty');
	            hasError = true;
	        }
	        else {
	            attrs.object.reviewRequestElements.forEach(function(item, indx) {
	                var docIndex = indx + 1;
	                if (item.documentId == undefined || item.documentId == '') {
	                    errors.push('Document name was not selected for ' + docIndex+ '- Document');
	                    hasError = true;
	                }
	                if (!item.reviewers || item.reviewers.length == 0) {
	                    errors.push('Reviewers were not selected for ' + docIndex + '- Document');
	                    hasError = true;
	                }
	                item.reviewers.forEach(function(revItem, indx2) {
	                    var reviewersIndex = indx2 + 1;
	                    if ((!revItem.organizationId || revItem.organizationId == '') && (!revItem.personId || revItem.personId == '')) {
	                        errors.push('Organization or Person were not selected for ' + reviewersIndex + '- group of Reviewers of ' + docIndex + ' Document');
	                        hasError = true;
	                    }
	                });
	            });
	        }
	
	        if (hasError) {
	            return errors;
	        }
	    },
	
	    sync: function (method, model, options) {
	        (model.get('object').reviewRequestElements || []).forEach(function(element){
	            delete element['documentName'];
	        });
	        //delete model.get('createdBy')['relations'];
	        options.attrs = model.attributes;
	        return Backbone.sync.call(this, method, model, options);
	    }
	
	});
	
	
	module.exports = ReviewRequestModel;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var ReviewerSelectView = __webpack_require__(405);
	var YesNoConfirmationModal = __webpack_require__(237);
	var PasswordConfirmation = __webpack_require__(312);
	
	var EntityModel = __webpack_require__(228);
	
	var CommonUtils = __webpack_require__(189);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var DocumentReviewersView = Marionette.View.extend({
	    template: __webpack_require__(407),
	
	    regions: {
	        passwordConfirmationDiv: '.password-confirmation-div',
	        obsoleteConfirmationModal: '#obsolete-confirmation-modal'
	    },
	
	    events: {
	        'click #sign': 'setStatusToSignOrView',
	        'click #delete': 'setStatusToDelete',
	        'click .reassign-person': 'assignPerson',
	        'click .assign-person': 'assignPerson',
	        'click .reassign-organization': 'assignOrganization',
	        'click .assign-organization': 'assignOrganization'
	    },
	
	    ui: {
	        changeReviewerModal: '#changeReviewerModal'
	    },
	
	    childViewEvents: {
	        'action:confirmed': 'onConfirmed'
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'changeStatus', 'canUserChangeStatus', 'setStatusToSignOrView', 'setStatusToDelete', 'changeStatusAction', 'canChangeReviewer',
	            'assignOrganization', 'assignPerson', 'assignReviewer', 'renderSignedByPersonNameAsync', 'onConfirmed');
	        this.reviewers = options.reviewers;
	        this.documentId = options.documentId;
	
	        this.elementStatuses = options.elementStatuses;
	        this.idNamesMap = options.idNamesMap;
	
	        this.permissions = options.permissions || [];
	        this.relations = options.relations || [];
	
	        this.utils = new CommonUtils();
	        this.canEdit = options.canEdit;
	        this.canUploadForOrganizationInDocument = options.canUploadForOrganizationInDocument;
	        this.byAdmin = options.byAdmin;
	    },
	
	    onRender: function() {
	        this.obsoleteReviewerConfirmationModal =
	            new YesNoConfirmationModal({
	                message: 'You are going to obsolete this reviewer. Are you sure?',
	                tag: 'obsolete-reviewer'
	            });
	        this.showChildView('obsoleteConfirmationModal', this.obsoleteReviewerConfirmationModal);
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            reviewers: that.reviewers,
	            getReviewerStatusText: that.utils.getReviewerStatus,
	            elementStatuses: that.elementStatuses,
	            //getName: function (id) {
	            //    return that.idNamesMap[id];
	            //},
	            getName: function (id, uid) {
	                var idNamesMap = {};
	                that.relations.forEach(function (relation) {
	                    idNamesMap[relation.child.id] = relation.child.name;
	                });
	                if (_.contains(_.keys(idNamesMap), id))
	                    return idNamesMap[id];
	                else
	                    that.renderSignedByPersonNameAsync(id, uid);
	            },
	            canUserChangeStatus: that.canUserChangeStatus,
	            canEdit: function () {
	                return that.canEdit();
	            },
	            canUploadForOrganizationInDocument: function () {
	                return that.canUploadForOrganizationInDocument();
	            },
	            canChangeReviewer: that.canChangeReviewer,
	            //persons: that.persons,
	            changeReviewer: that.changeReviewer,
	            byAdmin: that.byAdmin,
	            fmtTime: function(timeAsLong) {
	                return that.utils.longToDateTimeFormatted(timeAsLong, "MM/DD/YYYY hh:mm A");
	            }
	        }
	    },
	
	    canUserChangeStatus: function (reviewer) {
	        return this.utils.canUserChangeStatus(this.permissions, reviewer);
	    },
	
	    changeStatus: function (event) {
	        this.changeStatusAction($(event.target).attr('uid'), $(event.target).attr('value'));
	    },
	
	    setStatusToSignOrView: function (event) {
	        if ($(event.target).attr('data-value') == 'true') {
	            var passwordConfirmation = new PasswordConfirmation({
	                action: this.changeStatusAction,
	                id: $(event.target).attr('uid')
	            });
	            this.showChildView('passwordConfirmationDiv', passwordConfirmation);
	            passwordConfirmation.showPasswordConfirmation();
	        }
	        else
	            this.changeStatusAction($(event.target).attr('uid'), 'VIEWED');
	    },
	
	    setStatusToDelete: function (event) {
	        var that = this;
	        this.obsoleteReviewerConfirmationModal.show();
	        this.callback = function() {
	            that.changeStatusAction($(event.target).attr('uid'), 'DELETED');
	        }
	    },
	
	    changeStatusAction: function (uid, value, password) {
	        var that = this;
	        that.utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/document/' + this.documentId + '/element/' + uid + '/status/' + value,
	            data: password,
	            contentType: 'text/plain',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    that.triggerMethod('review:status:updated', response);
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner();
	                notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        });
	    },
	    canChangeReviewer: function (reviewer) {
	        var organizationId = reviewer.organizationId;
	        var personId = this.permissions.userId;
	        return this.utils.userCanDo(
	            this.permissions,
	            function (permission) {
	                return permission.canChangeReviewer;
	            },
	            [{
	                organizationId: organizationId,
	                ownerId: personId
	            }],
	            function (permission) {
	                return true;
	            });
	    },
	
	    assignPerson: function (event) {
	        this.assignReviewer(event, true);
	    },
	
	    assignOrganization: function (event) {
	        this.assignReviewer(event, false);
	    },
	
	    assignReviewer: function(event, isReviewerPerson) {
	        var that = this;
	        var uid = $(event.target).attr('uid');
	        var reviewer = that.reviewers.find(function (reviewer) {
	            return reviewer.uuid == uid;
	        });
	        var reviewerId = isReviewerPerson ? reviewer.personId : reviewer.organizationId;
	        var perSelect = new ReviewerSelectView({
	            el: this.$('#' + uid + reviewerId),
	            isReviewerPerson: isReviewerPerson,
	            selectedEntity: reviewerId,
	            reviewer: _.clone(reviewer),
	            documentId: that.documentId,
	            onSave: function (response) {
	                if (response)
	                    that.reviewers = response.object.reviewers;
	                that.relations = response.relations;
	                that.render();
	            },
	            onCancel: function () {
	                that.render();
	            }
	        });
	        perSelect.render();
	    },
	
	    renderSignedByPersonNameAsync: function(id, uid) {
	        var that = this;
	        var model = new EntityModel({
	            id: id
	        });
	        model.fetch({
	            success: function () {
	                $('#' + uid + id + ' > a').text(model.get('name'));
	            },
	            error: function () {
	            }
	        });
	    },
	
	    onConfirmed: function(data) {
	        var that = this;
	        if (data.result == true && data.tag === "obsolete-reviewer") {
	            that.callback();
	        }
	    }
	});
	
	module.exports = DocumentReviewersView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	var EntityModel = __webpack_require__(228);
	var RemoteSuggesterView = __webpack_require__(196);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	
	var ReviewerSelectView = Marionette.View.extend({
	    template: __webpack_require__(406),
	
	    regions: {
	        reviewersSelect: '#reviewers-select'
	    },
	
	    events: {
	        'click .save': 'saveReviewer',
	        'click .cancel': 'cancel'
	    },
	
	    childViewEvents: {
	        'suggestor:selected:md': 'onMdSelected',
	        'suggestor:selected:organization': 'onOrganizationSelected',
	    },
	
	    constants: {
	        maxNumberOfItemsInControlWithSuggester: 20
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'saveReviewer', 'cancel', 'showReviewerSelect', 'onMdSelected', 'onOrganizationSelected', 'renderReviewerSelect');
	        this.reviewer = options.reviewer;
	        this.isReviewerPerson = options.isReviewerPerson;
	        this.placeholder = options.isReviewerPerson ? 'Select a person' : 'Select an org.';
	        this.documentId = options.documentId;
	        this.onSave = options.onSave;
	        this.onCancel = options.onCancel;
	
	    },
	    utils: new CommonUtils(),
	
	    templateContext: function () {
	        var that = this;
	        return {}
	    },
	
	    onRender: function () {
	
	        if (this.isReviewerPerson) {
	            this.renderReviewerSelect(this.reviewer.personId, true);
	        } else {
	            this.renderReviewerSelect(this.reviewer.organizationId, false);
	        }
	    },
	
	    renderReviewerSelect: function(reviewerId, isReviewerPerson) {
	        var that = this;
	        if (!reviewerId) {
	            that.showReviewerSelect(isReviewerPerson);
	            return;
	        }
	
	        var current = new EntityModel({
	            id: reviewerId
	        });
	        current.fetch({
	            success: function () {
	                that.showReviewerSelect(isReviewerPerson, {
	                    id: current.get('id'),
	                    name: current.get('name')
	                });
	            },
	            error: function () {
	                that.showReviewerSelect(isReviewerPerson);
	            }
	        });
	    },
	
	    showReviewerSelect: function (isReviewerPerson, defaultSelected) {
	        var that = this;
	
	        that.showChildView('reviewersSelect', new RemoteSuggesterView({
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
	            + '&sortby=name&like_name=~~~&type=' + (isReviewerPerson ? 'person' : 'organization'),
	            symbolForSearchInUrl: '~~~',
	            listLocation: (isReviewerPerson ? function (data) {
	                return data.filter(function (item) {
	                    return item.object && item.object.isMd;
	                });
	            } : function (data) {
	                return data.filter(function (item) {
	                    return item.object;
	                });
	            }),
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: that.placeholder,
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return (arr[index] || {}).id;
	            },
	            tag: isReviewerPerson  ? 'md': 'organization',
	            defaultSelected: defaultSelected
	        }));
	    },
	
	    onMdSelected: function (id) {
	        this.reviewer.personId = id;
	    },
	
	    onOrganizationSelected: function (id) {
	        this.reviewer.organizationId = id;
	    },
	
	    saveReviewer: function () {
	        var that = this;
	
	        if (!this.reviewer.organizationId && !this.reviewer.personId) {
	            notificationsChannel.request('show:notification', 'The organization or MD must be filled');
	            return;
	        }
	
	        this.reviewer = _.omit(this.reviewer, 'statusText');
	        that.utils.showSpinner();
	        $.ajax({
	            type: "PUT",
	            url: '/api/document/' + this.documentId + '/reviewer',
	            data: JSON.stringify(this.reviewer),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    // notificationsChannel.request('show:notification', {message:"saved", code:200}); //maybe this needed but i think when we implement hide possibility off success notifications in user profile
	                    that.onSave(response);
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner();
	                notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        });
	    },
	
	    cancel: function() {
	        this.onCancel();
	    }
	});
	
	module.exports = ReviewerSelectView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="control-group">\n    <div id="reviewers-select"></div>\n    <button type="button" class="btn btn-primary btn-xs save">Save</button>\n    <button type="button" class="btn btn-primary btn-xs cancel">Cancel</button>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 407 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 for (var i in reviewers) { 
	__p+='\n<div class="row reviewer-row well ';
	 if (reviewers[i].status == 'DELETED') { 
	__p+=' deprecated-header ';
	 } 
	__p+='">\n    <div class="col-md-4">\n        Organization:\n        ';
	 if ((reviewers[i].organizationId || '') !== "") { 
	__p+='\n            <div class="form-inline" id="'+
	((__t=( reviewers[i].uuid + reviewers[i].organizationId ))==null?'':__t)+
	'">\n                <a href="/#organization/'+
	((__t=( reviewers[i].organizationId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( getName(reviewers[i].organizationId) ))==null?'':__t)+
	'</a>\n            ';
	 if (byAdmin) { 
	__p+='\n                <span class="glyphicon glyphicon-pencil clickable reassign-organization" uid="'+
	((__t=( reviewers[i].uuid ))==null?'':__t)+
	'" aria-hidden="true" title="Re-assign"></span>\n            ';
	 } 
	__p+='\n                        </div>\n        ';
	 } else { 
	__p+='\n            <div class="form-inline" id="'+
	((__t=( reviewers[i].uuid + reviewers[i].organizationId ))==null?'':__t)+
	'">\n                ';
	if(byAdmin){
	__p+='\n                    <button type="button" class="btn btn-success btn-md assign-organization btn-xs" class="toggle" uid="'+
	((__t=( reviewers[i].uuid ))==null?'':__t)+
	'">ASSIGN</button>\n                ';
	}
	__p+='\n            </div>\n        ';
	 } 
	__p+='\n    </div>\n    <div class="col-md-4">\n        Person:\n        ';
	 if ((reviewers[i].personId || '') !== "") { 
	__p+='\n        <div class="form-inline" id="'+
	((__t=( reviewers[i].uuid + reviewers[i].personId ))==null?'':__t)+
	'"><a href="/#person/'+
	((__t=( reviewers[i].personId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( getName(reviewers[i].personId) ))==null?'':__t)+
	'</a>\n                    ';
	if(canChangeReviewer(reviewers[i])==true && reviewers[i].status != 'SIGNED' && reviewers[i].status != 'VIEWED'){
	__p+='\n                    <span class="glyphicon glyphicon-pencil clickable reassign-person" uid="'+
	((__t=( reviewers[i].uuid ))==null?'':__t)+
	'" aria-hidden="true" title="Re-assign"></span>\n                    ';
	}
	__p+='\n                </div>\n        ';
	 if (reviewers[i].signedByPersonId && reviewers[i].signedByPersonId != reviewers[i].personId && (reviewers[i].status == 'SIGNED' || reviewers[i].status == 'VIEWED')) { 
	__p+='\n        <div class="col-md-6">\n            Signed by: <div class="form-inline" id="'+
	((__t=( reviewers[i].uuid + reviewers[i].signedByPersonId ))==null?'':__t)+
	'">\n                <a href="/#person/'+
	((__t=( reviewers[i].signedByPersonId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( getName(reviewers[i].signedByPersonId, reviewers[i].uuid) ))==null?'':__t)+
	'</a></div>\n        </div>\n        ';
	 } 
	__p+='\n        ';
	 } else if (typeof(reviewers[i].organizationId) !== "undefined") {
	__p+='\n        <div class="form-inline" id="'+
	((__t=( reviewers[i].uuid + reviewers[i].personId ))==null?'':__t)+
	'">\n                    ';
	if(canChangeReviewer(reviewers[i])==true && reviewers[i].status != 'SIGNED' && reviewers[i].status != 'VIEWED'){
	__p+='\n                        <button type="button" class="btn btn-success btn-md assign-person btn-xs" class="toggle" uid="'+
	((__t=( reviewers[i].uuid ))==null?'':__t)+
	'">ASSIGN</button>\n                    ';
	}
	__p+='\n                </div>\n        ';
	}
	__p+='\n    </div>\n\n    <div class="col-md-2">\n        '+
	((__t=( getReviewerStatusText(reviewers[i].status) ))==null?'':__t)+
	'\n    </div>\n\n    <div class="col-md-2">\n        ';
	 if (reviewers[i].status != 'SIGNED' && reviewers[i].status != 'VIEWED') { 
	__p+='\n            ';
	 if (canUserChangeStatus(reviewers[i])==true) { 
	__p+='\n            <button type="button" class="btn btn-success btn-xs" ';
	 if (reviewers[i].status == 'UNDER_REVIEW') { 
	__p+=' disabled ';
	 } 
	__p+='\n                    id="sign" uid="'+
	((__t=( reviewers[i].uuid ))==null?'':__t)+
	'" data-value="'+
	((__t=( reviewers[i].mandatory ))==null?'':__t)+
	'">Sign</button>\n            ';
	 } 
	__p+='\n            ';
	 if (canEdit() || canUploadForOrganizationInDocument()) { 
	__p+='\n            <button type="button" class="btn btn-danger btn-xs" id="delete" uid="'+
	((__t=( reviewers[i].uuid ))==null?'':__t)+
	'">Won\'t sign</button>\n            ';
	 }
	__p+='\n        ';
	 } else { 
	__p+='\n            '+
	((__t=( fmtTime(reviewers[i].time) ))==null?'':__t)+
	'\n        ';
	 } 
	__p+='\n    </div>\n</div>\n';
	 } 
	__p+='\n\n<div class="password-confirmation-div"></div>\n<div id="obsolete-confirmation-modal"></div>';
	}
	return __p;
	};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	var AddendumsTableView = __webpack_require__(409);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var AddendumsView = Marionette.View.extend({
	    template: __webpack_require__(413),
	
	    regions: {
	        addendumsList: '#addendums-list'
	    },
	
	    events: {
	        'click #add-addendum-comment': 'addAddendumComment'
	    },
	
	    ui: {
	        addendumCommentText: '#addendum-comment-text'
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'addAddendumComment', 'canUserAddAddendums');
	        this.model = options.model;
	        this.userPermissions = options.userPermissions || [];
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	        this.refreshAddendumsTable();
	    },
	
	    refreshAddendumsTable: function () {
	        var that = this;
	        that.showChildView('addendumsList',
	            new AddendumsTableView({collectionValues: that.getAddendumsByParent(that.model.get('relations'), that.model.get('id'))}));
	    },
	
	    getAddendumsByParent: function (relations, id) {
	        return relations.filter(function (item) {
	            return item.systemRelationType == 'DOCUMENT_ADDENDUM' && item.parentId == id;
	        }).sort(function (itemFirst, itemNext) {
	            if (itemFirst.child.createdTime > itemNext.child.createdTime) return 1;
	            else if (itemFirst.child.createdTime < itemNext.child.createdTime) return -1;
	            else return 0;
	        });
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            canUserAddAddendums: function() { return that.canUserAddAddendums(); }
	        }
	    },
	
	    addAddendumComment: function () {
	        var comment = this.ui.addendumCommentText.val();
	        var that = this;
	        that.utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/document/' + this.model.get('id') + '/addendum/comment',
	            data: comment,
	            contentType: 'text/plain',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    //that.triggerMethod('addendum:created', response);
	                    that.model.fetch({
	                        success: function() {
	                            that.refreshAddendumsTable();
	                        }
	                    });
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner();
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            }
	        });
	    },
	
	    canUserAddAddendums: function () {
	        var that = this;
	        var canEdit = this.utils.userCanDo(this.userPermissions,
	            function (permission) {
	                return permission.canWriteFor;
	            },
	            this.model.get('permissions'),
	            function (permission) {
	                return permission.canWrite;
	            }
	        );
	
	        var canSign = false;
	        (this.model.get('object').reviewers || []).forEach(function (reviewer) {
	            if (that.utils.canUserChangeStatus(that.userPermissions, reviewer)) {
	                canSign = true;
	            }
	        });
	        return canEdit || canSign;
	    }
	});
	
	module.exports = AddendumsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	var AddendumsCollection = __webpack_require__(410);
	var CommonUtils = __webpack_require__(189);
	
	var utils = new CommonUtils();
	
	var AddendumsRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(411),
	    events: {},
	
	    templateContext: function () {
	        var that = this;
	        return {
	            childId: that.model.get('child').id,
	            childName: that.model.get('child').name,
	            fmCreatedTime: utils.longToDateTimeFormatted(that.model.get('child').createdTime, "MMM DD YYYY")
	        }
	    },
	
	    initialize: function (options) {
	        //_.bindAll(this, '');
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(4), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var AddendumsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: AddendumsRowView,
	    emptyView: EmptyView,
	
	    childViewEvents: {
	    },
	
	    initialize: function (options) {
	        //_.bindAll(this, 'showLoading', 'hideLoading', 'logError', 'updateModel', 'afterModelDestroy');
	        this.collection = options.collection;
	    },
	
	    childViewOptions: function () {
	        return {};
	    }
	});
	
	var AddendumssTableView = Marionette.View.extend({
	    tagName: 'div',
	    className: 'addendums-table',
	    template: __webpack_require__(412),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        }
	    },
	
	    childViewEvents: {
	    },
	
	    templateContext: function () {
	        return {
	        }
	    },
	
	    onRender: function () {
	        this.showChildView('body', new AddendumsTableBody({
	            collection: this.collection,
	        }));
	    },
	
	    initialize: function (options) {
	        //_.bindAll(this, 'saveConfirmed', 'onAction');
	        this.collection = new AddendumsCollection(options.collectionValues);
	    }
	});
	
	module.exports = AddendumssTableView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	
	
	var AddendumsCollection = BaseCollection.extend({
	
	    initialize: function(models, options){
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    }
	});
	
	
	module.exports = AddendumsCollection;

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td><a href="/#document/'+
	((__t=( childId ))==null?'':__t)+
	'">'+
	((__t=( childName ))==null?'':__t)+
	'</a></td>\r\n<td>'+
	((__t=( fmCreatedTime ))==null?'':__t)+
	'</td>\r\n<td>\r\n    <a href="/api/document/download/'+
	((__t=( childId ))==null?'':__t)+
	'"><span class="clickable glyphicon glyphicon-floppy-disk"/></a>\r\n</td>\r\n<td>\r\n    <a href="/api/document/view/'+
	((__t=( childId ))==null?'':__t)+
	'" target="_blank"><span class="clickable glyphicon glyphicon-eye-open"/></a>\r\n</td>\r\n';
	}
	return __p;
	};


/***/ }),
/* 412 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<table class="table table-hover">\r\n    <thead>\r\n    <tr>\r\n        <th>Name</th>\r\n        <th>Created time</th>\r\n        <th>Download</th>\r\n        <th>View</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody></tbody>\r\n</table>';
	}
	return __p;
	};


/***/ }),
/* 413 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if (canUserAddAddendums){ 
	__p+='\n<div id="addendums-form-container">\n    <div id="addendums-list" class="well"></div>\n    <div class="form-horizontal well">\n        <div class="form-group">\n            <label class="col-sm-3 control-label" for="addendum-comment-text">Addendum Comment</label>\n            <div class="col-sm-9">\n                <textarea rows="5" cols="50" name="addendum-comment-text" id="addendum-comment-text"></textarea>\n            </div>\n        </div>\n        <div class="form-group">\n            <div class="col-sm-7 right">\n                <button id="add-addendum-comment" class="btn btn-primary">Add addendum</button>\n            </div>\n\n        </div>\n    </div>\n</div>\n';
	 } 
	__p+='';
	}
	return __p;
	};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	var RemoteSuggesterView = __webpack_require__(196);
	var CommonUtils = __webpack_require__(189);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var utils = new CommonUtils();
	
	var DocumentPatientForm = Marionette.View.extend({
	    template: __webpack_require__(415),
	
	    regions: {
	        patientSelect: '#patient-select'
	    },
	
	    ui: {
	        container: '#patients-select',
	        saveBtn: '#save',
	        clickable: '.clickable'
	    },
	
	    events: {
	        'click @ui.saveBtn': 'save',
	        'click @ui.clickable': 'remove'
	    },
	
	    childViewEvents: {
	        'suggestor:selected:patient': 'onPatientSelected'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var documentPatientRelation = _.find(that.model.get('relations'), function (item) {
	            return item.parentId == that.model.get('id')
	                && item.systemRelationType == 'DOCUMENT_PATIENT'
	                && item.child.id == that.model.get('object').patientId;
	        });
	        var patient = documentPatientRelation && documentPatientRelation.child && documentPatientRelation.child.object ? {
	            id: documentPatientRelation.child.id,
	            name: utils.formatPerson(documentPatientRelation.child.object)
	        } : undefined;
	        return {
	            canEdit: function() { return that.canEdit(); },
	            patient: patient,
	            buttonText: patient ? 'Replace patient' : 'Add patient'
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'save', 'remove');
	        this.model = options.model;
	        this.canEdit = options.canEdit;
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	        var that = this;
	        this.ui.saveBtn.attr('disabled', true);
	        that.patientsSelectView = new RemoteSuggesterView({
	            inputId: 'DOCUMENT_PATIENT',
	            maxNumberOfElements: 100,
	            url: '/api/dbo/preview?page-size=' + 100
	            + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data.filter(function (item) {
	                    return item.object && item.object.isPatient && item.object.mergeable === false;
	                });
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Select patient to add or replace",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return (arr[index] || {}).id;
	            },
	            tag: 'patient'
	        });
	
	        that.showChildView('patientSelect', that.patientsSelectView);
	    },
	
	    save: function () {
	        var that = this;
	        var patientId = that.selectedPatientId;
	        if (!patientId)
	            return;
	
	        that.utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/document/' + that.model.get('id') + '/patient/' + patientId,
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    that.triggerMethod('patient:added:to:doc', response);
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner();
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            }
	        });
	    },
	
	    remove: function(event) {
	        var that = this;
	
	        that.utils.showSpinner();
	        $.ajax({
	            type: "DELETE",
	            url: '/api/document/' + that.model.get('id') + '/patient/' + event.target.id,
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    that.triggerMethod('patient:added:to:doc', response);
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner();
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            }
	        });
	    },
	
	    onPatientSelected: function(patientId) {
	        this.selectedPatientId = patientId;
	        if (_.isUndefined(patientId))
	            this.ui.saveBtn.attr('disabled', true);
	        else
	            this.ui.saveBtn.removeAttr('disabled');
	    }
	
	});
	
	module.exports = DocumentPatientForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row">\r\n    <div id="patients-select">\r\n        <div id="patient">\r\n            <b>Patient: </b>\r\n            ';
	 if (patient) { 
	__p+='\r\n            <a href="/#person/'+
	((__t=( patient.id ))==null?'':__t)+
	'"> '+
	((__t=( patient.name ))==null?'':__t)+
	' </a>\r\n            <span class="clickable glyphicon glyphicon-remove" id="'+
	((__t=( patient.id ))==null?'':__t)+
	'" title="Remove"/>\r\n            ';
	 } else { 
	__p+='\r\n            Is not set\r\n            ';
	 } 
	__p+='\r\n        </div>\r\n\r\n        <div class="form-horizontal top-margined col-xs-4 col-md-4">\r\n            <div class="form-group" id="patient-select">\r\n            </div>\r\n            <div class="form-group">\r\n                <div class="right">\r\n                    <button type="button" class="btn btn-primary" id="save">'+
	((__t=( buttonText))==null?'':__t)+
	'</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	
	var PersonsCollection = __webpack_require__(210);
	
	var YesNoConfirmationModal = __webpack_require__(237);
	var MarkAsSignedForm = __webpack_require__(417);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var utils = new CommonUtils();
	
	
	var HistoryRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(419),
	
	    ui: {
	        commentContainer: '.comment-container',
	        textarea: '.textarea',
	        spans: '.spans',
	        add: '.add',
	        edit: '.edit',
	        save: '.save',
	        cancel: '.cancel',
	        markAsDelivered: '.mark-as-delivered',
	        markAsSigned: '.mark-as-signed',
	
	        showCommentChangeHistory: ".show-comment-history"
	    },
	
	    events: {
	        'click @ui.spans': 'onAddOrEdit',
	        'click @ui.save': 'onSave',
	        'click @ui.cancel': 'onCancel',
	        'click @ui.markAsDelivered': 'onMarkAsDelivered',
	        'click @ui.markAsSigned': 'onMarkAsSigned',
	        'click @ui.showCommentChangeHistory': 'onShowCommentChangeHistory'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            time: utils.longToDateTimeFormatted(Number(that.model.get('time')), 'MM/DD/YYYY hh:mm A'),
	            canEdit: that.getOption('canEdit'),
	            byAdmin: that.getOption('byAdmin'),
	            isSentEvent: that.model.get('eventType') == 'SENT',
	            isUnderReview: that.model.get('eventType') == 'UNDER_REVIEW' && that.getOption('status') == 'UNDER_REVIEW',
	            isNotCommentEvent: that.model.get('eventType') != "COMMENT_ADDED" && that.model.get('eventType') != "COMMENT_BECAME_IRRELEVANT"
	        }
	    },
	
	    initialize: function (options) {
	    },
	
	    onRender: function () {
	        var that = this;
	        that.ui.textarea.hide();
	        that.ui.save.hide();
	        that.ui.cancel.hide();
	        that.commentHistoryContent = null;
	    },
	
	    onAddOrEdit: function () {
	        this.ui.commentContainer.hide();
	        this.ui.spans.hide();
	        this.ui.textarea.show();
	        this.ui.save.show();
	        this.ui.cancel.show();
	    },
	
	    onSave: function () {
	        var that = this;
	        utils.showSpinner();
	        $.ajax({
	            type: "PUT",
	            url: '/api/event/' + that.model.get('id') + '/comment',
	            data: this.ui.textarea.val(),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    if (response) {
	                        utils.hideSpinner();
	                        that.model.set('auditComment', response.auditComment);
	                        that.model.set('commentHistory', response.commentHistory);
	                        that.render();
	                    }
	                }
	            },
	            error: function (e) {
	                utils.hideSpinner();
	                notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	            }
	        });
	    },
	
	    onCancel: function () {
	        this.ui.textarea.val(this.model.get('auditComment') || '');
	
	        this.ui.commentContainer.show();
	        this.ui.spans.show();
	        this.ui.textarea.hide();
	        this.ui.save.hide();
	        this.ui.cancel.hide();
	    },
	
	    onMarkAsDelivered: function () {
	        var that = this;
	        var parentId = this.model.get('parentId');
	        if (_.isEmpty(parentId))
	            return;
	
	        var newDeliveredEvent = {
	            parentId: parentId,
	            eventType: 'DELIVERED',
	            auditComment: 'Marked as delivered from UI'
	        };
	
	        that.triggerMethod('mark-as-delivered', {
	            event: newDeliveredEvent
	        });
	    },
	
	    onMarkAsSigned: function () {
	        var that = this;
	        var parentId = this.model.get('parentId');
	        var parentVersion = this.model.get('parentVersion');
	
	        if (parentId && parentVersion) {
	            that.triggerMethod('mark-as-signed', {
	                parentId: parentId,
	                parentVersion: parentVersion
	            });
	        }
	    },
	
	    onShowCommentChangeHistory: function (e) {
	        var self = $(e.target);
	        var that = this;
	
	        if (!that.commentHistoryContent) {
	            self.popover({
	                html: true,
	                content: "<b>Loading...</b>"
	            });
	            self.popover('show');
	
	            var popoverAsyncRender = function (commentHistoryContent) {
	                that.commentHistoryContent = commentHistoryContent;
	                self.attr("data-content", that.commentHistoryContent);
	                self.popover({
	                    html: true
	                });
	                self.popover('show');
	            }
	
	            that.renderHistory(popoverAsyncRender);
	
	        } else {
	            self.attr("data-content", that.commentHistoryContent);
	            self.popover({
	                html: true
	            });
	            self.popover('show');
	        }
	    },
	
	    renderHistory: function (popoverRender) {
	        var that = this;
	        var commentHistory = that.model.get("commentHistory");
	        var authors = commentHistory.map(function (ch) {
	            return {key: 'id', value: ch.authorId};
	        });
	
	        var personsCollection = new PersonsCollection([], {
	            params: _.union([
	                {key: 'active', value: 'true'},
	                {key: 'active', value: 'false'}
	            ], authors)
	        });
	
	        personsCollection.fetch({
	            success: function () {
	                var authorsWithNames = {};
	                personsCollection.forEach(function (model) {
	                    authorsWithNames[model.get("id")] = model.get("name");
	                })
	
	                var tableStart = '<table class="table table-hover top-margined">' +
	                    '<thead><tr><th>Time</th><th>Commenter</th><th>Old Comment</th><th>New Comment</th></tr></thead><tbody>';
	                var tableEnd = '</tbody></table>';
	                var tableContent = _.chain(commentHistory)
	                    .sortBy("time")
	                    .reverse()
	                    .map(function (ch) {
	                        return '<tr><td>' + utils.longToDateTimeFormatted(ch.time, 'MM/DD/YYYY hh:mm A')
	                            + '</td><td>' + '<a href = "/#person/' + ch.authorId + '" target="_blank">' + authorsWithNames[ch.authorId] + '</a>'
	                            + '</td><td>' + (ch.oldComment || '')
	                            + '</td><td>' + (ch.newComment || '')
	                            + '</td></tr>';
	                    })
	                    .value();
	                popoverRender(tableStart + tableContent + tableEnd);
	            },
	            error: function (e) {
	                console.log(e);
	                popoverRender("Error - " + e.toString());
	            }
	        });
	    },
	
	    hideCommentsHistory: function () {
	        var that = this;
	        that.ui.showCommentChangeHistory.each(function () {
	            var self = $(this);
	            //if (that.activeCommentChangeHistoryPopoverId != self.attr("id")) {
	            //self.popover("hide");
	            self.popover("destroy");
	            //}
	        });
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(4), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var HistoryTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: HistoryRowView,
	    emptyView: EmptyView,
	
	    collectionEvents: {
	        request: 'showLoading',
	        sync: 'hideLoading',
	        error: 'logError'
	    },
	
	    childViewEvents: {
	        'mark-as-delivered': 'markAsDelivered',
	        'mark-as-signed': 'markAsSigned'
	    },
	
	    childViewOptions: function () {
	        var that = this;
	        return {
	            canEdit: that.getOption('canEdit'),
	            byAdmin: that.getOption('byAdmin'),
	            status: that.getOption('status')
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'showLoading', 'hideLoading', 'logError');
	        this.collection = options.collection;
	    },
	
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        notificationsChannel.request('show:notification', response.responseText);
	    },
	
	    markAsDelivered: function (data) {
	        this.triggerMethod('mark-as-delivered', data);
	    },
	
	    markAsSigned: function (data) {
	        this.triggerMethod('mark-as-signed', data);
	    },
	
	    hideCommentsHistory: function () {
	        this.children.each(function (view) {
	            view.hideCommentsHistory();
	        })
	    }
	
	});
	
	var DocumentHistoryView = Marionette.View.extend({
	    tagName: 'div',
	    className: 'history-table',
	    template: __webpack_require__(420),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        markedAsDeliveredConfirmationModal: '#marked-as-delivered-confirmation-modal',
	        markAsSignedModal: '#mark-as-signed-modal'
	    },
	
	    childViewEvents: {
	        'mark-as-delivered': 'markAsDelivered',
	        'mark-as-signed': 'markAsSigned',
	        'action:confirmed': 'onConfirmed',
	        'document:marked:as:signed': 'onDocumentMarkedAsSigned'
	    },
	
	    templateContext: function () {
	        return {
	            documentName: this.getOption('name'),
	            documentId: this.getOption('id'),
	            baseParentIdPath: this.getOption('baseParentIdPath'),
	            parentUrl: this.getOption('baseParentIdPath') + this.getOption('id')
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	        _.bindAll(that, 'onRender', 'renderTable');
	        this.canEdit = options.canEdit;
	        this.byAdmin = options.byAdmin;
	        this.document = options.document || {};
	    },
	
	    onRender: function () {
	        var that = this;
	        that.getDataAndRender();
	
	        that.markedAsDeliveredConfirmationModal =
	            new YesNoConfirmationModal({message: 'Are you sure you want to mark this message as delivered?'});
	        that.showChildView('markedAsDeliveredConfirmationModal', that.markedAsDeliveredConfirmationModal);
	
	        window.setTimeout(function () {
	            $(function () {
	                $("body").click(function (event) {
	                    var clicked = $(event.target);
	                    var popover = clicked.closest(".popover");
	
	                    if (clicked.hasClass('popover-content') || clicked.hasClass("show-comment-history") || popover.html())
	                        return;
	
	                    that.getChildView("body").hideCommentsHistory();
	                });
	            });
	        }, 1000);
	    },
	
	    onBeforeDestroy: function () {
	        $("body").unbind("click");
	    },
	
	    getDataAndRender: function () {
	        var that = this;
	        utils.showSpinner();
	        $.ajax({
	            type: "GET",
	            url: '/api/event/all/' + that.getOption('id'),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    utils.hideSpinner();
	                    that.collection = new Backbone.Collection(response);
	                    that.renderTable();
	                }
	            },
	            error: function (e) {
	                utils.hideSpinner();
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            }
	        });
	    },
	
	    renderTable: function () {
	        this.showChildView('body', new HistoryTableBody({
	            collection: this.collection,
	            canEdit: this.canEdit,
	            byAdmin: this.byAdmin,
	            status: this.document.status
	        }));
	
	        this.asyncHandleComments();
	    },
	
	    asyncHandleComments: function () {
	
	        console.log('asyncHandleComments');
	
	        /*$.ajax({
	            type: "GET",
	            url: '/api/event/all/' + that.getOption('id'),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    utils.hideSpinner();
	                    that.collection = new Backbone.Collection(response);
	                    that.renderTable();
	                }
	            },
	            error: function (e) {
	                utils.hideSpinner();
	                if (e.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            }
	        });*/
	    },
	
	    markAsDelivered: function (data) {
	        var that = this;
	        that.markedAsDeliveredConfirmationModal.show();
	
	        that.callback = function () {
	
	            utils.showSpinner();
	            $.ajax({
	                type: "POST",
	                url: '/api/event',
	                data: JSON.stringify(data.event),
	                contentType: 'application/json',
	                statusCode: {
	                    200: function (response) {
	                        utils.hideSpinner();
	                        that.getDataAndRender();
	                    }
	                },
	                error: function (e) {
	                    utils.hideSpinner();
	                    if (e.status == 401) {
	                        actionsChannel.request("redirect:to:login");
	                    } else {
	                        notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	                    }
	                }
	            });
	        };
	    },
	
	    markAsSigned: function (data) {
	        var that = this;
	        that.showChildView('markAsSignedModal', new MarkAsSignedForm({
	            documentId: data.parentId,
	            documentVersion: data.parentVersion
	        }));
	    },
	
	    onConfirmed: function (data) {
	        if (data.result == true) {
	            this.callback();
	        }
	        else {
	            this.markedAsDeliveredConfirmationModal.hide();
	        }
	    },
	
	    onDocumentMarkedAsSigned: function () {
	        window.setTimeout(function () {
	            window.location.reload();
	        }, 2000);
	    }
	});
	
	module.exports = DocumentHistoryView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	
	var MarkAsSignedForm = Marionette.View.extend({
	    template: __webpack_require__(418),
	
	    ui: {
	        modal: '#mark-as-signed-modal',
	        comment: '#comment',
	        time: '#time',
	        mark: '#mark',
	
	        loader: '#mark-as-signed-loader'
	    },
	
	    events: {
	        'click @ui.mark': 'onMarkAsSigned',
	        'keyup @ui.comment': 'onCommentChanged'
	    },
	
	    templateContext: function () {
	        return {}
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.utils = new CommonUtils();
	        that.documentId = options.documentId;
	        that.documentVersion = options.documentVersion;
	        that.comment = "";
	        that.time = new Date().getTime();
	    },
	
	    onRender: function () {
	        var that = this;
	        that.ui.time.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'MM/DD/YYYY hh:mm A',
	            defaultDate: new Date(that.time),
	            maxDate: new Date()
	        });
	        that.ui.time.on("dp.change", function (e) {
	
	            if (e.date) {
	                that.time = e.date.valueOf();
	            } else {
	                that.time = 0;
	            }
	            that.check()
	        });
	        this.show();
	    },
	
	    onMarkAsSigned: function () {
	
	        var that = this;
	
	        that.utils.showSpinner(that.ui.loader.id);
	
	        $.ajax({
	            type: "POST",
	            url: '/api/document/' + that.documentId + "/mark/under-review/as/signed/" + that.documentVersion,
	            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
	            data: {time: that.time, comment: that.comment},
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner(that.ui.loader.id);
	                    that.hide();
	                    that.triggerMethod("document:marked:as:signed");
	                    $.notify({
	                        message: "The document marked as Signed "
	                    }, {
	                        type: 'success',
	                        z_index: 2000,
	                    });
	                }
	            },
	            error: function (e) {
	                notificationsChannel.request('show:notification', e.responseJSON);
	                that.utils.hideSpinner(that.ui.loader.id);
	            }
	        });
	    },
	
	    show: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    },
	
	    onCommentChanged: function (event) {
	        this.comment = event.target.value;
	        this.check();
	    },
	
	    check: function () {
	
	        if (_.isEmpty(this.comment) || !this.time) {
	            this.ui.mark.attr('disabled', true);
	        } else {
	            this.ui.mark.removeAttr('disabled');
	        }
	    }
	});
	
	module.exports = MarkAsSignedForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Modal -->\n<div class="modal fade" id="mark-as-signed-modal" tabindex="-1" role="dialog" aria-labelledby="mark-as-signed-modal">\n    <div class="modal-dialog modal-lg" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\n                        aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title" id="mark-as-signed-modal-label">Mark as Signed</h4>\n            </div>\n            <div class="modal-body">\n                <div class="form-group">\n                    <textarea rows="8" class="form-control" id="comment" placeholder="Comment"></textarea>\n                </div>\n                <div class="form-group">\n                    <input type="text" class="form-control" id="time" placeholder="Time">\n                </div>\n                <div id="mark-as-signed-loader" class="loader" style="height: 200px;"></div>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\n                <button type="button" class="btn btn-primary" id="mark" disabled>Save</button>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td>'+
	((__t=( time ))==null?'':__t)+
	'</td>\r\n<td>\r\n    '+
	((__t=( eventType ))==null?'':__t)+
	'\r\n    ';
	 if (isSentEvent && (byAdmin || canEdit)) { 
	__p+='\r\n    &nbsp;\r\n    <span class="glyphicon glyphicon-transfer clickable mark-as-delivered" uid="'+
	((__t=( id ))==null?'':__t)+
	'" aria-hidden="true" title="Mark as Delivered"></span>\r\n    ';
	 } 
	__p+='\r\n    ';
	 if (parentId && parentVersion) { 
	__p+='\r\n        ';
	 if (isUnderReview && (byAdmin || canEdit)) { 
	__p+='\r\n        &nbsp;\r\n        <span class="glyphicon glyphicon-pencil clickable mark-as-signed" uid="'+
	((__t=( id ))==null?'':__t)+
	'" aria-hidden="true" title="Mark as Signed"></span>\r\n        ';
	 } 
	__p+='\r\n        &nbsp;\r\n        <a href="/api/document/view/'+
	((__t=( parentId ))==null?'':__t)+
	'/'+
	((__t=( parentVersion ))==null?'':__t)+
	'" target="_blank">\r\n            <span class="clickable glyphicon glyphicon-eye-open" title="View Document Version - '+
	((__t=( parentVersion ))==null?'':__t)+
	'"/>\r\n        </a>\r\n    ';
	 } 
	__p+='\r\n</td>\r\n<td><a href = "/#person/'+
	((__t=( userId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( userName ))==null?'':__t)+
	'</a></td>\r\n<td>\r\n    <div class="comment-container">\r\n        '+
	((__t=( auditComment ))==null?'':__t)+
	'\r\n    </div>\r\n    ';
	 if (canEdit && isNotCommentEvent) { 
	__p+='\r\n        &nbsp;\r\n        <textarea cols="10" rows="10"  class="form-control textarea">'+
	((__t=( auditComment ))==null?'':__t)+
	'</textarea>\r\n        ';
	 if (_.isEmpty(auditComment)) { 
	__p+='\r\n            <span class="glyphicon glyphicon-plus-sign clickable add spans" uid="'+
	((__t=( id ))==null?'':__t)+
	'" aria-hidden="true" title="Add audit comment"></span>\r\n        ';
	 } else { 
	__p+='\r\n            <span class="glyphicon glyphicon-pencil clickable edit spans" uid="'+
	((__t=( id ))==null?'':__t)+
	'" aria-hidden="true" title="Edit audit comment"></span>\r\n        ';
	 } 
	__p+='\r\n        <button class="save">Save</button>\r\n        <button class="cancel">Cancel</button>\r\n    ';
	 } 
	__p+='\r\n    ';
	 if (!_.isEmpty(commentHistory) && isNotCommentEvent) { 
	__p+='\r\n        &nbsp;\r\n        <span class="glyphicon glyphicon glyphicon-th-list clickable show-comment-history" title="Comment change history"\r\n              role="button" data-toggle="popover" data-placement="top" data-content=""/>\r\n    ';
	 } 
	__p+='\r\n</td>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h3 class="center">\r\n\r\n    ';
	 if (baseParentIdPath){ 
	__p+='\r\n    <a href="'+
	((__t=( parentUrl ))==null?'':__t)+
	'" target="_blank">\r\n    ';
	 } 
	__p+='\r\n\r\n        '+
	((__t=( documentName ))==null?'':__t)+
	'\r\n\r\n    ';
	 if (baseParentIdPath){ 
	__p+='\r\n    </a>\r\n    ';
	 } 
	__p+='\r\n\r\n\r\n</h3>\r\n<div class="col-md-offset-1 col-xs-offset-1 col-md-10 col-xs-10">\r\n    <table class="table table-hover top-margined">\r\n        <thead>\r\n        <tr>\r\n            <th>Time</th>\r\n            <th>Event type</th>\r\n            <th>User</th>\r\n            <th>Audit comment</th>\r\n        </tr>\r\n        </thead>\r\n        <tbody></tbody>\r\n    </table>\r\n</div>\r\n\r\n<div id="marked-as-delivered-confirmation-modal"></div>\r\n<div id="mark-as-signed-modal"></div>';
	}
	return __p;
	};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var DocumentActionByDocumentView = Marionette.View.extend({
	    template: __webpack_require__(422),
	
	    regions: {},
	
	    childViewEvents: {},
	
	    ui: {
	        action: '#action',
	        fileSelector: '#file-input',
	        actionTime: '#action-time',
	        actionTimeLabel: '#action-time-label'
	    },
	
	    events: {
	        'change @ui.action': 'onActionChange'
	    },
	
	    defaultParameters: {
	        time: 0
	    },
	
	    parameters: {
	        time: 0
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	        }
	    },
	
	    initialize: function (options) {
	        this.model = options.model;
	        this.canEdit = options.canEdit;
	        this.utils = new CommonUtils();
	        this.action = 'sign';
	    },
	
	
	    onRender: function () {
	        var that = this;
	        that.parameters = _.clone(that.defaultParameters);
	
	        that.ui.fileSelector.fileinput({
	            uploadLabel: 'Upload for sign',
	            uploadUrl: "/api/document/" + that.model.get('id') + "/" + that.action + "/by/document",
	            allowedFileExtensions: ["pdf"],
	            dropZoneTitle: 'Drag & drop a PDF-file to here &hellip;',
	            uploadExtraData: that.parameters
	        });
	
	        that.ui.fileSelector.on('fileuploaded', function (event, data, previewId, index) {
	
	            $.notify("The document was "
	                + (that.action == 'sign' ? 'signed' : (that.action == 'obsolete' ? 'obsoleted' : ""))
	                + " successfully", "success");
	            window.setTimeout(function () {
	                that.triggerMethod("action:with:document:upload", data.response);
	            }, 0);
	        });
	
	        that.ui.actionTime.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'MM/DD/YYYY hh:mm A'
	        });
	        that.ui.actionTime.on("dp.change", function (e) {
	
	            if (e.date) {
	                that.parameters.time = e.date.valueOf();
	            } else {
	                that.parameters.time = 0;
	            }
	        }).on('dp.show', function () {
	            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(new Date()));
	        });
	    },
	
	    onActionChange: function(event) {
	        var value = event.target.value;
	        this.action = value;
	        this.ui.fileSelector.fileinput('refresh', {
	            uploadLabel: 'Upload for ' + this.action,
	            uploadUrl: "/api/document/" + this.model.get('id') + "/" + this.action + "/by/document"
	        });
	
	        if (value === "sign") {
	            this.ui.actionTimeLabel.text("Signature date:");
	        } else if (value == "obsolete") {
	            this.ui.actionTimeLabel.text("Obsoleted date:");
	        }
	    }
	});
	
	module.exports = DocumentActionByDocumentView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form-horizontal col-md-8 col-xs-8">\r\n    <div class="form-group">\r\n        <label class="col-md-3 col-xs-3 control-label" for="action">Action:</label>\r\n        <div class="col-xs-9 col-md-9">\r\n            <select id="action" class="form-control col-md-3 col-xs-3">\r\n                <option value="sign">SIGN</option>\r\n                <option value="obsolete">OBSOLETE</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div class="form-group">\r\n        <label class="col-md-3 col-xs-3 control-label" for="action-time" id="action-time-label">Signature date:</label>\r\n        <div class="col-xs-9 col-md-9">\r\n            <input type="text" class="form-control col-md-6 col-xs-6" id="action-time">\r\n        </div>\r\n    </div>\r\n    <div class="form-group">\r\n        <input id="file-input" name="file" type="file" class="file" data-show-caption="true">\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 423 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\n    <!-- Nav tabs -->\n    <ul class="nav nav-tabs" role="tablist">\n        <li role="presentation" class="active"><a href="#main" aria-controls="main" role="tab" data-toggle="tab">Document</a>\n        </li>\n        <li role="presentation"><a href="#document-comments" aria-controls="document-comments" role="tab" data-toggle="tab">Comments <span class="badge" id="comments-count"></span></a></li>\n        <li role="presentation"><a href="#document-contacts" aria-controls="document-contacts" role="tab" data-toggle="tab">\n            Contacts ';
	 if (contactsCount > 0) { 
	__p+=' <span class="badge"> '+
	((__t=( contactsCount ))==null?'':__t)+
	' ';
	 } 
	__p+='</span>\n        </a></li>\n        ';
	 if (isShowSignData() && canEdit()) { 
	__p+='\n        <li role="presentation" id="item-sign-settings">\n            <a href="#document-sign-settings" aria-controls="document-sign-settings" role="tab" data-toggle="tab">Sign settings</a>\n        </li>\n        ';
	 } 
	__p+='\n        ';
	 if (canEdit()) { 
	__p+='\n        <li role="presentation"><a href="#document-patients" aria-controls="document-patients" role="tab" data-toggle="tab">Patient</a></li>\n        <li role="presentation"><a href="#document-action-by-document" aria-controls="document-action-by-document" role="tab" data-toggle="tab">Sign or Obsolete by document</a></li>\n        <li role="presentation"><a href="#document-permissions" aria-controls="document-permissions" role="tab" data-toggle="tab">Permissions</a></li>\n        ';
	 } 
	__p+='\n        <li role="presentation"><a href="#document-history" aria-controls="document-history" role="tab" data-toggle="tab">History</a></li>\n        ';
	 if (canEdit()) { 
	__p+='\n        <li role="presentation"><a href="#document-settings" aria-controls="document-settings" role="tab" data-toggle="tab">Settings</a></li>\n        ';
	 } 
	__p+='\n    </ul>\n\n    <!-- Tab panes -->\n    <div class="tab-content">\n        <div role="tabpanel" class="tab-pane active top-margined" id="main">\n            <div id="document-data"></div>\n\n            <div id="document-requests"></div>\n            <div class="row">\n                <h3 class="center">Reviewers</h3>\n                <div id="reviewers"></div>\n                <div id="add-reviewers-form" class="row"></div>\n                ';
	 if (canEdit() || canUploadForOrganizationInDocument()) { 
	__p+='\n                <div>\n                    <button id="add-reviewer-button" class="btn btn-primary" disabled>Add</button>\n                </div>\n                ';
	 } 
	__p+='\n            </div>\n\n            <div id="save-confirmation-modal"></div>\n\n        </div>\n        <div role="tabpanel" class="tab-pane top-margined" id="document-comments">\n            <div class="row"  id="comments-list">\n                <h3 class="center">Comments</h3>\n                <div id="comments" style="max-height: 20000px;"></div>\n                ';
	 if (canEdit()) { 
	__p+='\n                <div id="add-comment" class="col-xs-12 col-md-12"></div>\n                ';
	 } 
	__p+='\n            </div>\n        </div>\n        <div role="tabpanel" class="tab-pane top-margined" id="document-contacts">\n            <div class="row" id="contacts-list">\n                <h3 class="center">Contacts</h3>\n                <div id="contacts"></div>\n                <div id="contact-form" class="col-xs-12 col-md-12"></div>\n            </div>\n        </div>\n        <div role="tabpanel" class="tab-pane top-margined" id="document-sign-settings">\n            ';
	 if (isShowSignData() && canEdit()) { 
	__p+='\n            <div id="document-sign-data"></div>\n            ';
	 } 
	__p+='\n        </div>\n        <div role="tabpanel" class="tab-pane top-margined" id="document-patients">\n            ';
	 if (canEdit()) { 
	__p+='\n            <div id="document-patient"></div>\n            ';
	 } 
	__p+='\n        </div>\n        <div role="tabpanel" class="tab-pane top-margined" id="document-action-by-document">\n            ';
	 if (canEdit()) { 
	__p+='\n            <div id="document-action-by-document-content"></div>\n            ';
	 } 
	__p+='\n        </div>\n        <div role="tabpanel" class="tab-pane top-margined" id="document-permissions">\n            ';
	 if (canEdit()) { 
	__p+='\n            <div class="row" id="permissions-list">\n                <h3 class="center">Permissions</h3>\n                <div id="permissions"></div>\n                <div id="add-permission" class="col-xs-12 col-md-12"></div>\n            </div>\n            ';
	 } 
	__p+='\n        </div>\n        <div role="tabpanel" class="tab-pane top-margined" id="document-history">\n            <div id="history"></div>\n        </div>\n        <div role="tabpanel" class="tab-pane top-margined" id="document-settings">\n            ';
	 if (canEdit()) { 
	__p+='\n            <div class="form-horizontal col-md-offset-3 col-xs-offset-3 col-md-6 col-xs-6">\n                <h4 class="center">Change alias</h4>\n                <div class="form-group">\n                    <label class="col-md-1 control-label" for="alias">Alias</label>\n                    <div class="col-md-7">\n                        <input class="form-control" type="text" id="alias" placeholder="Alias" required="" value="'+
	((__t=( alias ))==null?'':__t)+
	'">\n                    </div>\n                    <button type="button" class="btn btn-primary" id="alias-update" disabled>Change</button>\n                    <button type="button" class="btn btn-danger" id="alias-cancel" disabled>Cancel</button>\n                </div>\n            </div>\n            ';
	 } 
	__p+='\n        </div>\n    </div>\n\n</div>';
	}
	return __p;
	};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(180);
	
	var SettingsList = Marionette.View.extend({
	    template: __webpack_require__(425),
	
	    initialize: function (options) {
	        window.document.title = "Settings";
	    }
	
	});
	
	
	module.exports = SettingsList;

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div id="settings">\r\n    <h2>Settings list</h2>\r\n    <div class="list-group">\r\n        <a href="#persons" class="list-group-item"><b>Persons</b></a>\r\n        <a href="#import-persons" class="list-group-item"><b>Persons import</b></a>\r\n        <a href="#merge-persons" class="list-group-item"><b>Persons merge</b></a>\r\n        <a href="#relations" class="list-group-item hidden"><b>Relations</b></a>\r\n        <a href="#relationtypes" class="list-group-item hidden"><b>Relation types</b></a>\r\n        <a href="#roles" class="list-group-item"><b>Roles (permissions templates)</b></a>\r\n        <a href="#doctypes" class="list-group-item"><b>Document types</b></a>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(180);
	
	var Relations = Marionette.View.extend({
	    template: __webpack_require__(427),
	
	    initialize: function(options){
	    }
	
	});
	
	
	module.exports = Relations;

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='relations';
	}
	return __p;
	};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var RelationTypesCollection = __webpack_require__(223);
	var RelationType = __webpack_require__(224);
	var RelationTypeForm = __webpack_require__(429);
	var RelationTypesListView = __webpack_require__(432);
	var DboTypesCollection = __webpack_require__(430);
	
	var RelationTypesList = Marionette.View.extend({
	    template: __webpack_require__(435),
	    collection: new RelationTypesCollection(),
	
	    events: {
	        'click #save-relationtype': 'saveRelationType',
	        'keyup input#filter-relationtype': 'applyFilter'
	    },
	
	    regions: {
	        modal: '#addRelationTypeModal',
	        form: '#form',
	        table: '#relationtypes-table'
	    },
	
	    collectionEvents: {
	        add: 'itemAdded',
	        request: 'showLoading',
	        sync: 'hideLoading',
	        error: 'logError'
	    },
	
	    initialize: function(options){
	        this.model = new RelationType();
	        this.model.view = this;
	        this.model.on('invalid', this.onErrors);
	        _.bindAll(this, 'onRender', 'renderTable', 'itemSaved',
	            'saveRelationType', 'applyFilter', 'onErrors');
	    },
	
	    onErrors: function(model, errors) {
	        model.view.triggerMethod('server:error', errors.join('. \n'));
	    },
	
	    onRender: function(){
	        var that = this;
	        var dboTypes = new DboTypesCollection();
	        dboTypes.fetch({success: function() {
	            that.relationTypeForm = new RelationTypeForm({model: that.model, dboTypes: dboTypes});
	            that.showChildView('form', that.relationTypeForm);
	        }});
	        that.collection.fetch({success: that.renderTable(that.collection)});
	    },
	
	    renderTable: function(collection){
	        var that = this;
	        that.showChildView('table', new RelationTypesListView({relationtypes: collection, filter: ''}));
	    },
	
	    saveRelationType: function () {
	        var that = this;
	        that.model = that.relationTypeForm.fillModel();
	        that.model.save(that.model.toJSON(), {success: function(response) {
	            that.itemSaved();
	            $('#addRelationTypeModal').modal('hide');
	        }
	        });
	    },
	
	    itemAdded: function() {
	        this.model = this.relationTypeForm.clearModel();
	    },
	
	    itemSaved: function(){
	        this.collection.add(this.model.clone());
	    },
	
	    applyFilter: function(event) {
	        var that = this;
	        that.getChildView('table').setFilter(event.target.value);
	    },
	
	    showLoading: function() {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function() {
	        this.$('.loading').hide();
	    },
	
	    logError: function(obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    }
	
	});
	
	
	module.exports = RelationTypesList;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	var RelationType = __webpack_require__(224);
	var DboTypesCollection = __webpack_require__(430);
	
	var RelationTypeForm = Marionette.View.extend({
	    tagName: 'form',
	    template: __webpack_require__(431),
	    model: new RelationType(),
	    //collection: new DboTypesCollection(),
	
	    modelEvents: {
	        change: 'render'
	    },
	
	    ui: {
	        name: '#name',
	        description: '#description',
	        parentType: '#parent-type',
	        childType: '#child-type'
	    },
	
	    templateContext: function(){
	        var that = this;
	        return {
	            items: that.collection.map(function(item) {
	                return item.get("name");
	            }),
	            len: that.collection.length
	        }
	    },
	
	    initialize: function(options){
	        var that = this;
	        _.bindAll(that, 'fillModel', 'clearModel');
	        that.model.on('change', that.render, that);
	        that.collection = options.dboTypes;
	        /*that.collection.fetch({success: function() {
	        }});*/
	    },
	
	    onRender: function() {
	        this.$('#parent-type').selectize({
	            allowEmptyOption: false
	        });
	        this.$('#child-type').selectize({
	            allowEmptyOption: false
	        });
	    },
	
	    fillModel: function(){
	        var that = this;
	        that.model.set({
	            name: that.ui.name.val(),
	            description: that.ui.description.val(),
	            parentType: that.ui.parentType.val(),
	            childType: that.ui.childType.val()
	        }/*, {validate: true}*/);
	        return this.model;
	    },
	
	    clearModel: function(){
	        this.model.set(this.model.defaults);
	        return this.model;
	    }
	
	});
	
	module.exports = RelationTypeForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	
	
	var DboTypesCollection = BaseCollection.extend({
	
	    url:"/api/relationtype/dbotypes",
	
	    initialize: function(models, options){
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    },
	
	    parse: function(response) {
	        var transformed = response.map(function(item) {
	            return {'name': item};
	        });
	        return transformed;
	    }
	});
	
	
	module.exports = DboTypesCollection;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form-horizontal">\r\n    <form>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 control-label" for="name">Name</label>\r\n            <div class="col-sm-9">\r\n                <input class="form-control" type="text" id="name" placeholder="Name" required="" value="'+
	((__t=( name ))==null?'':_.escape(__t))+
	'" >\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 control-label" for="description">Decription</label>\r\n            <div class="col-sm-9">\r\n                <textarea class="form-control" rows="5" id="description" maxlength="255">'+
	((__t=( description ))==null?'':_.escape(__t))+
	'</textarea>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 control-label" for="parent-type">Parent type name</label>\r\n            <div class="col-sm-9">\r\n                <select id="parent-type" data-placeholder="Parent type" value="'+
	((__t=( parentType ))==null?'':_.escape(__t))+
	'">\r\n                    <option value=""></option>\r\n                    ';
	 _.each(items, function(item){ 
	__p+='\r\n                    ';
	 if (parentType == item) {
	__p+='\r\n                    <option value="'+
	((__t=( item ))==null?'':__t)+
	'" name="'+
	((__t=( item ))==null?'':__t)+
	'" selected> '+
	((__t=( item ))==null?'':__t)+
	'</option>\r\n                    ';
	 } else { 
	__p+='\r\n                    <option value="'+
	((__t=( item ))==null?'':__t)+
	'" name="'+
	((__t=( item ))==null?'':__t)+
	'" > '+
	((__t=( item ))==null?'':__t)+
	'</option>\r\n                    ';
	 } 
	__p+='\r\n                    ';
	 }) 
	__p+='\r\n                </select>\r\n                <!--<input class="form-control" type="text" id="parent-type" placeholder="Parent type" value="'+
	((__t=( parentType ))==null?'':_.escape(__t))+
	'" >-->\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 control-label" for="child-type">Child type name</label>\r\n            <div class="col-sm-9">\r\n                <select id="child-type" data-placeholder="Child type" value="'+
	((__t=( childType ))==null?'':_.escape(__t))+
	'">\r\n                    <option value=""></option>\r\n                    ';
	 _.each(items, function(item){ 
	__p+='\r\n                    ';
	 if (childType == item) {
	__p+='\r\n                    <option value="'+
	((__t=( item ))==null?'':__t)+
	'" name="'+
	((__t=( item ))==null?'':__t)+
	'" selected>'+
	((__t=( item ))==null?'':__t)+
	'</option>\r\n                    ';
	 } else { 
	__p+='\r\n                    <option value="'+
	((__t=( item ))==null?'':__t)+
	'" name="'+
	((__t=( item ))==null?'':__t)+
	'">'+
	((__t=( item ))==null?'':__t)+
	'</option>\r\n                    ';
	 } 
	__p+='\r\n                    ';
	 }) 
	__p+='\r\n                </select>\r\n                <!--<input class="form-control" type="text" id="child-type" placeholder="Child type" value="'+
	((__t=( childType ))==null?'':_.escape(__t))+
	'" >-->\r\n            </div>\r\n        </div>\r\n    </form>\r\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	var RelationTypesCollection = __webpack_require__(223);
	
	var RelationTypeItem = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(433),
	
	    initialize : function (options) {
	    },
	
	    templateContext: function(){
	        var that = this;
	        var description = that.model.get('description');
	        return {
	            fullDescription: description,
	            description: description.length > 100 ? (description.substr(0, 97) + '...') : description
	        }
	    },
	
	    className: function() {
	        var filter = this.getOption('filter');
	        var utils = new CommonUtils();
	        if (utils.stringContains(this.model.attributes.name, filter) || utils.stringContains(this.model.attributes.description, filter)
	            || utils.stringContains(this.model.attributes.parentType, filter) || utils.stringContains(this.model.attributes.childType, filter)) {
	            return '';
	        }
	        else {
	            return 'hidden';
	        }
	    },
	
	    onRender: function() {
	        this.$('[data-toggle="tooltip"]').tooltip();
	    }
	});
	
	var RelationTypesListView = Marionette.CompositeView.extend({
	    template: __webpack_require__(434),
	    childViewContainer:'#relationtypes-list',
	    childView: RelationTypeItem,
	    collection: new RelationTypesCollection(),
	
	    filter: '',
	
	    collectionEvents: {
	        request: 'showLoading',
	        sync: 'hideLoading',
	        error: 'logError'
	    },
	
	    childViewOptions: function() {
	        return {filter: this.filter};
	    },
	
	    initialize: function(options){
	        this.filter = this.getOption('filter');
	        if (this.getOption('relationtypes')) {
	            this.collection = this.getOption('relationtypes');
	        }
	        else {
	            this.collection.fetch();
	        }
	
	    },
	
	    setFilter: function(filter) {
	        this.filter = filter;
	        this.render();
	        this.hideLoading();
	    },
	
	    showLoading: function() {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function() {
	        this.$('.loading').hide();
	    },
	
	    logError: function(obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    }
	});
	
	
	module.exports = RelationTypesListView;

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td><a href = "/#relationtype/'+
	((__t=( id ))==null?'':__t)+
	'">'+
	((__t=( name ))==null?'':__t)+
	'</a></td>\r\n<td><div data-toggle="tooltip" title="'+
	((__t=( fullDescription ))==null?'':__t)+
	'">'+
	((__t=( description ))==null?'':__t)+
	'</div></td>\r\n<td>'+
	((__t=( parentType ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( childType ))==null?'':__t)+
	'</td>\r\n';
	}
	return __p;
	};


/***/ }),
/* 434 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="loading"></div>\r\n<div id="relationtypes-list-container">\r\n    <table class="table-striped table-hover table-condensed">\r\n        <head>\r\n            <thead>\r\n            <tr>\r\n                <th>Name</th>\r\n                <th>Description</th>\r\n                <th>Parent type</th>\r\n                <th>Child type</th>\r\n            </tr>\r\n            </thead>\r\n        </head>\r\n        <tbody id="relationtypes-list"></tbody>\r\n    </table>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 435 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row">\r\n    <div class="col-xs-10 col-md-6">\r\n        <div class="row">\r\n            <div class="col-xs-3 col-md-6">\r\n                <h1>\r\n                    Relation types\r\n                </h1>\r\n            </div>\r\n            <div class="col-xs-1 col-md-1 filter">\r\n                <button type="button" title="Add" class="btn btn-primary" data-toggle="modal" data-target="#addRelationTypeModal">+</button>\r\n            </div>\r\n            <div class="col-xs-5 col-md-5 filter">\r\n                <form><input class="form-control" type="text" id="filter-relationtype" placeholder="Filter"></form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class="loading"></div>\r\n<div id="relationtypes-table"></div>\r\n\r\n\r\n<!--Modal -->\r\n<div class="modal fade" id="addRelationTypeModal" tabindex="-1" role="dialog" aria-labelledby="addRelationTypeModalLabel">\r\n    <div class="modal-dialog modal-lg" role="document">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\r\n                <h4 class="modal-title" id="addRelationTypeModalLabel">Add new relation type</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <div id="form"></div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>\r\n                <button type="button" class="btn btn-primary" id="save-relationtype">Save changes</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var RelationTypeForm = __webpack_require__(429);
	var RelationType = __webpack_require__(224);
	var DeleteConfirmationModal = __webpack_require__(241);
	var DboTypesCollection = __webpack_require__(430);
	
	
	var RelationTypeView = Marionette.View.extend({
	    template: __webpack_require__(437),
	    regions:{
	        relationTypeForm: '#relationtype-form',
	        editSection: '#edit-section',
	        deleteRelationTypeConfirmationModal: '.delete-confirmation-modal'
	    },
	
	    events:{
	        'click #cancel-edit': 'backToList',
	        'click #save-relationtype': 'saveChanges',
	        'click #remove-relationtype': 'removeRelationType'
	    },
	
	    childViewEvents:{
	        'delete:confirmed': 'deleteConfirmed'
	    },
	
	    initialize: function(){
	        this.model = new RelationType();
	        this.model.set('id', this.id);
	        this.model.view = this;
	        this.model.on('invalid', this.onErrors);
	        _.bindAll(this, 'onRender', 'renderRelationType', 'backToList', 'saveChanges', 'removeRelationType');
	        this.dboTypes = new DboTypesCollection();
	        this.dboTypes.fetch({success: function() {
	        }});
	    },
	
	    onErrors: function(model, errors) {
	        model.view.triggerMethod('server:error', errors.join('. \n'));
	    },
	
	    onRender: function(){
	        this.model.fetch({success: this.renderRelationType});
	    },
	
	    renderRelationType: function(){
	        var that = this;
	        that.relationTypeForm = new RelationTypeForm({model: that.model, dboTypes: that.dboTypes});
	        that.showChildView('relationTypeForm', that.relationTypeForm);
	        that.deleteRelationTypeConfirmationModal =
	            new DeleteConfirmationModal({message: 'Enter: "confirm" if you agree to remove this relation type.',
	                confirmationAnswer: 'confirm'});
	        that.showChildView('deleteRelationTypeConfirmationModal', that.deleteRelationTypeConfirmationModal);
	    },
	
	    backToList: function(){
	        Backbone.history.navigate('/relationtypes', {
	            trigger: true
	        });
	    },
	
	    saveChanges: function(){
	        var that = this;
	        that.model = that.relationTypeForm.fillModel();
	        that.model.save(that.model.toJSON(), {success: function(response) {
	            that.backToList();
	        }
	        });
	    },
	
	    removeRelationType: function(){
	        this.$('#delete-confirmation-modal').modal();
	    },
	
	    deleteConfirmed: function(value) {
	        if (value == true) {
	            var that = this;
	            this.model.destroy({
	                dataType: "text",
	                success: function() {
	                    that.remove();
	                    that.unbind();
	                    that.backToList();
	                }
	            });
	        }
	    }
	
	});
	
	module.exports = RelationTypeView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div id="edit-section">\r\n    <h1>Relation type edit</h1>\r\n    <div id="relationtype-form" class="edit-form"></div>\r\n    <div id="edit-buttons" class="edit-buttons">\r\n        <div class="left-buttons">\r\n            <button type="button" class="btn btn-default" id="cancel-edit">Cancel</button>\r\n            <button type="button" class="btn btn-primary" id="save-relationtype">Save changes</button>\r\n        </div>\r\n        <div class="right-buttons">\r\n            <button type="button" class="btn btn-danger" id="remove-relationtype">Remove</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class="delete-confirmation-modal"></div>';
	}
	return __p;
	};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var EntitiesSelectView = __webpack_require__(226);
	var DocumentTypesCollection = __webpack_require__(401);
	var RemoteSuggesterView = __webpack_require__(196);
	var AssignReviewersForm = __webpack_require__(439);
	var DocumentMetaModal = __webpack_require__(394);
	
	var Radio = __webpack_require__(183);
	var sessionChannel = Radio.channel('session');
	
	var CommonUtils = __webpack_require__(189);
	var Dicts = __webpack_require__(193);
	
	var DocumentUploadView = Marionette.View.extend({
	    template: __webpack_require__(441),
	
	    regions: {
	        organizations: "#organizations-list",
	        patients: '#patients-list',
	        docTypes: '#doc-types-list',
	        assignReviewersFormRegion: '#assign-reviewers-form',
	        addMetaFormRegion: '#add-meta-form'
	    },
	
	    childViewEvents: {
	        'entity:selected': 'entitySelected',
	        'suggestor:selected:patient': 'onPatientSelected',
	        'reviewers:added:to:document': 'onReviewersAdded'
	    },
	
	    ui: {
	        fileSelector: '#file-input',
	        uploadedDocumentsList: '#uploaded-documents-list',
	        assign: '#assign',
	        checkAll: '#check-all',
	        addMeta: '#add-meta'
	    },
	
	    events: {
	        'click input[type=checkbox]': 'onUploadedDocumentChecked',
	        'click @ui.assign': 'onAssign',
	        'click @ui.addMeta': 'onAddMeta',
	        'click @ui.checkAll': 'onCheckAll'
	    },
	
	    defaultParameters: {
	        'patientId': '',
	        'documentTypeId': '',
	        requestedFromFrontend: true
	    },
	
	    constants: {
	        maxNumberOfItemsInControlWithSuggester: 20
	    },
	
	    initialize: function () {
	        this.utils = new CommonUtils();
	        var permissions = sessionChannel.request('get:permissions');
	        if ((permissions.systemRoles || []).indexOf('ADMIN') <= -1) {
	            this.canUploadForIds = (permissions.userPermissions || [])
	                .filter(function (permission) {
	                    return permission.canUploadFor
	                })
	                .map(function (permission) {
	                    return {key: 'id', value: permission.permittedObjectId}
	                });
	        }
	
	        this.docTypesCollection = new DocumentTypesCollection([], {
	            params: [{key: 'sortby', value: 'name'}, {key: 'sortdir', value: 'ASC'}]
	        });
	
	        this.uploadedDocuments = [];
	    },
	
	
	    onRender: function () {
	        window.document.title = "Upload documents";
	        var that = this;
	        that.parameters = _.clone(that.defaultParameters);
	
	        that.organizationsSelectView = new EntitiesSelectView({
	            entityType: 'organization',
	            customPlaceholder: 'Select an organization',
	            params: this.canUploadForIds
	        });
	        that.showChildView('organizations', that.organizationsSelectView);
	
	
	        that.showChildView('patients', new RemoteSuggesterView({
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: '/api/dbo/preview?page-size=' + that.constants.maxNumberOfItemsInControlWithSuggester
	            + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data.filter(function (item) {
	                    return item.object && item.object.isPatient && item.object.mergeable === false;
	                });
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return (arr[index] || {}).id;
	            },
	            placeholder: "Search and select a patient",
	            classes: ["form-control"],
	            tag: 'patient'
	        }));
	
	        that.docTypesCollection.fetch({
	            success: function () {
	                that.documentTypeSelectView = new EntitiesSelectView({
	                    entityType: 'documentType',
	                    customPlaceholder: 'Select a document type',
	                    collectionValues: that.docTypesCollection
	                });
	                that.showChildView('docTypes', that.documentTypeSelectView);
	            }
	        });
	
	        that.ui.fileSelector.fileinput({
	            uploadUrl: "/api/document/upload/",
	            allowedFileExtensions: that.fileExtension(),
	            dropZoneTitle: 'Drag & drop files here &hellip; <br>Organization should be selected',
	            uploadExtraData: that.parameters
	        });
	
	        that.ui.fileSelector.fileinput('disable');
	
	        that.ui.fileSelector.on('fileuploaded', function (event, data, previewId, index) {
	            var documentId = data.response.id;
	            var documentName = data.response.name;
	
	            that.uploadedDocuments.push({
	                id: documentId,
	                name: documentName,
	                selected: false
	            });
	        });
	
	        that.ui.fileSelector.on('filebatchuploadcomplete', function (event, files, extra) {
	            that.renderUploadedDocumentsList();
	        });
	    },
	
	    fileExtension: function() {
	        return _.keys(Dicts.documentTypes)
	    },
	
	    entitySelected: function (data) {
	        if (typeof data.id === 'undefined' || data.id == '') {
	            if (data.type == 'documentType')
	                this.parameters.documentTypeId = '';
	            else if (data.type == 'organization')
	                this.ui.fileSelector.fileinput('disable');
	            return;
	        }
	
	        if (data.type == 'organization') {
	            this.ui.fileSelector.fileinput('refresh', {uploadUrl: "/api/document/upload/" + data.id});
	            this.ui.fileSelector.fileinput('enable');
	        }
	
	        if (data.type == 'documentType') {
	            this.parameters.documentTypeId = data.id
	        }
	    },
	
	    onPatientSelected: function (id) {
	        this.parameters.patientId = (id == null ? '' : id);
	    },
	
	    renderUploadedDocumentsList: function () {
	        var that = this;
	        that.ui.uploadedDocumentsList.empty();
	        that.uploadedDocuments.forEach(function (document) {
	            var template = '<label class="checkbox"><input type="checkbox" id="' + document.id + '"/><a href="/#document/' + document.id
	                + '" target="_blank">' + document.name + '</a></label>';
	            that.ui.uploadedDocumentsList.append(template);
	        });
	
	        if (that.uploadedDocuments.length > 0) {
	            that.ui.checkAll.parent().parent().show();
	            that.ui.checkAll.prop('checked', true);
	            that.uploadedDocuments.forEach(function (document) {
	                document.selected = true;
	            });
	            that.checkOrUncheckAllCheckboxes(true);
	        } else {
	            that.ui.checkAll.parent().parent().hide();
	            that.ui.checkAll.prop('checked', false);
	        }
	        that.checkSelectedDocuments();
	    },
	
	    onUploadedDocumentChecked: function (event) {
	        var that = this;
	        var selectedDocumentId = event.target.id;
	        if (event.target.checked) {
	            that.uploadedDocuments.forEach(function (document) {
	                if (document.id == selectedDocumentId)
	                    document.selected = true;
	            });
	        } else {
	            that.uploadedDocuments.forEach(function (document) {
	                if (document.id == selectedDocumentId)
	                    document.selected = false;
	            });
	            that.ui.checkAll.prop('checked', false);
	        }
	        that.checkSelectedDocuments();
	    },
	
	    onCheckAll: function (event) {
	        var that = this;
	        if (event.target.checked) {
	            that.uploadedDocuments.forEach(function (document) {
	                document.selected = true;
	            });
	            that.checkOrUncheckAllCheckboxes(true);
	        } else {
	            that.uploadedDocuments.forEach(function (document) {
	                document.selected = false;
	            });
	            that.checkOrUncheckAllCheckboxes(false);
	        }
	        that.checkSelectedDocuments();
	    },
	
	    checkOrUncheckAllCheckboxes: function (checked) {
	        var that = this;
	        that.ui.uploadedDocumentsList.find('input[type=checkbox]').each(function () {
	            $(this).prop('checked', checked);
	        });
	    },
	
	    checkSelectedDocuments: function () {
	        var that = this;
	        var selectedCnt = _.filter(that.uploadedDocuments, function (document) {
	            return document.selected == true;
	        }).length;
	
	        if (selectedCnt == 0) {
	            that.ui.assign.attr('disabled', true);
	            that.ui.addMeta.attr('disabled', true);
	        } else {
	            that.ui.assign.removeAttr('disabled');
	        }
	
	        if (selectedCnt == 1)
	            that.ui.addMeta.removeAttr('disabled');
	    },
	
	    onAssign: function () {
	        var that = this;
	
	        that.showChildView('assignReviewersFormRegion', new AssignReviewersForm({
	            docIds: that.getSelectedDocumentsIds()
	        }));
	    },
	
	    getSelectedDocumentsIds: function() {
	        return this.uploadedDocuments.filter(function (document) {
	            return document.selected == true;
	        }).map(function (document) {
	            return document.id;
	        });
	    },
	
	    onReviewersAdded: function () {
	        $.notify("Reviewers added successfully", "success");
	    },
	
	    onAddMeta: function() {
	        var that = this;
	
	        that.showChildView('addMetaFormRegion', new DocumentMetaModal({
	            documentId: that.getSelectedDocumentsIds()[0],
	            meta: that.utils.initialMeta()
	        }));
	    }
	});
	
	module.exports = DocumentUploadView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var ReviewerFormView = __webpack_require__(315);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	
	var AssignReviewersForm = Marionette.View.extend({
	    template: __webpack_require__(440),
	
	    regions: {
	    },
	
	    ui: {
	        modal: '#addReviewersModal',
	        reviewers: '.reviewers-review',
	        saveReviewers: '#save',
	        addReviewer: '.add-reviewer'
	    },
	
	    events: {
	        'click @ui.addReviewer': 'addReviewer',
	        'click @ui.saveReviewers': 'saveReviewers'
	    },
	
	    childViewEvents: {
	        'reviewer:will-be-remove': 'reviewerRemove',
	        'reviewer:changed': 'onReviewerChanged'
	    },
	
	    initReviewer: function () {
	        return {
	            personId: "",
	            organizationId: "",
	            mandatory: true
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.reviewers = [];
	        that.utils = new CommonUtils();
	        that.docIds = options.docIds;
	    },
	
	    onRender: function () {
	        var that = this;
	        that.show();
	    },
	
	    addReviewer: function () {
	        var reviewer = this.initReviewer();
	        this.reviewers.push(reviewer);
	        var newRegionId = _.uniqueId('reviewer');
	        this.ui.reviewers.append('<div id="' + newRegionId + '"></div>');
	        this.addRegion(newRegionId, "#" + newRegionId);
	        this.storeRegion(newRegionId);
	        this.showChildView(newRegionId, new ReviewerFormView({
	            reviewer: reviewer,
	            regionId: newRegionId
	        }));
	
	        this.checkReviewers();
	    },
	
	    reviewerRemove: function (data) {
	        var that = this;
	        var regionId = data.regionId;
	        var reviewer = data.reviewer;
	        that.getRegion(regionId).empty();
	        that.removeRegion(regionId);
	        that.$('#' + regionId).remove();
	        this.tempRegionNames = this.tempRegionNames.filter(function (item) {
	            return item !== regionId;
	        });
	        that.reviewers = that.reviewers.filter(function (item) {
	            return item !== reviewer;
	        });
	        that.checkReviewers();
	    },
	
	    saveReviewers: function () {
	        if (this.reviewers.length == 0 || this.docIds == [] || _.isEmpty(this.docIds))
	            return;
	
	        var that = this;
	        that.utils.showSpinner('#add-reviewers-loader');
	        $.ajax({
	            type: "POST",
	            url: '/api/document/multi/' + that.docIds.join() + '/reviewers',
	            data: JSON.stringify(that.reviewers),
	            contentType: 'application/json',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner('#add-reviewers-loader');
	                    that.reviewersSaved();
	                    that.triggerMethod('reviewers:added:to:document');
	                }
	            },
	            error: function(e) {
	                that.utils.hideSpinner('#add-reviewers-loader');
	                notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        });
	    },
	
	    reviewersSaved: function() {
	        var that = this;
	        if (that.tempRegionNames) {
	            that.tempRegionNames.forEach(function (item) {
	                that.getRegion(item).empty();
	                that.removeRegion(item);
	                that.$('#' + item).remove();
	            });
	        }
	        that.tempRegionNames = [];
	        that.reviewers = [];
	        that.hide();
	    },
	
	    deleteRegion: function (regionId) {
	        this.getRegion(regionId).empty();
	        this.removeRegion(regionId);
	        this.$('#' + regionId).remove();
	    },
	
	    storeRegion: function (regionName) {
	        this.tempRegionNames = this.tempRegionNames || [];
	        this.tempRegionNames.push(regionName);
	    },
	
	    show: function() {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function() {
	        this.ui.modal.modal('hide');
	    },
	
	    onReviewerChanged: function() {
	        this.checkReviewers();
	    },
	
	    checkReviewers: function() {
	        var that = this;
	        if (that.reviewers.filter(function(reviewer) {
	                return reviewer.organizationId || reviewer.personId;
	            }).length == that.reviewers.length)
	            that.ui.saveReviewers.removeAttr('disabled');
	        else
	            that.ui.saveReviewers.attr('disabled', true);
	    }
	});
	
	module.exports = AssignReviewersForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\r\n<!-- Reviews add Modal -->\r\n<div class="modal fade" id="addReviewersModal" tabindex="-1" role="dialog" aria-labelledby="addReviewersModal">\r\n    <div class="modal-dialog modal-lg" role="document">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\r\n                        aria-hidden="true">&times;</span></button>\r\n                <h4 class="modal-title" id="addReviewersModalLabel">Add reviewers</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <div class="reviewers-review row"></div>\r\n                <div>\r\n                    <div class="form-inline">\r\n                        <div class="form-group"><span class="add-reviewer dotted-link">+ Add reviewer</span></div>\r\n                    </div>\r\n                </div>\r\n                <div id="add-reviewers-loader" class="loader" style="height: 200px;"></div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>\r\n                <button type="button" class="btn btn-primary" id="save" disabled>Save</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 441 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row container">\n    <div class="col-md-8 col-xs-8">\n        <h2>Documents upload</h2>\n        <div class="row">\n            <div id="organizations-list" class="col-md-4"></div>\n            <div id="patients-list" class="col-md-4"></div>\n            <div id="doc-types-list" class="col-md-4" style="display: none;"></div>\n        </div>\n        <input id="file-input" name="file" type="file" class="file" multiple data-show-caption="true">\n    </div>\n    <div class="col-md-offset-1 col-xs-offset-1 col-md-3 col-xs-3">\n        <h2>Uploaded</h2>\n        <div hidden>\n            <label class="checkbox"><input type="checkbox" id="check-all"/><b>All</b></label>\n        </div>\n        <div id="uploaded-documents-list" class="form"></div>\n        <button id="assign" class="btn btn-primary" disabled>Assign</button>\n        <button id="add-meta" class="btn btn-primary" disabled>Add metadata</button>\n    </div>\n</div>\n\n<div id="assign-reviewers-form"></div>\n<div id="add-meta-form"></div>';
	}
	return __p;
	};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var RemoteSuggesterView = __webpack_require__(196);
	var UploadSignedDocumentForm = __webpack_require__(443);
	var YesNoConfirmationModal = __webpack_require__(237);
	
	var DocumentsCollection = __webpack_require__(302);
	
	var UploadSignedDocumentView = Marionette.View.extend({
	    template: __webpack_require__(445),
	
	    regions: {
	        patientSelect: '#patient-select',
	        uploadForm: '#upload-form',
	        confirmationModal: '#confirmation-modal'
	    },
	
	    childViewEvents: {
	        'suggestor:selected:patient': "onPatientSelected",
	        'signed:document:uploaded': "onDocumentUploaded",
	        'action:confirmed': 'onSignSignedDocumentConfirmed'
	    },
	
	    ui: {
	        barcode: "#barcode",
	        search: '#search-documents',
	        docs: "#fount-docs"
	    },
	
	    events: {
	        'keyup @ui.barcode': 'onChangeBarcode',
	        'click @ui.search': 'searchDocuments'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {}
	    },
	
	    initialize: function (options) {
	        this.utils = new CommonUtils();
	    },
	
	
	    onRender: function () {
	        window.document.title = "Upload signed documents";
	        var that = this;
	        that.showPatientsSelect();
	
	        this.confirmationModal = new YesNoConfirmationModal({
	            tag: 'sign-signed-doc',
	            message: "This document is already signed within the portal. Would you like to replace it with a new document?"
	        });
	        this.showChildView('confirmationModal', this.confirmationModal);
	    },
	
	    showPatientsSelect: function () {
	        var that = this;
	
	        that.showChildView('patientSelect', new RemoteSuggesterView({
	            multiSelect: false,
	            maxNumberOfElements: 20,
	            url: '/api/person/preview?page-size=' + 20
	                + '&sortby=name&like_name=~~~&object_mergeable=false&object_isPatient=true',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data.filter(function (item) {
	                    return item.object;
	                });
	            },
	            getIdFn: function (element) {
	                return element.id;
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Patient",
	            tag: 'patient',
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return arr[index] || null;
	            }
	        }));
	    },
	
	    enableDisableSearch: function () {
	        if (this.ui.barcode.val() || this.selectedPatient)
	            this.ui.search.removeAttr("disabled");
	        else
	            this.ui.search.attr("disabled", true);
	    },
	
	    onChangeBarcode: function (e) {
	        this.enableDisableSearch();
	    },
	
	    onPatientSelected: function (selected) {
	        this.selectedPatient = selected;
	        this.enableDisableSearch();
	    },
	
	    onDocumentUploaded: function (doc) {
	        Backbone.history.navigate('/document/' + doc.id, {trigger: true});
	    },
	
	    searchDocuments: function () {
	        var that = this;
	        that.detachChildView('uploadForm');
	
	        var params = [
	            {key: 'sortby', value: 'createdTime'},
	            {key: 'sortdir', value: 'DESC'},
	            {key: 'object_type', value: 'pdf'},
	            {key: 'object_status', value: 'IN_REVIEW'},
	            {key: 'object_status', value: 'UNDER_REVIEW'},
	            {key: 'object_status', value: 'SIGNED'}
	        ];
	
	        if (this.ui.barcode.val())
	            params.push({key: 'object_externalIds_in', value: Constants.barCodePrefix + that.ui.barcode.val()});
	        if (this.selectedPatient)
	            params.push({key: 'object_patientId', value: that.selectedPatient.id});
	
	        var documentsCollection = new DocumentsCollection([], {
	            params: params
	        });
	        documentsCollection.fetch({
	            success: function () {
	                var rows = documentsCollection.map(function (model) {
	                    return model.attributes;
	                });
	                that.documents = rows;
	                that.renderDocuments(rows);
	            },
	            error: function (e) {
	                that.logError(e);
	            }
	        });
	    },
	
	    renderDocuments: function (rows) {
	        var that = this;
	
	        if (rows.length == 0) {
	            this.ui.docs.html("No documents");
	            return;
	        }
	
	        var listStart = '<ul class="list-group">';
	        var listEnd = "</ul>";
	        var listContent = rows.map(function (row) {
	            var checkbox = '<input type="checkbox" id="' + row.id + '" class="doc-check"/>';
	            var linkToViewDoc = '<a href="/api/document/view/' + row.id
	                + '" target="_blank" class="view"><span class="clickable glyphicon glyphicon-eye-open"/></a>';
	            var linkToDoc = '<a href="/#document/' + row.id + '" target="_blank">' + row.name + '</a>';
	            var docStatus = that.utils.getDocumentStatus((row.object || {}).status);
	            return '<li class="list-group-item">' + linkToViewDoc + '&nbsp;' + checkbox + '&nbsp;' + linkToDoc + " (" + docStatus + ") " + "</li>"
	        }).join("");
	
	        this.ui.docs.html(listStart + listContent + listEnd);
	
	        $(function () {
	            $('.doc-check').click(function (e) {
	                var id = e.target.id;
	                $('.doc-check').each(function (i, el) {
	                    if (el.id !== id) {
	                        $(this).prop('checked', false);
	                    }
	                });
	                that.renderForm(id, e.target.checked);
	            });
	        });
	    },
	
	    renderForm: function (documentId, selected) {
	        var selectedDocument = _.findWhere(this.documents, {id: documentId});
	        this.detachChildView('uploadForm');
	
	        if (selected) {
	            this.selectedDocument = selectedDocument;
	            if (selectedDocument.object.status !== "SIGNED")
	                this.showChildView("uploadForm", new UploadSignedDocumentForm({document: selectedDocument}));
	            else {
	                this.confirmationModal.show();
	            }
	        }
	    },
	
	    onSignSignedDocumentConfirmed: function (data) {
	        if (data.tag === 'sign-signed-doc' && data.result == true) {
	            this.showChildView("uploadForm", new UploadSignedDocumentForm({document: this.selectedDocument}));
	        } else {
	            this.confirmationModal.hide();
	            $('#' + this.selectedDocument.id).prop('checked', false);
	        }
	    }
	});
	
	module.exports = UploadSignedDocumentView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var RemoteSuggesterView = __webpack_require__(196);
	
	var UploadSignedDocumentForm = Marionette.View.extend({
	    template: __webpack_require__(444),
	
	    regions: {
	        reviewerPerson: '#reviewer-person',
	        reviewerOrg: '#reviewer-org'
	    },
	
	    childViewEvents: {
	        'suggestor:selected:person': 'onPersonChanged',
	        'suggestor:selected:organization': 'onOrganizationChanged'
	    },
	
	    ui: {
	        status: '#status',
	        fileSelector: '#file-input',
	        statusTime: '#status-time',
	        statusTimeLabel: '#status-time-label',
	        comment: "#comment",
	
	        reviewerPerson: '#reviewer-person',
	        reviewerOrg: '#reviewer-org'
	    },
	
	    events: {
	        'change @ui.status': 'onStatusChange',
	        'keyup @ui.comment': 'onComment'
	    },
	
	    defaultParameters: {
	        reviewerUUID: "",
	        reviewerPersonId: "",
	        reviewerOrgId: "",
	        time: 0,
	        comment: ""
	    },
	
	    parameters: {},
	
	    templateContext: function () {
	        var that = this;
	        return {
	            signStatusOfDocument: (that.document.object || {}).status
	        }
	    },
	
	    initialize: function (options) {
	        console.log("initialize");
	        this.document = options.document;
	        this.utils = new CommonUtils();
	        this.status = 'sign';
	
	        this.initReviewer(this.document);
	    },
	
	    initReviewer: function (document) {
	        var reviewer = _.findWhere(document.object.reviewers, {status: "UNDER_REVIEW"})
	            || _.findWhere(document.object.reviewers, {status: "IN_REVIEW"})
	            || _.findWhere(document.object.reviewers, {status: "UNREVIEWED"})
	            || _.findWhere(document.object.reviewers, {status: "SIGNED"});
	        console.log(reviewer);
	
	        this.defaultParameters.reviewerPersonId = reviewer.personId || "";
	        this.defaultParameters.reviewerOrgId = reviewer.organizationId || "";
	        this.defaultParameters.reviewerUUID = reviewer.uuid;
	
	        this.reviewerPerson = _.isEmpty(reviewer.personId) ? null : _.find(document.relations, function (relation) {
	            return relation.child.id == reviewer.personId;
	        }).child;
	        console.log(this.reviewerPerson);
	        this.reviewerOrg = _.isEmpty(reviewer.organizationId) ? null : _.find(document.relations, function (relation) {
	            return relation.child.id == reviewer.organizationId;
	        }).child;
	        console.log(this.reviewerOrg);
	    },
	
	    onRender: function () {
	        var that = this;
	        that.parameters = _.clone(that.defaultParameters);
	        that.parameters.time = new Date().getTime();
	
	        that.ui.fileSelector.fileinput({
	            uploadLabel: 'Upload for sign',
	            uploadUrl: "/api/document/upload/" + that.document.id + "/" + that.status,
	            allowedFileExtensions: ["pdf"],
	            dropZoneTitle: 'Drag & drop a PDF-file to here &hellip;',
	            uploadExtraData: that.parameters
	        });
	
	        that.ui.fileSelector.on('fileuploaded', function (event, data, previewId, index) {
	
	            $.notify("The document was "
	                + (that.status == 'sign' ? 'signed' : (that.status == 'under_review' ? 'under review' : ""))
	                + " successfully", "success");
	            window.setTimeout(function () {
	                that.triggerMethod("signed:document:uploaded", that.document);
	            }, 0);
	        });
	
	        that.ui.statusTime.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'MM/DD/YYYY hh:mm A',
	            defaultDate: new Date(that.parameters.time),
	            maxDate: new Date()
	        });
	        that.ui.statusTime.on("dp.change", function (e) {
	
	            if (e.date) {
	                that.parameters.time = e.date.valueOf();
	            } else {
	                that.parameters.time = 0;
	            }
	        })/*.on('dp.show', function () {
	            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(new Date()));
	        })*/;
	
	        that.showReviewerPersonSelect(that.reviewerPerson);
	        that.showReviewerOrgSelect(that.reviewerOrg);
	
	        window.setTimeout(function () {
	            that.disableReviewerInputs();
	        }, 0);
	    },
	
	    showReviewerPersonSelect: function (defaultSelected) {
	        var that = this;
	
	        that.showChildView('reviewerPerson', new RemoteSuggesterView({
	            maxNumberOfElements: 20,
	            url: '/api/person/preview?page-size=' + 20 + '&sortby=name&like_name=~~~&object_mergeable=false',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data.filter(function (item) {
	                    return item.object && item.object.isMd;
	                });
	            },
	            getIdFn: function (element) {
	                return element.id;
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Physician",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return (arr[index] || {}).id;
	            },
	            tag: 'person',
	            defaultSelected: defaultSelected
	        }));
	    },
	
	    showReviewerOrgSelect: function (defaultSelected) {
	        var that = this;
	
	        that.showChildView('reviewerOrg', new RemoteSuggesterView({
	            maxNumberOfElements: 20,
	            url: '/api/organization/preview?page-size=' + 20 + '&sortby=name&like_name=~~~&type=organization',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getIdFn: function (element) {
	                return element.id;
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Organization",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return (arr[index] || {}).id;
	            },
	            tag: 'organization',
	            defaultSelected: defaultSelected
	        }));
	    },
	
	    disableReviewerInputs: function () {
	        this.ui.reviewerPerson.find('input').each(function () {
	            $(this).attr('disabled', true);
	        });
	
	        this.ui.reviewerOrg.find('input').each(function () {
	            $(this).attr('disabled', true);
	        });
	    },
	
	    onStatusChange: function (event) {
	        var value = event.target.value;
	        this.status = value;
	        this.ui.fileSelector.fileinput('refresh', {
	            uploadLabel: 'Upload for ' + this.status,
	            uploadUrl: "/api/document/upload/" + this.document.id + "/" + this.status
	        });
	
	        if (value === "sign") {
	            this.ui.statusTimeLabel.text("Signature Date:");
	            this.ui.reviewerPerson.find('input').each(function () {
	                $(this).attr('disabled', true);
	            });
	        } else if (value == "under_review") {
	            this.ui.statusTimeLabel.text("Under Review Date:");
	            this.ui.reviewerPerson.find('input').each(function () {
	                $(this).removeAttr('disabled');
	            });
	        }
	    },
	
	    onComment: function (e) {
	        this.parameters.comment = e.target.value;
	    },
	
	    onPersonChanged: function (selected) {
	        this.parameters.reviewerPersonId = selected;
	    },
	
	    onOrganizationChanged: function (selected) {
	
	    }
	});
	
	module.exports = UploadSignedDocumentForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<div class="form form-horizontal col-md-6 col-xs-6">\n    <div class="form-group">\n        <div class="col-md-6 col-xs-6">\n            <div id="reviewer-person"></div>\n        </div>\n        <div class="col-md-6 col-xs-6">\n            <div id="reviewer-org"></div>\n        </div>\n    </div>\n    <div class="form-group">\n        <label class="col-md-3 col-xs-3 control-label" for="status">Status:</label>\n        <div class="col-xs-9 col-md-9">\n            <select id="status" class="form-control col-md-3 col-xs-3">\n                <option value="sign">SIGN</option>\n                ';
	 if (signStatusOfDocument != 'SIGNED') { 
	__p+='\n                <option value="under_review">UNDER REVIEW</option>\n                ';
	 } 
	__p+='\n            </select>\n        </div>\n    </div>\n    <div class="form-group">\n        <label class="col-md-3 col-xs-3 control-label" for="status-time" id="status-time-label">Signature Date:</label>\n        <div class="col-xs-9 col-md-9">\n            <input type="text" class="form-control col-md-6 col-xs-6" id="status-time">\n        </div>\n    </div>\n    <div class="form-group">\n        <label class="col-md-3 col-xs-3 control-label" for="comment">Comment</label>\n        <div class="col-xs-9 col-md-9">\n            <textarea class="form-control col-md-6 col-xs-6" rows="5" id="comment"></textarea>\n        </div>\n    </div>\n</div>\n\n<div class="form form-horizontal col-md-6 col-xs-6">\n    <div class="form-group">\n        <input id="file-input" name="file" type="file" class="file" data-show-caption="true">\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 445 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h3 class="center">Upload Signed Document</h3>\n\n<div class="row reviewer-row well">\n    <div class="col-md-7 col-xs-7 top-margined">\n        <div class="form form-horizontal">\n            <div class="form-group col-md-4 col-xs-4">\n                <input type="text" id="barcode" class="form-control" placeholder="Barcode"/>\n            </div>\n            <div class="form-group col-md-6 col-xs-6" style="margin-left: 1px;">\n                <div id="patient-select"></div>\n            </div>\n            <div class="form-group col-md-2 col-xs-2" style="margin-left: 1px;">\n                <button id="search-documents" class="btn btn-primary" disabled>Search</button>\n            </div>\n        </div>\n    </div>\n\n    <div class="col-md-5 col-xs-5 top-margined">\n        <div id="fount-docs">No documents</div>\n    </div>\n</div>\n\n<div class="top-margined">\n    <div id="upload-form"></div>\n</div>\n\n<div id="confirmation-modal"></div>';
	}
	return __p;
	};


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var YesNoConfirmationModal = __webpack_require__(237);
	var RolesCollection = __webpack_require__(245);
	var RoleModel = __webpack_require__(246);
	var RoleFormView = __webpack_require__(447);
	
	var RolesRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(449),
	
	    ui: {
	        hiddenableEdit: '.hiddenable',
	        hiddenableComplimentEdit: '.hiddenable-compliment'
	    },
	
	    events: {
	        'click .role-delete': 'removeRoles',
	        'click input[type=checkbox]': 'onChecked',
	        'keyup .role-name': 'onRoleNameChanged',
	        'change .role-type': 'onRoleTypeChanged',
	        'click .role-update': 'updateModel',
	        'click .cancel': 'cancel'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {}
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'removeRoles', 'onChecked', 'onRoleNameChanged', 'onRoleTypeChanged', 'updateModel',
	            'onModelChanged', 'cancel');
	    },
	
	    onRender: function () {
	        this.ui.hiddenableEdit.hide();
	        this.ui.hiddenableComplimentEdit.show();
	        this.modelCopy = new RoleModel(_.clone(this.model.toJSON()));
	    },
	
	    removeRoles: function (event) {
	        this.triggerMethod('delete:model', this.model);
	    },
	
	    onChecked: function (event) {
	        this.model.set(event.target.value, event.target.checked);
	        this.onModelChanged();
	    },
	
	    onRoleNameChanged: function (event) {
	        if (this.model.get('templateName') != event.target.value) {
	            this.model.set('templateName', event.target.value);
	            this.onModelChanged();
	        }
	    },
	
	    onRoleTypeChanged: function (event) {
	        if (this.model.get('templateType') != event.target.value) {
	            this.model.set('templateType', event.target.value);
	            this.onModelChanged();
	        }
	    },
	
	    onModelChanged: function () {
	        this.ui.hiddenableEdit.show();
	        this.ui.hiddenableComplimentEdit.hide();
	        this.ui.hiddenableEdit.parent().css("background-color", "red");
	    },
	
	    updateModel: function () {
	        this.triggerMethod('update:model', this.model);
	    },
	
	    cancel: function () {
	        this.ui.hiddenableEdit.parent().css("background-color", "white");
	        var modelOriginalCid = this.model.cid;
	        this.model = new RoleModel(_.clone(this.modelCopy.toJSON()));
	        this.model.cid = modelOriginalCid;
	        this.triggerMethod('render:model', this.model);
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(13), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var RolesTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: RolesRowView,
	    emptyView: EmptyView,
	
	    collectionEvents: {
	        request: 'showLoading',
	        sync: 'hideLoading',
	        error: 'logError'
	    },
	
	    childViewEvents: {
	        'update:model': 'updateModel',
	        'delete:model': 'deleteModel',
	        'render:model': 'reRenderModel'
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'showLoading', 'hideLoading', 'logError', 'updateModel', 'deleteModel', 'reRenderModel');
	        this.collection = options.collection;
	    },
	
	    childViewOptions: function () {
	    },
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    },
	
	    updateModel: function (model) {
	        var that = this;
	        var callback = function () {
	            var cloned = model.clone();
	            cloned.save();
	            that.render();
	        };
	        this.triggerMethod('on:action', {callback: callback, mode: 'update'});
	    },
	
	    deleteModel: function (model) {
	        var that = this;
	        var responseHandler = function (model, xhr, options) {
	            if (xhr.status == 200) {
	                that.collection.remove(model);
	                that.render();
	            }
	            else
	                window.console.log('Error:' + ' ' + xhr.status);
	        };
	        var callback = function () {
	            model.destroy({
	                wait: true,
	                success: responseHandler,
	                error: responseHandler
	            });
	        }
	        this.triggerMethod('on:action', {callback: callback, mode: 'delete'});
	    },
	
	    reRenderModel: function(model) {
	        var childView = this.children.findByModelCid(model.cid);
	        childView.render();
	    }
	});
	
	var RolesView = Marionette.View.extend({
	    tagName: 'div',
	    className: 'roles-table',
	    template: __webpack_require__(450),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        updateConfirmationModal: '#yes-no-confirmation-modal-for-update',
	        deleteConfirmationModal: '#yes-no-confirmation-modal-for-delete',
	        rolesForm: '#roles-form'
	    },
	
	    childViewEvents: {
	        'action:confirmed': 'saveConfirmed',
	        'on:action': 'onAction',
	        'role:saved': 'onRoleSaved'
	    },
	
	    callback: undefined,
	
	    templateContext: function () {
	        return {}
	    },
	
	    onRender: function () {
	        window.document.title = "Roles";
	        this.showChildView('body', new RolesTableBody({
	            collection: this.collection
	        }));
	
	        this.showChildView('rolesForm', new RoleFormView());
	
	
	        this.updateConfirmationModal = new YesNoConfirmationModal({
	            title: 'Update confirmation',
	            message: 'You are going to update role. Are you sure?'
	        });
	        this.showChildView('updateConfirmationModal', this.updateConfirmationModal);
	
	        this.deleteConfirmationModal = new YesNoConfirmationModal({
	            title: 'Remove confirmation',
	            message: 'You are going to remove role. Are you sure?'
	        });
	        this.showChildView('deleteConfirmationModal', this.deleteConfirmationModal);
	    },
	
	    initialize: function (options) {
	        var that = this;
	        _.bindAll(that, 'saveConfirmed', 'onAction', 'onRoleSaved');
	        that.collection = new RolesCollection();
	        that.collection.fetch({
	            success: function () {
	                that.render;
	            }
	        });
	    },
	
	    onAction: function (data) {
	        this.callback = data.callback;
	        if (typeof this.callback !== "function")
	            return;
	        if (data.mode == 'update') {
	            this.updateConfirmationModal.show();
	        } else if (data.mode == 'delete') {
	            this.deleteConfirmationModal.show();
	        }
	    },
	
	    saveConfirmed: function (data) {
	        if (data.result == true) {
	            this.callback();
	        }
	        else {
	            this.updateConfirmationModal.hide();
	            this.deleteConfirmationModal.hide();
	        }
	    },
	
	    onRoleSaved: function (model) {
	        this.collection.add(model);
	    }
	});
	
	module.exports = RolesView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var RoleModel = __webpack_require__(246);
	
	var RoleFormView = Marionette.View.extend({
	    template: __webpack_require__(448),
	
	    regions: {
	    },
	
	    model: new RoleModel(),
	
	    childViewEvents: {
	    },
	
	    ui: {
	        saveBtn: '#save-role',
	        roleName: '#name',
	        roleType: '#type'
	    },
	
	    events: {
	        'click @ui.saveBtn': 'addRole',
	        'keyup @ui.roleName': 'validate',
	        'change @ui.roleType': 'roleTypeSelected',
	        'change #can-read': 'onChecked',
	        'change #can-write': 'onChecked',
	        'change #can-write-for': 'onChecked',
	        'change #can-delete': 'onChecked',
	        'change #can-sign': 'onChecked',
	        'change #can-sign-all': 'onChecked',
	        'change #can-upload-for': 'onChecked',
	        'change #can-read-for': 'onChecked',
	        'change #can-read-all': 'onChecked',
	        'change #can-change-reviewer': 'onChecked',
	        'change #can-edit-all': 'onChecked'
	    },
	
	    showOrganization: false,
	
	    templateContext: function () {
	        return {
	        };
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'addRole',
	            'afterUpdate', 'onChecked', 'validate', 'roleTypeSelected');
	        if (options) {
	        }
	    },
	
	    onRender: function () {
	        this.$('#type').selectize({
	            allowEmptyOption: false
	        });
	        this.initiateStates();
	    },
	
	    validate: function(event) {
	        var value = event.target.value;
	        this.model.set('templateName', value);
	        if (value != '')
	            this.ui.saveBtn.removeAttr("disabled");
	        else
	            this.ui.saveBtn.attr("disabled", "true");
	    },
	
	    initiateStates: function() {
	        this.model.set(this.model.defaults);
	        this.ui.saveBtn.attr("disabled", "true");
	    },
	
	    addRole: function () {
	        this.model.save(this.model.toJSON(), {success: this.afterUpdate});
	    },
	
	    afterUpdate: function () {
	        this.triggerMethod('role:saved', this.model.clone());
	        this.model.set(this.model.defaults);
	        this.render();
	    },
	
	    onChecked: function (event) {
	        this.model.set(event.target.value, event.target.checked);
	    },
	
	    roleTypeSelected: function (event) {
	        this.model.set('templateType', event.target.value);
	    }
	});
	
	module.exports = RoleFormView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form top-margined row">\r\n    <h4 class="center">Add new role</h4>\r\n    <div class="col-md-6 col-xs-6">\r\n        <div class="form-group">\r\n            <label class="col-md-2 col-xs-2 control-label" for="name">Name</label>\r\n            <div class="col-md-10 col-xs-10">\r\n                <input class="form-control" type="text" id="name" placeholder="Role name" required="">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-2 col-xs-2 control-label" for="type">Type</label>\r\n            <div class="col-md-10 col-xs-10">\r\n                <select id="type" data-placeholder="Select type">\r\n                    <option></option>\r\n                    <option value="document">Document</option>\r\n                    <option value="organization">Organization</option>\r\n                    <option value="person">Person</option>\r\n                </select>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class="col-md-6 col-xs-6">\r\n        <label class="checkbox"><input type="checkbox" id="can-read" value="canRead">Can view</label>\r\n        <label class="checkbox"><input type="checkbox" id="can-read-all" value="canReadAll">Can read all entities\r\n            for</label>\r\n        <label class="checkbox"><input type="checkbox" id="can-read-for" value="canReadFor">Can read for</label>\r\n        <label class="checkbox"><input type="checkbox" id="can-write" value="canWrite">Can edit</label>\r\n        <label class="checkbox"><input type="checkbox" id="can-write-for" value="canWriteFor">Can edit for</label>\r\n        <label class="checkbox"><input type="checkbox" id="can-edit-all" value="canWriteAll">Can edit all</label>\r\n        <label class="checkbox"><input type="checkbox" id="can-delete" value="canDelete">Can delete</label>\r\n        <label class="checkbox"><input type="checkbox" id="can-sign" value="canSign">Can sign</label>\r\n        <label class="checkbox"><input type="checkbox" id="can-sign-all" value="canSignAll">Can sign for all</label>\r\n        <label class="checkbox"><input type="checkbox" id="can-upload-for" value="canUploadFor">Can upload for</label>\r\n        <label class="checkbox"><input type="checkbox" id="can-change-reviewer" value="canChangeReviewer">Can change\r\n            reviewer</label>\r\n\r\n        <div class="left-buttons">\r\n            <button type="button" class="btn btn-success" id="save-role" disabled>Add</button>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td><input type="text" class="form-control transparent-input role-name" value="'+
	((__t=( templateName ))==null?'':_.escape(__t))+
	'"></td>\r\n<td>\r\n    <select class="form-control transparent-input role-type" style="width:120px;">\r\n        <option></option>\r\n        <option value="document" ';
	 if (templateType == 'document') { 
	__p+=' selected ';
	 } 
	__p+=' >Document</option>\r\n        <option value="organization" ';
	 if (templateType == 'organization') { 
	__p+=' selected ';
	 } 
	__p+=' >Organization</option>\r\n        <option value="person" ';
	 if (templateType == 'person') { 
	__p+=' selected ';
	 } 
	__p+=' >Person</option>\r\n    </select>\r\n</td>\r\n<td><input type="checkbox" class="form-control" value="canRead" ';
	 if (canRead) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canReadAll" ';
	 if (canReadAll) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canReadFor" ';
	 if (canReadFor) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canWrite" ';
	 if (canWrite) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canWriteFor" ';
	 if (canWriteFor) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canWriteAll" ';
	 if (canWriteAll) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canDelete" ';
	 if (canDelete) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canSign" ';
	 if (canSign) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canSignAll" ';
	 if (canSignAll) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canUploadFor" ';
	 if (canUploadFor) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canChangeReviewer" ';
	 if (canChangeReviewer) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n<td class="hiddenable-compliment"><span class="glyphicon glyphicon-minus clickable role-delete form-control transparent-input" title="Remove role" rel-id="'+
	((__t=( id ))==null?'':__t)+
	'"/></td>\r\n<td class="hiddenable"><span class="glyphicon glyphicon-ok clickable role-update form-control transparent-input" title="Save changes" rel-id="'+
	((__t=( id ))==null?'':__t)+
	'"/></td>\r\n<td class="hiddenable"><span class="glyphicon glyphicon-remove clickable cancel form-control transparent-input" title="Discard changes" rel-id="'+
	((__t=( id ))==null?'':__t)+
	'"/></td>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h3 class="center">Roles list</h3>\r\n<table class="table table-hover top-margined">\r\n    <thead>\r\n    <tr>\r\n        <th>Role name</th>\r\n        <th>Type</th>\r\n        <th>Can View</th>\r\n        <th>Can Read All</th>\r\n        <th>Can Read For</th>\r\n        <th>Can Edit</th>\r\n        <th>Can Edit For</th>\r\n        <th>Can Edit All</th>\r\n        <th>Can Delete</th>\r\n        <th>Can Sign</th>\r\n        <th>Can Sign For All</th>\r\n        <th>Can Upload For</th>\r\n        <th>Can Change Reviewer</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody></tbody>\r\n</table>\r\n<div id="roles-form"></div>\r\n<div id="yes-no-confirmation-modal-for-update"></div>\r\n<div id="yes-no-confirmation-modal-for-delete"></div>';
	}
	return __p;
	};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	var SuccessDialog = __webpack_require__(332);
	var Radio = __webpack_require__(183);
	
	var notificationsChannel = Radio.channel('notifications');
	
	var PasswordChangeForm = Marionette.View.extend({
	    template: __webpack_require__(452),
	
	    ui: {
	        oldPass: '#old-password',
	        newPass: '#new-password',
	        newPassConfirm: '#new-password-confirmed',
	        passwordHidden: '#password-hidden',
	        saveBtn: '#save',
	        cancelBtn: '#cancel',
	        oldPasswordDiv: '#old-password-div',
	
	        generatePass: '#generate-pass'
	    },
	
	    events: {
	        'click @ui.saveBtn': 'save',
	        'keyup @ui.newPass': 'validateNewPassword',
	        'change @ui.newPass': 'validateNewPassword',
	        'keyup @ui.newPassConfirm': 'validateNewPassword',
	        'change @ui.newPassConfirm': 'validateNewPassword',
	        'click @ui.generatePass': 'generatePass'
	    },
	
	    regions: {
	        dialog: '#message-dialog'
	    },
	
	    generatePassButtonText: 'Generate and copy to clipboard',
	    newPassword: undefined,
	
	    templateContext: function () {
	        var that = this;
	        return {
	            id: that.id,
	            generatePassButtonText: this.generatePassButtonText
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'validateNewPassword', 'save', 'successCallBack', 'performRelogin', 'generatePass', 'hideOldPassword');
	        this.id = options.id;
	        this.utils = new CommonUtils();
	        this.byAdmin = options.byAdmin;
	        this.isSelf = options.isSelf;
	        this.defaultPassword = options.defaultPassword;
	    },
	
	    onRender: function () {
	        this.showChildView('dialog', new SuccessDialog({
	            title: '',
	            message: 'Password was changed',
	            action: this.successCallBack
	        }));
	        if (this.byAdmin && !this.isSelf) {
	            this.ui.oldPass.parent().parent().hide();
	        }
	        this.newPassword = '';
	        this.validateNewPassword();
	        this.hideOldPassword();
	    },
	
	    validateNewPassword: function () {
	        var newPass = this.ui.newPass.val();
	        var newPassConf = this.ui.newPassConfirm.val();
	
	        var newPassError = this.passwordCheck(newPass);
	
	        if (newPassError != '') {
	            this.addTooltip(this.ui.newPass, newPassError);
	            this.addErrorClass(this.ui.newPass);
	            this.checkSaveBtn(false);
	        } else {
	            this.removeTooltip(this.ui.newPass);
	            this.removeErrorClass(this.ui.newPass);
	        }
	
	        if (newPass != newPassConf) {
	            this.addTooltip(this.ui.newPassConfirm, "Passwords do not match");
	            this.addErrorClass(this.ui.newPassConfirm);
	            this.checkSaveBtn(false);
	        } else {
	            this.removeTooltip(this.ui.newPassConfirm);
	            this.removeErrorClass(this.ui.newPassConfirm);
	        }
	
	        if (newPassError == '' && newPass == newPassConf) {
	            this.checkSaveBtn(true);
	        }
	    },
	
	    checkSaveBtn: function (result) {
	        if (result)
	            this.ui.saveBtn.removeAttr("disabled");
	        else
	            this.ui.saveBtn.attr("disabled", "true");
	    },
	
	    save: function () {
	        var that = this;
	        that.utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/person/change/password/' + that.id,
	            data: {
	                oldPassword: that.ui.oldPass.val(),
	                newPassword: that.ui.newPass.val()
	            },
	            dataType: 'text',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    that.newPassword = that.ui.newPass.val();
	                    that.getChildView('dialog').show();
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner();
	                notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	            }
	        });
	    },
	
	    addTooltip: function (jQelement, text) {
	        jQelement.tooltip({title: text});
	    },
	
	    removeTooltip: function (jQelement) {
	        jQelement.tooltip("destroy");
	    },
	
	    addErrorClass: function (jQelement) {
	        jQelement.parent().parent().addClass('has-error has-feedback');
	    },
	
	    removeErrorClass: function (jQelement) {
	        jQelement.parent().parent().removeClass('has-error has-feedback');
	    },
	
	    passwordCheck: function (value) {
	        if (value.length < 8 || !(/[\d]/.test(value)) || !(/[a-z]/.test(value)) || !(/[A-Z]/.test(value))) {
	            return "Password length should be at least 8 characters long and contains at least 1 letter, 1 digit and 1 capital letter.";
	        } else {
	            return "";
	        }
	    },
	
	    successCallBack: function () {
	        if (this.byAdmin && !this.isSelf/* || !this.defaultPassword*/) {
	            Backbone.history.navigate('/person/' + this.id, {trigger: true});
	        } else {
	            this.performRelogin();
	        }
	    },
	
	    performRelogin: function () {
	        var that = this;
	        $.ajax({
	            type: "DELETE",
	            url: '/api/login/session',
	            statusCode: {
	                200: function () {
	                    Backbone.history.navigate('/login', {trigger: true});
	                    /*$.ajax({
	                        type: "POST",
	                        url: '/api/login/auth?login=' + that.id + '&password=' + that.newPassword,
	                        statusCode: {
	                            200: function () {
	                                Backbone.history.navigate('/documents?toReview=true&simpleMode=true', {trigger: true});
	                            }
	                        }
	                    });*/
	                }
	            }
	        });
	    },
	
	    generatePass: function () {
	        var password = this.utils.generatePassword(8);
	        this.ui.newPass.val(password);
	        this.ui.newPassConfirm.val(password);
	        this.ui.passwordHidden.val(password);
	        this.ui.passwordHidden.show();
	        this.ui.passwordHidden.select();
	        document.execCommand('copy');
	        this.ui.passwordHidden.hide();
	        this.ui.passwordHidden.val('');
	
	        this.ui.generatePass.toggleClass('btn-primary');
	        this.ui.generatePass.toggleClass('btn-success');
	        this.ui.generatePass.html('Copied');
	        this.ui.generatePass.prop('disabled', function (i, v) {
	            return !v;
	        });
	
	        var that = this;
	        setTimeout(function () {
	            that.ui.generatePass.toggleClass('btn-primary');
	            that.ui.generatePass.toggleClass('btn-success');
	            that.ui.generatePass.html(that.generatePassButtonText);
	            that.ui.generatePass.prop('disabled', function (i, v) {
	                return !v;
	            });
	        }, 1000);
	        this.validateNewPassword();
	    },
	
	    hideOldPassword: function () {
	        var that = this;
	        Backbone.$.ajax({
	            type: "GET",
	            url: "/api/utility/instant/token/bysession",
	            statusCode: {
	                200: function (response) {
	                    if (!_.isEmpty(response.id))
	                        that.ui.oldPasswordDiv.hide();
	                }
	            }
	        });
	    }
	
	});
	
	module.exports = PasswordChangeForm;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form-horizontal top-margined">\r\n    <div class="form-group" id="old-password-div">\r\n        <label class="col-sm-3 control-label" for="old-password">Old password</label>\r\n        <div class="col-sm-9">\r\n            <input class="form-control" type="password" id="old-password" placeholder="Type old password">\r\n        </div>\r\n    </div>\r\n    <div class="form-group">\r\n        <label class="col-sm-3 control-label" for="new-password">New password</label>\r\n        <div class="col-sm-9">\r\n            <input class="form-control" type="password" id="new-password" placeholder="Type new password">\r\n        </div>\r\n    </div>\r\n    <div class="form-group">\r\n        <label class="col-sm-3 control-label" for="new-password-confirmed">New password confirmed</label>\r\n        <div class="col-sm-9">\r\n            <input class="form-control" type="password" id="new-password-confirmed" placeholder="Confirm new password">\r\n        </div>\r\n    </div>\r\n\r\n    <div>\r\n        <a href="/#person/'+
	((__t=( id ))==null?'':__t)+
	'" class="btn btn-danger" id="cancel">Cancel</a>\r\n        <input class="form-control" type="text" id="password-hidden" style="display: none">\r\n        <button type="button" class="btn btn-primary" id="generate-pass">'+
	((__t=( generatePassButtonText ))==null?'':__t)+
	'</button>\r\n        <button type="button" class="btn btn-success" id="save" disabled>Save changes</button>\r\n    </div>\r\n</div>\r\n\r\n<div id="message-dialog"></div>';
	}
	return __p;
	};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	var DocumentTypeFormView = __webpack_require__(454);
	var DocumentTypesTableView = __webpack_require__(456);
	var DocumentTypesCollection = __webpack_require__(401);
	var EntitiesCollection = __webpack_require__(227);
	
	var Radio = __webpack_require__(183);
	
	var notificationsChannel = Radio.channel('notifications');
	
	var DocTypesView = Marionette.View.extend({
	    template: __webpack_require__(459),
	
	    regions: {
	        documentTypes: '#document-types',
	        documentTypeForm: '#document-type-form'
	    },
	
	    ui: {
	    },
	
	    events: {
	    },
	
	    childViewEvents: {
	        'on:new': 'onNewDocumentType',
	        'on:cancel': 'onCancel',
	        'on:save': 'onSave',
	        'on:update': 'onUpdate',
	        'on:delete': 'onDelete'
	    },
	
	    initialize: function (options) {
	        var that = this;
	        _.bindAll(this, 'renderDocTypes', 'renderDocTypeFrom', 'onNewDocumentType', 'onCancel', 'onSave', 'getOrgName', 'onUpdate', 'onDelete');
	        that.organizationCollection = new EntitiesCollection([], {params: [{key: 'type', value: 'organization'}]});
	        that.collection = new DocumentTypesCollection();
	        that.organizationCollection.fetch({success: function() {
	            that.collection.fetch({success: that.renderDocTypes});
	        }});
	    },
	
	    onRender: function () {
	        window.document.title = "Document types";
	        //this.renderDocTypes();
	    },
	
	    renderDocTypes: function() {
	        this.showChildView('documentTypes', new DocumentTypesTableView({collection: this.collection, getOrgName: this.getOrgName}));
	    },
	
	    renderDocTypeFrom: function(mode, model) {
	        this.showChildView('documentTypeForm', new DocumentTypeFormView({mode: mode,
	            organizationCollection: this.organizationCollection, model: model}));
	    },
	
	    getOrgName: function(id) {
	        if (id == undefined || id == '')
	            return '';
	        var that = this;
	        var found = that.organizationCollection.findWhere({id: id});
	        return found.attributes.name;
	    },
	
	    onNewDocumentType: function() {
	        this.renderDocTypeFrom('add');
	    },
	
	    onCancel: function() {
	        this.detachChildView('documentTypeForm');
	        this.getChildView('documentTypes').showButton();
	    },
	
	    onSave: function() {
	        this.collection.fetch();
	        this.getChildView('documentTypes').render();
	        this.onCancel();
	    },
	
	    onUpdate: function(model) {
	        this.renderDocTypeFrom('edit', model);
	    },
	
	    onDelete: function(model) {
	        var that = this;
	        model.destroy({
	            success: function() {
	                that.collection.fetch();
	            }
	        });
	    }
	});
	
	module.exports = DocTypesView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var DocumentTypeModel = __webpack_require__(400);
	var EntitiesSelectView = __webpack_require__(226);
	
	var DocumentTypeFormView = Marionette.View.extend({
	    template: __webpack_require__(455),
	
	    regions: {
	        organizations: "#organizations-list"
	    },
	
	    ui: {
	        save: '#save',
	        name: '#name',
	        limit: '#limit',
	        signX: '#sign-x',
	        signY: '#sign-y',
	        signWidth: '#sign-width',
	        cancel: '#cancel'
	    },
	
	    events: {
	        'click @ui.save': 'save',
	        'click @ui.cancel': 'cancel',
	        'keypress input[type=number]': 'onKeyPress'
	    },
	
	    childViewEvents: {
	        'entity:selected': 'entitySelected'
	    },
	
	    templateContext: function () {
	        return {
	            title: this.mode == 'add' ? 'New document type' : "Edit document type",
	            mode: this.mode == 'add' ? 'Add' : "Edit"
	        };
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'save', 'entitySelected', 'onRender', 'cancel', 'modelSaved', 'onKeyPress');
	        this.mode = options.mode;
	        if (this.mode == 'add') {
	            this.model = new DocumentTypeModel();
	        } else if (this.mode == 'edit') {
	            this.model = options.model;
	        }
	        this.organizationCollection = options.organizationCollection;
	    },
	
	    onRender: function () {
	        var that = this;
	        that.organizationsSelectView = new EntitiesSelectView({
	            collectionValues: this.organizationCollection,
	            customPlaceholder: 'Select a organization',
	            entityId: that.model.get('organizationId')
	        });
	        that.showChildView('organizations', that.organizationsSelectView);
	    },
	
	    entitySelected: function (data) {
	        this.model.set('organizationId', data.id);
	    },
	
	    save: function () {
	        this.model.set('name', this.ui.name.val());
	        this.model.get('object').signsLimit = this.ui.limit.val();
	        this.model.get('object').signX = this.ui.signX.val();
	        this.model.get('object').signY = this.ui.signY.val();
	        this.model.get('object').signWidth = this.ui.signWidth.val();
	        this.model.save(this.model.toJSON(), {success: this.modelSaved});
	    },
	
	    modelSaved: function () {
	        this.triggerMethod('on:save', null);
	    },
	
	    cancel: function () {
	        this.triggerMethod('on:cancel', null);
	    },
	
	    onKeyPress: function (event) {
	        return event.keyCode == 8 || event.keyCode == 46 || event.keyCode == 37 || event.keyCode == 39 ||
	            event.charCode >= 48 && event.charCode <= 57;
	    }
	
	});
	
	module.exports = DocumentTypeFormView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form-horizontal col-md-offset-6 col-xs-offset-6 col-md-6 col-xs-6">\r\n    <h4 class="center">'+
	((__t=( title ))==null?'':__t)+
	'</h4>\r\n    <div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="name">Name</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="text" id="name" placeholder="Document type name" required=""\r\n                       value="'+
	((__t=( name ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="organizations-list">Organization</label>\r\n            <div class="col-md-9">\r\n                <div id="organizations-list"/>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="limit">Signs limit</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="number" id="limit" placeholder="Signs limit in digits" required=""\r\n                       value="'+
	((__t=( object.signsLimit ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="sign-x">Sign X</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="number" id="sign-x" placeholder="Sign X" required=""\r\n                       value="'+
	((__t=( object.signX ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="sign-y">Sign Y</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="number" id="sign-y" placeholder="Sign Y" required=""\r\n                       value="'+
	((__t=( object.signY ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-md-3 control-label" for="sign-width">Sign width</label>\r\n            <div class="col-md-9">\r\n                <input class="form-control" type="number" id="sign-width" placeholder="Sign width" required=""\r\n                       value="'+
	((__t=( object.signWidth ))==null?'':__t)+
	'">\r\n            </div>\r\n        </div>\r\n        <div class="right-buttons">\r\n            <button type="button" class="btn btn-success" id="save">'+
	((__t=( mode ))==null?'':__t)+
	'</button>\r\n            <button type="button" class="btn btn-danger" id="cancel">Cancel</button>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	var YesNoConfirmationModal = __webpack_require__(237);
	
	var DocumentTypesRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(457),
	    events: {
	        'click #delete': 'remove',
	        'click #edit': 'edit'
	    },
	
	    templateContext: function () {
	        return {
	            organization: this.getOrgName(this.model.get('organizationId'))
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'remove', 'edit');
	        this.getOrgName = options.getOrgName;
	    },
	
	    remove: function (event) {
	        this.triggerMethod('delete:model', this.model);
	    },
	
	    edit: function (event) {
	        this.triggerMethod('update:model', this.model);
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(5), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var DocumentTypesTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: DocumentTypesRowView,
	    emptyView: EmptyView,
	
	    childViewEvents: {
	        'update:model': 'updateModel',
	        'delete:model': 'deleteModel'
	    },
	
	    childViewOptions: function () {
	        return {
	            getOrgName: this.getOrgName
	        };
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'updateModel', 'deleteModel');
	        this.collection = options.collection;
	        this.getOrgName = options.getOrgName;
	    },
	
	    updateModel: function (model) {
	        var that = this;
	        var callback = function () {
	            that.triggerMethod('on:update', model);
	        }
	        this.triggerMethod('on:action', {callback: callback, mode: 'update'});
	    },
	
	    deleteModel: function (model) {
	        var that = this;
	        var callback = function () {
	            that.triggerMethod('on:delete', model);
	        }
	        this.triggerMethod('on:action', {callback: callback, mode: 'delete'});
	    }
	});
	
	var DocumentTypesTableView = Marionette.View.extend({
	    tagName: 'div',
	    className: 'document-types-table',
	    template: __webpack_require__(458),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        updateConfirmationModal: '#yes-no-confirmation-modal-for-update',
	        deleteConfirmationModal: '#yes-no-confirmation-modal-for-delete'
	    },
	
	    childViewEvents: {
	        'action:confirmed': 'saveConfirmed',
	        'on:action': 'onAction',
	        'on:update': 'onUpdate',
	        'on:delete': 'onDelete'
	    },
	
	    ui: {
	        addBtn: '#add-document-type',
	        updateConfirmationModal: '#yes-no-confirmation-modal-for-update',
	        deleteConfirmationModal: '#yes-no-confirmation-modal-for-delete'
	    },
	
	    events: {
	        'click @ui.addBtn': 'add'
	    },
	
	    callback: undefined,
	
	    templateContext: function () {
	        return {}
	    },
	
	    onRender: function () {
	        this.showChildView('body', new DocumentTypesTableBody({
	            collection: this.collection,
	            getOrgName: this.getOrgName
	        }));
	
	        this.updateConfirmationModal = new YesNoConfirmationModal({
	            title: 'Update confirmation',
	            message: 'You are going to update document type. Are you sure?'
	        });
	        this.showChildView('updateConfirmationModal', this.updateConfirmationModal);
	
	        this.deleteConfirmationModal = new YesNoConfirmationModal({
	            title: 'Remove confirmation',
	            message: 'You are going to remove document type. Are you sure?'
	        });
	        this.showChildView('deleteConfirmationModal', this.deleteConfirmationModal);
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'saveConfirmed', 'onAction', 'add', 'onDelete', 'onUpdate');
	        this.collection = options.collection;
	        this.getOrgName = options.getOrgName;
	    },
	
	    onAction: function (data) {
	        this.callback = data.callback;
	        if (typeof this.callback !== "function")
	            return;
	        if (data.mode == 'update') {
	            this.updateConfirmationModal.show();
	        } else if (data.mode == 'delete') {
	            this.deleteConfirmationModal.show();
	        }
	    },
	
	    saveConfirmed: function (data) {
	        if (data.result == true) {
	            this.callback();
	        }
	        else {
	            this.updateConfirmationModal.hide();
	            this.deleteConfirmationModal.hide();
	        }
	    },
	
	    add: function () {
	        this.triggerMethod('on:new', null);
	        this.hideButton();
	    },
	
	    showButton: function () {
	        this.ui.addBtn.show();
	    },
	
	    hideButton: function () {
	        this.ui.addBtn.hide();
	    },
	
	    onUpdate: function(model) {
	        this.triggerMethod('on:update', model);
	    },
	
	    onDelete: function(model) {
	        this.triggerMethod('on:delete', model);
	    }
	});
	
	module.exports = DocumentTypesTableView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td>'+
	((__t=( name ))==null?'':__t)+
	'</td>\r\n';
	 if (typeof organizationId == "undefined" || organizationId == '') { 
	__p+='\r\n<td></td>\r\n';
	 } else { 
	__p+='\r\n<td><a href = "/#organization/'+
	((__t=( organizationId ))==null?'':__t)+
	'">'+
	((__t=( organization ))==null?'':__t)+
	'</a></td>\r\n';
	 } 
	__p+='\r\n<td>'+
	((__t=( object.signsLimit ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( object.signX ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( object.signY ))==null?'':__t)+
	'</td>\r\n<td>'+
	((__t=( object.signWidth ))==null?'':__t)+
	'</td>\r\n<td><span class="glyphicon glyphicon-edit clickable" id="edit" rel-id=""/></td>\r\n<td><span class="glyphicon glyphicon-remove clickable" id="delete" rel-id=""/></td>';
	}
	return __p;
	};


/***/ }),
/* 458 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<table class="table table-hover">\r\n    <thead>\r\n    <tr>\r\n        <th>Document type name</th>\r\n        <th>Organization</th>\r\n        <th>Signs limit</th>\r\n        <th>Sign X</th>\r\n        <th>Sign Y</th>\r\n        <th>Sign width</th>\r\n        <th>Edit</th>\r\n        <th>Delete</th>\r\n    </tr>\r\n    </thead>\r\n    <tbody></tbody>\r\n</table>\r\n<div class="left-buttons">\r\n    <button type="button" class="btn btn-success" id="add-document-type">Add new document type</button>\r\n</div>\r\n<div id="yes-no-confirmation-modal-for-update"></div>\r\n<div id="yes-no-confirmation-modal-for-delete"></div>';
	}
	return __p;
	};


/***/ }),
/* 459 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row top-margined" id="doc-types-list">\r\n    <h3 class="center">Document types</h3>\r\n    <div id="document-types"></div>\r\n    <div id="document-type-form" class="col-xs-12 col-md-12"></div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(300);
	__webpack_require__(26);
	__webpack_require__(27);
	
	var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var PersonsCollection = __webpack_require__(210);
	var Pager = __webpack_require__(309);
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	
	var PatientsRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(461),
	    events: {},
	
	    templateContext: function () {
	        var that = this;
	        var birthDate = that.model.get('object').birthData;
	        return {
	            age: (birthDate == '' || birthDate == 0 ? '-' : (new Date().getFullYear() - new Date(birthDate).getFullYear()))
	        }
	    },
	
	    initialize: function (options) {
	        //_.bindAll(this, 'removePermission', 'onChecked');
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(2), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var PatientsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: PatientsRowView,
	    emptyView: EmptyView,
	
	    collectionEvents: {
	        request: 'showLoading',
	        sync: 'hideLoading',
	        error: 'logError'
	    },
	
	    childViewEvents: {},
	
	    initialize: function (options) {
	        _.bindAll(this, 'showLoading', 'hideLoading', 'logError');
	        this.collection = options.collection;
	    },
	
	    childViewOptions: function () {
	        return {};
	    },
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    }
	});
	
	var PatientsView = Marionette.View.extend({
	    tagName: 'div',
	    className: 'patients-table',
	    template: __webpack_require__(462),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        },
	        pager: '#pager'
	    },
	
	    ui: {
	        filter: '#filter',
	        clearFilter: '#clear-filter',
	        patientName: '#patient-name',
	        birthDate: '#birth-date',
	        burnAfter: '#burn-after',
	        burnBefore: '#burn-before'
	    },
	
	    events: {
	        'click @ui.filter': 'doFilter',
	        'click @ui.clearFilter': 'doClearFilter'
	    },
	
	    childViewEvents: {},
	
	    templateContext: function () {
	        var that = this;
	        return {
	            getParam: function (key) {
	                return that.params[key];
	            },
	            getDateParam: function (key) {
	                if (that.params[key]) {
	                    try {
	                        return that.utils.longToDateTimeFormatted(Number(that.params[key]), 'MM/DD/YYYY');
	                    } catch (e) {
	                        console.log(e);
	                        return undefined;
	                    }
	                }
	                return undefined;
	            }
	        }
	    },
	
	    onRender: function () {
	        window.document.title = "RNS Patients";
	        var that = this;
	        that.ui.birthDate.datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	        that.ui.burnAfter.datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	        that.ui.burnBefore.datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	
	        that.collection = new PersonsCollection([],
	            {params: that.utils.mergeCollectionParams(that.defaultCollectionParams, that.utils.queryParamsToCollection(that.params) || [])});
	        that.collection.fetch({
	            success: function () {
	                that.showChildView('body', new PatientsTableBody({
	                    collection: that.collection
	                }));
	
	                that.showChildView('pager', new Pager({
	                    baseCountUrl: '/api/person/count?object_isPatient=true&object_mergeable=false'
	                }));
	            }
	        });
	
	        if (that.utils.isUrlWoExtraQueryParameters()) {
	            that.ui.clearFilter.hide();
	        } else {
	            that.ui.clearFilter.show();
	        }
	    },
	
	    initialize: function (options) {
	        var that = this;
	        _.bindAll(that, 'doFilter', 'doClearFilter');
	        that.utils = new CommonUtils();
	        that.params = $.deparam(window.location.hash.replace('#patients', '').replace('?', ''));
	        that.defaultListParams = that.utils.getDefaultListParams();
	        that.initDefaultCollectionParams()
	    },
	
	    initDefaultCollectionParams: function () {
	
	        this.defaultCollectionParams = [
	            {key: 'sortby', value: 'name'},
	            {key: 'sortdir', value: 'ASC'},
	            {key: 'page-size', value: Constants.pageCapacity},
	            {key: 'object_isPatient', value: true},
	            {key: 'object_mergeable', value: false}
	        ]
	    },
	
	    doFilter: function () {
	        var that = this;
	
	        if (that.ui.patientName.val() != undefined && that.ui.patientName.val() != '')
	            that.defaultListParams['like_name'] = that.ui.patientName.val();
	        else
	            delete (that.defaultListParams['like_name']);
	
	        if (that.ui.birthDate.val() != undefined && that.ui.birthDate.val() != '')
	            that.defaultListParams['object_birthData_date'] = that.utils.dateToLong(that.ui.birthDate.val());
	        else
	            delete (that.defaultListParams['object_birthData_date']);
	
	        if (that.ui.burnAfter.val() != undefined && that.ui.burnAfter.val() != '')
	            that.defaultListParams['object_birthData_from'] = that.utils.dateToLong(that.ui.burnAfter.val());
	        else
	            delete (that.defaultListParams['object_birthData_from']);
	
	        if (that.ui.burnBefore.val() != undefined && that.ui.burnBefore.val() != '')
	            that.defaultListParams['object_birthData_to'] = that.utils.dateToLong(that.ui.burnBefore.val());
	        else
	            delete (that.defaultListParams['object_birthData_to']);
	
	        that.defaultListParams.page = 0;
	
	        window.location.hash = that.utils.getCleanBaseHash() + "?" + that.utils.objectToQueryParams(that.defaultListParams);
	    },
	
	    doClearFilter: function () {
	        this.utils.redirectToUrlWoExtraQueryParameters();
	    }
	});
	
	module.exports = PatientsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td><a href = "/#person/'+
	((__t=( id ))==null?'':__t)+
	'">'+
	((__t=( name ))==null?'':__t)+
	'</a></td>\r\n<td>'+
	((__t=( age ))==null?'':__t)+
	'</td>';
	}
	return __p;
	};


/***/ }),
/* 462 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h2>Patients</h2>\r\n<div id="patients-container" class="top-margined">\r\n\r\n    <!--Filters-->\r\n    <div class="filters">\r\n        <div class="form-inline form">\r\n            <div class="form-group">\r\n                <input type="text"  class="form-control" id="patient-name" placeholder="Patient Name"\r\n                ';
	 if (getParam('like_name')) { 
	__p+=' value="'+
	((__t=( getParam('like_name') ))==null?'':__t)+
	'"  ';
	 } 
	__p+='\r\n                />\r\n            </div>\r\n            <div class="input-daterange input-group form-group" id="burn-range" style="width:280px;">\r\n                <input type="text" class="form-control" id="burn-after" placeholder="Born After" style="width:130px;"\r\n                ';
	 if (getDateParam('object_birthData_from')){ 
	__p+=' value="'+
	((__t=( getDateParam('object_birthData_from') ))==null?'':__t)+
	'"  ';
	 } 
	__p+='\r\n                />\r\n                <span class="input-group-addon">to</span>\r\n                <input type="text" class="form-control" id="burn-before" placeholder="Born Before" style="width:130px;"\r\n                ';
	 if (getDateParam('object_birthData_to')){ 
	__p+=' value="'+
	((__t=( getDateParam('object_birthData_to') ))==null?'':__t)+
	'"  ';
	 } 
	__p+='\r\n                />\r\n            </div>\r\n            &nbsp;OR&nbsp;\r\n            <div class="form-group">\r\n                <input type="text"  class="form-control" id="birth-date" placeholder="Birth Date"\r\n                ';
	 if (getDateParam('object_birthData_date')){ 
	__p+=' value="'+
	((__t=( getDateParam('object_birthData_date') ))==null?'':__t)+
	'"  ';
	 } 
	__p+='\r\n                />\r\n            </div>\r\n            <div class="form-group">\r\n                <button class="btn btn-primary" id="filter">Filter</button>\r\n            </div>\r\n            <div class="form-group">\r\n                <button class="btn btn-primary" title="Reset filter" id="clear-filter">Clear filter</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <!--<div class="loading"></div>-->\r\n    <table class="table table-hover">\r\n        <thead>\r\n        <tr>\r\n            <th>Patient</th>\r\n            <th>Age</th>\r\n        </tr>\r\n        </thead>\r\n        <tbody></tbody>\r\n    </table>\r\n\r\n    <div id="pager"></div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	var DocumentSignStatisticView = __webpack_require__(464);
	var DocumentSignStatisticByCommentsView = __webpack_require__(467);
	var DocumentSignStatisticByComments2View = __webpack_require__(470);
	
	var StatisticsView = Marionette.View.extend({
	    template: __webpack_require__(473),
	
	    regions: {
	        mdsSignedRegion: '#mds-signed-content',
	        mdsPendingRegion: '#mds-pending-content',
	        orgsSignedRegion: '#orgs-signed-content',
	        orgsPendingRegion: '#orgs-pending-content',
	        documentStatisticsByCommentsRegion: '#by-comments-content',
	        documentStatisticsByComments2Region: '#by-comments-content-2'
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRender', 'renderMdsSignedTab', 'renderMdsPendingTab', 'renderOrgsSignedTab', 'renderOrgsPendingTab');
	
	        this.initFlags = {
	            mdsSignedTabIsInit: false,
	            mdsPendingTabIsInit: false,
	            orgsSignedTabIsInit: false,
	            orgsPendingTabIsInit: false,
	            documentStatisticByCommentsTabsInit: false,
	            documentStatisticByComments2TabsInit: false
	        };
	    },
	
	    onRender: function () {
	        window.document.title = "Statistics";
	        var that = this;
	
	        that.renderMdsSignedTab();
	
	        that.$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
	            var target = that.$(e.target).attr("href");
	
	            if (target == '#mds-signed') {
	                that.renderMdsSignedTab();
	            } else if (target == '#mds-pending') {
	                that.renderMdsPendingTab();
	            } else if (target == '#orgs-signed') {
	                that.renderOrgsSignedTab();
	            } else if (target == '#orgs-pending') {
	                that.renderOrgsPendingTab();
	            } else if (target == '#by-comments') {
	                that.renderDocumentStatisticsByComments();
	            } else if (target == '#by-comments-2') {
	                that.renderDocumentStatisticsByComments2();
	            }
	        });
	    },
	
	    renderMdsSignedTab: function () {
	        var that = this;
	        if (this.initFlags.mdsSignedTabIsInit)
	            return;
	
	        that.showChildView('mdsSignedRegion', new DocumentSignStatisticView({
	            forSigned: true,
	            forMd: true
	        }));
	        this.initFlags.mdsSignedTabIsInit = true;
	    },
	
	    renderMdsPendingTab: function () {
	        var that = this;
	        if (this.initFlags.mdsPendingTabIsInit)
	            return;
	
	        that.showChildView('mdsPendingRegion', new DocumentSignStatisticView({
	            forSigned: false,
	            forMd: true
	        }));
	        this.initFlags.mdsPendingTabIsInit = true;
	    },
	
	    renderOrgsSignedTab: function () {
	        var that = this;
	        if (this.initFlags.orgsSignedTabIsInit)
	            return;
	
	        that.showChildView('orgsSignedRegion', new DocumentSignStatisticView({
	            forSigned: true,
	            forMd: false
	        }));
	        this.initFlags.orgsSignedTabIsInit = true;
	    },
	
	    renderOrgsPendingTab: function () {
	        var that = this;
	        if (this.initFlags.orgsPendingTabIsInit)
	            return;
	
	        that.showChildView('orgsPendingRegion', new DocumentSignStatisticView({
	            forSigned: false,
	            forMd: false
	        }));
	        this.initFlags.orgsPendingTabIsInit = true;
	    },
	
	    renderDocumentStatisticsByComments: function () {
	        var that = this;
	        if (this.initFlags.documentStatisticByCommentsTabsInit)
	            return;
	
	        this.showChildView('documentStatisticsByCommentsRegion', new DocumentSignStatisticByCommentsView());
	        this.initFlags.documentStatisticByCommentsTabsInit = true;
	    },
	
	    renderDocumentStatisticsByComments2: function () {
	        var that = this;
	        if (this.initFlags.documentStatisticByComments2TabsInit)
	            return;
	
	        this.showChildView('documentStatisticsByComments2Region', new DocumentSignStatisticByComments2View());
	        this.initFlags.documentStatisticByComments2TabsInit = true;
	    }
	
	});
	
	
	module.exports = StatisticsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	
	var Radio = __webpack_require__(183);
	var services = Radio.channel('services');
	var notificationsChannel = Radio.channel('notifications');
	var utils = new CommonUtils();
	
	var DocumentSignStatisticRowView = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(465),
	
	    ui: {
	        documentsShow: '.documents-show'
	    },
	
	    events: {
	        'click @ui.documentsShow': 'showDocuments'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	        }
	    },
	
	    initialize: function (options) {
	    },
	
	    onRender: function () {
	
	    },
	
	    showDocuments: function() {
	        this.triggerMethod('show:documents', this.model.get('documentsWithSignedDate'));
	    }
	});
	
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(2), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	var DocumentSignStatisticTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: DocumentSignStatisticRowView,
	    emptyView: EmptyView,
	
	    collectionEvents: {},
	
	    childViewEvents: {
	        'show:documents': 'showDocuments'
	    },
	
	    initialize: function (options) {
	        this.collection = options.collection;
	    },
	
	    childViewOptions: function () {
	        return {
	        };
	    },
	
	    showDocuments: function(data) {
	        this.triggerMethod('show:documents', data);
	    }
	});
	
	var DocumentSignStatisticView = Marionette.View.extend({
	    template: __webpack_require__(466),
	
	    regions: {
	        body: {
	            el: 'tbody',
	            replaceElement: true
	        }
	    },
	
	    ui: {
	        documentsShowModal: '#documents-show-modal',
	        total: '#total',
	
	        fromDateTime: '#from',
	        toDateTime: '#to',
	        filter: '#filter'
	    },
	
	    events: {
	        'click @ui.filter': 'filter'
	    },
	
	    childViewEvents: {
	        'show:documents': 'showDocuments'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            fromPlaceholder: that.forSigned ? 'Signed after' : 'Requested after',
	            toPlaceholder: that.forSigned ? 'Signed before' : 'Requested before',
	            signerTitle: that.forMd ? 'MD' : 'Organization',
	            documentTitle: that.forSigned ? 'Signed documents' : 'Requested documents'
	        }
	    },
	
	
	    initialize: function (options) {
	        _.bindAll(this, 'showDocuments', 'getData', 'getRequestParameters', 'transformResponse', 'filter', 'resetTotal', 'getUrlPart');
	        this.forSigned = options.forSigned;
	        this.forMd = options.forMd;
	    },
	
	    onRender: function () {
	        var that = this;
	
	        that.ui.fromDateTime.datetimepicker({
	        });
	        that.ui.toDateTime.datetimepicker({
	        });
	
	        that.collection = new Backbone.Collection();
	
	        var callback = function(response) {
	            that.collection.reset(that.transformResponse(response));
	            that.showChildView('body', new DocumentSignStatisticTableBody({
	                collection: that.collection
	            }));
	            that.resetTotal(that.collection);
	        }
	
	        that.getData(callback);
	    },
	
	    filter: function() {
	        var that = this;
	        that.getData(function(response) {
	            that.collection.reset(that.transformResponse(response));
	            that.resetTotal(that.collection);
	        });
	    },
	
	    getData: function(callback) {
	        var that = this;
	
	        utils.showSpinner();
	        $.ajax({
	            type: "GET",
	            url: that.getUrlPart() + '?' + that.getRequestParameters(),
	            statusCode: {
	                200: function (response) {
	                    utils.hideSpinner();
	                    if (_.isFunction(callback)) {
	                        callback(response);
	                    }
	                }
	            },
	            error: function(e) {
	                utils.hideSpinner();
	                notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        });
	    },
	
	    transformResponse: function(response) {
	        var transformed = _.keys(response).map(function(key) {
	            var signerSplitted = utils.splitToPair(key, ":");
	            return {
	                signerId: signerSplitted[0],
	                signerName: signerSplitted[1],
	                documentsWithSignedDate: response[key]
	            }
	        });
	
	        return _.sortBy(transformed, 'signerName');
	    },
	
	    getRequestParameters: function() {
	        var params = {};
	
	        if (this.ui.fromDateTime.val() != undefined && this.ui.fromDateTime.val() != '')
	            params['from_actionTime'] = utils.dateToLong(this.ui.fromDateTime.val());
	        if (this.ui.toDateTime.val() != undefined && this.ui.toDateTime.val() != '')
	            params['to_actionTime'] = utils.dateToLong(this.ui.toDateTime.val());
	        
	        return _.keys(params).map(function(key) {
	            return key + "=" + params[key];
	        }).join('&');
	    },
	
	    showDocuments: function(documents) {
	        var that = this;
	
	        $('#documents-table tbody').empty();
	
	        documents = _.sortBy(documents, 'right').reverse();
	        documents.forEach(function (document) {
	            var documentIdAndName = utils.splitToPair(document.middle, ":");
	            var documentSignedTime = document.right;
	            var newRowContent = '<tr id="' + documentIdAndName[0]
	                + '"><td>' +  utils.longToDateTimeFormatted(Number(documentSignedTime), 'MMM DD YYYY hh:mm A')
	                + '</td><td><a href="/#document/' + documentIdAndName[0] + '" target="_blank"><b>' + documentIdAndName[1]
	                + '</b></a></td></tr>';
	
	            $('#documents-table tbody').append(newRowContent);
	        });
	
	        this.ui.documentsShowModal.modal('show');
	    },
	
	    resetTotal: function(collection) {
	        var total = 0;
	        collection.models.forEach(function(model) {
	            total = total + (model.attributes.documentsWithSignedDate || []).length;
	        });
	        this.ui.total.text(total);
	    },
	
	    getUrlPart: function() {
	        return '/api/statistics/' + (this.forMd ? 'mds' : 'organizations') + '/documents/' + (this.forSigned ? 'signed' : 'requested');
	    }
	
	});
	
	module.exports = DocumentSignStatisticView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td><a href="/#person/'+
	((__t=( signerId ))==null?'':__t)+
	'"  target="_blank" class="center">'+
	((__t=( signerName ))==null?'':__t)+
	'</a></td>\r\n<td>';
	 if ((documentsWithSignedDate || []).length != 0) { 
	__p+='\r\n    <div class="documents-show center clickable" title="Documents">\r\n        <span class="badge">'+
	((__t=( (documentsWithSignedDate || []).length ))==null?'':__t)+
	'</span>\r\n    </div>\r\n    ';
	 } 
	__p+='\r\n</td>';
	}
	return __p;
	};


/***/ }),
/* 466 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="top-margined">\r\n    <div class="col-md-offset-1 col-xs-offset-1 col-md-2 col-xs-2 form-horizontal" id="filters">\r\n        <div class="form-group">\r\n            <h3>Filters</h3>\r\n        </div>\r\n        <div class="form-group">\r\n            <input type="text" class="form-control filter-field" id="from" placeholder="'+
	((__t=( fromPlaceholder))==null?'':__t)+
	'" name="from_signedTime">\r\n        </div>\r\n        <div class="form-group">\r\n            <input type="text" class="form-control filter-field" id="to" placeholder="'+
	((__t=( toPlaceholder))==null?'':__t)+
	'" name="to_signedTime">\r\n        </div>\r\n        <div class="form-group">\r\n            <button class="btn btn-primary" id="filter">Filter</button>\r\n        </div>\r\n    </div>\r\n    <div class="col-md-offset-1 col-xs-offset-1 col-md-8 col-xs-8">\r\n        <table class="table table-hover">\r\n            <thead>\r\n            <tr>\r\n                <th class="center">'+
	((__t=( signerTitle ))==null?'':__t)+
	'</th>\r\n                <th class="center">'+
	((__t=( documentTitle ))==null?'':__t)+
	' <span class="badge" id="total"></span></th>\r\n            </tr>\r\n            </thead>\r\n            <tbody></tbody>\r\n        </table>\r\n    </div>\r\n</div>\r\n\r\n<!-- Documents show modal as table -->\r\n<div class="modal fade" id="documents-show-modal" tabindex="-1" role="dialog">\r\n    <div class="modal-dialog">\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal">&times;</button>\r\n                <h4 class="modal-title">'+
	((__t=( documentTitle))==null?'':__t)+
	'</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <table class="table" id="documents-table">\r\n                    <thead>\r\n                    <tr>\r\n                        <th>Time</th>\r\n                        <th>Document name</th>\r\n                    </tr>\r\n                    </thead>\r\n                    <tbody></tbody>\r\n                </table>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var Radio = __webpack_require__(183);
	var services = Radio.channel('services');
	var notificationsChannel = Radio.channel('notifications');
	var utils = new CommonUtils();
	
	var DocumentSignStatisticByCommentsRowView = Marionette.View.extend({
	    tagName: 'div',
	    template: __webpack_require__(468),
	
	    ui: {
	        commentPopover: '.comment-popover',
	        collapser: '.collapser'
	    },
	
	    events: {
	        'click @ui.collapser': 'onToggleCollapse',
	        'click @ui.commentPopover': 'onCommentPopoverClick'
	    },
	
	    templateContext: function () {
	        var that = this;
	
	        var commentsCount = that.model.get('comments').length;
	
	        var signedDocuments = _.chain(that.model.get('comments') || [])
	            .map(function (comment) {
	                return comment.signedDocuments || [];
	            })
	            .flatten()
	            .uniq()
	            .value();
	
	        var signedCount = signedDocuments.length;
	
	        var notSignedDocuments = _.chain(that.model.get('comments') || [])
	            .map(function (comment) {
	                return _.union(comment.notAssignedDocuments || [],
	                    comment.obsoletedDocuments || [],
	                    comment.pendingDocuments || []);
	            })
	            .flatten()
	            .uniq()
	            .value();
	
	        var notSignedCount = notSignedDocuments.length;
	
	        return {
	            commentsCount: commentsCount,
	            signedCount: signedCount,
	            notSignedCount: notSignedCount,
	            signedLink: signedCount == 0
	                ? '<a class="center" style="color: #ffffff">' + signedCount + '</a>'
	                : '<a href="' + that.getDocumentsUrl(signedDocuments) + '" target="_blank" class="center white-link" style="color: #ffffff">' + signedCount + '</a>',
	            notSignedLink: notSignedCount == 0
	                ? '<a class="center white-link" style="color: #ffffff">' + notSignedCount + '</a>'
	                : '<a href="' + that.getDocumentsUrl(notSignedDocuments) + '" target="_blank" class="center white-link" style="color: #ffffff">' + notSignedCount + '</a>',
	            getDocumentsUrl: that.getDocumentsUrl,
	            getPersonsUrl: that.getPersonsUrl,
	            getOrganizationsUrl: that.getOrganizationsUrl,
	            formatDateTime: function (long) {
	                return long != undefined && long != '' && !isNaN(long)
	                    ? that.utils.longToDateTimeFormatted(long, "MM/DD/YYYY hh:mm A") : '-'
	            },
	            getTotalCountForComment: function (comment) {
	                return _.uniq(_.union(comment.signedDocuments || [],
	                    comment.notAssignedDocuments || [],
	                    comment.obsoletedDocuments || [],
	                    comment.pendingDocuments || [])).length;
	            },
	            getTotalDocumentsUrlForComment: function (comment) {
	                var totalDocuments = _.uniq(_.union(comment.signedDocuments || [],
	                    comment.notAssignedDocuments || [],
	                    comment.obsoletedDocuments || [],
	                    comment.pendingDocuments || []));
	                return that.getDocumentsUrl(totalDocuments);
	            }
	        }
	    },
	
	    initialize: function (options) {
	        this.utils = new CommonUtils();
	        this.activeCommentPopoverId = null;
	    },
	
	    onRender: function () {
	        var that = this;
	        //that.ui.commentPopover.popover();
	        that.ui.commentPopover.on('show.bs.popover', function () {
	            var thisPopover = $(this);
	            that.activeCommentPopoverId = thisPopover.attr("id");
	            window.setTimeout(function () {
	                that.activeCommentPopoverId = null;
	            }, 1000);
	        });
	    },
	
	    getDocumentsUrl: function (documentsIds) {
	        return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	            + documentsIds.map(function (docId) {
	                return "&id=" + docId;
	            }).join('');
	    },
	
	    getPersonsUrl: function (ids) {
	        return '/#persons?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	            + ids.map(function (docId) {
	                return "&id=" + docId;
	            }).join('');
	    },
	
	    getOrganizationsUrl: function (ids) {
	        return '/#organizations?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	            + ids.map(function (docId) {
	                return "&id=" + docId;
	            }).join('');
	    },
	
	
	    onToggleCollapse: function (event) {
	        var collapser = $(event.target);
	        if (collapser.html() == "Show comments")
	            $(event.target).html('Hide comments');
	        else
	            $(event.target).html('Show comments');
	    },
	
	    showPopover: function () {
	        this.ui.commentPopover.popover("show");
	    },
	
	    hidePopover: function () {
	        this.ui.commentPopover.popover("hide");
	    },
	
	    onCommentPopoverClick: function (event) {
	        $(event.target).popover('show');
	    },
	
	    hideComments: function () {
	        var that = this;
	        that.ui.commentPopover.each(function () {
	            var self = $(this);
	            if (that.activeCommentPopoverId != self.attr("id")) {
	                self.popover("hide");
	            }
	        });
	    }
	});
	
	var DocumentSignStatisticByCommentsTableBody = Marionette.CollectionView.extend({
	    tagName: 'div',
	    childView: DocumentSignStatisticByCommentsRowView,
	
	    collectionEvents: {},
	
	    childViewEvents: {},
	
	    initialize: function (options) {
	        this.collection = options.collection;
	    },
	
	    childViewOptions: function () {
	        return {};
	    },
	
	    findAndExpandComments: function (query) {
	        var that = this;
	        that.clearAndCollapseComments();
	
	        that.collection.filter(function (model) {
	            return model.get('commentText').indexOf(query) > -1;
	        }).forEach(function (model) {
	            var childView = that.children.findByModelCid(model.cid);
	            childView.showPopover();
	        });
	    },
	
	    clearAndCollapseComments: function () {
	        $('[data-toggle="popover"]').popover("hide");
	    },
	
	    hideComments: function () {
	        this.children.each(function (view) {
	            view.hideComments();
	        })
	    }
	});
	
	var DocumentSignStatisticByCommentsView = Marionette.View.extend({
	    tagName: 'div',
	    template: __webpack_require__(469),
	
	    regions: {
	        body: {
	            el: '.list-of-commenters',
	            replaceElement: true
	        }
	    },
	
	    ui: {
	        fromDateTime: '#from',
	        toDateTime: '#to',
	        filter: '#filter',
	
	        commentQuery: '#comment-query',
	        findComment: '#find-and-expand',
	        clear: '#clear-and-collapse'
	    },
	
	    events: {
	        'click @ui.filter': 'filter',
	        'click @ui.findComment': 'findAndExpandComments',
	        'click @ui.clear': 'clearAndCollapseComments'
	    },
	
	    childViewEvents: {},
	
	    templateContext: function () {
	        var that = this;
	        return {}
	    },
	
	
	    initialize: function (options) {
	    },
	
	    onRender: function () {
	        var that = this;
	
	        that.ui.fromDateTime.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'MM/DD/YYYY hh:mm A'
	        });
	        that.ui.toDateTime.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'MM/DD/YYYY hh:mm A'
	        });
	
	        that.collection = new Backbone.Collection();
	        that.showChildView('body', new DocumentSignStatisticByCommentsTableBody({
	            collection: that.collection
	        }));
	
	        window.setTimeout(function () {
	            $(function () {
	                $("body").click(function (event) {
	                    var clicked = $(event.target);
	                    if (clicked.hasClass('popover-content') /*|| clicked.hasClass('comment-popover')*/)
	                        return;
	
	                    that.getChildView("body").hideComments();
	                });
	            });
	        }, 1000);
	    },
	
	    onBeforeDestroy: function () {
	        $("body").unbind("click");
	    },
	
	    filter: function () {
	        var that = this;
	        that.getData(function (response) {
	            that.collection.reset(that.transformAndSort(response));
	        });
	    },
	
	    getData: function (callback) {
	        var that = this;
	
	        utils.showSpinner();
	        $.ajax({
	            type: "GET",
	            url: '/api/statistics/realtime/commenters/documents/filtered' + '?' + that.getRequestParameters(),
	            statusCode: {
	                200: function (response) {
	                    utils.hideSpinner();
	                    if (_.isFunction(callback)) {
	                        callback(response);
	                    }
	                }
	            },
	            error: function (e) {
	                utils.hideSpinner();
	                notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        });
	    },
	
	    getRequestParameters: function () {
	        var params = {};
	
	        if (this.ui.fromDateTime.val() != undefined && this.ui.fromDateTime.val() != '')
	            params['from_time'] = utils.dateToLong(this.ui.fromDateTime.val());
	        if (this.ui.toDateTime.val() != undefined && this.ui.toDateTime.val() != '')
	            params['to_time'] = utils.dateToLong(this.ui.toDateTime.val());
	
	        return _.keys(params).map(function (key) {
	            return key + "=" + params[key];
	        }).join('&');
	    },
	
	    transformAndSort: function (items) {
	        var grouped = _.groupBy(items, 'commenterId');
	        return _.sortBy(_.keys(grouped).map(function (key) {
	            return {
	                commenterId: key,
	                commenterIdInline: key.replace(/\./g, ''),
	                commenterName: grouped[key][0].commenterName,
	                comments: grouped[key]
	            }
	        }), 'commenterName');
	    },
	
	    findAndExpandComments: function () {
	        var query = this.ui.commentQuery.val();
	        if (query.length < 3)
	            return;
	        this.getChildView("body").findAndExpandComments(query);
	    },
	
	    clearAndCollapseComments: function () {
	        this.ui.commentQuery.val('');
	        this.getChildView("body").clearAndCollapseComments();
	    }
	});
	
	module.exports = DocumentSignStatisticByCommentsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="panel panel-success">\r\n    <div class="panel-heading">\r\n        <div class="inline center text-muted">\r\n            ';
	 if (commenterId == 'admin') { 
	__p+='\r\n                Commented by: <a>'+
	((__t=( commenterName ))==null?'':__t)+
	'</a>\r\n            ';
	 } else  { 
	__p+='\r\n                Commented by: <a href="/#person/'+
	((__t=( commenterId ))==null?'':__t)+
	'"  target="_blank" class="center">'+
	((__t=( commenterName ))==null?'':__t)+
	'</a>\r\n            ';
	 } 
	__p+=',\r\n            Comments: <span class="badge badge-success">'+
	((__t=( commentsCount ))==null?'':__t)+
	'</span>,\r\n            Related documents:\r\n            Signed - <span class="badge badge-success">'+
	((__t=( signedLink ))==null?'':__t)+
	'</span>,\r\n            Not Signed - <span class="badge badge-success">'+
	((__t=( notSignedLink ))==null?'':__t)+
	'</span>\r\n        </div>\r\n        <div class="pull-right inline">\r\n            <div data-toggle="collapse" data-target="#'+
	((__t=( commenterIdInline ))==null?'':__t)+
	'" class="collapser">\r\n                <span class="dotted-link">Show comments</span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class="collapse" id="'+
	((__t=( commenterIdInline ))==null?'':__t)+
	'">\r\n        <div class="panel-body">\r\n            <div>\r\n                <table class="table table-bordered table-condensed vertical-aligned-table">\r\n                <thead>\r\n                <tr>\r\n                    <th class="center" rowspan="2">Persons</th>\r\n                    <th class="center" rowspan="2">Orgs</th>\r\n                    <th class="center" colspan="5">Documents</th>\r\n                </tr>\r\n                <tr>\r\n                    <th class="center">Not assigned</th>\r\n                    <th class="center">Pending</th>\r\n                    <th class="center">Signed</th>\r\n                    <th class="center">Obsoleted</th>\r\n                    <th class="center">Total</th>\r\n                    <th class="center" rowspan="2">Comment</th>\r\n                    <th class="center" rowspan="2">Comment time</th>\r\n                </tr>\r\n                </thead>\r\n                <tbody>\r\n                ';
	 _.each(comments, function(comment, index) { 
	__p+='\r\n                <tr>\r\n                    <td class="center">\r\n                        ';
	 if ((comment.persons || []).length == 0) { 
	__p+='\r\n                        0\r\n                        ';
	 } else { 
	__p+='\r\n                        <a href="'+
	((__t=( getPersonsUrl(comment.persons || []) ))==null?'':__t)+
	'"  target="_blank" class="center">\r\n                            '+
	((__t=( (comment.persons || []).length ))==null?'':__t)+
	'\r\n                        </a>\r\n                        ';
	 } 
	__p+='\r\n                    </td>\r\n                    <td class="center">\r\n                        ';
	 if ((comment.organizations || []).length == 0) { 
	__p+='\r\n                        0\r\n                        ';
	 } else { 
	__p+='\r\n                        <a href="'+
	((__t=( getOrganizationsUrl(comment.organizations || []) ))==null?'':__t)+
	'"  target="_blank" class="center">\r\n                            '+
	((__t=( (comment.organizations || []).length ))==null?'':__t)+
	'\r\n                        </a>\r\n                        ';
	 } 
	__p+='\r\n                    </td>\r\n                    <td class="center">\r\n                    ';
	 if ((comment.notAssignedDocuments || []).length == 0) { 
	__p+='\r\n                    <a class="center">'+
	((__t=( (comment.notAssignedDocuments || []).length ))==null?'':__t)+
	'</a>\r\n                    ';
	 } else { 
	__p+='\r\n                    <a href="'+
	((__t=( getDocumentsUrl(comment.notAssignedDocuments || []) ))==null?'':__t)+
	'"  target="_blank" class="center">'+
	((__t=( (comment.notAssignedDocuments || []).length ))==null?'':__t)+
	'</a>\r\n                    ';
	 } 
	__p+='\r\n                    </td>\r\n                    <td class="center">\r\n                        ';
	 if ((comment.pendingDocuments || []).length == 0) { 
	__p+='\r\n                        <a class="center">'+
	((__t=( (comment.pendingDocuments || []).length ))==null?'':__t)+
	'</a>\r\n                        ';
	 } else { 
	__p+='\r\n                        <a href="'+
	((__t=( getDocumentsUrl(comment.pendingDocuments || []) ))==null?'':__t)+
	'"  target="_blank" class="center">'+
	((__t=( (comment.pendingDocuments || []).length ))==null?'':__t)+
	'</a>\r\n                        ';
	 } 
	__p+='\r\n                    </td>\r\n                    <td class="center">\r\n                        ';
	 if ((comment.signedDocuments || []).length == 0) { 
	__p+='\r\n                        <a class="center">'+
	((__t=( (comment.signedDocuments || []).length ))==null?'':__t)+
	'</a>\r\n                        ';
	 } else { 
	__p+='\r\n                        <a href="'+
	((__t=( getDocumentsUrl(comment.signedDocuments || []) ))==null?'':__t)+
	'"  target="_blank" class="center">'+
	((__t=( (comment.signedDocuments || []).length ))==null?'':__t)+
	'</a>\r\n                        ';
	 } 
	__p+='\r\n                    </td>\r\n                    <td class="center">\r\n                        ';
	 if ((comment.obsoletedDocuments || []).length == 0) { 
	__p+='\r\n                        <a class="center">'+
	((__t=( (comment.obsoletedDocuments || []).length ))==null?'':__t)+
	'</a>\r\n                        ';
	 } else { 
	__p+='\r\n                        <a href="'+
	((__t=( getDocumentsUrl(comment.obsoletedDocuments || []) ))==null?'':__t)+
	'"  target="_blank" class="center">'+
	((__t=( (comment.obsoletedDocuments || []).length ))==null?'':__t)+
	'</a>\r\n                        ';
	 } 
	__p+='\r\n                    </td>\r\n                    <td class="center">\r\n                        ';
	 if (getTotalCountForComment(comment) == 0) { 
	__p+='\r\n                        <a class="center">'+
	((__t=( getTotalCountForComment(comment) ))==null?'':__t)+
	'</a>\r\n                        ';
	 } else { 
	__p+='\r\n                        <a href="'+
	((__t=( getTotalDocumentsUrlForComment(comment) ))==null?'':__t)+
	'"  target="_blank" class="center">'+
	((__t=( getTotalCountForComment(comment) ))==null?'':__t)+
	'</a>\r\n                        ';
	 } 
	__p+='\r\n                    </td>\r\n                    <td class="center"><a tabindex="0" class="btn btn-transparent comment-popover" role="button" data-toggle="popover" data-placement="left"\r\n                                          data-content="'+
	((__t=( comment.commentText ))==null?'':__t)+
	'" id="'+
	((__t=( 'comment-popover-' + index ))==null?'':__t)+
	'">View comment</a></td>\r\n                    <td class="center">'+
	((__t=( formatDateTime(comment.time) ))==null?'':__t)+
	'</td>\r\n                </tr>\r\n                ';
	 }) 
	__p+='\r\n                </tbody>\r\n            </table>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="top-margined" id="productivity-report-content">\r\n    <div class="col-md-2 col-xs-2 form-horizontal">\r\n        <div class="form-group">\r\n            <h3>Filters</h3>\r\n        </div>\r\n        <div class="form-group">\r\n            <input type="text" class="form-control filter-field" id="from" placeholder="Commented after" name="from_time">\r\n        </div>\r\n        <div class="form-group">\r\n            <input type="text" class="form-control filter-field" id="to" placeholder="Commented before" name="to_time">\r\n        </div>\r\n        <div class="form-group">\r\n            <button class="btn btn-primary" id="filter">Filter</button>\r\n        </div>\r\n    </div>\r\n    <div class="col-md-offset-1 col-xs-offset-1 col-md-9 col-xs-9 top-margined">\r\n        <div class="row" style="display: none;">\r\n            <div class="col-md-6 col-xs-6">\r\n                <input type="text" id="comment-query" class="form-control" placeholder="Comment fragment. At least 3 character"/>\r\n            </div>\r\n            <div class="col-md-3 col-xs-3">\r\n                <button id="find-and-expand" class="btn btn-primary form-control">Find and expand</button>\r\n            </div>\r\n            <div class="col-md-3 col-xs-3">\r\n                <button id="clear-and-collapse" class="btn btn-primary form-control">Clear and collapse</button>\r\n            </div>\r\n        </div>\r\n        <div class="list-of-commenters"></div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Backbone = __webpack_require__(181);
	var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	var RemoteSuggesterView = __webpack_require__(196);
	
	var Radio = __webpack_require__(183);
	var services = Radio.channel('services');
	var notificationsChannel = Radio.channel('notifications');
	var utils = new CommonUtils();
	
	var DocumentSignStatisticByComments2RowView = Marionette.View.extend({
	    tagName: 'div',
	    template: __webpack_require__(471),
	
	    ui: {
	        commentPopover: '.comment-popover',
	        collapser: '.collapser'
	    },
	
	    events: {
	        'click @ui.collapser': 'onToggleCollapse',
	        'click @ui.commentPopover': 'onCommentPopoverClick'
	    },
	
	    templateContext: function () {
	        var that = this;
	
	        var commentsCount = that.model.get('comments').length;
	
	        var signedDocuments = _.chain(that.model.get('comments') || [])
	            .map(function (comment) {
	                return comment.signedDocuments || [];
	            })
	            .flatten()
	            .uniq()
	            .value();
	
	        var signedCount = signedDocuments.length;
	
	        var notSignedDocuments = _.chain(that.model.get('comments') || [])
	            .map(function (comment) {
	                return _.union(comment.notAssignedDocuments || [],
	                    comment.obsoletedDocuments || [],
	                    comment.pendingDocuments || []);
	            })
	            .flatten()
	            .uniq()
	            .value();
	
	        var notSignedCount = notSignedDocuments.length;
	
	        return {
	            commentsCount: commentsCount,
	            signedLink: signedCount == 0
	                ? '<a class="center" style="color: #ffffff">' + signedCount + '</a>'
	                : '<a href="' + that.getDocumentsUrl(signedDocuments) + '" target="_blank" class="center white-link" style="color: #ffffff">' + signedCount + '</a>',
	            notSignedLink: notSignedCount == 0
	                ? '<a class="center white-link" style="color: #ffffff">' + notSignedCount + '</a>'
	                : '<a href="' + that.getDocumentsUrl(notSignedDocuments) + '" target="_blank" class="center white-link" style="color: #ffffff">' + notSignedCount + '</a>',
	            formatDateTime: function (long) {
	                return long != undefined && long != '' && !isNaN(long)
	                    ? that.utils.longToDateTimeFormatted(long, "MM/DD/YYYY hh:mm A") : '-'
	            },
	            getTotalCountForComment: function (comment) {
	                return _.uniq(_.union(comment.signedDocuments || [],
	                    comment.notAssignedDocuments || [],
	                    comment.obsoletedDocuments || [],
	                    comment.pendingDocuments || [])).length;
	            },
	            getTotalDocumentsUrlForComment: function (comment) {
	                var totalDocuments = _.uniq(_.union(comment.signedDocuments || [],
	                    comment.notAssignedDocuments || [],
	                    comment.obsoletedDocuments || [],
	                    comment.pendingDocuments || []));
	                return that.getDocumentsUrl(totalDocuments);
	            },
	            orgSignedDocumentsLink: function (id) {
	                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	                    + '&ORGANIZATION_REVIEW_FINISHED_REQUEST=' + id;
	            },
	            orgPendingDocumentsLink: function (id) {
	                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	                    + '&ORGANIZATION_REVIEW_REQUEST=' + id;
	            },
	            personSignedDocumentsLink: function (id) {
	                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	                    + '&PERSON_REVIEW_FINISHED_REQUEST=' + id;
	            },
	            personPendingDocumentsLink: function (id) {
	                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	                    + '&PERSON_REVIEW_REQUEST=' + id;
	            },
	            patientSignedDocumentsLink: function (id) {
	                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	                    + '&DOCUMENT_PATIENT=' + id + '&object_status=SIGNED&object_status=VIEWED';
	            },
	            patientPendingDocumentsLink: function (id) {
	                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	                    + '&DOCUMENT_PATIENT=' + id + '&object_status=IN_REVIEW';
	            },
	            sortedBy: function (data, item) {
	                return _.sortBy(data, item);
	            },
	            docsLink: function (ids) {
	                return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	                    + "&" + ids.map(function (id) {
	                        return "id=" + id;
	                    }).join("&");
	            },
	            calculateCleared: function (pendingCnt, signedCnt) {
	                if (pendingCnt == 0 && signedCnt == 0)
	                    return "-";
	                else if (signedCnt == 0)
	                    return "0";
	                else if (pendingCnt == 0)
	                    return "100";
	                else
	                    return new Number(signedCnt / (pendingCnt + signedCnt)).toFixed(2);
	            }
	        }
	    },
	
	    initialize: function (options) {
	        this.utils = new CommonUtils();
	        this.activeCommentPopoverId = null;
	    },
	
	    onRender: function () {
	        var that = this;
	        //that.ui.commentPopover.popover();
	        that.ui.commentPopover.on('show.bs.popover', function () {
	            var thisPopover = $(this);
	            that.activeCommentPopoverId = thisPopover.attr("id");
	            window.setTimeout(function () {
	                that.activeCommentPopoverId = null;
	            }, 1000);
	        });
	    },
	
	    getDocumentsUrl: function (documentsIds) {
	        return '/#documents?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	            + documentsIds.map(function (docId) {
	                return "&id=" + docId;
	            }).join('');
	    },
	
	    getPersonsUrl: function (ids) {
	        return '/#persons?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	            + ids.map(function (docId) {
	                return "&id=" + docId;
	            }).join('');
	    },
	
	    getOrganizationsUrl: function (ids) {
	        return '/#organizations?page-size=' + Constants.pageCapacity + '&page=' + Constants.pageInitialOrd
	            + ids.map(function (docId) {
	                return "&id=" + docId;
	            }).join('');
	    },
	
	
	    onToggleCollapse: function (event) {
	        var collapser = $(event.target);
	        if (collapser.html() == "Show comments")
	            $(event.target).html('Hide comments');
	        else
	            $(event.target).html('Show comments');
	    },
	
	    showPopover: function () {
	        this.ui.commentPopover.popover("show");
	    },
	
	    hidePopover: function () {
	        this.ui.commentPopover.popover("hide");
	    },
	
	    onCommentPopoverClick: function (event) {
	        $(event.target).popover('show');
	    },
	
	    hideComments: function () {
	        var that = this;
	        that.ui.commentPopover.each(function () {
	            var self = $(this);
	            if (that.activeCommentPopoverId != self.attr("id")) {
	                self.popover("hide");
	            }
	        });
	    }
	});
	
	var DocumentSignStatisticByComments2TableBody = Marionette.CollectionView.extend({
	    tagName: 'div',
	    childView: DocumentSignStatisticByComments2RowView,
	
	    collectionEvents: {},
	
	    childViewEvents: {},
	
	    initialize: function (options) {
	        this.collection = options.collection;
	    },
	
	    childViewOptions: function () {
	        return {};
	    },
	
	    findAndExpandComments: function (query) {
	        var that = this;
	        that.clearAndCollapseComments();
	
	        that.collection.filter(function (model) {
	            return model.get('commentText').indexOf(query) > -1;
	        }).forEach(function (model) {
	            var childView = that.children.findByModelCid(model.cid);
	            childView.showPopover();
	        });
	    },
	
	    clearAndCollapseComments: function () {
	        $('[data-toggle="popover"]').popover("hide");
	    },
	
	    hideComments: function () {
	        this.children.each(function (view) {
	            view.hideComments();
	        })
	    }
	});
	
	var DocumentSignStatisticByComments2View = Marionette.View.extend({
	    tagName: 'div',
	    template: __webpack_require__(472),
	
	    regions: {
	        body: {
	            el: '.list-of-commenters',
	            replaceElement: true
	        },
	        commenter: "#commenter",
	    },
	
	    ui: {
	        fromDateTime: '#from',
	        toDateTime: '#to',
	        filter: '#filter',
	
	        commentQuery: '#comment-query',
	        findComment: '#find-and-expand',
	        clear: '#clear-and-collapse'
	    },
	
	    events: {
	        'change @ui.fromDateTime': 'onFilterChange',
	        'change @ui.toDateTime': 'onFilterChange',
	        'click @ui.filter': 'filter',
	        'click @ui.findComment': 'findAndExpandComments',
	        'click @ui.clear': 'clearAndCollapseComments'
	    },
	
	    childViewEvents: {
	        'suggestor:selected:commenter': 'onCommenterSelected'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {}
	    },
	
	
	    initialize: function (options) {
	    },
	
	    onRender: function () {
	        var that = this;
	
	        that.ui.fromDateTime.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'MM/DD/YYYY hh:mm A'
	        });
	        that.ui.fromDateTime.on("dp.change", function (e) {
	            that.enableOrDisableFilter();
	        })
	        that.ui.toDateTime.datetimepicker({
	            showClear: true,
	            showClose: true,
	            useCurrent: false,
	            format: 'MM/DD/YYYY hh:mm A'
	        });
	        that.ui.toDateTime.on("dp.change", function (e) {
	            that.enableOrDisableFilter();
	        })
	
	        that.renderCommenterSelectView();
	
	        that.collection = new Backbone.Collection();
	        that.showChildView('body', new DocumentSignStatisticByComments2TableBody({
	            collection: that.collection
	        }));
	
	        window.setTimeout(function () {
	            $(function () {
	                $("body").click(function (event) {
	                    var clicked = $(event.target);
	                    if (clicked.hasClass('popover-content') /*|| clicked.hasClass('comment-popover')*/)
	                        return;
	
	                    that.getChildView("body").hideComments();
	                });
	            });
	        }, 1000);
	    },
	
	    onBeforeDestroy: function () {
	        $("body").unbind("click");
	    },
	
	    renderCommenterSelectView: function () {
	
	        var that = this;
	
	        that.showChildView('commenter', new RemoteSuggesterView({
	            maxNumberOfElements: 20,
	            url: '/api/person/preview?page-size=' + 20
	            + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data.filter(function (item) {
	                    return item.object;
	                });
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Select a commenter",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return (arr[index] || {}).id;
	            },
	            tag: 'commenter'
	        }));
	    },
	
	    filter: function () {
	        var that = this;
	        that.getData(function (response) {
	            that.collection.reset(that.transformAndSort(response));
	        });
	    },
	
	    getData: function (callback) {
	        var that = this;
	
	        utils.showSpinner();
	        $.ajax({
	            type: "GET",
	            url: '/api/statistics/realtime/commenters/documents/filtered2' + '?' + that.getRequestParameters(),
	            statusCode: {
	                200: function (response) {
	                    utils.hideSpinner();
	                    if (_.isFunction(callback)) {
	                        callback(response);
	                    }
	                }
	            },
	            error: function (e) {
	                utils.hideSpinner();
	                notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        });
	    },
	
	    getRequestParameters: function () {
	        var params = {};
	
	        if (this.ui.fromDateTime.val() != undefined && this.ui.fromDateTime.val() != '')
	            params['from_time'] = utils.dateToLong(this.ui.fromDateTime.val());
	        else
	            delete params['from_time'];
	        if (this.ui.toDateTime.val() != undefined && this.ui.toDateTime.val() != '')
	            params['to_time'] = utils.dateToLong(this.ui.toDateTime.val());
	        else
	            delete params['to_time'];
	        if (this.commenter)
	            params['commenter'] = this.commenter;
	        else
	            delete params['commenter'];
	
	        return _.keys(params).map(function (key) {
	            return key + "=" + params[key];
	        }).join('&');
	    },
	
	    transformAndSort: function (items) {
	        var grouped = _.groupBy(items, 'commenterId');
	        var transformed = _.sortBy(_.keys(grouped).map(function (key) {
	            return {
	                commenterId: key,
	                commenterIdInline: key.replace(/\./g, '') + "_2",
	                commenterName: grouped[key][0].commenterName,
	                comments: grouped[key]
	            }
	        }), 'commenterName');
	        return transformed;
	    },
	
	    findAndExpandComments: function () {
	        var query = this.ui.commentQuery.val();
	        if (query.length < 3)
	            return;
	        this.getChildView("body").findAndExpandComments(query);
	    },
	
	    clearAndCollapseComments: function () {
	        this.ui.commentQuery.val('');
	        this.getChildView("body").clearAndCollapseComments();
	    },
	
	    onCommenterSelected: function (selected) {
	        this.commenter = selected;
	        this.enableOrDisableFilter();
	    },
	
	    enableOrDisableFilter: function () {
	        console.log('enableOrDisableFilter');
	        if (this.ui.fromDateTime.val() || this.ui.toDateTime.val() || this.commenter)
	            this.ui.filter.removeAttr("disabled");
	        else
	            this.ui.filter.attr("disabled", true);
	    }
	});
	
	module.exports = DocumentSignStatisticByComments2View;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="panel panel-success">\r\n    <div class="panel-heading">\r\n        <div class="inline center text-muted">\r\n            ';
	 if (commenterId == 'admin') { 
	__p+='\r\n                Commented by: <a>'+
	((__t=( commenterName ))==null?'':__t)+
	'</a>\r\n            ';
	 } else  { 
	__p+='\r\n                Commented by: <a href="/#person/'+
	((__t=( commenterId ))==null?'':__t)+
	'"  target="_blank" class="center">'+
	((__t=( commenterName ))==null?'':__t)+
	'</a>\r\n            ';
	 } 
	__p+=',\r\n            Comments: <span class="badge badge-success">'+
	((__t=( commentsCount ))==null?'':__t)+
	'</span>,\r\n            Related documents:\r\n            Signed - <span class="badge badge-success">'+
	((__t=( signedLink ))==null?'':__t)+
	'</span>,\r\n            Not Signed - <span class="badge badge-success">'+
	((__t=( notSignedLink ))==null?'':__t)+
	'</span>\r\n        </div>\r\n        <div class="pull-right inline">\r\n            <div data-toggle="collapse" data-target="#'+
	((__t=( commenterIdInline ))==null?'':__t)+
	'" class="collapser">\r\n                <span class="dotted-link">Show comments</span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class="collapse" id="'+
	((__t=( commenterIdInline ))==null?'':__t)+
	'">\r\n        <div class="panel-body">\r\n            <div>\r\n                <table class="table table-bordered table-condensed vertical-aligned-table">\r\n                <thead>\r\n                <tr>\r\n                    <th class="center">Comment</th>\r\n                    <th class="center">Time</th>\r\n                    <th class="center">Organizations</th>\r\n                    <th class="center">Persons</th>\r\n                    <th class="center">Patients</th>\r\n                </tr>\r\n                </thead>\r\n                <tbody>\r\n                ';
	 _.each(comments, function(comment, index) { 
	__p+='\r\n                <tr>\r\n                    <td class="center">\r\n                        <a tabindex="0" class="btn btn-transparent comment-popover" role="button" data-toggle="popover"\r\n                               data-placement="right" data-content="'+
	((__t=( comment.commentText ))==null?'':__t)+
	'" id="'+
	((__t=( 'comment-popover-' + index ))==null?'':__t)+
	'">View</a>\r\n                    </td>\r\n                    <td class="center"><b>'+
	((__t=( formatDateTime(comment.time) ))==null?'':__t)+
	'</b></td>\r\n                    <td class="center" style="padding: 0px 0px 0px 0px; vertical-align: top;">\r\n                        ';
	 if (comment.organizationsReport.length > 0) { 
	__p+='\r\n                        <table class="table table-bordered table-condensed" style="margin-bottom: 0px;">\r\n                            <thead>\r\n                            <tr>\r\n                                <th class="center">Name</th>\r\n                                <th class="center">Pending</th>\r\n                                <th class="center">Signed</th>\r\n                                <th class="center">% Cleared</th>\r\n                            </tr>\r\n                            </thead>\r\n                            <tbody>\r\n                            ';
	 _.each(sortedBy(comment.organizationsReport, "name"), function(org, index) { 
	__p+='\r\n                            <tr>\r\n                                <td class="left">\r\n                                    <a href="/#organization/'+
	((__t=( org.id ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( org.name ))==null?'':__t)+
	'</a>\r\n                                </td>\r\n                                <td>\r\n                                    ';
	 if (org.pending.length > 0) { 
	__p+='\r\n                                    <a href="'+
	((__t=( docsLink(org.pending) ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( org.pending.length ))==null?'':__t)+
	'</a>\r\n                                    ';
	 } else { 
	__p+='\r\n                                    '+
	((__t=( org.pending.length ))==null?'':__t)+
	'\r\n                                    ';
	 } 
	__p+='\r\n                                </td>\r\n                                <td>\r\n                                    ';
	 if (org.signed.length > 0) { 
	__p+='\r\n                                    <a href="'+
	((__t=( docsLink(org.signed) ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( org.signed.length ))==null?'':__t)+
	'</a>\r\n                                    ';
	 } else { 
	__p+='\r\n                                    '+
	((__t=( org.signed.length ))==null?'':__t)+
	'\r\n                                    ';
	 } 
	__p+='\r\n                                </td>\r\n                                <td>'+
	((__t=( calculateCleared(org.pending.length, org.signed.length) ))==null?'':__t)+
	'</td>\r\n                            </tr>\r\n                            ';
	 }) 
	__p+='\r\n                            </tbody>\r\n                        </table>\r\n                        ';
	 } 
	__p+='\r\n                    </td>\r\n                    <td class="center" style="padding: 0px 0px 0px 0px; vertical-align: top;">\r\n                        ';
	 if (comment.personsReport.length > 0) { 
	__p+='\r\n                        <table class="table table-bordered table-condensed" style="margin-bottom: 0px;">\r\n                            <thead>\r\n                            <tr>\r\n                                <th class="center">Name</th>\r\n                                <th class="center">Pending</th>\r\n                                <th class="center">Signed</th>\r\n                                <th class="center">% Cleared</th>\r\n                            </tr>\r\n                            </thead>\r\n                            <tbody>\r\n                            ';
	 _.each(sortedBy(comment.personsReport, "name"), function(person, index) { 
	__p+='\r\n                            <tr>\r\n                                <td class="left">\r\n                                    <a href="/#person/'+
	((__t=( person.id ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( person.name ))==null?'':__t)+
	'</a>\r\n                                </td>\r\n                                <td>\r\n                                    ';
	 if (person.pending.length > 0) { 
	__p+='\r\n                                    <a href="'+
	((__t=( docsLink(person.pending) ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( person.pending.length ))==null?'':__t)+
	'</a>\r\n                                    ';
	 } else { 
	__p+='\r\n                                    '+
	((__t=( person.pending.length ))==null?'':__t)+
	'\r\n                                    ';
	 } 
	__p+='\r\n                                </td>\r\n                                <td>\r\n                                    ';
	 if (person.signed.length > 0) { 
	__p+='\r\n                                    <a href="'+
	((__t=( docsLink(person.signed) ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( person.signed.length ))==null?'':__t)+
	'</a>\r\n                                    ';
	 } else { 
	__p+='\r\n                                    '+
	((__t=( person.signed.length ))==null?'':__t)+
	'\r\n                                    ';
	 } 
	__p+='\r\n                                </td>\r\n                                <td>'+
	((__t=( calculateCleared(person.pending.length, person.signed.length) ))==null?'':__t)+
	'</td>\r\n                            </tr>\r\n                            ';
	 }) 
	__p+='\r\n                            </tbody>\r\n                        </table>\r\n                        ';
	 } 
	__p+='\r\n                    </td>\r\n                    <td class="center" style="padding: 0px 0px 0px 0px; vertical-align: top;">\r\n                        ';
	 if (comment.patientsReport.length > 0) { 
	__p+='\r\n                        <table class="table table-bordered table-condensed" style="margin-bottom: 0px;">\r\n                            <thead>\r\n                            <tr>\r\n                                <th class="center">Name</th>\r\n                                <th class="center">Pending</th>\r\n                                <th class="center">Signed</th>\r\n                                <th class="center">% Cleared</th>\r\n                            </tr>\r\n                            </thead>\r\n                            <tbody>\r\n                            ';
	 _.each(sortedBy(comment.patientsReport, "name"), function(patient, index) { 
	__p+='\r\n                            <tr>\r\n                                <td class="left">\r\n                                    <a href="/#person/'+
	((__t=( patient.id ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( patient.name ))==null?'':__t)+
	'</a>\r\n                                </td>\r\n                                <td>\r\n                                    ';
	 if (patient.pending.length > 0) { 
	__p+='\r\n                                    <a href="'+
	((__t=( docsLink(patient.pending) ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( patient.pending.length ))==null?'':__t)+
	'</a>\r\n                                    ';
	 } else { 
	__p+='\r\n                                    '+
	((__t=( patient.pending.length ))==null?'':__t)+
	'\r\n                                    ';
	 } 
	__p+='\r\n                                </td>\r\n                                <td>\r\n                                    ';
	 if (patient.signed.length > 0) { 
	__p+='\r\n                                    <a href="'+
	((__t=( docsLink(patient.signed) ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( patient.signed.length ))==null?'':__t)+
	'</a>\r\n                                    ';
	 } else { 
	__p+='\r\n                                    '+
	((__t=( patient.signed.length ))==null?'':__t)+
	'\r\n                                    ';
	 } 
	__p+='\r\n                                </td>\r\n                                <td>'+
	((__t=( calculateCleared(patient.pending.length, patient.signed.length) ))==null?'':__t)+
	'</td>\r\n                            </tr>\r\n                            ';
	 }) 
	__p+='\r\n                            </tbody>\r\n                        </table>\r\n                        ';
	 } 
	__p+='\r\n                    </td>\r\n                </tr>\r\n                ';
	 }) 
	__p+='\r\n                </tbody>\r\n            </table>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="top-margined" id="productivity-report-content">\r\n    <div class="form form-inline">\r\n        <div class="form-group">\r\n            <input type="text" class="form-control filter-field" id="from" placeholder="Commented after" name="from_time">\r\n        </div>\r\n        <div class="form-group">\r\n            <input type="text" class="form-control filter-field" id="to" placeholder="Commented before" name="to_time">\r\n        </div>\r\n        <div id="commenter" class="form-group"></div>\r\n        <div class="form-group">\r\n            <button class="btn btn-primary" id="filter" disabled>Filter</button>\r\n        </div>\r\n    </div>\r\n    <div class="top-margined">\r\n        <div class="row" style="display: none;">\r\n            <div class="col-md-6 col-xs-6">\r\n                <input type="text" id="comment-query" class="form-control" placeholder="Comment fragment. At least 3 character"/>\r\n            </div>\r\n            <div class="col-md-3 col-xs-3">\r\n                <button id="find-and-expand" class="btn btn-primary form-control">Find and expand</button>\r\n            </div>\r\n            <div class="col-md-3 col-xs-3">\r\n                <button id="clear-and-collapse" class="btn btn-primary form-control">Clear and collapse</button>\r\n            </div>\r\n        </div>\r\n        <div class="list-of-commenters"></div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 473 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\r\n    <!-- Nav tabs -->\r\n    <ul class="nav nav-tabs" role="tablist">\r\n        <li role="presentation" class="active">\r\n            <a href="#mds-signed" aria-controls="mds-signed" role="tab" data-toggle="tab">Signed per Reviewer</a>\r\n        </li>\r\n        <li role="presentation">\r\n            <a href="#orgs-signed" aria-controls="orgs-signed" role="tab" data-toggle="tab">Signed per Organization</a>\r\n        </li>\r\n        <li role="presentation">\r\n            <a href="#mds-pending" aria-controls="mds-pending" role="tab" data-toggle="tab">Uploaded per Reviewer</a>\r\n        </li>\r\n        <li role="presentation">\r\n            <a href="#orgs-pending" aria-controls="orgs-pending" role="tab" data-toggle="tab">Uploaded per Organization</a>\r\n        </li>\r\n        <li role="presentation">\r\n            <a href="#by-comments" aria-controls="by-comments" role="tab" data-toggle="tab">Productivity Report</a>\r\n        </li>\r\n        <li role="presentation">\r\n            <a href="#by-comments-2" aria-controls="by-comments" role="tab" data-toggle="tab">Productivity Report 2</a>\r\n        </li>\r\n    </ul>\r\n\r\n    <!-- Tab panes -->\r\n    <div class="tab-content">\r\n\r\n        <div role="tabpanel" class="tab-pane active top-margined" id="mds-signed">\r\n            <div id="mds-signed-content"></div>\r\n        </div>\r\n        <div role="tabpanel" class="tab-pane active top-margined" id="mds-pending">\r\n            <div id="mds-pending-content"></div>\r\n        </div>\r\n        <div role="tabpanel" class="tab-pane active top-margined" id="orgs-signed">\r\n            <div id="orgs-signed-content"></div>\r\n        </div>\r\n        <div role="tabpanel" class="tab-pane active top-margined" id="orgs-pending">\r\n            <div id="orgs-pending-content"></div>\r\n        </div>\r\n        <div role="tabpanel" class="tab-pane active top-margined" id="by-comments">\r\n            <div id="by-comments-content"></div>\r\n        </div>\r\n        <div role="tabpanel" class="tab-pane active top-margined" id="by-comments-2">\r\n            <div id="by-comments-content-2"></div>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n';
	}
	return __p;
	};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	
	var ImportPersonsView = Marionette.View.extend({
	    template: __webpack_require__(475),
	
	    ui: {
	        importType: "#import-type",
	        fileSelector: '#file-input'
	    },
	
	    events: {
	        'change @ui.importType': 'onChangeImportType'
	    },
	
	    parameters: {
	        importType: ''
	    },
	
	    initialize: function () {
	    },
	
	
	    onRender: function () {
	        window.document.title = "Import persons";
	        var that = this;
	
	        that.ui.importType.selectize({
	            allowEmptyOption: false,
	            valueField: 'value',
	            labelField: 'name',
	            searchField: ['name', 'value'],
	            options: [
	                {name: 'CCR', value: 'ccr'},
	                {name: 'CCDA', value: 'ccda'}
	            ],
	        });
	
	        that.parameters.importType = that.ui.importType.val();
	
	        that.ui.fileSelector.fileinput({
	            uploadUrl: "/api/person/import/",
	            dropZoneTitle: 'Drag & drop files here &hellip;',
	            uploadExtraData: that.parameters
	        });
	
	        that.ui.fileSelector.fileinput('disable');
	    },
	
	    onChangeImportType: function (event) {
	        this.parameters.importType = event.target.value;
	        if (event.target.value == '')
	            this.ui.fileSelector.fileinput('disable');
	        else
	            this.ui.fileSelector.fileinput('enable');
	    }
	});
	
	module.exports = ImportPersonsView;

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h1 class="center">Import persons</h1>\r\n<div class="row top-margined">\r\n    <select id="import-type" data-placeholder="Select import type" class="col-md-3" style="margin: 20px 10px 10px 10px;">\r\n    </select>\r\n</div>\r\n\r\n<label class="control-label">Select File</label>\r\n<input id="file-input" name="file" type="file" class="file" multiple data-show-caption="true">\r\n';
	}
	return __p;
	};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var MergePersonsDetailView = __webpack_require__(477);
	var RemoteSuggesterView = __webpack_require__(196);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var MergePersonsView = Marionette.View.extend({
	    template: __webpack_require__(499),
	
	    regions: {
	        mergeFromPerson: '#merge-from-person-select',
	        mergeToPerson: '#merge-to-person-select',
	        mergeDetailsRegion: '#merge-details'
	    },
	
	    ui: {
	        mergeFromPersonSelect: '#merge-from-person-select',
	        mergeToPersonSelect: '#merge-to-person-select',
	        mergeFromPersonProbables: '#merge-from-person-select-probables',
	        mergeToPersonProbables: '#merge-to-person-select-probables',
	        mergeDetailsShow: '#show-merge-details',
	        mergeFromPersonsFilterSelect: '#merge-from-persons-filter',
	        personsSelectForm: '#persons-select-form',
	        mergeDetailsContainer: '#merge-details',
	        reset: '#reset'
	    },
	
	    events: {
	        'click @ui.mergeDetailsShow': 'onMergeDetailsShowClick',
	        'change @ui.mergeFromPersonsFilterSelect': 'onMergeFromPersonsFilterChange',
	        'click @ui.reset': 'onResetSelects'
	    },
	
	    childViewEvents: {
	        'back:to:select': 'onBackToSelect',
	        'suggestor:selected:fromperson': 'onSelectedFromPerson',
	        'suggestor:selected:toperson': 'onSelectedToPerson'
	    },
	
	    constants: {
	        maxNumberOfItemsInControlWithSuggester: 20
	    },
	
	    vars: {
	        mergeFromPersonsGetUrl: '/api/person/preview?page-size=20&sortby=name&active=true&active=false&object_isPatient=true&like_name=~~~',
	        mergeToPersonsGetUrl: '/api/person/preview?page-size=20&sortby=name&active=true&active=false&object_isPatient=true&like_name=~~~'
	    },
	
	    initialize: function (options) {
	        this.ids = {
	            mergeFromPersonId: options.mergeFrom,
	            mergeToPersonId: options.mergeTo
	        };
	        this.mergeFromPersonInputId = 'merge-from-person-input';
	        this.mergeToPersonInputId = 'merge-to-person-input';
	    },
	
	
	    onRender: function () {
	        window.document.title = "Merge persons";
	        var that = this;
	
	        var mergableFromSelectize = that.ui.mergeFromPersonsFilterSelect.selectize({
	            allowEmptyOption: false,
	            placeholder: 'Select merge from persons filter',
	            inputClass: 'form-control selectize-input normal-width',
	            valueField: 'value',
	            labelField: 'name',
	            searchField: ['name', 'value']
	        });
	
	        if (!_.isEmpty(that.ids.mergeFromPersonId) && !_.isEmpty(that.ids.mergeToPersonId)) {
	            that.onMergeDetailsShowClick(false);
	
	        } else {
	            that.showMergeFromPersonSelect();
	            that.showMergeToPersonSelect();
	            that.ui.personsSelectForm.collapse('show');
	        }
	
	    },
	
	    showMergeFromPersonSelect: function () {
	        var that = this;
	
	        that.showChildView('mergeFromPerson', new RemoteSuggesterView({
	            inputId: that.mergeFromPersonInputId,
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: that.vars.mergeFromPersonsGetUrl,
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Merge from person",
	            findSelectedIdBySelectedIndex: that.findSelectedIdBySelectedIndex,
	            tag: 'fromperson'
	        }));
	    },
	
	    showMergeToPersonSelect: function () {
	        var that = this;
	
	        that.showChildView('mergeToPerson', new RemoteSuggesterView({
	            inputId: that.mergeToPersonInputId,
	            maxNumberOfElements: that.constants.maxNumberOfItemsInControlWithSuggester,
	            url: that.vars.mergeToPersonsGetUrl,
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getValueFn: function (element) {
	                return element.name;
	            },
	            classes: ["form-control"],
	            placeholder: "Merge to person",
	            findSelectedIdBySelectedIndex: that.findSelectedIdBySelectedIndex,
	            tag: 'toperson'
	        }));
	    },
	
	    onMergeDetailsShowClick: function (witBack) {
	        var that = this;
	
	        if (that.ids["mergeFromPersonId"] == that.ids["mergeToPersonId"]) {
	            notificationsChannel.request('show:notification', 'Selected "merge from" and "merge to" persons are same user');
	            return;
	        }
	
	        $.when(
	            $.ajax({
	                type: "GET",
	                url: '/api/person/' + that.ids["mergeFromPersonId"]
	            }),
	            $.ajax({
	                type: "GET",
	                url: '/api/medprofile/person/' + that.ids["mergeFromPersonId"]
	            }),
	            $.ajax({
	                type: "GET",
	                url: '/api/person/' + that.ids["mergeToPersonId"]
	            }),
	            $.ajax({
	                type: "GET",
	                url: '/api/medprofile/person/' + that.ids["mergeToPersonId"]
	            })
	        ).then(
	            function (mergeFromPersonResponse, mergeFromPersonMedProfileResponse, mergeToPersonResponse, mergeToPersonMedProfileResponse) {
	
	                that.showChildView('mergeDetailsRegion', new MergePersonsDetailView({
	                    mergeFromPerson: mergeFromPersonResponse[0],
	                    mergeFromPersonMedProfile: mergeFromPersonMedProfileResponse[0],
	                    mergeToPerson: mergeToPersonResponse[0],
	                    mergeToPersonMedProfile: mergeToPersonMedProfileResponse[0],
	                    withBack: witBack ? true : false
	                }));
	
	                that.ui.personsSelectForm.collapse('hide');
	                that.ui.mergeDetailsContainer.collapse('show');
	            },
	            function (error, text, status) {
	
	                if (error.status == 401) {
	                    actionsChannel.request("redirect:to:login");
	                } else if (error.status == 404) {
	                    notificationsChannel.request('show:notification',
	                        'Error. Not found medical profile for either "merge from" or "merge to" person. Please, check medical profiles.');
	                } else {
	                    notificationsChannel.request('show:notification',
	                        'Error. Try later');
	                }
	
	            }
	        );
	    },
	
	    onMergeFromPersonsFilterChange: function (event) {
	        if (event.target.value == 'mergeble') {
	            this.vars.mergeFromPersonsGetUrl = '/api/person/preview?page-size=20&sortby=name&active=true&active=false&object_isPatient=true&object_mergeable=true&like_name=~~~';
	            this.showMergeFromPersonSelect();
	        }
	        else {
	            this.vars.mergeFromPersonsGetUrl = '/api/person/preview?page-size=20&sortby=name&active=true&active=false&object_isPatient=true&like_name=~~~';
	            this.showMergeFromPersonSelect();
	        }
	
	        this.ids.mergeFromPersonId = null;
	        this.ui.mergeFromPersonProbables.empty();
	        this.validate();
	    },
	
	    onBackToSelect: function () {
	        this.ui.personsSelectForm.collapse('show');
	        this.ui.mergeDetailsContainer.collapse('hide');
	    },
	
	    findSelectedIdBySelectedValue: function (arr, value) {
	        var found = _.findWhere(arr, {name: value});
	        return found ? found.id : null;
	    },
	
	    findSelectedIdBySelectedIndex: function (arr, index) {
	        return (arr[index] || {}).id;
	    },
	
	    onSelectedFromPerson: function (id) {
	        var that = this;
	        that.ids["mergeFromPersonId"] = id;
	        this.ui.mergeFromPersonProbables.empty();
	
	        if (that.ids["mergeToPersonId"])
	            that.validate();
	        else {
	            that.renderLocalSuggester(id, that.ui.mergeToPersonProbables, "merge-to-probable-selectize", "mergeToPersonId", that.mergeToPersonInputId);
	        }
	    },
	
	    onSelectedToPerson: function (id) {
	        var that = this;
	        that.ids["mergeToPersonId"] = id;
	        this.ui.mergeToPersonProbables.empty();
	
	        if (that.ids["mergeFromPersonId"])
	            that.validate();
	        else {
	            that.renderLocalSuggester(id, that.ui.mergeFromPersonProbables, "merge-from-probable-selectize", "mergeFromPersonId", that.mergeFromPersonInputId);
	        }
	    },
	
	    renderLocalSuggester: function (id, target, targetSelectId, idKey, suggestorInputId) {
	        var that = this;
	
	        $.when(
	            $.ajax({
	                type: "GET",
	                url: '/api/person/' + id
	            })
	        ).done(function (response) {
	
	            var params = [];
	            if (response.object.firstName)
	                params.push("firstName=" + response.object.firstName);
	            if (response.object.lastName)
	                params.push("lastName=" + response.object.lastName);
	            if (response.object.middleName)
	                params.push("middleName=" + response.object.middleName);
	            if (response.object.birthData)
	                params.push("birthDate=" + response.object.birthData);
	            if (response.object.npi)
	                params.push("npi=" + response.object.npi);
	            if (response.object.ssn)
	                params.push("ssn=" + response.object.ssn);
	            if (response.object.insuranceId)
	                params.push("insuranceId=" + response.object.insuranceId);
	
	            $.when(
	                $.ajax({
	                    type: "GET",
	                    url: '/api/person/mpi/all?' + params.join('&')
	                })
	            ).done(function (list) {
	                var persons = list.filter(function(item) {
	                    return item.id != id;
	                });
	                if (persons.length > 0) {
	                    that.renderLocalSuggesterRegion(persons, target, targetSelectId, idKey, suggestorInputId);
	                }
	            });
	
	        });
	    },
	
	    validate: function () {
	        if (this.ids["mergeFromPersonId"] && this.ids["mergeToPersonId"])
	            this.ui.mergeDetailsShow.removeAttr('disabled');
	        else
	            this.ui.mergeDetailsShow.attr('disabled', true);
	    },
	
	    renderLocalSuggesterRegion: function(persons, target, targetSelectId, idKey, suggestorInputId) {
	        var that = this;
	        target.empty();
	        var options = persons.map(function(item) {
	            return "<option value='" + item.id + "'>" + item.name + "</option>";
	        });
	        target.append("<select id='" + targetSelectId + "'><option value=''></option>" + options.join('') + "</select>");
	        $('#' + targetSelectId).selectize({
	            allowEmptyOption: false,
	            inputClass: 'form-control selectize-input normal-width form-control',
	            highlight: true,
	            openOnFocus: true,
	            placeholder: 'Probable matches'
	        });
	        $('#' + targetSelectId).on('change', function(e) {
	            $('#' + suggestorInputId).val(e.target.innerText);
	            that.ids[idKey] = e.target.value;
	            that.validate();
	        })
	    },
	
	    onResetSelects: function() {
	        this.ui.mergeFromPersonProbables.empty();
	        this.ui.mergeToPersonProbables.empty();
	        this.getChildView('mergeFromPerson').render();
	        this.getChildView('mergeToPerson').render();
	        this.ids = {
	            mergeFromPersonId: null,
	            mergeToPersonId: null
	        };
	        this.validate();
	    }
	});
	
	module.exports = MergePersonsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var PersonModel = __webpack_require__(206);
	var MedProfileModel = __webpack_require__(213);
	var PermissionModel = __webpack_require__(244);
	
	var DocumentsCollection = __webpack_require__(302);
	var PermissionsCollection = __webpack_require__(249);
	
	var MergeFromPersonDemographicsView = __webpack_require__(478);
	var MergeToPersonDemographicsView = __webpack_require__(480);
	var MergeFromPersonContactsView = __webpack_require__(482);
	var MergeToPersonContactsView = __webpack_require__(484);
	var MergeFromPersonDiseasesView = __webpack_require__(486);
	var MergeToPersonDiseasesView = __webpack_require__(488);
	var MergeFromPersonMedicationsView = __webpack_require__(490);
	var MergeToPersonMedicationsView = __webpack_require__(492);
	var MergePersonDocumentsView = __webpack_require__(494);
	var MergePersonPermissionsView = __webpack_require__(496);
	
	var YesNoConfirmationModal = __webpack_require__(237);
	
	var CommonUtils = __webpack_require__(189);
	var Radio = __webpack_require__(183);
	
	var notificationsChannel = Radio.channel('notifications');
	
	
	var MergePersonsDetailView = Marionette.View.extend({
	    template: __webpack_require__(498),
	
	    regions: {
	        mergeFromPersonDemographicsRegion: '#merge-from-person-demographics-data',
	        mergeFromPersonContactsRegion: '#merge-from-person-contacts-data',
	        mergeFromPersonDiseasesRegion: '#merge-from-person-diseases-data',
	        mergeFromPersonMedicationsRegion: '#merge-from-person-medications-data',
	        mergeFromPersonDocumentsRegion: '#merge-from-person-documents-data',
	        mergeFromPersonPermissionsRegion: '#merge-from-person-permissions-data',
	        mergeToPersonDemographicsRegion: '#merge-to-person-demographics-data',
	        mergeToPersonContactsRegion: '#merge-to-person-contacts-data',
	        mergeToPersonDiseasesRegion: '#merge-to-person-diseases-data',
	        mergeToPersonMedicationsRegion: '#merge-to-person-medications-data',
	        mergeToPersonDocumentsRegion: '#merge-to-person-documents-data',
	        mergeToPersonPermissionsRegion: '#merge-to-person-permissions-data',
	
	        cancelConfirmationRegion: '#cancel-confirmation-modal',
	        saveConfirmationRegion: '#save-confirmation-modal',
	        saveAndDeleteConfirmationRegion: '#save-and-delete-confirmation-modal'
	    },
	
	    ui: {
	        back: '#back',
	        save: '#save',
	        saveAndDelete: '#save-and-delete',
	        cancel: '#cancel',
	
	        cancelConfirmationModal: '#cancel-confirmation-modal',
	        saveConfirmationModal: '#save-confirmation-modal',
	        saveAndDeleteConfirmationModal: '#save-and-delete-confirmation-modal'
	    },
	
	    events: {
	        'click @ui.back': 'onBack',
	        'click @ui.cancel': 'onCancel',
	        'click @ui.save': 'onSave',
	        'click @ui.saveAndDelete': 'onSaveAndDelete'
	    },
	
	    childViewEvents: {
	        'action:confirmed': 'saveConfirmed',
	
	        'merge:person:demographics': 'onMergePersonDemographics',
	        'restore:person:demographics': 'onRestorePersonDemographics',
	        'edit:person:demographics': 'onEditPersonDemographics',
	        'merge:person:contacts:row': 'onMergeRowPersonContacts',
	        'remove:person:contacts:row': 'onRemoveRowPersonContacts',
	        'merge:person:diseases:row': 'onMergeRowPersonDiseases',
	        'remove:person:diseases:row': 'onRemoveRowPersonDiseases',
	        'merge:person:medications:row': 'onMergeRowPersonMedications',
	        'remove:person:medications:row': 'onRemoveRowPersonMedications',
	        'merge:person:documents:row': 'onMergeRowPersonDocuments',
	        'remove:person:documents:row': 'onRemoveRowPersonDocuments',
	        'merge:person:permissions:row': 'onMergeRowPersonPermissions',
	        'remove:person:permissions:row': 'onRemoveRowPersonPermissions'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            withBack: that.getOption('withBack')
	        }
	    },
	
	    initialize: function (options) {
	
	        this.utils = new CommonUtils();
	
	        this.mergeFromPersonModel = new PersonModel(options.mergeFromPerson);
	
	        var mergeFromMedProfileNotSorted = options.mergeFromPersonMedProfile;
	        var mergeFromMedProfileSorted = this.sortMedProfile(mergeFromMedProfileNotSorted);
	        this.mergeFromPersonMedProfileModel = new MedProfileModel(mergeFromMedProfileSorted);
	
	        this.mergeToPersonModel = new PersonModel(options.mergeToPerson);
	
	        var mergeToMedProfileNotSorted = options.mergeToPersonMedProfile;
	        var mergeToMedProfileSorted = this.sortMedProfile(mergeToMedProfileNotSorted);
	        this.mergeToPersonMedProfileModel = new MedProfileModel(mergeToMedProfileSorted);
	
	        this.mergeToPersonModelOriginal = new PersonModel(this.utils.deepClone(options.mergeToPerson));
	        this.mergeToPersonMedProfileModelOriginal = new MedProfileModel(this.utils.deepClone(mergeToMedProfileSorted));
	
	        this.mergeFromPersonDocumentsModel = new Backbone.Model();
	        this.mergeFromPersonDocumentsModelOriginal = new Backbone.Model();
	        this.mergeToPersonDocumentsModel = new Backbone.Model();
	        this.mergeToPersonDocumentsModelOriginal = new Backbone.Model();
	
	        this.mergeFromPersonPermissionsModel = new Backbone.Model();
	        this.mergeFromPersonPermissionsModelOriginal = new Backbone.Model();
	        this.mergeToPersonPermissionsModel = new Backbone.Model();
	        this.mergeToPersonPermissionsModelOriginal = new Backbone.Model();
	    },
	
	
	    onRender: function () {
	        var that = this;
	
	        that.checkModelsChanges();
	
	        that.renderMergeFromPersonDemographicsRegion();
	        that.renderMergeToPersonDemographicsRegion();
	
	        that.renderMergeFromPersonContactsRegion();
	        that.renderMergeToPersonContactsRegion();
	
	        that.renderMergeFromPersonDiseasesRegion();
	        that.renderMergeToPersonDiseasesRegion();
	
	        that.renderMergeFromPersonMedicationsRegion();
	        that.renderMergeToPersonMedicationsRegion();
	
	        that.renderMergeFromPersonDocumentsRegion();
	        that.renderMergeToPersonDocumentsRegion();
	
	        that.renderMergeToPersonPermissionsRegion();
	        window.setTimeout(function () {
	            that.renderMergeFromPersonPermissionsRegion();
	        }, 600);
	
	        this.cancelConfirmationModal = new YesNoConfirmationModal({
	            title: 'Cancel confirmation',
	            message: 'You are going to cancel all made works. Are you sure?'
	        });
	        this.showChildView('cancelConfirmationRegion', this.cancelConfirmationModal);
	
	        this.saveConfirmationModal = new YesNoConfirmationModal({
	            title: 'Save confirmation',
	            message: 'You are going to save merged person. Are you sure?'
	        });
	        this.showChildView('saveConfirmationRegion', this.saveConfirmationModal);
	
	        this.saveAndDeleteConfirmationModal = new YesNoConfirmationModal({
	            title: 'Save and delete confirmation',
	            message: 'You are going to save merged person and remove "from merge" person. Are you sure?'
	        });
	        this.showChildView('saveAndDeleteConfirmationRegion', this.saveAndDeleteConfirmationModal);
	    },
	
	    renderMergeFromPersonDemographicsRegion: function () {
	        var that = this;
	        that.showChildView('mergeFromPersonDemographicsRegion', new MergeFromPersonDemographicsView({
	            model: that.mergeFromPersonModel,
	            mergeFromPersonId: that.getMergeFromPersonId(),
	            mergeFromPersonName: that.getMergeFromPersonName(),
	            isBeingMerged: function (modelAttrName) {
	                return that.mergeToPersonModel.get('object')[modelAttrName] == that.mergeFromPersonModel.get('object')[modelAttrName];
	            }
	        }));
	    },
	
	    renderMergeToPersonDemographicsRegion: function () {
	        var that = this;
	        that.showChildView('mergeToPersonDemographicsRegion', new MergeToPersonDemographicsView({
	            model: that.mergeToPersonModel,
	            mergeToPersonId: that.getMergeToPersonId(),
	            mergeToPersonName: that.getMergeToPersonName(),
	            isBeingMerged: function (modelAttrName) {
	                return that.mergeToPersonModel.get('object')[modelAttrName] != that.mergeToPersonModelOriginal.get('object')[modelAttrName];
	            }
	        }));
	    },
	
	    renderMergeFromPersonContactsRegion: function () {
	        var that = this;
	        that.showChildView('mergeFromPersonContactsRegion', new MergeFromPersonContactsView({
	            model: that.mergeFromPersonModel,
	            mergeFromPersonId: that.getMergeFromPersonId(),
	            mergeFromPersonName: that.getMergeFromPersonName(),
	            isBeingMerged: function (contact) {
	                return _.filter(that.mergeToPersonModel.get('object').contacts || [], function (item) {
	                        return contact.data == item.data && contact.type == item.type && contact.preferred == item.preferred;
	                    }).length > 0;
	            }
	        }));
	    },
	
	    renderMergeToPersonContactsRegion: function () {
	        this.showChildView('mergeToPersonContactsRegion', new MergeToPersonContactsView({
	            model: this.mergeToPersonModel,
	            modelCopyAsOriginal: this.mergeToPersonModelOriginal,
	            mergeToPersonId: this.getMergeToPersonId(),
	            mergeToPersonName: this.getMergeToPersonName()
	        }));
	    },
	
	    renderMergeFromPersonDiseasesRegion: function () {
	        var that = this;
	        that.showChildView('mergeFromPersonDiseasesRegion', new MergeFromPersonDiseasesView({
	            model: that.mergeFromPersonMedProfileModel,
	            mergeFromPersonId: that.getMergeFromPersonId(),
	            mergeFromPersonName: that.getMergeFromPersonName(),
	            isBeingMerged: function (disease) {
	                return (that.mergeToPersonMedProfileModel.get('object').diseases || []).filter(function (d) {
	                        return _.isEqual(d, disease);
	                    }).length > 0;
	            }
	        }));
	    },
	
	    renderMergeToPersonDiseasesRegion: function () {
	        this.showChildView('mergeToPersonDiseasesRegion', new MergeToPersonDiseasesView({
	            model: this.mergeToPersonMedProfileModel,
	            modelCopyAsOriginal: this.mergeToPersonMedProfileModelOriginal,
	            mergeToPersonId: this.getMergeToPersonId(),
	            mergeToPersonName: this.getMergeToPersonName()
	        }));
	    },
	
	    renderMergeFromPersonMedicationsRegion: function () {
	        var that = this;
	        that.showChildView('mergeFromPersonMedicationsRegion', new MergeFromPersonMedicationsView({
	            model: that.mergeFromPersonMedProfileModel,
	            mergeFromPersonId: that.getMergeFromPersonId(),
	            mergeFromPersonName: that.getMergeFromPersonName(),
	            isBeingMerged: function (medication) {
	                return (that.mergeToPersonMedProfileModel.get('object').medications || []).filter(function (m) {
	                        return _.isEqual(m, medication);
	                    }).length > 0;
	            }
	        }));
	    },
	
	    renderMergeToPersonMedicationsRegion: function () {
	        this.showChildView('mergeToPersonMedicationsRegion', new MergeToPersonMedicationsView({
	            model: this.mergeToPersonMedProfileModel,
	            modelCopyAsOriginal: this.mergeToPersonMedProfileModelOriginal,
	            mergeToPersonId: this.getMergeToPersonId(),
	            mergeToPersonName: this.getMergeToPersonName()
	        }));
	    },
	
	    renderMergeFromPersonDocumentsRegion: function () {
	        this.renderPersonDocuments('from');
	    },
	
	    renderMergeToPersonDocumentsRegion: function () {
	        this.renderPersonDocuments('to');
	    },
	
	    renderPersonDocuments: function (mode) {
	        var that = this;
	        var personDocuments = new DocumentsCollection([], {
	            params: [
	                {key: 'sortby', value: 'createdTime'},
	                {key: 'sortdir', value: 'DESC'},
	                {
	                    key: 'object_patientId',
	                    value: mode == 'from' ? that.getMergeFromPersonId() : that.getMergeToPersonId()
	                }
	            ]
	        });
	        personDocuments.fetch({
	            success: function () {
	                var documents = personDocuments.models.map(function (model) {
	                    return {
	                        id: model.attributes.id,
	                        name: model.attributes.name,
	                        createdTime: model.attributes.createdTime
	                    };
	                });
	
	                if (mode == 'from') {
	                    that.mergeFromPersonDocumentsModel = new Backbone.Model({documents: documents});
	                    that.mergeFromPersonDocumentsModelOriginal = new Backbone.Model({documents: that.utils.deepClone(documents)});
	                    that.renderMergeFromPersonDocuments();
	                } else {
	                    that.mergeToPersonDocumentsModel = new Backbone.Model({documents: documents});
	                    that.mergeToPersonDocumentsModelOriginal = new Backbone.Model({documents: that.utils.deepClone(documents)});
	                    that.renderMergeToPersonDocuments();
	                }
	            },
	            error: function (e) {
	                console.log(e);
	            }
	        });
	    },
	
	    renderMergeFromPersonDocuments: function () {
	        this.showChildView('mergeFromPersonDocumentsRegion', new MergePersonDocumentsView({
	            mode: 'from',
	            mergeFromPersonDocumentsModel: this.mergeFromPersonDocumentsModel,
	            personId: this.getMergeFromPersonId(),
	            personName: this.getMergeFromPersonName()
	        }));
	    },
	
	    renderMergeToPersonDocuments: function () {
	        this.showChildView('mergeToPersonDocumentsRegion', new MergePersonDocumentsView({
	            mode: 'to',
	            mergeToPersonDocumentsModel: this.mergeToPersonDocumentsModel,
	            mergeToPersonDocumentsModelOriginal: this.mergeToPersonDocumentsModelOriginal,
	            personId: this.getMergeToPersonId(),
	            personName: this.getMergeToPersonName()
	        }));
	    },
	
	    renderMergeFromPersonPermissionsRegion: function () {
	        this.renderPersonPermissions('from');
	    },
	
	    renderMergeToPersonPermissionsRegion: function () {
	        this.renderPersonPermissions('to');
	    },
	
	    renderPersonPermissions: function (mode) {
	        var that = this;
	        var personPermissions = new PermissionsCollection([], {
	            params: [{
	                key: 'permittedObjectId',
	                value: mode == 'from' ? that.getMergeFromPersonId() : that.getMergeToPersonId()
	            }]
	        });
	        personPermissions.fetch({
	            success: function () {
	                var perms = personPermissions.models.filter(function (model) {
	                    return model.attributes.permittedObjectId != model.attributes.ownerId;
	                }).map(function (model) {
	                    return {
	                        id: model.attributes.id,
	                        permittedOrgPersonToRead: model.attributes.permittedOrgPersonToRead,
	                        permittedOrgToRead: model.attributes.permittedOrgToRead,
	                        permittedObjectId: model.attributes.permittedObjectId,
	                        ownerId: model.attributes.ownerId,
	                        organizationId: model.attributes.organizationId,
	                        grantedToReviewer: model.attributes.grantedToReviewer,
	                        canRead: model.attributes.canRead,
	                        canReadAll: model.attributes.canReadAll,
	                        canReadFor: model.attributes.canReadFor,
	                        canWrite: model.attributes.canWrite,
	                        canWriteAll: model.attributes.canWriteAll,
	                        canWriteFor: model.attributes.canWriteFor,
	                        canSign: model.attributes.canSign,
	                        canSignAll: model.attributes.canSignAll,
	                        canUploadFor: model.attributes.canUploadFor,
	                        canDelete: model.attributes.canDelete,
	                        canChangeReviewer: model.attributes.canChangeReviewer,
	                        owner: model.attributes.owner,
	                        organization: model.attributes.organization
	                    };
	                });
	
	                if (mode == 'from') {
	                    that.mergeFromPersonPermissionsModel = new Backbone.Model({perms: that.sortPermissions(perms)});
	                    that.mergeFromPersonPermissionsModelOriginal = new Backbone.Model({perms: that.utils.deepClone(that.sortPermissions(perms))});
	                    that.renderMergeFromPersonPermissions();
	                } else {
	                    that.mergeToPersonPermissionsModel = new Backbone.Model({perms: that.sortPermissions(perms)});
	                    that.mergeToPersonPermissionsModelOriginal = new Backbone.Model({perms: that.utils.deepClone(that.sortPermissions(perms))});
	                    that.renderMergeToPersonPermissions();
	                }
	            },
	            error: function (e) {
	                console.log(e);
	            }
	        });
	    },
	
	    renderMergeFromPersonPermissions: function () {
	        var that = this;
	        that.showChildView('mergeFromPersonPermissionsRegion', new MergePersonPermissionsView({
	            mode: 'from',
	            mergeFromPersonPermissionsModel: that.mergeFromPersonPermissionsModel,
	            personId: that.getMergeFromPersonId(),
	            personName: that.getMergeFromPersonName(),
	            isBeingMerged: function (permission) {
	                return that.mergedPermissionsCount(that.mergeToPersonPermissionsModel.get('perms'), permission).length > 0;
	            }
	        }));
	    },
	
	    renderMergeToPersonPermissions: function () {
	        this.showChildView('mergeToPersonPermissionsRegion', new MergePersonPermissionsView({
	            mode: 'to',
	            mergeToPersonPermissionsModel: this.mergeToPersonPermissionsModel,
	            mergeToPersonPermissionsModelOriginal: this.mergeToPersonPermissionsModelOriginal,
	            personId: this.getMergeToPersonId(),
	            personName: this.getMergeToPersonName(),
	            mergedPermissionsCount: this.mergedPermissionsCount
	        }));
	    },
	
	    onMergePersonDemographics: function (modelAttrName) {
	        this.mergeToPersonModel.get('object')[modelAttrName] = this.mergeFromPersonModel.get('object')[modelAttrName];
	        this.getChildView('mergeToPersonDemographicsRegion').render();
	        this.getChildView('mergeFromPersonDemographicsRegion').render();
	        this.checkModelsChanges();
	    },
	
	    onRestorePersonDemographics: function (modelAttrName) {
	        this.mergeToPersonModel.get('object')[modelAttrName] = this.mergeToPersonModelOriginal.get('object')[modelAttrName];
	        this.getChildView('mergeToPersonDemographicsRegion').render();
	        this.getChildView('mergeFromPersonDemographicsRegion').render();
	        this.checkModelsChanges();
	    },
	
	    onEditPersonDemographics: function (data) {
	        this.mergeToPersonModel.get('object')[data.fieldName] = data.value;
	        this.getChildView('mergeToPersonDemographicsRegion').render();
	        this.getChildView('mergeFromPersonDemographicsRegion').render();
	        this.checkModelsChanges();
	    },
	
	    onMergeRowPersonContacts: function (data) {
	        var contacts = this.mergeToPersonModel.get('object').contacts || [];
	        var contact = data.contact;
	
	        if (typeof (_.findWhere(contacts, {
	                type: contact.type,
	                data: contact.data,
	                preferred: contact.preferred
	            })) != 'undefined')
	            return;
	
	        contacts.splice(data.insertedIndex, 0, contact);
	
	        this.mergeToPersonModel.get('object').contacts = contacts;
	        this.getChildView('mergeFromPersonContactsRegion').render();
	        this.getChildView('mergeToPersonContactsRegion').render();
	        this.checkModelsChanges();
	    },
	
	    onRemoveRowPersonContacts: function (removedContact) {
	        this.mergeToPersonModel.get('object').contacts = _.filter(this.mergeToPersonModel.get('object').contacts,
	            function (contact) {
	                return !_.isEqual(contact, removedContact);
	            });
	        this.getChildView('mergeFromPersonContactsRegion').render();
	        this.getChildView('mergeToPersonContactsRegion').render();
	        this.checkModelsChanges();
	    },
	
	    onMergeRowPersonDiseases: function (data) {
	        var diseases = this.mergeToPersonMedProfileModel.get('object').diseases || [];
	        var disease = data.disease;
	
	        if (diseases.filter(function (d) {
	                return _.isEqual(d, disease);
	            }).length > 0)
	            return;
	
	        diseases.push(disease);
	
	        this.mergeToPersonMedProfileModel.get('object').diseases = _.chain(diseases)
	            .sortBy(function (item) {
	                return item.uuid;
	            })
	            .value();
	        this.getChildView('mergeFromPersonDiseasesRegion').render();
	        this.getChildView('mergeToPersonDiseasesRegion').render();
	        this.checkModelsChanges();
	    },
	
	    onRemoveRowPersonDiseases: function (removedDisease) {
	        this.mergeToPersonMedProfileModel.get('object').diseases = _.chain(this.mergeToPersonMedProfileModel.get('object').diseases)
	            .filter(function (disease) {
	                return !_.isEqual(disease, removedDisease);
	            })
	            .sortBy(function (item) {
	                return item.uuid;
	            })
	            .value();
	
	        this.getChildView('mergeFromPersonDiseasesRegion').render();
	        this.getChildView('mergeToPersonDiseasesRegion').render();
	        this.checkModelsChanges();
	    },
	
	    onMergeRowPersonMedications: function (data) {
	        var medications = this.mergeToPersonMedProfileModel.get('object').medications || [];
	        var medication = data.medication;
	
	        if (medications.filter(function (d) {
	                return _.isEqual(d, medication);
	            }).length > 0)
	            return;
	
	        medications.push(medication);
	
	        this.mergeToPersonMedProfileModel.get('object').medications = _.chain(medications)
	            .sortBy(function (item) {
	                return item.groupUuid + item.medicationUuid;
	            })
	            .value();
	        this.getChildView('mergeFromPersonMedicationsRegion').render();
	        this.getChildView('mergeToPersonMedicationsRegion').render();
	        this.checkModelsChanges();
	    },
	
	    onRemoveRowPersonMedications: function (removedMedication) {
	        this.mergeToPersonMedProfileModel.get('object').medications = _.chain(this.mergeToPersonMedProfileModel.get('object').medications)
	            .filter(function (medication) {
	                return !_.isEqual(medication, removedMedication);
	            })
	            .sortBy(function (item) {
	                return item.groupUuid + item.medicationUuid;
	            })
	            .value();
	
	        this.getChildView('mergeFromPersonMedicationsRegion').render();
	        this.getChildView('mergeToPersonMedicationsRegion').render();
	        this.checkModelsChanges();
	    },
	
	    onMergeRowPersonDocuments: function (data) {
	        this.mergeOrRemoveDocument(data.document, data.insertedIndex, this.mergeFromPersonDocumentsModel, this.mergeToPersonDocumentsModel, data.onlyRemove);
	    },
	
	    onRemoveRowPersonDocuments: function (data) {
	        this.mergeOrRemoveDocument(data.document, data.insertedIndex, this.mergeToPersonDocumentsModel, this.mergeFromPersonDocumentsModel, data.onlyRemove);
	    },
	
	    mergeOrRemoveDocument: function (document, index, sourceModel, targetModel, onlyRemove) {
	
	        sourceModel.set('documents', _.filter(sourceModel.get('documents') || [],
	            function (d) {
	                return !_.isEqual(document, d);
	            })
	        );
	
	        if (!onlyRemove) {
	            var documents = targetModel.get('documents') || [];
	            documents.splice(index, 0, document);
	            targetModel.set('documents', documents);
	        }
	
	        this.getChildView('mergeFromPersonDocumentsRegion').render();
	        this.getChildView('mergeToPersonDocumentsRegion').render();
	        this.checkModelsChanges();
	    },
	
	    onMergeRowPersonPermissions: function (data) {
	        var permissions = this.mergeToPersonPermissionsModel.get('perms') || [];
	        var permission = data.permission;
	
	        if (this.mergedPermissionsCount(permissions, permission).length > 0)
	            return;
	
	        permissions.push(permission);
	
	        this.mergeToPersonPermissionsModel.set('perms', this.sortPermissions(permissions));
	        this.getChildView('mergeFromPersonPermissionsRegion').render();
	        this.getChildView('mergeToPersonPermissionsRegion').render();
	        this.checkModelsChanges();
	    },
	
	    onRemoveRowPersonPermissions: function (data) {
	        var removedPermission = data.permission;
	        var permissions = _.filter(this.mergeToPersonPermissionsModel.get('perms'),
	            function (permission) {
	                return permission.id != removedPermission.id;
	            });
	        this.mergeToPersonPermissionsModel.set('perms', this.sortPermissions(permissions));
	        this.getChildView('mergeFromPersonPermissionsRegion').render();
	        this.getChildView('mergeToPersonPermissionsRegion').render();
	        this.checkModelsChanges();
	    },
	
	    checkModelsChanges: function () {
	        this.triggerMethod('have:models:changes');
	    },
	
	    onBack: function () {
	        this.triggerMethod('back:to:select');
	    },
	
	    onCancel: function () {
	        var that = this;
	        that.callback = function () {
	            that.mergeToPersonModel = new PersonModel(that.utils.deepClone(that.mergeToPersonModelOriginal.attributes));
	            that.renderMergeFromPersonDemographicsRegion();
	            that.renderMergeFromPersonContactsRegion();
	            that.renderMergeToPersonDemographicsRegion();
	            that.renderMergeToPersonContactsRegion();
	
	            that.mergeToPersonMedProfileModel = new MedProfileModel(that.utils.deepClone(that.mergeToPersonMedProfileModelOriginal.attributes));
	            that.renderMergeFromPersonDiseasesRegion();
	            that.renderMergeFromPersonMedicationsRegion();
	            that.renderMergeToPersonDiseasesRegion();
	            that.renderMergeToPersonMedicationsRegion();
	
	            that.mergeFromPersonDocumentsModel = new Backbone.Model({documents: that.utils.deepClone(that.mergeFromPersonDocumentsModelOriginal.get('documents'))});
	            that.mergeToPersonDocumentsModel = new Backbone.Model({documents: that.utils.deepClone(that.mergeToPersonDocumentsModelOriginal.get('documents'))});
	            that.renderMergeToPersonDocuments();
	            that.renderMergeFromPersonDocuments();
	
	            that.mergeFromPersonPermissionsModel = new Backbone.Model({perms: that.utils.deepClone(that.mergeFromPersonPermissionsModelOriginal.get('perms'))});
	            that.mergeToPersonPermissionsModel = new Backbone.Model({perms: that.utils.deepClone(that.mergeToPersonPermissionsModelOriginal.get('perms'))});
	            that.renderMergeToPersonPermissions();
	            that.renderMergeFromPersonPermissions();
	
	            that.checkModelsChanges();
	        }
	        that.cancelConfirmationModal.show();
	    },
	
	    onSave: function () {
	        this.commitMerge(false);
	    },
	
	    onSaveAndDelete: function () {
	        this.commitMerge(true);
	    },
	
	    commitRemove: function () {
	        var that = this;
	        that.mergeFromPersonMedProfileModel.destroy();
	        that.mergeFromPersonModel.destroy();
	
	        Backbone.history.navigate('/person/' + that.mergeToPersonModel.get('id'), {trigger: true});
	    },
	
	    commitMerge: function (doDelete) {
	        var that = this;
	
	        that.callback = function () {
	
	            if (!_.isEqual(that.mergeToPersonModel.attributes, that.mergeToPersonModelOriginal.attributes)
	                && !_.isEqual(that.mergeToPersonMedProfileModel.attributes, that.mergeToPersonMedProfileModelOriginal.attributes)) {
	
	                that.mergeToPersonMedProfileModel.save(that.mergeToPersonMedProfileModel.toJSON(), {
	                    success: function () {
	                        that.mergeToPersonModel.save(that.mergeToPersonModel.toJSON(), {
	                            success: function () {
	                                that.saveDocumentPatientsChanges();
	                                that.savePermissionChanges();
	                                if (doDelete) {
	                                    that.commitRemove();
	                                } else {
	                                    that.mergeToPersonModelOriginal = new PersonModel(that.utils.deepClone(that.mergeToPersonModel.attributes));
	                                    that.renderMergeToPersonDemographicsRegion();
	                                    that.renderMergeToPersonContactsRegion();
	                                    that.mergeToPersonMedProfileModelOriginal = new MedProfileModel(that.utils.deepClone(that.mergeToPersonMedProfileModel.attributes));
	                                    that.renderMergeToPersonDiseasesRegion();
	                                    that.renderMergeToPersonMedicationsRegion();
	                                    that.syncMergePatientsDocuments();
	                                    that.syncMergePatientsPermissions();
	                                    that.checkModelsChanges();
	                                }
	
	                            },
	                            error: function (model, xhr, options) {
	                                notificationsChannel.request('show:notification', xhr.responseText);
	                                //rollback medprofile
	                                that.mergeToPersonMedProfileModelOriginal.save();
	                            }
	                        });
	                    },
	                    error: function (model, xhr, options) {
	                        notificationsChannel.request('show:notification', xhr.responseText);
	                    }
	                });
	
	            } else if (!_.isEqual(that.mergeToPersonModel.attributes, that.mergeToPersonModelOriginal.attributes)) {
	
	                that.mergeToPersonModel.save(that.mergeToPersonModel.toJSON(), {
	                    success: function () {
	                        that.saveDocumentPatientsChanges();
	                        that.savePermissionChanges();
	                        if (doDelete) {
	                            that.commitRemove();
	                        } else {
	                            that.mergeToPersonModelOriginal = new PersonModel(that.utils.deepClone(that.mergeToPersonModel.attributes));
	                            that.renderMergeToPersonDemographicsRegion();
	                            that.renderMergeToPersonContactsRegion();
	                            that.syncMergePatientsDocuments();
	                            that.syncMergePatientsPermissions();
	                            that.checkModelsChanges();
	                        }
	                    },
	                    error: function (model, xhr, options) {
	                        notificationsChannel.request('show:notification', xhr.responseText);
	                    }
	                });
	
	            } else if (!_.isEqual(that.mergeToPersonMedProfileModel.attributes, that.mergeToPersonMedProfileModelOriginal.attributes)) {
	
	                that.mergeToPersonMedProfileModel.save(that.mergeToPersonMedProfileModel.toJSON(), {
	                    success: function () {
	                        that.saveDocumentPatientsChanges();
	                        that.savePermissionChanges();
	                        if (doDelete) {
	                            that.commitRemove();
	                        } else {
	                            that.mergeToPersonMedProfileModelOriginal = new MedProfileModel(that.utils.deepClone(that.mergeToPersonMedProfileModel.attributes));
	                            that.renderMergeToPersonDiseasesRegion();
	                            that.renderMergeToPersonMedicationsRegion();
	                            that.syncMergePatientsDocuments();
	                            that.syncMergePatientsPermissions();
	                            that.checkModelsChanges();
	                        }
	                    },
	                    error: function (model, xhr, options) {
	                        notificationsChannel.request('show:notification', xhr.responseText);
	                    }
	                });
	
	            } else {
	                that.saveDocumentPatientsChanges();
	                that.savePermissionChanges();
	                if (doDelete) {
	                    that.commitRemove();
	                }
	                else {
	                    that.syncMergePatientsDocuments();
	                    that.syncMergePatientsPermissions();
	                    that.checkModelsChanges();
	                }
	            }
	
	        }
	
	        if (doDelete)
	            that.saveAndDeleteConfirmationModal.show();
	        else
	            that.saveConfirmationModal.show();
	    },
	
	    saveDocumentPatientsChanges: function () {
	        var that = this;
	        if (_.isEqual(that.mergeToPersonDocumentsModel.attributes, that.mergeToPersonDocumentsModelOriginal.attributes))
	            return;
	
	        var originals = that.mergeToPersonDocumentsModelOriginal.get('documents');
	        that.mergeToPersonDocumentsModel.get('documents').forEach(function (document) {
	
	            var exists = _.findWhere(originals, {id: document.id});
	            if (!exists) {
	                $.ajax({
	                    type: "POST",
	                    url: '/api/document/' + document.id + '/patient/' + that.getMergeToPersonId(),
	                    statusCode: {
	                        200: function (response) {
	                        }
	                    },
	                    error: function (e) {
	                        console.log(e);
	                    }
	                });
	            }
	
	        });
	
	        originals.forEach(function (document) {
	
	            var exists = _.findWhere(that.mergeToPersonDocumentsModel.get('documents'), {id: document.id});
	            if (!exists) {
	                $.ajax({
	                    type: "DELETE",
	                    url: '/api/document/' + document.id + '/patient/' + that.getMergeToPersonId(),
	                    statusCode: {
	                        200: function (response) {
	                        }
	                    },
	                    error: function (e) {
	                        console.log(e);
	                    }
	                });
	            }
	
	        });
	
	    },
	
	    syncMergePatientsDocuments: function () {
	        if (_.isEqual(this.mergeToPersonDocumentsModel.attributes, this.mergeToPersonDocumentsModelOriginal.attributes))
	            return;
	        this.mergeFromPersonDocumentsModelOriginal = new Backbone.Model({documents: this.utils.deepClone(this.mergeFromPersonDocumentsModel.get('documents'))});
	        this.mergeToPersonDocumentsModelOriginal = new Backbone.Model({documents: this.utils.deepClone(this.mergeToPersonDocumentsModel.get('documents'))});
	        this.renderMergeToPersonDocuments();
	    },
	
	    savePermissionChanges: function () {
	        var that = this;
	        if (!that.hasPermissionsChanges())
	            return;
	
	        var originals = that.mergeToPersonPermissionsModelOriginal.get('perms');
	        that.mergeToPersonPermissionsModel.get('perms').forEach(function (permission) {
	
	            if (that.mergedPermissionsCount(originals, permission).length == 0) {
	                permission = _.omit(permission, 'id');
	                permission = _.omit(permission, 'owner');
	                permission = _.omit(permission, 'organization');
	                permission.permittedObjectId = that.getMergeToPersonId();
	                var permissionsModel = new PermissionModel(permission);
	                permissionsModel.save(permissionsModel.toJSON());
	            }
	        });
	
	        originals.forEach(function (permission) {
	
	            if (that.mergedPermissionsCount(that.mergeToPersonPermissionsModel.get('perms'), permission).length == 0) {
	                var permissionsModel = new PermissionModel(permission);
	                permissionsModel.destroy();
	            }
	        });
	    },
	
	    syncMergePatientsPermissions: function () {
	        if (!this.hasPermissionsChanges())
	            return;
	        this.mergeFromPersonPermissionsModelOriginal = new Backbone.Model({perms: this.utils.deepClone(this.mergeFromPersonPermissionsModel.get('perms'))});
	        this.mergeToPersonPermissionsModelOriginal = new Backbone.Model({perms: this.utils.deepClone(this.mergeToPersonPermissionsModel.get('perms'))});
	        this.renderMergeToPersonPermissions();
	    },
	
	    onHaveModelsChanges: function () {
	        var that = this;
	
	        if (_.isEqual(that.mergeToPersonModel.attributes, that.mergeToPersonModelOriginal.attributes)
	            && _.isEqual(that.mergeToPersonMedProfileModel.attributes, that.mergeToPersonMedProfileModelOriginal.attributes)
	            && _.isEqual(that.mergeToPersonDocumentsModel.attributes, that.mergeToPersonDocumentsModelOriginal.attributes)
	            && !that.hasPermissionsChanges()) {
	            that.disableButtons();
	        } else {
	            that.enableButtons();
	        }
	    },
	
	    saveConfirmed: function (data) {
	        if (data.result == true) {
	            this.callback();
	        }
	        else {
	            this.cancelConfirmationModal.hide();
	            this.saveConfirmationModal.hide();
	            this.saveAndDeleteConfirmationModal.hide();
	        }
	    },
	
	    enableButtons: function () {
	        this.ui.save.removeAttr('disabled');
	        this.ui.saveAndDelete.removeAttr('disabled');
	        this.ui.cancel.removeAttr('disabled');
	    },
	
	    disableButtons: function () {
	        this.ui.save.attr('disabled', true);
	        this.ui.saveAndDelete.attr('disabled', true);
	        this.ui.cancel.attr('disabled', true);
	    },
	
	    getMergeFromPersonId: function () {
	        return this.mergeFromPersonModel.get('id');
	    },
	
	    getMergeFromPersonName: function () {
	        return this.mergeFromPersonModel.get('name');
	    },
	
	    getMergeToPersonId: function () {
	        return this.mergeToPersonModel.get('id');
	    },
	
	    getMergeToPersonName: function () {
	        return this.mergeToPersonModel.get('name');
	    },
	
	    sortMedProfile: function (medProfile) {
	        medProfile.object.medications = _.sortBy(medProfile.object.medications, function (item) {
	            return item.groupUuid + item.medicationUuid;
	        });
	        medProfile.object.diseases = _.sortBy(medProfile.object.diseases, function (item) {
	            return item.uuid;
	        });
	        return medProfile;
	    },
	
	    sortPermissions: function (perms) {
	        //Backbone.Model({perms: perms})
	        return _.sortBy(perms, function (perm) {
	            return perm.id;
	        })
	    },
	
	    mergedPermissionsCount: function (permissions, permission) {
	        return (permissions || []).filter(function (p) {
	            var pWoId = _.omit(_.omit(p, 'id'), 'permittedObjectId');
	            var permissionWoId = _.omit(_.omit(permission, 'id'), 'permittedObjectId');
	            return _.isEqual(pWoId, permissionWoId);
	        });
	    },
	
	    hasPermissionsChanges: function() {
	        var that = this;
	        return (that.mergeToPersonPermissionsModelOriginal.attributes.perms || []).filter(function (item) {
	            return that.mergedPermissionsCount(that.mergeToPersonPermissionsModel.attributes.perms, item).length == 0;
	        }).length != 0
	        || (that.mergeToPersonPermissionsModel.attributes.perms || []).filter(function (item) {
	            return that.mergedPermissionsCount(that.mergeToPersonPermissionsModelOriginal.attributes.perms, item).length == 0;
	        }).length != 0
	    }
	
	});
	
	module.exports = MergePersonsDetailView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	
	
	var MergeFromPersonDemographicsView = Marionette.View.extend({
	    template: __webpack_require__(479),
	    modelEvents: {
	        change: 'render'
	    },
	
	    ui: {
	        merge: '.merge'
	    },
	
	    events: {
	        'click @ui.merge': 'onMerge'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var bd = that.model.get('object').birthData;
	        return {
	            birthData: (bd == '' || bd == null || bd == 0 ? '' : that.utils.longToDateTimeFormatted(Number(bd), 'MM/DD/YYYY')),
	            mergeFromPersonId: that.getOption('mergeFromPersonId'),
	            mergeFromPersonName: that.getOption('mergeFromPersonName'),
	            isHidden: function(field) {
	                return that.getOption('isBeingMerged')(field) ? 'hidden' : ''
	            },
	            isDeprecated: function(field) {
	                return that.getOption('isBeingMerged')(field) ? 'deprecated-header' : ''
	            }
	        }
	    },
	
	    initialize: function (options) {
	        this.model.on('change', this.render, this);
	        this.model = options.model;
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	    },
	
	    onMerge: function(event) {
	        this.triggerMethod('merge:person:demographics', event.target.id.replace('span.', ''));
	    }
	});
	
	module.exports = MergeFromPersonDemographicsView;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h4 class="center">Merge from <a href="/#person/'+
	((__t=( mergeFromPersonId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( mergeFromPersonName ))==null?'':__t)+
	'</a></h4>\r\n<div class="form-horizontal well">\r\n    <div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('npi') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="npi">NPI</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="npi" readonly value="'+
	((__t=( object.npi ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('npi') ))==null?'':__t)+
	'" id="span.npi"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('lastName') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="last-name">Last Name</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="last-name" readonly value="'+
	((__t=( object.lastName ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('lastName') ))==null?'':__t)+
	'" id="span.lastName"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('firstName') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="first-name">First Name</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="first-name" readonly value="'+
	((__t=( object.firstName ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('firstName') ))==null?'':__t)+
	'" id="span.firstName"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('middleName') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="middle-name">Middle Name</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="middle-name" readonly value="'+
	((__t=( object.middleName ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('middleName') ))==null?'':__t)+
	'" id="span.middleName"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('prefix') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="prefix">Prefix</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="prefix" readonly value="'+
	((__t=( object.prefix ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('prefix') ))==null?'':__t)+
	'" id="span.prefix"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('suffix') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="suffix">Suffix</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="suffix" readonly value="'+
	((__t=( object.suffix ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('suffix') ))==null?'':__t)+
	'" id="span.suffix"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('birthData') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="birth-date">Birth Date</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="birth-date" readonly value="'+
	((__t=( birthData ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('birthData') ))==null?'':__t)+
	'" id="span.birthData"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('gender') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="gender">Gender</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="gender" readonly value="'+
	((__t=( object.gender ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('gender') ))==null?'':__t)+
	'" id="span.gender"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('address') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="address">Address</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="address" readonly value="'+
	((__t=( object.address ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('address') ))==null?'':__t)+
	'" id="span.address"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('token') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="token">Token</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="token" readonly value="'+
	((__t=( object.token ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('token') ))==null?'':__t)+
	'" id="span.token"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('ssn') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="ssn">SSN</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="ssn" readonly value="'+
	((__t=( object.ssn ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('ssn') ))==null?'':__t)+
	'" id="span.ssn"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('insuranceId') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="insuranceId">Insurance id</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="insuranceId" readonly value="'+
	((__t=( object.insuranceId ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('insuranceId') ))==null?'':__t)+
	'" id="span.insuranceId"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('isMd') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="is-md">Is Provider</label>\r\n            <div class="checkbox col-sm-8 col-md-8">\r\n                <input type="checkbox" value="" onclick="return false;" id="is-md" style="margin-left: 10px;" ';
	 if (object && object.isMd) { 
	__p+='\r\n                checked ';
	 } 
	__p+=' >\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('isMd') ))==null?'':__t)+
	'" id="span.isMd"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('isPatient') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="is-patient">Is patient</label>\r\n            <div class="checkbox col-sm-8 col-md-8">\r\n                <input type="checkbox" value="" onclick="return false;" id="is-patient" style="margin-left: 10px;" ';
	 if (object &&
	                object.isPatient) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('isPatient') ))==null?'':__t)+
	'" id="span.isPatient"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group '+
	((__t=( isDeprecated('mergeable') ))==null?'':__t)+
	'">\r\n            <label class="col-sm-3 col-md-3 control-label" for="is-mergeable">Is mergeable</label>\r\n            <div class="checkbox col-sm-8 col-md-8">\r\n                <input type="checkbox" value="" onclick="return false;" id="is-mergeable" style="margin-left: 10px;" ';
	 if (object &&
	                object.mergeable) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden('mergeable') ))==null?'':__t)+
	'" id="span.mergeable"></span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	
	
	var MergeToPersonDemographicsView = Marionette.View.extend({
	    template: __webpack_require__(481),
	    modelEvents: {
	        change: 'render'
	    },
	
	    ui: {
	        birthDate: '#birth-date',
	        gender: '#gender',
	        restore: '.restore'
	    },
	
	    events: {
	        'click @ui.restore': 'onRestore',
	        'change input[type=text]': 'onInputChange',
	        'change input[type=checkbox]': 'onCheckboxChange',
	        'change @ui.gender': 'onInputChange'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var bd = that.model.get('object').birthData;
	        return {
	            birthData: (bd == '' || bd == null || bd == 0 ? '' : that.utils.longToDateTimeFormatted(Number(bd), 'MM/DD/YYYY')),
	            mergeToPersonId: that.getOption('mergeToPersonId'),
	            mergeToPersonName: that.getOption('mergeToPersonName'),
	            isHidden: function(field) {
	                return that.getOption('isBeingMerged')(field) ? '' : 'hidden'
	            }
	        }
	    },
	
	    initialize: function (options) {
	        this.model.on('change', this.render, this);
	        this.model = options.model;
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	
	        this.ui.birthDate.datepicker({
	            format: 'mm/dd/yyyy',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	        });
	
	        var genderSelectize = this.ui.gender.selectize({
	            allowEmptyOption: false
	        });
	    },
	
	    onRestore: function(event) {
	        this.triggerMethod('restore:person:demographics', event.target.id.replace('span.', ''));
	    },
	
	    onInputChange: function(event) {
	        this.triggerMethod('edit:person:demographics', {
	            fieldName: event.target.id,
	            value: event.target.value
	        });
	    },
	
	    onCheckboxChange: function(event) {
	        this.triggerMethod('edit:person:demographics', {
	            fieldName: event.target.id,
	            value: event.target.checked
	        });
	    }
	});
	
	module.exports = MergeToPersonDemographicsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h4 class="center">Merge to <a href="/#person/'+
	((__t=( mergeToPersonId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( mergeToPersonName ))==null?'':__t)+
	'</a></h4>\r\n<div class="form-horizontal well">\r\n    <div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="npi">NPI</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="npi" value="'+
	((__t=( object.npi ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('npi') ))==null?'':__t)+
	'" id="span.npi"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="lastName">Last Name</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="lastName" value="'+
	((__t=( object.lastName ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('lastName') ))==null?'':__t)+
	'" id="span.lastName"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="firstName">First Name</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="firstName" value="'+
	((__t=( object.firstName ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('firstName') ))==null?'':__t)+
	'" id="span.firstName"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="middleName">Middle Name</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="middleName" value="'+
	((__t=( object.middleName ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('middleName') ))==null?'':__t)+
	'" id="span.middleName"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="prefix">Prefix</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="prefix" value="'+
	((__t=( object.prefix ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('prefix') ))==null?'':__t)+
	'" id="span.prefix"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="suffix">Suffix</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="suffix" value="'+
	((__t=( object.suffix ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('suffix') ))==null?'':__t)+
	'" id="span.suffix"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="birthData">Birth Date</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="birthData" value="'+
	((__t=( birthData ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('birthData') ))==null?'':__t)+
	'" id="span.birthData"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="gender">Gender</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <select id="gender">\r\n                    <option value=""></option>\r\n                    ';
	 _.each(["M", "F", "NA"], function(gender){ 
	__p+='\r\n                    <option value="'+
	((__t=( gender ))==null?'':__t)+
	'" name="'+
	((__t=( gender ))==null?'':__t)+
	'"\r\n                    ';
	 if (gender == object.gender){
	__p+=' selected ';
	}
	__p+=' > '+
	((__t=( gender ))==null?'':__t)+
	'</option>\r\n                    ';
	 }) 
	__p+='\r\n                </select>\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('gender') ))==null?'':__t)+
	'" id="span.gender"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="address">Address</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="address" value="'+
	((__t=( object.address ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('address') ))==null?'':__t)+
	'" id="span.address"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="token">Token</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="token" value="'+
	((__t=( object.token ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('token') ))==null?'':__t)+
	'" id="span.token"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="ssn">SSN</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="ssn" value="'+
	((__t=( object.ssn ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('ssn') ))==null?'':__t)+
	'" id="span.ssn"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="insuranceId">Insurance id</label>\r\n            <div class="col-sm-8 col-md-8">\r\n                <input class="form-control" type="text" id="insuranceId" value="'+
	((__t=( object.insuranceId ))==null?'':_.escape(__t))+
	'">\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('insuranceId') ))==null?'':__t)+
	'" id="span.insuranceId"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="isMd">Is Provider</label>\r\n            <div class="checkbox col-sm-8 col-md-8">\r\n                <input type="checkbox" value="" id="isMd" style="margin-left: 10px;" ';
	 if (object && object.isMd) { 
	__p+='\r\n                checked ';
	 } 
	__p+=' >\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('isMd') ))==null?'':__t)+
	'" id="span.isMd"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="isPatient">Is patient</label>\r\n            <div class="checkbox col-sm-8 col-md-8">\r\n                <input type="checkbox" value="" id="isPatient" style="margin-left: 10px;" ';
	 if (object &&
	                object.isPatient) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('isPatient') ))==null?'':__t)+
	'" id="span.isPatient"></span>\r\n            </div>\r\n        </div>\r\n        <div class="form-group">\r\n            <label class="col-sm-3 col-md-3 control-label" for="mergeable">Is mergeable</label>\r\n            <div class="checkbox col-sm-8 col-md-8">\r\n                <input type="checkbox" value="" id="mergeable" style="margin-left: 10px;" ';
	 if (object &&
	                object.mergeable) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n            </div>\r\n            <div class="col-sm-1 col-md-1">\r\n                <span class="control-label glyphicon glyphicon-remove-circle clickable restore '+
	((__t=( isHidden('mergeable') ))==null?'':__t)+
	'" id="span.mergeable"></span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(180);
	
	var MergeFromPersonContactsView = Marionette.View.extend({
	    template: __webpack_require__(483),
	
	    ui: {
	        merge: '.merge'
	    },
	
	    events: {
	        'click @ui.merge': 'onRowMerge'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            contacts: that.model.get('object').contacts || [],
	            getStringified: function(contact) {
	                return contact.type + that.delimeter + contact.data + that.delimeter + contact.preferred;
	            },
	            mergeFromPersonId: that.getOption('mergeFromPersonId'),
	            mergeFromPersonName: that.getOption('mergeFromPersonName'),
	            isHidden: function(contact) {
	                return that.getOption('isBeingMerged')(contact) ? 'hidden' : ''
	            },
	            isDeprecated: function(contact) {
	                return that.getOption('isBeingMerged')(contact) ? 'deprecated-header' : ''
	            }
	        }
	    },
	
	    initialize: function (options) {
	        this.model = options.model;
	        this.delimeter = '~~~';
	    },
	
	    onRender: function () {
	    },
	
	    onRowMerge: function(event) {
	        var stringified = event.target.id;
	        var index = event.target.parentElement.id;
	        var contact = stringified.split(this.delimeter);
	
	        this.triggerMethod('merge:person:contacts:row', {
	            contact: {
	                type: contact[0],
	                data: contact[1],
	                preferred: JSON.parse(contact[2])
	            },
	            insertedIndex: index
	        });
	    }
	});
	
	module.exports = MergeFromPersonContactsView;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h4 class="center">Merge from <a href="/#person/'+
	((__t=( mergeFromPersonId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( mergeFromPersonName ))==null?'':__t)+
	'</a></h4>\r\n\r\n<table class="table table-hover well">\r\n    <thead>\r\n    <tr>\r\n        <th>Contact type</th>\r\n        <th>Contact data</th>\r\n        <th>Is preferred</th>\r\n        <th></th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    ';
	 _.each(contacts, function(contact, index){ 
	__p+='\r\n    <tr class="'+
	((__t=( isDeprecated(contact) ))==null?'':__t)+
	'">\r\n        <td>'+
	((__t=( contact.type ))==null?'':__t)+
	'</td>\r\n        <td>'+
	((__t=( contact.data ))==null?'':__t)+
	'</td>\r\n        <td>\r\n            <input type="checkbox" value="" onclick="return false;" ';
	 if (contact.preferred) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n        </td>\r\n        <td id="'+
	((__t=( index ))==null?'':__t)+
	'"><span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden(contact) ))==null?'':__t)+
	'" id="'+
	((__t=( getStringified(contact) ))==null?'':__t)+
	'" title="Add"></span></td>\r\n    </tr>\r\n    ';
	 }) 
	__p+='\r\n    </tbody>\r\n</table>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var MergeToPersonContactsView = Marionette.View.extend({
	    template: __webpack_require__(485),
	
	    ui: {
	        remove: '.remove'
	    },
	
	    events: {
	        'click @ui.remove': 'onRemoveRow'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            contacts: that.model.get('object').contacts || [],
	            getStringified: function(contact) {
	                return contact.type + that.delimeter + contact.data + that.delimeter + contact.preferred;
	            },
	            isMergedContact: function(ctct) {
	                return (that.modelCopyAsOriginal.get('object').contacts || []).filter(function(contact) {
	                   return _.isEqual(contact, ctct);
	                }).length == 0;
	            },
	            mergeToPersonId: that.getOption('mergeToPersonId'),
	            mergeToPersonName: that.getOption('mergeToPersonName')
	        }
	    },
	
	    initialize: function (options) {
	        this.model = options.model;
	        this.modelCopyAsOriginal = options.modelCopyAsOriginal;
	        this.delimeter = '~~~';
	    },
	
	    onRender: function () {
	    },
	
	    onRemoveRow: function(event) {
	        var stringified = event.target.id;
	        var contact = stringified.split(this.delimeter);
	
	        this.triggerMethod('remove:person:contacts:row', {
	            type: contact[0],
	            data: contact[1],
	            preferred: JSON.parse(contact[2])
	        });
	    }
	});
	
	module.exports = MergeToPersonContactsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h4 class="center">Merge to <a href="/#person/'+
	((__t=( mergeToPersonId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( mergeToPersonName ))==null?'':__t)+
	'</a></h4>\r\n\r\n<table class="table table-hover well">\r\n    <thead>\r\n    <tr>\r\n        <th>Contact type</th>\r\n        <th>Contact data</th>\r\n        <th>Is preferred</th>\r\n        <th></th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    ';
	 _.each(contacts, function(contact){ 
	__p+='\r\n\r\n        ';
	 if (isMergedContact(contact)) { 
	__p+='\r\n            <tr>\r\n                <td>'+
	((__t=( contact.type ))==null?'':__t)+
	'</td>\r\n                <td>'+
	((__t=( contact.data ))==null?'':__t)+
	'</td>\r\n                <td>\r\n                    <input type="checkbox" value="" onclick="return false;" ';
	 if (contact.preferred) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n                </td>\r\n                <td><span class="control-label glyphicon glyphicon-remove-circle clickable remove" id="'+
	((__t=( getStringified(contact) ))==null?'':__t)+
	'" title="Remove"></span></td>\r\n            </tr>\r\n        ';
	 } else { 
	__p+='\r\n            <tr class="deprecated-header">\r\n                <td>'+
	((__t=( contact.type ))==null?'':__t)+
	'</td>\r\n                <td>'+
	((__t=( contact.data ))==null?'':__t)+
	'</td>\r\n                <td>\r\n                    <input type="checkbox" value="" onclick="return false;" ';
	 if (contact.preferred) { 
	__p+=' checked ';
	 } 
	__p+=' >\r\n                </td>\r\n            </tr>\r\n        ';
	 } 
	__p+='\r\n\r\n    ';
	 }) 
	__p+='\r\n    </tbody>\r\n</table>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	var OkDialogModal = __webpack_require__(332);
	var Dicts = __webpack_require__(193);
	
	var ExacerbationsView = __webpack_require__(358);
	
	var MergeFromPersonDiseasesView = Marionette.View.extend({
	    template: __webpack_require__(487),
	
	    regions: {
	        exacerbationsShowRegion: '#exacerbation-show',
	        comment: '#comment-content'
	    },
	
	    ui: {
	        merge: '.merge',
	        showExacs: '.show-exacs',
	        showComment: '.show-comment',
	        exacerbationShowModal: '#exacerbation-show-modal'
	    },
	
	    events: {
	        'click @ui.merge': 'onRowMerge',
	        'click @ui.showExacs': 'onShowExacs',
	        'click @ui.showComment': 'onShowComment'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            diseases: that.model.get('object').diseases || [],
	            mergeFromPersonId: that.getOption('mergeFromPersonId'),
	            mergeFromPersonName: that.getOption('mergeFromPersonName'),
	            formatDate: function(dt) {
	                return (dt == '' || dt == null || dt == 0 ? '' : that.utils.longToDateTimeFormatted(Number(dt), 'MM/DD/YYYY'));
	            },
	            isHidden: function(disease) {
	                return that.getOption('isBeingMerged')(disease) ? 'hidden' : ''
	            },
	            isDeprecated: function(disease) {
	                return that.getOption('isBeingMerged')(disease) ? 'deprecated-header' : ''
	            },
	            getTypeOfIdName: function(typeOfId) {
	                return Dicts.hl7Dict[typeOfId] || typeOfId;
	            }
	        }
	    },
	
	    initialize: function (options) {
	        this.model = options.model;
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	
	        this.exacerbationsView = new ExacerbationsView({
	            exacerbations: [],
	            isReadOnly: true
	        });
	        this.showChildView('exacerbationsShowRegion', this.exacerbationsView);
	    },
	
	    onRowMerge: function(event) {
	        var uuid = event.target.id;
	        var index = event.target.parentElement.id;
	        var disease = _.findWhere(this.model.get('object').diseases, {uuid: uuid});
	
	        this.triggerMethod('merge:person:diseases:row', {
	            disease: disease,
	            insertedIndex: index
	        });
	    },
	
	    onShowExacs: function(event) {
	        var disease = _.findWhere(this.model.get('object').diseases, {uuid: event.target.id.replace('_', '')});
	        this.exacerbationsView.resetCollection(disease.exacerbations || []);
	        this.ui.exacerbationShowModal.modal('show');
	    },
	
	    onShowComment: function(event) {
	        var disease = _.findWhere(this.model.get('object').diseases, {uuid: event.target.id.replace('__', '')});
	
	        this.commentView = new OkDialogModal({
	            title: 'Comment',
	            message: disease.comment
	        });
	
	        this.showChildView('comment', this.commentView);
	        this.commentView.show();
	    }
	});
	
	module.exports = MergeFromPersonDiseasesView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h4 class="center">Merge from <a href="/#person/'+
	((__t=( mergeFromPersonId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( mergeFromPersonName ))==null?'':__t)+
	'</a></h4>\r\n\r\n<table class="table table-hover well">\r\n    <thead>\r\n    <tr>\r\n        <th>Type</th>\r\n        <th>Code</th>\r\n        <th>Name</th>\r\n        <th>Start date</th>\r\n        <th>Stop date</th>\r\n        <th>Comment</th>\r\n        <th title="Exacerbations">Exac.</th>\r\n        <th></th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    ';
	 _.each(diseases, function(disease, index) { 
	__p+='\r\n    <tr class="'+
	((__t=( isDeprecated(disease) ))==null?'':__t)+
	'">\r\n        <td>'+
	((__t=( getTypeOfIdName(disease.typeOfId) ))==null?'':__t)+
	'</td>\r\n        <td>'+
	((__t=( disease.diseaseId ))==null?'':__t)+
	'</td>\r\n        <td>'+
	((__t=( disease.name ))==null?'':__t)+
	'</td>\r\n        <td>'+
	((__t=( formatDate(disease.startDate) ))==null?'':__t)+
	'</td>\r\n        <td>'+
	((__t=( formatDate(disease.stopDate) ))==null?'':__t)+
	'</td>\r\n        <td class="center"><span class="clickable center show-comment" id="'+
	((__t=( disease.uuid + '__' ))==null?'':__t)+
	'" title="Show comment">...</span></td>\r\n        <td class="center"><span class="clickable center show-exacs" id="'+
	((__t=( disease.uuid + '_' ))==null?'':__t)+
	'" title="Show exacerbations">...</span></td>\r\n        <td id="'+
	((__t=( index ))==null?'':__t)+
	'"><span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden(disease) ))==null?'':__t)+
	'" id="'+
	((__t=( disease.uuid ))==null?'':__t)+
	'" title="Add"></span></td>\r\n    </tr>\r\n    ';
	 }) 
	__p+='\r\n    </tbody>\r\n</table>\r\n\r\n<!-- Exacerbation show modal -->\r\n<div class="modal fade" id="exacerbation-show-modal" tabindex="-1" role="dialog">\r\n    <div class="modal-dialog">\r\n\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal">&times;</button>\r\n                <h4 class="modal-title">Exacerbations</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <div id="exacerbation-show"></div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" id="close" data-dismiss="modal">Close</button>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n\r\n<div id="comment-content"></div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	var Dicts = __webpack_require__(193);
	
	var OkDialogModal = __webpack_require__(332);
	var ExacerbationsView = __webpack_require__(358);
	
	var MergeToPersonDiseasesView = Marionette.View.extend({
	    template: __webpack_require__(489),
	
	    regions: {
	        exacerbationsShowRegion: '#exacerbation-show',
	        comment: '#comment-content'
	    },
	
	    ui: {
	        remove: '.remove',
	        showExacs: '.show-exacs',
	        showComment: '.show-comment',
	        exacerbationShowModal: '#exacerbation-show-modal'
	    },
	
	    events: {
	        'click @ui.remove': 'onRemoveRow',
	        'click @ui.showExacs': 'onShowExacs',
	        'click @ui.showComment': 'onShowComment'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            diseases: that.model.get('object').diseases || [],
	            isMergedDisease: function(d) {
	                return (that.modelCopyAsOriginal.get('object').diseases || []).filter(function(disease) {
	                        return _.isEqual(disease, d);
	                    }).length == 0;
	            },
	            mergeToPersonId: that.getOption('mergeToPersonId'),
	            mergeToPersonName: that.getOption('mergeToPersonName'),
	            formatDate: function(dt) {
	                return (dt == '' || dt == null || dt == 0 ? '' : that.utils.longToDateTimeFormatted(Number(dt), 'MM/DD/YYYY'));
	            },
	            getTypeOfIdName: function(typeOfId) {
	                return Dicts.hl7Dict[typeOfId] || typeOfId;
	            }
	        }
	    },
	
	    initialize: function (options) {
	        this.model = options.model;
	        this.modelCopyAsOriginal = options.modelCopyAsOriginal;
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	        this.exacerbationsView = new ExacerbationsView({
	            exacerbations: [],
	            isReadOnly: true
	        });
	        this.showChildView('exacerbationsShowRegion', this.exacerbationsView);
	    },
	
	    onRemoveRow: function(event) {
	        var uuid = event.target.id;
	        var disease = _.findWhere(this.model.get('object').diseases, {uuid: uuid});
	        this.triggerMethod('remove:person:diseases:row', disease);
	    },
	
	    onShowExacs: function(event) {
	        console.log(event.target.id.replace('_', ''));
	        var disease = _.findWhere(this.model.get('object').diseases, {uuid: event.target.id.replace('_', '')});
	        this.exacerbationsView.resetCollection(disease.exacerbations || []);
	        this.ui.exacerbationShowModal.modal('show');
	    },
	
	    onShowComment: function(event) {
	        var disease = _.findWhere(this.model.get('object').diseases, {uuid: event.target.id.replace('__', '')});
	
	        this.commentView = new OkDialogModal({
	            title: 'Comment',
	            message: disease.comment
	        });
	
	        this.showChildView('comment', this.commentView);
	        this.commentView.show();
	    }
	});
	
	module.exports = MergeToPersonDiseasesView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h4 class="center">Merge to <a href="/#person/'+
	((__t=( mergeToPersonId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( mergeToPersonName ))==null?'':__t)+
	'</a></h4>\r\n\r\n<table class="table table-hover well">\r\n    <thead>\r\n    <tr>\r\n        <th>Type</th>\r\n        <th>Code</th>\r\n        <th>Name</th>\r\n        <th>Start date</th>\r\n        <th>Stop date</th>\r\n        <th>Comment</th>\r\n        <th title="Exacerbations">Exac.</th>\r\n        <th></th>\r\n    </tr>\r\n    </thead>\r\n    <tbody>\r\n    ';
	 _.each(diseases, function(disease, index) { 
	__p+='\r\n\r\n    <tr ';
	 if (!isMergedDisease(disease)) { 
	__p+=' class="deprecated-header" ';
	 } 
	__p+=' >\r\n        <td>'+
	((__t=( getTypeOfIdName(disease.typeOfId) ))==null?'':__t)+
	'</td>\r\n        <td>'+
	((__t=( disease.diseaseId ))==null?'':__t)+
	'</td>\r\n        <td>'+
	((__t=( disease.name ))==null?'':__t)+
	'</td>\r\n        <td>'+
	((__t=( formatDate(disease.startDate) ))==null?'':__t)+
	'</td>\r\n        <td>'+
	((__t=( formatDate(disease.stopDate) ))==null?'':__t)+
	'</td>\r\n        <td class="center"><span class="clickable center show-comment" id="'+
	((__t=( disease.uuid + '__' ))==null?'':__t)+
	'" title="Show comment">...</span></td>\r\n        <td class="center"><span class="clickable center show-exacs" id="'+
	((__t=( disease.uuid + '_' ))==null?'':__t)+
	'" title="Show exacerbations">...</span></td>\r\n        <td><span class="control-label glyphicon glyphicon-remove-circle clickable remove" id="'+
	((__t=( disease.uuid ))==null?'':__t)+
	'" title="Remove"></span></td>\r\n    </tr>\r\n\r\n    ';
	 }) 
	__p+='\r\n    </tbody>\r\n</table>\r\n\r\n<!-- Exacerbation show modal -->\r\n<div class="modal fade" id="exacerbation-show-modal" tabindex="-1" role="dialog">\r\n    <div class="modal-dialog">\r\n\r\n        <div class="modal-content">\r\n            <div class="modal-header">\r\n                <button type="button" class="close" data-dismiss="modal">&times;</button>\r\n                <h4 class="modal-title">Exacerbations</h4>\r\n            </div>\r\n            <div class="modal-body">\r\n                <div id="exacerbation-show"></div>\r\n            </div>\r\n            <div class="modal-footer">\r\n                <button type="button" class="btn btn-default" id="close" data-dismiss="modal">Close</button>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n\r\n<div id="comment-content"></div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	var OkDialogModal = __webpack_require__(332);
	var Dicts = __webpack_require__(193);
	
	var MergeFromPersonMedicationsView = Marionette.View.extend({
	    template: __webpack_require__(491),
	
	    regions: {
	    },
	
	    ui: {
	        merge: '.merge'
	    },
	
	    events: {
	        'click @ui.merge': 'onRowMerge'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            medications: that.model.get('object').medications || [],
	            mergeFromPersonId: that.getOption('mergeFromPersonId'),
	            mergeFromPersonName: that.getOption('mergeFromPersonName'),
	            formatDate: function(dt) {
	                return (dt == '' || dt == null || dt == 0 ? '' : that.utils.longToDateTimeFormatted(Number(dt), 'MM/DD/YYYY'));
	            },
	            isHidden: function(medication) {
	                return that.getOption('isBeingMerged')(medication) ? 'hidden' : ''
	            },
	            isDeprecated: function(medication) {
	                return that.getOption('isBeingMerged')(medication) ? 'deprecated-header' : ''
	            },
	            getSystemTypeName: function(systemType) {
	                return Dicts.hl7Dict[systemType] || systemType;
	            }
	        }
	    },
	
	    initialize: function (options) {
	        this.model = options.model;
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	    },
	
	    onRowMerge: function(event) {
	        var uuid = event.target.id;
	        var index = event.target.parentElement.id;
	        var medication = _.findWhere(this.model.get('object').medications, {medicationUuid: uuid});
	
	        this.triggerMethod('merge:person:medications:row', {
	            medication: medication,
	            insertedIndex: index
	        });
	    }
	});
	
	module.exports = MergeFromPersonMedicationsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h4 class="center">Merge from <a href="/#person/'+
	((__t=( mergeFromPersonId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( mergeFromPersonName ))==null?'':__t)+
	'</a></h4>\r\n\r\n<div class="table-responsive well" style="font-size: 10px;">\r\n    <table class="table table-hover">\r\n        <thead>\r\n        <tr>\r\n            <th>System type</th>\r\n            <th>Name</th>\r\n            <th>Event</th>\r\n            <!--<th title="Diseases">Diseases</th>\r\n            <th>Form</th>-->\r\n            <th>Dose</th>\r\n            <th>Quant.</th>\r\n            <th>Freq.</th>\r\n            <th>Start date</th>\r\n            <th>Stop date</th>\r\n            <!--<th title="Documents">Docs</th>\r\n            <th>Comment</th>-->\r\n            <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        ';
	 _.each(medications, function(medication, index) { 
	__p+='\r\n        <tr class="'+
	((__t=( isDeprecated(medication) ))==null?'':__t)+
	'">\r\n            <td>'+
	((__t=( getSystemTypeName(medication.systemType) ))==null?'':__t)+
	'</td>\r\n            <td>'+
	((__t=( medication.name ))==null?'':__t)+
	'</td>\r\n            <td>'+
	((__t=( (medication.eventType || '').replace('_', ' ') ))==null?'':__t)+
	'</td>\r\n            <!--<td class="center"><span class="clickable center show-diseases" id="'+
	((__t=( medication.medicationUuid + '_diseases' ))==null?'':__t)+
	'" title="Show diseases">...</span></td>\r\n            <td>'+
	((__t=( medication.form ))==null?'':__t)+
	'</td>-->\r\n            <td>'+
	((__t=( medication.dose ))==null?'':__t)+
	'</td>\r\n            <td>'+
	((__t=( medication.quantity ))==null?'':__t)+
	'</td>\r\n            <td title="'+
	((__t=( ((medication.frequency || [])[0] || {}).systemId + '-' + ((medication.frequency || [])[0] || {}).code ))==null?'':__t)+
	'">\r\n                '+
	((__t=( ((medication.frequency || [])[0] || {}).title ))==null?'':__t)+
	'\r\n            </td>\r\n            <td>'+
	((__t=( formatDate(medication.startDate) ))==null?'':__t)+
	'</td>\r\n            <td>'+
	((__t=( formatDate(medication.stopDate) ))==null?'':__t)+
	'</td>\r\n            <!--<td class="center"><span class="clickable center show-docs" id="'+
	((__t=( medication.medicationUuid + '_docs' ))==null?'':__t)+
	'" title="Show documents">...</span></td>\r\n            <td class="center"><span class="clickable center show-comment" id="'+
	((__t=( medication.medicationUuid + '__' ))==null?'':__t)+
	'" title="Show comment">...</span></td>-->\r\n            <td id="'+
	((__t=( index ))==null?'':__t)+
	'"><span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden(medication) ))==null?'':__t)+
	'" id="'+
	((__t=( medication.medicationUuid ))==null?'':__t)+
	'" title="Add"></span></td>\r\n        </tr>\r\n        ';
	 }) 
	__p+='\r\n        </tbody>\r\n    </table>\r\n</div>\r\n\r\n<div id="inner-show"></div>';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	
	var OkDialogModal = __webpack_require__(332);
	var Dicts = __webpack_require__(193);
	
	var MergeToPersonMedicationsView = Marionette.View.extend({
	    template: __webpack_require__(493),
	
	    regions: {
	    },
	
	    ui: {
	        remove: '.remove'
	    },
	
	    events: {
	        'click @ui.remove': 'onRemoveRow'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            medications: that.model.get('object').medications || [],
	            isMergedMedication: function(m) {
	                return (that.modelCopyAsOriginal.get('object').medications || []).filter(function(medication) {
	                        return _.isEqual(medication, m);
	                    }).length == 0;
	            },
	            mergeToPersonId: that.getOption('mergeToPersonId'),
	            mergeToPersonName: that.getOption('mergeToPersonName'),
	            formatDate: function(dt) {
	                return (dt == '' || dt == null || dt == 0 ? '' : that.utils.longToDateTimeFormatted(Number(dt), 'MM/DD/YYYY'));
	            },
	            getSystemTypeName: function(systemType) {
	                return Dicts.hl7Dict[systemType] || systemType;
	            }
	        }
	    },
	
	    initialize: function (options) {
	        this.model = options.model;
	        this.modelCopyAsOriginal = options.modelCopyAsOriginal;
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	    },
	
	    onRemoveRow: function(event) {
	        var uuid = event.target.id;
	        var medication = _.findWhere(this.model.get('object').medications, {medicationUuid: uuid});
	        this.triggerMethod('remove:person:medications:row', medication);
	    }
	});
	
	module.exports = MergeToPersonMedicationsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h4 class="center">Merge to <a href="/#person/'+
	((__t=( mergeToPersonId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( mergeToPersonName ))==null?'':__t)+
	'</a></h4>\r\n\r\n\r\n<div class="table-responsive well" style="font-size: 10px;">\r\n    <table class="table table-hover">\r\n        <thead>\r\n        <tr>\r\n            <th>System type</th>\r\n            <th>Name</th>\r\n            <th>Event</th>\r\n            <!--<th title="Diseases">Diseases</th>\r\n            <th>Form</th>-->\r\n            <th>Dose</th>\r\n            <th>Quant.</th>\r\n            <th>Freq.</th>\r\n            <th>Start date</th>\r\n            <th>Stop date</th>\r\n            <!--<th title="Documents">Docs</th>\r\n            <th>Comment</th>-->\r\n            <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        ';
	 _.each(medications, function(medication, index) { 
	__p+='\r\n\r\n        <tr ';
	 if (!isMergedMedication(medication)) { 
	__p+=' class="deprecated-header" ';
	 } 
	__p+=' >\r\n            <td>'+
	((__t=( getSystemTypeName(medication.systemType) ))==null?'':__t)+
	'</td>\r\n            <td>'+
	((__t=( medication.name ))==null?'':__t)+
	'</td>\r\n            <td>'+
	((__t=( (medication.eventType || '').replace('_', ' ') ))==null?'':__t)+
	'</td>\r\n            <!--<td class="center"><span class="clickable center show-diseases" id="'+
	((__t=( medication.medicationUuid + '_diseases' ))==null?'':__t)+
	'" title="Show diseases">...</span></td>\r\n            <td>'+
	((__t=( medication.form ))==null?'':__t)+
	'</td>-->\r\n            <td>'+
	((__t=( medication.dose ))==null?'':__t)+
	'</td>\r\n            <td>'+
	((__t=( medication.quantity ))==null?'':__t)+
	'</td>\r\n            <td>'+
	((__t=( medication.frequency ))==null?'':__t)+
	'</td>\r\n            <td>'+
	((__t=( formatDate(medication.startDate) ))==null?'':__t)+
	'</td>\r\n            <td>'+
	((__t=( formatDate(medication.stopDate) ))==null?'':__t)+
	'</td>\r\n            <!--<td class="center"><span class="clickable center show-docs" id="'+
	((__t=( medication.medicationUuid + '_docs' ))==null?'':__t)+
	'" title="Show documents">...</span></td>\r\n            <td class="center"><span class="clickable center show-comment" id="'+
	((__t=( medication.medicationUuid + '__' ))==null?'':__t)+
	'" title="Show comment">...</span></td>-->\r\n            <td><span class="control-label glyphicon glyphicon-remove-circle clickable remove" id="'+
	((__t=( medication.medicationUuid ))==null?'':__t)+
	'" title="Remove"></span></td>\r\n        </tr>\r\n\r\n        ';
	 }) 
	__p+='\r\n        </tbody>\r\n    </table>\r\n</div>\r\n\r\n<div id="inner-show"></div>\r\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	
	
	var MergePersonDocumentsView = Marionette.View.extend({
	    template: __webpack_require__(495),
	
	    regions: {
	    },
	
	    ui: {
	        merge: '.merge',
	        remove: '.remove'
	    },
	
	    events: {
	        'click @ui.merge': 'onRowMerge',
	        'click @ui.remove': 'onRowRemove'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var mode = that.getOption('mode');
	        return {
	            mode: mode,
	            personId: that.getOption('personId'),
	            personName: that.getOption('personName'),
	            documents: mode == 'from' ? that.getOption('mergeFromPersonDocumentsModel').get('documents') : that.getOption('mergeToPersonDocumentsModel').get('documents'),
	            isMergedDocument: that.isMergedDocument,
	            formatDate: function(dt) {
	                return (dt == '' || dt == null || dt == 0 ? '' : that.utils.longToDateTimeFormatted(Number(dt), 'MM/DD/YYYY'));
	            }
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRowMerge', 'onRowRemove', 'triggerUp', 'isMergedDocument');
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	    },
	
	    onRowMerge: function(event) {
	        this.triggerUp('merge:person:documents:row', event, this.getOption('mergeFromPersonDocumentsModel').get('documents'), false);
	    },
	
	    onRowRemove: function(event) {
	        this.triggerUp('remove:person:documents:row', event, this.getOption('mergeToPersonDocumentsModel').get('documents'), this.isMergedDocument);
	    },
	
	    triggerUp: function(action, event, documents, onlyRemove) {
	        var id = event.target.id;
	        var index = event.target.parentElement.id;
	        var document = _.findWhere(documents, {id: id});
	        this.triggerMethod(action, {
	            document: document,
	            insertedIndex: index,
	            onlyRemove: _.isFunction(onlyRemove) ? !onlyRemove(document) : onlyRemove
	        });
	
	    },
	
	    isMergedDocument: function(d) {
	        var that = this;
	        return (that.getOption('mergeToPersonDocumentsModelOriginal').get('documents') || []).filter(function(document) {
	                return _.isEqual(document, d);
	            }).length == 0;
	    }
	});
	
	module.exports = MergePersonDocumentsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h4 class="center">Merge '+
	((__t=( mode ))==null?'':__t)+
	' <a href="/#person/'+
	((__t=( personId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( personName ))==null?'':__t)+
	'</a></h4>\r\n\r\n<div class="table-responsive well">\r\n    <table class="table table-hover">\r\n        <thead>\r\n        <tr>\r\n            <th>Name</th>\r\n            <th>Created date</th>\r\n            <th>Download</th>\r\n            <th>View</th>\r\n            <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        ';
	 _.each(documents, function(document, index) { 
	__p+='\r\n        <tr ';
	 if (mode == 'to' && !isMergedDocument(document)) { 
	__p+=' class="deprecated-header" ';
	 } 
	__p+=' >\r\n        <td><a href="/#document/'+
	((__t=( document.id ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( document.name ))==null?'':__t)+
	'</a></td>\r\n        <td>'+
	((__t=( formatDate(document.createdTime) ))==null?'':__t)+
	'</td>\r\n        <td>\r\n            <a href="/api/document/download/'+
	((__t=( document.id ))==null?'':__t)+
	'" class="preview-doc"><span class="clickable glyphicon glyphicon-floppy-disk"/></a>\r\n        </td>\r\n        <td>\r\n            <a href="/api/document/view/'+
	((__t=( document.id ))==null?'':__t)+
	'" target="_blank" class="preview-doc"><span class="clickable glyphicon glyphicon-eye-open"/></a>\r\n        </td>\r\n        ';
	 if (mode == 'from') { 
	__p+='\r\n        <td id="'+
	((__t=( index ))==null?'':__t)+
	'"><span class="control-label glyphicon glyphicon-arrow-right clickable merge" id="'+
	((__t=( document.id ))==null?'':__t)+
	'" title="Add"></span></td>\r\n        ';
	 } 
	__p+='\r\n        ';
	 if (mode == 'to') { 
	__p+='\r\n        <td id="'+
	((__t=( index ))==null?'':__t)+
	'"><span class="control-label glyphicon glyphicon-remove-circle clickable remove" id="'+
	((__t=( document.id ))==null?'':__t)+
	'" title="Remove"></span></td>\r\n        ';
	 } 
	__p+='\r\n        </tr>\r\n        ';
	 }) 
	__p+='\r\n        </tbody>\r\n    </table>\r\n</div>\r\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(180);
	
	var CommonUtils = __webpack_require__(189);
	
	
	var MergePersonPermissionsView = Marionette.View.extend({
	    template: __webpack_require__(497),
	
	    regions: {
	    },
	
	    ui: {
	        merge: '.merge',
	        remove: '.remove'
	    },
	
	    events: {
	        'click @ui.merge': 'onRowMerge',
	        'click @ui.remove': 'onRowRemove'
	    },
	
	    templateContext: function () {
	        var that = this;
	        var mode = that.getOption('mode');
	        return {
	            mode: mode,
	            personId: that.getOption('personId'),
	            personName: that.getOption('personName'),
	            permissions: mode == 'from' ? that.getOption('mergeFromPersonPermissionsModel').get('perms') : that.getOption('mergeToPersonPermissionsModel').get('perms'),
	            isMergedPermission: that.isMergedPermission,
	            isDeprecated: function(permission) {
	                return that.getOption('isBeingMerged') ? (that.getOption('isBeingMerged')(permission) ? 'deprecated-header' : '') : ''
	            },
	            isHidden: function(permission) {
	                return that.getOption('isBeingMerged') ? (that.getOption('isBeingMerged')(permission) ? 'hidden' : '') : ''
	            },
	            formatPerson: that.utils.formatPerson
	        }
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'onRowMerge', 'onRowRemove', 'triggerUp', 'isMergedPermission');
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	    },
	
	    onRowMerge: function(event) {
	        this.triggerUp('merge:person:permissions:row', event, this.getOption('mergeFromPersonPermissionsModel').get('perms'));
	    },
	
	    onRowRemove: function(event) {
	        this.triggerUp('remove:person:permissions:row', event, this.getOption('mergeToPersonPermissionsModel').get('perms'));
	    },
	
	    triggerUp: function(action, event, permissions) {
	        var id = event.target.id;
	        var index = event.target.parentElement.id;
	        var permission = _.findWhere(permissions, {id: id});
	        this.triggerMethod(action, {
	            permission: permission,
	            insertedIndex: index
	        });
	
	    },
	
	    isMergedPermission: function(p) {
	        var that = this;
	        if (that.getOption('mergedPermissionsCount')) {
	            return that.getOption('mergedPermissionsCount')(that.getOption('mergeToPersonPermissionsModelOriginal').get('perms'), p).length == 0;
	        } else return false;
	    }
	});
	
	module.exports = MergePersonPermissionsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h4 class="center">Merge '+
	((__t=( mode ))==null?'':__t)+
	' <a href="/#person/'+
	((__t=( personId ))==null?'':__t)+
	'" target="_blank">'+
	((__t=( personName ))==null?'':__t)+
	'</a></h4>\r\n\r\n<div class="table-responsive well" style="font-size: 10px;">\r\n    <table class="table table-hover">\r\n        <thead>\r\n        <tr>\r\n            <th>Owner</th>\r\n            <th>Org.</th>\r\n            <th title="Can View">CV</th>\r\n            <th title="Can Read All">CRA</th>\r\n            <th title="Can Read For">CRF</th>\r\n            <th title="Can Edit">CE</th>\r\n            <th title="Can Edit For">CEF</th>\r\n            <th title="Can Edit All">CEA</th>\r\n            <th title="Can Delete">CD</th>\r\n            <th title="Can Sign">CS</th>\r\n            <th title="Can Sign For All">CSFA</th>\r\n            <th title="Can Upload For">CUF</th>\r\n            <th title="Can Change Reviewer">CCR</th>\r\n            <th></th>\r\n        </tr>\r\n        </thead>\r\n        <tbody>\r\n        ';
	 _.each(permissions, function(permission, index) { 
	__p+='\r\n        <tr ';
	 if (mode == 'to' && !isMergedPermission(permission) || mode == 'from' && isDeprecated(permission)) { 
	__p+=' class="deprecated-header" ';
	 } 
	__p+=' >\r\n\r\n            ';
	 if (permission.ownerId != null && permission.owner != null) { 
	__p+='\r\n                <td><a href = "/#person/'+
	((__t=( permission.ownerId ))==null?'':__t)+
	'">'+
	((__t=( formatPerson(permission.owner.object) ))==null?'':__t)+
	'</a></td>\r\n            ';
	 } else { 
	__p+='\r\n                <td>-</td>\r\n            ';
	 } 
	__p+='\r\n            ';
	 if (permission.organizationId != null && permission.organization != null) { 
	__p+='\r\n                <td><a href = "/#organization/'+
	((__t=( permission.organizationId ))==null?'':__t)+
	'">'+
	((__t=( permission.organization.name ))==null?'':__t)+
	'</a></td>\r\n            ';
	 } else { 
	__p+='\r\n                <td>-</td>\r\n            ';
	 } 
	__p+='\r\n\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canRead" ';
	 if (permission.canRead) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canReadAll" ';
	 if (permission.canReadAll) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canReadFor" ';
	 if (permission.canReadFor) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canWrite" ';
	 if (permission.canWrite) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canWriteFor" ';
	 if (permission.canWriteFor) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canWriteAll" ';
	 if (permission.canWriteAll) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canDelete" ';
	 if (permission.canDelete) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canSign" ';
	 if (permission.canSign) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canSignAll" ';
	 if (permission.canSignAll) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canUploadFor" ';
	 if (permission.canUploadFor) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n            <td><input type="checkbox" onclick="return false;" onkeydown="return false;" value="canChangeReviewer" ';
	 if (permission.canChangeReviewer) { 
	__p+=' checked ';
	 } 
	__p+=' ></td>\r\n\r\n\r\n            ';
	 if (mode == 'from') { 
	__p+='\r\n            <td id="'+
	((__t=( index ))==null?'':__t)+
	'"><span class="control-label glyphicon glyphicon-arrow-right clickable merge '+
	((__t=( isHidden(permission) ))==null?'':__t)+
	'" id="'+
	((__t=( permission.id ))==null?'':__t)+
	'" title="Add"></span></td>\r\n            ';
	 } 
	__p+='\r\n            ';
	 if (mode == 'to') { 
	__p+='\r\n            <td id="'+
	((__t=( index ))==null?'':__t)+
	'"><span class="control-label glyphicon glyphicon-remove-circle clickable remove" id="'+
	((__t=( permission.id ))==null?'':__t)+
	'" title="Remove"></span></td>\r\n            ';
	 } 
	__p+='\r\n        </tr>\r\n        ';
	 }) 
	__p+='\r\n        </tbody>\r\n    </table>\r\n</div>\r\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div id="buttons" class="form-horizontal form">\r\n    <div class="form-group">\r\n        <div class="col-md-3 col-xs-3">\r\n            ';
	 if (withBack) { 
	__p+='\r\n            <button type="button" class="btn btn-primary pull-left" id="back">Back to persons select</button>\r\n            ';
	 } 
	__p+='\r\n        </div>\r\n        <div class="col-md-9 col-xs-9">\r\n            <button type="button" class="btn btn-warning pull-right btn-with-right-space" id="cancel">Cancel</button>\r\n            <button type="button" class="btn btn-danger pull-right btn-with-right-space" id="save-and-delete">Save and delete "Merge From" user</button>\r\n            <button type="button" class="btn btn-success pull-right btn-with-right-space" id="save">Save</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div>\r\n\r\n    <!-- Nav tabs -->\r\n    <ul class="nav nav-tabs" role="tablist">\r\n        <li role="presentation" class="active"><a href="#demographics" aria-controls="demographics-main" role="tab" data-toggle="tab">Demographics</a></li>\r\n        <li role="presentation"><a href="#contacts" aria-controls="contacts" role="tab" data-toggle="tab">Contacts</a></li>\r\n        <li role="presentation"><a href="#diseases" aria-controls="diseases" role="tab" data-toggle="tab">Diseases</a></li>\r\n        <li role="presentation"><a href="#medications" aria-controls="medications" role="tab" data-toggle="tab">Medications</a></li>\r\n        <li role="presentation"><a href="#documents" aria-controls="documents" role="tab" data-toggle="tab">Documents</a></li>\r\n        <li role="presentation"><a href="#permissions" aria-controls="permissions" role="tab" data-toggle="tab">Permissions</a></li>\r\n    </ul>\r\n\r\n    <!-- Tab panes -->\r\n    <div class="tab-content">\r\n        <div role="tabpanel" class="tab-pane active top-margined" id="demographics">\r\n            <div id="merge-from-person-demographics-data" class="col-xs-6 col-md-6"></div>\r\n            <div id="merge-to-person-demographics-data" class="col-xs-6 col-md-6"></div>\r\n        </div>\r\n        <div role="tabpanel" class="tab-pane top-margined" id="contacts">\r\n            <div id="merge-from-person-contacts-data" class="col-xs-6 col-md-6">gf</div>\r\n            <div id="merge-to-person-contacts-data" class="col-xs-6 col-md-6">gf</div>\r\n        </div>\r\n        <div role="tabpanel" class="tab-pane top-margined" id="diseases">\r\n            <div id="merge-from-person-diseases-data" class="col-xs-6 col-md-6">gf</div>\r\n            <div id="merge-to-person-diseases-data" class="col-xs-6 col-md-6">gf</div>\r\n        </div>\r\n        <div role="tabpanel" class="tab-pane top-margined" id="medications">\r\n            <div id="merge-from-person-medications-data" class="col-xs-6 col-md-6">gf</div>\r\n            <div id="merge-to-person-medications-data" class="col-xs-6 col-md-6">gf</div>\r\n        </div>\r\n        <div role="tabpanel" class="tab-pane top-margined" id="documents">\r\n            <div id="merge-from-person-documents-data" class="col-xs-6 col-md-6"></div>\r\n            <div id="merge-to-person-documents-data" class="col-xs-6 col-md-6"></div>\r\n        </div>\r\n        <div role="tabpanel" class="tab-pane top-margined" id="permissions">\r\n            <div id="merge-from-person-permissions-data" class="col-xs-6 col-md-6"></div>\r\n            <div id="merge-to-person-permissions-data" class="col-xs-6 col-md-6"></div>\r\n        </div>\r\n    </div>\r\n\r\n</div>\r\n\r\n<div id="cancel-confirmation-modal"></div>\r\n<div id="save-confirmation-modal"></div>\r\n<div id="save-and-delete-confirmation-modal"></div>\r\n';
	}
	return __p;
	};


/***/ }),
/* 499 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h3 class="center">Merge persons</h3>\r\n\r\n<div id="persons-select-form" class="top-margined collapse">\r\n    <div class="form-inline form row">\r\n        <div class="form-group">\r\n            <select id="merge-from-persons-filter" data-placeholder="Select filter">\r\n                <option value="mergeble" name="Mergeble">Mergeble</option>\r\n                <option value="all" name="All">All</option>\r\n            </select>\r\n        </div>\r\n        <div class="form-group">\r\n            <label>Merge from</label>\r\n        </div>\r\n        <div class="form-group">\r\n            <div id="merge-from-person-select"></div>\r\n        </div>\r\n        <div class="form-group">\r\n            <span class="control-label glyphicon glyphicon-option-vertical"></span>\r\n        </div>\r\n        <div class="form-group">\r\n            <label>Merge to</label>\r\n        </div>\r\n        <div class="form-group">\r\n            <div id="merge-to-person-select"></div>\r\n        </div>\r\n        <div class="form-group">\r\n            <span class="control-label glyphicon glyphicon-option-vertical"></span>\r\n        </div>\r\n        <div class="form-group">\r\n            <button type="button" class="btn btn-primary" id="reset">Reset</button>\r\n        </div>\r\n        <div class="form-group">\r\n            <button type="button" class="btn btn-danger" id="show-merge-details" disabled>Merge</button>\r\n        </div>\r\n    </div>\r\n\r\n    <div class="form row top-margined">\r\n        <div class="form-group col-md-offset-2 col-xs-offset-2 col-md-2 col-xs-2" id="merge-from-person-select-probables">\r\n        </div>\r\n        <div class="form-group col-md-offset-1 col-xs-offset-1 col-md-2 col-xs-2" id="merge-to-person-select-probables">\r\n        </div>\r\n    </div>\r\n</div>\r\n<div id="merge-details" class="top-margined row collapse">\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(180);
	
	var HelpSectionsList = Marionette.View.extend({
	    template: __webpack_require__(501),
	
	    initialize: function(options){
	    }
	
	});
	
	
	module.exports = HelpSectionsList;

/***/ }),
/* 501 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div id="sections">\r\n    <h2>Help sections</h2>\r\n    <div class="list-group">\r\n        <a href="#help-physician" class="list-group-item"><b>Physician</b></a>\r\n        <a href="#help-office-admin" class="list-group-item"><b>Office Administrator</b></a>\r\n        <a href="#help-corporate-admin" class="list-group-item"><b>Corporate Administrator</b></a>\r\n        <a href="#help-feedback" class="list-group-item"><b>Feedback</b></a>\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(180);
	
	var HelpPhysicianView = Marionette.View.extend({
	    template: __webpack_require__(503),
	
	    initialize: function(options){
	    }
	
	});
	
	
	module.exports = HelpPhysicianView;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<img class="img-responsive" src="' + __webpack_require__(504) + '"/>';
	}
	return __p;
	};


/***/ }),
/* 504 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(180);
	
	var HelpOfficeAdminView = Marionette.View.extend({
	    template: __webpack_require__(506),
	
	    initialize: function(options){
	    }
	
	});
	
	
	module.exports = HelpOfficeAdminView;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<img class="img-responsive" src="' + __webpack_require__(507) + '"/>';
	}
	return __p;
	};


/***/ }),
/* 507 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(180);
	
	var HelpCorporateAdminView = Marionette.View.extend({
	    template: __webpack_require__(509),
	
	    initialize: function(options){
	    }
	
	});
	
	
	module.exports = HelpCorporateAdminView;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<img class="img-responsive" src="' + __webpack_require__(510) + '"/>';
	}
	return __p;
	};


/***/ }),
/* 510 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	var CommonUtils = __webpack_require__(189);
	var SuccessDialog = __webpack_require__(332);
	var Radio = __webpack_require__(183);
	
	var notificationsChannel = Radio.channel('notifications');
	
	var HelpFeedbackView = Marionette.View.extend({
	    template: __webpack_require__(512),
	
	    ui: {
	        name: '#name',
	        email: '#email',
	        text: '#text',
	        send: '#send'
	    },
	
	    events: {
	        'click @ui.send': 'send',
	        'keyup @ui.email': 'validateEmail',
	        'change @ui.email': 'validateEmail'
	    },
	
	    regions: {
	        dialog: '#success-dialog'
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'send', 'validateEmail');
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	        this.showChildView('dialog', new SuccessDialog({
	            title: 'Success',
	            message: 'Feedback was sent successfully'
	        }));
	    },
	
	    validateEmail: function (event) {
	        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.target.value)) {
	            this.ui.email.parent().removeClass('has-error has-feedback');
	            this.ui.email.tooltip("destroy");
	            this.ui.send.removeAttr("disabled");
	        } else {
	            this.ui.email.parent().addClass('has-error has-feedback');
	            this.ui.email.tooltip({title: 'Invalid e-mail'});
	            this.ui.send.attr("disabled", "true");
	        }
	    },
	
	    send: function () {
	        var that = this;
	        that.utils.showSpinner();
	        $.ajax({
	            type: "POST",
	            url: '/api/help/feedback',
	            data: {
	                name: that.ui.name.val(),
	                email: that.ui.email.val(),
	                text: that.ui.text.val()
	            },
	            dataType: 'text',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner();
	                    that.getChildView('dialog').show();
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner();
	                notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	            }
	        });
	    }
	
	});
	
	
	module.exports = HelpFeedbackView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="form-horizontal col-md-offset-3 col-xs-offset-3 col-md-6 col-xs-6">\r\n    <h4 class="center">Leave a feedback</h4>\r\n    <div>\r\n        <div class="form-group">\r\n            <input class="form-control" id="name" placeholder="Enter your name"/>\r\n        </div>\r\n        <div class="form-group">\r\n            <input class="form-control" id="email" placeholder="Enter your e-mail"/>\r\n        </div>\r\n        <div class="form-group">\r\n            <textarea class="form-control" rows="10" id="text"></textarea>\r\n        </div>\r\n        <div class="left-buttons">\r\n            <button type="button" class="btn btn-success" id="send" disabled>Send</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div id="success-dialog"></div>';
	}
	return __p;
	};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var AuthByInstantToken = Marionette.View.extend({
	    template: __webpack_require__(343),
	
	    initialize: function(options){
	        this.token = options.token;
	        _.bindAll(this, 'performLogin');
	    },
	    onRender: function () {
	        this.performLogin();
	    },
	    performLogin: function(){
	        $.ajax({
	            type: "GET",
	            url: '/api/login/auth/instant/token/' + this.token,
	            statusCode: {
	                200: function() {
	                    Backbone.history.navigate('/documents?toReview=true&simpleMode=true', {trigger: true});
	                }
	            },
	            error: function (e) {
	                notificationsChannel.request('show:notification', e.responseJSON);
	                Backbone.history.navigate('/', {trigger: true});
	            }
	        });
	    },
	});
	
	module.exports = AuthByInstantToken;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var RemoteSuggesterView = __webpack_require__(196);
	var PhysicianFormView = __webpack_require__(515);
	var DeterminationOfNeedRevisedView = __webpack_require__(370);
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var Radio = __webpack_require__(183);
	var services = Radio.channel('services');
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var ReferralFormView = Marionette.View.extend({
	        template: __webpack_require__(517),
	
	        regions: {
	            languageSelect: '#language-select',
	            stateSelect: '#state-select',
	            countrySelect: '#country-select',
	            primaryPhysicianForm: '#primary-physician-form',
	            donrTable: '#don-r-table'
	        },
	
	        ui: {
	            referralSourceContent: '#referral-source-content',
	            profileContent: '#profile-content',
	            medicalInformationContent: '#medical-information-content',
	            referralDate: '#referral-date',
	            referredBy: '#referred-by',
	            referredByPhone: '#referred-by-phone',
	            referredByEmail: '#referred-by-email',
	            dob: '#dob',
	            ssn: '#ssn',
	            sex: '#sex',
	            address: '#address',
	            zip: '#zip',
	            personPhone: '#person-phone',
	            personEmail: '#person-email',
	            housing: '#housing',
	            housingDetails: '#housing-details',
	            primaryContactName: '#primary-contact-name',
	            primaryContactRelationship: '#primary-contact-rel',
	            primaryContactPhone: '#primary-contact-phone',
	            primaryContactAddress: '#primary-contact-address',
	
	            diagnosisSearchText: '#search-text',
	            diagnosisSearchButton: '#search-button',
	            diagnosisTable: '#diagnosis',
	            selectedDiagnosisTable: '#selected-diagnosis',
	            diagnosisComments: '#diagnosis-comments',
	
	            generalComments: '#general-comments',
	
	            languageSelectContent: '#language-select',
	            selectedLanguages: '#selected-languages',
	
	            createReferralFormBtn: '#create',
	            countrySelect: '#country-select',
	            countySelect: '#county-select',
	
	            otherPhysicians: '#other-physicians',
	            addPhysician: '#add-physician',
	
	            reCaptcha: '#re-captcha'
	        },
	
	        events: {
	            'click @ui.createReferralFormBtn': 'onCreate',
	            'change .simple-input': 'onChangeSimpleInput',
	            'change @ui.referredByPhone': 'onReferredByPhoneChanged',
	            'change @ui.referredByEmail': 'onReferredByEmailChanged',
	            'change @ui.address': 'onChangeAddress',
	            'change @ui.zip': 'onChangeAddress',
	            'change @ui.personPhone': 'onPersonPhoneChanged',
	            'change @ui.personEmail': 'onPersonEmailChanged',
	            'change @ui.ssn': 'onSsnChange',
	            'change @ui.housing': 'onChangeHousing',
	            'change @ui.housingDetails': 'onChangeHousingDetails',
	            'change .primary-contact': 'onChangePrimaryContact',
	            'change @ui.primaryContactPhone': 'onPrimaryContactPhoneChanged',
	
	            'keyup @ui.diagnosisSearchText': 'searchDiagnosis',
	            'click @ui.diagnosisSearchButton': 'searchDiagnosis',
	            'click .remove-diagnosis': 'onRemoveDiagnosis',
	            'change @ui.diagnosisComments': 'onChangeDiagnosisComments',
	            'change @ui.generalComments': 'onChangeGeneralComments',
	
	            'click .language-primary': 'setLanguageAsPrimary',
	            'click .remove-language': 'removeLanguage',
	
	            'click @ui.addPhysician': 'addPhysician'
	        },
	
	        childViewEvents: {
	            'suggestor:selected:language': 'onSelectLanguage',
	            'suggestor:selected:state': 'onSelectState',
	            'suggestor:selected:country': 'onSelectCountry',
	            'physician:remove': 'removePhysician'
	        },
	
	        primaryLanguageColor: '#337ab7',
	        secondaryLanguageColor: '#afc7dc',
	
	        initialize: function () {
	            var that = this;
	            that.utils = new CommonUtils();
	            that.initReferralFormData();
	            that.servicesAddresses = services.request('get:services:address');
	
	            window.setTimeout(function () {
	                if (_.isUndefined(that.servicesAddresses))
	                    that.servicesAddresses = services.request('get:services:address');
	            }, 1000);
	        },
	
	        templateContext: function () {
	            var that = this;
	            return {
	                housingValues: that.utils.getHousingValues()
	            }
	        },
	
	        initReferralFormData: function () {
	            this.referralForm = {
	                person: {
	                    referredByContacts: [],
	                    languages: [],
	                    contacts: [],
	                    primaryContacts: [
	                        {
	                            contacts: []
	                        }
	                    ],
	                    primaryPhysician: {},
	                    physicians: []
	                },
	                medProfile: {
	                    diseases: [],
	                    determinationOfNeedRevised: this.utils.getDeterminationOfNeedRevised()
	                }
	            }
	        },
	
	        onRender: function () {
	            window.document.title = "Referral form";
	            var that = this;
	
	            var now = new Date();
	
	            that.ui.referralSourceContent.collapse("show");
	            that.ui.profileContent.collapse("show");
	            that.ui.medicalInformationContent.collapse("show");
	
	            that.ui.referralDate.datepicker({
	                format: 'mm/dd/yyyy',
	                clearBtn: true
	            }).on('changeDate', function (e) {
	                $(this).datepicker('hide');
	                that.referralForm.person.referralDate = that.utils.dateToLong(e.target.value);
	            }).on('clearDate', function (e) {
	                that.referralForm.person.referralDate = 0;
	            });
	            that.ui.referralDate.datepicker('update', now);
	            that.referralForm.person.referralDate = that.utils.dateToLong(now);
	
	            that.ui.dob.datepicker({
	                format: 'mm/dd/yyyy',
	                clearBtn: true
	            }).on('changeDate', function (e) {
	                $(this).datepicker('hide');
	                that.referralForm.person.birthData = that.utils.dateToLong(e.target.value);
	            }).on('clearDate', function (e) {
	                that.referralForm.person.birthData = 0;
	            });
	
	            var sexSelectize = this.ui.sex.selectize({
	                allowEmptyOption: false
	            });
	
	            var housingSelectize = this.ui.housing.selectize({
	                allowEmptyOption: false
	            });
	
	            that.countySelect = this.ui.countySelect.selectize({
	                allowEmptyOption: false,
	                placeholder: 'Select a county',
	                inputClass: 'form-control selectize-input',
	                highlight: true,
	                onChange: function (value) {
	                    that.rebuildFullSimpleAddress();
	                }
	            });
	
	            that.ui.referredByPhone.mask("(999) 999-9999", {
	                autoclear: false,
	                completed: function () {
	                    that.clearError(this);
	                    that.onContactChanged("referredByContacts", this.val(), 'PHONE');
	                }
	            });
	            that.ui.ssn.mask("999-99-9999", {
	                autoclear: false,
	                completed: function () {
	                    that.clearError(this);
	                    that.referralForm.person["ssn"] = this.val();
	                }
	            });
	            that.ui.personPhone.mask("(999) 999-9999", {
	                autoclear: false,
	                completed: function () {
	                    that.clearError(this);
	                    that.onContactChanged("contacts", this.val(), 'PHONE');
	                }
	            });
	            that.ui.primaryContactPhone.mask("(999) 999-9999", {
	                autoclear: false,
	                completed: function () {
	                    that.clearError(this);
	                    that.primaryContactPhoneChange(this.val());
	                }
	            });
	
	            that.showlanguageSelect();
	            that.showStateSelect();
	            that.showCountrySelect();
	            that.showPrimaryPhysician();
	            that.showDonRTable();
	
	            that.disableSeparateFields();
	
	            window.setTimeout(function () {
	                that.initAddressesSuggest();
	            }, 1000);
	
	            window.setTimeout(function () {
	                that.initReCaptcha();
	            }, 1000);
	
	        },
	
	        initReCaptcha: function () {
	            var that = this;
	            that.recaptcha = window.grecaptcha.render(that.ui.reCaptcha.get(0), {
	                'sitekey': Constants.googleRecaptchaKey,
	                'callback': function (response) {
	                    if (!_.isEmpty(response)) {
	                        that.recaptchaResponse = response;
	                    }
	                }
	            });
	        },
	
	        recaptchaReset: function () {
	            window.grecaptcha.reset(this.recaptcha);
	            this.recaptchaResponse = '';
	        },
	
	        initAddressesSuggest: function () {
	            var that = this;
	            var clientAddressDomEl = that.ui.address.get(0);
	            var primaryContactAddressDomEl = that.ui.primaryContactAddress.get(0);
	            var options = {
	                types: ['address'],
	                componentRestrictions: {country: 'us'}
	            };
	
	            var addressParser = function (place) {
	                var addressComponents = {
	                    street_number: 'short_name',
	                    route: 'long_name',
	                    locality: 'long_name',
	                    administrative_area_level_3: 'short_name',
	                    administrative_area_level_2: 'short_name',
	                    administrative_area_level_1: 'short_name',
	                    country: 'short_name',
	                    postal_code: 'short_name'
	                };
	
	                var addressParts = [];
	
	                for (var i = 0; i < place.address_components.length; i++) {
	                    var addressType = place.address_components[i].types[0];
	                    if (addressComponents[addressType]) {
	                        addressParts.push(place.address_components[i][addressComponents[addressType]]);
	                    }
	                }
	
	                return addressParts.join(', ');
	            };
	
	            that.clientAddressAutocomplete = new google.maps.places.Autocomplete(clientAddressDomEl, options);
	            that.clientAddressAutocomplete.addListener('place_changed', function () {
	                var place = that.clientAddressAutocomplete.getPlace();
	                var address = addressParser(place);
	                that.rebuildFullSimpleAddress();
	            });
	
	            that.primaryContactAddressAutocomplete = new google.maps.places.Autocomplete(primaryContactAddressDomEl, options);
	            that.primaryContactAddressAutocomplete.addListener('place_changed', function () {
	                var place = that.primaryContactAddressAutocomplete.getPlace();
	                var address = addressParser(place);
	                that.referralForm.person.primaryContacts[0]["address"] = address;
	            });
	        },
	
	        disableSeparateFields: function () {
	            var that = this;
	            window.setTimeout(function () {
	                that.ui.countrySelect.find('#country').attr('disabled', true);
	            }, 500);
	        },
	
	        onChangeSimpleInput: function (event) {
	            this.referralForm.person[event.target.name] = event.target.value;
	        },
	
	        onReferredByPhoneChanged: function (event) {
	            if (event.target.value.indexOf('_') > -1) {
	                this.showError($(event.target), "Uncompleted");
	                this.onContactChanged("referredByContacts", '', 'PHONE');
	            } else if (_.isEmpty(event.target.value)) {
	                this.clearError($(event.target));
	                this.onContactChanged("referredByContacts", '', 'PHONE');
	            }
	        },
	
	        onReferredByEmailChanged: function (event) {
	            var val = event.target.value;
	            if (this.utils.isValidEmail(val) || _.isEmpty(val)) {
	                this.onContactChanged("referredByContacts", val, 'EMAIL');
	                this.clearError($(event.target));
	            } else {
	                this.onContactChanged("referredByContacts", '', 'EMAIL');
	                this.showError($(event.target), "Invalid e-mail");
	            }
	        },
	
	        onPersonPhoneChanged: function (event) {
	
	            if (event.target.value.indexOf('_') > -1) {
	                this.showError($(event.target), "Uncompleted");
	                this.onContactChanged("contacts", '', 'PHONE');
	            } else if (_.isEmpty(event.target.value)) {
	                this.clearError($(event.target));
	                this.onContactChanged("contacts", '', 'PHONE');
	            }
	        },
	
	        onSsnChange: function (event) {
	
	            if (event.target.value.indexOf('_') > -1) {
	                this.showError($(event.target), "Uncompleted");
	                this.referralForm.person["ssn"] = "";
	            } else if (_.isEmpty(event.target.value)) {
	                this.clearError($(event.target));
	                this.referralForm.person["ssn"] = "";
	            }
	        },
	
	        onPersonEmailChanged: function (event) {
	            var val = event.target.value;
	            if (this.utils.isValidEmail(val) || _.isEmpty(val)) {
	                this.onContactChanged("contacts", val, 'EMAIL');
	                this.clearError($(event.target));
	            } else {
	                this.onContactChanged("contacts", '', 'EMAIL');
	                this.showError($(event.target), "Invalid e-mail");
	            }
	        },
	
	        onContactChanged: function (contactField, val, contactType) {
	            if (_.isEmpty(val)) {
	                this.referralForm.person[contactField] = this.referralForm.person[contactField].filter(function (contact) {
	                    return contact.type != contactType;
	                });
	            } else {
	                if (_.isUndefined(_.findWhere(this.referralForm.person[contactField], {type: contactType})))
	                    this.referralForm.person[contactField].push({
	                        data: val,
	                        type: contactType
	                    });
	                else
	                    this.referralForm.person[contactField].forEach(function (contact) {
	                        if (contact.type == contactType)
	                            contact.data = val;
	                    });
	            }
	        },
	
	        onChangeAddress: function () {
	            this.rebuildFullSimpleAddress();
	        },
	
	        onSelectState: function (selected) {
	            var that = this;
	            if (_.isEmpty(selected) || _.isNull(selected) || _.isUndefined(selected)) {
	                that.countySelect[0].selectize.clearOptions();
	            } else {
	                $.ajax({
	                    type: "GET",
	                    url: '/api/reference/counties/' + selected,
	                    contentType: 'application/json',
	                    statusCode: {
	                        200: function (response) {
	                            that.countySelect[0].selectize.clearOptions();
	                            response.forEach(function (county) {
	                                that.countySelect[0].selectize.addOption({
	                                    value: county,
	                                    text: county
	                                });
	                            });
	                        }
	                    },
	                    error: function (e) {
	                        if (e.status == 401) {
	                            actionsChannel.request("redirect:to:login");
	                        } else {
	                            that.countySelect[0].selectize.clearOptions();
	                            console.log(e);
	                        }
	                    }
	                });
	            }
	            this.rebuildFullSimpleAddress();
	        },
	
	        onSelectCountry: function (selected) {
	            this.rebuildFullSimpleAddress();
	        },
	
	        rebuildFullSimpleAddress: function () {
	            var address = this.ui.address.val();
	            var county = this.ui.countySelect.val();
	            var state = this.getChildView('stateSelect').getSelectedId();
	            var zip = this.ui.zip.val();
	            var country = this.getChildView('countrySelect').getSelectedId();
	
	            var fullSipmleAddress = [address, county, state, zip, country].filter(function (item) {
	                return !_.isEmpty(item) && !_.isNull(item) && !_.isUndefined(item);
	            });
	            this.referralForm.person.address = fullSipmleAddress.join(", ");
	        },
	
	        onChangeHousing: function (event) {
	            var that = this;
	            var housing = event.target.value;
	            that.referralForm.person.housing = housing;
	
	            if (housing != 'Other') {
	                this.ui.housingDetails.parent().parent().hide();
	                that.referralForm.person.housingDetails = '';
	                this.ui.housingDetails.val();
	            } else {
	                this.ui.housingDetails.parent().parent().show();
	            }
	        },
	
	        onChangeHousingDetails: function (event) {
	            this.referralForm.person.housingDetails = event.target.value;
	        },
	
	        onChangePrimaryContact: function (event) {
	            this.referralForm.person.primaryContacts[0][event.target.name] = event.target.value;
	        },
	
	        onPrimaryContactPhoneChanged: function (event) {
	            if (event.target.value.indexOf('_') > -1) {
	                this.showError($(event.target), "Uncompleted");
	                this.primaryContactPhoneChange('');
	            } else if (_.isEmpty(event.target.value)) {
	                this.clearError($(event.target));
	                this.primaryContactPhoneChange('');
	            }
	        },
	
	        primaryContactPhoneChange: function (val) {
	            var contactType = 'PHONE';
	            if (_.isEmpty(val)) {
	                this.referralForm.person.primaryContacts[0].contacts = this.referralForm.person.primaryContacts[0].contacts.filter(function (contact) {
	                    return contact.type != contactType;
	                });
	            } else {
	                if (_.isUndefined(_.findWhere(this.referralForm.person.primaryContacts[0].contacts, {type: contactType})))
	                    this.referralForm.person.primaryContacts[0].contacts.push({
	                        data: val,
	                        type: contactType
	                    });
	                else
	                    this.referralForm.person.primaryContacts[0].contacts.forEach(function (contact) {
	                        if (contact.type == contactType)
	                            contact.data = val;
	                    });
	            }
	        },
	
	        validateReferralForm: function () {
	
	            if (this.getErrorsCount() > 0)
	                return "Some fields with errors";
	
	            if (!this.referralForm.person.firstName || _.isEmpty(this.referralForm.person.firstName
	                    || !this.referralForm.person.lastName && _.isEmpty(this.referralForm.person.lastName)))
	                return 'Please, fill first name and last name of prospective client';
	
	            if (_.isEmpty(this.recaptchaResponse))
	                return "Check the recaptcha";
	
	            return "";
	        },
	
	        getErrorsCount: function () {
	            return this.$el.find('.has-error').length;
	        },
	
	        onCreate: function () {
	            var that = this;
	            console.log(that.referralForm);
	
	            var errorText = that.validateReferralForm();
	            if (!_.isEmpty(errorText)) {
	                notificationsChannel.request('show:notification', errorText);
	                return;
	            }
	
	
	            that.utils.showSpinner();
	            $.ajax({
	                type: "POST",
	                url: '/api/cmform',
	                data: JSON.stringify(that.referralForm),
	                contentType: 'application/json',
	                statusCode: {
	                    200: function (response) {
	                        that.utils.hideSpinner();
	                        $.notify("Referral form created successfully", "success");
	                        that.initReferralFormData();
	                        that.render();
	                        that.recaptchaReset();
	                    }
	                },
	                error: function (e) {
	                    that.utils.hideSpinner();
	                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	                }
	            });
	        },
	
	        showlanguageSelect: function () {
	            var that = this;
	
	            that.showChildView('languageSelect', new RemoteSuggesterView({
	                tag: 'language',
	                inputId: 'language',
	                maxNumberOfElements: 20,
	                url: '/api/reference/languages/~~~',
	                symbolForSearchInUrl: '~~~',
	                listLocation: function (data) {
	                    return data;
	                },
	                getIdFn: function (element) {
	                    return element;
	                },
	                getValueFn: function (element) {
	                    return element;
	                },
	                classes: ["form-control"],
	                placeholder: "Select language",
	                findSelectedIdBySelectedIndex: function (arr, index) {
	                    return arr[index] || null;
	                }
	            }));
	        },
	
	        showStateSelect: function () {
	            var that = this;
	
	            that.showChildView('stateSelect', new RemoteSuggesterView({
	                tag: 'state',
	                inputId: 'state',
	                maxNumberOfElements: 20,
	                url: '/api/reference/states/~~~',
	                symbolForSearchInUrl: '~~~',
	                listLocation: function (data) {
	                    return data;
	                },
	                getValueFn: function (element) {
	                    return element;
	                },
	                classes: ["form-control"],
	                placeholder: "Select state",
	                findSelectedIdBySelectedIndex: function (arr, index) {
	                    return arr[index] || null;
	                }
	            }));
	        },
	
	        showCountrySelect: function () {
	            var that = this;
	
	            that.showChildView('countrySelect', new RemoteSuggesterView({
	                tag: 'country',
	                inputId: 'country',
	                maxNumberOfElements: 20,
	                url: '/api/reference/countries/~~~',
	                symbolForSearchInUrl: '~~~',
	                listLocation: function (data) {
	                    return data;
	                },
	                getValueFn: function (element) {
	                    return element;
	                },
	                classes: ["form-control"],
	                placeholder: "Select country",
	                findSelectedIdBySelectedIndex: function (arr, index) {
	                    return arr[index] || null;
	                },
	                defaultSelected: 'United States'
	            }));
	
	            window.setTimeout(function () {
	                that.rebuildFullSimpleAddress();
	            }, 500);
	        },
	
	        showPrimaryPhysician: function () {
	            this.showChildView('primaryPhysicianForm', new PhysicianFormView({
	                showRemove: false,
	                physician: this.referralForm.person.primaryPhysician
	            }));
	        },
	
	        showDonRTable: function () {
	            this.showChildView('donrTable', new DeterminationOfNeedRevisedView({
	                determinationOfNeedRevised: this.referralForm.medProfile.determinationOfNeedRevised,
	                isEditMode: true
	            }));
	        },
	
	        onSelectLanguage: function (lang) {
	            var that = this;
	            if (!_.isNull(lang) && _.isUndefined(_.findWhere(that.referralForm.person.languages, {language: lang}))) {
	                that.referralForm.person.languages.push({
	                    language: lang,
	                    primary: false
	                });
	                var liContent = "<li class='list-group-item' id='" + that.langToId(lang) + "'>"
	                    + "<div class='row'>"
	                    + "<div class='col-xs-5 col-md-5'>"
	                    + lang + ""
	                    + "</div>"
	                    + "<div class='col-xs-5 col-md-5'>"
	                    + "Primary? <input type='checkbox' class='language-primary' title='Set as primary' style='margin-left:10px;'/> "
	                    + "</div>"
	                    + "<div class='col-xs-1 col-md-1'>"
	                    + "<span class='glyphicon glyphicon-remove clickable remove-language' title='Remove' style='margin-left:10px;'/> "
	                    + "</div>"
	                    + "</div>"
	                    + "</li>";
	                that.ui.selectedLanguages.append(liContent);
	            }
	        },
	
	        setLanguageAsPrimary: function (event) {
	            var that = this;
	            var currentLiEl = $(event.target).closest('li');
	            var lang = that.idToLang(currentLiEl.attr('id'));
	            if (event.target.checked == true) {
	                currentLiEl.parent().find('li').each(function () {
	                    var currentLi = $(this);
	                    if (lang != that.idToLang(currentLi.attr('id'))) {
	                        currentLi.find('.language-primary').prop('checked', false);
	                    }
	                });
	            }
	
	            that.referralForm.person.languages.forEach(function (language) {
	                if (language.language == lang)
	                    language.primary = event.target.checked;
	                else
	                    language.primary = false;
	            });
	        },
	
	        removeLanguage: function (event) {
	            var that = this;
	            var li = $(event.target).closest('li');
	            var lang = that.idToLang(li.attr('id'));
	            that.referralForm.person.languages = that.referralForm.person.languages.filter(function (language) {
	                return language.language != lang;
	            });
	            li.remove();
	        },
	
	        langToId: function (lang) {
	            return lang.replace(' ', '_');
	        },
	
	        idToLang: function (lang) {
	            return lang.replace('_', ' ');
	        },
	
	        searchDiagnosis: function (event) {
	            var that = this;
	
	            var searchText = that.ui.diagnosisSearchText.val();
	            if (searchText.length <= 1) return;
	
	            that.ui.diagnosisTable.find('tr:not(:first)').remove();
	
	            //$('#search-results tr:not(:first)').remove();
	
	            if (event.keyCode == 13 || event.target.id == that.ui.diagnosisSearchButton.attr('id')) {
	
	                if (typeof that.servicesAddresses["icdServiceAddress"] != "undefined") {
	                    that.ui.diagnosisSearchText.addClass('data-loader');
	                    $.when(
	                        $.ajax({
	                            type: "GET",
	                            url: that.servicesAddresses["icdServiceAddress"] +
	                            '/search?terms=' + searchText
	                        })
	                    ).done(function (resp) {
	                        that.resfreshDiagnosisTableFromICDResults(resp || []);
	                        that.ui.diagnosisSearchText.removeClass('data-loader');
	                    }).fail(function (jqXHR, textStatus) {
	                        that.ui.diagnosisSearchText.removeClass('data-loader');
	                        notificationsChannel.request('show:notification', "Error. ICD service is unavailable");
	                    });
	                }
	            }
	        },
	
	        resfreshDiagnosisTableFromICDResults: function (results) {
	            var that = this;
	            var icdName = "ICD";
	
	            results.forEach(function (item) {
	                var newRowContent = "<tr class='clickable' id='" + item.code +
	                    "'><td><button class='add-to-left' title='Add to selected'>Add</button></td><td>" + icdName + "-"
	                    + item.version + "</td><td>"
	                    + item.code + "</td><td>" + item.name + "</td></tr>";
	                that.ui.diagnosisTable.find('tbody').append(newRowContent);
	            });
	
	            that.ui.diagnosisTable.find('tr:not(:first)').on('dblclick', function (event) {
	                var id = event.currentTarget.id;
	                $(this).addClass('selected').siblings().removeClass('selected');
	                that.onDiagnosisSelected(id, results, icdName);
	            });
	            that.ui.diagnosisTable.find('.add-to-left').on('click', function (event) {
	                var id = $(event.currentTarget).parent().parent().attr('id');
	                that.onDiagnosisSelected(id, results, icdName);
	            });
	        },
	
	        onDiagnosisSelected: function (selectedId, results, type) {
	            var selected = _.findWhere(results, {code: selectedId});
	
	            var alreadyExists = _.findWhere(this.referralForm.medProfile.diseases, {diseaseId: selectedId});
	            if (!_.isUndefined(alreadyExists))
	                return;
	
	            this.referralForm.medProfile.diseases.push({
	                typeOfId: type + '-' + selected.version,
	                diseaseId: selected.code,
	                name: selected.name
	            });
	
	            var newRowContent = "<tr class='clickable' id='" + selected.code + "'><td>ICD-"
	                + selected.version + "</td><td>"
	                + selected.code + "</td><td>"
	                + selected.name + "</td><td><span class='glyphicon glyphicon-remove clickable remove-diagnosis' title='Remove'/></td></tr>";
	            this.ui.selectedDiagnosisTable.find('tbody').append(newRowContent);
	        },
	
	        onRemoveDiagnosis: function (event) {
	            var row = $(event.target);
	            var diagnosisId = row.parent().parent().attr('id');
	            this.referralForm.medProfile.diseases = this.referralForm.medProfile.diseases.filter(function (d) {
	                return d.diseaseId != diagnosisId;
	            });
	            this.ui.selectedDiagnosisTable.find('tr[id="' + diagnosisId + '"]').remove();
	        },
	
	        onChangeDiagnosisComments: function (event) {
	            this.referralForm.medProfile.diagnosisComments = event.target.value;
	        },
	
	        onChangeGeneralComments: function (event) {
	            this.referralForm.person.generalComments = event.target.value;
	        },
	
	        addPhysician: function () {
	            var physician = this.initAndGetPhysician();
	            this.referralForm.person.physicians.push(physician);
	            var newRegionId = _.uniqueId('physician');
	            this.ui.otherPhysicians.append('<div id="' + newRegionId + '" class="form-group"></div>');
	            this.addRegion(newRegionId, "#" + newRegionId);
	            this.storeRegion(newRegionId);
	            this.showChildView(newRegionId, new PhysicianFormView({
	                showRemove: true,
	                physician: physician,
	                regionId: newRegionId
	            }));
	        },
	
	        removePhysician: function (data) {
	
	            var that = this;
	            var regionId = data.regionId;
	            var physician = data.physician;
	            that.getRegion(regionId).empty();
	            that.removeRegion(regionId);
	            that.$('#' + regionId).remove();
	            this.otherPhysiciansRegions = this.otherPhysiciansRegions.filter(function (item) {
	                return item !== regionId;
	            });
	            that.referralForm.person.physicians = that.referralForm.person.physicians.filter(function (item) {
	                return item !== physician;
	            });
	        },
	
	        storeRegion: function (regionName) {
	            this.otherPhysiciansRegions = this.otherPhysiciansRegions || [];
	            this.otherPhysiciansRegions.push(regionName);
	        },
	
	        initAndGetPhysician: function () {
	            return {
	                dateOfLastVisit: 0,
	                name: '',
	                relationship: ''
	            };
	        },
	
	        enableCreateButton: function () {
	            this.ui.createReferralFormBtn.removeAttr('disabled');
	        },
	
	        disableCreateButton: function () {
	            this.ui.createReferralFormBtn.attr('disabled', true);
	        },
	
	        showError: function (jQelement, text) {
	            jQelement.tooltip({title: text});
	            jQelement.parent().parent().addClass('has-error has-feedback');
	        },
	
	        clearError: function (jQelement) {
	            jQelement.tooltip("destroy");
	            jQelement.parent().parent().removeClass('has-error has-feedback');
	        }
	    })
	;
	
	module.exports = ReferralFormView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Marionette = __webpack_require__(180);
	
	var RemoteSuggesterView = __webpack_require__(196);
	
	var CommonUtils = __webpack_require__(189);
	
	var PhysicianFormView = Marionette.View.extend({
	    template: __webpack_require__(516),
	
	    regions: {
	        primaryPhysicianSelect: '#primary-physician-name-select'
	    },
	    
	    ui: {
	        primaryPhysicianRelationship: '.primary-physician-rel',
	        primaryPhysicianDateOfLastVisit: '.primary-physician-date-of-last-visit',
	        remove: '.remove-physician'
	    },
	
	    events: {
	        'click @ui.remove': 'removePhysician',
	        'change @ui.primaryPhysicianRelationship': 'onPrimaryPhysicianRelationshipChanged'
	    },
	
	    childViewEvents: {
	        'suggestor:selected:physician': 'onSelectPhysician'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            showRemove: this.showRemove == undefined ? true : this.showRemove
	        }
	    },
	
	
	    initialize: function (options) {
	        if (options) {
	            this.physician = options.physician;
	            this.regionId = options.regionId;
	            this.showRemove = options.showRemove;
	        }
	
	        this.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	        var that = this;
	
	        that.ui.primaryPhysicianDateOfLastVisit.datepicker({
	            format: 'mm/dd/yyyy',
	            endDate: '+0d',
	            clearBtn: true
	        }).on('changeDate', function (e) {
	            $(this).datepicker('hide');
	            that.physician.dateOfLastVisit = that.utils.dateToLong(e.target.value);
	        }).on('clearDate', function(e) {
	            that.physician.dateOfLastVisit = 0;
	        });
	
	        that.showPrimaryPhysicianSelect();
	    },
	
	    onPrimaryPhysicianRelationshipChanged: function (event) {
	        this.physician.relationship = event.target.value;
	    },
	
	    onSelectPhysician: function (selected) {
	        this.physician.name = selected;
	    },
	
	    showPrimaryPhysicianSelect: function () {
	        var that = this;
	
	        var nameRetriever = function (item) {
	            if (_.isUndefined(item) || _.isNull(item))
	                return '';
	
	            return item.basic["last_name"] + ' ' + item.basic["first_name"]
	                + ' (' + item.number + ')'
	        };
	
	        that.showChildView('primaryPhysicianSelect', new RemoteSuggesterView({
	            tag: 'physician',
	            //inputId: that.regionId + '-input',
	            requestDelay: 5000,
	            maxNumberOfElements: 200,
	            url: '/api/npi/person/like?nameOrNpi=~~~',
	            symbolForSearchInUrl: '~~~',
	            listLocation: function (data) {
	                return data;
	            },
	            getValueFn: function (element) {
	                return nameRetriever(element);
	            },
	            classes: ["form-control"],
	            placeholder: "Type NPI or names (first and last) part splitted with space",
	            findSelectedIdBySelectedIndex: function (arr, index) {
	                return nameRetriever(arr[index]) || null;
	            }
	        }));
	    },
	
	    removePhysician: function () {
	        var that = this;
	        that.triggerMethod('physician:remove', {regionId: that.regionId, physician: that.physician});
	    }
	});
	
	module.exports = PhysicianFormView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div>\r\n    <div id="primary-physician-name-select" class="col-xs-5 col-md-5"></div>\r\n    <div class="col-xs-2 col-md-2">\r\n        <input class="form-control primary-physician-date-of-last-visit" type="text" placeholder="Date of last visit">\r\n    </div>\r\n    <div class="col-md-2 col-xs-2">\r\n        ';
	 if (showRemove) { 
	__p+='\r\n        <div class="checkbox">\r\n            <span class="remove-physician dotted-link edit-buttons right-buttons" style="color: red;">- Remove</span>\r\n        </div>\r\n        ';
	 } 
	__p+='\r\n    </div>\r\n</div>';
	}
	return __p;
	};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="col-md-offset-1 col-xs-offset-1 col-md-10 col-xs-10">\r\n    <h2 class="center">Referral form</h2>\r\n\r\n    <div class="top-margined">\r\n        <div class="row right">\r\n            <div data-toggle="collapse" data-target="#referral-source-content" class="col-xs-offset-7 col-md-offset-7">\r\n                <span class="dotted-link"><b>REFERRAL SOURCE OF PROSPECTIVE CLIENT</b></span>\r\n            </div>\r\n        </div>\r\n        <div class="row collapse" style="margin: 20px 0px 20px 0px;" id="referral-source-content">\r\n            <div class="form form-horizontal">\r\n                <div class="form-group">\r\n                    <label class="col-xs-2 col-md-2 control-label" for="referral-date">Referral date:</label>\r\n                    <div class="col-xs-2 col-md-2">\r\n                        <input class="form-control" type="text" id="referral-date" placeholder="Referral Date">\r\n                    </div>\r\n                </div>\r\n                <div class="form-group">\r\n                    <label class="col-xs-2 col-md-2 control-label" for="referred-by">Referred by:</label>\r\n                    <div class="col-xs-10 col-md-10">\r\n                        <input class="form-control simple-input" type="text" id="referred-by" name="referredBy"\r\n                               placeholder="Referred by Name">\r\n                    </div>\r\n                </div>\r\n                <div class="form-group">\r\n                    <div>\r\n                        <label class="col-xs-2 col-md-2 control-label" for="referred-by-phone">Referred by\r\n                            Phone:</label>\r\n                        <div class="col-xs-3 col-md-3">\r\n                            <input class="form-control" type="text" id="referred-by-phone"\r\n                                   placeholder="Referred by Phone">\r\n                        </div>\r\n                    </div>\r\n                    <div>\r\n                        <label class="col-xs-2 col-md-2 control-label" for="referred-by-email">Referred by\r\n                            Email:</label>\r\n                        <div class="col-xs-5 col-md-5">\r\n                            <input class="form-control" type="text" id="referred-by-email"\r\n                                   placeholder="Referred by Email">\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class="row right">\r\n            <div data-toggle="collapse" data-target="#profile-content" class="col-xs-offset-8 col-md-offset-8">\r\n                <span class="dotted-link"><b>PROFILE OF PROSPECTIVE CLIENT</b></span>\r\n            </div>\r\n        </div>\r\n        <div class="row collapse" style="margin: 20px 0px 20px 0px;" id="profile-content">\r\n            <div class="form form-horizontal">\r\n                <div class="form-group">\r\n                    <label class="col-xs-3 col-md-3 control-label">Name (First, Middle, Last):</label>\r\n                    <div class="col-xs-3 col-md-3">\r\n                        <input class="form-control simple-input" type="text" id="first-name" name="firstName"\r\n                               placeholder="First name">\r\n                    </div>\r\n                    <div class="col-xs-3 col-md-3">\r\n                        <input class="form-control simple-input" type="text" id="middle-name" name="middleName"\r\n                               placeholder="Middle name">\r\n                    </div>\r\n                    <div class="col-xs-3 col-md-3">\r\n                        <input class="form-control simple-input" type="text" id="last-name" name="lastName"\r\n                               placeholder="Last name">\r\n                    </div>\r\n                </div>\r\n                <div class="form-group">\r\n                    <div>\r\n                        <label class="col-xs-1 col-md-1 control-label" for="dob">D.O.B:</label>\r\n                        <div class="col-xs-2 col-md-2">\r\n                            <input class="form-control" type="text" id="dob"\r\n                                   placeholder="Date of birth">\r\n                        </div>\r\n                    </div>\r\n                    <div>\r\n                        <label class="col-xs-1 col-md-1 control-label" for="medicaid">Medicaid:</label>\r\n                        <div class="col-xs-4 col-md-4">\r\n                            <input class="form-control simple-input" type="text" id="medicaid" name="medicaid"\r\n                                   placeholder="Medicaid ID">\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="form-group">\r\n                    <div>\r\n                        <label class="col-xs-1 col-md-1 control-label" for="ssn">SSN:</label>\r\n                        <div class="col-xs-2 col-md-2">\r\n                            <input class="form-control" type="text" id="ssn" name="ssn" placeholder="SSN">\r\n                        </div>\r\n                    </div>\r\n                    <div>\r\n                        <label class="col-xs-1 col-md-1 control-label" for="sex">Sex:</label>\r\n                        <div class="col-xs-2 col-md-2">\r\n                            <select id="sex" name="gender" class="simple-input" data-placeholder="Sex">\r\n                                <option value=""></option>\r\n                                ';
	 _.each([{name: "M", value: "Male"}, {name: "F", value: "Female"}], function(gender){ 
	__p+='\r\n                                <option value="'+
	((__t=( gender.name ))==null?'':__t)+
	'" name="'+
	((__t=( gender.name ))==null?'':__t)+
	'">'+
	((__t=( gender.value ))==null?'':__t)+
	'\r\n                                </option>\r\n                                ';
	 }) 
	__p+='\r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n                    <div>\r\n                        <div>\r\n                            <label class="col-xs-2 col-md-2 control-label">Languages:</label>\r\n                        </div>\r\n                        <div id="language-select" class="col-xs-4 col-md-4"></div>\r\n                    </div>\r\n                </div>\r\n                <div class="form-group">\r\n                    <ul class="list-group col-md-offset-8 col-xs-offset-8 col-md-4 col-xs-4" id="selected-languages">\r\n                    </ul>\r\n                </div>\r\n                <div class="form-group">\r\n                    <div>\r\n                        <div>\r\n                            <label class="col-xs-1 col-md-1 control-label">Country:</label>\r\n                        </div>\r\n                        <div id="country-select" class="col-xs-3 col-md-3"></div>\r\n                    </div>\r\n                    <div>\r\n                        <div>\r\n                            <label class="col-xs-1 col-md-1 control-label">State:</label>\r\n                        </div>\r\n                        <div id="state-select" class="col-xs-3 col-md-3"></div>\r\n                    </div>\r\n                    <div>\r\n                        <div>\r\n                            <label class="col-xs-1 col-md-1 control-label">County:</label>\r\n                        </div>\r\n                        <select id="county-select" class="col-xs-3 col-md-3"></select>\r\n                    </div>\r\n                </div>\r\n                <div class="form-group">\r\n                    <div>\r\n                        <label class="col-xs-1 col-md-1 control-label" for="zip">ZIP:</label>\r\n                        <div class="col-xs-2 col-md-2">\r\n                            <input class="form-control" type="text" id="zip" placeholder="ZIP-code">\r\n                        </div>\r\n                    </div>\r\n                    <div>\r\n                        <label class="col-xs-1 col-md-1 control-label" for="address">Address:</label>\r\n                        <div class="col-xs-8 col-md-8">\r\n                            <input class="form-control" type="text" id="address" placeholder="Address">\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="form-group">\r\n                    <div>\r\n                        <label class="col-xs-2 col-md-2 control-label" for="person-phone">Client phone:</label>\r\n                        <div class="col-xs-3 col-md-3">\r\n                            <input class="form-control" type="text" id="person-phone"\r\n                                   placeholder="Client phone">\r\n                        </div>\r\n                    </div>\r\n                    <div>\r\n                        <label class="col-xs-2 col-md-2 control-label" for="person-email">Client Email:</label>\r\n                        <div class="col-xs-5 col-md-5">\r\n                            <input class="form-control" type="text" id="person-email"\r\n                                   placeholder="Client Email">\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="form-group">\r\n                    <div>\r\n                        <label class="col-xs-1 col-md-1 control-label" for="housing">Housing:</label>\r\n                        <div class="col-xs-3 col-md-3">\r\n                            <select id="housing">\r\n                                <option value=""></option>\r\n                                ';
	 _.each(housingValues, function(housing){ 
	__p+='\r\n                                <option value="'+
	((__t=( housing ))==null?'':__t)+
	'" name="'+
	((__t=( housing ))==null?'':__t)+
	'"> '+
	((__t=( housing ))==null?'':__t)+
	'</option>\r\n                                ';
	 }) 
	__p+='\r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n                    <div hidden>\r\n                        <label class="col-xs-2 col-md-2 control-label" for="housing-details">Housing details:</label>\r\n                        <div class="col-xs-6 col-md-6">\r\n                            <textarea class="form-control" id="housing-details"></textarea>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class="form-group">\r\n                    <label class="col-xs-6 col-md-6 control-label">Primary contact (Name, Relationship, Contact,\r\n                        Address):</label>\r\n                    <div class="col-xs-6 col-md-6">\r\n                        <input class="form-control primary-contact" type="text" id="primary-contact-name" name="name"\r\n                               placeholder="Name">\r\n                    </div>\r\n                </div>\r\n                <div class="form-group">\r\n                    <div>\r\n                        <div class="col-xs-3 col-md-3">\r\n                            <input class="form-control primary-contact" type="text" id="primary-contact-rel"\r\n                                   name="relationship"\r\n                                   placeholder="Primary contact Relationship">\r\n                        </div>\r\n                    </div>\r\n                    <div>\r\n                        <div class="col-xs-3 col-md-3">\r\n                            <input class="form-control" type="text" id="primary-contact-phone"\r\n                                   placeholder="Primary contact telephone">\r\n                        </div>\r\n                    </div>\r\n                    <div>\r\n                        <div class="col-xs-6 col-md-6">\r\n                            <input class="form-control primary-contact" type="text" id="primary-contact-address"\r\n                                   name="address"\r\n                                   placeholder="Primary contact Address">\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class="row right">\r\n            <div data-toggle="collapse" data-target="#medical-information-content"\r\n                 class="col-xs-offset-6 col-md-offset-6">\r\n                <span class="dotted-link"><b>MEDICAL INFORMATION OF PROSPECTIVE CLIENT</b></span>\r\n            </div>\r\n        </div>\r\n        <div class="row collapse" style="margin: 20px 0px 20px 0px;" id="medical-information-content">\r\n            <div class="form form-horizontal">\r\n                <div class="form-group">\r\n                    <label class="col-xs-6 col-md-6 control-label">Primary physician (Name, Relationship, Date of last\r\n                        visit):</label>\r\n                </div>\r\n                <div class="form-group" id="primary-physician-form"></div>\r\n                <div class="form-group">\r\n                    <label class="col-xs-3 col-md-3 control-label">Other physicians:</label>\r\n                    <button class="btn btn-primary btn-sm col-md-offset-7 col-xs-offset-7 col-md-2 col-xs-2"\r\n                            id="add-physician">Add physician\r\n                    </button>\r\n                </div>\r\n                <div id="other-physicians"></div>\r\n                <div class="form-group">\r\n                    <label class="col-xs-2 col-md-2 control-label">Diagnosis:</label>\r\n                </div>\r\n                <div class="form-group">\r\n                    <div class="input-group">\r\n                        <input class="form-control" type="text" id="search-text"\r\n                               placeholder="For search type at least 2 character and Enter"/>\r\n                        <span class="input-group-btn">\r\n                            <button class="form-control col-xs-1 col-xs-1 glyphicon glyphicon-search"\r\n                                    id="search-button"></button>\r\n                        </span>\r\n                    </div>\r\n                    <div class="well" style="max-height: 200px;overflow-y: auto;background-color: #ffffff;">\r\n                        <table class="table table-bordered table-hover" id="diagnosis">\r\n                            <thead>\r\n                            <th></th>\r\n                            <th>Type</th>\r\n                            <th>Id</th>\r\n                            <th>Name</th>\r\n                            </thead>\r\n                            <tbody>\r\n                            </tbody>\r\n                        </table>\r\n                    </div>\r\n                </div>\r\n                <div class="form-group">\r\n                    <h5 class="center"><b>Selected diagnosis</b></h5>\r\n                    <div class="well" style="max-height: 200px;overflow-y: auto;background-color: #ffffff;">\r\n                        <table class="table table-bordered table-hover" id="selected-diagnosis">\r\n                            <thead>\r\n                            <th>Type</th>\r\n                            <th>Id</th>\r\n                            <th>Name</th>\r\n                            <th></th>\r\n                            </thead>\r\n                            <tbody>\r\n                            </tbody>\r\n                        </table>\r\n                    </div>\r\n                </div>\r\n                <div class="form-group">\r\n                    <label class="col-xs-2 col-md-2 control-label">Diagnosis comments:</label>\r\n                    <div class="col-xs-10 col-md-10">\r\n                        <textarea class="form-control" id="diagnosis-comments" rows="5"></textarea>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class="row" style="margin: 20px 0px 20px 0px;">\r\n            <div class="form form-horizontal">\r\n                <div class="form-group">\r\n                    <label class="col-xs-2 col-md-2 control-label">General comments:</label>\r\n                    <div class="col-xs-10 col-md-10">\r\n                        <textarea class="form-control" id="general-comments" rows="5"></textarea>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class="row right" style="display:none;">\r\n            <div data-toggle="collapse" data-target="#don-r"\r\n                 class="col-xs-offset-6 col-md-offset-6">\r\n                <span class="dotted-link"><b>DETERMINATION OF NEED-REVISED (DON-R)</b></span>\r\n            </div>\r\n        </div>\r\n        <div class="row collapse" style="margin: 20px 0px 20px 0px; display: none" id="don-r">\r\n            <div id="don-r-table"></div>\r\n        </div>\r\n\r\n        <div id="re-captcha"></div>\r\n        <button id="create" class="btn btn-primary top-margined">Create</button>\r\n    </div>\r\n</div>\r\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Marionette = __webpack_require__(180);
	
	var RemoteSuggesterView = __webpack_require__(196);
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	var PersonModel = __webpack_require__(206);
	
	var Radio = __webpack_require__(183);
	var services = Radio.channel('services');
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	var domtoimage = __webpack_require__(519);
	
	var VillagePodiatryFormView = Marionette.View.extend({
	        template: __webpack_require__(520),
	
	        regions: {
	            reviewerSelect: '#reviewer-select',
	            orgSelect: '#organization-select'
	        },
	
	        ui: {
	            content: "#village-podiatry-content",
	            patientName: '#patient-name',
	            patientMrn: '#patient-mrn',
	            patientDob: '#patient-dob',
	            daySelect: '.day-select',
	            supplySelect: '.supply-select',
	            comment: '#comment',
	            create: "#create",
	
	            footer: "#form-footer"
	        },
	
	        events: {
	            'change @ui.patientName': 'onPatientNameChanged',
	            'change @ui.patientMrn': 'onPatientMrnChanged',
	            'click @ui.daySelect': 'onDaySelected',
	            'click @ui.supplySelect': 'onSupplySelected',
	            'change @ui.comment': 'onCommentChanged',
	            'click @ui.create': 'onCreate'
	        },
	
	        childViewEvents: {
	            'suggestor:selected:reviewer': 'onReviewerSelected',
	            'suggestor:selected:organization': 'onOrganizationSelected'
	        },
	
	        initialize: function (options) {
	            var that = this;
	            that.utils = new CommonUtils();
	            this.currentUser = options.currentUser;
	            that.initPayload();
	        },
	
	        templateContext: function () {
	            var that = this;
	            return {
	                days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	                supplies: ["Prisma or Promogran", "Sorbact WCL", "Silver Alginate",
	                    "XeroForm", "Sorbian Sachet", "Hydrafera Blue",
	                    "ukamed Sorbact", "Betadine", "2x2 Guaze",
	                    "4x4 Gauze", "ABD Pad", "Kerlix",
	                    "Ace Wrap", "Coban", "Tape",
	                    "Wound Cleaner", "Saline", "Moisturizer"]
	            }
	        },
	
	        initPayload: function () {
	            var that = this;
	            this.payload = {
	                patientName: "",
	                patientMrn: "",
	                patientDob: null,
	                days: [],
	                supplies: [],
	                comment: "",
	                reviewer: "1770539801", // hardcode -> md with id 1770539801 as default reviewer
	                organization: ""
	            }
	        },
	
	        onRender: function () {
	            window.document.title = "Village podiatry form";
	            var that = this;
	            var now = new Date();
	
	            that.ui.patientDob.datepicker({
	                format: 'mm/dd/yyyy',
	                clearBtn: true
	            }).on('changeDate', function (e) {
	                $(this).datepicker('hide');
	                that.payload.patientDob = that.utils.dateToLong(e.target.value);
	            }).on('clearDate', function (e) {
	                that.payload.patientDob = 0;
	            });
	
	            // hardcode -> md with id 1770539801 as default reviewer
	            var allenRaphael = new PersonModel();
	            allenRaphael.set("id", "1770539801");
	            allenRaphael.fetch({
	                success: function (resp, status, xhr) {
	                    that.showReviewerSelect(resp.attributes);
	                },
	                error: function (error, model_, options) {
	                    that.showReviewerSelect(null);
	                }
	            });
	
	            that.showOrganizationSelect(null);
	        },
	
	        onPatientNameChanged: function (event) {
	            this.payload.patientName = event.target.value;
	        },
	        onPatientMrnChanged: function (event) {
	            this.payload.patientMrn = event.target.value;
	        },
	
	        onDaySelected: function (event) {
	            var value = event.target.name;
	            if (event.target.checked) {
	                this.payload.days.push(value);
	                this.payload.days = _.uniq(this.payload.days);
	            } else {
	                this.payload.days = this.payload.days.filter(function (day) {
	                    return day !== value
	                });
	            }
	
	            console.log(this.payload.days);
	        },
	
	        onSupplySelected: function (event) {
	            var value = event.target.name;
	            if (event.target.checked) {
	                this.payload.supplies.push(value);
	                this.payload.supplies = _.uniq(this.payload.supplies);
	            } else {
	                this.payload.supplies = this.payload.supplies.filter(function (supply) {
	                    return supply !== value
	                });
	            }
	
	            console.log(this.payload.supplies);
	        },
	
	        onCommentChanged: function (event) {
	            this.payload.comment = event.target.value;
	            console.log(this.payload);
	        },
	
	        validateForm: function () {
	
	            if (_.isEmpty(this.payload.patientName))
	                return 'Please, fill Patient Name';
	
	            if (_.isEmpty(this.payload.reviewer)) {
	                return 'Please, select Reviewer';
	            }
	
	            if (_.isEmpty(this.payload.organization)) {
	                return 'Please, select Requesting Organization';
	            }
	
	            return "";
	        },
	
	        getErrorsCount: function () {
	            return this.$el.find('.has-error').length;
	        },
	
	        onCreate: function () {
	            var that = this;
	
	            console.log(that.payload);
	            console.log(that.ui.content);
	            //console.log(that.ui.content.parent().html());
	
	            var errorText = that.validateForm();
	            if (!_.isEmpty(errorText)) {
	                notificationsChannel.request('show:notification', errorText);
	                return;
	            }
	
	            that.ui.footer.hide();
	            that.ui.content.find('input:checkbox').each(function () {
	                $(this).hide();
	                if ($(this).prop('checked')) {
	                    //$(this).parent().addClass('underline');
	                    $(this).parent().html("<b>&#9745;</b>&nbsp;" + $(this).parent().html());
	                } else {
	                    $(this).parent().html("<b>&#9744;</b>&nbsp;" + $(this).parent().html());
	                }
	            })
	
	            var restore = function () {
	                that.ui.footer.show();
	                that.ui.content.find('input:checkbox').each(function () {
	                    $(this).show();
	                    if ($(this).prop('checked')) {
	                        //$(this).parent().addClass('underline');
	                        $(this).parent().html($(this).parent().text().replaceAll("<b>&#9745;</b>&nbsp;", ""));
	                    } else {
	                        $(this).parent().html($(this).parent().text().replaceAll("<b>&#9744;</b>&nbsp;", ""));
	                    }
	                    /*if ($(this).prop('checked')) {
	                        $(this).parent().removeClass('underline');
	                    }*/
	                })
	            }
	
	            /*domtoimage.toPng(document.getElementById('village-podiatry-content'), {
	                bgcolor: '#FFFFFF',
	                width: that.ui.content.parent()[0].clientWidth,
	                height: that.ui.content.parent()[0].clientHeight
	            }).then(function (dataUrl) {
	                var img = new Image();
	                img.src = dataUrl;
	                document.getElementById('village-podiatry-content').appendChild(img);
	            }).catch(function (error) {
	                console.error('oops, something went wrong!', error);
	            });
	
	            return;*/
	
	            that.utils.showSpinner();
	
	            domtoimage.toPng(document.getElementById('village-podiatry-content'), {
	                bgcolor: '#FFFFFF',
	                width: that.ui.content.parent()[0].clientWidth,
	                height: that.ui.content.parent()[0].clientHeight
	            }).then(function (dataUrl) {
	                $.ajax({
	                    type: "POST",
	                    url: '/api/village-podiatry-form/' + that.payload.organization + '/' + that.payload.reviewer + '/' + that.payload.patientName.replace(" ", "_"),
	                    data: dataUrl.replace("data:image/png;base64,", ""),
	                    contentType: 'text/plain',
	                    statusCode: {
	                        200: function (response) {
	                            that.utils.hideSpinner();
	                            $.notify("Form created successfully", "success");
	                            Backbone.history.navigate('/documents?PERSON_REVIEW_REQUEST=' + that.payload.reviewer + '&object_status=IN_REVIEW', {trigger: true});
	                        }
	                    },
	                    error: function (e) {
	                        that.utils.hideSpinner();
	                        notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	                        restore();
	                    }
	                });
	            }).catch(function (error) {
	                console.error('oops, something went wrong!', error);
	                that.utils.hideSpinner();
	                restore();
	            });
	        },
	
	        showReviewerSelect: function (selected) {
	            var that = this;
	            that.reviewerSelectView = new RemoteSuggesterView({
	                maxNumberOfElements: 100,
	                url: '/api/person/preview?page-size=' + 100
	                    + '&sortby=name&like_name=~~~&object_isMd=true&object_mergeable=false',
	                symbolForSearchInUrl: '~~~',
	                listLocation: function (data) {
	                    return data.filter(function (item) {
	                        return item.object;
	                    });
	                },
	                getValueFn: function (element) {
	                    return element.name;
	                },
	                classes: ["form-control"],
	                placeholder: "Assigned Physician",
	                findSelectedIdBySelectedIndex: function (arr, index) {
	                    return (arr[index] || {}).id;
	                },
	                tag: 'reviewer',
	                defaultSelected: selected ? selected : null
	            });
	
	            that.showChildView('reviewerSelect', that.reviewerSelectView);
	        },
	
	        showOrganizationSelect: function (selected) {
	            var that = this;
	            that.orgSelectView = new RemoteSuggesterView({
	                maxNumberOfElements: 100,
	                url: '/api/organization/preview?page-size=' + 100
	                    + '&sortby=name&like_name=~~~',
	                symbolForSearchInUrl: '~~~',
	                listLocation: function (data) {
	                    return data.filter(function (item) {
	                        return item.object;
	                    });
	                },
	                getValueFn: function (element) {
	                    return element.name;
	                },
	                classes: ["form-control"],
	                placeholder: "Requesting Organization",
	                findSelectedIdBySelectedIndex: function (arr, index) {
	                    return (arr[index] || {}).id;
	                },
	                tag: 'organization',
	                defaultSelected: selected ? selected : null
	            });
	
	            that.showChildView('orgSelect', that.orgSelectView);
	        },
	
	        onReviewerSelected: function (selectedId) {
	            this.payload.reviewer = selectedId;
	        },
	
	        onOrganizationSelected: function (selectedId) {
	            this.payload.organization = selectedId;
	        },
	
	        showError: function (jQelement, text) {
	            jQelement.tooltip({title: text});
	            jQelement.parent().parent().addClass('has-error has-feedback');
	        },
	
	        clearError: function (jQelement) {
	            jQelement.tooltip("destroy");
	            jQelement.parent().parent().removeClass('has-error has-feedback');
	        }
	    })
	;
	
	module.exports = VillagePodiatryFormView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	(function(global) {
	    'use strict';
	
	    var util = newUtil();
	    var inliner = newInliner();
	    var fontFaces = newFontFaces();
	    var images = newImages();
	
	    // Default impl options
	    var defaultOptions = {
	        // Default is to fail on error, no placeholder
	        imagePlaceholder: undefined,
	        // Default cache bust is false, it will use the cache
	        cacheBust: false,
	        // Use (existing) authentication credentials for external URIs (CORS requests)
	        useCredentials: false
	    };
	
	    var domtoimage = {
	        toSvg: toSvg,
	        toPng: toPng,
	        toJpeg: toJpeg,
	        toBlob: toBlob,
	        toPixelData: toPixelData,
	        toCanvas: toCanvas,
	        impl: {
	            fontFaces: fontFaces,
	            images: images,
	            util: util,
	            inliner: inliner,
	            options: {}
	        }
	    };
	
	    if (true)
	        module.exports = domtoimage;
	    else
	        global.domtoimage = domtoimage;
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options
	     * @param {Function} options.filter - Should return true if passed node should be included in the output
	     *          (excluding node means excluding it's children as well). Not called on the root node.
	     * @param {String} options.bgcolor - color for the background, any valid CSS color value.
	     * @param {Number} options.width - width to be applied to node before rendering.
	     * @param {Number} options.height - height to be applied to node before rendering.
	     * @param {Object} options.style - an object whose properties to be copied to node's style before rendering.
	     * @param {Number} options.quality - a Number between 0 and 1 indicating image quality (applicable to JPEG only),
	                defaults to 1.0.
	     * @param {Number} options.scale - a Number multiplier to scale up the canvas before rendering to reduce fuzzy images, defaults to 1.0.
	     * @param {String} options.imagePlaceholder - dataURL to use as a placeholder for failed images, default behaviour is to fail fast on images we can't fetch
	     * @param {Boolean} options.cacheBust - set to true to cache bust by appending the time to the request url
	     * @return {Promise} - A promise that is fulfilled with a SVG image data URL
	     * */
	    function toSvg(node, options) {
	        options = options || {};
	        copyOptions(options);
	        return Promise.resolve(node)
	            .then(function(node) {
	                return cloneNode(node, options.filter, true);
	            })
	            .then(embedFonts)
	            .then(inlineImages)
	            .then(applyOptions)
	            .then(function(clone) {
	                return makeSvgDataUri(clone,
	                    options.width || util.width(node),
	                    options.height || util.height(node)
	                );
	            });
	
	        function applyOptions(clone) {
	            if (options.bgcolor) clone.style.backgroundColor = options.bgcolor;
	            if (options.width) clone.style.width = options.width + 'px';
	            if (options.height) clone.style.height = options.height + 'px';
	
	            if (options.style)
	                Object.keys(options.style).forEach(function(property) {
	                    clone.style[property] = options.style[property];
	                });
	
	            return clone;
	        }
	    }
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options, @see {@link toSvg}
	     * @return {Promise} - A promise that is fulfilled with a Uint8Array containing RGBA pixel data.
	     * */
	    function toPixelData(node, options) {
	        return draw(node, options || {})
	            .then(function(canvas) {
	                return canvas.getContext('2d').getImageData(
	                    0,
	                    0,
	                    util.width(node),
	                    util.height(node)
	                ).data;
	            });
	    }
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options, @see {@link toSvg}
	     * @return {Promise} - A promise that is fulfilled with a PNG image data URL
	     * */
	    function toPng(node, options) {
	        return draw(node, options || {})
	            .then(function(canvas) {
	                return canvas.toDataURL();
	            });
	    }
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options, @see {@link toSvg}
	     * @return {Promise} - A promise that is fulfilled with a JPEG image data URL
	     * */
	    function toJpeg(node, options) {
	        options = options || {};
	        return draw(node, options)
	            .then(function(canvas) {
	                return canvas.toDataURL('image/jpeg', options.quality || 1.0);
	            });
	    }
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options, @see {@link toSvg}
	     * @return {Promise} - A promise that is fulfilled with a PNG image blob
	     * */
	    function toBlob(node, options) {
	        return draw(node, options || {})
	            .then(util.canvasToBlob);
	    }
	
	    /**
	     * @param {Node} node - The DOM Node object to render
	     * @param {Object} options - Rendering options, @see {@link toSvg}
	     * @return {Promise} - A promise that is fulfilled with a canvas object
	     * */
	    function toCanvas(node, options) {
	        return draw(node, options || {});
	    }
	
	    function copyOptions(options) {
	        // Copy options to impl options for use in impl
	        if (typeof(options.imagePlaceholder) === 'undefined') {
	            domtoimage.impl.options.imagePlaceholder = defaultOptions.imagePlaceholder;
	        } else {
	            domtoimage.impl.options.imagePlaceholder = options.imagePlaceholder;
	        }
	
	        if (typeof(options.cacheBust) === 'undefined') {
	            domtoimage.impl.options.cacheBust = defaultOptions.cacheBust;
	        } else {
	            domtoimage.impl.options.cacheBust = options.cacheBust;
	        }
	
	        if(typeof(options.useCredentials) === 'undefined') {
	            domtoimage.impl.options.useCredentials = defaultOptions.useCredentials;
	        } else {
	            domtoimage.impl.options.useCredentials = options.useCredentials;
	        }
	    }
	
	    function draw(domNode, options) {
	        return toSvg(domNode, options)
	            .then(util.makeImage)
	            .then(util.delay(100))
	            .then(function(image) {
	                var scale = typeof(options.scale) !== 'number' ? 1 : options.scale;
	                var canvas = newCanvas(domNode, scale);
	                var ctx = canvas.getContext('2d');
	                if (image) {
	                    ctx.scale(scale, scale);
	                    ctx.drawImage(image, 0, 0);
	                }
	                return canvas;
	            });
	
	        function newCanvas(domNode, scale) {
	            var canvas = document.createElement('canvas');
	            canvas.width = (options.width || util.width(domNode)) * scale;
	            canvas.height = (options.height || util.height(domNode)) * scale;
	
	            if (options.bgcolor) {
	                var ctx = canvas.getContext('2d');
	                ctx.fillStyle = options.bgcolor;
	                ctx.fillRect(0, 0, canvas.width, canvas.height);
	            }
	
	            return canvas;
	        }
	    }
	
	    function cloneNode(node, filter, root) {
	        if (!root && filter && !filter(node)) return Promise.resolve();
	
	        return Promise.resolve(node)
	            .then(makeNodeCopy)
	            .then(function(clone) {
	                return cloneChildren(node, clone, filter);
	            })
	            .then(function(clone) {
	                return processClone(node, clone);
	            });
	
	        function makeNodeCopy(node) {
	            if (node instanceof HTMLCanvasElement) return util.makeImage(node.toDataURL());
	            return node.cloneNode(false);
	        }
	
	        function cloneChildren(original, clone, filter) {
	            var children = original.childNodes;
	            if (children.length === 0) return Promise.resolve(clone);
	
	            return cloneChildrenInOrder(clone, util.asArray(children), filter)
	                .then(function() {
	                    return clone;
	                });
	
	            function cloneChildrenInOrder(parent, children, filter) {
	                var done = Promise.resolve();
	                children.forEach(function(child) {
	                    done = done
	                        .then(function() {
	                            return cloneNode(child, filter);
	                        })
	                        .then(function(childClone) {
	                            if (childClone) parent.appendChild(childClone);
	                        });
	                });
	                return done;
	            }
	        }
	
	        function processClone(original, clone) {
	            if (!(clone instanceof Element)) return clone;
	
	            return Promise.resolve()
	                .then(cloneStyle)
	                .then(clonePseudoElements)
	                .then(copyUserInput)
	                .then(fixSvg)
	                .then(function() {
	                    return clone;
	                });
	
	            function cloneStyle() {
	                copyStyle(window.getComputedStyle(original), clone.style);
	
	                function copyStyle(source, target) {
	                    if (source.cssText) {
	                        target.cssText = source.cssText;
	                        target.font = source.font; // here, we re-assign the font prop.
	                    } else copyProperties(source, target);
	
	                    function copyProperties(source, target) {
	                        util.asArray(source).forEach(function(name) {
	                            target.setProperty(
	                                name,
	                                source.getPropertyValue(name),
	                                source.getPropertyPriority(name)
	                            );
	                        });
	                    }
	                }
	            }
	
	            function clonePseudoElements() {
	                [':before', ':after'].forEach(function(element) {
	                    clonePseudoElement(element);
	                });
	
	                function clonePseudoElement(element) {
	                    var style = window.getComputedStyle(original, element);
	                    var content = style.getPropertyValue('content');
	
	                    if (content === '' || content === 'none') return;
	
	                    var className = util.uid();
	                    var currentClass = clone.getAttribute('class');
	                    if (currentClass) {
	                        clone.setAttribute('class', currentClass + ' ' + className);
	                    }
	
	                    var styleElement = document.createElement('style');
	                    styleElement.appendChild(formatPseudoElementStyle(className, element, style));
	                    clone.appendChild(styleElement);
	
	                    function formatPseudoElementStyle(className, element, style) {
	                        var selector = '.' + className + ':' + element;
	                        var cssText = style.cssText ? formatCssText(style) : formatCssProperties(style);
	                        return document.createTextNode(selector + '{' + cssText + '}');
	
	                        function formatCssText(style) {
	                            var content = style.getPropertyValue('content');
	                            return style.cssText + ' content: ' + content + ';';
	                        }
	
	                        function formatCssProperties(style) {
	
	                            return util.asArray(style)
	                                .map(formatProperty)
	                                .join('; ') + ';';
	
	                            function formatProperty(name) {
	                                return name + ': ' +
	                                    style.getPropertyValue(name) +
	                                    (style.getPropertyPriority(name) ? ' !important' : '');
	                            }
	                        }
	                    }
	                }
	            }
	
	            function copyUserInput() {
	                if (original instanceof HTMLTextAreaElement) clone.innerHTML = original.value;
	                if (original instanceof HTMLInputElement) clone.setAttribute("value", original.value);
	            }
	
	            function fixSvg() {
	                if (!(clone instanceof SVGElement)) return;
	                clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	
	                if (!(clone instanceof SVGRectElement)) return;
	                ['width', 'height'].forEach(function(attribute) {
	                    var value = clone.getAttribute(attribute);
	                    if (!value) return;
	
	                    clone.style.setProperty(attribute, value);
	                });
	            }
	        }
	    }
	
	    function embedFonts(node) {
	        return fontFaces.resolveAll()
	            .then(function(cssText) {
	                var styleNode = document.createElement('style');
	                node.appendChild(styleNode);
	                styleNode.appendChild(document.createTextNode(cssText));
	                return node;
	            });
	    }
	
	    function inlineImages(node) {
	        return images.inlineAll(node)
	            .then(function() {
	                return node;
	            });
	    }
	
	    function makeSvgDataUri(node, width, height) {
	        return Promise.resolve(node)
	            .then(function(node) {
	                node.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
	                return new XMLSerializer().serializeToString(node);
	            })
	            .then(util.escapeXhtml)
	            .then(function(xhtml) {
	                return '<foreignObject x="0" y="0" width="100%" height="100%">' + xhtml + '</foreignObject>';
	            })
	            .then(function(foreignObject) {
	                return '<svg xmlns="http://www.w3.org/2000/svg" width="' + width + '" height="' + height + '">' +
	                    foreignObject + '</svg>';
	            })
	            .then(function(svg) {
	                return 'data:image/svg+xml;charset=utf-8,' + svg;
	            });
	    }
	
	    function newUtil() {
	        return {
	            escape: escape,
	            parseExtension: parseExtension,
	            mimeType: mimeType,
	            dataAsUrl: dataAsUrl,
	            isDataUrl: isDataUrl,
	            canvasToBlob: canvasToBlob,
	            resolveUrl: resolveUrl,
	            getAndEncode: getAndEncode,
	            uid: uid(),
	            delay: delay,
	            asArray: asArray,
	            escapeXhtml: escapeXhtml,
	            makeImage: makeImage,
	            width: width,
	            height: height
	        };
	
	        function mimes() {
	            /*
	             * Only WOFF and EOT mime types for fonts are 'real'
	             * see http://www.iana.org/assignments/media-types/media-types.xhtml
	             */
	            var WOFF = 'application/font-woff';
	            var JPEG = 'image/jpeg';
	
	            return {
	                'woff': WOFF,
	                'woff2': WOFF,
	                'ttf': 'application/font-truetype',
	                'eot': 'application/vnd.ms-fontobject',
	                'png': 'image/png',
	                'jpg': JPEG,
	                'jpeg': JPEG,
	                'gif': 'image/gif',
	                'tiff': 'image/tiff',
	                'svg': 'image/svg+xml'
	            };
	        }
	
	        function parseExtension(url) {
	            var match = /\.([^\.\/]*?)(\?|$)/g.exec(url);
	            if (match) return match[1];
	            else return '';
	        }
	
	        function mimeType(url) {
	            var extension = parseExtension(url).toLowerCase();
	            return mimes()[extension] || '';
	        }
	
	        function isDataUrl(url) {
	            return url.search(/^(data:)/) !== -1;
	        }
	
	        function toBlob(canvas) {
	            return new Promise(function(resolve) {
	                var binaryString = window.atob(canvas.toDataURL().split(',')[1]);
	                var length = binaryString.length;
	                var binaryArray = new Uint8Array(length);
	
	                for (var i = 0; i < length; i++)
	                    binaryArray[i] = binaryString.charCodeAt(i);
	
	                resolve(new Blob([binaryArray], {
	                    type: 'image/png'
	                }));
	            });
	        }
	
	        function canvasToBlob(canvas) {
	            if (canvas.toBlob)
	                return new Promise(function(resolve) {
	                    canvas.toBlob(resolve);
	                });
	
	            return toBlob(canvas);
	        }
	
	        function resolveUrl(url, baseUrl) {
	            var doc = document.implementation.createHTMLDocument();
	            var base = doc.createElement('base');
	            doc.head.appendChild(base);
	            var a = doc.createElement('a');
	            doc.body.appendChild(a);
	            base.href = baseUrl;
	            a.href = url;
	            return a.href;
	        }
	
	        function uid() {
	            var index = 0;
	
	            return function() {
	                return 'u' + fourRandomChars() + index++;
	
	                function fourRandomChars() {
	                    /* see http://stackoverflow.com/a/6248722/2519373 */
	                    return ('0000' + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
	                }
	            };
	        }
	
	        function makeImage(uri) {
	            if (uri === 'data:,') return Promise.resolve();
	            return new Promise(function(resolve, reject) {
	                var image = new Image();
	                if(domtoimage.impl.options.useCredentials) {
	                    image.crossOrigin = 'use-credentials';
	                }
	                image.onload = function() {
	                    resolve(image);
	                };
	                image.onerror = reject;
	                image.src = uri;
	            });
	        }
	
	        function getAndEncode(url) {
	            var TIMEOUT = 30000;
	            if (domtoimage.impl.options.cacheBust) {
	                // Cache bypass so we dont have CORS issues with cached images
	                // Source: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
	                url += ((/\?/).test(url) ? "&" : "?") + (new Date()).getTime();
	            }
	
	            return new Promise(function(resolve) {
	                var request = new XMLHttpRequest();
	
	                request.onreadystatechange = done;
	                request.ontimeout = timeout;
	                request.responseType = 'blob';
	                request.timeout = TIMEOUT;
	                if(domtoimage.impl.options.useCredentials) {
	                    request.withCredentials = true;
	                }
	                request.open('GET', url, true);
	                request.send();
	
	                var placeholder;
	                if (domtoimage.impl.options.imagePlaceholder) {
	                    var split = domtoimage.impl.options.imagePlaceholder.split(/,/);
	                    if (split && split[1]) {
	                        placeholder = split[1];
	                    }
	                }
	
	                function done() {
	                    if (request.readyState !== 4) return;
	
	                    if (request.status !== 200) {
	                        if (placeholder) {
	                            resolve(placeholder);
	                        } else {
	                            fail('cannot fetch resource: ' + url + ', status: ' + request.status);
	                        }
	
	                        return;
	                    }
	
	                    var encoder = new FileReader();
	                    encoder.onloadend = function() {
	                        var content = encoder.result.split(/,/)[1];
	                        resolve(content);
	                    };
	                    encoder.readAsDataURL(request.response);
	                }
	
	                function timeout() {
	                    if (placeholder) {
	                        resolve(placeholder);
	                    } else {
	                        fail('timeout of ' + TIMEOUT + 'ms occured while fetching resource: ' + url);
	                    }
	                }
	
	                function fail(message) {
	                    console.error(message);
	                    resolve('');
	                }
	            });
	        }
	
	        function dataAsUrl(content, type) {
	            return 'data:' + type + ';base64,' + content;
	        }
	
	        function escape(string) {
	            return string.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
	        }
	
	        function delay(ms) {
	            return function(arg) {
	                return new Promise(function(resolve) {
	                    setTimeout(function() {
	                        resolve(arg);
	                    }, ms);
	                });
	            };
	        }
	
	        function asArray(arrayLike) {
	            var array = [];
	            var length = arrayLike.length;
	            for (var i = 0; i < length; i++) array.push(arrayLike[i]);
	            return array;
	        }
	
	        function escapeXhtml(string) {
	            return string.replace(/#/g, '%23').replace(/\n/g, '%0A');
	        }
	
	        function width(node) {
	            var leftBorder = px(node, 'border-left-width');
	            var rightBorder = px(node, 'border-right-width');
	            return node.scrollWidth + leftBorder + rightBorder;
	        }
	
	        function height(node) {
	            var topBorder = px(node, 'border-top-width');
	            var bottomBorder = px(node, 'border-bottom-width');
	            return node.scrollHeight + topBorder + bottomBorder;
	        }
	
	        function px(node, styleProperty) {
	            var value = window.getComputedStyle(node).getPropertyValue(styleProperty);
	            return parseFloat(value.replace('px', ''));
	        }
	    }
	
	    function newInliner() {
	        var URL_REGEX = /url\(['"]?([^'"]+?)['"]?\)/g;
	
	        return {
	            inlineAll: inlineAll,
	            shouldProcess: shouldProcess,
	            impl: {
	                readUrls: readUrls,
	                inline: inline
	            }
	        };
	
	        function shouldProcess(string) {
	            return string.search(URL_REGEX) !== -1;
	        }
	
	        function readUrls(string) {
	            var result = [];
	            var match;
	            while ((match = URL_REGEX.exec(string)) !== null) {
	                result.push(match[1]);
	            }
	            return result.filter(function(url) {
	                return !util.isDataUrl(url);
	            });
	        }
	
	        function inline(string, url, baseUrl, get) {
	            return Promise.resolve(url)
	                .then(function(url) {
	                    return baseUrl ? util.resolveUrl(url, baseUrl) : url;
	                })
	                .then(get || util.getAndEncode)
	                .then(function(data) {
	                    return util.dataAsUrl(data, util.mimeType(url));
	                })
	                .then(function(dataUrl) {
	                    return string.replace(urlAsRegex(url), '$1' + dataUrl + '$3');
	                });
	
	            function urlAsRegex(url) {
	                return new RegExp('(url\\([\'"]?)(' + util.escape(url) + ')([\'"]?\\))', 'g');
	            }
	        }
	
	        function inlineAll(string, baseUrl, get) {
	            if (nothingToInline()) return Promise.resolve(string);
	
	            return Promise.resolve(string)
	                .then(readUrls)
	                .then(function(urls) {
	                    var done = Promise.resolve(string);
	                    urls.forEach(function(url) {
	                        done = done.then(function(string) {
	                            return inline(string, url, baseUrl, get);
	                        });
	                    });
	                    return done;
	                });
	
	            function nothingToInline() {
	                return !shouldProcess(string);
	            }
	        }
	    }
	
	    function newFontFaces() {
	        return {
	            resolveAll: resolveAll,
	            impl: {
	                readAll: readAll
	            }
	        };
	
	        function resolveAll() {
	            return readAll(document)
	                .then(function(webFonts) {
	                    return Promise.all(
	                        webFonts.map(function(webFont) {
	                            return webFont.resolve();
	                        })
	                    );
	                })
	                .then(function(cssStrings) {
	                    return cssStrings.join('\n');
	                });
	        }
	
	        function readAll() {
	            return Promise.resolve(util.asArray(document.styleSheets))
	                .then(getCssRules)
	                .then(selectWebFontRules)
	                .then(function(rules) {
	                    return rules.map(newWebFont);
	                });
	
	            function selectWebFontRules(cssRules) {
	                return cssRules
	                    .filter(function(rule) {
	                        return rule.type === CSSRule.FONT_FACE_RULE;
	                    })
	                    .filter(function(rule) {
	                        return inliner.shouldProcess(rule.style.getPropertyValue('src'));
	                    });
	            }
	
	            function getCssRules(styleSheets) {
	                var cssRules = [];
	                styleSheets.forEach(function(sheet) {
	                    if (sheet.hasOwnProperty("cssRules")) {
	                        try {
	                            util.asArray(sheet.cssRules || []).forEach(cssRules.push.bind(cssRules));
	                        } catch (e) {
	                            console.log('Error while reading CSS rules from ' + sheet.href, e.toString());
	                        }
	                    }
	                });
	                return cssRules;
	            }
	
	            function newWebFont(webFontRule) {
	                return {
	                    resolve: function resolve() {
	                        var baseUrl = (webFontRule.parentStyleSheet || {}).href;
	                        return inliner.inlineAll(webFontRule.cssText, baseUrl);
	                    },
	                    src: function() {
	                        return webFontRule.style.getPropertyValue('src');
	                    }
	                };
	            }
	        }
	    }
	
	    function newImages() {
	        return {
	            inlineAll: inlineAll,
	            impl: {
	                newImage: newImage
	            }
	        };
	
	        function newImage(element) {
	            return {
	                inline: inline
	            };
	
	            function inline(get) {
	                if (util.isDataUrl(element.src)) return Promise.resolve();
	
	                return Promise.resolve(element.src)
	                    .then(get || util.getAndEncode)
	                    .then(function(data) {
	                        return util.dataAsUrl(data, util.mimeType(element.src));
	                    })
	                    .then(function(dataUrl) {
	                        return new Promise(function(resolve, reject) {
	                            element.onload = resolve;
	                            // for any image with invalid src(such as <img src />), just ignore it
	                            element.onerror = resolve;
	                            element.src = dataUrl;
	                        });
	                    });
	            }
	        }
	
	        function inlineAll(node) {
	            if (!(node instanceof Element)) return Promise.resolve(node);
	
	            return inlineBackground(node)
	                .then(function() {
	                    if (node instanceof HTMLImageElement)
	                        return newImage(node).inline();
	                    else
	                        return Promise.all(
	                            util.asArray(node.childNodes).map(function(child) {
	                                return inlineAll(child);
	                            })
	                        );
	                });
	
	            function inlineBackground(node) {
	                var background = node.style.getPropertyValue('background');
	
	                if (!background) return Promise.resolve(node);
	
	                return inliner.inlineAll(background)
	                    .then(function(inlined) {
	                        node.style.setProperty(
	                            'background',
	                            inlined,
	                            node.style.getPropertyPriority('background')
	                        );
	                    })
	                    .then(function() {
	                        return node;
	                    });
	            }
	        }
	    }
	})(this);


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="col-md-offset-2 col-xs-offset-2 col-md-8 col-xs-8">\n    <div id="village-podiatry-content" style="padding: 20px 20px 20px 50px;">\n        <h2 class="center">Physician Orders</h2>\n\n        <div class="form form-horizontal top-margined">\n            <div class="form-group col-md-12 col-xs-12">\n                <label for="patient-name" class="col-md-2 col-xs-2" style="padding: 6px 12px;">Patient Name</label>\n                <div class="col-md-10 col-xs-10">\n                    <input type="text" id="patient-name" class="form-control"/>\n                </div>\n            </div>\n            <div class="form-group col-md-12 col-xs-12">\n                <label for="patient-mrn" class="col-md-1 col-xs-1" style="padding: 6px 12px;">MRN</label>\n                <div class="col-md-5 col-xs-5">\n                    <input type="text" id="patient-mrn" class="form-control"/>\n                </div>\n                <label for="patient-dob" class="col-md-1 col-xs-1" style="padding: 6px 12px;">DOB</label>\n                <div class="col-md-5 col-xs-5">\n                    <input type="text" id="patient-dob" class="form-control"/>\n                </div>\n            </div>\n            <div class="form-group col-md-12 col-xs-12 top-margined center">\n                <i>Please see the below orders for <br>home health skilled nursing for wound care.</i>\n            </div>\n            <div class="form-group col-md-12 col-xs-12 top-margined">\n                <div style="padding: 6px 12px;"><b>Please change the dressings on the following days:</b></div>\n            </div>\n            <div class="form-group col-md-12 col-xs-12">\n                ';
	 _.each(days, function(day){ 
	__p+='\n                <label class="checkbox" style="margin-left: 50px;float: left;font-weight: normal;"><input type="checkbox" id="'+
	((__t=( day ))==null?'':__t)+
	'" class="day-select" name="'+
	((__t=( day ))==null?'':__t)+
	'"/>'+
	((__t=( day ))==null?'':__t)+
	'</label>\n                ';
	 }) 
	__p+='\n            </div>\n            <div class="form-group col-md-12 col-xs-12 top-margined">\n                <div style="padding: 6px 12px;"><b>The following supplies are needed:</b></div>\n            </div>\n            ';
	 _.each(supplies, function(supply, index){ 
	__p+='\n            ';
	 if (index % 3 == 0) { 
	__p+='\n            <div class="form-group col-md-12 col-xs-12" style="margin-left: 15px;">\n                <label class="checkbox col-md-4 col-xs-4" style="font-weight: normal;"><input type="checkbox" id="'+
	((__t=( supply.replace(' ', '') ))==null?'':__t)+
	'" class="supply-select" name="'+
	((__t=( supply ))==null?'':__t)+
	'"/>'+
	((__t=( supply ))==null?'':__t)+
	'</label>\n                ';
	 } else { 
	__p+='\n                <label class="checkbox col-md-4 col-xs-4" style="font-weight: normal;"><input type="checkbox" id="'+
	((__t=( supply.replace(' ', '') ))==null?'':__t)+
	'" class="supply-select" name="'+
	((__t=( supply ))==null?'':__t)+
	'"/>'+
	((__t=( supply ))==null?'':__t)+
	'</label>\n                ';
	 } 
	__p+='\n                ';
	 if (index % 3 == 2) { 
	__p+='\n            </div>\n            ';
	 } 
	__p+='\n            ';
	 }) 
	__p+='\n            <div class="form-group col-md-12 col-xs-12 top-margined">\n                <div style="padding: 6px 12px;"><b>Apply as directed below:</b></div>\n            </div>\n            <div class="form-group col-md-12 col-xs-12">\n                <textarea id="comment" class="form-control" rows="5"></textarea>\n            </div>\n            <div class="form-group col-md-12 col-xs-12 top-margined">\n                <div class="col-md-5 col-xs-5">\n                    <div>\n                        <b>Location</b><br>\n                        3200 Highlands Parkway, Suite 100<br>\n                        Smyrna, GA 30082<br>\n                    </div>\n                    <div class="top-margined">\n                        <b>Contact Information</b><br>\n                        Phone: (770) 319-5502<br>\n                        Fax: (770) 481-4452<br>\n                    </div>\n                </div>\n                <div class="col-md-7 col-xs-7">\n                    <div>\n                        <b>For questions or concerns, please reach out to the following: </b>\n                    </div>\n                    <div class="top-margined">\n                        Carlos Cruz: Ext 14317<br>\n                        Medical Assistant\n                    </div>\n                    <div class="top-margined">Silvia Fung, Ext: 14312<br>\n                        Surgery & Front Office Coordinator\n                    </div>\n                </div>\n            </div>\n            <div class="form-group col-md-12 col-xs-12 top-margined" id="form-footer" style="margin-bottom: 100px;">\n                <div class="col-xs-4 col-md-4">\n                    <div id="reviewer-select"></div>\n                </div>\n                <div class="col-xs-4 col-md-4">\n                    <div id="organization-select"></div>\n                </div>\n                <div class="col-xs-2 col-md-2">\n                    <button class="btn btn-primary" id="create">Save</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var RemoteSuggesterView = __webpack_require__(196);
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var Radio = __webpack_require__(183);
	var services = Radio.channel('services');
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	var domtoimage = __webpack_require__(519);
	
	var FaceToFaceFormView = Marionette.View.extend({
	        template: __webpack_require__(522),
	
	        regions: {
	            languageSelect: '#language-select',
	            stateSelect: '#state-select',
	            reviewerSelect: '#reviewer-select',
	            reqOrgSelect: '#req-org-select'
	        },
	
	        ui: {
	            hospitalInformation: '#hospital-information',
	            patientDemographics: '#patient-demographics',
	            emergencyContact: '#emergency-contact',
	            insuranceInformation: '#insurance-information',
	            medicalInformationContent: '#medical-information-content',
	            admissionDate: '#admission-date',
	            dischargeDate: '#discharge-date',
	            hospitalInput: '.hospital-input',
	            hospitalEmail: '#hospital-email',
	            hospitalPhone: '#hospital-phone',
	            dob: '#dob',
	            ssn: '#ssn',
	            suffix: '#suffix',
	            sex: '#sex',
	            martialStatus: "#martial-status",
	            address: '#address',
	            city: "#city",
	            zip: '#zip',
	            personPhone: '#person-phone',
	            personEmail: '#person-email',
	            primaryContactName: '#primary-contact-name',
	            primaryContactRelationship: '#primary-contact-rel',
	            primaryContactPhone: '#primary-contact-phone',
	
	            diagnosisSearchText: '#search-text',
	            diagnosisSearchButton: '#search-button',
	            diagnosisTable: '#diagnosis',
	            selectedDiagnosisTable: '#selected-diagnosis',
	            surgeriesTable: '#surgeries',
	            addSurgery: '#add-surgery',
	
	            diet: '#diet',
	            allergies: '#allergies',
	            briefMedicalHistory: '#brief-medical-history',
	            complications: '#complications',
	            clinicalIndication: '#clinical-indication',
	            orders: '#orders',
	            suggestedFrequency: '#suggested-frequency',
	            ffDataInput: ".ff-data",
	            phoneNumber: '#phone-number',
	
	            languageSelectContent: '#language-select',
	            selectedLanguages: '#selected-languages',
	
	            primaryCarePhysicianInput: '.primary-care-physician-input',
	            dateOfNextVisit: '#date-of-next-visit',
	
	            referralChb: '.referral-chb',
	            reasonChb: '.reason-chb',
	
	            faceToFaceDate: '#ff-date',
	
	            create: '#create',
	            update: '#update',
	            sign: '#sign',
	            back: '#back'
	        },
	
	        events: {
	            'click @ui.create': 'onCreate',
	            'click @ui.update': 'onUpdate',
	            'click @ui.sign': 'onSign',
	            'click @ui.back': 'onBackToList',
	            'change @ui.hospitalInput': 'onChangeHospitalInput',
	            'change @ui.hospitalPhone': 'onHospitalPhoneChanged',
	            'change @ui.hospitalEmail': 'onHospitalEmailChanged',
	            'change .simple-input': 'onChangeSimpleInput',
	            'change @ui.address': 'onChangeAddress',
	            'change @ui.city': 'onChangeAddress',
	            'change @ui.zip': 'onChangeAddress',
	            'change @ui.personPhone': 'onPersonPhoneChanged',
	            'change @ui.personEmail': 'onPersonEmailChanged',
	            'change @ui.ssn': 'onSsnChange',
	            'change .primary-contact': 'onChangePrimaryContact',
	            'change @ui.primaryContactPhone': 'onPrimaryContactPhoneChanged',
	
	            'keyup @ui.diagnosisSearchText': 'searchDiagnosis',
	            'click @ui.diagnosisSearchButton': 'searchDiagnosis',
	            'click .remove-diagnosis': 'onRemoveDiagnosis',
	            'change @ui.diet': 'onChangeDiet',
	            'change @ui.allergies': 'onChangeAllergies',
	            'change @ui.briefMedicalHistory': 'onChangeBriefMedicalHistory',
	            'change @ui.complications': 'onChangeComplications',
	            'change @ui.ffDataInput': 'onChangeFfDataInput',
	            'change @ui.phoneNumber': 'onPhoneNumberChanged',
	
	            'click .language-primary': 'setLanguageAsPrimary',
	            'click .remove-language': 'removeLanguage',
	
	            'click @ui.addSurgery': 'addSurgery',
	            'click .remove-surgery': 'onRemoveSurgery',
	
	            'change @ui.primaryCarePhysicianInput': "onChangePrimaryCarePhysicianInput",
	
	            'change @ui.referralChb': 'onReferralTypeCheck',
	            'change @ui.reasonChb': 'onReasonCheck'
	        },
	
	        childViewEvents: {
	            'suggestor:selected:language': 'onSelectLanguage',
	            'suggestor:selected:state': 'onSelectState',
	            'suggestor:selected:reviewer': 'onReviewerSelected',
	            'suggestor:selected:req-org': 'onReqOrgSelected'
	        },
	
	        primaryLanguageColor: '#337ab7',
	        secondaryLanguageColor: '#afc7dc',
	
	        initialize: function (options) {
	            var that = this;
	            that.utils = new CommonUtils();
	            if (options.model)
	                this.data = options.model;
	            else
	                this.data = null;
	
	            this.mode = that.data ? "edit" : "add";
	            this.currentUser = options.currentUser;
	
	            this.medProfile = options.medProfile;
	
	            that.initReferralFormData();
	            that.servicesAddresses = services.request('get:services:address');
	
	            window.setTimeout(function () {
	                if (_.isUndefined(that.servicesAddresses))
	                    that.servicesAddresses = services.request('get:services:address');
	            }, 1000);
	        },
	
	        templateContext: function () {
	            var that = this;
	            var hospitalEmail = that.ffForm && that.ffForm.data && that.ffForm.data.hospital && that.ffForm.data.hospital.hospitalContacts
	                ? _.find(that.ffForm.data.hospital.hospitalContacts, function (contact) {
	                    return contact.type == 'EMAIL';
	                }) : "";
	            var hospitalPhone = that.ffForm && that.ffForm.data && that.ffForm.data.hospital && that.ffForm.data.hospital.hospitalContacts
	                ? _.find(that.ffForm.data.hospital.hospitalContacts, function (contact) {
	                    return contact.type == 'PHONE';
	                }) : "";
	            var patientEmail = that.ffForm && this.ffForm.person && this.ffForm.person.contacts
	                ? _.find(this.ffForm.person.contacts, function (contact) {
	                    return contact.type == 'EMAIL';
	                }) : "";
	            var patientPhone = that.ffForm && this.ffForm.person && this.ffForm.person.contacts
	                ? _.find(this.ffForm.person.contacts, function (contact) {
	                    return contact.type == 'PHONE';
	                }) : "";
	            var primaryContactPhone = that.ffForm && this.ffForm.person && this.ffForm.person.primaryContacts && this.ffForm.person.primaryContacts[0].contacts
	                ? _.find(this.ffForm.person.primaryContacts[0].contacts, function (contact) {
	                    return contact.type == 'PHONE';
	                }) : "";
	            return {
	                martialStatuses: that.utils.martialStatuses(),
	                hospitalName: "Grady Memorial Hospital",
	                mode: that.mode,
	                userCanUpdate: that.data && (that.data.createdBy.id == that.currentUser || that.data.reviewer.id == that.currentUser),
	                userCanSign: that.data && that.data.reviewer.id == that.currentUser,
	
	                ffForm: that.ffForm,
	                patientAddress: that.patientAddress,
	                hospitalEmail: hospitalEmail ? hospitalEmail.data : "",
	                hospitalPhone: hospitalPhone ? hospitalPhone.data : "",
	                patientEmail: patientEmail ? patientEmail.data : "",
	                patientPhone: patientPhone ? patientPhone.data : "",
	                primaryContacts: this.ffForm && this.ffForm.person && this.ffForm.person.primaryContacts
	                    ? this.ffForm.person.primaryContacts[0] : {},
	                primaryContactPhone: primaryContactPhone ? primaryContactPhone.data : "",
	                primaryPhysician: this.ffForm && this.ffForm.person ? this.ffForm.person.primaryPhysician : {},
	                referralTypes: this.ffForm && this.ffForm.data ? this.ffForm.data.referralTypes : [],
	                reasons: this.ffForm && this.ffForm.data ? this.ffForm.data.reasons : []
	            }
	        },
	
	        initReferralFormData: function () {
	
	            var that = this;
	
	            if (!this.data) {
	                this.ffForm = {
	                    person: {
	                        addresses: [{
	                            uuid: this.utils.generatedUUID(),
	                            country: "US",
	                            state: "",
	                            county: "",
	                            zip: "",
	                            town: "",
	                            address: "",
	                            usage: "WP"
	                        }],
	                        languages: [],
	                        contacts: [],
	                        primaryContacts: [
	                            {
	                                contacts: []
	                            }
	                        ],
	                        primaryPhysician: {
	                            name: "",
	                            relationship: "",
	                            dateOfNextVisit: 0,
	                            locationOfNextVisit: ""
	                        }
	                    },
	                    medProfile: {
	                        diseases: [],
	                        surgeries: [],
	                        diet: "",
	                        allergy: "",
	                        briefMedicalHistory: "",
	                        complication: ""
	                    },
	                    data: {
	                        hospital: {
	                            name: "Grady Memorial Hospital",
	                            hospitalContacts: []
	                        },
	                        referralTypes: [],
	                        reasons: []
	                    },
	                    reviewer: null,
	                    requestingOrg: null
	                }
	
	                this.patientAddress = this.ffForm.person.addresses[0];
	
	            } else {
	
	                this.ffForm = {
	                    person: _.omit(this.data.patient.object, "@class"),
	                    medProfile: that.medProfile,
	                    data: this.data.data,
	                    reviewer: this.data.reviewer ? this.data.reviewer.id : null
	                }
	
	                this.patientAddress = this.ffForm.person.addresses[0];
	            }
	        },
	
	        onRender: function () {
	            window.document.title = "Face to face form";
	            var that = this;
	
	            var now = new Date();
	
	            that.ui.hospitalInformation.collapse("show");
	            that.ui.patientDemographics.collapse("show");
	            that.ui.emergencyContact.collapse("show");
	            that.ui.insuranceInformation.collapse("show");
	            that.ui.medicalInformationContent.collapse("show");
	
	            that.ui.admissionDate.datepicker({
	                format: 'mm/dd/yyyy',
	                clearBtn: true
	            }).on('changeDate', function (e) {
	                $(this).datepicker('hide');
	                that.ffForm.data.hospital.admissionDate = that.utils.dateToLong(e.target.value);
	            }).on('clearDate', function (e) {
	                that.ffForm.data.hospital.admissionDate = 0;
	            });
	            if (that.mode == 'add') {
	                that.ui.admissionDate.datepicker('update', now);
	                that.ffForm.data.hospital.admissionDate = that.utils.dateToLong(now);
	            } else {
	                if (that.ffForm.data.hospital) {
	                    that.ui.admissionDate.datepicker('update', that.utils.longToDateTimeFormatted(that.ffForm.data.hospital.admissionDate, 'MM/DD/YYYY'));
	                }
	            }
	
	            that.ui.dischargeDate.datepicker({
	                format: 'mm/dd/yyyy',
	                clearBtn: true
	            }).on('changeDate', function (e) {
	                $(this).datepicker('hide');
	                that.ffForm.data.hospital.dischargeDate = that.utils.dateToLong(e.target.value);
	            }).on('clearDate', function (e) {
	                that.ffForm.data.hospital.dischargeDate = 0;
	            });
	
	            if (that.mode == 'edit' && that.ffForm.data.hospital) {
	                that.ui.dischargeDate.datepicker('update', that.utils.longToDateTimeFormatted(that.ffForm.data.hospital.dischargeDate, 'MM/DD/YYYY'));
	            }
	
	            that.ui.dob.datepicker({
	                format: 'mm/dd/yyyy',
	                clearBtn: true
	            }).on('changeDate', function (e) {
	                $(this).datepicker('hide');
	                that.ffForm.person.birthData = that.utils.dateToLong(e.target.value);
	            }).on('clearDate', function (e) {
	                that.ffForm.person.birthData = 0;
	            });
	
	            if (that.mode == 'edit' && that.ffForm.person) {
	                that.ui.dob.datepicker('update', that.utils.longToDateTimeFormatted(that.ffForm.person.birthData, 'MM/DD/YYYY'));
	            }
	
	            that.ui.dateOfNextVisit.datepicker({
	                format: 'mm/dd/yyyy',
	                clearBtn: true
	            }).on('changeDate', function (e) {
	                $(this).datepicker('hide');
	                that.ffForm.person.primaryPhysician.dateOfNextVisit = that.utils.dateToLong(e.target.value);
	            }).on('clearDate', function (e) {
	                that.ffForm.person.primaryPhysician.dateOfNextVisit = 0;
	            });
	
	            if (that.mode == 'edit' && that.ffForm.person && that.ffForm.person.primaryPhysician) {
	                that.ui.dateOfNextVisit.datepicker('update', that.utils.longToDateTimeFormatted(that.ffForm.person.primaryPhysician.dateOfNextVisit, 'MM/DD/YYYY'));
	            }
	
	            that.ui.faceToFaceDate.datepicker({
	                format: 'mm/dd/yyyy',
	                clearBtn: true
	            }).on('changeDate', function (e) {
	                $(this).datepicker('hide');
	                that.ffForm.data.faceToFaceDate = that.utils.dateToLong(e.target.value);
	            }).on('clearDate', function (e) {
	                that.ffForm.data.faceToFaceDate = 0;
	            });
	
	            if (that.mode == 'edit' && that.ffForm.data && that.ffForm.data.faceToFaceDate) {
	                that.ui.faceToFaceDate.datepicker('update', that.utils.longToDateTimeFormatted(that.ffForm.data.faceToFaceDate, 'MM/DD/YYYY'));
	            }
	
	            var sexSelectize = this.ui.sex.selectize({
	                allowEmptyOption: false
	            });
	
	            var suffixSelectize = this.ui.suffix.selectize({
	                allowEmptyOption: false
	            });
	
	            var martialStatusSelectize = this.ui.martialStatus.selectize({
	                allowEmptyOption: false
	            });
	
	            that.ui.hospitalPhone.mask("(999) 999-9999", {
	                autoclear: false,
	                completed: function () {
	                    that.clearError(this);
	                    that.contactChange(that.ffForm.data.hospital, "hospitalContacts", this.val(), 'PHONE');
	                }
	            });
	            that.ui.ssn.mask("999-99-9999", {
	                autoclear: false,
	                completed: function () {
	                    that.clearError(this);
	                    that.ffForm.person["ssn"] = this.val();
	                }
	            });
	            that.ui.personPhone.mask("(999) 999-9999", {
	                autoclear: false,
	                completed: function () {
	                    that.clearError(this);
	                    that.onContactChanged("contacts", this.val(), 'PHONE');
	                }
	            });
	            that.ui.primaryContactPhone.mask("(999) 999-9999", {
	                autoclear: false,
	                completed: function () {
	                    that.clearError(this);
	                    that.primaryContactPhoneChange(this.val());
	                }
	            });
	            that.ui.phoneNumber.mask("(999) 999-9999", {
	                autoclear: false,
	                completed: function () {
	                    that.clearError(this);
	                    that.ffForm.data.phoneNumber = this.val();
	                }
	            });
	
	            that.showlanguageSelect();
	            that.showStateSelect();
	            that.showReviewerSelect();
	            that.showReqOrgSelect();
	
	            that.initLanguages(that.ffForm.person.languages);
	            that.initDiseases(that.ffForm.medProfile.diseases);
	            that.initSurgeries(this.ffForm.medProfile.surgeries);
	
	            that.disableSeparateFields();
	        },
	
	        disableSeparateFields: function () {
	            var that = this;
	            window.setTimeout(function () {
	                //that.ui.countrySelect.find('#country').attr('disabled', true);
	            }, 500);
	        },
	
	        onChangeHospitalInput: function (event) {
	            var name = event.target.name;
	            if (true) {
	
	            }
	            this.ffForm.data.hospital[name] = event.target.value;
	        },
	
	        onChangeSimpleInput: function (event) {
	            this.ffForm.person[event.target.name] = event.target.value;
	        },
	
	        onChangePrimaryCarePhysicianInput: function (event) {
	            this.ffForm.person.primaryPhysician[event.target.name] = event.target.value;
	        },
	
	        onHospitalPhoneChanged: function (event) {
	            if (event.target.value.indexOf('_') > -1) {
	                this.showError($(event.target), "Uncompleted");
	                this.contactChange(this.ffForm.data.hospital, "hospitalContacts", '', 'PHONE');
	            } else if (_.isEmpty(event.target.value)) {
	                this.clearError($(event.target));
	                this.contactChange(this.ffForm.data.hospital, "hospitalContacts", '', 'PHONE');
	            }
	        },
	
	        onHospitalEmailChanged: function (event) {
	            var val = event.target.value;
	            if (this.utils.isValidEmail(val) || _.isEmpty(val)) {
	                this.contactChange(this.ffForm.data.hospital, "hospitalContacts", val, 'EMAIL');
	                this.clearError($(event.target));
	            } else {
	                this.contactChange(this.ffForm.data.hospital, "hospitalContacts", '', 'EMAIL');
	                this.showError($(event.target), "Invalid e-mail");
	            }
	        },
	
	        onPersonPhoneChanged: function (event) {
	
	            if (event.target.value.indexOf('_') > -1) {
	                this.showError($(event.target), "Uncompleted");
	                this.onContactChanged("contacts", '', 'PHONE');
	            } else if (_.isEmpty(event.target.value)) {
	                this.clearError($(event.target));
	                this.onContactChanged("contacts", '', 'PHONE');
	            }
	        },
	
	        onSsnChange: function (event) {
	
	            if (event.target.value.indexOf('_') > -1) {
	                this.showError($(event.target), "Uncompleted");
	                this.ffForm.person["ssn"] = "";
	            } else if (_.isEmpty(event.target.value)) {
	                this.clearError($(event.target));
	                this.ffForm.person["ssn"] = "";
	            }
	        },
	
	        onPersonEmailChanged: function (event) {
	            var val = event.target.value;
	            if (this.utils.isValidEmail(val) || _.isEmpty(val)) {
	                this.onContactChanged("contacts", val, 'EMAIL');
	                this.clearError($(event.target));
	            } else {
	                this.onContactChanged("contacts", '', 'EMAIL');
	                this.showError($(event.target), "Invalid e-mail");
	            }
	        },
	
	        onContactChanged: function (contactField, val, contactType) {
	            if (_.isEmpty(val)) {
	                this.ffForm.person[contactField] = this.ffForm.person[contactField].filter(function (contact) {
	                    return contact.type != contactType;
	                });
	            } else {
	                if (_.isUndefined(_.findWhere(this.ffForm.person[contactField], {type: contactType})))
	                    this.ffForm.person[contactField].push({
	                        data: val,
	                        type: contactType
	                    });
	                else
	                    this.ffForm.person[contactField].forEach(function (contact) {
	                        if (contact.type == contactType)
	                            contact.data = val;
	                    });
	            }
	        },
	
	        contactChange: function (target, contactField, val, contactType) {
	            if (_.isEmpty(val)) {
	                target[contactField] = target[contactField].filter(function (contact) {
	                    return contact.type != contactType;
	                });
	            } else {
	                if (_.isUndefined(_.findWhere(target[contactField], {type: contactType})))
	                    target[contactField].push({
	                        data: val,
	                        type: contactType
	                    });
	                else
	                    target[contactField].forEach(function (contact) {
	                        if (contact.type == contactType)
	                            contact.data = val;
	                    });
	            }
	        },
	
	        onChangeAddress: function () {
	            this.rebuildAddress();
	        },
	
	        onSelectState: function (selected) {
	            this.rebuildAddress();
	        },
	
	        onReviewerSelected: function (selectedId) {
	            this.ffForm.reviewer = selectedId;
	        },
	
	        onReqOrgSelected: function (selectedId) {
	            this.ffForm.requestingOrg = selectedId;
	        },
	
	        rebuildAddress: function () {
	            var address = this.ui.address.val();
	            var city = this.ui.city.val();
	            var state = this.getChildView('stateSelect').getSelectedId();
	            var zip = this.ui.zip.val();
	
	            this.patientAddress.address = address;
	            this.patientAddress.town = city;
	            this.patientAddress.state = state;
	            this.patientAddress.zip = zip;
	        },
	
	        onChangePrimaryContact: function (event) {
	            this.ffForm.person.primaryContacts[0][event.target.name] = event.target.value;
	        },
	
	        onPrimaryContactPhoneChanged: function (event) {
	            if (event.target.value.indexOf('_') > -1) {
	                this.showError($(event.target), "Uncompleted");
	                this.primaryContactPhoneChange('');
	            } else if (_.isEmpty(event.target.value)) {
	                this.clearError($(event.target));
	                this.primaryContactPhoneChange('');
	            }
	        },
	
	        onPhoneNumberChanged: function (event) {
	            if (event.target.value.indexOf('_') > -1) {
	                this.showError($(event.target), "Uncompleted");
	                this.ffForm.data.phoneNumber = "";
	            } else if (_.isEmpty(event.target.value)) {
	                this.clearError($(event.target));
	                this.ffForm.data.phoneNumber = "";
	            }
	        },
	
	        primaryContactPhoneChange: function (val) {
	            var contactType = 'PHONE';
	            if (_.isEmpty(val)) {
	                this.ffForm.person.primaryContacts[0].contacts = this.ffForm.person.primaryContacts[0].contacts.filter(function (contact) {
	                    return contact.type != contactType;
	                });
	            } else {
	                if (_.isUndefined(_.findWhere(this.ffForm.person.primaryContacts[0].contacts, {type: contactType})))
	                    this.ffForm.person.primaryContacts[0].contacts.push({
	                        data: val,
	                        type: contactType
	                    });
	                else
	                    this.ffForm.person.primaryContacts[0].contacts.forEach(function (contact) {
	                        if (contact.type == contactType)
	                            contact.data = val;
	                    });
	            }
	        },
	
	        validateReferralForm: function () {
	
	            if (this.getErrorsCount() > 0)
	                return "Some fields with errors";
	
	            if (_.isEmpty(this.ffForm.person.firstName || _.isEmpty(this.ffForm.person.lastName)))
	                return 'Please, fill first name and last name of Patient';
	
	            if (_.isEmpty(this.ffForm.reviewer)) {
	                return 'Please, select Reviewer';
	            }
	
	            return "";
	        },
	
	        getErrorsCount: function () {
	            return this.$el.find('.has-error').length;
	        },
	
	        onCreate: function () {
	            var that = this;
	
	            var errorText = that.validateReferralForm();
	            if (!_.isEmpty(errorText)) {
	                notificationsChannel.request('show:notification', errorText);
	                return;
	            }
	
	            console.log(that.ffForm);
	
	            that.utils.showSpinner();
	            $.ajax({
	                type: "POST",
	                url: '/api/face-to-face-form',
	                data: JSON.stringify(that.ffForm),
	                contentType: 'application/json',
	                statusCode: {
	                    200: function (response) {
	                        that.utils.hideSpinner();
	                        $.notify("Face-to-Face Form created successfully", "success");
	                        Backbone.history.navigate('/ff-forms', {trigger: true});
	                    }
	                },
	                error: function (e) {
	                    that.utils.hideSpinner();
	                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	                }
	            });
	        },
	
	        onUpdate: function () {
	            var that = this;
	
	            var errorText = that.validateReferralForm();
	            if (!_.isEmpty(errorText)) {
	                notificationsChannel.request('show:notification', errorText);
	                return;
	            }
	
	            console.log(that.ffForm);
	
	            that.utils.showSpinner();
	            $.ajax({
	                type: "PUT",
	                url: '/api/face-to-face-form/' + this.data.id,
	                data: JSON.stringify(that.ffForm),
	                contentType: 'application/json',
	                statusCode: {
	                    200: function (response) {
	                        that.utils.hideSpinner();
	                        $.notify("Face-to-Face Form updated successfully", "success");
	                        Backbone.history.navigate('/ff-forms', {trigger: true});
	                    }
	                },
	                error: function (e) {
	                    that.utils.hideSpinner();
	                    notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	                }
	            });
	        },
	
	        onSign: function () {
	            var that = this;
	            that.utils.showSpinner();
	            var element = document.getElementById("buttons");
	            var removedChildButtons = [];
	            while (element.firstChild) {
	                removedChildButtons.push(element.removeChild(element.firstChild));
	            }
	
	            var restoreButtons = function () {
	                removedChildButtons.forEach(function (buttonEl) {
	                    element.appendChild(buttonEl);
	                });
	            }
	
	            domtoimage.toPng(document.getElementById('face-to-face-form-container'), {bgcolor: '#FFFFFF', width: '1500'})
	                .then(function (dataUrl) {
	                    $.ajax({
	                        type: "POST",
	                        url: '/api/face-to-face-form/sign/' + that.data.id,
	                        data: dataUrl.replace("data:image/png;base64,", ""),
	                        contentType: 'text/plain',
	                        statusCode: {
	                            200: function (response) {
	                                that.utils.hideSpinner();
	                                $.notify("Face-to-Face Form signed successfully", "success");
	                                Backbone.history.navigate('/ff-forms', {trigger: true});
	                            }
	                        },
	                        error: function (e) {
	                            that.utils.hideSpinner();
	                            notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	                            restoreButtons();
	                        }
	                    });
	                })
	                .catch(function (error) {
	                    console.error('oops, something went wrong!', error);
	                    that.utils.hideSpinner();
	                    restoreButtons();
	                });
	            /*
	                        return;
	
	                        domtoimage.toBlob(document.getElementById('face-to-face-form-container'), {bgcolor: '#FFFFFF', width: '1200'})
	                            .then(function (blob) {
	                                console.log(blob);
	
	                                var a = document.createElement("a");
	                                document.body.appendChild(a);
	                                a.style = "display: none";
	                                var url = window.URL.createObjectURL(blob);
	                                a.href = url;
	                                a.download = name;
	                                a.click();
	                                window.URL.revokeObjectURL(url);
	
	                                var fileReader = new FileReader();
	                                fileReader.onload = function (event) {
	                                    var result = event.target.result;
	                                    console.log(result);
	                                    that.utils.showSpinner();
	
	                                    $.ajax({
	                                        type: "POST",
	                                        url: '/api/face-to-face-form/sign/' + that.data.id,
	                                        data: result,
	                                        contentType: 'application/octet-stream',
	                                        statusCode: {
	                                            200: function (response) {
	                                                that.utils.hideSpinner();
	                                                $.notify("Face-to-Face Form signed successfully", "success");
	                                                Backbone.history.navigate('/ff-forms', {trigger: true});
	                                            }
	                                        },
	                                        error: function (e) {
	                                            that.utils.hideSpinner();
	                                            notificationsChannel.request('show:notification', JSON.parse(e.responseText));
	                                        }
	                                    });
	                                };
	                                fileReader.readAsArrayBuffer(blob);
	                            });*/
	        },
	
	        onBackToList: function () {
	            Backbone.history.navigate('/ff-forms', {trigger: true});
	        },
	
	        showlanguageSelect: function () {
	            var that = this;
	
	            that.showChildView('languageSelect', new RemoteSuggesterView({
	                tag: 'language',
	                inputId: 'language',
	                maxNumberOfElements: 20,
	                url: '/api/reference/languages/~~~',
	                symbolForSearchInUrl: '~~~',
	                listLocation: function (data) {
	                    return data;
	                },
	                getIdFn: function (element) {
	                    return element;
	                },
	                getValueFn: function (element) {
	                    return element;
	                },
	                classes: ["form-control"],
	                placeholder: "Language",
	                findSelectedIdBySelectedIndex: function (arr, index) {
	                    return arr[index] || null;
	                }
	            }));
	        },
	
	        showStateSelect: function () {
	            var that = this;
	
	            that.showChildView('stateSelect', new RemoteSuggesterView({
	                tag: 'state',
	                inputId: 'state',
	                maxNumberOfElements: 20,
	                url: '/api/reference/states/~~~',
	                symbolForSearchInUrl: '~~~',
	                listLocation: function (data) {
	                    return data;
	                },
	                getValueFn: function (element) {
	                    return element;
	                },
	                classes: ["form-control"],
	                placeholder: "State",
	                findSelectedIdBySelectedIndex: function (arr, index) {
	                    return arr[index] || null;
	                },
	                defaultSelected: this.patientAddress.state
	            }));
	        },
	
	        showReviewerSelect: function () {
	            var that = this;
	            that.reviewerSelectView = new RemoteSuggesterView({
	                maxNumberOfElements: 100,
	                url: '/api/person/preview?page-size=' + 100
	                + '&sortby=name&like_name=~~~&object_isMd=true&object_mergeable=false',
	                symbolForSearchInUrl: '~~~',
	                listLocation: function (data) {
	                    return data.filter(function (item) {
	                        return item.object;
	                    });
	                },
	                getValueFn: function (element) {
	                    return element.name;
	                },
	                classes: ["form-control"],
	                placeholder: "Begin to Type and Select Reviewer",
	                findSelectedIdBySelectedIndex: function (arr, index) {
	                    return (arr[index] || {}).id;
	                },
	                tag: 'reviewer',
	                defaultSelected: this.data ? this.data.reviewer : null
	            });
	
	            that.showChildView('reviewerSelect', that.reviewerSelectView);
	        },
	
	        showReqOrgSelect: function () {
	            var that = this;
	            that.reqOrgSelectView = new RemoteSuggesterView({
	                maxNumberOfElements: 100,
	                url: '/api/dbo/preview?page-size=' + 100
	                + '&sortby=name&like_name=~~~&type=organization',
	                symbolForSearchInUrl: '~~~',
	                listLocation: function (data) {
	                    return data.filter(function (item) {
	                        return item.object;
	                    });
	                },
	                getValueFn: function (element) {
	                    return element.name;
	                },
	                classes: ["form-control"],
	                placeholder: "Begin to Type and Select Requesting Organization",
	                findSelectedIdBySelectedIndex: function (arr, index) {
	                    return (arr[index] || {}).id;
	                },
	                tag: 'req-org',
	                defaultSelected: this.data ? this.data.requestingOrg : null
	            });
	
	            that.showChildView('reqOrgSelect', that.reqOrgSelectView);
	        },
	
	        initLanguages: function (languages) {
	            var that = this;
	            languages.forEach(function (lang) {
	                that.addLang(lang);
	            });
	        },
	
	        initDiseases: function (diseases) {
	            var that = this;
	            diseases.forEach(function (disease) {
	                that.diseasesRender(disease);
	            });
	        },
	
	        initSurgeries: function (surgeries) {
	            var that = this;
	            surgeries.forEach(function (surgery) {
	                that.renderSurgery(surgery.id);
	            });
	        },
	
	        onSelectLanguage: function (lang) {
	            var that = this;
	            if (!_.isNull(lang) && _.isUndefined(_.findWhere(that.ffForm.person.languages, {language: lang}))) {
	                this.addLang({
	                    language: lang,
	                    primary: false
	                });
	                that.ffForm.person.languages.push({
	                    language: lang,
	                    primary: false
	                });
	            }
	        },
	
	        addLang: function (lang) {
	            var that = this;
	            var liContent = "<li class='list-group-item' id='" + that.langToId(lang.language) + "'>"
	                + "<div class='row'>"
	                + "<div class='col-xs-5 col-md-5'>"
	                + lang.language + ""
	                + "</div>"
	                + "<div class='col-xs-5 col-md-5'>"
	                + "Primary? <input type='checkbox' class='language-primary' title='Set as primary'" + (lang.primary ? " checked " : "")
	                + " style='margin-left:10px;'/> "
	                + "</div>"
	                + "<div class='col-xs-1 col-md-1'>"
	                + "<span class='glyphicon glyphicon-remove clickable remove-language' title='Remove' style='margin-left:10px;'/> "
	                + "</div>"
	                + "</div>"
	                + "</li>";
	            that.ui.selectedLanguages.append(liContent);
	        },
	
	        setLanguageAsPrimary: function (event) {
	            var that = this;
	            var currentLiEl = $(event.target).closest('li');
	            var lang = that.idToLang(currentLiEl.attr('id'));
	            if (event.target.checked == true) {
	                currentLiEl.parent().find('li').each(function () {
	                    var currentLi = $(this);
	                    if (lang != that.idToLang(currentLi.attr('id'))) {
	                        currentLi.find('.language-primary').prop('checked', false);
	                    }
	                });
	            }
	
	            that.ffForm.person.languages.forEach(function (language) {
	                if (language.language == lang)
	                    language.primary = event.target.checked;
	                else
	                    language.primary = false;
	            });
	        },
	
	        removeLanguage: function (event) {
	            var that = this;
	            var li = $(event.target).closest('li');
	            var lang = that.idToLang(li.attr('id'));
	            that.ffForm.person.languages = that.ffForm.person.languages.filter(function (language) {
	                return language.language != lang;
	            });
	            li.remove();
	        },
	
	        langToId: function (lang) {
	            return lang.replace(' ', '_');
	        },
	
	        idToLang: function (lang) {
	            return lang.replace('_', ' ');
	        },
	
	        searchDiagnosis: function (event) {
	            var that = this;
	
	            var searchText = that.ui.diagnosisSearchText.val();
	            if (searchText.length <= 1) return;
	
	            that.ui.diagnosisTable.find('tr:not(:first)').remove();
	
	            //$('#search-results tr:not(:first)').remove();
	
	            if (event.keyCode == 13 || event.target.id == that.ui.diagnosisSearchButton.attr('id')) {
	
	                if (typeof that.servicesAddresses["icdServiceAddress"] != "undefined") {
	                    that.ui.diagnosisSearchText.addClass('data-loader');
	                    $.when(
	                        $.ajax({
	                            type: "GET",
	                            url: that.servicesAddresses["icdServiceAddress"] +
	                            '/search?terms=' + searchText
	                        })
	                    ).done(function (resp) {
	                        that.resfreshDiagnosisTableFromICDResults(resp || []);
	                        that.ui.diagnosisSearchText.removeClass('data-loader');
	                    }).fail(function (jqXHR, textStatus) {
	                        that.ui.diagnosisSearchText.removeClass('data-loader');
	                        notificationsChannel.request('show:notification', "Error. ICD service is unavailable");
	                    });
	                }
	            }
	        },
	
	        resfreshDiagnosisTableFromICDResults: function (results) {
	            var that = this;
	            var icdName = "ICD";
	
	            results.forEach(function (item) {
	                var newRowContent = "<tr class='clickable' id='" + item.code +
	                    "'><td><button class='add-to-left' title='Add to selected'>Add to selected</button></td><td>" + icdName + "-"
	                    + item.version + "</td><td>"
	                    + item.code + "</td><td>" + item.name + "</td></tr>";
	                that.ui.diagnosisTable.find('tbody').append(newRowContent);
	            });
	
	            that.ui.diagnosisTable.find('tr:not(:first)').on('dblclick', function (event) {
	                var id = event.currentTarget.id;
	                $(this).addClass('selected').siblings().removeClass('selected');
	                that.onDiagnosisSelected(id, results, icdName);
	            });
	            that.ui.diagnosisTable.find('.add-to-left').on('click', function (event) {
	                var id = $(event.currentTarget).parent().parent().attr('id');
	                that.onDiagnosisSelected(id, results, icdName);
	            });
	        },
	
	        onDiagnosisSelected: function (selectedId, results, type) {
	            var that = this;
	            var selected = _.findWhere(results, {code: selectedId});
	
	            var alreadyExists = _.findWhere(this.ffForm.medProfile.diseases, {diseaseId: selectedId});
	            if (!_.isUndefined(alreadyExists))
	                return;
	
	            this.ffForm.medProfile.diseases.push({
	                typeOfId: type + '-' + selected.version,
	                diseaseId: selected.code,
	                name: selected.name
	            });
	
	            that.diseasesRender(selected);
	        },
	
	        diseasesRender: function (selected) {
	            var that = this;
	
	            var rowId = selected.code || selected.diseaseId;
	            var dateOfOnsetElId = "date_" + (selected.code || selected.diseaseId);
	
	            var newRowContent = "<tr class='clickable' id='" + rowId + "'><td>ICD-"
	                + selected.version + "</td><td>"
	                + (selected.code || selected.diseaseId) + "</td><td>"
	                + selected.name + "</td><td><input class='form-control' type='text' id='" + dateOfOnsetElId
	                + "'></td><td><span class='glyphicon glyphicon-remove clickable remove-diagnosis' title='Remove'/></td></tr>";
	            this.ui.selectedDiagnosisTable.find('tbody').append(newRowContent);
	
	            var added = _.findWhere(this.ffForm.medProfile.diseases, {diseaseId: selected.code || selected.diseaseId});
	
	            $(function () {
	                $('#' + dateOfOnsetElId).datepicker({
	                    format: 'mm/dd/yyyy',
	                    clearBtn: true
	                }).on('changeDate', function (e) {
	                    $(this).datepicker('hide');
	                    added.dateOfOnset = that.utils.dateToLong(e.target.value);
	                }).on('clearDate', function (e) {
	                    added.dateOfOnset = 0;
	                });
	
	                if (that.mode == 'edit') {
	                    $('#' + dateOfOnsetElId).datepicker('update', that.utils.longToDateTimeFormatted(added.dateOfOnset, 'MM/DD/YYYY'));
	                }
	            });
	        },
	
	        onRemoveDiagnosis: function (event) {
	            var row = $(event.target);
	            var diagnosisId = row.parent().parent().attr('id');
	            this.ffForm.medProfile.diseases = this.ffForm.medProfile.diseases.filter(function (d) {
	                return d.diseaseId != diagnosisId;
	            });
	            this.ui.selectedDiagnosisTable.find('tr[id="' + diagnosisId + '"]').remove();
	        },
	
	        addSurgery: function () {
	            var that = this;
	
	            var uniqueId = that.utils.generatedUUID();
	
	            this.ffForm.medProfile.surgeries.push({
	                id: uniqueId,
	                type: "",
	                date: 0
	            });
	            that.renderSurgery(uniqueId);
	        },
	
	        renderSurgery: function (uniqueId) {
	
	            var that = this;
	
	            var typeElId = "type_" + uniqueId;
	            var dateElId = "date_" + uniqueId;
	
	            var newRowContent = "<tr class='clickable' id='" + uniqueId
	                + "'><td><input class='form-control' type='text' id='" + typeElId
	                + "'></td><td><input class='form-control' type='text' id='" + dateElId
	                + "'></td><td><span class='glyphicon glyphicon-remove clickable remove-surgery' title='Remove'/></td></tr>";
	            this.ui.surgeriesTable.find('tbody').append(newRowContent);
	
	            var added = _.findWhere(this.ffForm.medProfile.surgeries, {id: uniqueId});
	
	            $(function () {
	
	                $('#' + typeElId).on('change', function (e) {
	                    added.type = e.target.value;
	                });
	                $('#' + dateElId).datepicker({
	                    format: 'mm/dd/yyyy',
	                    clearBtn: true
	                }).on('changeDate', function (e) {
	                    $(this).datepicker('hide');
	                    added.date = that.utils.dateToLong(e.target.value);
	                }).on('clearDate', function (e) {
	                    added.date = 0;
	                });
	
	                if (that.mode == 'edit') {
	                    $('#' + typeElId).val(added.type);
	                    $('#' + dateElId).datepicker('update', that.utils.longToDateTimeFormatted(added.date, 'MM/DD/YYYY'));
	                }
	            });
	        },
	
	        onRemoveSurgery: function (event) {
	            var row = $(event.target);
	            var surveryId = row.parent().parent().attr('id');
	            this.ffForm.medProfile.surgeries = this.ffForm.medProfile.surgeries.filter(function (s) {
	                return s.id != surveryId;
	            });
	            this.ui.surgeriesTable.find('tr[id="' + surveryId + '"]').remove();
	        },
	
	        onChangeDiet: function (event) {
	            this.ffForm.medProfile.diet = event.target.value;
	        },
	
	        onChangeAllergies: function (event) {
	            this.ffForm.medProfile.allergy = event.target.value;
	        },
	
	        onChangeBriefMedicalHistory: function (event) {
	            this.ffForm.medProfile.briefMedicalHistory = event.target.value;
	        },
	
	        onChangeComplications: function (event) {
	            this.ffForm.medProfile.complication = event.target.value;
	        },
	
	        onChangeFfDataInput: function (event) {
	            this.ffForm.data[event.target.name] = event.target.value;
	        },
	
	        onReferralTypeCheck: function (event) {
	            var name = event.target.name;
	            var checked = event.target.checked;
	            if (checked) {
	                this.ffForm.data.referralTypes.push(name);
	            } else {
	                this.ffForm.data.referralTypes = this.ffForm.data.referralTypes.filter(function (rt) {
	                    return rt !== name;
	                });
	            }
	        },
	
	        onReasonCheck: function (event) {
	            var name = event.target.name;
	            var checked = event.target.checked;
	            if (checked) {
	                this.ffForm.data.reasons.push(name);
	            } else {
	                this.ffForm.data.reasons = this.ffForm.data.reasons.filter(function (rt) {
	                    return rt !== name;
	                });
	            }
	        },
	
	        enableCreateButton: function () {
	            this.ui.create.removeAttr('disabled');
	        },
	
	        disableCreateButton: function () {
	            this.ui.create.attr('disabled', true);
	        },
	
	        showError: function (jQelement, text) {
	            jQelement.tooltip({title: text});
	            jQelement.parent().parent().addClass('has-error has-feedback');
	        },
	
	        clearError: function (jQelement) {
	            jQelement.tooltip("destroy");
	            jQelement.parent().parent().removeClass('has-error has-feedback');
	        }
	    })
	;
	
	module.exports = FaceToFaceFormView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="col-md-offset-1 col-xs-offset-1 col-md-10 col-xs-10" id="face-to-face-form-container">\n    <h2 class="center">Face-to-Face Form</h2>\n\n    <div class="top-margined" style="margin-bottom: 80px;">\n        <div class="row right">\n            <div data-toggle="collapse" data-target="#hospital-information" class="col-xs-offset-7 col-md-offset-7">\n                <span class="dotted-link"><b>HOSPITAL INFORMATION</b></span>\n            </div>\n        </div>\n        <div class="row collapse" style="margin: 20px 0px 20px 0px;" id="hospital-information">\n            <div class="form form-horizontal">\n                <div class="form-group">\n                    <div class="col-xs-2 col-md-2">\n                        <label class="control-label" for="admission-date">Admission Date:</label>\n                        <div>\n                            <input class="form-control" type="text" id="admission-date" placeholder="Admission Date"\n                                   value="'+
	((__t=( ffForm.data.hospital.admissionDate ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-2 col-md-2">\n                        <label class="control-label" for="discharge-date">Discharge Date:</label>\n                        <div>\n                            <input class="form-control" type="text" id="discharge-date" placeholder="Discharge Date"\n                                   value="'+
	((__t=( ffForm.data.hospital.dischargeDate ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-2 col-md-2">\n                        <label class="control-label" for="case-number">Case Number:</label>\n                        <div>\n                            <input class="form-control hospital-input" type="text" id="case-number" name="caseNumber"\n                                   placeholder="Case number" value="'+
	((__t=( ffForm.data.hospital.caseNumber ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="grady-number">Grady Number:</label>\n                        <div>\n                            <input class="form-control hospital-input" type="text" id="grady-number" name="gradyNumber"\n                                   placeholder="Grady number" value="'+
	((__t=( ffForm.data.hospital.gradyNumber ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="room-number">Room Number:</label>\n                        <div>\n                            <input class="form-control hospital-input" type="text" id="room-number" name="roomNumber"\n                                   placeholder="Room number" value="'+
	((__t=( ffForm.data.hospital.roomNumber ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-6 col-md-6">\n                        <label class="control-label" for="hospital-name">Hospital Name:</label>\n                        <div>\n                            <input class="form-control hospital-input" type="text" id="hospital-name" name="name"\n                                   placeholder="Hospital name" value="'+
	((__t=( hospitalName ))==null?'':__t)+
	'" disabled>\n                        </div>\n                    </div>\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="hospital-email">Email:</label>\n                        <div>\n                            <input class="form-control" type="text" id="hospital-email" name="email"\n                                   placeholder="Email" value="'+
	((__t=( hospitalEmail ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="hospital-phone">Phone:</label>\n                        <div>\n                            <input class="form-control" type="text" id="hospital-phone" name="phone"\n                                   placeholder="Phone" value="'+
	((__t=( hospitalPhone ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class="row right">\n            <div data-toggle="collapse" data-target="#patient-demographics" class="col-xs-offset-8 col-md-offset-8">\n                <span class="dotted-link"><b>PATIENT DEMOGRAPHICS</b></span>\n            </div>\n        </div>\n        <div class="row collapse" style="margin: 20px 0px 20px 0px;" id="patient-demographics">\n            <div class="form form-horizontal">\n                <div class="form-group">\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="first-name">First Name:</label>\n                        <div>\n                            <input class="form-control simple-input" type="text" id="first-name" name="firstName"\n                                   placeholder="First Name" value="'+
	((__t=( ffForm.person.firstName ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="middle-name">Middle Name:</label>\n                        <div>\n                            <input class="form-control simple-input" type="text" id="middle-name" name="middleName"\n                                   placeholder="Middle Name" value="'+
	((__t=( ffForm.person.middleName ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="last-name">Last Name:</label>\n                        <div>\n                            <input class="form-control simple-input" type="text" id="last-name" name="lastName"\n                                   placeholder="Last Name" value="'+
	((__t=( ffForm.person.lastName ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-2 col-md-2">\n                        <label class="control-label" for="suffix">Suffix:</label>\n                        <div>\n                            <select id="suffix" name="suffix" class="simple-input" data-placeholder="Suffix">\n                                <option value=""></option>\n                                ';
	 _.each(["Jr.", "Mr.", "Mrs.", "Ms.", "Mx.", "Sr."], function(suffix){
	                                
	__p+='\n                                <option value="'+
	((__t=( suffix ))==null?'':__t)+
	'" name="'+
	((__t=( suffix ))==null?'':__t)+
	'"\n                                    ';
	 if (ffForm.person.suffix == suffix) { 
	__p+=' selected ';
	 } 
	__p+=' > '+
	((__t=( suffix ))==null?'':__t)+
	'\n                                </option>\n                                ';
	 }) 
	__p+='\n                            </select>\n                        </div>\n                    </div>\n                    <div class="col-xs-1 col-md-1">\n                        <label class="control-label" for="sex">Sex:</label>\n                        <div>\n                            <select id="sex" name="gender" class="simple-input" data-placeholder="Sex">\n                                <option value=""></option>\n                                ';
	 _.each([{name: "M", value: "Male"}, {name: "F", value: "Female"}], function(gender){
	                                
	__p+='\n                                <option value="'+
	((__t=( gender.name ))==null?'':__t)+
	'" name="'+
	((__t=( gender.name ))==null?'':__t)+
	'"\n                                    ';
	 if (ffForm.person.gender == gender.name) { 
	__p+=' selected ';
	 } 
	__p+=' > '+
	((__t=( gender.value ))==null?'':__t)+
	'\n                                </option>\n                                ';
	 }) 
	__p+='\n                            </select>\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-2 col-md-2">\n                        <label class="control-label" for="dob">D.O.B:</label>\n                        <div>\n                            <input class="form-control" type="text" id="dob"\n                                   placeholder="Date of Birth">\n                        </div>\n                    </div>\n                    <div class="col-xs-2 col-md-2">\n                        <label class="control-label" for="ssn">SSN:</label>\n                        <div>\n                            <input class="form-control" type="text" id="ssn" name="ssn" placeholder="SSN" value="'+
	((__t=( ffForm.person.ssn ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-2 col-md-2">\n                        <label class="control-label" for="martial-status">Martial Status:</label>\n                        <div>\n                            <select id="martial-status" name="martialStatus" class="simple-input"\n                                    data-placeholder="Martial Status">\n                                <option value=""></option>\n                                ';
	 _.each(martialStatuses, function(ms){
	                                
	__p+='\n                                <option value="'+
	((__t=( ms.name ))==null?'':__t)+
	'" name="'+
	((__t=( ms.name ))==null?'':__t)+
	'"\n                                    ';
	 if (ffForm.person.martialStatus == ms.name) { 
	__p+=' selected ';
	 } 
	__p+=' >'+
	((__t=( ms.value ))==null?'':__t)+
	'\n                                </option>\n                                ';
	 }) 
	__p+='\n                            </select>\n                        </div>\n                    </div>\n                    <div class="col-xs-2 col-md-2">\n                        <div>\n                            <label class="control-label">Language(s):</label>\n                        </div>\n                        <div id="language-select"></div>\n                    </div>\n                    <div class="col-xs-4 col-md-4">\n                        <ul class="list-group" id="selected-languages">\n                        </ul>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-8 col-md-8">\n                        <label class="control-label" for="address">Street Address:</label>\n                        <div>\n                            <input class="form-control" type="text" id="address" placeholder="Street Address" value="'+
	((__t=( patientAddress.address ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-4 col-md-4">\n                        <label class="control-label" for="city">City:</label>\n                        <div>\n                            <input class="form-control" type="text" id="city" placeholder="City" value="'+
	((__t=( patientAddress.town ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="state-select">State:</label>\n                        <div id="state-select"></div>\n                    </div>\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="zip">Zip-Code:</label>\n                        <div>\n                            <input class="form-control " type="text" id="zip" placeholder="Zip-Code" value="'+
	((__t=( patientAddress.zip ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="person-phone">Phone:</label>\n                        <div>\n                            <input class="form-control" type="text" id="person-phone" placeholder="Phone" value="'+
	((__t=( patientPhone ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="person-email">Email:</label>\n                        <div>\n                            <input class="form-control" type="text" id="person-email" placeholder="Email" value="'+
	((__t=( patientEmail ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-6 col-md-6">\n                        <label class="control-label" for="person-educated-on-care">Person Being Educated on\n                            Care:</label>\n                        <div>\n                            <input class="form-control simple-input" type="text" id="person-educated-on-care"\n                                   name="personEducatedOnCare"\n                                   placeholder="Person Being Educated on Care" value="'+
	((__t=( ffForm.person.personEducatedOnCare ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class="row right">\n            <div data-toggle="collapse" data-target="#emergency-contact" class="col-xs-offset-7 col-md-offset-7">\n                <span class="dotted-link"><b>EMERGENCY CONTACT</b></span>\n            </div>\n        </div>\n        <div class="row collapse" style="margin: 20px 0px 20px 0px;" id="emergency-contact">\n            <div class="form form-horizontal">\n                <div class="form-group">\n                    <div class="col-xs-5 col-md-5">\n                        <label class="control-label" for="primary-contact-name">Name:</label>\n                        <div>\n                            <input class="form-control primary-contact" type="text" id="primary-contact-name"\n                                   name="name"\n                                   placeholder="Name" value="'+
	((__t=( primaryContacts.name ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-4 col-md-4">\n                        <label class="control-label" for="primary-contact-rel">Relationship to Patient:</label>\n                        <div>\n                            <input class="form-control primary-contact" type="text" id="primary-contact-rel"\n                                   name="relationship" placeholder="Relationship to Patient" value="'+
	((__t=( primaryContacts.relationship ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="primary-contact-phone">Contact Number:</label>\n                        <div>\n                            <input class="form-control" type="text" id="primary-contact-phone"\n                                   placeholder="Contact Number" value="'+
	((__t=( primaryContactPhone ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class="row right">\n            <div data-toggle="collapse" data-target="#insurance-information" class="col-xs-offset-7 col-md-offset-7">\n                <span class="dotted-link"><b>INSURANCE INFORMATION</b></span>\n            </div>\n        </div>\n        <div class="row collapse" style="margin: 20px 0px 20px 0px;" id="insurance-information">\n            <div class="form form-horizontal">\n                <div class="form-group">\n                    <div class="col-xs-6 col-md-6">\n                        <label class="control-label" for="medicare">Medicare Number:</label>\n                        <div>\n                            <input class="form-control simple-input" type="text" id="medicare" name="medicare"\n                                   placeholder="Medicare Number" value="'+
	((__t=( ffForm.person.medicare ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-6 col-md-6">\n                        <label class="control-label" for="medicaid">Medicaid Number:</label>\n                        <div>\n                            <input class="form-control simple-input" type="text" id="medicaid" name="medicaid"\n                                   placeholder="Medicaid Number" value="'+
	((__t=( ffForm.person.medicaid ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="other-ins-name">Other Insurance Name:</label>\n                        <div>\n                            <input class="form-control simple-input" type="text" id="other-ins-name"\n                                   name="otherInsuranceName"\n                                   placeholder="Insurance Name" value="'+
	((__t=( ffForm.person.otherInsuranceName ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="group-number">Group Number:</label>\n                        <div>\n                            <input class="form-control simple-input" type="text" id="group-number" name="groupNumber"\n                                   placeholder="Group Number" value="'+
	((__t=( ffForm.person.groupNumber ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="policy-number">Policy Number:</label>\n                        <div>\n                            <input class="form-control simple-input" type="text" id="policy-number" name="policyNumber"\n                                   placeholder="Policy Number" value="'+
	((__t=( ffForm.person.policyNumber ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="payor-id">Payor ID:</label>\n                        <div>\n                            <input class="form-control simple-input" type="text" id="payor-id" name="payorId"\n                                   placeholder="Payor ID" value="'+
	((__t=( ffForm.person.payorId ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class="row right">\n            <div data-toggle="collapse" data-target="#medical-information-content"\n                 class="col-xs-offset-6 col-md-offset-6">\n                <span class="dotted-link"><b>MEDICAL INFORMATION</b></span>\n            </div>\n        </div>\n        <div class="row collapse" style="margin: 20px 0px 20px 0px;" id="medical-information-content">\n            <div class="form form-horizontal">\n                <div class="form-group">\n                    <div class="col-xs-6 col-md-6">\n                        <label class="control-label">Diagnosis Type and Date:</label>\n                        <div class="input-group">\n                            <input class="form-control" type="text" id="search-text"\n                                   placeholder="To Search, type at least 2 characters and press Enter"/>\n                            <span class="input-group-btn">\n                            <button class="form-control col-xs-1 col-xs-1 glyphicon glyphicon-search"\n                                    id="search-button"></button>\n                        </span>\n                        </div>\n                        <div class="well" style="max-height: 200px;overflow-y: auto;background-color: #ffffff;">\n                            <table class="table table-bordered table-hover" id="diagnosis">\n                                <thead>\n                                <th></th>\n                                <th>Type</th>\n                                <th>ID</th>\n                                <th>Name</th>\n                                </thead>\n                                <tbody>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                    <div class="col-xs-6 col-md-6">\n                        <h5 class="center"><b>Selected diagnosis</b></h5>\n                        <div class="well" style="max-height: 200px;overflow-y: auto;background-color: #ffffff;">\n                            <table class="table table-bordered table-hover" id="selected-diagnosis">\n                                <thead>\n                                <th>Type</th>\n                                <th>ID</th>\n                                <th>Name</th>\n                                <th>Date of Onset</th>\n                                <th></th>\n                                </thead>\n                                <tbody>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-6 col-md-6">\n                        <label class="control-label">Surgeries Type and Date:</label>\n                        <button id="add-surgery" class="btn btn-primary btn-sm" style="margin: 3px 3px 3px 3px;">Add\n                        </button>\n                        <div class="well" style="max-height: 200px;overflow-y: auto;background-color: #ffffff;">\n                            <table class="table table-bordered table-hover" id="surgeries">\n                                <thead>\n                                <th>Type</th>\n                                <th>Date</th>\n                                <th></th>\n                                </thead>\n                                <tbody>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-12 col-md-12">\n                        <label class="control-label" for="diet">Diet:</label>\n                        <div>\n                            <textarea class="form-control" id="diet" rows="2">'+
	((__t=( ffForm.medProfile.diet ))==null?'':__t)+
	'</textarea>\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-12 col-md-12">\n                        <label class="control-label" for="allergies">Allergies:</label>\n                        <div>\n                            <textarea class="form-control" id="allergies" rows="2">'+
	((__t=( ffForm.medProfile.allergy ))==null?'':__t)+
	'</textarea>\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-6 col-md-6">\n                        <label class="control-label" for="brief-medical-history">Brief Medical History:</label>\n                        <div>\n                            <textarea class="form-control" id="brief-medical-history" rows="5">'+
	((__t=( ffForm.medProfile.briefMedicalHistory ))==null?'':__t)+
	'</textarea>\n                        </div>\n                    </div>\n                    <div class="col-xs-6 col-md-6">\n                        <label class="control-label" for="complications">Complications:</label>\n                        <div>\n                            <textarea class="form-control" id="complications" rows="5">'+
	((__t=( ffForm.medProfile.complication ))==null?'':__t)+
	'</textarea>\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-4 col-md-4">\n                        <label class="control-label" for="primary-care-physician">Primary Care Physician:</label>\n                        <div>\n                            <input class="form-control primary-care-physician-input" type="text"\n                                   id="primary-care-physician" name="name"\n                                   placeholder="Primary Care Physician" value="'+
	((__t=( primaryPhysician.name ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                    <div class="col-xs-3 col-md-3">\n                        <label class="control-label" for="date-of-next-visit">Date of Next Visit:</label>\n                        <div>\n                            <input class="form-control" type="text" id="date-of-next-visit" placeholder="Date of Next Visit">\n                        </div>\n                    </div>\n                    <div class="col-xs-5 col-md-5">\n                        <label class="control-label" for="location-of-next-visit">Location of Next Visit:</label>\n                        <div>\n                            <input class="form-control primary-care-physician-input" type="text"\n                                   id="location-of-next-visit" name="locationOfNextVisit"\n                                   placeholder="Location of Next Visit" value="'+
	((__t=( primaryPhysician.locationOfNextVisit ))==null?'':__t)+
	'">\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group center">\n                    <div class="col-xs-offset-2 col-md-offset-2 col-xs-1 col-md-1">\n                        <label class="checkbox">\n                            <input type="checkbox" class="referral-chb" id="nursing-chb" name="Nursing"\n                            ';
	 if (_.contains(referralTypes, 'Nursing')) { 
	__p+=' checked ';
	 } 
	__p+=' > Nursing\n                        </label>\n                    </div>\n                    <div class="col-xs-1 col-md-1">\n                        <label class="checkbox">\n                            <input type="checkbox" class="referral-chb" id="pt-chb" name="PT"\n                            ';
	 if (_.contains(referralTypes, 'PT')) { 
	__p+=' checked ';
	 } 
	__p+=' > PT\n                        </label>\n                    </div>\n                    <div class="col-xs-1 col-md-1">\n                        <label class="checkbox">\n                            <input type="checkbox" class="referral-chb" id="ot-chb" name="OT"\n                            ';
	 if (_.contains(referralTypes, 'OT')) { 
	__p+=' checked ';
	 } 
	__p+=' > OT\n                        </label>\n                    </div>\n                    <div class="col-xs-1 col-md-1">\n                        <label class="checkbox">\n                            <input type="checkbox" class="referral-chb" id="st-chb" name="ST"\n                            ';
	 if (_.contains(referralTypes, 'ST')) { 
	__p+=' checked ';
	 } 
	__p+=' > ST\n                        </label>\n                    </div>\n                    <div class="col-xs-2 col-md-2">\n                        <label class="checkbox">\n                            <input type="checkbox" class="referral-chb" id="telehealth-chb" name="Telehealth"\n                            ';
	 if (_.contains(referralTypes, 'Telehealth')) { 
	__p+=' checked ';
	 } 
	__p+=' > Telehealth\n                        </label>\n                    </div>\n                    <div class="col-xs-1 col-md-1">\n                        <label class="checkbox">\n                            <input type="checkbox" class="referral-chb" id="hha-chb" name="HHA"\n                            ';
	 if (_.contains(referralTypes, 'HHA')) { 
	__p+=' checked ';
	 } 
	__p+=' > HHA\n                        </label>\n                    </div>\n                    <div class="col-xs-1 col-md-1">\n                        <label class="checkbox">\n                            <input type="checkbox" class="referral-chb" id="msw-chb" name="MSW"\n                            ';
	 if (_.contains(referralTypes, 'MSW')) { 
	__p+=' checked ';
	 } 
	__p+=' > MSW\n                        </label>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-12 col-md-12">\n                        <label class="control-label" for="clinical-indication">Clinical Indication:</label>\n                        <div>\n                            <textarea class="form-control ff-data" id="clinical-indication" rows="2" name="clinicalIndication">'+
	((__t=( ffForm.data.clinicalIndication ))==null?'':__t)+
	'</textarea>\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-12 col-md-12">\n                        <label class="control-label" for="orders">Orders:</label>\n                        <div>\n                            <textarea class="form-control ff-data" id="orders" rows="2" name="order">'+
	((__t=( ffForm.data.order ))==null?'':__t)+
	'</textarea>\n                        </div>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-12 col-md-12">\n                        <label class="control-label" for="suggested-frequency">Suggested Frequency:</label>\n                        <div>\n                            <textarea class="form-control ff-data" id="suggested-frequency" rows="2" name="suggestedFrequency">'+
	((__t=( ffForm.data.suggestedFrequency ))==null?'':__t)+
	'</textarea>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div>\n            <div class="form form-horizontal top-margined">\n                <div class="form-group">\n                    <div class="col-xs-12 col-md-12">\n                        <b>I have authorized the services on the plan of care.  I certify that a physician will periodically review the plan of care. I certify that my clinical findings support that the patient is home-bound due to the following reason(s) [check all that apply]:</b>\n                    </div>\n                </div>\n                <div class="form-group">\n                    <div class="col-xs-offset-1 col-md-offset-1">\n                        <label class="checkbox">\n                            <input type="checkbox" class="reason-chb" name="Medical deconditioning post-hospitalization"\n                            ';
	 if (_.contains(reasons, 'Medical deconditioning post-hospitalization')) { 
	__p+=' checked ';
	 } 
	__p+=' > Medical deconditioning post-hospitalization\n                        </label>\n                    </div>\n                    <div class="col-xs-offset-1 col-md-offset-1">\n                        <label class="checkbox">\n                            <input type="checkbox" class="reason-chb" name="Severly advanced disease limiting activity"\n                            ';
	 if (_.contains(reasons, 'Severly advanced disease limiting activity')) { 
	__p+=' checked ';
	 } 
	__p+=' > Severly advanced disease limiting activity\n                        </label>\n                    </div>\n                    <div class="col-xs-offset-1 col-md-offset-1">\n                        <label class="checkbox">\n                            <input type="checkbox" class="reason-chb" name="Requires significant supportive devices"\n                            ';
	 if (_.contains(reasons, 'Requires significant supportive devices')) { 
	__p+=' checked ';
	 } 
	__p+=' > Requires significant supportive devices\n                        </label>\n                    </div>\n                    <div class="col-xs-offset-1 col-md-offset-1">\n                        <label class="checkbox">\n                            <input type="checkbox" class="reason-chb" name="Requires the assistance of another individual for ADLs or to leave his/her residence"\n                            ';
	 if (_.contains(reasons, 'Requires the assistance of another individual for ADLs or to leave his/her residence')) { 
	__p+=' checked ';
	 } 
	__p+=' > Requires the assistance of another individual for ADLs or to leave his/her residence\n                        </label>\n                    </div>\n                    <div class="col-xs-offset-1 col-md-offset-1">\n                        <label class="checkbox">\n                            <input type="checkbox" class="reason-chb" name="Activity restrictions form underlying medical disease"\n                            ';
	 if (_.contains(reasons, 'Activity restrictions form underlying medical disease')) { 
	__p+=' checked ';
	 } 
	__p+=' > Activity restrictions form underlying medical disease\n                        </label>\n                    </div>\n                    <div class="col-xs-offset-1 col-md-offset-1">\n                        <label class="checkbox">\n                            <input type="checkbox" class="reason-chb" name="Manifests psychiatric illness with patient refusing to leave home environment and/or not safe to leave home environment"\n                            ';
	 if (_.contains(reasons, 'Manifests psychiatric illness with patient refusing to leave home environment and/or not safe to leave home environment')) { 
	__p+=' checked ';
	 } 
	__p+=' > Manifests psychiatric illness with patient refusing to leave home environment and/or not safe to leave home environment\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class="form form-horizontal top-margined">\n            <div class="form-group">\n                <div class="col-xs-6 col-md-6">\n                    <label class="control-label" for="residents-name">Resident\'s Name:</label>\n                    <div>\n                        <input class="form-control ff-data" type="text" id="residents-name" name="residentName"\n                               value="'+
	((__t=( ffForm.data.residentName ))==null?'':__t)+
	'">\n                    </div>\n                </div>\n                <div class="col-xs-6 col-md-6">\n                    <label class="control-label" for="pic-pager1">PIC/Pager #:</label>\n                    <div>\n                        <input class="form-control ff-data" type="text" id="pic-pager1" name="picPager1"\n                               value="'+
	((__t=( ffForm.data.picPager1 ))==null?'':__t)+
	'">\n                    </div>\n                </div>\n            </div>\n            <div class="form-group">\n                <div class="col-xs-6 col-md-6">\n                    <label class="control-label" for="attendings-name">Attending\'s Name:</label>\n                    <div>\n                        <input class="form-control ff-data" type="text" id="attendings-name" name="attendingName"\n                               value="'+
	((__t=( ffForm.data.attendingName ))==null?'':__t)+
	'">\n                    </div>\n                </div>\n                <div class="col-xs-6 col-md-6">\n                    <label class="control-label" for="pic-pager2">PIC/Pager #:</label>\n                    <div>\n                        <input class="form-control ff-data" type="text" id="pic-pager2" name="picPager2"\n                               value="'+
	((__t=( ffForm.data.picPager2 ))==null?'':__t)+
	'">\n                    </div>\n                </div>\n            </div>\n            <div class="form-group">\n                <div class="col-xs-6 col-md-6">\n                    <label class="control-label" for="id">ID #:</label>\n                    <div>\n                        <input class="form-control ff-data" type="text" id="id" name="id"\n                               value="'+
	((__t=( ffForm.data.id ))==null?'':__t)+
	'">\n                    </div>\n                </div>\n                <div class="col-xs-6 col-md-6">\n                    <label class="control-label" for="address2">Address:</label>\n                    <div>\n                        <input class="form-control ff-data" type="text" id="address2" name="address"\n                               value="'+
	((__t=( ffForm.data.address ))==null?'':__t)+
	'">\n                    </div>\n                </div>\n            </div>\n            <div class="form-group">\n                <div class="col-xs-6 col-md-6">\n                    <label class="control-label" for="cm-name">Case Manager/Social Worker’s Name:</label>\n                    <div>\n                        <input class="form-control ff-data" type="text" id="cm-name" name="caseManagerOrSocialWorkerName"\n                               value="'+
	((__t=( ffForm.data.caseManagerOrSocialWorkerName ))==null?'':__t)+
	'">\n                    </div>\n                </div>\n                <div class="col-xs-6 col-md-6">\n                    <label class="control-label" for="phone-number">Phone Number:</label>\n                    <div>\n                        <input class="form-control" type="text" id="phone-number" name="phoneNumber"\n                               value="'+
	((__t=( ffForm.data.phoneNumber ))==null?'':__t)+
	'">\n                    </div>\n                </div>\n            </div>\n            <div class="form-group">\n                <div class="col-xs-6 col-md-6">\n                    <label class="control-label" for="team">Team #:</label>\n                    <div>\n                        <input class="form-control ff-data" type="text" id="team" name="team"\n                               value="'+
	((__t=( ffForm.data.team ))==null?'':__t)+
	'">\n                    </div>\n                </div>\n                <div class="col-xs-6 col-md-6">\n                    <label class="control-label" for="area">Area:</label>\n                    <div>\n                        <input class="form-control ff-data" type="text" id="area" name="area"\n                               value="'+
	((__t=( ffForm.data.area ))==null?'':__t)+
	'">\n                    </div>\n                </div>\n            </div>\n            <div class="form-group">\n                <div class="col-xs-5 col-md-5">\n                    <label class="control-label" for="reviewer-select">Assigned Reviewer:</label>\n                    <div id="reviewer-select"></div>\n                </div>\n                <div class="col-xs-5 col-md-5">\n                    <label class="control-label" for="req-org-select">Requesting Organization:</label>\n                    <div id="req-org-select"></div>\n                </div>\n                <div class="col-xs-2 col-md-2">\n                    <label class="control-label" for="ff-date">Face-to-Face Date:</label>\n                    <div>\n                        <input class="form-control" type="text" id="ff-date">\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div id="buttons">\n            ';
	 if (mode == 'add') { 
	__p+='\n            <button id="create" class="btn btn-primary top-margined">Create</button>\n            ';
	 } 
	__p+='\n            ';
	 if (mode == 'edit' && userCanUpdate) { 
	__p+='\n            <button id="update" class="btn btn-primary top-margined">Update</button>\n            ';
	 } 
	__p+='\n            ';
	 if (mode == 'edit' && userCanSign) { 
	__p+='\n            <button id="sign" class="btn btn-primary top-margined">Sign</button>\n            ';
	 } 
	__p+='\n            <button id="back" class="btn btn-primary top-margined">Back to Face-to-Face Forms list</button>\n        </div>\n    </div>\n</div>\n';
	}
	return __p;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(180);
	
	var FaceToFaceFormsCollection = __webpack_require__(524);
	var FaceToFaceFormModel = __webpack_require__(212);
	
	var CommonUtils = __webpack_require__(189);
	var Constants = __webpack_require__(195);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	
	var FaceToFaceFormItem = Marionette.View.extend({
	    tagName: 'tr',
	    template: __webpack_require__(525),
	
	    ui: {
	        checkOrUncheck: '.check-ff-form',
	        removeFaceToFaceForm: '.remove-face-to-face-form'
	    },
	
	    events: {
	        'click @ui.checkOrUncheck': 'checkOrUncheck',
	        'click @ui.removeFaceToFaceForm': 'remove'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {
	            id: this.model.get("signed")
	                ? "-"
	                : '<a href = "/#ff-form/' + this.model.get("id") + '">Open</a>',
	            faceToFaceDate: that.utils.longToDateTimeFormatted((this.model.get("data").faceToFaceDate), 'MM/DD/YYYY'),
	            patient: this.model.get("patient")
	                ? '<a href="/#person/' + this.model.get("patient").id + '" target="_blank">' + this.model.get("patient").name + '</a>'
	                : "",
	            reviewer: this.model.get("reviewer")
	                ? '<a href="/#person/' + this.model.get("reviewer").id + '" target="_blank">' + this.model.get("reviewer").name + '</a>'
	                : "",
	            requestingOrg: this.model.get("requestingOrg")
	                ? '<a href="/#organization/' + this.model.get("requestingOrg").id + '" target="_blank">' + this.model.get("requestingOrg").name + '</a>'
	                : "",
	            creator: this.model.get("createdBy")
	                ? '<a href="/#person/' + this.model.get("createdBy").id + '" target="_blank">' + this.model.get("createdBy").name + '</a>'
	                : "",
	            isSigned: this.model.get("signed") ? "YES" : "NO",
	            signedTime: this.model.get("signedTime") == 0
	                ? ""
	                : that.utils.longToDateTimeFormatted((this.model.get("signedTime")), 'MM/DD/YYYY hh:mm A'),
	            signedDocumentId: this.model.get("signedDocumentId"),
	            currentUserDo: this.currentUser == this.model.get("createdBy").id
	        }
	    },
	
	    initialize: function (options) {
	        this.utils = new CommonUtils();
	        this.currentUser = options.currentUser
	    },
	
	    checkOrUncheck: function (event) {
	        this.triggerMethod('row:selected', {
	            ffFormId: this.model.get("id"),
	            addOrRemove: event.target.checked
	        });
	    },
	    remove: function(event) {
	        this.triggerMethod('row:remove', {
	            ffFormId: this.model.get("id")
	        });
	    }
	});
	
	var EmptyView = Marionette.View.extend({
	    tagName: 'tr',
	    template: _.template(_.reduce(_.map(_.range(8), function (value) {
	        return '<td>-</td>'
	    }), function (memo, str) {
	        return memo + str;
	    }, ""))
	});
	
	
	var FaceToFaceFormsTableBody = Marionette.CollectionView.extend({
	    tagName: 'tbody',
	    childView: FaceToFaceFormItem,
	    emptyView: EmptyView,
	
	    collectionEvents: {
	        request: 'showLoading',
	        sync: 'hideLoading',
	        error: 'logError'
	    },
	
	    childViewEvents: {
	        'row:selected': 'onFfFormRowSelected',
	        'row:remove': 'onFfFormRowRemove'
	    },
	
	    initialize: function (options) {
	        _.bindAll(this, 'showLoading', 'hideLoading', 'logError');
	        this.collection = options.collection;
	        this.currentUser = options.currentUser;
	        this.formatDate = options.formatDate;
	    },
	
	    childViewOptions: function () {
	        return {
	            currentUser: this.currentUser,
	            formatDate: this.formatDate
	        };
	    },
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    },
	
	    onFfFormRowSelected: function (data) {
	        this.triggerMethod('row:selected', data);
	    },
	
	    onFfFormRowRemove: function (data) {
	        this.triggerMethod('row:remove', data);
	    }
	});
	
	var FaceToFaceFormsListView = Marionette.View.extend({
	    template: __webpack_require__(526),
	
	    regions: {
	        form: '#form',
	        tableBody: {
	            el: 'tbody',
	            replaceElement: true
	        }
	    },
	
	    ui: {
	        checkOrUncheckAll: '#check-all',
	        sortable: '.sortable'
	    },
	
	    events: {
	        'click @ui.checkOrUncheckAll': 'checkOrUncheckAllPersons',
	        'click @ui.sortable': 'reorder'
	    },
	
	    collectionEvents: {
	        error: 'logError'
	    },
	
	    childViewEvents: {
	        'row:selected': 'onFfFormRowSelected',
	        'row:remove': 'onFfFormRowRemove'
	    },
	
	    templateContext: function () {
	        var that = this;
	        return {}
	    },
	
	    initialize: function (options) {
	        this.model = new FaceToFaceFormModel();
	        this.utils = new CommonUtils();
	        this.currentUser = options.currentUser;
	        this.ffFormsIds = [];
	
	        this.tableFilterPreferences = {
	            tableColumnFilters: [],
	            sortField: "faceToFaceDate",
	            sortDirection: "ASC"
	        };
	    },
	
	    onErrors: function (model, errors) {
	        model.view.triggerMethod('server:error', errors.join('. \n'));
	    },
	
	    onRender: function () {
	        window.document.title = "Face to face forms";
	        var that = this;
	
	        that.collection = new FaceToFaceFormsCollection([], {});
	
	        that.showLoading();
	        that.collection.fetch({
	            success: function () {
	                that.renderTable();
	                that.hideLoading();
	            },
	            error: function () {
	                that.hideLoading();
	            }
	        });
	    },
	
	    renderTable: function () {
	        var that = this;
	        this.tableBody = new FaceToFaceFormsTableBody({
	            collection: that.collection,
	            currentUser: that.currentUser,
	            formatDate: function (dateAsLong) {
	                return that.utils.longToDateTimeFormatted(dateAsLong, 'MMM DD YYYY');
	            }
	        });
	        that.showChildView('tableBody', this.tableBody);
	    },
	
	    showLoading: function () {
	        this.$('.loading').show();
	    },
	
	    hideLoading: function () {
	        this.$('.loading').hide();
	    },
	
	    logError: function (obj, response) {
	        this.$('.loading').hide();
	        this.triggerMethod('server:error', response.responseText);
	    },
	
	    checkOrUncheckAllPersons: function (event) {
	        var that = this;
	        if (event.target.checked) {
	            $('.check-ff-form').prop('checked', true);
	
	            that.ffFormsIds = that.collection.map(function (model) {
	                return model.get('id');
	            });
	        } else {
	            that.ffFormsIds = [];
	            $('.check-ff-form').prop('checked', false);
	        }
	
	        that.ffFormsIds = _.uniq(that.ffFormsIds);
	    },
	
	    onFfFormRowSelected: function (data) {
	        var that = this;
	        if (data.addOrRemove) {
	            that.ffFormsIds.push(data.ffFormId);
	        } else {
	            that.ffFormsIds = (that.ffFormsIds || []).filter(function (id) {
	                return id !== data.ffFormId
	            });
	        }
	
	        that.ffFormsIds = _.uniq(that.ffFormsIds);
	    },
	
	    onFfFormRowRemove: function (data) {
	        var that = this;
	        var r = confirm("You are going to Remove this Face-to-Face Form. Are you sure?");
	        if (r == true) {
	            $.ajax({
	                type: "DELETE",
	                url: '/api/face-to-face-form/' + data.ffFormId,
	                statusCode: {
	                    200: function (response) {
	                        $.notify("Removed successfully", "success");
	                        that.onRender();
	                    }
	                },
	                error: function (e) {
	                    notificationsChannel.request('show:notification', e.responseJSON);
	                }
	            });
	        } else {
	            console.log("Cancel");
	        }
	    },
	
	    reorder: function (event) {
	        console.log(this.tableFilterPreferences);
	        var that = this;
	        var sortFieldName = $(event.target).next().attr("id");
	        if (this.tableFilterPreferences.sortField == sortFieldName) {
	            this.tableFilterPreferences.sortDirection = this.tableFilterPreferences.sortDirection == "ASC" ? "DESC" : "ASC";
	        } else {
	            this.tableFilterPreferences.sortField = sortFieldName;
	            this.tableFilterPreferences.sortDirection = "ASC";
	        }
	
	        this.renderSortColumns();
	        this.resort(this.collection);
	        this.renderTable();
	    },
	
	    renderSortColumns: function () {
	        var that = this;
	        var sortField = that.tableFilterPreferences.sortField;
	        var sortDirection = that.tableFilterPreferences.sortDirection;
	        $('.sort-icon').removeClass("glyphicon glyphicon-triangle-top glyphicon-triangle-bottom");
	        var currentSortEl = $("#" + sortField).parent().children(':first-child');
	
	        if (sortDirection == "ASC") {
	            currentSortEl.addClass("glyphicon glyphicon-triangle-top");
	        } else {
	            currentSortEl.addClass("glyphicon glyphicon-triangle-bottom");
	        }
	    },
	
	    resort: function (collection) {
	        collection.sortByFieldAndDirection(this.tableFilterPreferences.sortField, this.tableFilterPreferences.sortDirection);
	    }
	});
	
	
	module.exports = FaceToFaceFormsListView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(11)))

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseCollection = __webpack_require__(211);
	
	
	var FaceToFaceFormCollection = BaseCollection.extend({
	    url:"/api/face-to-face-form",
	    sortConf: {field: 'faceToFaceDate', asc: true},
	
	    initialize: function(models, options){
	        BaseCollection.prototype.initialize.apply(this, arguments);
	    },
	
	    comparator: function(a, b) {
	        if (this.sortConf.field == "faceToFaceDate") {
	            a = new Number(a.get("data")[this.sortConf.field]);
	            b = new Number(b.get("data")[this.sortConf.field]);
	        } else if (this.sortConf.field == "signedTime" || this.sortConf.field == "signed") {
	            a = new Number(a.get("signedTime"));
	            b = new Number(b.get("signedTime"));
	        } else {
	            a = (a.get(this.sortConf.field) || {}).name || "";
	            b = (b.get(this.sortConf.field) || {}).name || "";
	        }
	        result = a > b ?  1
	            : a < b ? -1
	                :          0;
	
	        if (!this.sortConf.asc){
	            return result * -1;
	        }
	        return result;
	    },
	
	    sortByFieldAndDirection: function (fieldName, direction) {
	        this.sortConf = {field: fieldName, asc: direction == "ASC"};
	        this.sort();
	    }
	});
	
	
	module.exports = FaceToFaceFormCollection;

/***/ }),
/* 525 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<td class="center" style="display: none"><input type="checkbox" class="check-ff-form"></td>\n<td class="center">\n    ';
	 if (signedDocumentId) { 
	__p+='\n    <a href="/api/document/view/'+
	((__t=( signedDocumentId ))==null?'':__t)+
	'" target="_blank" class="preview-doc"><span class="clickable glyphicon glyphicon-eye-open"/></a>\n    ';
	 } 
	__p+='\n</td>\n<td class="center">\n    ';
	 if (signedDocumentId) { 
	__p+='\n    <a href="/api/document/download/'+
	((__t=( signedDocumentId ))==null?'':__t)+
	'" class="preview-doc"><span class="clickable glyphicon glyphicon-floppy-disk"/></a>\n    ';
	 } 
	__p+='\n</td>\n<td class="center">'+
	((__t=( id ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( faceToFaceDate ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( data.hospital.name ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( patient ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( reviewer ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( requestingOrg ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( creator ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( isSigned ))==null?'':__t)+
	'</td>\n<td>'+
	((__t=( signedTime ))==null?'':__t)+
	'</td>\n';
	 if (currentUserDo) { 
	__p+='\n<td><span class=\'glyphicon glyphicon-remove clickable remove-face-to-face-form\' title=\'Remove\'/></td>\n';
	 } 
	__p+='';
	}
	return __p;
	};


/***/ }),
/* 526 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="row">\n    <div class="col-xs-10 col-md-6">\n        <div class="row">\n            <h2>\n                Face to Face List\n            </h2>\n        </div>\n    </div>\n</div>\n\n<div class="loading"></div>\n\n<table class="table table-hover top-margined">\n    <head>\n        <thead>\n        <tr>\n            <th style="display: none"><label class="checkbox-inline"><input type="checkbox"\n                                                                            id="check-all"><b>All</b></label></th>\n            <th></th>\n            <th></th>\n            <th>View/Edit</th>\n            <th>\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Date</div>\n                <div id="faceToFaceDate" class="pull-left"></div>\n            </th>\n            <th>Hospital Name</th>\n            <th>\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Patient</div>\n                <div id="patient" class="pull-left"></div>\n            </th>\n            <th>\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Reviewer</div>\n                <div id="reviewer" class="pull-left"></div>\n            </th>\n            <th>\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Requesting Org.</div>\n                <div id="requestingOrg" class="pull-left"></div>\n            </th>\n            <th>\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Created By</div>\n                <div id="createdBy" class="pull-left"></div>\n            </th>\n            <th>\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Signed?</div>\n                <div id="signed" class="pull-left"></div>\n            </th>\n            <th>\n                <div class="pull-left sort-icon"></div>\n                <div class="pull-left sortable clickable">Signature Stamp</div>\n                <div id="signedTime" class="pull-left"></div>\n            </th>\n            <th></th>\n        </tr>\n        </thead>\n    </head>\n    <tbody></tbody>\n</table>';
	}
	return __p;
	};


/***/ }),
/* 527 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="body-hook"></div>\n<div class="loader"></div>\n\n<div class="error-message-container">\n<div id="alert-warn" class="alert alert-warning alert-top" role="alert">\n    <button type="button" class="close alert-close" aria-label="Close"><span aria-hidden="true">×</span></button>\n    <h4>Error!</h4>\n    <span class="alert-msg"></span>\n</div>\n</div>\n';
	}
	return __p;
	};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(180);
	
	var Footer = Marionette.View.extend({
	    template: __webpack_require__(529)
	});
	
	
	module.exports = Footer;

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<footer class="footer bar-light">\n    <div class="container form-inline">\n        <p class="text-muted form-group col-md-3">© Review & Sign 2017</p>\n        <p class="text-muted form-group col-md-4">\n            Main Phone Number: 833-2ASKRNS (833-227-5767)\n            Main Fax Number: 833-2FAXRNS (833-232-9767)\n        </p>\n        <div class="text-muted form-group col-md-3 pull-right">\n            <a class="pull-right" href="/#help">Help</a>\n        </div>\n    </div>\n</footer>';
	}
	return __p;
	};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, _) {var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	
	var CommonUtils = __webpack_require__(189);
	
	var SvnInfoModal = Marionette.View.extend({
	    template: __webpack_require__(531),
	
	    ui: {
	        modal: '#svn-info-modal',
	        contentUI: '#svn-info-content-ui',
	        contentAPI: '#svn-info-content-api',
	        loader: '#svn-info-loader'
	    },
	
	    events: {},
	
	    templateContext: function () {
	        return {}
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.utils = new CommonUtils();
	    },
	
	    onRender: function () {
	        var that = this;
	        that.show();
	        that.utils.showSpinner(that.ui.loader.id);
	
	        $.ajax({
	            type: "GET",
	            url: '/api/system/info/svn',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner(that.ui.loader.id);
	                    that.renderTable(that.ui.contentAPI, response);
	                }
	            },
	            error: function (e) {
	                that.utils.hideSpinner(that.ui.loader.id);
	                notificationsChannel.request('show:notification', e.responseJSON);
	                that.utils.hideSpinner(that.ui.loader.id);
	            }
	        });
	
	        var onlyNeedEntries = {};
	
	        _.keys(__SVN_INFO__).filter(function (key) {
	            return key === "lastChangedAuthor"
	                || key === "lastChangedDate"
	                || key === "lastChangedRev"
	                || key === "repositoryUuid"
	                || key === "url"
	        }).forEach(function (key) {
	            var value = __SVN_INFO__[key];
	            switch (key) {
	                case 'lastChangedAuthor':
	                    onlyNeedEntries["Last Changed Author"] = value;
	                    break;
	                case 'lastChangedDate':
	                    onlyNeedEntries["Last Changed Date"] = value;
	                    break;
	                case 'lastChangedRev':
	                    onlyNeedEntries["Last Changed Rev"] = value;
	                    break;
	                case 'repositoryUuid':
	                    onlyNeedEntries["Repository UUID"] = value;
	                    break;
	                case 'url':
	                    onlyNeedEntries["URL"] = value;
	                    break;
	                default:
	                    onlyNeedEntries[key] = value;
	                    break;
	            }
	        });
	
	        that.renderTable(that.ui.contentUI, onlyNeedEntries);
	    },
	
	    renderTable: function (target, data) {
	
	        var tableStart = "<table class='table table-bordered table-hover'><tr><th class='center'>Key</th><th class='center'>Value</th></tr>";
	        var tableEnd = "</table>";
	
	        var sortedByKey = _.sortBy(_.keys(data) || [], function (key) {
	            return key;
	        });
	        sortedByKey = sortedByKey.reverse();
	        var tableBody = sortedByKey.map(function (key) {
	            return '<tr><td>' + key + '</td><td>' + data[key] + '</td></tr>';
	        }).join("")
	
	        target.html(tableStart + tableBody + tableEnd);
	    },
	
	    show: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    }
	});
	
	module.exports = SvnInfoModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(182)))

/***/ }),
/* 531 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Modal -->\n<div class="modal fade" id="svn-info-modal" tabindex="-1" role="dialog" aria-labelledby="svn-info-modal">\n    <div class="modal-dialog modal-lg" style="width: 1200px !important;" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\n                        aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title" id="svn-info-modal-label">SVN Info</h4>\n            </div>\n            <div class="modal-body" style="min-height: 200px;">\n                <div>\n                    <span class="col-md-6 col-xs-6 center"><b>UI</b></span>\n                    <span class="col-md-6 col-xs-6 center"><b>API</b></span>\n                </div>\n                <div>\n                    <div id="svn-info-content-ui" class="col-md-6 col-xs-6"></div>\n                    <div id="svn-info-content-api" class="col-md-6 col-xs-6"></div>\n                </div>\n                <div id="svn-info-loader" class="loader" style="height: 200px;"></div>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var Marionette = __webpack_require__(180);
	
	var Radio = __webpack_require__(183);
	var notificationsChannel = Radio.channel('notifications');
	var actionsChannel = Radio.channel('actions');
	
	var CommonUtils = __webpack_require__(189);
	
	var ActiveSessionsModal = Marionette.View.extend({
	    template: __webpack_require__(533),
	
	    ui: {
	        modal: '#active-sessions-modal',
	        content: '#active-sessions-content',
	        loader: '#active-sessions-loader',
	
	        refresh: "#refresh-active-sessions"
	    },
	
	    events: {
	        'click @ui.refresh': "refresh"
	    },
	
	    templateContext: function () {
	        return {}
	    },
	
	    initialize: function (options) {
	        var that = this;
	        that.utils = new CommonUtils();
	        that.mySessionId = options.mySessionId;
	    },
	
	    onRender: function () {
	        var that = this;
	        that.show();
	        that.refresh();
	    },
	
	    renderTable: function (data) {
	        var that = this;
	
	        var tableStart = "<table class='table table-bordered table-hover'><tr><th>Session Id</th><th>Login</th><th>Person</th><th>Is Admin?</th></tr>";
	        var tableEnd = "</table>";
	
	        var tableBody = data.map(function (item) {
	            return '<tr ' + (that.mySessionId == item.sessionId ? 'style="background-color: yellow;"' : "") + '><td>' + item.sessionId + '</td><td>' + item.login + '</td><td>' + item.person + '</td><td>' + item.isAdmin + '</td></tr>';
	        }).join("")
	
	        that.ui.content.html(tableStart + tableBody + tableEnd);
	    },
	
	    show: function () {
	        this.ui.modal.modal({backdrop: 'static', keyboard: false});
	    },
	
	    hide: function () {
	        this.ui.modal.modal('hide');
	    },
	
	    refresh: function () {
	        var that = this;
	
	        that.utils.showSpinner(that.ui.loader.id);
	
	        $.ajax({
	            type: "GET",
	            url: '/api/system/sessions',
	            statusCode: {
	                200: function (response) {
	                    that.utils.hideSpinner(that.ui.loader.id);
	
	                    var transformed = response.filter(function (item) {
	                        return item.name != "undefined" && item.name != "null";
	                    }).map(function (item) {
	                        return {
	                            sessionId: item.id,
	                            login: item.name,
	                            person: that.utils.formatPerson(item.person || {}),
	                            isAdmin: ((item.systemRoles || []).indexOf('ADMIN') > -1) ? "YES" : "NO"
	                        }
	                    });
	                    that.data = transformed;
	                    that.renderTable(transformed);
	                },
	                401: function (e) {
	                    that.utils.hideSpinner(that.ui.loader.id);
	                    that.hide();
	                    actionsChannel.request("redirect:to:login");
	                }
	            },
	            error: function (e) {
	                console.log(e);
	                that.utils.hideSpinner(that.ui.loader.id);
	                //notificationsChannel.request('show:notification', e.responseJSON);
	            }
	        })
	    }
	});
	
	module.exports = ActiveSessionsModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<!-- Modal -->\n<div class="modal fade" id="active-sessions-modal" tabindex="-1" role="dialog" aria-labelledby="active-sessions-modal">\n    <div class="modal-dialog modal-lg" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span\n                        aria-hidden="true">&times;</span></button>\n                <h4 class="modal-title" id="active-sessions-modal-label">Active Sessions</h4>\n            </div>\n            <div class="modal-body">\n                <div id="active-sessions-content"></div>\n                <div id="active-sessions-loader" class="loader" style="height: 200px;"></div>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-primary" id="refresh-active-sessions">Refresh</button>\n                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>\n            </div>\n        </div>\n    </div>\n</div>';
	}
	return __p;
	};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.js